
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefe96"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefe96"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eHRxX", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iNa44"));

});
parcelRegister("iNa44", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $dae49c3e42fb6506$export$ffb0004e005737fa; }, function (v) { return $dae49c3e42fb6506$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $dae49c3e42fb6506$export$34b9dba7ce09269b; }, function (v) { return $dae49c3e42fb6506$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $dae49c3e42fb6506$export$25062201e9e25d76; }, function (v) { return $dae49c3e42fb6506$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dae49c3e42fb6506$export$ffb0004e005737fa;
var $dae49c3e42fb6506$export$34b9dba7ce09269b;
var $dae49c3e42fb6506$export$25062201e9e25d76;
"use strict";
var $dae49c3e42fb6506$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dae49c3e42fb6506$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $dae49c3e42fb6506$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $dae49c3e42fb6506$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$dae49c3e42fb6506$export$ffb0004e005737fa = $dae49c3e42fb6506$var$REACT_FRAGMENT_TYPE;
$dae49c3e42fb6506$export$34b9dba7ce09269b = $dae49c3e42fb6506$var$jsxProd;
$dae49c3e42fb6506$export$25062201e9e25d76 = $dae49c3e42fb6506$var$jsxProd;

});


parcelRegister("jHEir", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gkvm3"));

});
parcelRegister("gkvm3", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $be36d5feddcf5f62$export$9c16c1426311996d; }, function (v) { return $be36d5feddcf5f62$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $be36d5feddcf5f62$export$dca3b0875bd9a954; }, function (v) { return $be36d5feddcf5f62$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $be36d5feddcf5f62$export$16fa2f45be04daa8; }, function (v) { return $be36d5feddcf5f62$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $be36d5feddcf5f62$export$ffb0004e005737fa; }, function (v) { return $be36d5feddcf5f62$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $be36d5feddcf5f62$export$e2c29f18771995cb; }, function (v) { return $be36d5feddcf5f62$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $be36d5feddcf5f62$export$221d75b3f55bb0bd; }, function (v) { return $be36d5feddcf5f62$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $be36d5feddcf5f62$export$5f8d39834fd61797; }, function (v) { return $be36d5feddcf5f62$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $be36d5feddcf5f62$export$74bf444e3cd11ea5; }, function (v) { return $be36d5feddcf5f62$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "ViewTransition", function () { return $be36d5feddcf5f62$export$8cdaa4703948c5e9; }, function (v) { return $be36d5feddcf5f62$export$8cdaa4703948c5e9 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $be36d5feddcf5f62$export$1ced07cd6b1985ce; }, function (v) { return $be36d5feddcf5f62$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $be36d5feddcf5f62$export$abd8e32b826d7ea7; }, function (v) { return $be36d5feddcf5f62$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "addTransitionType", function () { return $be36d5feddcf5f62$export$87c99536b1b8cdd8; }, function (v) { return $be36d5feddcf5f62$export$87c99536b1b8cdd8 = v; });
$parcel$export(module.exports, "cache", function () { return $be36d5feddcf5f62$export$69a3209f1a06c04d; }, function (v) { return $be36d5feddcf5f62$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $be36d5feddcf5f62$export$8c538325882c7eec; }, function (v) { return $be36d5feddcf5f62$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $be36d5feddcf5f62$export$e530037191fcd5d7; }, function (v) { return $be36d5feddcf5f62$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $be36d5feddcf5f62$export$fd42f52fd3ae1109; }, function (v) { return $be36d5feddcf5f62$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $be36d5feddcf5f62$export$c8a8987d4410bf2d; }, function (v) { return $be36d5feddcf5f62$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $be36d5feddcf5f62$export$7d1e3a5e95ceca43; }, function (v) { return $be36d5feddcf5f62$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $be36d5feddcf5f62$export$257a8862b851cb5b; }, function (v) { return $be36d5feddcf5f62$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $be36d5feddcf5f62$export$a8257692ac88316c; }, function (v) { return $be36d5feddcf5f62$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $be36d5feddcf5f62$export$488013bae63b21da; }, function (v) { return $be36d5feddcf5f62$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $be36d5feddcf5f62$export$7c73462e0d25e514; }, function (v) { return $be36d5feddcf5f62$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $be36d5feddcf5f62$export$7568632d0d33d16d; }, function (v) { return $be36d5feddcf5f62$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $be36d5feddcf5f62$export$f93f40ac0ca7e3a8; }, function (v) { return $be36d5feddcf5f62$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $be36d5feddcf5f62$export$1f96ae73734a86cc; }, function (v) { return $be36d5feddcf5f62$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $be36d5feddcf5f62$export$9a47ced3238df325; }, function (v) { return $be36d5feddcf5f62$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $be36d5feddcf5f62$export$35808ee640e87ca7; }, function (v) { return $be36d5feddcf5f62$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $be36d5feddcf5f62$export$fae74005e78b1a27; }, function (v) { return $be36d5feddcf5f62$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $be36d5feddcf5f62$export$dc8fbce3eb94dc1e; }, function (v) { return $be36d5feddcf5f62$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $be36d5feddcf5f62$export$6a7bc4e911dc01cf; }, function (v) { return $be36d5feddcf5f62$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $be36d5feddcf5f62$export$6d9c69b0de29b591; }, function (v) { return $be36d5feddcf5f62$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $be36d5feddcf5f62$export$7f54fc3180508a52; }, function (v) { return $be36d5feddcf5f62$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $be36d5feddcf5f62$export$f680877a34711e37; }, function (v) { return $be36d5feddcf5f62$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $be36d5feddcf5f62$export$d5a552a76deda3c2; }, function (v) { return $be36d5feddcf5f62$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $be36d5feddcf5f62$export$aaabe4eda9ed9969; }, function (v) { return $be36d5feddcf5f62$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $be36d5feddcf5f62$export$e5c5a5f917a5871c; }, function (v) { return $be36d5feddcf5f62$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $be36d5feddcf5f62$export$1538c33de8887b59; }, function (v) { return $be36d5feddcf5f62$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $be36d5feddcf5f62$export$fca7f784ae7a249a; }, function (v) { return $be36d5feddcf5f62$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $be36d5feddcf5f62$export$13e3392192263954; }, function (v) { return $be36d5feddcf5f62$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $be36d5feddcf5f62$export$b8f5890fc79d6aca; }, function (v) { return $be36d5feddcf5f62$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $be36d5feddcf5f62$export$60241385465d0a34; }, function (v) { return $be36d5feddcf5f62$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $be36d5feddcf5f62$export$306c0aa65ff9ec16; }, function (v) { return $be36d5feddcf5f62$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $be36d5feddcf5f62$export$7b286972b8d8ccbf; }, function (v) { return $be36d5feddcf5f62$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $be36d5feddcf5f62$export$83d89fbfd8236492; }, function (v) { return $be36d5feddcf5f62$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $be36d5feddcf5f62$export$9c16c1426311996d;
var $be36d5feddcf5f62$export$dca3b0875bd9a954;
var $be36d5feddcf5f62$export$16fa2f45be04daa8;
var $be36d5feddcf5f62$export$ffb0004e005737fa;
var $be36d5feddcf5f62$export$e2c29f18771995cb;
var $be36d5feddcf5f62$export$221d75b3f55bb0bd;
var $be36d5feddcf5f62$export$5f8d39834fd61797;
var $be36d5feddcf5f62$export$74bf444e3cd11ea5;
var $be36d5feddcf5f62$export$8cdaa4703948c5e9;
var $be36d5feddcf5f62$export$1ced07cd6b1985ce;
var $be36d5feddcf5f62$export$abd8e32b826d7ea7;
var $be36d5feddcf5f62$export$87c99536b1b8cdd8;
var $be36d5feddcf5f62$export$69a3209f1a06c04d;
var $be36d5feddcf5f62$export$8c538325882c7eec;
var $be36d5feddcf5f62$export$e530037191fcd5d7;
var $be36d5feddcf5f62$export$fd42f52fd3ae1109;
var $be36d5feddcf5f62$export$c8a8987d4410bf2d;
var $be36d5feddcf5f62$export$7d1e3a5e95ceca43;
var $be36d5feddcf5f62$export$257a8862b851cb5b;
var $be36d5feddcf5f62$export$a8257692ac88316c;
var $be36d5feddcf5f62$export$488013bae63b21da;
var $be36d5feddcf5f62$export$7c73462e0d25e514;
var $be36d5feddcf5f62$export$7568632d0d33d16d;
var $be36d5feddcf5f62$export$f93f40ac0ca7e3a8;
var $be36d5feddcf5f62$export$1f96ae73734a86cc;
var $be36d5feddcf5f62$export$9a47ced3238df325;
var $be36d5feddcf5f62$export$35808ee640e87ca7;
var $be36d5feddcf5f62$export$fae74005e78b1a27;
var $be36d5feddcf5f62$export$dc8fbce3eb94dc1e;
var $be36d5feddcf5f62$export$6a7bc4e911dc01cf;
var $be36d5feddcf5f62$export$6d9c69b0de29b591;
var $be36d5feddcf5f62$export$7f54fc3180508a52;
var $be36d5feddcf5f62$export$f680877a34711e37;
var $be36d5feddcf5f62$export$d5a552a76deda3c2;
var $be36d5feddcf5f62$export$aaabe4eda9ed9969;
var $be36d5feddcf5f62$export$e5c5a5f917a5871c;
var $be36d5feddcf5f62$export$1538c33de8887b59;
var $be36d5feddcf5f62$export$fca7f784ae7a249a;
var $be36d5feddcf5f62$export$13e3392192263954;
var $be36d5feddcf5f62$export$b8f5890fc79d6aca;
var $be36d5feddcf5f62$export$60241385465d0a34;
var $be36d5feddcf5f62$export$306c0aa65ff9ec16;
var $be36d5feddcf5f62$export$7b286972b8d8ccbf;
var $be36d5feddcf5f62$export$83d89fbfd8236492;
"use strict";
var $be36d5feddcf5f62$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $be36d5feddcf5f62$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $be36d5feddcf5f62$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $be36d5feddcf5f62$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $be36d5feddcf5f62$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $be36d5feddcf5f62$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $be36d5feddcf5f62$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $be36d5feddcf5f62$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $be36d5feddcf5f62$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $be36d5feddcf5f62$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $be36d5feddcf5f62$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $be36d5feddcf5f62$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $be36d5feddcf5f62$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $be36d5feddcf5f62$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $be36d5feddcf5f62$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $be36d5feddcf5f62$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$be36d5feddcf5f62$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $be36d5feddcf5f62$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $be36d5feddcf5f62$var$assign = Object.assign, $be36d5feddcf5f62$var$emptyObject = {};
function $be36d5feddcf5f62$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $be36d5feddcf5f62$var$emptyObject;
    this.updater = updater || $be36d5feddcf5f62$var$ReactNoopUpdateQueue;
}
$be36d5feddcf5f62$var$Component.prototype.isReactComponent = {};
$be36d5feddcf5f62$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$be36d5feddcf5f62$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $be36d5feddcf5f62$var$ComponentDummy() {}
$be36d5feddcf5f62$var$ComponentDummy.prototype = $be36d5feddcf5f62$var$Component.prototype;
function $be36d5feddcf5f62$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $be36d5feddcf5f62$var$emptyObject;
    this.updater = updater || $be36d5feddcf5f62$var$ReactNoopUpdateQueue;
}
var $be36d5feddcf5f62$var$pureComponentPrototype = $be36d5feddcf5f62$var$PureComponent.prototype = new $be36d5feddcf5f62$var$ComponentDummy();
$be36d5feddcf5f62$var$pureComponentPrototype.constructor = $be36d5feddcf5f62$var$PureComponent;
$be36d5feddcf5f62$var$assign($be36d5feddcf5f62$var$pureComponentPrototype, $be36d5feddcf5f62$var$Component.prototype);
$be36d5feddcf5f62$var$pureComponentPrototype.isPureReactComponent = !0;
var $be36d5feddcf5f62$var$isArrayImpl = Array.isArray;
function $be36d5feddcf5f62$var$noop() {}
var $be36d5feddcf5f62$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $be36d5feddcf5f62$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $be36d5feddcf5f62$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $be36d5feddcf5f62$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $be36d5feddcf5f62$var$cloneAndReplaceKey(oldElement, newKey) {
    return $be36d5feddcf5f62$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $be36d5feddcf5f62$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $be36d5feddcf5f62$var$REACT_ELEMENT_TYPE;
}
function $be36d5feddcf5f62$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $be36d5feddcf5f62$var$userProvidedKeyEscapeRegex = /\/+/g;
function $be36d5feddcf5f62$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $be36d5feddcf5f62$var$escape("" + element.key) : index.toString(36);
}
function $be36d5feddcf5f62$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($be36d5feddcf5f62$var$noop, $be36d5feddcf5f62$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $be36d5feddcf5f62$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $be36d5feddcf5f62$var$REACT_ELEMENT_TYPE:
                case $be36d5feddcf5f62$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $be36d5feddcf5f62$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $be36d5feddcf5f62$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $be36d5feddcf5f62$var$getElementKey(children, 0) : nameSoFar, $be36d5feddcf5f62$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($be36d5feddcf5f62$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $be36d5feddcf5f62$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($be36d5feddcf5f62$var$isValidElement(callback) && (callback = $be36d5feddcf5f62$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($be36d5feddcf5f62$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($be36d5feddcf5f62$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $be36d5feddcf5f62$var$getElementKey(nameSoFar, i), invokeCallback += $be36d5feddcf5f62$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $be36d5feddcf5f62$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $be36d5feddcf5f62$var$getElementKey(nameSoFar, i++), invokeCallback += $be36d5feddcf5f62$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $be36d5feddcf5f62$var$mapIntoArray($be36d5feddcf5f62$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $be36d5feddcf5f62$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $be36d5feddcf5f62$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $be36d5feddcf5f62$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $be36d5feddcf5f62$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $be36d5feddcf5f62$var$startTransition(scope) {
    var prevTransition = $be36d5feddcf5f62$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $be36d5feddcf5f62$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $be36d5feddcf5f62$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($be36d5feddcf5f62$var$noop, $be36d5feddcf5f62$var$reportGlobalError);
    } catch (error) {
        $be36d5feddcf5f62$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $be36d5feddcf5f62$var$ReactSharedInternals.T = prevTransition;
    }
}
function $be36d5feddcf5f62$var$addTransitionType(type) {
    var transition = $be36d5feddcf5f62$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $be36d5feddcf5f62$var$startTransition($be36d5feddcf5f62$var$addTransitionType.bind(null, type));
}
var $be36d5feddcf5f62$var$Children = {
    map: $be36d5feddcf5f62$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $be36d5feddcf5f62$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $be36d5feddcf5f62$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $be36d5feddcf5f62$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$be36d5feddcf5f62$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$be36d5feddcf5f62$export$9c16c1426311996d = $be36d5feddcf5f62$var$REACT_ACTIVITY_TYPE;
$be36d5feddcf5f62$export$dca3b0875bd9a954 = $be36d5feddcf5f62$var$Children;
$be36d5feddcf5f62$export$16fa2f45be04daa8 = $be36d5feddcf5f62$var$Component;
$be36d5feddcf5f62$export$ffb0004e005737fa = $be36d5feddcf5f62$var$REACT_FRAGMENT_TYPE;
$be36d5feddcf5f62$export$e2c29f18771995cb = $be36d5feddcf5f62$var$REACT_PROFILER_TYPE;
$be36d5feddcf5f62$export$221d75b3f55bb0bd = $be36d5feddcf5f62$var$PureComponent;
$be36d5feddcf5f62$export$5f8d39834fd61797 = $be36d5feddcf5f62$var$REACT_STRICT_MODE_TYPE;
$be36d5feddcf5f62$export$74bf444e3cd11ea5 = $be36d5feddcf5f62$var$REACT_SUSPENSE_TYPE;
$be36d5feddcf5f62$export$8cdaa4703948c5e9 = $be36d5feddcf5f62$var$REACT_VIEW_TRANSITION_TYPE;
$be36d5feddcf5f62$export$1ced07cd6b1985ce = $be36d5feddcf5f62$var$ReactSharedInternals;
$be36d5feddcf5f62$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $be36d5feddcf5f62$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$be36d5feddcf5f62$export$87c99536b1b8cdd8 = $be36d5feddcf5f62$var$addTransitionType;
$be36d5feddcf5f62$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$be36d5feddcf5f62$export$8c538325882c7eec = function() {
    return null;
};
$be36d5feddcf5f62$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $be36d5feddcf5f62$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$be36d5feddcf5f62$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $be36d5feddcf5f62$var$ReactElement(element.type, key, props);
};
$be36d5feddcf5f62$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $be36d5feddcf5f62$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $be36d5feddcf5f62$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$be36d5feddcf5f62$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$be36d5feddcf5f62$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $be36d5feddcf5f62$var$ReactElement(type, key, props);
};
$be36d5feddcf5f62$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$be36d5feddcf5f62$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $be36d5feddcf5f62$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$be36d5feddcf5f62$export$a8257692ac88316c = $be36d5feddcf5f62$var$isValidElement;
$be36d5feddcf5f62$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $be36d5feddcf5f62$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $be36d5feddcf5f62$var$lazyInitializer
    };
};
$be36d5feddcf5f62$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $be36d5feddcf5f62$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$be36d5feddcf5f62$export$7568632d0d33d16d = $be36d5feddcf5f62$var$startTransition;
$be36d5feddcf5f62$export$f93f40ac0ca7e3a8 = function() {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.useCacheRefresh();
};
$be36d5feddcf5f62$export$1f96ae73734a86cc = function(usable) {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.use(usable);
};
$be36d5feddcf5f62$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$be36d5feddcf5f62$export$35808ee640e87ca7 = function(callback, deps) {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$be36d5feddcf5f62$export$fae74005e78b1a27 = function(Context) {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.useContext(Context);
};
$be36d5feddcf5f62$export$dc8fbce3eb94dc1e = function() {};
$be36d5feddcf5f62$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$be36d5feddcf5f62$export$6d9c69b0de29b591 = function(create, deps) {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.useEffect(create, deps);
};
$be36d5feddcf5f62$export$7f54fc3180508a52 = function(callback) {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$be36d5feddcf5f62$export$f680877a34711e37 = function() {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.useId();
};
$be36d5feddcf5f62$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$be36d5feddcf5f62$export$aaabe4eda9ed9969 = function(create, deps) {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$be36d5feddcf5f62$export$e5c5a5f917a5871c = function(create, deps) {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$be36d5feddcf5f62$export$1538c33de8887b59 = function(create, deps) {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.useMemo(create, deps);
};
$be36d5feddcf5f62$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$be36d5feddcf5f62$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$be36d5feddcf5f62$export$b8f5890fc79d6aca = function(initialValue) {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.useRef(initialValue);
};
$be36d5feddcf5f62$export$60241385465d0a34 = function(initialState) {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.useState(initialState);
};
$be36d5feddcf5f62$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$be36d5feddcf5f62$export$7b286972b8d8ccbf = function() {
    return $be36d5feddcf5f62$var$ReactSharedInternals.H.useTransition();
};
$be36d5feddcf5f62$export$83d89fbfd8236492 = "19.3.1";

});


parcelRegister("cc1lg", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $8e07a5888a205cc0$export$882461b6382ed46c; }, function (v) { return $8e07a5888a205cc0$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $8e07a5888a205cc0$export$757ceba2d55c277e; }, function (v) { return $8e07a5888a205cc0$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $8e07a5888a205cc0$export$83d89fbfd8236492; }, function (v) { return $8e07a5888a205cc0$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $8e07a5888a205cc0$export$882461b6382ed46c;
var $8e07a5888a205cc0$export$757ceba2d55c277e;
var $8e07a5888a205cc0$export$83d89fbfd8236492;
"use strict";

var $5JhdH = parcelRequire("5JhdH");

var $jHEir = parcelRequire("jHEir");

var $faOpr = parcelRequire("faOpr");
function $8e07a5888a205cc0$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $8e07a5888a205cc0$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $8e07a5888a205cc0$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $8e07a5888a205cc0$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $8e07a5888a205cc0$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $8e07a5888a205cc0$var$assertIsMounted(fiber) {
    if ($8e07a5888a205cc0$var$getNearestMountedFiber(fiber) !== fiber) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(188));
}
function $8e07a5888a205cc0$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $8e07a5888a205cc0$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $8e07a5888a205cc0$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $8e07a5888a205cc0$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $8e07a5888a205cc0$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $8e07a5888a205cc0$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $8e07a5888a205cc0$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $8e07a5888a205cc0$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $8e07a5888a205cc0$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $8e07a5888a205cc0$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $8e07a5888a205cc0$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $8e07a5888a205cc0$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $8e07a5888a205cc0$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $8e07a5888a205cc0$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $8e07a5888a205cc0$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $8e07a5888a205cc0$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(559));
    }
}
var $8e07a5888a205cc0$var$searchTarget = null, $8e07a5888a205cc0$var$searchBoundary = null;
function $8e07a5888a205cc0$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($8e07a5888a205cc0$var$searchTarget = child, !0) : !1;
}
function $8e07a5888a205cc0$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($8e07a5888a205cc0$var$searchBoundary = child, !1) : child === target ? (null !== $8e07a5888a205cc0$var$searchBoundary && ($8e07a5888a205cc0$var$searchTarget = child), !0) : !1;
}
function $8e07a5888a205cc0$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $8e07a5888a205cc0$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $8e07a5888a205cc0$var$assign = Object.assign, $8e07a5888a205cc0$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $8e07a5888a205cc0$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $8e07a5888a205cc0$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $8e07a5888a205cc0$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $8e07a5888a205cc0$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $8e07a5888a205cc0$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $8e07a5888a205cc0$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $8e07a5888a205cc0$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $8e07a5888a205cc0$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $8e07a5888a205cc0$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $8e07a5888a205cc0$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $8e07a5888a205cc0$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $8e07a5888a205cc0$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $8e07a5888a205cc0$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $8e07a5888a205cc0$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $8e07a5888a205cc0$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $8e07a5888a205cc0$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $8e07a5888a205cc0$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $8e07a5888a205cc0$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $8e07a5888a205cc0$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $8e07a5888a205cc0$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$8e07a5888a205cc0$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $8e07a5888a205cc0$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $8e07a5888a205cc0$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $8e07a5888a205cc0$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $8e07a5888a205cc0$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $8e07a5888a205cc0$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $8e07a5888a205cc0$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $8e07a5888a205cc0$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $8e07a5888a205cc0$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $8e07a5888a205cc0$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $8e07a5888a205cc0$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $8e07a5888a205cc0$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $8e07a5888a205cc0$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $8e07a5888a205cc0$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $8e07a5888a205cc0$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $8e07a5888a205cc0$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $8e07a5888a205cc0$var$getComponentNameFromType(type.type) || "Memo";
        case $8e07a5888a205cc0$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $8e07a5888a205cc0$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $8e07a5888a205cc0$var$isArrayImpl = Array.isArray, $8e07a5888a205cc0$var$ReactSharedInternals = $jHEir.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $8e07a5888a205cc0$var$ReactDOMSharedInternals = $faOpr.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $8e07a5888a205cc0$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $8e07a5888a205cc0$var$valueStack = [], $8e07a5888a205cc0$var$index = -1;
function $8e07a5888a205cc0$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $8e07a5888a205cc0$var$pop(cursor) {
    0 > $8e07a5888a205cc0$var$index || (cursor.current = $8e07a5888a205cc0$var$valueStack[$8e07a5888a205cc0$var$index], $8e07a5888a205cc0$var$valueStack[$8e07a5888a205cc0$var$index] = null, $8e07a5888a205cc0$var$index--);
}
function $8e07a5888a205cc0$var$push(cursor, value) {
    $8e07a5888a205cc0$var$index++;
    $8e07a5888a205cc0$var$valueStack[$8e07a5888a205cc0$var$index] = cursor.current;
    cursor.current = value;
}
var $8e07a5888a205cc0$var$contextStackCursor = $8e07a5888a205cc0$var$createCursor(null), $8e07a5888a205cc0$var$contextFiberStackCursor = $8e07a5888a205cc0$var$createCursor(null), $8e07a5888a205cc0$var$rootInstanceStackCursor = $8e07a5888a205cc0$var$createCursor(null), $8e07a5888a205cc0$var$hostTransitionProviderCursor = $8e07a5888a205cc0$var$createCursor(null);
function $8e07a5888a205cc0$var$pushHostContainer(fiber, nextRootInstance) {
    $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$rootInstanceStackCursor, nextRootInstance);
    $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$contextFiberStackCursor, fiber);
    $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $8e07a5888a205cc0$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $8e07a5888a205cc0$var$getOwnHostContext(nextRootInstance), fiber = $8e07a5888a205cc0$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $8e07a5888a205cc0$var$pop($8e07a5888a205cc0$var$contextStackCursor);
    $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$contextStackCursor, fiber);
}
function $8e07a5888a205cc0$var$popHostContainer() {
    $8e07a5888a205cc0$var$pop($8e07a5888a205cc0$var$contextStackCursor);
    $8e07a5888a205cc0$var$pop($8e07a5888a205cc0$var$contextFiberStackCursor);
    $8e07a5888a205cc0$var$pop($8e07a5888a205cc0$var$rootInstanceStackCursor);
}
function $8e07a5888a205cc0$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($8e07a5888a205cc0$var$HostTransitionContext._currentValue = stateHook.memoizedState, $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$hostTransitionProviderCursor, fiber));
    stateHook = $8e07a5888a205cc0$var$contextStackCursor.current;
    var JSCompiler_inline_result = $8e07a5888a205cc0$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$contextFiberStackCursor, fiber), $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$contextStackCursor, JSCompiler_inline_result));
}
function $8e07a5888a205cc0$var$popHostContext(fiber) {
    $8e07a5888a205cc0$var$contextFiberStackCursor.current === fiber && ($8e07a5888a205cc0$var$pop($8e07a5888a205cc0$var$contextStackCursor), $8e07a5888a205cc0$var$pop($8e07a5888a205cc0$var$contextFiberStackCursor));
    $8e07a5888a205cc0$var$hostTransitionProviderCursor.current === fiber && ($8e07a5888a205cc0$var$pop($8e07a5888a205cc0$var$hostTransitionProviderCursor), $8e07a5888a205cc0$var$HostTransitionContext._currentValue = $8e07a5888a205cc0$var$sharedNotPendingObject);
}
var $8e07a5888a205cc0$var$prefix, $8e07a5888a205cc0$var$suffix;
function $8e07a5888a205cc0$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $8e07a5888a205cc0$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $8e07a5888a205cc0$var$prefix = match && match[1] || "";
        $8e07a5888a205cc0$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $8e07a5888a205cc0$var$prefix + name + $8e07a5888a205cc0$var$suffix;
}
var $8e07a5888a205cc0$var$reentry = !1;
function $8e07a5888a205cc0$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $8e07a5888a205cc0$var$reentry) return "";
    $8e07a5888a205cc0$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $8e07a5888a205cc0$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $8e07a5888a205cc0$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $8e07a5888a205cc0$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $8e07a5888a205cc0$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $8e07a5888a205cc0$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $8e07a5888a205cc0$var$describeBuiltInComponentFrame("Suspense Fallback") : $8e07a5888a205cc0$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $8e07a5888a205cc0$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $8e07a5888a205cc0$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $8e07a5888a205cc0$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $8e07a5888a205cc0$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $8e07a5888a205cc0$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $8e07a5888a205cc0$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $8e07a5888a205cc0$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $8e07a5888a205cc0$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $8e07a5888a205cc0$var$hasOwnProperty = Object.prototype.hasOwnProperty, $8e07a5888a205cc0$var$scheduleCallback$3 = $5JhdH.unstable_scheduleCallback, $8e07a5888a205cc0$var$cancelCallback$1 = $5JhdH.unstable_cancelCallback, $8e07a5888a205cc0$var$shouldYield = $5JhdH.unstable_shouldYield, $8e07a5888a205cc0$var$requestPaint = $5JhdH.unstable_requestPaint, $8e07a5888a205cc0$var$now = $5JhdH.unstable_now, $8e07a5888a205cc0$var$getCurrentPriorityLevel = $5JhdH.unstable_getCurrentPriorityLevel, $8e07a5888a205cc0$var$ImmediatePriority = $5JhdH.unstable_ImmediatePriority, $8e07a5888a205cc0$var$UserBlockingPriority = $5JhdH.unstable_UserBlockingPriority, $8e07a5888a205cc0$var$NormalPriority$1 = $5JhdH.unstable_NormalPriority, $8e07a5888a205cc0$var$LowPriority = $5JhdH.unstable_LowPriority, $8e07a5888a205cc0$var$IdlePriority = $5JhdH.unstable_IdlePriority, $8e07a5888a205cc0$var$log$1 = $5JhdH.log, $8e07a5888a205cc0$var$unstable_setDisableYieldValue = $5JhdH.unstable_setDisableYieldValue, $8e07a5888a205cc0$var$rendererID = null, $8e07a5888a205cc0$var$injectedHook = null;
function $8e07a5888a205cc0$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $8e07a5888a205cc0$var$log$1 && $8e07a5888a205cc0$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($8e07a5888a205cc0$var$injectedHook && "function" === typeof $8e07a5888a205cc0$var$injectedHook.setStrictMode) try {
        $8e07a5888a205cc0$var$injectedHook.setStrictMode($8e07a5888a205cc0$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $8e07a5888a205cc0$var$clz32 = Math.clz32 ? Math.clz32 : $8e07a5888a205cc0$var$clz32Fallback, $8e07a5888a205cc0$var$log = Math.log, $8e07a5888a205cc0$var$LN2 = Math.LN2;
function $8e07a5888a205cc0$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($8e07a5888a205cc0$var$log(x) / $8e07a5888a205cc0$var$LN2 | 0) | 0;
}
var $8e07a5888a205cc0$var$nextTransitionUpdateLane = 256, $8e07a5888a205cc0$var$nextTransitionDeferredLane = 262144, $8e07a5888a205cc0$var$nextRetryLane = 4194304;
function $8e07a5888a205cc0$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $8e07a5888a205cc0$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $8e07a5888a205cc0$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $8e07a5888a205cc0$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $8e07a5888a205cc0$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $8e07a5888a205cc0$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $8e07a5888a205cc0$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $8e07a5888a205cc0$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $8e07a5888a205cc0$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $8e07a5888a205cc0$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $8e07a5888a205cc0$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $8e07a5888a205cc0$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $8e07a5888a205cc0$var$claimNextRetryLane() {
    var lane = $8e07a5888a205cc0$var$nextRetryLane;
    $8e07a5888a205cc0$var$nextRetryLane <<= 1;
    0 === ($8e07a5888a205cc0$var$nextRetryLane & 62914560) && ($8e07a5888a205cc0$var$nextRetryLane = 4194304);
    return lane;
}
function $8e07a5888a205cc0$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $8e07a5888a205cc0$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $8e07a5888a205cc0$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $8e07a5888a205cc0$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $8e07a5888a205cc0$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $8e07a5888a205cc0$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $8e07a5888a205cc0$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $8e07a5888a205cc0$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $8e07a5888a205cc0$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $8e07a5888a205cc0$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $8e07a5888a205cc0$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $8e07a5888a205cc0$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $8e07a5888a205cc0$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $8e07a5888a205cc0$var$resolveUpdatePriority() {
    var updatePriority = $8e07a5888a205cc0$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $8e07a5888a205cc0$var$getEventPriority(updatePriority.type);
}
function $8e07a5888a205cc0$var$runWithPriority(priority, fn) {
    var previousPriority = $8e07a5888a205cc0$var$ReactDOMSharedInternals.p;
    try {
        return $8e07a5888a205cc0$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $8e07a5888a205cc0$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $8e07a5888a205cc0$var$randomKey = Math.random().toString(36).slice(2), $8e07a5888a205cc0$var$internalInstanceKey = "__reactFiber$" + $8e07a5888a205cc0$var$randomKey, $8e07a5888a205cc0$var$internalPropsKey = "__reactProps$" + $8e07a5888a205cc0$var$randomKey, $8e07a5888a205cc0$var$internalContainerInstanceKey = "__reactContainer$" + $8e07a5888a205cc0$var$randomKey, $8e07a5888a205cc0$var$internalEventHandlersKey = "__reactEvents$" + $8e07a5888a205cc0$var$randomKey, $8e07a5888a205cc0$var$internalEventHandlerListenersKey = "__reactListeners$" + $8e07a5888a205cc0$var$randomKey, $8e07a5888a205cc0$var$internalEventHandlesSetKey = "__reactHandles$" + $8e07a5888a205cc0$var$randomKey, $8e07a5888a205cc0$var$internalRootNodeResourcesKey = "__reactResources$" + $8e07a5888a205cc0$var$randomKey, $8e07a5888a205cc0$var$internalHoistableMarker = "__reactMarker$" + $8e07a5888a205cc0$var$randomKey, $8e07a5888a205cc0$var$internalLoadPendingKey = "__reactLoad$" + $8e07a5888a205cc0$var$randomKey;
function $8e07a5888a205cc0$var$detachDeletedInstance(node) {
    delete node[$8e07a5888a205cc0$var$internalInstanceKey];
    delete node[$8e07a5888a205cc0$var$internalPropsKey];
    delete node[$8e07a5888a205cc0$var$internalEventHandlerListenersKey];
    delete node[$8e07a5888a205cc0$var$internalEventHandlesSetKey];
}
function $8e07a5888a205cc0$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$8e07a5888a205cc0$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$8e07a5888a205cc0$var$internalContainerInstanceKey] || parentNode[$8e07a5888a205cc0$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $8e07a5888a205cc0$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$8e07a5888a205cc0$var$internalInstanceKey]) return parentNode;
                targetNode = $8e07a5888a205cc0$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $8e07a5888a205cc0$var$getInstanceFromNode(node) {
    if (node = node[$8e07a5888a205cc0$var$internalInstanceKey] || node[$8e07a5888a205cc0$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $8e07a5888a205cc0$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(33));
}
function $8e07a5888a205cc0$var$getResourcesFromRoot(root) {
    var resources = root[$8e07a5888a205cc0$var$internalRootNodeResourcesKey];
    resources || (resources = root[$8e07a5888a205cc0$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $8e07a5888a205cc0$var$markNodeAsHoistable(node) {
    node[$8e07a5888a205cc0$var$internalHoistableMarker] = !0;
}
function $8e07a5888a205cc0$var$clearPendingLoadOnNode(node) {
    node[$8e07a5888a205cc0$var$internalLoadPendingKey] = void 0;
}
var $8e07a5888a205cc0$var$allNativeEvents = new Set(), $8e07a5888a205cc0$var$registrationNameDependencies = {};
function $8e07a5888a205cc0$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $8e07a5888a205cc0$var$registerDirectEvent(registrationName, dependencies);
    $8e07a5888a205cc0$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $8e07a5888a205cc0$var$registerDirectEvent(registrationName, dependencies) {
    $8e07a5888a205cc0$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$8e07a5888a205cc0$var$allNativeEvents.add(dependencies[registrationName]);
}
var $8e07a5888a205cc0$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $8e07a5888a205cc0$var$illegalAttributeNameCache = {}, $8e07a5888a205cc0$var$validatedAttributeNameCache = {};
function $8e07a5888a205cc0$var$isAttributeNameSafe(attributeName) {
    if ($8e07a5888a205cc0$var$hasOwnProperty.call($8e07a5888a205cc0$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($8e07a5888a205cc0$var$hasOwnProperty.call($8e07a5888a205cc0$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($8e07a5888a205cc0$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $8e07a5888a205cc0$var$validatedAttributeNameCache[attributeName] = !0;
    $8e07a5888a205cc0$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $8e07a5888a205cc0$var$viewTransitionMutationContext = !1;
function $8e07a5888a205cc0$var$pushMutationContext() {
    var prev = $8e07a5888a205cc0$var$viewTransitionMutationContext;
    $8e07a5888a205cc0$var$viewTransitionMutationContext = !1;
    return prev;
}
function $8e07a5888a205cc0$var$setValueForAttribute(node, name, value) {
    if ($8e07a5888a205cc0$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $8e07a5888a205cc0$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $8e07a5888a205cc0$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $8e07a5888a205cc0$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $8e07a5888a205cc0$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $8e07a5888a205cc0$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $8e07a5888a205cc0$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $8e07a5888a205cc0$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $8e07a5888a205cc0$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $8e07a5888a205cc0$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $8e07a5888a205cc0$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $8e07a5888a205cc0$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $8e07a5888a205cc0$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($8e07a5888a205cc0$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $8e07a5888a205cc0$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $8e07a5888a205cc0$var$getToStringValue(value);
        } else element.value !== "" + $8e07a5888a205cc0$var$getToStringValue(value) && (element.value = "" + $8e07a5888a205cc0$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $8e07a5888a205cc0$var$setDefaultValue(element, $8e07a5888a205cc0$var$getToStringValue(element.value)) : $8e07a5888a205cc0$var$setDefaultValue(element, $8e07a5888a205cc0$var$getToStringValue(value)) : null != defaultValue ? $8e07a5888a205cc0$var$setDefaultValue(element, $8e07a5888a205cc0$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $8e07a5888a205cc0$var$getToStringValue(name) : element.removeAttribute("name");
}
function $8e07a5888a205cc0$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $8e07a5888a205cc0$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $8e07a5888a205cc0$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $8e07a5888a205cc0$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $8e07a5888a205cc0$var$track(element);
}
function $8e07a5888a205cc0$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $8e07a5888a205cc0$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $8e07a5888a205cc0$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $8e07a5888a205cc0$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $8e07a5888a205cc0$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $8e07a5888a205cc0$var$getToStringValue(defaultValue) : "";
}
function $8e07a5888a205cc0$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(92));
            if ($8e07a5888a205cc0$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $8e07a5888a205cc0$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $8e07a5888a205cc0$var$track(element);
}
function $8e07a5888a205cc0$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $8e07a5888a205cc0$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $8e07a5888a205cc0$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $8e07a5888a205cc0$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $8e07a5888a205cc0$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $8e07a5888a205cc0$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($8e07a5888a205cc0$var$setValueForStyle(node, styleName$16, styleName), $8e07a5888a205cc0$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $8e07a5888a205cc0$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $8e07a5888a205cc0$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $8e07a5888a205cc0$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $8e07a5888a205cc0$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $8e07a5888a205cc0$var$sanitizeURL(url) {
    return $8e07a5888a205cc0$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $8e07a5888a205cc0$var$noop$1() {}
var $8e07a5888a205cc0$var$currentReplayingEvent = null;
function $8e07a5888a205cc0$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $8e07a5888a205cc0$var$restoreTarget = null, $8e07a5888a205cc0$var$restoreQueue = null;
function $8e07a5888a205cc0$var$restoreStateOfTarget(target) {
    var internalInstance = $8e07a5888a205cc0$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$8e07a5888a205cc0$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $8e07a5888a205cc0$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $8e07a5888a205cc0$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$8e07a5888a205cc0$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(90));
                            $8e07a5888a205cc0$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $8e07a5888a205cc0$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $8e07a5888a205cc0$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $8e07a5888a205cc0$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $8e07a5888a205cc0$var$isInsideEventHandler = !1;
function $8e07a5888a205cc0$var$batchedUpdates$1(fn, a, b) {
    if ($8e07a5888a205cc0$var$isInsideEventHandler) return fn(a, b);
    $8e07a5888a205cc0$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($8e07a5888a205cc0$var$isInsideEventHandler = !1, null !== $8e07a5888a205cc0$var$restoreTarget || null !== $8e07a5888a205cc0$var$restoreQueue) {
            if ($8e07a5888a205cc0$var$flushSyncWork$1(), $8e07a5888a205cc0$var$restoreTarget && (a = $8e07a5888a205cc0$var$restoreTarget, fn = $8e07a5888a205cc0$var$restoreQueue, $8e07a5888a205cc0$var$restoreQueue = $8e07a5888a205cc0$var$restoreTarget = null, $8e07a5888a205cc0$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$8e07a5888a205cc0$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $8e07a5888a205cc0$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$8e07a5888a205cc0$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $8e07a5888a205cc0$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $8e07a5888a205cc0$var$passiveBrowserEventsSupported = !1;
if ($8e07a5888a205cc0$var$canUseDOM) try {
    var $8e07a5888a205cc0$var$options = {};
    Object.defineProperty($8e07a5888a205cc0$var$options, "passive", {
        get: function() {
            $8e07a5888a205cc0$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $8e07a5888a205cc0$var$options, $8e07a5888a205cc0$var$options);
    window.removeEventListener("test", $8e07a5888a205cc0$var$options, $8e07a5888a205cc0$var$options);
} catch (e) {
    $8e07a5888a205cc0$var$passiveBrowserEventsSupported = !1;
}
var $8e07a5888a205cc0$var$root = null, $8e07a5888a205cc0$var$startText = null, $8e07a5888a205cc0$var$fallbackText = null;
function $8e07a5888a205cc0$var$getData() {
    if ($8e07a5888a205cc0$var$fallbackText) return $8e07a5888a205cc0$var$fallbackText;
    var start, startValue = $8e07a5888a205cc0$var$startText, startLength = startValue.length, end, endValue = "value" in $8e07a5888a205cc0$var$root ? $8e07a5888a205cc0$var$root.value : $8e07a5888a205cc0$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $8e07a5888a205cc0$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $8e07a5888a205cc0$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $8e07a5888a205cc0$var$functionThatReturnsTrue() {
    return !0;
}
function $8e07a5888a205cc0$var$functionThatReturnsFalse() {
    return !1;
}
function $8e07a5888a205cc0$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $8e07a5888a205cc0$var$functionThatReturnsTrue : $8e07a5888a205cc0$var$functionThatReturnsFalse;
        this.isPropagationStopped = $8e07a5888a205cc0$var$functionThatReturnsFalse;
        return this;
    }
    $8e07a5888a205cc0$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $8e07a5888a205cc0$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $8e07a5888a205cc0$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $8e07a5888a205cc0$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $8e07a5888a205cc0$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $8e07a5888a205cc0$var$SyntheticEvent = $8e07a5888a205cc0$var$createSyntheticEvent($8e07a5888a205cc0$var$EventInterface), $8e07a5888a205cc0$var$UIEventInterface = $8e07a5888a205cc0$var$assign({}, $8e07a5888a205cc0$var$EventInterface, {
    view: 0,
    detail: 0
}), $8e07a5888a205cc0$var$SyntheticUIEvent = $8e07a5888a205cc0$var$createSyntheticEvent($8e07a5888a205cc0$var$UIEventInterface), $8e07a5888a205cc0$var$lastMovementX, $8e07a5888a205cc0$var$lastMovementY, $8e07a5888a205cc0$var$lastMouseEvent, $8e07a5888a205cc0$var$MouseEventInterface = $8e07a5888a205cc0$var$assign({}, $8e07a5888a205cc0$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $8e07a5888a205cc0$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $8e07a5888a205cc0$var$lastMouseEvent && ($8e07a5888a205cc0$var$lastMouseEvent && "mousemove" === event.type ? ($8e07a5888a205cc0$var$lastMovementX = event.screenX - $8e07a5888a205cc0$var$lastMouseEvent.screenX, $8e07a5888a205cc0$var$lastMovementY = event.screenY - $8e07a5888a205cc0$var$lastMouseEvent.screenY) : $8e07a5888a205cc0$var$lastMovementY = $8e07a5888a205cc0$var$lastMovementX = 0, $8e07a5888a205cc0$var$lastMouseEvent = event);
        return $8e07a5888a205cc0$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $8e07a5888a205cc0$var$lastMovementY;
    }
}), $8e07a5888a205cc0$var$SyntheticMouseEvent = $8e07a5888a205cc0$var$createSyntheticEvent($8e07a5888a205cc0$var$MouseEventInterface), $8e07a5888a205cc0$var$DragEventInterface = $8e07a5888a205cc0$var$assign({}, $8e07a5888a205cc0$var$MouseEventInterface, {
    dataTransfer: 0
}), $8e07a5888a205cc0$var$SyntheticDragEvent = $8e07a5888a205cc0$var$createSyntheticEvent($8e07a5888a205cc0$var$DragEventInterface), $8e07a5888a205cc0$var$FocusEventInterface = $8e07a5888a205cc0$var$assign({}, $8e07a5888a205cc0$var$UIEventInterface, {
    relatedTarget: 0
}), $8e07a5888a205cc0$var$SyntheticFocusEvent = $8e07a5888a205cc0$var$createSyntheticEvent($8e07a5888a205cc0$var$FocusEventInterface), $8e07a5888a205cc0$var$AnimationEventInterface = $8e07a5888a205cc0$var$assign({}, $8e07a5888a205cc0$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8e07a5888a205cc0$var$SyntheticAnimationEvent = $8e07a5888a205cc0$var$createSyntheticEvent($8e07a5888a205cc0$var$AnimationEventInterface), $8e07a5888a205cc0$var$ClipboardEventInterface = $8e07a5888a205cc0$var$assign({}, $8e07a5888a205cc0$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $8e07a5888a205cc0$var$SyntheticClipboardEvent = $8e07a5888a205cc0$var$createSyntheticEvent($8e07a5888a205cc0$var$ClipboardEventInterface), $8e07a5888a205cc0$var$CompositionEventInterface = $8e07a5888a205cc0$var$assign({}, $8e07a5888a205cc0$var$EventInterface, {
    data: 0
}), $8e07a5888a205cc0$var$SyntheticCompositionEvent = $8e07a5888a205cc0$var$createSyntheticEvent($8e07a5888a205cc0$var$CompositionEventInterface), $8e07a5888a205cc0$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $8e07a5888a205cc0$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $8e07a5888a205cc0$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $8e07a5888a205cc0$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $8e07a5888a205cc0$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $8e07a5888a205cc0$var$getEventModifierState() {
    return $8e07a5888a205cc0$var$modifierStateGetter;
}
var $8e07a5888a205cc0$var$KeyboardEventInterface = $8e07a5888a205cc0$var$assign({}, $8e07a5888a205cc0$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $8e07a5888a205cc0$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $8e07a5888a205cc0$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $8e07a5888a205cc0$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $8e07a5888a205cc0$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $8e07a5888a205cc0$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $8e07a5888a205cc0$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $8e07a5888a205cc0$var$SyntheticKeyboardEvent = $8e07a5888a205cc0$var$createSyntheticEvent($8e07a5888a205cc0$var$KeyboardEventInterface), $8e07a5888a205cc0$var$PointerEventInterface = $8e07a5888a205cc0$var$assign({}, $8e07a5888a205cc0$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $8e07a5888a205cc0$var$SyntheticPointerEvent = $8e07a5888a205cc0$var$createSyntheticEvent($8e07a5888a205cc0$var$PointerEventInterface), $8e07a5888a205cc0$var$SubmitEventInterface = $8e07a5888a205cc0$var$assign({}, $8e07a5888a205cc0$var$EventInterface, {
    submitter: 0
}), $8e07a5888a205cc0$var$SyntheticSubmitEvent = $8e07a5888a205cc0$var$createSyntheticEvent($8e07a5888a205cc0$var$SubmitEventInterface), $8e07a5888a205cc0$var$TouchEventInterface = $8e07a5888a205cc0$var$assign({}, $8e07a5888a205cc0$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $8e07a5888a205cc0$var$getEventModifierState
}), $8e07a5888a205cc0$var$SyntheticTouchEvent = $8e07a5888a205cc0$var$createSyntheticEvent($8e07a5888a205cc0$var$TouchEventInterface), $8e07a5888a205cc0$var$TransitionEventInterface = $8e07a5888a205cc0$var$assign({}, $8e07a5888a205cc0$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8e07a5888a205cc0$var$SyntheticTransitionEvent = $8e07a5888a205cc0$var$createSyntheticEvent($8e07a5888a205cc0$var$TransitionEventInterface), $8e07a5888a205cc0$var$WheelEventInterface = $8e07a5888a205cc0$var$assign({}, $8e07a5888a205cc0$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $8e07a5888a205cc0$var$SyntheticWheelEvent = $8e07a5888a205cc0$var$createSyntheticEvent($8e07a5888a205cc0$var$WheelEventInterface), $8e07a5888a205cc0$var$ToggleEventInterface = $8e07a5888a205cc0$var$assign({}, $8e07a5888a205cc0$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $8e07a5888a205cc0$var$SyntheticToggleEvent = $8e07a5888a205cc0$var$createSyntheticEvent($8e07a5888a205cc0$var$ToggleEventInterface), $8e07a5888a205cc0$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $8e07a5888a205cc0$var$canUseCompositionEvent = $8e07a5888a205cc0$var$canUseDOM && "CompositionEvent" in window, $8e07a5888a205cc0$var$documentMode = null;
$8e07a5888a205cc0$var$canUseDOM && "documentMode" in document && ($8e07a5888a205cc0$var$documentMode = document.documentMode);
var $8e07a5888a205cc0$var$canUseTextInputEvent = $8e07a5888a205cc0$var$canUseDOM && "TextEvent" in window && !$8e07a5888a205cc0$var$documentMode, $8e07a5888a205cc0$var$useFallbackCompositionData = $8e07a5888a205cc0$var$canUseDOM && (!$8e07a5888a205cc0$var$canUseCompositionEvent || $8e07a5888a205cc0$var$documentMode && 8 < $8e07a5888a205cc0$var$documentMode && 11 >= $8e07a5888a205cc0$var$documentMode), $8e07a5888a205cc0$var$SPACEBAR_CHAR = String.fromCharCode(32), $8e07a5888a205cc0$var$hasSpaceKeypress = !1;
function $8e07a5888a205cc0$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $8e07a5888a205cc0$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $8e07a5888a205cc0$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $8e07a5888a205cc0$var$isComposing = !1;
function $8e07a5888a205cc0$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $8e07a5888a205cc0$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $8e07a5888a205cc0$var$hasSpaceKeypress = !0;
            return $8e07a5888a205cc0$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $8e07a5888a205cc0$var$SPACEBAR_CHAR && $8e07a5888a205cc0$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $8e07a5888a205cc0$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($8e07a5888a205cc0$var$isComposing) return "compositionend" === domEventName || !$8e07a5888a205cc0$var$canUseCompositionEvent && $8e07a5888a205cc0$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $8e07a5888a205cc0$var$getData(), $8e07a5888a205cc0$var$fallbackText = $8e07a5888a205cc0$var$startText = $8e07a5888a205cc0$var$root = null, $8e07a5888a205cc0$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $8e07a5888a205cc0$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $8e07a5888a205cc0$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $8e07a5888a205cc0$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$8e07a5888a205cc0$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $8e07a5888a205cc0$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $8e07a5888a205cc0$var$restoreTarget ? $8e07a5888a205cc0$var$restoreQueue ? $8e07a5888a205cc0$var$restoreQueue.push(target) : $8e07a5888a205cc0$var$restoreQueue = [
        target
    ] : $8e07a5888a205cc0$var$restoreTarget = target;
    inst = $8e07a5888a205cc0$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $8e07a5888a205cc0$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $8e07a5888a205cc0$var$activeElement$1 = null, $8e07a5888a205cc0$var$activeElementInst$1 = null;
function $8e07a5888a205cc0$var$runEventInBatch(dispatchQueue) {
    $8e07a5888a205cc0$var$processDispatchQueue(dispatchQueue, 0);
}
function $8e07a5888a205cc0$var$getInstIfValueChanged(targetInst) {
    var targetNode = $8e07a5888a205cc0$var$getNodeFromInstance(targetInst);
    if ($8e07a5888a205cc0$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $8e07a5888a205cc0$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $8e07a5888a205cc0$var$isInputEventSupported = !1;
if ($8e07a5888a205cc0$var$canUseDOM) {
    var $8e07a5888a205cc0$var$JSCompiler_inline_result$jscomp$318;
    if ($8e07a5888a205cc0$var$canUseDOM) {
        var $8e07a5888a205cc0$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$8e07a5888a205cc0$var$isSupported$jscomp$inline_474) {
            var $8e07a5888a205cc0$var$element$jscomp$inline_475 = document.createElement("div");
            $8e07a5888a205cc0$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $8e07a5888a205cc0$var$isSupported$jscomp$inline_474 = "function" === typeof $8e07a5888a205cc0$var$element$jscomp$inline_475.oninput;
        }
        $8e07a5888a205cc0$var$JSCompiler_inline_result$jscomp$318 = $8e07a5888a205cc0$var$isSupported$jscomp$inline_474;
    } else $8e07a5888a205cc0$var$JSCompiler_inline_result$jscomp$318 = !1;
    $8e07a5888a205cc0$var$isInputEventSupported = $8e07a5888a205cc0$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $8e07a5888a205cc0$var$stopWatchingForValueChange() {
    $8e07a5888a205cc0$var$activeElement$1 && ($8e07a5888a205cc0$var$activeElement$1.detachEvent("onpropertychange", $8e07a5888a205cc0$var$handlePropertyChange), $8e07a5888a205cc0$var$activeElementInst$1 = $8e07a5888a205cc0$var$activeElement$1 = null);
}
function $8e07a5888a205cc0$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $8e07a5888a205cc0$var$getInstIfValueChanged($8e07a5888a205cc0$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $8e07a5888a205cc0$var$createAndAccumulateChangeEvent(dispatchQueue, $8e07a5888a205cc0$var$activeElementInst$1, nativeEvent, $8e07a5888a205cc0$var$getEventTarget(nativeEvent));
        $8e07a5888a205cc0$var$batchedUpdates$1($8e07a5888a205cc0$var$runEventInBatch, dispatchQueue);
    }
}
function $8e07a5888a205cc0$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($8e07a5888a205cc0$var$stopWatchingForValueChange(), $8e07a5888a205cc0$var$activeElement$1 = target, $8e07a5888a205cc0$var$activeElementInst$1 = targetInst, $8e07a5888a205cc0$var$activeElement$1.attachEvent("onpropertychange", $8e07a5888a205cc0$var$handlePropertyChange)) : "focusout" === domEventName && $8e07a5888a205cc0$var$stopWatchingForValueChange();
}
function $8e07a5888a205cc0$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $8e07a5888a205cc0$var$getInstIfValueChanged($8e07a5888a205cc0$var$activeElementInst$1);
}
function $8e07a5888a205cc0$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $8e07a5888a205cc0$var$getInstIfValueChanged(targetInst);
}
function $8e07a5888a205cc0$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $8e07a5888a205cc0$var$getInstIfValueChanged(targetInst);
}
function $8e07a5888a205cc0$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $8e07a5888a205cc0$var$objectIs = "function" === typeof Object.is ? Object.is : $8e07a5888a205cc0$var$is;
function $8e07a5888a205cc0$var$shallowEqual(objA, objB) {
    if ($8e07a5888a205cc0$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$8e07a5888a205cc0$var$hasOwnProperty.call(objB, currentKey) || !$8e07a5888a205cc0$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $8e07a5888a205cc0$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $8e07a5888a205cc0$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $8e07a5888a205cc0$var$getNodeForCharacterOffset(root, offset) {
    var node = $8e07a5888a205cc0$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $8e07a5888a205cc0$var$getLeafNode(node);
    }
}
function $8e07a5888a205cc0$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $8e07a5888a205cc0$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $8e07a5888a205cc0$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $8e07a5888a205cc0$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $8e07a5888a205cc0$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $8e07a5888a205cc0$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $8e07a5888a205cc0$var$skipSelectionChangeEvent = $8e07a5888a205cc0$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $8e07a5888a205cc0$var$activeElement = null, $8e07a5888a205cc0$var$activeElementInst = null, $8e07a5888a205cc0$var$lastSelection = null, $8e07a5888a205cc0$var$mouseDown = !1;
function $8e07a5888a205cc0$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $8e07a5888a205cc0$var$mouseDown || null == $8e07a5888a205cc0$var$activeElement || $8e07a5888a205cc0$var$activeElement !== $8e07a5888a205cc0$var$getActiveElement(doc) || (doc = $8e07a5888a205cc0$var$activeElement, "selectionStart" in doc && $8e07a5888a205cc0$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $8e07a5888a205cc0$var$lastSelection && $8e07a5888a205cc0$var$shallowEqual($8e07a5888a205cc0$var$lastSelection, doc) || ($8e07a5888a205cc0$var$lastSelection = doc, doc = $8e07a5888a205cc0$var$accumulateTwoPhaseListeners($8e07a5888a205cc0$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $8e07a5888a205cc0$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $8e07a5888a205cc0$var$activeElement)));
}
function $8e07a5888a205cc0$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $8e07a5888a205cc0$var$vendorPrefixes = {
    animationend: $8e07a5888a205cc0$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $8e07a5888a205cc0$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $8e07a5888a205cc0$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $8e07a5888a205cc0$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $8e07a5888a205cc0$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $8e07a5888a205cc0$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $8e07a5888a205cc0$var$makePrefixMap("Transition", "TransitionEnd")
}, $8e07a5888a205cc0$var$prefixedEventNames = {}, $8e07a5888a205cc0$var$style = {};
$8e07a5888a205cc0$var$canUseDOM && ($8e07a5888a205cc0$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $8e07a5888a205cc0$var$vendorPrefixes.animationend.animation, delete $8e07a5888a205cc0$var$vendorPrefixes.animationiteration.animation, delete $8e07a5888a205cc0$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $8e07a5888a205cc0$var$vendorPrefixes.transitionend.transition);
function $8e07a5888a205cc0$var$getVendorPrefixedEventName(eventName) {
    if ($8e07a5888a205cc0$var$prefixedEventNames[eventName]) return $8e07a5888a205cc0$var$prefixedEventNames[eventName];
    if (!$8e07a5888a205cc0$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $8e07a5888a205cc0$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $8e07a5888a205cc0$var$style) return $8e07a5888a205cc0$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $8e07a5888a205cc0$var$ANIMATION_END = $8e07a5888a205cc0$var$getVendorPrefixedEventName("animationend"), $8e07a5888a205cc0$var$ANIMATION_ITERATION = $8e07a5888a205cc0$var$getVendorPrefixedEventName("animationiteration"), $8e07a5888a205cc0$var$ANIMATION_START = $8e07a5888a205cc0$var$getVendorPrefixedEventName("animationstart"), $8e07a5888a205cc0$var$TRANSITION_RUN = $8e07a5888a205cc0$var$getVendorPrefixedEventName("transitionrun"), $8e07a5888a205cc0$var$TRANSITION_START = $8e07a5888a205cc0$var$getVendorPrefixedEventName("transitionstart"), $8e07a5888a205cc0$var$TRANSITION_CANCEL = $8e07a5888a205cc0$var$getVendorPrefixedEventName("transitioncancel"), $8e07a5888a205cc0$var$TRANSITION_END = $8e07a5888a205cc0$var$getVendorPrefixedEventName("transitionend"), $8e07a5888a205cc0$var$topLevelEventsToReactNames = new Map(), $8e07a5888a205cc0$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$8e07a5888a205cc0$var$simpleEventPluginEvents.push("scrollEnd");
function $8e07a5888a205cc0$var$registerSimpleEvent(domEventName, reactName) {
    $8e07a5888a205cc0$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $8e07a5888a205cc0$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $8e07a5888a205cc0$var$globalClientIdCounter$1 = 0;
function $8e07a5888a205cc0$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $8e07a5888a205cc0$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $8e07a5888a205cc0$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $8e07a5888a205cc0$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $8e07a5888a205cc0$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $8e07a5888a205cc0$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $8e07a5888a205cc0$var$getClassNameByType(defaultClass);
    eventClass = $8e07a5888a205cc0$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $8e07a5888a205cc0$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $8e07a5888a205cc0$var$concurrentQueues = [], $8e07a5888a205cc0$var$concurrentQueuesIndex = 0, $8e07a5888a205cc0$var$concurrentlyUpdatedLanes = 0;
function $8e07a5888a205cc0$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $8e07a5888a205cc0$var$concurrentQueuesIndex, i = $8e07a5888a205cc0$var$concurrentlyUpdatedLanes = $8e07a5888a205cc0$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $8e07a5888a205cc0$var$concurrentQueues[i];
        $8e07a5888a205cc0$var$concurrentQueues[i++] = null;
        var queue = $8e07a5888a205cc0$var$concurrentQueues[i];
        $8e07a5888a205cc0$var$concurrentQueues[i++] = null;
        var update = $8e07a5888a205cc0$var$concurrentQueues[i];
        $8e07a5888a205cc0$var$concurrentQueues[i++] = null;
        var lane = $8e07a5888a205cc0$var$concurrentQueues[i];
        $8e07a5888a205cc0$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $8e07a5888a205cc0$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $8e07a5888a205cc0$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $8e07a5888a205cc0$var$concurrentQueues[$8e07a5888a205cc0$var$concurrentQueuesIndex++] = fiber;
    $8e07a5888a205cc0$var$concurrentQueues[$8e07a5888a205cc0$var$concurrentQueuesIndex++] = queue;
    $8e07a5888a205cc0$var$concurrentQueues[$8e07a5888a205cc0$var$concurrentQueuesIndex++] = update;
    $8e07a5888a205cc0$var$concurrentQueues[$8e07a5888a205cc0$var$concurrentQueuesIndex++] = lane;
    $8e07a5888a205cc0$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $8e07a5888a205cc0$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $8e07a5888a205cc0$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $8e07a5888a205cc0$var$getRootForUpdatedFiber(fiber);
}
function $8e07a5888a205cc0$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $8e07a5888a205cc0$var$enqueueUpdate$1(fiber, null, null, lane);
    return $8e07a5888a205cc0$var$getRootForUpdatedFiber(fiber);
}
function $8e07a5888a205cc0$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $8e07a5888a205cc0$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $8e07a5888a205cc0$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $8e07a5888a205cc0$var$nestedUpdateCount) throw $8e07a5888a205cc0$var$nestedUpdateCount = 0, $8e07a5888a205cc0$var$rootWithNestedUpdates = null, Error($8e07a5888a205cc0$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $8e07a5888a205cc0$var$emptyContextObject = {};
function $8e07a5888a205cc0$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $8e07a5888a205cc0$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $8e07a5888a205cc0$var$FiberNode(tag, pendingProps, key, mode);
}
function $8e07a5888a205cc0$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $8e07a5888a205cc0$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $8e07a5888a205cc0$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $8e07a5888a205cc0$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $8e07a5888a205cc0$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $8e07a5888a205cc0$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $8e07a5888a205cc0$var$isHostHoistableType(type, pendingProps, $8e07a5888a205cc0$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $8e07a5888a205cc0$var$REACT_ACTIVITY_TYPE:
            return type = $8e07a5888a205cc0$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $8e07a5888a205cc0$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $8e07a5888a205cc0$var$REACT_FRAGMENT_TYPE:
            return $8e07a5888a205cc0$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $8e07a5888a205cc0$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $8e07a5888a205cc0$var$REACT_PROFILER_TYPE:
            return type = $8e07a5888a205cc0$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $8e07a5888a205cc0$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $8e07a5888a205cc0$var$REACT_SUSPENSE_TYPE:
            return type = $8e07a5888a205cc0$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $8e07a5888a205cc0$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $8e07a5888a205cc0$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $8e07a5888a205cc0$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $8e07a5888a205cc0$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $8e07a5888a205cc0$var$REACT_LEGACY_HIDDEN_TYPE:
        case $8e07a5888a205cc0$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $8e07a5888a205cc0$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $8e07a5888a205cc0$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $8e07a5888a205cc0$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $8e07a5888a205cc0$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $8e07a5888a205cc0$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $8e07a5888a205cc0$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $8e07a5888a205cc0$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($8e07a5888a205cc0$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $8e07a5888a205cc0$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $8e07a5888a205cc0$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $8e07a5888a205cc0$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $8e07a5888a205cc0$var$createFiberFromText(content, mode, lanes) {
    content = $8e07a5888a205cc0$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $8e07a5888a205cc0$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $8e07a5888a205cc0$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $8e07a5888a205cc0$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $8e07a5888a205cc0$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $8e07a5888a205cc0$var$CapturedStacks = new WeakMap();
function $8e07a5888a205cc0$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $8e07a5888a205cc0$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $8e07a5888a205cc0$var$getStackByFiberInDevAndProd(source)
        };
        $8e07a5888a205cc0$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $8e07a5888a205cc0$var$getStackByFiberInDevAndProd(source)
    };
}
var $8e07a5888a205cc0$var$forkStack = [], $8e07a5888a205cc0$var$forkStackIndex = 0, $8e07a5888a205cc0$var$treeForkProvider = null, $8e07a5888a205cc0$var$treeForkCount = 0, $8e07a5888a205cc0$var$idStack = [], $8e07a5888a205cc0$var$idStackIndex = 0, $8e07a5888a205cc0$var$treeContextProvider = null, $8e07a5888a205cc0$var$treeContextId = 1, $8e07a5888a205cc0$var$treeContextOverflow = "";
function $8e07a5888a205cc0$var$pushTreeFork(workInProgress, totalChildren) {
    $8e07a5888a205cc0$var$forkStack[$8e07a5888a205cc0$var$forkStackIndex++] = $8e07a5888a205cc0$var$treeForkCount;
    $8e07a5888a205cc0$var$forkStack[$8e07a5888a205cc0$var$forkStackIndex++] = $8e07a5888a205cc0$var$treeForkProvider;
    $8e07a5888a205cc0$var$treeForkProvider = workInProgress;
    $8e07a5888a205cc0$var$treeForkCount = totalChildren;
}
function $8e07a5888a205cc0$var$pushTreeId(workInProgress, totalChildren, index) {
    $8e07a5888a205cc0$var$idStack[$8e07a5888a205cc0$var$idStackIndex++] = $8e07a5888a205cc0$var$treeContextId;
    $8e07a5888a205cc0$var$idStack[$8e07a5888a205cc0$var$idStackIndex++] = $8e07a5888a205cc0$var$treeContextOverflow;
    $8e07a5888a205cc0$var$idStack[$8e07a5888a205cc0$var$idStackIndex++] = $8e07a5888a205cc0$var$treeContextProvider;
    $8e07a5888a205cc0$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $8e07a5888a205cc0$var$treeContextId;
    workInProgress = $8e07a5888a205cc0$var$treeContextOverflow;
    var baseLength = 32 - $8e07a5888a205cc0$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $8e07a5888a205cc0$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $8e07a5888a205cc0$var$treeContextId = 1 << 32 - $8e07a5888a205cc0$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $8e07a5888a205cc0$var$treeContextOverflow = length + workInProgress;
    } else $8e07a5888a205cc0$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $8e07a5888a205cc0$var$treeContextOverflow = workInProgress;
}
function $8e07a5888a205cc0$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($8e07a5888a205cc0$var$pushTreeFork(workInProgress, 1), $8e07a5888a205cc0$var$pushTreeId(workInProgress, 1, 0));
}
function $8e07a5888a205cc0$var$popTreeContext(workInProgress) {
    for(; workInProgress === $8e07a5888a205cc0$var$treeForkProvider;)$8e07a5888a205cc0$var$treeForkProvider = $8e07a5888a205cc0$var$forkStack[--$8e07a5888a205cc0$var$forkStackIndex], $8e07a5888a205cc0$var$forkStack[$8e07a5888a205cc0$var$forkStackIndex] = null, $8e07a5888a205cc0$var$treeForkCount = $8e07a5888a205cc0$var$forkStack[--$8e07a5888a205cc0$var$forkStackIndex], $8e07a5888a205cc0$var$forkStack[$8e07a5888a205cc0$var$forkStackIndex] = null;
    for(; workInProgress === $8e07a5888a205cc0$var$treeContextProvider;)$8e07a5888a205cc0$var$treeContextProvider = $8e07a5888a205cc0$var$idStack[--$8e07a5888a205cc0$var$idStackIndex], $8e07a5888a205cc0$var$idStack[$8e07a5888a205cc0$var$idStackIndex] = null, $8e07a5888a205cc0$var$treeContextOverflow = $8e07a5888a205cc0$var$idStack[--$8e07a5888a205cc0$var$idStackIndex], $8e07a5888a205cc0$var$idStack[$8e07a5888a205cc0$var$idStackIndex] = null, $8e07a5888a205cc0$var$treeContextId = $8e07a5888a205cc0$var$idStack[--$8e07a5888a205cc0$var$idStackIndex], $8e07a5888a205cc0$var$idStack[$8e07a5888a205cc0$var$idStackIndex] = null;
}
function $8e07a5888a205cc0$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $8e07a5888a205cc0$var$idStack[$8e07a5888a205cc0$var$idStackIndex++] = $8e07a5888a205cc0$var$treeContextId;
    $8e07a5888a205cc0$var$idStack[$8e07a5888a205cc0$var$idStackIndex++] = $8e07a5888a205cc0$var$treeContextOverflow;
    $8e07a5888a205cc0$var$idStack[$8e07a5888a205cc0$var$idStackIndex++] = $8e07a5888a205cc0$var$treeContextProvider;
    $8e07a5888a205cc0$var$treeContextId = suspendedContext.id;
    $8e07a5888a205cc0$var$treeContextOverflow = suspendedContext.overflow;
    $8e07a5888a205cc0$var$treeContextProvider = workInProgress;
}
var $8e07a5888a205cc0$var$hydrationParentFiber = null, $8e07a5888a205cc0$var$nextHydratableInstance = null, $8e07a5888a205cc0$var$isHydrating = !1, $8e07a5888a205cc0$var$hydrationErrors = null, $8e07a5888a205cc0$var$rootOrSingletonContext = !1, $8e07a5888a205cc0$var$HydrationMismatchException = Error($8e07a5888a205cc0$var$formatProdErrorMessage(519));
function $8e07a5888a205cc0$var$throwOnHydrationMismatch(fiber) {
    var error = Error($8e07a5888a205cc0$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $8e07a5888a205cc0$var$queueHydrationError($8e07a5888a205cc0$var$createCapturedValueAtFiber(error, fiber));
    throw $8e07a5888a205cc0$var$HydrationMismatchException;
}
function $8e07a5888a205cc0$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$8e07a5888a205cc0$var$internalInstanceKey] = fiber;
    instance[$8e07a5888a205cc0$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("cancel", instance);
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $8e07a5888a205cc0$var$mediaEventTypes.length; type++)$8e07a5888a205cc0$var$listenToNonDelegatedEvent($8e07a5888a205cc0$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("error", instance);
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("invalid", instance);
            $8e07a5888a205cc0$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("invalid", instance), $8e07a5888a205cc0$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $8e07a5888a205cc0$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($8e07a5888a205cc0$var$listenToNonDelegatedEvent("beforetoggle", instance), $8e07a5888a205cc0$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $8e07a5888a205cc0$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $8e07a5888a205cc0$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $8e07a5888a205cc0$var$noop$1), instance = !0) : instance = !1;
    instance || $8e07a5888a205cc0$var$throwOnHydrationMismatch(fiber, !0);
}
function $8e07a5888a205cc0$var$popToNextHostParent(fiber) {
    for($8e07a5888a205cc0$var$hydrationParentFiber = fiber.return; $8e07a5888a205cc0$var$hydrationParentFiber;)switch($8e07a5888a205cc0$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $8e07a5888a205cc0$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $8e07a5888a205cc0$var$rootOrSingletonContext = !0;
            return;
        default:
            $8e07a5888a205cc0$var$hydrationParentFiber = $8e07a5888a205cc0$var$hydrationParentFiber.return;
    }
}
function $8e07a5888a205cc0$var$popHydrationState(fiber) {
    if (fiber !== $8e07a5888a205cc0$var$hydrationParentFiber) return !1;
    if (!$8e07a5888a205cc0$var$isHydrating) return $8e07a5888a205cc0$var$popToNextHostParent(fiber), $8e07a5888a205cc0$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $8e07a5888a205cc0$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $8e07a5888a205cc0$var$nextHydratableInstance && $8e07a5888a205cc0$var$throwOnHydrationMismatch(fiber);
    $8e07a5888a205cc0$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(317));
        $8e07a5888a205cc0$var$nextHydratableInstance = $8e07a5888a205cc0$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(317));
        $8e07a5888a205cc0$var$nextHydratableInstance = $8e07a5888a205cc0$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $8e07a5888a205cc0$var$nextHydratableInstance, $8e07a5888a205cc0$var$isSingletonScope(fiber.type) ? (fiber = $8e07a5888a205cc0$var$previousHydratableOnEnteringScopedSingleton, $8e07a5888a205cc0$var$previousHydratableOnEnteringScopedSingleton = null, $8e07a5888a205cc0$var$nextHydratableInstance = fiber) : $8e07a5888a205cc0$var$nextHydratableInstance = tag) : $8e07a5888a205cc0$var$nextHydratableInstance = $8e07a5888a205cc0$var$hydrationParentFiber ? $8e07a5888a205cc0$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $8e07a5888a205cc0$var$resetHydrationState() {
    $8e07a5888a205cc0$var$nextHydratableInstance = $8e07a5888a205cc0$var$hydrationParentFiber = null;
    $8e07a5888a205cc0$var$isHydrating = !1;
}
function $8e07a5888a205cc0$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $8e07a5888a205cc0$var$hydrationErrors;
    null !== queuedErrors && (null === $8e07a5888a205cc0$var$workInProgressRootRecoverableErrors ? $8e07a5888a205cc0$var$workInProgressRootRecoverableErrors = queuedErrors : $8e07a5888a205cc0$var$workInProgressRootRecoverableErrors.push.apply($8e07a5888a205cc0$var$workInProgressRootRecoverableErrors, queuedErrors), $8e07a5888a205cc0$var$hydrationErrors = null);
    return queuedErrors;
}
function $8e07a5888a205cc0$var$queueHydrationError(error) {
    null === $8e07a5888a205cc0$var$hydrationErrors ? $8e07a5888a205cc0$var$hydrationErrors = [
        error
    ] : $8e07a5888a205cc0$var$hydrationErrors.push(error);
}
var $8e07a5888a205cc0$var$valueCursor = $8e07a5888a205cc0$var$createCursor(null), $8e07a5888a205cc0$var$currentlyRenderingFiber$1 = null, $8e07a5888a205cc0$var$lastContextDependency = null;
function $8e07a5888a205cc0$var$pushProvider(providerFiber, context, nextValue) {
    $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $8e07a5888a205cc0$var$popProvider(context) {
    context._currentValue = $8e07a5888a205cc0$var$valueCursor.current;
    $8e07a5888a205cc0$var$pop($8e07a5888a205cc0$var$valueCursor);
}
function $8e07a5888a205cc0$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $8e07a5888a205cc0$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $8e07a5888a205cc0$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $8e07a5888a205cc0$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $8e07a5888a205cc0$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $8e07a5888a205cc0$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $8e07a5888a205cc0$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $8e07a5888a205cc0$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($8e07a5888a205cc0$var$HostTransitionContext) : current = [
                $8e07a5888a205cc0$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $8e07a5888a205cc0$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $8e07a5888a205cc0$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$8e07a5888a205cc0$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $8e07a5888a205cc0$var$prepareToReadContext(workInProgress) {
    $8e07a5888a205cc0$var$currentlyRenderingFiber$1 = workInProgress;
    $8e07a5888a205cc0$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $8e07a5888a205cc0$var$readContext(context) {
    return $8e07a5888a205cc0$var$readContextForConsumer($8e07a5888a205cc0$var$currentlyRenderingFiber$1, context);
}
function $8e07a5888a205cc0$var$readContextDuringReconciliation(consumer, context) {
    null === $8e07a5888a205cc0$var$currentlyRenderingFiber$1 && $8e07a5888a205cc0$var$prepareToReadContext(consumer);
    return $8e07a5888a205cc0$var$readContextForConsumer(consumer, context);
}
function $8e07a5888a205cc0$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $8e07a5888a205cc0$var$lastContextDependency) {
        if (null === consumer) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(308));
        $8e07a5888a205cc0$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $8e07a5888a205cc0$var$lastContextDependency = $8e07a5888a205cc0$var$lastContextDependency.next = context;
    return value;
}
var $8e07a5888a205cc0$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $8e07a5888a205cc0$var$scheduleCallback$2 = $5JhdH.unstable_scheduleCallback, $8e07a5888a205cc0$var$NormalPriority = $5JhdH.unstable_NormalPriority, $8e07a5888a205cc0$var$CacheContext = {
    $$typeof: $8e07a5888a205cc0$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $8e07a5888a205cc0$var$createCache() {
    return {
        controller: new $8e07a5888a205cc0$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $8e07a5888a205cc0$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $8e07a5888a205cc0$var$scheduleCallback$2($8e07a5888a205cc0$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $8e07a5888a205cc0$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $8e07a5888a205cc0$var$entangledTransitionTypes = null;
function $8e07a5888a205cc0$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $8e07a5888a205cc0$var$currentEntangledListeners = null, $8e07a5888a205cc0$var$currentEntangledPendingCount = 0, $8e07a5888a205cc0$var$currentEntangledLane = 0, $8e07a5888a205cc0$var$currentEntangledActionThenable = null;
function $8e07a5888a205cc0$var$entangleAsyncAction(transition, thenable) {
    if (null === $8e07a5888a205cc0$var$currentEntangledListeners) {
        var entangledListeners = $8e07a5888a205cc0$var$currentEntangledListeners = [];
        $8e07a5888a205cc0$var$currentEntangledPendingCount = 0;
        $8e07a5888a205cc0$var$currentEntangledLane = $8e07a5888a205cc0$var$requestTransitionLane();
        $8e07a5888a205cc0$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $8e07a5888a205cc0$var$currentEntangledPendingCount++;
    thenable.then($8e07a5888a205cc0$var$pingEngtangledActionScope, $8e07a5888a205cc0$var$pingEngtangledActionScope);
    return thenable;
}
function $8e07a5888a205cc0$var$pingEngtangledActionScope() {
    if (0 === --$8e07a5888a205cc0$var$currentEntangledPendingCount && ($8e07a5888a205cc0$var$entangledTransitionTypes = null, null !== $8e07a5888a205cc0$var$currentEntangledListeners)) {
        null !== $8e07a5888a205cc0$var$currentEntangledActionThenable && ($8e07a5888a205cc0$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $8e07a5888a205cc0$var$currentEntangledListeners;
        $8e07a5888a205cc0$var$currentEntangledListeners = null;
        $8e07a5888a205cc0$var$currentEntangledLane = 0;
        $8e07a5888a205cc0$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $8e07a5888a205cc0$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $8e07a5888a205cc0$var$prevOnStartTransitionFinish = $8e07a5888a205cc0$var$ReactSharedInternals.S;
$8e07a5888a205cc0$var$ReactSharedInternals.S = function(transition, returnValue) {
    $8e07a5888a205cc0$var$globalMostRecentTransitionTime = $8e07a5888a205cc0$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $8e07a5888a205cc0$var$entangleAsyncAction(transition, returnValue);
    if (null !== $8e07a5888a205cc0$var$entangledTransitionTypes) for(var root$28 = $8e07a5888a205cc0$var$firstScheduledRoot; null !== root$28;)$8e07a5888a205cc0$var$queueTransitionTypes(root$28, $8e07a5888a205cc0$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $8e07a5888a205cc0$var$firstScheduledRoot; null !== root$29;)$8e07a5888a205cc0$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $8e07a5888a205cc0$var$currentEntangledLane) {
            root$29 = $8e07a5888a205cc0$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $8e07a5888a205cc0$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $8e07a5888a205cc0$var$prevOnStartTransitionFinish && $8e07a5888a205cc0$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $8e07a5888a205cc0$var$resumedCache = $8e07a5888a205cc0$var$createCursor(null);
function $8e07a5888a205cc0$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $8e07a5888a205cc0$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $8e07a5888a205cc0$var$workInProgressRoot.pooledCache;
}
function $8e07a5888a205cc0$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$resumedCache, $8e07a5888a205cc0$var$resumedCache.current) : $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$resumedCache, prevCachePool.pool);
}
function $8e07a5888a205cc0$var$getSuspendedCache() {
    var cacheFromPool = $8e07a5888a205cc0$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $8e07a5888a205cc0$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $8e07a5888a205cc0$var$SuspenseException = Error($8e07a5888a205cc0$var$formatProdErrorMessage(460)), $8e07a5888a205cc0$var$SuspenseyCommitException = Error($8e07a5888a205cc0$var$formatProdErrorMessage(474)), $8e07a5888a205cc0$var$SuspenseActionException = Error($8e07a5888a205cc0$var$formatProdErrorMessage(542)), $8e07a5888a205cc0$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $8e07a5888a205cc0$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $8e07a5888a205cc0$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($8e07a5888a205cc0$var$noop$1, $8e07a5888a205cc0$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $8e07a5888a205cc0$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($8e07a5888a205cc0$var$noop$1, $8e07a5888a205cc0$var$noop$1);
            else {
                thenableState = $8e07a5888a205cc0$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $8e07a5888a205cc0$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $8e07a5888a205cc0$var$suspendedThenable = thenable;
            throw $8e07a5888a205cc0$var$SuspenseException;
    }
}
function $8e07a5888a205cc0$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $8e07a5888a205cc0$var$suspendedThenable = x, $8e07a5888a205cc0$var$SuspenseException;
        throw x;
    }
}
var $8e07a5888a205cc0$var$suspendedThenable = null;
function $8e07a5888a205cc0$var$getSuspendedThenable() {
    if (null === $8e07a5888a205cc0$var$suspendedThenable) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(459));
    var thenable = $8e07a5888a205cc0$var$suspendedThenable;
    $8e07a5888a205cc0$var$suspendedThenable = null;
    return thenable;
}
function $8e07a5888a205cc0$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $8e07a5888a205cc0$var$SuspenseException || rejectedReason === $8e07a5888a205cc0$var$SuspenseActionException) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(483));
}
var $8e07a5888a205cc0$var$thenableState$1 = null, $8e07a5888a205cc0$var$thenableIndexCounter$1 = 0;
function $8e07a5888a205cc0$var$unwrapThenable(thenable) {
    var index = $8e07a5888a205cc0$var$thenableIndexCounter$1;
    $8e07a5888a205cc0$var$thenableIndexCounter$1 += 1;
    null === $8e07a5888a205cc0$var$thenableState$1 && ($8e07a5888a205cc0$var$thenableState$1 = []);
    return $8e07a5888a205cc0$var$trackUsedThenable($8e07a5888a205cc0$var$thenableState$1, thenable, index);
}
function $8e07a5888a205cc0$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $8e07a5888a205cc0$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $8e07a5888a205cc0$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $8e07a5888a205cc0$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $8e07a5888a205cc0$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $8e07a5888a205cc0$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $8e07a5888a205cc0$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $8e07a5888a205cc0$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $8e07a5888a205cc0$var$REACT_LAZY_TYPE && $8e07a5888a205cc0$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $8e07a5888a205cc0$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $8e07a5888a205cc0$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $8e07a5888a205cc0$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $8e07a5888a205cc0$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $8e07a5888a205cc0$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $8e07a5888a205cc0$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8e07a5888a205cc0$var$REACT_ELEMENT_TYPE:
                    return lanes = $8e07a5888a205cc0$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $8e07a5888a205cc0$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $8e07a5888a205cc0$var$REACT_PORTAL_TYPE:
                    return newChild = $8e07a5888a205cc0$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $8e07a5888a205cc0$var$REACT_LAZY_TYPE:
                    return newChild = $8e07a5888a205cc0$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($8e07a5888a205cc0$var$isArrayImpl(newChild) || $8e07a5888a205cc0$var$getIteratorFn(newChild)) return newChild = $8e07a5888a205cc0$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $8e07a5888a205cc0$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8e07a5888a205cc0$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $8e07a5888a205cc0$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8e07a5888a205cc0$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8e07a5888a205cc0$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $8e07a5888a205cc0$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $8e07a5888a205cc0$var$REACT_LAZY_TYPE:
                    return newChild = $8e07a5888a205cc0$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($8e07a5888a205cc0$var$isArrayImpl(newChild) || $8e07a5888a205cc0$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $8e07a5888a205cc0$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8e07a5888a205cc0$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $8e07a5888a205cc0$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8e07a5888a205cc0$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8e07a5888a205cc0$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $8e07a5888a205cc0$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $8e07a5888a205cc0$var$REACT_LAZY_TYPE:
                    return newChild = $8e07a5888a205cc0$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($8e07a5888a205cc0$var$isArrayImpl(newChild) || $8e07a5888a205cc0$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $8e07a5888a205cc0$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8e07a5888a205cc0$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $8e07a5888a205cc0$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8e07a5888a205cc0$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $8e07a5888a205cc0$var$isHydrating && $8e07a5888a205cc0$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $8e07a5888a205cc0$var$isHydrating && $8e07a5888a205cc0$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $8e07a5888a205cc0$var$isHydrating && $8e07a5888a205cc0$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $8e07a5888a205cc0$var$isHydrating && $8e07a5888a205cc0$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $8e07a5888a205cc0$var$isHydrating && $8e07a5888a205cc0$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $8e07a5888a205cc0$var$isHydrating && $8e07a5888a205cc0$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $8e07a5888a205cc0$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8e07a5888a205cc0$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $8e07a5888a205cc0$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $8e07a5888a205cc0$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $8e07a5888a205cc0$var$REACT_LAZY_TYPE && $8e07a5888a205cc0$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $8e07a5888a205cc0$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $8e07a5888a205cc0$var$REACT_FRAGMENT_TYPE ? (lanes = $8e07a5888a205cc0$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $8e07a5888a205cc0$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $8e07a5888a205cc0$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $8e07a5888a205cc0$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $8e07a5888a205cc0$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $8e07a5888a205cc0$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $8e07a5888a205cc0$var$REACT_LAZY_TYPE:
                    return newChild = $8e07a5888a205cc0$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($8e07a5888a205cc0$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($8e07a5888a205cc0$var$getIteratorFn(newChild)) {
                key = $8e07a5888a205cc0$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $8e07a5888a205cc0$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8e07a5888a205cc0$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $8e07a5888a205cc0$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8e07a5888a205cc0$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $8e07a5888a205cc0$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $8e07a5888a205cc0$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $8e07a5888a205cc0$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $8e07a5888a205cc0$var$SuspenseException || x === $8e07a5888a205cc0$var$SuspenseActionException) throw x;
            var fiber = $8e07a5888a205cc0$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $8e07a5888a205cc0$var$reconcileChildFibers = $8e07a5888a205cc0$var$createChildReconciler(!0), $8e07a5888a205cc0$var$mountChildFibers = $8e07a5888a205cc0$var$createChildReconciler(!1), $8e07a5888a205cc0$var$hasForceUpdate = !1;
function $8e07a5888a205cc0$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $8e07a5888a205cc0$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $8e07a5888a205cc0$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $8e07a5888a205cc0$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($8e07a5888a205cc0$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $8e07a5888a205cc0$var$getRootForUpdatedFiber(fiber);
        $8e07a5888a205cc0$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $8e07a5888a205cc0$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $8e07a5888a205cc0$var$getRootForUpdatedFiber(fiber);
}
function $8e07a5888a205cc0$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $8e07a5888a205cc0$var$markRootEntangled(root, lane);
    }
}
function $8e07a5888a205cc0$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $8e07a5888a205cc0$var$didReadFromEntangledAsyncAction = !1;
function $8e07a5888a205cc0$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($8e07a5888a205cc0$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $8e07a5888a205cc0$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $8e07a5888a205cc0$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $8e07a5888a205cc0$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $8e07a5888a205cc0$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($8e07a5888a205cc0$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $8e07a5888a205cc0$var$currentEntangledLane && ($8e07a5888a205cc0$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $8e07a5888a205cc0$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $8e07a5888a205cc0$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $8e07a5888a205cc0$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $8e07a5888a205cc0$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $8e07a5888a205cc0$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$8e07a5888a205cc0$var$callCallback(callbacks[updateQueue], context);
}
var $8e07a5888a205cc0$var$currentTreeHiddenStackCursor = $8e07a5888a205cc0$var$createCursor(null), $8e07a5888a205cc0$var$prevEntangledRenderLanesCursor = $8e07a5888a205cc0$var$createCursor(0);
function $8e07a5888a205cc0$var$pushHiddenContext(fiber, context) {
    fiber = $8e07a5888a205cc0$var$entangledRenderLanes;
    $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$prevEntangledRenderLanesCursor, fiber);
    $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$currentTreeHiddenStackCursor, context);
    $8e07a5888a205cc0$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $8e07a5888a205cc0$var$reuseHiddenContextOnStack() {
    $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$prevEntangledRenderLanesCursor, $8e07a5888a205cc0$var$entangledRenderLanes);
    $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$currentTreeHiddenStackCursor, $8e07a5888a205cc0$var$currentTreeHiddenStackCursor.current);
}
function $8e07a5888a205cc0$var$popHiddenContext() {
    $8e07a5888a205cc0$var$entangledRenderLanes = $8e07a5888a205cc0$var$prevEntangledRenderLanesCursor.current;
    $8e07a5888a205cc0$var$pop($8e07a5888a205cc0$var$currentTreeHiddenStackCursor);
    $8e07a5888a205cc0$var$pop($8e07a5888a205cc0$var$prevEntangledRenderLanesCursor);
}
var $8e07a5888a205cc0$var$suspenseHandlerStackCursor = $8e07a5888a205cc0$var$createCursor(null), $8e07a5888a205cc0$var$shellBoundary = null;
function $8e07a5888a205cc0$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$suspenseStackCursor, $8e07a5888a205cc0$var$suspenseStackCursor.current & 1);
    $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$suspenseHandlerStackCursor, handler);
    null === $8e07a5888a205cc0$var$shellBoundary && (null === current || null !== $8e07a5888a205cc0$var$currentTreeHiddenStackCursor.current ? $8e07a5888a205cc0$var$shellBoundary = handler : null !== current.memoizedState && ($8e07a5888a205cc0$var$shellBoundary = handler));
}
function $8e07a5888a205cc0$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$suspenseStackCursor, $8e07a5888a205cc0$var$suspenseStackCursor.current);
    $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$suspenseHandlerStackCursor, fiber);
    null === $8e07a5888a205cc0$var$shellBoundary && ($8e07a5888a205cc0$var$shellBoundary = fiber);
}
function $8e07a5888a205cc0$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$suspenseStackCursor, $8e07a5888a205cc0$var$suspenseStackCursor.current), $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$suspenseHandlerStackCursor, fiber), null === $8e07a5888a205cc0$var$shellBoundary && ($8e07a5888a205cc0$var$shellBoundary = fiber)) : $8e07a5888a205cc0$var$reuseSuspenseHandlerOnStack();
}
function $8e07a5888a205cc0$var$reuseSuspenseHandlerOnStack() {
    $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$suspenseStackCursor, $8e07a5888a205cc0$var$suspenseStackCursor.current);
    $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$suspenseHandlerStackCursor, $8e07a5888a205cc0$var$suspenseHandlerStackCursor.current);
}
function $8e07a5888a205cc0$var$popSuspenseHandler(fiber) {
    $8e07a5888a205cc0$var$pop($8e07a5888a205cc0$var$suspenseHandlerStackCursor);
    $8e07a5888a205cc0$var$shellBoundary === fiber && ($8e07a5888a205cc0$var$shellBoundary = null);
    $8e07a5888a205cc0$var$pop($8e07a5888a205cc0$var$suspenseStackCursor);
}
var $8e07a5888a205cc0$var$suspenseStackCursor = $8e07a5888a205cc0$var$createCursor(0);
function $8e07a5888a205cc0$var$pushSuspenseListContext(fiber, newContext) {
    $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$suspenseHandlerStackCursor, $8e07a5888a205cc0$var$suspenseHandlerStackCursor.current);
    $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$suspenseStackCursor, newContext);
}
function $8e07a5888a205cc0$var$popSuspenseListContext(fiber) {
    $8e07a5888a205cc0$var$pop($8e07a5888a205cc0$var$suspenseStackCursor);
    $8e07a5888a205cc0$var$pop($8e07a5888a205cc0$var$suspenseHandlerStackCursor);
    $8e07a5888a205cc0$var$shellBoundary === fiber && ($8e07a5888a205cc0$var$shellBoundary = null);
}
function $8e07a5888a205cc0$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $8e07a5888a205cc0$var$isSuspenseInstancePending(state) || $8e07a5888a205cc0$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $8e07a5888a205cc0$var$renderLanes = 0, $8e07a5888a205cc0$var$currentlyRenderingFiber = null, $8e07a5888a205cc0$var$currentHook = null, $8e07a5888a205cc0$var$workInProgressHook = null, $8e07a5888a205cc0$var$didScheduleRenderPhaseUpdate = !1, $8e07a5888a205cc0$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $8e07a5888a205cc0$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $8e07a5888a205cc0$var$localIdCounter = 0, $8e07a5888a205cc0$var$thenableIndexCounter = 0, $8e07a5888a205cc0$var$thenableState = null, $8e07a5888a205cc0$var$globalClientIdCounter = 0;
function $8e07a5888a205cc0$var$throwInvalidHookError() {
    throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(321));
}
function $8e07a5888a205cc0$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$8e07a5888a205cc0$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $8e07a5888a205cc0$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $8e07a5888a205cc0$var$renderLanes = nextRenderLanes;
    $8e07a5888a205cc0$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $8e07a5888a205cc0$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $8e07a5888a205cc0$var$HooksDispatcherOnMount : $8e07a5888a205cc0$var$HooksDispatcherOnUpdate;
    $8e07a5888a205cc0$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $8e07a5888a205cc0$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $8e07a5888a205cc0$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $8e07a5888a205cc0$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $8e07a5888a205cc0$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $8e07a5888a205cc0$var$finishRenderingHooks(current) {
    $8e07a5888a205cc0$var$ReactSharedInternals.H = $8e07a5888a205cc0$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $8e07a5888a205cc0$var$currentHook && null !== $8e07a5888a205cc0$var$currentHook.next;
    $8e07a5888a205cc0$var$renderLanes = 0;
    $8e07a5888a205cc0$var$workInProgressHook = $8e07a5888a205cc0$var$currentHook = $8e07a5888a205cc0$var$currentlyRenderingFiber = null;
    $8e07a5888a205cc0$var$didScheduleRenderPhaseUpdate = !1;
    $8e07a5888a205cc0$var$thenableIndexCounter = 0;
    $8e07a5888a205cc0$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(300));
    null === current || $8e07a5888a205cc0$var$didReceiveUpdate || (current = current.dependencies, null !== current && $8e07a5888a205cc0$var$checkIfContextChanged(current) && ($8e07a5888a205cc0$var$didReceiveUpdate = !0));
}
function $8e07a5888a205cc0$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $8e07a5888a205cc0$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $8e07a5888a205cc0$var$didScheduleRenderPhaseUpdateDuringThisPass && ($8e07a5888a205cc0$var$thenableState = null);
        $8e07a5888a205cc0$var$thenableIndexCounter = 0;
        $8e07a5888a205cc0$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $8e07a5888a205cc0$var$workInProgressHook = $8e07a5888a205cc0$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $8e07a5888a205cc0$var$ReactSharedInternals.H = $8e07a5888a205cc0$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($8e07a5888a205cc0$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $8e07a5888a205cc0$var$TransitionAwareHostComponent() {
    var dispatcher = $8e07a5888a205cc0$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $8e07a5888a205cc0$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $8e07a5888a205cc0$var$currentHook ? $8e07a5888a205cc0$var$currentHook.memoizedState : null) !== dispatcher && ($8e07a5888a205cc0$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $8e07a5888a205cc0$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $8e07a5888a205cc0$var$localIdCounter;
    $8e07a5888a205cc0$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $8e07a5888a205cc0$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $8e07a5888a205cc0$var$resetHooksOnUnwind(workInProgress) {
    if ($8e07a5888a205cc0$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $8e07a5888a205cc0$var$didScheduleRenderPhaseUpdate = !1;
    }
    $8e07a5888a205cc0$var$renderLanes = 0;
    $8e07a5888a205cc0$var$workInProgressHook = $8e07a5888a205cc0$var$currentHook = $8e07a5888a205cc0$var$currentlyRenderingFiber = null;
    $8e07a5888a205cc0$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $8e07a5888a205cc0$var$thenableIndexCounter = $8e07a5888a205cc0$var$localIdCounter = 0;
    $8e07a5888a205cc0$var$thenableState = null;
}
function $8e07a5888a205cc0$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $8e07a5888a205cc0$var$workInProgressHook ? $8e07a5888a205cc0$var$currentlyRenderingFiber.memoizedState = $8e07a5888a205cc0$var$workInProgressHook = hook : $8e07a5888a205cc0$var$workInProgressHook = $8e07a5888a205cc0$var$workInProgressHook.next = hook;
    return $8e07a5888a205cc0$var$workInProgressHook;
}
function $8e07a5888a205cc0$var$updateWorkInProgressHook() {
    if (null === $8e07a5888a205cc0$var$currentHook) {
        var nextCurrentHook = $8e07a5888a205cc0$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $8e07a5888a205cc0$var$currentHook.next;
    var nextWorkInProgressHook = null === $8e07a5888a205cc0$var$workInProgressHook ? $8e07a5888a205cc0$var$currentlyRenderingFiber.memoizedState : $8e07a5888a205cc0$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $8e07a5888a205cc0$var$workInProgressHook = nextWorkInProgressHook, $8e07a5888a205cc0$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $8e07a5888a205cc0$var$currentlyRenderingFiber.alternate) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(467));
            throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(310));
        }
        $8e07a5888a205cc0$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $8e07a5888a205cc0$var$currentHook.memoizedState,
            baseState: $8e07a5888a205cc0$var$currentHook.baseState,
            baseQueue: $8e07a5888a205cc0$var$currentHook.baseQueue,
            queue: $8e07a5888a205cc0$var$currentHook.queue,
            next: null
        };
        null === $8e07a5888a205cc0$var$workInProgressHook ? $8e07a5888a205cc0$var$currentlyRenderingFiber.memoizedState = $8e07a5888a205cc0$var$workInProgressHook = nextCurrentHook : $8e07a5888a205cc0$var$workInProgressHook = $8e07a5888a205cc0$var$workInProgressHook.next = nextCurrentHook;
    }
    return $8e07a5888a205cc0$var$workInProgressHook;
}
function $8e07a5888a205cc0$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $8e07a5888a205cc0$var$useThenable(thenable) {
    var index = $8e07a5888a205cc0$var$thenableIndexCounter;
    $8e07a5888a205cc0$var$thenableIndexCounter += 1;
    null === $8e07a5888a205cc0$var$thenableState && ($8e07a5888a205cc0$var$thenableState = []);
    thenable = $8e07a5888a205cc0$var$trackUsedThenable($8e07a5888a205cc0$var$thenableState, thenable, index);
    index = $8e07a5888a205cc0$var$currentlyRenderingFiber;
    null === (null === $8e07a5888a205cc0$var$workInProgressHook ? index.memoizedState : $8e07a5888a205cc0$var$workInProgressHook.next) && (index = index.alternate, $8e07a5888a205cc0$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $8e07a5888a205cc0$var$HooksDispatcherOnMount : $8e07a5888a205cc0$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $8e07a5888a205cc0$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $8e07a5888a205cc0$var$useThenable(usable);
        if (usable.$$typeof === $8e07a5888a205cc0$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $8e07a5888a205cc0$var$REACT_CONTEXT_TYPE) return $8e07a5888a205cc0$var$readContext(usable);
    }
    throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(438, String(usable)));
}
function $8e07a5888a205cc0$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $8e07a5888a205cc0$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $8e07a5888a205cc0$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $8e07a5888a205cc0$var$createFunctionComponentUpdateQueue(), $8e07a5888a205cc0$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $8e07a5888a205cc0$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $8e07a5888a205cc0$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $8e07a5888a205cc0$var$updateReducer(reducer) {
    var hook = $8e07a5888a205cc0$var$updateWorkInProgressHook();
    return $8e07a5888a205cc0$var$updateReducerImpl(hook, $8e07a5888a205cc0$var$currentHook, reducer);
}
function $8e07a5888a205cc0$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($8e07a5888a205cc0$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($8e07a5888a205cc0$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $8e07a5888a205cc0$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($8e07a5888a205cc0$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $8e07a5888a205cc0$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $8e07a5888a205cc0$var$currentlyRenderingFiber.lanes |= revertLane, $8e07a5888a205cc0$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $8e07a5888a205cc0$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $8e07a5888a205cc0$var$currentlyRenderingFiber.lanes |= updateLane, $8e07a5888a205cc0$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$8e07a5888a205cc0$var$objectIs(pendingQueue, hook.memoizedState) && ($8e07a5888a205cc0$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $8e07a5888a205cc0$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $8e07a5888a205cc0$var$rerenderReducer(reducer) {
    var hook = $8e07a5888a205cc0$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $8e07a5888a205cc0$var$objectIs(newState, hook.memoizedState) || ($8e07a5888a205cc0$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $8e07a5888a205cc0$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $8e07a5888a205cc0$var$currentlyRenderingFiber, hook = $8e07a5888a205cc0$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $8e07a5888a205cc0$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$8e07a5888a205cc0$var$objectIs(($8e07a5888a205cc0$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $8e07a5888a205cc0$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $8e07a5888a205cc0$var$updateEffect($8e07a5888a205cc0$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $8e07a5888a205cc0$var$workInProgressHook && 0 !== ($8e07a5888a205cc0$var$workInProgressHook.memoizedState.tag & 1);
    $8e07a5888a205cc0$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $8e07a5888a205cc0$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $8e07a5888a205cc0$var$workInProgressRoot) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($8e07a5888a205cc0$var$renderLanes & 127) || $8e07a5888a205cc0$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $8e07a5888a205cc0$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $8e07a5888a205cc0$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $8e07a5888a205cc0$var$createFunctionComponentUpdateQueue(), $8e07a5888a205cc0$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $8e07a5888a205cc0$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $8e07a5888a205cc0$var$checkIfSnapshotChanged(inst) && $8e07a5888a205cc0$var$forceStoreRerender(fiber);
}
function $8e07a5888a205cc0$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $8e07a5888a205cc0$var$checkIfSnapshotChanged(inst) && $8e07a5888a205cc0$var$forceStoreRerender(fiber);
    });
}
function $8e07a5888a205cc0$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$8e07a5888a205cc0$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $8e07a5888a205cc0$var$forceStoreRerender(fiber) {
    var root = $8e07a5888a205cc0$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $8e07a5888a205cc0$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $8e07a5888a205cc0$var$mountStateImpl(initialState) {
    var hook = $8e07a5888a205cc0$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($8e07a5888a205cc0$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $8e07a5888a205cc0$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $8e07a5888a205cc0$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $8e07a5888a205cc0$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $8e07a5888a205cc0$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $8e07a5888a205cc0$var$updateReducerImpl(hook, $8e07a5888a205cc0$var$currentHook, "function" === typeof reducer ? reducer : $8e07a5888a205cc0$var$basicStateReducer);
}
function $8e07a5888a205cc0$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($8e07a5888a205cc0$var$isRenderPhaseUpdate(fiber)) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $8e07a5888a205cc0$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $8e07a5888a205cc0$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $8e07a5888a205cc0$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $8e07a5888a205cc0$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $8e07a5888a205cc0$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $8e07a5888a205cc0$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $8e07a5888a205cc0$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $8e07a5888a205cc0$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $8e07a5888a205cc0$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $8e07a5888a205cc0$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $8e07a5888a205cc0$var$onActionError(actionQueue, node, error$70);
    }
}
function $8e07a5888a205cc0$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $8e07a5888a205cc0$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $8e07a5888a205cc0$var$onActionError(actionQueue, node, error);
    }) : $8e07a5888a205cc0$var$onActionSuccess(actionQueue, node, returnValue);
}
function $8e07a5888a205cc0$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $8e07a5888a205cc0$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $8e07a5888a205cc0$var$runActionStateAction(actionQueue, nextState)));
}
function $8e07a5888a205cc0$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $8e07a5888a205cc0$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $8e07a5888a205cc0$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $8e07a5888a205cc0$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $8e07a5888a205cc0$var$mountActionState(action, initialStateProp) {
    if ($8e07a5888a205cc0$var$isHydrating) {
        var ssrFormState = $8e07a5888a205cc0$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $8e07a5888a205cc0$var$currentlyRenderingFiber;
                if ($8e07a5888a205cc0$var$isHydrating) {
                    if ($8e07a5888a205cc0$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $8e07a5888a205cc0$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $8e07a5888a205cc0$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $8e07a5888a205cc0$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $8e07a5888a205cc0$var$nextHydratableInstance = $8e07a5888a205cc0$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $8e07a5888a205cc0$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $8e07a5888a205cc0$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $8e07a5888a205cc0$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $8e07a5888a205cc0$var$dispatchSetState.bind(null, $8e07a5888a205cc0$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $8e07a5888a205cc0$var$mountStateImpl(!1);
    inRootOrSingleton = $8e07a5888a205cc0$var$dispatchOptimisticSetState.bind(null, $8e07a5888a205cc0$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $8e07a5888a205cc0$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $8e07a5888a205cc0$var$dispatchActionState.bind(null, $8e07a5888a205cc0$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $8e07a5888a205cc0$var$updateActionState(action) {
    var stateHook = $8e07a5888a205cc0$var$updateWorkInProgressHook();
    return $8e07a5888a205cc0$var$updateActionStateImpl(stateHook, $8e07a5888a205cc0$var$currentHook, action);
}
function $8e07a5888a205cc0$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $8e07a5888a205cc0$var$updateReducerImpl(stateHook, currentStateHook, $8e07a5888a205cc0$var$actionStateReducer)[0];
    stateHook = $8e07a5888a205cc0$var$updateReducer($8e07a5888a205cc0$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $8e07a5888a205cc0$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $8e07a5888a205cc0$var$SuspenseException) throw $8e07a5888a205cc0$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $8e07a5888a205cc0$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($8e07a5888a205cc0$var$currentlyRenderingFiber.flags |= 2048, $8e07a5888a205cc0$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $8e07a5888a205cc0$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $8e07a5888a205cc0$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $8e07a5888a205cc0$var$rerenderActionState(action) {
    var stateHook = $8e07a5888a205cc0$var$updateWorkInProgressHook(), currentStateHook = $8e07a5888a205cc0$var$currentHook;
    if (null !== currentStateHook) return $8e07a5888a205cc0$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $8e07a5888a205cc0$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $8e07a5888a205cc0$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $8e07a5888a205cc0$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $8e07a5888a205cc0$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $8e07a5888a205cc0$var$createFunctionComponentUpdateQueue(), $8e07a5888a205cc0$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $8e07a5888a205cc0$var$updateRef() {
    return $8e07a5888a205cc0$var$updateWorkInProgressHook().memoizedState;
}
function $8e07a5888a205cc0$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $8e07a5888a205cc0$var$mountWorkInProgressHook();
    $8e07a5888a205cc0$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $8e07a5888a205cc0$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $8e07a5888a205cc0$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $8e07a5888a205cc0$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $8e07a5888a205cc0$var$currentHook && null !== deps && $8e07a5888a205cc0$var$areHookInputsEqual(deps, $8e07a5888a205cc0$var$currentHook.memoizedState.deps) ? hook.memoizedState = $8e07a5888a205cc0$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($8e07a5888a205cc0$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $8e07a5888a205cc0$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $8e07a5888a205cc0$var$mountEffect(create, deps) {
    $8e07a5888a205cc0$var$mountEffectImpl(8390656, 8, create, deps);
}
function $8e07a5888a205cc0$var$updateEffect(create, deps) {
    $8e07a5888a205cc0$var$updateEffectImpl(2048, 8, create, deps);
}
function $8e07a5888a205cc0$var$useEffectEventImpl(payload) {
    $8e07a5888a205cc0$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $8e07a5888a205cc0$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $8e07a5888a205cc0$var$createFunctionComponentUpdateQueue(), $8e07a5888a205cc0$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $8e07a5888a205cc0$var$updateEvent(callback) {
    var ref = $8e07a5888a205cc0$var$updateWorkInProgressHook().memoizedState;
    $8e07a5888a205cc0$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($8e07a5888a205cc0$var$executionContext & 2)) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $8e07a5888a205cc0$var$updateInsertionEffect(create, deps) {
    return $8e07a5888a205cc0$var$updateEffectImpl(4, 2, create, deps);
}
function $8e07a5888a205cc0$var$updateLayoutEffect(create, deps) {
    return $8e07a5888a205cc0$var$updateEffectImpl(4, 4, create, deps);
}
function $8e07a5888a205cc0$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $8e07a5888a205cc0$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $8e07a5888a205cc0$var$updateEffectImpl(4, 4, $8e07a5888a205cc0$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $8e07a5888a205cc0$var$mountDebugValue() {}
function $8e07a5888a205cc0$var$updateCallback(callback, deps) {
    var hook = $8e07a5888a205cc0$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $8e07a5888a205cc0$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $8e07a5888a205cc0$var$updateMemo(nextCreate, deps) {
    var hook = $8e07a5888a205cc0$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $8e07a5888a205cc0$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($8e07a5888a205cc0$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $8e07a5888a205cc0$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $8e07a5888a205cc0$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $8e07a5888a205cc0$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($8e07a5888a205cc0$var$renderLanes & 1073741824) && 0 === ($8e07a5888a205cc0$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $8e07a5888a205cc0$var$requestDeferredLane();
    $8e07a5888a205cc0$var$currentlyRenderingFiber.lanes |= hook;
    $8e07a5888a205cc0$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $8e07a5888a205cc0$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($8e07a5888a205cc0$var$objectIs(value, prevValue)) return value;
    if (null !== $8e07a5888a205cc0$var$currentTreeHiddenStackCursor.current) return hook = $8e07a5888a205cc0$var$mountDeferredValueImpl(hook, value, initialValue), $8e07a5888a205cc0$var$objectIs(hook, prevValue) || ($8e07a5888a205cc0$var$didReceiveUpdate = !0), hook;
    if (0 === ($8e07a5888a205cc0$var$renderLanes & 106) || 0 !== ($8e07a5888a205cc0$var$renderLanes & 1073741824) && 0 === ($8e07a5888a205cc0$var$workInProgressRootRenderLanes & 261930)) return $8e07a5888a205cc0$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $8e07a5888a205cc0$var$requestDeferredLane();
    $8e07a5888a205cc0$var$currentlyRenderingFiber.lanes |= hook;
    $8e07a5888a205cc0$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $8e07a5888a205cc0$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $8e07a5888a205cc0$var$ReactDOMSharedInternals.p;
    $8e07a5888a205cc0$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $8e07a5888a205cc0$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $8e07a5888a205cc0$var$ReactSharedInternals.T = currentTransition;
    $8e07a5888a205cc0$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $8e07a5888a205cc0$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $8e07a5888a205cc0$var$chainThenableValue(returnValue, finishedState);
            $8e07a5888a205cc0$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $8e07a5888a205cc0$var$requestUpdateLane(fiber));
        } else $8e07a5888a205cc0$var$dispatchSetStateInternal(fiber, queue, finishedState, $8e07a5888a205cc0$var$requestUpdateLane(fiber));
    } catch (error) {
        $8e07a5888a205cc0$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $8e07a5888a205cc0$var$requestUpdateLane());
    } finally{
        $8e07a5888a205cc0$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $8e07a5888a205cc0$var$ReactSharedInternals.T = prevTransition;
    }
}
function $8e07a5888a205cc0$var$noop() {}
function $8e07a5888a205cc0$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(476));
    var queue = $8e07a5888a205cc0$var$ensureFormComponentIsStateful(formFiber).queue;
    $8e07a5888a205cc0$var$startTransition(formFiber, queue, pendingState, $8e07a5888a205cc0$var$sharedNotPendingObject, null === action ? $8e07a5888a205cc0$var$noop : function() {
        $8e07a5888a205cc0$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $8e07a5888a205cc0$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $8e07a5888a205cc0$var$sharedNotPendingObject,
        baseState: $8e07a5888a205cc0$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $8e07a5888a205cc0$var$basicStateReducer,
            lastRenderedState: $8e07a5888a205cc0$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $8e07a5888a205cc0$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $8e07a5888a205cc0$var$requestFormReset$1(formFiber) {
    var stateHook = $8e07a5888a205cc0$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $8e07a5888a205cc0$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $8e07a5888a205cc0$var$requestUpdateLane());
}
function $8e07a5888a205cc0$var$useHostTransitionStatus() {
    return $8e07a5888a205cc0$var$readContext($8e07a5888a205cc0$var$HostTransitionContext);
}
function $8e07a5888a205cc0$var$updateId() {
    return $8e07a5888a205cc0$var$updateWorkInProgressHook().memoizedState;
}
function $8e07a5888a205cc0$var$updateRefresh() {
    return $8e07a5888a205cc0$var$updateWorkInProgressHook().memoizedState;
}
function $8e07a5888a205cc0$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $8e07a5888a205cc0$var$requestUpdateLane();
                fiber = $8e07a5888a205cc0$var$createUpdate(lane);
                var root$73 = $8e07a5888a205cc0$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($8e07a5888a205cc0$var$scheduleUpdateOnFiber(root$73, provider, lane), $8e07a5888a205cc0$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $8e07a5888a205cc0$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $8e07a5888a205cc0$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $8e07a5888a205cc0$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $8e07a5888a205cc0$var$isRenderPhaseUpdate(fiber) ? $8e07a5888a205cc0$var$enqueueRenderPhaseUpdate(queue, action) : (action = $8e07a5888a205cc0$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($8e07a5888a205cc0$var$scheduleUpdateOnFiber(action, fiber, lane), $8e07a5888a205cc0$var$entangleTransitionUpdate(action, queue, lane)));
}
function $8e07a5888a205cc0$var$dispatchSetState(fiber, queue, action) {
    var lane = $8e07a5888a205cc0$var$requestUpdateLane();
    $8e07a5888a205cc0$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $8e07a5888a205cc0$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8e07a5888a205cc0$var$isRenderPhaseUpdate(fiber)) $8e07a5888a205cc0$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($8e07a5888a205cc0$var$objectIs(eagerState, currentState)) return $8e07a5888a205cc0$var$enqueueUpdate$1(fiber, queue, update, 0), null === $8e07a5888a205cc0$var$workInProgressRoot && $8e07a5888a205cc0$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $8e07a5888a205cc0$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $8e07a5888a205cc0$var$scheduleUpdateOnFiber(action, fiber, lane), $8e07a5888a205cc0$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $8e07a5888a205cc0$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $8e07a5888a205cc0$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8e07a5888a205cc0$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $8e07a5888a205cc0$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $8e07a5888a205cc0$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $8e07a5888a205cc0$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $8e07a5888a205cc0$var$currentlyRenderingFiber || null !== alternate && alternate === $8e07a5888a205cc0$var$currentlyRenderingFiber;
}
function $8e07a5888a205cc0$var$enqueueRenderPhaseUpdate(queue, update) {
    $8e07a5888a205cc0$var$didScheduleRenderPhaseUpdateDuringThisPass = $8e07a5888a205cc0$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $8e07a5888a205cc0$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $8e07a5888a205cc0$var$markRootEntangled(root, lane);
    }
}
var $8e07a5888a205cc0$var$ContextOnlyDispatcher = {
    readContext: $8e07a5888a205cc0$var$readContext,
    use: $8e07a5888a205cc0$var$use,
    useCallback: $8e07a5888a205cc0$var$throwInvalidHookError,
    useContext: $8e07a5888a205cc0$var$throwInvalidHookError,
    useEffect: $8e07a5888a205cc0$var$throwInvalidHookError,
    useImperativeHandle: $8e07a5888a205cc0$var$throwInvalidHookError,
    useLayoutEffect: $8e07a5888a205cc0$var$throwInvalidHookError,
    useInsertionEffect: $8e07a5888a205cc0$var$throwInvalidHookError,
    useMemo: $8e07a5888a205cc0$var$throwInvalidHookError,
    useReducer: $8e07a5888a205cc0$var$throwInvalidHookError,
    useRef: $8e07a5888a205cc0$var$throwInvalidHookError,
    useState: $8e07a5888a205cc0$var$throwInvalidHookError,
    useDebugValue: $8e07a5888a205cc0$var$throwInvalidHookError,
    useDeferredValue: $8e07a5888a205cc0$var$throwInvalidHookError,
    useTransition: $8e07a5888a205cc0$var$throwInvalidHookError,
    useSyncExternalStore: $8e07a5888a205cc0$var$throwInvalidHookError,
    useId: $8e07a5888a205cc0$var$throwInvalidHookError,
    useHostTransitionStatus: $8e07a5888a205cc0$var$throwInvalidHookError,
    useFormState: $8e07a5888a205cc0$var$throwInvalidHookError,
    useActionState: $8e07a5888a205cc0$var$throwInvalidHookError,
    useOptimistic: $8e07a5888a205cc0$var$throwInvalidHookError,
    useMemoCache: $8e07a5888a205cc0$var$throwInvalidHookError,
    useCacheRefresh: $8e07a5888a205cc0$var$throwInvalidHookError,
    useEffectEvent: $8e07a5888a205cc0$var$throwInvalidHookError
}, $8e07a5888a205cc0$var$HooksDispatcherOnMount = {
    readContext: $8e07a5888a205cc0$var$readContext,
    use: $8e07a5888a205cc0$var$use,
    useCallback: function(callback, deps) {
        $8e07a5888a205cc0$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $8e07a5888a205cc0$var$readContext,
    useEffect: $8e07a5888a205cc0$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $8e07a5888a205cc0$var$mountEffectImpl(4194308, 4, $8e07a5888a205cc0$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $8e07a5888a205cc0$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $8e07a5888a205cc0$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $8e07a5888a205cc0$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($8e07a5888a205cc0$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $8e07a5888a205cc0$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $8e07a5888a205cc0$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $8e07a5888a205cc0$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($8e07a5888a205cc0$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $8e07a5888a205cc0$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $8e07a5888a205cc0$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $8e07a5888a205cc0$var$dispatchReducerAction.bind(null, $8e07a5888a205cc0$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $8e07a5888a205cc0$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $8e07a5888a205cc0$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $8e07a5888a205cc0$var$dispatchSetState.bind(null, $8e07a5888a205cc0$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $8e07a5888a205cc0$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $8e07a5888a205cc0$var$mountWorkInProgressHook();
        return $8e07a5888a205cc0$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $8e07a5888a205cc0$var$mountStateImpl(!1);
        stateHook = $8e07a5888a205cc0$var$startTransition.bind(null, $8e07a5888a205cc0$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $8e07a5888a205cc0$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $8e07a5888a205cc0$var$currentlyRenderingFiber, hook = $8e07a5888a205cc0$var$mountWorkInProgressHook();
        if ($8e07a5888a205cc0$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $8e07a5888a205cc0$var$workInProgressRoot) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(349));
            0 !== ($8e07a5888a205cc0$var$workInProgressRootRenderLanes & 127) || $8e07a5888a205cc0$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $8e07a5888a205cc0$var$mountEffect($8e07a5888a205cc0$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $8e07a5888a205cc0$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $8e07a5888a205cc0$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $8e07a5888a205cc0$var$mountWorkInProgressHook(), identifierPrefix = $8e07a5888a205cc0$var$workInProgressRoot.identifierPrefix;
        if ($8e07a5888a205cc0$var$isHydrating) {
            var JSCompiler_inline_result = $8e07a5888a205cc0$var$treeContextOverflow;
            var idWithLeadingBit = $8e07a5888a205cc0$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $8e07a5888a205cc0$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $8e07a5888a205cc0$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $8e07a5888a205cc0$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $8e07a5888a205cc0$var$useHostTransitionStatus,
    useFormState: $8e07a5888a205cc0$var$mountActionState,
    useActionState: $8e07a5888a205cc0$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $8e07a5888a205cc0$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $8e07a5888a205cc0$var$dispatchOptimisticSetState.bind(null, $8e07a5888a205cc0$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $8e07a5888a205cc0$var$useMemoCache,
    useCacheRefresh: function() {
        return $8e07a5888a205cc0$var$mountWorkInProgressHook().memoizedState = $8e07a5888a205cc0$var$refreshCache.bind(null, $8e07a5888a205cc0$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $8e07a5888a205cc0$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($8e07a5888a205cc0$var$executionContext & 2)) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $8e07a5888a205cc0$var$HooksDispatcherOnUpdate = {
    readContext: $8e07a5888a205cc0$var$readContext,
    use: $8e07a5888a205cc0$var$use,
    useCallback: $8e07a5888a205cc0$var$updateCallback,
    useContext: $8e07a5888a205cc0$var$readContext,
    useEffect: $8e07a5888a205cc0$var$updateEffect,
    useImperativeHandle: $8e07a5888a205cc0$var$updateImperativeHandle,
    useInsertionEffect: $8e07a5888a205cc0$var$updateInsertionEffect,
    useLayoutEffect: $8e07a5888a205cc0$var$updateLayoutEffect,
    useMemo: $8e07a5888a205cc0$var$updateMemo,
    useReducer: $8e07a5888a205cc0$var$updateReducer,
    useRef: $8e07a5888a205cc0$var$updateRef,
    useState: function() {
        return $8e07a5888a205cc0$var$updateReducer($8e07a5888a205cc0$var$basicStateReducer);
    },
    useDebugValue: $8e07a5888a205cc0$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $8e07a5888a205cc0$var$updateWorkInProgressHook();
        return $8e07a5888a205cc0$var$updateDeferredValueImpl(hook, $8e07a5888a205cc0$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $8e07a5888a205cc0$var$updateReducer($8e07a5888a205cc0$var$basicStateReducer)[0], start = $8e07a5888a205cc0$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $8e07a5888a205cc0$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $8e07a5888a205cc0$var$updateSyncExternalStore,
    useId: $8e07a5888a205cc0$var$updateId,
    useHostTransitionStatus: $8e07a5888a205cc0$var$useHostTransitionStatus,
    useFormState: $8e07a5888a205cc0$var$updateActionState,
    useActionState: $8e07a5888a205cc0$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $8e07a5888a205cc0$var$updateWorkInProgressHook();
        return $8e07a5888a205cc0$var$updateOptimisticImpl(hook, $8e07a5888a205cc0$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $8e07a5888a205cc0$var$useMemoCache,
    useCacheRefresh: $8e07a5888a205cc0$var$updateRefresh,
    useEffectEvent: $8e07a5888a205cc0$var$updateEvent
}, $8e07a5888a205cc0$var$HooksDispatcherOnRerender = {
    readContext: $8e07a5888a205cc0$var$readContext,
    use: $8e07a5888a205cc0$var$use,
    useCallback: $8e07a5888a205cc0$var$updateCallback,
    useContext: $8e07a5888a205cc0$var$readContext,
    useEffect: $8e07a5888a205cc0$var$updateEffect,
    useImperativeHandle: $8e07a5888a205cc0$var$updateImperativeHandle,
    useInsertionEffect: $8e07a5888a205cc0$var$updateInsertionEffect,
    useLayoutEffect: $8e07a5888a205cc0$var$updateLayoutEffect,
    useMemo: $8e07a5888a205cc0$var$updateMemo,
    useReducer: $8e07a5888a205cc0$var$rerenderReducer,
    useRef: $8e07a5888a205cc0$var$updateRef,
    useState: function() {
        return $8e07a5888a205cc0$var$rerenderReducer($8e07a5888a205cc0$var$basicStateReducer);
    },
    useDebugValue: $8e07a5888a205cc0$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $8e07a5888a205cc0$var$updateWorkInProgressHook();
        return null === $8e07a5888a205cc0$var$currentHook ? $8e07a5888a205cc0$var$mountDeferredValueImpl(hook, value, initialValue) : $8e07a5888a205cc0$var$updateDeferredValueImpl(hook, $8e07a5888a205cc0$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $8e07a5888a205cc0$var$rerenderReducer($8e07a5888a205cc0$var$basicStateReducer)[0], start = $8e07a5888a205cc0$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $8e07a5888a205cc0$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $8e07a5888a205cc0$var$updateSyncExternalStore,
    useId: $8e07a5888a205cc0$var$updateId,
    useHostTransitionStatus: $8e07a5888a205cc0$var$useHostTransitionStatus,
    useFormState: $8e07a5888a205cc0$var$rerenderActionState,
    useActionState: $8e07a5888a205cc0$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $8e07a5888a205cc0$var$updateWorkInProgressHook();
        if (null !== $8e07a5888a205cc0$var$currentHook) return $8e07a5888a205cc0$var$updateOptimisticImpl(hook, $8e07a5888a205cc0$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $8e07a5888a205cc0$var$useMemoCache,
    useCacheRefresh: $8e07a5888a205cc0$var$updateRefresh,
    useEffectEvent: $8e07a5888a205cc0$var$updateEvent
};
function $8e07a5888a205cc0$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $8e07a5888a205cc0$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $8e07a5888a205cc0$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $8e07a5888a205cc0$var$requestUpdateLane(), update = $8e07a5888a205cc0$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $8e07a5888a205cc0$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($8e07a5888a205cc0$var$scheduleUpdateOnFiber(payload, inst, lane), $8e07a5888a205cc0$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $8e07a5888a205cc0$var$requestUpdateLane(), update = $8e07a5888a205cc0$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $8e07a5888a205cc0$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($8e07a5888a205cc0$var$scheduleUpdateOnFiber(payload, inst, lane), $8e07a5888a205cc0$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $8e07a5888a205cc0$var$requestUpdateLane(), update = $8e07a5888a205cc0$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $8e07a5888a205cc0$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($8e07a5888a205cc0$var$scheduleUpdateOnFiber(callback, inst, lane), $8e07a5888a205cc0$var$entangleTransitions(callback, inst, lane));
    }
};
function $8e07a5888a205cc0$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$8e07a5888a205cc0$var$shallowEqual(oldProps, newProps) || !$8e07a5888a205cc0$var$shallowEqual(oldState, newState) : !0;
}
function $8e07a5888a205cc0$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $8e07a5888a205cc0$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $8e07a5888a205cc0$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $8e07a5888a205cc0$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $8e07a5888a205cc0$var$defaultOnUncaughtError(error) {
    $8e07a5888a205cc0$var$reportGlobalError(error);
}
function $8e07a5888a205cc0$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $8e07a5888a205cc0$var$defaultOnRecoverableError(error) {
    $8e07a5888a205cc0$var$reportGlobalError(error);
}
function $8e07a5888a205cc0$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $8e07a5888a205cc0$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $8e07a5888a205cc0$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $8e07a5888a205cc0$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $8e07a5888a205cc0$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $8e07a5888a205cc0$var$createClassErrorUpdate(lane) {
    lane = $8e07a5888a205cc0$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $8e07a5888a205cc0$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $8e07a5888a205cc0$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $8e07a5888a205cc0$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $8e07a5888a205cc0$var$legacyErrorBoundariesThatAlreadyFailed ? $8e07a5888a205cc0$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $8e07a5888a205cc0$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $8e07a5888a205cc0$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $8e07a5888a205cc0$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $8e07a5888a205cc0$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $8e07a5888a205cc0$var$shellBoundary ? $8e07a5888a205cc0$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $8e07a5888a205cc0$var$workInProgressRootExitStatus && ($8e07a5888a205cc0$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $8e07a5888a205cc0$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $8e07a5888a205cc0$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $8e07a5888a205cc0$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $8e07a5888a205cc0$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $8e07a5888a205cc0$var$attachPingListener(root, value, rootRenderLanes);
        $8e07a5888a205cc0$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($8e07a5888a205cc0$var$isHydrating) return returnFiber = $8e07a5888a205cc0$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $8e07a5888a205cc0$var$HydrationMismatchException && (root = Error($8e07a5888a205cc0$var$formatProdErrorMessage(422), {
        cause: value
    }), $8e07a5888a205cc0$var$queueHydrationError($8e07a5888a205cc0$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $8e07a5888a205cc0$var$HydrationMismatchException && (returnFiber = Error($8e07a5888a205cc0$var$formatProdErrorMessage(423), {
        cause: value
    }), $8e07a5888a205cc0$var$queueHydrationError($8e07a5888a205cc0$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $8e07a5888a205cc0$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $8e07a5888a205cc0$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $8e07a5888a205cc0$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $8e07a5888a205cc0$var$workInProgressRootExitStatus && ($8e07a5888a205cc0$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($8e07a5888a205cc0$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $8e07a5888a205cc0$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $8e07a5888a205cc0$var$workInProgressRootConcurrentErrors ? $8e07a5888a205cc0$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $8e07a5888a205cc0$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $8e07a5888a205cc0$var$workInProgressRootExitStatus && ($8e07a5888a205cc0$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $8e07a5888a205cc0$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $8e07a5888a205cc0$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $8e07a5888a205cc0$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $8e07a5888a205cc0$var$legacyErrorBoundariesThatAlreadyFailed || !$8e07a5888a205cc0$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $8e07a5888a205cc0$var$createClassErrorUpdate(rootRenderLanes), $8e07a5888a205cc0$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $8e07a5888a205cc0$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $8e07a5888a205cc0$var$SelectiveHydrationException = Error($8e07a5888a205cc0$var$formatProdErrorMessage(461)), $8e07a5888a205cc0$var$didReceiveUpdate = !1;
function $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $8e07a5888a205cc0$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $8e07a5888a205cc0$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $8e07a5888a205cc0$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $8e07a5888a205cc0$var$prepareToReadContext(workInProgress);
    nextProps = $8e07a5888a205cc0$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $8e07a5888a205cc0$var$checkDidRenderIdHook();
    if (null !== current && !$8e07a5888a205cc0$var$didReceiveUpdate) return $8e07a5888a205cc0$var$bailoutHooks(current, workInProgress, renderLanes), $8e07a5888a205cc0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $8e07a5888a205cc0$var$isHydrating && key && $8e07a5888a205cc0$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $8e07a5888a205cc0$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$8e07a5888a205cc0$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $8e07a5888a205cc0$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $8e07a5888a205cc0$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$8e07a5888a205cc0$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $8e07a5888a205cc0$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $8e07a5888a205cc0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $8e07a5888a205cc0$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $8e07a5888a205cc0$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($8e07a5888a205cc0$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($8e07a5888a205cc0$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $8e07a5888a205cc0$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($8e07a5888a205cc0$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $8e07a5888a205cc0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $8e07a5888a205cc0$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $8e07a5888a205cc0$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $8e07a5888a205cc0$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $8e07a5888a205cc0$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $8e07a5888a205cc0$var$pushHiddenContext(workInProgress, prevState) : $8e07a5888a205cc0$var$reuseHiddenContextOnStack(), $8e07a5888a205cc0$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $8e07a5888a205cc0$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($8e07a5888a205cc0$var$pushTransition(workInProgress, prevState.cachePool), $8e07a5888a205cc0$var$pushHiddenContext(workInProgress, prevState), $8e07a5888a205cc0$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $8e07a5888a205cc0$var$pushTransition(workInProgress, null), $8e07a5888a205cc0$var$reuseHiddenContextOnStack(), $8e07a5888a205cc0$var$reuseSuspenseHandlerOnStack());
    $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $8e07a5888a205cc0$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $8e07a5888a205cc0$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $8e07a5888a205cc0$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $8e07a5888a205cc0$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $8e07a5888a205cc0$var$pushTransition(workInProgress, null);
    $8e07a5888a205cc0$var$reuseHiddenContextOnStack();
    $8e07a5888a205cc0$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $8e07a5888a205cc0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $8e07a5888a205cc0$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $8e07a5888a205cc0$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $8e07a5888a205cc0$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $8e07a5888a205cc0$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $8e07a5888a205cc0$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $8e07a5888a205cc0$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $8e07a5888a205cc0$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($8e07a5888a205cc0$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $8e07a5888a205cc0$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $8e07a5888a205cc0$var$bailoutOffscreenComponent(null, current);
            $8e07a5888a205cc0$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $8e07a5888a205cc0$var$nextHydratableInstance) ? (current = $8e07a5888a205cc0$var$canHydrateHydrationBoundary(current, $8e07a5888a205cc0$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $8e07a5888a205cc0$var$treeContextProvider ? {
                    id: $8e07a5888a205cc0$var$treeContextId,
                    overflow: $8e07a5888a205cc0$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $8e07a5888a205cc0$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $8e07a5888a205cc0$var$hydrationParentFiber = workInProgress, $8e07a5888a205cc0$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $8e07a5888a205cc0$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $8e07a5888a205cc0$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $8e07a5888a205cc0$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $8e07a5888a205cc0$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(558));
        } else if ($8e07a5888a205cc0$var$didReceiveUpdate || $8e07a5888a205cc0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $8e07a5888a205cc0$var$didReceiveUpdate || didSuspend) {
            if (null === $8e07a5888a205cc0$var$currentTreeHiddenStackCursor.current) {
                nextProps = $8e07a5888a205cc0$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $8e07a5888a205cc0$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $8e07a5888a205cc0$var$enqueueConcurrentRenderForLane(current, dehydrated), $8e07a5888a205cc0$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $8e07a5888a205cc0$var$SelectiveHydrationException;
                $8e07a5888a205cc0$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $8e07a5888a205cc0$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $8e07a5888a205cc0$var$nextHydratableInstance = $8e07a5888a205cc0$var$getNextHydratable(dehydrated.nextSibling), $8e07a5888a205cc0$var$hydrationParentFiber = workInProgress, $8e07a5888a205cc0$var$isHydrating = !0, $8e07a5888a205cc0$var$hydrationErrors = null, $8e07a5888a205cc0$var$rootOrSingletonContext = !1, null !== current && $8e07a5888a205cc0$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $8e07a5888a205cc0$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $8e07a5888a205cc0$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $8e07a5888a205cc0$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $8e07a5888a205cc0$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $8e07a5888a205cc0$var$prepareToReadContext(workInProgress);
    Component = $8e07a5888a205cc0$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $8e07a5888a205cc0$var$checkDidRenderIdHook();
    if (null !== current && !$8e07a5888a205cc0$var$didReceiveUpdate) return $8e07a5888a205cc0$var$bailoutHooks(current, workInProgress, renderLanes), $8e07a5888a205cc0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $8e07a5888a205cc0$var$isHydrating && nextProps && $8e07a5888a205cc0$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $8e07a5888a205cc0$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $8e07a5888a205cc0$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $8e07a5888a205cc0$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $8e07a5888a205cc0$var$finishRenderingHooks(current);
    Component = $8e07a5888a205cc0$var$checkDidRenderIdHook();
    if (null !== current && !$8e07a5888a205cc0$var$didReceiveUpdate) return $8e07a5888a205cc0$var$bailoutHooks(current, workInProgress, renderLanes), $8e07a5888a205cc0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $8e07a5888a205cc0$var$isHydrating && Component && $8e07a5888a205cc0$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $8e07a5888a205cc0$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $8e07a5888a205cc0$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $8e07a5888a205cc0$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $8e07a5888a205cc0$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $8e07a5888a205cc0$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $8e07a5888a205cc0$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $8e07a5888a205cc0$var$readContext(contextType) : $8e07a5888a205cc0$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($8e07a5888a205cc0$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $8e07a5888a205cc0$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $8e07a5888a205cc0$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $8e07a5888a205cc0$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $8e07a5888a205cc0$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $8e07a5888a205cc0$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $8e07a5888a205cc0$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $8e07a5888a205cc0$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $8e07a5888a205cc0$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $8e07a5888a205cc0$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $8e07a5888a205cc0$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $8e07a5888a205cc0$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($8e07a5888a205cc0$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $8e07a5888a205cc0$var$hasForceUpdate || $8e07a5888a205cc0$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $8e07a5888a205cc0$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $8e07a5888a205cc0$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $8e07a5888a205cc0$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $8e07a5888a205cc0$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $8e07a5888a205cc0$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $8e07a5888a205cc0$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $8e07a5888a205cc0$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $8e07a5888a205cc0$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $8e07a5888a205cc0$var$hasForceUpdate || null !== current && null !== current.dependencies && $8e07a5888a205cc0$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($8e07a5888a205cc0$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $8e07a5888a205cc0$var$hasForceUpdate || $8e07a5888a205cc0$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $8e07a5888a205cc0$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $8e07a5888a205cc0$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $8e07a5888a205cc0$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $8e07a5888a205cc0$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $8e07a5888a205cc0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $8e07a5888a205cc0$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $8e07a5888a205cc0$var$resetHydrationState();
    workInProgress.flags |= 256;
    $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $8e07a5888a205cc0$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $8e07a5888a205cc0$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $8e07a5888a205cc0$var$getSuspendedCache()
    };
}
function $8e07a5888a205cc0$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $8e07a5888a205cc0$var$workInProgressDeferredLane);
    return current;
}
function $8e07a5888a205cc0$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($8e07a5888a205cc0$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($8e07a5888a205cc0$var$isHydrating) {
            showFallback ? $8e07a5888a205cc0$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $8e07a5888a205cc0$var$reuseSuspenseHandlerOnStack();
            (current = $8e07a5888a205cc0$var$nextHydratableInstance) ? (current = $8e07a5888a205cc0$var$canHydrateHydrationBoundary(current, $8e07a5888a205cc0$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $8e07a5888a205cc0$var$treeContextProvider ? {
                    id: $8e07a5888a205cc0$var$treeContextId,
                    overflow: $8e07a5888a205cc0$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $8e07a5888a205cc0$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $8e07a5888a205cc0$var$hydrationParentFiber = workInProgress, $8e07a5888a205cc0$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $8e07a5888a205cc0$var$throwOnHydrationMismatch(workInProgress);
            $8e07a5888a205cc0$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $8e07a5888a205cc0$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $8e07a5888a205cc0$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $8e07a5888a205cc0$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $8e07a5888a205cc0$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $8e07a5888a205cc0$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $8e07a5888a205cc0$var$SUSPENDED_MARKER, $8e07a5888a205cc0$var$bailoutOffscreenComponent(null, nextProps);
        $8e07a5888a205cc0$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $8e07a5888a205cc0$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $8e07a5888a205cc0$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $8e07a5888a205cc0$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $8e07a5888a205cc0$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $8e07a5888a205cc0$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $8e07a5888a205cc0$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $8e07a5888a205cc0$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $8e07a5888a205cc0$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $8e07a5888a205cc0$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $8e07a5888a205cc0$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $8e07a5888a205cc0$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $8e07a5888a205cc0$var$SUSPENDED_MARKER, $8e07a5888a205cc0$var$bailoutOffscreenComponent(current.child, nextProps);
    $8e07a5888a205cc0$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $8e07a5888a205cc0$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $8e07a5888a205cc0$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $8e07a5888a205cc0$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $8e07a5888a205cc0$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $8e07a5888a205cc0$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $8e07a5888a205cc0$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $8e07a5888a205cc0$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $8e07a5888a205cc0$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $8e07a5888a205cc0$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $8e07a5888a205cc0$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $8e07a5888a205cc0$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $8e07a5888a205cc0$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $8e07a5888a205cc0$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $8e07a5888a205cc0$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $8e07a5888a205cc0$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $8e07a5888a205cc0$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $8e07a5888a205cc0$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $8e07a5888a205cc0$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $8e07a5888a205cc0$var$SUSPENDED_MARKER;
        return $8e07a5888a205cc0$var$bailoutOffscreenComponent(null, nextProps);
    }
    $8e07a5888a205cc0$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($8e07a5888a205cc0$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($8e07a5888a205cc0$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $8e07a5888a205cc0$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $8e07a5888a205cc0$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $8e07a5888a205cc0$var$didReceiveUpdate || $8e07a5888a205cc0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($8e07a5888a205cc0$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $8e07a5888a205cc0$var$currentTreeHiddenStackCursor.current) return $8e07a5888a205cc0$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $8e07a5888a205cc0$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $8e07a5888a205cc0$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $8e07a5888a205cc0$var$enqueueConcurrentRenderForLane(current, nextProps), $8e07a5888a205cc0$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $8e07a5888a205cc0$var$SelectiveHydrationException;
        $8e07a5888a205cc0$var$isSuspenseInstancePending(suspenseInstance) || $8e07a5888a205cc0$var$renderDidSuspendDelayIfPossible();
        return $8e07a5888a205cc0$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($8e07a5888a205cc0$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $8e07a5888a205cc0$var$nextHydratableInstance = $8e07a5888a205cc0$var$getNextHydratable(suspenseInstance.nextSibling);
    $8e07a5888a205cc0$var$hydrationParentFiber = workInProgress;
    $8e07a5888a205cc0$var$isHydrating = !0;
    $8e07a5888a205cc0$var$hydrationErrors = null;
    $8e07a5888a205cc0$var$rootOrSingletonContext = !1;
    null !== current && $8e07a5888a205cc0$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $8e07a5888a205cc0$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $8e07a5888a205cc0$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $8e07a5888a205cc0$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $8e07a5888a205cc0$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $8e07a5888a205cc0$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $8e07a5888a205cc0$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $8e07a5888a205cc0$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $8e07a5888a205cc0$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $8e07a5888a205cc0$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $8e07a5888a205cc0$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $8e07a5888a205cc0$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($8e07a5888a205cc0$var$reverseChildren(current), $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $8e07a5888a205cc0$var$reverseChildren(current)) : $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $8e07a5888a205cc0$var$isHydrating ? $8e07a5888a205cc0$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $8e07a5888a205cc0$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $8e07a5888a205cc0$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $8e07a5888a205cc0$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $8e07a5888a205cc0$var$reverseChildren(workInProgress));
            $8e07a5888a205cc0$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $8e07a5888a205cc0$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $8e07a5888a205cc0$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $8e07a5888a205cc0$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $8e07a5888a205cc0$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $8e07a5888a205cc0$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $8e07a5888a205cc0$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $8e07a5888a205cc0$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $8e07a5888a205cc0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $8e07a5888a205cc0$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($8e07a5888a205cc0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $8e07a5888a205cc0$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $8e07a5888a205cc0$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $8e07a5888a205cc0$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $8e07a5888a205cc0$var$checkIfContextChanged(current) ? !0 : !1;
}
function $8e07a5888a205cc0$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $8e07a5888a205cc0$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $8e07a5888a205cc0$var$pushProvider(workInProgress, $8e07a5888a205cc0$var$CacheContext, current.memoizedState.cache);
            $8e07a5888a205cc0$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $8e07a5888a205cc0$var$pushHostContext(workInProgress);
            break;
        case 4:
            $8e07a5888a205cc0$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $8e07a5888a205cc0$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $8e07a5888a205cc0$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $8e07a5888a205cc0$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $8e07a5888a205cc0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $8e07a5888a205cc0$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $8e07a5888a205cc0$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $8e07a5888a205cc0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $8e07a5888a205cc0$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $8e07a5888a205cc0$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($8e07a5888a205cc0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $8e07a5888a205cc0$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $8e07a5888a205cc0$var$pushSuspenseListContext(workInProgress, $8e07a5888a205cc0$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $8e07a5888a205cc0$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $8e07a5888a205cc0$var$pushProvider(workInProgress, $8e07a5888a205cc0$var$CacheContext, current.memoizedState.cache);
    }
    return $8e07a5888a205cc0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $8e07a5888a205cc0$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $8e07a5888a205cc0$var$didReceiveUpdate = !0;
        else {
            if (!$8e07a5888a205cc0$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $8e07a5888a205cc0$var$didReceiveUpdate = !1, $8e07a5888a205cc0$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $8e07a5888a205cc0$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $8e07a5888a205cc0$var$didReceiveUpdate = !1, $8e07a5888a205cc0$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $8e07a5888a205cc0$var$pushTreeId(workInProgress, $8e07a5888a205cc0$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $8e07a5888a205cc0$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $8e07a5888a205cc0$var$shouldConstruct(current) ? (props = $8e07a5888a205cc0$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $8e07a5888a205cc0$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $8e07a5888a205cc0$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $8e07a5888a205cc0$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $8e07a5888a205cc0$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $8e07a5888a205cc0$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $8e07a5888a205cc0$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $8e07a5888a205cc0$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $8e07a5888a205cc0$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $8e07a5888a205cc0$var$getComponentNameFromType(current) || current;
                    throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $8e07a5888a205cc0$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $8e07a5888a205cc0$var$resolveClassComponentProps(props, workInProgress.pendingProps), $8e07a5888a205cc0$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $8e07a5888a205cc0$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $8e07a5888a205cc0$var$cloneUpdateQueue(current, workInProgress);
                $8e07a5888a205cc0$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $8e07a5888a205cc0$var$pushProvider(workInProgress, $8e07a5888a205cc0$var$CacheContext, props);
                props !== prevState.cache && $8e07a5888a205cc0$var$propagateContextChanges(workInProgress, [
                    $8e07a5888a205cc0$var$CacheContext
                ], renderLanes, !0);
                $8e07a5888a205cc0$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $8e07a5888a205cc0$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $8e07a5888a205cc0$var$createCapturedValueAtFiber(Error($8e07a5888a205cc0$var$formatProdErrorMessage(424)), workInProgress);
                        $8e07a5888a205cc0$var$queueHydrationError($$typeof);
                        workInProgress = $8e07a5888a205cc0$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $8e07a5888a205cc0$var$nextHydratableInstance = $8e07a5888a205cc0$var$getNextHydratable(current.firstChild);
                        $8e07a5888a205cc0$var$hydrationParentFiber = workInProgress;
                        $8e07a5888a205cc0$var$isHydrating = !0;
                        $8e07a5888a205cc0$var$hydrationErrors = null;
                        $8e07a5888a205cc0$var$rootOrSingletonContext = !0;
                        renderLanes = $8e07a5888a205cc0$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $8e07a5888a205cc0$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $8e07a5888a205cc0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $8e07a5888a205cc0$var$markRef(current, workInProgress), null === current ? (renderLanes = $8e07a5888a205cc0$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $8e07a5888a205cc0$var$isHydrating || (workInProgress.stateNode = $8e07a5888a205cc0$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $8e07a5888a205cc0$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $8e07a5888a205cc0$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $8e07a5888a205cc0$var$pushHostContext(workInProgress), null === current && $8e07a5888a205cc0$var$isHydrating && (props = workInProgress.stateNode = $8e07a5888a205cc0$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $8e07a5888a205cc0$var$rootInstanceStackCursor.current), $8e07a5888a205cc0$var$hydrationParentFiber = workInProgress, $8e07a5888a205cc0$var$rootOrSingletonContext = !0, $$typeof = $8e07a5888a205cc0$var$nextHydratableInstance, $8e07a5888a205cc0$var$isSingletonScope(workInProgress.type) ? ($8e07a5888a205cc0$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $8e07a5888a205cc0$var$nextHydratableInstance = $8e07a5888a205cc0$var$getNextHydratable(props.firstChild)) : $8e07a5888a205cc0$var$nextHydratableInstance = $$typeof), $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $8e07a5888a205cc0$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $8e07a5888a205cc0$var$isHydrating) {
                if ($$typeof = props = $8e07a5888a205cc0$var$nextHydratableInstance) props = $8e07a5888a205cc0$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $8e07a5888a205cc0$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $8e07a5888a205cc0$var$hydrationParentFiber = workInProgress, $8e07a5888a205cc0$var$nextHydratableInstance = $8e07a5888a205cc0$var$getNextHydratable(props.firstChild), $8e07a5888a205cc0$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $8e07a5888a205cc0$var$throwOnHydrationMismatch(workInProgress);
            }
            $8e07a5888a205cc0$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $8e07a5888a205cc0$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $8e07a5888a205cc0$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $8e07a5888a205cc0$var$renderWithHooks(current, workInProgress, $8e07a5888a205cc0$var$TransitionAwareHostComponent, null, null, renderLanes), $8e07a5888a205cc0$var$HostTransitionContext._currentValue = $$typeof);
            $8e07a5888a205cc0$var$markRef(current, workInProgress);
            $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $8e07a5888a205cc0$var$isHydrating) {
                if (current = renderLanes = $8e07a5888a205cc0$var$nextHydratableInstance) renderLanes = $8e07a5888a205cc0$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $8e07a5888a205cc0$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $8e07a5888a205cc0$var$hydrationParentFiber = workInProgress, $8e07a5888a205cc0$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $8e07a5888a205cc0$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $8e07a5888a205cc0$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $8e07a5888a205cc0$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $8e07a5888a205cc0$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $8e07a5888a205cc0$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $8e07a5888a205cc0$var$markRef(current, workInProgress), $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $8e07a5888a205cc0$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $8e07a5888a205cc0$var$prepareToReadContext(workInProgress), $$typeof = $8e07a5888a205cc0$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $8e07a5888a205cc0$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $8e07a5888a205cc0$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $8e07a5888a205cc0$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $8e07a5888a205cc0$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $8e07a5888a205cc0$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $8e07a5888a205cc0$var$prepareToReadContext(workInProgress), props = $8e07a5888a205cc0$var$readContext($8e07a5888a205cc0$var$CacheContext), null === current ? ($$typeof = $8e07a5888a205cc0$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $8e07a5888a205cc0$var$workInProgressRoot, prevState = $8e07a5888a205cc0$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $8e07a5888a205cc0$var$initializeUpdateQueue(workInProgress), $8e07a5888a205cc0$var$pushProvider(workInProgress, $8e07a5888a205cc0$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($8e07a5888a205cc0$var$cloneUpdateQueue(current, workInProgress), $8e07a5888a205cc0$var$processUpdateQueue(workInProgress, null, null, renderLanes), $8e07a5888a205cc0$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $8e07a5888a205cc0$var$pushProvider(workInProgress, $8e07a5888a205cc0$var$CacheContext, props)) : (props = prevState.cache, $8e07a5888a205cc0$var$pushProvider(workInProgress, $8e07a5888a205cc0$var$CacheContext, props), props !== $$typeof.cache && $8e07a5888a205cc0$var$propagateContextChanges(workInProgress, [
                $8e07a5888a205cc0$var$CacheContext
            ], renderLanes, !0))), $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $8e07a5888a205cc0$var$isHydrating && $8e07a5888a205cc0$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $8e07a5888a205cc0$var$markRef(current, workInProgress), $8e07a5888a205cc0$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $8e07a5888a205cc0$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $8e07a5888a205cc0$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $8e07a5888a205cc0$var$maySuspendCommit(type, newProps) : $8e07a5888a205cc0$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($8e07a5888a205cc0$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $8e07a5888a205cc0$var$suspendedThenable = $8e07a5888a205cc0$var$noopSuspenseyCommitThenable, $8e07a5888a205cc0$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $8e07a5888a205cc0$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$8e07a5888a205cc0$var$preloadResource(resource)) {
        if ($8e07a5888a205cc0$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $8e07a5888a205cc0$var$suspendedThenable = $8e07a5888a205cc0$var$noopSuspenseyCommitThenable, $8e07a5888a205cc0$var$SuspenseyCommitException;
    }
}
function $8e07a5888a205cc0$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $8e07a5888a205cc0$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $8e07a5888a205cc0$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $8e07a5888a205cc0$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$8e07a5888a205cc0$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $8e07a5888a205cc0$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $8e07a5888a205cc0$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $8e07a5888a205cc0$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $8e07a5888a205cc0$var$bubbleProperties(workInProgress), null;
        case 1:
            return $8e07a5888a205cc0$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $8e07a5888a205cc0$var$popProvider($8e07a5888a205cc0$var$CacheContext);
            $8e07a5888a205cc0$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $8e07a5888a205cc0$var$popHydrationState(workInProgress) ? $8e07a5888a205cc0$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $8e07a5888a205cc0$var$upgradeHydrationErrorsToRecoverable());
            $8e07a5888a205cc0$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($8e07a5888a205cc0$var$markUpdate(workInProgress), null !== nextResource ? ($8e07a5888a205cc0$var$bubbleProperties(workInProgress), $8e07a5888a205cc0$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($8e07a5888a205cc0$var$bubbleProperties(workInProgress), $8e07a5888a205cc0$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($8e07a5888a205cc0$var$markUpdate(workInProgress), $8e07a5888a205cc0$var$bubbleProperties(workInProgress), $8e07a5888a205cc0$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($8e07a5888a205cc0$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $8e07a5888a205cc0$var$markUpdate(workInProgress), $8e07a5888a205cc0$var$bubbleProperties(workInProgress), $8e07a5888a205cc0$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $8e07a5888a205cc0$var$popHostContext(workInProgress);
            renderLanes = $8e07a5888a205cc0$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $8e07a5888a205cc0$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(166));
                    $8e07a5888a205cc0$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $8e07a5888a205cc0$var$contextStackCursor.current;
                $8e07a5888a205cc0$var$popHydrationState(workInProgress) ? $8e07a5888a205cc0$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $8e07a5888a205cc0$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $8e07a5888a205cc0$var$markUpdate(workInProgress));
            }
            $8e07a5888a205cc0$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $8e07a5888a205cc0$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $8e07a5888a205cc0$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(166));
                    $8e07a5888a205cc0$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $8e07a5888a205cc0$var$contextStackCursor.current;
                if ($8e07a5888a205cc0$var$popHydrationState(workInProgress)) $8e07a5888a205cc0$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $8e07a5888a205cc0$var$getOwnerDocumentFromRootContainer($8e07a5888a205cc0$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$8e07a5888a205cc0$var$internalInstanceKey] = workInProgress;
                    nextResource[$8e07a5888a205cc0$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($8e07a5888a205cc0$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $8e07a5888a205cc0$var$markUpdate(workInProgress);
                }
            }
            $8e07a5888a205cc0$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $8e07a5888a205cc0$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $8e07a5888a205cc0$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(166));
                current = $8e07a5888a205cc0$var$rootInstanceStackCursor.current;
                if ($8e07a5888a205cc0$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $8e07a5888a205cc0$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$8e07a5888a205cc0$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $8e07a5888a205cc0$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $8e07a5888a205cc0$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $8e07a5888a205cc0$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$8e07a5888a205cc0$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $8e07a5888a205cc0$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $8e07a5888a205cc0$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(557));
                        current[$8e07a5888a205cc0$var$internalInstanceKey] = workInProgress;
                    } else $8e07a5888a205cc0$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $8e07a5888a205cc0$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $8e07a5888a205cc0$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $8e07a5888a205cc0$var$popSuspenseHandler(workInProgress), workInProgress;
                    $8e07a5888a205cc0$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(558));
            }
            $8e07a5888a205cc0$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $8e07a5888a205cc0$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(317));
                        type[$8e07a5888a205cc0$var$internalInstanceKey] = workInProgress;
                    } else $8e07a5888a205cc0$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $8e07a5888a205cc0$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $8e07a5888a205cc0$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $8e07a5888a205cc0$var$popSuspenseHandler(workInProgress), workInProgress;
                    $8e07a5888a205cc0$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $8e07a5888a205cc0$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $8e07a5888a205cc0$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $8e07a5888a205cc0$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $8e07a5888a205cc0$var$popHostContainer(), null === current && $8e07a5888a205cc0$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $8e07a5888a205cc0$var$bubbleProperties(workInProgress), null;
        case 10:
            return $8e07a5888a205cc0$var$popProvider(workInProgress.type), $8e07a5888a205cc0$var$bubbleProperties(workInProgress), null;
        case 19:
            $8e07a5888a205cc0$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $8e07a5888a205cc0$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $8e07a5888a205cc0$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $8e07a5888a205cc0$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $8e07a5888a205cc0$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $8e07a5888a205cc0$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $8e07a5888a205cc0$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$8e07a5888a205cc0$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $8e07a5888a205cc0$var$pushSuspenseListContext(workInProgress, $8e07a5888a205cc0$var$suspenseStackCursor.current & 1 | 2);
                            $8e07a5888a205cc0$var$isHydrating && $8e07a5888a205cc0$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $8e07a5888a205cc0$var$now() > $8e07a5888a205cc0$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $8e07a5888a205cc0$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $8e07a5888a205cc0$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $8e07a5888a205cc0$var$scheduleRetryEffect(workInProgress, current), $8e07a5888a205cc0$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$8e07a5888a205cc0$var$isHydrating) return $8e07a5888a205cc0$var$bubbleProperties(workInProgress), null;
                    } else 2 * $8e07a5888a205cc0$var$now() - newProps.renderingStartTime > $8e07a5888a205cc0$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $8e07a5888a205cc0$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $8e07a5888a205cc0$var$now();
                current.sibling = null;
                nextResource = $8e07a5888a205cc0$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $8e07a5888a205cc0$var$isHydrating ? $8e07a5888a205cc0$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$suspenseHandlerStackCursor, workInProgress), $8e07a5888a205cc0$var$push($8e07a5888a205cc0$var$suspenseStackCursor, renderLanes), null === $8e07a5888a205cc0$var$shellBoundary && ($8e07a5888a205cc0$var$shellBoundary = workInProgress));
                $8e07a5888a205cc0$var$isHydrating && $8e07a5888a205cc0$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $8e07a5888a205cc0$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $8e07a5888a205cc0$var$popSuspenseHandler(workInProgress), $8e07a5888a205cc0$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($8e07a5888a205cc0$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $8e07a5888a205cc0$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $8e07a5888a205cc0$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $8e07a5888a205cc0$var$pop($8e07a5888a205cc0$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $8e07a5888a205cc0$var$popProvider($8e07a5888a205cc0$var$CacheContext), $8e07a5888a205cc0$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $8e07a5888a205cc0$var$bubbleProperties(workInProgress), null;
    }
    throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $8e07a5888a205cc0$var$unwindWork(current, workInProgress) {
    $8e07a5888a205cc0$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $8e07a5888a205cc0$var$popProvider($8e07a5888a205cc0$var$CacheContext), $8e07a5888a205cc0$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $8e07a5888a205cc0$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $8e07a5888a205cc0$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(340));
                $8e07a5888a205cc0$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $8e07a5888a205cc0$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(340));
                $8e07a5888a205cc0$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $8e07a5888a205cc0$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $8e07a5888a205cc0$var$popHostContainer(), null;
        case 10:
            return $8e07a5888a205cc0$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $8e07a5888a205cc0$var$popSuspenseHandler(workInProgress), $8e07a5888a205cc0$var$popHiddenContext(), null !== current && $8e07a5888a205cc0$var$pop($8e07a5888a205cc0$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $8e07a5888a205cc0$var$popProvider($8e07a5888a205cc0$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $8e07a5888a205cc0$var$unwindInterruptedWork(current, interruptedWork) {
    $8e07a5888a205cc0$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $8e07a5888a205cc0$var$popProvider($8e07a5888a205cc0$var$CacheContext);
            $8e07a5888a205cc0$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $8e07a5888a205cc0$var$popHostContext(interruptedWork);
            break;
        case 4:
            $8e07a5888a205cc0$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $8e07a5888a205cc0$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $8e07a5888a205cc0$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $8e07a5888a205cc0$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $8e07a5888a205cc0$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $8e07a5888a205cc0$var$popSuspenseHandler(interruptedWork);
            $8e07a5888a205cc0$var$popHiddenContext();
            null !== current && $8e07a5888a205cc0$var$pop($8e07a5888a205cc0$var$resumedCache);
            break;
        case 24:
            $8e07a5888a205cc0$var$popProvider($8e07a5888a205cc0$var$CacheContext);
    }
}
function $8e07a5888a205cc0$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $8e07a5888a205cc0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8e07a5888a205cc0$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $8e07a5888a205cc0$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $8e07a5888a205cc0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8e07a5888a205cc0$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $8e07a5888a205cc0$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $8e07a5888a205cc0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $8e07a5888a205cc0$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $8e07a5888a205cc0$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $8e07a5888a205cc0$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $8e07a5888a205cc0$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $8e07a5888a205cc0$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $8e07a5888a205cc0$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $8e07a5888a205cc0$var$FragmentInstance(current);
                        $8e07a5888a205cc0$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $8e07a5888a205cc0$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $8e07a5888a205cc0$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $8e07a5888a205cc0$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $8e07a5888a205cc0$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $8e07a5888a205cc0$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $8e07a5888a205cc0$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$8e07a5888a205cc0$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $8e07a5888a205cc0$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $8e07a5888a205cc0$var$isFragmentInstanceParent(parent) && $8e07a5888a205cc0$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($8e07a5888a205cc0$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $8e07a5888a205cc0$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $8e07a5888a205cc0$var$isFragmentInstanceParent(parent) && $8e07a5888a205cc0$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($8e07a5888a205cc0$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $8e07a5888a205cc0$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $8e07a5888a205cc0$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $8e07a5888a205cc0$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $8e07a5888a205cc0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8e07a5888a205cc0$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $8e07a5888a205cc0$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$8e07a5888a205cc0$var$internalPropsKey] = newProps;
    } catch (error) {
        $8e07a5888a205cc0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8e07a5888a205cc0$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $8e07a5888a205cc0$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $8e07a5888a205cc0$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $8e07a5888a205cc0$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $8e07a5888a205cc0$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $8e07a5888a205cc0$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $8e07a5888a205cc0$var$noop$1)), $8e07a5888a205cc0$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $8e07a5888a205cc0$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($8e07a5888a205cc0$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $8e07a5888a205cc0$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($8e07a5888a205cc0$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$8e07a5888a205cc0$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $8e07a5888a205cc0$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $8e07a5888a205cc0$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $8e07a5888a205cc0$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($8e07a5888a205cc0$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $8e07a5888a205cc0$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($8e07a5888a205cc0$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$8e07a5888a205cc0$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $8e07a5888a205cc0$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $8e07a5888a205cc0$var$setInitialProperties(singleton, type, props);
        singleton[$8e07a5888a205cc0$var$internalInstanceKey] = finishedWork;
        singleton[$8e07a5888a205cc0$var$internalPropsKey] = props;
    } catch (error) {
        $8e07a5888a205cc0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $8e07a5888a205cc0$var$shouldStartViewTransition = !1, $8e07a5888a205cc0$var$appearingViewTransitions = null;
function $8e07a5888a205cc0$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $8e07a5888a205cc0$var$shouldStartViewTransition = !0;
}
var $8e07a5888a205cc0$var$viewTransitionCancelableChildren = null;
function $8e07a5888a205cc0$var$pushViewTransitionCancelableScope() {
    var prevChildren = $8e07a5888a205cc0$var$viewTransitionCancelableChildren;
    $8e07a5888a205cc0$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $8e07a5888a205cc0$var$viewTransitionHostInstanceIdx = 0;
function $8e07a5888a205cc0$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $8e07a5888a205cc0$var$viewTransitionHostInstanceIdx = 0;
    return $8e07a5888a205cc0$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $8e07a5888a205cc0$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $8e07a5888a205cc0$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $8e07a5888a205cc0$var$measureInstance(instance).view && (inViewport = !0);
            $8e07a5888a205cc0$var$shouldStartViewTransition = !0;
            $8e07a5888a205cc0$var$applyViewTransitionName(instance, 0 === $8e07a5888a205cc0$var$viewTransitionHostInstanceIdx ? name : name + "_" + $8e07a5888a205cc0$var$viewTransitionHostInstanceIdx, className);
            $8e07a5888a205cc0$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $8e07a5888a205cc0$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $8e07a5888a205cc0$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $8e07a5888a205cc0$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $8e07a5888a205cc0$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $8e07a5888a205cc0$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($8e07a5888a205cc0$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $8e07a5888a205cc0$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($8e07a5888a205cc0$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $8e07a5888a205cc0$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $8e07a5888a205cc0$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $8e07a5888a205cc0$var$getViewTransitionName(props, state), className = $8e07a5888a205cc0$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $8e07a5888a205cc0$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($8e07a5888a205cc0$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $8e07a5888a205cc0$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $8e07a5888a205cc0$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $8e07a5888a205cc0$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$8e07a5888a205cc0$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $8e07a5888a205cc0$var$commitAppearingPairViewTransitions(placement);
}
function $8e07a5888a205cc0$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $8e07a5888a205cc0$var$appearingViewTransitions && 0 !== $8e07a5888a205cc0$var$appearingViewTransitions.size) {
        var pairs = $8e07a5888a205cc0$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $8e07a5888a205cc0$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($8e07a5888a205cc0$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $8e07a5888a205cc0$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $8e07a5888a205cc0$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $8e07a5888a205cc0$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $8e07a5888a205cc0$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $8e07a5888a205cc0$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $8e07a5888a205cc0$var$appearingViewTransitions ? $8e07a5888a205cc0$var$appearingViewTransitions.get(name) : void 0, className = $8e07a5888a205cc0$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($8e07a5888a205cc0$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $8e07a5888a205cc0$var$appearingViewTransitions.delete(name), $8e07a5888a205cc0$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $8e07a5888a205cc0$var$scheduleViewTransitionEvent(deletion, props.onExit) : $8e07a5888a205cc0$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $8e07a5888a205cc0$var$appearingViewTransitions && $8e07a5888a205cc0$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$8e07a5888a205cc0$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $8e07a5888a205cc0$var$appearingViewTransitions && $8e07a5888a205cc0$var$commitDeletedPairViewTransitions(deletion);
}
function $8e07a5888a205cc0$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $8e07a5888a205cc0$var$getViewTransitionName(props, changedParent.stateNode);
            props = $8e07a5888a205cc0$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $8e07a5888a205cc0$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $8e07a5888a205cc0$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $8e07a5888a205cc0$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $8e07a5888a205cc0$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $8e07a5888a205cc0$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $8e07a5888a205cc0$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $8e07a5888a205cc0$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $8e07a5888a205cc0$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$8e07a5888a205cc0$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $8e07a5888a205cc0$var$restorePairedViewTransitions(fiber);
}
function $8e07a5888a205cc0$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $8e07a5888a205cc0$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $8e07a5888a205cc0$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $8e07a5888a205cc0$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $8e07a5888a205cc0$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$8e07a5888a205cc0$var$viewTransitionHostInstanceIdx], nextMeasurement = $8e07a5888a205cc0$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $8e07a5888a205cc0$var$applyViewTransitionName(instance, 0 === $8e07a5888a205cc0$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $8e07a5888a205cc0$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $8e07a5888a205cc0$var$viewTransitionCancelableChildren && ($8e07a5888a205cc0$var$viewTransitionCancelableChildren = []), $8e07a5888a205cc0$var$viewTransitionCancelableChildren.push(instance, 0 === $8e07a5888a205cc0$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $8e07a5888a205cc0$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $8e07a5888a205cc0$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $8e07a5888a205cc0$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $8e07a5888a205cc0$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $8e07a5888a205cc0$var$getViewTransitionName(props, state), className = $8e07a5888a205cc0$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($8e07a5888a205cc0$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $8e07a5888a205cc0$var$viewTransitionHostInstanceIdx = 0;
            name = $8e07a5888a205cc0$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $8e07a5888a205cc0$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $8e07a5888a205cc0$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $8e07a5888a205cc0$var$offscreenSubtreeIsHidden = !1, $8e07a5888a205cc0$var$offscreenSubtreeWasHidden = !1, $8e07a5888a205cc0$var$offscreenDirectParentIsHidden = !1, $8e07a5888a205cc0$var$needsFormReset = !1, $8e07a5888a205cc0$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $8e07a5888a205cc0$var$nextEffect = null, $8e07a5888a205cc0$var$viewTransitionContextChanged = !1, $8e07a5888a205cc0$var$inUpdateViewTransition = !1, $8e07a5888a205cc0$var$rootViewTransitionAffected = !1, $8e07a5888a205cc0$var$rootViewTransitionNameCanceled = !1;
function $8e07a5888a205cc0$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $8e07a5888a205cc0$var$eventsEnabled = $8e07a5888a205cc0$var$_enabled;
    root = $8e07a5888a205cc0$var$getActiveElementDeep(root);
    if ($8e07a5888a205cc0$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $8e07a5888a205cc0$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $8e07a5888a205cc0$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $8e07a5888a205cc0$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $8e07a5888a205cc0$var$nextEffect;){
        root = $8e07a5888a205cc0$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $8e07a5888a205cc0$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $8e07a5888a205cc0$var$trackEnterViewTransitions(root), $8e07a5888a205cc0$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $8e07a5888a205cc0$var$commitExitViewTransitions(JSCompiler_temp);
                    $8e07a5888a205cc0$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $8e07a5888a205cc0$var$trackEnterViewTransitions(root);
                    $8e07a5888a205cc0$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $8e07a5888a205cc0$var$nextEffect = JSCompiler_temp) : (committedLanes && $8e07a5888a205cc0$var$commitNestedViewTransitions(root), $8e07a5888a205cc0$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $8e07a5888a205cc0$var$appearingViewTransitions = null;
}
function $8e07a5888a205cc0$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $8e07a5888a205cc0$var$nextEffect;){
        var fiber = $8e07a5888a205cc0$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $8e07a5888a205cc0$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $8e07a5888a205cc0$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $8e07a5888a205cc0$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $8e07a5888a205cc0$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $8e07a5888a205cc0$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $8e07a5888a205cc0$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $8e07a5888a205cc0$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $8e07a5888a205cc0$var$nextEffect = current;
            break;
        }
        $8e07a5888a205cc0$var$nextEffect = fiber.return;
    }
}
function $8e07a5888a205cc0$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $8e07a5888a205cc0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $8e07a5888a205cc0$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $8e07a5888a205cc0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $8e07a5888a205cc0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $8e07a5888a205cc0$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $8e07a5888a205cc0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $8e07a5888a205cc0$var$commitClassCallbacks(finishedWork);
            flags & 512 && $8e07a5888a205cc0$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $8e07a5888a205cc0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $8e07a5888a205cc0$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $8e07a5888a205cc0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $8e07a5888a205cc0$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $8e07a5888a205cc0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $8e07a5888a205cc0$var$commitHostMount(finishedWork);
            flags & 512 && $8e07a5888a205cc0$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $8e07a5888a205cc0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $8e07a5888a205cc0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $8e07a5888a205cc0$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $8e07a5888a205cc0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $8e07a5888a205cc0$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $8e07a5888a205cc0$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $8e07a5888a205cc0$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $8e07a5888a205cc0$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $8e07a5888a205cc0$var$offscreenSubtreeWasHidden;
                current = $8e07a5888a205cc0$var$offscreenSubtreeIsHidden;
                prevProps = $8e07a5888a205cc0$var$offscreenSubtreeWasHidden;
                $8e07a5888a205cc0$var$offscreenSubtreeIsHidden = flags;
                ($8e07a5888a205cc0$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $8e07a5888a205cc0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $8e07a5888a205cc0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $8e07a5888a205cc0$var$offscreenSubtreeIsHidden = current;
                $8e07a5888a205cc0$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $8e07a5888a205cc0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $8e07a5888a205cc0$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $8e07a5888a205cc0$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $8e07a5888a205cc0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $8e07a5888a205cc0$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$8e07a5888a205cc0$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $8e07a5888a205cc0$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $8e07a5888a205cc0$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $8e07a5888a205cc0$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $8e07a5888a205cc0$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $8e07a5888a205cc0$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $8e07a5888a205cc0$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $8e07a5888a205cc0$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $8e07a5888a205cc0$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $8e07a5888a205cc0$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $8e07a5888a205cc0$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $8e07a5888a205cc0$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $8e07a5888a205cc0$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $8e07a5888a205cc0$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $8e07a5888a205cc0$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8e07a5888a205cc0$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $8e07a5888a205cc0$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $8e07a5888a205cc0$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $8e07a5888a205cc0$var$hostParent = null, $8e07a5888a205cc0$var$hostParentIsContainer = !1;
function $8e07a5888a205cc0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$8e07a5888a205cc0$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $8e07a5888a205cc0$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($8e07a5888a205cc0$var$injectedHook && "function" === typeof $8e07a5888a205cc0$var$injectedHook.onCommitFiberUnmount) try {
        $8e07a5888a205cc0$var$injectedHook.onCommitFiberUnmount($8e07a5888a205cc0$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $8e07a5888a205cc0$var$offscreenSubtreeWasHidden || $8e07a5888a205cc0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $8e07a5888a205cc0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$8e07a5888a205cc0$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $8e07a5888a205cc0$var$offscreenSubtreeWasHidden || $8e07a5888a205cc0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $8e07a5888a205cc0$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $8e07a5888a205cc0$var$hostParent, prevHostParentIsContainer = $8e07a5888a205cc0$var$hostParentIsContainer;
            $8e07a5888a205cc0$var$isSingletonScope(deletedFiber.type) && ($8e07a5888a205cc0$var$hostParent = deletedFiber.stateNode, $8e07a5888a205cc0$var$hostParentIsContainer = !1);
            $8e07a5888a205cc0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8e07a5888a205cc0$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $8e07a5888a205cc0$var$hostParent = prevHostParent;
            $8e07a5888a205cc0$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $8e07a5888a205cc0$var$offscreenSubtreeWasHidden || $8e07a5888a205cc0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $8e07a5888a205cc0$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $8e07a5888a205cc0$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $8e07a5888a205cc0$var$hostParent;
            prevHostParentIsContainer = $8e07a5888a205cc0$var$hostParentIsContainer;
            $8e07a5888a205cc0$var$hostParent = null;
            $8e07a5888a205cc0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8e07a5888a205cc0$var$hostParent = prevHostParent;
            $8e07a5888a205cc0$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $8e07a5888a205cc0$var$hostParent) {
                if ($8e07a5888a205cc0$var$hostParentIsContainer) try {
                    (9 === $8e07a5888a205cc0$var$hostParent.nodeType ? $8e07a5888a205cc0$var$hostParent.body : "HTML" === $8e07a5888a205cc0$var$hostParent.nodeName ? $8e07a5888a205cc0$var$hostParent.ownerDocument.body : $8e07a5888a205cc0$var$hostParent).removeChild(deletedFiber.stateNode), $8e07a5888a205cc0$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $8e07a5888a205cc0$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $8e07a5888a205cc0$var$hostParent.removeChild(deletedFiber.stateNode), $8e07a5888a205cc0$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $8e07a5888a205cc0$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $8e07a5888a205cc0$var$hostParent && ($8e07a5888a205cc0$var$hostParentIsContainer ? (finishedRoot = $8e07a5888a205cc0$var$hostParent, $8e07a5888a205cc0$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $8e07a5888a205cc0$var$retryIfBlockedOn(finishedRoot)) : $8e07a5888a205cc0$var$clearHydrationBoundary($8e07a5888a205cc0$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $8e07a5888a205cc0$var$hostParent;
            prevHostParentIsContainer = $8e07a5888a205cc0$var$hostParentIsContainer;
            $8e07a5888a205cc0$var$hostParent = deletedFiber.stateNode.containerInfo;
            $8e07a5888a205cc0$var$hostParentIsContainer = !0;
            $8e07a5888a205cc0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8e07a5888a205cc0$var$hostParent = prevHostParent;
            $8e07a5888a205cc0$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $8e07a5888a205cc0$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $8e07a5888a205cc0$var$offscreenSubtreeWasHidden || $8e07a5888a205cc0$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $8e07a5888a205cc0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $8e07a5888a205cc0$var$offscreenSubtreeWasHidden || ($8e07a5888a205cc0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $8e07a5888a205cc0$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $8e07a5888a205cc0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $8e07a5888a205cc0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $8e07a5888a205cc0$var$offscreenSubtreeWasHidden = (prevHostParent = $8e07a5888a205cc0$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $8e07a5888a205cc0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8e07a5888a205cc0$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $8e07a5888a205cc0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $8e07a5888a205cc0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $8e07a5888a205cc0$var$offscreenSubtreeWasHidden || $8e07a5888a205cc0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $8e07a5888a205cc0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $8e07a5888a205cc0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $8e07a5888a205cc0$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $8e07a5888a205cc0$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $8e07a5888a205cc0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $8e07a5888a205cc0$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $8e07a5888a205cc0$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $8e07a5888a205cc0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8e07a5888a205cc0$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $8e07a5888a205cc0$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $8e07a5888a205cc0$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $8e07a5888a205cc0$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $8e07a5888a205cc0$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $8e07a5888a205cc0$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $8e07a5888a205cc0$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($8e07a5888a205cc0$var$isSingletonScope(parent.type)) {
                        $8e07a5888a205cc0$var$hostParent = parent.stateNode;
                        $8e07a5888a205cc0$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $8e07a5888a205cc0$var$hostParent = parent.stateNode;
                    $8e07a5888a205cc0$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $8e07a5888a205cc0$var$hostParent = parent.stateNode.containerInfo;
                    $8e07a5888a205cc0$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $8e07a5888a205cc0$var$hostParent) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(160));
        $8e07a5888a205cc0$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $8e07a5888a205cc0$var$hostParent = null;
        $8e07a5888a205cc0$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$8e07a5888a205cc0$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $8e07a5888a205cc0$var$currentHoistableRoot = null;
function $8e07a5888a205cc0$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $8e07a5888a205cc0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $8e07a5888a205cc0$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($8e07a5888a205cc0$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $8e07a5888a205cc0$var$commitHookEffectListMount(3, finishedWork), $8e07a5888a205cc0$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $8e07a5888a205cc0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $8e07a5888a205cc0$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8e07a5888a205cc0$var$offscreenSubtreeWasHidden || null === current || $8e07a5888a205cc0$var$safelyDetachRef(current, current.return));
            flags & 64 && $8e07a5888a205cc0$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $8e07a5888a205cc0$var$currentHoistableRoot;
            $8e07a5888a205cc0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $8e07a5888a205cc0$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8e07a5888a205cc0$var$offscreenSubtreeWasHidden || null === current || $8e07a5888a205cc0$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($8e07a5888a205cc0$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $8e07a5888a205cc0$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$8e07a5888a205cc0$var$internalHoistableMarker] || current[$8e07a5888a205cc0$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $8e07a5888a205cc0$var$setInitialProperties(current, root, lanes);
                                            current[$8e07a5888a205cc0$var$internalInstanceKey] = finishedWork;
                                            $8e07a5888a205cc0$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $8e07a5888a205cc0$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $8e07a5888a205cc0$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $8e07a5888a205cc0$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $8e07a5888a205cc0$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$8e07a5888a205cc0$var$internalInstanceKey] = finishedWork;
                                    $8e07a5888a205cc0$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $8e07a5888a205cc0$var$offscreenSubtreeIsHidden || $8e07a5888a205cc0$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $8e07a5888a205cc0$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $8e07a5888a205cc0$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $8e07a5888a205cc0$var$offscreenSubtreeIsHidden || $8e07a5888a205cc0$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $8e07a5888a205cc0$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $8e07a5888a205cc0$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $8e07a5888a205cc0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $8e07a5888a205cc0$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8e07a5888a205cc0$var$offscreenSubtreeWasHidden || null === current || $8e07a5888a205cc0$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $8e07a5888a205cc0$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $8e07a5888a205cc0$var$offscreenDirectParentIsHidden;
            $8e07a5888a205cc0$var$offscreenDirectParentIsHidden = !1;
            $8e07a5888a205cc0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $8e07a5888a205cc0$var$offscreenDirectParentIsHidden = ii;
            $8e07a5888a205cc0$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8e07a5888a205cc0$var$offscreenSubtreeWasHidden || null === current || $8e07a5888a205cc0$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $8e07a5888a205cc0$var$setTextContent(root, ""), $8e07a5888a205cc0$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $8e07a5888a205cc0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $8e07a5888a205cc0$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($8e07a5888a205cc0$var$needsFormReset = !0);
            break;
        case 6:
            $8e07a5888a205cc0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $8e07a5888a205cc0$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $8e07a5888a205cc0$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $8e07a5888a205cc0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $8e07a5888a205cc0$var$viewTransitionMutationContext = !1;
            $8e07a5888a205cc0$var$tagCaches = null;
            ii = $8e07a5888a205cc0$var$currentHoistableRoot;
            $8e07a5888a205cc0$var$currentHoistableRoot = $8e07a5888a205cc0$var$getHoistableRoot(root.containerInfo);
            $8e07a5888a205cc0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $8e07a5888a205cc0$var$currentHoistableRoot = ii;
            $8e07a5888a205cc0$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $8e07a5888a205cc0$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $8e07a5888a205cc0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $8e07a5888a205cc0$var$needsFormReset && ($8e07a5888a205cc0$var$needsFormReset = !1, $8e07a5888a205cc0$var$recursivelyResetForms(finishedWork));
            $8e07a5888a205cc0$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $8e07a5888a205cc0$var$offscreenDirectParentIsHidden;
            $8e07a5888a205cc0$var$offscreenDirectParentIsHidden = $8e07a5888a205cc0$var$offscreenSubtreeIsHidden;
            current = $8e07a5888a205cc0$var$pushMutationContext();
            ii = $8e07a5888a205cc0$var$currentHoistableRoot;
            $8e07a5888a205cc0$var$currentHoistableRoot = $8e07a5888a205cc0$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $8e07a5888a205cc0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $8e07a5888a205cc0$var$commitReconciliationEffects(finishedWork);
            $8e07a5888a205cc0$var$currentHoistableRoot = ii;
            $8e07a5888a205cc0$var$viewTransitionMutationContext && $8e07a5888a205cc0$var$inUpdateViewTransition && ($8e07a5888a205cc0$var$rootViewTransitionAffected = !0);
            $8e07a5888a205cc0$var$viewTransitionMutationContext = current;
            $8e07a5888a205cc0$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $8e07a5888a205cc0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $8e07a5888a205cc0$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $8e07a5888a205cc0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $8e07a5888a205cc0$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $8e07a5888a205cc0$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $8e07a5888a205cc0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $8e07a5888a205cc0$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($8e07a5888a205cc0$var$globalMostRecentFallbackTime = $8e07a5888a205cc0$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $8e07a5888a205cc0$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $8e07a5888a205cc0$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $8e07a5888a205cc0$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $8e07a5888a205cc0$var$offscreenDirectParentIsHidden;
            $8e07a5888a205cc0$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $8e07a5888a205cc0$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $8e07a5888a205cc0$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $8e07a5888a205cc0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $8e07a5888a205cc0$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $8e07a5888a205cc0$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $8e07a5888a205cc0$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $8e07a5888a205cc0$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $8e07a5888a205cc0$var$offscreenSubtreeIsHidden || $8e07a5888a205cc0$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $8e07a5888a205cc0$var$offscreenSubtreeWasHidden, lanes = $8e07a5888a205cc0$var$offscreenSubtreeIsHidden, current = $8e07a5888a205cc0$var$offscreenSubtreeWasHidden, $8e07a5888a205cc0$var$offscreenSubtreeIsHidden = ii || $8e07a5888a205cc0$var$offscreenSubtreeIsHidden, $8e07a5888a205cc0$var$offscreenSubtreeWasHidden = root, $8e07a5888a205cc0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $8e07a5888a205cc0$var$offscreenSubtreeIsHidden = lanes, $8e07a5888a205cc0$var$offscreenSubtreeWasHidden = current), !ii && $8e07a5888a205cc0$var$offscreenDirectParentIsHidden || $8e07a5888a205cc0$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $8e07a5888a205cc0$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $8e07a5888a205cc0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $8e07a5888a205cc0$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $8e07a5888a205cc0$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($8e07a5888a205cc0$var$offscreenSubtreeWasHidden || null === current || $8e07a5888a205cc0$var$safelyDetachRef(current, current.return));
            flags = $8e07a5888a205cc0$var$pushMutationContext();
            ii = $8e07a5888a205cc0$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $8e07a5888a205cc0$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $8e07a5888a205cc0$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $8e07a5888a205cc0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $8e07a5888a205cc0$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $8e07a5888a205cc0$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $8e07a5888a205cc0$var$inUpdateViewTransition = ii;
            $8e07a5888a205cc0$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($8e07a5888a205cc0$var$offscreenSubtreeWasHidden || null === current || $8e07a5888a205cc0$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $8e07a5888a205cc0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $8e07a5888a205cc0$var$commitReconciliationEffects(finishedWork);
    }
}
function $8e07a5888a205cc0$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($8e07a5888a205cc0$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($8e07a5888a205cc0$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($8e07a5888a205cc0$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $8e07a5888a205cc0$var$getHostSibling(finishedWork);
                    $8e07a5888a205cc0$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($8e07a5888a205cc0$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $8e07a5888a205cc0$var$getHostSibling(finishedWork);
                    $8e07a5888a205cc0$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $8e07a5888a205cc0$var$getHostSibling(finishedWork);
                    $8e07a5888a205cc0$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $8e07a5888a205cc0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $8e07a5888a205cc0$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $8e07a5888a205cc0$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $8e07a5888a205cc0$var$_enabled = !0, fiber.reset(), $8e07a5888a205cc0$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $8e07a5888a205cc0$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$8e07a5888a205cc0$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $8e07a5888a205cc0$var$measureNestedViewTransitions(parentFiber, !1);
}
function $8e07a5888a205cc0$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $8e07a5888a205cc0$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $8e07a5888a205cc0$var$rootViewTransitionNameCanceled = $8e07a5888a205cc0$var$viewTransitionContextChanged = !1;
            $8e07a5888a205cc0$var$pushViewTransitionCancelableScope();
            $8e07a5888a205cc0$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$8e07a5888a205cc0$var$viewTransitionContextChanged && !$8e07a5888a205cc0$var$rootViewTransitionAffected) {
                finishedWork = $8e07a5888a205cc0$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $8e07a5888a205cc0$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $8e07a5888a205cc0$var$rootViewTransitionNameCanceled = !0;
            }
            $8e07a5888a205cc0$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $8e07a5888a205cc0$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $8e07a5888a205cc0$var$viewTransitionContextChanged;
            $8e07a5888a205cc0$var$viewTransitionContextChanged = !1;
            $8e07a5888a205cc0$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $8e07a5888a205cc0$var$viewTransitionContextChanged && ($8e07a5888a205cc0$var$rootViewTransitionAffected = !0);
            $8e07a5888a205cc0$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $8e07a5888a205cc0$var$commitEnterViewTransitions(finishedWork, !1) : $8e07a5888a205cc0$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $8e07a5888a205cc0$var$viewTransitionContextChanged;
            oldName = $8e07a5888a205cc0$var$pushViewTransitionCancelableScope();
            $8e07a5888a205cc0$var$viewTransitionContextChanged = !1;
            $8e07a5888a205cc0$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $8e07a5888a205cc0$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $8e07a5888a205cc0$var$getViewTransitionName(props, state);
            state = $8e07a5888a205cc0$var$getViewTransitionName(current.memoizedProps, state);
            var className = $8e07a5888a205cc0$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $8e07a5888a205cc0$var$viewTransitionHostInstanceIdx = 0, root = $8e07a5888a205cc0$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $8e07a5888a205cc0$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($8e07a5888a205cc0$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $8e07a5888a205cc0$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $8e07a5888a205cc0$var$viewTransitionCancelableChildren), $8e07a5888a205cc0$var$viewTransitionCancelableChildren = oldName);
            $8e07a5888a205cc0$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $8e07a5888a205cc0$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $8e07a5888a205cc0$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$8e07a5888a205cc0$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $8e07a5888a205cc0$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $8e07a5888a205cc0$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $8e07a5888a205cc0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $8e07a5888a205cc0$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $8e07a5888a205cc0$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $8e07a5888a205cc0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $8e07a5888a205cc0$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $8e07a5888a205cc0$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $8e07a5888a205cc0$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $8e07a5888a205cc0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $8e07a5888a205cc0$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $8e07a5888a205cc0$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $8e07a5888a205cc0$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $8e07a5888a205cc0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $8e07a5888a205cc0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $8e07a5888a205cc0$var$safelyDetachRef(finishedWork, finishedWork.return);
                $8e07a5888a205cc0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $8e07a5888a205cc0$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $8e07a5888a205cc0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8e07a5888a205cc0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $8e07a5888a205cc0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $8e07a5888a205cc0$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $8e07a5888a205cc0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $8e07a5888a205cc0$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$8e07a5888a205cc0$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $8e07a5888a205cc0$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $8e07a5888a205cc0$var$commitClassCallbacks(finishedWork);
                $8e07a5888a205cc0$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $8e07a5888a205cc0$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $8e07a5888a205cc0$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $8e07a5888a205cc0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $8e07a5888a205cc0$var$commitHostMount(finishedWork);
                $8e07a5888a205cc0$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $8e07a5888a205cc0$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $8e07a5888a205cc0$var$offscreenSubtreeIsHidden || $8e07a5888a205cc0$var$mountHoistable($8e07a5888a205cc0$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $8e07a5888a205cc0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $8e07a5888a205cc0$var$commitHostMount(finishedWork);
                $8e07a5888a205cc0$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $8e07a5888a205cc0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $8e07a5888a205cc0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $8e07a5888a205cc0$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $8e07a5888a205cc0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $8e07a5888a205cc0$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $8e07a5888a205cc0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $8e07a5888a205cc0$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $8e07a5888a205cc0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $8e07a5888a205cc0$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $8e07a5888a205cc0$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $8e07a5888a205cc0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8e07a5888a205cc0$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $8e07a5888a205cc0$var$releaseCache(previousCache));
}
function $8e07a5888a205cc0$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $8e07a5888a205cc0$var$releaseCache(current));
}
function $8e07a5888a205cc0$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$8e07a5888a205cc0$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $8e07a5888a205cc0$var$restoreNestedViewTransitions(parentFiber);
}
function $8e07a5888a205cc0$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $8e07a5888a205cc0$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $8e07a5888a205cc0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $8e07a5888a205cc0$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $8e07a5888a205cc0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $8e07a5888a205cc0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $8e07a5888a205cc0$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $8e07a5888a205cc0$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $8e07a5888a205cc0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $8e07a5888a205cc0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $8e07a5888a205cc0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $8e07a5888a205cc0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $8e07a5888a205cc0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $8e07a5888a205cc0$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $8e07a5888a205cc0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $8e07a5888a205cc0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $8e07a5888a205cc0$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $8e07a5888a205cc0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $8e07a5888a205cc0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $8e07a5888a205cc0$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $8e07a5888a205cc0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $8e07a5888a205cc0$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($8e07a5888a205cc0$var$restoreViewTransitionOnHostInstances(flags.child, !0), $8e07a5888a205cc0$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $8e07a5888a205cc0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $8e07a5888a205cc0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $8e07a5888a205cc0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $8e07a5888a205cc0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $8e07a5888a205cc0$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $8e07a5888a205cc0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $8e07a5888a205cc0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $8e07a5888a205cc0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $8e07a5888a205cc0$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $8e07a5888a205cc0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $8e07a5888a205cc0$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $8e07a5888a205cc0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8e07a5888a205cc0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $8e07a5888a205cc0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $8e07a5888a205cc0$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $8e07a5888a205cc0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $8e07a5888a205cc0$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $8e07a5888a205cc0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $8e07a5888a205cc0$var$suspenseyCommitFlag = 8192;
function $8e07a5888a205cc0$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $8e07a5888a205cc0$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$8e07a5888a205cc0$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $8e07a5888a205cc0$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $8e07a5888a205cc0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $8e07a5888a205cc0$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $8e07a5888a205cc0$var$suspendResource(suspendedState, $8e07a5888a205cc0$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $8e07a5888a205cc0$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $8e07a5888a205cc0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $8e07a5888a205cc0$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $8e07a5888a205cc0$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $8e07a5888a205cc0$var$currentHoistableRoot;
            $8e07a5888a205cc0$var$currentHoistableRoot = $8e07a5888a205cc0$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $8e07a5888a205cc0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $8e07a5888a205cc0$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $8e07a5888a205cc0$var$suspenseyCommitFlag, $8e07a5888a205cc0$var$suspenseyCommitFlag = 16777216, $8e07a5888a205cc0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $8e07a5888a205cc0$var$suspenseyCommitFlag = previousHoistableRoot) : $8e07a5888a205cc0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $8e07a5888a205cc0$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $8e07a5888a205cc0$var$appearingViewTransitions && ($8e07a5888a205cc0$var$appearingViewTransitions = new Map());
                $8e07a5888a205cc0$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $8e07a5888a205cc0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $8e07a5888a205cc0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $8e07a5888a205cc0$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $8e07a5888a205cc0$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $8e07a5888a205cc0$var$nextEffect = childToDelete;
            $8e07a5888a205cc0$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $8e07a5888a205cc0$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$8e07a5888a205cc0$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $8e07a5888a205cc0$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $8e07a5888a205cc0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $8e07a5888a205cc0$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $8e07a5888a205cc0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $8e07a5888a205cc0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $8e07a5888a205cc0$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $8e07a5888a205cc0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $8e07a5888a205cc0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $8e07a5888a205cc0$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $8e07a5888a205cc0$var$nextEffect = childToDelete;
            $8e07a5888a205cc0$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $8e07a5888a205cc0$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $8e07a5888a205cc0$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $8e07a5888a205cc0$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $8e07a5888a205cc0$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $8e07a5888a205cc0$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8e07a5888a205cc0$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $8e07a5888a205cc0$var$nextEffect;){
        var fiber = $8e07a5888a205cc0$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $8e07a5888a205cc0$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $8e07a5888a205cc0$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $8e07a5888a205cc0$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $8e07a5888a205cc0$var$nextEffect;){
            cache = $8e07a5888a205cc0$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $8e07a5888a205cc0$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $8e07a5888a205cc0$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $8e07a5888a205cc0$var$nextEffect = sibling;
                break a;
            }
            $8e07a5888a205cc0$var$nextEffect = returnFiber;
        }
    }
}
var $8e07a5888a205cc0$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $8e07a5888a205cc0$var$readContext($8e07a5888a205cc0$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $8e07a5888a205cc0$var$readContext($8e07a5888a205cc0$var$CacheContext).controller.signal;
    }
}, $8e07a5888a205cc0$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $8e07a5888a205cc0$var$executionContext = 0, $8e07a5888a205cc0$var$workInProgressRoot = null, $8e07a5888a205cc0$var$workInProgress = null, $8e07a5888a205cc0$var$workInProgressRootRenderLanes = 0, $8e07a5888a205cc0$var$workInProgressSuspendedReason = 0, $8e07a5888a205cc0$var$workInProgressThrownValue = null, $8e07a5888a205cc0$var$workInProgressRootDidSkipSuspendedSiblings = !1, $8e07a5888a205cc0$var$workInProgressRootIsPrerendering = !1, $8e07a5888a205cc0$var$workInProgressRootDidAttachPingListener = !1, $8e07a5888a205cc0$var$entangledRenderLanes = 0, $8e07a5888a205cc0$var$workInProgressRootExitStatus = 0, $8e07a5888a205cc0$var$workInProgressRootSkippedLanes = 0, $8e07a5888a205cc0$var$workInProgressRootInterleavedUpdatedLanes = 0, $8e07a5888a205cc0$var$workInProgressRootPingedLanes = 0, $8e07a5888a205cc0$var$workInProgressDeferredLane = 0, $8e07a5888a205cc0$var$workInProgressSuspendedRetryLanes = 0, $8e07a5888a205cc0$var$workInProgressRootConcurrentErrors = null, $8e07a5888a205cc0$var$workInProgressRootRecoverableErrors = null, $8e07a5888a205cc0$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $8e07a5888a205cc0$var$globalMostRecentFallbackTime = 0, $8e07a5888a205cc0$var$globalMostRecentTransitionTime = 0, $8e07a5888a205cc0$var$workInProgressRootRenderTargetTime = Infinity, $8e07a5888a205cc0$var$workInProgressTransitions = null, $8e07a5888a205cc0$var$legacyErrorBoundariesThatAlreadyFailed = null, $8e07a5888a205cc0$var$pendingEffectsStatus = 0, $8e07a5888a205cc0$var$pendingEffectsRoot = null, $8e07a5888a205cc0$var$pendingFinishedWork = null, $8e07a5888a205cc0$var$pendingEffectsLanes = 0, $8e07a5888a205cc0$var$pendingEffectsRemainingLanes = 0, $8e07a5888a205cc0$var$pendingPassiveTransitions = null, $8e07a5888a205cc0$var$pendingRecoverableErrors = null, $8e07a5888a205cc0$var$pendingViewTransition = null, $8e07a5888a205cc0$var$pendingViewTransitionEvents = null, $8e07a5888a205cc0$var$pendingTransitionTypes = null, $8e07a5888a205cc0$var$nestedUpdateCount = 0, $8e07a5888a205cc0$var$rootWithNestedUpdates = null;
function $8e07a5888a205cc0$var$requestUpdateLane() {
    return 0 !== ($8e07a5888a205cc0$var$executionContext & 2) && 0 !== $8e07a5888a205cc0$var$workInProgressRootRenderLanes ? $8e07a5888a205cc0$var$workInProgressRootRenderLanes & -$8e07a5888a205cc0$var$workInProgressRootRenderLanes : null !== $8e07a5888a205cc0$var$ReactSharedInternals.T ? $8e07a5888a205cc0$var$requestTransitionLane() : $8e07a5888a205cc0$var$resolveUpdatePriority();
}
function $8e07a5888a205cc0$var$requestDeferredLane() {
    if (0 === $8e07a5888a205cc0$var$workInProgressDeferredLane) {
        if (0 === ($8e07a5888a205cc0$var$workInProgressRootRenderLanes & 536870912) || $8e07a5888a205cc0$var$isHydrating) {
            var lane = $8e07a5888a205cc0$var$nextTransitionDeferredLane;
            $8e07a5888a205cc0$var$nextTransitionDeferredLane <<= 1;
            0 === ($8e07a5888a205cc0$var$nextTransitionDeferredLane & 3932160) && ($8e07a5888a205cc0$var$nextTransitionDeferredLane = 262144);
            $8e07a5888a205cc0$var$workInProgressDeferredLane = lane;
        } else $8e07a5888a205cc0$var$workInProgressDeferredLane = 536870912;
    }
    lane = $8e07a5888a205cc0$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $8e07a5888a205cc0$var$workInProgressDeferredLane;
}
function $8e07a5888a205cc0$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $8e07a5888a205cc0$var$createViewTransitionInstance($8e07a5888a205cc0$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $8e07a5888a205cc0$var$pendingViewTransitionEvents && ($8e07a5888a205cc0$var$pendingViewTransitionEvents = []);
        $8e07a5888a205cc0$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $8e07a5888a205cc0$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $8e07a5888a205cc0$var$workInProgressRoot && (2 === $8e07a5888a205cc0$var$workInProgressSuspendedReason || 9 === $8e07a5888a205cc0$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $8e07a5888a205cc0$var$prepareFreshStack(root, 0), $8e07a5888a205cc0$var$markRootSuspended(root, $8e07a5888a205cc0$var$workInProgressRootRenderLanes, $8e07a5888a205cc0$var$workInProgressDeferredLane, !1);
    $8e07a5888a205cc0$var$markRootUpdated$1(root, lane);
    if (0 === ($8e07a5888a205cc0$var$executionContext & 2) || root !== $8e07a5888a205cc0$var$workInProgressRoot) root === $8e07a5888a205cc0$var$workInProgressRoot && (0 === ($8e07a5888a205cc0$var$executionContext & 2) && ($8e07a5888a205cc0$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $8e07a5888a205cc0$var$workInProgressRootExitStatus && $8e07a5888a205cc0$var$markRootSuspended(root, $8e07a5888a205cc0$var$workInProgressRootRenderLanes, $8e07a5888a205cc0$var$workInProgressDeferredLane, !1)), $8e07a5888a205cc0$var$ensureRootIsScheduled(root);
}
function $8e07a5888a205cc0$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($8e07a5888a205cc0$var$executionContext & 6)) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $8e07a5888a205cc0$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $8e07a5888a205cc0$var$renderRootConcurrent(root$jscomp$0, lanes) : $8e07a5888a205cc0$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $8e07a5888a205cc0$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $8e07a5888a205cc0$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$8e07a5888a205cc0$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $8e07a5888a205cc0$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $8e07a5888a205cc0$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($8e07a5888a205cc0$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $8e07a5888a205cc0$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($8e07a5888a205cc0$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $8e07a5888a205cc0$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $8e07a5888a205cc0$var$workInProgressRootRecoverableErrors;
                            $8e07a5888a205cc0$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $8e07a5888a205cc0$var$workInProgressRootRecoverableErrors ? $8e07a5888a205cc0$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $8e07a5888a205cc0$var$workInProgressRootRecoverableErrors.push.apply($8e07a5888a205cc0$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $8e07a5888a205cc0$var$prepareFreshStack(root$jscomp$0, 0);
                $8e07a5888a205cc0$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $8e07a5888a205cc0$var$markRootSuspended(shouldTimeSlice, lanes, $8e07a5888a205cc0$var$workInProgressDeferredLane, !$8e07a5888a205cc0$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $8e07a5888a205cc0$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $8e07a5888a205cc0$var$globalMostRecentFallbackTime + 300 - $8e07a5888a205cc0$var$now(), 10 < exitStatus)) {
                    $8e07a5888a205cc0$var$markRootSuspended(shouldTimeSlice, lanes, $8e07a5888a205cc0$var$workInProgressDeferredLane, !$8e07a5888a205cc0$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $8e07a5888a205cc0$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $8e07a5888a205cc0$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $8e07a5888a205cc0$var$scheduleTimeout($8e07a5888a205cc0$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $8e07a5888a205cc0$var$workInProgressRootRecoverableErrors, $8e07a5888a205cc0$var$workInProgressTransitions, $8e07a5888a205cc0$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $8e07a5888a205cc0$var$workInProgressDeferredLane, $8e07a5888a205cc0$var$workInProgressRootInterleavedUpdatedLanes, $8e07a5888a205cc0$var$workInProgressSuspendedRetryLanes, $8e07a5888a205cc0$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $8e07a5888a205cc0$var$completeRootWhenReady(shouldTimeSlice, forceSync, $8e07a5888a205cc0$var$workInProgressRootRecoverableErrors, $8e07a5888a205cc0$var$workInProgressTransitions, $8e07a5888a205cc0$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $8e07a5888a205cc0$var$workInProgressDeferredLane, $8e07a5888a205cc0$var$workInProgressRootInterleavedUpdatedLanes, $8e07a5888a205cc0$var$workInProgressSuspendedRetryLanes, $8e07a5888a205cc0$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $8e07a5888a205cc0$var$ensureRootIsScheduled(root$jscomp$0);
}
function $8e07a5888a205cc0$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $8e07a5888a205cc0$var$noop$1
        }, $8e07a5888a205cc0$var$appearingViewTransitions = null, $8e07a5888a205cc0$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $8e07a5888a205cc0$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $8e07a5888a205cc0$var$globalMostRecentFallbackTime - $8e07a5888a205cc0$var$now() : (lanes & 4194048) === lanes ? $8e07a5888a205cc0$var$globalMostRecentTransitionTime - $8e07a5888a205cc0$var$now() : 0, subtreeFlags = $8e07a5888a205cc0$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $8e07a5888a205cc0$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($8e07a5888a205cc0$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $8e07a5888a205cc0$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $8e07a5888a205cc0$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $8e07a5888a205cc0$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$8e07a5888a205cc0$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $8e07a5888a205cc0$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $8e07a5888a205cc0$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$8e07a5888a205cc0$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$8e07a5888a205cc0$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $8e07a5888a205cc0$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $8e07a5888a205cc0$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $8e07a5888a205cc0$var$flushSyncWork$1() {
    return 0 === ($8e07a5888a205cc0$var$executionContext & 6) ? ($8e07a5888a205cc0$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $8e07a5888a205cc0$var$resetWorkInProgressStack() {
    if (null !== $8e07a5888a205cc0$var$workInProgress) {
        if (0 === $8e07a5888a205cc0$var$workInProgressSuspendedReason) var interruptedWork = $8e07a5888a205cc0$var$workInProgress.return;
        else interruptedWork = $8e07a5888a205cc0$var$workInProgress, $8e07a5888a205cc0$var$lastContextDependency = $8e07a5888a205cc0$var$currentlyRenderingFiber$1 = null, $8e07a5888a205cc0$var$resetHooksOnUnwind(interruptedWork), $8e07a5888a205cc0$var$thenableState$1 = null, $8e07a5888a205cc0$var$thenableIndexCounter$1 = 0, interruptedWork = $8e07a5888a205cc0$var$workInProgress;
        for(; null !== interruptedWork;)$8e07a5888a205cc0$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $8e07a5888a205cc0$var$workInProgress = null;
    }
}
function $8e07a5888a205cc0$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $8e07a5888a205cc0$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $8e07a5888a205cc0$var$pendingEffectsLanes = 0;
    $8e07a5888a205cc0$var$resetWorkInProgressStack();
    $8e07a5888a205cc0$var$workInProgressRoot = root;
    $8e07a5888a205cc0$var$workInProgress = timeoutHandle = $8e07a5888a205cc0$var$createWorkInProgress(root.current, null);
    $8e07a5888a205cc0$var$workInProgressRootRenderLanes = lanes;
    $8e07a5888a205cc0$var$workInProgressSuspendedReason = 0;
    $8e07a5888a205cc0$var$workInProgressThrownValue = null;
    $8e07a5888a205cc0$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $8e07a5888a205cc0$var$workInProgressRootIsPrerendering = $8e07a5888a205cc0$var$checkIfRootIsPrerendering(root, lanes);
    $8e07a5888a205cc0$var$workInProgressRootDidAttachPingListener = !1;
    $8e07a5888a205cc0$var$workInProgressSuspendedRetryLanes = $8e07a5888a205cc0$var$workInProgressDeferredLane = $8e07a5888a205cc0$var$workInProgressRootPingedLanes = $8e07a5888a205cc0$var$workInProgressRootInterleavedUpdatedLanes = $8e07a5888a205cc0$var$workInProgressRootSkippedLanes = $8e07a5888a205cc0$var$workInProgressRootExitStatus = 0;
    $8e07a5888a205cc0$var$workInProgressRootRecoverableErrors = $8e07a5888a205cc0$var$workInProgressRootConcurrentErrors = null;
    $8e07a5888a205cc0$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $8e07a5888a205cc0$var$entangledRenderLanes = $8e07a5888a205cc0$var$getEntangledLanes(root, lanes);
    $8e07a5888a205cc0$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $8e07a5888a205cc0$var$handleThrow(root, thrownValue) {
    $8e07a5888a205cc0$var$currentlyRenderingFiber = null;
    $8e07a5888a205cc0$var$ReactSharedInternals.H = $8e07a5888a205cc0$var$ContextOnlyDispatcher;
    thrownValue === $8e07a5888a205cc0$var$SuspenseException || thrownValue === $8e07a5888a205cc0$var$SuspenseActionException ? (thrownValue = $8e07a5888a205cc0$var$getSuspendedThenable(), $8e07a5888a205cc0$var$workInProgressSuspendedReason = 3) : thrownValue === $8e07a5888a205cc0$var$SuspenseyCommitException ? (thrownValue = $8e07a5888a205cc0$var$getSuspendedThenable(), $8e07a5888a205cc0$var$workInProgressSuspendedReason = 4) : $8e07a5888a205cc0$var$workInProgressSuspendedReason = thrownValue === $8e07a5888a205cc0$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $8e07a5888a205cc0$var$workInProgressThrownValue = thrownValue;
    null === $8e07a5888a205cc0$var$workInProgress && ($8e07a5888a205cc0$var$workInProgressRootExitStatus = 1, $8e07a5888a205cc0$var$logUncaughtError(root, $8e07a5888a205cc0$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $8e07a5888a205cc0$var$shouldRemainOnPreviousScreen() {
    var handler = $8e07a5888a205cc0$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($8e07a5888a205cc0$var$workInProgressRootRenderLanes & 4194048) === $8e07a5888a205cc0$var$workInProgressRootRenderLanes ? null === $8e07a5888a205cc0$var$shellBoundary ? !0 : !1 : ($8e07a5888a205cc0$var$workInProgressRootRenderLanes & 62914560) === $8e07a5888a205cc0$var$workInProgressRootRenderLanes || 0 !== ($8e07a5888a205cc0$var$workInProgressRootRenderLanes & 536870912) ? handler === $8e07a5888a205cc0$var$shellBoundary : !1;
}
function $8e07a5888a205cc0$var$pushDispatcher() {
    var prevDispatcher = $8e07a5888a205cc0$var$ReactSharedInternals.H;
    $8e07a5888a205cc0$var$ReactSharedInternals.H = $8e07a5888a205cc0$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $8e07a5888a205cc0$var$ContextOnlyDispatcher : prevDispatcher;
}
function $8e07a5888a205cc0$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $8e07a5888a205cc0$var$ReactSharedInternals.A;
    $8e07a5888a205cc0$var$ReactSharedInternals.A = $8e07a5888a205cc0$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $8e07a5888a205cc0$var$renderDidSuspendDelayIfPossible() {
    $8e07a5888a205cc0$var$workInProgressRootExitStatus = 4;
    $8e07a5888a205cc0$var$workInProgressRootDidSkipSuspendedSiblings || ($8e07a5888a205cc0$var$workInProgressRootRenderLanes & 4194048) !== $8e07a5888a205cc0$var$workInProgressRootRenderLanes && null !== $8e07a5888a205cc0$var$suspenseHandlerStackCursor.current || ($8e07a5888a205cc0$var$workInProgressRootIsPrerendering = !0);
    0 === ($8e07a5888a205cc0$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($8e07a5888a205cc0$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $8e07a5888a205cc0$var$workInProgressRoot || $8e07a5888a205cc0$var$markRootSuspended($8e07a5888a205cc0$var$workInProgressRoot, $8e07a5888a205cc0$var$workInProgressRootRenderLanes, $8e07a5888a205cc0$var$workInProgressDeferredLane, !1);
}
function $8e07a5888a205cc0$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $8e07a5888a205cc0$var$executionContext;
    $8e07a5888a205cc0$var$executionContext |= 2;
    var prevDispatcher = $8e07a5888a205cc0$var$pushDispatcher(), prevAsyncDispatcher = $8e07a5888a205cc0$var$pushAsyncDispatcher();
    if ($8e07a5888a205cc0$var$workInProgressRoot !== root || $8e07a5888a205cc0$var$workInProgressRootRenderLanes !== lanes) $8e07a5888a205cc0$var$workInProgressTransitions = null, $8e07a5888a205cc0$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $8e07a5888a205cc0$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $8e07a5888a205cc0$var$workInProgressSuspendedReason && null !== $8e07a5888a205cc0$var$workInProgress) {
            var unitOfWork = $8e07a5888a205cc0$var$workInProgress, thrownValue = $8e07a5888a205cc0$var$workInProgressThrownValue;
            switch($8e07a5888a205cc0$var$workInProgressSuspendedReason){
                case 8:
                    $8e07a5888a205cc0$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $8e07a5888a205cc0$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $8e07a5888a205cc0$var$workInProgressSuspendedReason;
                    $8e07a5888a205cc0$var$workInProgressSuspendedReason = 0;
                    $8e07a5888a205cc0$var$workInProgressThrownValue = null;
                    $8e07a5888a205cc0$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $8e07a5888a205cc0$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $8e07a5888a205cc0$var$workInProgressSuspendedReason, $8e07a5888a205cc0$var$workInProgressSuspendedReason = 0, $8e07a5888a205cc0$var$workInProgressThrownValue = null, $8e07a5888a205cc0$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $8e07a5888a205cc0$var$workLoopSync();
        exitStatus = $8e07a5888a205cc0$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $8e07a5888a205cc0$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $8e07a5888a205cc0$var$lastContextDependency = $8e07a5888a205cc0$var$currentlyRenderingFiber$1 = null;
    $8e07a5888a205cc0$var$executionContext = prevExecutionContext;
    $8e07a5888a205cc0$var$ReactSharedInternals.H = prevDispatcher;
    $8e07a5888a205cc0$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $8e07a5888a205cc0$var$workInProgress && ($8e07a5888a205cc0$var$workInProgressRoot = null, $8e07a5888a205cc0$var$workInProgressRootRenderLanes = 0, $8e07a5888a205cc0$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $8e07a5888a205cc0$var$workLoopSync() {
    for(; null !== $8e07a5888a205cc0$var$workInProgress;)$8e07a5888a205cc0$var$performUnitOfWork($8e07a5888a205cc0$var$workInProgress);
}
function $8e07a5888a205cc0$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $8e07a5888a205cc0$var$executionContext;
    $8e07a5888a205cc0$var$executionContext |= 2;
    var prevDispatcher = $8e07a5888a205cc0$var$pushDispatcher(), prevAsyncDispatcher = $8e07a5888a205cc0$var$pushAsyncDispatcher();
    $8e07a5888a205cc0$var$workInProgressRoot !== root || $8e07a5888a205cc0$var$workInProgressRootRenderLanes !== lanes ? ($8e07a5888a205cc0$var$workInProgressTransitions = null, $8e07a5888a205cc0$var$workInProgressRootRenderTargetTime = $8e07a5888a205cc0$var$now() + 500, $8e07a5888a205cc0$var$prepareFreshStack(root, lanes)) : $8e07a5888a205cc0$var$workInProgressRootIsPrerendering = $8e07a5888a205cc0$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $8e07a5888a205cc0$var$workInProgressSuspendedReason && null !== $8e07a5888a205cc0$var$workInProgress) {
            lanes = $8e07a5888a205cc0$var$workInProgress;
            var thrownValue = $8e07a5888a205cc0$var$workInProgressThrownValue;
            b: switch($8e07a5888a205cc0$var$workInProgressSuspendedReason){
                case 1:
                    $8e07a5888a205cc0$var$workInProgressSuspendedReason = 0;
                    $8e07a5888a205cc0$var$workInProgressThrownValue = null;
                    $8e07a5888a205cc0$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($8e07a5888a205cc0$var$isThenableResolved(thrownValue)) {
                        $8e07a5888a205cc0$var$workInProgressSuspendedReason = 0;
                        $8e07a5888a205cc0$var$workInProgressThrownValue = null;
                        $8e07a5888a205cc0$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $8e07a5888a205cc0$var$workInProgressSuspendedReason && 9 !== $8e07a5888a205cc0$var$workInProgressSuspendedReason || $8e07a5888a205cc0$var$workInProgressRoot !== root || ($8e07a5888a205cc0$var$workInProgressSuspendedReason = 7);
                        $8e07a5888a205cc0$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $8e07a5888a205cc0$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $8e07a5888a205cc0$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $8e07a5888a205cc0$var$isThenableResolved(thrownValue) ? ($8e07a5888a205cc0$var$workInProgressSuspendedReason = 0, $8e07a5888a205cc0$var$workInProgressThrownValue = null, $8e07a5888a205cc0$var$replaySuspendedUnitOfWork(lanes)) : ($8e07a5888a205cc0$var$workInProgressSuspendedReason = 0, $8e07a5888a205cc0$var$workInProgressThrownValue = null, $8e07a5888a205cc0$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($8e07a5888a205cc0$var$workInProgress.tag){
                        case 26:
                            resource = $8e07a5888a205cc0$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $8e07a5888a205cc0$var$workInProgress;
                            if (resource ? $8e07a5888a205cc0$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $8e07a5888a205cc0$var$workInProgressSuspendedReason = 0;
                                $8e07a5888a205cc0$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $8e07a5888a205cc0$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($8e07a5888a205cc0$var$workInProgress = returnFiber, $8e07a5888a205cc0$var$completeUnitOfWork(returnFiber)) : $8e07a5888a205cc0$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $8e07a5888a205cc0$var$workInProgressSuspendedReason = 0;
                    $8e07a5888a205cc0$var$workInProgressThrownValue = null;
                    $8e07a5888a205cc0$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $8e07a5888a205cc0$var$workInProgressSuspendedReason = 0;
                    $8e07a5888a205cc0$var$workInProgressThrownValue = null;
                    $8e07a5888a205cc0$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $8e07a5888a205cc0$var$resetWorkInProgressStack();
                    $8e07a5888a205cc0$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(462));
            }
        }
        $8e07a5888a205cc0$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $8e07a5888a205cc0$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $8e07a5888a205cc0$var$lastContextDependency = $8e07a5888a205cc0$var$currentlyRenderingFiber$1 = null;
    $8e07a5888a205cc0$var$ReactSharedInternals.H = prevDispatcher;
    $8e07a5888a205cc0$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $8e07a5888a205cc0$var$executionContext = prevExecutionContext;
    if (null !== $8e07a5888a205cc0$var$workInProgress) return 0;
    $8e07a5888a205cc0$var$workInProgressRoot = null;
    $8e07a5888a205cc0$var$workInProgressRootRenderLanes = 0;
    $8e07a5888a205cc0$var$finishQueueingConcurrentUpdates();
    return $8e07a5888a205cc0$var$workInProgressRootExitStatus;
}
function $8e07a5888a205cc0$var$workLoopConcurrentByScheduler() {
    for(; null !== $8e07a5888a205cc0$var$workInProgress && !$8e07a5888a205cc0$var$shouldYield();)$8e07a5888a205cc0$var$performUnitOfWork($8e07a5888a205cc0$var$workInProgress);
}
function $8e07a5888a205cc0$var$performUnitOfWork(unitOfWork) {
    var next = $8e07a5888a205cc0$var$beginWork(unitOfWork.alternate, unitOfWork, $8e07a5888a205cc0$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $8e07a5888a205cc0$var$completeUnitOfWork(unitOfWork) : $8e07a5888a205cc0$var$workInProgress = next;
}
function $8e07a5888a205cc0$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $8e07a5888a205cc0$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $8e07a5888a205cc0$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $8e07a5888a205cc0$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $8e07a5888a205cc0$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $8e07a5888a205cc0$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $8e07a5888a205cc0$var$hydrationParentFiber && ($8e07a5888a205cc0$var$isHydrating ? ($8e07a5888a205cc0$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($8e07a5888a205cc0$var$nextHydratableInstance = fiber.stateNode)) : ($8e07a5888a205cc0$var$popToNextHostParent(fiber), $8e07a5888a205cc0$var$isHydrating = !0));
        default:
            $8e07a5888a205cc0$var$unwindInterruptedWork(current, next), next = $8e07a5888a205cc0$var$workInProgress = $8e07a5888a205cc0$var$resetWorkInProgress(next, $8e07a5888a205cc0$var$entangledRenderLanes), next = $8e07a5888a205cc0$var$beginWork(current, next, $8e07a5888a205cc0$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $8e07a5888a205cc0$var$completeUnitOfWork(unitOfWork) : $8e07a5888a205cc0$var$workInProgress = next;
}
function $8e07a5888a205cc0$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $8e07a5888a205cc0$var$lastContextDependency = $8e07a5888a205cc0$var$currentlyRenderingFiber$1 = null;
    $8e07a5888a205cc0$var$resetHooksOnUnwind(unitOfWork);
    $8e07a5888a205cc0$var$thenableState$1 = null;
    $8e07a5888a205cc0$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($8e07a5888a205cc0$var$throwException(root, returnFiber, unitOfWork, thrownValue, $8e07a5888a205cc0$var$workInProgressRootRenderLanes)) {
            $8e07a5888a205cc0$var$workInProgressRootExitStatus = 1;
            $8e07a5888a205cc0$var$logUncaughtError(root, $8e07a5888a205cc0$var$createCapturedValueAtFiber(thrownValue, root.current));
            $8e07a5888a205cc0$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $8e07a5888a205cc0$var$workInProgress = returnFiber, error;
        $8e07a5888a205cc0$var$workInProgressRootExitStatus = 1;
        $8e07a5888a205cc0$var$logUncaughtError(root, $8e07a5888a205cc0$var$createCapturedValueAtFiber(thrownValue, root.current));
        $8e07a5888a205cc0$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($8e07a5888a205cc0$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($8e07a5888a205cc0$var$workInProgressRootIsPrerendering || 0 !== ($8e07a5888a205cc0$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($8e07a5888a205cc0$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $8e07a5888a205cc0$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $8e07a5888a205cc0$var$unwindUnitOfWork(unitOfWork, root);
    } else $8e07a5888a205cc0$var$completeUnitOfWork(unitOfWork);
}
function $8e07a5888a205cc0$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $8e07a5888a205cc0$var$unwindUnitOfWork(completedWork, $8e07a5888a205cc0$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $8e07a5888a205cc0$var$completeWork(completedWork.alternate, completedWork, $8e07a5888a205cc0$var$entangledRenderLanes);
        if (null !== next) {
            $8e07a5888a205cc0$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $8e07a5888a205cc0$var$workInProgress = completedWork;
            return;
        }
        $8e07a5888a205cc0$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $8e07a5888a205cc0$var$workInProgressRootExitStatus && ($8e07a5888a205cc0$var$workInProgressRootExitStatus = 5);
}
function $8e07a5888a205cc0$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $8e07a5888a205cc0$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $8e07a5888a205cc0$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $8e07a5888a205cc0$var$workInProgress = unitOfWork;
            return;
        }
        $8e07a5888a205cc0$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $8e07a5888a205cc0$var$workInProgressRootExitStatus = 6;
    $8e07a5888a205cc0$var$workInProgress = null;
}
function $8e07a5888a205cc0$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $8e07a5888a205cc0$var$flushPendingEffects();
    while (0 !== $8e07a5888a205cc0$var$pendingEffectsStatus);
    if (0 !== ($8e07a5888a205cc0$var$executionContext & 6)) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(177));
        root === $8e07a5888a205cc0$var$workInProgressRoot && ($8e07a5888a205cc0$var$workInProgress = $8e07a5888a205cc0$var$workInProgressRoot = null, $8e07a5888a205cc0$var$workInProgressRootRenderLanes = 0);
        $8e07a5888a205cc0$var$pendingFinishedWork = finishedWork;
        $8e07a5888a205cc0$var$pendingEffectsRoot = root;
        $8e07a5888a205cc0$var$pendingEffectsLanes = lanes;
        $8e07a5888a205cc0$var$pendingPassiveTransitions = transitions;
        $8e07a5888a205cc0$var$pendingRecoverableErrors = recoverableErrors;
        $8e07a5888a205cc0$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $8e07a5888a205cc0$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $8e07a5888a205cc0$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $8e07a5888a205cc0$var$concurrentlyUpdatedLanes;
    $8e07a5888a205cc0$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $8e07a5888a205cc0$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($8e07a5888a205cc0$var$pendingTransitionTypes = $8e07a5888a205cc0$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($8e07a5888a205cc0$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $8e07a5888a205cc0$var$scheduleCallback$1($8e07a5888a205cc0$var$NormalPriority$1, function() {
        $8e07a5888a205cc0$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $8e07a5888a205cc0$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $8e07a5888a205cc0$var$ReactSharedInternals.T;
        $8e07a5888a205cc0$var$ReactSharedInternals.T = null;
        updatedLanes = $8e07a5888a205cc0$var$ReactDOMSharedInternals.p;
        $8e07a5888a205cc0$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $8e07a5888a205cc0$var$executionContext;
        $8e07a5888a205cc0$var$executionContext |= 4;
        try {
            $8e07a5888a205cc0$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $8e07a5888a205cc0$var$executionContext = suspendedRetryLanes, $8e07a5888a205cc0$var$ReactDOMSharedInternals.p = updatedLanes, $8e07a5888a205cc0$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $8e07a5888a205cc0$var$pendingEffectsStatus = 1;
    $8e07a5888a205cc0$var$shouldStartViewTransition ? $8e07a5888a205cc0$var$pendingViewTransition = $8e07a5888a205cc0$var$startViewTransition(suspendedState, root.containerInfo, $8e07a5888a205cc0$var$pendingTransitionTypes, $8e07a5888a205cc0$var$flushMutationEffects, $8e07a5888a205cc0$var$flushLayoutEffects, $8e07a5888a205cc0$var$flushAfterMutationEffects, $8e07a5888a205cc0$var$flushSpawnedWork, $8e07a5888a205cc0$var$flushPassiveEffects, $8e07a5888a205cc0$var$reportViewTransitionError, null, null) : ($8e07a5888a205cc0$var$flushMutationEffects(), $8e07a5888a205cc0$var$flushLayoutEffects(), $8e07a5888a205cc0$var$flushSpawnedWork());
}
function $8e07a5888a205cc0$var$reportViewTransitionError(error) {
    if (0 !== $8e07a5888a205cc0$var$pendingEffectsStatus) {
        var onRecoverableError = $8e07a5888a205cc0$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $8e07a5888a205cc0$var$flushAfterMutationEffects() {
    3 === $8e07a5888a205cc0$var$pendingEffectsStatus && ($8e07a5888a205cc0$var$pendingEffectsStatus = 0, $8e07a5888a205cc0$var$commitAfterMutationEffectsOnFiber($8e07a5888a205cc0$var$pendingFinishedWork, $8e07a5888a205cc0$var$pendingEffectsRoot), $8e07a5888a205cc0$var$pendingEffectsStatus = 4);
}
function $8e07a5888a205cc0$var$flushMutationEffects() {
    if (1 === $8e07a5888a205cc0$var$pendingEffectsStatus) {
        $8e07a5888a205cc0$var$pendingEffectsStatus = 0;
        var root = $8e07a5888a205cc0$var$pendingEffectsRoot, finishedWork = $8e07a5888a205cc0$var$pendingFinishedWork, lanes = $8e07a5888a205cc0$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $8e07a5888a205cc0$var$ReactSharedInternals.T;
            $8e07a5888a205cc0$var$ReactSharedInternals.T = null;
            var previousPriority = $8e07a5888a205cc0$var$ReactDOMSharedInternals.p;
            $8e07a5888a205cc0$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $8e07a5888a205cc0$var$executionContext;
            $8e07a5888a205cc0$var$executionContext |= 4;
            try {
                $8e07a5888a205cc0$var$inUpdateViewTransition = $8e07a5888a205cc0$var$rootViewTransitionAffected = !1;
                $8e07a5888a205cc0$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $8e07a5888a205cc0$var$selectionInformation;
                var curFocusedElem = $8e07a5888a205cc0$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $8e07a5888a205cc0$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $8e07a5888a205cc0$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $8e07a5888a205cc0$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $8e07a5888a205cc0$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $8e07a5888a205cc0$var$_enabled = !!$8e07a5888a205cc0$var$eventsEnabled;
                $8e07a5888a205cc0$var$selectionInformation = $8e07a5888a205cc0$var$eventsEnabled = null;
            } finally{
                $8e07a5888a205cc0$var$executionContext = prevExecutionContext, $8e07a5888a205cc0$var$ReactDOMSharedInternals.p = previousPriority, $8e07a5888a205cc0$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $8e07a5888a205cc0$var$pendingEffectsStatus = 2;
    }
}
function $8e07a5888a205cc0$var$flushLayoutEffects() {
    if (2 === $8e07a5888a205cc0$var$pendingEffectsStatus) {
        $8e07a5888a205cc0$var$pendingEffectsStatus = 0;
        var root = $8e07a5888a205cc0$var$pendingEffectsRoot, finishedWork = $8e07a5888a205cc0$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $8e07a5888a205cc0$var$ReactSharedInternals.T;
            $8e07a5888a205cc0$var$ReactSharedInternals.T = null;
            var previousPriority = $8e07a5888a205cc0$var$ReactDOMSharedInternals.p;
            $8e07a5888a205cc0$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $8e07a5888a205cc0$var$executionContext;
            $8e07a5888a205cc0$var$executionContext |= 4;
            try {
                $8e07a5888a205cc0$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $8e07a5888a205cc0$var$executionContext = prevExecutionContext, $8e07a5888a205cc0$var$ReactDOMSharedInternals.p = previousPriority, $8e07a5888a205cc0$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $8e07a5888a205cc0$var$pendingEffectsStatus = 3;
    }
}
function $8e07a5888a205cc0$var$flushSpawnedWork() {
    if (4 === $8e07a5888a205cc0$var$pendingEffectsStatus || 3 === $8e07a5888a205cc0$var$pendingEffectsStatus) {
        $8e07a5888a205cc0$var$pendingEffectsStatus = 0;
        var committedViewTransition = $8e07a5888a205cc0$var$pendingViewTransition;
        $8e07a5888a205cc0$var$pendingViewTransition = null;
        $8e07a5888a205cc0$var$requestPaint();
        var root = $8e07a5888a205cc0$var$pendingEffectsRoot, finishedWork = $8e07a5888a205cc0$var$pendingFinishedWork, lanes = $8e07a5888a205cc0$var$pendingEffectsLanes, recoverableErrors = $8e07a5888a205cc0$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $8e07a5888a205cc0$var$pendingEffectsStatus = 5 : ($8e07a5888a205cc0$var$pendingEffectsStatus = 0, $8e07a5888a205cc0$var$pendingFinishedWork = $8e07a5888a205cc0$var$pendingEffectsRoot = null, $8e07a5888a205cc0$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($8e07a5888a205cc0$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $8e07a5888a205cc0$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($8e07a5888a205cc0$var$injectedHook && "function" === typeof $8e07a5888a205cc0$var$injectedHook.onCommitFiberRoot) try {
            $8e07a5888a205cc0$var$injectedHook.onCommitFiberRoot($8e07a5888a205cc0$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $8e07a5888a205cc0$var$ReactSharedInternals.T;
            passiveSubtreeMask = $8e07a5888a205cc0$var$ReactDOMSharedInternals.p;
            $8e07a5888a205cc0$var$ReactDOMSharedInternals.p = 2;
            $8e07a5888a205cc0$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $8e07a5888a205cc0$var$ReactSharedInternals.T = finishedWork, $8e07a5888a205cc0$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $8e07a5888a205cc0$var$pendingViewTransitionEvents;
        onRecoverableError = $8e07a5888a205cc0$var$pendingTransitionTypes;
        $8e07a5888a205cc0$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($8e07a5888a205cc0$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($8e07a5888a205cc0$var$pendingEffectsLanes & 3) && $8e07a5888a205cc0$var$flushPendingEffects();
        $8e07a5888a205cc0$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $8e07a5888a205cc0$var$rootWithNestedUpdates ? $8e07a5888a205cc0$var$nestedUpdateCount++ : ($8e07a5888a205cc0$var$nestedUpdateCount = 0, $8e07a5888a205cc0$var$rootWithNestedUpdates = root) : ($8e07a5888a205cc0$var$nestedUpdateCount = 0, $8e07a5888a205cc0$var$rootWithNestedUpdates = null);
        $8e07a5888a205cc0$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $8e07a5888a205cc0$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $8e07a5888a205cc0$var$releaseCache(remainingLanes)));
}
function $8e07a5888a205cc0$var$flushPendingEffects() {
    null !== $8e07a5888a205cc0$var$pendingViewTransition && ($8e07a5888a205cc0$var$pendingViewTransition.skipTransition(), $8e07a5888a205cc0$var$pendingViewTransition = null);
    $8e07a5888a205cc0$var$flushMutationEffects();
    $8e07a5888a205cc0$var$flushLayoutEffects();
    $8e07a5888a205cc0$var$flushSpawnedWork();
    return $8e07a5888a205cc0$var$flushPassiveEffects();
}
function $8e07a5888a205cc0$var$flushPassiveEffects() {
    if (5 !== $8e07a5888a205cc0$var$pendingEffectsStatus) return !1;
    var root = $8e07a5888a205cc0$var$pendingEffectsRoot, remainingLanes = $8e07a5888a205cc0$var$pendingEffectsRemainingLanes;
    $8e07a5888a205cc0$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $8e07a5888a205cc0$var$lanesToEventPriority($8e07a5888a205cc0$var$pendingEffectsLanes), prevTransition = $8e07a5888a205cc0$var$ReactSharedInternals.T, previousPriority = $8e07a5888a205cc0$var$ReactDOMSharedInternals.p;
    try {
        $8e07a5888a205cc0$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $8e07a5888a205cc0$var$ReactSharedInternals.T = null;
        renderPriority = $8e07a5888a205cc0$var$pendingPassiveTransitions;
        $8e07a5888a205cc0$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $8e07a5888a205cc0$var$pendingEffectsRoot, lanes = $8e07a5888a205cc0$var$pendingEffectsLanes;
        $8e07a5888a205cc0$var$pendingEffectsStatus = 0;
        $8e07a5888a205cc0$var$pendingFinishedWork = $8e07a5888a205cc0$var$pendingEffectsRoot = null;
        $8e07a5888a205cc0$var$pendingEffectsLanes = 0;
        if (0 !== ($8e07a5888a205cc0$var$executionContext & 6)) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(331));
        var prevExecutionContext = $8e07a5888a205cc0$var$executionContext;
        $8e07a5888a205cc0$var$executionContext |= 4;
        $8e07a5888a205cc0$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $8e07a5888a205cc0$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $8e07a5888a205cc0$var$executionContext = prevExecutionContext;
        $8e07a5888a205cc0$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($8e07a5888a205cc0$var$injectedHook && "function" === typeof $8e07a5888a205cc0$var$injectedHook.onPostCommitFiberRoot) try {
            $8e07a5888a205cc0$var$injectedHook.onPostCommitFiberRoot($8e07a5888a205cc0$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $8e07a5888a205cc0$var$ReactDOMSharedInternals.p = previousPriority, $8e07a5888a205cc0$var$ReactSharedInternals.T = prevTransition, $8e07a5888a205cc0$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $8e07a5888a205cc0$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $8e07a5888a205cc0$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $8e07a5888a205cc0$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $8e07a5888a205cc0$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($8e07a5888a205cc0$var$markRootUpdated$1(rootFiber, 2), $8e07a5888a205cc0$var$ensureRootIsScheduled(rootFiber));
}
function $8e07a5888a205cc0$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $8e07a5888a205cc0$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $8e07a5888a205cc0$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $8e07a5888a205cc0$var$legacyErrorBoundariesThatAlreadyFailed || !$8e07a5888a205cc0$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $8e07a5888a205cc0$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $8e07a5888a205cc0$var$createClassErrorUpdate(2);
                instance = $8e07a5888a205cc0$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($8e07a5888a205cc0$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $8e07a5888a205cc0$var$markRootUpdated$1(instance, 2), $8e07a5888a205cc0$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $8e07a5888a205cc0$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $8e07a5888a205cc0$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($8e07a5888a205cc0$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $8e07a5888a205cc0$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $8e07a5888a205cc0$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $8e07a5888a205cc0$var$workInProgressRoot === root && ($8e07a5888a205cc0$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $8e07a5888a205cc0$var$workInProgressRootExitStatus || 3 === $8e07a5888a205cc0$var$workInProgressRootExitStatus && ($8e07a5888a205cc0$var$workInProgressRootRenderLanes & 62914560) === $8e07a5888a205cc0$var$workInProgressRootRenderLanes && 300 > $8e07a5888a205cc0$var$now() - $8e07a5888a205cc0$var$globalMostRecentFallbackTime ? 0 === ($8e07a5888a205cc0$var$executionContext & 2) ? $8e07a5888a205cc0$var$prepareFreshStack(root, 0) : $8e07a5888a205cc0$var$workInProgressRootPingedLanes |= pingedLanes : $8e07a5888a205cc0$var$workInProgressRootPingedLanes |= pingedLanes, $8e07a5888a205cc0$var$workInProgressSuspendedRetryLanes === $8e07a5888a205cc0$var$workInProgressRootRenderLanes && ($8e07a5888a205cc0$var$workInProgressSuspendedRetryLanes = 0));
    $8e07a5888a205cc0$var$ensureRootIsScheduled(root);
}
function $8e07a5888a205cc0$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $8e07a5888a205cc0$var$claimNextRetryLane());
    boundaryFiber = $8e07a5888a205cc0$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($8e07a5888a205cc0$var$markRootUpdated$1(boundaryFiber, retryLane), $8e07a5888a205cc0$var$ensureRootIsScheduled(boundaryFiber));
}
function $8e07a5888a205cc0$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $8e07a5888a205cc0$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $8e07a5888a205cc0$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $8e07a5888a205cc0$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $8e07a5888a205cc0$var$scheduleCallback$1(priorityLevel, callback) {
    return $8e07a5888a205cc0$var$scheduleCallback$3(priorityLevel, callback);
}
var $8e07a5888a205cc0$var$firstScheduledRoot = null, $8e07a5888a205cc0$var$lastScheduledRoot = null, $8e07a5888a205cc0$var$didScheduleMicrotask = !1, $8e07a5888a205cc0$var$mightHavePendingSyncWork = !1, $8e07a5888a205cc0$var$isFlushingWork = !1, $8e07a5888a205cc0$var$currentEventTransitionLane = 0;
function $8e07a5888a205cc0$var$ensureRootIsScheduled(root) {
    root !== $8e07a5888a205cc0$var$lastScheduledRoot && null === root.next && (null === $8e07a5888a205cc0$var$lastScheduledRoot ? $8e07a5888a205cc0$var$firstScheduledRoot = $8e07a5888a205cc0$var$lastScheduledRoot = root : $8e07a5888a205cc0$var$lastScheduledRoot = $8e07a5888a205cc0$var$lastScheduledRoot.next = root);
    $8e07a5888a205cc0$var$mightHavePendingSyncWork = !0;
    $8e07a5888a205cc0$var$didScheduleMicrotask || ($8e07a5888a205cc0$var$didScheduleMicrotask = !0, $8e07a5888a205cc0$var$scheduleImmediateRootScheduleTask());
}
function $8e07a5888a205cc0$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$8e07a5888a205cc0$var$isFlushingWork && $8e07a5888a205cc0$var$mightHavePendingSyncWork) {
        $8e07a5888a205cc0$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $8e07a5888a205cc0$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $8e07a5888a205cc0$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $8e07a5888a205cc0$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $8e07a5888a205cc0$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $8e07a5888a205cc0$var$getNextLanes(root$190, root$190 === $8e07a5888a205cc0$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $8e07a5888a205cc0$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $8e07a5888a205cc0$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $8e07a5888a205cc0$var$isFlushingWork = !1;
    }
}
function $8e07a5888a205cc0$var$processRootScheduleInImmediateTask() {
    $8e07a5888a205cc0$var$processRootScheduleInMicrotask();
}
function $8e07a5888a205cc0$var$processRootScheduleInMicrotask() {
    $8e07a5888a205cc0$var$mightHavePendingSyncWork = $8e07a5888a205cc0$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $8e07a5888a205cc0$var$currentEventTransitionLane && $8e07a5888a205cc0$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $8e07a5888a205cc0$var$currentEventTransitionLane);
    for(var currentTime = $8e07a5888a205cc0$var$now(), prev = null, root = $8e07a5888a205cc0$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $8e07a5888a205cc0$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $8e07a5888a205cc0$var$firstScheduledRoot = next : prev.next = next, null === next && ($8e07a5888a205cc0$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $8e07a5888a205cc0$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $8e07a5888a205cc0$var$pendingEffectsStatus && 5 !== $8e07a5888a205cc0$var$pendingEffectsStatus || $8e07a5888a205cc0$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $8e07a5888a205cc0$var$currentEventTransitionLane && ($8e07a5888a205cc0$var$currentEventTransitionLane = 0);
}
function $8e07a5888a205cc0$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $8e07a5888a205cc0$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $8e07a5888a205cc0$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $8e07a5888a205cc0$var$workInProgressRoot;
    suspendedLanes = $8e07a5888a205cc0$var$workInProgressRootRenderLanes;
    suspendedLanes = $8e07a5888a205cc0$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $8e07a5888a205cc0$var$workInProgressSuspendedReason || 9 === $8e07a5888a205cc0$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $8e07a5888a205cc0$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $8e07a5888a205cc0$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $8e07a5888a205cc0$var$cancelCallback$1(pingedLanes);
        switch($8e07a5888a205cc0$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $8e07a5888a205cc0$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $8e07a5888a205cc0$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $8e07a5888a205cc0$var$IdlePriority;
                break;
            default:
                suspendedLanes = $8e07a5888a205cc0$var$NormalPriority$1;
        }
        pingedLanes = $8e07a5888a205cc0$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $8e07a5888a205cc0$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $8e07a5888a205cc0$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $8e07a5888a205cc0$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $8e07a5888a205cc0$var$pendingEffectsStatus && 5 !== $8e07a5888a205cc0$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($8e07a5888a205cc0$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $8e07a5888a205cc0$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $8e07a5888a205cc0$var$getNextLanes(root, root === $8e07a5888a205cc0$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $8e07a5888a205cc0$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $8e07a5888a205cc0$var$scheduleTaskForRootDuringMicrotask(root, $8e07a5888a205cc0$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $8e07a5888a205cc0$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $8e07a5888a205cc0$var$performSyncWorkOnRoot(root, lanes) {
    if ($8e07a5888a205cc0$var$flushPendingEffects()) return null;
    $8e07a5888a205cc0$var$performWorkOnRoot(root, lanes, !0);
}
function $8e07a5888a205cc0$var$scheduleImmediateRootScheduleTask() {
    $8e07a5888a205cc0$var$scheduleMicrotask(function() {
        0 !== ($8e07a5888a205cc0$var$executionContext & 6) ? $8e07a5888a205cc0$var$scheduleCallback$3($8e07a5888a205cc0$var$ImmediatePriority, $8e07a5888a205cc0$var$processRootScheduleInImmediateTask) : $8e07a5888a205cc0$var$processRootScheduleInMicrotask();
    });
}
function $8e07a5888a205cc0$var$requestTransitionLane() {
    if (0 === $8e07a5888a205cc0$var$currentEventTransitionLane) {
        var actionScopeLane = $8e07a5888a205cc0$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $8e07a5888a205cc0$var$nextTransitionUpdateLane, $8e07a5888a205cc0$var$nextTransitionUpdateLane <<= 1, 0 === ($8e07a5888a205cc0$var$nextTransitionUpdateLane & 261888) && ($8e07a5888a205cc0$var$nextTransitionUpdateLane = 256));
        $8e07a5888a205cc0$var$currentEventTransitionLane = actionScopeLane;
    }
    return $8e07a5888a205cc0$var$currentEventTransitionLane;
}
function $8e07a5888a205cc0$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $8e07a5888a205cc0$var$sanitizeURL(actionProp);
}
function $8e07a5888a205cc0$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $8e07a5888a205cc0$var$coerceFormActionProp((nativeEventTarget[$8e07a5888a205cc0$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$8e07a5888a205cc0$var$internalPropsKey] || null) ? $8e07a5888a205cc0$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $8e07a5888a205cc0$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $8e07a5888a205cc0$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $8e07a5888a205cc0$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $8e07a5888a205cc0$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $8e07a5888a205cc0$var$i$jscomp$inline_1667 = 0; $8e07a5888a205cc0$var$i$jscomp$inline_1667 < $8e07a5888a205cc0$var$simpleEventPluginEvents.length; $8e07a5888a205cc0$var$i$jscomp$inline_1667++){
    var $8e07a5888a205cc0$var$eventName$jscomp$inline_1668 = $8e07a5888a205cc0$var$simpleEventPluginEvents[$8e07a5888a205cc0$var$i$jscomp$inline_1667], $8e07a5888a205cc0$var$domEventName$jscomp$inline_1669 = $8e07a5888a205cc0$var$eventName$jscomp$inline_1668.toLowerCase(), $8e07a5888a205cc0$var$capitalizedEvent$jscomp$inline_1670 = $8e07a5888a205cc0$var$eventName$jscomp$inline_1668[0].toUpperCase() + $8e07a5888a205cc0$var$eventName$jscomp$inline_1668.slice(1);
    $8e07a5888a205cc0$var$registerSimpleEvent($8e07a5888a205cc0$var$domEventName$jscomp$inline_1669, "on" + $8e07a5888a205cc0$var$capitalizedEvent$jscomp$inline_1670);
}
$8e07a5888a205cc0$var$registerSimpleEvent($8e07a5888a205cc0$var$ANIMATION_END, "onAnimationEnd");
$8e07a5888a205cc0$var$registerSimpleEvent($8e07a5888a205cc0$var$ANIMATION_ITERATION, "onAnimationIteration");
$8e07a5888a205cc0$var$registerSimpleEvent($8e07a5888a205cc0$var$ANIMATION_START, "onAnimationStart");
$8e07a5888a205cc0$var$registerSimpleEvent("dblclick", "onDoubleClick");
$8e07a5888a205cc0$var$registerSimpleEvent("focusin", "onFocus");
$8e07a5888a205cc0$var$registerSimpleEvent("focusout", "onBlur");
$8e07a5888a205cc0$var$registerSimpleEvent($8e07a5888a205cc0$var$TRANSITION_RUN, "onTransitionRun");
$8e07a5888a205cc0$var$registerSimpleEvent($8e07a5888a205cc0$var$TRANSITION_START, "onTransitionStart");
$8e07a5888a205cc0$var$registerSimpleEvent($8e07a5888a205cc0$var$TRANSITION_CANCEL, "onTransitionCancel");
$8e07a5888a205cc0$var$registerSimpleEvent($8e07a5888a205cc0$var$TRANSITION_END, "onTransitionEnd");
$8e07a5888a205cc0$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$8e07a5888a205cc0$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$8e07a5888a205cc0$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$8e07a5888a205cc0$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$8e07a5888a205cc0$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$8e07a5888a205cc0$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$8e07a5888a205cc0$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$8e07a5888a205cc0$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$8e07a5888a205cc0$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$8e07a5888a205cc0$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $8e07a5888a205cc0$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $8e07a5888a205cc0$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($8e07a5888a205cc0$var$mediaEventTypes));
function $8e07a5888a205cc0$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $8e07a5888a205cc0$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $8e07a5888a205cc0$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $8e07a5888a205cc0$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$8e07a5888a205cc0$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$8e07a5888a205cc0$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($8e07a5888a205cc0$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $8e07a5888a205cc0$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $8e07a5888a205cc0$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $8e07a5888a205cc0$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $8e07a5888a205cc0$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$8e07a5888a205cc0$var$listeningMarker]) {
        rootContainerElement[$8e07a5888a205cc0$var$listeningMarker] = !0;
        $8e07a5888a205cc0$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($8e07a5888a205cc0$var$nonDelegatedEvents.has(domEventName) || $8e07a5888a205cc0$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $8e07a5888a205cc0$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$8e07a5888a205cc0$var$listeningMarker] || (ownerDocument[$8e07a5888a205cc0$var$listeningMarker] = !0, $8e07a5888a205cc0$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $8e07a5888a205cc0$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($8e07a5888a205cc0$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $8e07a5888a205cc0$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $8e07a5888a205cc0$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $8e07a5888a205cc0$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$8e07a5888a205cc0$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $8e07a5888a205cc0$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $8e07a5888a205cc0$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $8e07a5888a205cc0$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $8e07a5888a205cc0$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $8e07a5888a205cc0$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $8e07a5888a205cc0$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $8e07a5888a205cc0$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $8e07a5888a205cc0$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $8e07a5888a205cc0$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $8e07a5888a205cc0$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $8e07a5888a205cc0$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $8e07a5888a205cc0$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $8e07a5888a205cc0$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $8e07a5888a205cc0$var$SyntheticTouchEvent;
                        break;
                    case $8e07a5888a205cc0$var$ANIMATION_END:
                    case $8e07a5888a205cc0$var$ANIMATION_ITERATION:
                    case $8e07a5888a205cc0$var$ANIMATION_START:
                        SyntheticEventCtor = $8e07a5888a205cc0$var$SyntheticAnimationEvent;
                        break;
                    case $8e07a5888a205cc0$var$TRANSITION_END:
                        SyntheticEventCtor = $8e07a5888a205cc0$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $8e07a5888a205cc0$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $8e07a5888a205cc0$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $8e07a5888a205cc0$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $8e07a5888a205cc0$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $8e07a5888a205cc0$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $8e07a5888a205cc0$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $8e07a5888a205cc0$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($8e07a5888a205cc0$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $8e07a5888a205cc0$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($8e07a5888a205cc0$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$8e07a5888a205cc0$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $8e07a5888a205cc0$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $8e07a5888a205cc0$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $8e07a5888a205cc0$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $8e07a5888a205cc0$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $8e07a5888a205cc0$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $8e07a5888a205cc0$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $8e07a5888a205cc0$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $8e07a5888a205cc0$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $8e07a5888a205cc0$var$getParent) : null;
                        null !== reactName && $8e07a5888a205cc0$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $8e07a5888a205cc0$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $8e07a5888a205cc0$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $8e07a5888a205cc0$var$getTargetInstForChangeEvent;
                else if ($8e07a5888a205cc0$var$isTextInputElement(reactName)) {
                    if ($8e07a5888a205cc0$var$isInputEventSupported) getTargetInstFunc = $8e07a5888a205cc0$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $8e07a5888a205cc0$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $8e07a5888a205cc0$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $8e07a5888a205cc0$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $8e07a5888a205cc0$var$getTargetInstForChangeEvent) : getTargetInstFunc = $8e07a5888a205cc0$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $8e07a5888a205cc0$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $8e07a5888a205cc0$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($8e07a5888a205cc0$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $8e07a5888a205cc0$var$activeElement = handleEventFunc, $8e07a5888a205cc0$var$activeElementInst = targetInst, $8e07a5888a205cc0$var$lastSelection = null;
                    break;
                case "focusout":
                    $8e07a5888a205cc0$var$lastSelection = $8e07a5888a205cc0$var$activeElementInst = $8e07a5888a205cc0$var$activeElement = null;
                    break;
                case "mousedown":
                    $8e07a5888a205cc0$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $8e07a5888a205cc0$var$mouseDown = !1;
                    $8e07a5888a205cc0$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($8e07a5888a205cc0$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $8e07a5888a205cc0$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($8e07a5888a205cc0$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $8e07a5888a205cc0$var$isComposing ? $8e07a5888a205cc0$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($8e07a5888a205cc0$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($8e07a5888a205cc0$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $8e07a5888a205cc0$var$isComposing && (fallbackData = $8e07a5888a205cc0$var$getData()) : ($8e07a5888a205cc0$var$root = nativeEventTarget, $8e07a5888a205cc0$var$startText = "value" in $8e07a5888a205cc0$var$root ? $8e07a5888a205cc0$var$root.value : $8e07a5888a205cc0$var$root.textContent, $8e07a5888a205cc0$var$isComposing = !0)), handleEventFunc = $8e07a5888a205cc0$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $8e07a5888a205cc0$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $8e07a5888a205cc0$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $8e07a5888a205cc0$var$canUseTextInputEvent ? $8e07a5888a205cc0$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $8e07a5888a205cc0$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $8e07a5888a205cc0$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $8e07a5888a205cc0$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $8e07a5888a205cc0$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $8e07a5888a205cc0$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $8e07a5888a205cc0$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $8e07a5888a205cc0$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $8e07a5888a205cc0$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($8e07a5888a205cc0$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $8e07a5888a205cc0$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($8e07a5888a205cc0$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $8e07a5888a205cc0$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $8e07a5888a205cc0$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $8e07a5888a205cc0$var$getListener(target, registrationName), null != stateNode && listeners.unshift($8e07a5888a205cc0$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $8e07a5888a205cc0$var$getListener(target, registrationName), null != stateNode && listeners.push($8e07a5888a205cc0$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $8e07a5888a205cc0$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $8e07a5888a205cc0$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $8e07a5888a205cc0$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($8e07a5888a205cc0$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($8e07a5888a205cc0$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $8e07a5888a205cc0$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $8e07a5888a205cc0$var$normalizeMarkupForTextOrAttribute(clientText);
    return $8e07a5888a205cc0$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $8e07a5888a205cc0$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $8e07a5888a205cc0$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $8e07a5888a205cc0$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $8e07a5888a205cc0$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $8e07a5888a205cc0$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $8e07a5888a205cc0$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $8e07a5888a205cc0$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $8e07a5888a205cc0$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $8e07a5888a205cc0$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $8e07a5888a205cc0$var$setProp(domElement, tag, "name", props.name, props, null), $8e07a5888a205cc0$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $8e07a5888a205cc0$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $8e07a5888a205cc0$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($8e07a5888a205cc0$var$setProp(domElement, tag, "encType", props.encType, props, null), $8e07a5888a205cc0$var$setProp(domElement, tag, "method", props.method, props, null), $8e07a5888a205cc0$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $8e07a5888a205cc0$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $8e07a5888a205cc0$var$noop$1);
            return;
        case "onScroll":
            null != value && $8e07a5888a205cc0$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $8e07a5888a205cc0$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $8e07a5888a205cc0$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("toggle", domElement);
            $8e07a5888a205cc0$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $8e07a5888a205cc0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $8e07a5888a205cc0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $8e07a5888a205cc0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $8e07a5888a205cc0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $8e07a5888a205cc0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $8e07a5888a205cc0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $8e07a5888a205cc0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $8e07a5888a205cc0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $8e07a5888a205cc0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $8e07a5888a205cc0$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $8e07a5888a205cc0$var$aliases.get(key) || key, $8e07a5888a205cc0$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $8e07a5888a205cc0$var$viewTransitionMutationContext = !0;
}
function $8e07a5888a205cc0$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $8e07a5888a205cc0$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $8e07a5888a205cc0$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $8e07a5888a205cc0$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $8e07a5888a205cc0$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $8e07a5888a205cc0$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $8e07a5888a205cc0$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$8e07a5888a205cc0$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$8e07a5888a205cc0$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $8e07a5888a205cc0$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $8e07a5888a205cc0$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $8e07a5888a205cc0$var$viewTransitionMutationContext = !0;
}
function $8e07a5888a205cc0$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("error", domElement);
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(137, tag));
                    default:
                        $8e07a5888a205cc0$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $8e07a5888a205cc0$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $8e07a5888a205cc0$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $8e07a5888a205cc0$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $8e07a5888a205cc0$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $8e07a5888a205cc0$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $8e07a5888a205cc0$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $8e07a5888a205cc0$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(91));
                    break;
                default:
                    $8e07a5888a205cc0$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $8e07a5888a205cc0$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $8e07a5888a205cc0$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("toggle", domElement);
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("cancel", domElement);
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $8e07a5888a205cc0$var$mediaEventTypes.length; hasSrc++)$8e07a5888a205cc0$var$listenToNonDelegatedEvent($8e07a5888a205cc0$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("error", domElement);
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $8e07a5888a205cc0$var$listenToNonDelegatedEvent("error", domElement), $8e07a5888a205cc0$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(137, tag));
                default:
                    $8e07a5888a205cc0$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($8e07a5888a205cc0$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $8e07a5888a205cc0$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $8e07a5888a205cc0$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $8e07a5888a205cc0$var$emptyProps = {};
function $8e07a5888a205cc0$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $8e07a5888a205cc0$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($8e07a5888a205cc0$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($8e07a5888a205cc0$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($8e07a5888a205cc0$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($8e07a5888a205cc0$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($8e07a5888a205cc0$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($8e07a5888a205cc0$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $8e07a5888a205cc0$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $8e07a5888a205cc0$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $8e07a5888a205cc0$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($8e07a5888a205cc0$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($8e07a5888a205cc0$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($8e07a5888a205cc0$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $8e07a5888a205cc0$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $8e07a5888a205cc0$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $8e07a5888a205cc0$var$updateOptions(domElement, !!lastProps, tag, !0) : $8e07a5888a205cc0$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $8e07a5888a205cc0$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($8e07a5888a205cc0$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($8e07a5888a205cc0$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $8e07a5888a205cc0$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $8e07a5888a205cc0$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $8e07a5888a205cc0$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($8e07a5888a205cc0$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $8e07a5888a205cc0$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $8e07a5888a205cc0$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $8e07a5888a205cc0$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($8e07a5888a205cc0$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $8e07a5888a205cc0$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $8e07a5888a205cc0$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $8e07a5888a205cc0$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $8e07a5888a205cc0$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $8e07a5888a205cc0$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $8e07a5888a205cc0$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $8e07a5888a205cc0$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $8e07a5888a205cc0$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $8e07a5888a205cc0$var$eventsEnabled = null, $8e07a5888a205cc0$var$selectionInformation = null;
function $8e07a5888a205cc0$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $8e07a5888a205cc0$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $8e07a5888a205cc0$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $8e07a5888a205cc0$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $8e07a5888a205cc0$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$8e07a5888a205cc0$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$8e07a5888a205cc0$var$internalPropsKey] = props;
    $8e07a5888a205cc0$var$setInitialProperties(rootContainerInstance, type, props);
    $8e07a5888a205cc0$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $8e07a5888a205cc0$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $8e07a5888a205cc0$var$currentPopstateTransitionEvent = null;
function $8e07a5888a205cc0$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $8e07a5888a205cc0$var$currentPopstateTransitionEvent) return !1;
        $8e07a5888a205cc0$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $8e07a5888a205cc0$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $8e07a5888a205cc0$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $8e07a5888a205cc0$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $8e07a5888a205cc0$var$localPromise = "function" === typeof Promise ? Promise : void 0, $8e07a5888a205cc0$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $8e07a5888a205cc0$var$scheduleTimeout, $8e07a5888a205cc0$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $8e07a5888a205cc0$var$localPromise ? function(callback) {
    return $8e07a5888a205cc0$var$localPromise.resolve(null).then(callback).catch($8e07a5888a205cc0$var$handleErrorInNextTick);
} : $8e07a5888a205cc0$var$scheduleTimeout;
function $8e07a5888a205cc0$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $8e07a5888a205cc0$var$isSingletonScope(type) {
    return "head" === type;
}
function $8e07a5888a205cc0$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $8e07a5888a205cc0$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $8e07a5888a205cc0$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $8e07a5888a205cc0$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$8e07a5888a205cc0$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $8e07a5888a205cc0$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $8e07a5888a205cc0$var$retryIfBlockedOn(hydrationInstance);
}
function $8e07a5888a205cc0$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $8e07a5888a205cc0$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $8e07a5888a205cc0$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $8e07a5888a205cc0$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $8e07a5888a205cc0$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $8e07a5888a205cc0$var$createMeasurement(rect, computedStyle, instance);
}
function $8e07a5888a205cc0$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $8e07a5888a205cc0$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $8e07a5888a205cc0$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $8e07a5888a205cc0$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $8e07a5888a205cc0$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($8e07a5888a205cc0$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $8e07a5888a205cc0$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $8e07a5888a205cc0$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($8e07a5888a205cc0$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $8e07a5888a205cc0$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$8e07a5888a205cc0$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $8e07a5888a205cc0$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$8e07a5888a205cc0$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$8e07a5888a205cc0$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $8e07a5888a205cc0$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $8e07a5888a205cc0$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $8e07a5888a205cc0$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $8e07a5888a205cc0$var$ViewTransitionPseudoElement("old", name),
        new: new $8e07a5888a205cc0$var$ViewTransitionPseudoElement("new", name)
    };
}
function $8e07a5888a205cc0$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$8e07a5888a205cc0$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $8e07a5888a205cc0$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $8e07a5888a205cc0$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $8e07a5888a205cc0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $8e07a5888a205cc0$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $8e07a5888a205cc0$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $8e07a5888a205cc0$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$8e07a5888a205cc0$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $8e07a5888a205cc0$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $8e07a5888a205cc0$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $8e07a5888a205cc0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $8e07a5888a205cc0$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $8e07a5888a205cc0$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $8e07a5888a205cc0$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $8e07a5888a205cc0$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $8e07a5888a205cc0$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $8e07a5888a205cc0$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $8e07a5888a205cc0$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $8e07a5888a205cc0$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$8e07a5888a205cc0$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $8e07a5888a205cc0$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $8e07a5888a205cc0$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $8e07a5888a205cc0$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $8e07a5888a205cc0$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$8e07a5888a205cc0$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $8e07a5888a205cc0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $8e07a5888a205cc0$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $8e07a5888a205cc0$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $8e07a5888a205cc0$var$getInstanceFromHostFiber(fiber);
    return $8e07a5888a205cc0$var$setFocusIfFocusable(fiber, focusOptions);
}
$8e07a5888a205cc0$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $8e07a5888a205cc0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $8e07a5888a205cc0$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$8e07a5888a205cc0$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $8e07a5888a205cc0$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$8e07a5888a205cc0$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $8e07a5888a205cc0$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $8e07a5888a205cc0$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $8e07a5888a205cc0$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $8e07a5888a205cc0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $8e07a5888a205cc0$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $8e07a5888a205cc0$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $8e07a5888a205cc0$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$8e07a5888a205cc0$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $8e07a5888a205cc0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $8e07a5888a205cc0$var$observeChild, observer, void 0, void 0);
};
function $8e07a5888a205cc0$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $8e07a5888a205cc0$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$8e07a5888a205cc0$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $8e07a5888a205cc0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $8e07a5888a205cc0$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $8e07a5888a205cc0$var$pendingIntersectionUnobserves.length; i++){
            var pending = $8e07a5888a205cc0$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $8e07a5888a205cc0$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $8e07a5888a205cc0$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $8e07a5888a205cc0$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $8e07a5888a205cc0$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $8e07a5888a205cc0$var$pendingIntersectionUnobserves = [], $8e07a5888a205cc0$var$intersectionUnobserveScheduled = !1;
function $8e07a5888a205cc0$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $8e07a5888a205cc0$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $8e07a5888a205cc0$var$intersectionUnobserveScheduled || ($8e07a5888a205cc0$var$intersectionUnobserveScheduled = !0, $8e07a5888a205cc0$var$requestPostPaintCallback(function() {
        $8e07a5888a205cc0$var$intersectionUnobserveScheduled = !1;
        var pending = $8e07a5888a205cc0$var$pendingIntersectionUnobserves;
        $8e07a5888a205cc0$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$8e07a5888a205cc0$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $8e07a5888a205cc0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $8e07a5888a205cc0$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $8e07a5888a205cc0$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $8e07a5888a205cc0$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$8e07a5888a205cc0$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $8e07a5888a205cc0$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $8e07a5888a205cc0$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$8e07a5888a205cc0$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $8e07a5888a205cc0$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $8e07a5888a205cc0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $8e07a5888a205cc0$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $8e07a5888a205cc0$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($8e07a5888a205cc0$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $8e07a5888a205cc0$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $8e07a5888a205cc0$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $8e07a5888a205cc0$var$getInstanceFromHostFiber(children[0]);
    result = $8e07a5888a205cc0$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $8e07a5888a205cc0$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $8e07a5888a205cc0$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $8e07a5888a205cc0$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $8e07a5888a205cc0$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $8e07a5888a205cc0$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $8e07a5888a205cc0$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $8e07a5888a205cc0$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($8e07a5888a205cc0$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $8e07a5888a205cc0$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $8e07a5888a205cc0$var$searchTarget, $8e07a5888a205cc0$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $8e07a5888a205cc0$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $8e07a5888a205cc0$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($8e07a5888a205cc0$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $8e07a5888a205cc0$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $8e07a5888a205cc0$var$searchTarget, $8e07a5888a205cc0$var$searchBoundary = $8e07a5888a205cc0$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $8e07a5888a205cc0$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$8e07a5888a205cc0$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(566));
    var children = [];
    $8e07a5888a205cc0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $8e07a5888a205cc0$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $8e07a5888a205cc0$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $8e07a5888a205cc0$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $8e07a5888a205cc0$var$getInstanceFromHostFiber(hostSiblings);
            $8e07a5888a205cc0$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $8e07a5888a205cc0$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $8e07a5888a205cc0$var$getInstanceFromHostFiber(child), $8e07a5888a205cc0$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $8e07a5888a205cc0$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $8e07a5888a205cc0$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $8e07a5888a205cc0$var$getInstanceFromHostFiber(child);
    $8e07a5888a205cc0$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $8e07a5888a205cc0$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $8e07a5888a205cc0$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $8e07a5888a205cc0$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $8e07a5888a205cc0$var$pendingIntersectionUnobserves.length; i++){
            var pending = $8e07a5888a205cc0$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $8e07a5888a205cc0$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $8e07a5888a205cc0$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $8e07a5888a205cc0$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $8e07a5888a205cc0$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $8e07a5888a205cc0$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $8e07a5888a205cc0$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $8e07a5888a205cc0$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $8e07a5888a205cc0$var$clearContainerSparingly(node);
                $8e07a5888a205cc0$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $8e07a5888a205cc0$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$8e07a5888a205cc0$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $8e07a5888a205cc0$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $8e07a5888a205cc0$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $8e07a5888a205cc0$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $8e07a5888a205cc0$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $8e07a5888a205cc0$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $8e07a5888a205cc0$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $8e07a5888a205cc0$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $8e07a5888a205cc0$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $8e07a5888a205cc0$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $8e07a5888a205cc0$var$previousHydratableOnEnteringScopedSingleton = null;
function $8e07a5888a205cc0$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $8e07a5888a205cc0$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $8e07a5888a205cc0$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $8e07a5888a205cc0$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $8e07a5888a205cc0$var$requestPostPaintCallback(callback) {
    $8e07a5888a205cc0$var$localRequestAnimationFrame(function() {
        $8e07a5888a205cc0$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $8e07a5888a205cc0$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $8e07a5888a205cc0$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(451));
    }
}
function $8e07a5888a205cc0$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $8e07a5888a205cc0$var$setProp(instance, type, propKey, null, $8e07a5888a205cc0$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $8e07a5888a205cc0$var$noop$1 && (instance.onclick = null);
    $8e07a5888a205cc0$var$detachDeletedInstance(instance);
}
function $8e07a5888a205cc0$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $8e07a5888a205cc0$var$detachDeletedInstance(instance);
}
var $8e07a5888a205cc0$var$preloadPropsMap = new Map(), $8e07a5888a205cc0$var$preconnectsSet = new Set();
function $8e07a5888a205cc0$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $8e07a5888a205cc0$var$previousDispatcher = $8e07a5888a205cc0$var$ReactDOMSharedInternals.d;
$8e07a5888a205cc0$var$ReactDOMSharedInternals.d = {
    f: $8e07a5888a205cc0$var$flushSyncWork,
    r: $8e07a5888a205cc0$var$requestFormReset,
    D: $8e07a5888a205cc0$var$prefetchDNS,
    C: $8e07a5888a205cc0$var$preconnect,
    L: $8e07a5888a205cc0$var$preload,
    m: $8e07a5888a205cc0$var$preloadModule,
    X: $8e07a5888a205cc0$var$preinitScript,
    S: $8e07a5888a205cc0$var$preinitStyle,
    M: $8e07a5888a205cc0$var$preinitModuleScript
};
function $8e07a5888a205cc0$var$flushSyncWork() {
    var previousWasRendering = $8e07a5888a205cc0$var$previousDispatcher.f(), wasRendering = $8e07a5888a205cc0$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $8e07a5888a205cc0$var$requestFormReset(form) {
    var formInst = $8e07a5888a205cc0$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $8e07a5888a205cc0$var$requestFormReset$1(formInst) : $8e07a5888a205cc0$var$previousDispatcher.r(form);
}
var $8e07a5888a205cc0$var$globalDocument = "undefined" === typeof document ? null : document;
function $8e07a5888a205cc0$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $8e07a5888a205cc0$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $8e07a5888a205cc0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $8e07a5888a205cc0$var$preconnectsSet.has(limitedEscapedHref) || ($8e07a5888a205cc0$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $8e07a5888a205cc0$var$setInitialProperties(href, "link", rel), $8e07a5888a205cc0$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $8e07a5888a205cc0$var$prefetchDNS(href) {
    $8e07a5888a205cc0$var$previousDispatcher.D(href);
    $8e07a5888a205cc0$var$preconnectAs("dns-prefetch", href, null);
}
function $8e07a5888a205cc0$var$preconnect(href, crossOrigin) {
    $8e07a5888a205cc0$var$previousDispatcher.C(href, crossOrigin);
    $8e07a5888a205cc0$var$preconnectAs("preconnect", href, crossOrigin);
}
function $8e07a5888a205cc0$var$preload(href, as, options) {
    $8e07a5888a205cc0$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $8e07a5888a205cc0$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $8e07a5888a205cc0$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $8e07a5888a205cc0$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $8e07a5888a205cc0$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $8e07a5888a205cc0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $8e07a5888a205cc0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $8e07a5888a205cc0$var$getStyleKey(href);
                break;
            case "script":
                key = $8e07a5888a205cc0$var$getScriptKey(href);
        }
        if (!($8e07a5888a205cc0$var$preloadPropsMap.has(key) || (href = $8e07a5888a205cc0$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $8e07a5888a205cc0$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($8e07a5888a205cc0$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($8e07a5888a205cc0$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $8e07a5888a205cc0$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$8e07a5888a205cc0$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $8e07a5888a205cc0$var$clearPendingLoadOnNode(instance);
            });
            $8e07a5888a205cc0$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $8e07a5888a205cc0$var$preloadModule(href, options) {
    $8e07a5888a205cc0$var$previousDispatcher.m(href, options);
    var ownerDocument = $8e07a5888a205cc0$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $8e07a5888a205cc0$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $8e07a5888a205cc0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $8e07a5888a205cc0$var$getScriptKey(href);
        }
        if (!$8e07a5888a205cc0$var$preloadPropsMap.has(key) && (href = $8e07a5888a205cc0$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $8e07a5888a205cc0$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($8e07a5888a205cc0$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $8e07a5888a205cc0$var$setInitialProperties(as, "link", href);
            $8e07a5888a205cc0$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $8e07a5888a205cc0$var$preinitStyle(href, precedence, options) {
    $8e07a5888a205cc0$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $8e07a5888a205cc0$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $8e07a5888a205cc0$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $8e07a5888a205cc0$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($8e07a5888a205cc0$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $8e07a5888a205cc0$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $8e07a5888a205cc0$var$preloadPropsMap.get(key)) && $8e07a5888a205cc0$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $8e07a5888a205cc0$var$markNodeAsHoistable(link);
                $8e07a5888a205cc0$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $8e07a5888a205cc0$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $8e07a5888a205cc0$var$preinitScript(src, options) {
    $8e07a5888a205cc0$var$previousDispatcher.X(src, options);
    var ownerDocument = $8e07a5888a205cc0$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $8e07a5888a205cc0$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $8e07a5888a205cc0$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($8e07a5888a205cc0$var$getScriptSelectorFromKey(key)), resource || (src = $8e07a5888a205cc0$var$assign({
            src: src,
            async: !0
        }, options), (options = $8e07a5888a205cc0$var$preloadPropsMap.get(key)) && $8e07a5888a205cc0$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $8e07a5888a205cc0$var$markNodeAsHoistable(resource), $8e07a5888a205cc0$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $8e07a5888a205cc0$var$preinitModuleScript(src, options) {
    $8e07a5888a205cc0$var$previousDispatcher.M(src, options);
    var ownerDocument = $8e07a5888a205cc0$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $8e07a5888a205cc0$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $8e07a5888a205cc0$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($8e07a5888a205cc0$var$getScriptSelectorFromKey(key)), resource || (src = $8e07a5888a205cc0$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $8e07a5888a205cc0$var$preloadPropsMap.get(key)) && $8e07a5888a205cc0$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $8e07a5888a205cc0$var$markNodeAsHoistable(resource), $8e07a5888a205cc0$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $8e07a5888a205cc0$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $8e07a5888a205cc0$var$rootInstanceStackCursor.current) ? $8e07a5888a205cc0$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $8e07a5888a205cc0$var$getStyleKey(pendingProps.href), currentProps = $8e07a5888a205cc0$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $8e07a5888a205cc0$var$getStyleKey(pendingProps.href);
                var styles$268 = $8e07a5888a205cc0$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($8e07a5888a205cc0$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $8e07a5888a205cc0$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $8e07a5888a205cc0$var$preloadPropsMap.set(type, styles$268)), $8e07a5888a205cc0$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $8e07a5888a205cc0$var$getScriptKey(pendingProps), currentProps = $8e07a5888a205cc0$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(444, type));
    }
}
function $8e07a5888a205cc0$var$getStyleKey(href) {
    return 'href="' + $8e07a5888a205cc0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $8e07a5888a205cc0$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $8e07a5888a205cc0$var$stylesheetPropsFromRawProps(rawProps) {
    return $8e07a5888a205cc0$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $8e07a5888a205cc0$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$8e07a5888a205cc0$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$8e07a5888a205cc0$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $8e07a5888a205cc0$var$clearPendingLoadOnNode.bind(null, key), $8e07a5888a205cc0$var$setInitialProperties(key, "link", preloadProps), $8e07a5888a205cc0$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $8e07a5888a205cc0$var$getScriptKey(src) {
    return '[src="' + $8e07a5888a205cc0$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $8e07a5888a205cc0$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $8e07a5888a205cc0$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $8e07a5888a205cc0$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $8e07a5888a205cc0$var$markNodeAsHoistable(instance), instance;
            var styleProps = $8e07a5888a205cc0$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $8e07a5888a205cc0$var$markNodeAsHoistable(instance);
            $8e07a5888a205cc0$var$setInitialProperties(instance, "style", styleProps);
            $8e07a5888a205cc0$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $8e07a5888a205cc0$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($8e07a5888a205cc0$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $8e07a5888a205cc0$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $8e07a5888a205cc0$var$stylesheetPropsFromRawProps(props);
            (styleProps = $8e07a5888a205cc0$var$preloadPropsMap.get(styleProps)) && $8e07a5888a205cc0$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $8e07a5888a205cc0$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $8e07a5888a205cc0$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $8e07a5888a205cc0$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $8e07a5888a205cc0$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($8e07a5888a205cc0$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $8e07a5888a205cc0$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $8e07a5888a205cc0$var$preloadPropsMap.get(instance$274)) instance = $8e07a5888a205cc0$var$assign({}, props), $8e07a5888a205cc0$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $8e07a5888a205cc0$var$markNodeAsHoistable(styleProps);
            $8e07a5888a205cc0$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $8e07a5888a205cc0$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $8e07a5888a205cc0$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $8e07a5888a205cc0$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $8e07a5888a205cc0$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $8e07a5888a205cc0$var$tagCaches = null;
function $8e07a5888a205cc0$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $8e07a5888a205cc0$var$tagCaches) {
        var cache = new Map();
        var caches = $8e07a5888a205cc0$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $8e07a5888a205cc0$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$8e07a5888a205cc0$var$internalHoistableMarker] || node[$8e07a5888a205cc0$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $8e07a5888a205cc0$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $8e07a5888a205cc0$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $8e07a5888a205cc0$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $8e07a5888a205cc0$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $8e07a5888a205cc0$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $8e07a5888a205cc0$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $8e07a5888a205cc0$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $8e07a5888a205cc0$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $8e07a5888a205cc0$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $8e07a5888a205cc0$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($8e07a5888a205cc0$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $8e07a5888a205cc0$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $8e07a5888a205cc0$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $8e07a5888a205cc0$var$stylesheetPropsFromRawProps(props);
            (key = $8e07a5888a205cc0$var$preloadPropsMap.get(key)) && $8e07a5888a205cc0$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $8e07a5888a205cc0$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $8e07a5888a205cc0$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $8e07a5888a205cc0$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $8e07a5888a205cc0$var$estimatedBytesWithinLimit = 0;
function $8e07a5888a205cc0$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $8e07a5888a205cc0$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $8e07a5888a205cc0$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $8e07a5888a205cc0$var$estimatedBytesWithinLimit && ($8e07a5888a205cc0$var$estimatedBytesWithinLimit = 62500 * $8e07a5888a205cc0$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $8e07a5888a205cc0$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $8e07a5888a205cc0$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $8e07a5888a205cc0$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $8e07a5888a205cc0$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $8e07a5888a205cc0$var$onUnsuspend() {
    this.count--;
    $8e07a5888a205cc0$var$checkIfFullyUnsuspended(this);
}
function $8e07a5888a205cc0$var$onUnsuspendImg() {
    this.imgCount--;
    $8e07a5888a205cc0$var$checkIfFullyUnsuspended(this);
}
var $8e07a5888a205cc0$var$precedencesByRoot = null;
function $8e07a5888a205cc0$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $8e07a5888a205cc0$var$precedencesByRoot = new Map(), resources.forEach($8e07a5888a205cc0$var$insertStylesheetIntoRoot, state), $8e07a5888a205cc0$var$precedencesByRoot = null, $8e07a5888a205cc0$var$onUnsuspend.call(state));
}
function $8e07a5888a205cc0$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $8e07a5888a205cc0$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $8e07a5888a205cc0$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $8e07a5888a205cc0$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $8e07a5888a205cc0$var$HostTransitionContext = {
    $$typeof: $8e07a5888a205cc0$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $8e07a5888a205cc0$var$sharedNotPendingObject,
    _currentValue2: $8e07a5888a205cc0$var$sharedNotPendingObject,
    _threadCount: 0
};
function $8e07a5888a205cc0$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $8e07a5888a205cc0$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $8e07a5888a205cc0$var$createLaneMap(0);
    this.hiddenUpdates = $8e07a5888a205cc0$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $8e07a5888a205cc0$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $8e07a5888a205cc0$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $8e07a5888a205cc0$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $8e07a5888a205cc0$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $8e07a5888a205cc0$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $8e07a5888a205cc0$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $8e07a5888a205cc0$var$emptyContextObject;
    parentComponent = $8e07a5888a205cc0$var$emptyContextObject;
    return parentComponent;
}
function $8e07a5888a205cc0$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $8e07a5888a205cc0$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $8e07a5888a205cc0$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $8e07a5888a205cc0$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($8e07a5888a205cc0$var$scheduleUpdateOnFiber(element, rootFiber, lane), $8e07a5888a205cc0$var$entangleTransitions(element, rootFiber, lane));
}
function $8e07a5888a205cc0$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $8e07a5888a205cc0$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $8e07a5888a205cc0$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $8e07a5888a205cc0$var$markRetryLaneImpl(fiber, retryLane);
}
function $8e07a5888a205cc0$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $8e07a5888a205cc0$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $8e07a5888a205cc0$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $8e07a5888a205cc0$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $8e07a5888a205cc0$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $8e07a5888a205cc0$var$requestUpdateLane();
        lane = $8e07a5888a205cc0$var$getBumpedLaneForHydrationByLane(lane);
        var root = $8e07a5888a205cc0$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $8e07a5888a205cc0$var$scheduleUpdateOnFiber(root, fiber, lane);
        $8e07a5888a205cc0$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $8e07a5888a205cc0$var$_enabled = !0;
function $8e07a5888a205cc0$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $8e07a5888a205cc0$var$ReactSharedInternals.T;
    $8e07a5888a205cc0$var$ReactSharedInternals.T = null;
    var previousPriority = $8e07a5888a205cc0$var$ReactDOMSharedInternals.p;
    try {
        $8e07a5888a205cc0$var$ReactDOMSharedInternals.p = 2, $8e07a5888a205cc0$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $8e07a5888a205cc0$var$ReactDOMSharedInternals.p = previousPriority, $8e07a5888a205cc0$var$ReactSharedInternals.T = prevTransition;
    }
}
function $8e07a5888a205cc0$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $8e07a5888a205cc0$var$ReactSharedInternals.T;
    $8e07a5888a205cc0$var$ReactSharedInternals.T = null;
    var previousPriority = $8e07a5888a205cc0$var$ReactDOMSharedInternals.p;
    try {
        $8e07a5888a205cc0$var$ReactDOMSharedInternals.p = 8, $8e07a5888a205cc0$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $8e07a5888a205cc0$var$ReactDOMSharedInternals.p = previousPriority, $8e07a5888a205cc0$var$ReactSharedInternals.T = prevTransition;
    }
}
function $8e07a5888a205cc0$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($8e07a5888a205cc0$var$_enabled) {
        var blockedOn = $8e07a5888a205cc0$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $8e07a5888a205cc0$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $8e07a5888a205cc0$var$return_targetInst, targetContainer), $8e07a5888a205cc0$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($8e07a5888a205cc0$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($8e07a5888a205cc0$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $8e07a5888a205cc0$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $8e07a5888a205cc0$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $8e07a5888a205cc0$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $8e07a5888a205cc0$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $8e07a5888a205cc0$var$ensureRootIsScheduled(fiber);
                                0 === ($8e07a5888a205cc0$var$executionContext & 6) && ($8e07a5888a205cc0$var$workInProgressRootRenderTargetTime = $8e07a5888a205cc0$var$now() + 500, $8e07a5888a205cc0$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $8e07a5888a205cc0$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $8e07a5888a205cc0$var$scheduleUpdateOnFiber(root, fiber, 2), $8e07a5888a205cc0$var$flushSyncWork$1(), $8e07a5888a205cc0$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $8e07a5888a205cc0$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $8e07a5888a205cc0$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $8e07a5888a205cc0$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $8e07a5888a205cc0$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $8e07a5888a205cc0$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $8e07a5888a205cc0$var$getEventTarget(nativeEvent);
    return $8e07a5888a205cc0$var$findInstanceBlockingTarget(nativeEvent);
}
var $8e07a5888a205cc0$var$return_targetInst = null;
function $8e07a5888a205cc0$var$findInstanceBlockingTarget(targetNode) {
    $8e07a5888a205cc0$var$return_targetInst = null;
    targetNode = $8e07a5888a205cc0$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $8e07a5888a205cc0$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $8e07a5888a205cc0$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $8e07a5888a205cc0$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $8e07a5888a205cc0$var$return_targetInst = targetNode;
    return null;
}
function $8e07a5888a205cc0$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($8e07a5888a205cc0$var$getCurrentPriorityLevel()){
                case $8e07a5888a205cc0$var$ImmediatePriority:
                    return 2;
                case $8e07a5888a205cc0$var$UserBlockingPriority:
                    return 8;
                case $8e07a5888a205cc0$var$NormalPriority$1:
                case $8e07a5888a205cc0$var$LowPriority:
                    return 32;
                case $8e07a5888a205cc0$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $8e07a5888a205cc0$var$hasScheduledReplayAttempt = !1, $8e07a5888a205cc0$var$queuedFocus = null, $8e07a5888a205cc0$var$queuedDrag = null, $8e07a5888a205cc0$var$queuedMouse = null, $8e07a5888a205cc0$var$queuedPointers = new Map(), $8e07a5888a205cc0$var$queuedPointerCaptures = new Map(), $8e07a5888a205cc0$var$queuedExplicitHydrationTargets = [], $8e07a5888a205cc0$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $8e07a5888a205cc0$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $8e07a5888a205cc0$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $8e07a5888a205cc0$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $8e07a5888a205cc0$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $8e07a5888a205cc0$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $8e07a5888a205cc0$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $8e07a5888a205cc0$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $8e07a5888a205cc0$var$getInstanceFromNode(blockedOn), null !== blockedOn && $8e07a5888a205cc0$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $8e07a5888a205cc0$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $8e07a5888a205cc0$var$queuedFocus = $8e07a5888a205cc0$var$accumulateOrCreateContinuousQueuedReplayableEvent($8e07a5888a205cc0$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $8e07a5888a205cc0$var$queuedDrag = $8e07a5888a205cc0$var$accumulateOrCreateContinuousQueuedReplayableEvent($8e07a5888a205cc0$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $8e07a5888a205cc0$var$queuedMouse = $8e07a5888a205cc0$var$accumulateOrCreateContinuousQueuedReplayableEvent($8e07a5888a205cc0$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $8e07a5888a205cc0$var$queuedPointers.set(pointerId, $8e07a5888a205cc0$var$accumulateOrCreateContinuousQueuedReplayableEvent($8e07a5888a205cc0$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $8e07a5888a205cc0$var$queuedPointerCaptures.set(pointerId, $8e07a5888a205cc0$var$accumulateOrCreateContinuousQueuedReplayableEvent($8e07a5888a205cc0$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $8e07a5888a205cc0$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $8e07a5888a205cc0$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $8e07a5888a205cc0$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $8e07a5888a205cc0$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $8e07a5888a205cc0$var$runWithPriority(queuedTarget.priority, function() {
                        $8e07a5888a205cc0$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $8e07a5888a205cc0$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $8e07a5888a205cc0$var$runWithPriority(queuedTarget.priority, function() {
                        $8e07a5888a205cc0$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $8e07a5888a205cc0$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $8e07a5888a205cc0$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $8e07a5888a205cc0$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $8e07a5888a205cc0$var$currentReplayingEvent = null;
        } else return targetContainers = $8e07a5888a205cc0$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $8e07a5888a205cc0$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $8e07a5888a205cc0$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $8e07a5888a205cc0$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $8e07a5888a205cc0$var$replayUnblockedEvents() {
    $8e07a5888a205cc0$var$hasScheduledReplayAttempt = !1;
    null !== $8e07a5888a205cc0$var$queuedFocus && $8e07a5888a205cc0$var$attemptReplayContinuousQueuedEvent($8e07a5888a205cc0$var$queuedFocus) && ($8e07a5888a205cc0$var$queuedFocus = null);
    null !== $8e07a5888a205cc0$var$queuedDrag && $8e07a5888a205cc0$var$attemptReplayContinuousQueuedEvent($8e07a5888a205cc0$var$queuedDrag) && ($8e07a5888a205cc0$var$queuedDrag = null);
    null !== $8e07a5888a205cc0$var$queuedMouse && $8e07a5888a205cc0$var$attemptReplayContinuousQueuedEvent($8e07a5888a205cc0$var$queuedMouse) && ($8e07a5888a205cc0$var$queuedMouse = null);
    $8e07a5888a205cc0$var$queuedPointers.forEach($8e07a5888a205cc0$var$attemptReplayContinuousQueuedEventInMap);
    $8e07a5888a205cc0$var$queuedPointerCaptures.forEach($8e07a5888a205cc0$var$attemptReplayContinuousQueuedEventInMap);
}
function $8e07a5888a205cc0$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $8e07a5888a205cc0$var$hasScheduledReplayAttempt || ($8e07a5888a205cc0$var$hasScheduledReplayAttempt = !0, $5JhdH.unstable_scheduleCallback($5JhdH.unstable_NormalPriority, $8e07a5888a205cc0$var$replayUnblockedEvents)));
}
var $8e07a5888a205cc0$var$lastScheduledReplayQueue = null;
function $8e07a5888a205cc0$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $8e07a5888a205cc0$var$lastScheduledReplayQueue !== formReplayingQueue && ($8e07a5888a205cc0$var$lastScheduledReplayQueue = formReplayingQueue, $5JhdH.unstable_scheduleCallback($5JhdH.unstable_NormalPriority, function() {
        $8e07a5888a205cc0$var$lastScheduledReplayQueue === formReplayingQueue && ($8e07a5888a205cc0$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $8e07a5888a205cc0$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $8e07a5888a205cc0$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $8e07a5888a205cc0$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $8e07a5888a205cc0$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $8e07a5888a205cc0$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $8e07a5888a205cc0$var$queuedFocus && $8e07a5888a205cc0$var$scheduleCallbackIfUnblocked($8e07a5888a205cc0$var$queuedFocus, unblocked);
    null !== $8e07a5888a205cc0$var$queuedDrag && $8e07a5888a205cc0$var$scheduleCallbackIfUnblocked($8e07a5888a205cc0$var$queuedDrag, unblocked);
    null !== $8e07a5888a205cc0$var$queuedMouse && $8e07a5888a205cc0$var$scheduleCallbackIfUnblocked($8e07a5888a205cc0$var$queuedMouse, unblocked);
    $8e07a5888a205cc0$var$queuedPointers.forEach(unblock);
    $8e07a5888a205cc0$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $8e07a5888a205cc0$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $8e07a5888a205cc0$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $8e07a5888a205cc0$var$queuedExplicitHydrationTargets.length && (i = $8e07a5888a205cc0$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$8e07a5888a205cc0$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $8e07a5888a205cc0$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$8e07a5888a205cc0$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $8e07a5888a205cc0$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$8e07a5888a205cc0$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $8e07a5888a205cc0$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $8e07a5888a205cc0$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $8e07a5888a205cc0$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $8e07a5888a205cc0$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$8e07a5888a205cc0$var$ReactDOMHydrationRoot.prototype.render = $8e07a5888a205cc0$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(409));
    var current = root.current, lane = $8e07a5888a205cc0$var$requestUpdateLane();
    $8e07a5888a205cc0$var$updateContainerImpl(current, lane, children, root, null, null);
};
$8e07a5888a205cc0$var$ReactDOMHydrationRoot.prototype.unmount = $8e07a5888a205cc0$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $8e07a5888a205cc0$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $8e07a5888a205cc0$var$flushSyncWork$1();
        container[$8e07a5888a205cc0$var$internalContainerInstanceKey] = null;
    }
};
function $8e07a5888a205cc0$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$8e07a5888a205cc0$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $8e07a5888a205cc0$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $8e07a5888a205cc0$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $8e07a5888a205cc0$var$queuedExplicitHydrationTargets[i].priority; i++);
        $8e07a5888a205cc0$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $8e07a5888a205cc0$var$attemptExplicitHydrationTarget(target);
    }
};
var $8e07a5888a205cc0$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $jHEir.version;
if ("19.3.1" !== $8e07a5888a205cc0$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(527, $8e07a5888a205cc0$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.1"));
$8e07a5888a205cc0$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $8e07a5888a205cc0$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $8e07a5888a205cc0$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $8e07a5888a205cc0$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $8e07a5888a205cc0$var$ReactSharedInternals,
    reconcilerVersion: "19.3.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $8e07a5888a205cc0$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$8e07a5888a205cc0$var$hook$jscomp$inline_2587.isDisabled && $8e07a5888a205cc0$var$hook$jscomp$inline_2587.supportsFiber) try {
        $8e07a5888a205cc0$var$rendererID = $8e07a5888a205cc0$var$hook$jscomp$inline_2587.inject($8e07a5888a205cc0$var$internals$jscomp$inline_2586), $8e07a5888a205cc0$var$injectedHook = $8e07a5888a205cc0$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$8e07a5888a205cc0$export$882461b6382ed46c = function(container, options) {
    if (!$8e07a5888a205cc0$var$isValidContainer(container)) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $8e07a5888a205cc0$var$defaultOnUncaughtError, onCaughtError = $8e07a5888a205cc0$var$defaultOnCaughtError, onRecoverableError = $8e07a5888a205cc0$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $8e07a5888a205cc0$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $8e07a5888a205cc0$var$defaultOnDefaultTransitionIndicator);
    container[$8e07a5888a205cc0$var$internalContainerInstanceKey] = options.current;
    $8e07a5888a205cc0$var$listenToAllSupportedEvents(container);
    return new $8e07a5888a205cc0$var$ReactDOMRoot(options);
};
$8e07a5888a205cc0$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$8e07a5888a205cc0$var$isValidContainer(container)) throw Error($8e07a5888a205cc0$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $8e07a5888a205cc0$var$defaultOnUncaughtError, onCaughtError = $8e07a5888a205cc0$var$defaultOnCaughtError, onRecoverableError = $8e07a5888a205cc0$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $8e07a5888a205cc0$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $8e07a5888a205cc0$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $8e07a5888a205cc0$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $8e07a5888a205cc0$var$requestUpdateLane();
    isStrictMode = $8e07a5888a205cc0$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $8e07a5888a205cc0$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $8e07a5888a205cc0$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $8e07a5888a205cc0$var$markRootUpdated$1(initialChildren, options);
    $8e07a5888a205cc0$var$ensureRootIsScheduled(initialChildren);
    container[$8e07a5888a205cc0$var$internalContainerInstanceKey] = initialChildren.current;
    $8e07a5888a205cc0$var$listenToAllSupportedEvents(container);
    return new $8e07a5888a205cc0$var$ReactDOMHydrationRoot(initialChildren);
};
$8e07a5888a205cc0$export$83d89fbfd8236492 = "19.3.1";

});
parcelRegister("5JhdH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iupWu"));

});
parcelRegister("iupWu", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $d75f26f4831e9c2b$export$c4744153514ff05d; }, function (v) { return $d75f26f4831e9c2b$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $d75f26f4831e9c2b$export$3e506c1ccc9cc1a7; }, function (v) { return $d75f26f4831e9c2b$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $d75f26f4831e9c2b$export$e26fe2ed2fa76875; }, function (v) { return $d75f26f4831e9c2b$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $d75f26f4831e9c2b$export$502329bbf4b505b1; }, function (v) { return $d75f26f4831e9c2b$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $d75f26f4831e9c2b$export$6e3807111c4874c4; }, function (v) { return $d75f26f4831e9c2b$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $d75f26f4831e9c2b$export$c27134553091fb3a; }, function (v) { return $d75f26f4831e9c2b$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $d75f26f4831e9c2b$export$33ee1acdc04fd2a2; }, function (v) { return $d75f26f4831e9c2b$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $d75f26f4831e9c2b$export$b00a404bbd5edef2; }, function (v) { return $d75f26f4831e9c2b$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $d75f26f4831e9c2b$export$d66a1c1c77bd778b; }, function (v) { return $d75f26f4831e9c2b$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $d75f26f4831e9c2b$export$d3dfb8e4810cb555; }, function (v) { return $d75f26f4831e9c2b$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $d75f26f4831e9c2b$export$72fdf0e06517287b; }, function (v) { return $d75f26f4831e9c2b$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $d75f26f4831e9c2b$export$816d2913ae6b83b1; }, function (v) { return $d75f26f4831e9c2b$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $d75f26f4831e9c2b$export$61bcfe829111a1d0; }, function (v) { return $d75f26f4831e9c2b$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $d75f26f4831e9c2b$export$7ee8c9beb337bc3f; }, function (v) { return $d75f26f4831e9c2b$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $d75f26f4831e9c2b$export$b5836b71941fa3ed; }, function (v) { return $d75f26f4831e9c2b$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $d75f26f4831e9c2b$export$cf845f2c119da08a; }, function (v) { return $d75f26f4831e9c2b$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d75f26f4831e9c2b$export$c4744153514ff05d;
var $d75f26f4831e9c2b$export$3e506c1ccc9cc1a7;
var $d75f26f4831e9c2b$export$e26fe2ed2fa76875;
var $d75f26f4831e9c2b$export$502329bbf4b505b1;
var $d75f26f4831e9c2b$export$6e3807111c4874c4;
var $d75f26f4831e9c2b$export$c27134553091fb3a;
var $d75f26f4831e9c2b$export$33ee1acdc04fd2a2;
var $d75f26f4831e9c2b$export$b00a404bbd5edef2;
var $d75f26f4831e9c2b$export$d66a1c1c77bd778b;
var $d75f26f4831e9c2b$export$d3dfb8e4810cb555;
var $d75f26f4831e9c2b$export$72fdf0e06517287b;
var $d75f26f4831e9c2b$export$816d2913ae6b83b1;
var $d75f26f4831e9c2b$export$61bcfe829111a1d0;
var $d75f26f4831e9c2b$export$7ee8c9beb337bc3f;
var $d75f26f4831e9c2b$export$b5836b71941fa3ed;
var $d75f26f4831e9c2b$export$cf845f2c119da08a;
"use strict";
function $d75f26f4831e9c2b$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $d75f26f4831e9c2b$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $d75f26f4831e9c2b$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $d75f26f4831e9c2b$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $d75f26f4831e9c2b$var$compare(left, last)) rightIndex < length && 0 > $d75f26f4831e9c2b$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $d75f26f4831e9c2b$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $d75f26f4831e9c2b$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$d75f26f4831e9c2b$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $d75f26f4831e9c2b$var$localPerformance = performance;
    $d75f26f4831e9c2b$export$c4744153514ff05d = function() {
        return $d75f26f4831e9c2b$var$localPerformance.now();
    };
} else {
    var $d75f26f4831e9c2b$var$localDate = Date, $d75f26f4831e9c2b$var$initialTime = $d75f26f4831e9c2b$var$localDate.now();
    $d75f26f4831e9c2b$export$c4744153514ff05d = function() {
        return $d75f26f4831e9c2b$var$localDate.now() - $d75f26f4831e9c2b$var$initialTime;
    };
}
var $d75f26f4831e9c2b$var$taskQueue = [], $d75f26f4831e9c2b$var$timerQueue = [], $d75f26f4831e9c2b$var$taskIdCounter = 1, $d75f26f4831e9c2b$var$currentTask = null, $d75f26f4831e9c2b$var$currentPriorityLevel = 3, $d75f26f4831e9c2b$var$isPerformingWork = !1, $d75f26f4831e9c2b$var$isHostCallbackScheduled = !1, $d75f26f4831e9c2b$var$isHostTimeoutScheduled = !1, $d75f26f4831e9c2b$var$needsPaint = !1, $d75f26f4831e9c2b$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $d75f26f4831e9c2b$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $d75f26f4831e9c2b$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $d75f26f4831e9c2b$var$advanceTimers(currentTime) {
    for(var timer = $d75f26f4831e9c2b$var$peek($d75f26f4831e9c2b$var$timerQueue); null !== timer;){
        if (null === timer.callback) $d75f26f4831e9c2b$var$pop($d75f26f4831e9c2b$var$timerQueue);
        else if (timer.startTime <= currentTime) $d75f26f4831e9c2b$var$pop($d75f26f4831e9c2b$var$timerQueue), timer.sortIndex = timer.expirationTime, $d75f26f4831e9c2b$var$push($d75f26f4831e9c2b$var$taskQueue, timer);
        else break;
        timer = $d75f26f4831e9c2b$var$peek($d75f26f4831e9c2b$var$timerQueue);
    }
}
function $d75f26f4831e9c2b$var$handleTimeout(currentTime) {
    $d75f26f4831e9c2b$var$isHostTimeoutScheduled = !1;
    $d75f26f4831e9c2b$var$advanceTimers(currentTime);
    if (!$d75f26f4831e9c2b$var$isHostCallbackScheduled) {
        if (null !== $d75f26f4831e9c2b$var$peek($d75f26f4831e9c2b$var$taskQueue)) $d75f26f4831e9c2b$var$isHostCallbackScheduled = !0, $d75f26f4831e9c2b$var$isMessageLoopRunning || ($d75f26f4831e9c2b$var$isMessageLoopRunning = !0, $d75f26f4831e9c2b$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $d75f26f4831e9c2b$var$peek($d75f26f4831e9c2b$var$timerQueue);
            null !== firstTimer && $d75f26f4831e9c2b$var$requestHostTimeout($d75f26f4831e9c2b$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $d75f26f4831e9c2b$var$isMessageLoopRunning = !1, $d75f26f4831e9c2b$var$taskTimeoutID = -1, $d75f26f4831e9c2b$var$frameInterval = 5, $d75f26f4831e9c2b$var$startTime = -1;
function $d75f26f4831e9c2b$var$shouldYieldToHost() {
    return $d75f26f4831e9c2b$var$needsPaint ? !0 : $d75f26f4831e9c2b$export$c4744153514ff05d() - $d75f26f4831e9c2b$var$startTime < $d75f26f4831e9c2b$var$frameInterval ? !1 : !0;
}
function $d75f26f4831e9c2b$var$performWorkUntilDeadline() {
    $d75f26f4831e9c2b$var$needsPaint = !1;
    if ($d75f26f4831e9c2b$var$isMessageLoopRunning) {
        var currentTime = $d75f26f4831e9c2b$export$c4744153514ff05d();
        $d75f26f4831e9c2b$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $d75f26f4831e9c2b$var$isHostCallbackScheduled = !1;
                $d75f26f4831e9c2b$var$isHostTimeoutScheduled && ($d75f26f4831e9c2b$var$isHostTimeoutScheduled = !1, $d75f26f4831e9c2b$var$localClearTimeout($d75f26f4831e9c2b$var$taskTimeoutID), $d75f26f4831e9c2b$var$taskTimeoutID = -1);
                $d75f26f4831e9c2b$var$isPerformingWork = !0;
                var previousPriorityLevel = $d75f26f4831e9c2b$var$currentPriorityLevel;
                try {
                    b: {
                        $d75f26f4831e9c2b$var$advanceTimers(currentTime);
                        for($d75f26f4831e9c2b$var$currentTask = $d75f26f4831e9c2b$var$peek($d75f26f4831e9c2b$var$taskQueue); null !== $d75f26f4831e9c2b$var$currentTask && !($d75f26f4831e9c2b$var$currentTask.expirationTime > currentTime && $d75f26f4831e9c2b$var$shouldYieldToHost());){
                            var callback = $d75f26f4831e9c2b$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $d75f26f4831e9c2b$var$currentTask.callback = null;
                                $d75f26f4831e9c2b$var$currentPriorityLevel = $d75f26f4831e9c2b$var$currentTask.priorityLevel;
                                var continuationCallback = callback($d75f26f4831e9c2b$var$currentTask.expirationTime <= currentTime);
                                currentTime = $d75f26f4831e9c2b$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $d75f26f4831e9c2b$var$currentTask.callback = continuationCallback;
                                    $d75f26f4831e9c2b$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $d75f26f4831e9c2b$var$currentTask === $d75f26f4831e9c2b$var$peek($d75f26f4831e9c2b$var$taskQueue) && $d75f26f4831e9c2b$var$pop($d75f26f4831e9c2b$var$taskQueue);
                                $d75f26f4831e9c2b$var$advanceTimers(currentTime);
                            } else $d75f26f4831e9c2b$var$pop($d75f26f4831e9c2b$var$taskQueue);
                            $d75f26f4831e9c2b$var$currentTask = $d75f26f4831e9c2b$var$peek($d75f26f4831e9c2b$var$taskQueue);
                        }
                        if (null !== $d75f26f4831e9c2b$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $d75f26f4831e9c2b$var$peek($d75f26f4831e9c2b$var$timerQueue);
                            null !== firstTimer && $d75f26f4831e9c2b$var$requestHostTimeout($d75f26f4831e9c2b$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $d75f26f4831e9c2b$var$currentTask = null, $d75f26f4831e9c2b$var$currentPriorityLevel = previousPriorityLevel, $d75f26f4831e9c2b$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $d75f26f4831e9c2b$var$schedulePerformWorkUntilDeadline() : $d75f26f4831e9c2b$var$isMessageLoopRunning = !1;
        }
    }
}
var $d75f26f4831e9c2b$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $d75f26f4831e9c2b$var$localSetImmediate) $d75f26f4831e9c2b$var$schedulePerformWorkUntilDeadline = function() {
    $d75f26f4831e9c2b$var$localSetImmediate($d75f26f4831e9c2b$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $d75f26f4831e9c2b$var$channel = new MessageChannel(), $d75f26f4831e9c2b$var$port = $d75f26f4831e9c2b$var$channel.port2;
    $d75f26f4831e9c2b$var$channel.port1.onmessage = $d75f26f4831e9c2b$var$performWorkUntilDeadline;
    $d75f26f4831e9c2b$var$schedulePerformWorkUntilDeadline = function() {
        $d75f26f4831e9c2b$var$port.postMessage(null);
    };
} else $d75f26f4831e9c2b$var$schedulePerformWorkUntilDeadline = function() {
    $d75f26f4831e9c2b$var$localSetTimeout($d75f26f4831e9c2b$var$performWorkUntilDeadline, 0);
};
function $d75f26f4831e9c2b$var$requestHostTimeout(callback, ms) {
    $d75f26f4831e9c2b$var$taskTimeoutID = $d75f26f4831e9c2b$var$localSetTimeout(function() {
        callback($d75f26f4831e9c2b$export$c4744153514ff05d());
    }, ms);
}
$d75f26f4831e9c2b$export$3e506c1ccc9cc1a7 = 5;
$d75f26f4831e9c2b$export$e26fe2ed2fa76875 = 1;
$d75f26f4831e9c2b$export$502329bbf4b505b1 = 4;
$d75f26f4831e9c2b$export$6e3807111c4874c4 = 3;
$d75f26f4831e9c2b$export$c27134553091fb3a = null;
$d75f26f4831e9c2b$export$33ee1acdc04fd2a2 = 2;
$d75f26f4831e9c2b$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$d75f26f4831e9c2b$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $d75f26f4831e9c2b$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$d75f26f4831e9c2b$export$d3dfb8e4810cb555 = function() {
    return $d75f26f4831e9c2b$var$currentPriorityLevel;
};
$d75f26f4831e9c2b$export$72fdf0e06517287b = function(eventHandler) {
    switch($d75f26f4831e9c2b$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $d75f26f4831e9c2b$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $d75f26f4831e9c2b$var$currentPriorityLevel;
    $d75f26f4831e9c2b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $d75f26f4831e9c2b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$d75f26f4831e9c2b$export$816d2913ae6b83b1 = function() {
    $d75f26f4831e9c2b$var$needsPaint = !0;
};
$d75f26f4831e9c2b$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $d75f26f4831e9c2b$var$currentPriorityLevel;
    $d75f26f4831e9c2b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $d75f26f4831e9c2b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$d75f26f4831e9c2b$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $d75f26f4831e9c2b$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $d75f26f4831e9c2b$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $d75f26f4831e9c2b$var$push($d75f26f4831e9c2b$var$timerQueue, priorityLevel), null === $d75f26f4831e9c2b$var$peek($d75f26f4831e9c2b$var$taskQueue) && priorityLevel === $d75f26f4831e9c2b$var$peek($d75f26f4831e9c2b$var$timerQueue) && ($d75f26f4831e9c2b$var$isHostTimeoutScheduled ? ($d75f26f4831e9c2b$var$localClearTimeout($d75f26f4831e9c2b$var$taskTimeoutID), $d75f26f4831e9c2b$var$taskTimeoutID = -1) : $d75f26f4831e9c2b$var$isHostTimeoutScheduled = !0, $d75f26f4831e9c2b$var$requestHostTimeout($d75f26f4831e9c2b$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $d75f26f4831e9c2b$var$push($d75f26f4831e9c2b$var$taskQueue, priorityLevel), $d75f26f4831e9c2b$var$isHostCallbackScheduled || $d75f26f4831e9c2b$var$isPerformingWork || ($d75f26f4831e9c2b$var$isHostCallbackScheduled = !0, $d75f26f4831e9c2b$var$isMessageLoopRunning || ($d75f26f4831e9c2b$var$isMessageLoopRunning = !0, $d75f26f4831e9c2b$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$d75f26f4831e9c2b$export$b5836b71941fa3ed = $d75f26f4831e9c2b$var$shouldYieldToHost;
$d75f26f4831e9c2b$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $d75f26f4831e9c2b$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $d75f26f4831e9c2b$var$currentPriorityLevel;
        $d75f26f4831e9c2b$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $d75f26f4831e9c2b$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("faOpr", function(module, exports) {
'use strict';
function $b0bee46cd840d1b3$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b0bee46cd840d1b3$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b0bee46cd840d1b3$var$checkDCE();

module.exports = (parcelRequire("8NBI4"));

});
parcelRegister("8NBI4", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $668026b6eb821c3e$export$69ce8ef3fe5cead0; }, function (v) { return $668026b6eb821c3e$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "browser", function () { return $668026b6eb821c3e$export$3f2684e5d7cb1006; }, function (v) { return $668026b6eb821c3e$export$3f2684e5d7cb1006 = v; });
$parcel$export(module.exports, "createPortal", function () { return $668026b6eb821c3e$export$d39a5bbd09211389; }, function (v) { return $668026b6eb821c3e$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $668026b6eb821c3e$export$cd75ccfd720a3cd4; }, function (v) { return $668026b6eb821c3e$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $668026b6eb821c3e$export$a0816fa17a9e79be; }, function (v) { return $668026b6eb821c3e$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $668026b6eb821c3e$export$7292efcadded39f3; }, function (v) { return $668026b6eb821c3e$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $668026b6eb821c3e$export$da407abadb9b8f86; }, function (v) { return $668026b6eb821c3e$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $668026b6eb821c3e$export$314cfea32580671c; }, function (v) { return $668026b6eb821c3e$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $668026b6eb821c3e$export$513ccb98c53b8039; }, function (v) { return $668026b6eb821c3e$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $668026b6eb821c3e$export$dbca993bc2d264a; }, function (v) { return $668026b6eb821c3e$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $668026b6eb821c3e$export$4797a8006f0655d0; }, function (v) { return $668026b6eb821c3e$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $668026b6eb821c3e$export$c78a37762a8d58e1; }, function (v) { return $668026b6eb821c3e$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $668026b6eb821c3e$export$606f11b2eb45ecc6; }, function (v) { return $668026b6eb821c3e$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $668026b6eb821c3e$export$f7e8a0bf92324b1e; }, function (v) { return $668026b6eb821c3e$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $668026b6eb821c3e$export$83d89fbfd8236492; }, function (v) { return $668026b6eb821c3e$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $668026b6eb821c3e$export$69ce8ef3fe5cead0;
var $668026b6eb821c3e$export$3f2684e5d7cb1006;
var $668026b6eb821c3e$export$d39a5bbd09211389;
var $668026b6eb821c3e$export$cd75ccfd720a3cd4;
var $668026b6eb821c3e$export$a0816fa17a9e79be;
var $668026b6eb821c3e$export$7292efcadded39f3;
var $668026b6eb821c3e$export$da407abadb9b8f86;
var $668026b6eb821c3e$export$314cfea32580671c;
var $668026b6eb821c3e$export$513ccb98c53b8039;
var $668026b6eb821c3e$export$dbca993bc2d264a;
var $668026b6eb821c3e$export$4797a8006f0655d0;
var $668026b6eb821c3e$export$c78a37762a8d58e1;
var $668026b6eb821c3e$export$606f11b2eb45ecc6;
var $668026b6eb821c3e$export$f7e8a0bf92324b1e;
var $668026b6eb821c3e$export$83d89fbfd8236492;
"use strict";

var $jHEir = parcelRequire("jHEir");
function $668026b6eb821c3e$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $668026b6eb821c3e$var$noop() {}
var $668026b6eb821c3e$var$Internals = {
    d: {
        f: $668026b6eb821c3e$var$noop,
        r: function() {
            throw Error($668026b6eb821c3e$var$formatProdErrorMessage(522));
        },
        D: $668026b6eb821c3e$var$noop,
        C: $668026b6eb821c3e$var$noop,
        L: $668026b6eb821c3e$var$noop,
        m: $668026b6eb821c3e$var$noop,
        X: $668026b6eb821c3e$var$noop,
        S: $668026b6eb821c3e$var$noop,
        M: $668026b6eb821c3e$var$noop
    },
    p: 0,
    findDOMNode: null
}, $668026b6eb821c3e$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $668026b6eb821c3e$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $668026b6eb821c3e$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $668026b6eb821c3e$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $668026b6eb821c3e$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $668026b6eb821c3e$var$REACT_OPTIMISTIC_KEY ? $668026b6eb821c3e$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $668026b6eb821c3e$var$ReactSharedInternals = $jHEir.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $668026b6eb821c3e$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$668026b6eb821c3e$export$69ce8ef3fe5cead0 = $668026b6eb821c3e$var$Internals;
$668026b6eb821c3e$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $668026b6eb821c3e$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$668026b6eb821c3e$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($668026b6eb821c3e$var$formatProdErrorMessage(299));
    return $668026b6eb821c3e$var$createPortal$1(children, container, null, key);
};
$668026b6eb821c3e$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $668026b6eb821c3e$var$ReactSharedInternals.T, previousUpdatePriority = $668026b6eb821c3e$var$Internals.p;
    try {
        if ($668026b6eb821c3e$var$ReactSharedInternals.T = null, $668026b6eb821c3e$var$Internals.p = 2, fn) return fn();
    } finally{
        $668026b6eb821c3e$var$ReactSharedInternals.T = previousTransition, $668026b6eb821c3e$var$Internals.p = previousUpdatePriority, $668026b6eb821c3e$var$Internals.d.f();
    }
};
$668026b6eb821c3e$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $668026b6eb821c3e$var$Internals.d.C(href, options));
};
$668026b6eb821c3e$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $668026b6eb821c3e$var$Internals.d.D(href);
};
$668026b6eb821c3e$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $668026b6eb821c3e$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $668026b6eb821c3e$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $668026b6eb821c3e$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$668026b6eb821c3e$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $668026b6eb821c3e$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $668026b6eb821c3e$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $668026b6eb821c3e$var$Internals.d.M(href);
    }
};
$668026b6eb821c3e$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $668026b6eb821c3e$var$getCrossOriginStringAs(as, options.crossOrigin);
        $668026b6eb821c3e$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$668026b6eb821c3e$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $668026b6eb821c3e$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $668026b6eb821c3e$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $668026b6eb821c3e$var$Internals.d.m(href);
    }
};
$668026b6eb821c3e$export$4797a8006f0655d0 = function(form) {
    $668026b6eb821c3e$var$Internals.d.r(form);
};
$668026b6eb821c3e$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$668026b6eb821c3e$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $668026b6eb821c3e$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$668026b6eb821c3e$export$f7e8a0bf92324b1e = function() {
    return $668026b6eb821c3e$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$668026b6eb821c3e$export$83d89fbfd8236492 = "19.3.1";

});



parcelRegister("cK6an", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $946e906b28ac6219$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $946e906b28ac6219$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useSearchParams", function () { return $946e906b28ac6219$export$f1a78c17382fe22a; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8w9JA = parcelRequire("8w9JA");

var $i4yVL = parcelRequire("i4yVL");

var $vjGlj = parcelRequire("vjGlj");

var $6WCgj = parcelRequire("6WCgj");

var $3uzJP = parcelRequire("3uzJP");

var $lfSRY = parcelRequire("lfSRY");

var $dr43k = parcelRequire("dr43k");

var $koI43 = parcelRequire("koI43");

var $lIBUZ = parcelRequire("lIBUZ");

var $6quj3 = parcelRequire("6quj3");

var $jHEir = parcelRequire("jHEir");
//#region lib/dom/lib.tsx
const $946e906b28ac6219$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($946e906b28ac6219$var$isBrowser) window.__reactRouterVersion = "8";
} catch  {}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* and [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $946e906b28ac6219$export$1f3f55432a00e06d(routes, opts) {
    return (0, $6WCgj.createRouter)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $i4yVL.createBrowserHistory)({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $946e906b28ac6219$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $vjGlj.defaultMapRouteProperties),
        hydrationRouteProperties: $lIBUZ.hydrationRouteProperties,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $946e906b28ac6219$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $6WCgj.createRouter)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $i4yVL.createHashHistory)({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $946e906b28ac6219$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $vjGlj.defaultMapRouteProperties),
        hydrationRouteProperties: $lIBUZ.hydrationRouteProperties,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $946e906b28ac6219$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $946e906b28ac6219$var$deserializeErrors(state.errors)
    };
    return state;
}
function $946e906b28ac6219$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries)if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $vjGlj.ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
    else if (val && val.__type === "Error") {
        if (typeof val.__subType === "string" && (0, $vjGlj.SUPPORTED_ERROR_TYPES).includes(val.__subType)) {
            let ErrorConstructor = window[val.__subType];
            if (typeof ErrorConstructor === "function") try {
                let error = new ErrorConstructor(val.message);
                error.stack = "";
                serialized[key] = error;
            } catch  {}
        }
        if (serialized[key] == null) {
            let error = new Error(val.message);
            error.stack = "";
            serialized[key] = error;
        }
    } else serialized[key] = val;
    return serialized;
}
/**
* A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {BrowserRouterProps.basename} props.basename n/a
* @param {BrowserRouterProps.children} props.children n/a
* @param {BrowserRouterProps.useTransitions} props.useTransitions n/a
* @param {BrowserRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*/ function $946e906b28ac6219$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $jHEir.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $i4yVL.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jHEir.useState({
        action: history.action,
        location: history.location
    });
    let setState = $jHEir.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $jHEir.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $jHEir.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $jHEir.createElement((0, $lIBUZ.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores the location in the
* [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash) portion
* of the URL so it is not sent to the server.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HashRouterProps.basename} props.basename n/a
* @param {HashRouterProps.children} props.children n/a
* @param {HashRouterProps.useTransitions} props.useTransitions n/a
* @param {HashRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash)
* for client-side routing.
*/ function $946e906b28ac6219$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $jHEir.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $i4yVL.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jHEir.useState({
        action: history.action,
        location: history.location
    });
    let setState = $jHEir.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $jHEir.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $jHEir.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $jHEir.createElement((0, $lIBUZ.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that accepts a pre-instantiated
* `history` object.
* It's important to note that using your own `history` object is highly discouraged
* and may add two versions of the `history` library to your bundles unless you use
* the same version of the `history` library that React Router uses internally.
*
* @name unstable_HistoryRouter
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HistoryRouterProps.basename} props.basename n/a
* @param {HistoryRouterProps.children} props.children n/a
* @param {HistoryRouterProps.history} props.history n/a
* @param {HistoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative {@link Router | `<Router>`} using the provided history
* implementation for client-side routing.
*/ function $946e906b28ac6219$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $jHEir.useState({
        action: history.action,
        location: history.location
    });
    let setState = $jHEir.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $jHEir.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $jHEir.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $jHEir.createElement((0, $lIBUZ.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$946e906b28ac6219$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
/**
* A progressively enhanced [`<a href>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a)
* wrapper to enable navigation with client-side routing.
*
* @example
* import { Link } from "react-router";
*
* <Link to="/dashboard">Dashboard</Link>;
*
* <Link
*   to={{
*     pathname: "/some/path",
*     search: "?query=string",
*     hash: "#hash",
*   }}
* />;
*
* @public
* @category Components
* @param {LinkProps.discover} props.discover [modes: framework] n/a
* @param {LinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {LinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {LinkProps.relative} props.relative n/a
* @param {LinkProps.reloadDocument} props.reloadDocument n/a
* @param {LinkProps.replace} props.replace n/a
* @param {LinkProps.state} props.state n/a
* @param {LinkProps.to} props.to n/a
* @param {LinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
* @param {LinkProps.defaultShouldRevalidate} props.defaultShouldRevalidate n/a
* @param {LinkProps.mask} props.mask [modes: framework, data] n/a
*/ const $946e906b28ac6219$export$a6c7ac8248d6e38a = $jHEir.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $jHEir.useContext((0, $3uzJP.NavigationContext));
    let isAbsolute = typeof to === "string" && (0, $8w9JA.ABSOLUTE_URL_REGEX).test(to);
    let parsed = (0, $vjGlj.parseToInfo)(to, basename);
    to = parsed.to;
    let href = (0, $lfSRY.useHref)(to, {
        relative: relative
    });
    let location = (0, $lfSRY.useLocation)();
    let maskedHref = null;
    if (mask) {
        let resolved = (0, $vjGlj.resolveTo)(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : (0, $vjGlj.joinPaths)([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = (0, $koI43.usePrefetchBehavior)(prefetch, rest);
    let internalOnClick = $946e906b28ac6219$export$67621102c14d847(to, {
        replace: replace,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = /* @__PURE__ */ $jHEir.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: (0, $koI43.mergeRefs)(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $jHEir.createElement($jHEir.Fragment, null, link, /* @__PURE__ */ $jHEir.createElement((0, $koI43.PrefetchPageLinks), {
        page: href
    })) : link;
});
$946e906b28ac6219$export$a6c7ac8248d6e38a.displayName = "Link";
/**
* Wraps {@link Link | `<Link>`} with additional props for styling active and
* pending states.
*
* - Automatically applies classes to the link based on its `active` and `pending`
* states, see {@link NavLinkProps.className}
*   - Note that `pending` is only available with Framework and Data modes.
* - Automatically applies `aria-current="page"` to the link when the link is active.
* See [`aria-current`](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-current)
* on MDN.
* - States are additionally available through the className, style, and children
* render props. See {@link NavLinkRenderProps}.
*
* @example
* <NavLink to="/message">Messages</NavLink>
*
* // Using render props
* <NavLink
*   to="/messages"
*   className={({ isActive, isPending }) =>
*     isPending ? "pending" : isActive ? "active" : ""
*   }
* >
*   Messages
* </NavLink>
*
* @public
* @category Components
* @param {NavLinkProps.caseSensitive} props.caseSensitive n/a
* @param {NavLinkProps.children} props.children n/a
* @param {NavLinkProps.className} props.className n/a
* @param {NavLinkProps.discover} props.discover [modes: framework] n/a
* @param {NavLinkProps.end} props.end n/a
* @param {NavLinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {NavLinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {NavLinkProps.relative} props.relative n/a
* @param {NavLinkProps.reloadDocument} props.reloadDocument n/a
* @param {NavLinkProps.replace} props.replace n/a
* @param {NavLinkProps.state} props.state n/a
* @param {NavLinkProps.style} props.style n/a
* @param {NavLinkProps.to} props.to n/a
* @param {NavLinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
*/ const $946e906b28ac6219$export$b0d92dbee9b5b60d = $jHEir.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = (0, $lfSRY.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $lfSRY.useLocation)();
    let routerNavigation = $jHEir.useContext((0, $3uzJP.DataRouterNavigationContext));
    let { navigator: navigator, basename: basename } = $jHEir.useContext((0, $3uzJP.NavigationContext));
    let isTransitioning = routerNavigation != null && $946e906b28ac6219$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerNavigation?.navigation.location ? routerNavigation.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $vjGlj.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(endSlashPosition) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $jHEir.createElement($946e906b28ac6219$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$946e906b28ac6219$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
* A progressively enhanced HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form)
* that submits data to actions via [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/fetch),
* activating pending states in {@link useNavigation} which enables advanced
* user interfaces beyond a basic HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form).
* After a form's `action` completes, all data on the page is automatically
* revalidated to keep the UI in sync with the data.
*
* Because it uses the HTML form API, server rendered pages are interactive at a
* basic level before JavaScript loads. Instead of React Router managing the
* submission, the browser manages the submission as well as the pending states
* (like the spinning favicon). After JavaScript loads, React Router takes over
* enabling web application user experiences.
*
* `Form` is most useful for submissions that should also change the URL or
* otherwise add an entry to the browser history stack. For forms that shouldn't
* manipulate the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, use {@link FetcherWithComponents.Form | `<fetcher.Form>`}.
*
* @example
* import { Form } from "react-router";
*
* function NewEvent() {
*   return (
*     <Form action="/events" method="post">
*       <input name="title" type="text" />
*       <input name="description" type="text" />
*     </Form>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param {FormProps.action} action n/a
* @param {FormProps.discover} discover n/a
* @param {FormProps.encType} encType n/a
* @param {FormProps.fetcherKey} fetcherKey n/a
* @param {FormProps.method} method n/a
* @param {FormProps.navigate} navigate n/a
* @param {FormProps.preventScrollReset} preventScrollReset n/a
* @param {FormProps.relative} relative n/a
* @param {FormProps.reloadDocument} reloadDocument n/a
* @param {FormProps.replace} replace n/a
* @param {FormProps.state} state n/a
* @param {FormProps.viewTransition} viewTransition n/a
* @param {FormProps.defaultShouldRevalidate} defaultShouldRevalidate n/a
* @returns A progressively enhanced [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) component
*/ const $946e906b28ac6219$export$a7fed597f4b8afd8 = $jHEir.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = "get", action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $jHEir.useContext((0, $3uzJP.NavigationContext));
    let submit = $946e906b28ac6219$export$47c85c6e3a081d3();
    let formAction = $946e906b28ac6219$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && (0, $8w9JA.ABSOLUTE_URL_REGEX).test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $jHEir.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $jHEir.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$946e906b28ac6219$export$a7fed597f4b8afd8.displayName = "Form";
/**
* Emulates the browser's scroll restoration on location changes. Apps should only render one of these, right before the {@link Scripts} component.
*
* ```tsx
* import { ScrollRestoration } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <body>
*         <ScrollRestoration />
*         <Scripts />
*       </body>
*     </html>
*   );
* }
* ```
*
* This component renders an inline `<script>` to prevent scroll flashing. The
* `nonce` prop will be passed down to the script tag to allow CSP nonce usage.
* If not provided in Framework Mode, it will default to any
* {@link ServerRouter | `<ServerRouter nonce>`} prop.
*
* ```tsx
* <ScrollRestoration nonce={cspNonce} />
* ```
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {ScrollRestorationProps.getKey} props.getKey n/a
* @param {ScriptsProps.nonce} props.nonce n/a
* @param {ScrollRestorationProps.storageKey} props.storageKey n/a
* @returns A [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tag that restores scroll positions on navigation.
*/ function $946e906b28ac6219$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $jHEir.useContext((0, $koI43.FrameworkContext));
    let { basename: basename } = $jHEir.useContext((0, $3uzJP.NavigationContext));
    let location = (0, $lfSRY.useLocation)();
    let matches = (0, $lfSRY.useMatches)();
    $946e906b28ac6219$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $jHEir.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $946e906b28ac6219$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let storedY = JSON.parse(sessionStorage.getItem(storageKey) || "{}")[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $jHEir.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${(0, $dr43k.escapeHtml)(JSON.stringify(storageKey || $946e906b28ac6219$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${(0, $dr43k.escapeHtml)(JSON.stringify(ssrKey))})`
        }
    });
}
$946e906b28ac6219$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
/**
* Handles the click behavior for router {@link Link | `<Link>`} components.This
* is useful if you need to create custom {@link Link | `<Link>`} components with
* the same click behavior we use in our exported {@link Link | `<Link>`}.
*
* @public
* @category Hooks
* @param to The URL to navigate to, can be a string or a partial {@link Path}.
* @param options Options
* @param options.preventScrollReset Whether to prevent the scroll position from
* being reset to the top of the viewport on completion of the navigation when
* using the {@link ScrollRestoration} component. Defaults to `false`.
* @param options.relative The {@link RelativeRoutingType | relative routing type}
* to use for the link. Defaults to `"route"`.
* @param options.replace Whether to replace the current [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry instead of pushing a new one. Defaults to `false`.
* @param options.state The state to add to the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry for this navigation. Defaults to `undefined`.
* @param options.target The target attribute for the link. Defaults to `undefined`.
* @param options.viewTransition **Deprecated.** Use React's
* [`<ViewTransition>`](https://react.dev/reference/react/ViewTransition) component
* instead. See the [migration guide](../../how-to/view-transitions).
* @param options.defaultShouldRevalidate Specify the default revalidation
* behavior for the navigation. When not specified, loaders revalidate
* according to the router's standard revalidation behavior.
* @param options.mask Masked location to display in the browser instead
* of the router location. Defaults to `undefined`.
* @param options.useTransitions Wraps the navigation in
* [`React.startTransition`](https://react.dev/reference/react/startTransition)
* for concurrent rendering. Defaults to `false`.
* @returns A click handler function that can be used in a custom {@link Link} component.
*/ function $946e906b28ac6219$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = (0, $lfSRY.useNavigate)();
    let location = (0, $lfSRY.useLocation)();
    let path = (0, $lfSRY.useResolvedPath)(to, {
        relative: relative
    });
    return $jHEir.useCallback((event)=>{
        if ((0, $6quj3.shouldProcessLinkClick)(event, target)) {
            event.preventDefault();
            let replace = replaceProp !== void 0 ? replaceProp : (0, $i4yVL.createPath)(location) === (0, $i4yVL.createPath)(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $jHEir.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
/**
* Returns a tuple of the current URL's [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them. Setting the search params causes a navigation.
*
* ```tsx
* import { useSearchParams } from "react-router";
*
* export function SomeComponent() {
*   const [searchParams, setSearchParams] = useSearchParams();
*   // ...
* }
* ```
*
* ### `setSearchParams` function
*
* The second element of the tuple is a function that can be used to update the
* search params. It accepts the same types as `defaultInit` and will cause a
* navigation to the new URL.
*
* ```tsx
* let [searchParams, setSearchParams] = useSearchParams();
*
* // a search param string
* setSearchParams("?tab=1");
*
* // a shorthand object
* setSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* setSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* setSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* setSearchParams(new URLSearchParams("?tab=1"));
* ```
*
* It also supports a function callback like React's
* [`setState`](https://react.dev/reference/react/useState#setstate):
*
* ```tsx
* setSearchParams((searchParams) => {
*   searchParams.set("tab", "2");
*   return searchParams;
* });
* ```
*
* <docs-warning>The function callback version of `setSearchParams` does not support
* the [queueing](https://react.dev/reference/react/useState#setstate-parameters)
* logic that React's `setState` implements.  Multiple calls to `setSearchParams`
* in the same tick will not build on the prior value.  If you need this behavior,
* you can use `setState` manually.</docs-warning>
*
* ### Notes
*
* Note that `searchParams` is a stable reference, so you can reliably use it
* as a dependency in React's [`useEffect`](https://react.dev/reference/react/useEffect)
* hooks.
*
* ```tsx
* useEffect(() => {
*   console.log(searchParams.get("tab"));
* }, [searchParams]);
* ```
*
* However, this also means it's mutable. If you change the object without
* calling `setSearchParams`, its values will change between renders if some
* other state causes the component to re-render and URL will not reflect the
* values.
*
* @public
* @category Hooks
* @param defaultInit
* You can initialize the search params with a default value, though it **will
* not** change the URL on the first render.
*
* ```tsx
* // a search param string
* useSearchParams("?tab=1");
*
* // a shorthand object
* useSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* useSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* useSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* useSearchParams(new URLSearchParams("?tab=1"));
* ```
* @returns A tuple of the current [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them.
*/ function $946e906b28ac6219$export$f1a78c17382fe22a(defaultInit) {
    (0, $i4yVL.warning)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    let defaultSearchParamsRef = $jHEir.useRef((0, $6quj3.createSearchParams)(defaultInit));
    let hasSetSearchParamsRef = $jHEir.useRef(false);
    let location = (0, $lfSRY.useLocation)();
    let searchParams = $jHEir.useMemo(()=>(0, $6quj3.getSearchParamsForLocation)(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $lfSRY.useNavigate)();
    return [
        searchParams,
        $jHEir.useCallback((nextInit, navigateOptions)=>{
            const newSearchParams = (0, $6quj3.createSearchParams)(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
            hasSetSearchParamsRef.current = true;
            navigate("?" + newSearchParams, navigateOptions);
        }, [
            navigate,
            searchParams
        ])
    ];
}
let $946e906b28ac6219$var$fetcherId = 0;
let $946e906b28ac6219$var$getUniqueFetcherId = ()=>`__${String(++$946e906b28ac6219$var$fetcherId)}__`;
/**
* The imperative version of {@link Form | `<Form>`} that lets you submit a form
* from code instead of a user interaction.
*
* The `viewTransition` submission option is deprecated. Use React's
* [`<ViewTransition>`](https://react.dev/reference/react/ViewTransition) component
* instead. See the [migration guide](../../how-to/view-transitions).
*
* @example
* import { useSubmit } from "react-router";
*
* function SomeComponent() {
*   const submit = useSubmit();
*   return (
*     <Form onChange={(event) => submit(event.currentTarget)} />
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns A function that can be called to submit a {@link Form} imperatively.
*/ function $946e906b28ac6219$export$47c85c6e3a081d3() {
    let { router: router } = (0, $lfSRY.useDataRouterContext)("useSubmit");
    let { basename: basename } = $jHEir.useContext((0, $3uzJP.NavigationContext));
    let currentRouteId = (0, $lfSRY.useCurrentRouteId)("useSubmit");
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $jHEir.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = (0, $6quj3.getFormSubmissionInfo)(target, basename);
        if (options.navigate === false) await routerFetch(options.fetcherKey || $946e906b28ac6219$var$getUniqueFetcherId(), currentRouteId, options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            relative: options.relative,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            flushSync: options.flushSync
        });
        else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            relative: options.relative,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
/**
* Resolves the URL to the closest route in the component hierarchy instead of
* the current URL of the app.
*
* This is used internally by {@link Form} to resolve the `action` to the closest
* route, but can be used generically as well.
*
* ```ts
* import { useFormAction } from "react-router";
*
* function SomeComponent() {
*   // closest route URL
*   let action = useFormAction();
*
*   // closest route URL + "destroy"
*   let destroyAction = useFormAction("destroy");
* }
* ```
*
* <docs-info>This hook adds a `basename` if your app specifies one, so that it
* can be used with raw `<form>` elements in a progressively enhanced way.  If
* you are using this to provide an `action` to `<Form>` or `fetcher.submit`, you
* will need to remove the `basename` since both of those will prepend it
* internally.</docs-info>
*
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param action The action to append to the closest route URL. Defaults to the
* closest route URL.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* action. Defaults to `"route"`.
* @returns The resolved action URL.
*/ function $946e906b28ac6219$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $jHEir.useContext((0, $3uzJP.NavigationContext));
    let routeContext = $jHEir.useContext((0, $3uzJP.RouteContext));
    (0, $i4yVL.invariant)(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...(0, $lfSRY.useResolvedPath)(action ? action : ".", {
            relative: relative
        })
    };
    let location = (0, $lfSRY.useLocation)();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        if (indexValues.some((v)=>v === "")) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $vjGlj.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $i4yVL.createPath)(path);
}
/**
* Useful for creating complex, dynamic user interfaces that require multiple,
* concurrent data interactions without causing a navigation.
*
* Fetchers track their own, independent state and can be used to load data, submit
* forms, and generally interact with [`action`](../../start/framework/route-module#action)
* and [`loader`](../../start/framework/route-module#loader) functions.
*
* @example
* import { useFetcher } from "react-router"
*
* function SomeComponent() {
*   let fetcher = useFetcher()
*
*   // states are available on the fetcher
*   fetcher.state // "idle" | "loading" | "submitting"
*   fetcher.data // the data returned from the action or loader
*
*   // render a form
*   <fetcher.Form method="post" />
*
*   // load data
*   fetcher.load("/some/route")
*
*   // submit data
*   fetcher.submit(someFormRef, { method: "post" })
*   fetcher.submit(someData, {
*     method: "post",
*     encType: "application/json"
*   })
*
*   // reset fetcher
*   fetcher.reset()
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.key A unique key to identify the fetcher.
*
*
* By default, `useFetcher` generates a unique fetcher scoped to that component.
* If you want to identify a fetcher with your own key such that you can access
* it from elsewhere in your app, you can do that with the `key` option:
*
* ```tsx
* function SomeComp() {
*   let fetcher = useFetcher({ key: "my-key" })
*   // ...
* }
*
* // Somewhere else
* function AnotherComp() {
*   // this will be the same fetcher, sharing the state across the app
*   let fetcher = useFetcher({ key: "my-key" });
*   // ...
* }
* ```
* @returns A {@link FetcherWithComponents} object that contains the fetcher's state, data, and components for submitting forms and loading data.
*/ function $946e906b28ac6219$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = (0, $lfSRY.useDataRouterContext)("useFetcher");
    let fetchersContext = (0, $lfSRY.useDataRouterFetchers)("useFetcher");
    let routeId = (0, $lfSRY.useCurrentRouteId)("useFetcher");
    let defaultKey = $jHEir.useId();
    let [fetcherKey, setFetcherKey] = $jHEir.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $jHEir.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $jHEir.useCallback(async (href, opts)=>{
        (0, $i4yVL.invariant)(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $946e906b28ac6219$export$47c85c6e3a081d3();
    let submit = $jHEir.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $jHEir.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $jHEir.useMemo(()=>{
        let FetcherForm = $jHEir.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $jHEir.createElement($946e906b28ac6219$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    let fetcher = fetchersContext.fetchers.get(fetcherKey) || (0, $6WCgj.IDLE_FETCHER);
    let data = fetchersContext.fetcherData.get(fetcherKey);
    return $jHEir.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data
    ]);
}
/**
* Returns an array of all in-flight {@link Fetcher}s. This is useful for components
* throughout the app that didn't create the fetchers but want to use their submissions
* to participate in optimistic UI.
*
* @example
* import { useFetchers } from "react-router";
*
* function SomeComponent() {
*   const fetchers = useFetchers();
*   fetchers[0].formData; // FormData
*   fetchers[0].state; // etc.
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of all in-flight {@link Fetcher}s, each with a unique `key`
* property.
*/ function $946e906b28ac6219$export$fa996778a3a31087() {
    let { fetchers: fetchers } = (0, $lfSRY.useDataRouterFetchers)("useFetchers");
    return $jHEir.useMemo(()=>Array.from(fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        fetchers
    ]);
}
const $946e906b28ac6219$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $946e906b28ac6219$var$savedScrollPositions = {};
function $946e906b28ac6219$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: (0, $vjGlj.stripBasename)(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
/**
* When rendered inside a {@link RouterProvider}, will restore scroll positions
* on navigations
*
* <!--
* Not marked `@public` because we only export as UNSAFE_ and therefore we don't
* maintain an .md file for this hook
* -->
*
* @name UNSAFE_useScrollRestoration
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.getKey A function that returns a key to use for scroll restoration.
* This is useful for custom scroll restoration logic, such as using only the pathname
* so that subsequent navigations to prior paths will restore the scroll. Defaults
* to `location.key`.
* @param options.storageKey The key to use for storing scroll positions in
* `sessionStorage`. Defaults to `"react-router-scroll-positions"`.
* @returns {void}
*/ function $946e906b28ac6219$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = (0, $lfSRY.useDataRouterContext)("useScrollRestoration");
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = (0, $lfSRY.useDataRouterState)("useScrollRestoration");
    let { basename: basename } = $jHEir.useContext((0, $3uzJP.NavigationContext));
    let location = (0, $lfSRY.useLocation)();
    let matches = (0, $lfSRY.useMatches)();
    let navigation = (0, $lfSRY.useNavigation)();
    $jHEir.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $946e906b28ac6219$var$usePageShow($jHEir.useCallback((event)=>{
        if (event.persisted) window.history.scrollRestoration = "manual";
    }, []));
    $946e906b28ac6219$var$usePageHide($jHEir.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $946e906b28ac6219$var$getScrollRestorationKey(location, matches, basename, getKey);
            $946e906b28ac6219$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $946e906b28ac6219$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($946e906b28ac6219$var$savedScrollPositions));
        } catch (error) {
            (0, $i4yVL.warning)(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $jHEir.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $946e906b28ac6219$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $946e906b28ac6219$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch  {}
        }, [
            storageKey
        ]);
        $jHEir.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($946e906b28ac6219$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location, matches)=>$946e906b28ac6219$var$getScrollRestorationKey(location, matches, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $jHEir.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                (0, $i4yVL.warning)(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
* Set up a callback to be fired on [Window's `beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event).
*
* @public
* @category Hooks
* @param callback The callback to be called when the [`beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event)
* is fired.
* @param options Options
* @param options.capture If `true`, the event will be captured during the capture
* phase. Defaults to `false`.
* @returns {void}
*/ function $946e906b28ac6219$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $jHEir.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $946e906b28ac6219$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $jHEir.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $946e906b28ac6219$var$usePageShow(callback, options) {
    let { capture: capture } = options || {};
    $jHEir.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pageshow", callback, opts);
        return ()=>{
            window.removeEventListener("pageshow", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
* Wrapper around {@link useBlocker} to show a [`window.confirm`](https://developer.mozilla.org/en-US/docs/Web/API/Window/confirm)
* prompt to users instead of building a custom UI with {@link useBlocker}.
*
* The `unstable_` flag will not be removed because this technique has a lot of
* rough edges and behaves very differently (and incorrectly sometimes) across
* browsers if users click addition back/forward navigations while the
* confirmation is open. Use at your own risk.
*
* @example
* function ImportantForm() {
*   let [value, setValue] = React.useState("");
*
*   // Block navigating elsewhere when data has been entered into the input
*   unstable_usePrompt({
*     message: "Are you sure?",
*     when: ({ currentLocation, nextLocation }) =>
*       value !== "" &&
*       currentLocation.pathname !== nextLocation.pathname,
*   });
*
*   return (
*     <Form method="post">
*       <label>
*         Enter some important data:
*         <input
*           name="data"
*           value={value}
*           onChange={(e) => setValue(e.target.value)}
*         />
*       </label>
*       <button type="submit">Save</button>
*     </Form>
*   );
* }
*
* @name unstable_usePrompt
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.message The message to show in the confirmation dialog.
* @param options.when A boolean or a function that returns a boolean indicating
* whether to block the navigation. If a function is provided, it will receive an
* object with `currentLocation` and `nextLocation` properties.
* @returns {void}
*/ function $946e906b28ac6219$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = (0, $lfSRY.useBlocker)(when);
    $jHEir.useEffect(()=>{
        if (blocker.state === "blocked") {
            if (window.confirm(message)) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $jHEir.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
* **Deprecated.** Use React's [`<ViewTransition>`](https://react.dev/reference/react/ViewTransition)
* component to style transitions instead. This hook only tracks React Router's
* legacy view transitions, not transitions started by React. See the
* [migration guide](../../how-to/view-transitions).
*
* This hook returns `true` when there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the specified location matches either side of the navigation (the URL you are
* navigating **to** or the URL you are navigating **from**). This can be used to apply finer-grained styles to
* elements to further customize the view transition. This requires that view
* transitions have been enabled for the given navigation via {@link LinkProps.viewTransition}
* (or the `Form`, `submit`, or `navigate` call)
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param to The {@link To} location to compare against the active transition's current
* and next URLs.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* `to` location, defaults to `"route"`. See {@link RelativeRoutingType} for
* more details.
* @returns `true` if there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the resolved path matches the transition's destination or source pathname, otherwise `false`.
*
* @deprecated Use React's `<ViewTransition>` component instead.
*/ function $946e906b28ac6219$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $jHEir.useContext((0, $3uzJP.ViewTransitionContext));
    (0, $i4yVL.invariant)(vtContext != null, "`useViewTransitionState` must be used within `react-router/dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = (0, $lfSRY.useDataRouterContext)("useViewTransitionState");
    let path = (0, $lfSRY.useResolvedPath)(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $vjGlj.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $vjGlj.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return (0, $vjGlj.matchPath)(path.pathname, nextPath) != null || (0, $vjGlj.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("8w9JA", function(module, exports) {

$parcel$export(module.exports, "ABSOLUTE_URL_REGEX", function () { return $6338dce65ff53c70$export$6c52c2011d568bd0; });
$parcel$export(module.exports, "PROTOCOL_RELATIVE_URL_REGEX", function () { return $6338dce65ff53c70$export$825a82322d91916e; });
$parcel$export(module.exports, "normalizeProtocolRelativeUrl", function () { return $6338dce65ff53c70$export$977999b735cd4f26; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/url.ts
const $6338dce65ff53c70$export$6c52c2011d568bd0 = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
const $6338dce65ff53c70$export$825a82322d91916e = /^[\\/]{2}/;
function $6338dce65ff53c70$export$977999b735cd4f26(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}

});

parcelRegister("i4yVL", function(module, exports) {

$parcel$export(module.exports, "createMemoryHistory", function () { return $d283b23e44edd9d8$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createLocation", function () { return $d283b23e44edd9d8$export$90c043f1c57770b8; });
$parcel$export(module.exports, "warning", function () { return $d283b23e44edd9d8$export$491112666e282270; });
$parcel$export(module.exports, "createPath", function () { return $d283b23e44edd9d8$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $d283b23e44edd9d8$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $d283b23e44edd9d8$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $d283b23e44edd9d8$export$b71fdd3798280242; });
$parcel$export(module.exports, "invariant", function () { return $d283b23e44edd9d8$export$f5708dca728d7177; });
$parcel$export(module.exports, "createBrowserURLImpl", function () { return $d283b23e44edd9d8$export$e2450fce17852bf2; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8w9JA = parcelRequire("8w9JA");
//#region lib/router/history.ts
/**
* Actions represent the type of change to a location value.
*/ let $d283b23e44edd9d8$export$e19cd5f9376f8cee = /* @__PURE__ */ function(Action) {
    /**
	* A POP indicates a change to an arbitrary index in the history stack, such
	* as a back or forward navigation. It does not describe the direction of the
	* navigation, only that the current index changed.
	*
	* Note: This is the default action for newly created history objects.
	*/ Action["Pop"] = "POP";
    /**
	* A PUSH indicates a new entry being added to the history stack, such as when
	* a link is clicked and a new page loads. When this happens, all subsequent
	* entries in the stack are lost.
	*/ Action["Push"] = "PUSH";
    /**
	* A REPLACE indicates the entry at the current index in the history stack
	* being replaced by a new one.
	*/ Action["Replace"] = "REPLACE";
    return Action;
}({});
const $d283b23e44edd9d8$var$PopStateEventType = "popstate";
function $d283b23e44edd9d8$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
/**
* Memory history stores the current location in memory. It is designed for use
* in stateful non-browser environments like tests and React Native.
*/ function $d283b23e44edd9d8$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP";
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $d283b23e44edd9d8$export$90c043f1c57770b8(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $d283b23e44edd9d8$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $d283b23e44edd9d8$export$fe53371bee54353d(to);
    }
    return {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $d283b23e44edd9d8$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH";
            let nextLocation = $d283b23e44edd9d8$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE";
            let nextLocation = $d283b23e44edd9d8$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP";
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
}
/**
* Browser history stores the location in regular URLs. This is the standard for
* most web apps, but it requires some configuration on the server to ensure you
* serve the same app at multiple URLs.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
*/ function $d283b23e44edd9d8$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window.location;
        return $d283b23e44edd9d8$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash
        } : void 0);
    }
    function createBrowserHref(window, to) {
        return typeof to === "string" ? to : $d283b23e44edd9d8$export$fe53371bee54353d(to);
    }
    return $d283b23e44edd9d8$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
* Hash history stores the location in window.location.hash. This makes it ideal
* for situations where you don't want to send the location to the server for
* some reason, either because you do cannot configure it or the URL space is
* reserved for something else.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
*/ function $d283b23e44edd9d8$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $d283b23e44edd9d8$export$8ccf933b0513f8d0(window.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $d283b23e44edd9d8$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window, to) {
        let base = window.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $d283b23e44edd9d8$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $d283b23e44edd9d8$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $d283b23e44edd9d8$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $d283b23e44edd9d8$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $d283b23e44edd9d8$export$491112666e282270(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch  {}
    }
}
function $d283b23e44edd9d8$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
/**
* For browser-based histories, we combine the state and key into an object
*/ function $d283b23e44edd9d8$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
/**
* Creates a Location object with a unique key from the given Path
*/ function $d283b23e44edd9d8$export$90c043f1c57770b8(current, to, state = null, key, mask) {
    return {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $d283b23e44edd9d8$export$8ccf933b0513f8d0(to) : to,
        state: state,
        key: to && to.key || key || $d283b23e44edd9d8$var$createKey(),
        mask: mask
    };
}
/**
* Creates a string URL path from the given pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The pathname, search, and hash components to combine.
* @returns The combined URL path.
*/ function $d283b23e44edd9d8$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
* Parses a string URL path into its separate pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The URL path to parse.
* @returns The parsed pathname, search, and hash components.
*/ function $d283b23e44edd9d8$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $d283b23e44edd9d8$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options = {}) {
    let { window: window = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window.history;
    let action = "POP";
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        return (globalHistory.state || {
            idx: null
        }).idx;
    }
    function handlePop() {
        action = "POP";
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH";
        let location = $d283b23e44edd9d8$var$isLocation(to) ? to : $d283b23e44edd9d8$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $d283b23e44edd9d8$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = "REPLACE";
        let location = $d283b23e44edd9d8$var$isLocation(to) ? to : $d283b23e44edd9d8$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $d283b23e44edd9d8$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $d283b23e44edd9d8$export$e2450fce17852bf2(window, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window.addEventListener($d283b23e44edd9d8$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window.removeEventListener($d283b23e44edd9d8$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $d283b23e44edd9d8$export$e2450fce17852bf2(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $d283b23e44edd9d8$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $d283b23e44edd9d8$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && (0, $8w9JA.PROTOCOL_RELATIVE_URL_REGEX).test(href)) href = base + href;
    return new URL(href, base);
}

});

parcelRegister("vjGlj", function(module, exports) {

$parcel$export(module.exports, "createContext", function () { return $05e229ca209f5114$export$fd42f52fd3ae1109; });
$parcel$export(module.exports, "RouterContextProvider", function () { return $05e229ca209f5114$export$b8d3e69d4b3eff04; });
$parcel$export(module.exports, "DiscoveryCancelledError", function () { return $05e229ca209f5114$export$96cecaff35fb119d; });
$parcel$export(module.exports, "isUnsupportedLazyRouteObjectKey", function () { return $05e229ca209f5114$export$3e22299e33adeed1; });
$parcel$export(module.exports, "isUnsupportedLazyRouteFunctionKey", function () { return $05e229ca209f5114$export$a89d811eaa209e85; });
$parcel$export(module.exports, "defaultMapRouteProperties", function () { return $05e229ca209f5114$export$6bc17138063be773; });
$parcel$export(module.exports, "convertRoutesToDataRoutes", function () { return $05e229ca209f5114$export$87cb1a9238dc3fba; });
$parcel$export(module.exports, "matchRoutes", function () { return $05e229ca209f5114$export$2708184779ceb39d; });
$parcel$export(module.exports, "matchRoutesImpl", function () { return $05e229ca209f5114$export$5c7b09132f833c25; });
$parcel$export(module.exports, "stripBasename", function () { return $05e229ca209f5114$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "flattenAndRankRoutes", function () { return $05e229ca209f5114$export$e486c0390e42ccf6; });
$parcel$export(module.exports, "decodePath", function () { return $05e229ca209f5114$export$cd27bea214d030c2; });
$parcel$export(module.exports, "convertRouteMatchToUiMatch", function () { return $05e229ca209f5114$export$fcf533780bf49ee2; });
$parcel$export(module.exports, "joinPaths", function () { return $05e229ca209f5114$export$86d9a7913e44197e; });
$parcel$export(module.exports, "compilePath", function () { return $05e229ca209f5114$export$d726f29eb2425705; });
$parcel$export(module.exports, "explodeOptionalSegments", function () { return $05e229ca209f5114$export$82472424e06ad5c9; });
$parcel$export(module.exports, "matchPath", function () { return $05e229ca209f5114$export$81336c211d5ff295; });
$parcel$export(module.exports, "normalizePathname", function () { return $05e229ca209f5114$export$a5c6d149b50c1d86; });
$parcel$export(module.exports, "prependBasename", function () { return $05e229ca209f5114$export$e9a5bfadbc179142; });
$parcel$export(module.exports, "isAbsoluteUrl", function () { return $05e229ca209f5114$export$a1cbf2de32a9fd1; });
$parcel$export(module.exports, "removeDoubleSlashes", function () { return $05e229ca209f5114$export$f857a07c5bd323b8; });
$parcel$export(module.exports, "getPathContributingMatches", function () { return $05e229ca209f5114$export$b234c29a3bb68fc8; });
$parcel$export(module.exports, "getResolveToMatches", function () { return $05e229ca209f5114$export$fe6dbc5de95f53ab; });
$parcel$export(module.exports, "resolveTo", function () { return $05e229ca209f5114$export$cae722b0cc860f13; });
$parcel$export(module.exports, "data", function () { return $05e229ca209f5114$export$4051a07651545597; });
$parcel$export(module.exports, "redirect", function () { return $05e229ca209f5114$export$89e12c5b50f7529d; });
$parcel$export(module.exports, "SUPPORTED_ERROR_TYPES", function () { return $05e229ca209f5114$export$1a235bd2b33434e5; });
$parcel$export(module.exports, "ErrorResponseImpl", function () { return $05e229ca209f5114$export$f2680fa305b734ca; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $05e229ca209f5114$export$972111febbeef05b; });
$parcel$export(module.exports, "getRoutePattern", function () { return $05e229ca209f5114$export$d738435097971c09; });
$parcel$export(module.exports, "createDataFunctionUrl", function () { return $05e229ca209f5114$export$141d98e45b4b08e4; });
$parcel$export(module.exports, "isBrowser", function () { return $05e229ca209f5114$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "parseToInfo", function () { return $05e229ca209f5114$export$ac5aeb949e84fd96; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8w9JA = parcelRequire("8w9JA");

var $i4yVL = parcelRequire("i4yVL");

var $jHEir = parcelRequire("jHEir");
//#region lib/router/utils.ts
/**
* Creates a type-safe {@link RouterContext} object that can be used to
* store and retrieve arbitrary values in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
* Similar to React's [`createContext`](https://react.dev/reference/react/createContext),
* but specifically designed for React Router's request/response lifecycle.
*
* If a `defaultValue` is provided, it will be returned from `context.get()`
* when no value has been set for the context. Otherwise, reading this context
* when no value has been set will throw an error.
*
* ```tsx filename=app/context.ts
* import { createContext } from "react-router";
*
* // Create a context for user data
* export const userContext =
*   createContext<User | null>(null);
* ```
*
* ```tsx filename=app/middleware/auth.ts
* import { getUserFromSession } from "~/auth.server";
* import { userContext } from "~/context";
*
* export const authMiddleware = async ({
*   context,
*   request,
* }) => {
*   const user = await getUserFromSession(request);
*   context.set(userContext, user);
* };
* ```
*
* ```tsx filename=app/routes/profile.tsx
* import { userContext } from "~/context";
*
* export async function loader({
*   context,
* }: Route.LoaderArgs) {
*   const user = context.get(userContext);
*
*   if (!user) {
*     throw new Response("Unauthorized", { status: 401 });
*   }
*
*   return { user };
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param defaultValue An optional default value for the context. This value
* will be returned if no value has been set for this context.
* @returns A {@link RouterContext} object that can be used with
* `context.get()` and `context.set()` in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
*/ function $05e229ca209f5114$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
/**
* Provides methods for writing/reading values in application context in a
* type-safe way. Primarily for usage with [middleware](../../how-to/middleware).
*
* @example
* import {
*   createContext,
*   RouterContextProvider
* } from "react-router";
*
* const userContext = createContext<User | null>(null);
* const contextProvider = new RouterContextProvider();
* contextProvider.set(userContext, getUser());
* //                               ^ Type-safe
* const user = contextProvider.get(userContext);
* //    ^ User
*
* @public
* @category Utils
* @mode framework
* @mode data
*/ var $05e229ca209f5114$export$b8d3e69d4b3eff04 = class {
    #map = /* @__PURE__ */ new Map();
    /**
	* Create a new `RouterContextProvider` instance
	* @param init An optional initial context map to populate the provider with
	*/ constructor(init){
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
	* Access a value from the context. If no value has been set for the context,
	* it will return the context's `defaultValue` if provided, or throw an error
	* if no `defaultValue` was set.
	* @param context The context to get the value for
	* @returns The value for the context, or the context's `defaultValue` if no
	* value was set
	*/ get(context) {
        if (this.#map.has(context)) return this.#map.get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
	* Set a value for the context. If the context already has a value set, this
	* will overwrite it.
	*
	* @param context The context to set the value for
	* @param value The value to set for the context
	* @returns {void}
	*/ set(context, value) {
        this.#map.set(context, value);
    }
};
var $05e229ca209f5114$export$96cecaff35fb119d = class extends Error {
};
const $05e229ca209f5114$var$unsupportedLazyRouteObjectKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children",
    "unstable_validateParams"
]);
function $05e229ca209f5114$export$3e22299e33adeed1(key) {
    return $05e229ca209f5114$var$unsupportedLazyRouteObjectKeys.has(key);
}
const $05e229ca209f5114$var$unsupportedLazyRouteFunctionKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children",
    "unstable_validateParams"
]);
function $05e229ca209f5114$export$a89d811eaa209e85(key) {
    return $05e229ca209f5114$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $05e229ca209f5114$var$isIndexRoute(route) {
    return route.index === true;
}
function $05e229ca209f5114$export$6bc17138063be773(route) {
    let updates = {};
    if (route.Component) Object.assign(updates, {
        element: $jHEir.createElement(route.Component),
        Component: void 0
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: $jHEir.createElement(route.HydrateFallback),
        HydrateFallback: void 0
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: $jHEir.createElement(route.ErrorBoundary),
        ErrorBoundary: void 0
    });
    return updates;
}
function $05e229ca209f5114$export$87cb1a9238dc3fba(routes, mapRouteProperties = $05e229ca209f5114$export$6bc17138063be773, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        (0, $i4yVL.invariant)(route.index !== true || !route.children, `Cannot specify children on an index route`);
        (0, $i4yVL.invariant)(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($05e229ca209f5114$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $05e229ca209f5114$var$mergeRouteUpdates(indexRoute, mapRouteProperties(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $05e229ca209f5114$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $05e229ca209f5114$export$87cb1a9238dc3fba(route.children, mapRouteProperties, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $05e229ca209f5114$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
/**
* Matches the given routes to a location and returns the match data.
*
* @example
* import { matchRoutes } from "react-router";
*
* let routes = [{
*   path: "/",
*   Component: Root,
*   children: [{
*     path: "dashboard",
*     Component: Dashboard,
*   }]
* }];
*
* matchRoutes(routes, "/dashboard"); // [rootMatch, dashboardMatch]
*
* @public
* @category Utils
* @param routes The array of route objects to match against.
* @param locationArg The location to match against, either a string path or a
* partial {@link Location} object
* @param basename Optional base path to strip from the location before matching.
* Defaults to `/`.
* @returns An array of matched routes, or `null` if no matches were found.
*/ function $05e229ca209f5114$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $05e229ca209f5114$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $05e229ca209f5114$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let pathname = $05e229ca209f5114$export$b69e3301ce081aa3((typeof locationArg === "string" ? (0, $i4yVL.parsePath)(locationArg) : locationArg).pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $05e229ca209f5114$export$e486c0390e42ccf6(routes);
    let matches = null;
    let decoded = $05e229ca209f5114$export$cd27bea214d030c2(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $05e229ca209f5114$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $05e229ca209f5114$export$fcf533780bf49ee2(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $05e229ca209f5114$export$e486c0390e42ccf6(routes) {
    let branches = $05e229ca209f5114$var$flattenRoutes(routes);
    $05e229ca209f5114$var$rankRouteBranches(branches);
    return branches;
}
function $05e229ca209f5114$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            (0, $i4yVL.invariant)(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $05e229ca209f5114$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            (0, $i4yVL.invariant)(route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $05e229ca209f5114$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $05e229ca209f5114$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta, i)=>{
                let [matcher, params] = $05e229ca209f5114$export$d726f29eb2425705(meta.relativePath, meta.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $05e229ca209f5114$export$82472424e06ad5c9(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $05e229ca209f5114$export$82472424e06ad5c9(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $05e229ca209f5114$export$82472424e06ad5c9(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $05e229ca209f5114$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $05e229ca209f5114$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $05e229ca209f5114$var$paramRe = /^:[\w-]+$/;
const $05e229ca209f5114$var$partialParamRe = /^:[\w-]+/;
const $05e229ca209f5114$var$partialDynamicSegmentValue = 3.5;
const $05e229ca209f5114$var$dynamicSegmentValue = 3;
const $05e229ca209f5114$var$indexRouteValue = 2;
const $05e229ca209f5114$var$emptySegmentValue = 1;
const $05e229ca209f5114$var$staticSegmentValue = 10;
const $05e229ca209f5114$var$splatPenalty = -2;
const $05e229ca209f5114$var$isSplat = (s)=>s === "*";
function $05e229ca209f5114$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($05e229ca209f5114$var$isSplat)) initialScore += $05e229ca209f5114$var$splatPenalty;
    if (index) initialScore += $05e229ca209f5114$var$indexRouteValue;
    return segments.filter((s)=>!$05e229ca209f5114$var$isSplat(s)).reduce((score, segment)=>score + ($05e229ca209f5114$var$paramRe.test(segment) ? $05e229ca209f5114$var$dynamicSegmentValue : $05e229ca209f5114$var$partialParamRe.test(segment) ? $05e229ca209f5114$var$partialDynamicSegmentValue : segment === "" ? $05e229ca209f5114$var$emptySegmentValue : $05e229ca209f5114$var$staticSegmentValue), initialScore);
}
function $05e229ca209f5114$var$compareIndexes(a, b) {
    return a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]) ? a[a.length - 1] - b[b.length - 1] : 0;
}
function $05e229ca209f5114$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = meta.matcher && meta.compiledParams ? $05e229ca209f5114$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $05e229ca209f5114$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $05e229ca209f5114$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            params: matchedParams,
            pathname: $05e229ca209f5114$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $05e229ca209f5114$export$a5c6d149b50c1d86($05e229ca209f5114$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $05e229ca209f5114$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
* Characters that `encodeURIComponent` escapes but that are valid literally in
* a URL path segment. Per RFC 3986 §3.3, a path segment is made of `pchar`:
*
* ```
* pchar = unreserved / pct-encoded / sub-delims / ":" / "@"
* sub-delims = "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
* ```
*
* `encodeURIComponent` targets query-string values, where `$ & + , ; = : @`
* are delimiters and must be escaped — but in a path segment they carry no
* special meaning, and browsers keep them literal in `location.pathname`.
* (`! ' ( ) *` and the unreserved set are already left alone by
* `encodeURIComponent`, so they need no restoring.)
*/ const $05e229ca209f5114$var$PATH_PARAM_OVERESCAPED = {
    "%24": "$",
    "%26": "&",
    "%2B": "+",
    "%2C": ",",
    "%3A": ":",
    "%3B": ";",
    "%3D": "=",
    "%40": "@"
};
/**
* Encodes a param value for interpolation into a single URL path segment.
*
* Escapes characters that would break the path (`/ ? # %`, whitespace,
* non-ASCII, …) while leaving characters that RFC 3986 permits literally in a
* path segment untouched. Escaping those would needlessly rewrite URLs — e.g.
*  a semver build param `1.0.0+1` would become `1.0.0%2B1` even though browsers
* display and match the `+` literally in `location.pathname`.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3))
*
* @param value The param value to encode.
* @returns The encoded value, safe for use as a single path segment.
*/ function $05e229ca209f5114$export$1adf7db041bd81b8(value) {
    return encodeURIComponent(value).replace(/%(?:24|26|2B|2C|3A|3B|3D|40)/g, (match)=>$05e229ca209f5114$var$PATH_PARAM_OVERESCAPED[match]);
}
/**
* Returns a path with params interpolated.
*
* Param values are percent-encoded for use in a path segment: characters that
* would change the URL structure (`/`, `?`, `#`, `%`, whitespace, non-ASCII)
* are escaped, while characters that RFC 3986 allows literally in a path
* segment (`$ & + , ; = : @`) are kept as-is. Note this differs from query-string
* encoding (`encodeURIComponent`/`URLSearchParams`), where those characters are
* delimiters and must be escaped. Splat (`*`) values are encoded per segment,
* preserving `/` separators.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3)
*
* @example
* import { generatePath } from "react-router";
*
* generatePath("/users/:id", { id: "123" }); // "/users/123"
* generatePath("/files/:name", { name: "a b" }); // "/files/a%20b"
* generatePath("/releases/:v", { v: "1.0.0+1" }); // "/releases/1.0.0+1"
*
* @public
* @category Utils
* @param originalPath The original path to generate.
* @param params The parameters to interpolate into the path.
* @returns The generated path with parameters interpolated.
*/ function $05e229ca209f5114$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        (0, $i4yVL.warning)(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    return prefix + path.split(/\/+/).map((segment, index, array)=>{
        if (index === array.length - 1 && segment === "*") return stringify(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            (0, $i4yVL.invariant)(optional === "?" || param != null, `Missing ":${key}" param`);
            return $05e229ca209f5114$export$1adf7db041bd81b8(stringify(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment).join("/");
}
/**
* Performs pattern matching on a URL pathname and returns information about
* the match.
*
* @public
* @category Utils
* @param pattern The pattern to match against the URL pathname. This can be a
* string or a {@link PathPattern} object. If a string is provided, it will be
* treated as a pattern with `caseSensitive` set to `false` and `end` set to
* `true`.
* @param pathname The URL pathname to match against the pattern.
* @returns A path match object if the pattern matches the pathname,
* or `null` if it does not match.
*/ function $05e229ca209f5114$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $05e229ca209f5114$export$d726f29eb2425705(pattern.path, pattern.caseSensitive, pattern.end);
    return $05e229ca209f5114$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $05e229ca209f5114$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = $05e229ca209f5114$export$b6d465111d914331(matchedPathname, 1);
    let captureGroups = match.slice(1);
    return {
        params: compiledParams.reduce((memo, { paramName: paramName, isOptional: isOptional }, index)=>{
            if (paramName === "*") {
                let splatValue = captureGroups[index] || "";
                pathnameBase = $05e229ca209f5114$export$b6d465111d914331(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
            }
            const value = captureGroups[index];
            if (isOptional && !value) memo[paramName] = void 0;
            else memo[paramName] = (value || "").replace(/%2F/g, "/");
            return memo;
        }, {}),
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $05e229ca209f5114$export$d726f29eb2425705(path, caseSensitive = false, end = true) {
    (0, $i4yVL.warning)(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/((?:[^/?()[\]*^\\]|\\.)+)\?(?=\/|$|\()/g, "(?:/$1)?");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    return [
        new RegExp(regexpSource, caseSensitive ? void 0 : "i"),
        params
    ];
}
function $05e229ca209f5114$export$cd27bea214d030c2(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        (0, $i4yVL.warning)(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $05e229ca209f5114$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $05e229ca209f5114$export$e9a5bfadbc179142({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $05e229ca209f5114$export$86d9a7913e44197e([
        basename,
        pathname
    ]);
}
const $05e229ca209f5114$export$a1cbf2de32a9fd1 = (url)=>(0, $8w9JA.ABSOLUTE_URL_REGEX).test(url);
/**
* Returns a resolved {@link Path} object relative to the given pathname.
*
* @public
* @category Utils
* @param to The path to resolve, either a string or a partial {@link Path}
* object.
* @param fromPathname The pathname to resolve the path from. Defaults to `/`.
* @returns A {@link Path} object with the resolved pathname, search, and hash.
*/ function $05e229ca209f5114$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? (0, $i4yVL.parsePath)(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $05e229ca209f5114$export$f857a07c5bd323b8(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = $05e229ca209f5114$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $05e229ca209f5114$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $05e229ca209f5114$var$normalizeSearch(search),
        hash: $05e229ca209f5114$var$normalizeHash(hash)
    };
}
function $05e229ca209f5114$var$resolvePathname(relativePath, fromPathname) {
    let segments = $05e229ca209f5114$export$b6d465111d914331(fromPathname).split("/");
    relativePath.split("/").forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $05e229ca209f5114$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $05e229ca209f5114$export$b234c29a3bb68fc8(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $05e229ca209f5114$export$fe6dbc5de95f53ab(matches) {
    let pathMatches = $05e229ca209f5114$export$b234c29a3bb68fc8(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $05e229ca209f5114$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = (0, $i4yVL.parsePath)(toArg);
    else {
        to = {
            ...toArg
        };
        (0, $i4yVL.invariant)(!to.pathname || !to.pathname.includes("?"), $05e229ca209f5114$var$getInvalidPathError("?", "pathname", "search", to));
        (0, $i4yVL.invariant)(!to.pathname || !to.pathname.includes("#"), $05e229ca209f5114$var$getInvalidPathError("#", "pathname", "hash", to));
        (0, $i4yVL.invariant)(!to.search || !to.search.includes("#"), $05e229ca209f5114$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $05e229ca209f5114$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
const $05e229ca209f5114$export$f857a07c5bd323b8 = (path)=>path.replace(/[\\/]{2,}/g, "/");
const $05e229ca209f5114$export$86d9a7913e44197e = (paths)=>$05e229ca209f5114$export$f857a07c5bd323b8(paths.join("/"));
function $05e229ca209f5114$export$b6d465111d914331(path, minLength = 0) {
    let end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
const $05e229ca209f5114$export$a5c6d149b50c1d86 = (pathname)=>$05e229ca209f5114$export$b6d465111d914331(pathname).replace(/^\/*/, "/");
const $05e229ca209f5114$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
const $05e229ca209f5114$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $05e229ca209f5114$var$DataWithResponseInit = class {
    type = "DataWithResponseInit";
    data;
    init;
    constructor(data, init){
        this.data = data;
        this.init = init || null;
    }
};
/**
* Create "responses" that contain `headers`/`status` without forcing
* serialization into an actual [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
*
* @example
* import { data } from "react-router";
*
* export async function action({ request }: Route.ActionArgs) {
*   let formData = await request.formData();
*   let item = await createItem(formData);
*   return data(item, {
*     headers: { "X-Custom-Header": "value" }
*     status: 201,
*   });
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param data The data to be included in the response.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A {@link DataWithResponseInit} instance containing the data and
* response init.
*/ function $05e229ca209f5114$export$4051a07651545597(data, init) {
    return new $05e229ca209f5114$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response).
* Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* @example
* import { redirect } from "react-router";
*
* export async function loader({ request }: Route.LoaderArgs) {
*   if (!isLoggedIn(request))
*     throw redirect("/login");
*   }
*
*   // ...
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $05e229ca209f5114$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will force a document reload to the new location. Sets the status code
* and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* ```tsx filename=routes/logout.tsx
* import { redirectDocument } from "react-router";
*
* import { destroySession } from "../sessions.server";
*
* export async function action({ request }: Route.ActionArgs) {
*   let session = await getSession(request.headers.get("Cookie"));
*   return redirectDocument("/", {
*     headers: { "Set-Cookie": await destroySession(session) }
*   });
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $05e229ca209f5114$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $05e229ca209f5114$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will perform a [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState)
* instead of a [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* for client-side navigation redirects. Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* @example
* import { replace } from "react-router";
*
* export async function loader() {
*   return replace("/new-location");
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $05e229ca209f5114$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $05e229ca209f5114$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
const $05e229ca209f5114$export$1a235bd2b33434e5 = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $05e229ca209f5114$export$f2680fa305b734ca = class {
    status;
    statusText;
    data;
    error;
    internal;
    constructor(status, statusText, data, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
};
/**
* Check if the given error is an {@link ErrorResponse} generated from a 4xx/5xx
* [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* thrown from an [`action`](../../start/framework/route-module#action) or
* [`loader`](../../start/framework/route-module#loader) function.
*
* @example
* import { isRouteErrorResponse } from "react-router";
*
* export function ErrorBoundary({ error }: Route.ErrorBoundaryProps) {
*   if (isRouteErrorResponse(error)) {
*     return (
*       <>
*         <p>Error: `${error.status}: ${error.statusText}`</p>
*         <p>{error.data}</p>
*       </>
*     );
*   }
*
*   return (
*     <p>Error: {error instanceof Error ? error.message : "Unknown Error"}</p>
*   );
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param error The error to check.
* @returns `true` if the error is an {@link ErrorResponse}, `false` otherwise.
*/ function $05e229ca209f5114$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $05e229ca209f5114$export$d738435097971c09(matches) {
    return $05e229ca209f5114$export$86d9a7913e44197e(matches.map((m)=>m.route.path).filter(Boolean)) || "/";
}
function $05e229ca209f5114$export$141d98e45b4b08e4(request, path) {
    let url = new URL(typeof request === "string" || request instanceof URL ? request : request.url);
    let parsed = typeof path === "string" ? (0, $i4yVL.parsePath)(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        let search = searchParams.toString();
        url.search = search ? `?${search}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
const $05e229ca209f5114$export$4e09c449d6c407f7 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $05e229ca209f5114$export$ac5aeb949e84fd96(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !(0, $8w9JA.ABSOLUTE_URL_REGEX).test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($05e229ca209f5114$export$4e09c449d6c407f7) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = (0, $8w9JA.PROTOCOL_RELATIVE_URL_REGEX).test(to) ? new URL((0, $8w9JA.normalizeProtocolRelativeUrl)(to, currentUrl.protocol)) : new URL(to);
        let path = $05e229ca209f5114$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch  {
        (0, $i4yVL.warning)(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}

});

parcelRegister("6WCgj", function(module, exports) {

$parcel$export(module.exports, "IDLE_FETCHER", function () { return $50e5d6e8689f58ea$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $50e5d6e8689f58ea$export$386d57f03f0b2883; });
$parcel$export(module.exports, "clientErrors", function () { return $50e5d6e8689f58ea$export$f1f19d63f0eb8dcb; });
$parcel$export(module.exports, "createRouter", function () { return $50e5d6e8689f58ea$export$baddd0131ee8c05b; });
$parcel$export(module.exports, "isResponse", function () { return $50e5d6e8689f58ea$export$3f1eb41d9a6a6a27; });
$parcel$export(module.exports, "isDataWithResponseInit", function () { return $50e5d6e8689f58ea$export$e0163cfdf7bc9cfa; });
$parcel$export(module.exports, "hasInvalidProtocol", function () { return $50e5d6e8689f58ea$export$961a3ef7a4da3a39; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8w9JA = parcelRequire("8w9JA");

var $i4yVL = parcelRequire("i4yVL");

var $vjGlj = parcelRequire("vjGlj");

var $5l3C8 = parcelRequire("5l3C8");

var $kXPDB = parcelRequire("kXPDB");

var $8ZYWE = parcelRequire("8ZYWE");

var $1PkTq = parcelRequire("1PkTq");
//#region lib/router/router.ts
const $50e5d6e8689f58ea$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
const $50e5d6e8689f58ea$var$validMutationMethods = new Set($50e5d6e8689f58ea$var$validMutationMethodsArr);
const $50e5d6e8689f58ea$var$validRequestMethodsArr = [
    "GET",
    ...$50e5d6e8689f58ea$var$validMutationMethodsArr
];
const $50e5d6e8689f58ea$var$validRequestMethods = new Set($50e5d6e8689f58ea$var$validRequestMethodsArr);
const $50e5d6e8689f58ea$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $50e5d6e8689f58ea$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $50e5d6e8689f58ea$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $50e5d6e8689f58ea$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $50e5d6e8689f58ea$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
const $50e5d6e8689f58ea$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
const $50e5d6e8689f58ea$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $50e5d6e8689f58ea$export$5e64b3b9d7e2ec36(future, basename) {
    if (future.unstable_routePatternMatching) {
        let RoutePatternMatcher = (0, $8ZYWE.getRoutePatternMatcher)();
        (0, $i4yVL.invariant)(RoutePatternMatcher, "You must call unstable_preloadRoutePattern() from \"react-router/route-pattern\" before enabling future.unstable_routePatternMatching.");
        return new RoutePatternMatcher(basename);
    }
    return new (0, $kXPDB.V6RegExMatcher)(basename);
}
/**
* Encapsulates the stable and in-flight route trees together with their
* pre-computed branch caches so the structures always stay in sync.
*/ var $50e5d6e8689f58ea$var$DataRoutes = class {
    #routes;
    #hmrRoutes;
    #matcher;
    constructor(routes, matcher){
        this.#routes = routes;
        this.#matcher = matcher;
        this.#matcher.update(routes);
    }
    /** The stable route tree */ get stableRoutes() {
        return this.#routes;
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return this.#hmrRoutes ?? this.#routes;
    }
    get hasHMRRoutes() {
        return this.#hmrRoutes != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        this.#routes = routes;
        if (!this.#hmrRoutes) this.#matcher.update(routes);
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        this.#hmrRoutes = routes;
        this.#matcher.update(routes);
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if (this.#hmrRoutes) {
            this.#routes = this.#hmrRoutes;
            this.#hmrRoutes = void 0;
            this.#matcher.update(this.#routes);
        }
    }
};
const $50e5d6e8689f58ea$export$f1f19d63f0eb8dcb = /* @__PURE__ */ new WeakMap();
/**
* Create a router and listen to history POP navigations
*/ function $50e5d6e8689f58ea$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    (0, $i4yVL.invariant)(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties = (route)=>{
            return {
                ..._mapRouteProperties?.(route),
                ...(0, $5l3C8.getRouteInstrumentationUpdates)(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let future = {
        ...init.future
    };
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataRouteMatcher = $50e5d6e8689f58ea$export$5e64b3b9d7e2ec36(future, basename);
    let manifest = {};
    let dataRoutes = new $50e5d6e8689f58ea$var$DataRoutes((0, $vjGlj.convertRoutesToDataRoutes)(init.routes, mapRouteProperties, void 0, manifest), dataRouteMatcher);
    let dataStrategyImpl = init.dataStrategy || $50e5d6e8689f58ea$var$defaultDataStrategyWithMiddleware;
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions = null;
    let getScrollRestorationKey = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = dataRouteMatcher.match(init.history.location);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $50e5d6e8689f58ea$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $50e5d6e8689f58ea$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            if (checkFogOfWar(initialMatches, init.history.location.pathname).active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$50e5d6e8689f58ea$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $50e5d6e8689f58ea$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $50e5d6e8689f58ea$export$ed3e14b2f9e105d0,
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP";
    let pendingPopstateDelta = 0;
    let pendingDiscoveryCancellation;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            (0, $i4yVL.warning)(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $50e5d6e8689f58ea$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            if (future.unstable_customRouteDiscovery) pendingPopstateDelta += delta || 0;
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            $50e5d6e8689f58ea$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$50e5d6e8689f58ea$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP", state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        let newErrors = newState.errors ?? null;
        let cachedErrors = newErrors ? $50e5d6e8689f58ea$export$f1f19d63f0eb8dcb.get(newErrors) : void 0;
        if (cachedErrors !== void 0) newErrors = cachedErrors;
        if (newState.errors !== void 0 || newState.initialized) {
            if (state.errors) $50e5d6e8689f58ea$export$f1f19d63f0eb8dcb.delete(state.errors);
            if (newState.errors) $50e5d6e8689f58ea$export$f1f19d63f0eb8dcb.set(newState.errors, newErrors);
        }
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newErrors,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $50e5d6e8689f58ea$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $50e5d6e8689f58ea$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0 && !isUninterruptedRevalidation) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $50e5d6e8689f58ea$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $50e5d6e8689f58ea$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP") ;
        else if (pendingAction === "PUSH") init.history.push(location, location.state);
        else if (pendingAction === "REPLACE") init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" && !isUninterruptedRevalidation && location !== state.location) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $50e5d6e8689f58ea$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        resetPendingNavigation();
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    function resetPendingNavigation() {
        pendingPopstateDelta = 0;
        pendingAction = "POP";
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = fetchReloadIds.size > 0;
    }
    async function navigate(to, opts) {
        if (pendingDiscoveryCancellation) await pendingDiscoveryCancellation;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $50e5d6e8689f58ea$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let instrumentationNavigateMetaReceiver = (0, $5l3C8.consumeInstrumentationClientResultMetaReceiver)(router);
        let { path: path, submission: submission, error: error } = $50e5d6e8689f58ea$var$normalizeNavigateOptions(false, $50e5d6e8689f58ea$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative), opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? (0, $i4yVL.parsePath)(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: partialPath.pathname ?? "",
                search: partialPath.search ?? "",
                hash: partialPath.hash ?? ""
            };
            if ((0, $8w9JA.PROTOCOL_RELATIVE_URL_REGEX).test(maskPath.pathname)) throw new Error("External navigation is not allowed");
            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
            (0, $1PkTq.validateNavigationTarget)(typeof opts.mask === "string" ? opts.mask : (0, $i4yVL.createPath)(opts.mask), (0, $i4yVL.createPath)(maskPath), init.history.createURL("/"), "reject");
        }
        let currentLocation = state.location;
        let nextLocation = (0, $i4yVL.createLocation)(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        (0, $1PkTq.validateNavigationTarget)(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : (0, $i4yVL.createPath)(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH";
        let currentPath = state.location.pathname + state.location.search;
        if (userReplace === true) historyAction = "REPLACE";
        else if (userReplace === false) ;
        else if (submission != null && $50e5d6e8689f58ea$export$cbae47800eb95bc3(submission.formMethod) && (submission.formAction === currentPath || nextLocation.pathname + nextLocation.search === currentPath)) historyAction = "REPLACE";
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $50e5d6e8689f58ea$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate,
            instrumentationNavigateMetaReceiver: instrumentationNavigateMetaReceiver
        });
    }
    function revalidate() {
        if (pendingDiscoveryCancellation) return pendingDiscoveryCancellation.then(revalidate);
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $50e5d6e8689f58ea$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true,
                dataStrategyInitiator: "revalidation"
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            dataStrategyInitiator: "revalidation",
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        if (pendingDiscoveryCancellation) await pendingDiscoveryCancellation;
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? state.matches : dataRouteMatcher.match(location);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $50e5d6e8689f58ea$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $50e5d6e8689f58ea$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (opts?.instrumentationNavigateMetaReceiver) {
            let meta = $50e5d6e8689f58ea$var$getInstrumentationNavigateMeta(init.history, location, matches);
            opts.instrumentationNavigateMetaReceiver(meta);
        }
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $50e5d6e8689f58ea$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let dataStrategyInitiator = opts?.initialHydration ? "initialization" : opts?.dataStrategyInitiator ?? "navigation";
        let scopedContext = init.getContext ? await init.getContext() : new (0, $vjGlj.RouterContextProvider)();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $50e5d6e8689f58ea$var$findNearestBoundary(matches).route.id,
            {
                type: "error",
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $50e5d6e8689f58ea$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, dataStrategyInitiator, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($50e5d6e8689f58ea$var$isErrorResult(result) && (0, $vjGlj.isRouteErrorResponse)(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $50e5d6e8689f58ea$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $50e5d6e8689f58ea$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, dataStrategyInitiator, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$50e5d6e8689f58ea$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    function cancelDiscoveryNavigation() {
        let cancellation = $50e5d6e8689f58ea$var$createDeferred();
        pendingDiscoveryCancellation = cancellation.promise;
        let delta = pendingPopstateDelta;
        let popstateNavigationDfd = pendingPopstateNavigationDfd;
        pendingPopstateNavigationDfd = null;
        pendingNavigationController?.abort();
        pendingNavigationController = null;
        resetPendingNavigation();
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
        let blockers = new Map(state.blockers);
        blockers.forEach((blocker, key)=>{
            if (blocker.state === "proceeding") blockers.set(key, $50e5d6e8689f58ea$export$386d57f03f0b2883);
        });
        let fetchers = new Map(state.fetchers);
        let didUpdateFetchers = markFetchRedirectsDone(fetchers);
        fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "loading" && !fetchControllers.has(key)) {
                fetchers.set(key, $50e5d6e8689f58ea$var$getDoneFetcher(fetcher.data));
                didUpdateFetchers = true;
            }
        });
        cancelledFetcherLoads.clear();
        updateState({
            navigation: $50e5d6e8689f58ea$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            blockers: blockers,
            ...didUpdateFetchers ? {
                fetchers: fetchers
            } : {}
        });
        function finishCancellation() {
            pendingDiscoveryCancellation = void 0;
            popstateNavigationDfd?.resolve();
            cancellation.resolve();
        }
        if (delta) {
            unblockBlockerHistoryUpdate = finishCancellation;
            init.history.go(-delta);
        } else finishCancellation();
        return cancellation.promise;
    }
    async function handleAction(request, dataStrategyInitiator, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        if (!future.unstable_customRouteDiscovery) interruptActiveLoads();
        updateState({
            navigation: $50e5d6e8689f58ea$var$getSubmittingNavigation(location, matches, historyAction, submission)
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (future.unstable_customRouteDiscovery && request.signal.aborted || discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "cancelled") {
                await cancelDiscoveryNavigation();
                return {
                    shortCircuited: true
                };
            } else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $50e5d6e8689f58ea$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error",
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $50e5d6e8689f58ea$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error",
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error",
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        if (future.unstable_customRouteDiscovery) interruptActiveLoads();
        let result;
        let actionMatch = $50e5d6e8689f58ea$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error",
            error: $50e5d6e8689f58ea$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy(request, location, $50e5d6e8689f58ea$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties, scopedContext), scopedContext, null, dataStrategyInitiator, historyAction);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($50e5d6e8689f58ea$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else replace = $50e5d6e8689f58ea$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history) === state.location.pathname + state.location.search;
            await startRedirectNavigation(request, result, true, dataStrategyInitiator, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($50e5d6e8689f58ea$var$isErrorResult(result)) {
            let boundaryMatch = $50e5d6e8689f58ea$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH";
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, dataStrategyInitiator, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $50e5d6e8689f58ea$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $50e5d6e8689f58ea$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (future.unstable_customRouteDiscovery && request.signal.aborted || discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "cancelled") {
                await cancelDiscoveryNavigation();
                return {
                    shortCircuited: true
                };
            } else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $50e5d6e8689f58ea$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $50e5d6e8689f58ea$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else {
                matches = discoverResult.matches;
                if (initialHydration && !request.signal.aborted) updateState({
                    matches: matches
                });
            }
        }
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $50e5d6e8689f58ea$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, dataRouteMatcher, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers = new Map(state.fetchers);
            let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                errors: pendingActionResult && $50e5d6e8689f58ea$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$50e5d6e8689f58ea$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects ? {
                    fetchers: workingFetchers
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>{
                if (fetchControllers.get(rf.key) === rf.controller) abortFetcher(rf.key);
            });
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext, dataStrategyInitiator, historyAction);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.get(rf.key) === rf.controller) fetchControllers.delete(rf.key);
        });
        let redirect = $50e5d6e8689f58ea$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, dataStrategyInitiator, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $50e5d6e8689f58ea$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, dataStrategyInitiator, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $50e5d6e8689f58ea$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) {
            let newClientErrors = errors ?? null;
            errors = {
                ...state.errors,
                ...errors
            };
            $50e5d6e8689f58ea$export$f1f19d63f0eb8dcb.set(errors, newClientErrors);
        }
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$50e5d6e8689f58ea$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $50e5d6e8689f58ea$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch(key, routeId, href, opts) {
        if (pendingDiscoveryCancellation) await pendingDiscoveryCancellation;
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let instrumentationResultMetaReceiver = (0, $5l3C8.consumeInstrumentationClientResultMetaReceiver)(router);
        let normalizedPath = $50e5d6e8689f58ea$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = dataRouteMatcher.match(normalizedPath);
        let fogOfWar = checkFogOfWar(matches, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (instrumentationResultMetaReceiver) instrumentationResultMetaReceiver($50e5d6e8689f58ea$var$getInstrumentationNavigateMeta(init.history, normalizedPath, matches));
        if (!matches) {
            setFetcherError(key, routeId, $50e5d6e8689f58ea$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $50e5d6e8689f58ea$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new (0, $vjGlj.RouterContextProvider)();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $50e5d6e8689f58ea$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        let loadMatch = {
            routeId: routeId,
            path: path,
            isDiscovering: fogOfWar.active
        };
        fetchLoadMatches.set(key, loadMatch);
        await handleFetcherLoader(key, loadMatch, matches, scopedContext, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        if (!future.unstable_customRouteDiscovery) interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $50e5d6e8689f58ea$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        if (future.unstable_customRouteDiscovery) fetchControllers.set(key, abortController);
        let fetchRequest = $50e5d6e8689f58ea$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (future.unstable_customRouteDiscovery && fetchRequest.signal.aborted || discoverResult.type === "aborted") return;
            else if (discoverResult.type === "cancelled") {
                fetchControllers.delete(key);
                fetchLoadMatches.delete(key);
                updateFetcherState(key, $50e5d6e8689f58ea$var$getDoneFetcher(existingFetcher?.data), {
                    flushSync: flushSync
                });
                return;
            } else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $50e5d6e8689f58ea$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $50e5d6e8689f58ea$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            setFetcherError(key, routeId, $50e5d6e8689f58ea$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            }), {
                flushSync: flushSync
            });
            return;
        }
        if (future.unstable_customRouteDiscovery) interruptActiveLoads();
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $50e5d6e8689f58ea$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key, "fetcher");
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match of fetchMatches)if (actionResults[match.route.id]) {
                actionResult = actionResults[match.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($50e5d6e8689f58ea$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $50e5d6e8689f58ea$var$getDoneFetcher(void 0));
                return;
            }
            if ($50e5d6e8689f58ea$var$isRedirectResult(actionResult)) {
                isRevalidationRequired = true;
                actionResult = {
                    type: "data",
                    data: void 0
                };
            }
        } else {
            if ($50e5d6e8689f58ea$var$isRedirectResult(actionResult)) {
                if (pendingNavigationLoadId > originatingLoadId) {
                    isRevalidationRequired = true;
                    actionResult = {
                        type: "data",
                        data: void 0
                    };
                } else {
                    fetchControllers.delete(key);
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $50e5d6e8689f58ea$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, "fetcher", {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($50e5d6e8689f58ea$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        isRevalidationRequired = true;
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $50e5d6e8689f58ea$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let matches = state.navigation.state !== "idle" ? dataRouteMatcher.match(state.navigation.location) : state.matches;
        (0, $i4yVL.invariant)(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $50e5d6e8689f58ea$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, dataRouteMatcher, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $50e5d6e8689f58ea$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = workingFetchers.get(staleKey);
            let revalidatingFetcher = $50e5d6e8689f58ea$var$getLoadingFetcher(void 0, existingFetcher ? existingFetcher.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>{
                if (fetchControllers.get(rf.key) === rf.controller) abortFetcher(rf.key);
            });
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext, "fetcher");
        if (abortController.signal.aborted) {
            if (fetchReloadIds.get(key) === loadId) fetchReloadIds.delete(key);
            return;
        }
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>{
            if (fetchControllers.get(r.key) === r.controller) fetchControllers.delete(r.key);
        });
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers = new Map(s.fetchers);
            workingFetchers.set(key, $50e5d6e8689f58ea$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers
            };
        };
        let redirect = $50e5d6e8689f58ea$var$findRedirect(loaderResults);
        if (redirect) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, "fetcher", {
                preventScrollReset: preventScrollReset
            });
        }
        redirect = $50e5d6e8689f58ea$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, "fetcher", {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $50e5d6e8689f58ea$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $50e5d6e8689f58ea$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            (0, $i4yVL.invariant)(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            markFetchRedirectsDone(finalFetchers);
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $50e5d6e8689f58ea$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = fetchReloadIds.size > 0;
        }
    }
    async function handleFetcherLoader(key, loadMatch, matches, scopedContext, flushSync, preventScrollReset, submission) {
        let { routeId: routeId, path: path } = loadMatch;
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $50e5d6e8689f58ea$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        if (future.unstable_customRouteDiscovery) fetchControllers.set(key, abortController);
        let fetchRequest = $50e5d6e8689f58ea$var$createClientSideRequest(init.history, path, abortController.signal);
        if (loadMatch.isDiscovering) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (future.unstable_customRouteDiscovery && fetchRequest.signal.aborted || discoverResult.type === "aborted") return;
            else if (discoverResult.type === "cancelled") {
                fetchControllers.delete(key);
                fetchLoadMatches.delete(key);
                updateFetcherState(key, $50e5d6e8689f58ea$var$getDoneFetcher(existingFetcher?.data), {
                    flushSync: flushSync
                });
                return;
            } else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $50e5d6e8689f58ea$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                loadMatch.isDiscovering = false;
            }
        }
        let match = $50e5d6e8689f58ea$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy(fetchRequest, path, $50e5d6e8689f58ea$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, matches, match, hydrationRouteProperties, scopedContext), scopedContext, key, "fetcher");
        let result = results[match.route.id];
        if (!result) {
            for (let match of matches)if (results[match.route.id]) {
                result = results[match.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $50e5d6e8689f58ea$var$getDoneFetcher(void 0));
            return;
        }
        if ($50e5d6e8689f58ea$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $50e5d6e8689f58ea$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, "fetcher", {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($50e5d6e8689f58ea$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $50e5d6e8689f58ea$var$getDoneFetcher(result.data));
    }
    /**
	* Utility function to handle redirects returned from an action or loader.
	* Normally, a redirect "replaces" the navigation that triggered it.  So, for
	* example:
	*
	*  - user is on /a
	*  - user clicks a link to /b
	*  - loader for /b redirects to /c
	*
	* In a non-JS app the browser would track the in-flight navigation to /b and
	* then replace it with /c when it encountered the redirect response.  In
	* the end it would only ever update the URL bar with /c.
	*
	* In client-side routing using pushState/replaceState, we aim to emulate
	* this behavior and we also do not update history until the end of the
	* navigation (including processed redirects).  This means that we never
	* actually touch history until we've processed redirects, so we just use
	* the history action from the original navigation (PUSH or REPLACE).
	*/ async function startRedirectNavigation(request, redirect, isNavigation, dataStrategyInitiator, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        (0, $i4yVL.invariant)(location, "Expected a Location header on the redirect Response");
        let originalLocation = location;
        let currentUrl = new URL(request.url);
        location = $50e5d6e8689f58ea$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
        (0, $1PkTq.validateNavigationTarget)(originalLocation, location, currentUrl, "allow-explicit");
        let redirectLocation = (0, $i4yVL.createLocation)(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ((0, $vjGlj.isAbsoluteUrl)(location)) {
                const url = (0, $i4yVL.createBrowserURLImpl)(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || (0, $vjGlj.stripBasename)(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace === true || redirect.response.headers.has("X-Remix-Replace") ? "REPLACE" : "PUSH";
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $50e5d6e8689f58ea$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($50e5d6e8689f58ea$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $50e5d6e8689f58ea$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0,
            dataStrategyInitiator: dataStrategyInitiator
        });
        else await startNavigation(redirectNavigationType, redirectLocation, {
            overrideNavigation: $50e5d6e8689f58ea$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission),
            fetcherSubmission: fetcherSubmission,
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0,
            dataStrategyInitiator: dataStrategyInitiator
        });
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey, initiator, navigationType = null) {
        let results;
        let dataResults = {};
        try {
            results = await $50e5d6e8689f58ea$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, initiator, scopedContext, false, navigationType);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error",
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$50e5d6e8689f58ea$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error") break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error",
                result: /* @__PURE__ */ new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($50e5d6e8689f58ea$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect",
                response: $50e5d6e8689f58ea$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $50e5d6e8689f58ea$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext, initiator, navigationType = null) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null, initiator, navigationType);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let result = (await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key, initiator, navigationType))[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error",
                    error: $50e5d6e8689f58ea$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        return {
            loaderResults: await loaderResultsPromise,
            fetcherResults: (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {})
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((loadMatch, key)=>{
            if (future.unstable_customRouteDiscovery && loadMatch.isDiscovering) return;
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $50e5d6e8689f58ea$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $50e5d6e8689f58ea$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        fetchLoadMatches.delete(key);
        cancelledFetcherLoads.delete(key);
        updateFetcherState(key, $50e5d6e8689f58ea$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            (0, $i4yVL.invariant)(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $50e5d6e8689f58ea$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            (0, $i4yVL.invariant)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            (0, $i4yVL.invariant)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $50e5d6e8689f58ea$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $50e5d6e8689f58ea$export$386d57f03f0b2883;
        (0, $i4yVL.invariant)(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) (0, $i4yVL.warning)(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $50e5d6e8689f58ea$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $50e5d6e8689f58ea$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        if (!initialScrollRestored && state.navigation === $50e5d6e8689f58ea$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) return getScrollRestorationKey(location, matches.map((m)=>(0, $vjGlj.convertRouteMatchToUiMatch)(m, state.loaderData))) || location.key;
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) return {
                active: true,
                matches: dataRouteMatcher.match(pathname, true) || []
            };
            else if (Object.keys(matches[0].params).length > 0) return {
                active: true,
                matches: dataRouteMatcher.match(pathname, true)
            };
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $50e5d6e8689f58ea$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties, false);
                    }
                });
            } catch (e) {
                if (future.unstable_customRouteDiscovery) {
                    if (signal.aborted) return {
                        type: "aborted"
                    };
                    if (e instanceof (0, $vjGlj.DiscoveryCancelledError)) return {
                        type: "cancelled"
                    };
                }
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = dataRouteMatcher.match(pathname);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = dataRouteMatcher.match(pathname, true);
                    if (!(newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length)))) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = dataRouteMatcher.match(pathname, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes((0, $vjGlj.convertRoutesToDataRoutes)(newRoutes, mapRouteProperties, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $50e5d6e8689f58ea$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        match (locationArg) {
            return dataRouteMatcher.match(locationArg);
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        createHref: (to)=>init.history.createHref(to),
        createURL: (to)=>init.history.createURL(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = (0, $5l3C8.instrumentClientSideRouter)(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
/**
* Create a static handler to perform server-side data loading
*
* @example
* export async function handleRequest(request: Request) {
*   let { query, dataRoutes } = createStaticHandler(routes);
*   let context = await query(request);
*
*   if (context instanceof Response) {
*     return context;
*   }
*
*   let router = createStaticRouter(dataRoutes, context);
*   return new Response(
*     ReactDOMServer.renderToString(<StaticRouterProvider ... />),
*     { headers: { "Content-Type": "text/html" } }
*   );
* }
*
* @public
* @category Data Routers
* @mode data
* @param routes The {@link RouteObject | route objects} to create a static
* handler for
* @param opts Options
* @param opts.basename The base URL for the static handler (default: `/`)
* @param opts.future Future flags for the static handler
* @returns A static handler that can be used to query data for the provided
* routes
*/ function $50e5d6e8689f58ea$export$3336b097a6fbc59a(routes, opts) {
    (0, $i4yVL.invariant)(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    let dataRouteMatcher = $50e5d6e8689f58ea$export$5e64b3b9d7e2ec36({
        ...opts?.future
    }, basename);
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties = (route)=>{
            return {
                ..._mapRouteProperties?.(route),
                ...(0, $5l3C8.getRouteInstrumentationUpdates)(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = (0, $vjGlj.convertRoutesToDataRoutes)(routes, mapRouteProperties, void 0, manifest);
    dataRouteMatcher.update(dataRoutes);
    let match = (locationArg)=>dataRouteMatcher.match(locationArg);
    /**
	* The query() method is intended for document requests, in which we want to
	* call an optional action and potentially multiple loaders for all nested
	* routes.  It returns a StaticHandlerContext object, which is very similar
	* to the router state (location, loaderData, actionData, errors, etc.) and
	* also adds SSR-specific information such as the statusCode and headers
	* from action/loaders Responses.
	*
	* It _should_ never throw and should report all errors through the
	* returned handlerContext.errors object, properly associating errors to
	* their error boundary.  Additionally, it tracks _deepestRenderedBoundaryId
	* which can be used to emulate React error boundaries during SSR by performing
	* a second pass only down to the boundaryId.
	*
	* The one exception where we do not return a StaticHandlerContext is when a
	* redirect response is returned or thrown from any action/loader.  We
	* propagate that out and return the raw Response so the HTTP server can
	* return it directly.
	*
	* - `opts.requestContext` is an optional server context that will be passed
	*   to actions/loaders in the `context` parameter
	* - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
	*   the bubbling of errors which allows single-fetch-type implementations
	*   where the client will handle the bubbling and we may need to return data
	*   for the handling route
	*/ async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $50e5d6e8689f58ea$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $i4yVL.createLocation)("", normalizePathImpl(request), null, "default");
        let matches = dataRouteMatcher.match(location);
        requestContext = requestContext != null ? requestContext : new (0, $vjGlj.RouterContextProvider)();
        if (!$50e5d6e8689f58ea$var$isValidMethod(method) && method !== "HEAD") {
            let error = $50e5d6e8689f58ea$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $50e5d6e8689f58ea$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                _match: match
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $50e5d6e8689f58ea$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $50e5d6e8689f58ea$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                _match: match
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            (0, $i4yVL.invariant)(requestContext instanceof (0, $vjGlj.RouterContextProvider), "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $50e5d6e8689f58ea$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
                let renderedStaticContext;
                let response = await $50e5d6e8689f58ea$var$runServerMiddlewarePipeline({
                    request: request,
                    url: (0, $vjGlj.createDataFunctionUrl)(request, location),
                    pattern: (0, $vjGlj.getRoutePattern)(matches),
                    matches: matches,
                    params: matches[0].params,
                    context: requestContext
                }, async ()=>{
                    return await generateMiddlewareResponse(async (revalidationRequest, opts = {})=>{
                        let result = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts ? opts.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($50e5d6e8689f58ea$export$3f1eb41d9a6a6a27(result)) return result;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result,
                            _match: match
                        };
                        return renderedStaticContext;
                    });
                }, async (error, routeId)=>{
                    if ($50e5d6e8689f58ea$export$6e80290866a84dd4(error)) return error;
                    if ($50e5d6e8689f58ea$export$3f1eb41d9a6a6a27(error)) try {
                        error = new (0, $vjGlj.ErrorResponseImpl)(error.status, error.statusText, await $50e5d6e8689f58ea$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($50e5d6e8689f58ea$export$e0163cfdf7bc9cfa(error)) error = $50e5d6e8689f58ea$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $50e5d6e8689f58ea$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $50e5d6e8689f58ea$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [skipLoaderErrorBubbling ? routeId : $50e5d6e8689f58ea$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id]: error
                            },
                            statusCode: (0, $vjGlj.isRouteErrorResponse)(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {},
                            _match: match
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                (0, $i4yVL.invariant)($50e5d6e8689f58ea$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($50e5d6e8689f58ea$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($50e5d6e8689f58ea$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result,
            _match: match
        };
    }
    /**
	* The queryRoute() method is intended for targeted route requests, either
	* for fetch ?_data requests or resource route requests.  In this case, we
	* are only ever calling a single action or loader, and we are returning the
	* returned value directly.  In most cases, this will be a Response returned
	* from the action/loader, but it may be a primitive or other value as well -
	* and in such cases the calling context should handle that accordingly.
	*
	* We do respect the throw/return differentiation, so if an action/loader
	* throws, then this method will throw the value.  This is important so we
	* can do proper boundary identification in Remix where a thrown Response
	* must go to the Catch Boundary but a returned Response is happy-path.
	*
	* One thing to note is that any Router-initiated Errors that make sense
	* to associate with a status code will be thrown as an ErrorResponse
	* instance which include the raw Error, such that the calling context can
	* serialize the error as they see fit while including the proper response
	* code.  Examples here are 404 and 405 errors that occur prior to reaching
	* any user-defined loaders.
	*
	* - `opts.routeId` allows you to specify the specific route handler to call.
	*   If not provided the handler will determine the proper route by matching
	*   against `request.url`
	* - `opts.requestContext` is an optional server context that will be passed
	*    to actions/loaders in the `context` parameter
	*/ async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $50e5d6e8689f58ea$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $i4yVL.createLocation)("", normalizePathImpl(request), null, "default");
        let matches = dataRouteMatcher.match(location);
        requestContext = requestContext != null ? requestContext : new (0, $vjGlj.RouterContextProvider)();
        if (!$50e5d6e8689f58ea$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $50e5d6e8689f58ea$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $50e5d6e8689f58ea$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $50e5d6e8689f58ea$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $50e5d6e8689f58ea$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $50e5d6e8689f58ea$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            (0, $i4yVL.invariant)(requestContext instanceof (0, $vjGlj.RouterContextProvider), "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $50e5d6e8689f58ea$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
            return await $50e5d6e8689f58ea$var$runServerMiddlewarePipeline({
                request: request,
                url: (0, $vjGlj.createDataFunctionUrl)(request, location),
                pattern: (0, $vjGlj.getRoutePattern)(matches),
                matches: matches,
                params: matches[0].params,
                context: requestContext
            }, async ()=>{
                return await generateMiddlewareResponse(async (innerRequest)=>{
                    let processed = handleQueryResult(await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false));
                    return $50e5d6e8689f58ea$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
            }, (error)=>{
                if ($50e5d6e8689f58ea$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($50e5d6e8689f58ea$var$dataWithResponseInitToResponse(error));
                if ($50e5d6e8689f58ea$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
        }
        return handleQueryResult(await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false));
        function handleQueryResult(result) {
            if ($50e5d6e8689f58ea$export$3f1eb41d9a6a6a27(result)) return result;
            let error = result.errors ? Object.values(result.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result.actionData) return Object.values(result.actionData)[0];
            if (result.loaderData) return Object.values(result.loaderData)[0];
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        (0, $i4yVL.invariant)(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($50e5d6e8689f58ea$export$cbae47800eb95bc3(request.method)) return await submit(request, location, matches, routeMatch || $50e5d6e8689f58ea$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $50e5d6e8689f58ea$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($50e5d6e8689f58ea$var$isDataStrategyResult(e) && $50e5d6e8689f58ea$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error") throw e.result;
                return e.result;
            }
            if ($50e5d6e8689f58ea$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $50e5d6e8689f58ea$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error",
                error: error
            };
        } else {
            result = (await callDataStrategy(request, location, $50e5d6e8689f58ea$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, [], requestContext), isRouteRequest, requestContext, dataStrategy))[actionMatch.route.id];
            if (request.signal.aborted) $50e5d6e8689f58ea$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($50e5d6e8689f58ea$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($50e5d6e8689f58ea$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($50e5d6e8689f58ea$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $50e5d6e8689f58ea$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: (0, $vjGlj.isRouteErrorResponse)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($50e5d6e8689f58ea$var$isErrorResult(result)) return {
            ...await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                (skipLoaderErrorBubbling ? actionMatch : $50e5d6e8689f58ea$var$findNearestBoundary(matches, actionMatch.route.id)).route.id,
                result
            ]),
            statusCode: (0, $vjGlj.isRouteErrorResponse)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
            actionData: null,
            actionHeaders: {
                ...result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {}
            }
        };
        return {
            ...await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad),
            actionData: {
                [actionMatch.route.id]: result.data
            },
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $50e5d6e8689f58ea$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $50e5d6e8689f58ea$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $50e5d6e8689f58ea$var$isErrorResult(pendingActionResult[1]) ? matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = (0, $vjGlj.getRoutePattern)(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $50e5d6e8689f58ea$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, false);
                return $50e5d6e8689f58ea$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $50e5d6e8689f58ea$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $50e5d6e8689f58ea$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        return {
            ...$50e5d6e8689f58ea$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling),
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $50e5d6e8689f58ea$var$callDataStrategyImpl(dataStrategy || $50e5d6e8689f58ea$var$defaultDataStrategy, request, location, matches, null, "static", requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($50e5d6e8689f58ea$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $50e5d6e8689f58ea$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($50e5d6e8689f58ea$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($50e5d6e8689f58ea$export$e0163cfdf7bc9cfa(result.result)) throw $50e5d6e8689f58ea$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $50e5d6e8689f58ea$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        get _matchCost () {
            return dataRouteMatcher instanceof (0, $kXPDB.V6RegExMatcher) ? dataRouteMatcher.matchCost : void 0;
        },
        match: match,
        query: query,
        queryRoute: queryRoute
    };
}
/**
* Given an existing StaticHandlerContext and an error thrown at render time,
* provide an updated StaticHandlerContext suitable for a second SSR render
*
* @category Utils
*/ function $50e5d6e8689f58ea$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: (0, $vjGlj.isRouteErrorResponse)(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $50e5d6e8689f58ea$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    throw new Error(`${isRouteRequest ? "queryRoute" : "query"}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $50e5d6e8689f58ea$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $50e5d6e8689f58ea$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $50e5d6e8689f58ea$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = (0, $vjGlj.resolveTo)(to ? to : ".", (0, $vjGlj.getResolveToMatches)(contextualMatches), (0, $vjGlj.stripBasename)(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $50e5d6e8689f58ea$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = (0, $vjGlj.prependBasename)({
        basename: basename,
        pathname: path.pathname
    });
    return (0, $i4yVL.createPath)(path);
}
function $50e5d6e8689f58ea$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$50e5d6e8689f58ea$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$50e5d6e8689f58ea$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $50e5d6e8689f58ea$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $50e5d6e8689f58ea$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let formMethod = (opts.formMethod || "get").toUpperCase();
    let formAction = $50e5d6e8689f58ea$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$50e5d6e8689f58ea$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}\n`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$50e5d6e8689f58ea$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch  {
                return getInvalidBodyError();
            }
        }
    }
    (0, $i4yVL.invariant)(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $50e5d6e8689f58ea$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $50e5d6e8689f58ea$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $50e5d6e8689f58ea$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $50e5d6e8689f58ea$var$convertSearchParamsToFormData(searchParams);
    } catch  {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($50e5d6e8689f58ea$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = (0, $i4yVL.parsePath)(path);
    if (isFetcher && parsedPath.search && $50e5d6e8689f58ea$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: (0, $i4yVL.createPath)(parsedPath),
        submission: submission
    };
}
function $50e5d6e8689f58ea$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, dataRouteMatcher, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $50e5d6e8689f58ea$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $50e5d6e8689f58ea$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = (0, $vjGlj.getRoutePattern)(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$50e5d6e8689f58ea$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad } = $50e5d6e8689f58ea$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad;
        } else if ($50e5d6e8689f58ea$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $50e5d6e8689f58ea$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($50e5d6e8689f58ea$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        return $50e5d6e8689f58ea$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, $50e5d6e8689f58ea$var$shouldRevalidateLoader(match, shouldRevalidateArgs), shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key) || f.isDiscovering) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = dataRouteMatcher.match(f.path);
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $50e5d6e8689f58ea$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $50e5d6e8689f58ea$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $50e5d6e8689f58ea$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $50e5d6e8689f58ea$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($50e5d6e8689f58ea$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $50e5d6e8689f58ea$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $50e5d6e8689f58ea$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $50e5d6e8689f58ea$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$50e5d6e8689f58ea$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $50e5d6e8689f58ea$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $50e5d6e8689f58ea$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $50e5d6e8689f58ea$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $50e5d6e8689f58ea$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        (0, $i4yVL.invariant)(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute)=>$50e5d6e8689f58ea$var$isSameRoute(newRoute, existingRoute));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = (0, $vjGlj.convertRoutesToDataRoutes)(uniqueChildren, mapRouteProperties, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = (0, $vjGlj.convertRoutesToDataRoutes)([
            newRoute
        ], mapRouteProperties, [], {}, true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $50e5d6e8689f58ea$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$50e5d6e8689f58ea$var$isSameRoute(aChild, bChild))) ?? false;
}
const $50e5d6e8689f58ea$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
const $50e5d6e8689f58ea$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties })=>{
    let routeToUpdate = manifest[route.id];
    (0, $i4yVL.invariant)(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $50e5d6e8689f58ea$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $50e5d6e8689f58ea$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = (0, $vjGlj.isUnsupportedLazyRouteObjectKey)(key);
        let isStaticallyDefined = routeToUpdate[key] !== void 0;
        if (isUnsupported) {
            (0, $i4yVL.warning)(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) (0, $i4yVL.warning)(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    propertyPromise.catch(()=>{
        if (cache[key] === propertyPromise) delete cache[key];
    });
    return propertyPromise;
};
const $50e5d6e8689f58ea$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
/**
* Execute route.lazy functions to lazily load route modules (loader, action,
* shouldRevalidate) and update the routeManifest in place which shares objects
* with dataRoutes so those get updated as well.
*/ function $50e5d6e8689f58ea$var$loadLazyRoute(route, type, manifest, mapRouteProperties, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    (0, $i4yVL.invariant)(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $50e5d6e8689f58ea$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise = (async ()=>{
            (0, $i4yVL.invariant)(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = (0, $vjGlj.isUnsupportedLazyRouteFunctionKey)(lazyRouteProperty);
                let isStaticallyDefined = routeToUpdate[lazyRouteProperty] !== void 0;
                if (isUnsupported) (0, $i4yVL.warning)(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) (0, $i4yVL.warning)(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                ...mapRouteProperties(routeToUpdate),
                lazy: void 0
            });
        })();
        $50e5d6e8689f58ea$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise);
        lazyRoutePromise.catch(()=>{
            if ($50e5d6e8689f58ea$var$lazyRouteFunctionCache.get(routeToUpdate) === lazyRoutePromise) $50e5d6e8689f58ea$var$lazyRouteFunctionCache.delete(routeToUpdate);
        });
        return {
            lazyRoutePromise: lazyRoutePromise,
            lazyHandlerPromise: lazyRoutePromise
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $50e5d6e8689f58ea$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $50e5d6e8689f58ea$var$isNonNullable(value) {
    return value !== void 0;
}
function $50e5d6e8689f58ea$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return;
        return $50e5d6e8689f58ea$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
    }).filter($50e5d6e8689f58ea$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $50e5d6e8689f58ea$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    (await Promise.all(matchesToLoad.map((m)=>m.resolve()))).forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $50e5d6e8689f58ea$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $50e5d6e8689f58ea$var$defaultDataStrategy(args);
    return $50e5d6e8689f58ea$var$runClientMiddlewarePipeline(args, ()=>$50e5d6e8689f58ea$var$defaultDataStrategy(args));
}
function $50e5d6e8689f58ea$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $50e5d6e8689f58ea$var$runMiddlewarePipeline(args, handler, processResult, $50e5d6e8689f58ea$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $50e5d6e8689f58ea$export$e0163cfdf7bc9cfa(result) ? $50e5d6e8689f58ea$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $50e5d6e8689f58ea$var$runClientMiddlewarePipeline(args, handler) {
    return $50e5d6e8689f58ea$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($50e5d6e8689f58ea$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $50e5d6e8689f58ea$var$isDataStrategyResults, errorHandler);
    async function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        });
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let deepestRouteId = matches[maxBoundaryIdx].route.id;
            for (let match of matches.slice(0, maxBoundaryIdx + 1))try {
                await match._lazyPromises?.route;
            } catch  {
                deepestRouteId = match.route.id;
                break;
            }
            return {
                [$50e5d6e8689f58ea$var$findNearestBoundary(matches, deepestRouteId).route.id]: {
                    type: "error",
                    result: error
                }
            };
        }
    }
}
async function $50e5d6e8689f58ea$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    return await $50e5d6e8689f58ea$var$callRouteMiddleware(dataFnArgs, matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []), handler, processResult, isResult, errorHandler);
}
async function $50e5d6e8689f58ea$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? /* @__PURE__ */ new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) return await handler();
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            nextResult = {
                value: await $50e5d6e8689f58ea$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1)
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        return await errorHandler(error, routeId, nextResult);
    }
}
function $50e5d6e8689f58ea$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $50e5d6e8689f58ea$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties
    });
    let lazyRoutePromises = $50e5d6e8689f58ea$var$loadLazyRoute(match.route, $50e5d6e8689f58ea$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $50e5d6e8689f58ea$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $50e5d6e8689f58ea$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $50e5d6e8689f58ea$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $50e5d6e8689f58ea$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $50e5d6e8689f58ea$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$50e5d6e8689f58ea$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($50e5d6e8689f58ea$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $50e5d6e8689f58ea$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data",
                result: void 0
            });
        }
    };
}
function $50e5d6e8689f58ea$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $50e5d6e8689f58ea$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $50e5d6e8689f58ea$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, (0, $vjGlj.getRoutePattern)(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $50e5d6e8689f58ea$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, initiator, scopedContext, isStaticHandler, navigationType = null) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: (0, $vjGlj.createDataFunctionUrl)(request, path),
        pattern: (0, $vjGlj.getRoutePattern)(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches,
        unstable_initiator: initiator,
        unstable_navigationType: initiator === "navigation" ? navigationType : null
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $50e5d6e8689f58ea$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch  {}
    return results;
}
async function $50e5d6e8689f58ea$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $50e5d6e8689f58ea$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(/* @__PURE__ */ new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: (0, $vjGlj.createDataFunctionUrl)(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                return {
                    type: "data",
                    result: await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler())
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler = isAction ? match.route.action : match.route.loader;
                if (handler) [result] = await Promise.all([
                    runHandler(handler),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $50e5d6e8689f58ea$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else {
                    await lazyRoutePromise;
                    return {
                        type: "data",
                        result: void 0
                    };
                }
            }
        } else if (!handler) {
            let url = new URL(request.url);
            throw $50e5d6e8689f58ea$var$getInternalRouterError(404, {
                pathname: url.pathname + url.search
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error",
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $50e5d6e8689f58ea$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $50e5d6e8689f58ea$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($50e5d6e8689f58ea$export$3f1eb41d9a6a6a27(result)) {
        let data;
        try {
            data = await $50e5d6e8689f58ea$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error",
                error: e
            };
        }
        if (type === "error") return {
            type: "error",
            error: new (0, $vjGlj.ErrorResponseImpl)(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data",
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error") {
        if ($50e5d6e8689f58ea$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error",
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error",
                error: $50e5d6e8689f58ea$var$dataWithResponseInitToErrorResponse(result),
                statusCode: (0, $vjGlj.isRouteErrorResponse)(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error",
            error: result,
            statusCode: (0, $vjGlj.isRouteErrorResponse)(result) ? result.status : void 0
        };
    }
    if ($50e5d6e8689f58ea$export$e0163cfdf7bc9cfa(result)) return {
        type: "data",
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data",
        data: result
    };
}
function $50e5d6e8689f58ea$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    (0, $i4yVL.invariant)(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!(0, $vjGlj.isAbsoluteUrl)(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $50e5d6e8689f58ea$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
const $50e5d6e8689f58ea$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    "javascript:"
];
function $50e5d6e8689f58ea$export$961a3ef7a4da3a39(location) {
    try {
        return $50e5d6e8689f58ea$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $50e5d6e8689f58ea$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ((0, $vjGlj.isAbsoluteUrl)(location)) {
        let normalizedLocation = location;
        let url = (0, $8w9JA.PROTOCOL_RELATIVE_URL_REGEX).test(normalizedLocation) ? new URL((0, $8w9JA.normalizeProtocolRelativeUrl)(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($50e5d6e8689f58ea$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = (0, $vjGlj.stripBasename)(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return (0, $vjGlj.removeDoubleSlashes)(url.pathname) + url.search + url.hash;
    }
    try {
        if ($50e5d6e8689f58ea$export$961a3ef7a4da3a39(historyInstance.createURL(location).toString())) throw new Error("Invalid redirect location");
    } catch  {}
    return location;
}
function $50e5d6e8689f58ea$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($50e5d6e8689f58ea$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $50e5d6e8689f58ea$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $50e5d6e8689f58ea$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $50e5d6e8689f58ea$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $50e5d6e8689f58ea$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $50e5d6e8689f58ea$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $50e5d6e8689f58ea$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        (0, $i4yVL.invariant)(!$50e5d6e8689f58ea$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($50e5d6e8689f58ea$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $50e5d6e8689f58ea$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $50e5d6e8689f58ea$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = (0, $vjGlj.isRouteErrorResponse)(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $50e5d6e8689f58ea$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $50e5d6e8689f58ea$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, routeId: routeId, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        (0, $i4yVL.invariant)(result, "Did not find corresponding fetcher result");
        if ($50e5d6e8689f58ea$var$isErrorResult(result)) {
            let boundaryMatch = $50e5d6e8689f58ea$var$findNearestBoundary(state.matches, routeId);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($50e5d6e8689f58ea$var$isRedirectResult(result)) (0, $i4yVL.invariant)(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $50e5d6e8689f58ea$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $50e5d6e8689f58ea$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $50e5d6e8689f58ea$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    let preservedCount = 0;
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) {
            mergedLoaderData[id] = loaderData[id];
            preservedCount++;
        }
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return Object.keys(newLoaderData).length === 0 && preservedCount === Object.keys(loaderData).length ? loaderData : mergedLoaderData;
}
function $50e5d6e8689f58ea$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $50e5d6e8689f58ea$var$isErrorResult(pendingActionResult[1]) ? {
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $50e5d6e8689f58ea$var$findNearestBoundary(matches, routeId) {
    return (routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ]).reverse().find((m)=>m.route.ErrorBoundary != null || m.route.errorElement != null) || matches[0];
}
function $50e5d6e8689f58ea$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $50e5d6e8689f58ea$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new (0, $vjGlj.ErrorResponseImpl)(status || 500, statusText, new Error(errorMessage), true);
}
function $50e5d6e8689f58ea$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($50e5d6e8689f58ea$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $50e5d6e8689f58ea$var$stripHashFromPath(path) {
    return (0, $i4yVL.createPath)({
        ...typeof path === "string" ? (0, $i4yVL.parsePath)(path) : path,
        hash: ""
    });
}
function $50e5d6e8689f58ea$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $50e5d6e8689f58ea$var$dataWithResponseInitToResponse(data) {
    return Response.json(data.data, data.init ?? void 0);
}
function $50e5d6e8689f58ea$var$dataWithResponseInitToErrorResponse(data) {
    return new (0, $vjGlj.ErrorResponseImpl)(data.init?.status ?? 500, data.init?.statusText ?? "Internal Server Error", data.data);
}
function $50e5d6e8689f58ea$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $50e5d6e8689f58ea$var$isDataStrategyResult(value));
}
function $50e5d6e8689f58ea$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" || result.type === "error");
}
function $50e5d6e8689f58ea$var$isRedirectDataStrategyResult(result) {
    return $50e5d6e8689f58ea$export$3f1eb41d9a6a6a27(result.result) && $50e5d6e8689f58ea$var$redirectStatusCodes.has(result.result.status);
}
function $50e5d6e8689f58ea$var$isErrorResult(result) {
    return result.type === "error";
}
function $50e5d6e8689f58ea$var$isRedirectResult(result) {
    return (result && result.type) === "redirect";
}
function $50e5d6e8689f58ea$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $50e5d6e8689f58ea$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $50e5d6e8689f58ea$export$794b2760043cf8cd(statusCode) {
    return $50e5d6e8689f58ea$var$redirectStatusCodes.has(statusCode);
}
function $50e5d6e8689f58ea$export$6e80290866a84dd4(result) {
    return $50e5d6e8689f58ea$export$3f1eb41d9a6a6a27(result) && $50e5d6e8689f58ea$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $50e5d6e8689f58ea$var$isValidMethod(method) {
    return $50e5d6e8689f58ea$var$validRequestMethods.has(method.toUpperCase());
}
function $50e5d6e8689f58ea$export$cbae47800eb95bc3(method) {
    return $50e5d6e8689f58ea$var$validMutationMethods.has(method.toUpperCase());
}
function $50e5d6e8689f58ea$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $50e5d6e8689f58ea$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? (0, $i4yVL.parsePath)(location).search : location.search;
    if (matches[matches.length - 1].route.index && $50e5d6e8689f58ea$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = (0, $vjGlj.getPathContributingMatches)(matches);
    return pathMatches[pathMatches.length - 1];
}
function $50e5d6e8689f58ea$var$getInstrumentationNavigateMeta(history, location, matches) {
    return {
        url: (0, $vjGlj.createDataFunctionUrl)(history.createURL(location), location),
        pattern: matches ? (0, $vjGlj.getRoutePattern)(matches) : "",
        params: matches?.[0]?.params ? {
            ...matches[0].params
        } : {}
    };
}
function $50e5d6e8689f58ea$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $50e5d6e8689f58ea$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    else return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0
    };
}
function $50e5d6e8689f58ea$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    return {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
}
function $50e5d6e8689f58ea$var$getLoadingFetcher(submission, data) {
    if (submission) return {
        state: "loading",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: data
    };
    else return {
        state: "loading",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $50e5d6e8689f58ea$var$getSubmittingFetcher(submission, existingFetcher) {
    return {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
}
function $50e5d6e8689f58ea$var$getDoneFetcher(data) {
    return {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $50e5d6e8689f58ea$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($50e5d6e8689f58ea$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch  {}
}
function $50e5d6e8689f58ea$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($50e5d6e8689f58ea$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            (0, $i4yVL.warning)(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $50e5d6e8689f58ea$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch  {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch  {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}

});
parcelRegister("5l3C8", function(module, exports) {

$parcel$export(module.exports, "getRouteInstrumentationUpdates", function () { return $3e31b79baaa4bedf$export$3cb8f5f9ecc770ef; });
$parcel$export(module.exports, "instrumentClientSideRouter", function () { return $3e31b79baaa4bedf$export$ac4df491f31cbbfc; });
$parcel$export(module.exports, "consumeInstrumentationClientResultMetaReceiver", function () { return $3e31b79baaa4bedf$export$5579798e35f5560e; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $i4yVL = parcelRequire("i4yVL");

var $vjGlj = parcelRequire("vjGlj");
//#region lib/router/instrumentation.ts
const $3e31b79baaa4bedf$var$UninstrumentedSymbol = Symbol("Uninstrumented");
const $3e31b79baaa4bedf$export$b1aab28b8e9d7d25 = (0, $vjGlj.createContext)();
let $3e31b79baaa4bedf$var$instrumentationClientResultMetaReceivers = /* @__PURE__ */ new WeakMap();
function $3e31b79baaa4bedf$export$3cb8f5f9ecc770ef(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                if (i.lazy != null) aggregated.lazy.push(i.lazy);
                if (i["lazy.loader"] != null) aggregated["lazy.loader"].push(i["lazy.loader"]);
                if (i["lazy.action"] != null) aggregated["lazy.action"].push(i["lazy.action"]);
                if (i["lazy.middleware"] != null) aggregated["lazy.middleware"].push(i["lazy.middleware"]);
                if (i.middleware != null) aggregated.middleware.push(i.middleware);
                if (i.loader != null) aggregated.loader.push(i.loader);
                if (i.action != null) aggregated.action.push(i.action);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let lazy = route.lazy;
        updates.lazy = async (...args)=>{
            return $3e31b79baaa4bedf$var$throwOrReturnResult(await $3e31b79baaa4bedf$var$recurseRight(aggregated.lazy, void 0, ()=>lazy(...args), $3e31b79baaa4bedf$var$getInstrumentationInnerResult));
        };
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        if (typeof lazyObject.middleware === "function" && aggregated["lazy.middleware"].length > 0) {
            let middleware = lazyObject.middleware;
            updates.lazy = Object.assign(updates.lazy || {}, {
                middleware: async (...args)=>{
                    return $3e31b79baaa4bedf$var$throwOrReturnResult(await $3e31b79baaa4bedf$var$recurseRight(aggregated["lazy.middleware"], void 0, ()=>middleware(...args), $3e31b79baaa4bedf$var$getInstrumentationInnerResult));
                }
            });
        }
        if (typeof lazyObject.loader === "function" && aggregated["lazy.loader"].length > 0) {
            let loader = lazyObject.loader;
            updates.lazy = Object.assign(updates.lazy || {}, {
                loader: async (...args)=>{
                    return $3e31b79baaa4bedf$var$throwOrReturnResult(await $3e31b79baaa4bedf$var$recurseRight(aggregated["lazy.loader"], void 0, ()=>loader(...args), $3e31b79baaa4bedf$var$getInstrumentationInnerResult));
                }
            });
        }
        if (typeof lazyObject.action === "function" && aggregated["lazy.action"].length > 0) {
            let action = lazyObject.action;
            updates.lazy = Object.assign(updates.lazy || {}, {
                action: async (...args)=>{
                    return $3e31b79baaa4bedf$var$throwOrReturnResult(await $3e31b79baaa4bedf$var$recurseRight(aggregated["lazy.action"], void 0, ()=>action(...args), $3e31b79baaa4bedf$var$getInstrumentationInnerResult));
                }
            });
        }
    }
    if (typeof route.loader === "function" && aggregated.loader.length > 0) {
        let original = $3e31b79baaa4bedf$var$getUninstrumentedHandler(route.loader);
        let instrumented = async (...args)=>{
            return $3e31b79baaa4bedf$var$throwOrReturnResult(await $3e31b79baaa4bedf$var$recurseRight(aggregated.loader, $3e31b79baaa4bedf$var$getHandlerInfo(args[0]), ()=>original(...args), $3e31b79baaa4bedf$var$getInstrumentationInnerResult));
        };
        if (original.hydrate === true) instrumented.hydrate = true;
        $3e31b79baaa4bedf$var$setUninstrumentedHandler(instrumented, original);
        updates.loader = instrumented;
    }
    if (typeof route.action === "function" && aggregated.action.length > 0) {
        let original = $3e31b79baaa4bedf$var$getUninstrumentedHandler(route.action);
        let instrumented = async (...args)=>{
            return $3e31b79baaa4bedf$var$throwOrReturnResult(await $3e31b79baaa4bedf$var$recurseRight(aggregated.action, $3e31b79baaa4bedf$var$getHandlerInfo(args[0]), ()=>original(...args), $3e31b79baaa4bedf$var$getInstrumentationInnerResult));
        };
        $3e31b79baaa4bedf$var$setUninstrumentedHandler(instrumented, original);
        updates.action = instrumented;
    }
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = $3e31b79baaa4bedf$var$getUninstrumentedHandler(middleware);
        let instrumented = async (...args)=>{
            return $3e31b79baaa4bedf$var$throwOrReturnResult(await $3e31b79baaa4bedf$var$recurseRight(aggregated.middleware, $3e31b79baaa4bedf$var$getHandlerInfo(args[0]), ()=>original(...args), $3e31b79baaa4bedf$var$getInstrumentationInnerResult));
        };
        $3e31b79baaa4bedf$var$setUninstrumentedHandler(instrumented, original);
        return instrumented;
    });
    return updates;
}
function $3e31b79baaa4bedf$export$ac4df491f31cbbfc(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                if (i.navigate != null) aggregated.navigate.push(i.navigate);
                if (i.fetch != null) aggregated.fetch.push(i.fetch);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = $3e31b79baaa4bedf$var$getUninstrumentedHandler(router.navigate);
        let instrumentedNavigate = async (...args)=>{
            let [to, opts] = args;
            let meta;
            let info = {
                to: typeof to === "number" || typeof to === "string" ? to : to ? (0, $i4yVL.createPath)(to) : ".",
                ...$3e31b79baaa4bedf$var$getRouterInfo(router, opts ?? {})
            };
            return $3e31b79baaa4bedf$var$throwOrReturnResult(await $3e31b79baaa4bedf$var$recurseRight(aggregated.navigate, info, async ()=>{
                if (typeof to === "number") return await navigate(...args);
                let cleanup = $3e31b79baaa4bedf$var$setInstrumentationClientResultMetaReceiver(router, (value)=>{
                    meta = value;
                });
                try {
                    return await navigate(...args);
                } finally{
                    cleanup();
                }
            }, (result)=>({
                    ...$3e31b79baaa4bedf$var$getInstrumentationInnerResult(result),
                    meta: meta
                })));
        };
        $3e31b79baaa4bedf$var$setUninstrumentedHandler(instrumentedNavigate, navigate);
        router.navigate = instrumentedNavigate;
    }
    if (aggregated.fetch.length > 0) {
        let fetch = $3e31b79baaa4bedf$var$getUninstrumentedHandler(router.fetch);
        let instrumentedFetch = async (...args)=>{
            let [key, _, href, opts] = args;
            let meta;
            return $3e31b79baaa4bedf$var$throwOrReturnResult(await $3e31b79baaa4bedf$var$recurseRight(aggregated.fetch, {
                href: href ?? ".",
                fetcherKey: key,
                ...$3e31b79baaa4bedf$var$getRouterInfo(router, opts ?? {})
            }, async ()=>{
                let cleanup = $3e31b79baaa4bedf$var$setInstrumentationClientResultMetaReceiver(router, (value)=>{
                    meta = value;
                });
                try {
                    return await fetch(...args);
                } finally{
                    cleanup();
                }
            }, (result)=>({
                    ...$3e31b79baaa4bedf$var$getInstrumentationInnerResult(result),
                    meta: meta
                })));
        };
        $3e31b79baaa4bedf$var$setUninstrumentedHandler(instrumentedFetch, fetch);
        router.fetch = instrumentedFetch;
    }
    return router;
}
function $3e31b79baaa4bedf$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                if (i.request != null) aggregated.request.push(i.request);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = async (...args)=>{
        let [request, context] = args;
        let instrumentationContext = context ?? new (0, $vjGlj.RouterContextProvider)();
        return $3e31b79baaa4bedf$var$throwOrReturnResult(await $3e31b79baaa4bedf$var$recurseRight(aggregated.request, {
            request: $3e31b79baaa4bedf$var$getReadonlyRequest(request),
            context: $3e31b79baaa4bedf$var$getReadonlyContext(instrumentationContext)
        }, ()=>handler(request, instrumentationContext), (result, info)=>{
            let meta;
            try {
                meta = info.context?.get($3e31b79baaa4bedf$export$b1aab28b8e9d7d25);
            } catch  {}
            (0, $i4yVL.invariant)(result.value instanceof Response, "Expected a Response from the request handler");
            return {
                ...$3e31b79baaa4bedf$var$getInstrumentationInnerResult(result),
                statusCode: result.value.status,
                meta: meta
            };
        }));
    };
    return instrumentedHandler;
}
function $3e31b79baaa4bedf$var$getUninstrumentedHandler(handler) {
    return handler[$3e31b79baaa4bedf$var$UninstrumentedSymbol] ?? handler;
}
function $3e31b79baaa4bedf$var$setUninstrumentedHandler(handler, uninstrumentedHandler) {
    handler[$3e31b79baaa4bedf$var$UninstrumentedSymbol] = uninstrumentedHandler;
}
function $3e31b79baaa4bedf$var$setInstrumentationClientResultMetaReceiver(router, receiver) {
    $3e31b79baaa4bedf$var$instrumentationClientResultMetaReceivers.set(router, receiver);
    return ()=>{
        if ($3e31b79baaa4bedf$var$instrumentationClientResultMetaReceivers.get(router) === receiver) $3e31b79baaa4bedf$var$instrumentationClientResultMetaReceivers.delete(router);
    };
}
function $3e31b79baaa4bedf$export$5579798e35f5560e(router) {
    let receiver = $3e31b79baaa4bedf$var$instrumentationClientResultMetaReceivers.get(router);
    $3e31b79baaa4bedf$var$instrumentationClientResultMetaReceivers.delete(router);
    return receiver;
}
function $3e31b79baaa4bedf$var$throwOrReturnResult(result) {
    if (result.type === "error") throw result.value;
    return result.value;
}
async function $3e31b79baaa4bedf$var$recurseRight(impls, info, handler, getInnerResult, state = {
    result: null,
    innerResult: null
}, index = impls.length - 1) {
    let impl = impls[index];
    if (!impl) {
        try {
            state.result = {
                type: "success",
                value: await handler()
            };
        } catch (e) {
            state.result = {
                type: "error",
                value: e
            };
        }
        state.innerResult = getInnerResult(state.result, info);
    } else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $3e31b79baaa4bedf$var$recurseRight(impls, info, handler, getInnerResult, state, index - 1);
            await handlerPromise;
            (0, $i4yVL.invariant)(state.innerResult, "Expected an inner result");
            return state.innerResult;
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (state.result) return state.result;
    state.result = {
        type: "error",
        value: /* @__PURE__ */ new Error("No result assigned in instrumentation chain.")
    };
    state.innerResult = getInnerResult(state.result, info);
    return state.result;
}
function $3e31b79baaa4bedf$var$getInstrumentationInnerResult(result) {
    if (result.type === "error" && result.value instanceof Error) return {
        status: "error",
        error: result.value
    };
    return {
        status: "success",
        error: void 0
    };
}
function $3e31b79baaa4bedf$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params } = args;
    return {
        ...args,
        request: $3e31b79baaa4bedf$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        context: $3e31b79baaa4bedf$var$getReadonlyContext(context)
    };
}
function $3e31b79baaa4bedf$var$getRouterInfo(router, opts) {
    return {
        currentUrl: (0, $i4yVL.createPath)(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $3e31b79baaa4bedf$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $3e31b79baaa4bedf$var$getReadonlyContext(context) {
    return {
        get: (ctx)=>context.get(ctx)
    };
}

});

parcelRegister("kXPDB", function(module, exports) {

$parcel$export(module.exports, "V6RegExMatcher", function () { return $f4315f89146efef6$export$92541312f2982378; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $vjGlj = parcelRequire("vjGlj");
//#region lib/router/matcher.ts
var $f4315f89146efef6$export$92541312f2982378 = class {
    #routes = [];
    #branches = [];
    #basename;
    #matchCost = 0;
    constructor(basename){
        this.#basename = basename;
    }
    update(routes) {
        this.#routes = routes;
        this.#branches = (0, $vjGlj.flattenAndRankRoutes)(routes);
        this.#matchCost = this.#branches.reduce((total, branch)=>total + branch.routesMeta.length, 0);
    }
    get matchCost() {
        return this.#matchCost;
    }
    match(locationArg, allowPartial = false) {
        return (0, $vjGlj.matchRoutesImpl)(this.#routes, locationArg, this.#basename, allowPartial, this.#branches);
    }
};

});

parcelRegister("8ZYWE", function(module, exports) {

$parcel$export(module.exports, "getRoutePatternMatcher", function () { return $68d34ba526dc2ea2$export$45cda2a841115322; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $5BQsP = parcelRequire("5BQsP");
//#region lib/router/matcher-route-pattern.preload.ts
let $68d34ba526dc2ea2$var$RoutePatternMatcher;
function $68d34ba526dc2ea2$export$45cda2a841115322() {
    return $68d34ba526dc2ea2$var$RoutePatternMatcher;
}
/**
* Initialize the route-pattern matcher before creating a Data Router or static
* handler with `future.unstable_routePatternMatching` enabled. Import from
* `react-router/route-pattern` and call this once during application startup.
* Server and browser applications must each preload their own matcher.
*
* The matcher is statically imported by this module. Tree-shaking bundlers can
* remove it from applications that do not use this function. Initialization is
* synchronous, and repeated calls are safe.
*
* @public
* @category Data Routers
* @mode data
* @returns {void}
*/ function $68d34ba526dc2ea2$export$c6cb8c636109e21b() {
    $68d34ba526dc2ea2$var$RoutePatternMatcher = (0, $5BQsP.RoutePatternDataRouteMatcher);
}

});
parcelRegister("5BQsP", function(module, exports) {

$parcel$export(module.exports, "RoutePatternDataRouteMatcher", function () { return $41591ab2d63bb119$export$9f42f7e9b7c469cc; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $i4yVL = parcelRequire("i4yVL");

var $vjGlj = parcelRequire("vjGlj");
parcelRequire("7JQEI");
var $RSyrX = parcelRequire("RSyrX");
parcelRequire("i6q8q");
var $3T281 = parcelRequire("3T281");
//#region lib/router/matcher-route-pattern.ts
var $41591ab2d63bb119$export$9f42f7e9b7c469cc = class {
    #state;
    #basename;
    constructor(basename){
        this.#basename = basename;
    }
    update(routes) {
        let branches = $41591ab2d63bb119$var$flattenRoutes(routes);
        let matcher = (0, $RSyrX.createMultiMatcher)({
            ignoreCase: true
        });
        let partialMatcher = (0, $RSyrX.createMultiMatcher)({
            ignoreCase: true
        });
        for (let branch of branches){
            let routePattern = $41591ab2d63bb119$var$convertReactRouterPathToRoutePattern(branch.path);
            $41591ab2d63bb119$var$validateRoutePatternSplat(branch.path, routePattern);
            routePattern = $41591ab2d63bb119$var$addOptionalTrailingSlash(routePattern);
            matcher.add(routePattern, branch);
            if (!branch.routesMeta[branch.routesMeta.length - 1].route.index) partialMatcher.add(routePattern === "/" ? `/*__rr_partial` : `${routePattern}(/*__rr_partial)`, branch);
        }
        this.#state = {
            branches: branches,
            matcher: matcher,
            partialMatcher: partialMatcher
        };
        return branches;
    }
    match(locationArg, allowPartial = false) {
        let pathname = (0, $vjGlj.stripBasename)((typeof locationArg === "string" ? (0, $i4yVL.parsePath)(locationArg) : locationArg).pathname || "/", this.#basename);
        if (pathname == null) return null;
        let decoded = (0, $vjGlj.decodePath)(pathname);
        let url = new URL("http://reactrouter.local");
        url.pathname = pathname.endsWith("/") ? pathname : `${pathname}/`;
        (0, $i4yVL.invariant)(this.#state, "Route pattern routes must be initialized before matching.");
        let matches = this.#state.matcher.matchAll(url);
        if (allowPartial) matches.push(...this.#state.partialMatcher.matchAll(url));
        for (let match of $41591ab2d63bb119$var$prioritizeValidatedMatches(matches)){
            let routeMatches = $41591ab2d63bb119$var$convertRoutePatternMatchToRouteMatches(match, decoded, allowPartial);
            if (routeMatches && $41591ab2d63bb119$var$validateRouteMatchParams(routeMatches)) return routeMatches;
        }
        return null;
    }
};
function $41591ab2d63bb119$var$validateRoutePatternSplat(routePath, routePattern) {
    (0, $i4yVL.invariant)($41591ab2d63bb119$var$getRoutePatternSplatIndexes(routePattern).length <= 1 && $41591ab2d63bb119$var$isTerminalRoutePatternSplat(routePattern), `Route path "${routePath}" is not supported with \`future.unstable_routePatternMatching\` because React Router only supports a single splat at the end of a route path.`);
}
function $41591ab2d63bb119$var$getRoutePatternSplatIndexes(routePattern) {
    let splatIndexes = [];
    for(let i = 0; i < routePattern.length; i++){
        let char = routePattern[i];
        if (char === "\\") {
            i++;
            continue;
        }
        if (char === "*") splatIndexes.push(i);
    }
    return splatIndexes;
}
function $41591ab2d63bb119$var$isTerminalRoutePatternSplat(routePattern) {
    for(let i = 0; i < routePattern.length; i++){
        let char = routePattern[i];
        if (char === "\\") {
            i++;
            continue;
        }
        if (char !== "*") continue;
        let suffix = routePattern.slice(i + 1);
        return /^[a-zA-Z_$][a-zA-Z_$0-9]*$/.test(suffix) || suffix === "";
    }
    return true;
}
function $41591ab2d63bb119$var$addOptionalTrailingSlash(routePattern) {
    return routePattern === "/" ? routePattern : `${routePattern.replace(/\/+$/, "")}(/)`;
}
function $41591ab2d63bb119$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "") {
    routes.forEach((route, index)=>{
        (0, $i4yVL.invariant)(route.caseSensitive !== true, "`caseSensitive` routes are not supported with `future.unstable_routePatternMatching`.");
        let meta = {
            relativePath: route.path || "",
            caseSensitive: false,
            childrenIndex: index,
            route: route
        };
        let absolutePath;
        if (meta.relativePath.startsWith("/")) {
            absolutePath = meta.relativePath;
            let parentPathMatch = (0, $vjGlj.explodeOptionalSegments)(parentPath).find((path)=>meta.relativePath.startsWith(path));
            (0, $i4yVL.invariant)(parentPathMatch != null, `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPathMatch.length);
        }
        let routesMeta = parentsMeta.concat(meta);
        let path = absolutePath ?? (meta.relativePath ? (0, $vjGlj.joinPaths)([
            parentPath,
            meta.relativePath
        ]) : parentPath);
        if (route.children && route.children.length > 0) {
            (0, $i4yVL.invariant)(route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $41591ab2d63bb119$var$flattenRoutes(route.children, branches, routesMeta, path);
            if (route.children?.some((child)=>child.index)) return;
        }
        if (route.path != null || route.index) branches.push({
            path: path,
            score: 0,
            routesMeta: routesMeta
        });
    });
    return branches;
}
function $41591ab2d63bb119$var$convertReactRouterPathToRoutePattern(path) {
    (0, $i4yVL.warning)(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) path = path.replace(/\*$/, "/*");
    path = path.replace(/^\/*/, "/");
    if (path === "") return "/";
    let segments = path.split("/");
    let pattern = segments.shift() || "";
    for(let i = 0; i < segments.length;){
        let optionalRun = [];
        while(i < segments.length && $41591ab2d63bb119$var$isOptionalRouteSegment(segments[i])){
            optionalRun.push($41591ab2d63bb119$var$convertRouteSegment(segments[i].slice(0, -1)));
            i++;
        }
        if (optionalRun.length > 0) {
            let nested = optionalRun.reduceRight((child, segment)=>`/${segment}${child ? `(${child})` : ""}`, "");
            pattern += `(${nested})`;
            continue;
        }
        pattern += `/${$41591ab2d63bb119$var$convertRouteSegment(segments[i])}`;
        i++;
    }
    return pattern || "/";
}
function $41591ab2d63bb119$var$isOptionalRouteSegment(segment) {
    return segment.endsWith("?");
}
function $41591ab2d63bb119$var$convertRouteSegment(segment) {
    if (segment === "*") return "*__rr_splat";
    let paramMatch = segment.match(/^:([\w-]+)(\?)?(.*)$/);
    if (paramMatch) {
        let [, paramName, optional, suffix] = paramMatch;
        let converted = `:${paramName}${$41591ab2d63bb119$var$escapeRoutePatternLiteral(suffix)}`;
        return optional ? `(:${paramName})${$41591ab2d63bb119$var$escapeRoutePatternLiteral(suffix)}` : converted;
    }
    return $41591ab2d63bb119$var$escapeRoutePatternLiteral(segment);
}
function $41591ab2d63bb119$var$escapeRoutePatternLiteral(value) {
    return value.replace(/[\\():*]/g, "\\$&");
}
function $41591ab2d63bb119$var$validateRouteMatchParams(matches) {
    return matches.every(({ route: route, params: params })=>route.unstable_validateParams == null || Object.keys(route.unstable_validateParams).length === 0 || Object.entries(route.unstable_validateParams).every(([param, re])=>params[param] != null ? new RegExp(re.source, re.flags).test(params[param]) : true));
}
function $41591ab2d63bb119$var$prioritizeValidatedMatches(matches) {
    return matches.sort((a, b)=>{
        let specificity = (0, $3T281.descending)(a, b);
        if (specificity !== 0) return specificity;
        return Number($41591ab2d63bb119$var$hasParamValidators(b)) - Number($41591ab2d63bb119$var$hasParamValidators(a));
    });
}
function $41591ab2d63bb119$var$hasParamValidators(match) {
    return match.data.routesMeta.some((meta)=>meta.route.unstable_validateParams != null && Object.keys(meta.route.unstable_validateParams).length > 0);
}
function $41591ab2d63bb119$var$convertRoutePatternMatchToRouteMatches(match, pathname, allowPartial) {
    let result = $41591ab2d63bb119$var$matchRoutePatternBranch(match.data, pathname, allowPartial, 0, "/", {});
    if (result == null) return null;
    for (let routeMatch of result.matches)routeMatch.params = result.params;
    return result.matches;
}
function $41591ab2d63bb119$var$matchRoutePatternBranch(branch, pathname, allowPartial, metaIndex, matchedPathname, matchedParams) {
    let meta = branch.routesMeta[metaIndex];
    let end = metaIndex === branch.routesMeta.length - 1;
    let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
    for (let relativePath of (0, $vjGlj.explodeOptionalSegments)(meta.relativePath)){
        let pattern = {
            path: relativePath,
            caseSensitive: false,
            end: end
        };
        let pathMatch = (0, $vjGlj.matchPath)(pattern, remainingPathname);
        if (!pathMatch && end && allowPartial && !meta.route.index) pathMatch = (0, $vjGlj.matchPath)({
            ...pattern,
            end: false
        }, remainingPathname);
        if (!pathMatch) continue;
        let params = {
            ...matchedParams,
            ...pathMatch.params
        };
        let routeMatch = {
            params: params,
            pathname: (0, $vjGlj.joinPaths)([
                matchedPathname,
                pathMatch.pathname
            ]),
            pathnameBase: (0, $vjGlj.normalizePathname)((0, $vjGlj.joinPaths)([
                matchedPathname,
                pathMatch.pathnameBase
            ])),
            route: meta.route
        };
        let nextMatchedPathname = pathMatch.pathnameBase === "/" ? matchedPathname : (0, $vjGlj.joinPaths)([
            matchedPathname,
            pathMatch.pathnameBase
        ]);
        if (end) return {
            matches: [
                routeMatch
            ],
            params: params
        };
        let childResult = $41591ab2d63bb119$var$matchRoutePatternBranch(branch, pathname, allowPartial, metaIndex + 1, nextMatchedPathname, params);
        if (childResult) return {
            matches: [
                routeMatch,
                ...childResult.matches
            ],
            params: childResult.params
        };
    }
    return null;
}

});
parcelRegister("7JQEI", function(module, exports) {

$parcel$export(module.exports, "createMultiMatcher", function () { return (parcelRequire("RSyrX")).createMultiMatcher; });

var $RSyrX = parcelRequire("RSyrX");

});
parcelRegister("RSyrX", function(module, exports) {

$parcel$export(module.exports, "createMultiMatcher", function () { return $0a1f44c47a1cf22c$export$cf760d085d57ec27; });

var $kZ1Ul = parcelRequire("kZ1Ul");

var $fkMsu = parcelRequire("fkMsu");

var $kWAGs = parcelRequire("kWAGs");

var $3T281 = parcelRequire("3T281");
function $0a1f44c47a1cf22c$export$1d94974cf1366deb(pattern, options) {
    pattern = typeof pattern === 'string' ? (0, $kZ1Ul.RoutePattern).parse(pattern) : pattern;
    let matcher = $0a1f44c47a1cf22c$export$cf760d085d57ec27(options);
    matcher.add(pattern, undefined);
    return {
        match (url) {
            return matcher.match(url);
        }
    };
}
function $0a1f44c47a1cf22c$export$cf760d085d57ec27(options) {
    return new $0a1f44c47a1cf22c$var$TrieMatcher(options);
}
class $0a1f44c47a1cf22c$var$TrieMatcher {
    ignoreCase;
    #trie;
    constructor(options){
        this.ignoreCase = options?.ignoreCase ?? false;
        this.#trie = new (0, $kWAGs.Trie)({
            ignoreCase: this.ignoreCase
        });
    }
    add(pattern, data) {
        pattern = typeof pattern === 'string' ? (0, $fkMsu.parsePattern)(pattern) : pattern;
        this.#trie.insert(pattern, data);
    }
    match(url) {
        let parsedUrl = typeof url === 'string' ? new URL(url) : url;
        let best = null;
        for (let match of this.#trie.search(parsedUrl))if (best === null || $3T281.greaterThan(match, best)) best = match;
        return best;
    }
    matchAll(url) {
        let parsedUrl = typeof url === 'string' ? new URL(url) : url;
        let matches = [];
        for (let match of this.#trie.search(parsedUrl))matches.push(match);
        return matches.sort($3T281.descending);
    }
}

});
parcelRegister("kZ1Ul", function(module, exports) {

$parcel$export(module.exports, "RoutePattern", function () { return $f46afbfe630f5131$export$2917961db0dd6e8b; });

var $fkMsu = parcelRequire("fkMsu");

var $FR5FW = parcelRequire("FR5FW");
class $f46afbfe630f5131$export$2917961db0dd6e8b {
    protocol;
    hostname;
    port;
    pathname;
    search;
    /**
     * Create a new `RoutePattern` by parsing a source string.
     *
     * @param source The route pattern source string.
     * @returns The parsed route pattern.
     */ static parse(source) {
        return (0, $fkMsu.parsePattern)(source);
    }
    /**
     * Create a new `RoutePattern` from parsed parts of a route pattern.
     *
     * Useful for efficiently deriving new patterns from already parsed patterns.
     * Unless you know what you are doing, you probably want `RoutePattern.parse`.
     *
     * @param parsed Parsed route pattern parts.
     */ constructor(parsed){
        this.protocol = parsed.protocol;
        this.hostname = parsed.hostname;
        this.port = parsed.port;
        this.pathname = parsed.pathname;
        this.search = parsed.search;
    }
    /** Normalized string representation of this pattern */ get source() {
        return (0, $FR5FW.serializePattern)(this);
    }
    /**
     * Returns a string representing this route pattern.
     *
     * @returns The same normalized pattern string as `RoutePattern.source`.
     */ toString() {
        return this.source;
    }
    /**
     * Returns a JSON-serializable object containing each serialized part of this route pattern.
     *
     * @returns The serialized protocol, hostname, port, pathname, and search.
     */ toJSON() {
        return (0, $FR5FW.serializePatternParts)(this);
    }
}

});
parcelRegister("fkMsu", function(module, exports) {

$parcel$export(module.exports, "parsePattern", function () { return $b29e50226ffecc87$export$e26190e3669abbfe; });

var $fNJ4P = parcelRequire("fNJ4P");

var $kZ1Ul = parcelRequire("kZ1Ul");
const $b29e50226ffecc87$var$IDENTIFIER_RE = /^[a-zA-Z_$][a-zA-Z_$0-9]*/;
function $b29e50226ffecc87$export$e26190e3669abbfe(source) {
    let spans = (0, $fNJ4P.split)(source);
    return new (0, $kZ1Ul.RoutePattern)({
        protocol: $b29e50226ffecc87$var$parseProtocol(source, spans.protocol),
        hostname: $b29e50226ffecc87$var$parseHostname(source, spans.hostname),
        port: spans.port ? source.slice(...spans.port) : null,
        pathname: spans.pathname ? $b29e50226ffecc87$export$6681bda78b6b4cbd(source, {
            span: spans.pathname,
            type: 'pathname'
        }) : $b29e50226ffecc87$export$6681bda78b6b4cbd('', {
            span: [
                0,
                0
            ],
            type: 'pathname'
        }),
        search: spans.search ? $b29e50226ffecc87$var$parseSearch(source.slice(...spans.search)) : new Map()
    });
}
function $b29e50226ffecc87$export$6681bda78b6b4cbd(source, options) {
    let span = options.span ?? [
        0,
        source.length
    ];
    let separator = options.type === 'hostname' ? '.' : '/';
    let tokens = [];
    let optionals = new Map();
    let appendText = (text)=>{
        let currentToken = tokens.at(-1);
        if (currentToken?.type === 'text') currentToken.text += text;
        else tokens.push({
            type: 'text',
            text: text
        });
    };
    let i = span[0];
    let optionalStack = [];
    while(i < span[1]){
        let char = source[i];
        if (char === '(') {
            optionalStack.push(tokens.length);
            tokens.push({
                type: char
            });
            i += 1;
            continue;
        }
        if (char === ')') {
            let begin = optionalStack.pop();
            if (begin === undefined) throw new $b29e50226ffecc87$export$f9c837a54db411d('unmatched )', source, i);
            optionals.set(begin, tokens.length);
            tokens.push({
                type: char
            });
            i += 1;
            continue;
        }
        if (char === ':') {
            i += 1;
            let name = $b29e50226ffecc87$var$IDENTIFIER_RE.exec(source.slice(i, span[1]))?.[0];
            if (!name) throw new $b29e50226ffecc87$export$f9c837a54db411d('missing variable name', source, i - 1);
            tokens.push({
                type: ':',
                name: name
            });
            i += name.length;
            continue;
        }
        if (char === '*') {
            i += 1;
            let name = $b29e50226ffecc87$var$IDENTIFIER_RE.exec(source.slice(i, span[1]))?.[0];
            tokens.push({
                type: '*',
                name: name ?? '*'
            });
            i += name?.length ?? 0;
            continue;
        }
        if (char === separator) {
            tokens.push({
                type: 'separator'
            });
            i += 1;
            continue;
        }
        if (char === '\\') {
            if (i + 1 === span[1]) throw new $b29e50226ffecc87$export$f9c837a54db411d('dangling escape', source, i);
            let text = source.slice(i + 1, i + 2);
            appendText(text);
            i += 2;
            continue;
        }
        appendText(char);
        i += 1;
    }
    if (optionalStack.length > 0) throw new $b29e50226ffecc87$export$f9c837a54db411d('unmatched (', source, optionalStack.at(-1));
    return {
        tokens: tokens,
        optionals: optionals,
        type: options.type
    };
}
function $b29e50226ffecc87$var$parseProtocol(source, span) {
    if (!span) return null;
    let protocol = source.slice(...span);
    if (protocol === '' || protocol === 'http' || protocol === 'https' || protocol === 'http(s)') return protocol === '' ? null : protocol;
    throw new $b29e50226ffecc87$export$f9c837a54db411d('invalid protocol', source, span[0]);
}
function $b29e50226ffecc87$var$parseHostname(source, span) {
    if (!span) return null;
    let part = $b29e50226ffecc87$export$6681bda78b6b4cbd(source, {
        span: span,
        type: 'hostname'
    });
    if ($b29e50226ffecc87$var$isNamelessWildcard(part)) return null;
    return part;
}
function $b29e50226ffecc87$var$isNamelessWildcard(part) {
    if (part.tokens.length !== 1) return false;
    let token = part.tokens[0];
    if (token.type !== '*') return false;
    return token.name === '*';
}
function $b29e50226ffecc87$var$parseSearch(source) {
    let constraints = new Map();
    let searchParams = new URLSearchParams(source);
    for (let [key, value] of searchParams){
        let requiredValues = constraints.get(key);
        if (!requiredValues) {
            requiredValues = new Set();
            constraints.set(key, requiredValues);
        }
        if (value === '') continue;
        requiredValues.add(value);
    }
    return constraints;
}
class $b29e50226ffecc87$export$f9c837a54db411d extends Error {
    /** The parse failure category. */ type;
    /** Original pattern source being parsed. */ source;
    /** Character index where parsing failed. */ index;
    constructor(type, source, index){
        let underline = ' '.repeat(index) + '^';
        let message = `${type}\n\n${source}\n${underline}`;
        super(message);
        this.name = 'ParseError';
        this.type = type;
        this.source = source;
        this.index = index;
    }
}

});
parcelRegister("fNJ4P", function(module, exports) {

$parcel$export(module.exports, "split", function () { return $b80e65f30d9ebfa4$export$65980d18b75784e2; });
/**
 * Split a route pattern into protocol, hostname, port, pathname, and search
 * spans delimited as `protocol://hostname:port/pathname?search`.
 *
 * Delimiters are not included in the spans with the exception of the leading `/` for pathname.
 * Spans are [begin (inclusive), end (exclusive)].
 *
 * @param source the route pattern string to split
 * @returns an object containing spans for each URL component
 */ function $b80e65f30d9ebfa4$export$65980d18b75784e2(source) {
    let result = {
        protocol: null,
        hostname: null,
        port: null,
        pathname: null,
        search: null
    };
    let questionMarkIndex = source.indexOf('?');
    if (questionMarkIndex !== -1) {
        result.search = $b80e65f30d9ebfa4$var$span(questionMarkIndex + 1, source.length);
        source = source.slice(0, questionMarkIndex);
    }
    let solidusIndex = source.indexOf('://');
    if (solidusIndex === -1) {
        result.pathname = $b80e65f30d9ebfa4$var$pathnameSpan(source, 0, source.length);
        return result;
    }
    let slashIndex = source.indexOf('/');
    if (slashIndex === solidusIndex + 1) slashIndex = source.indexOf('/', solidusIndex + 3);
    if (slashIndex === -1) {
        result.protocol = $b80e65f30d9ebfa4$var$span(0, solidusIndex);
        let host = $b80e65f30d9ebfa4$var$span(solidusIndex + 3, source.length);
        if (host) {
            let { hostname: hostname, port: port } = $b80e65f30d9ebfa4$var$hostSpans(source, host);
            result.hostname = hostname;
            result.port = port;
        }
        return result;
    }
    if (slashIndex < solidusIndex) {
        result.pathname = $b80e65f30d9ebfa4$var$pathnameSpan(source, 0, source.length);
        return result;
    }
    result.protocol = $b80e65f30d9ebfa4$var$span(0, solidusIndex);
    let host = $b80e65f30d9ebfa4$var$span(solidusIndex + 3, slashIndex);
    if (host) {
        let { hostname: hostname, port: port } = $b80e65f30d9ebfa4$var$hostSpans(source, host);
        result.hostname = hostname;
        result.port = port;
    }
    result.pathname = $b80e65f30d9ebfa4$var$pathnameSpan(source, slashIndex, source.length);
    return result;
}
function $b80e65f30d9ebfa4$var$span(start, end) {
    if (start === end) return null;
    return [
        start,
        end
    ];
}
function $b80e65f30d9ebfa4$var$hostSpans(source, host) {
    let lastColonIndex = source.slice(0, host[1]).lastIndexOf(':');
    if (lastColonIndex === -1 || lastColonIndex < host[0]) return {
        hostname: host,
        port: null
    };
    if (source.slice(lastColonIndex + 1, host[1]).match(/^\d+$/)) return {
        hostname: $b80e65f30d9ebfa4$var$span(host[0], lastColonIndex),
        port: $b80e65f30d9ebfa4$var$span(lastColonIndex + 1, host[1])
    };
    return {
        hostname: host,
        port: null
    };
}
function $b80e65f30d9ebfa4$var$pathnameSpan(source, begin, end) {
    if (source[begin] === '/') begin += 1;
    return $b80e65f30d9ebfa4$var$span(begin, end);
}

});


parcelRegister("FR5FW", function(module, exports) {

$parcel$export(module.exports, "serializePattern", function () { return $07dd031ffb532f5d$export$f54f830b0caf58b; });
$parcel$export(module.exports, "serializePatternParts", function () { return $07dd031ffb532f5d$export$161f896add7aeb90; });

var $jfrXf = parcelRequire("jfrXf");
function $07dd031ffb532f5d$export$f54f830b0caf58b(pattern) {
    let protocol = $07dd031ffb532f5d$export$f5782abab8870711(pattern);
    let hostname = $07dd031ffb532f5d$export$191bef10f978d68f(pattern);
    let port = $07dd031ffb532f5d$export$776a5d5828862b2f(pattern);
    let pathname = $07dd031ffb532f5d$export$a2dfe5fa28b7cbe3(pattern);
    let search = $07dd031ffb532f5d$export$3ba2b473bde2deb8(pattern);
    let result = '';
    if (protocol || hostname || port) result += `${protocol}://${hostname}${port === '' ? '' : `:${port}`}`;
    result += '/' + pathname;
    if (search) result += `?${search}`;
    return result;
}
function $07dd031ffb532f5d$export$161f896add7aeb90(pattern) {
    return {
        protocol: $07dd031ffb532f5d$export$f5782abab8870711(pattern),
        hostname: $07dd031ffb532f5d$export$191bef10f978d68f(pattern),
        port: $07dd031ffb532f5d$export$776a5d5828862b2f(pattern),
        pathname: $07dd031ffb532f5d$export$a2dfe5fa28b7cbe3(pattern),
        search: $07dd031ffb532f5d$export$3ba2b473bde2deb8(pattern)
    };
}
function $07dd031ffb532f5d$export$f5782abab8870711(pattern) {
    return pattern.protocol ?? '';
}
function $07dd031ffb532f5d$export$191bef10f978d68f(pattern) {
    return pattern.hostname ? $07dd031ffb532f5d$export$4d98ccdba8645223(pattern.hostname) : '';
}
function $07dd031ffb532f5d$export$776a5d5828862b2f(pattern) {
    return pattern.port ?? '';
}
function $07dd031ffb532f5d$export$a2dfe5fa28b7cbe3(pattern) {
    return $07dd031ffb532f5d$export$4d98ccdba8645223(pattern.pathname);
}
function $07dd031ffb532f5d$export$3ba2b473bde2deb8(pattern) {
    if (pattern.search.size === 0) return '';
    let searchParams = new URLSearchParams();
    for (let [key, constraint] of pattern.search){
        if (constraint.size === 0) searchParams.append(key, '');
        else for (let value of constraint)searchParams.append(key, value);
    }
    return searchParams.toString();
}
function $07dd031ffb532f5d$var$escapeText(text) {
    return text.replaceAll(/[:*()\\]/g, '\\$&');
}
function $07dd031ffb532f5d$export$4d98ccdba8645223(part) {
    let separator = part.type === 'hostname' ? '.' : '/';
    let result = '';
    for (let token of part.tokens){
        if (token.type === '(' || token.type === ')') {
            result += token.type;
            continue;
        }
        if (token.type === 'text') {
            result += $07dd031ffb532f5d$var$escapeText(token.text);
            continue;
        }
        if (token.type === ':' || token.type === '*') {
            let name = token.name === '*' ? '' : token.name;
            result += `${token.type}${name}`;
            continue;
        }
        if (token.type === 'separator') {
            result += separator;
            continue;
        }
        (0, $jfrXf.unreachable)(token.type);
    }
    return result;
}

});
parcelRegister("jfrXf", function(module, exports) {

$parcel$export(module.exports, "unreachable", function () { return $e0351a389751dc37$export$565e9d9bd6b6e0d4; });
/**
 * An internal error that should never happen.
 *
 * @param value Typed as `never` to ensure exhaustiveness for discriminated unions.
 */ function $e0351a389751dc37$export$565e9d9bd6b6e0d4(value) {
    let message = value === undefined ? 'Unreachable' : `Unreachable: ${value}`;
    throw new Error(message);
}

});



parcelRegister("kWAGs", function(module, exports) {

$parcel$export(module.exports, "Trie", function () { return $f3f5ae121c9b7b01$export$73571c50d0f2507e; });
parcelRequire("8YaVq");
var $aYrgC = parcelRequire("aYrgC");

var $loh6S = parcelRequire("loh6S");

var $jfrXf = parcelRequire("jfrXf");
class $f3f5ae121c9b7b01$export$73571c50d0f2507e {
    ignoreCase;
    #root;
    constructor(options){
        this.ignoreCase = options?.ignoreCase ?? false;
        this.#root = {
            http: $f3f5ae121c9b7b01$var$createHostnameNode(),
            https: $f3f5ae121c9b7b01$var$createHostnameNode()
        };
    }
    insert(pattern, data) {
        for (let variant of (0, $loh6S.generateVariants)(pattern)){
            let hostnameNode = this.#root[variant.protocol];
            let portNode;
            if (variant.hostname.type === 'any') portNode = hostnameNode.any;
            else if (variant.hostname.type === 'static') {
                let key = variant.hostname.value.toLowerCase();
                let existing = hostnameNode.static.get(key);
                if (existing === undefined) {
                    existing = new Map();
                    hostnameNode.static.set(key, existing);
                }
                portNode = existing;
            } else {
                portNode = new Map();
                hostnameNode.dynamic.push({
                    regexp: variant.hostname.regexp,
                    params: variant.hostname.params,
                    portNode: portNode
                });
            }
            let pathnameRoot = portNode.get(variant.port);
            if (pathnameRoot === undefined) {
                pathnameRoot = $f3f5ae121c9b7b01$var$createPathnameNode();
                portNode.set(variant.port, pathnameRoot);
            }
            let pathnameNode = pathnameRoot;
            for (let segment of variant.pathname){
                if (segment.type === 'static') {
                    let key = this.ignoreCase ? segment.key.toLowerCase() : segment.key;
                    let next = pathnameNode.static.get(key);
                    if (next === undefined) {
                        next = $f3f5ae121c9b7b01$var$createPathnameNode();
                        pathnameNode.static.set(key, next);
                    }
                    pathnameNode = next;
                    continue;
                }
                if (segment.type === 'variable') {
                    let next = pathnameNode.variable.get(segment.key);
                    if (next === undefined) {
                        next = {
                            regexp: segment.regexp,
                            pathnameNode: $f3f5ae121c9b7b01$var$createPathnameNode()
                        };
                        pathnameNode.variable.set(segment.key, next);
                    }
                    pathnameNode = next.pathnameNode;
                    continue;
                }
                if (segment.type === 'wildcard') {
                    let next = pathnameNode.wildcard.get(segment.key);
                    if (next === undefined) {
                        next = {
                            regexp: segment.regexp,
                            pathnameNode: $f3f5ae121c9b7b01$var$createPathnameNode()
                        };
                        pathnameNode.wildcard.set(segment.key, next);
                    }
                    pathnameNode = next.pathnameNode;
                    continue;
                }
                (0, $jfrXf.unreachable)(segment);
            }
            let requiredParams = [];
            for (let segment of variant.pathname){
                if (segment.type === 'variable' || segment.type === 'wildcard') for (let param of segment.params)requiredParams.push(param);
            }
            let undefinedParams = [];
            for (let param of pattern.pathname.tokens){
                if (param.type !== ':' && param.type !== '*') continue;
                if (requiredParams.some((p)=>p.name === param.name)) continue;
                if (undefinedParams.some((p)=>p.name === param.name)) continue;
                undefinedParams.push(param);
            }
            pathnameNode.values.push({
                pattern: pattern,
                data: data,
                requiredParams: requiredParams,
                undefinedParams: undefinedParams
            });
        }
    }
    search(url) {
        let protocol = url.protocol.slice(0, -1);
        if (protocol !== 'http' && protocol !== 'https') return [];
        let hostnameNode = this.#root[protocol];
        let decodedHostname = (0, $aYrgC.toUnicode)(url.hostname);
        let origins = [];
        // any hostname (no port allowed -- empty-port key)
        let anyPathname = hostnameNode.any.get('');
        if (anyPathname) origins.push({
            hostnameMatch: [
                {
                    type: '*',
                    name: '*',
                    value: decodedHostname,
                    begin: 0,
                    end: decodedHostname.length
                }
            ],
            pathnameNode: anyPathname
        });
        // static hostname
        let staticPort = hostnameNode.static.get(decodedHostname.toLowerCase());
        if (staticPort) {
            let next = staticPort.get(url.port);
            if (next) origins.push({
                hostnameMatch: [],
                pathnameNode: next
            });
        }
        // dynamic hostnames
        for (let entry of hostnameNode.dynamic){
            let m = entry.regexp.exec(decodedHostname);
            if (!m) continue;
            let next = entry.portNode.get(url.port);
            if (!next) continue;
            let hostnameMatch = [];
            for(let i = 0; i < entry.params.length; i++){
                let param = entry.params[i];
                let span = m.indices?.[i + 1];
                if (span === undefined) continue;
                hostnameMatch.push({
                    type: param.type,
                    name: param.name,
                    value: m[i + 1],
                    begin: span[0],
                    end: span[1]
                });
            }
            origins.push({
                hostnameMatch: hostnameMatch,
                pathnameNode: next
            });
        }
        let results = [];
        let urlSegments = $f3f5ae121c9b7b01$var$normalizePathname(url.pathname);
        if (urlSegments === null) return results;
        for (let origin of origins){
            let stack = [
                {
                    segmentIndex: 0,
                    pathnameNode: origin.pathnameNode,
                    charOffset: 0,
                    captures: []
                }
            ];
            while(stack.length > 0){
                let current = stack.pop();
                if (current.segmentIndex === urlSegments.length) {
                    for (let value of current.pathnameNode.values){
                        if (!$f3f5ae121c9b7b01$var$matchSearch(url.searchParams, value.pattern.search)) continue;
                        let pathnameMatch = [];
                        for(let i = 0; i < value.requiredParams.length; i++){
                            let param = value.requiredParams[i];
                            let cap = current.captures[i];
                            pathnameMatch.push({
                                type: param.type,
                                name: param.name,
                                value: $f3f5ae121c9b7b01$var$fastDecodeURIComponent(cap.value),
                                begin: cap.begin,
                                end: cap.end
                            });
                        }
                        let params = {};
                        for (let token of value.pattern.hostname?.tokens ?? [])if ((token.type === ':' || token.type === '*') && token.name !== '*') params[token.name] = undefined;
                        for (let token of value.pattern.pathname.tokens)if ((token.type === ':' || token.type === '*') && token.name !== '*') params[token.name] = undefined;
                        for (let p of origin.hostnameMatch){
                            if (p.name === '*') continue;
                            params[p.name] = p.value;
                        }
                        for (let p of pathnameMatch){
                            if (p.name === '*') continue;
                            params[p.name] = p.value;
                        }
                        results.push({
                            url: url,
                            pattern: value.pattern,
                            data: value.data,
                            params: params,
                            paramsMeta: {
                                hostname: origin.hostnameMatch,
                                pathname: pathnameMatch
                            }
                        });
                    }
                    continue;
                }
                let urlSegment = urlSegments[current.segmentIndex];
                let staticKey = this.ignoreCase ? urlSegment.toLowerCase() : urlSegment;
                let nextStatic = current.pathnameNode.static.get(staticKey);
                if (nextStatic) stack.push({
                    segmentIndex: current.segmentIndex + 1,
                    pathnameNode: nextStatic,
                    charOffset: current.charOffset + urlSegment.length + 1,
                    captures: current.captures
                });
                for (let { regexp: regexp, pathnameNode: pathnameNode } of current.pathnameNode.variable.values()){
                    let m = regexp.exec(urlSegment);
                    if (!m) continue;
                    let captures = current.captures.slice();
                    for(let i = 1; i < m.indices.length; i++){
                        let span = m.indices[i];
                        if (span === undefined) (0, $jfrXf.unreachable)();
                        captures.push({
                            value: m[i],
                            begin: current.charOffset + span[0],
                            end: current.charOffset + span[1]
                        });
                    }
                    stack.push({
                        segmentIndex: current.segmentIndex + 1,
                        pathnameNode: pathnameNode,
                        charOffset: current.charOffset + m.index + m[0].length + 1,
                        captures: captures
                    });
                }
                for (let { regexp: regexp, pathnameNode: pathnameNode } of current.pathnameNode.wildcard.values()){
                    let remaining = urlSegments.slice(current.segmentIndex).join('/');
                    let m = regexp.exec(remaining);
                    if (!m) continue;
                    let captures = current.captures.slice();
                    for(let i = 1; i < m.indices.length; i++){
                        let span = m.indices[i];
                        if (span === undefined) continue;
                        captures.push({
                            value: m[i],
                            begin: current.charOffset + span[0],
                            end: current.charOffset + span[1]
                        });
                    }
                    stack.push({
                        segmentIndex: urlSegments.length,
                        pathnameNode: pathnameNode,
                        charOffset: current.charOffset + remaining.length,
                        captures: captures
                    });
                }
            }
        }
        return results;
    }
}
// Pathname codec ----------------------------------------------------------------------------------
// Pathname matching uses canonical percent-encoded text. URL pathnames are split on structural
// "/" before normalization so encoded slashes like "%2F" remain data within a segment instead of
// becoming separators. Pattern static text is encoded the same way when variants are generated.
function $f3f5ae121c9b7b01$var$normalizePathname(pathname) {
    let segments = [];
    for (let segment of pathname.slice(1).split('/')){
        let normalized = $f3f5ae121c9b7b01$var$normalizePathnameText(segment);
        if (normalized === null) return null;
        segments.push(normalized);
    }
    return segments;
}
function $f3f5ae121c9b7b01$var$normalizePathnameText(text) {
    let decoded = $f3f5ae121c9b7b01$var$safeDecodeURIComponent(text);
    return decoded === null ? null : encodeURIComponent(decoded);
}
function $f3f5ae121c9b7b01$var$fastDecodeURIComponent(text) {
    return text.includes('%') ? decodeURIComponent(text) : text;
}
function $f3f5ae121c9b7b01$var$safeDecodeURIComponent(text) {
    try {
        return $f3f5ae121c9b7b01$var$fastDecodeURIComponent(text);
    } catch (error) {
        if (error instanceof URIError) return null;
        throw error;
    }
}
// Search ------------------------------------------------------------------------------------------
function $f3f5ae121c9b7b01$var$matchSearch(params, constraints) {
    for (let [name, requiredValues] of constraints){
        if (requiredValues.size === 0) {
            if (!params.has(name)) return false;
            continue;
        }
        let values = params.getAll(name);
        for (let requiredValue of requiredValues){
            if (!values.includes(requiredValue)) return false;
        }
    }
    return true;
}
function $f3f5ae121c9b7b01$var$createHostnameNode() {
    return {
        static: new Map(),
        dynamic: [],
        any: new Map()
    };
}
function $f3f5ae121c9b7b01$var$createPathnameNode() {
    return {
        static: new Map(),
        variable: new Map(),
        wildcard: new Map(),
        values: []
    };
}

});
parcelRegister("8YaVq", function(module, exports) {

$parcel$export(module.exports, "decodeHostname", function () { return (parcelRequire("aYrgC")).toUnicode; });

var $aYrgC = parcelRequire("aYrgC");

});
parcelRegister("aYrgC", function(module, exports) {

$parcel$export(module.exports, "toUnicode", function () { return $7fd4a8a65682a31e$export$110c810e8727e62b; });
// Adapted from https://github.com/mathiasbynens/punycode.js/blob/9e1b2cda98d215d3a73fcbfe93c62e021f4ba768/punycode.js
/** Highest positive signed 32-bit float value */ const $7fd4a8a65682a31e$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $7fd4a8a65682a31e$var$base = 36;
const $7fd4a8a65682a31e$var$tMin = 1;
const $7fd4a8a65682a31e$var$tMax = 26;
const $7fd4a8a65682a31e$var$skew = 38;
const $7fd4a8a65682a31e$var$damp = 700;
const $7fd4a8a65682a31e$var$initialBias = 72;
const $7fd4a8a65682a31e$var$initialN = 128; // 0x80
const $7fd4a8a65682a31e$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $7fd4a8a65682a31e$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $7fd4a8a65682a31e$var$errors = {
    overflow: 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
const $7fd4a8a65682a31e$var$baseMinusTMin = $7fd4a8a65682a31e$var$base - $7fd4a8a65682a31e$var$tMin;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @param type The error type.
 */ function $7fd4a8a65682a31e$var$error(type) {
    throw new RangeError($7fd4a8a65682a31e$var$errors[type]);
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @param domain The domain name or email address.
 * @param callback The function that gets called for every character.
 * @returns A new string of characters returned by the callback function.
 */ function $7fd4a8a65682a31e$var$mapDomain(domain, callback) {
    let parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    domain = domain.replace($7fd4a8a65682a31e$var$regexSeparators, '.');
    let labels = domain.split('.');
    let encoded = labels.map(callback).join('.');
    return result + encoded;
}
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @param codePoint The basic numeric code point value.
 * @returns The numeric value of a basic code point in the range `0` to
 * `base - 1`, or `base` if the code point does not represent a value.
 */ function $7fd4a8a65682a31e$var$basicToDigit(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3a) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5b) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7b) return codePoint - 0x61;
    return $7fd4a8a65682a31e$var$base;
}
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @param delta The current delta.
 * @param numPoints The number of code points handled.
 * @param firstTime Whether this is the first adaptation.
 * @returns The adapted bias.
 */ function $7fd4a8a65682a31e$var$adapt(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? Math.floor(delta / $7fd4a8a65682a31e$var$damp) : delta >> 1;
    delta += Math.floor(delta / numPoints);
    for(; delta > $7fd4a8a65682a31e$var$baseMinusTMin * $7fd4a8a65682a31e$var$tMax >> 1; k += $7fd4a8a65682a31e$var$base)delta = Math.floor(delta / $7fd4a8a65682a31e$var$baseMinusTMin);
    return Math.floor(k + ($7fd4a8a65682a31e$var$baseMinusTMin + 1) * delta / (delta + $7fd4a8a65682a31e$var$skew));
}
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @param input The Punycode string of ASCII-only symbols.
 * @returns The resulting string of Unicode symbols.
 */ function $7fd4a8a65682a31e$var$decode(input) {
    // Don't use UCS-2.
    let output = [];
    let inputLength = input.length;
    let i = 0;
    let n = $7fd4a8a65682a31e$var$initialN;
    let bias = $7fd4a8a65682a31e$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($7fd4a8a65682a31e$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $7fd4a8a65682a31e$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength /* no final expression */ ;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        let oldi = i;
        for(let w = 1, k = $7fd4a8a65682a31e$var$base /* no condition */ ;; k += $7fd4a8a65682a31e$var$base){
            if (index >= inputLength) $7fd4a8a65682a31e$var$error('invalid-input');
            let digit = $7fd4a8a65682a31e$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $7fd4a8a65682a31e$var$base) $7fd4a8a65682a31e$var$error('invalid-input');
            if (digit > Math.floor(($7fd4a8a65682a31e$var$maxInt - i) / w)) $7fd4a8a65682a31e$var$error('overflow');
            i += digit * w;
            let t = k <= bias ? $7fd4a8a65682a31e$var$tMin : k >= bias + $7fd4a8a65682a31e$var$tMax ? $7fd4a8a65682a31e$var$tMax : k - bias;
            if (digit < t) break;
            let baseMinusT = $7fd4a8a65682a31e$var$base - t;
            if (w > Math.floor($7fd4a8a65682a31e$var$maxInt / baseMinusT)) $7fd4a8a65682a31e$var$error('overflow');
            w *= baseMinusT;
        }
        let out = output.length + 1;
        bias = $7fd4a8a65682a31e$var$adapt(i - oldi, out, oldi === 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if (Math.floor(i / out) > $7fd4a8a65682a31e$var$maxInt - n) $7fd4a8a65682a31e$var$error('overflow');
        n += Math.floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
}
const $7fd4a8a65682a31e$export$110c810e8727e62b = function(input) {
    // Optimization: skip if no punycode markers found
    if (!input.includes('xn--')) return input;
    return $7fd4a8a65682a31e$var$mapDomain(input, function(string) {
        return string.startsWith('xn--') ? $7fd4a8a65682a31e$var$decode(string.slice(4).toLowerCase()) : string;
    });
};

});


parcelRegister("loh6S", function(module, exports) {

$parcel$export(module.exports, "generateVariants", function () { return $f9291c8d86dd35ab$export$9ac16898ad61bc17; });

var $7F67b = parcelRequire("7F67b");

var $jfrXf = parcelRequire("jfrXf");
function $f9291c8d86dd35ab$export$9ac16898ad61bc17(pattern) {
    let result = [];
    for (let protocol of $f9291c8d86dd35ab$var$generateProtocolVariants(pattern.protocol)){
        let port = $f9291c8d86dd35ab$var$normalizePort(protocol, pattern.port);
        for (let hostname of $f9291c8d86dd35ab$var$generateHostnameVariants(pattern.hostname))for (let pathname of $f9291c8d86dd35ab$var$generatePathnameVariants(pattern.pathname))result.push({
            protocol: protocol,
            hostname: hostname,
            port: port,
            pathname: pathname
        });
    }
    return result;
}
function $f9291c8d86dd35ab$var$generateProtocolVariants(protocol) {
    if (protocol === null || protocol === 'http(s)') return [
        'http',
        'https'
    ];
    return [
        protocol
    ];
}
function $f9291c8d86dd35ab$var$normalizePort(protocol, port) {
    if (port === null) return '';
    if (protocol === 'http' && port === '80') return '';
    if (protocol === 'https' && port === '443') return '';
    return port;
}
function $f9291c8d86dd35ab$var$toParams(tokens) {
    let params = [];
    for (let token of tokens)if (token.type === ':' || token.type === '*') params.push(token);
    return params;
}
function $f9291c8d86dd35ab$var$generateHostnameVariants(hostname) {
    let result = [];
    if (hostname === null) return [
        {
            type: 'any'
        }
    ];
    for (let variant of $f9291c8d86dd35ab$export$57a1d23d0b7a46c(hostname)){
        let params = $f9291c8d86dd35ab$var$toParams(variant);
        if (params.length > 0) result.push({
            type: 'dynamic',
            params: params,
            regexp: (0, $7F67b.toRegExp)(variant, {
                separator: '.',
                ignoreCase: false
            })
        });
        else result.push({
            type: 'static',
            value: $f9291c8d86dd35ab$var$stringifyStatic(variant, '.')
        });
    }
    return result;
}
function $f9291c8d86dd35ab$var$stringifyStatic(variant, separator) {
    let result = '';
    for (let token of variant){
        if (token.type === 'text') result += token.text;
        else if (token.type === 'separator') result += separator;
        else throw new Error(`expected static part variant, got token type '${token.type}'`);
    }
    return result;
}
function $f9291c8d86dd35ab$var$generatePathnameVariants(pathname, options) {
    let result = [];
    let ignoreCase = options?.ignoreCase ?? false;
    for (let tokens of $f9291c8d86dd35ab$export$57a1d23d0b7a46c(pathname)){
        let variant = [];
        let key = '';
        let reSource = '';
        let reFlags = ignoreCase ? 'di' : 'd';
        let type = 'static';
        let params = [];
        for (let token of tokens){
            if (token.type === 'separator') {
                if (type === 'static') {
                    variant.push({
                        type: 'static',
                        key: ignoreCase ? key.toLowerCase() : key
                    });
                    key = '';
                    reSource = '';
                    continue;
                }
                if (type === 'variable') {
                    variant.push({
                        type: 'variable',
                        key: key,
                        regexp: new RegExp(`^${reSource}$`, reFlags),
                        params: params
                    });
                    key = '';
                    reSource = '';
                    params = [];
                    type = 'static';
                    continue;
                }
                if (type === 'wildcard') {
                    key += '/';
                    reSource += (0, $7F67b.escape)('/');
                    continue;
                }
                (0, $jfrXf.unreachable)(type);
            }
            if (token.type === 'text') {
                // Encode to comply with URL pathname normalization in trie matcher
                let text = encodeURIComponent(token.text);
                key += text;
                reSource += (0, $7F67b.escape)(text);
                continue;
            }
            if (token.type === ':') {
                key += '{:}';
                reSource += `([^/]+)`;
                params.push(token);
                if (type === 'static') type = 'variable';
                continue;
            }
            if (token.type === '*') {
                key += '{*}';
                reSource += `(.*)`;
                params.push(token);
                type = 'wildcard';
                continue;
            }
            (0, $jfrXf.unreachable)(token.type);
        }
        if (type === 'static') variant.push({
            type: 'static',
            key: ignoreCase ? key.toLowerCase() : key
        });
        if (type === 'variable' || type === 'wildcard') variant.push({
            type: type,
            key: key,
            regexp: new RegExp(`^${reSource}$`, reFlags),
            params: params
        });
        result.push(variant);
    }
    return result;
}
function $f9291c8d86dd35ab$export$57a1d23d0b7a46c(part) {
    let result = [];
    let stack = [
        {
            index: 0,
            tokens: []
        }
    ];
    while(stack.length > 0){
        let { index: index, tokens: tokens } = stack.pop();
        if (index === part.tokens.length) {
            result.push(tokens);
            continue;
        }
        let token = part.tokens[index];
        if (token.type === '(') {
            stack.push({
                index: index + 1,
                tokens: tokens
            }, {
                index: part.optionals.get(index) + 1,
                tokens: tokens.slice()
            });
            continue;
        }
        if (token.type === ')') {
            stack.push({
                index: index + 1,
                tokens: tokens
            });
            continue;
        }
        if (token.type === ':' || token.type === '*' || token.type === 'text' || token.type === 'separator') {
            tokens.push(token);
            stack.push({
                index: index + 1,
                tokens: tokens
            });
            continue;
        }
        (0, $jfrXf.unreachable)(token.type);
    }
    return result;
}

});
parcelRegister("7F67b", function(module, exports) {

$parcel$export(module.exports, "escape", function () { return $59411b0964d55c73$export$4e7f196112fea3c5; });
$parcel$export(module.exports, "toRegExp", function () { return $59411b0964d55c73$export$238374f1b270e387; });

var $jfrXf = parcelRequire("jfrXf");
function $59411b0964d55c73$export$4e7f196112fea3c5(text) {
    return text.replace(/[.*+?^${}()|[\]\\-]/g, '\\$&');
}
function $59411b0964d55c73$export$238374f1b270e387(tokens, options) {
    let result = '';
    for (let token of tokens){
        if (token.type === 'text') {
            result += $59411b0964d55c73$export$4e7f196112fea3c5(token.text);
            continue;
        }
        if (token.type === ':') {
            result += `([^${options.separator}]+?)`;
            continue;
        }
        if (token.type === '*') {
            result += `(.*)`;
            continue;
        }
        if (token.type === '(') {
            result += '(?:';
            continue;
        }
        if (token.type === ')') {
            result += ')?';
            continue;
        }
        if (token.type === 'separator') {
            result += $59411b0964d55c73$export$4e7f196112fea3c5(options.separator);
            continue;
        }
        (0, $jfrXf.unreachable)(token.type);
    }
    let flags = 'd';
    if (options.ignoreCase) flags += 'i';
    return new RegExp(`^${result}$`, flags);
}

});



parcelRegister("3T281", function(module, exports) {

$parcel$export(module.exports, "greaterThan", function () { return $2d4828cffe36f5c2$export$f517ea36c68d4644; });
$parcel$export(module.exports, "descending", function () { return $2d4828cffe36f5c2$export$4fa3190a997c3d8f; });
parcelRequire("8YaVq");
var $aYrgC = parcelRequire("aYrgC");
function $2d4828cffe36f5c2$export$9b050841a3a1b328(a, b) {
    return $2d4828cffe36f5c2$export$398604a469f7de9a(a, b) === -1;
}
function $2d4828cffe36f5c2$export$f517ea36c68d4644(a, b) {
    return $2d4828cffe36f5c2$export$398604a469f7de9a(a, b) === 1;
}
function $2d4828cffe36f5c2$export$411ce8e5a71e3069(a, b) {
    return $2d4828cffe36f5c2$export$398604a469f7de9a(a, b) === 0;
}
const $2d4828cffe36f5c2$export$fcb633242ef15540 = (a, b)=>$2d4828cffe36f5c2$export$398604a469f7de9a(a, b);
const $2d4828cffe36f5c2$export$4fa3190a997c3d8f = (a, b)=>$2d4828cffe36f5c2$export$398604a469f7de9a(a, b) * -1;
function $2d4828cffe36f5c2$export$398604a469f7de9a(a, b) {
    if (a.url.href !== b.url.href) throw new Error(`Cannot compare matches for different URLs: ${a.url.href} vs ${b.url.href}`);
    let hostname = (0, $aYrgC.toUnicode)(a.url.hostname);
    let hostnameResult = $2d4828cffe36f5c2$var$compareHostname(hostname, a.paramsMeta.hostname, b.paramsMeta.hostname);
    if (hostnameResult !== 0) return hostnameResult;
    let pathnameResult = $2d4828cffe36f5c2$var$comparePathname(a.paramsMeta.pathname, b.paramsMeta.pathname);
    if (pathnameResult !== 0) return pathnameResult;
    let searchResult = $2d4828cffe36f5c2$var$compareSearch(a.pattern.search, b.pattern.search);
    if (searchResult !== 0) return searchResult;
    return 0;
}
function $2d4828cffe36f5c2$var$compareHostname(hostname, a, b) {
    if (a.length === 0 && b.length === 0) return 0;
    if (a.length === 0 && b.length > 0) return 1;
    if (a.length > 0 && b.length === 0) return -1;
    // Encoding of hostname chars: 0 = static, 1 = variable (:), 2 = wildcard (*)
    // Note: `Int8Array` defaults to 0 for all indices not explicitly set.
    let aEncoding = new Int8Array(hostname.length);
    for (let range of a)aEncoding.fill(range.type === ':' ? 1 : 2, range.begin, range.end);
    let bEncoding = new Int8Array(hostname.length);
    for (let range of b)bEncoding.fill(range.type === ':' ? 1 : 2, range.begin, range.end);
    // Build segments right-to-left: desc order by begin
    let segments = [];
    let end = hostname.length;
    for(let i = hostname.length - 1; i >= 0; i--)if (hostname[i] === '.') {
        segments.push({
            begin: i + 1,
            end: end
        });
        end = i;
    }
    segments.push({
        begin: 0,
        end: end
    }); // leftmost segment
    for (let segment of segments)for(let j = segment.begin; j < segment.end; j++){
        if (aEncoding[j] < bEncoding[j]) return 1; // a is more specific
        if (aEncoding[j] > bEncoding[j]) return -1; // b is more specific
    }
    return 0;
}
function $2d4828cffe36f5c2$var$comparePathname(a, b) {
    if (a.length === 0 && b.length === 0) return 0;
    if (a.length === 0 && b.length > 0) return 1;
    if (a.length > 0 && b.length === 0) return -1;
    let i = 0;
    let aIndex = 0;
    let bIndex = 0;
    while(aIndex < a.length || bIndex < b.length){
        let aRange = a[aIndex];
        let bRange = b[bIndex];
        if (aRange === undefined) return 1; // a is fully static from here
        if (bRange === undefined) return -1; // b is fully static from here
        // Skip to the minimum begin of the two current ranges
        i = Math.min(aRange.begin, bRange.begin);
        if (i < aRange.begin) return 1; // a has static content at i
        if (i < bRange.begin) return -1; // b has static content at i
        if (aRange.type === ':' && bRange.type === '*') return 1; // a is more specific
        if (aRange.type === '*' && bRange.type === ':') return -1; // b is more specific
        let minEnd = Math.min(aRange.end, bRange.end);
        i = minEnd;
        // Advance range indices if we've reached their ends
        if (i >= aRange.end) aIndex += 1;
        if (i >= bRange.end) bIndex += 1;
    }
    return 0;
}
function $2d4828cffe36f5c2$var$compareSearch(a, b) {
    let aSpecificity = $2d4828cffe36f5c2$var$searchSpecificity(a);
    let bSpecificity = $2d4828cffe36f5c2$var$searchSpecificity(b);
    if (aSpecificity.keyValue > bSpecificity.keyValue) return 1;
    if (aSpecificity.keyValue < bSpecificity.keyValue) return -1;
    if (aSpecificity.key > bSpecificity.key) return 1;
    if (aSpecificity.key < bSpecificity.key) return -1;
    return 0;
}
function $2d4828cffe36f5c2$var$searchSpecificity(constraints) {
    let specificity = {
        key: 0,
        keyValue: 0
    };
    for (let constraint of constraints.values()){
        if (constraint.size === 0) {
            specificity.key += 1;
            continue;
        }
        specificity.keyValue += constraint.size;
    }
    return specificity;
}

});



parcelRegister("i6q8q", function(module, exports) {

$parcel$export(module.exports, "descending", function () { return (parcelRequire("3T281")).descending; });

var $3T281 = parcelRequire("3T281");

});



parcelRegister("1PkTq", function(module, exports) {

$parcel$export(module.exports, "getNavigatorCurrentUrl", function () { return $154ac2c721275776$export$1da545bc000055cf; });
$parcel$export(module.exports, "validateNavigationTarget", function () { return $154ac2c721275776$export$6c8e41f66e7aa990; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/navigation.ts
const $154ac2c721275776$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $154ac2c721275776$export$1da545bc000055cf(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $154ac2c721275776$var$DEFAULT_NAVIGATION_URL);
    } catch  {
        return $154ac2c721275776$var$DEFAULT_NAVIGATION_URL;
    }
}
function $154ac2c721275776$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $154ac2c721275776$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    let protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $154ac2c721275776$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    let originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch  {}
    let resolvedUrl = new URL(resolved, currentUrl);
    let originalIsExternal = originalUrl != null && !$154ac2c721275776$var$isSameOrigin(originalUrl, currentUrl);
    let resolvedIsExternal = !$154ac2c721275776$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$154ac2c721275776$var$isExplicitUrl(original, originalUrl) || !$154ac2c721275776$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}

});


parcelRegister("3uzJP", function(module, exports) {

$parcel$export(module.exports, "DataRouterContext", function () { return $28afe5520f583c6f$export$2eeee58951ff3c1c; });
$parcel$export(module.exports, "DataRouterStateContext", function () { return $28afe5520f583c6f$export$315e3ffb01f217; });
$parcel$export(module.exports, "DataRouterDataContext", function () { return $28afe5520f583c6f$export$19d7395466bdeac8; });
$parcel$export(module.exports, "DataRouterNavigationContext", function () { return $28afe5520f583c6f$export$2473c5952c6a10d1; });
$parcel$export(module.exports, "RSCRouterContext", function () { return $28afe5520f583c6f$export$717f757c655223f1; });
$parcel$export(module.exports, "useIsRSCRouterContext", function () { return $28afe5520f583c6f$export$6e1eeb090b3ec35b; });
$parcel$export(module.exports, "ViewTransitionContext", function () { return $28afe5520f583c6f$export$3681f408decb40d1; });
$parcel$export(module.exports, "FetchersContext", function () { return $28afe5520f583c6f$export$cb3f1df1bef00a39; });
$parcel$export(module.exports, "AwaitContext", function () { return $28afe5520f583c6f$export$804c460aade54ac8; });
$parcel$export(module.exports, "NavigationContext", function () { return $28afe5520f583c6f$export$3044ab7fdabeaee6; });
$parcel$export(module.exports, "LocationContext", function () { return $28afe5520f583c6f$export$e6a44b110a0c44d3; });
$parcel$export(module.exports, "RouteContext", function () { return $28afe5520f583c6f$export$aac280ed165a4397; });
$parcel$export(module.exports, "IsDataRouteContext", function () { return $28afe5520f583c6f$export$efd71bfc7ccfba1; });
$parcel$export(module.exports, "RouteIdContext", function () { return $28afe5520f583c6f$export$92d0be8f6ef5c7bf; });
$parcel$export(module.exports, "RouteErrorContext", function () { return $28afe5520f583c6f$export$af8bd2647fea9c11; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $jHEir = parcelRequire("jHEir");
//#region lib/context.ts
const $28afe5520f583c6f$export$2eeee58951ff3c1c = $jHEir.createContext(null);
$28afe5520f583c6f$export$2eeee58951ff3c1c.displayName = "DataRouter";
const $28afe5520f583c6f$export$315e3ffb01f217 = $jHEir.createContext(null);
$28afe5520f583c6f$export$315e3ffb01f217.displayName = "DataRouterState";
const $28afe5520f583c6f$export$19d7395466bdeac8 = $jHEir.createContext(null);
$28afe5520f583c6f$export$19d7395466bdeac8.displayName = "DataRouterData";
const $28afe5520f583c6f$export$2473c5952c6a10d1 = $jHEir.createContext(null);
$28afe5520f583c6f$export$2473c5952c6a10d1.displayName = "DataRouterNavigation";
const $28afe5520f583c6f$export$717f757c655223f1 = $jHEir.createContext(false);
function $28afe5520f583c6f$export$6e1eeb090b3ec35b() {
    return $jHEir.useContext($28afe5520f583c6f$export$717f757c655223f1);
}
const $28afe5520f583c6f$export$3681f408decb40d1 = $jHEir.createContext({
    isTransitioning: false
});
$28afe5520f583c6f$export$3681f408decb40d1.displayName = "ViewTransition";
const $28afe5520f583c6f$export$cb3f1df1bef00a39 = $jHEir.createContext(null);
$28afe5520f583c6f$export$cb3f1df1bef00a39.displayName = "Fetchers";
const $28afe5520f583c6f$export$804c460aade54ac8 = $jHEir.createContext(null);
$28afe5520f583c6f$export$804c460aade54ac8.displayName = "Await";
const $28afe5520f583c6f$export$2666c20e15407622 = (props)=>$jHEir.createElement($28afe5520f583c6f$export$804c460aade54ac8.Provider, props);
const $28afe5520f583c6f$export$3044ab7fdabeaee6 = $jHEir.createContext(null);
$28afe5520f583c6f$export$3044ab7fdabeaee6.displayName = "Navigation";
const $28afe5520f583c6f$export$e6a44b110a0c44d3 = $jHEir.createContext(null);
$28afe5520f583c6f$export$e6a44b110a0c44d3.displayName = "Location";
const $28afe5520f583c6f$export$aac280ed165a4397 = $jHEir.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$28afe5520f583c6f$export$aac280ed165a4397.displayName = "Route";
const $28afe5520f583c6f$export$efd71bfc7ccfba1 = $jHEir.createContext(false);
$28afe5520f583c6f$export$efd71bfc7ccfba1.displayName = "IsDataRoute";
const $28afe5520f583c6f$export$92d0be8f6ef5c7bf = $jHEir.createContext(void 0);
$28afe5520f583c6f$export$92d0be8f6ef5c7bf.displayName = "RouteId";
const $28afe5520f583c6f$export$af8bd2647fea9c11 = $jHEir.createContext(null);
$28afe5520f583c6f$export$af8bd2647fea9c11.displayName = "RouteError";

});

parcelRegister("lfSRY", function(module, exports) {

$parcel$export(module.exports, "useHref", function () { return $f7958fa260273afe$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useInRouterContext", function () { return $f7958fa260273afe$export$9c954a9d03d32f4a; });
$parcel$export(module.exports, "useResolvedPath", function () { return $f7958fa260273afe$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $f7958fa260273afe$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $f7958fa260273afe$export$9770f232ac06a008; });
$parcel$export(module.exports, "useOutlet", function () { return $f7958fa260273afe$export$a3be3530d8e40d0b; });
$parcel$export(module.exports, "useParams", function () { return $f7958fa260273afe$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "useRoutes", function () { return $f7958fa260273afe$export$5d3fca4a98652595; });
$parcel$export(module.exports, "useRoutesImpl", function () { return $f7958fa260273afe$export$f7ce0646a48561fb; });
$parcel$export(module.exports, "_renderMatches", function () { return $f7958fa260273afe$export$569816e95a012c39; });
$parcel$export(module.exports, "useRouteError", function () { return $f7958fa260273afe$export$ed527bf60f6e05f2; });
$parcel$export(module.exports, "useDataRouterContext", function () { return $f7958fa260273afe$export$ae09415e57d46628; });
$parcel$export(module.exports, "useDataRouterState", function () { return $f7958fa260273afe$export$f93124018767f269; });
$parcel$export(module.exports, "useDataRouterFetchers", function () { return $f7958fa260273afe$export$c6e4e4d7047d4ffe; });
$parcel$export(module.exports, "useDataRouterData", function () { return $f7958fa260273afe$export$798168c290ba5b3d; });
$parcel$export(module.exports, "useCurrentRouteId", function () { return $f7958fa260273afe$export$501a3f562d56eac6; });
$parcel$export(module.exports, "useNavigation", function () { return $f7958fa260273afe$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $f7958fa260273afe$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useLoaderData", function () { return $f7958fa260273afe$export$1448a5050d252c4d; });
$parcel$export(module.exports, "useActionData", function () { return $f7958fa260273afe$export$fdc00f3f26066d5e; });
$parcel$export(module.exports, "useAsyncValue", function () { return $f7958fa260273afe$export$78a72ddb39bdd145; });
$parcel$export(module.exports, "useBlocker", function () { return $f7958fa260273afe$export$b273b3273281a049; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $i4yVL = parcelRequire("i4yVL");

var $vjGlj = parcelRequire("vjGlj");

var $1PkTq = parcelRequire("1PkTq");

var $6WCgj = parcelRequire("6WCgj");

var $3uzJP = parcelRequire("3uzJP");

var $7DINx = parcelRequire("7DINx");

var $jHEir = parcelRequire("jHEir");
//#region lib/hooks.tsx
/**
* Resolves a URL against the current {@link Location}.
*
* @example
* import { useHref } from "react-router";
*
* function SomeComponent() {
*   let href = useHref("some/where");
*   // "/resolved/some/where"
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the
* route tree.
* Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved href string
*/ function $f7958fa260273afe$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    (0, $i4yVL.invariant)($f7958fa260273afe$export$9c954a9d03d32f4a(), `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $jHEir.useContext((0, $3uzJP.NavigationContext));
    let { hash: hash, pathname: pathname, search: search } = $f7958fa260273afe$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $vjGlj.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
* Returns `true` if this component is a descendant of a {@link Router}, useful
* to ensure a component is used within a {@link Router}.
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns Whether the component is within a {@link Router} context
*/ function $f7958fa260273afe$export$9c954a9d03d32f4a() {
    return $jHEir.useContext((0, $3uzJP.LocationContext)) != null;
}
/**
* Returns the current {@link Location}. This can be useful if you'd like to
* perform some side effect whenever it changes.
*
* @example
* import * as React from 'react'
* import { useLocation } from 'react-router'
*
* function SomeComponent() {
*   let location = useLocation()
*
*   React.useEffect(() => {
*     // Google Analytics
*     ga('send', 'pageview')
*   }, [location]);
*
*   return (
*     // ...
*   );
* }
*
* @public
* @category Hooks
* @returns The current {@link Location} object
*/ function $f7958fa260273afe$export$45d76561a5302f2b() {
    (0, $i4yVL.invariant)($f7958fa260273afe$export$9c954a9d03d32f4a(), `useLocation() may be used only in the context of a <Router> component.`);
    return $jHEir.useContext((0, $3uzJP.LocationContext)).location;
}
/**
* Returns the current {@link Navigation} action which describes how the router
* came to the current {@link Location}, either by a pop, push, or replace on
* the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack.
*
* @public
* @category Hooks
* @returns The current {@link NavigationType} (`"POP"`, `"PUSH"`, or `"REPLACE"`)
*/ function $f7958fa260273afe$export$1b3f31771c5d07c() {
    return $jHEir.useContext((0, $3uzJP.LocationContext)).navigationType;
}
/**
* Returns a {@link PathMatch} object if the given pattern matches the current URL.
* This is useful for components that need to know "active" state, e.g.
* {@link NavLink | `<NavLink>`}.
*
* @public
* @category Hooks
* @param pattern The pattern to match against the current {@link Location}
* @returns The path match object if the pattern matches, `null` otherwise
*/ function $f7958fa260273afe$export$6c330e8992e8a295(pattern) {
    (0, $i4yVL.invariant)($f7958fa260273afe$export$9c954a9d03d32f4a(), `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $f7958fa260273afe$export$45d76561a5302f2b();
    return $jHEir.useMemo(()=>(0, $vjGlj.matchPath)(pattern, (0, $vjGlj.decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
const $f7958fa260273afe$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
/**
* Returns a function that lets you navigate programmatically in the browser in
* response to user interactions or effects.
*
* It's often better to use {@link redirect} in [`action`](../../start/framework/route-module#action)/[`loader`](../../start/framework/route-module#loader)
* functions than this hook.
*
* The returned function signature is `navigate(to, options?)`/`navigate(delta)` where:
*
* * `to` can be a string path, a {@link To} object, or a number (delta)
* * `options` contains options for modifying the navigation
*   * These options work in all modes (Framework, Data, and Declarative):
*     * `relative`: `"route"` or `"path"` to control relative routing logic
*     * `replace`: Replace the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack
*     * `state`: Optional [`history.state`](https://developer.mozilla.org/en-US/docs/Web/API/History/state) to include with the new {@link Location}
*   * These options only work in Framework and Data modes:
*     * `flushSync`: Wrap the DOM updates in [`ReactDom.flushSync`](https://react.dev/reference/react-dom/flushSync)
*     * `preventScrollReset`: Do not scroll back to the top of the page after navigation
*     * `viewTransition`: **Deprecated.** Use React's [`<ViewTransition>`](https://react.dev/reference/react/ViewTransition) component instead. See the [migration guide](../../how-to/view-transitions).
*
* @example
* import { useNavigate } from "react-router";
*
* function SomeComponent() {
*   let navigate = useNavigate();
*   return (
*     <button onClick={() => navigate(-1)}>
*       Go Back
*     </button>
*   );
* }
*
* @additionalExamples
* ### Navigate to another path
*
* ```tsx
* navigate("/some/route");
* navigate("/some/route?search=param");
* ```
*
* ### Navigate with a {@link To} object
*
* All properties are optional.
*
* ```tsx
* navigate(
*   {
*     pathname: "/some/route",
*     search: "?search=param",
*     hash: "#hash",
*   },
*   {
*     state: { some: "state" },
*   },
* );
* ```
*
* If you use `state`, that will be available on the {@link Location} object on
* the next page. Access it with `useLocation().state` (see {@link useLocation}).
*
* ### Navigate back or forward in the history stack
*
* ```tsx
* // back
* // often used to close modals
* navigate(-1);
*
* // forward
* // often used in a multistep wizard workflows
* navigate(1);
* ```
*
* Be cautious with `navigate(number)`. If your application can load up to a
* route that has a button that tries to navigate forward/back, there may not be
* a [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry to go back or forward to, or it can go somewhere you don't expect
* (like a different domain).
*
* Only use this if you're sure they will have an entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack to navigate to.
*
* ### Replace the current entry in the history stack
*
* This will remove the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, replacing it with a new one, similar to a server side redirect.
*
* ```tsx
* navigate("/some/route", { replace: true });
* ```
*
* ### Prevent Scroll Reset
*
* [MODES: framework, data]
*
* To prevent {@link ScrollRestoration | `<ScrollRestoration>`} from resetting
* the scroll position, use the `preventScrollReset` option.
*
* ```tsx
* navigate("?some-tab=1", { preventScrollReset: true });
* ```
*
* For example, if you have a tab interface connected to search params in the
* middle of a page, and you don't want it to scroll to the top when a tab is
* clicked.
*
* ### Return Type Augmentation
*
* Internally, `useNavigate` uses a separate implementation when you are in
* Declarative mode versus Data/Framework mode - the primary difference being
* that the latter is able to return a stable reference that does not change
* identity across navigations. The implementation in Data/Framework mode also
* returns a [`Promise`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise)
* that resolves when the navigation is completed. This means the return type of
* `useNavigate` is `void | Promise<void>`. This is accurate, but can lead to
* some red squigglies based on the union in the return value:
*
* - If you're using `typescript-eslint`, you may see errors from
*   [`@typescript-eslint/no-floating-promises`](https://typescript-eslint.io/rules/no-floating-promises)
* - In Framework/Data mode, `React.use(navigate())` will show a false-positive
*   `Argument of type 'void | Promise<void>' is not assignable to parameter of
*   type 'Usable<void>'` error
*
* The easiest way to work around these issues is to augment the type based on the
* router you're using:
*
* ```ts
* // If using <BrowserRouter>
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): void;
*     (delta: number): void;
*   }
* }
*
* // If using <RouterProvider> or Framework mode
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): Promise<void>;
*     (delta: number): Promise<void>;
*   }
* }
* ```
*
* @public
* @category Hooks
* @returns A navigate function for programmatic navigation
*/ function $f7958fa260273afe$export$9770f232ac06a008() {
    return $jHEir.useContext((0, $3uzJP.IsDataRouteContext)) ? $f7958fa260273afe$var$useNavigateStable() : $f7958fa260273afe$var$useNavigateUnstable();
}
function $f7958fa260273afe$var$useNavigateUnstable() {
    (0, $i4yVL.invariant)($f7958fa260273afe$export$9c954a9d03d32f4a(), `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $jHEir.useContext((0, $3uzJP.DataRouterContext));
    let { basename: basename, navigator: navigator } = $jHEir.useContext((0, $3uzJP.NavigationContext));
    let { matches: matches } = $jHEir.useContext((0, $3uzJP.RouteContext));
    let { pathname: locationPathname } = $f7958fa260273afe$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $vjGlj.getResolveToMatches)(matches));
    let activeRef = $jHEir.useRef(false);
    $jHEir.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $jHEir.useCallback((to, options = {})=>{
        (0, $i4yVL.warning)(activeRef.current, $f7958fa260273afe$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $vjGlj.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $vjGlj.joinPaths)([
            basename,
            path.pathname
        ]);
        (0, $1PkTq.validateNavigationTarget)(typeof to === "string" ? to : (0, $i4yVL.createPath)(to), navigator.createHref(path), (0, $1PkTq.getNavigatorCurrentUrl)(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
}
const $f7958fa260273afe$var$OutletContext = $jHEir.createContext(null);
/**
* Returns the parent route {@link Outlet | `<Outlet context>`}.
*
* Often parent routes manage state or other values you want shared with child
* routes. You can create your own [context provider](https://react.dev/learn/passing-data-deeply-with-context)
* if you like, but this is such a common situation that it's built-into
* {@link Outlet | `<Outlet>`}.
*
* ```tsx
* // Parent route
* function Parent() {
*   const [count, setCount] = React.useState(0);
*   return <Outlet context={[count, setCount]} />;
* }
* ```
*
* ```tsx
* // Child route
* import { useOutletContext } from "react-router";
*
* function Child() {
*   const [count, setCount] = useOutletContext();
*   const increment = () => setCount((c) => c + 1);
*   return <button onClick={increment}>{count}</button>;
* }
* ```
*
* If you're using TypeScript, we recommend the parent component provide a
* custom hook for accessing the context value. This makes it easier for
* consumers to get nice typings, control consumers, and know who's consuming
* the context value.
*
* Here's a more realistic example:
*
* ```tsx filename=src/routes/dashboard.tsx lines=[14,20]
* import { useState } from "react";
* import { Outlet, useOutletContext } from "react-router";
*
* import type { User } from "./types";
*
* type ContextType = { user: User | null };
*
* export default function Dashboard() {
*   const [user, setUser] = useState<User | null>(null);
*
*   return (
*     <div>
*       <h1>Dashboard</h1>
*       <Outlet context={{ user } satisfies ContextType} />
*     </div>
*   );
* }
*
* export function useUser() {
*   return useOutletContext<ContextType>();
* }
* ```
*
* ```tsx filename=src/routes/dashboard/messages.tsx lines=[1,4]
* import { useUser } from "../dashboard";
*
* export default function DashboardMessages() {
*   const { user } = useUser();
*   return (
*     <div>
*       <h2>Messages</h2>
*       <p>Hello, {user.name}!</p>
*     </div>
*   );
* }
* ```
*
* @public
* @category Hooks
* @returns The context value passed to the parent {@link Outlet} component
*/ function $f7958fa260273afe$export$4138103a3ae699cc() {
    return $jHEir.useContext($f7958fa260273afe$var$OutletContext);
}
/**
* Returns the element for the child route at this level of the route
* hierarchy. Used internally by {@link Outlet | `<Outlet>`} to render child
* routes.
*
* @public
* @category Hooks
* @param context The context to pass to the outlet
* @returns The child route element or `null` if no child routes match
*/ function $f7958fa260273afe$export$a3be3530d8e40d0b(context) {
    let outlet = $jHEir.useContext((0, $3uzJP.RouteContext)).outlet;
    return $jHEir.useMemo(()=>outlet && /* @__PURE__ */ $jHEir.createElement($f7958fa260273afe$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
/**
* Returns an object of key/value-pairs of the dynamic params from the current
* URL that were matched by the routes. Child routes inherit all params from
* their parent routes.
*
* Assuming a route pattern like `/posts/:postId` is matched by `/posts/123`
* then `params.postId` will be `"123"`.
*
* @example
* import { useParams } from "react-router";
*
* function SomeComponent() {
*   let params = useParams();
*   params.postId;
* }
*
* @additionalExamples
* ### Basic Usage
*
* ```tsx
* import { useParams } from "react-router";
*
* // given a route like:
* <Route path="/posts/:postId" element={<Post />} />;
*
* // or a data route like:
* createBrowserRouter([
*   {
*     path: "/posts/:postId",
*     component: Post,
*   },
* ]);
*
* // or in routes.ts
* route("/posts/:postId", "routes/post.tsx");
* ```
*
* Access the params in a component:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return <h1>Post: {params.postId}</h1>;
* }
* ```
*
* ### Multiple Params
*
* Patterns can have multiple params:
*
* ```tsx
* "/posts/:postId/comments/:commentId";
* ```
*
* All will be available in the params object:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return (
*     <h1>
*       Post: {params.postId}, Comment: {params.commentId}
*     </h1>
*   );
* }
* ```
*
* ### Catchall Params
*
* Catchall params are defined with `*`:
*
* ```tsx
* "/files/*";
* ```
*
* The matched value will be available in the params object as follows:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function File() {
*   let params = useParams();
*   let catchall = params["*"];
*   // ...
* }
* ```
*
* You can destructure the catchall param:
*
* ```tsx
* export default function File() {
*   let { "*": catchall } = useParams();
*   console.log(catchall);
* }
* ```
*
* @public
* @category Hooks
* @returns An object containing the dynamic route parameters
*/ function $f7958fa260273afe$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $jHEir.useContext((0, $3uzJP.RouteContext));
    return matches[matches.length - 1]?.params ?? {};
}
/**
* Resolves the pathname of the given `to` value against the current
* {@link Location}. Similar to {@link useHref}, but returns a
* {@link Path} instead of a string.
*
* @example
* import { useResolvedPath } from "react-router";
*
* function SomeComponent() {
*   // if the user is at /dashboard/profile
*   let path = useResolvedPath("../accounts");
*   path.pathname; // "/dashboard/accounts"
*   path.search; // ""
*   path.hash; // ""
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the route tree.
*                         Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved {@link Path} object with `pathname`, `search`, and `hash`
*/ function $f7958fa260273afe$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $jHEir.useContext((0, $3uzJP.RouteContext));
    let { pathname: locationPathname } = $f7958fa260273afe$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $vjGlj.getResolveToMatches)(matches));
    return $jHEir.useMemo(()=>(0, $vjGlj.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
* Hook version of {@link Routes | `<Routes>`} that uses objects instead of
* components. These objects have the same properties as the component props.
* The return value of `useRoutes` is either a valid React element you can use
* to render the route tree, or `null` if nothing matched.
*
* @example
* import { useRoutes } from "react-router";
*
* function App() {
*   let element = useRoutes([
*     {
*       path: "/",
*       element: <Dashboard />,
*       children: [
*         {
*           path: "messages",
*           element: <DashboardMessages />,
*         },
*         { path: "tasks", element: <DashboardTasks /> },
*       ],
*     },
*     { path: "team", element: <AboutPage /> },
*   ]);
*
*   return element;
* }
*
* @public
* @category Hooks
* @param routes An array of {@link RouteObject}s that define the route hierarchy
* @param locationArg An optional {@link Location} object or pathname string to
* use instead of the current {@link Location}
* @returns A React element to render the matched route, or `null` if no routes matched
*/ function $f7958fa260273afe$export$5d3fca4a98652595(routes, locationArg) {
    return $f7958fa260273afe$export$f7ce0646a48561fb(routes, locationArg);
}
function $f7958fa260273afe$export$f7ce0646a48561fb(routes, locationArg, dataRouterOpts) {
    (0, $i4yVL.invariant)($f7958fa260273afe$export$9c954a9d03d32f4a(), `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $jHEir.useContext((0, $3uzJP.NavigationContext));
    let { matches: parentMatches } = $jHEir.useContext((0, $3uzJP.RouteContext));
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    routeMatch && routeMatch.pathname;
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    routeMatch && routeMatch.route;
    let locationFromContext = $f7958fa260273afe$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? (0, $i4yVL.parsePath)(locationArg) : locationArg;
        (0, $i4yVL.invariant)(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        remainingPathname = "/" + pathname.replace(/^\//, "").split("/").slice(parentSegments.length).join("/");
    }
    let matches;
    if (dataRouterOpts) {
        if (dataRouterOpts.state.matches.length) matches = dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
                route: dataRouterOpts.manifest[m.route.id] || m.route
            }));
        else matches = dataRouterOpts.router.match(dataRouterOpts.state.location);
    } else matches = (0, $vjGlj.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $f7958fa260273afe$export$569816e95a012c39(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $vjGlj.joinPaths)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $vjGlj.joinPaths)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.LocationContext).Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP"
        }
    }, renderedMatches);
    return renderedMatches;
}
function $f7958fa260273afe$var$DefaultErrorComponent() {
    let error = $f7958fa260273afe$export$ed527bf60f6e05f2();
    let message = (0, $vjGlj.isRouteErrorResponse)(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    return /* @__PURE__ */ $jHEir.createElement($jHEir.Fragment, null, /* @__PURE__ */ $jHEir.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $jHEir.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $jHEir.createElement("pre", {
        style: {
            padding: "0.5rem",
            backgroundColor: "rgba(200,200,200, 0.5)"
        }
    }, stack) : null, null);
}
const $f7958fa260273afe$var$defaultErrorElement = /* @__PURE__ */ $jHEir.createElement($f7958fa260273afe$var$DefaultErrorComponent, null);
var $f7958fa260273afe$var$RenderErrorBoundary = class extends $jHEir.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static contextType = (0, $3uzJP.RSCRouterContext);
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = (0, $7DINx.decodeRouteErrorResponseDigest)(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.RouteContext).Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.IsDataRouteContext).Provider, {
            value: this.props.routeContext.isDataRoute
        }, /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.RouteIdContext).Provider, {
            value: this.props.routeContext.matches[this.props.routeContext.matches.length - 1]?.route.id
        }, /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.RouteErrorContext).Provider, {
            value: error,
            children: this.props.component
        })))) : this.props.children;
        if (this.context) return /* @__PURE__ */ $jHEir.createElement($f7958fa260273afe$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
const $f7958fa260273afe$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $f7958fa260273afe$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename, navigator: navigator } = $jHEir.useContext((0, $3uzJP.NavigationContext));
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect = (0, $7DINx.decodeRedirectErrorDigest)(error.digest);
        if (redirect) {
            let existingRedirect = $f7958fa260273afe$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = (0, $vjGlj.parseToInfo)(redirect.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            (0, $1PkTq.validateNavigationTarget)(redirect.location, target, (0, $1PkTq.getNavigatorCurrentUrl)(navigator), "allow-explicit");
            if ((0, $6WCgj.hasInvalidProtocol)(target)) throw new Error("Invalid redirect location");
            if ((0, $vjGlj.isBrowser) && !$f7958fa260273afe$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect.replace
                        }));
                    $f7958fa260273afe$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $jHEir.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $f7958fa260273afe$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $jHEir.useContext((0, $3uzJP.DataRouterContext));
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.RouteContext).Provider, {
        value: routeContext
    }, /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.IsDataRouteContext).Provider, {
        value: routeContext.isDataRoute
    }, /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.RouteIdContext).Provider, {
        value: match.route.id
    }, children)));
}
function $f7958fa260273afe$export$569816e95a012c39(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        (0, $i4yVL.invariant)(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors || errors[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: (0, $vjGlj.getRoutePattern)(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $f7958fa260273afe$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $f7958fa260273afe$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $jHEir.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $jHEir.createElement($f7958fa260273afe$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $jHEir.createElement($f7958fa260273afe$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $f7958fa260273afe$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $f7958fa260273afe$export$ae09415e57d46628(hookName) {
    let ctx = $jHEir.useContext((0, $3uzJP.DataRouterContext));
    (0, $i4yVL.invariant)(ctx, $f7958fa260273afe$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $f7958fa260273afe$export$f93124018767f269(hookName) {
    let state = $jHEir.useContext((0, $3uzJP.DataRouterStateContext));
    (0, $i4yVL.invariant)(state, $f7958fa260273afe$var$getDataRouterConsoleError(hookName));
    return state;
}
function $f7958fa260273afe$export$c6e4e4d7047d4ffe(hookName) {
    let fetchers = $jHEir.useContext((0, $3uzJP.FetchersContext));
    (0, $i4yVL.invariant)(fetchers, $f7958fa260273afe$var$getDataRouterConsoleError(hookName));
    return fetchers;
}
function $f7958fa260273afe$export$798168c290ba5b3d(hookName) {
    let data = $jHEir.useContext((0, $3uzJP.DataRouterDataContext));
    (0, $i4yVL.invariant)(data, $f7958fa260273afe$var$getDataRouterConsoleError(hookName));
    return data;
}
function $f7958fa260273afe$var$useDataRouterNavigation(hookName) {
    let navigation = $jHEir.useContext((0, $3uzJP.DataRouterNavigationContext));
    (0, $i4yVL.invariant)(navigation, $f7958fa260273afe$var$getDataRouterConsoleError(hookName));
    return navigation;
}
function $f7958fa260273afe$export$501a3f562d56eac6(hookName) {
    let routeId = $jHEir.useContext((0, $3uzJP.RouteIdContext));
    (0, $i4yVL.invariant)(routeId, `${hookName} can only be used on routes that contain a unique "id"`);
    return routeId;
}
/**
* Returns the current {@link Navigation}, defaulting to an "idle" navigation
* when no navigation is in progress. You can use this to render pending UI
* (like a global spinner) or read [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData)
* from a form navigation.
*
* @example
* import { useNavigation } from "react-router";
*
* function SomeComponent() {
*   let navigation = useNavigation();
*   navigation.state;
*   navigation.formData;
*   // etc.
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current {@link Navigation} object
*/ function $f7958fa260273afe$export$d0fd4b7106de2769() {
    let { navigation: navigation } = $f7958fa260273afe$var$useDataRouterNavigation("useNavigation");
    return $jHEir.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = navigation;
        return rest;
    }, [
        navigation
    ]);
}
/**
* Revalidate the data on the page for reasons outside of normal data mutations
* like [`Window` focus](https://developer.mozilla.org/en-US/docs/Web/API/Window/focus_event)
* or polling on an interval.
*
* Note that page data is already revalidated automatically after actions.
* If you find yourself using this for normal CRUD operations on your data in
* response to user interactions, you're probably not taking advantage of the
* other APIs like {@link useFetcher}, {@link Form}, {@link useSubmit} that do
* this automatically.
*
* @example
* import { useRevalidator } from "react-router";
*
* function WindowFocusRevalidator() {
*   const revalidator = useRevalidator();
*
*   useFakeWindowFocus(() => {
*     revalidator.revalidate();
*   });
*
*   return (
*     <div hidden={revalidator.state === "idle"}>
*       Revalidating...
*     </div>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An object with a `revalidate` function and the current revalidation
* `state`
*/ function $f7958fa260273afe$export$600dc272ed516c15() {
    let dataRouterContext = $f7958fa260273afe$export$ae09415e57d46628("useRevalidator");
    let { revalidation: revalidation } = $f7958fa260273afe$var$useDataRouterNavigation("useRevalidator");
    let revalidate = $jHEir.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $jHEir.useMemo(()=>({
            revalidate: revalidate,
            state: revalidation
        }), [
        revalidate,
        revalidation
    ]);
}
/**
* Returns the active route matches, useful for accessing `loaderData` for
* parent/child routes or the route [`handle`](../../start/framework/route-module#handle)
* property
*
* Pairing the route `handle` with `useMatches` gets very powerful since you can put
* whatever you want on a route handle and have access to `useMatches` anywhere.
* Please see the [handle](../../how-to/using-handle) documentation for an example
* of breadcrumbs via `useMatches`/`handle`.
*
* ```tsx
* import { useMatches } from "react-router";
*
* function SomeComponent() {
*   const matches = useMatches();
*   // matches[i].id          // route id
*   // matches[i].pathname    // the portion of the URL the route matched
*   // matches[i].params      // the parsed params from the URL
*   // matches[i].loaderData  // the data from the loader
*   // matches[i].handle      // the route handle with any app specific data
* }
* ```
*
* <docs-info>useMatches only works with a data router like `createBrowserRouter`,
* since they know the full route tree up front and can provide all of the current
* matches. Additionally, `useMatches` will not match down into any descendant route
* trees since the router isn't aware of the descendant routes.</docs-info>
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of {@link UIMatch | UI matches} for the current route hierarchy
*/ function $f7958fa260273afe$export$2378eb7f5ff86053() {
    let { matches: matches } = $f7958fa260273afe$export$f93124018767f269("useMatches");
    let { loaderData: loaderData } = $f7958fa260273afe$export$798168c290ba5b3d("useMatches");
    return $jHEir.useMemo(()=>matches.map((m)=>(0, $vjGlj.convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
* Returns the data from the closest route
* [`loader`](../../start/framework/route-module#loader) or
* [`clientLoader`](../../start/framework/route-module#clientloader).
*
* @example
* import { useLoaderData } from "react-router";
*
* export async function loader() {
*   return await fakeDb.invoices.findAll();
* }
*
* export default function Invoices() {
*   let invoices = useLoaderData<typeof loader>();
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`loader`](../../start/framework/route-module#loader) or [`clientLoader`](../../start/framework/route-module#clientloader) function
*/ function $f7958fa260273afe$export$1448a5050d252c4d() {
    let data = $f7958fa260273afe$export$798168c290ba5b3d("useLoaderData");
    let routeId = $f7958fa260273afe$export$501a3f562d56eac6("useLoaderData");
    return data.loaderData[routeId];
}
/**
* Returns the [`loader`](../../start/framework/route-module#loader) data for a
* given route by route ID.
*
* Route IDs are created automatically. They are simply the path of the route file
* relative to the app folder without the extension.
*
* | Route Filename               | Route ID               |
* | ---------------------------- | ---------------------- |
* | `app/root.tsx`               | `"root"`               |
* | `app/routes/teams.tsx`       | `"routes/teams"`       |
* | `app/whatever/teams.$id.tsx` | `"whatever/teams.$id"` |
*
* @example
* import { useRouteLoaderData } from "react-router";
*
* function SomeComponent() {
*   const { user } = useRouteLoaderData("root");
* }
*
* // You can also specify your own route ID's manually in your routes.ts file:
* route("/", "containers/app.tsx", { id: "app" })
* useRouteLoaderData("app");
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param routeId The ID of the route to return loader data from
* @returns The data returned from the specified route's [`loader`](../../start/framework/route-module#loader)
* function, or `undefined` if not found
*/ function $f7958fa260273afe$export$fd5d37484eab868d(routeId) {
    return $f7958fa260273afe$export$798168c290ba5b3d("useRouteLoaderData").loaderData[routeId];
}
/**
* Returns the [`action`](../../start/framework/route-module#action) data from
* the most recent `POST` navigation form submission or `undefined` if there
* hasn't been one.
*
* @example
* import { Form, useActionData } from "react-router";
*
* export async function action({ request }) {
*   const body = await request.formData();
*   const name = body.get("visitorsName");
*   return { message: `Hello, ${name}` };
* }
*
* export default function Invoices() {
*   const data = useActionData();
*   return (
*     <Form method="post">
*       <input type="text" name="visitorsName" />
*       {data ? data.message : "Waiting..."}
*     </Form>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`action`](../../start/framework/route-module#action)
* function, or `undefined` if no [`action`](../../start/framework/route-module#action)
* has been called
*/ function $f7958fa260273afe$export$fdc00f3f26066d5e() {
    let data = $f7958fa260273afe$export$798168c290ba5b3d("useActionData");
    let routeId = $f7958fa260273afe$export$501a3f562d56eac6("useActionData");
    return data.actionData ? data.actionData[routeId] : void 0;
}
/**
* Accesses the error thrown during an
* [`action`](../../start/framework/route-module#action),
* [`loader`](../../start/framework/route-module#loader),
* or component render to be used in a route module
* [`ErrorBoundary`](../../start/framework/route-module#errorboundary).
*
* @example
* export function ErrorBoundary() {
*   const error = useRouteError();
*   return <div>{error.message}</div>;
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown during route [loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action) execution, or rendering
*/ function $f7958fa260273afe$export$ed527bf60f6e05f2() {
    let error = $jHEir.useContext((0, $3uzJP.RouteErrorContext));
    let data = $f7958fa260273afe$export$798168c290ba5b3d("useRouteError");
    let routeId = $f7958fa260273afe$export$501a3f562d56eac6("useRouteError");
    if (error !== void 0) return error;
    return data.errors?.[routeId];
}
/**
* Returns the resolved promise value from the closest {@link Await | `<Await>`}.
*
* @example
* function SomeDescendant() {
*   const value = useAsyncValue();
*   // ...
* }
*
* // somewhere in your app
* <Await resolve={somePromise}>
*   <SomeDescendant />
* </Await>;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The resolved value from the nearest {@link Await} component
*/ function $f7958fa260273afe$export$78a72ddb39bdd145() {
    let value = $jHEir.useContext((0, $3uzJP.AwaitContext));
    return value && "status" in value && !("_tracked" in value) ? value.status === "fulfilled" ? value.value : void 0 : value?._data;
}
/**
* Returns the rejection value from the closest {@link Await | `<Await>`}.
*
* @example
* import { Await, useAsyncError } from "react-router";
*
* function ErrorElement() {
*   const error = useAsyncError();
*   return (
*     <p>Uh Oh, something went wrong! {error.message}</p>
*   );
* }
*
* // somewhere in your app
* <Await
*   resolve={promiseThatRejects}
*   errorElement={<ErrorElement />}
* />;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown in the nearest {@link Await} component
*/ function $f7958fa260273afe$export$17f53340677d5831() {
    let value = $jHEir.useContext((0, $3uzJP.AwaitContext));
    return value && "status" in value && !("_tracked" in value) ? value.status === "rejected" ? value.reason : void 0 : value?._error;
}
let $f7958fa260273afe$var$blockerId = 0;
/**
* Allow the application to block navigations within the SPA and present the
* user a confirmation dialog to confirm the navigation. Mostly used to avoid
* using half-filled form data. This does not handle hard-reloads or
* cross-origin navigations.
*
* The {@link Blocker} object returned by the hook has the following properties:
*
* - **`state`**
*   - `unblocked` - the blocker is idle and has not prevented any navigation
*   - `blocked` - the blocker has prevented a navigation
*   - `proceeding` - the blocker is proceeding through from a blocked navigation
* - **`location`**
*   - When in a `blocked` state, this represents the {@link Location} to which
*     we blocked a navigation. When in a `proceeding` state, this is the
*     location being navigated to after a `blocker.proceed()` call.
* - **`proceed()`**
*   - When in a `blocked` state, you may call `blocker.proceed()` to proceed to
*     the blocked location.
* - **`reset()`**
*   - When in a `blocked` state, you may call `blocker.reset()` to return the
*     blocker to an `unblocked` state and leave the user at the current
*     location.
*
* @example
* // Boolean version
* let blocker = useBlocker(value !== "");
*
* // Function version
* let blocker = useBlocker(
*   ({ currentLocation, nextLocation, historyAction }) =>
*     value !== "" &&
*     currentLocation.pathname !== nextLocation.pathname
* );
*
* @additionalExamples
* ```tsx
* import { useCallback, useState } from "react";
* import { BlockerFunction, useBlocker } from "react-router";
*
* export function ImportantForm() {
*   const [value, setValue] = useState("");
*
*   const shouldBlock = useCallback<BlockerFunction>(
*     () => value !== "",
*     [value]
*   );
*   const blocker = useBlocker(shouldBlock);
*
*   return (
*     <form
*       onSubmit={(e) => {
*         e.preventDefault();
*         setValue("");
*         if (blocker.state === "blocked") {
*           blocker.proceed();
*         }
*       }}
*     >
*       <input
*         name="data"
*         value={value}
*         onChange={(e) => setValue(e.target.value)}
*       />
*
*       <button type="submit">Save</button>
*
*       {blocker.state === "blocked" ? (
*         <>
*           <p style={{ color: "red" }}>
*             Blocked the last navigation to
*           </p>
*           <button
*             type="button"
*             onClick={() => blocker.proceed()}
*           >
*             Let me through
*           </button>
*           <button
*             type="button"
*             onClick={() => blocker.reset()}
*           >
*             Keep me here
*           </button>
*         </>
*       ) : blocker.state === "proceeding" ? (
*         <p style={{ color: "orange" }}>
*           Proceeding through blocked navigation
*         </p>
*       ) : (
*         <p style={{ color: "green" }}>
*           Blocker is currently unblocked
*         </p>
*       )}
*     </form>
*   );
* }
* ```
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param shouldBlock Either a boolean or a function returning a boolean which
* indicates whether the navigation should be blocked. The function format
* receives a single object parameter containing the `currentLocation`,
* `nextLocation`, and `historyAction` of the potential navigation.
* @returns A {@link Blocker} object with state and reset functionality
*/ function $f7958fa260273afe$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $f7958fa260273afe$export$ae09415e57d46628("useBlocker");
    let state = $f7958fa260273afe$export$f93124018767f269("useBlocker");
    let [blockerKey, setBlockerKey] = $jHEir.useState("");
    let blockerFunction = $jHEir.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: (0, $vjGlj.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: (0, $vjGlj.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $jHEir.useEffect(()=>{
        let key = String(++$f7958fa260273afe$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $jHEir.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $6WCgj.IDLE_BLOCKER);
}
function $f7958fa260273afe$var$useNavigateStable() {
    let { router: router } = $f7958fa260273afe$export$ae09415e57d46628("useNavigate");
    let id = $f7958fa260273afe$export$501a3f562d56eac6("useNavigate");
    let activeRef = $jHEir.useRef(false);
    $jHEir.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $jHEir.useCallback(async (to, options = {})=>{
        (0, $i4yVL.warning)(activeRef.current, $f7958fa260273afe$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
}
const $f7958fa260273afe$var$alreadyWarned = {};
function $f7958fa260273afe$var$warningOnce(key, cond, message) {
    if (!cond && !$f7958fa260273afe$var$alreadyWarned[key]) {
        $f7958fa260273afe$var$alreadyWarned[key] = true;
        (0, $i4yVL.warning)(false, message);
    }
}
function $f7958fa260273afe$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $f7958fa260273afe$export$501a3f562d56eac6("useRoute");
    const id = args[0] ?? currentRouteId;
    const state = $f7958fa260273afe$export$f93124018767f269("useRoute");
    const data = $f7958fa260273afe$export$798168c290ba5b3d("useRoute");
    const route = state.matches.find(({ route: route })=>route.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: data.loaderData[id],
        actionData: data.actionData?.[id]
    };
}
function $f7958fa260273afe$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
/**
* A unified hook for reading router state: current (`active`) and in-flight
* (`pending`) locations, search params, params, matches, and navigation type.
*
* This hook consolidates the information you used to get from {@link useLocation},
* {@link useSearchParams}, {@link useParams}, {@link useMatches}, {@link useNavigation},
* and {@link useNavigationType} into a single hook.
*
*
* @example
* import { unstable_useRouterState as useRouterState } from "react-router";
*
* let { active, pending } = useRouterState();
*
* // Active is always populated with the current location
* active.location; // replaces `useLocation()`
* active.searchParams; // replaces `useSearchParams()[0]`
* active.params; // replaces `useParams()`
* active.matches; // replaces `useMatches()`
* active.type; // replaces `useNavigationType()`
*
* // Pending is only populated during a navigation
* pending.location; // replaces `useNavigation().location`
* pending.searchParams; // equivalent to `new URLSearchParams(useNavigation().search)`
* pending.params; // Not directly accessible today
* pending.matches; // Not directly accessible today
* pending.type; // Not directly accessible today
* pending.state; // replaces `useNavigation().state`
* pending.formMethod; // replaces useNavigation().formMethod
* pending.formAction; // replaces useNavigation().formAction
* pending.formEncType; // replaces useNavigation().formEncType
* pending.formData; // replaces useNavigation().formData
* pending.json; // replaces useNavigation().json
* pending.text; // replaces useNavigation().text
*
* @name unstable_useRouterState
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current router state with `active` and `pending` variants
*/ function $f7958fa260273afe$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches } = $f7958fa260273afe$export$f93124018767f269("unstable_useRouterState");
    let { navigation: navigation } = $f7958fa260273afe$var$useDataRouterNavigation("unstable_useRouterState");
    let active = $jHEir.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$f7958fa260273afe$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $jHEir.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$f7958fa260273afe$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $jHEir.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}

});
parcelRegister("7DINx", function(module, exports) {

$parcel$export(module.exports, "decodeRedirectErrorDigest", function () { return $58feece21e96913d$export$30db792b333fd2ee; });
$parcel$export(module.exports, "decodeRouteErrorResponseDigest", function () { return $58feece21e96913d$export$2b5950305b3e7eaf; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $vjGlj = parcelRequire("vjGlj");
//#region lib/errors.ts
const $58feece21e96913d$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
const $58feece21e96913d$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
const $58feece21e96913d$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $58feece21e96913d$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$58feece21e96913d$var$ERROR_DIGEST_BASE}:${$58feece21e96913d$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $58feece21e96913d$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$58feece21e96913d$var$ERROR_DIGEST_BASE}:${$58feece21e96913d$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new (0, $vjGlj.ErrorResponseImpl)(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}

});


parcelRegister("dr43k", function(module, exports) {

$parcel$export(module.exports, "escapeHtml", function () { return $9c80f0c7ec9c9c68$export$4cf11838cdc2a8a8; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/markup.ts
const $9c80f0c7ec9c9c68$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
const $9c80f0c7ec9c9c68$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $9c80f0c7ec9c9c68$export$4cf11838cdc2a8a8(html) {
    return html.replace($9c80f0c7ec9c9c68$var$ESCAPE_REGEX, (match)=>$9c80f0c7ec9c9c68$var$ESCAPE_LOOKUP[match]);
}
function $9c80f0c7ec9c9c68$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

});

parcelRegister("koI43", function(module, exports) {

$parcel$export(module.exports, "FrameworkContext", function () { return $ed983acaa0b73e81$export$208d6a3bc3aa62bd; });
$parcel$export(module.exports, "useFrameworkContext", function () { return $ed983acaa0b73e81$export$17134ff624fc6bc2; });
$parcel$export(module.exports, "usePrefetchBehavior", function () { return $ed983acaa0b73e81$export$6eb91431f5da407c; });
$parcel$export(module.exports, "PrefetchPageLinks", function () { return $ed983acaa0b73e81$export$60dcec93e67386bd; });
$parcel$export(module.exports, "Scripts", function () { return $ed983acaa0b73e81$export$ff0bf87698939488; });
$parcel$export(module.exports, "mergeRefs", function () { return $ed983acaa0b73e81$export$c9058316764c140e; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $3uzJP = parcelRequire("3uzJP");

var $lfSRY = parcelRequire("lfSRY");

var $lMYnX = parcelRequire("lMYnX");

var $eIBmG = parcelRequire("eIBmG");

var $dr43k = parcelRequire("dr43k");

var $8qlIu = parcelRequire("8qlIu");

var $5QqfD = parcelRequire("5QqfD");

var $ei6eN = parcelRequire("ei6eN");

var $jHEir = parcelRequire("jHEir");
//#region lib/dom/ssr/components.tsx
const $ed983acaa0b73e81$export$208d6a3bc3aa62bd = $jHEir.createContext(void 0);
$ed983acaa0b73e81$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $ed983acaa0b73e81$export$17134ff624fc6bc2() {
    let context = $jHEir.useContext($ed983acaa0b73e81$export$208d6a3bc3aa62bd);
    (0, $lMYnX.default)(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $ed983acaa0b73e81$export$6eb91431f5da407c(prefetch, theirElementProps) {
    let frameworkContext = $jHEir.useContext($ed983acaa0b73e81$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $jHEir.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $jHEir.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $jHEir.useRef(null);
    $jHEir.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: .5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $jHEir.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $ed983acaa0b73e81$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $ed983acaa0b73e81$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $ed983acaa0b73e81$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $ed983acaa0b73e81$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $ed983acaa0b73e81$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $ed983acaa0b73e81$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $ed983acaa0b73e81$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$ed983acaa0b73e81$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
const $ed983acaa0b73e81$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
/**
* Renders all the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags created by the route module's [`links`](../../start/framework/route-module#links)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Links } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Links />
*       </head>
*       <body></body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {LinksProps.nonce} props.nonce n/a
* @param {LinksProps.crossOrigin} props.crossOrigin n/a
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $ed983acaa0b73e81$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $ed983acaa0b73e81$export$17134ff624fc6bc2();
    let { matches: routerMatches } = (0, $lfSRY.useDataRouterState)("Links");
    let { errors: errors } = (0, $lfSRY.useDataRouterData)("Links");
    let matches = $ed983acaa0b73e81$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $jHEir.useMemo(()=>(0, $eIBmG.getKeyedLinksForMatches)(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $jHEir.createElement($jHEir.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $jHEir.createElement("style", {
        [$ed983acaa0b73e81$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $jHEir.createElement("link", {
        [$ed983acaa0b73e81$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>(0, $eIBmG.isPageLinkDescriptor)(link) ? /* @__PURE__ */ $jHEir.createElement($ed983acaa0b73e81$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $jHEir.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
/**
* Renders [`<link rel=prefetch|modulepreload>`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel)
* tags for modules and data of another page to enable an instant navigation to
* that page. [`<Link prefetch>`](./Link#prefetch) uses this internally, but you
* can render it to prefetch a page for any other reason.
*
* For example, you may render one of this as the user types into a search field
* to prefetch search results before they click through to their selection.
*
* @example
* import { PrefetchPageLinks } from "react-router";
*
* <PrefetchPageLinks page="/absolute/path" />
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {PageLinkDescriptor.page} props.page n/a
* @param props.linkProps Additional props to spread onto the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/crossOrigin),
* [`integrity`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/integrity),
* [`rel`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel),
* etc.
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $ed983acaa0b73e81$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = (0, $3uzJP.useIsRSCRouterContext)();
    let { nonce: contextNonce } = $ed983acaa0b73e81$export$17134ff624fc6bc2();
    let { router: router } = (0, $lfSRY.useDataRouterContext)("PrefetchPageLinks");
    let matches = $jHEir.useMemo(()=>router.match(page), [
        router,
        router.routes,
        page
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $jHEir.createElement($ed983acaa0b73e81$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $jHEir.createElement($ed983acaa0b73e81$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $ed983acaa0b73e81$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $ed983acaa0b73e81$export$17134ff624fc6bc2();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $jHEir.useState([]);
    $jHEir.useEffect(()=>{
        let interrupted = false;
        (0, $eIBmG.getKeyedPrefetchLinks)(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $ed983acaa0b73e81$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = (0, $lfSRY.useLocation)();
    let { unstable_apiServerOrigin: unstable_apiServerOrigin } = $ed983acaa0b73e81$export$17134ff624fc6bc2();
    let dataHrefs = $jHEir.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = (0, $8qlIu.singleFetchUrl)(page, "rsc", unstable_apiServerOrigin);
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            unstable_apiServerOrigin ? url.toString() : url.pathname + url.search
        ];
    }, [
        page,
        location,
        nextMatches,
        unstable_apiServerOrigin
    ]);
    return /* @__PURE__ */ $jHEir.createElement($jHEir.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $jHEir.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $ed983acaa0b73e81$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = (0, $lfSRY.useLocation)();
    let { manifest: manifest, routeModules: routeModules, unstable_apiServerOrigin: unstable_apiServerOrigin } = $ed983acaa0b73e81$export$17134ff624fc6bc2();
    let { matches: matches } = (0, $lfSRY.useDataRouterState)("PrefetchPageLinks");
    let { loaderData: loaderData } = (0, $lfSRY.useDataRouterData)("PrefetchPageLinks");
    let newMatchesForData = $jHEir.useMemo(()=>(0, $eIBmG.getNewMatchesForLinks)(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $jHEir.useMemo(()=>(0, $eIBmG.getNewMatchesForLinks)(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $jHEir.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = (0, $8qlIu.singleFetchUrl)(page, "data", unstable_apiServerOrigin);
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            unstable_apiServerOrigin ? url.toString() : url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules,
        unstable_apiServerOrigin
    ]);
    let moduleHrefs = $jHEir.useMemo(()=>(0, $eIBmG.getModuleLinkHrefs)(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $ed983acaa0b73e81$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $jHEir.createElement($jHEir.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $jHEir.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $jHEir.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>/* @__PURE__ */ $jHEir.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
/**
* Renders all the [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags created by the route module's [`meta`](../../start/framework/route-module#meta)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Meta } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Meta />
*       </head>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @returns A collection of React elements for [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags
*/ function $ed983acaa0b73e81$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $ed983acaa0b73e81$export$17134ff624fc6bc2();
    let { matches: routerMatches } = (0, $lfSRY.useDataRouterState)("Meta");
    let { errors: errors, loaderData: loaderData } = (0, $lfSRY.useDataRouterData)("Meta");
    let location = (0, $lfSRY.useLocation)();
    let _matches = $ed983acaa0b73e81$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            loaderData: data,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            loaderData: data,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $jHEir.createElement($jHEir.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$ed983acaa0b73e81$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $jHEir.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $jHEir.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ??= metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $jHEir.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $jHEir.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: (0, $dr43k.escapeHtml)(json)
                }
            });
        } catch  {
            return null;
        }
        return /* @__PURE__ */ $jHEir.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $ed983acaa0b73e81$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
/**
* Tracks whether hydration is finished, so scripts can be skipped
* during client-side updates.
*/ let $ed983acaa0b73e81$var$isHydrated = false;
function $ed983acaa0b73e81$export$3be068dde909e563() {
    $ed983acaa0b73e81$var$isHydrated = true;
}
/**
* Renders the client runtime of your app. It should be rendered inside the
* [`<body>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/body)
*  of the document.
*
* If server rendering, you can omit `<Scripts/>` and the app will work as a
* traditional web app without JavaScript, relying solely on HTML and browser
* behaviors.
*
* @example
* import { Scripts } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head />
*       <body>
*         <Scripts />
*       </body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param scriptProps Additional props to spread onto the [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement/crossOrigin),
* [`nonce`](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Global_attributes/nonce),
* etc.
* @returns A collection of React elements for [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags
*/ function $ed983acaa0b73e81$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $ed983acaa0b73e81$export$17134ff624fc6bc2();
    let { router: router, static: isStatic, staticContext: staticContext } = (0, $lfSRY.useDataRouterContext)("Scripts");
    let { matches: routerMatches } = (0, $lfSRY.useDataRouterState)("Scripts");
    let isRSCRouterContext = (0, $3uzJP.useIsRSCRouterContext)();
    let enableFogOfWar = (0, $ei6eN.isFogOfWarEnabled)(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $ed983acaa0b73e81$var$getActiveMatches(routerMatches, null, isSpaMode);
    $jHEir.useEffect(()=>{
        $ed983acaa0b73e81$export$3be068dde909e563();
    }, []);
    let initialScripts = $jHEir.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            (0, $lMYnX.default)(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            return [
                chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n"),
                `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? `window.__reactRouterManifest = ${JSON.stringify((0, $ei6eN.getPartialManifest)(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $jHEir.createElement($jHEir.Fragment, null, /* @__PURE__ */ $jHEir.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $jHEir.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $ed983acaa0b73e81$var$isHydrated || isRSCRouterContext ? [] : [
        ...new Set(manifest.entry.imports.concat((0, $eIBmG.getModuleLinkHrefs)(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    (0, $5QqfD.warnOnce)(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $ed983acaa0b73e81$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $jHEir.createElement($jHEir.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $jHEir.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $jHEir.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $jHEir.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $jHEir.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $ed983acaa0b73e81$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}

});
parcelRegister("lMYnX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdccebfa0ea0c0e5$export$2e2bcd8739ae039; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/invariant.ts
function $fdccebfa0ea0c0e5$export$2e2bcd8739ae039(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}

});

parcelRegister("eIBmG", function(module, exports) {

$parcel$export(module.exports, "getKeyedLinksForMatches", function () { return $ab72289dacf369d3$export$c43eb07eab2c950a; });
$parcel$export(module.exports, "getModuleLinkHrefs", function () { return $ab72289dacf369d3$export$442b9e023f41af00; });
$parcel$export(module.exports, "prefetchRouteCss", function () { return $ab72289dacf369d3$export$2ee8f5601ba37b41; });
$parcel$export(module.exports, "prefetchStyleLinks", function () { return $ab72289dacf369d3$export$26f28bc6dfd6cfc6; });
$parcel$export(module.exports, "isPageLinkDescriptor", function () { return $ab72289dacf369d3$export$aea1aca0de10baae; });
$parcel$export(module.exports, "getKeyedPrefetchLinks", function () { return $ab72289dacf369d3$export$98f31d7a23772264; });
$parcel$export(module.exports, "getNewMatchesForLinks", function () { return $ab72289dacf369d3$export$4af547f9516933c; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $67gn7 = parcelRequire("67gn7");
//#region lib/dom/ssr/links.ts
/**
* Gets all the links for a set of matches. The modules are assumed to have been
* loaded already.
*/ function $ab72289dacf369d3$export$c43eb07eab2c950a(matches, routeModules, manifest) {
    return $ab72289dacf369d3$var$dedupeLinkDescriptors(matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2), $ab72289dacf369d3$export$442b9e023f41af00(matches, manifest));
}
function $ab72289dacf369d3$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $ab72289dacf369d3$export$2ee8f5601ba37b41(route) {
    if (!route.css) return;
    let descriptors = $ab72289dacf369d3$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($ab72289dacf369d3$var$prefetchStyleLink));
}
async function $ab72289dacf369d3$export$26f28bc6dfd6cfc6(route, routeModule) {
    if (!route.css && !routeModule.links || !$ab72289dacf369d3$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$ab72289dacf369d3$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$ab72289dacf369d3$export$aea1aca0de10baae(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($ab72289dacf369d3$var$prefetchStyleLink));
}
async function $ab72289dacf369d3$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $ab72289dacf369d3$export$aea1aca0de10baae(object) {
    return object != null && typeof object.page === "string";
}
function $ab72289dacf369d3$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $ab72289dacf369d3$export$98f31d7a23772264(matches, manifest, routeModules) {
    return $ab72289dacf369d3$var$dedupeLinkDescriptors((await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await (0, $67gn7.loadRouteModule)(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }))).flat(1).filter($ab72289dacf369d3$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $ab72289dacf369d3$export$4af547f9516933c(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return currentMatches[index].pathname !== match.pathname || currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"];
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $ab72289dacf369d3$export$442b9e023f41af00(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $ab72289dacf369d3$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $ab72289dacf369d3$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $ab72289dacf369d3$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $ab72289dacf369d3$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        if (preloads && !$ab72289dacf369d3$export$aea1aca0de10baae(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href)) return deduped;
        let key = JSON.stringify($ab72289dacf369d3$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
let $ab72289dacf369d3$var$_isPreloadSupported;
function $ab72289dacf369d3$var$isPreloadSupported() {
    if ($ab72289dacf369d3$var$_isPreloadSupported !== void 0) return $ab72289dacf369d3$var$_isPreloadSupported;
    let el = document.createElement("link");
    $ab72289dacf369d3$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $ab72289dacf369d3$var$_isPreloadSupported;
}

});
parcelRegister("67gn7", function(module, exports) {

$parcel$export(module.exports, "loadRouteModule", function () { return $474018a6dba1cdd5$export$d9c4a4e8105733a6; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/routeModules.ts
var $474018a6dba1cdd5$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/production/lib/dom/ssr/routeModules.js"
});
async function $474018a6dba1cdd5$export$d9c4a4e8105733a6(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && $474018a6dba1cdd5$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}

});


parcelRegister("8qlIu", function(module, exports) {

$parcel$export(module.exports, "singleFetchUrl", function () { return $622198e93806af9a$export$7b977381851b2c; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $vjGlj = parcelRequire("vjGlj");

var $6WCgj = parcelRequire("6WCgj");

var $lMYnX = parcelRequire("lMYnX");

var $dr43k = parcelRequire("dr43k");

var $2noQd = parcelRequire("2noQd");

var $k5jWQ = parcelRequire("k5jWQ");

var $jHEir = parcelRequire("jHEir");
//#region lib/dom/ssr/single-fetch.tsx
const $622198e93806af9a$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $622198e93806af9a$var$SingleFetchNoResultError = class extends Error {
};
const $622198e93806af9a$export$e35ccdcde387134d = new Set([
    100,
    101,
    204,
    205
]);
function $622198e93806af9a$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $jHEir.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${(0, $dr43k.escapeHtml)(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $jHEir.createElement($jHEir.Fragment, null, scriptTag, /* @__PURE__ */ $jHEir.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $jHEir.createElement($jHEir.Fragment, null, scriptTag, /* @__PURE__ */ $jHEir.createElement($jHEir.Suspense, null, /* @__PURE__ */ $jHEir.createElement($622198e93806af9a$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $622198e93806af9a$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, fetchImplementation = (request)=>fetch(request), isApiOnly = false, serverOrigin, isSpaMode = false) {
    let dataStrategy = $622198e93806af9a$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        (0, $lMYnX.default)(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $622198e93806af9a$var$fetchAndDecodeViaTurboStream(fetchImplementation, serverOrigin), ssr, void 0, isApiOnly, isSpaMode);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $622198e93806af9a$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true, isApiOnly = false, isSpaMode = false) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $622198e93806af9a$var$singleFetchActionStrategy(args, fetchAndDecode);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $622198e93806af9a$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode);
        if (fetcherKey) return $622198e93806af9a$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode);
        return $622198e93806af9a$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut, isApiOnly, isSpaMode);
    };
}
async function $622198e93806af9a$var$singleFetchActionStrategy(args, fetchAndDecode) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $lMYnX.default)(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        return await handler(async ()=>{
            let { data: data, status: status } = await fetchAndDecode(args, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $622198e93806af9a$var$unwrapSingleFetchResult(data, actionMatch.route.id);
        });
    });
    if ((0, $6WCgj.isResponse)(result.result) || (0, $vjGlj.isRouteErrorResponse)(result.result) || (0, $6WCgj.isDataWithResponseInit)(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: (0, $vjGlj.data)(result.result, actionStatus)
        }
    };
}
async function $622198e93806af9a$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map(async (m)=>{
        let routeId = m.route.id;
        results[routeId] = await m.resolve(async (handler)=>{
            let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return hasClientLoader ? handler(async ()=>{
                let { data: data } = await fetchAndDecode(args, [
                    routeId
                ]);
                return $622198e93806af9a$var$unwrapSingleFetchResult(data, routeId);
            }) : handler();
        });
    }));
    return results;
}
async function $622198e93806af9a$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true, isApiOnly = false, isSpaMode = false) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$622198e93806af9a$var$createDeferred());
    let singleFetchDfd = $622198e93806af9a$var$createDeferred();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            if (!m.shouldCallHandler(defaultShouldRevalidate)) {
                foundOptOutRoute ||= m.shouldRevalidateArgs != null && hasLoader;
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    results[routeId] = {
                        type: "data",
                        result: await handler(async ()=>{
                            let { data: data } = await fetchAndDecode(args, [
                                routeId
                            ]);
                            return $622198e93806af9a$var$unwrapSingleFetchResult(data, routeId);
                        })
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                results[routeId] = {
                    type: "data",
                    result: await handler(async ()=>{
                        return $622198e93806af9a$var$unwrapSingleFetchResult(await singleFetchDfd.promise, routeId);
                    })
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    if ((!router.state.initialized && router.state.navigation.state === "idle" && !isApiOnly && !isSpaMode || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data = await fetchAndDecode(args, targetRoutes);
            singleFetchDfd.resolve(data.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $622198e93806af9a$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $622198e93806af9a$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $622198e93806af9a$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch  {}
}
async function $622198e93806af9a$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $lMYnX.default)(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data } = await fetchAndDecode(args, [
                routeId
            ]);
            return $622198e93806af9a$var$unwrapSingleFetchResult(data, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $622198e93806af9a$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $622198e93806af9a$export$7b977381851b2c(reqUrl, extension, serverOrigin) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, serverOrigin ?? (typeof window === "undefined" ? "server://singlefetch/" : window.location.origin)) : new URL(reqUrl);
    if (serverOrigin && url.origin !== serverOrigin) url = new URL(url.pathname + url.search + url.hash, serverOrigin);
    if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
    else url.pathname = `${url.pathname}.${extension}`;
    return url;
}
function $622198e93806af9a$var$fetchAndDecodeViaTurboStream(fetchImplementation, serverOrigin) {
    return async (args, targetRoutes)=>{
        let { request: request } = args;
        let url = $622198e93806af9a$export$7b977381851b2c(request.url, "data", serverOrigin);
        if (request.method === "GET") {
            url = $622198e93806af9a$export$425969b7f98e2c9c(url);
            if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
        }
        let req = new Request(url, await (0, $k5jWQ.createRequestInit)(request));
        (0, $lMYnX.default)(args.unstable_initiator !== "static", "Static data strategy initiator used for a client data request");
        let fetchContext;
        if (args.unstable_initiator === "navigation") {
            (0, $lMYnX.default)(args.unstable_navigationType !== null, "Missing navigation type for a navigation data request");
            fetchContext = {
                type: "navigation",
                fetcherKey: args.fetcherKey,
                navigationType: args.unstable_navigationType
            };
        } else fetchContext = {
            type: args.unstable_initiator,
            fetcherKey: args.fetcherKey,
            navigationType: null
        };
        let res = await fetchImplementation(req, fetchContext);
        if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new (0, $vjGlj.ErrorResponseImpl)(res.status, res.statusText, await res.text());
        if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
            status: 202,
            data: {
                redirect: {
                    redirect: res.headers.get("X-Remix-Redirect"),
                    status: Number(res.headers.get("X-Remix-Status") || "302"),
                    revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                    reload: res.headers.get("X-Remix-Reload-Document") === "true",
                    replace: res.headers.get("X-Remix-Replace") === "true"
                }
            }
        };
        if ($622198e93806af9a$export$e35ccdcde387134d.has(res.status)) {
            let routes = {};
            if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
                data: void 0
            };
            return {
                status: res.status,
                data: {
                    routes: routes
                }
            };
        }
        (0, $lMYnX.default)(res.body, "No response body to decode");
        try {
            let decoded = await $622198e93806af9a$export$4023ad4ecd4126a2(res.body, window);
            let data;
            if (request.method === "GET") {
                let typed = decoded.value;
                if ($622198e93806af9a$export$60644022b8b46aaa in typed) data = {
                    redirect: typed[$622198e93806af9a$export$60644022b8b46aaa]
                };
                else data = {
                    routes: typed
                };
            } else {
                let typed = decoded.value;
                let routeId = targetRoutes?.[0];
                (0, $lMYnX.default)(routeId, "No routeId found for single fetch call decoding");
                if ("redirect" in typed) data = {
                    redirect: typed
                };
                else data = {
                    routes: {
                        [routeId]: typed
                    }
                };
            }
            return {
                status: res.status,
                data: data
            };
        } catch (cause) {
            throw new Error("Unable to decode turbo-stream response", {
                cause: cause
            });
        }
    };
}
function $622198e93806af9a$export$4023ad4ecd4126a2(body, global) {
    return (0, $2noQd.decode)(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && (0, $vjGlj.SUPPORTED_ERROR_TYPES).includes(name) && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data, status, statusText] = rest;
                    return {
                        value: new (0, $vjGlj.ErrorResponseImpl)(status, statusText, data)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$622198e93806af9a$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $622198e93806af9a$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace, status: status } = result.redirect;
        throw (0, $vjGlj.redirect)(location, {
            status: status,
            headers: {
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $622198e93806af9a$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $622198e93806af9a$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch  {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch  {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}

});
parcelRegister("2noQd", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $1bb0ffaffde76ed5$export$2f872c0f2117be69; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $GixHn = parcelRequire("GixHn");

var $k7X4z = parcelRequire("k7X4z");

var $50LHI = parcelRequire("50LHI");
//#region vendor/turbo-stream-v2/turbo-stream.ts
async function $1bb0ffaffde76ed5$export$2f872c0f2117be69(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new (0, $GixHn.Deferred)();
    const reader = readable.pipeThrough((0, $GixHn.createLineSplittingTransform)()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $1bb0ffaffde76ed5$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $1bb0ffaffde76ed5$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $1bb0ffaffde76ed5$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch  {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: (0, $50LHI.unflatten).call(this, line)
    };
}
async function $1bb0ffaffde76ed5$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case "P":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch  {
                        throw new SyntaxError();
                    }
                    const value = (0, $50LHI.unflatten).call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case "E":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch  {
                        throw new SyntaxError();
                    }
                    const value = (0, $50LHI.unflatten).call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $1bb0ffaffde76ed5$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    return new ReadableStream({
        async start (controller) {
            const id = await (0, $k7X4z.flatten).call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}\n`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]\n`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || /* @__PURE__ */ new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id = await (0, $k7X4z.flatten).call(encoder, resolved);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`P${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = /* @__PURE__ */ new Error("An unknown error occurred");
                                const id = await (0, $k7X4z.flatten).call(encoder, reason);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`E${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
}

});
parcelRegister("GixHn", function(module, exports) {

$parcel$export(module.exports, "Deferred", function () { return $07f24e84a4b3ed0b$export$85f6557964517f1a; });
$parcel$export(module.exports, "createLineSplittingTransform", function () { return $07f24e84a4b3ed0b$export$4786a9f20844482d; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/utils.ts
var $07f24e84a4b3ed0b$export$85f6557964517f1a = class {
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $07f24e84a4b3ed0b$export$4786a9f20844482d() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}

});

parcelRegister("k7X4z", function(module, exports) {

$parcel$export(module.exports, "flatten", function () { return $ea7248b012e4ebda$export$bffa455ba8c619a6; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/flatten.ts
const $ea7248b012e4ebda$var$TIME_LIMIT_MS = 1;
const $ea7248b012e4ebda$var$getNow = ()=>Date.now();
const $ea7248b012e4ebda$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $ea7248b012e4ebda$export$bffa455ba8c619a6(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return -7;
    if (input === null) return -5;
    if (Number.isNaN(input)) return -2;
    if (input === Number.POSITIVE_INFINITY) return -6;
    if (input === Number.NEGATIVE_INFINITY) return -3;
    if (input === 0 && 1 / input < 0) return -4;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $ea7248b012e4ebda$var$stringify.call(this, stack);
    return index;
}
async function $ea7248b012e4ebda$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $ea7248b012e4ebda$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return -7;
        if (value === null) return -5;
        if (Number.isNaN(value)) return -2;
        if (value === Number.POSITIVE_INFINITY) return -6;
        if (value === Number.NEGATIVE_INFINITY) return -3;
        if (value === 0 && 1 / value < 0) return -4;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $ea7248b012e4ebda$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $ea7248b012e4ebda$var$TIME_LIMIT_MS) {
            await $ea7248b012e4ebda$var$yieldToMain();
            lastYieldTime = $ea7248b012e4ebda$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["B","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = /* @__PURE__ */ new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["Y",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `-5`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input.length; i++)result += (i ? "," : "") + (i in input ? flattenValue(input[i]) : -1);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["D",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["U",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["R",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["S",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["S"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["M",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["M"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["P",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["E",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["N",{${partsForObj(input)}}]`;
                        else if ($ea7248b012e4ebda$var$isPlainObject(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = /* @__PURE__ */ new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = /* @__PURE__ */ new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
const $ea7248b012e4ebda$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $ea7248b012e4ebda$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $ea7248b012e4ebda$var$objectProtoNames;
}

});

parcelRegister("50LHI", function(module, exports) {

$parcel$export(module.exports, "unflatten", function () { return $3a61f4e6608ce99a$export$4315a2af848d75d7; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $vjGlj = parcelRequire("vjGlj");

var $GixHn = parcelRequire("GixHn");
//#region vendor/turbo-stream-v2/unflatten.ts
const $3a61f4e6608ce99a$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $3a61f4e6608ce99a$export$4315a2af848d75d7(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $3a61f4e6608ce99a$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $3a61f4e6608ce99a$var$hydrate.call(this, startIndex);
}
function $3a61f4e6608ce99a$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index, set] = stack.pop();
        switch(index){
            case -7:
                set(void 0);
                continue;
            case -5:
                set(null);
                continue;
            case -2:
                set(NaN);
                continue;
            case -6:
                set(Infinity);
                continue;
            case -3:
                set(-Infinity);
                continue;
            case -4:
                set(-0);
                continue;
        }
        $3a61f4e6608ce99a$var$validateIndex(index, values.length);
        if (hydrated[index]) {
            set(hydrated[index]);
            continue;
        }
        const value = values[index];
        if (!value || typeof value !== "object") {
            hydrated[index] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case "D":
                        set(hydrated[index] = new Date(b));
                        continue;
                    case "U":
                        set(hydrated[index] = new URL(b));
                        continue;
                    case "B":
                        set(hydrated[index] = BigInt(b));
                        continue;
                    case "R":
                        set(hydrated[index] = new RegExp(b, c));
                        continue;
                    case "Y":
                        set(hydrated[index] = Symbol.for(b));
                        continue;
                    case "S":
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case "M":
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case "N":
                        const obj = Object.create(null);
                        hydrated[index] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case "P":
                        $3a61f4e6608ce99a$var$validateIndex(b, values.length);
                        if (hydrated[b]) set(hydrated[index] = hydrated[b]);
                        else {
                            const d = new (0, $GixHn.Deferred)();
                            const promise = d.promise;
                            promise.status = "pending";
                            promise.then((value)=>{
                                promise.status = "fulfilled";
                                promise.value = value;
                            }, (reason)=>{
                                promise.status = "rejected";
                                promise.reason = reason;
                            });
                            deferred[b] = d;
                            set(hydrated[index] = promise);
                        }
                        continue;
                    case "E":
                        const [, message, errorType] = value;
                        let error = errorType && $3a61f4e6608ce99a$var$globalObj && (0, $vjGlj.SUPPORTED_ERROR_TYPES).includes(errorType) && errorType in $3a61f4e6608ce99a$var$globalObj && typeof $3a61f4e6608ce99a$var$globalObj[errorType] === "function" ? new $3a61f4e6608ce99a$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index] = error;
                        set(error);
                        continue;
                    case "Z":
                        $3a61f4e6608ce99a$var$validateIndex(b, values.length);
                        set(hydrated[index] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v)=>{
                                        r[i] = v;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result = plugin(value[0], ...r);
                                    if (result) {
                                        set(hydrated[index] = result.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== -1) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    Object.defineProperty(object, r[0], {
                        value: r[1],
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
function $3a61f4e6608ce99a$var$validateIndex(index, length) {
    if (!Number.isSafeInteger(index) || index < 0 || index >= length) throw new SyntaxError();
}

});


parcelRegister("k5jWQ", function(module, exports) {

$parcel$export(module.exports, "createRequestInit", function () { return $e9f3bf9149edaa2a$export$a30aa2a0fce6c468; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/data.ts
async function $e9f3bf9149edaa2a$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}

});


parcelRegister("5QqfD", function(module, exports) {

$parcel$export(module.exports, "warnOnce", function () { return $44162c0a9be5bee9$export$5b28268982f175ba; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/server-runtime/warnings.ts
const $44162c0a9be5bee9$var$alreadyWarned = {};
function $44162c0a9be5bee9$export$5b28268982f175ba(condition, message) {
    if (!condition && !$44162c0a9be5bee9$var$alreadyWarned[message]) {
        $44162c0a9be5bee9$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}

});

parcelRegister("ei6eN", function(module, exports) {

$parcel$export(module.exports, "isFogOfWarEnabled", function () { return $a67795ca06d23dae$export$741d98b28dbfd; });
$parcel$export(module.exports, "getPartialManifest", function () { return $a67795ca06d23dae$export$ae5150779dbcc11a; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $i4yVL = parcelRequire("i4yVL");

var $vjGlj = parcelRequire("vjGlj");

var $9yN5Z = parcelRequire("9yN5Z");

var $jHEir = parcelRequire("jHEir");
//#region lib/dom/ssr/fog-of-war.ts
const $a67795ca06d23dae$var$nextPaths = /* @__PURE__ */ new Set();
const $a67795ca06d23dae$var$discoveredPathsMaxSize = 1e3;
const $a67795ca06d23dae$var$discoveredPaths = /* @__PURE__ */ new Set();
const $a67795ca06d23dae$export$b5915cf27fa06b9f = 7680;
function $a67795ca06d23dae$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $a67795ca06d23dae$export$741d98b28dbfd(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr;
}
const $a67795ca06d23dae$var$MANIFEST_MATCH_COST_LIMIT = 5e4;
const $a67795ca06d23dae$var$MANIFEST_MATCH_COST_SEGMENT_THRESHOLD = 10;
function $a67795ca06d23dae$export$6b125d9215e726d(pathname, matchCost = 0) {
    let segmentCount = pathname.split("/").length - 1;
    return Math.max(segmentCount - 1, 0) * pathname.length + 1 > 7680 || segmentCount > $a67795ca06d23dae$var$MANIFEST_MATCH_COST_SEGMENT_THRESHOLD && segmentCount * matchCost > $a67795ca06d23dae$var$MANIFEST_MATCH_COST_LIMIT;
}
function $a67795ca06d23dae$export$ae5150779dbcc11a({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = router.match(path);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $a67795ca06d23dae$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename, fetchImplementation = (request)=>fetch(request), serverOrigin, isApiOnly = false) {
    if (!$a67795ca06d23dae$export$741d98b28dbfd(routeDiscovery, ssr)) return;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($a67795ca06d23dae$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $a67795ca06d23dae$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : (0, $i4yVL.createPath)(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal, fetchImplementation, serverOrigin, isApiOnly);
    };
}
function $a67795ca06d23dae$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode, fetchImplementation = (request)=>fetch(request), serverOrigin, isApiOnly = false) {
    $jHEir.useEffect(()=>{
        if (!$a67795ca06d23dae$export$741d98b28dbfd(routeDiscovery, ssr) || window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$a67795ca06d23dae$var$discoveredPaths.has(pathname)) $a67795ca06d23dae$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($a67795ca06d23dae$var$nextPaths.keys()).filter((path)=>{
                if ($a67795ca06d23dae$var$discoveredPaths.has(path)) {
                    $a67795ca06d23dae$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $a67795ca06d23dae$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes, void 0, fetchImplementation, serverOrigin, isApiOnly);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $a67795ca06d23dae$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery,
        fetchImplementation,
        serverOrigin,
        isApiOnly
    ]);
}
function $a67795ca06d23dae$export$251abd15fde24921(paths) {
    return paths.slice().sort().map((path)=>path.replace(/,/g, "%2C")).join(",");
}
function $a67795ca06d23dae$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : (0, $vjGlj.joinPaths)([
        basename,
        manifestPath
    ]);
}
const $a67795ca06d23dae$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
const $a67795ca06d23dae$var$MANIFEST_RELOAD_TIMEOUT = 5e3;
let $a67795ca06d23dae$var$pendingManifestReload;
async function $a67795ca06d23dae$export$2f7ce2790dc2d211(needsReload, version, errorReloadPath) {
    if ($a67795ca06d23dae$var$pendingManifestReload) return $a67795ca06d23dae$var$pendingManifestReload;
    if (!needsReload) {
        try {
            sessionStorage.removeItem($a67795ca06d23dae$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        return false;
    }
    if (!errorReloadPath) {
        console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
        return true;
    }
    let alreadyReloaded = false;
    try {
        alreadyReloaded = sessionStorage.getItem($a67795ca06d23dae$var$MANIFEST_VERSION_STORAGE_KEY) === version;
        if (!alreadyReloaded) sessionStorage.setItem($a67795ca06d23dae$var$MANIFEST_VERSION_STORAGE_KEY, version);
    } catch  {}
    if (alreadyReloaded) throw new Error("Unable to discover routes due to manifest version mismatch.");
    let rejectReload;
    let reloadPromise = new Promise((_, reject)=>{
        rejectReload = reject;
    });
    $a67795ca06d23dae$var$pendingManifestReload = reloadPromise;
    let failReload = ()=>{
        clearTimeout(timeout);
        window.removeEventListener("pageshow", onPageShow);
        $a67795ca06d23dae$var$pendingManifestReload = void 0;
        rejectReload(/* @__PURE__ */ new Error("Unable to discover routes due to manifest version mismatch."));
    };
    let timeout = setTimeout(failReload, $a67795ca06d23dae$var$MANIFEST_RELOAD_TIMEOUT);
    let onPageShow = (event)=>{
        if (event.persisted) failReload();
    };
    window.addEventListener("pageshow", onPageShow);
    try {
        window.location.href = errorReloadPath;
        console.warn("Detected manifest version mismatch, reloading...");
    } catch  {
        failReload();
    }
    return reloadPromise;
}
async function $a67795ca06d23dae$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal, fetchImplementation = (request)=>fetch(request), serverOrigin, isApiOnly = false) {
    paths = $a67795ca06d23dae$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", $a67795ca06d23dae$export$251abd15fde24921(paths));
    searchParams.set("version", manifest.version);
    let url = new URL($a67795ca06d23dae$export$bcb79c3deff01d56(manifestPath, basename), serverOrigin ?? window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > 7680) {
        $a67795ca06d23dae$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetchImplementation(new Request(url, {
            signal: signal
        }), {
            type: "manifest"
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        if (await $a67795ca06d23dae$export$2f7ce2790dc2d211(res.status === 204 && res.headers.has("X-Remix-Reload-Document"), manifest.version, errorReloadPath)) return;
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    if (signal?.aborted) return;
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$a67795ca06d23dae$var$addToFifoQueue(p, $a67795ca06d23dae$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, (0, $9yN5Z.createClientRoutes)(patches, routeModules, null, ssr, isSpaMode, parentId, void 0, void 0, isApiOnly)));
}
function $a67795ca06d23dae$var$addToFifoQueue(path, queue) {
    if (queue.size >= $a67795ca06d23dae$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        if (first !== void 0) queue.delete(first);
    }
    queue.add(path);
}
function $a67795ca06d23dae$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}

});
parcelRegister("9yN5Z", function(module, exports) {

$parcel$export(module.exports, "createClientRoutes", function () { return $6f5d5f661d062959$export$af76e85f27ba0229; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $vjGlj = parcelRequire("vjGlj");

var $lfSRY = parcelRequire("lfSRY");

var $lMYnX = parcelRequire("lMYnX");

var $67gn7 = parcelRequire("67gn7");

var $eIBmG = parcelRequire("eIBmG");

var $5vFNy = parcelRequire("5vFNy");

var $44hHm = parcelRequire("44hHm");

var $jHEir = parcelRequire("jHEir");
//#region lib/dom/ssr/routes.tsx
function $6f5d5f661d062959$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $6f5d5f661d062959$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component = $6f5d5f661d062959$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? (0, $44hHm.RemixRootDefaultHydrateFallback) : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $jHEir.createElement((0, $5vFNy.RemixRootDefaultErrorBoundary), {
            error: (0, $lfSRY.useRouteError)()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component ? {
            element: /* @__PURE__ */ $jHEir.createElement(routeModule.Layout, null, /* @__PURE__ */ $jHEir.createElement(Component, null))
        } : {
            Component: Component
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $jHEir.createElement(routeModule.Layout, null, /* @__PURE__ */ $jHEir.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $jHEir.createElement(routeModule.Layout, null, /* @__PURE__ */ $jHEir.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $6f5d5f661d062959$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $6f5d5f661d062959$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        (0, $lMYnX.default)(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$6f5d5f661d062959$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $6f5d5f661d062959$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $6f5d5f661d062959$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $6f5d5f661d062959$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $6f5d5f661d062959$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $6f5d5f661d062959$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let msg = `You are trying to call ${type === "action" ? "serverAction()" : "serverLoader()"} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new (0, $vjGlj.ErrorResponseImpl)(400, "Bad Request", new Error(msg), true);
    }
}
function $6f5d5f661d062959$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new (0, $vjGlj.ErrorResponseImpl)(405, "Method Not Allowed", new Error(msg), true);
}
function $6f5d5f661d062959$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $6f5d5f661d062959$var$groupRoutesByParentId(manifest), needsRevalidation, isApiOnly = false) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            (0, $lMYnX.default)(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $6f5d5f661d062959$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route) {
            if (route.clientActionModule) prefetchModule(route.clientActionModule);
            if (route.clientLoaderModule) prefetchModule(route.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? (0, $eIBmG.prefetchStyleLinks)(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$6f5d5f661d062959$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $6f5d5f661d062959$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                return await prefetchStylesAndCallHandler(async ()=>{
                    (0, $lMYnX.default)(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $6f5d5f661d062959$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
            };
            dataRoute.loader.hydrate = $6f5d5f661d062959$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode, isApiOnly);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    (0, $lMYnX.default)(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode && !isApiOnly) throw $6f5d5f661d062959$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $6f5d5f661d062959$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode && !isApiOnly) throw $6f5d5f661d062959$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $6f5d5f661d062959$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    (0, $lMYnX.default)(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $6f5d5f661d062959$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    (0, $lMYnX.default)(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $6f5d5f661d062959$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    (0, $lMYnX.default)(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $6f5d5f661d062959$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $6f5d5f661d062959$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation, isApiOnly);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $6f5d5f661d062959$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $6f5d5f661d062959$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? (0, $vjGlj.compilePath)(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $6f5d5f661d062959$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $6f5d5f661d062959$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = (0, $67gn7.loadRouteModule)(route, routeModules);
    let prefetchRouteCssPromise = (0, $eIBmG.prefetchRouteCss)(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        (0, $eIBmG.prefetchStyleLinks)(route, routeModule)
    ]);
    return {
        Component: $6f5d5f661d062959$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $6f5d5f661d062959$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    if (!(typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0)) return routeModule.default;
}
function $6f5d5f661d062959$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode, isApiOnly = false) {
    return isSpaMode && routeId !== "root" || isApiOnly && isSpaMode && hasLoader || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}

});
parcelRegister("5vFNy", function(module, exports) {

$parcel$export(module.exports, "RemixRootDefaultErrorBoundary", function () { return $4030453e79b65ebe$export$20b33acd14692c9; });
$parcel$export(module.exports, "BoundaryShell", function () { return $4030453e79b65ebe$export$cf8626ebc6a4ba63; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $vjGlj = parcelRequire("vjGlj");

var $koI43 = parcelRequire("koI43");

var $jHEir = parcelRequire("jHEir");
//#region lib/dom/ssr/errorBoundaries.tsx
var $4030453e79b65ebe$export$32e57f52df4b6e34 = class extends $jHEir.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $jHEir.createElement($4030453e79b65ebe$export$20b33acd14692c9, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
/**
* When app's don't provide a root level ErrorBoundary, we default to this.
*/ function $4030453e79b65ebe$export$20b33acd14692c9({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = (0, $koI43.useFrameworkContext)();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $jHEir.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ((0, $vjGlj.isRouteErrorResponse)(error)) return /* @__PURE__ */ $jHEir.createElement($4030453e79b65ebe$export$cf8626ebc6a4ba63, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $jHEir.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $jHEir.createElement($4030453e79b65ebe$export$cf8626ebc6a4ba63, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $jHEir.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $jHEir.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $4030453e79b65ebe$export$cf8626ebc6a4ba63({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = (0, $koI43.useFrameworkContext)();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $jHEir.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $jHEir.createElement("head", null, /* @__PURE__ */ $jHEir.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $jHEir.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $jHEir.createElement("title", null, title)), /* @__PURE__ */ $jHEir.createElement("body", null, /* @__PURE__ */ $jHEir.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $jHEir.createElement((0, $koI43.Scripts), null) : null)));
}

});

parcelRegister("44hHm", function(module, exports) {

$parcel$export(module.exports, "RemixRootDefaultHydrateFallback", function () { return $2f6543ab92586561$export$7e8143a7b6df36d9; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $5vFNy = parcelRequire("5vFNy");

var $koI43 = parcelRequire("koI43");

var $jHEir = parcelRequire("jHEir");
//#region lib/dom/ssr/fallback.tsx
function $2f6543ab92586561$export$7e8143a7b6df36d9() {
    let { nonce: nonce } = (0, $koI43.useFrameworkContext)();
    return /* @__PURE__ */ $jHEir.createElement((0, $5vFNy.BoundaryShell), {
        title: "Loading...",
        renderScripts: true
    }, null);
}

});




parcelRegister("lIBUZ", function(module, exports) {

$parcel$export(module.exports, "hydrationRouteProperties", function () { return $fcfb1ec8b2d531bd$export$e2fd2c03906469db; });
$parcel$export(module.exports, "Router", function () { return $fcfb1ec8b2d531bd$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Navigate", function () { return $fcfb1ec8b2d531bd$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Route", function () { return $fcfb1ec8b2d531bd$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $fcfb1ec8b2d531bd$export$3565eb3d00ca5a74; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $i4yVL = parcelRequire("i4yVL");

var $vjGlj = parcelRequire("vjGlj");

var $1PkTq = parcelRequire("1PkTq");

var $6WCgj = parcelRequire("6WCgj");

var $3uzJP = parcelRequire("3uzJP");

var $kKffe = parcelRequire("kKffe");

var $lfSRY = parcelRequire("lfSRY");

var $5QqfD = parcelRequire("5QqfD");

var $koI43 = parcelRequire("koI43");

var $jHEir = parcelRequire("jHEir");
//#region lib/components.tsx
const $fcfb1ec8b2d531bd$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
/**
* Create a new {@link DataRouter} that manages the application path using an
* in-memory [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack. Useful for non-browser environments without a DOM API.
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {MemoryRouterOpts.basename} opts.basename n/a
* @param {MemoryRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {MemoryRouterOpts.future} opts.future n/a
* @param {MemoryRouterOpts.getContext} opts.getContext n/a
* @param {MemoryRouterOpts.hydrationData} opts.hydrationData n/a
* @param {MemoryRouterOpts.initialEntries} opts.initialEntries n/a
* @param {MemoryRouterOpts.initialIndex} opts.initialIndex n/a
* @param {MemoryRouterOpts.instrumentations} opts.instrumentations n/a
* @param {MemoryRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @returns An initialized {@link DataRouter} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $fcfb1ec8b2d531bd$export$f30f7e456d254e83(routes, opts) {
    return (0, $6WCgj.createRouter)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $i4yVL.createMemoryHistory)({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        mapRouteProperties: (0, $vjGlj.defaultMapRouteProperties),
        hydrationRouteProperties: $fcfb1ec8b2d531bd$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $fcfb1ec8b2d531bd$var$Deferred = class {
    status = "pending";
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $fcfb1ec8b2d531bd$var$handleSkippedViewTransition(transition, document) {
    transition.ready.catch((reason)=>{
        if (!(document.visibilityState === "hidden" || typeof reason === "object" && reason !== null && "name" in reason && reason.name === "AbortError")) throw reason;
    });
}
/**
* Render the UI for the given {@link DataRouter}. This component should
* typically be at the top of an app's element tree. The router prop should
* be a single router instance created outside of the React tree. Avoid
* creating new routers during React renders/re-renders.
*
* ```tsx
* import { createBrowserRouter } from "react-router";
* import { RouterProvider } from "react-router/dom";
* import { createRoot } from "react-dom/client";
*
* const router = createBrowserRouter(routes);
* createRoot(document.getElementById("root")).render(
*   <RouterProvider router={router} />
* );
* ```
*
* <docs-info>Please note that this component is exported both from
* `react-router` and `react-router/dom` with the only difference being that the
* latter automatically wires up `react-dom`'s [`flushSync`](https://react.dev/reference/react-dom/flushSync)
* implementation. You _almost always_ want to use the version from
* `react-router/dom` unless you're running in a non-DOM environment.</docs-info>
*
*
* @public
* @category Data Routers
* @mode data
* @param props Props
* @param {RouterProviderProps.flushSync} props.flushSync n/a
* @param {RouterProviderProps.onError} props.onError n/a
* @param {RouterProviderProps.router} props.router n/a
* @param {RouterProviderProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router
*/ function $fcfb1ec8b2d531bd$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    useTransitions = (0, $3uzJP.useIsRSCRouterContext)() || useTransitions;
    let [_state, setStateImpl] = $jHEir.useState(router.state);
    let [state, setOptimisticState] = (0, $jHEir.useOptimistic)(_state);
    let lastState = $jHEir.useRef(state);
    let [pendingState, setPendingState] = $jHEir.useState();
    let [vtContext, setVtContext] = $jHEir.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $jHEir.useState();
    let [transition, setTransition] = $jHEir.useState();
    let [interruption, setInterruption] = $jHEir.useState();
    let fetcherData = $jHEir.useRef(/* @__PURE__ */ new Map());
    let handledErrors = $jHEir.useRef(/* @__PURE__ */ new WeakSet());
    let setState = $jHEir.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        lastState.current = newState;
        if (newErrors && newState.errors && (0, $6WCgj.clientErrors).has(newState.errors)) {
            if (handledErrors.current.has(newState.errors)) newErrors = null;
            else handledErrors.current.add(newState.errors);
        }
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: (0, $vjGlj.getRoutePattern)(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        (0, $5QqfD.warnOnce)(flushSync === false || reactDomFlushSyncImpl != null, "You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from \"react-router/dom\"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.");
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        (0, $5QqfD.warnOnce)(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $jHEir.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$fcfb1ec8b2d531bd$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            $fcfb1ec8b2d531bd$var$handleSkippedViewTransition(t, router.window.document);
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $jHEir.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $jHEir.useLayoutEffect(()=>{
        let errors = router.state.errors;
        let newErrors = errors ? (0, $6WCgj.clientErrors).get(errors) : null;
        if (lastState.current !== router.state || errors && newErrors && !handledErrors.current.has(errors)) setState(router.state, {
            deletedFetchers: [],
            flushSync: false,
            newErrors: newErrors ?? null
        });
    }, [
        router,
        setState
    ]);
    $jHEir.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $fcfb1ec8b2d531bd$var$Deferred());
    }, [
        vtContext
    ]);
    $jHEir.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $jHEir.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$fcfb1ec8b2d531bd$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            $fcfb1ec8b2d531bd$var$handleSkippedViewTransition(transition, router.window.document);
            transition.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $jHEir.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $jHEir.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $jHEir.useMemo(()=>{
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $jHEir.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    let dataRouterState = $jHEir.useMemo(()=>({
            historyAction: state.historyAction,
            location: state.location,
            matches: state.matches,
            initialized: state.initialized,
            renderFallback: state.renderFallback,
            restoreScrollPosition: state.restoreScrollPosition,
            preventScrollReset: state.preventScrollReset,
            blockers: state.blockers
        }), [
        state.historyAction,
        state.location,
        state.matches,
        state.initialized,
        state.renderFallback,
        state.restoreScrollPosition,
        state.preventScrollReset,
        state.blockers
    ]);
    let dataRouterNavigation = $jHEir.useMemo(()=>({
            navigation: state.navigation,
            revalidation: state.revalidation
        }), [
        state.navigation,
        state.revalidation
    ]);
    let dataRouterData = $jHEir.useMemo(()=>({
            loaderData: state.loaderData,
            actionData: state.actionData,
            errors: state.errors
        }), [
        state.loaderData,
        state.actionData,
        state.errors
    ]);
    let fetchersContext = $jHEir.useMemo(()=>({
            fetchers: state.fetchers,
            fetcherData: fetcherData.current
        }), [
        state.fetchers
    ]);
    return /* @__PURE__ */ $jHEir.createElement($jHEir.Fragment, null, /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.DataRouterContext).Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.DataRouterStateContext).Provider, {
        value: dataRouterState
    }, /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.DataRouterNavigationContext).Provider, {
        value: dataRouterNavigation
    }, /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.DataRouterDataContext).Provider, {
        value: dataRouterData
    }, /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.FetchersContext).Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.ViewTransitionContext).Provider, {
        value: vtContext
    }, /* @__PURE__ */ $jHEir.createElement($fcfb1ec8b2d531bd$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $jHEir.createElement($fcfb1ec8b2d531bd$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        state: state,
        isStatic: false,
        onError: onError
    })))))))), null);
}
function $fcfb1ec8b2d531bd$var$getOptimisticRouterState(currentState, newState) {
    return {
        ...currentState,
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
const $fcfb1ec8b2d531bd$var$MemoizedDataRoutes = $jHEir.memo($fcfb1ec8b2d531bd$export$699f06c8afb533c9);
function $fcfb1ec8b2d531bd$export$699f06c8afb533c9({ routes: routes, manifest: manifest, state: state, isStatic: isStatic, onError: onError }) {
    let dataRouterContext = $jHEir.useContext((0, $3uzJP.DataRouterContext));
    (0, $i4yVL.invariant)(dataRouterContext, "You must render this element inside a <DataRouterContext.Provider> element");
    let discoveryRuntime = $jHEir.useContext((0, $koI43.FrameworkContext))?.routeDiscoveryRuntime;
    $jHEir.useEffect(()=>{
        if (state.initialized) discoveryRuntime?.markReady();
    }, [
        state.initialized,
        discoveryRuntime
    ]);
    return (0, $lfSRY.useRoutesImpl)(routes, void 0, {
        router: dataRouterContext.router,
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores all entries in memory.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {MemoryRouterProps.basename} props.basename n/a
* @param {MemoryRouterProps.children} props.children n/a
* @param {MemoryRouterProps.initialEntries} props.initialEntries n/a
* @param {MemoryRouterProps.initialIndex} props.initialIndex n/a
* @param {MemoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative in-memory {@link Router | `<Router>`} for client-side
* routing.
*/ function $fcfb1ec8b2d531bd$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $jHEir.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $i4yVL.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jHEir.useState({
        action: history.action,
        location: history.location
    });
    let setState = $jHEir.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $jHEir.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $jHEir.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $jHEir.createElement($fcfb1ec8b2d531bd$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A component-based version of {@link useNavigate} to use in a
* [`React.Component` class](https://react.dev/reference/react/Component) where
* hooks cannot be used.
*
* It's recommended to avoid using this component in favor of {@link useNavigate}.
*
* @example
* <Navigate to="/tasks" />
*
* @public
* @category Components
* @param props Props
* @param {NavigateProps.relative} props.relative n/a
* @param {NavigateProps.replace} props.replace n/a
* @param {NavigateProps.state} props.state n/a
* @param {NavigateProps.to} props.to n/a
* @returns {void}
*
*/ function $fcfb1ec8b2d531bd$export$444b3ab0cb9aec40({ to: to, replace: replace, state: state, relative: relative }) {
    (0, $i4yVL.invariant)((0, $lfSRY.useInRouterContext)(), `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic, navigator: navigator } = $jHEir.useContext((0, $3uzJP.NavigationContext));
    (0, $i4yVL.warning)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $jHEir.useContext((0, $3uzJP.RouteContext));
    let { pathname: locationPathname } = (0, $lfSRY.useLocation)();
    let navigate = (0, $lfSRY.useNavigate)();
    let path = (0, $vjGlj.resolveTo)(to, (0, $vjGlj.getResolveToMatches)(matches), locationPathname, relative === "path");
    (0, $1PkTq.validateNavigationTarget)(typeof to === "string" ? to : (0, $i4yVL.createPath)(to), navigator.createHref(path), (0, $1PkTq.getNavigatorCurrentUrl)(navigator), "reject");
    let jsonPath = JSON.stringify(path);
    $jHEir.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
* Renders the matching child route of a parent route or nothing if no child
* route matches.
*
* @example
* import { Outlet } from "react-router";
*
* export default function SomeParent() {
*   return (
*     <div>
*       <h1>Parent Content</h1>
*       <Outlet />
*     </div>
*   );
* }
*
* @public
* @category Components
* @param props Props
* @param {OutletProps.context} props.context n/a
* @returns React element for the rendered outlet or `null` if no child route matches.
*/ function $fcfb1ec8b2d531bd$export$910ae8079b2c2852(props) {
    return (0, $lfSRY.useOutlet)(props.context);
}
/**
* Configures an element to render when a pattern matches the current location.
* It must be rendered within a {@link Routes} element. Note that these routes
* do not participate in data loading, actions, code splitting, or any other
* route module features.
*
* @example
* // Usually used in a declarative router
* function App() {
*   return (
*     <BrowserRouter>
*       <Routes>
*         <Route index element={<StepOne />} />
*         <Route path="step-2" element={<StepTwo />} />
*         <Route path="step-3" element={<StepThree />} />
*       </Routes>
*    </BrowserRouter>
*   );
* }
*
* // But can be used with a data router as well if you prefer the JSX notation
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @public
* @category Components
* @param props Props
* @param {PathRouteProps.action} props.action n/a
* @param {PathRouteProps.caseSensitive} props.caseSensitive n/a
* @param {PathRouteProps.Component} props.Component n/a
* @param {PathRouteProps.children} props.children n/a
* @param {PathRouteProps.element} props.element n/a
* @param {PathRouteProps.ErrorBoundary} props.ErrorBoundary n/a
* @param {PathRouteProps.errorElement} props.errorElement n/a
* @param {PathRouteProps.handle} props.handle n/a
* @param {PathRouteProps.HydrateFallback} props.HydrateFallback n/a
* @param {PathRouteProps.hydrateFallbackElement} props.hydrateFallbackElement n/a
* @param {PathRouteProps.id} props.id n/a
* @param {PathRouteProps.index} props.index n/a
* @param {PathRouteProps.lazy} props.lazy n/a
* @param {PathRouteProps.loader} props.loader n/a
* @param {PathRouteProps.path} props.path n/a
* @param {PathRouteProps.shouldRevalidate} props.shouldRevalidate n/a
* @returns {void}
*/ function $fcfb1ec8b2d531bd$export$e7b0ac011bb776c6(props) {
    (0, $i4yVL.invariant)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
* Provides location context for the rest of the app.
*
* Note: You usually won't render a `<Router>` directly. Instead, you'll render a
* router that is more specific to your environment such as a {@link BrowserRouter}
* in web browsers or a {@link ServerRouter} for server rendering.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {RouterProps.basename} props.basename n/a
* @param {RouterProps.children} props.children n/a
* @param {RouterProps.location} props.location n/a
* @param {RouterProps.navigationType} props.navigationType n/a
* @param {RouterProps.navigator} props.navigator n/a
* @param {RouterProps.static} props.static n/a
* @param {RouterProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router or `null` if the location does
* not match the {@link props.basename}
*/ function $fcfb1ec8b2d531bd$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP", navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    (0, $i4yVL.invariant)(!(0, $lfSRY.useInRouterContext)(), "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $jHEir.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = (0, $i4yVL.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $jHEir.useMemo(()=>{
        let trailingPathname = (0, $vjGlj.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    (0, $i4yVL.warning)(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.NavigationContext).Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.LocationContext).Provider, {
        children: children,
        value: locationContext
    }));
}
/**
* Renders a branch of {@link Route | `<Route>`s} that best matches the current
* location. Note that these routes do not participate in [data loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action), code splitting, or
* any other [route module](../../start/framework/route-module) features.
*
* @example
* import { Route, Routes } from "react-router";
*
* <Routes>
*   <Route index element={<StepOne />} />
*   <Route path="step-2" element={<StepTwo />} />
*   <Route path="step-3" element={<StepThree />} />
* </Routes>
*
* @public
* @category Components
* @param props Props
* @param {RoutesProps.children} props.children n/a
* @param {RoutesProps.location} props.location n/a
* @returns React element for the rendered routes or `null` if no route matches
*/ function $fcfb1ec8b2d531bd$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return (0, $lfSRY.useRoutes)($fcfb1ec8b2d531bd$export$16da398f5434bdec(children), location);
}
/**
* Used to render promise values with automatic error handling.
*
* **Note:** `<Await>` expects to be rendered inside a [`<React.Suspense>`](https://react.dev/reference/react/Suspense)
*
* Pass `unstable_promise` instead of `resolve` to opt into React's
* [`use()`](https://react.dev/reference/react/use) implementation. With
* `unstable_promise`, `errorElement` handles promise rejections, while errors
* thrown by children bubble to the nearest React error boundary.
*
* In React Server Components, `resolve` already has this error-handling behavior:
* `errorElement` handles only input rejections, while child render errors
* propagate to the surrounding error boundary. Both props accept promise-like
* values without modifying the source promise. Both props treat a falsy
* `errorElement` as absent and propagate the rejection. Pass an empty fragment
* to handle a rejection without rendering any content.
*
* <docs-warning>The `unstable_promise` prop is experimental and may change in
* minor or patch releases.</docs-warning>
*
* @example
* import { Await, useLoaderData } from "react-router";
*
* export async function loader() {
*   // not awaited
*   const reviews = getReviews();
*   // awaited (blocks the transition)
*   const book = await fetch("/api/book").then((res) => res.json());
*   return { book, reviews };
* }
*
* function Book() {
*   const { book, reviews } = useLoaderData();
*   return (
*     <div>
*       <h1>{book.title}</h1>
*       <p>{book.description}</p>
*       <React.Suspense fallback={<ReviewsSkeleton />}>
*         <Await
*           resolve={reviews}
*           errorElement={
*             <div>Could not load reviews 😬</div>
*           }
*           children={(resolvedReviews) => (
*             <Reviews items={resolvedReviews} />
*           )}
*         />
*       </React.Suspense>
*     </div>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {AwaitProps.children} props.children n/a
* @param {AwaitProps.errorElement} props.errorElement n/a
* @param {AwaitProps.resolve} props.resolve n/a
* @param props.unstable_promise A promise (or value) to read using React's `use()`
* API in client components. Accepts promise-like values without modifying the
* source promise. Pass exactly one of `unstable_promise` or `resolve`.
* @returns React element for the rendered awaited value
*/ function $fcfb1ec8b2d531bd$export$6ddabde395c8c576(props) {
    (0, $i4yVL.invariant)("resolve" in props !== "unstable_promise" in props, "<Await> requires exactly one of `resolve` or `unstable_promise`");
    let { children: children, errorElement: errorElement } = props;
    let dataRouterContext = $jHEir.useContext((0, $3uzJP.DataRouterContext));
    let dataRouterStateContext = $jHEir.useContext((0, $3uzJP.DataRouterStateContext));
    let onError = $jHEir.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: (0, $vjGlj.getRoutePattern)(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    if ("unstable_promise" in props) return /* @__PURE__ */ $jHEir.createElement($fcfb1ec8b2d531bd$var$AwaitPromise, {
        value: props.unstable_promise,
        errorElement: errorElement,
        onError: onError
    }, children);
    return /* @__PURE__ */ $jHEir.createElement($fcfb1ec8b2d531bd$var$AwaitErrorBoundary, {
        resolve: props.resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $jHEir.createElement($fcfb1ec8b2d531bd$var$ResolveAwait, null, children));
}
function $fcfb1ec8b2d531bd$var$AwaitPromise({ value: value, children: children, errorElement: errorElement, onError: onError }) {
    let result = value != null && (typeof value === "object" || typeof value === "function") && "then" in value && typeof value.then === "function" ? $jHEir.use((0, $kKffe.getAwaitPromise)(value, onError)) : {
        status: "fulfilled",
        value: value
    };
    if (result.status === "rejected" && !errorElement) throw result.reason;
    return /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.AwaitContext).Provider, {
        value: result
    }, result.status === "rejected" ? errorElement : /* @__PURE__ */ $jHEir.createElement($fcfb1ec8b2d531bd$var$ResolveAwait, null, children));
}
var $fcfb1ec8b2d531bd$var$AwaitErrorBoundary = class extends $jHEir.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0;
        if (!(resolve instanceof Promise)) {
            status = 1;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 : "_data" in promise ? 1 : 0;
        } else {
            status = 0;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            let result = (0, $kKffe.getPromiseResult)(resolve);
            if (result) {
                promise = resolve;
                if (result.status === "fulfilled") {
                    status = 1;
                    Object.defineProperty(resolve, "_data", {
                        get: ()=>result.value
                    });
                } else {
                    status = 2;
                    Object.defineProperty(resolve, "_error", {
                        get: ()=>result.reason
                    });
                    Promise.resolve(resolve).catch((reason)=>{
                        try {
                            this.props.onError?.(reason);
                        } catch (error) {
                            console.error("<Await> caught the following error in onError", error);
                        }
                    });
                }
            } else promise = Promise.resolve(resolve).then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 && !errorElement) throw promise._error;
        if (status === 2) return /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.AwaitContext).Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1) return /* @__PURE__ */ $jHEir.createElement((0, $3uzJP.AwaitContext).Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $fcfb1ec8b2d531bd$var$ResolveAwait({ children: children }) {
    let data = (0, $lfSRY.useAsyncValue)();
    let toRender = typeof children === "function" ? children(data) : children;
    return /* @__PURE__ */ $jHEir.createElement($jHEir.Fragment, null, toRender);
}
/**
* Creates a route config from a React "children" object, which is usually
* either a `<Route>` element or an array of them. Used internally by
* `<Routes>` to create a route config from its children.
*
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ function $fcfb1ec8b2d531bd$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $jHEir.Children.forEach(children, (element, index)=>{
        if (!$jHEir.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $jHEir.Fragment) {
            routes.push.apply(routes, $fcfb1ec8b2d531bd$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        (0, $i4yVL.invariant)(element.type === $fcfb1ec8b2d531bd$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        let props = element.props;
        (0, $i4yVL.invariant)(!props.index || !props.children, "An index route cannot have child routes.");
        let route = {
            id: props.id || treePath.join("-"),
            caseSensitive: props.caseSensitive,
            element: props.element,
            Component: props.Component,
            index: props.index,
            path: props.path,
            middleware: props.middleware,
            loader: props.loader,
            action: props.action,
            hydrateFallbackElement: props.hydrateFallbackElement,
            HydrateFallback: props.HydrateFallback,
            errorElement: props.errorElement,
            ErrorBoundary: props.ErrorBoundary,
            shouldRevalidate: props.shouldRevalidate,
            handle: props.handle,
            lazy: props.lazy
        };
        if (props.children) route.children = $fcfb1ec8b2d531bd$export$16da398f5434bdec(props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
* Create route objects from JSX elements instead of arrays of objects.
*
* @example
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @name createRoutesFromElements
* @public
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* This is used for internal recursion and is not intended to be used by the
* application developer.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ const $fcfb1ec8b2d531bd$export$9b5b6d122dea0c88 = $fcfb1ec8b2d531bd$export$16da398f5434bdec;
/**
* Renders the result of {@link matchRoutes} into a React element.
*
* @public
* @category Utils
* @param matches The array of {@link RouteMatch | route matches} to render
* @returns A React element that renders the matched routes or `null` if no matches
*/ function $fcfb1ec8b2d531bd$export$daf73786167a7f72(matches) {
    return (0, $lfSRY._renderMatches)(matches);
}
function $fcfb1ec8b2d531bd$var$useRouteComponentProps() {
    return {
        params: (0, $lfSRY.useParams)(),
        loaderData: (0, $lfSRY.useLoaderData)(),
        actionData: (0, $lfSRY.useActionData)(),
        matches: (0, $lfSRY.useMatches)()
    };
}
function $fcfb1ec8b2d531bd$export$6c4f3826290c37af({ children: children }) {
    const props = $fcfb1ec8b2d531bd$var$useRouteComponentProps();
    return $jHEir.cloneElement(children, props);
}
function $fcfb1ec8b2d531bd$export$1a5de91a5c3255e0(Component) {
    return function WithComponentProps() {
        const props = $fcfb1ec8b2d531bd$var$useRouteComponentProps();
        return $jHEir.createElement(Component, props);
    };
}
function $fcfb1ec8b2d531bd$var$useHydrateFallbackProps() {
    return {
        params: (0, $lfSRY.useParams)(),
        loaderData: (0, $lfSRY.useLoaderData)(),
        actionData: (0, $lfSRY.useActionData)()
    };
}
function $fcfb1ec8b2d531bd$export$f8cff34f39c1932a({ children: children }) {
    const props = $fcfb1ec8b2d531bd$var$useHydrateFallbackProps();
    return $jHEir.cloneElement(children, props);
}
function $fcfb1ec8b2d531bd$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps() {
        const props = $fcfb1ec8b2d531bd$var$useHydrateFallbackProps();
        return $jHEir.createElement(HydrateFallback, props);
    };
}
function $fcfb1ec8b2d531bd$var$useErrorBoundaryProps() {
    return {
        params: (0, $lfSRY.useParams)(),
        loaderData: (0, $lfSRY.useLoaderData)(),
        actionData: (0, $lfSRY.useActionData)(),
        error: (0, $lfSRY.useRouteError)()
    };
}
function $fcfb1ec8b2d531bd$export$e5afde5c4b6d747b({ children: children }) {
    const props = $fcfb1ec8b2d531bd$var$useErrorBoundaryProps();
    return $jHEir.cloneElement(children, props);
}
function $fcfb1ec8b2d531bd$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps() {
        const props = $fcfb1ec8b2d531bd$var$useErrorBoundaryProps();
        return $jHEir.createElement(ErrorBoundary, props);
    };
}

});
parcelRegister("kKffe", function(module, exports) {

$parcel$export(module.exports, "getPromiseResult", function () { return $f1a3edc8ec7db205$export$7c2250e1d8e9bb1b; });
$parcel$export(module.exports, "getAwaitPromise", function () { return $f1a3edc8ec7db205$export$be7e832cbe7a26ed; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/await.ts
function $f1a3edc8ec7db205$export$7c2250e1d8e9bb1b(promise) {
    if (promise.status === "fulfilled") return {
        status: "fulfilled",
        value: promise.value
    };
    if (promise.status === "rejected") return {
        status: "rejected",
        reason: promise.reason
    };
}
let $f1a3edc8ec7db205$var$awaitPromises = /* @__PURE__ */ new WeakMap();
function $f1a3edc8ec7db205$export$be7e832cbe7a26ed(source, onError) {
    let cached = $f1a3edc8ec7db205$var$awaitPromises.get(source);
    if (!cached) {
        cached = {
            promise: Promise.resolve(source).then((value)=>settle({
                    status: "fulfilled",
                    value: value
                }), (reason)=>{
                let result = settle({
                    status: "rejected",
                    reason: reason
                });
                try {
                    cached.onError(reason);
                } catch (error) {
                    console.error("<Await> caught the following error in onError", error);
                }
                return result;
            }),
            onError: onError
        };
        $f1a3edc8ec7db205$var$awaitPromises.set(source, cached);
    } else cached.onError = onError;
    function settle(result) {
        Object.assign(cached.promise, {
            status: "fulfilled",
            value: result
        });
        return result;
    }
    let result = $f1a3edc8ec7db205$export$7c2250e1d8e9bb1b(source);
    if (result) settle(result);
    return cached.promise;
}

});


parcelRegister("6quj3", function(module, exports) {

$parcel$export(module.exports, "shouldProcessLinkClick", function () { return $4adcadfaa5427018$export$4c2d35dce1b682e; });
$parcel$export(module.exports, "createSearchParams", function () { return $4adcadfaa5427018$export$a2e4e2dcc7b1f22f; });
$parcel$export(module.exports, "getSearchParamsForLocation", function () { return $4adcadfaa5427018$export$4370c962fe3096e6; });
$parcel$export(module.exports, "getFormSubmissionInfo", function () { return $4adcadfaa5427018$export$80917616746b9ab4; });
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $i4yVL = parcelRequire("i4yVL");

var $vjGlj = parcelRequire("vjGlj");
const $4adcadfaa5427018$var$defaultEncType = "application/x-www-form-urlencoded";
function $4adcadfaa5427018$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $4adcadfaa5427018$var$isButtonElement(object) {
    return $4adcadfaa5427018$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $4adcadfaa5427018$var$isFormElement(object) {
    return $4adcadfaa5427018$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $4adcadfaa5427018$var$isInputElement(object) {
    return $4adcadfaa5427018$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $4adcadfaa5427018$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $4adcadfaa5427018$export$4c2d35dce1b682e(event, target) {
    return event.button === 0 && (!target || target === "_self") && !$4adcadfaa5427018$var$isModifiedEvent(event);
}
/**
* Creates a URLSearchParams object using the given initializer.
*
* This is identical to `new URLSearchParams(init)` except it also supports
* arrays as values in the object form of the initializer instead of just
* strings. This is convenient when you need multiple values for a given key,
* but don't want to use an array initializer.
*
* @example
* // Instead of:
* let searchParams = new URLSearchParams([
*   ["sort", "name"],
*   ["sort", "price"],
* ]);
*
* // You can do:
* let searchParams = createSearchParams({
*   sort: ["name", "price"],
* });
*
* @public
* @category Utils
* @param init The value used to initialize the URL search parameters.
* @returns A URLSearchParams object containing the initialized search
* parameters.
*/ function $4adcadfaa5427018$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $4adcadfaa5427018$export$4370c962fe3096e6(locationSearch, defaultSearchParams) {
    let searchParams = $4adcadfaa5427018$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
let $4adcadfaa5427018$var$_formDataSupportsSubmitter = null;
function $4adcadfaa5427018$var$isFormDataSubmitterSupported() {
    if ($4adcadfaa5427018$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), 0);
        $4adcadfaa5427018$var$_formDataSupportsSubmitter = false;
    } catch  {
        $4adcadfaa5427018$var$_formDataSupportsSubmitter = true;
    }
    return $4adcadfaa5427018$var$_formDataSupportsSubmitter;
}
const $4adcadfaa5427018$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $4adcadfaa5427018$var$getFormEncType(encType) {
    if (encType != null && !$4adcadfaa5427018$var$supportedFormEncTypes.has(encType)) {
        (0, $i4yVL.warning)(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$4adcadfaa5427018$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $4adcadfaa5427018$export$80917616746b9ab4(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($4adcadfaa5427018$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? (0, $vjGlj.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || "get";
        encType = $4adcadfaa5427018$var$getFormEncType(target.getAttribute("enctype")) || $4adcadfaa5427018$var$defaultEncType;
        formData = new FormData(target);
    } else if ($4adcadfaa5427018$var$isButtonElement(target) || $4adcadfaa5427018$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $vjGlj.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || "get";
        encType = $4adcadfaa5427018$var$getFormEncType(target.getAttribute("formenctype")) || $4adcadfaa5427018$var$getFormEncType(form.getAttribute("enctype")) || $4adcadfaa5427018$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$4adcadfaa5427018$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($4adcadfaa5427018$var$isHtmlElement(target)) throw new Error("Cannot submit element that is not <form>, <button>, or <input type=\"submit|image\">");
    else {
        method = "get";
        action = null;
        encType = $4adcadfaa5427018$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}

});


parcelRegister("e4aOX", function(module, exports) {

$parcel$export(module.exports, "AuthProvider", function () { return $2a32699379bab0aa$export$87091915187a1a85; });
$parcel$export(module.exports, "useAuth", function () { return $2a32699379bab0aa$export$1d39dc5b47e56ff0; });

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $zs3Np = parcelRequire("zs3Np");
const $2a32699379bab0aa$var$AuthContext = /*#__PURE__*/ (0, $jHEir.createContext)(undefined);
const $2a32699379bab0aa$var$parseJwt = (token)=>{
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        const decoded = JSON.parse(jsonPayload);
        // Enforce required fields
        if (!decoded.sub || !decoded.id) return null;
        return {
            // Managed-account tokens retain the manager as `sub` for audit,
            // while API/market-data state must be keyed by the effective user.
            id: decoded.acting_as_user_id || decoded.id,
            username: decoded.acting_as_username || decoded.sub,
            // JWT claims provide only a provisional cache identity. Permissions
            // and profile fields always come from the authenticated /me endpoint.
            role: 'viewer',
            is_active: true
        };
    } catch  {
        return null;
    }
};
const $2a32699379bab0aa$export$87091915187a1a85 = ({ children: children })=>{
    // Decode only the effective identity synchronously so tenant-scoped query
    // caches start under the right key; profile and role are refreshed below.
    const [token, setToken] = (0, $jHEir.useState)(()=>localStorage.getItem('token'));
    const [user, setUser] = (0, $jHEir.useState)(()=>{
        const persistedToken = localStorage.getItem('token');
        return persistedToken ? $2a32699379bab0aa$var$parseJwt(persistedToken) : null;
    });
    const [isUserLoading, setIsUserLoading] = (0, $jHEir.useState)(()=>!!localStorage.getItem('token'));
    const [userProfileError, setUserProfileError] = (0, $jHEir.useState)(null);
    const [profileRefreshKey, setProfileRefreshKey] = (0, $jHEir.useState)(0);
    const isAuthenticated = !!token;
    (0, $jHEir.useEffect)(()=>{
        if (token) {
            localStorage.setItem('token', token);
            setIsUserLoading(true);
            setUserProfileError(null);
            setUser((currentUser)=>currentUser || $2a32699379bab0aa$var$parseJwt(token));
            const controller = new AbortController();
            (0, $zs3Np.tradingApi).getCurrentUser(controller.signal).then((currentUser)=>setUser(currentUser)).catch((error)=>{
                if (!controller.signal.aborted) {
                    setUser(null);
                    setUserProfileError(error instanceof Error ? error.message : 'Unable to load the account profile.');
                    console.warn('Failed to load authenticated user profile:', error);
                }
            }).finally(()=>{
                if (!controller.signal.aborted) setIsUserLoading(false);
            });
            return ()=>controller.abort();
        } else {
            localStorage.removeItem('token');
            setUser(null);
            setIsUserLoading(false);
            setUserProfileError(null);
        }
    }, [
        token,
        profileRefreshKey
    ]);
    const login = (newToken)=>{
        localStorage.setItem('token', newToken);
        setUser($2a32699379bab0aa$var$parseJwt(newToken));
        setIsUserLoading(true);
        setUserProfileError(null);
        setProfileRefreshKey((current)=>current + 1);
        setToken(newToken);
    };
    const refreshUserProfile = ()=>{
        setUser(null);
        setUserProfileError(null);
        setIsUserLoading(true);
        setProfileRefreshKey((current)=>current + 1);
    };
    const logout = ()=>{
        localStorage.removeItem('token');
        setToken(null);
        setUser(null);
        setIsUserLoading(false);
        setUserProfileError(null);
        // Force full reload/redirect to clear state
        window.location.href = '/login';
    };
    return /*#__PURE__*/ (0, $eHRxX.jsx)($2a32699379bab0aa$var$AuthContext.Provider, {
        value: {
            token: token,
            user: user,
            isAuthenticated: isAuthenticated,
            isUserLoading: isUserLoading,
            userProfileError: userProfileError,
            login: login,
            logout: logout,
            refreshUserProfile: refreshUserProfile
        },
        children: children
    });
};
const $2a32699379bab0aa$export$1d39dc5b47e56ff0 = ()=>{
    const context = (0, $jHEir.useContext)($2a32699379bab0aa$var$AuthContext);
    if (context === undefined) throw new Error('useAuth must be used within an AuthProvider');
    return context;
};

});
parcelRegister("zs3Np", function(module, exports) {

$parcel$export(module.exports, "tradingApi", function () { return $c3a108990a9b4d6a$export$9fce83b5ea9fffcd; });
// API service for fetching data from the IB Trading System API

var $ymHgh = parcelRequire("ymHgh");

var $9Xewf = parcelRequire("9Xewf");

var $cYjmz = parcelRequire("cYjmz");

var $cWYaq = parcelRequire("cWYaq");

var $bETVs = parcelRequire("bETVs");

var $miuea = parcelRequire("miuea");

var $dA9Ja = parcelRequire("dA9Ja");

var $5qOs9 = parcelRequire("5qOs9");

var $bNcI0 = parcelRequire("bNcI0");

var $8iag5 = parcelRequire("8iag5");

var $eWVKm = parcelRequire("eWVKm");

var $gjf37 = parcelRequire("gjf37");

var $gxTjb = parcelRequire("gxTjb");
class $c3a108990a9b4d6a$var$TradingApiService {
    constructor(baseUrl = (0, $ymHgh.API_BASE_URL)){
        this.accountsApi = new (0, $9Xewf.AccountsApiService)(baseUrl);
        this.authApi = new (0, $cYjmz.AuthApiService)(baseUrl);
        this.backtestsApi = new (0, $cWYaq.BacktestsApiService)(baseUrl);
        this.dataApi = new (0, $bETVs.DataApiService)(baseUrl);
        this.logsApi = new (0, $miuea.LogsApiService)(baseUrl);
        this.managedAccountsApi = new (0, $dA9Ja.ManagedAccountsApiService)(baseUrl);
        this.marketApi = new (0, $5qOs9.MarketApiService)(baseUrl);
        this.notificationsApi = new (0, $bNcI0.NotificationsApiService)(baseUrl);
        this.ordersApi = new (0, $8iag5.OrdersApiService)(baseUrl);
        this.strategiesApi = new (0, $eWVKm.StrategiesApiService)(baseUrl);
        this.systemApi = new (0, $gjf37.SystemApiService)(baseUrl);
        this.userAdministrationApi = new (0, $gxTjb.UserAdministrationApiService)(baseUrl);
    }
    async login(username, password) {
        return this.authApi.login(username, password);
    }
    async signup(email, password, role = 'trader', firstName, lastName, isCompany, companyName) {
        return this.authApi.signup(email, password, role, firstName, lastName, isCompany, companyName);
    }
    async getRegistrationStatus() {
        return this.authApi.getRegistrationStatus();
    }
    async joinWaitlist(email, firstName, lastName) {
        return this.authApi.joinWaitlist(email, firstName, lastName);
    }
    // --- Onboarding ---
    async sendInvite(userId) {
        return this.authApi.sendInvite(userId);
    }
    async activateUser(userId) {
        return this.authApi.activateUser(userId);
    }
    async verifyInvite(token) {
        return this.authApi.verifyInvite(token);
    }
    async setupAccount(token, password) {
        return this.authApi.setupAccount(token, password);
    }
    async getUsers() {
        return this.userAdministrationApi.getUsers();
    }
    async adminCreateUser(user) {
        return this.userAdministrationApi.adminCreateUser(user);
    }
    async adminUpdateUser(userId, user) {
        return this.userAdministrationApi.adminUpdateUser(userId, user);
    }
    async deleteUser(userId) {
        return this.userAdministrationApi.deleteUser(userId);
    }
    async getUserDetails(userId) {
        return this.userAdministrationApi.getUserDetails(userId);
    }
    async adminConfigureUserGateway(userId, config) {
        return this.userAdministrationApi.adminConfigureUserGateway(userId, config);
    }
    async adminControlUserGateway(userId, gatewayId, action) {
        return this.userAdministrationApi.adminControlUserGateway(userId, gatewayId, action);
    }
    async adminActivateUserGateway(userId, gatewayId) {
        return this.userAdministrationApi.adminActivateUserGateway(userId, gatewayId);
    }
    async adminDeleteUserGateway(userId, gatewayId) {
        return this.userAdministrationApi.adminDeleteUserGateway(userId, gatewayId);
    }
    async getPortfolio() {
        return this.accountsApi.getPortfolio();
    }
    async getPositions() {
        return this.accountsApi.getPositions();
    }
    async getHistoricalData(symbol, timeframe, duration, source = 'auto', signal) {
        return this.marketApi.getHistoricalData(symbol, timeframe, duration, source, signal);
    }
    async getMarketStatus() {
        return this.marketApi.getMarketStatus();
    }
    async getCurrentUser(signal) {
        return this.authApi.getCurrentUser(signal);
    }
    async getStrategyDescriptionTags() {
        return this.accountsApi.getStrategyDescriptionTags();
    }
    async createStrategyDescriptionTag(payload) {
        return this.accountsApi.createStrategyDescriptionTag(payload);
    }
    async updateStrategyDescriptionTag(tagId, payload) {
        return this.accountsApi.updateStrategyDescriptionTag(tagId, payload);
    }
    async deleteStrategyDescriptionTag(tagId) {
        return this.accountsApi.deleteStrategyDescriptionTag(tagId);
    }
    async updatePositionStrategyTags(positionKey, tagIds) {
        return this.accountsApi.updatePositionStrategyTags(positionKey, tagIds);
    }
    async updatePositionCustomStrategy(positionKey, strategyName) {
        return this.accountsApi.updatePositionCustomStrategy(positionKey, strategyName);
    }
    async updatePositionMetadata(positionKey, strategyName, tagIds) {
        return this.accountsApi.updatePositionMetadata(positionKey, strategyName, tagIds);
    }
    async closePosition(symbol, secType, contract) {
        return this.accountsApi.closePosition(symbol, secType, contract);
    }
    async controlIBGateway(action, gatewayId) {
        return this.systemApi.controlIBGateway(action, gatewayId);
    }
    async getOpenOrders(page = 1, pageSize = 5, secType) {
        return this.ordersApi.getOpenOrders(page, pageSize, secType);
    }
    async getFilledOrdersToday(page = 1, pageSize = 5, secType) {
        return this.ordersApi.getFilledOrdersToday(page, pageSize, secType);
    }
    async cancelOrder(orderId) {
        return this.ordersApi.cancelOrder(orderId);
    }
    async modifyOrder(orderId, order) {
        return this.ordersApi.modifyOrder(orderId, order);
    }
    async getTradeLogs(page = 1, pageSize = 50, filters = {}) {
        return this.logsApi.getTradeLogs(page, pageSize, filters);
    }
    async getRecentLogs(maxLines = 100, levelFilter, logFile = "all") {
        return this.logsApi.getRecentLogs(maxLines, levelFilter, logFile);
    }
    async getSecurityEvents(filters = {}) {
        return this.logsApi.getSecurityEvents(filters);
    }
    async exportSecurityEvents(filters = {}) {
        return this.logsApi.exportSecurityEvents(filters);
    }
    async getSecurityAlertSettings() {
        return this.logsApi.getSecurityAlertSettings();
    }
    async updateSecurityAlertSettings(settings) {
        return this.logsApi.updateSecurityAlertSettings(settings);
    }
    // Generic strategy status method (for backward compatibility)
    async getStrategyStatus() {
        return this.strategiesApi.getStrategyStatus();
    }
    // ON strategy specific methods
    async getONStrategyStatus() {
        return this.strategiesApi.getONStrategyStatus();
    }
    async getONPositions() {
        return this.strategiesApi.getONPositions();
    }
    // ORB strategy specific methods
    async getORBStrategyStatus() {
        return this.strategiesApi.getORBStrategyStatus();
    }
    async getORBPositions() {
        return this.strategiesApi.getORBPositions();
    }
    // All strategies overview
    async getAllStrategiesStatus() {
        return this.strategiesApi.getAllStrategiesStatus();
    }
    async getSystemStatus() {
        return this.systemApi.getSystemStatus();
    }
    async getTradingSignal(symbol) {
        return this.strategiesApi.getTradingSignal(symbol);
    }
    async getMarketAnalysis(symbol) {
        return this.strategiesApi.getMarketAnalysis(symbol);
    }
    // Generic strategy status with parameter
    async getStrategyStatusByName(strategyName) {
        return this.strategiesApi.getStrategyStatusByName(strategyName);
    }
    async getNQMMStrategyStatus() {
        return this.strategiesApi.getNQMMStrategyStatus();
    }
    async getNQMMPositions() {
        return this.strategiesApi.getNQMMPositions();
    }
    async getNQMMPreviousPositions() {
        return this.strategiesApi.getNQMMPreviousPositions();
    }
    async addNQMMPreviousPosition(position) {
        return this.strategiesApi.addNQMMPreviousPosition(position);
    }
    async deleteNQMMPreviousPosition(symbol) {
        return this.strategiesApi.deleteNQMMPreviousPosition(symbol);
    }
    async getSystemControlState() {
        return this.systemApi.getSystemControlState();
    }
    async setSystemEnabled(enabled) {
        return this.systemApi.setSystemEnabled(enabled);
    }
    async getQuotes(symbols) {
        return this.marketApi.getQuotes(symbols);
    }
    async getContractQuote(contract) {
        return this.marketApi.getContractQuote(contract);
    }
    async setStrategyEnabled(strategyName, enabled) {
        return this.systemApi.setStrategyEnabled(strategyName, enabled);
    }
    async emergencyLiquidate() {
        return this.systemApi.emergencyLiquidate();
    }
    async resetEmergencyMode() {
        return this.systemApi.resetEmergencyMode();
    }
    async connectIB() {
        return this.systemApi.connectIB();
    }
    async disconnectIB() {
        return this.systemApi.disconnectIB();
    }
    // --- Strategy Configuration (User-Specific) ---
    async getStrategyDbConfig(strategyName) {
        return this.strategiesApi.getStrategyDbConfig(strategyName);
    }
    async getStrategyDbConfigHistory(strategyName) {
        return this.strategiesApi.getStrategyDbConfigHistory(strategyName);
    }
    // --- Signals & Audit ---
    async getStrategySignals(params) {
        return this.strategiesApi.getStrategySignals(params);
    }
    async resetStrategyDbConfig(strategyName) {
        return this.strategiesApi.resetStrategyDbConfig(strategyName);
    }
    async updateStrategyConfig(strategyName, payload) {
        return this.strategiesApi.updateStrategyConfig(strategyName, payload);
    }
    async updateStrategyDbConfig(strategyName, payload) {
        return this.strategiesApi.updateStrategyDbConfig(strategyName, payload);
    }
    // --- Admin Log Management ---
    async listLogFiles() {
        return this.logsApi.listLogFiles();
    }
    async getLoggingSettings() {
        return this.logsApi.getLoggingSettings();
    }
    async setDebugLogging(enabled) {
        return this.logsApi.setDebugLogging(enabled);
    }
    async getTradingRuntimeSettings() {
        return this.systemApi.getTradingRuntimeSettings();
    }
    async updateTradingRuntimeSettings(settings) {
        return this.systemApi.updateTradingRuntimeSettings(settings);
    }
    async getLogFileContent(filename, page = 1, pageSize = 100, level, search, startDate, endDate) {
        return this.logsApi.getLogFileContent(filename, page, pageSize, level, search, startDate, endDate);
    }
    async exportLogFile(filename) {
        return this.logsApi.exportLogFile(filename);
    }
    async configureIBGateway(username, password, mode = 'paper', gatewayId, publicPort, originalGatewayId) {
        return this.systemApi.configureIBGateway(username, password, mode, gatewayId, publicPort, originalGatewayId);
    }
    async deleteIBGatewayConfig(gatewayId) {
        return this.systemApi.deleteIBGatewayConfig(gatewayId);
    }
    async activateIBGateway(gatewayId) {
        return this.systemApi.activateIBGateway(gatewayId);
    }
    // --- Manual Orders ---
    async placeOrder(order) {
        return this.ordersApi.placeOrder(order);
    }
    async lookupOrderContracts(params) {
        return this.ordersApi.lookupOrderContracts(params);
    }
    async getBacktestStrategies() {
        return this.backtestsApi.getStrategies();
    }
    async getNQMMBacktestUniverse() {
        return this.backtestsApi.getNQMMUniverse();
    }
    async getLatestTradingDay() {
        return this.dataApi.getLatestTradingDay();
    }
    async getBacktestProgress() {
        return this.backtestsApi.getProgress();
    }
    async cancelBacktest() {
        return this.backtestsApi.cancel();
    }
    async runBacktest(config, onQueued, onProgress) {
        return this.backtestsApi.run(config, onQueued, onProgress);
    }
    async checkBacktestCache(config) {
        return this.dataApi.checkBacktestCache(config);
    }
    async getMarketDataInventory(filters = {}, pagination = {}) {
        return this.dataApi.getMarketDataInventory(filters, pagination);
    }
    async deleteMarketDataSeries(params) {
        return this.dataApi.deleteMarketDataSeries(params);
    }
    async getLakeBackupStatus(params) {
        return this.dataApi.getLakeBackupStatus(params);
    }
    async syncMarketDataToLake(params) {
        return this.dataApi.syncMarketDataToLake(params);
    }
    async getMarketDataSeries(filters) {
        return this.dataApi.getMarketDataSeries(filters);
    }
    async getDataDownloadTasks() {
        return this.dataApi.getDataDownloadTasks();
    }
    async getDataDownloadTask(taskId) {
        return this.dataApi.getDataDownloadTask(taskId);
    }
    async createDataDownloadTask(config, idempotencyKey) {
        return this.dataApi.createDataDownloadTask(config, idempotencyKey);
    }
    async cancelDataDownloadTask(taskId) {
        return this.dataApi.cancelDataDownloadTask(taskId);
    }
    async getAutomatedDataTasks() {
        return this.dataApi.getAutomatedDataTasks();
    }
    async createAutomatedDataTask(task) {
        return this.dataApi.createAutomatedDataTask(task);
    }
    async updateAutomatedDataTask(taskId, updates) {
        return this.dataApi.updateAutomatedDataTask(taskId, updates);
    }
    async deleteAutomatedDataTask(taskId) {
        return this.dataApi.deleteAutomatedDataTask(taskId);
    }
    async runAutomatedDataTask(taskId, idempotencyKey) {
        return this.dataApi.runAutomatedDataTask(taskId, idempotencyKey);
    }
    async getDurableJob(jobId) {
        return this.dataApi.getDurableJob(jobId);
    }
    async cancelDurableJob(jobId) {
        return this.dataApi.cancelDurableJob(jobId);
    }
    async runPortfolioBacktest(config, onQueued) {
        return this.backtestsApi.runPortfolio(config, onQueued);
    }
    async savePortfolioBacktest(result) {
        return this.backtestsApi.savePortfolio(result);
    }
    async runOptimization(config, onQueued, onProgress) {
        return this.backtestsApi.runOptimization(config, onQueued, onProgress);
    }
    async saveBacktest(result) {
        return this.backtestsApi.saveBacktest(result);
    }
    async getBacktestHistory(page = 1, pageSize = 20, startDate, endDate, scope = 'all') {
        return this.backtestsApi.getHistory(page, pageSize, startDate, endDate, scope);
    }
    async getBacktestDetail(id) {
        return this.backtestsApi.getDetail(id);
    }
    async getBacktestShareUsers() {
        return this.backtestsApi.getShareUsers();
    }
    async getBacktestSharing(id) {
        return this.backtestsApi.getSharing(id);
    }
    async updateBacktestSharing(id, shareAll, userIds) {
        return this.backtestsApi.updateSharing(id, shareAll, userIds);
    }
    async extendBacktest(id, config = {}) {
        return this.backtestsApi.extend(id, config);
    }
    async deleteBacktest(id) {
        return this.backtestsApi.delete(id);
    }
    async saveOptimization(result) {
        return this.backtestsApi.saveOptimization(result);
    }
    async getOptimizationHistory(skip = 0, limit = 20) {
        return this.backtestsApi.getOptimizationHistory(skip, limit);
    }
    async getOptimizationDetail(id) {
        return this.backtestsApi.getOptimizationDetail(id);
    }
    async deleteOptimization(id) {
        return this.backtestsApi.deleteOptimization(id);
    }
    // --- Managed Accounts ---
    async getManagedAccounts() {
        return this.managedAccountsApi.getManagedAccounts();
    }
    async addManagedAccount(managedUserId) {
        return this.managedAccountsApi.addManagedAccount(managedUserId);
    }
    async removeManagedAccount(managedUserId) {
        return this.managedAccountsApi.removeManagedAccount(managedUserId);
    }
    async switchToManagedAccount(managedUserId) {
        return this.managedAccountsApi.switchToManagedAccount(managedUserId);
    }
    async switchBackToOwnAccount() {
        return this.managedAccountsApi.switchBackToOwnAccount();
    }
    async getCurrentContext() {
        return this.authApi.getCurrentContext();
    }
    // --- Admin: Managed Accounts for Any User ---
    async adminGetUserManagers(userId) {
        return this.userAdministrationApi.adminGetUserManagers(userId);
    }
    async adminAddUserManager(userId, managerUserId) {
        return this.userAdministrationApi.adminAddUserManager(userId, managerUserId);
    }
    async adminRemoveUserManager(userId, managerUserId) {
        return this.userAdministrationApi.adminRemoveUserManager(userId, managerUserId);
    }
    // --- Notifications ---
    async getNotifications(limit = 50, unreadOnly = false) {
        return this.notificationsApi.getNotifications(limit, unreadOnly);
    }
    async getUnreadCount() {
        return this.notificationsApi.getUnreadCount();
    }
    async markNotificationRead(id) {
        return this.notificationsApi.markNotificationRead(id);
    }
    async markAllRead() {
        return this.notificationsApi.markAllRead();
    }
    async updateNotificationPreferences(prefs) {
        return this.notificationsApi.updateNotificationPreferences(prefs);
    }
    // --- Portfolio History ---
    async getPortfolioHistory(skip = 0, limit = 100) {
        return this.backtestsApi.getPortfolioHistory(skip, limit);
    }
    async deletePortfolio(id) {
        return this.backtestsApi.deletePortfolio(id);
    }
    async getPortfolioById(id) {
        return this.backtestsApi.getPortfolioById(id);
    }
}
const $c3a108990a9b4d6a$export$9fce83b5ea9fffcd = new $c3a108990a9b4d6a$var$TradingApiService();
var $c3a108990a9b4d6a$export$2e2bcd8739ae039 = $c3a108990a9b4d6a$var$TradingApiService;

});
parcelRegister("ymHgh", function(module, exports) {

$parcel$export(module.exports, "ApiError", function () { return $8043d8773bb78950$export$f2e832acab1bdd79; });
$parcel$export(module.exports, "API_BASE_URL", function () { return $8043d8773bb78950$export$c3ee1e672e1e24e7; });
$parcel$export(module.exports, "apiRequest", function () { return $8043d8773bb78950$export$52e83573e7782585; });
$parcel$export(module.exports, "apiRequestBlob", function () { return $8043d8773bb78950$export$25b5a7454673d50b; });
class $8043d8773bb78950$export$f2e832acab1bdd79 extends Error {
    constructor(message, statusCode, endpoint, response, code = 'HTTP_ERROR', requestId, details = []){
        super(message);
        this.name = 'ApiError';
        this.statusCode = statusCode;
        this.endpoint = endpoint;
        this.response = response;
        this.code = code;
        this.requestId = requestId;
        this.details = details;
    }
}
const $8043d8773bb78950$export$fc80ab207c069933 = ()=>{
    if (typeof window !== 'undefined') {
        if (window.location.port === '3001') return 'http://localhost:8001/api/v1';
        return '/api/v1';
    }
    return 'http://localhost:8000/api/v1';
};
const $8043d8773bb78950$export$c3ee1e672e1e24e7 = $8043d8773bb78950$export$fc80ab207c069933();
const $8043d8773bb78950$var$RETRYABLE_STATUS_CODES = new Set([
    502,
    503,
    504
]);
const $8043d8773bb78950$var$isIdempotentRequest = (method)=>[
        'GET',
        'HEAD',
        'OPTIONS'
    ].includes((method || 'GET').toUpperCase());
const $8043d8773bb78950$var$isTransientError = (error)=>error instanceof $8043d8773bb78950$export$f2e832acab1bdd79 && ($8043d8773bb78950$var$RETRYABLE_STATUS_CODES.has(error.statusCode) || error.code === 'TIMEOUT') || error instanceof TypeError;
const $8043d8773bb78950$var$delay = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $8043d8773bb78950$var$getStoredToken = ()=>{
    try {
        return typeof localStorage === 'undefined' ? null : localStorage.getItem('token');
    } catch  {
        return null;
    }
};
const $8043d8773bb78950$var$createRequestId = ()=>{
    if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return crypto.randomUUID();
    return `web-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};
const $8043d8773bb78950$var$normalizeFieldErrors = (value)=>{
    if (!Array.isArray(value)) return [];
    return value.flatMap((item)=>{
        if (!item || typeof item !== 'object') return [];
        const record = item;
        const location = Array.isArray(record.location) ? record.location : Array.isArray(record.loc) ? record.loc : [];
        const message = typeof record.message === 'string' ? record.message : typeof record.msg === 'string' ? record.msg : 'Invalid value';
        const code = typeof record.code === 'string' ? record.code : typeof record.type === 'string' ? record.type : undefined;
        return [
            {
                location: location.filter((part)=>typeof part === 'string' || typeof part === 'number'),
                message: message,
                code: code
            }
        ];
    });
};
const $8043d8773bb78950$var$errorFromResponse = async (response, endpoint)=>{
    const bodyText = await response.text();
    let body = {};
    try {
        const parsed = JSON.parse(bodyText);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) body = parsed;
    } catch  {
    // Some proxies return plain text or HTML while the API is restarting.
    }
    const detail = body.detail;
    const detailRecord = detail && typeof detail === 'object' && !Array.isArray(detail) ? detail : undefined;
    const candidates = [
        body.message,
        detailRecord?.message,
        detail,
        body.error
    ];
    const message = candidates.find((candidate)=>typeof candidate === 'string' && candidate.length > 0) || (response.status >= 502 ? `System unavailable (${response.status}); the service may be restarting.` : `API request failed: ${response.status} ${response.statusText}`);
    const details = $8043d8773bb78950$var$normalizeFieldErrors(body.details ?? (Array.isArray(detail) ? detail : []));
    const code = typeof body.code === 'string' ? body.code : response.status === 422 ? 'VALIDATION_ERROR' : `HTTP_${response.status}`;
    const requestId = typeof body.request_id === 'string' ? body.request_id : response.headers.get('X-Request-ID') || undefined;
    return new $8043d8773bb78950$export$f2e832acab1bdd79(message, response.status, endpoint, bodyText || body, code, requestId, details);
};
const $8043d8773bb78950$var$handleUnauthorized = (error)=>{
    if (error.statusCode !== 401 || error.endpoint.includes('/auth/token')) return;
    try {
        if (typeof localStorage !== 'undefined') localStorage.removeItem('token');
    } catch  {
    // Storage can be disabled by browser privacy settings.
    }
    if (typeof window !== 'undefined' && window.location.pathname !== '/login') window.location.href = '/login';
};
const $8043d8773bb78950$var$requestResponse = async (endpoint, options = {})=>{
    const { timeoutMs: timeoutMs, signal: signal, retries: retries, ...requestOptions } = options;
    const headers = new Headers(requestOptions.headers || {});
    const token = $8043d8773bb78950$var$getStoredToken();
    if (token && !headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
    if (!headers.has('X-Request-ID')) headers.set('X-Request-ID', $8043d8773bb78950$var$createRequestId());
    if (!headers.has('Accept')) headers.set('Accept', 'application/json');
    const maxAttempts = $8043d8773bb78950$var$isIdempotentRequest(requestOptions.method) ? Math.max(1, retries ?? 3) : 1;
    let lastError;
    for(let attempt = 1; attempt <= maxAttempts; attempt += 1){
        let timeoutId;
        let controller;
        let abortListener;
        if (timeoutMs && timeoutMs > 0) {
            controller = new AbortController();
            timeoutId = setTimeout(()=>controller?.abort(), timeoutMs);
            if (signal) {
                if (signal.aborted) controller.abort();
                else {
                    abortListener = ()=>controller?.abort();
                    signal.addEventListener('abort', abortListener, {
                        once: true
                    });
                }
            }
        }
        try {
            const response = await fetch(endpoint, {
                ...requestOptions,
                headers: headers,
                signal: controller?.signal ?? signal
            });
            if (!response.ok) throw await $8043d8773bb78950$var$errorFromResponse(response, endpoint);
            return response;
        } catch (error) {
            let finalError = error;
            if (error instanceof DOMException && error.name === 'AbortError' && controller?.signal.aborted && !signal?.aborted) finalError = new $8043d8773bb78950$export$f2e832acab1bdd79(`Request timed out after ${timeoutMs}ms`, 0, endpoint, undefined, 'TIMEOUT');
            lastError = finalError;
            if (attempt >= maxAttempts || !$8043d8773bb78950$var$isTransientError(finalError) || signal?.aborted) {
                if (finalError instanceof $8043d8773bb78950$export$f2e832acab1bdd79) $8043d8773bb78950$var$handleUnauthorized(finalError);
                throw finalError;
            }
            await $8043d8773bb78950$var$delay(250 * attempt);
        } finally{
            if (timeoutId) clearTimeout(timeoutId);
            if (signal && abortListener) signal.removeEventListener('abort', abortListener);
        }
    }
    throw lastError;
};
const $8043d8773bb78950$export$52e83573e7782585 = async (endpoint, options = {})=>{
    const response = await $8043d8773bb78950$var$requestResponse(endpoint, options);
    if (response.status === 204) return undefined;
    try {
        return await response.json();
    } catch  {
        throw new $8043d8773bb78950$export$f2e832acab1bdd79('The server returned an invalid JSON response.', response.status, endpoint, undefined, 'INVALID_RESPONSE');
    }
};
const $8043d8773bb78950$export$25b5a7454673d50b = async (endpoint, options = {})=>(await $8043d8773bb78950$var$requestResponse(endpoint, options)).blob();

});

parcelRegister("9Xewf", function(module, exports) {

$parcel$export(module.exports, "AccountsApiService", function () { return $9dae8b7c079c06c4$export$53a5929dfc0786d0; });

var $ymHgh = parcelRequire("ymHgh");
class $9dae8b7c079c06c4$export$53a5929dfc0786d0 {
    constructor(baseUrl = (0, $ymHgh.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $ymHgh.apiRequest)(endpoint, options);
    }
    getPortfolio() {
        return this.request(`${this.baseUrl}/account/portfolio`, {
            timeoutMs: 15000,
            retries: 1
        });
    }
    getPositions() {
        return this.request(`${this.baseUrl}/account/positions`, {
            timeoutMs: 15000,
            retries: 1
        });
    }
    getStrategyDescriptionTags() {
        return this.request(`${this.baseUrl}/account/strategy-tags`, {
            timeoutMs: 8000,
            retries: 1
        });
    }
    createStrategyDescriptionTag(payload) {
        return this.request(`${this.baseUrl}/account/strategy-tags`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
    }
    updateStrategyDescriptionTag(tagId, payload) {
        return this.request(`${this.baseUrl}/account/strategy-tags/${tagId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
    }
    deleteStrategyDescriptionTag(tagId) {
        return this.request(`${this.baseUrl}/account/strategy-tags/${tagId}`, {
            method: 'DELETE'
        });
    }
    updatePositionStrategyTags(positionKey, tagIds) {
        return this.request(`${this.baseUrl}/account/position-tags`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                position_key: positionKey,
                tag_ids: tagIds
            })
        });
    }
    updatePositionCustomStrategy(positionKey, strategyName) {
        return this.request(`${this.baseUrl}/account/position-strategy-name`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                position_key: positionKey,
                strategy_name: strategyName
            })
        });
    }
    updatePositionMetadata(positionKey, strategyName, tagIds) {
        return this.request(`${this.baseUrl}/account/position-metadata`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                position_key: positionKey,
                strategy_name: strategyName,
                tag_ids: tagIds
            })
        });
    }
    closePosition(symbol, secType, contract) {
        let endpoint = `${this.baseUrl}/account/positions/${encodeURIComponent(symbol)}/close`;
        const params = new URLSearchParams();
        if (secType) params.set('sec_type', secType);
        if (contract?.con_id !== undefined && contract.con_id !== null) params.set('con_id', String(contract.con_id));
        if (contract?.exchange) params.set('exchange', contract.exchange);
        if (contract?.currency) params.set('currency', contract.currency);
        if (contract?.local_symbol) params.set('local_symbol', contract.local_symbol);
        if (contract?.trading_class) params.set('trading_class', contract.trading_class);
        if (contract?.last_trade_date_or_contract_month) params.set('last_trade_date_or_contract_month', contract.last_trade_date_or_contract_month);
        if (contract?.multiplier) params.set('multiplier', contract.multiplier);
        const query = params.toString();
        if (query) endpoint += `?${query}`;
        return this.request(endpoint, {
            method: 'POST'
        });
    }
}

});

parcelRegister("cYjmz", function(module, exports) {

$parcel$export(module.exports, "AuthApiService", function () { return $28b1da4b1dce9c65$export$c3a67766b2b8b815; });

var $ymHgh = parcelRequire("ymHgh");
class $28b1da4b1dce9c65$export$c3a67766b2b8b815 {
    constructor(baseUrl = (0, $ymHgh.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $ymHgh.apiRequest)(endpoint, options);
    }
    async login(username, password) {
        const formData = new FormData();
        formData.append('username', username);
        formData.append('password', password);
        return this.request(`${this.baseUrl}/auth/token`, {
            method: 'POST',
            body: formData
        });
    }
    async signup(email, password, role = 'trader', firstName, lastName, isCompany, companyName) {
        return this.request(`${this.baseUrl}/auth/signup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                username: email,
                password: password,
                role: role,
                first_name: firstName,
                last_name: lastName,
                is_company: isCompany,
                company_name: companyName
            })
        });
    }
    getRegistrationStatus() {
        return this.request(`${this.baseUrl}/auth/registration-status`);
    }
    getCurrentUser(signal) {
        return this.request(`${this.baseUrl}/auth/me`, {
            timeoutMs: 8000,
            retries: 1,
            signal: signal
        });
    }
    getCurrentContext() {
        return this.request(`${this.baseUrl}/auth/me/context`, {
            timeoutMs: 2500
        });
    }
    joinWaitlist(email, firstName, lastName) {
        return this.request(`${this.baseUrl}/auth/waitlist`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email,
                first_name: firstName,
                last_name: lastName
            })
        });
    }
    sendInvite(userId) {
        return this.request(`${this.baseUrl}/auth/invite`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                user_id: userId
            })
        });
    }
    activateUser(userId) {
        return this.request(`${this.baseUrl}/auth/users/${userId}/activate`, {
            method: 'POST'
        });
    }
    verifyInvite(token) {
        return this.request(`${this.baseUrl}/auth/verify-invite/${token}`);
    }
    setupAccount(token, password) {
        return this.request(`${this.baseUrl}/auth/setup-account`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: token,
                password: password
            })
        });
    }
}

});

parcelRegister("cWYaq", function(module, exports) {

$parcel$export(module.exports, "BacktestsApiService", function () { return $402257b2bbe59467$export$213a8fe88a865ad4; });

var $ymHgh = parcelRequire("ymHgh");
class $402257b2bbe59467$export$213a8fe88a865ad4 {
    constructor(baseUrl = (0, $ymHgh.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $ymHgh.apiRequest)(endpoint, options);
    }
    async submitDurableRun(endpoint, config, onQueued, onProgress) {
        const headers = new Headers({
            'Content-Type': 'application/json'
        });
        headers.set('Idempotency-Key', typeof crypto !== 'undefined' && 'randomUUID' in crypto ? crypto.randomUUID() : `backtest-${Date.now()}-${Math.random().toString(36).slice(2)}`);
        const response = await this.request(endpoint, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(config)
        });
        if (!response.data?.id) throw new Error('Backtest job response did not include a job ID');
        onQueued?.(response.data.id);
        onProgress?.(response.data);
        let snapshot = response.data;
        while(snapshot.status === 'queued' || snapshot.status === 'running' || snapshot.status === 'cancelling'){
            snapshot = await this.getDurableJob(snapshot.id);
            onProgress?.(snapshot);
            if (snapshot.status === 'queued' || snapshot.status === 'running' || snapshot.status === 'cancelling') await new Promise((resolve)=>setTimeout(resolve, 1000));
        }
        if (snapshot.status === 'completed') {
            if (!snapshot.result) throw new Error('Completed backtest job did not include a result');
            return snapshot.result;
        }
        throw new Error(snapshot.error || snapshot.message || `Backtest job ${snapshot.status}`);
    }
    async getDurableJob(jobId) {
        const response = await this.request(`${this.baseUrl}/backtest/jobs/${encodeURIComponent(jobId)}`);
        if (!response.data) throw new Error('Job status response did not include job data');
        return response.data;
    }
    getStrategies() {
        return this.request(`${this.baseUrl}/backtest/strategies`);
    }
    getNQMMUniverse() {
        return this.request(`${this.baseUrl}/backtest/nqmm/universe`);
    }
    getProgress() {
        return this.request(`${this.baseUrl}/backtest/progress`);
    }
    cancel() {
        return this.request(`${this.baseUrl}/backtest/cancel`, {
            method: 'POST'
        });
    }
    run(config, onQueued, onProgress) {
        return this.submitDurableRun(`${this.baseUrl}/backtest/run`, config, onQueued, onProgress);
    }
    runPortfolio(config, onQueued) {
        return this.submitDurableRun(`${this.baseUrl}/backtest/portfolio/run`, config, onQueued);
    }
    savePortfolio(result) {
        return this.request(`${this.baseUrl}/backtest/portfolio/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(result)
        });
    }
    runOptimization(config, onQueued, onProgress) {
        return this.submitDurableRun(`${this.baseUrl}/backtest/optimize`, config, onQueued, onProgress);
    }
    saveBacktest(result) {
        return this.request(`${this.baseUrl}/backtest/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(result)
        });
    }
    getHistory(page = 1, pageSize = 20, startDate, endDate, scope = 'all') {
        const params = new URLSearchParams({
            skip: String((page - 1) * pageSize),
            limit: String(pageSize)
        });
        if (startDate) params.set('start_date', startDate);
        if (endDate) params.set('end_date', endDate);
        if (scope !== 'all') params.set('scope', scope);
        return this.request(`${this.baseUrl}/backtest/history?${params.toString()}`);
    }
    getDetail(id) {
        return this.request(`${this.baseUrl}/backtest/history/${id}`);
    }
    getShareUsers() {
        return this.request(`${this.baseUrl}/backtest/sharing/users`);
    }
    getSharing(id) {
        return this.request(`${this.baseUrl}/backtest/history/${id}/sharing`);
    }
    updateSharing(id, shareAll, userIds) {
        return this.request(`${this.baseUrl}/backtest/history/${id}/sharing`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                share_all: shareAll,
                user_ids: userIds
            })
        });
    }
    extend(id, config = {}) {
        return this.request(`${this.baseUrl}/backtest/history/${id}/extend`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(config)
        });
    }
    delete(id) {
        return this.request(`${this.baseUrl}/backtest/history/${id}`, {
            method: 'DELETE'
        });
    }
    saveOptimization(result) {
        return this.request(`${this.baseUrl}/backtest/optimization/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(result)
        });
    }
    getOptimizationHistory(skip = 0, limit = 20) {
        const params = new URLSearchParams({
            skip: String(skip),
            limit: String(limit)
        });
        return this.request(`${this.baseUrl}/backtest/optimization/history?${params.toString()}`);
    }
    getOptimizationDetail(id) {
        return this.request(`${this.baseUrl}/backtest/optimization/${id}`);
    }
    deleteOptimization(id) {
        return this.request(`${this.baseUrl}/backtest/optimization/${id}`, {
            method: 'DELETE'
        });
    }
    getPortfolioHistory(skip = 0, limit = 100) {
        const params = new URLSearchParams({
            skip: String(skip),
            limit: String(limit)
        });
        return this.request(`${this.baseUrl}/backtest/portfolio/history?${params.toString()}`);
    }
    deletePortfolio(id) {
        return this.request(`${this.baseUrl}/backtest/portfolio/${id}`, {
            method: 'DELETE'
        });
    }
    getPortfolioById(id) {
        return this.request(`${this.baseUrl}/backtest/portfolio/${id}`);
    }
}

});

parcelRegister("bETVs", function(module, exports) {

$parcel$export(module.exports, "DataApiService", function () { return $40d9adee3275db56$export$45563efabe4a6e08; });

var $ymHgh = parcelRequire("ymHgh");
const $40d9adee3275db56$var$normalizeAutomatedTaskSymbols = (symbols)=>{
    if (Array.isArray(symbols)) return symbols;
    return (symbols || '').split(/[\s,]+/).map((symbol)=>symbol.trim().toUpperCase()).filter(Boolean);
};
const $40d9adee3275db56$var$normalizeAutomatedTaskDays = (scheduleDays)=>{
    if (Array.isArray(scheduleDays)) return scheduleDays;
    const normalized = (scheduleDays || '').trim().toUpperCase();
    if (normalized === 'MON-FRI') return [
        'MON',
        'TUE',
        'WED',
        'THU',
        'FRI'
    ];
    if (normalized === 'ALL') return [
        'MON',
        'TUE',
        'WED',
        'THU',
        'FRI',
        'SAT',
        'SUN'
    ];
    return normalized.split(/[\s,]+/).filter(Boolean);
};
const $40d9adee3275db56$var$automatedTaskPayload = (task)=>{
    const payload = {
        ...task
    };
    if ('symbols' in task && task.symbols) payload.symbols = task.symbols.join(', ');
    if ('schedule_days' in task && task.schedule_days) {
        const days = task.schedule_days;
        const weekdays = [
            'MON',
            'TUE',
            'WED',
            'THU',
            'FRI'
        ];
        payload.schedule_days = days.length === 5 && weekdays.every((day)=>days.includes(day)) ? 'mon-fri' : days.length === 7 && days.every((day)=>[
                'MON',
                'TUE',
                'WED',
                'THU',
                'FRI',
                'SAT',
                'SUN'
            ].includes(day)) ? 'all' : days.join(',');
    }
    return payload;
};
const $40d9adee3275db56$var$createDataDownloadIdempotencyKey = ()=>{
    if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return crypto.randomUUID();
    return `download-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};
const $40d9adee3275db56$var$normalizeAutomatedTask = (task)=>{
    const normalizedTask = task && typeof task === 'object' ? task : {};
    return {
        ...normalizedTask,
        symbols: $40d9adee3275db56$var$normalizeAutomatedTaskSymbols(normalizedTask.symbols),
        schedule_days: $40d9adee3275db56$var$normalizeAutomatedTaskDays(normalizedTask.schedule_days)
    };
};
const $40d9adee3275db56$var$automatedTaskData = (data)=>data && 'task' in data ? data.task : data;
class $40d9adee3275db56$export$45563efabe4a6e08 {
    constructor(baseUrl = (0, $ymHgh.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $ymHgh.apiRequest)(endpoint, options);
    }
    getLatestTradingDay() {
        return this.request(`${this.baseUrl}/backtest/data/latest-trading-day`);
    }
    async checkBacktestCache(config) {
        return this.request(`${this.baseUrl}/backtest/cache/check`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(config)
        });
    }
    async getMarketDataInventory(filters = {}, pagination = {}) {
        const params = new URLSearchParams();
        if (filters.symbol) params.set('symbol', filters.symbol);
        if (filters.timeframe) params.set('timeframe', filters.timeframe);
        if (filters.sec_type) params.set('sec_type', filters.sec_type);
        if (filters.data_source) params.set('data_source', filters.data_source);
        if (filters.storage) params.set('storage', filters.storage);
        if (filters.data_type) params.set('data_type', filters.data_type);
        if (pagination.skip !== undefined) params.set('skip', String(pagination.skip));
        if (pagination.limit !== undefined) params.set('limit', String(pagination.limit));
        const query = params.toString();
        const endpoint = `${this.baseUrl}/backtest/data/inventory${query ? `?${query}` : ''}`;
        const response = await this.request(endpoint);
        if (!response.data) throw new Error('Market-data inventory response did not include data');
        return response.data;
    }
    deleteMarketDataSeries(params) {
        const searchParams = new URLSearchParams();
        searchParams.set('symbol', params.symbol);
        searchParams.set('timeframe', params.timeframe);
        if (params.sec_type) searchParams.set('sec_type', params.sec_type);
        if (params.data_source) searchParams.set('data_source', params.data_source);
        if (params.multiplier) searchParams.set('multiplier', String(params.multiplier));
        if (params.data_type) searchParams.set('data_type', params.data_type);
        const endpoint = `${this.baseUrl}/backtest/data/series?${searchParams.toString()}`;
        return this.request(endpoint, {
            method: 'DELETE'
        });
    }
    async getLakeBackupStatus(params) {
        const searchParams = this.marketDataIdentityParams(params);
        const response = await this.request(`${this.baseUrl}/backtest/data/lake-status?${searchParams.toString()}`);
        return response;
    }
    async syncMarketDataToLake(params) {
        const searchParams = this.marketDataIdentityParams(params);
        const response = await this.request(`${this.baseUrl}/backtest/data/sync?${searchParams.toString()}`, {
            method: 'POST'
        });
        return response;
    }
    async getMarketDataSeries(filters) {
        const params = new URLSearchParams();
        params.set('symbol', filters.symbol);
        params.set('timeframe', filters.timeframe);
        if (filters.sec_type) params.set('sec_type', filters.sec_type);
        if (filters.data_source) params.set('data_source', filters.data_source);
        if (filters.storage) params.set('storage', filters.storage);
        if (filters.data_type) params.set('data_type', filters.data_type);
        if (filters.multiplier) params.set('multiplier', String(filters.multiplier));
        if (filters.start_date) params.set('start_date', filters.start_date);
        if (filters.end_date) params.set('end_date', filters.end_date);
        if (filters.limit) params.set('limit', String(filters.limit));
        if (filters.offset !== undefined) params.set('offset', String(filters.offset));
        if (filters.sort_by) params.set('sort_by', filters.sort_by);
        if (filters.sort_dir) params.set('sort_dir', filters.sort_dir);
        if (filters.min_price !== undefined) params.set('min_price', String(filters.min_price));
        if (filters.max_price !== undefined) params.set('max_price', String(filters.max_price));
        if (filters.min_volume !== undefined) params.set('min_volume', String(filters.min_volume));
        const response = await this.request(`${this.baseUrl}/backtest/data/series?${params.toString()}`);
        if (!response.data) throw new Error('Market-data series response did not include data');
        return response.data;
    }
    async getDataDownloadTasks() {
        const response = await this.request(`${this.baseUrl}/backtest/data/tasks`);
        return response.data?.tasks || [];
    }
    async getDataDownloadTask(taskId) {
        const response = await this.request(`${this.baseUrl}/backtest/data/tasks/${encodeURIComponent(taskId)}`);
        if (!response.data) throw new Error('Download task response did not include task data');
        return response.data;
    }
    async createDataDownloadTask(config, idempotencyKey) {
        const headers = new Headers({
            'Content-Type': 'application/json'
        });
        headers.set('Idempotency-Key', idempotencyKey || $40d9adee3275db56$var$createDataDownloadIdempotencyKey());
        const response = await this.request(`${this.baseUrl}/backtest/data/download`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(config)
        });
        if (!response.data) throw new Error('Download task response did not include task data');
        return response.data;
    }
    cancelDataDownloadTask(taskId) {
        return this.request(`${this.baseUrl}/backtest/data/tasks/${taskId}/cancel`, {
            method: 'POST'
        });
    }
    async getAutomatedDataTasks() {
        const response = await this.request(`${this.baseUrl}/backtest/data/automated-tasks`);
        return (response.data?.tasks || []).map($40d9adee3275db56$var$normalizeAutomatedTask);
    }
    async createAutomatedDataTask(task) {
        const response = await this.request(`${this.baseUrl}/backtest/data/automated-tasks`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify($40d9adee3275db56$var$automatedTaskPayload(task))
        });
        const taskRecord = $40d9adee3275db56$var$automatedTaskData(response.data);
        if (!taskRecord) throw new Error('Automated-task response did not include task data');
        return $40d9adee3275db56$var$normalizeAutomatedTask(taskRecord);
    }
    async updateAutomatedDataTask(taskId, updates) {
        const response = await this.request(`${this.baseUrl}/backtest/data/automated-tasks/${taskId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify($40d9adee3275db56$var$automatedTaskPayload(updates))
        });
        const taskRecord = $40d9adee3275db56$var$automatedTaskData(response.data);
        if (!taskRecord) throw new Error('Automated-task response did not include task data');
        return $40d9adee3275db56$var$normalizeAutomatedTask(taskRecord);
    }
    deleteAutomatedDataTask(taskId) {
        return this.request(`${this.baseUrl}/backtest/data/automated-tasks/${taskId}`, {
            method: 'DELETE'
        });
    }
    runAutomatedDataTask(taskId, idempotencyKey) {
        const headers = new Headers();
        headers.set('Idempotency-Key', idempotencyKey || $40d9adee3275db56$var$createDataDownloadIdempotencyKey());
        return this.request(`${this.baseUrl}/backtest/data/automated-tasks/${taskId}/run`, {
            method: 'POST',
            headers: headers
        });
    }
    async getDurableJob(jobId) {
        const response = await this.request(`${this.baseUrl}/backtest/jobs/${encodeURIComponent(jobId)}`);
        if (!response.data) throw new Error('Job status response did not include job data');
        return response.data;
    }
    async cancelDurableJob(jobId) {
        const response = await this.request(`${this.baseUrl}/backtest/jobs/${encodeURIComponent(jobId)}/cancel`, {
            method: 'POST'
        });
        if (!response.data) throw new Error('Job cancellation response did not include job data');
        return response.data;
    }
    marketDataIdentityParams(params) {
        const searchParams = new URLSearchParams();
        searchParams.set('symbol', params.symbol);
        searchParams.set('timeframe', params.timeframe);
        if (params.sec_type) searchParams.set('sec_type', params.sec_type);
        if (params.data_source) searchParams.set('data_source', params.data_source);
        if (params.multiplier) searchParams.set('multiplier', String(params.multiplier));
        if (params.data_type) searchParams.set('data_type', params.data_type);
        return searchParams;
    }
}

});

parcelRegister("miuea", function(module, exports) {

$parcel$export(module.exports, "LogsApiService", function () { return $231fb03a8bed1e87$export$7ffe167bded84da5; });

var $ymHgh = parcelRequire("ymHgh");
function $231fb03a8bed1e87$var$securityEventQuery(filters) {
    const params = new URLSearchParams();
    if (filters.startAt) params.set('start_at', filters.startAt);
    if (filters.endAt) params.set('end_at', filters.endAt);
    if (filters.eventType) params.set('event_type', filters.eventType);
    if (filters.outcome) params.set('outcome', filters.outcome);
    if (filters.sourceIp) params.set('source_ip', filters.sourceIp);
    if (filters.actorUserId) params.set('actor_user_id', String(filters.actorUserId));
    if (filters.subjectUserId) params.set('subject_user_id', String(filters.subjectUserId));
    return params;
}
class $231fb03a8bed1e87$export$7ffe167bded84da5 {
    constructor(baseUrl = (0, $ymHgh.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $ymHgh.apiRequest)(endpoint, options);
    }
    getTradeLogs(page = 1, pageSize = 50, filters = {}) {
        const params = new URLSearchParams({
            page: String(page),
            page_size: String(pageSize)
        });
        if (filters.symbol) params.set('symbol', filters.symbol);
        if (filters.strategy) params.set('strategy', filters.strategy);
        if (filters.startDate) params.set('start_date', filters.startDate);
        if (filters.endDate) params.set('end_date', filters.endDate);
        filters.decisionIds?.forEach((decisionId)=>params.append('decision_ids', decisionId));
        return this.request(`${this.baseUrl}/trades/logs?${params.toString()}`);
    }
    getRecentLogs(maxLines = 100, levelFilter, logFile = 'all') {
        const params = new URLSearchParams({
            max_lines: String(maxLines),
            log_file: logFile
        });
        if (levelFilter) params.set('level_filter', levelFilter);
        return this.request(`${this.baseUrl}/logs/recent?${params.toString()}`);
    }
    listLogFiles() {
        return this.request(`${this.baseUrl}/admin/logs/files`);
    }
    getSecurityEvents(filters = {}) {
        const params = new URLSearchParams({
            page: String(filters.page ?? 1),
            page_size: String(filters.pageSize ?? 50)
        });
        $231fb03a8bed1e87$var$securityEventQuery(filters).forEach((value, key)=>params.set(key, value));
        return this.request(`${this.baseUrl}/admin/security-events?${params.toString()}`);
    }
    exportSecurityEvents(filters = {}) {
        const params = $231fb03a8bed1e87$var$securityEventQuery(filters);
        params.set('format', 'csv');
        return (0, $ymHgh.apiRequestBlob)(`${this.baseUrl}/admin/security-events?${params.toString()}`);
    }
    getSecurityAlertSettings() {
        return this.request(`${this.baseUrl}/admin/security-alert-settings`);
    }
    updateSecurityAlertSettings(settings) {
        return this.request(`${this.baseUrl}/admin/security-alert-settings`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(settings)
        });
    }
    getLoggingSettings() {
        return this.request(`${this.baseUrl}/admin/settings/logging`);
    }
    setDebugLogging(enabled) {
        return this.request(`${this.baseUrl}/admin/settings/logging/debug`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                enabled: enabled
            })
        });
    }
    getLogFileContent(filename, page = 1, pageSize = 100, level, search, startDate, endDate) {
        const params = new URLSearchParams({
            filename: filename,
            page: String(page),
            page_size: String(pageSize)
        });
        if (level && level !== 'ALL') params.set('level', level);
        if (search) params.set('search', search);
        if (startDate) params.set('start_date', startDate);
        if (endDate) params.set('end_date', endDate);
        return this.request(`${this.baseUrl}/admin/logs/content?${params.toString()}`);
    }
    exportLogFile(filename) {
        const params = new URLSearchParams({
            filename: filename
        });
        return (0, $ymHgh.apiRequestBlob)(`${this.baseUrl}/admin/logs/export?${params.toString()}`);
    }
}

});

parcelRegister("dA9Ja", function(module, exports) {

$parcel$export(module.exports, "ManagedAccountsApiService", function () { return $2936f4fde2c3231f$export$7319e3a4f3371493; });

var $ymHgh = parcelRequire("ymHgh");
class $2936f4fde2c3231f$export$7319e3a4f3371493 {
    constructor(baseUrl = (0, $ymHgh.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $ymHgh.apiRequest)(endpoint, options);
    }
    getManagedAccounts() {
        return this.request(`${this.baseUrl}/managers/accounts`);
    }
    addManagedAccount(managedUserId) {
        return this.request(`${this.baseUrl}/managers/accounts`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                managed_user_id: managedUserId
            })
        });
    }
    removeManagedAccount(managedUserId) {
        return this.request(`${this.baseUrl}/managers/accounts/${managedUserId}`, {
            method: 'DELETE'
        });
    }
    switchToManagedAccount(managedUserId) {
        return this.request(`${this.baseUrl}/managers/switch/${managedUserId}`, {
            method: 'POST'
        });
    }
    switchBackToOwnAccount() {
        return this.request(`${this.baseUrl}/managers/switch-back`, {
            method: 'POST'
        });
    }
}

});

parcelRegister("5qOs9", function(module, exports) {

$parcel$export(module.exports, "MarketApiService", function () { return $2b1b40b80f150c81$export$96b2f7f1f218d585; });

var $ymHgh = parcelRequire("ymHgh");
class $2b1b40b80f150c81$export$96b2f7f1f218d585 {
    constructor(baseUrl = (0, $ymHgh.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $ymHgh.apiRequest)(endpoint, options);
    }
    getHistoricalData(symbol, timeframe, duration, source = 'auto', signal) {
        const params = new URLSearchParams({
            timeframe: timeframe,
            duration: duration,
            source: source
        });
        const endpoint = `${this.baseUrl}/market/history/${encodeURIComponent(symbol)}?${params.toString()}`;
        return this.request(endpoint, {
            timeoutMs: 20000,
            retries: 1,
            signal: signal
        });
    }
    getMarketStatus() {
        return this.request(`${this.baseUrl}/market/status`, {
            timeoutMs: 8000,
            retries: 1
        });
    }
    getQuotes(symbols) {
        const endpoint = `${this.baseUrl}/market/quotes?symbols=${encodeURIComponent(symbols.join(','))}`;
        return this.request(endpoint);
    }
    getContractQuote(contract) {
        return this.request(`${this.baseUrl}/market/quote`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(contract)
        });
    }
}

});

parcelRegister("bNcI0", function(module, exports) {

$parcel$export(module.exports, "NotificationsApiService", function () { return $d0510396b9cadb26$export$9e61bcd14f6a5469; });

var $ymHgh = parcelRequire("ymHgh");
class $d0510396b9cadb26$export$9e61bcd14f6a5469 {
    constructor(baseUrl = (0, $ymHgh.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $ymHgh.apiRequest)(endpoint, options);
    }
    getNotifications(limit = 50, unreadOnly = false) {
        return this.request(`${this.baseUrl}/notifications?limit=${limit}&unread_only=${unreadOnly}`);
    }
    getUnreadCount() {
        return this.request(`${this.baseUrl}/notifications/unread-count`, {
            timeoutMs: 2000
        });
    }
    markNotificationRead(id) {
        return this.request(`${this.baseUrl}/notifications/${id}/read`, {
            method: 'POST'
        });
    }
    markAllRead() {
        return this.request(`${this.baseUrl}/notifications/read-all`, {
            method: 'POST'
        });
    }
    updateNotificationPreferences(preferences) {
        return this.request(`${this.baseUrl}/auth/me/preferences`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(preferences)
        });
    }
}

});

parcelRegister("8iag5", function(module, exports) {

$parcel$export(module.exports, "OrdersApiService", function () { return $8db3001815fdd240$export$42a2dbcefd7505b5; });

var $ymHgh = parcelRequire("ymHgh");
class $8db3001815fdd240$export$42a2dbcefd7505b5 {
    constructor(baseUrl = (0, $ymHgh.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $ymHgh.apiRequest)(endpoint, options);
    }
    getOpenOrders(page = 1, pageSize = 5, secType) {
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('page_size', pageSize.toString());
        if (secType && secType !== 'ALL') params.append('sec_type', secType);
        return this.request(`${this.baseUrl}/account/orders?${params.toString()}`, {
            timeoutMs: 6000,
            retries: 1
        });
    }
    getFilledOrdersToday(page = 1, pageSize = 5, secType) {
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('page_size', pageSize.toString());
        if (secType && secType !== 'ALL') params.append('sec_type', secType);
        return this.request(`${this.baseUrl}/account/orders/filled?${params.toString()}`, {
            timeoutMs: 6000,
            retries: 1
        });
    }
    cancelOrder(orderId) {
        return this.request(`${this.baseUrl}/account/orders/${orderId}/cancel`, {
            method: 'POST'
        });
    }
    modifyOrder(orderId, order) {
        return this.request(`${this.baseUrl}/orders/${orderId}/modify`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(order)
        });
    }
    async placeOrder(order) {
        try {
            return await this.request(`${this.baseUrl}/orders`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(order)
            });
        } catch (err) {
            // Re-throw with just the message to prevent stack trace issues.
            throw new Error(err instanceof Error ? err.message : 'Order placement failed');
        }
    }
    lookupOrderContracts(params) {
        const searchParams = new URLSearchParams();
        searchParams.set('symbol', params.symbol);
        searchParams.set('sec_type', params.sec_type || 'FUT');
        if (params.exchange) searchParams.set('exchange', params.exchange);
        return this.request(`${this.baseUrl}/orders/lookup?${searchParams.toString()}`, {
            timeoutMs: 15000,
            retries: 0
        });
    }
}

});

parcelRegister("eWVKm", function(module, exports) {

$parcel$export(module.exports, "StrategiesApiService", function () { return $4f25d274100485d3$export$880b2e655b46b5e7; });

var $ymHgh = parcelRequire("ymHgh");
class $4f25d274100485d3$export$880b2e655b46b5e7 {
    constructor(baseUrl = (0, $ymHgh.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $ymHgh.apiRequest)(endpoint, options);
    }
    getStrategyStatus() {
        return this.request(`${this.baseUrl}/strategy/on/status`);
    }
    getONStrategyStatus() {
        return this.request(`${this.baseUrl}/strategy/on/status`);
    }
    getONPositions() {
        return this.request(`${this.baseUrl}/strategy/on/positions`);
    }
    getORBStrategyStatus() {
        return this.request(`${this.baseUrl}/strategy/orb/status`);
    }
    getORBPositions() {
        return this.request(`${this.baseUrl}/strategy/orb/positions`);
    }
    getAllStrategiesStatus() {
        return this.request(`${this.baseUrl}/strategy/overview`);
    }
    getTradingSignal(symbol) {
        return this.request(`${this.baseUrl}/strategy/on/signals/${symbol}`);
    }
    getMarketAnalysis(symbol) {
        return this.request(`${this.baseUrl}/strategy/on/analysis/${symbol}`);
    }
    getStrategyStatusByName(strategyName) {
        return this.request(`${this.baseUrl}/strategy/status/${strategyName}`);
    }
    getNQMMStrategyStatus() {
        return this.request(`${this.baseUrl}/strategy/nqmm/status`);
    }
    getNQMMPositions() {
        return this.request(`${this.baseUrl}/strategy/nqmm/positions`);
    }
    getNQMMPreviousPositions() {
        return this.request(`${this.baseUrl}/strategy/nqmm/previous-positions`);
    }
    addNQMMPreviousPosition(position) {
        return this.request(`${this.baseUrl}/strategy/nqmm/previous-positions`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(position)
        });
    }
    deleteNQMMPreviousPosition(symbol) {
        return this.request(`${this.baseUrl}/strategy/nqmm/previous-positions/${encodeURIComponent(symbol)}`, {
            method: 'DELETE'
        });
    }
    getStrategyDbConfig(strategyName) {
        return this.request(`${this.baseUrl}/strategy/config/${strategyName}`);
    }
    getStrategyDbConfigHistory(strategyName) {
        return this.request(`${this.baseUrl}/strategy/config/${strategyName}/history`);
    }
    getStrategySignals(filters) {
        const query = new URLSearchParams();
        if (filters.strategy) query.append('strategy', filters.strategy);
        if (filters.symbol) query.append('symbol', filters.symbol);
        if (filters.start_date) query.append('start_date', filters.start_date);
        if (filters.end_date) query.append('end_date', filters.end_date);
        if (filters.page) query.append('page', filters.page.toString());
        if (filters.limit) query.append('limit', filters.limit.toString());
        return this.request(`${this.baseUrl}/strategy/signals?${query.toString()}`);
    }
    resetStrategyDbConfig(strategyName) {
        return this.request(`${this.baseUrl}/strategy/config/${strategyName}/reset`, {
            method: 'POST'
        });
    }
    updateStrategyConfig(strategyName, payload) {
        return this.request(`${this.baseUrl}/strategy/config/${strategyName}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
    }
    updateStrategyDbConfig(strategyName, payload) {
        return this.request(`${this.baseUrl}/strategy/config/${strategyName}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
    }
}

});

parcelRegister("gjf37", function(module, exports) {

$parcel$export(module.exports, "SystemApiService", function () { return $6a3e72732ab5d389$export$bbffa564d5e69446; });

var $ymHgh = parcelRequire("ymHgh");
class $6a3e72732ab5d389$export$bbffa564d5e69446 {
    constructor(baseUrl = (0, $ymHgh.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $ymHgh.apiRequest)(endpoint, options);
    }
    getSystemStatus() {
        return this.request(`${this.baseUrl}/system/status`);
    }
    getSystemControlState() {
        return this.request(`${this.baseUrl}/system/control`, {
            timeoutMs: 15000
        });
    }
    setSystemEnabled(enabled) {
        return this.request(`${this.baseUrl}/system/enable`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(enabled)
        });
    }
    setStrategyEnabled(strategyName, enabled) {
        return this.request(`${this.baseUrl}/system/strategy/${encodeURIComponent(strategyName)}/enable`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(enabled)
        });
    }
    emergencyLiquidate() {
        return this.request(`${this.baseUrl}/system/liquidate`, {
            method: 'POST'
        });
    }
    resetEmergencyMode() {
        return this.request(`${this.baseUrl}/system/emergency/reset`, {
            method: 'POST'
        });
    }
    connectIB() {
        return this.request(`${this.baseUrl}/system/ib/connect`, {
            method: 'POST'
        });
    }
    disconnectIB() {
        return this.request(`${this.baseUrl}/system/ib/disconnect`, {
            method: 'POST'
        });
    }
    controlIBGateway(action, gatewayId) {
        const params = new URLSearchParams();
        if (gatewayId) params.set('gateway_id', gatewayId);
        const query = params.toString();
        const endpoint = `${this.baseUrl}/system/ib/gateway/${action}${query ? `?${query}` : ''}`;
        return this.request(endpoint, {
            method: 'POST'
        });
    }
    getTradingRuntimeSettings() {
        return this.request(`${this.baseUrl}/admin/settings/trading`);
    }
    updateTradingRuntimeSettings(settings) {
        return this.request(`${this.baseUrl}/admin/settings/trading`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(settings)
        });
    }
    configureIBGateway(username, password, mode = 'paper', gatewayId, publicPort, originalGatewayId) {
        return this.request(`${this.baseUrl}/system/ib/configure`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                username: username,
                password: password,
                mode: mode,
                gateway_id: gatewayId,
                public_port: publicPort,
                original_gateway_id: originalGatewayId
            })
        });
    }
    deleteIBGatewayConfig(gatewayId) {
        const params = new URLSearchParams({
            gateway_id: gatewayId
        });
        return this.request(`${this.baseUrl}/system/ib/configure?${params.toString()}`, {
            method: 'DELETE'
        });
    }
    activateIBGateway(gatewayId) {
        return this.request(`${this.baseUrl}/system/ib/activate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                gateway_id: gatewayId
            })
        });
    }
}

});

parcelRegister("gxTjb", function(module, exports) {

$parcel$export(module.exports, "UserAdministrationApiService", function () { return $c3cffdd570153dfd$export$2ad4fc3877b7f376; });

var $ymHgh = parcelRequire("ymHgh");
class $c3cffdd570153dfd$export$2ad4fc3877b7f376 {
    constructor(baseUrl = (0, $ymHgh.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $ymHgh.apiRequest)(endpoint, options);
    }
    getUsers() {
        return this.request(`${this.baseUrl}/auth/users`);
    }
    adminCreateUser(user) {
        return this.request(`${this.baseUrl}/auth/register`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(user)
        });
    }
    adminUpdateUser(userId, user) {
        return this.request(`${this.baseUrl}/auth/users/${userId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(user)
        });
    }
    deleteUser(userId) {
        return this.request(`${this.baseUrl}/auth/users/${userId}`, {
            method: 'DELETE'
        });
    }
    getUserDetails(userId) {
        return this.request(`${this.baseUrl}/admin/users/${userId}/details`);
    }
    adminConfigureUserGateway(userId, config) {
        return this.request(`${this.baseUrl}/admin/users/${userId}/gateways`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(config)
        });
    }
    adminControlUserGateway(userId, gatewayId, action) {
        const encodedGatewayId = encodeURIComponent(gatewayId);
        return this.request(`${this.baseUrl}/admin/users/${userId}/gateways/${encodedGatewayId}/control/${action}`, {
            method: 'POST'
        });
    }
    adminActivateUserGateway(userId, gatewayId) {
        const encodedGatewayId = encodeURIComponent(gatewayId);
        return this.request(`${this.baseUrl}/admin/users/${userId}/gateways/${encodedGatewayId}/activate`, {
            method: 'POST'
        });
    }
    adminDeleteUserGateway(userId, gatewayId) {
        const encodedGatewayId = encodeURIComponent(gatewayId);
        return this.request(`${this.baseUrl}/admin/users/${userId}/gateways/${encodedGatewayId}`, {
            method: 'DELETE'
        });
    }
    adminGetUserManagers(userId) {
        return this.request(`${this.baseUrl}/admin/users/${userId}/managers`);
    }
    adminAddUserManager(userId, managerUserId) {
        return this.request(`${this.baseUrl}/admin/users/${userId}/managers`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                manager_user_id: managerUserId
            })
        });
    }
    adminRemoveUserManager(userId, managerUserId) {
        return this.request(`${this.baseUrl}/admin/users/${userId}/managers/${managerUserId}`, {
            method: 'DELETE'
        });
    }
}

});



parcelRegister("12llf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cf9980294bd52e0$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $2cf9980294bd52e0$export$a2387ed3b5d536eb = {
    name: "clock",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "M12 6v6l4 2",
                key: "mmk7yg"
            }
        ]
    ]
};
$2cf9980294bd52e0$export$a2387ed3b5d536eb.node;
const $2cf9980294bd52e0$export$2e2bcd8739ae039 = (0, $hHhnY.default)($2cf9980294bd52e0$export$a2387ed3b5d536eb);

});
parcelRegister("hHhnY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81eae322ae61403f$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $jHEir = parcelRequire("jHEir");

var $1Nubc = parcelRequire("1Nubc");

var $cRQH3 = parcelRequire("cRQH3");

var $8W4ty = parcelRequire("8W4ty");
function $81eae322ae61403f$export$2e2bcd8739ae039(iconDataOrName, iconNode = [], aliases = []) {
    const iconData = typeof iconDataOrName === "string" ? (0, $1Nubc.toLucideIconData)(iconDataOrName, iconNode, aliases) : iconDataOrName;
    const Component = (0, $jHEir.forwardRef)(({ className: className, ...props }, ref)=>(0, $jHEir.createElement)((0, $8W4ty.default), {
            ref: ref,
            icon: iconData,
            className: className,
            ...props
        }));
    if (iconData.name) Component.displayName = (0, $cRQH3.toPascalCase)(iconData.name);
    return Component;
}

});
parcelRegister("1Nubc", function(module, exports) {

$parcel$export(module.exports, "toLucideIconData", function () { return $13b2b5441d028165$export$cffcae2df5126ae4; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $62bOD = parcelRequire("62bOD");
function $13b2b5441d028165$export$cffcae2df5126ae4(iconName, iconNode, aliases = []) {
    if (iconNode == null) throw new Error("[lucide]: iconNode is required when icon name is used");
    return {
        name: (0, $62bOD.toKebabCase)(iconName),
        size: 24,
        node: iconNode,
        ...aliases.length > 0 ? {
            aliases: aliases
        } : {}
    };
}

});
parcelRegister("62bOD", function(module, exports) {

$parcel$export(module.exports, "toKebabCase", function () { return $602c8bb15b21cbb8$export$73bda83cddbc7187; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $602c8bb15b21cbb8$export$73bda83cddbc7187 = (string)=>string?.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();

});


parcelRegister("cRQH3", function(module, exports) {

$parcel$export(module.exports, "toPascalCase", function () { return $a86843ec4888e659$export$6fb43ff9addf7357; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $jXFjX = parcelRequire("jXFjX");
const $a86843ec4888e659$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = (0, $jXFjX.toCamelCase)(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};

});
parcelRegister("jXFjX", function(module, exports) {

$parcel$export(module.exports, "toCamelCase", function () { return $53e8913c506adce6$export$86f54f62aa7a7514; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $53e8913c506adce6$export$86f54f62aa7a7514 = (string)=>{
    let out = "";
    let upperNext = false;
    for (const ch of string){
        if (ch === "-" || ch === "_" || ch <= " ") {
            upperNext = out.length > 0;
            continue;
        }
        if (out.length === 0) out += ch.toLowerCase();
        else out += upperNext ? ch.toUpperCase() : ch;
        upperNext = false;
    }
    return out;
};

});


parcelRegister("8W4ty", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d83752daf8796caa$export$2e2bcd8739ae039; });

var $jHEir = parcelRequire("jHEir");

var $dIAcQ = parcelRequire("dIAcQ");

var $jY0qI = parcelRequire("jY0qI");

var $1V0wn = parcelRequire("1V0wn");

var $gcPeo = parcelRequire("gcPeo");
"use strict";
"use client";
const $d83752daf8796caa$export$2e2bcd8739ae039 = (0, $jHEir.forwardRef)(({ color: color, size: size, width: width, height: height, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, nonScalingStroke: nonScalingStroke, className: className = "", children: children, iconNode: iconNode = [], icon: icon = {
    node: iconNode,
    aliases: [],
    size: 24
}, ...rest }, ref)=>{
    const { size: contextSize = 24, strokeWidth: contextStrokeWidth = 2, absoluteStrokeWidth: contextAbsoluteStrokeWidth = false, nonScalingStroke: contextNonScalingStroke = false, color: contextColor = "currentColor", className: contextClass = "" } = (0, $gcPeo.useLucideContext)() ?? {};
    const hasAccessibleProp = Boolean(children) || (0, $1V0wn.hasA11yProp)(rest);
    const [name, svgAttributes, builtIconNode = []] = (0, $jY0qI.default)(icon, {
        color: color ?? contextColor,
        width: width ?? size ?? contextSize,
        height: height ?? size ?? contextSize,
        strokeWidth: strokeWidth ?? contextStrokeWidth,
        absoluteStrokeWidth: absoluteStrokeWidth ?? contextAbsoluteStrokeWidth,
        nonScalingStroke: nonScalingStroke ?? contextNonScalingStroke,
        className: (0, $dIAcQ.mergeClasses)(contextClass, className),
        hasA11yProp: hasAccessibleProp,
        attributes: rest
    });
    return (0, $jHEir.createElement)(name, {
        ref: ref,
        ...svgAttributes
    }, [
        ...builtIconNode.map(([tag, attrs])=>(0, $jHEir.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});

});
parcelRegister("dIAcQ", function(module, exports) {

$parcel$export(module.exports, "mergeClasses", function () { return $b07aa21bfb51a75d$export$3d46f4579dba46e5; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $b07aa21bfb51a75d$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();

});

parcelRegister("jY0qI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15b75bc3937cdf75$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $aHYVO = parcelRequire("aHYVO");
function $15b75bc3937cdf75$export$2e2bcd8739ae039(icon, params = {}) {
    return (0, $aHYVO.default)(icon, {
        ...params,
        attributeNames: {
            ...params.attributeNames,
            class: "className",
            "stroke-width": "strokeWidth",
            "stroke-linecap": "strokeLinecap",
            "stroke-linejoin": "strokeLinejoin",
            "vector-effect": "vectorEffect"
        }
    });
}

});
parcelRegister("aHYVO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a2777144d29b8b4$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $7YdBO = parcelRequire("7YdBO");

var $dIAcQ = parcelRequire("dIAcQ");
function $8a2777144d29b8b4$var$isDefined(value) {
    return value !== null && value !== void 0;
}
function $8a2777144d29b8b4$export$2e2bcd8739ae039(icon, params = {}) {
    const attributeNames = params.attributeNames ?? {};
    const getAttributeName = (attributeName)=>attributeNames[attributeName] ?? attributeName;
    const viewBoxWidth = icon.size ?? icon.width ?? (0, $7YdBO.default)["width"];
    const viewBoxHeight = icon.size ?? icon.height ?? (0, $7YdBO.default)["height"];
    const aliasClassNames = icon.aliases?.filter((alias)=>typeof alias === "string" && alias.trim() !== "").map((alias)=>`lucide-${alias}`) ?? [];
    const iconClassNames = [
        ...icon.name ? [
            `lucide-${icon.name}`
        ] : [],
        ...aliasClassNames
    ];
    const classNamesFromClassName = params.className?.split(" ").filter(Boolean) ?? [];
    const className = params.includeDefaultClasses === false ? (0, $dIAcQ.mergeClasses)(...classNamesFromClassName) : (0, $dIAcQ.mergeClasses)("lucide", ...iconClassNames, ...classNamesFromClassName);
    const calculatedStrokeWidth = params.absoluteStrokeWidth ? Number(params.strokeWidth ?? (0, $7YdBO.default)["stroke-width"]) * Number(icon.size ?? icon.width ?? (0, $7YdBO.default)["width"]) / Number(params.size ?? params.width ?? (0, $7YdBO.default)["width"]) : params.strokeWidth ?? (0, $7YdBO.default)["stroke-width"];
    const attributes = {
        ...Object.entries((0, $7YdBO.default)).reduce((attrs, [attrName, value])=>{
            attrs[getAttributeName(attrName)] = value;
            return attrs;
        }, {}),
        ..."color" in params && params.color && {
            [getAttributeName("stroke")]: params.color
        },
        ..."size" in params && $8a2777144d29b8b4$var$isDefined(params.size) && {
            [getAttributeName("width")]: params.size,
            [getAttributeName("height")]: params.size
        },
        ..."width" in params && $8a2777144d29b8b4$var$isDefined(params.width) && {
            [getAttributeName("width")]: params.width
        },
        ..."height" in params && $8a2777144d29b8b4$var$isDefined(params.height) && {
            [getAttributeName("height")]: params.height
        },
        [getAttributeName("stroke-width")]: calculatedStrokeWidth,
        ...className && {
            [getAttributeName("class")]: className
        },
        [getAttributeName("viewBox")]: `0 0 ${viewBoxWidth} ${viewBoxHeight}`,
        ...params.hasA11yProp === false ? {
            [getAttributeName("aria-hidden")]: "true"
        } : {},
        ..."attributes" in params && params.attributes
    };
    return [
        "svg",
        attributes,
        icon.node.map((child)=>{
            const [name, attrs, children] = child;
            const nextAttrs = params.nonScalingStroke ? {
                [getAttributeName("vector-effect")]: "non-scaling-stroke",
                ...attrs
            } : attrs;
            return children ? [
                name,
                nextAttrs,
                children
            ] : [
                name,
                nextAttrs
            ];
        })
    ];
}

});
parcelRegister("7YdBO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b20e756c5d51205d$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $b20e756c5d51205d$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": 2,
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
};

});



parcelRegister("1V0wn", function(module, exports) {

$parcel$export(module.exports, "hasA11yProp", function () { return $0c63fd44a4ee0a1a$export$ab365959aa6deed0; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $0c63fd44a4ee0a1a$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
    return false;
};

});

parcelRegister("gcPeo", function(module, exports) {

$parcel$export(module.exports, "useLucideContext", function () { return $7ca131c6caa80ca1$export$52ee7576b6cde767; });

var $jHEir = parcelRequire("jHEir");
"use strict";
"use client";
const $7ca131c6caa80ca1$var$LucideContext = (0, $jHEir.createContext)({});
function $7ca131c6caa80ca1$export$f4a5ae9d8b2d8a16({ children: children, size: size, color: color, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, nonScalingStroke: nonScalingStroke, className: className }) {
    const value = (0, $jHEir.useMemo)(()=>({
            size: size,
            color: color,
            strokeWidth: strokeWidth,
            absoluteStrokeWidth: absoluteStrokeWidth,
            nonScalingStroke: nonScalingStroke,
            className: className
        }), [
        size,
        color,
        strokeWidth,
        absoluteStrokeWidth,
        nonScalingStroke,
        className
    ]);
    return (0, $jHEir.createElement)($7ca131c6caa80ca1$var$LucideContext.Provider, {
        value: value
    }, children);
}
const $7ca131c6caa80ca1$export$52ee7576b6cde767 = ()=>(0, $jHEir.useContext)($7ca131c6caa80ca1$var$LucideContext);

});




parcelRegister("hX4Sd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89e6a91f7289de96$export$2e2bcd8739ae039; });

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $dL2Lt = parcelRequire("dL2Lt");

var $zs3Np = parcelRequire("zs3Np");
const $89e6a91f7289de96$var$SystemControlButton = ({ controlState: controlState, onRefresh: onRefresh, className: className, onError: onError, variant: variant = 'compact', iconSize: iconSizeProp })=>{
    const [loading, setLoading] = (0, $jHEir.useState)(false);
    const buttonsTheme = (0, $jHEir.useMemo)(()=>({
            // Base styles common to all variants (colors, borders, transitions)
            base: "rounded-xl font-semibold transition-all duration-200 border",
            // Layout styles for Compact (Grid) view
            compact: "col-span-1 w-full px-3 py-3 flex flex-col items-center justify-center gap-1.5 text-xs sm:text-sm",
            // Layout styles for Slim (Row) view
            slim: "flex items-center justify-center gap-1.5 rounded-lg",
            start: "bg-emerald-500/15 text-emerald-400 hover:bg-emerald-500/25 border-emerald-500/20 shadow-xs",
            stop: "bg-rose-500/15 text-rose-400 hover:bg-rose-500/25 border-rose-500/20 shadow-xs",
            unavailable: "bg-white/5 text-muted border-white/10 shadow-none"
        }), []);
    const handleSystemToggle = async ()=>{
        if (!controlState) return;
        setLoading(true);
        try {
            const response = await (0, $zs3Np.tradingApi).setSystemEnabled(!controlState.system_enabled);
            if (response.success) await onRefresh();
            else onError(response.message || "Failed to update system state");
        } catch (err) {
            onError(err instanceof Error ? err.message : "Failed to update system state");
        } finally{
            setLoading(false);
        }
    };
    if (!controlState) return null;
    const layoutClass = variant === 'compact' ? buttonsTheme.compact : buttonsTheme.slim;
    const isConnected = controlState.ib_connected;
    const colorClass = !isConnected ? buttonsTheme.unavailable : controlState.system_enabled ? buttonsTheme.stop : buttonsTheme.start;
    const actionLabel = !isConnected ? "Connect first" : controlState.system_enabled ? "Stop Trading" : "Start Trading";
    const iconSize = iconSizeProp ?? (variant === 'slim' ? 16 : 18);
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
        onClick: handleSystemToggle,
        disabled: loading || !isConnected,
        className: `${buttonsTheme.base} ${layoutClass} ${colorClass} ${className || ''} ${!isConnected ? 'opacity-50 cursor-not-allowed grayscale' : ''}`,
        title: !isConnected ? "Connect the broker before changing trading state" : controlState.system_enabled ? "Stop new trading activity" : "Start trading activity",
        "aria-label": actionLabel,
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $dL2Lt.default), {
                size: iconSize
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                className: variant === 'slim' ? 'min-w-0 truncate leading-none font-bold' : '',
                children: actionLabel
            })
        ]
    });
};
var $89e6a91f7289de96$export$2e2bcd8739ae039 = $89e6a91f7289de96$var$SystemControlButton;

});
parcelRegister("dL2Lt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21c965555c3e326f$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $21c965555c3e326f$export$a2387ed3b5d536eb = {
    name: "power",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 2v10",
                key: "mnfbl"
            }
        ],
        [
            "path",
            {
                d: "M18.4 6.6a9 9 0 1 1-12.77.04",
                key: "obofu9"
            }
        ]
    ]
};
$21c965555c3e326f$export$a2387ed3b5d536eb.node;
const $21c965555c3e326f$export$2e2bcd8739ae039 = (0, $hHhnY.default)($21c965555c3e326f$export$a2387ed3b5d536eb);

});


parcelRegister("2KORC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $687b456f1f6bb962$export$2e2bcd8739ae039; });

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $j8jJ4 = parcelRequire("j8jJ4");
var $9WswS = parcelRequire("9WswS");
var $eC2xp = parcelRequire("eC2xp");
var $c5crE = parcelRequire("c5crE");

var $zs3Np = parcelRequire("zs3Np");
const $687b456f1f6bb962$var$GatewayControlButton = ({ controlState: controlState, onRefresh: onRefresh, onConfigureNeeded: onConfigureNeeded, className: className, onError: onError, variant: variant = 'compact', gatewayId: gatewayId, iconSize: iconSizeProp })=>{
    const [loadingAction, setLoadingAction] = (0, $jHEir.useState)(null);
    const abortControllerRef = (0, $jHEir.useRef)(null);
    const [pendingHint, setPendingHint] = (0, $jHEir.useState)(null);
    const hintTimerRef = (0, $jHEir.useRef)(null);
    const isFatalConnectionError = (msg)=>{
        if (!msg) return false;
        const lower = msg.toLowerCase();
        return lower.includes("invalid credential") || lower.includes("trading mode mismatch") || lower.includes("returned exit status") || lower.includes("failed to decrypt") || lower.includes("fatal");
    };
    // Keep local hint in sync with control state (e.g., from periodic refreshes)
    (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useEffect(()=>{
        // Show hint if gateway is in a pending state (not connected but has hint)
        if (controlState?.gateway_hint && !controlState.ib_connected && controlState.gateway_running) setPendingHint(controlState.gateway_hint);
        // Clear hint if connected or gateway is not running (stopped or not set)
        if (controlState?.ib_connected || !controlState?.gateway_running) setPendingHint(null);
    }, [
        controlState?.gateway_hint,
        controlState?.ib_connected,
        controlState?.gateway_running
    ]);
    const buttonsTheme = (0, $jHEir.useMemo)(()=>({
            // Base styles common to all variants (colors, borders, transitions)
            base: "rounded-xl font-semibold transition-all duration-200 border",
            // Layout styles for Compact (Grid) view
            compact: "col-span-1 w-full px-3 py-3 flex flex-col items-center justify-center gap-1.5 text-xs sm:text-sm",
            // Layout styles for Slim (Row) view
            slim: "flex items-center justify-center gap-1.5 rounded-lg",
            start: "bg-emerald-500/15 text-emerald-400 hover:bg-emerald-500/25 border-emerald-500/20 shadow-xs",
            stop: "bg-rose-500/15 text-rose-400 hover:bg-rose-500/25 border-rose-500/20 shadow-xs",
            loading: "bg-warning-500/15 text-warning-400 hover:bg-warning-500/25 border-warning-500/20 shadow-[0_0_15px_rgba(245,158,11,0.05)] cursor-wait"
        }), []);
    const handleGatewayControl = async (action)=>{
        if (!controlState) return;
        const isLiveMode = controlState.ib_mode === 'live';
        // Smart Start Logic: Check if configured before starting
        // If specific gatewayId is provided, we assume it's configured (or we can't check easily without iterating saved_gateways)
        if (action === "start" && !gatewayId && !controlState.gateway_configured) {
            onConfigureNeeded();
            return;
        }
        // Cancel any previous pending request
        if (abortControllerRef.current) abortControllerRef.current.abort();
        const controller = new AbortController();
        abortControllerRef.current = controller;
        setPendingHint(null);
        setLoadingAction(action);
        try {
            const response = await (0, $zs3Np.tradingApi).controlIBGateway(action, gatewayId);
            if (response.success) {
                if (action === "start") {
                    // Show a generic reminder after a short delay in live mode
                    if (isLiveMode && !controlState.ib_connected) {
                        // Show immediately so the user sees it even if backend retries/DNS take time
                        setPendingHint("Gateway is starting. Approve IB Key on your phone if prompted.");
                        if (hintTimerRef.current) clearTimeout(hintTimerRef.current);
                        hintTimerRef.current = setTimeout(()=>{
                            setPendingHint((current)=>current || "Gateway is starting. Approve IB Key on your phone if prompted.");
                        }, 5000);
                    }
                    // Poll for connection status
                    let attempts = 0;
                    const baseMaxAttempts = 30; // 30 seconds timeout
                    let maxAttempts = baseMaxAttempts;
                    let lastConnectionError = null;
                    while(attempts < maxAttempts && abortControllerRef.current === controller){
                        await onRefresh();
                        // We need to check the fresh state, but onRefresh updates the parent's state.
                        // We can't easily access the *new* prop value here immediately inside the loop 
                        // because of closure staleness, unless we trust onRefresh to update the prop 
                        // and we rely on the re-render? No, re-render won't update 'controlState' in this scope.
                        // We need to fetch the state directly or wait for the parent to update.
                        // Better: Fetch state directly here to check.
                        try {
                            const status = await (0, $zs3Np.tradingApi).getSystemControlState();
                            const statusData = status.data;
                            // Update hint state from backend (e.g. 2FA)
                            if (status.success && statusData?.gateway_hint) {
                                setPendingHint(statusData.gateway_hint);
                                // Extend wait window if user action is pending
                                maxAttempts = Math.max(maxAttempts, 180);
                            }
                            // Check for explicit errors from the backend (e.g. invalid credentials)
                            if (status.success && statusData?.connection_error) {
                                lastConnectionError = statusData.connection_error;
                                if (isFatalConnectionError(statusData.connection_error)) {
                                    onError(statusData.connection_error);
                                    // Stop the gateway to clean up
                                    await (0, $zs3Np.tradingApi).controlIBGateway("stop");
                                    break;
                                } else {
                                    // Treat as transient (DNS/startup). Keep waiting but extend window.
                                    setPendingHint(statusData.connection_error);
                                    maxAttempts = Math.max(maxAttempts, 180);
                                }
                            }
                            if (status.success && statusData?.ib_connected) {
                                setPendingHint(null);
                                break;
                            }
                        } catch (e) {
                            console.warn("Failed to poll status", e);
                        }
                        await new Promise((resolve)=>setTimeout(resolve, 1000));
                        attempts++;
                    }
                    if (attempts >= maxAttempts) {
                        if (pendingHint || lastConnectionError) onError(pendingHint || lastConnectionError || "Gateway is waiting for approval/startup. Please check the gateway and IB Key.");
                        else onError("Gateway start is taking longer than expected. Check gateway container status.");
                    }
                    // Final refresh to update UI
                    await onRefresh();
                } else {
                    // For stop, clear hint and refresh
                    setPendingHint(null);
                    await onRefresh();
                }
            } else onError(response.message || `Failed to ${action} gateway`);
        } catch (err) {
            if (err.name === 'AbortError') console.log('Gateway control action cancelled');
            else onError(err instanceof Error ? err.message : `Failed to ${action} gateway`);
        } finally{
            if (abortControllerRef.current === controller) {
                setLoadingAction(null);
                abortControllerRef.current = null;
            }
            if (hintTimerRef.current) {
                clearTimeout(hintTimerRef.current);
                hintTimerRef.current = null;
            }
        }
    };
    const handleCancel = async (e)=>{
        e.stopPropagation();
        const wasStarting = !controlState?.ib_connected;
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
            abortControllerRef.current = null;
        }
        setLoadingAction(null);
        if (wasStarting) try {
            // Explicitly stop the gateway to ensure cleanup
            await (0, $zs3Np.tradingApi).controlIBGateway("stop", gatewayId);
            await onRefresh();
        } catch (err) {
            console.warn("Failed to stop gateway during cancellation", err);
        }
    };
    if (!controlState) return null;
    const isConnecting = controlState.gateway_hint_code === "connecting";
    const showLoading = loadingAction !== null || isConnecting;
    // Determine gateway active state: prefer gateway_running (container status), fall back to ib_connected
    const isGatewayActive = controlState.gateway_running ?? controlState.ib_connected;
    const layoutClass = variant === 'compact' ? buttonsTheme.compact : buttonsTheme.slim;
    const colorClass = showLoading ? buttonsTheme.loading : isGatewayActive ? buttonsTheme.stop : buttonsTheme.start;
    const isConfigured = controlState.gateway_configured;
    const actionLabel = isGatewayActive ? "Disconnect" : isConfigured ? "Connect" : "Set up broker";
    const iconSize = iconSizeProp ?? (variant === 'slim' ? 16 : 18);
    return /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
        onClick: ()=>{
            if (showLoading) return;
            handleGatewayControl(isGatewayActive ? "stop" : "start");
        },
        disabled: loadingAction === 'stop',
        className: `${buttonsTheme.base} ${layoutClass} ${colorClass} ${className || ''} relative group disabled:opacity-50 disabled:cursor-not-allowed`,
        title: !isConfigured && !isGatewayActive ? "Set up the broker connection" : isGatewayActive ? "Disconnect the broker gateway" : "Connect to the broker gateway",
        "aria-label": showLoading ? loadingAction === 'stop' ? "Disconnecting from broker" : "Connecting to broker" : actionLabel,
        children: showLoading ? /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                    size: iconSize,
                    className: "animate-spin"
                }),
                variant === 'slim' ? /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex items-center gap-1 leading-none",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            children: loadingAction === 'stop' ? "Disconnecting..." : "Connecting..."
                        }),
                        loadingAction !== 'stop' && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            onClick: handleCancel,
                            className: "text-[9px] text-red-400 hover:text-red-300 underline cursor-pointer ml-1 z-10",
                            children: "(Cancel)"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex flex-col items-center leading-none",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            children: loadingAction === 'stop' ? "Disconnecting..." : loadingAction === 'start' || isConnecting ? "Connecting..." : isGatewayActive ? "Disconnecting..." : "Connecting..."
                        }),
                        loadingAction !== 'stop' && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            onClick: handleCancel,
                            className: "text-[10px] text-red-400 hover:text-red-300 underline cursor-pointer mt-1 z-10",
                            children: "Cancel"
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
            children: [
                !isGatewayActive && !isConfigured ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $eC2xp.default), {
                    size: iconSize
                }) : isGatewayActive ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $c5crE.default), {
                    size: iconSize
                }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $9WswS.default), {
                    size: iconSize
                }),
                variant === 'slim' ? /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                    className: "min-w-0 truncate leading-none font-bold",
                    children: actionLabel
                }) : /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex flex-col items-center leading-none",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            children: isGatewayActive ? "Disconnect" : "Connect to Broker"
                        }),
                        isConfigured && controlState.ib_username && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "text-[10px] opacity-70 font-normal mt-0.5",
                            children: controlState.ib_username
                        })
                    ]
                })
            ]
        })
    });
};
var $687b456f1f6bb962$export$2e2bcd8739ae039 = $687b456f1f6bb962$var$GatewayControlButton;

});
parcelRegister("j8jJ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35aefa01d9bd4cdf$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $35aefa01d9bd4cdf$export$a2387ed3b5d536eb = {
    name: "loader-circle",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M21 12a9 9 0 1 1-6.219-8.56",
                key: "13zald"
            }
        ]
    ],
    aliases: [
        "loader-2"
    ]
};
$35aefa01d9bd4cdf$export$a2387ed3b5d536eb.node;
const $35aefa01d9bd4cdf$export$2e2bcd8739ae039 = (0, $hHhnY.default)($35aefa01d9bd4cdf$export$a2387ed3b5d536eb);

});

parcelRegister("9WswS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52b01e95879e0455$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $52b01e95879e0455$export$a2387ed3b5d536eb = {
    name: "play",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z",
                key: "10ikf1"
            }
        ]
    ]
};
$52b01e95879e0455$export$a2387ed3b5d536eb.node;
const $52b01e95879e0455$export$2e2bcd8739ae039 = (0, $hHhnY.default)($52b01e95879e0455$export$a2387ed3b5d536eb);

});

parcelRegister("eC2xp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58c94055b47822ad$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $58c94055b47822ad$export$a2387ed3b5d536eb = {
    name: "settings",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
                key: "1i5ecw"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "3",
                key: "1v7zrd"
            }
        ]
    ]
};
$58c94055b47822ad$export$a2387ed3b5d536eb.node;
const $58c94055b47822ad$export$2e2bcd8739ae039 = (0, $hHhnY.default)($58c94055b47822ad$export$a2387ed3b5d536eb);

});

parcelRegister("c5crE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79f4e1c4b36adbd9$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $79f4e1c4b36adbd9$export$a2387ed3b5d536eb = {
    name: "square",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                key: "afitv7"
            }
        ]
    ]
};
$79f4e1c4b36adbd9$export$a2387ed3b5d536eb.node;
const $79f4e1c4b36adbd9$export$2e2bcd8739ae039 = (0, $hHhnY.default)($79f4e1c4b36adbd9$export$a2387ed3b5d536eb);

});


parcelRegister("62Hcf", function(module, exports) {

$parcel$export(module.exports, "ThemeButton", function () { return $a3c4606bf4c17b1a$export$91a69db4fc637fd9; });
$parcel$export(module.exports, "ThemeToggleButton", function () { return $a3c4606bf4c17b1a$export$b07618a3a4968298; });
$parcel$export(module.exports, "ThemeToggleGroup", function () { return $a3c4606bf4c17b1a$export$4df28b030a62b86b; });
$parcel$export(module.exports, "ThemeTabBar", function () { return $a3c4606bf4c17b1a$export$8c530cde4853e0b9; });
$parcel$export(module.exports, "ThemeSwitch", function () { return $a3c4606bf4c17b1a$export$720d52add0a18b65; });
$parcel$export(module.exports, "ThemeBadge", function () { return $a3c4606bf4c17b1a$export$160e8347e058d687; });
$parcel$export(module.exports, "ThemeAlert", function () { return $a3c4606bf4c17b1a$export$796e1518ffe69e9b; });
$parcel$export(module.exports, "ThemeInput", function () { return $a3c4606bf4c17b1a$export$14eb500dc537d5b3; });
$parcel$export(module.exports, "ThemeSelect", function () { return $a3c4606bf4c17b1a$export$1b9e02e625a724dc; });
$parcel$export(module.exports, "ThemePagination", function () { return $a3c4606bf4c17b1a$export$3afa71aeff4a8f3b; });
$parcel$export(module.exports, "ThemePaginationFooter", function () { return $a3c4606bf4c17b1a$export$ce9c832269f3ae45; });
$parcel$export(module.exports, "themeTableClasses", function () { return (parcelRequire("5HFtN")).themeTableClasses; });

var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");

var $h2RqY = parcelRequire("h2RqY");
var $ifMtg = parcelRequire("ifMtg");

var $5HFtN = parcelRequire("5HFtN");
const $a3c4606bf4c17b1a$export$91a69db4fc637fd9 = ({ variant: variant = 'ghost', size: size = 'sm', icon: icon, iconOnly: iconOnly = false, children: children, className: className = '', type: type = 'button', ...props })=>{
    const tone = {
        primary: 'border-neon bg-neon text-surface hover:bg-primary-600',
        secondary: 'border-neon/25 bg-neon/10 text-neon hover:bg-neon/20',
        ghost: 'border-white/8 bg-white/2.5 text-muted hover:bg-white/6 hover:text-foreground',
        danger: `${(0, $5HFtN.themeToneClasses).danger} hover:bg-error-500/20`,
        success: `${(0, $5HFtN.themeToneClasses).success} hover:bg-success-500/20`
    }[variant];
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
        ...props,
        type: type,
        className: `${(0, $5HFtN.themeButtonBase)} ${(0, $5HFtN.themeControlDimensions)(size, iconOnly)} ${tone} ${className}`,
        children: [
            icon,
            iconOnly ? /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                className: "sr-only",
                children: children
            }) : children
        ]
    });
};
const $a3c4606bf4c17b1a$export$b07618a3a4968298 = ({ label: label, selected: selected, segment: segment, size: size = 'sm', icon: icon, iconOnly: iconOnly = false, children: children, className: className = '', title: title, type: type = 'button', ...props })=>/*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
        ...props,
        type: type,
        "aria-label": label,
        "aria-pressed": selected,
        title: title ?? label,
        className: `${(0, $5HFtN.getThemeToggleClassName)(selected, size, segment, iconOnly)} ${className}`,
        children: [
            icon,
            iconOnly ? /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                className: "sr-only",
                children: children ?? label
            }) : children ?? label
        ]
    });
const $a3c4606bf4c17b1a$export$4df28b030a62b86b = ({ className: className = '', ...props })=>/*#__PURE__*/ (0, $eHRxX.jsx)("div", {
        role: "group",
        ...props,
        className: `inline-flex items-center rounded-md bg-transparent shadow-[inset_0_0_0_0.5px_rgba(255,255,255,0.08)] ${className}`
    });
const $a3c4606bf4c17b1a$export$8c530cde4853e0b9 = ({ className: className = '', ...props })=>/*#__PURE__*/ (0, $eHRxX.jsx)("div", {
        role: "group",
        ...props,
        className: `flex flex-wrap gap-2 border-b border-white/10 bg-surface px-4 py-2 ${className}`
    });
const $a3c4606bf4c17b1a$export$720d52add0a18b65 = ({ label: label, checked: checked, onCheckedChange: onCheckedChange, size: size = 'small', disabled: disabled, className: className = '', ...props })=>/*#__PURE__*/ (0, $eHRxX.jsx)("button", {
        ...props,
        type: "button",
        role: "switch",
        "aria-label": label,
        "aria-checked": checked,
        disabled: disabled,
        onClick: ()=>onCheckedChange(!checked),
        className: `relative shrink-0 rounded-full border-[0.5px] transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-neon/60 disabled:cursor-not-allowed disabled:opacity-40 ${size === 'small' ? 'h-5 w-9' : 'h-6 w-11'} ${checked ? 'border-neon/30 bg-neon/25' : 'border-white/8 bg-white/5'} ${className}`,
        children: /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
            "aria-hidden": "true",
            className: `absolute left-0.5 top-1/2 -translate-y-1/2 rounded-full transition-transform ${size === 'small' ? 'h-3.5 w-3.5' : 'h-4 w-4'} ${checked ? `${size === 'small' ? 'translate-x-4.5' : 'translate-x-6'} bg-neon` : 'translate-x-0 bg-white/45'}`
        })
    });
const $a3c4606bf4c17b1a$export$160e8347e058d687 = ({ tone: tone = 'neutral', icon: icon, children: children, className: className = '', ...props })=>/*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
        ...props,
        className: `inline-flex items-center gap-1.5 rounded-full border-[0.5px] px-2.5 py-1 text-[10px] font-semibold ${(0, $5HFtN.themeToneClasses)[tone]} ${className}`,
        children: [
            icon,
            children
        ]
    });
const $a3c4606bf4c17b1a$export$796e1518ffe69e9b = ({ tone: tone = 'info', icon: icon, children: children, className: className = '', ...props })=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        role: tone === 'danger' ? 'alert' : 'status',
        ...props,
        className: `flex items-start gap-2 rounded-lg border-[0.5px] p-3 text-xs ${(0, $5HFtN.themeToneClasses)[tone]} ${className}`,
        children: [
            icon,
            children
        ]
    });
const $a3c4606bf4c17b1a$var$inputClass = 'rounded-lg border-[0.5px] border-white/10 bg-surface text-foreground leading-none placeholder:text-muted focus:outline-hidden focus:border-neon/50 disabled:cursor-not-allowed disabled:opacity-40';
const $a3c4606bf4c17b1a$export$14eb500dc537d5b3 = ({ controlSize: controlSize = 'sm', className: className = '', ...props })=>/*#__PURE__*/ (0, $eHRxX.jsx)("input", {
        ...props,
        className: `${(0, $5HFtN.themeControlDimensions)(controlSize)} ${$a3c4606bf4c17b1a$var$inputClass} ${className}`
    });
const $a3c4606bf4c17b1a$export$1b9e02e625a724dc = ({ controlSize: controlSize = 'sm', className: className = '', ...props })=>/*#__PURE__*/ (0, $eHRxX.jsx)("select", {
        ...props,
        className: `${(0, $5HFtN.themeControlDimensions)(controlSize)} pr-8 ${$a3c4606bf4c17b1a$var$inputClass} ${className}`
    });
const $a3c4606bf4c17b1a$export$3afa71aeff4a8f3b = ({ label: label = 'Pagination', currentPage: currentPage, totalPages: totalPages, hasNext: hasNext, onPageChange: onPageChange, compact: compact = false, disabled: disabled = false })=>{
    const state = (0, $5HFtN.getThemePaginationState)(currentPage, totalPages, hasNext);
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("nav", {
        "aria-label": label,
        className: "flex items-center gap-1",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsx)($a3c4606bf4c17b1a$export$91a69db4fc637fd9, {
                iconOnly: true,
                icon: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $h2RqY.default), {
                    className: "h-3.5 w-3.5"
                }),
                "aria-label": "Previous page",
                title: "Previous page",
                disabled: disabled || !state.canPrevious,
                onClick: ()=>onPageChange(state.page - 1),
                children: "Previous page"
            }),
            compact || state.total === undefined ? /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                className: "min-w-12 px-1 text-center text-[10px] text-muted",
                "aria-live": "polite",
                children: [
                    state.page,
                    state.total === undefined ? '' : ` / ${state.total}`
                ]
            }) : state.pages.map((page)=>/*#__PURE__*/ (0, $eHRxX.jsx)($a3c4606bf4c17b1a$export$b07618a3a4968298, {
                    label: `Page ${page}`,
                    "aria-current": page === state.page ? 'page' : undefined,
                    selected: page === state.page,
                    disabled: disabled,
                    onClick: ()=>onPageChange(page),
                    children: page
                }, page)),
            /*#__PURE__*/ (0, $eHRxX.jsx)($a3c4606bf4c17b1a$export$91a69db4fc637fd9, {
                iconOnly: true,
                icon: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $ifMtg.default), {
                    className: "h-3.5 w-3.5"
                }),
                "aria-label": "Next page",
                title: "Next page",
                disabled: disabled || !state.canNext,
                onClick: ()=>onPageChange(state.page + 1),
                children: "Next page"
            })
        ]
    });
};
const $a3c4606bf4c17b1a$export$ce9c832269f3ae45 = ({ summary: summary, children: children })=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "mx-5 flex flex-wrap items-center justify-between gap-3 border-t border-white/5 px-4 py-3",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                className: "text-xs font-medium text-white/60",
                children: summary
            }),
            children
        ]
    });

});
parcelRegister("h2RqY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fbe998efb54c259$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $7fbe998efb54c259$export$a2387ed3b5d536eb = {
    name: "chevron-left",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m15 18-6-6 6-6",
                key: "1wnfg3"
            }
        ]
    ]
};
$7fbe998efb54c259$export$a2387ed3b5d536eb.node;
const $7fbe998efb54c259$export$2e2bcd8739ae039 = (0, $hHhnY.default)($7fbe998efb54c259$export$a2387ed3b5d536eb);

});

parcelRegister("ifMtg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $005f9101ac053a51$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $005f9101ac053a51$export$a2387ed3b5d536eb = {
    name: "chevron-right",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m9 18 6-6-6-6",
                key: "mthhwq"
            }
        ]
    ]
};
$005f9101ac053a51$export$a2387ed3b5d536eb.node;
const $005f9101ac053a51$export$2e2bcd8739ae039 = (0, $hHhnY.default)($005f9101ac053a51$export$a2387ed3b5d536eb);

});

parcelRegister("5HFtN", function(module, exports) {

$parcel$export(module.exports, "themeToneClasses", function () { return $b965410fb851e8d6$export$68e61be4563107cf; });
$parcel$export(module.exports, "themeToneTextClasses", function () { return $b965410fb851e8d6$export$f14fa0b643096c62; });
$parcel$export(module.exports, "themeButtonBase", function () { return $b965410fb851e8d6$export$20f9a8a6e2d03b3b; });
$parcel$export(module.exports, "themeTableClasses", function () { return $b965410fb851e8d6$export$a10a27aa955f65fa; });
$parcel$export(module.exports, "themeControlDimensions", function () { return $b965410fb851e8d6$export$38e02b434fc7483; });
$parcel$export(module.exports, "getThemeToggleClassName", function () { return $b965410fb851e8d6$export$28ed826f84b20bcc; });
$parcel$export(module.exports, "getThemePaginationState", function () { return $b965410fb851e8d6$export$ee256d6224abaf3b; });
$parcel$export(module.exports, "getLogLevelTone", function () { return $b965410fb851e8d6$export$29e8091376238cad; });
const $b965410fb851e8d6$export$68e61be4563107cf = {
    success: 'border-success-500/25 bg-success-50 text-success-500',
    warning: 'border-warning-500/25 bg-warning-50 text-warning-500',
    danger: 'border-error-500/25 bg-error-50 text-error-500',
    info: 'border-info-500/25 bg-info-50 text-info-500',
    neutral: 'border-white/10 bg-white/5 text-muted'
};
const $b965410fb851e8d6$export$f14fa0b643096c62 = {
    success: 'text-success-500',
    warning: 'text-warning-500',
    danger: 'text-error-500',
    info: 'text-info-500',
    neutral: 'text-muted'
};
const $b965410fb851e8d6$export$20f9a8a6e2d03b3b = 'inline-flex shrink-0 items-center justify-center gap-1.5 rounded-md border-[0.5px] font-semibold leading-none transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-neon/60 disabled:cursor-not-allowed disabled:opacity-40';
const $b965410fb851e8d6$export$a10a27aa955f65fa = {
    table: 'w-full min-w-full border-collapse text-foreground',
    bodyText: 'text-[13px]',
    head: 'bg-white/3 text-[11px] font-semibold text-muted',
    headerCell: 'px-4 py-3 align-middle',
    body: 'divide-y divide-white/5',
    row: 'transition-colors hover:bg-white/3',
    cell: 'px-4 py-3 align-middle'
};
function $b965410fb851e8d6$export$38e02b434fc7483(size, iconOnly = false) {
    if (iconOnly) return size === 'xs' ? 'h-7 w-7 px-0 text-[10px] leading-none' : size === 'sm' ? 'h-8 w-8 px-0 text-[11px] leading-none' : size === 'md' ? 'h-9 w-9 px-0 text-xs leading-none' : 'h-11 w-11 px-0 text-sm leading-none';
    return size === 'xs' ? 'h-7 px-2 text-[10px] leading-none' : size === 'sm' ? 'h-8 px-3 text-[11px] leading-none' : size === 'md' ? 'h-9 px-3 text-xs leading-none' : 'h-11 px-4 text-sm leading-none';
}
function $b965410fb851e8d6$export$28ed826f84b20bcc(selected, size, segment, iconOnly = false) {
    const shape = segment === 'first' ? 'rounded-l-md rounded-r-none' : segment === 'last' ? 'rounded-l-none rounded-r-md' : segment ? 'rounded-none' : '';
    const state = segment ? selected ? 'border-0 bg-neon/15 text-neon' : 'border-0 bg-surface-4 text-muted hover:bg-white/6 hover:text-white' : selected ? 'border-neon/20 bg-neon/15 text-neon' : 'border-white/8 bg-white/2.5 text-muted hover:border-white/12 hover:bg-white/6 hover:text-white';
    return `${$b965410fb851e8d6$export$20f9a8a6e2d03b3b} ${$b965410fb851e8d6$export$38e02b434fc7483(size, iconOnly)}${shape ? ` ${shape}` : ''} ${state}`;
}
function $b965410fb851e8d6$export$ee256d6224abaf3b(currentPage, totalPages, hasNext = false) {
    const total = totalPages !== undefined && Number.isFinite(totalPages) ? Math.max(1, Math.trunc(totalPages)) : undefined;
    const requested = Number.isFinite(currentPage) ? Math.max(1, Math.trunc(currentPage)) : 1;
    const page = total === undefined ? requested : Math.min(requested, total);
    const start = total === undefined ? page : Math.max(1, Math.min(page - 2, total - 4));
    return {
        page: page,
        total: total,
        canPrevious: page > 1,
        canNext: total === undefined ? hasNext : page < total,
        pages: total === undefined ? [
            page
        ] : Array.from({
            length: Math.min(5, total)
        }, (_, index)=>start + index)
    };
}
function $b965410fb851e8d6$export$29e8091376238cad(level) {
    if (level === 'WARNING') return 'warning';
    if (level === 'ERROR' || level === 'CRITICAL') return 'danger';
    if (level === 'INFO') return 'info';
    return 'neutral';
}

});


parcelRegister("gKbib", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3609d86d6170354$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $a3609d86d6170354$export$a2387ed3b5d536eb = {
    name: "circle-exclamation-point",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "line",
            {
                x1: "12",
                x2: "12",
                y1: "8",
                y2: "12",
                key: "1pkeuh"
            }
        ],
        [
            "line",
            {
                x1: "12",
                x2: "12.01",
                y1: "16",
                y2: "16",
                key: "4dfq90"
            }
        ]
    ],
    aliases: [
        "alert-circle",
        "circle-alert"
    ]
};
$a3609d86d6170354$export$a2387ed3b5d536eb.node;
const $a3609d86d6170354$export$2e2bcd8739ae039 = (0, $hHhnY.default)($a3609d86d6170354$export$a2387ed3b5d536eb);

});

parcelRegister("5j4E8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf26dc9472acdcf9$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $cf26dc9472acdcf9$export$a2387ed3b5d536eb = {
    name: "circle-check-big",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M21.801 10A10 10 0 1 1 17 3.335",
                key: "yps3ct"
            }
        ],
        [
            "path",
            {
                d: "m9 11 3 3L22 4",
                key: "1pflzl"
            }
        ]
    ],
    aliases: [
        "check-circle"
    ]
};
$cf26dc9472acdcf9$export$a2387ed3b5d536eb.node;
const $cf26dc9472acdcf9$export$2e2bcd8739ae039 = (0, $hHhnY.default)($cf26dc9472acdcf9$export$a2387ed3b5d536eb);

});

parcelRegister("bgvjD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6030b6ac20b04bf$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $c6030b6ac20b04bf$export$a2387ed3b5d536eb = {
    name: "x",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M18 6 6 18",
                key: "1bl5f8"
            }
        ],
        [
            "path",
            {
                d: "m6 6 12 12",
                key: "d8bk6v"
            }
        ]
    ]
};
$c6030b6ac20b04bf$export$a2387ed3b5d536eb.node;
const $c6030b6ac20b04bf$export$2e2bcd8739ae039 = (0, $hHhnY.default)($c6030b6ac20b04bf$export$a2387ed3b5d536eb);

});

parcelRegister("4nVaN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $242678c9eabfc6d9$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $242678c9eabfc6d9$export$a2387ed3b5d536eb = {
    name: "refresh-cw",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
                key: "v9h5vc"
            }
        ],
        [
            "path",
            {
                d: "M21 3v5h-5",
                key: "1q7to0"
            }
        ],
        [
            "path",
            {
                d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
                key: "3uifl3"
            }
        ],
        [
            "path",
            {
                d: "M8 16H3v5",
                key: "1cv678"
            }
        ]
    ]
};
$242678c9eabfc6d9$export$a2387ed3b5d536eb.node;
const $242678c9eabfc6d9$export$2e2bcd8739ae039 = (0, $hHhnY.default)($242678c9eabfc6d9$export$a2387ed3b5d536eb);

});

parcelRegister("jQze5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0439ea97a0810b9$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $d0439ea97a0810b9$export$a2387ed3b5d536eb = {
    name: "search",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m21 21-4.34-4.34",
                key: "14j7rj"
            }
        ],
        [
            "circle",
            {
                cx: "11",
                cy: "11",
                r: "8",
                key: "4ej97u"
            }
        ]
    ]
};
$d0439ea97a0810b9$export$a2387ed3b5d536eb.node;
const $d0439ea97a0810b9$export$2e2bcd8739ae039 = (0, $hHhnY.default)($d0439ea97a0810b9$export$a2387ed3b5d536eb);

});

parcelRegister("2Mt3i", function(module, exports) {

$parcel$export(module.exports, "CustomSelect", function () { return (parcelRequire("4YGkM")).CustomSelect; });
parcelRequire("8ofeM");
var $4YGkM = parcelRequire("4YGkM");

});
parcelRegister("8ofeM", function(module, exports) {

$parcel$export(module.exports, "CustomSelect", function () { return (parcelRequire("4YGkM")).CustomSelect; });

var $4YGkM = parcelRequire("4YGkM");

});
parcelRegister("4YGkM", function(module, exports) {

$parcel$export(module.exports, "CustomSelect", function () { return $c8dc06e6d27204f4$export$90fa2738acf99628; });

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $faOpr = parcelRequire("faOpr");

var $5HFtN = parcelRequire("5HFtN");
const $c8dc06e6d27204f4$export$90fa2738acf99628 = ({ value: value, options: options, onChange: onChange, placeholder: placeholder = 'Select...', disabled: disabled = false, className: className = '', buttonClassName: buttonClassName = '', menuClassName: menuClassName = '', optionClassName: optionClassName = '', align: align = 'left', ariaLabel: ariaLabel, triggerContent: triggerContent, triggerTitle: triggerTitle, hideCaret: hideCaret = false, controlSize: controlSize = 'md' })=>{
    const listboxId = (0, $jHEir.useId)();
    const rootRef = (0, $jHEir.useRef)(null);
    const menuRef = (0, $jHEir.useRef)(null);
    const [open, setOpen] = (0, $jHEir.useState)(false);
    const [menuPosition, setMenuPosition] = (0, $jHEir.useState)(null);
    const selectedOption = (0, $jHEir.useMemo)(()=>options.find((option)=>option.value === value), [
        options,
        value
    ]);
    const updateMenuPosition = (0, $jHEir.useCallback)(()=>{
        if (!rootRef.current) return;
        const triggerRect = rootRef.current.getBoundingClientRect();
        const menuWidth = menuRef.current?.offsetWidth || triggerRect.width;
        const viewportPadding = 8;
        const spaceBelow = window.innerHeight - triggerRect.bottom - viewportPadding;
        const spaceAbove = triggerRect.top - viewportPadding;
        const placement = spaceBelow < 120 && spaceAbove > spaceBelow ? 'top' : 'bottom';
        const maxHeight = Math.max(96, Math.min(220, placement === 'bottom' ? spaceBelow : spaceAbove));
        const rawLeft = align === 'right' ? triggerRect.right - menuWidth : triggerRect.left;
        const left = Math.max(viewportPadding, Math.min(rawLeft, window.innerWidth - menuWidth - viewportPadding));
        const top = placement === 'bottom' ? triggerRect.bottom - 1 : Math.max(viewportPadding, triggerRect.top - maxHeight + 1);
        const nextPosition = {
            left: left,
            top: top,
            minWidth: triggerRect.width,
            maxHeight: maxHeight,
            placement: placement
        };
        setMenuPosition((current)=>{
            if (current && Math.abs(current.left - nextPosition.left) < 0.5 && Math.abs(current.top - nextPosition.top) < 0.5 && Math.abs(current.minWidth - nextPosition.minWidth) < 0.5 && Math.abs(current.maxHeight - nextPosition.maxHeight) < 0.5 && current.placement === nextPosition.placement) return current;
            return nextPosition;
        });
    }, [
        align
    ]);
    (0, $jHEir.useLayoutEffect)(()=>{
        if (!open) {
            setMenuPosition(null);
            return;
        }
        updateMenuPosition();
    }, [
        open,
        updateMenuPosition,
        options.length
    ]);
    const setMenuNode = (0, $jHEir.useCallback)((node)=>{
        menuRef.current = node;
        if (node) updateMenuPosition();
    }, [
        updateMenuPosition
    ]);
    (0, $jHEir.useEffect)(()=>{
        if (!open) return;
        const handlePointerDown = (event)=>{
            const target = event.target;
            if (!rootRef.current?.contains(target) && !menuRef.current?.contains(target)) setOpen(false);
        };
        const handleViewportChange = ()=>updateMenuPosition();
        document.addEventListener('pointerdown', handlePointerDown, true);
        window.addEventListener('resize', handleViewportChange);
        window.addEventListener('scroll', handleViewportChange, true);
        return ()=>{
            document.removeEventListener('pointerdown', handlePointerDown, true);
            window.removeEventListener('resize', handleViewportChange);
            window.removeEventListener('scroll', handleViewportChange, true);
        };
    }, [
        open,
        updateMenuPosition
    ]);
    const selectOption = (option)=>{
        if (option.disabled) return;
        onChange(option.value);
        setOpen(false);
    };
    const moveSelection = (direction)=>{
        const enabledOptions = options.filter((option)=>!option.disabled);
        if (enabledOptions.length === 0) return;
        const currentIndex = enabledOptions.findIndex((option)=>option.value === value);
        const nextIndex = currentIndex === -1 ? 0 : (currentIndex + direction + enabledOptions.length) % enabledOptions.length;
        onChange(enabledOptions[nextIndex].value);
    };
    const menu = open && !disabled && menuPosition ? /*#__PURE__*/ (0, $faOpr.createPortal)(/*#__PURE__*/ (0, $eHRxX.jsx)("div", {
        ref: setMenuNode,
        id: listboxId,
        role: "listbox",
        style: {
            left: menuPosition.left,
            top: menuPosition.top,
            minWidth: menuPosition.minWidth
        },
        className: `fixed z-9999 bg-[#1a1a2e] border border-white/10 shadow-2xl overflow-hidden backdrop-blur-xl animate-in fade-in slide-in-from-top-1 duration-200 ${menuPosition.placement === 'bottom' ? 'border-t-0 rounded-b-xl' : 'border-b-0 rounded-t-xl'} ${menuClassName}`,
        children: /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
            className: "py-1 overflow-y-auto ux-scrollbar",
            style: {
                maxHeight: menuPosition.maxHeight
            },
            children: options.map((option)=>{
                const selected = option.value === value;
                return /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                    type: "button",
                    role: "option",
                    "aria-selected": selected,
                    disabled: option.disabled,
                    onClick: ()=>selectOption(option),
                    className: `w-full px-4 py-2 text-left text-[10px] font-bold text-white/70 hover:text-neon hover:bg-white/5 transition-colors border-b border-white/3 last:border-0 flex items-center justify-between h-8 disabled:opacity-40 disabled:cursor-not-allowed ${optionClassName}`,
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "truncate",
                            children: option.label
                        }),
                        selected && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "w-1 h-1 rounded-full bg-neon shadow-[0_0_8px_rgba(var(--neon-rgb),0.5)]"
                        })
                    ]
                }, option.value);
            })
        })
    }), document.body) : null;
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        ref: rootRef,
        className: `relative ${className}`,
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                type: "button",
                disabled: disabled,
                "aria-label": ariaLabel,
                title: triggerTitle,
                "aria-haspopup": "listbox",
                "aria-expanded": open,
                "aria-controls": listboxId,
                onClick: ()=>setOpen((current)=>!current),
                onKeyDown: (event)=>{
                    if (event.key === 'Escape') {
                        setOpen(false);
                        return;
                    }
                    if (event.key === 'ArrowDown') {
                        event.preventDefault();
                        if (!open) setOpen(true);
                        moveSelection(1);
                    }
                    if (event.key === 'ArrowUp') {
                        event.preventDefault();
                        if (!open) setOpen(true);
                        moveSelection(-1);
                    }
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        setOpen((current)=>!current);
                    }
                },
                className: `w-full ${(0, $5HFtN.themeControlDimensions)(controlSize)} bg-white/3 border border-white/10 text-foreground leading-none text-left flex items-center justify-between focus:border-neon/50 focus:bg-white/5 transition disabled:opacity-50 disabled:cursor-not-allowed ${open ? 'rounded-t-lg border-b-0' : 'rounded-lg'} ${buttonClassName}`,
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                        className: "truncate",
                        children: triggerContent ?? selectedOption?.label ?? placeholder
                    }),
                    !hideCaret && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                        "aria-hidden": "true",
                        className: `ml-2 w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-transparent border-t-4 transition-transform duration-200 ${open ? 'rotate-180 border-t-neon' : 'border-t-white/40'}`
                    })
                ]
            }),
            menu
        ]
    });
};

});



parcelRegister("iCbFX", function(module, exports) {

$parcel$export(module.exports, "formatCurrency", function () { return $75ff9ff6a234be90$export$3dc27271f5d5c629; });
$parcel$export(module.exports, "getCurrencySymbol", function () { return $75ff9ff6a234be90$export$4f7b2ae0c2141b10; });
/**
 * Utility for formatting currency values dynamically.
 */ /**
 * Formats a numeric value as currency based on the provided currency code.
 * Falls back to USD if the currency code is invalid or missing.
 */ const $75ff9ff6a234be90$export$3dc27271f5d5c629 = (value, currencyCode = 'USD', hideValue = false)=>{
    if (hideValue) return '***';
    if (value === undefined || value === null) return '-';
    try {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currencyCode || 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    } catch  {
        // Fallback if currency code is invalid
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    }
};
const $75ff9ff6a234be90$export$4f7b2ae0c2141b10 = (currencyCode = 'USD')=>{
    switch(currencyCode){
        case 'EUR':
            return "\u20AC";
        case 'GBP':
            return "\xa3";
        case 'JPY':
            return "\xa5";
        default:
            return '$';
    }
};

});

parcelRegister("aunDS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $328fdfbd35fe3351$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $328fdfbd35fe3351$export$a2387ed3b5d536eb = {
    name: "minus",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M5 12h14",
                key: "1ays0h"
            }
        ]
    ]
};
$328fdfbd35fe3351$export$a2387ed3b5d536eb.node;
const $328fdfbd35fe3351$export$2e2bcd8739ae039 = (0, $hHhnY.default)($328fdfbd35fe3351$export$a2387ed3b5d536eb);

});

parcelRegister("bTVJ1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bb2031ec4a05df3$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $3bb2031ec4a05df3$export$a2387ed3b5d536eb = {
    name: "plus",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M5 12h14",
                key: "1ays0h"
            }
        ],
        [
            "path",
            {
                d: "M12 5v14",
                key: "s699le"
            }
        ]
    ]
};
$3bb2031ec4a05df3$export$a2387ed3b5d536eb.node;
const $3bb2031ec4a05df3$export$2e2bcd8739ae039 = (0, $hHhnY.default)($3bb2031ec4a05df3$export$a2387ed3b5d536eb);

});

parcelRegister("hpygi", function(module, exports) {

$parcel$export(module.exports, "tradingApiSlice", function () { return $9d82a473985f51c3$export$632826e13a29e9c0; });
$parcel$export(module.exports, "usePositionsQuery", function () { return $9d82a473985f51c3$export$7dc1170e859056d5; });
$parcel$export(module.exports, "usePortfolioQuery", function () { return $9d82a473985f51c3$export$25a73db8e658b173; });
$parcel$export(module.exports, "useOpenOrdersQuery", function () { return $9d82a473985f51c3$export$ade3dd8b0ff7c7eb; });
$parcel$export(module.exports, "useStrategyStatusQuery", function () { return $9d82a473985f51c3$export$638cb8dd9792b25b; });

var $3vzKS = parcelRequire("3vzKS");

var $ymHgh = parcelRequire("ymHgh");
const $9d82a473985f51c3$var$apiBaseQuery = async (args, api)=>{
    const request = typeof args === 'string' ? {
        url: args
    } : args;
    const endpoint = `${(0, $ymHgh.API_BASE_URL).replace(/\/$/, '')}/${request.url.replace(/^\/+/, '')}`;
    const headers = new Headers(request.headers);
    let body = request.body;
    if (request.body !== undefined && typeof request.body !== 'string' && !(request.body instanceof FormData) && !(request.body instanceof Blob)) {
        headers.set('Content-Type', 'application/json');
        body = JSON.stringify(request.body);
    }
    try {
        const data = await (0, $ymHgh.apiRequest)(endpoint, {
            method: request.method || 'GET',
            headers: headers,
            body: body,
            signal: api.signal,
            timeoutMs: 15000,
            retries: 1
        });
        return {
            data: data
        };
    } catch (error) {
        if (error instanceof (0, $ymHgh.ApiError)) {
            const data = {
                code: error.code,
                message: error.message,
                request_id: error.requestId,
                details: error.details
            };
            if (error.statusCode === 0) return {
                error: {
                    status: 'CUSTOM_ERROR',
                    error: error.message,
                    data: data
                }
            };
            return {
                error: {
                    status: error.statusCode,
                    data: data
                }
            };
        }
        return {
            error: {
                status: 'FETCH_ERROR',
                error: error instanceof Error ? error.message : String(error)
            }
        };
    }
};
const $9d82a473985f51c3$export$632826e13a29e9c0 = (0, $3vzKS.createApi)({
    reducerPath: 'tradingApi',
    refetchOnFocus: true,
    refetchOnReconnect: true,
    // Account endpoints have bounded broker waits and persisted-state fallbacks;
    // keep their previous 15-second budget while sharing auth/error/retry behavior.
    baseQuery: $9d82a473985f51c3$var$apiBaseQuery,
    tagTypes: [
        'Account',
        'Orders',
        'Strategy'
    ],
    endpoints: (builder)=>({
            positions: builder.query({
                query: ()=>'account/positions',
                providesTags: [
                    'Account'
                ]
            }),
            portfolio: builder.query({
                query: ()=>'account/portfolio',
                providesTags: [
                    'Account'
                ]
            }),
            openOrders: builder.query({
                query: ({ page: page = 1, pageSize: pageSize = 100 })=>`account/orders?page=${page}&page_size=${pageSize}`,
                providesTags: [
                    'Orders'
                ]
            }),
            strategyStatus: builder.query({
                query: (name)=>`strategy/status/${name}`,
                providesTags: (_result, _error, name)=>[
                        {
                            type: 'Strategy',
                            id: name
                        }
                    ]
            })
        })
});
const { usePositionsQuery: $9d82a473985f51c3$export$7dc1170e859056d5, usePortfolioQuery: $9d82a473985f51c3$export$25a73db8e658b173, useOpenOrdersQuery: $9d82a473985f51c3$export$ade3dd8b0ff7c7eb, useStrategyStatusQuery: $9d82a473985f51c3$export$638cb8dd9792b25b } = $9d82a473985f51c3$export$632826e13a29e9c0;

});
parcelRegister("3vzKS", function(module, exports) {

$parcel$export(module.exports, "createApi", function () { return $e0d81903d3e4859a$export$9cdc2b9a8d94c842; });

var $7dKe6 = parcelRequire("7dKe6");

var $37Zv1 = parcelRequire("37Zv1");

var $7nAvJ = parcelRequire("7nAvJ");

var $6xl8b = parcelRequire("6xl8b");

var $jHEir = parcelRequire("jHEir");
//#region src/query/utils/capitalize.ts
function $e0d81903d3e4859a$var$capitalize(str) {
    return str.replace(str[0], str[0].toUpperCase());
}
//#endregion
//#region src/query/utils/countObjectKeys.ts
function $e0d81903d3e4859a$var$countObjectKeys(obj) {
    let count = 0;
    for(const _key in obj)count++;
    return count;
}
//#endregion
//#region src/query/endpointDefinitions.ts
const $e0d81903d3e4859a$var$ENDPOINT_QUERY = "query";
const $e0d81903d3e4859a$var$ENDPOINT_MUTATION = "mutation";
const $e0d81903d3e4859a$var$ENDPOINT_INFINITEQUERY = "infinitequery";
function $e0d81903d3e4859a$var$isQueryDefinition(e) {
    return e.type === $e0d81903d3e4859a$var$ENDPOINT_QUERY;
}
function $e0d81903d3e4859a$var$isMutationDefinition(e) {
    return e.type === $e0d81903d3e4859a$var$ENDPOINT_MUTATION;
}
function $e0d81903d3e4859a$var$isInfiniteQueryDefinition(e) {
    return e.type === $e0d81903d3e4859a$var$ENDPOINT_INFINITEQUERY;
}
//#endregion
//#region src/query/tsHelpers.ts
function $e0d81903d3e4859a$var$safeAssign(target, ...args) {
    return Object.assign(target, ...args);
}
//#endregion
//#region src/query/react/constants.ts
const $e0d81903d3e4859a$export$3e5f293e15ab07c8 = Symbol();
//#endregion
//#region src/query/react/useSerializedStableValue.ts
function $e0d81903d3e4859a$var$useStableQueryArgs(queryArgs) {
    const cache = (0, $jHEir.useRef)(queryArgs);
    const copy = (0, $jHEir.useMemo)(()=>(0, $7dKe6.copyWithStructuralSharing)(cache.current, queryArgs), [
        queryArgs
    ]);
    (0, $jHEir.useEffect)(()=>{
        if (cache.current !== copy) cache.current = copy;
    }, [
        copy
    ]);
    return copy;
}
//#endregion
//#region src/query/react/useShallowStableValue.ts
function $e0d81903d3e4859a$var$useShallowStableValue(value) {
    const cache = (0, $jHEir.useRef)(value);
    (0, $jHEir.useEffect)(()=>{
        if (!(0, $7nAvJ.shallowEqual)(cache.current, value)) cache.current = value;
    }, [
        value
    ]);
    return (0, $7nAvJ.shallowEqual)(cache.current, value) ? cache.current : value;
}
//#endregion
//#region src/query/react/buildHooks.ts
const $e0d81903d3e4859a$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $e0d81903d3e4859a$var$isDOM = /* @__PURE__ */ $e0d81903d3e4859a$var$canUseDOM();
const $e0d81903d3e4859a$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
const $e0d81903d3e4859a$var$isReactNative = /* @__PURE__ */ $e0d81903d3e4859a$var$isRunningInReactNative();
const $e0d81903d3e4859a$var$getUseIsomorphicLayoutEffect = ()=>$e0d81903d3e4859a$var$isDOM || $e0d81903d3e4859a$var$isReactNative ? (0, $jHEir.useLayoutEffect) : (0, $jHEir.useEffect);
const $e0d81903d3e4859a$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $e0d81903d3e4859a$var$getUseIsomorphicLayoutEffect();
const $e0d81903d3e4859a$var$noPendingQueryStateSelector = (selected)=>{
    if (selected.isUninitialized) return {
        ...selected,
        isUninitialized: false,
        isFetching: true,
        isLoading: selected.data !== void 0 ? false : true,
        status: (0, $7dKe6.QueryStatus).pending
    };
    return selected;
};
function $e0d81903d3e4859a$var$pick(obj, ...keys) {
    const ret = {};
    keys.forEach((key)=>{
        ret[key] = obj[key];
    });
    return ret;
}
const $e0d81903d3e4859a$var$COMMON_HOOK_DEBUG_FIELDS = [
    "data",
    "status",
    "isLoading",
    "isSuccess",
    "isError",
    "error"
];
function $e0d81903d3e4859a$var$buildHooks({ api: api, moduleOptions: { batch: batch, hooks: { useDispatch: useDispatch, useSelector: useSelector }, unstable__sideEffectsInRender: unstable__sideEffectsInRender, createSelector: createSelector }, serializeQueryArgs: serializeQueryArgs, context: context }) {
    const usePossiblyImmediateEffect = unstable__sideEffectsInRender ? (cb)=>cb() : (0, $jHEir.useEffect);
    const unsubscribePromiseRef = (ref)=>{
        ref.current?.unsubscribe?.();
        ref.current = void 0;
    };
    let hasWarnedAboutStoreChange = false;
    const useWarnIfStoreChanged = (dispatch)=>{
        const initialDispatchRef = (0, $jHEir.useRef)(dispatch);
        if (!hasWarnedAboutStoreChange && initialDispatchRef.current !== dispatch) {
            hasWarnedAboutStoreChange = true;
            console.warn(`RTK Query hooks for the API at reducerPath "${api.reducerPath}" rendered with a different Redux store than the one they first subscribed to. Their subscriptions stay on the original store, so they will not load data from the new one.
If you replace the store passed to <Provider>, also give the Provider a \`key\` that changes with the store (for example \`<Provider store={store} key={storeId}>\`), so the components under it remount and subscribe to the new store.`);
        }
    };
    const endpointDefinitions = context.endpointDefinitions;
    return {
        buildQueryHooks: buildQueryHooks,
        buildInfiniteQueryHooks: buildInfiniteQueryHooks,
        buildMutationHook: buildMutationHook,
        usePrefetch: usePrefetch
    };
    function queryStatePreSelector(currentState, lastResult, queryArgs) {
        if (lastResult?.endpointName && currentState.isUninitialized) {
            const { endpointName: endpointName } = lastResult;
            const endpointDefinition = endpointDefinitions[endpointName];
            if (queryArgs !== (0, $7dKe6.skipToken) && serializeQueryArgs({
                queryArgs: lastResult.originalArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            }) === serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            })) lastResult = void 0;
        }
        let data = currentState.data;
        if (data === void 0) data = lastResult?.data;
        const hasData = data !== void 0;
        const isFetching = currentState.isLoading;
        const isLoading = (!lastResult || lastResult.isLoading || lastResult.isUninitialized || lastResult.isError) && !hasData && isFetching;
        const isSuccess = currentState.isSuccess || hasData && (isFetching && currentState.error === void 0 || currentState.isUninitialized);
        return {
            ...currentState,
            data: data,
            currentData: currentState.data,
            isFetching: isFetching,
            isLoading: isLoading,
            isSuccess: isSuccess
        };
    }
    function infiniteQueryStatePreSelector(currentState, lastResult, queryArgs) {
        if (lastResult?.endpointName && currentState.isUninitialized) {
            const { endpointName: endpointName } = lastResult;
            const endpointDefinition = endpointDefinitions[endpointName];
            if (queryArgs !== (0, $7dKe6.skipToken) && serializeQueryArgs({
                queryArgs: lastResult.originalArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            }) === serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            })) lastResult = void 0;
        }
        let data = currentState.data;
        if (data === void 0) data = lastResult?.data;
        const hasData = data !== void 0;
        const isFetching = currentState.isLoading;
        const isLoading = (!lastResult || lastResult.isLoading || lastResult.isUninitialized || lastResult.isError) && !hasData && isFetching;
        const isSuccess = currentState.isSuccess || hasData && (isFetching && currentState.error === void 0 || currentState.isUninitialized);
        return {
            ...currentState,
            data: data,
            currentData: currentState.data,
            isFetching: isFetching,
            isLoading: isLoading,
            isSuccess: isSuccess
        };
    }
    function usePrefetch(endpointName, defaultOptions) {
        const dispatch = useDispatch();
        const stableDefaultOptions = $e0d81903d3e4859a$var$useShallowStableValue(defaultOptions);
        return (0, $jHEir.useCallback)((arg, options)=>dispatch(api.util.prefetch(endpointName, arg, {
                ...stableDefaultOptions,
                ...options
            })), [
            endpointName,
            dispatch,
            stableDefaultOptions
        ]);
    }
    function useQuerySubscriptionCommonImpl(endpointName, arg, { refetchOnReconnect: refetchOnReconnect, refetchOnFocus: refetchOnFocus, refetchOnMountOrArgChange: refetchOnMountOrArgChange, skip: skip = false, pollingInterval: pollingInterval = 0, skipPollingIfUnfocused: skipPollingIfUnfocused = false, ...rest } = {}) {
        const { initiate: initiate } = api.endpoints[endpointName];
        const dispatch = useDispatch();
        const subscriptionSelectorsRef = (0, $jHEir.useRef)(void 0);
        if (!subscriptionSelectorsRef.current) {
            const returnedValue = dispatch(api.internalActions.internal_getRTKQSubscriptions());
            subscriptionSelectorsRef.current = returnedValue;
        }
        const stableArg = $e0d81903d3e4859a$var$useStableQueryArgs(skip ? (0, $7dKe6.skipToken) : arg);
        const stableSubscriptionOptions = $e0d81903d3e4859a$var$useShallowStableValue({
            refetchOnReconnect: refetchOnReconnect,
            refetchOnFocus: refetchOnFocus,
            pollingInterval: pollingInterval,
            skipPollingIfUnfocused: skipPollingIfUnfocused
        });
        const initialPageParam = rest.initialPageParam;
        const stableInitialPageParam = $e0d81903d3e4859a$var$useShallowStableValue(initialPageParam);
        const refetchCachedPages = rest.refetchCachedPages;
        const stableRefetchCachedPages = $e0d81903d3e4859a$var$useShallowStableValue(refetchCachedPages);
        const promiseRef = (0, $jHEir.useRef)(void 0);
        let { queryCacheKey: queryCacheKey, requestId: requestId } = promiseRef.current || {};
        let currentRenderHasSubscription = false;
        if (queryCacheKey && requestId) currentRenderHasSubscription = subscriptionSelectorsRef.current.isRequestSubscribed(queryCacheKey, requestId);
        const subscriptionRemoved = !currentRenderHasSubscription && promiseRef.current !== void 0;
        usePossiblyImmediateEffect(()=>{
            if (subscriptionRemoved) promiseRef.current = void 0;
        }, [
            subscriptionRemoved
        ]);
        usePossiblyImmediateEffect(()=>{
            const lastPromise = promiseRef.current;
            if (stableArg === (0, $7dKe6.skipToken)) {
                lastPromise?.unsubscribe();
                promiseRef.current = void 0;
                return;
            }
            const lastSubscriptionOptions = promiseRef.current?.subscriptionOptions;
            if (!lastPromise || lastPromise.arg !== stableArg) {
                lastPromise?.unsubscribe();
                const promise = dispatch(initiate(stableArg, {
                    subscriptionOptions: stableSubscriptionOptions,
                    forceRefetch: refetchOnMountOrArgChange,
                    ...$e0d81903d3e4859a$var$isInfiniteQueryDefinition(endpointDefinitions[endpointName]) ? {
                        initialPageParam: stableInitialPageParam,
                        refetchCachedPages: stableRefetchCachedPages
                    } : {}
                }));
                promiseRef.current = promise;
            } else if (stableSubscriptionOptions !== lastSubscriptionOptions) lastPromise.updateSubscriptionOptions(stableSubscriptionOptions);
        }, [
            dispatch,
            initiate,
            refetchOnMountOrArgChange,
            stableArg,
            stableSubscriptionOptions,
            subscriptionRemoved,
            stableInitialPageParam,
            stableRefetchCachedPages,
            endpointName
        ]);
        return [
            promiseRef,
            dispatch,
            initiate,
            stableSubscriptionOptions
        ];
    }
    function buildUseQueryState(endpointName, preSelector) {
        const useQueryState = (arg, { skip: skip = false, selectFromResult: selectFromResult } = {})=>{
            const { select: select } = api.endpoints[endpointName];
            const stableArg = $e0d81903d3e4859a$var$useStableQueryArgs(skip ? (0, $7dKe6.skipToken) : arg);
            const lastValue = (0, $jHEir.useRef)(void 0);
            const latestDefaultResult = (0, $jHEir.useRef)(void 0);
            const selectDefaultResult = (0, $jHEir.useMemo)(()=>createSelector([
                    select(stableArg),
                    (_, lastResult)=>lastResult,
                    (_)=>stableArg
                ], preSelector, {
                    memoizeOptions: {
                        resultEqualityCheck: (0, $7nAvJ.shallowEqual)
                    }
                }), [
                select,
                stableArg
            ]);
            const currentState = useSelector((0, $jHEir.useMemo)(()=>{
                const selectResult = selectFromResult ? createSelector([
                    selectDefaultResult
                ], selectFromResult, {
                    devModeChecks: {
                        identityFunctionCheck: "never"
                    }
                }) : selectDefaultResult;
                return (state)=>{
                    const lastResult = lastValue.current;
                    const result = selectResult(state, lastResult);
                    latestDefaultResult.current = selectDefaultResult(state, lastResult);
                    return result;
                };
            }, [
                selectDefaultResult,
                selectFromResult
            ]), (0, $7nAvJ.shallowEqual));
            $e0d81903d3e4859a$var$useIsomorphicLayoutEffect(()=>{
                lastValue.current = latestDefaultResult.current;
            });
            return currentState;
        };
        return useQueryState;
    }
    function usePromiseRefUnsubscribeOnUnmount(promiseRef) {
        (0, $jHEir.useEffect)(()=>{
            return ()=>{
                unsubscribePromiseRef(promiseRef);
            };
        }, [
            promiseRef
        ]);
    }
    function refetchOrErrorIfUnmounted(promiseRef) {
        if (!promiseRef.current) throw new Error((0, $37Zv1.formatProdErrorMessage)(38));
        return promiseRef.current.refetch();
    }
    function buildQueryHooks(endpointName) {
        const useQuerySubscription = (arg, options = {})=>{
            const [promiseRef] = useQuerySubscriptionCommonImpl(endpointName, arg, options);
            usePromiseRefUnsubscribeOnUnmount(promiseRef);
            return (0, $jHEir.useMemo)(()=>({
                    refetch: ()=>refetchOrErrorIfUnmounted(promiseRef)
                }), [
                promiseRef
            ]);
        };
        const useLazyQuerySubscription = ({ refetchOnReconnect: refetchOnReconnect, refetchOnFocus: refetchOnFocus, pollingInterval: pollingInterval = 0, skipPollingIfUnfocused: skipPollingIfUnfocused = false } = {})=>{
            const { initiate: initiate } = api.endpoints[endpointName];
            const dispatch = useDispatch();
            const [arg, setArg] = (0, $jHEir.useState)($e0d81903d3e4859a$export$3e5f293e15ab07c8);
            const promiseRef = (0, $jHEir.useRef)(void 0);
            const stableSubscriptionOptions = $e0d81903d3e4859a$var$useShallowStableValue({
                refetchOnReconnect: refetchOnReconnect,
                refetchOnFocus: refetchOnFocus,
                pollingInterval: pollingInterval,
                skipPollingIfUnfocused: skipPollingIfUnfocused
            });
            usePossiblyImmediateEffect(()=>{
                const lastSubscriptionOptions = promiseRef.current?.subscriptionOptions;
                if (stableSubscriptionOptions !== lastSubscriptionOptions) promiseRef.current?.updateSubscriptionOptions(stableSubscriptionOptions);
            }, [
                stableSubscriptionOptions
            ]);
            const subscriptionOptionsRef = (0, $jHEir.useRef)(stableSubscriptionOptions);
            usePossiblyImmediateEffect(()=>{
                subscriptionOptionsRef.current = stableSubscriptionOptions;
            }, [
                stableSubscriptionOptions
            ]);
            const trigger = (0, $jHEir.useCallback)(function(arg, preferCacheValue = false) {
                let promise;
                batch(()=>{
                    unsubscribePromiseRef(promiseRef);
                    promiseRef.current = promise = dispatch(initiate(arg, {
                        subscriptionOptions: subscriptionOptionsRef.current,
                        forceRefetch: !preferCacheValue
                    }));
                    setArg(arg);
                });
                return promise;
            }, [
                dispatch,
                initiate
            ]);
            const reset = (0, $jHEir.useCallback)(()=>{
                if (promiseRef.current?.queryCacheKey) dispatch(api.internalActions.removeQueryResult({
                    queryCacheKey: promiseRef.current?.queryCacheKey
                }));
            }, [
                dispatch
            ]);
            (0, $jHEir.useEffect)(()=>{
                return ()=>{
                    unsubscribePromiseRef(promiseRef);
                };
            }, []);
            (0, $jHEir.useEffect)(()=>{
                if (arg !== $e0d81903d3e4859a$export$3e5f293e15ab07c8 && !promiseRef.current) trigger(arg, true);
            }, [
                arg,
                trigger
            ]);
            return (0, $jHEir.useMemo)(()=>[
                    trigger,
                    arg,
                    {
                        reset: reset
                    }
                ], [
                trigger,
                arg,
                reset
            ]);
        };
        const useQueryState = buildUseQueryState(endpointName, queryStatePreSelector);
        return {
            useQueryState: useQueryState,
            useQuerySubscription: useQuerySubscription,
            useLazyQuerySubscription: useLazyQuerySubscription,
            useLazyQuery (options) {
                const [trigger, arg, { reset: reset }] = useLazyQuerySubscription(options);
                const queryStateResults = useQueryState(arg, {
                    ...options,
                    skip: arg === $e0d81903d3e4859a$export$3e5f293e15ab07c8
                });
                const info = (0, $jHEir.useMemo)(()=>({
                        lastArg: arg
                    }), [
                    arg
                ]);
                return (0, $jHEir.useMemo)(()=>[
                        trigger,
                        {
                            ...queryStateResults,
                            reset: reset
                        },
                        info
                    ], [
                    trigger,
                    queryStateResults,
                    reset,
                    info
                ]);
            },
            useQuery (arg, options) {
                const querySubscriptionResults = useQuerySubscription(arg, options);
                const queryStateResults = useQueryState(arg, {
                    selectFromResult: arg === (0, $7dKe6.skipToken) || options?.skip ? void 0 : $e0d81903d3e4859a$var$noPendingQueryStateSelector,
                    ...options
                });
                const debugValue = $e0d81903d3e4859a$var$pick(queryStateResults, ...$e0d81903d3e4859a$var$COMMON_HOOK_DEBUG_FIELDS);
                (0, $jHEir.useDebugValue)(debugValue);
                return (0, $jHEir.useMemo)(()=>({
                        ...queryStateResults,
                        ...querySubscriptionResults
                    }), [
                    queryStateResults,
                    querySubscriptionResults
                ]);
            }
        };
    }
    function buildInfiniteQueryHooks(endpointName) {
        const useInfiniteQuerySubscription = (arg, options = {})=>{
            const [promiseRef, dispatch, initiate, stableSubscriptionOptions] = useQuerySubscriptionCommonImpl(endpointName, arg, options);
            const subscriptionOptionsRef = (0, $jHEir.useRef)(stableSubscriptionOptions);
            usePossiblyImmediateEffect(()=>{
                subscriptionOptionsRef.current = stableSubscriptionOptions;
            }, [
                stableSubscriptionOptions
            ]);
            const hookRefetchCachedPages = options.refetchCachedPages;
            const stableHookRefetchCachedPages = $e0d81903d3e4859a$var$useShallowStableValue(hookRefetchCachedPages);
            const trigger = (0, $jHEir.useCallback)(function(arg, direction) {
                let promise;
                batch(()=>{
                    unsubscribePromiseRef(promiseRef);
                    promiseRef.current = promise = dispatch(initiate(arg, {
                        subscriptionOptions: subscriptionOptionsRef.current,
                        direction: direction
                    }));
                });
                return promise;
            }, [
                promiseRef,
                dispatch,
                initiate
            ]);
            usePromiseRefUnsubscribeOnUnmount(promiseRef);
            const stableArg = $e0d81903d3e4859a$var$useStableQueryArgs(options.skip ? (0, $7dKe6.skipToken) : arg);
            const refetch = (0, $jHEir.useCallback)((options)=>{
                if (!promiseRef.current) throw new Error((0, $37Zv1.formatProdErrorMessage)(38));
                const mergedOptions = {
                    refetchCachedPages: options?.refetchCachedPages ?? stableHookRefetchCachedPages
                };
                return promiseRef.current.refetch(mergedOptions);
            }, [
                promiseRef,
                stableHookRefetchCachedPages
            ]);
            return (0, $jHEir.useMemo)(()=>{
                const fetchNextPage = ()=>{
                    return trigger(stableArg, "forward");
                };
                const fetchPreviousPage = ()=>{
                    return trigger(stableArg, "backward");
                };
                return {
                    trigger: trigger,
                    refetch: refetch,
                    fetchNextPage: fetchNextPage,
                    fetchPreviousPage: fetchPreviousPage
                };
            }, [
                refetch,
                trigger,
                stableArg
            ]);
        };
        const useInfiniteQueryState = buildUseQueryState(endpointName, infiniteQueryStatePreSelector);
        return {
            useInfiniteQueryState: useInfiniteQueryState,
            useInfiniteQuerySubscription: useInfiniteQuerySubscription,
            useInfiniteQuery (arg, options) {
                const { refetch: refetch, fetchNextPage: fetchNextPage, fetchPreviousPage: fetchPreviousPage } = useInfiniteQuerySubscription(arg, options);
                const queryStateResults = useInfiniteQueryState(arg, {
                    selectFromResult: arg === (0, $7dKe6.skipToken) || options?.skip ? void 0 : $e0d81903d3e4859a$var$noPendingQueryStateSelector,
                    ...options
                });
                const debugValue = $e0d81903d3e4859a$var$pick(queryStateResults, ...$e0d81903d3e4859a$var$COMMON_HOOK_DEBUG_FIELDS, "hasNextPage", "hasPreviousPage");
                (0, $jHEir.useDebugValue)(debugValue);
                return (0, $jHEir.useMemo)(()=>({
                        ...queryStateResults,
                        fetchNextPage: fetchNextPage,
                        fetchPreviousPage: fetchPreviousPage,
                        refetch: refetch
                    }), [
                    queryStateResults,
                    fetchNextPage,
                    fetchPreviousPage,
                    refetch
                ]);
            }
        };
    }
    function buildMutationHook(name) {
        return ({ selectFromResult: selectFromResult, fixedCacheKey: fixedCacheKey } = {})=>{
            const { select: select, initiate: initiate } = api.endpoints[name];
            const dispatch = useDispatch();
            const [promise, setPromise] = (0, $jHEir.useState)();
            (0, $jHEir.useEffect)(()=>()=>{
                    if (!promise?.arg.fixedCacheKey) promise?.reset();
                }, [
                promise
            ]);
            const triggerMutation = (0, $jHEir.useCallback)(function(arg) {
                const promise = dispatch(initiate(arg, {
                    fixedCacheKey: fixedCacheKey
                }));
                setPromise(promise);
                return promise;
            }, [
                dispatch,
                initiate,
                fixedCacheKey
            ]);
            const { requestId: requestId } = promise || {};
            const selectDefaultResult = (0, $jHEir.useMemo)(()=>select({
                    fixedCacheKey: fixedCacheKey,
                    requestId: promise?.requestId
                }), [
                fixedCacheKey,
                promise,
                select
            ]);
            const currentState = useSelector((0, $jHEir.useMemo)(()=>selectFromResult ? createSelector([
                    selectDefaultResult
                ], selectFromResult) : selectDefaultResult, [
                selectFromResult,
                selectDefaultResult
            ]), (0, $7nAvJ.shallowEqual));
            const originalArgs = fixedCacheKey == null ? promise?.arg.originalArgs : void 0;
            const reset = (0, $jHEir.useCallback)(()=>{
                batch(()=>{
                    if (promise) setPromise(void 0);
                    if (fixedCacheKey) dispatch(api.internalActions.removeMutationResult({
                        requestId: requestId,
                        fixedCacheKey: fixedCacheKey
                    }));
                });
            }, [
                dispatch,
                fixedCacheKey,
                promise,
                requestId
            ]);
            const debugValue = $e0d81903d3e4859a$var$pick(currentState, ...$e0d81903d3e4859a$var$COMMON_HOOK_DEBUG_FIELDS, "endpointName");
            (0, $jHEir.useDebugValue)(debugValue);
            const finalState = (0, $jHEir.useMemo)(()=>({
                    ...currentState,
                    originalArgs: originalArgs,
                    reset: reset
                }), [
                currentState,
                originalArgs,
                reset
            ]);
            return (0, $jHEir.useMemo)(()=>[
                    triggerMutation,
                    finalState
                ], [
                triggerMutation,
                finalState
            ]);
        };
    }
}
//#endregion
//#region src/query/react/module.ts
const $e0d81903d3e4859a$export$fba4c1b64338c09f = /* @__PURE__ */ Symbol();
const $e0d81903d3e4859a$export$8b98f9e72008ec90 = ({ batch: batch$1 = (0, $7nAvJ.batch), hooks: hooks = {
    useDispatch: $7nAvJ.useDispatch,
    useSelector: $7nAvJ.useSelector,
    useStore: $7nAvJ.useStore
}, createSelector: createSelector$1 = (0, $6xl8b.createSelector), unstable__sideEffectsInRender: unstable__sideEffectsInRender = false, ...rest } = {})=>{
    return {
        name: $e0d81903d3e4859a$export$fba4c1b64338c09f,
        init (api, { serializeQueryArgs: serializeQueryArgs }, context) {
            const anyApi = api;
            const { buildQueryHooks: buildQueryHooks, buildInfiniteQueryHooks: buildInfiniteQueryHooks, buildMutationHook: buildMutationHook, usePrefetch: usePrefetch } = $e0d81903d3e4859a$var$buildHooks({
                api: api,
                moduleOptions: {
                    batch: batch$1,
                    hooks: hooks,
                    unstable__sideEffectsInRender: unstable__sideEffectsInRender,
                    createSelector: createSelector$1
                },
                serializeQueryArgs: serializeQueryArgs,
                context: context
            });
            $e0d81903d3e4859a$var$safeAssign(anyApi, {
                usePrefetch: usePrefetch
            });
            $e0d81903d3e4859a$var$safeAssign(context, {
                batch: batch$1
            });
            return {
                injectEndpoint (endpointName, definition) {
                    if ($e0d81903d3e4859a$var$isQueryDefinition(definition)) {
                        const { useQuery: useQuery, useLazyQuery: useLazyQuery, useLazyQuerySubscription: useLazyQuerySubscription, useQueryState: useQueryState, useQuerySubscription: useQuerySubscription } = buildQueryHooks(endpointName);
                        $e0d81903d3e4859a$var$safeAssign(anyApi.endpoints[endpointName], {
                            useQuery: useQuery,
                            useLazyQuery: useLazyQuery,
                            useLazyQuerySubscription: useLazyQuerySubscription,
                            useQueryState: useQueryState,
                            useQuerySubscription: useQuerySubscription
                        });
                        api[`use${$e0d81903d3e4859a$var$capitalize(endpointName)}Query`] = useQuery;
                        api[`useLazy${$e0d81903d3e4859a$var$capitalize(endpointName)}Query`] = useLazyQuery;
                    }
                    if ($e0d81903d3e4859a$var$isMutationDefinition(definition)) {
                        const useMutation = buildMutationHook(endpointName);
                        $e0d81903d3e4859a$var$safeAssign(anyApi.endpoints[endpointName], {
                            useMutation: useMutation
                        });
                        api[`use${$e0d81903d3e4859a$var$capitalize(endpointName)}Mutation`] = useMutation;
                    } else if ($e0d81903d3e4859a$var$isInfiniteQueryDefinition(definition)) {
                        const { useInfiniteQuery: useInfiniteQuery, useInfiniteQuerySubscription: useInfiniteQuerySubscription, useInfiniteQueryState: useInfiniteQueryState } = buildInfiniteQueryHooks(endpointName);
                        $e0d81903d3e4859a$var$safeAssign(anyApi.endpoints[endpointName], {
                            useInfiniteQuery: useInfiniteQuery,
                            useInfiniteQuerySubscription: useInfiniteQuerySubscription,
                            useInfiniteQueryState: useInfiniteQueryState
                        });
                        api[`use${$e0d81903d3e4859a$var$capitalize(endpointName)}InfiniteQuery`] = useInfiniteQuery;
                    }
                }
            };
        }
    };
};
//#endregion
//#region src/query/react/ApiProvider.tsx
function $e0d81903d3e4859a$export$f4e57f6132f56752(props) {
    const context = props.context || (0, $7nAvJ.ReactReduxContext);
    if ((0, $jHEir.useContext)(context)) throw new Error((0, $37Zv1.formatProdErrorMessage)(35));
    const [store] = $jHEir.useState(()=>(0, $37Zv1.configureStore)({
            reducer: {
                [props.api.reducerPath]: props.api.reducer
            },
            middleware: (gDM)=>gDM().concat(props.api.middleware)
        }));
    (0, $jHEir.useEffect)(()=>props.setupListeners === false ? void 0 : (0, $7dKe6.setupListeners)(store.dispatch, props.setupListeners), [
        props.setupListeners,
        store.dispatch
    ]);
    return /* @__PURE__ */ $jHEir.createElement((0, $7nAvJ.Provider), {
        store: store,
        context: context
    }, props.children);
}
//#endregion
//#region src/query/react/index.ts
const $e0d81903d3e4859a$export$9cdc2b9a8d94c842 = /* @__PURE__ */ (0, $7dKe6.buildCreateApi)((0, $7dKe6.coreModule)(), $e0d81903d3e4859a$export$8b98f9e72008ec90());

});
parcelRegister("7dKe6", function(module, exports) {

$parcel$export(module.exports, "QueryStatus", function () { return $7c5b8303526498ea$export$f4258b89f6bad1d6; });
$parcel$export(module.exports, "copyWithStructuralSharing", function () { return $7c5b8303526498ea$export$b64d4502a1c929bd; });
$parcel$export(module.exports, "setupListeners", function () { return $7c5b8303526498ea$export$120c0dbb0351414c; });
$parcel$export(module.exports, "skipToken", function () { return $7c5b8303526498ea$export$1aa5a89531b7670d; });
$parcel$export(module.exports, "buildCreateApi", function () { return $7c5b8303526498ea$export$f957748792d43646; });
$parcel$export(module.exports, "coreModule", function () { return $7c5b8303526498ea$export$eb718ff92afd6f9b; });

var $dpYkU = parcelRequire("dpYkU");
var $37Zv1 = parcelRequire("37Zv1");
var $3xSPq = parcelRequire("3xSPq");
var $6xl8b = parcelRequire("6xl8b");

var $3xSPq = parcelRequire("3xSPq");

var $6bOi6 = parcelRequire("6bOi6");

var $6xl8b = parcelRequire("6xl8b");
//#region src/query/core/apiState.ts
let $7c5b8303526498ea$export$f4258b89f6bad1d6 = /* @__PURE__ */ function(QueryStatus) {
    QueryStatus["uninitialized"] = "uninitialized";
    QueryStatus["pending"] = "pending";
    QueryStatus["fulfilled"] = "fulfilled";
    QueryStatus["rejected"] = "rejected";
    return QueryStatus;
}({});
const $7c5b8303526498ea$var$STATUS_UNINITIALIZED = "uninitialized";
const $7c5b8303526498ea$var$STATUS_PENDING = "pending";
const $7c5b8303526498ea$var$STATUS_FULFILLED = "fulfilled";
const $7c5b8303526498ea$var$STATUS_REJECTED = "rejected";
function $7c5b8303526498ea$var$getRequestStatusFlags(status) {
    return {
        status: status,
        isUninitialized: status === $7c5b8303526498ea$var$STATUS_UNINITIALIZED,
        isLoading: status === $7c5b8303526498ea$var$STATUS_PENDING,
        isSuccess: status === $7c5b8303526498ea$var$STATUS_FULFILLED,
        isError: status === $7c5b8303526498ea$var$STATUS_REJECTED
    };
}
//#endregion
//#region src/query/utils/copyWithStructuralSharing.ts
const $7c5b8303526498ea$var$isPlainObject = (0, $dpYkU.isPlainObject);
function $7c5b8303526498ea$export$b64d4502a1c929bd(oldObj, newObj) {
    if (oldObj === newObj || !($7c5b8303526498ea$var$isPlainObject(oldObj) && $7c5b8303526498ea$var$isPlainObject(newObj) || Array.isArray(oldObj) && Array.isArray(newObj))) return newObj;
    const newKeys = Object.keys(newObj);
    const oldKeys = Object.keys(oldObj);
    let isSameObject = newKeys.length === oldKeys.length;
    const mergeObj = Array.isArray(newObj) ? [] : {};
    for (const key of newKeys){
        mergeObj[key] = $7c5b8303526498ea$export$b64d4502a1c929bd(oldObj[key], newObj[key]);
        if (isSameObject) isSameObject = Object.is(oldObj[key], mergeObj[key]);
    }
    return isSameObject ? oldObj : mergeObj;
}
//#endregion
//#region src/query/utils/filterMap.ts
function $7c5b8303526498ea$var$filterMap(array, predicate, mapper) {
    return array.reduce((acc, item, i)=>{
        if (predicate(item, i)) acc.push(mapper(item, i));
        return acc;
    }, []).flat();
}
//#endregion
//#region src/query/utils/isAbsoluteUrl.ts
function $7c5b8303526498ea$var$isAbsoluteUrl(url) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
//#endregion
//#region src/query/utils/isDocumentVisible.ts
function $7c5b8303526498ea$var$isDocumentVisible() {
    if (typeof document === "undefined") return true;
    return document.visibilityState !== "hidden";
}
//#endregion
//#region src/query/utils/isNotNullish.ts
function $7c5b8303526498ea$var$isNotNullish(v) {
    return v != null;
}
function $7c5b8303526498ea$var$filterNullishValues(map) {
    return [
        ...map?.values() ?? []
    ].filter($7c5b8303526498ea$var$isNotNullish);
}
//#endregion
//#region src/query/utils/isOnline.ts
function $7c5b8303526498ea$var$isOnline() {
    return typeof navigator === "undefined" ? true : navigator.onLine === void 0 ? true : navigator.onLine;
}
//#endregion
//#region src/query/utils/joinUrls.ts
const $7c5b8303526498ea$var$withoutTrailingSlash = (url)=>url.replace(/\/$/, "");
const $7c5b8303526498ea$var$withoutLeadingSlash = (url)=>url.replace(/^\//, "");
function $7c5b8303526498ea$var$joinUrls(base, url) {
    if (!base) return url;
    if (!url) return base;
    if ($7c5b8303526498ea$var$isAbsoluteUrl(url)) return url;
    const delimiter = base.endsWith("/") || !url.startsWith("?") ? "/" : "";
    base = $7c5b8303526498ea$var$withoutTrailingSlash(base);
    url = $7c5b8303526498ea$var$withoutLeadingSlash(url);
    return `${base}${delimiter}${url}`;
}
//#endregion
//#region src/query/utils/getOrInsert.ts
function $7c5b8303526498ea$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
const $7c5b8303526498ea$var$createNewMap = ()=>/* @__PURE__ */ new Map();
//#endregion
//#region src/query/utils/signals.ts
const $7c5b8303526498ea$var$timeoutSignal = (milliseconds)=>{
    const abortController = new AbortController();
    const timeoutId = setTimeout(()=>{
        const message = "signal timed out";
        const name = "TimeoutError";
        abortController.abort(typeof DOMException !== "undefined" ? new DOMException(message, name) : Object.assign(/* @__PURE__ */ new Error(message), {
            name: name
        }));
    }, milliseconds);
    return {
        signal: abortController.signal,
        clear: ()=>clearTimeout(timeoutId)
    };
};
const $7c5b8303526498ea$var$anySignal = (...signals)=>{
    for (const signal of signals)if (signal.aborted) return AbortSignal.abort(signal.reason);
    const abortController = new AbortController();
    for (const signal of signals)signal.addEventListener("abort", ()=>abortController.abort(signal.reason), {
        signal: abortController.signal,
        once: true
    });
    return abortController.signal;
};
//#endregion
//#region src/query/fetchBaseQuery.ts
const $7c5b8303526498ea$var$defaultFetchFn = (...args)=>fetch(...args);
const $7c5b8303526498ea$var$defaultValidateStatus = (response)=>response.status >= 200 && response.status <= 299;
const $7c5b8303526498ea$var$defaultIsJsonContentType = (headers)=>/ion\/(vnd\.api\+)?json/i.test(headers.get("content-type") || "");
const $7c5b8303526498ea$var$isTimeoutError = (error)=>(error instanceof Error || typeof DOMException !== "undefined" && error instanceof DOMException) && error.name === "TimeoutError";
function $7c5b8303526498ea$var$stripUndefined(obj) {
    if (!(0, $dpYkU.isPlainObject)(obj)) return obj;
    const copy = {
        ...obj
    };
    for (const [k, v] of Object.entries(copy))if (v === void 0) delete copy[k];
    return copy;
}
const $7c5b8303526498ea$var$hasToStringTag = (body, tag)=>Object.prototype.toString.call(body) === `[object ${tag}]`;
const $7c5b8303526498ea$var$needsRuntimeContentType = (body)=>$7c5b8303526498ea$var$hasToStringTag(body, "FormData") || $7c5b8303526498ea$var$hasToStringTag(body, "URLSearchParams");
const $7c5b8303526498ea$var$isJsonifiable = (body)=>typeof body === "object" && body !== null && ((0, $dpYkU.isPlainObject)(body) || Array.isArray(body) || typeof body.toJSON === "function");
function $7c5b8303526498ea$export$adcf4c6133c49b4e({ baseUrl: baseUrl, prepareHeaders: prepareHeaders = (x)=>x, fetchFn: fetchFn = $7c5b8303526498ea$var$defaultFetchFn, paramsSerializer: paramsSerializer, isJsonContentType: isJsonContentType = $7c5b8303526498ea$var$defaultIsJsonContentType, jsonContentType: jsonContentType = "application/json", jsonReplacer: jsonReplacer, timeout: defaultTimeout, responseHandler: globalResponseHandler, validateStatus: globalValidateStatus, ...baseFetchOptions } = {}) {
    if (typeof fetch === "undefined" && fetchFn === $7c5b8303526498ea$var$defaultFetchFn) console.warn("Warning: `fetch` is not available. Please supply a custom `fetchFn` property to use `fetchBaseQuery` on SSR environments.");
    return async (arg, api, extraOptions)=>{
        const { getState: getState, extra: extra, endpoint: endpoint, forced: forced, type: type } = api;
        let meta;
        let { url: url, headers: headers = new Headers(baseFetchOptions.headers), params: params, responseHandler: responseHandler = globalResponseHandler ?? "json", validateStatus: validateStatus = globalValidateStatus ?? $7c5b8303526498ea$var$defaultValidateStatus, timeout: timeout = defaultTimeout, ...rest } = typeof arg == "string" ? {
            url: arg
        } : arg;
        const timeoutController = timeout ? $7c5b8303526498ea$var$timeoutSignal(timeout) : void 0;
        try {
            let config = {
                ...baseFetchOptions,
                signal: timeoutController ? $7c5b8303526498ea$var$anySignal(api.signal, timeoutController.signal) : api.signal,
                ...rest
            };
            headers = new Headers($7c5b8303526498ea$var$stripUndefined(headers));
            config.headers = await prepareHeaders(headers, {
                getState: getState,
                arg: arg,
                extra: extra,
                endpoint: endpoint,
                forced: forced,
                type: type,
                extraOptions: extraOptions
            }) || headers;
            const bodyIsJsonifiable = $7c5b8303526498ea$var$isJsonifiable(config.body);
            if (config.body != null && !bodyIsJsonifiable && typeof config.body !== "string" && ($7c5b8303526498ea$var$needsRuntimeContentType(config.body) || $7c5b8303526498ea$var$defaultIsJsonContentType(config.headers) || isJsonContentType(config.headers))) config.headers.delete("content-type");
            if (!config.headers.has("content-type") && bodyIsJsonifiable) config.headers.set("content-type", jsonContentType);
            if (bodyIsJsonifiable && isJsonContentType(config.headers)) config.body = JSON.stringify(config.body, jsonReplacer);
            if (!config.headers.has("accept")) {
                if (responseHandler === "json") config.headers.set("accept", "application/json");
                else if (responseHandler === "text") config.headers.set("accept", "text/plain, text/html, */*");
            }
            if (params) {
                const divider = ~url.indexOf("?") ? "&" : "?";
                const query = paramsSerializer ? paramsSerializer(params) : new URLSearchParams($7c5b8303526498ea$var$stripUndefined(params));
                url += divider + query;
            }
            url = $7c5b8303526498ea$var$joinUrls(baseUrl, url);
            const request = new Request(url, config);
            meta = {
                request: new Request(url, config)
            };
            let response;
            try {
                response = await fetchFn(request);
            } catch (e) {
                return {
                    error: {
                        status: $7c5b8303526498ea$var$isTimeoutError(e) ? "TIMEOUT_ERROR" : "FETCH_ERROR",
                        error: String(e)
                    },
                    meta: meta
                };
            }
            const responseClone = response.clone();
            meta.response = responseClone;
            let resultData;
            let responseText = "";
            try {
                let handleResponseError;
                let responseHandlerFailed = false;
                await Promise.all([
                    handleResponse(response, responseHandler).then((r)=>resultData = r, (e)=>{
                        responseHandlerFailed = true;
                        handleResponseError = e;
                    }),
                    responseClone.text().then((r)=>responseText = r, ()=>{})
                ]);
                if (responseHandlerFailed) throw handleResponseError;
            } catch (e) {
                if (config.signal?.aborted && $7c5b8303526498ea$var$isTimeoutError(config.signal.reason)) return {
                    error: {
                        status: "TIMEOUT_ERROR",
                        error: String(config.signal.reason)
                    },
                    meta: meta
                };
                return {
                    error: {
                        status: "PARSING_ERROR",
                        originalStatus: response.status,
                        data: responseText,
                        error: String(e)
                    },
                    meta: meta
                };
            }
            return validateStatus(response, resultData) ? {
                data: resultData,
                meta: meta
            } : {
                error: {
                    status: response.status,
                    data: resultData
                },
                meta: meta
            };
        } finally{
            timeoutController?.clear();
        }
    };
    async function handleResponse(response, responseHandler) {
        if (typeof responseHandler === "function") return responseHandler(response);
        if (responseHandler === "content-type") responseHandler = isJsonContentType(response.headers) ? "json" : "text";
        if (responseHandler === "json") {
            const text = await response.text();
            return text.length ? JSON.parse(text) : null;
        }
        return response.text();
    }
}
//#endregion
//#region src/query/HandledError.ts
var $7c5b8303526498ea$var$HandledError = class {
    value;
    meta;
    constructor(value, meta){
        this.value = value;
        this.meta = meta;
    }
};
//#endregion
//#region src/query/retry.ts
async function $7c5b8303526498ea$var$defaultBackoff(attempt = 0, maxRetries = 5, signal) {
    const attempts = Math.min(attempt, maxRetries);
    const timeout = ~~((Math.random() + .4) * (300 << attempts));
    await new Promise((resolve, reject)=>{
        const timeoutId = setTimeout(()=>resolve(), timeout);
        if (signal) {
            const abortHandler = ()=>{
                clearTimeout(timeoutId);
                reject(/* @__PURE__ */ new Error("Aborted"));
            };
            if (signal.aborted) {
                clearTimeout(timeoutId);
                reject(/* @__PURE__ */ new Error("Aborted"));
            } else signal.addEventListener("abort", abortHandler, {
                once: true
            });
        }
    });
}
function $7c5b8303526498ea$var$fail(error, meta) {
    throw Object.assign(new $7c5b8303526498ea$var$HandledError({
        error: error,
        meta: meta
    }), {
        throwImmediately: true
    });
}
function $7c5b8303526498ea$var$failIfAborted(signal) {
    if (signal.aborted) $7c5b8303526498ea$var$fail({
        status: "CUSTOM_ERROR",
        error: "Aborted"
    });
}
const $7c5b8303526498ea$var$EMPTY_OPTIONS = {};
const $7c5b8303526498ea$var$retryWithBackoff = (baseQuery, defaultOptions)=>async (args, api, extraOptions)=>{
        const [maxRetries] = [
            5,
            (defaultOptions || $7c5b8303526498ea$var$EMPTY_OPTIONS).maxRetries,
            (extraOptions || $7c5b8303526498ea$var$EMPTY_OPTIONS).maxRetries
        ].filter((x)=>x !== void 0).slice(-1);
        const defaultRetryCondition = (_, __, { attempt: attempt })=>attempt <= maxRetries;
        const options = {
            maxRetries: maxRetries,
            backoff: $7c5b8303526498ea$var$defaultBackoff,
            retryCondition: defaultRetryCondition,
            ...defaultOptions,
            ...extraOptions
        };
        let retry = 0;
        while(true){
            $7c5b8303526498ea$var$failIfAborted(api.signal);
            try {
                const result = await baseQuery(args, api, extraOptions);
                if (result.error) throw new $7c5b8303526498ea$var$HandledError(result);
                return result;
            } catch (e) {
                retry++;
                if (e.throwImmediately) {
                    if (e instanceof $7c5b8303526498ea$var$HandledError) return e.value;
                    throw e;
                }
                if (e instanceof $7c5b8303526498ea$var$HandledError) {
                    if (!options.retryCondition(e.value.error, args, {
                        attempt: retry,
                        baseQueryApi: api,
                        extraOptions: extraOptions
                    })) return e.value;
                } else if (retry > options.maxRetries) return {
                    error: e
                };
                $7c5b8303526498ea$var$failIfAborted(api.signal);
                try {
                    await options.backoff(retry, options.maxRetries, api.signal);
                } catch (backoffError) {
                    $7c5b8303526498ea$var$failIfAborted(api.signal);
                    throw backoffError;
                }
            }
        }
    };
const $7c5b8303526498ea$export$9369b12211e1fce4 = /* @__PURE__ */ Object.assign($7c5b8303526498ea$var$retryWithBackoff, {
    fail: $7c5b8303526498ea$var$fail
});
//#endregion
//#region src/query/core/setupListeners.ts
const $7c5b8303526498ea$var$INTERNAL_PREFIX = "__rtkq/";
const $7c5b8303526498ea$var$ONLINE = "online";
const $7c5b8303526498ea$var$OFFLINE = "offline";
const $7c5b8303526498ea$var$FOCUS = "focus";
const $7c5b8303526498ea$var$FOCUSED = "focused";
const $7c5b8303526498ea$var$VISIBILITYCHANGE = "visibilitychange";
const $7c5b8303526498ea$var$onFocus = /* @__PURE__ */ (0, $37Zv1.createAction)(`${$7c5b8303526498ea$var$INTERNAL_PREFIX}${$7c5b8303526498ea$var$FOCUSED}`);
const $7c5b8303526498ea$var$onFocusLost = /* @__PURE__ */ (0, $37Zv1.createAction)(`${$7c5b8303526498ea$var$INTERNAL_PREFIX}un${$7c5b8303526498ea$var$FOCUSED}`);
const $7c5b8303526498ea$var$onOnline = /* @__PURE__ */ (0, $37Zv1.createAction)(`${$7c5b8303526498ea$var$INTERNAL_PREFIX}${$7c5b8303526498ea$var$ONLINE}`);
const $7c5b8303526498ea$var$onOffline = /* @__PURE__ */ (0, $37Zv1.createAction)(`${$7c5b8303526498ea$var$INTERNAL_PREFIX}${$7c5b8303526498ea$var$OFFLINE}`);
const $7c5b8303526498ea$var$actions = {
    onFocus: $7c5b8303526498ea$var$onFocus,
    onFocusLost: $7c5b8303526498ea$var$onFocusLost,
    onOnline: $7c5b8303526498ea$var$onOnline,
    onOffline: $7c5b8303526498ea$var$onOffline
};
const $7c5b8303526498ea$var$registeredDispatches = /* @__PURE__ */ new Map();
const $7c5b8303526498ea$var$dispatchToAll = (actionCreator)=>{
    for (const dispatch of [
        ...$7c5b8303526498ea$var$registeredDispatches.keys()
    ])dispatch(actionCreator());
};
const $7c5b8303526498ea$var$windowHandlers = {
    [$7c5b8303526498ea$var$FOCUS]: ()=>$7c5b8303526498ea$var$dispatchToAll($7c5b8303526498ea$var$onFocus),
    [$7c5b8303526498ea$var$VISIBILITYCHANGE]: ()=>{
        if (window.document.visibilityState === "visible") $7c5b8303526498ea$var$dispatchToAll($7c5b8303526498ea$var$onFocus);
        else $7c5b8303526498ea$var$dispatchToAll($7c5b8303526498ea$var$onFocusLost);
    },
    [$7c5b8303526498ea$var$ONLINE]: ()=>$7c5b8303526498ea$var$dispatchToAll($7c5b8303526498ea$var$onOnline),
    [$7c5b8303526498ea$var$OFFLINE]: ()=>$7c5b8303526498ea$var$dispatchToAll($7c5b8303526498ea$var$onOffline)
};
function $7c5b8303526498ea$var$updateWindowListeners(add) {
    Object.entries($7c5b8303526498ea$var$windowHandlers).forEach(([event, handler])=>{
        if (add) window.addEventListener(event, handler, false);
        else window.removeEventListener(event, handler);
    });
}
function $7c5b8303526498ea$export$120c0dbb0351414c(dispatch, customHandler) {
    function defaultHandler() {
        if (typeof window === "undefined" || !window.addEventListener) return ()=>{};
        if ($7c5b8303526498ea$var$registeredDispatches.size === 0) $7c5b8303526498ea$var$updateWindowListeners(true);
        $7c5b8303526498ea$var$registeredDispatches.set(dispatch, ($7c5b8303526498ea$var$registeredDispatches.get(dispatch) ?? 0) + 1);
        let subscribed = true;
        return ()=>{
            if (!subscribed) return;
            subscribed = false;
            const count = $7c5b8303526498ea$var$registeredDispatches.get(dispatch) ?? 0;
            if (count > 1) {
                $7c5b8303526498ea$var$registeredDispatches.set(dispatch, count - 1);
                return;
            }
            $7c5b8303526498ea$var$registeredDispatches.delete(dispatch);
            if ($7c5b8303526498ea$var$registeredDispatches.size === 0) $7c5b8303526498ea$var$updateWindowListeners(false);
        };
    }
    return customHandler ? customHandler(dispatch, $7c5b8303526498ea$var$actions) : defaultHandler();
}
//#endregion
//#region src/query/endpointDefinitions.ts
const $7c5b8303526498ea$var$ENDPOINT_QUERY = "query";
const $7c5b8303526498ea$var$ENDPOINT_MUTATION = "mutation";
const $7c5b8303526498ea$var$ENDPOINT_INFINITEQUERY = "infinitequery";
function $7c5b8303526498ea$var$isQueryDefinition(e) {
    return e.type === $7c5b8303526498ea$var$ENDPOINT_QUERY;
}
function $7c5b8303526498ea$var$isMutationDefinition(e) {
    return e.type === $7c5b8303526498ea$var$ENDPOINT_MUTATION;
}
function $7c5b8303526498ea$var$isInfiniteQueryDefinition(e) {
    return e.type === $7c5b8303526498ea$var$ENDPOINT_INFINITEQUERY;
}
function $7c5b8303526498ea$var$isAnyQueryDefinition(e) {
    return $7c5b8303526498ea$var$isQueryDefinition(e) || $7c5b8303526498ea$var$isInfiniteQueryDefinition(e);
}
function $7c5b8303526498ea$var$calculateProvidedBy(description, result, error, queryArg, meta, assertTagTypes) {
    const finalDescription = $7c5b8303526498ea$var$isFunction(description) ? description(result, error, queryArg, meta) : description;
    if (finalDescription) return $7c5b8303526498ea$var$filterMap(finalDescription, $7c5b8303526498ea$var$isNotNullish, (tag)=>assertTagTypes($7c5b8303526498ea$var$expandTagDescription(tag)));
    return [];
}
function $7c5b8303526498ea$var$isFunction(t) {
    return typeof t === "function";
}
function $7c5b8303526498ea$var$expandTagDescription(description) {
    return typeof description === "string" ? {
        type: description
    } : description;
}
//#endregion
//#region src/query/utils/skipToken.ts
const $7c5b8303526498ea$export$1aa5a89531b7670d = /* @__PURE__ */ Symbol.for("RTKQ/skipToken");
//#endregion
//#region src/tsHelpers.ts
function $7c5b8303526498ea$var$asSafePromise(promise, fallback) {
    return promise.catch(fallback);
}
//#endregion
//#region src/query/apiTypes.ts
const $7c5b8303526498ea$var$getEndpointDefinition = (context, endpointName)=>context.endpointDefinitions[endpointName];
//#endregion
//#region src/query/core/buildInitiate.ts
const $7c5b8303526498ea$var$forceQueryFnSymbol = Symbol("forceQueryFn");
const $7c5b8303526498ea$var$isUpsertQuery = (arg)=>typeof arg[$7c5b8303526498ea$var$forceQueryFnSymbol] === "function";
function $7c5b8303526498ea$var$buildInitiate({ serializeQueryArgs: serializeQueryArgs, queryThunk: queryThunk, infiniteQueryThunk: infiniteQueryThunk, mutationThunk: mutationThunk, api: api, context: context, getInternalState: getInternalState }) {
    const getRunningQueries = (dispatch)=>getInternalState(dispatch)?.runningQueries;
    const getRunningMutations = (dispatch)=>getInternalState(dispatch)?.runningMutations;
    const { unsubscribeQueryResult: unsubscribeQueryResult, removeMutationResult: removeMutationResult, updateSubscriptionOptions: updateSubscriptionOptions } = api.internalActions;
    return {
        buildInitiateQuery: buildInitiateQuery,
        buildInitiateInfiniteQuery: buildInitiateInfiniteQuery,
        buildInitiateMutation: buildInitiateMutation,
        getRunningQueryThunk: getRunningQueryThunk,
        getRunningMutationThunk: getRunningMutationThunk,
        getRunningQueriesThunk: getRunningQueriesThunk,
        getRunningMutationsThunk: getRunningMutationsThunk
    };
    function getRunningQueryThunk(endpointName, queryArgs) {
        return (dispatch)=>{
            const queryCacheKey = serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: $7c5b8303526498ea$var$getEndpointDefinition(context, endpointName),
                endpointName: endpointName
            });
            return getRunningQueries(dispatch)?.get(queryCacheKey);
        };
    }
    function getRunningMutationThunk(_endpointName, fixedCacheKeyOrRequestId) {
        return (dispatch)=>{
            return getRunningMutations(dispatch)?.get(fixedCacheKeyOrRequestId);
        };
    }
    function getRunningQueriesThunk() {
        return (dispatch)=>$7c5b8303526498ea$var$filterNullishValues(getRunningQueries(dispatch));
    }
    function getRunningMutationsThunk() {
        return (dispatch)=>$7c5b8303526498ea$var$filterNullishValues(getRunningMutations(dispatch));
    }
    function middlewareWarning(dispatch) {}
    function buildInitiateAnyQuery(endpointName, endpointDefinition) {
        const queryAction = (arg, { subscribe: subscribe = true, forceRefetch: forceRefetch, subscriptionOptions: subscriptionOptions, [$7c5b8303526498ea$var$forceQueryFnSymbol]: forceQueryFn, ...rest } = {})=>(dispatch, getState)=>{
                const queryCacheKey = arg === $7c5b8303526498ea$export$1aa5a89531b7670d ? `${endpointName}(skipToken)` : serializeQueryArgs({
                    queryArgs: arg,
                    endpointDefinition: endpointDefinition,
                    endpointName: endpointName
                });
                let thunk;
                const commonThunkArgs = {
                    ...rest,
                    type: $7c5b8303526498ea$var$ENDPOINT_QUERY,
                    subscribe: subscribe,
                    forceRefetch: forceRefetch,
                    subscriptionOptions: subscriptionOptions,
                    endpointName: endpointName,
                    originalArgs: arg,
                    queryCacheKey: queryCacheKey,
                    [$7c5b8303526498ea$var$forceQueryFnSymbol]: forceQueryFn
                };
                if ($7c5b8303526498ea$var$isQueryDefinition(endpointDefinition)) thunk = queryThunk(commonThunkArgs);
                else {
                    const { direction: direction, initialPageParam: initialPageParam, refetchCachedPages: refetchCachedPages } = rest;
                    thunk = infiniteQueryThunk({
                        ...commonThunkArgs,
                        direction: direction,
                        initialPageParam: initialPageParam,
                        refetchCachedPages: refetchCachedPages
                    });
                }
                const selector = api.endpoints[endpointName].select(arg);
                const thunkResult = dispatch(thunk);
                const stateAfter = selector(getState());
                middlewareWarning(dispatch);
                const { requestId: requestId, abort: abort } = thunkResult;
                const skippedSynchronously = stateAfter.requestId !== requestId;
                const runningQuery = arg === $7c5b8303526498ea$export$1aa5a89531b7670d ? void 0 : getRunningQueries(dispatch)?.get(queryCacheKey);
                const selectFromState = ()=>selector(getState());
                const statePromise = Object.assign(forceQueryFn ? thunkResult.then(selectFromState) : skippedSynchronously && !runningQuery ? Promise.resolve(stateAfter) : Promise.all([
                    runningQuery,
                    thunkResult
                ]).then(selectFromState), {
                    arg: arg,
                    requestId: requestId,
                    subscriptionOptions: subscriptionOptions,
                    queryCacheKey: queryCacheKey,
                    abort: abort,
                    async unwrap () {
                        const result = await statePromise;
                        if (result.isError) throw result.error;
                        return result.data;
                    },
                    refetch: (options)=>dispatch(queryAction(arg, {
                            subscribe: false,
                            forceRefetch: true,
                            ...options
                        })),
                    unsubscribe () {
                        if (subscribe) dispatch(unsubscribeQueryResult({
                            queryCacheKey: queryCacheKey,
                            requestId: requestId
                        }));
                    },
                    updateSubscriptionOptions (options) {
                        statePromise.subscriptionOptions = options;
                        dispatch(updateSubscriptionOptions({
                            endpointName: endpointName,
                            requestId: requestId,
                            queryCacheKey: queryCacheKey,
                            options: options
                        }));
                    }
                });
                if (!skippedSynchronously && !forceQueryFn) {
                    const runningQueries = getRunningQueries(dispatch);
                    runningQueries.set(queryCacheKey, statePromise);
                    const removeRunningQuery = ()=>{
                        if (runningQueries.get(queryCacheKey) === statePromise) runningQueries.delete(queryCacheKey);
                    };
                    statePromise.then(removeRunningQuery, removeRunningQuery);
                }
                return statePromise;
            };
        return queryAction;
    }
    function buildInitiateQuery(endpointName, endpointDefinition) {
        return buildInitiateAnyQuery(endpointName, endpointDefinition);
    }
    function buildInitiateInfiniteQuery(endpointName, endpointDefinition) {
        return buildInitiateAnyQuery(endpointName, endpointDefinition);
    }
    function buildInitiateMutation(endpointName) {
        return (arg, { track: track = true, fixedCacheKey: fixedCacheKey } = {})=>(dispatch, getState)=>{
                const thunkResult = dispatch(mutationThunk({
                    type: "mutation",
                    endpointName: endpointName,
                    originalArgs: arg,
                    track: track,
                    fixedCacheKey: fixedCacheKey
                }));
                middlewareWarning(dispatch);
                const { requestId: requestId, abort: abort, unwrap: unwrap } = thunkResult;
                const returnValuePromise = $7c5b8303526498ea$var$asSafePromise(thunkResult.unwrap().then((data)=>({
                        data: data
                    })), (error)=>({
                        error: error
                    }));
                const reset = ()=>{
                    dispatch(removeMutationResult({
                        requestId: requestId,
                        fixedCacheKey: fixedCacheKey
                    }));
                };
                const ret = Object.assign(returnValuePromise, {
                    arg: thunkResult.arg,
                    requestId: requestId,
                    abort: abort,
                    unwrap: unwrap,
                    reset: reset
                });
                const runningMutations = getRunningMutations(dispatch);
                runningMutations.set(requestId, ret);
                ret.then(()=>{
                    runningMutations.delete(requestId);
                });
                if (fixedCacheKey) {
                    runningMutations.set(fixedCacheKey, ret);
                    ret.then(()=>{
                        if (runningMutations.get(fixedCacheKey) === ret) runningMutations.delete(fixedCacheKey);
                    });
                }
                return ret;
            };
    }
}
//#endregion
//#region src/query/standardSchema.ts
var $7c5b8303526498ea$export$6c822e36c9b9dfb4 = class extends (0, $6bOi6.SchemaError) {
    value;
    schemaName;
    _bqMeta;
    constructor(issues, value, schemaName, _bqMeta){
        super(issues);
        this.value = value;
        this.schemaName = schemaName;
        this._bqMeta = _bqMeta;
    }
};
const $7c5b8303526498ea$var$shouldSkip = (skipSchemaValidation, schemaName)=>Array.isArray(skipSchemaValidation) ? skipSchemaValidation.includes(schemaName) : !!skipSchemaValidation;
async function $7c5b8303526498ea$var$parseWithSchema(schema, data, schemaName, bqMeta) {
    const result = await schema["~standard"].validate(data);
    if (result.issues) throw new $7c5b8303526498ea$export$6c822e36c9b9dfb4(result.issues, data, schemaName, bqMeta);
    return result.value;
}
//#endregion
//#region src/query/core/buildThunks.ts
function $7c5b8303526498ea$var$defaultTransformResponse(baseQueryReturnValue) {
    return baseQueryReturnValue;
}
const $7c5b8303526498ea$var$addShouldAutoBatch = (arg = {})=>{
    return {
        ...arg,
        [(0, $37Zv1.SHOULD_AUTOBATCH)]: true
    };
};
function $7c5b8303526498ea$var$buildThunks({ reducerPath: reducerPath, baseQuery: baseQuery, context: { endpointDefinitions: endpointDefinitions }, serializeQueryArgs: serializeQueryArgs, api: api, assertTagType: assertTagType, selectors: selectors, onSchemaFailure: onSchemaFailure, catchSchemaFailure: globalCatchSchemaFailure, skipSchemaValidation: globalSkipSchemaValidation }) {
    const lastSeqByStore = /* @__PURE__ */ new WeakMap();
    const requestStarts = /* @__PURE__ */ new Map();
    function startRequest(requestId, getState) {
        const seq = (lastSeqByStore.get(getState) ?? 0) + 1;
        lastSeqByStore.set(getState, seq);
        const requestStart = {
            startedTimeStamp: Date.now(),
            seq: seq
        };
        requestStarts.set(requestId, requestStart);
        return requestStart;
    }
    function takeRequestStart(requestId, getState) {
        const requestStart = requestStarts.get(requestId) ?? startRequest(requestId, getState);
        requestStarts.delete(requestId);
        return requestStart;
    }
    const patchQueryData = (endpointName, arg, patches, updateProvided)=>(dispatch, getState)=>{
            const endpointDefinition = endpointDefinitions[endpointName];
            const queryCacheKey = serializeQueryArgs({
                queryArgs: arg,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            dispatch(api.internalActions.queryResultPatched({
                queryCacheKey: queryCacheKey,
                patches: patches
            }));
            if (!updateProvided) return;
            const newValue = api.endpoints[endpointName].select(arg)(getState());
            const providedTags = $7c5b8303526498ea$var$calculateProvidedBy(endpointDefinition.providesTags, newValue.data, void 0, arg, {}, assertTagType);
            dispatch(api.internalActions.updateProvidedBy([
                {
                    queryCacheKey: queryCacheKey,
                    providedTags: providedTags
                }
            ]));
        };
    function addToStart(items, item, max = 0) {
        const newItems = [
            item,
            ...items
        ];
        return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
    }
    function addToEnd(items, item, max = 0) {
        const newItems = [
            ...items,
            item
        ];
        return max && newItems.length > max ? newItems.slice(1) : newItems;
    }
    const updateQueryData = (endpointName, arg, updateRecipe, updateProvided = true)=>(dispatch, getState)=>{
            const currentState = api.endpoints[endpointName].select(arg)(getState());
            const ret = {
                patches: [],
                inversePatches: [],
                undo: ()=>dispatch(api.util.patchQueryData(endpointName, arg, ret.inversePatches, updateProvided))
            };
            if (currentState.status === "uninitialized") return ret;
            let newValue;
            if ("data" in currentState) {
                if ((0, $3xSPq.isDraftable)(currentState.data)) {
                    const [value, patches, inversePatches] = (0, $3xSPq.produceWithPatches)(currentState.data, updateRecipe);
                    ret.patches.push(...patches);
                    ret.inversePatches.push(...inversePatches);
                    newValue = value;
                } else {
                    newValue = updateRecipe(currentState.data);
                    ret.patches.push({
                        op: "replace",
                        path: [],
                        value: newValue
                    });
                    ret.inversePatches.push({
                        op: "replace",
                        path: [],
                        value: currentState.data
                    });
                }
            }
            if (ret.patches.length === 0) return ret;
            dispatch(api.util.patchQueryData(endpointName, arg, ret.patches, updateProvided));
            return ret;
        };
    const upsertQueryData = (endpointName, arg, value)=>(dispatch)=>{
            return dispatch(api.endpoints[endpointName].initiate(arg, {
                subscribe: false,
                forceRefetch: true,
                [$7c5b8303526498ea$var$forceQueryFnSymbol]: ()=>({
                        data: value
                    })
            }));
        };
    const getTransformCallbackForEndpoint = (endpointDefinition, transformFieldName)=>{
        return endpointDefinition.query && endpointDefinition[transformFieldName] ? endpointDefinition[transformFieldName] : $7c5b8303526498ea$var$defaultTransformResponse;
    };
    const executeEndpoint = async (arg, { signal: signal, abort: abort, rejectWithValue: rejectWithValue, fulfillWithValue: fulfillWithValue, dispatch: dispatch, getState: getState, extra: extra, requestId: requestId })=>{
        const requestStart = takeRequestStart(requestId, getState);
        const endpointDefinition = endpointDefinitions[arg.endpointName];
        const { metaSchema: metaSchema, skipSchemaValidation: skipSchemaValidation = globalSkipSchemaValidation } = endpointDefinition;
        const isQuery = arg.type === $7c5b8303526498ea$var$ENDPOINT_QUERY;
        try {
            let transformResponse = $7c5b8303526498ea$var$defaultTransformResponse;
            const baseQueryApi = {
                signal: signal,
                abort: abort,
                dispatch: dispatch,
                getState: getState,
                extra: extra,
                endpoint: arg.endpointName,
                type: arg.type,
                forced: isQuery ? isForcedQuery(arg, getState()) : void 0,
                queryCacheKey: isQuery ? arg.queryCacheKey : void 0
            };
            const forceQueryFn = isQuery ? arg[$7c5b8303526498ea$var$forceQueryFnSymbol] : void 0;
            let finalQueryReturnValue;
            const fetchPage = async (data, param, maxPages, previous)=>{
                if (param == null && data.pages.length) return Promise.resolve({
                    data: data
                });
                const pageResponse = await executeRequest({
                    queryArg: arg.originalArgs,
                    pageParam: param
                });
                const addTo = previous ? addToStart : addToEnd;
                return {
                    data: {
                        pages: addTo(data.pages, pageResponse.data, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    },
                    meta: pageResponse.meta
                };
            };
            async function executeRequest(finalQueryArg) {
                let result;
                const { extraOptions: extraOptions, argSchema: argSchema, rawResponseSchema: rawResponseSchema, responseSchema: responseSchema } = endpointDefinition;
                if (argSchema && !$7c5b8303526498ea$var$shouldSkip(skipSchemaValidation, "arg")) finalQueryArg = await $7c5b8303526498ea$var$parseWithSchema(argSchema, finalQueryArg, "argSchema", {});
                if (forceQueryFn) result = forceQueryFn();
                else if (endpointDefinition.query) {
                    transformResponse = getTransformCallbackForEndpoint(endpointDefinition, "transformResponse");
                    result = await baseQuery(endpointDefinition.query(finalQueryArg), baseQueryApi, extraOptions);
                } else result = await endpointDefinition.queryFn(finalQueryArg, baseQueryApi, extraOptions, (arg)=>baseQuery(arg, baseQueryApi, extraOptions));
                if (result.error) throw new $7c5b8303526498ea$var$HandledError(result.error, result.meta);
                let { data: data } = result;
                if (rawResponseSchema && !$7c5b8303526498ea$var$shouldSkip(skipSchemaValidation, "rawResponse")) data = await $7c5b8303526498ea$var$parseWithSchema(rawResponseSchema, result.data, "rawResponseSchema", result.meta);
                let transformedResponse = await transformResponse(data, result.meta, finalQueryArg);
                if (responseSchema && !$7c5b8303526498ea$var$shouldSkip(skipSchemaValidation, "response")) transformedResponse = await $7c5b8303526498ea$var$parseWithSchema(responseSchema, transformedResponse, "responseSchema", result.meta);
                return {
                    ...result,
                    data: transformedResponse
                };
            }
            if (isQuery && "infiniteQueryOptions" in endpointDefinition) {
                const { infiniteQueryOptions: infiniteQueryOptions } = endpointDefinition;
                const { maxPages: maxPages = Infinity } = infiniteQueryOptions;
                const refetchCachedPages = arg.refetchCachedPages ?? infiniteQueryOptions.refetchCachedPages ?? true;
                let result;
                const blankData = {
                    pages: [],
                    pageParams: []
                };
                const cachedData = selectors.selectQueryEntry(getState(), arg.queryCacheKey)?.data;
                const existingData = isForcedQuery(arg, getState()) && !arg.direction || !cachedData ? blankData : cachedData;
                if ("direction" in arg && arg.direction && existingData.pages.length) {
                    const previous = arg.direction === "backward";
                    result = await fetchPage(existingData, (previous ? $7c5b8303526498ea$var$getPreviousPageParam : $7c5b8303526498ea$var$getNextPageParam)(infiniteQueryOptions, existingData, arg.originalArgs), maxPages, previous);
                } else {
                    const { initialPageParam: initialPageParam = infiniteQueryOptions.initialPageParam } = arg;
                    const cachedPageParams = cachedData?.pageParams ?? [];
                    const firstPageParam = cachedPageParams[0] ?? initialPageParam;
                    const totalPages = cachedPageParams.length;
                    result = await fetchPage(existingData, firstPageParam, maxPages);
                    if (forceQueryFn) result = {
                        data: result.data.pages[0]
                    };
                    if (refetchCachedPages) for(let i = 1; i < totalPages; i++){
                        const param = $7c5b8303526498ea$var$getNextPageParam(infiniteQueryOptions, result.data, arg.originalArgs);
                        result = await fetchPage(result.data, param, maxPages);
                    }
                }
                finalQueryReturnValue = result;
            } else finalQueryReturnValue = await executeRequest(arg.originalArgs);
            if (metaSchema && !$7c5b8303526498ea$var$shouldSkip(skipSchemaValidation, "meta") && finalQueryReturnValue.meta) finalQueryReturnValue.meta = await $7c5b8303526498ea$var$parseWithSchema(metaSchema, finalQueryReturnValue.meta, "metaSchema", finalQueryReturnValue.meta);
            return fulfillWithValue(finalQueryReturnValue.data, $7c5b8303526498ea$var$addShouldAutoBatch({
                ...requestStart,
                fulfilledTimeStamp: Date.now(),
                baseQueryMeta: finalQueryReturnValue.meta
            }));
        } catch (error) {
            let caughtError = error;
            if (caughtError instanceof $7c5b8303526498ea$var$HandledError) {
                let transformErrorResponse = getTransformCallbackForEndpoint(endpointDefinition, "transformErrorResponse");
                const { rawErrorResponseSchema: rawErrorResponseSchema, errorResponseSchema: errorResponseSchema } = endpointDefinition;
                let { value: value, meta: meta } = caughtError;
                try {
                    if (rawErrorResponseSchema && !$7c5b8303526498ea$var$shouldSkip(skipSchemaValidation, "rawErrorResponse")) value = await $7c5b8303526498ea$var$parseWithSchema(rawErrorResponseSchema, value, "rawErrorResponseSchema", meta);
                    if (metaSchema && !$7c5b8303526498ea$var$shouldSkip(skipSchemaValidation, "meta")) meta = await $7c5b8303526498ea$var$parseWithSchema(metaSchema, meta, "metaSchema", meta);
                    let transformedErrorResponse = await transformErrorResponse(value, meta, arg.originalArgs);
                    if (errorResponseSchema && !$7c5b8303526498ea$var$shouldSkip(skipSchemaValidation, "errorResponse")) transformedErrorResponse = await $7c5b8303526498ea$var$parseWithSchema(errorResponseSchema, transformedErrorResponse, "errorResponseSchema", meta);
                    return rejectWithValue(transformedErrorResponse, $7c5b8303526498ea$var$addShouldAutoBatch({
                        ...requestStart,
                        baseQueryMeta: meta
                    }));
                } catch (e) {
                    caughtError = e;
                }
            }
            try {
                if (caughtError instanceof $7c5b8303526498ea$export$6c822e36c9b9dfb4) {
                    const info = {
                        endpoint: arg.endpointName,
                        arg: arg.originalArgs,
                        type: arg.type,
                        queryCacheKey: isQuery ? arg.queryCacheKey : void 0
                    };
                    endpointDefinition.onSchemaFailure?.(caughtError, info);
                    onSchemaFailure?.(caughtError, info);
                    const { catchSchemaFailure: catchSchemaFailure = globalCatchSchemaFailure } = endpointDefinition;
                    if (catchSchemaFailure) return rejectWithValue(catchSchemaFailure(caughtError, info), $7c5b8303526498ea$var$addShouldAutoBatch({
                        ...requestStart,
                        baseQueryMeta: caughtError._bqMeta
                    }));
                }
            } catch (e) {
                caughtError = e;
            }
            console.error(caughtError);
            throw caughtError;
        }
    };
    function isForcedQuery(arg, state) {
        const requestState = selectors.selectQueryEntry(state, arg.queryCacheKey);
        const baseFetchOnMountOrArgChange = selectors.selectConfig(state).refetchOnMountOrArgChange;
        const fulfilledVal = requestState?.fulfilledTimeStamp;
        const refetchVal = arg.forceRefetch ?? (arg.subscribe && baseFetchOnMountOrArgChange);
        if (refetchVal) return refetchVal === true || (Number(/* @__PURE__ */ new Date()) - Number(fulfilledVal)) / 1e3 >= refetchVal;
        return false;
    }
    const createQueryThunk = ()=>{
        return (0, $37Zv1.createAsyncThunk)(`${reducerPath}/executeQuery`, executeEndpoint, {
            getPendingMeta ({ arg: arg, requestId: requestId }, { getState: getState }) {
                const endpointDefinition = endpointDefinitions[arg.endpointName];
                return $7c5b8303526498ea$var$addShouldAutoBatch({
                    ...startRequest(requestId, getState),
                    ...$7c5b8303526498ea$var$isInfiniteQueryDefinition(endpointDefinition) ? {
                        direction: arg.direction
                    } : {}
                });
            },
            condition (queryThunkArg, { getState: getState }) {
                const state = getState();
                const requestState = selectors.selectQueryEntry(state, queryThunkArg.queryCacheKey);
                const fulfilledVal = requestState?.fulfilledTimeStamp;
                const currentArg = queryThunkArg.originalArgs;
                const previousArg = requestState?.originalArgs;
                const endpointDefinition = endpointDefinitions[queryThunkArg.endpointName];
                const direction = queryThunkArg.direction;
                if ($7c5b8303526498ea$var$isUpsertQuery(queryThunkArg)) return true;
                if (queryThunkArg.originalArgs === $7c5b8303526498ea$export$1aa5a89531b7670d) return false;
                if (requestState?.status === "pending") return false;
                if (isForcedQuery(queryThunkArg, state)) return true;
                if ($7c5b8303526498ea$var$isQueryDefinition(endpointDefinition) && endpointDefinition?.forceRefetch?.({
                    currentArg: currentArg,
                    previousArg: previousArg,
                    endpointState: requestState,
                    state: state
                })) return true;
                if (fulfilledVal && !direction) return false;
                if (direction && $7c5b8303526498ea$var$isInfiniteQueryDefinition(endpointDefinition)) {
                    const cachedData = requestState?.data;
                    if (cachedData?.pages.length) {
                        const { infiniteQueryOptions: infiniteQueryOptions } = endpointDefinition;
                        if ((direction === "forward" ? $7c5b8303526498ea$var$getNextPageParam : $7c5b8303526498ea$var$getPreviousPageParam)(infiniteQueryOptions, cachedData, currentArg) == null) return false;
                    }
                }
                return true;
            },
            dispatchConditionRejection: true
        });
    };
    const queryThunk = createQueryThunk();
    const infiniteQueryThunk = createQueryThunk();
    const mutationThunk = (0, $37Zv1.createAsyncThunk)(`${reducerPath}/executeMutation`, executeEndpoint, {
        getPendingMeta ({ requestId: requestId }, { getState: getState }) {
            return $7c5b8303526498ea$var$addShouldAutoBatch(startRequest(requestId, getState));
        }
    });
    const hasTheForce = (options)=>"force" in options;
    const hasMaxAge = (options)=>"ifOlderThan" in options;
    const prefetch = (endpointName, arg, options = {})=>(dispatch, getState)=>{
            const force = hasTheForce(options) && options.force;
            const maxAge = hasMaxAge(options) && options.ifOlderThan;
            const queryAction = (force = true)=>{
                const options = {
                    forceRefetch: force,
                    subscribe: false
                };
                return api.endpoints[endpointName].initiate(arg, options);
            };
            const latestStateValue = api.endpoints[endpointName].select(arg)(getState());
            if (force) dispatch(queryAction());
            else if (maxAge) {
                const lastFulfilledTs = latestStateValue?.fulfilledTimeStamp;
                if (!lastFulfilledTs) {
                    dispatch(queryAction());
                    return;
                }
                if ((Number(/* @__PURE__ */ new Date()) - Number(new Date(lastFulfilledTs))) / 1e3 >= maxAge) dispatch(queryAction());
            } else dispatch(queryAction(false));
        };
    function matchesEndpoint(endpointName) {
        return (action)=>action?.meta?.arg?.endpointName === endpointName;
    }
    function buildMatchThunkActions(thunk, endpointName) {
        return {
            matchPending: (0, $37Zv1.isAllOf)((0, $37Zv1.isPending)(thunk), matchesEndpoint(endpointName)),
            matchFulfilled: (0, $37Zv1.isAllOf)((0, $37Zv1.isFulfilled)(thunk), matchesEndpoint(endpointName)),
            matchRejected: (0, $37Zv1.isAllOf)((0, $37Zv1.isRejected)(thunk), matchesEndpoint(endpointName))
        };
    }
    return {
        queryThunk: queryThunk,
        mutationThunk: mutationThunk,
        infiniteQueryThunk: infiniteQueryThunk,
        prefetch: prefetch,
        updateQueryData: updateQueryData,
        upsertQueryData: upsertQueryData,
        patchQueryData: patchQueryData,
        buildMatchThunkActions: buildMatchThunkActions
    };
}
function $7c5b8303526498ea$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }, queryArg) {
    const lastIndex = pages.length - 1;
    return options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams, queryArg);
}
function $7c5b8303526498ea$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }, queryArg) {
    return options.getPreviousPageParam?.(pages[0], pages, pageParams[0], pageParams, queryArg);
}
function $7c5b8303526498ea$var$calculateProvidedByThunk(action, type, endpointDefinitions, assertTagType) {
    return $7c5b8303526498ea$var$calculateProvidedBy(endpointDefinitions[action.meta.arg.endpointName][type], (0, $37Zv1.isFulfilled)(action) ? action.payload : void 0, (0, $37Zv1.isRejectedWithValue)(action) ? action.payload : void 0, action.meta.arg.originalArgs, "baseQueryMeta" in action.meta ? action.meta.baseQueryMeta : void 0, assertTagType);
}
//#endregion
//#region src/query/utils/getCurrent.ts
function $7c5b8303526498ea$var$getCurrent(value) {
    return (0, $3xSPq.isDraft)(value) ? (0, $3xSPq.current)(value) : value;
}
//#endregion
//#region src/query/core/buildSlice.ts
function $7c5b8303526498ea$var$updateQuerySubstateIfExists(state, queryCacheKey, update) {
    const substate = state[queryCacheKey];
    if (substate) update(substate);
}
function $7c5b8303526498ea$var$getMutationCacheKey(id) {
    return ("arg" in id ? id.arg.fixedCacheKey : id.fixedCacheKey) ?? id.requestId;
}
function $7c5b8303526498ea$var$updateMutationSubstateIfExists(state, id, update) {
    const substate = state[$7c5b8303526498ea$var$getMutationCacheKey(id)];
    if (substate) update(substate);
}
function $7c5b8303526498ea$var$areTagsEqual(existing, next) {
    if (!existing || existing.length !== next.length) return false;
    for(let i = 0; i < next.length; i++)if (existing[i].type !== next[i].type || existing[i].id !== next[i].id) return false;
    return true;
}
const $7c5b8303526498ea$var$initialState = {};
function $7c5b8303526498ea$var$buildSlice({ reducerPath: reducerPath, queryThunk: queryThunk, mutationThunk: mutationThunk, serializeQueryArgs: serializeQueryArgs, context: { endpointDefinitions: definitions, apiUid: apiUid, extractRehydrationInfo: extractRehydrationInfo, hasRehydrationInfo: hasRehydrationInfo }, assertTagType: assertTagType, config: config }) {
    const resetApiState = (0, $37Zv1.createAction)(`${reducerPath}/resetApiState`);
    function writePendingCacheEntry(draft, arg, upserting, meta) {
        draft[arg.queryCacheKey] ??= {
            status: $7c5b8303526498ea$var$STATUS_UNINITIALIZED,
            endpointName: arg.endpointName
        };
        $7c5b8303526498ea$var$updateQuerySubstateIfExists(draft, arg.queryCacheKey, (substate)=>{
            if (!(upserting && substate.requestId)) {
                substate.status = $7c5b8303526498ea$var$STATUS_PENDING;
                substate.requestId = meta.requestId;
            }
            if (arg.originalArgs !== void 0) substate.originalArgs = arg.originalArgs;
            substate.startedTimeStamp = meta.startedTimeStamp;
            const endpointDefinition = definitions[meta.arg.endpointName];
            if ($7c5b8303526498ea$var$isInfiniteQueryDefinition(endpointDefinition) && "direction" in arg) substate.direction = arg.direction;
        });
    }
    function writeFulfilledCacheEntry(draft, meta, payload, upserting) {
        $7c5b8303526498ea$var$updateQuerySubstateIfExists(draft, meta.arg.queryCacheKey, (substate)=>{
            if (substate.requestId !== meta.requestId && !upserting) return;
            const { merge: merge } = definitions[meta.arg.endpointName];
            substate.status = $7c5b8303526498ea$var$STATUS_FULFILLED;
            if (merge) {
                if (substate.data !== void 0) {
                    const { fulfilledTimeStamp: fulfilledTimeStamp, arg: arg, baseQueryMeta: baseQueryMeta, requestId: requestId } = meta;
                    substate.data = (0, $3xSPq.produce)(substate.data, (draftSubstateData)=>{
                        return merge(draftSubstateData, payload, {
                            arg: arg.originalArgs,
                            baseQueryMeta: baseQueryMeta,
                            fulfilledTimeStamp: fulfilledTimeStamp,
                            requestId: requestId
                        });
                    });
                } else substate.data = payload;
            } else substate.data = definitions[meta.arg.endpointName].structuralSharing ?? true ? $7c5b8303526498ea$export$b64d4502a1c929bd((0, $3xSPq.isDraft)(substate.data) ? (0, $3xSPq.original)(substate.data) : substate.data, payload) : payload;
            delete substate.error;
            substate.fulfilledTimeStamp = meta.fulfilledTimeStamp;
        });
    }
    const querySlice = (0, $37Zv1.createSlice)({
        name: `${reducerPath}/queries`,
        initialState: $7c5b8303526498ea$var$initialState,
        reducers: {
            removeQueryResult: {
                reducer (draft, { payload: { queryCacheKey: queryCacheKey } }) {
                    delete draft[queryCacheKey];
                },
                prepare: (0, $37Zv1.prepareAutoBatched)()
            },
            cacheEntriesUpserted: {
                reducer (draft, action) {
                    for (const entry of action.payload){
                        const { queryDescription: arg, value: value } = entry;
                        writePendingCacheEntry(draft, arg, true, {
                            arg: arg,
                            requestId: action.meta.requestId,
                            startedTimeStamp: action.meta.timestamp
                        });
                        writeFulfilledCacheEntry(draft, {
                            arg: arg,
                            requestId: action.meta.requestId,
                            fulfilledTimeStamp: action.meta.timestamp,
                            baseQueryMeta: {}
                        }, value, true);
                    }
                },
                prepare: (payload)=>{
                    const queryDescriptions = [];
                    for (const { endpointName: endpointName, arg: arg, value: value } of payload){
                        const endpointDefinition = definitions[endpointName];
                        if (!endpointDefinition || !$7c5b8303526498ea$var$isAnyQueryDefinition(endpointDefinition)) continue;
                        const queryDescription = {
                            type: $7c5b8303526498ea$var$ENDPOINT_QUERY,
                            endpointName: endpointName,
                            originalArgs: arg,
                            queryCacheKey: serializeQueryArgs({
                                queryArgs: arg,
                                endpointDefinition: endpointDefinition,
                                endpointName: endpointName
                            })
                        };
                        let providedTags;
                        try {
                            providedTags = $7c5b8303526498ea$var$calculateProvidedByThunk({
                                type: "UNKNOWN",
                                payload: value,
                                meta: {
                                    requestStatus: "fulfilled",
                                    requestId: "UNKNOWN",
                                    arg: queryDescription
                                }
                            }, "providesTags", definitions, assertTagType);
                        } catch (error) {
                            continue;
                        }
                        queryDescriptions.push({
                            queryDescription: queryDescription,
                            value: value,
                            providedTags: providedTags
                        });
                    }
                    return {
                        payload: queryDescriptions,
                        meta: {
                            [(0, $37Zv1.SHOULD_AUTOBATCH)]: true,
                            requestId: (0, $37Zv1.nanoid)(),
                            timestamp: Date.now()
                        }
                    };
                }
            },
            queryResultPatched: {
                reducer (draft, { payload: { queryCacheKey: queryCacheKey, patches: patches } }) {
                    $7c5b8303526498ea$var$updateQuerySubstateIfExists(draft, queryCacheKey, (substate)=>{
                        substate.data = (0, $3xSPq.applyPatches)(substate.data, patches.concat());
                    });
                },
                prepare: (0, $37Zv1.prepareAutoBatched)()
            }
        },
        extraReducers (builder) {
            builder.addCase(queryThunk.pending, (draft, { meta: meta, meta: { arg: arg } })=>{
                writePendingCacheEntry(draft, arg, $7c5b8303526498ea$var$isUpsertQuery(arg), meta);
            }).addCase(queryThunk.fulfilled, (draft, { meta: meta, payload: payload })=>{
                writeFulfilledCacheEntry(draft, meta, payload, $7c5b8303526498ea$var$isUpsertQuery(meta.arg));
            }).addCase(queryThunk.rejected, (draft, { meta: { condition: condition, arg: arg, requestId: requestId }, error: error, payload: payload })=>{
                $7c5b8303526498ea$var$updateQuerySubstateIfExists(draft, arg.queryCacheKey, (substate)=>{
                    if (condition) ;
                    else {
                        if (substate.requestId !== requestId) return;
                        substate.status = $7c5b8303526498ea$var$STATUS_REJECTED;
                        substate.error = payload ?? error;
                    }
                });
            }).addMatcher(hasRehydrationInfo, (draft, action)=>{
                const { queries: queries } = extractRehydrationInfo(action);
                for (const [key, entry] of Object.entries(queries))if (entry?.status === "fulfilled" || entry?.status === "rejected") draft[key] = entry;
            });
        }
    });
    const mutationSlice = (0, $37Zv1.createSlice)({
        name: `${reducerPath}/mutations`,
        initialState: $7c5b8303526498ea$var$initialState,
        reducers: {
            removeMutationResult: {
                reducer (draft, { payload: payload }) {
                    const cacheKey = $7c5b8303526498ea$var$getMutationCacheKey(payload);
                    if (cacheKey in draft) delete draft[cacheKey];
                },
                prepare: (0, $37Zv1.prepareAutoBatched)()
            }
        },
        extraReducers (builder) {
            builder.addCase(mutationThunk.pending, (draft, { meta: meta, meta: { requestId: requestId, arg: arg, startedTimeStamp: startedTimeStamp } })=>{
                if (!arg.track) return;
                draft[$7c5b8303526498ea$var$getMutationCacheKey(meta)] = {
                    requestId: requestId,
                    status: $7c5b8303526498ea$var$STATUS_PENDING,
                    endpointName: arg.endpointName,
                    startedTimeStamp: startedTimeStamp
                };
            }).addCase(mutationThunk.fulfilled, (draft, { payload: payload, meta: meta })=>{
                if (!meta.arg.track) return;
                $7c5b8303526498ea$var$updateMutationSubstateIfExists(draft, meta, (substate)=>{
                    if (substate.requestId !== meta.requestId) return;
                    substate.status = $7c5b8303526498ea$var$STATUS_FULFILLED;
                    substate.data = payload;
                    substate.fulfilledTimeStamp = meta.fulfilledTimeStamp;
                });
            }).addCase(mutationThunk.rejected, (draft, { payload: payload, error: error, meta: meta })=>{
                if (!meta.arg.track) return;
                $7c5b8303526498ea$var$updateMutationSubstateIfExists(draft, meta, (substate)=>{
                    if (substate.requestId !== meta.requestId) return;
                    substate.status = $7c5b8303526498ea$var$STATUS_REJECTED;
                    substate.error = payload ?? error;
                });
            }).addMatcher(hasRehydrationInfo, (draft, action)=>{
                const { mutations: mutations } = extractRehydrationInfo(action);
                for (const [key, entry] of Object.entries(mutations))if ((entry?.status === "fulfilled" || entry?.status === "rejected") && key !== entry?.requestId) draft[key] = entry;
            });
        }
    });
    const invalidationSlice = (0, $37Zv1.createSlice)({
        name: `${reducerPath}/invalidation`,
        initialState: {
            tags: {},
            keys: {}
        },
        reducers: {
            updateProvidedBy: {
                reducer (draft, action) {
                    const currentKeys = $7c5b8303526498ea$var$getCurrent(draft.keys);
                    const writtenKeys = /* @__PURE__ */ new Set();
                    for (const { queryCacheKey: queryCacheKey, providedTags: providedTags } of action.payload){
                        if (!writtenKeys.has(queryCacheKey) && $7c5b8303526498ea$var$areTagsEqual(currentKeys[queryCacheKey], providedTags)) continue;
                        writtenKeys.add(queryCacheKey);
                        removeCacheKeyFromTags(draft, queryCacheKey);
                        for (const { type: type, id: id } of providedTags){
                            const subscribedQueries = (draft.tags[type] ??= {})[id ?? "__internal_without_id"] ??= [];
                            if (!subscribedQueries.includes(queryCacheKey)) subscribedQueries.push(queryCacheKey);
                        }
                        draft.keys[queryCacheKey] = providedTags;
                    }
                },
                prepare: (0, $37Zv1.prepareAutoBatched)()
            }
        },
        extraReducers (builder) {
            builder.addCase(querySlice.actions.removeQueryResult, (draft, { payload: { queryCacheKey: queryCacheKey } })=>{
                removeCacheKeyFromTags(draft, queryCacheKey);
            }).addMatcher(hasRehydrationInfo, (draft, action)=>{
                const { provided: provided } = extractRehydrationInfo(action);
                for (const [type, incomingTags] of Object.entries(provided.tags ?? {}))for (const [id, cacheKeys] of Object.entries(incomingTags)){
                    const subscribedQueries = (draft.tags[type] ??= {})[id ?? "__internal_without_id"] ??= [];
                    for (const queryCacheKey of cacheKeys){
                        if (!subscribedQueries.includes(queryCacheKey)) subscribedQueries.push(queryCacheKey);
                        draft.keys[queryCacheKey] = provided.keys[queryCacheKey];
                    }
                }
            }).addMatcher((0, $37Zv1.isAnyOf)((0, $37Zv1.isFulfilled)(queryThunk), (0, $37Zv1.isRejectedWithValue)(queryThunk)), (draft, action)=>{
                if ((0, $37Zv1.isRejectedWithValue)(action) && $7c5b8303526498ea$var$isUpsertQuery(action.meta.arg)) return;
                writeProvidedTagsForQueries(draft, [
                    action
                ]);
            }).addMatcher(querySlice.actions.cacheEntriesUpserted.match, (draft, action)=>{
                invalidationSlice.caseReducers.updateProvidedBy(draft, invalidationSlice.actions.updateProvidedBy(action.payload.map(({ queryDescription: queryDescription, providedTags: providedTags })=>({
                        queryCacheKey: queryDescription.queryCacheKey,
                        providedTags: providedTags
                    }))));
            });
        }
    });
    function removeCacheKeyFromTags(draft, queryCacheKey) {
        const existingTags = $7c5b8303526498ea$var$getCurrent(draft.keys[queryCacheKey] ?? []);
        for (const tag of existingTags){
            const tagType = tag.type;
            const tagId = tag.id ?? "__internal_without_id";
            const tagSubscriptions = draft.tags[tagType]?.[tagId];
            if (tagSubscriptions) draft.tags[tagType][tagId] = $7c5b8303526498ea$var$getCurrent(tagSubscriptions).filter((qc)=>qc !== queryCacheKey);
        }
        delete draft.keys[queryCacheKey];
    }
    function writeProvidedTagsForQueries(draft, actions) {
        const providedByEntries = actions.map((action)=>{
            const providedTags = $7c5b8303526498ea$var$calculateProvidedByThunk(action, "providesTags", definitions, assertTagType);
            const { queryCacheKey: queryCacheKey } = action.meta.arg;
            return {
                queryCacheKey: queryCacheKey,
                providedTags: providedTags
            };
        });
        invalidationSlice.caseReducers.updateProvidedBy(draft, invalidationSlice.actions.updateProvidedBy(providedByEntries));
    }
    const subscriptionSlice = (0, $37Zv1.createSlice)({
        name: `${reducerPath}/subscriptions`,
        initialState: $7c5b8303526498ea$var$initialState,
        reducers: {
            updateSubscriptionOptions (d, a) {},
            unsubscribeQueryResult (d, a) {},
            internal_getRTKQSubscriptions () {}
        }
    });
    const internalSubscriptionsSlice = (0, $37Zv1.createSlice)({
        name: `${reducerPath}/internalSubscriptions`,
        initialState: $7c5b8303526498ea$var$initialState,
        reducers: {
            subscriptionsUpdated: {
                reducer (state, action) {
                    return (0, $3xSPq.applyPatches)(state, action.payload);
                },
                prepare: (0, $37Zv1.prepareAutoBatched)()
            }
        }
    });
    const configSlice = (0, $37Zv1.createSlice)({
        name: `${reducerPath}/config`,
        initialState: {
            online: $7c5b8303526498ea$var$isOnline(),
            focused: $7c5b8303526498ea$var$isDocumentVisible(),
            middlewareRegistered: false,
            ...config
        },
        reducers: {
            middlewareRegistered (state, { payload: payload }) {
                state.middlewareRegistered = state.middlewareRegistered === "conflict" || apiUid !== payload ? "conflict" : true;
            }
        },
        extraReducers: (builder)=>{
            builder.addCase($7c5b8303526498ea$var$onOnline, (state)=>{
                state.online = true;
            }).addCase($7c5b8303526498ea$var$onOffline, (state)=>{
                state.online = false;
            }).addCase($7c5b8303526498ea$var$onFocus, (state)=>{
                state.focused = true;
            }).addCase($7c5b8303526498ea$var$onFocusLost, (state)=>{
                state.focused = false;
            }).addMatcher(hasRehydrationInfo, (draft)=>({
                    ...draft
                }));
        }
    });
    const combinedReducer = (0, $dpYkU.combineReducers)({
        queries: querySlice.reducer,
        mutations: mutationSlice.reducer,
        provided: invalidationSlice.reducer,
        subscriptions: internalSubscriptionsSlice.reducer,
        config: configSlice.reducer
    });
    const ownTypePrefix = `${reducerPath}/`;
    function mayHandleAction(action) {
        const { type: type } = action;
        return typeof type !== "string" || type.startsWith(ownTypePrefix) || type.startsWith("__rtkq/") || type.startsWith("@@redux/") || hasRehydrationInfo(action);
    }
    const reducer = (state, action)=>{
        if (state !== void 0 && !mayHandleAction(action)) return state;
        return combinedReducer(resetApiState.match(action) ? void 0 : state, action);
    };
    return {
        reducer: reducer,
        actions: {
            ...configSlice.actions,
            ...querySlice.actions,
            ...subscriptionSlice.actions,
            ...internalSubscriptionsSlice.actions,
            ...mutationSlice.actions,
            ...invalidationSlice.actions,
            resetApiState: resetApiState
        }
    };
}
//#endregion
//#region src/query/core/buildSelectors.ts
const $7c5b8303526498ea$var$initialSubState = {
    status: $7c5b8303526498ea$var$STATUS_UNINITIALIZED
};
const $7c5b8303526498ea$var$defaultQuerySubState = /* @__PURE__ */ (0, $3xSPq.produce)($7c5b8303526498ea$var$initialSubState, ()=>{});
const $7c5b8303526498ea$var$defaultMutationSubState = /* @__PURE__ */ (0, $3xSPq.produce)($7c5b8303526498ea$var$initialSubState, ()=>{});
function $7c5b8303526498ea$var$buildSelectors({ serializeQueryArgs: serializeQueryArgs, reducerPath: reducerPath, createSelector: createSelector }) {
    const selectSkippedQuery = (state)=>$7c5b8303526498ea$var$defaultQuerySubState;
    const selectSkippedMutation = (state)=>$7c5b8303526498ea$var$defaultMutationSubState;
    const cacheEntries = /* @__PURE__ */ new WeakMap();
    const lastEntriesForEndpoint = /* @__PURE__ */ new Map();
    const selectAllQueryEntries = createSelector(selectQueries, (queries)=>{
        const entries = [];
        for (const [queryCacheKey, subState] of Object.entries(queries ?? {}))if (subState && subState.status !== "uninitialized") {
            let entry = cacheEntries.get(subState);
            if (!entry) {
                entry = {
                    ...subState,
                    queryCacheKey: queryCacheKey
                };
                cacheEntries.set(subState, entry);
            }
            entries.push(entry);
        }
        return entries;
    });
    return {
        buildQuerySelector: buildQuerySelector,
        buildInfiniteQuerySelector: buildInfiniteQuerySelector,
        buildMutationSelector: buildMutationSelector,
        selectInvalidatedBy: selectInvalidatedBy,
        selectCachedArgsForQuery: selectCachedArgsForQuery,
        selectAllQueryEntries: selectAllQueryEntries,
        selectEntriesForEndpoint: createSelector(selectAllQueryEntries, (_state, endpointName)=>endpointName, (entries, endpointName)=>{
            const result = entries.filter((entry)=>entry.endpointName === endpointName);
            const previous = lastEntriesForEndpoint.get(endpointName);
            if (previous && previous.length === result.length && previous.every((entry, i)=>entry === result[i])) return previous;
            lastEntriesForEndpoint.set(endpointName, result);
            return result;
        }),
        selectApiState: selectApiState,
        selectQueries: selectQueries,
        selectMutations: selectMutations,
        selectQueryEntry: selectQueryEntry,
        selectConfig: selectConfig
    };
    function withRequestFlags(substate) {
        return {
            ...substate,
            ...$7c5b8303526498ea$var$getRequestStatusFlags(substate.status)
        };
    }
    function selectApiState(rootState) {
        const state = rootState[reducerPath];
        return state;
    }
    function selectQueries(rootState) {
        return selectApiState(rootState)?.queries;
    }
    function selectQueryEntry(rootState, cacheKey) {
        return selectQueries(rootState)?.[cacheKey];
    }
    function selectMutations(rootState) {
        return selectApiState(rootState)?.mutations;
    }
    function selectConfig(rootState) {
        return selectApiState(rootState)?.config;
    }
    function buildAnyQuerySelector(endpointName, endpointDefinition, combiner) {
        return (queryArgs)=>{
            if (queryArgs === $7c5b8303526498ea$export$1aa5a89531b7670d) return createSelector(selectSkippedQuery, combiner);
            const serializedArgs = serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            const selectQuerySubstate = (state)=>selectQueryEntry(state, serializedArgs) ?? $7c5b8303526498ea$var$defaultQuerySubState;
            return createSelector(selectQuerySubstate, combiner);
        };
    }
    function buildQuerySelector(endpointName, endpointDefinition) {
        return buildAnyQuerySelector(endpointName, endpointDefinition, withRequestFlags);
    }
    function buildInfiniteQuerySelector(endpointName, endpointDefinition) {
        const { infiniteQueryOptions: infiniteQueryOptions } = endpointDefinition;
        function withInfiniteQueryResultFlags(substate) {
            const stateWithRequestFlags = {
                ...substate,
                ...$7c5b8303526498ea$var$getRequestStatusFlags(substate.status)
            };
            const { isLoading: isLoading, isError: isError, direction: direction } = stateWithRequestFlags;
            const isForward = direction === "forward";
            const isBackward = direction === "backward";
            return {
                ...stateWithRequestFlags,
                hasNextPage: getHasNextPage(infiniteQueryOptions, stateWithRequestFlags.data, stateWithRequestFlags.originalArgs),
                hasPreviousPage: getHasPreviousPage(infiniteQueryOptions, stateWithRequestFlags.data, stateWithRequestFlags.originalArgs),
                isFetchingNextPage: isLoading && isForward,
                isFetchingPreviousPage: isLoading && isBackward,
                isFetchNextPageError: isError && isForward,
                isFetchPreviousPageError: isError && isBackward
            };
        }
        return buildAnyQuerySelector(endpointName, endpointDefinition, withInfiniteQueryResultFlags);
    }
    function buildMutationSelector() {
        return (id)=>{
            let mutationId;
            if (typeof id === "object") mutationId = $7c5b8303526498ea$var$getMutationCacheKey(id) ?? $7c5b8303526498ea$export$1aa5a89531b7670d;
            else mutationId = id;
            const selectMutationSubstate = (state)=>selectApiState(state)?.mutations?.[mutationId] ?? $7c5b8303526498ea$var$defaultMutationSubState;
            return createSelector(mutationId === $7c5b8303526498ea$export$1aa5a89531b7670d ? selectSkippedMutation : selectMutationSubstate, withRequestFlags);
        };
    }
    function selectInvalidatedBy(state, tags) {
        const apiState = state[reducerPath];
        const toInvalidate = /* @__PURE__ */ new Set();
        const finalTags = $7c5b8303526498ea$var$filterMap(tags, $7c5b8303526498ea$var$isNotNullish, $7c5b8303526498ea$var$expandTagDescription);
        for (const tag of finalTags){
            const provided = apiState.provided.tags[tag.type];
            if (!provided) continue;
            let invalidateSubscriptions = (tag.id !== void 0 ? provided[tag.id] : Object.values(provided).flat()) ?? [];
            for (const invalidate of invalidateSubscriptions)toInvalidate.add(invalidate);
        }
        return Array.from(toInvalidate.values()).flatMap((queryCacheKey)=>{
            const querySubState = apiState.queries[queryCacheKey];
            return querySubState ? {
                queryCacheKey: queryCacheKey,
                endpointName: querySubState.endpointName,
                originalArgs: querySubState.originalArgs
            } : [];
        });
    }
    function selectCachedArgsForQuery(state, queryName) {
        return $7c5b8303526498ea$var$filterMap(Object.values(selectQueries(state)), (entry)=>entry?.endpointName === queryName && entry.status !== "uninitialized", (entry)=>entry.originalArgs);
    }
    function getHasNextPage(options, data, queryArg) {
        if (!data) return false;
        return $7c5b8303526498ea$var$getNextPageParam(options, data, queryArg) != null;
    }
    function getHasPreviousPage(options, data, queryArg) {
        if (!data || !options.getPreviousPageParam) return false;
        return $7c5b8303526498ea$var$getPreviousPageParam(options, data, queryArg) != null;
    }
}
//#endregion
//#region src/query/defaultSerializeQueryArgs.ts
const $7c5b8303526498ea$var$cache = WeakMap ? /* @__PURE__ */ new WeakMap() : void 0;
const $7c5b8303526498ea$export$db8e4edac9bbb67b = ({ endpointName: endpointName, queryArgs: queryArgs })=>{
    let serialized = "";
    const cached = $7c5b8303526498ea$var$cache?.get(queryArgs);
    if (typeof cached === "string") serialized = cached;
    else {
        const stringified = JSON.stringify(queryArgs, (key, value)=>{
            value = typeof value === "bigint" ? {
                $bigint: value.toString()
            } : value;
            value = (0, $dpYkU.isPlainObject)(value) ? Object.keys(value).sort().reduce((acc, key)=>{
                acc[key] = value[key];
                return acc;
            }, {}) : value;
            return value;
        });
        if ((0, $dpYkU.isPlainObject)(queryArgs)) $7c5b8303526498ea$var$cache?.set(queryArgs, stringified);
        serialized = stringified;
    }
    return `${endpointName}(${serialized})`;
};
//#endregion
//#region src/query/createApi.ts
function $7c5b8303526498ea$export$f957748792d43646(...modules) {
    return function baseCreateApi(options) {
        const extractRehydrationInfo = (0, $6xl8b.weakMapMemoize)((action)=>options.extractRehydrationInfo?.(action, {
                reducerPath: options.reducerPath ?? "api"
            }));
        const optionsWithDefaults = {
            reducerPath: "api",
            keepUnusedDataFor: 60,
            refetchOnMountOrArgChange: false,
            refetchOnFocus: false,
            refetchOnReconnect: false,
            invalidationBehavior: "delayed",
            ...options,
            extractRehydrationInfo: extractRehydrationInfo,
            serializeQueryArgs (queryArgsApi) {
                let finalSerializeQueryArgs = $7c5b8303526498ea$export$db8e4edac9bbb67b;
                if (queryArgsApi.endpointDefinition && "serializeQueryArgs" in queryArgsApi.endpointDefinition) {
                    const endpointSQA = queryArgsApi.endpointDefinition.serializeQueryArgs;
                    finalSerializeQueryArgs = (queryArgsApi)=>{
                        const initialResult = endpointSQA(queryArgsApi);
                        if (typeof initialResult === "string") return initialResult;
                        else return $7c5b8303526498ea$export$db8e4edac9bbb67b({
                            ...queryArgsApi,
                            queryArgs: initialResult
                        });
                    };
                } else if (options.serializeQueryArgs) finalSerializeQueryArgs = options.serializeQueryArgs;
                return finalSerializeQueryArgs(queryArgsApi);
            },
            tagTypes: [
                ...options.tagTypes || []
            ]
        };
        const context = {
            endpointDefinitions: {},
            batch (fn) {
                fn();
            },
            apiUid: (0, $37Zv1.nanoid)(),
            extractRehydrationInfo: extractRehydrationInfo,
            hasRehydrationInfo: (0, $6xl8b.weakMapMemoize)((action)=>extractRehydrationInfo(action) != null)
        };
        const api = {
            injectEndpoints: injectEndpoints,
            enhanceEndpoints ({ addTagTypes: addTagTypes, endpoints: endpoints }) {
                if (addTagTypes) {
                    for (const eT of addTagTypes)if (!optionsWithDefaults.tagTypes.includes(eT)) optionsWithDefaults.tagTypes.push(eT);
                }
                if (endpoints) for (const [endpointName, partialDefinition] of Object.entries(endpoints)){
                    const definition = $7c5b8303526498ea$var$getEndpointDefinition(context, endpointName);
                    definition;
                    if (typeof partialDefinition === "function") partialDefinition(definition);
                    else Object.assign(definition || {}, partialDefinition);
                }
                return api;
            }
        };
        const initializedModules = modules.map((m)=>m.init(api, optionsWithDefaults, context));
        function injectEndpoints(inject) {
            const evaluatedEndpoints = inject.endpoints({
                query: (x)=>({
                        ...x,
                        type: $7c5b8303526498ea$var$ENDPOINT_QUERY
                    }),
                mutation: (x)=>({
                        ...x,
                        type: $7c5b8303526498ea$var$ENDPOINT_MUTATION
                    }),
                infiniteQuery: (x)=>({
                        ...x,
                        type: $7c5b8303526498ea$var$ENDPOINT_INFINITEQUERY
                    })
            });
            for (const [endpointName, definition] of Object.entries(evaluatedEndpoints)){
                if (inject.overrideExisting !== true && endpointName in context.endpointDefinitions) {
                    if (inject.overrideExisting === "throw") throw new Error((0, $37Zv1.formatProdErrorMessage)(39));
                    continue;
                }
                context.endpointDefinitions[endpointName] = definition;
                for (const m of initializedModules)m.injectEndpoint(endpointName, definition);
            }
            return api;
        }
        return api.injectEndpoints({
            endpoints: options.endpoints
        });
    };
}
//#endregion
//#region src/query/createApiActionSanitizer.ts
function $7c5b8303526498ea$export$6b110bb772b8cd62(api) {
    const typePrefix = `${api.reducerPath}/`;
    return function apiActionSanitizer(action) {
        const endpointName = action.meta?.arg?.endpointName;
        if (typeof endpointName === "string" && typeof action.type === "string" && action.type.startsWith(typePrefix)) return {
            ...action,
            type: `${action.type} (${endpointName})`
        };
        return action;
    };
}
//#endregion
//#region src/query/fakeBaseQuery.ts
const $7c5b8303526498ea$export$b87087b3e686799a = /* @__PURE__ */ Symbol();
function $7c5b8303526498ea$export$f72b22d3ac378bae() {
    return function() {
        throw new Error((0, $37Zv1.formatProdErrorMessage)(33));
    };
}
function $7c5b8303526498ea$var$safeAssign(target, ...args) {
    return Object.assign(target, ...args);
}
//#endregion
//#region src/query/core/buildMiddleware/batchActions.ts
const $7c5b8303526498ea$var$buildBatchedActionsHandler = ({ api: api, queryThunk: queryThunk, internalState: internalState, mwApi: mwApi })=>{
    const subscriptionsPrefix = `${api.reducerPath}/subscriptions`;
    const changedKeys = /* @__PURE__ */ new Set();
    const syncedKeys = /* @__PURE__ */ new Set();
    let updateSyncTimer = null;
    const { updateSubscriptionOptions: updateSubscriptionOptions, unsubscribeQueryResult: unsubscribeQueryResult } = api.internalActions;
    const buildSubscriptionPatches = ()=>{
        const patches = [];
        for (const queryCacheKey of changedKeys){
            const subscribers = internalState.currentSubscriptions.get(queryCacheKey);
            if (subscribers) {
                syncedKeys.add(queryCacheKey);
                patches.push({
                    op: "add",
                    path: [
                        queryCacheKey
                    ],
                    value: Object.fromEntries(subscribers)
                });
            } else {
                syncedKeys.delete(queryCacheKey);
                patches.push({
                    op: "remove",
                    path: [
                        queryCacheKey
                    ]
                });
            }
        }
        changedKeys.clear();
        return patches;
    };
    const addSubscriber = (currentSubscriptions, queryCacheKey, requestId, subscriptionOptions)=>{
        const substate = $7c5b8303526498ea$var$getOrInsertComputed(currentSubscriptions, queryCacheKey, $7c5b8303526498ea$var$createNewMap);
        const options = subscriptionOptions ?? substate.get(requestId) ?? {};
        substate.set(requestId, options);
        changedKeys.add(queryCacheKey);
    };
    const actuallyMutateSubscriptions = (currentSubscriptions, action)=>{
        if (updateSubscriptionOptions.match(action)) {
            const { queryCacheKey: queryCacheKey, requestId: requestId, options: options } = action.payload;
            const sub = currentSubscriptions.get(queryCacheKey);
            if (sub?.has(requestId)) {
                sub.set(requestId, options);
                changedKeys.add(queryCacheKey);
                return true;
            }
            return false;
        }
        if (unsubscribeQueryResult.match(action)) {
            const { queryCacheKey: queryCacheKey, requestId: requestId } = action.payload;
            if (currentSubscriptions.get(queryCacheKey)?.delete(requestId)) {
                changedKeys.add(queryCacheKey);
                return true;
            }
            return false;
        }
        if (api.internalActions.removeQueryResult.match(action)) {
            const { queryCacheKey: queryCacheKey } = action.payload;
            currentSubscriptions.delete(queryCacheKey);
            if (syncedKeys.has(queryCacheKey) || changedKeys.has(queryCacheKey)) {
                changedKeys.add(queryCacheKey);
                return true;
            }
            return false;
        }
        if (queryThunk.pending.match(action)) {
            const { meta: { arg: arg, requestId: requestId } } = action;
            if (arg.subscribe) {
                addSubscriber(currentSubscriptions, arg.queryCacheKey, requestId, arg.subscriptionOptions);
                return true;
            }
            $7c5b8303526498ea$var$getOrInsertComputed(currentSubscriptions, arg.queryCacheKey, $7c5b8303526498ea$var$createNewMap);
            return false;
        }
        if (queryThunk.rejected.match(action)) {
            const { meta: { condition: condition, arg: arg, requestId: requestId } } = action;
            if (condition && arg.subscribe) {
                addSubscriber(currentSubscriptions, arg.queryCacheKey, requestId, arg.subscriptionOptions);
                return true;
            }
        }
        return false;
    };
    const getSubscriptions = ()=>internalState.currentSubscriptions;
    const getSubscriptionCount = (queryCacheKey)=>{
        return getSubscriptions().get(queryCacheKey)?.size ?? 0;
    };
    const isRequestSubscribed = (queryCacheKey, requestId)=>{
        return !!getSubscriptions()?.get(queryCacheKey)?.get(requestId);
    };
    const subscriptionSelectors = {
        getSubscriptions: getSubscriptions,
        getSubscriptionCount: getSubscriptionCount,
        isRequestSubscribed: isRequestSubscribed
    };
    return (action, mwApi)=>{
        if (api.util.resetApiState.match(action)) {
            changedKeys.clear();
            syncedKeys.clear();
            internalState.currentSubscriptions.clear();
            if (updateSyncTimer) {
                clearTimeout(updateSyncTimer);
                updateSyncTimer = null;
            }
            return [
                true,
                false
            ];
        }
        if (api.internalActions.internal_getRTKQSubscriptions.match(action)) return [
            false,
            subscriptionSelectors
        ];
        const didMutate = actuallyMutateSubscriptions(internalState.currentSubscriptions, action);
        if (didMutate && !updateSyncTimer) updateSyncTimer = setTimeout(()=>{
            const patches = buildSubscriptionPatches();
            updateSyncTimer = null;
            if (patches.length) mwApi.next(api.internalActions.subscriptionsUpdated(patches));
        }, 500);
        const isSubscriptionSliceAction = typeof action.type == "string" && action.type.startsWith(subscriptionsPrefix);
        const isAdditionalSubscriptionAction = queryThunk.rejected.match(action) && action.meta.condition && !!action.meta.arg.subscribe;
        return [
            !isSubscriptionSliceAction && !isAdditionalSubscriptionAction,
            false
        ];
    };
};
//#endregion
//#region src/query/core/buildMiddleware/cacheCollection.ts
const $7c5b8303526498ea$var$THIRTY_TWO_BIT_MAX_INT = 2147483647;
const $7c5b8303526498ea$var$THIRTY_TWO_BIT_MAX_TIMER_SECONDS = 2147482.647;
const $7c5b8303526498ea$var$buildCacheCollectionHandler = ({ reducerPath: reducerPath, api: api, queryThunk: queryThunk, context: context, internalState: internalState, selectors: { selectQueryEntry: selectQueryEntry, selectConfig: selectConfig }, getRunningQueryThunk: getRunningQueryThunk, mwApi: mwApi })=>{
    const { removeQueryResult: removeQueryResult, unsubscribeQueryResult: unsubscribeQueryResult, cacheEntriesUpserted: cacheEntriesUpserted } = api.internalActions;
    const isQueryThunkRejectedByError = (action)=>queryThunk.rejected.match(action) && !action.meta.condition;
    const canTriggerUnsubscribe = (0, $37Zv1.isAnyOf)(unsubscribeQueryResult.match, queryThunk.fulfilled, isQueryThunkRejectedByError, cacheEntriesUpserted.match);
    function anySubscriptionsRemainingForKey(queryCacheKey) {
        const subscriptions = internalState.currentSubscriptions.get(queryCacheKey);
        if (!subscriptions) return false;
        return subscriptions.size > 0;
    }
    const currentRemovalTimeouts = {};
    function abortAllPromises(promiseMap) {
        for (const promise of promiseMap.values())promise?.abort?.();
    }
    function clearRemovalTimeout(queryCacheKey) {
        const timeout = currentRemovalTimeouts[queryCacheKey];
        if (timeout) {
            clearTimeout(timeout);
            delete currentRemovalTimeouts[queryCacheKey];
        }
    }
    const handler = (action, mwApi)=>{
        const config = selectConfig(mwApi.getState());
        if ((queryThunk.pending.match(action) || queryThunk.rejected.match(action) && action.meta.condition) && action.meta.arg.subscribe) clearRemovalTimeout(action.meta.arg.queryCacheKey);
        if (removeQueryResult.match(action)) clearRemovalTimeout(action.payload.queryCacheKey);
        if (canTriggerUnsubscribe(action)) {
            let queryCacheKeys;
            if (cacheEntriesUpserted.match(action)) queryCacheKeys = action.payload.map((entry)=>entry.queryDescription.queryCacheKey);
            else {
                const { queryCacheKey: queryCacheKey } = unsubscribeQueryResult.match(action) ? action.payload : action.meta.arg;
                queryCacheKeys = [
                    queryCacheKey
                ];
            }
            handleUnsubscribeMany(queryCacheKeys, mwApi, config);
        }
        if (api.util.resetApiState.match(action)) {
            for (const [key, timeout] of Object.entries(currentRemovalTimeouts)){
                if (timeout) clearTimeout(timeout);
                delete currentRemovalTimeouts[key];
            }
            abortAllPromises(internalState.runningQueries);
            abortAllPromises(internalState.runningMutations);
        }
        if (context.hasRehydrationInfo(action)) {
            const { queries: queries } = context.extractRehydrationInfo(action);
            handleUnsubscribeMany(Object.keys(queries), mwApi, config);
        }
    };
    function handleUnsubscribeMany(cacheKeys, api, config) {
        const state = api.getState();
        for (const queryCacheKey of cacheKeys){
            const entry = selectQueryEntry(state, queryCacheKey);
            if (entry?.endpointName) handleUnsubscribe(queryCacheKey, entry.endpointName, api, config);
        }
    }
    function handleUnsubscribe(queryCacheKey, endpointName, api, config) {
        const keepUnusedDataFor = $7c5b8303526498ea$var$getEndpointDefinition(context, endpointName)?.keepUnusedDataFor ?? config.keepUnusedDataFor;
        if (keepUnusedDataFor === Infinity) return;
        const finalKeepUnusedDataFor = Math.max(0, Math.min(keepUnusedDataFor, $7c5b8303526498ea$var$THIRTY_TWO_BIT_MAX_TIMER_SECONDS));
        if (!anySubscriptionsRemainingForKey(queryCacheKey)) {
            const currentTimeout = currentRemovalTimeouts[queryCacheKey];
            if (currentTimeout) clearTimeout(currentTimeout);
            currentRemovalTimeouts[queryCacheKey] = setTimeout(()=>{
                delete currentRemovalTimeouts[queryCacheKey];
                if (!anySubscriptionsRemainingForKey(queryCacheKey)) {
                    const entry = selectQueryEntry(api.getState(), queryCacheKey);
                    if (entry?.endpointName) api.dispatch(getRunningQueryThunk(entry.endpointName, entry.originalArgs))?.abort();
                    api.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                }
            }, finalKeepUnusedDataFor * 1e3);
        }
    }
    return handler;
};
//#endregion
//#region src/query/core/buildMiddleware/cacheLifecycle.ts
const $7c5b8303526498ea$var$neverResolvedError = /* @__PURE__ */ new Error("Promise never resolved before cacheEntryRemoved.");
function $7c5b8303526498ea$var$warnIfNoCachedData(entry, endpointName, callbackName) {
    if (!("data" in entry)) console.warn(`\`updateCachedData\` was called in \`${callbackName}\` for the endpoint "${endpointName}" before the cache entry had any data, so it did nothing. Await \`cacheDataLoaded\` or \`queryFulfilled\` before updating the cached data.`);
}
function $7c5b8303526498ea$var$runLifecycleCallback(callback, endpointName, callbackName) {
    try {
        return callback();
    } catch (error) {
        console.error(error);
        return;
    }
}
const $7c5b8303526498ea$var$buildCacheLifecycleHandler = ({ api: api, reducerPath: reducerPath, context: context, queryThunk: queryThunk, mutationThunk: mutationThunk, internalState: internalState, selectors: { selectQueryEntry: selectQueryEntry, selectApiState: selectApiState } })=>{
    const isQueryThunk = (0, $37Zv1.isAsyncThunkAction)(queryThunk);
    const isMutationThunk = (0, $37Zv1.isAsyncThunkAction)(mutationThunk);
    const isFulfilledThunk = (0, $37Zv1.isFulfilled)(queryThunk, mutationThunk);
    const lifecycleMap = {};
    const { removeQueryResult: removeQueryResult, removeMutationResult: removeMutationResult, cacheEntriesUpserted: cacheEntriesUpserted } = api.internalActions;
    function resolveLifecycleEntry(cacheKey, data, meta, requestId) {
        const lifecycle = lifecycleMap[cacheKey];
        if (lifecycle?.valueResolved && (requestId === void 0 || lifecycle.requestIds?.has(requestId))) {
            lifecycle.valueResolved({
                data: data,
                meta: meta
            });
            delete lifecycle.valueResolved;
            delete lifecycle.requestIds;
        }
    }
    function removeLifecycleEntry(cacheKey) {
        const lifecycle = lifecycleMap[cacheKey];
        if (lifecycle) {
            delete lifecycleMap[cacheKey];
            lifecycle.cacheEntryRemoved();
        }
    }
    function getActionMetaFields(action) {
        const { arg: arg, requestId: requestId } = action.meta;
        const { endpointName: endpointName, originalArgs: originalArgs } = arg;
        return [
            endpointName,
            originalArgs,
            requestId
        ];
    }
    const handler = (action, mwApi, stateBefore)=>{
        const cacheKey = getCacheKey(action);
        function checkForNewCacheKey(endpointName, cacheKey, requestId, originalArgs) {
            const oldEntry = selectQueryEntry(stateBefore, cacheKey);
            const newEntry = selectQueryEntry(mwApi.getState(), cacheKey);
            if (!oldEntry && newEntry) handleNewKey(endpointName, originalArgs, cacheKey, mwApi, requestId);
        }
        if (queryThunk.pending.match(action)) {
            const [endpointName, originalArgs, requestId] = getActionMetaFields(action);
            checkForNewCacheKey(endpointName, cacheKey, requestId, originalArgs);
            lifecycleMap[cacheKey]?.requestIds?.add(requestId);
        } else if (cacheEntriesUpserted.match(action)) for (const { queryDescription: queryDescription, value: value } of action.payload){
            const { endpointName: endpointName, originalArgs: originalArgs, queryCacheKey: queryCacheKey } = queryDescription;
            checkForNewCacheKey(endpointName, queryCacheKey, action.meta.requestId, originalArgs);
            resolveLifecycleEntry(queryCacheKey, value, {});
        }
        else if (mutationThunk.pending.match(action)) {
            if (mwApi.getState()[reducerPath].mutations[cacheKey]) {
                const [endpointName, originalArgs, requestId] = getActionMetaFields(action);
                removeLifecycleEntry(cacheKey);
                handleNewKey(endpointName, originalArgs, cacheKey, mwApi, requestId);
            }
        } else if (isFulfilledThunk(action)) resolveLifecycleEntry(cacheKey, action.payload, action.meta.baseQueryMeta, action.meta.requestId);
        else if (removeQueryResult.match(action) || removeMutationResult.match(action)) removeLifecycleEntry(cacheKey);
        else if (api.util.resetApiState.match(action)) for (const cacheKey of Object.keys(lifecycleMap))removeLifecycleEntry(cacheKey);
    };
    function getCacheKey(action) {
        if (isQueryThunk(action)) return action.meta.arg.queryCacheKey;
        if (isMutationThunk(action)) return action.meta.arg.fixedCacheKey ?? action.meta.requestId;
        if (removeQueryResult.match(action)) return action.payload.queryCacheKey;
        if (removeMutationResult.match(action)) return $7c5b8303526498ea$var$getMutationCacheKey(action.payload);
        return "";
    }
    function handleNewKey(endpointName, originalArgs, queryCacheKey, mwApi, requestId) {
        const endpointDefinition = $7c5b8303526498ea$var$getEndpointDefinition(context, endpointName);
        const onCacheEntryAdded = endpointDefinition?.onCacheEntryAdded;
        if (!onCacheEntryAdded) return;
        const lifecycle = {
            requestIds: /* @__PURE__ */ new Set([
                requestId
            ])
        };
        const cacheEntryRemoved = new Promise((resolve)=>{
            lifecycle.cacheEntryRemoved = resolve;
        });
        const cacheDataLoaded = Promise.race([
            new Promise((resolve)=>{
                lifecycle.valueResolved = resolve;
            }),
            cacheEntryRemoved.then(()=>{
                throw $7c5b8303526498ea$var$neverResolvedError;
            })
        ]);
        cacheDataLoaded.catch(()=>{});
        lifecycleMap[queryCacheKey] = lifecycle;
        const selector = api.endpoints[endpointName].select($7c5b8303526498ea$var$isAnyQueryDefinition(endpointDefinition) ? originalArgs : queryCacheKey);
        const extra = mwApi.dispatch((_, __, extra)=>extra);
        const lifecycleApi = {
            ...mwApi,
            getCacheEntry: ()=>selector(mwApi.getState()),
            requestId: requestId,
            extra: extra,
            updateCachedData: $7c5b8303526498ea$var$isAnyQueryDefinition(endpointDefinition) ? (updateRecipe)=>{
                return mwApi.dispatch(api.util.updateQueryData(endpointName, originalArgs, updateRecipe));
            } : void 0,
            cacheDataLoaded: cacheDataLoaded,
            cacheEntryRemoved: cacheEntryRemoved
        };
        const runningHandler = $7c5b8303526498ea$var$runLifecycleCallback(()=>onCacheEntryAdded(originalArgs, lifecycleApi), endpointName, "onCacheEntryAdded");
        Promise.resolve(runningHandler).catch((e)=>{
            if (e === $7c5b8303526498ea$var$neverResolvedError) return;
            throw e;
        });
    }
    return handler;
};
//#endregion
//#region src/query/core/buildMiddleware/registration.ts
function $7c5b8303526498ea$var$registerMiddleware(api, mwApi, apiUid, reducerPath) {
    mwApi.next(api.internalActions.middlewareRegistered(apiUid));
}
//#endregion
//#region src/query/core/buildMiddleware/devMiddleware.ts
const $7c5b8303526498ea$var$buildDevCheckHandler = ({ api: api, context: { apiUid: apiUid }, reducerPath: reducerPath })=>{
    return (action, mwApi)=>{
        if (api.util.resetApiState.match(action)) $7c5b8303526498ea$var$registerMiddleware(api, mwApi, apiUid, reducerPath);
    };
};
//#endregion
//#region src/query/core/buildMiddleware/invalidationByTags.ts
const $7c5b8303526498ea$var$buildInvalidationByTagsHandler = ({ reducerPath: reducerPath, context: context, context: { endpointDefinitions: endpointDefinitions }, mutationThunk: mutationThunk, queryThunk: queryThunk, api: api, assertTagType: assertTagType, refetchQuery: refetchQuery, internalState: internalState })=>{
    const { removeQueryResult: removeQueryResult } = api.internalActions;
    const isThunkActionWithTags = (0, $37Zv1.isAnyOf)((0, $37Zv1.isFulfilled)(mutationThunk), (0, $37Zv1.isRejectedWithValue)(mutationThunk));
    const isQueryEnd = (0, $37Zv1.isAnyOf)((0, $37Zv1.isFulfilled)(queryThunk, mutationThunk), (0, $37Zv1.isRejected)(queryThunk, mutationThunk));
    let pendingTagInvalidations = [];
    const pendingRequestIds = /* @__PURE__ */ new Set();
    const handler = (action, mwApi)=>{
        if (api.util.resetApiState.match(action)) {
            pendingRequestIds.clear();
            pendingTagInvalidations = [];
            return;
        }
        if (queryThunk.pending.match(action) || mutationThunk.pending.match(action)) pendingRequestIds.add(action.meta.requestId);
        if (isQueryEnd(action)) pendingRequestIds.delete(action.meta.requestId);
        if (isThunkActionWithTags(action)) invalidateTags($7c5b8303526498ea$var$calculateProvidedByThunk(action, "invalidatesTags", endpointDefinitions, assertTagType), mwApi);
        else if (isQueryEnd(action)) invalidateTags([], mwApi);
        else if (api.util.invalidateTags.match(action)) invalidateTags($7c5b8303526498ea$var$calculateProvidedBy(action.payload, void 0, void 0, void 0, void 0, assertTagType), mwApi);
    };
    function hasPendingRequests() {
        return pendingRequestIds.size > 0;
    }
    function invalidateTags(newTags, mwApi) {
        const rootState = mwApi.getState();
        const state = rootState[reducerPath];
        pendingTagInvalidations.push(...newTags);
        if (state.config.invalidationBehavior === "delayed" && hasPendingRequests()) return;
        const tags = pendingTagInvalidations;
        pendingTagInvalidations = [];
        if (tags.length === 0) return;
        const toInvalidate = api.util.selectInvalidatedBy(rootState, tags);
        context.batch(()=>{
            const valuesArray = Array.from(toInvalidate.values());
            for (const { queryCacheKey: queryCacheKey } of valuesArray){
                const querySubState = state.queries[queryCacheKey];
                const subscriptionSubState = $7c5b8303526498ea$var$getOrInsertComputed(internalState.currentSubscriptions, queryCacheKey, $7c5b8303526498ea$var$createNewMap);
                if (querySubState) {
                    if (subscriptionSubState.size === 0) mwApi.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                    else if (querySubState.status !== "uninitialized") mwApi.dispatch(refetchQuery(querySubState));
                }
            }
        });
    }
    return handler;
};
//#endregion
//#region src/query/core/buildMiddleware/polling.ts
const $7c5b8303526498ea$var$buildPollingHandler = ({ reducerPath: reducerPath, queryThunk: queryThunk, api: api, refetchQuery: refetchQuery, internalState: internalState })=>{
    const { currentPolls: currentPolls, currentSubscriptions: currentSubscriptions } = internalState;
    const pendingPollingUpdates = /* @__PURE__ */ new Set();
    let pollingUpdateTimer = null;
    const handler = (action, mwApi)=>{
        if (api.internalActions.updateSubscriptionOptions.match(action) || api.internalActions.unsubscribeQueryResult.match(action)) schedulePollingUpdate(action.payload.queryCacheKey, mwApi);
        if (queryThunk.pending.match(action) || queryThunk.rejected.match(action) && action.meta.condition) schedulePollingUpdate(action.meta.arg.queryCacheKey, mwApi);
        if (queryThunk.fulfilled.match(action) || queryThunk.rejected.match(action) && !action.meta.condition) startNextPoll(action.meta.arg, mwApi);
        if (api.internalActions.removeQueryResult.match(action)) cleanupPollForKey(action.payload.queryCacheKey);
        if (api.util.resetApiState.match(action)) {
            clearPolls();
            if (pollingUpdateTimer) {
                clearTimeout(pollingUpdateTimer);
                pollingUpdateTimer = null;
            }
            pendingPollingUpdates.clear();
        }
    };
    function schedulePollingUpdate(queryCacheKey, api) {
        if (!currentPolls.has(queryCacheKey) && !Number.isFinite(findLowestPollingInterval(currentSubscriptions.get(queryCacheKey)).lowestPollingInterval)) return;
        pendingPollingUpdates.add(queryCacheKey);
        if (!pollingUpdateTimer) pollingUpdateTimer = setTimeout(()=>{
            for (const key of pendingPollingUpdates)updatePollingInterval({
                queryCacheKey: key
            }, api);
            pendingPollingUpdates.clear();
            pollingUpdateTimer = null;
        }, 0);
    }
    function startNextPoll({ queryCacheKey: queryCacheKey }, api, delay) {
        const querySubState = api.getState()[reducerPath].queries[queryCacheKey];
        const { lowestPollingInterval: lowestPollingInterval } = findLowestPollingInterval(currentSubscriptions.get(queryCacheKey));
        if (!querySubState || querySubState.status === "uninitialized" || !Number.isFinite(lowestPollingInterval)) {
            cleanupPollForKey(queryCacheKey);
            return;
        }
        const currentPoll = currentPolls.get(queryCacheKey);
        if (currentPoll?.timeout) {
            clearTimeout(currentPoll.timeout);
            currentPoll.timeout = void 0;
        }
        const pollingInterval = Math.min(lowestPollingInterval, $7c5b8303526498ea$var$THIRTY_TWO_BIT_MAX_INT);
        const timeoutMs = delay ?? pollingInterval;
        const nextPollTimestamp = Date.now() + timeoutMs;
        currentPolls.set(queryCacheKey, {
            nextPollTimestamp: nextPollTimestamp,
            pollingInterval: pollingInterval,
            timeout: setTimeout(()=>{
                const currentState = api.getState()[reducerPath];
                const currentQuerySubState = currentState.queries[queryCacheKey];
                const { lowestPollingInterval: currentPollingInterval, skipPollingIfUnfocused: skipPollingIfUnfocused } = findLowestPollingInterval(currentSubscriptions.get(queryCacheKey));
                if (!currentQuerySubState || currentQuerySubState.status === "uninitialized" || !Number.isFinite(currentPollingInterval)) {
                    cleanupPollForKey(queryCacheKey);
                    return;
                }
                if (currentQuerySubState.status === "pending") {
                    cleanupPollForKey(queryCacheKey);
                    return;
                }
                if (currentState.config.focused || !skipPollingIfUnfocused) api.dispatch(refetchQuery(currentQuerySubState));
                startNextPoll({
                    queryCacheKey: queryCacheKey
                }, api);
            }, timeoutMs)
        });
    }
    function updatePollingInterval({ queryCacheKey: queryCacheKey }, api) {
        const querySubState = api.getState()[reducerPath].queries[queryCacheKey];
        const subscriptions = currentSubscriptions.get(queryCacheKey);
        if (!querySubState || querySubState.status === "uninitialized") return;
        const { lowestPollingInterval: lowestPollingInterval } = findLowestPollingInterval(subscriptions);
        if (!Number.isFinite(lowestPollingInterval)) {
            cleanupPollForKey(queryCacheKey);
            return;
        }
        const currentPoll = currentPolls.get(queryCacheKey);
        if (!currentPoll) {
            startNextPoll({
                queryCacheKey: queryCacheKey
            }, api);
            return;
        }
        const pollingInterval = Math.min(lowestPollingInterval, $7c5b8303526498ea$var$THIRTY_TWO_BIT_MAX_INT);
        if (pollingInterval > currentPoll.pollingInterval) {
            const lastPollStart = currentPoll.nextPollTimestamp - currentPoll.pollingInterval;
            startNextPoll({
                queryCacheKey: queryCacheKey
            }, api, lastPollStart + pollingInterval - Date.now());
        } else if (Date.now() + pollingInterval < currentPoll.nextPollTimestamp) startNextPoll({
            queryCacheKey: queryCacheKey
        }, api);
    }
    function cleanupPollForKey(key) {
        const existingPoll = currentPolls.get(key);
        if (existingPoll?.timeout) clearTimeout(existingPoll.timeout);
        currentPolls.delete(key);
    }
    function clearPolls() {
        for (const key of currentPolls.keys())cleanupPollForKey(key);
    }
    function findLowestPollingInterval(subscribers = /* @__PURE__ */ new Map()) {
        let skipPollingIfUnfocused = false;
        let lowestPollingInterval = Number.POSITIVE_INFINITY;
        for (const entry of subscribers.values())if (entry.pollingInterval) {
            lowestPollingInterval = Math.min(entry.pollingInterval, lowestPollingInterval);
            skipPollingIfUnfocused = entry.skipPollingIfUnfocused || skipPollingIfUnfocused;
        }
        return {
            lowestPollingInterval: lowestPollingInterval,
            skipPollingIfUnfocused: skipPollingIfUnfocused
        };
    }
    return handler;
};
//#endregion
//#region src/query/core/buildMiddleware/queryLifecycle.ts
const $7c5b8303526498ea$var$buildQueryLifecycleHandler = ({ api: api, context: context, queryThunk: queryThunk, mutationThunk: mutationThunk })=>{
    const isPendingThunk = (0, $37Zv1.isPending)(queryThunk, mutationThunk);
    const isRejectedThunk = (0, $37Zv1.isRejected)(queryThunk, mutationThunk);
    const isFulfilledThunk = (0, $37Zv1.isFulfilled)(queryThunk, mutationThunk);
    const lifecycleMap = {};
    const handler = (action, mwApi)=>{
        if (isPendingThunk(action)) {
            const { requestId: requestId, arg: { endpointName: endpointName, originalArgs: originalArgs } } = action.meta;
            const endpointDefinition = $7c5b8303526498ea$var$getEndpointDefinition(context, endpointName);
            const onQueryStarted = endpointDefinition?.onQueryStarted;
            if (onQueryStarted) {
                const lifecycle = {};
                const queryFulfilled = new Promise((resolve, reject)=>{
                    lifecycle.resolve = resolve;
                    lifecycle.reject = reject;
                });
                queryFulfilled.catch(()=>{});
                lifecycleMap[requestId] = lifecycle;
                const selector = api.endpoints[endpointName].select($7c5b8303526498ea$var$isAnyQueryDefinition(endpointDefinition) ? originalArgs : $7c5b8303526498ea$var$getMutationCacheKey(action.meta));
                const extra = mwApi.dispatch((_, __, extra)=>extra);
                const lifecycleApi = {
                    ...mwApi,
                    getCacheEntry: ()=>selector(mwApi.getState()),
                    requestId: requestId,
                    extra: extra,
                    updateCachedData: $7c5b8303526498ea$var$isAnyQueryDefinition(endpointDefinition) ? (updateRecipe)=>{
                        return mwApi.dispatch(api.util.updateQueryData(endpointName, originalArgs, updateRecipe));
                    } : void 0,
                    queryFulfilled: queryFulfilled
                };
                $7c5b8303526498ea$var$runLifecycleCallback(()=>onQueryStarted(originalArgs, lifecycleApi), endpointName, "onQueryStarted");
            }
        } else if (isFulfilledThunk(action)) {
            const { requestId: requestId, baseQueryMeta: baseQueryMeta } = action.meta;
            lifecycleMap[requestId]?.resolve({
                data: action.payload,
                meta: baseQueryMeta
            });
            delete lifecycleMap[requestId];
        } else if (isRejectedThunk(action)) {
            const { requestId: requestId, rejectedWithValue: rejectedWithValue, baseQueryMeta: baseQueryMeta } = action.meta;
            lifecycleMap[requestId]?.reject({
                error: action.payload ?? action.error,
                isUnhandledError: !rejectedWithValue,
                meta: baseQueryMeta
            });
            delete lifecycleMap[requestId];
        }
    };
    return handler;
};
//#endregion
//#region src/query/core/buildMiddleware/windowEventHandling.ts
const $7c5b8303526498ea$var$buildWindowEventHandler = ({ reducerPath: reducerPath, context: context, api: api, refetchQuery: refetchQuery, internalState: internalState })=>{
    const { removeQueryResult: removeQueryResult } = api.internalActions;
    const handler = (action, mwApi)=>{
        if ($7c5b8303526498ea$var$onFocus.match(action)) refetchValidQueries(mwApi, "refetchOnFocus");
        if ($7c5b8303526498ea$var$onOnline.match(action)) refetchValidQueries(mwApi, "refetchOnReconnect");
    };
    function refetchValidQueries(api, type) {
        const state = api.getState()[reducerPath];
        const queries = state.queries;
        const subscriptions = internalState.currentSubscriptions;
        context.batch(()=>{
            for (const queryCacheKey of subscriptions.keys()){
                const querySubState = queries[queryCacheKey];
                const subscriptionSubState = subscriptions.get(queryCacheKey);
                if (!subscriptionSubState || !querySubState) continue;
                const values = [
                    ...subscriptionSubState.values()
                ];
                if (values.some((sub)=>sub[type] === true) || values.every((sub)=>sub[type] === void 0) && state.config[type]) {
                    if (subscriptionSubState.size === 0) api.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                    else if (querySubState.status !== "uninitialized") api.dispatch(refetchQuery(querySubState));
                }
            }
        });
    }
    return handler;
};
//#endregion
//#region src/query/core/buildMiddleware/index.ts
function $7c5b8303526498ea$var$buildMiddleware(input) {
    const { reducerPath: reducerPath, queryThunk: queryThunk, api: api, context: context, getInternalState: getInternalState } = input;
    const { apiUid: apiUid } = context;
    const actions = {
        invalidateTags: (0, $37Zv1.createAction)(`${reducerPath}/invalidateTags`)
    };
    const isThisApiSliceAction = (action)=>action.type.startsWith(`${reducerPath}/`);
    const handlerBuilders = [
        $7c5b8303526498ea$var$buildDevCheckHandler,
        $7c5b8303526498ea$var$buildCacheCollectionHandler,
        $7c5b8303526498ea$var$buildInvalidationByTagsHandler,
        $7c5b8303526498ea$var$buildPollingHandler,
        $7c5b8303526498ea$var$buildCacheLifecycleHandler,
        $7c5b8303526498ea$var$buildQueryLifecycleHandler
    ];
    const middleware = (mwApi)=>{
        let initialized = false;
        const internalState = getInternalState(mwApi.dispatch);
        const builderArgs = {
            ...input,
            internalState: internalState,
            refetchQuery: refetchQuery,
            isThisApiSliceAction: isThisApiSliceAction,
            mwApi: mwApi
        };
        const handlers = handlerBuilders.map((build)=>build(builderArgs));
        const batchedActionsHandler = $7c5b8303526498ea$var$buildBatchedActionsHandler(builderArgs);
        const windowEventsHandler = $7c5b8303526498ea$var$buildWindowEventHandler(builderArgs);
        return (next)=>{
            return (action)=>{
                if (!(0, $dpYkU.isAction)(action)) return next(action);
                const mwApiWithNext = {
                    ...mwApi,
                    next: next
                };
                if (!initialized) {
                    initialized = true;
                    $7c5b8303526498ea$var$registerMiddleware(api, mwApiWithNext, apiUid, reducerPath);
                }
                const stateBefore = mwApi.getState();
                const [actionShouldContinue, internalProbeResult] = batchedActionsHandler(action, mwApiWithNext, stateBefore);
                let res;
                if (actionShouldContinue) res = next(action);
                else res = internalProbeResult;
                if (mwApi.getState()[reducerPath]) {
                    windowEventsHandler(action, mwApiWithNext, stateBefore);
                    if (isThisApiSliceAction(action) || context.hasRehydrationInfo(action)) for (const handler of handlers)handler(action, mwApiWithNext, stateBefore);
                }
                return res;
            };
        };
    };
    return {
        middleware: middleware,
        actions: actions
    };
    function refetchQuery(querySubState) {
        return input.api.endpoints[querySubState.endpointName].initiate(querySubState.originalArgs, {
            subscribe: false,
            forceRefetch: true
        });
    }
}
//#endregion
//#region src/query/core/module.ts
const $7c5b8303526498ea$export$2902d0921e535c0 = /* @__PURE__ */ Symbol();
const $7c5b8303526498ea$export$eb718ff92afd6f9b = ({ createSelector: createSelector$1 = (0, $6xl8b.createSelector) } = {})=>({
        name: $7c5b8303526498ea$export$2902d0921e535c0,
        init (api, { baseQuery: baseQuery, tagTypes: tagTypes, reducerPath: reducerPath, serializeQueryArgs: serializeQueryArgs, keepUnusedDataFor: keepUnusedDataFor, refetchOnMountOrArgChange: refetchOnMountOrArgChange, refetchOnFocus: refetchOnFocus, refetchOnReconnect: refetchOnReconnect, invalidationBehavior: invalidationBehavior, onSchemaFailure: onSchemaFailure, catchSchemaFailure: catchSchemaFailure, skipSchemaValidation: skipSchemaValidation }, context) {
            (0, $3xSPq.enablePatches)();
            const assertTagType = (tag)=>{
                return tag;
            };
            Object.assign(api, {
                reducerPath: reducerPath,
                endpoints: {},
                internalActions: {
                    onOnline: $7c5b8303526498ea$var$onOnline,
                    onOffline: $7c5b8303526498ea$var$onOffline,
                    onFocus: $7c5b8303526498ea$var$onFocus,
                    onFocusLost: $7c5b8303526498ea$var$onFocusLost
                },
                util: {}
            });
            const selectors = $7c5b8303526498ea$var$buildSelectors({
                serializeQueryArgs: serializeQueryArgs,
                reducerPath: reducerPath,
                createSelector: createSelector$1
            });
            const { selectInvalidatedBy: selectInvalidatedBy, selectCachedArgsForQuery: selectCachedArgsForQuery, selectEntriesForEndpoint: selectEntriesForEndpoint, selectAllQueryEntries: selectAllQueryEntries, buildQuerySelector: buildQuerySelector, buildInfiniteQuerySelector: buildInfiniteQuerySelector, buildMutationSelector: buildMutationSelector } = selectors;
            $7c5b8303526498ea$var$safeAssign(api.util, {
                selectInvalidatedBy: selectInvalidatedBy,
                selectCachedArgsForQuery: selectCachedArgsForQuery,
                selectEntriesForEndpoint: selectEntriesForEndpoint,
                selectAllQueryEntries: selectAllQueryEntries
            });
            const { queryThunk: queryThunk, infiniteQueryThunk: infiniteQueryThunk, mutationThunk: mutationThunk, patchQueryData: patchQueryData, updateQueryData: updateQueryData, upsertQueryData: upsertQueryData, prefetch: prefetch, buildMatchThunkActions: buildMatchThunkActions } = $7c5b8303526498ea$var$buildThunks({
                baseQuery: baseQuery,
                reducerPath: reducerPath,
                context: context,
                api: api,
                serializeQueryArgs: serializeQueryArgs,
                assertTagType: assertTagType,
                selectors: selectors,
                onSchemaFailure: onSchemaFailure,
                catchSchemaFailure: catchSchemaFailure,
                skipSchemaValidation: skipSchemaValidation
            });
            const { reducer: reducer, actions: sliceActions } = $7c5b8303526498ea$var$buildSlice({
                context: context,
                queryThunk: queryThunk,
                infiniteQueryThunk: infiniteQueryThunk,
                mutationThunk: mutationThunk,
                serializeQueryArgs: serializeQueryArgs,
                reducerPath: reducerPath,
                assertTagType: assertTagType,
                config: {
                    refetchOnFocus: refetchOnFocus,
                    refetchOnReconnect: refetchOnReconnect,
                    refetchOnMountOrArgChange: refetchOnMountOrArgChange,
                    keepUnusedDataFor: keepUnusedDataFor,
                    reducerPath: reducerPath,
                    invalidationBehavior: invalidationBehavior
                }
            });
            $7c5b8303526498ea$var$safeAssign(api.util, {
                patchQueryData: patchQueryData,
                updateQueryData: updateQueryData,
                upsertQueryData: upsertQueryData,
                prefetch: prefetch,
                resetApiState: sliceActions.resetApiState,
                upsertQueryEntries: sliceActions.cacheEntriesUpserted
            });
            $7c5b8303526498ea$var$safeAssign(api.internalActions, sliceActions);
            const internalStateMap = /* @__PURE__ */ new WeakMap();
            const getInternalState = (dispatch)=>{
                return $7c5b8303526498ea$var$getOrInsertComputed(internalStateMap, dispatch, ()=>({
                        currentSubscriptions: /* @__PURE__ */ new Map(),
                        currentPolls: /* @__PURE__ */ new Map(),
                        runningQueries: /* @__PURE__ */ new Map(),
                        runningMutations: /* @__PURE__ */ new Map()
                    }));
            };
            const { buildInitiateQuery: buildInitiateQuery, buildInitiateInfiniteQuery: buildInitiateInfiniteQuery, buildInitiateMutation: buildInitiateMutation, getRunningMutationThunk: getRunningMutationThunk, getRunningMutationsThunk: getRunningMutationsThunk, getRunningQueriesThunk: getRunningQueriesThunk, getRunningQueryThunk: getRunningQueryThunk } = $7c5b8303526498ea$var$buildInitiate({
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                infiniteQueryThunk: infiniteQueryThunk,
                api: api,
                serializeQueryArgs: serializeQueryArgs,
                context: context,
                getInternalState: getInternalState
            });
            $7c5b8303526498ea$var$safeAssign(api.util, {
                getRunningMutationThunk: getRunningMutationThunk,
                getRunningMutationsThunk: getRunningMutationsThunk,
                getRunningQueryThunk: getRunningQueryThunk,
                getRunningQueriesThunk: getRunningQueriesThunk
            });
            const { middleware: middleware, actions: middlewareActions } = $7c5b8303526498ea$var$buildMiddleware({
                reducerPath: reducerPath,
                context: context,
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                infiniteQueryThunk: infiniteQueryThunk,
                api: api,
                assertTagType: assertTagType,
                selectors: selectors,
                getRunningQueryThunk: getRunningQueryThunk,
                getInternalState: getInternalState
            });
            $7c5b8303526498ea$var$safeAssign(api.util, middlewareActions);
            $7c5b8303526498ea$var$safeAssign(api, {
                reducer: reducer,
                middleware: middleware
            });
            return {
                name: $7c5b8303526498ea$export$2902d0921e535c0,
                injectEndpoint (endpointName, definition) {
                    const anyApi = api;
                    const endpoint = anyApi.endpoints[endpointName] ??= {};
                    if ($7c5b8303526498ea$var$isQueryDefinition(definition)) $7c5b8303526498ea$var$safeAssign(endpoint, {
                        name: endpointName,
                        select: buildQuerySelector(endpointName, definition),
                        initiate: buildInitiateQuery(endpointName, definition)
                    }, buildMatchThunkActions(queryThunk, endpointName));
                    if ($7c5b8303526498ea$var$isMutationDefinition(definition)) $7c5b8303526498ea$var$safeAssign(endpoint, {
                        name: endpointName,
                        select: buildMutationSelector(),
                        initiate: buildInitiateMutation(endpointName)
                    }, buildMatchThunkActions(mutationThunk, endpointName));
                    if ($7c5b8303526498ea$var$isInfiniteQueryDefinition(definition)) $7c5b8303526498ea$var$safeAssign(endpoint, {
                        name: endpointName,
                        select: buildInfiniteQuerySelector(endpointName, definition),
                        initiate: buildInitiateInfiniteQuery(endpointName, definition)
                    }, buildMatchThunkActions(queryThunk, endpointName));
                }
            };
        }
    });
//#endregion
//#region src/query/core/index.ts
const $7c5b8303526498ea$export$9cdc2b9a8d94c842 = /* @__PURE__ */ $7c5b8303526498ea$export$f957748792d43646($7c5b8303526498ea$export$eb718ff92afd6f9b());

});
parcelRegister("dpYkU", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $13f8f0550b71b2fa$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "createStore", function () { return $13f8f0550b71b2fa$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $13f8f0550b71b2fa$export$66e4520cdb265d18; });
$parcel$export(module.exports, "compose", function () { return $13f8f0550b71b2fa$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $13f8f0550b71b2fa$export$9ff26e0402cc7b7; });
$parcel$export(module.exports, "isAction", function () { return $13f8f0550b71b2fa$export$b956e38827fca970; });
// src/utils/formatProdErrorMessage.ts
function $13f8f0550b71b2fa$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $13f8f0550b71b2fa$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $13f8f0550b71b2fa$var$symbol_observable_default = $13f8f0550b71b2fa$var$$$observable;
// src/utils/actionTypes.ts
var $13f8f0550b71b2fa$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $13f8f0550b71b2fa$var$ActionTypes = {
    INIT: `@@redux/INIT${$13f8f0550b71b2fa$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$13f8f0550b71b2fa$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$13f8f0550b71b2fa$var$randomString()}`
};
var $13f8f0550b71b2fa$export$4219e499db7ca678 = $13f8f0550b71b2fa$var$ActionTypes;
// src/utils/isPlainObject.ts
function $13f8f0550b71b2fa$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $13f8f0550b71b2fa$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($13f8f0550b71b2fa$var$isDate(val)) return "date";
    if ($13f8f0550b71b2fa$var$isError(val)) return "error";
    const constructorName = $13f8f0550b71b2fa$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $13f8f0550b71b2fa$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $13f8f0550b71b2fa$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $13f8f0550b71b2fa$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $13f8f0550b71b2fa$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $13f8f0550b71b2fa$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($13f8f0550b71b2fa$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($13f8f0550b71b2fa$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($13f8f0550b71b2fa$var$formatProdErrorMessage(1));
        return enhancer($13f8f0550b71b2fa$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($13f8f0550b71b2fa$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($13f8f0550b71b2fa$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($13f8f0550b71b2fa$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($13f8f0550b71b2fa$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$13f8f0550b71b2fa$export$53b83ca8eaab0383(action)) throw new Error($13f8f0550b71b2fa$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($13f8f0550b71b2fa$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($13f8f0550b71b2fa$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($13f8f0550b71b2fa$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($13f8f0550b71b2fa$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $13f8f0550b71b2fa$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($13f8f0550b71b2fa$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$13f8f0550b71b2fa$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $13f8f0550b71b2fa$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$13f8f0550b71b2fa$var$symbol_observable_default]: observable
    };
    return store;
}
function $13f8f0550b71b2fa$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $13f8f0550b71b2fa$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $13f8f0550b71b2fa$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $13f8f0550b71b2fa$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $13f8f0550b71b2fa$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$13f8f0550b71b2fa$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$13f8f0550b71b2fa$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $13f8f0550b71b2fa$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $13f8f0550b71b2fa$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $13f8f0550b71b2fa$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($13f8f0550b71b2fa$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $13f8f0550b71b2fa$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($13f8f0550b71b2fa$var$formatProdErrorMessage(13));
    });
}
function $13f8f0550b71b2fa$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $13f8f0550b71b2fa$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($13f8f0550b71b2fa$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $13f8f0550b71b2fa$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $13f8f0550b71b2fa$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $13f8f0550b71b2fa$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($13f8f0550b71b2fa$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $13f8f0550b71b2fa$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $13f8f0550b71b2fa$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $13f8f0550b71b2fa$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($13f8f0550b71b2fa$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $13f8f0550b71b2fa$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $13f8f0550b71b2fa$export$b956e38827fca970(action) {
    return $13f8f0550b71b2fa$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}

});

parcelRegister("37Zv1", function(module, exports) {

$parcel$export(module.exports, "createAction", function () { return $3a977e47250b8b44$export$309c7a02b0b0bc62; });
$parcel$export(module.exports, "formatProdErrorMessage", function () { return $3a977e47250b8b44$export$378fa86b259c0280; });
$parcel$export(module.exports, "SHOULD_AUTOBATCH", function () { return $3a977e47250b8b44$export$8fb31c0f05df007b; });
$parcel$export(module.exports, "prepareAutoBatched", function () { return $3a977e47250b8b44$export$39fcd5145ec5e4e2; });
$parcel$export(module.exports, "autoBatchEnhancer", function () { return $3a977e47250b8b44$export$676277d7dca0f396; });
$parcel$export(module.exports, "configureStore", function () { return $3a977e47250b8b44$export$7d8a5b498da695ac; });
$parcel$export(module.exports, "isAnyOf", function () { return $3a977e47250b8b44$export$2c3435c7647f7b0d; });
$parcel$export(module.exports, "isAllOf", function () { return $3a977e47250b8b44$export$9dd1fb32974da385; });
$parcel$export(module.exports, "isPending", function () { return $3a977e47250b8b44$export$872dec21e9a69476; });
$parcel$export(module.exports, "isRejected", function () { return $3a977e47250b8b44$export$a5c5d27e3994c5be; });
$parcel$export(module.exports, "isRejectedWithValue", function () { return $3a977e47250b8b44$export$fcc3388fb56de601; });
$parcel$export(module.exports, "isFulfilled", function () { return $3a977e47250b8b44$export$1da80a6ef1307441; });
$parcel$export(module.exports, "isAsyncThunkAction", function () { return $3a977e47250b8b44$export$6aa4142d99c1abce; });
$parcel$export(module.exports, "nanoid", function () { return $3a977e47250b8b44$export$ac4959f4f1338dfc; });
$parcel$export(module.exports, "createAsyncThunk", function () { return $3a977e47250b8b44$export$6abd22dc03e5063f; });
$parcel$export(module.exports, "createSlice", function () { return $3a977e47250b8b44$export$4d8d9bd83c24ae8b; });
$parcel$export(module.exports, "createListenerMiddleware", function () { return $3a977e47250b8b44$export$1228acebbbcb485b; });
$parcel$export(module.exports, "createNextState", function () { return (parcelRequire("3xSPq")).produce; });
$parcel$export(module.exports, "current", function () { return (parcelRequire("3xSPq")).current; });

var $dpYkU = parcelRequire("dpYkU");

var $3xSPq = parcelRequire("3xSPq");

var $6xl8b = parcelRequire("6xl8b");

var $6sXbR = parcelRequire("6sXbR");
//#region src/createDraftSafeSelector.ts
const $3a977e47250b8b44$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector = (0, $6xl8b.createSelectorCreator)(...args);
    const createDraftSafeSelector = Object.assign((...args)=>{
        const selector = createSelector(...args);
        const wrappedSelector = (value, ...rest)=>selector((0, $3xSPq.isDraft)(value) ? (0, $3xSPq.current)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector
    });
    return createDraftSafeSelector;
};
const $3a977e47250b8b44$export$a5d3c27355e35910 = /* @__PURE__ */ $3a977e47250b8b44$export$aab6de9e3dbb1473((0, $6xl8b.weakMapMemoize));
//#endregion
//#region src/devtoolsExtension.ts
const $3a977e47250b8b44$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $dpYkU.compose;
    return (0, $dpYkU.compose).apply(null, arguments);
};
typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__;
//#endregion
//#region src/tsHelpers.ts
const $3a977e47250b8b44$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
//#endregion
//#region src/createAction.ts
function $3a977e47250b8b44$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($3a977e47250b8b44$export$378fa86b259c0280(0));
            return {
                type: type,
                payload: prepared.payload,
                ..."meta" in prepared && {
                    meta: prepared.meta
                },
                ..."error" in prepared && {
                    error: prepared.error
                }
            };
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>action != null && action.type === type && (0, $dpYkU.isAction)(action);
    return actionCreator;
}
function $3a977e47250b8b44$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $3a977e47250b8b44$var$hasMatchFunction(action);
}
function $3a977e47250b8b44$export$ebd532f9034651f3(action) {
    return (0, $dpYkU.isAction)(action) && Object.keys(action).every($3a977e47250b8b44$var$isValidKey);
}
function $3a977e47250b8b44$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
//#endregion
//#region src/actionCreatorInvariantMiddleware.ts
function $3a977e47250b8b44$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched.
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $3a977e47250b8b44$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
//#endregion
//#region src/utils.ts
function $3a977e47250b8b44$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                elapsed += Date.now() - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $3a977e47250b8b44$export$1908877435b1d5e9 = class Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, Tuple.prototype);
    }
    static get [Symbol.species]() {
        return Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new Tuple(...arr[0].concat(this));
        return new Tuple(...arr.concat(this));
    }
};
function $3a977e47250b8b44$var$freezeDraftable(val) {
    return (0, $3xSPq.isDraftable)(val) ? (0, $3xSPq.produce)(val, ()=>{}) : val;
}
function $3a977e47250b8b44$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
//#endregion
//#region src/immutableStateInvariantMiddleware.ts
function $3a977e47250b8b44$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $3a977e47250b8b44$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $3a977e47250b8b44$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $3a977e47250b8b44$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $3a977e47250b8b44$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", inProgress = /* @__PURE__ */ new Map()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        const alreadyInProgress = inProgress.get(obj);
        if (alreadyInProgress) return alreadyInProgress;
        tracked.children = {};
        inProgress.set(obj, tracked);
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                if (ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                })) continue;
            }
            tracked.children[key] = $3a977e47250b8b44$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath, inProgress);
        }
        inProgress.delete(obj);
    }
    return tracked;
}
function $3a977e47250b8b44$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "", seen = /* @__PURE__ */ new Map()) {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    let seenValues = seen.get(trackedProperty);
    if (!seenValues) {
        seenValues = /* @__PURE__ */ new Set();
        seen.set(trackedProperty, seenValues);
    } else if (seenValues.has(obj)) return {
        wasMutated: false
    };
    seenValues.add(obj);
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            if (ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            })) continue;
        }
        const result = $3a977e47250b8b44$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath, seen);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $3a977e47250b8b44$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
//#endregion
//#region src/serializableStateInvariantMiddleware.ts
function $3a977e47250b8b44$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $dpYkU.isPlainObject)(val);
}
function $3a977e47250b8b44$export$ada5dca0b571bc7(value, path = "", isSerializable = $3a977e47250b8b44$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    return $3a977e47250b8b44$var$findNonSerializableValueRecursive(value, path, isSerializable, getEntries, ignoredPaths, cache, /* @__PURE__ */ new Set());
}
function $3a977e47250b8b44$var$findNonSerializableValueRecursive(value, path, isSerializable, getEntries, ignoredPaths, cache, ancestors) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache?.has(value)) return false;
    if (ancestors.has(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    ancestors.add(value);
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            if (ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            })) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $3a977e47250b8b44$var$findNonSerializableValueRecursive(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache, ancestors);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    ancestors.delete(value);
    if (cache && $3a977e47250b8b44$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $3a977e47250b8b44$var$isNestedFrozen(value) {
    return $3a977e47250b8b44$var$isNestedFrozenRecursive(value, /* @__PURE__ */ new Set());
}
function $3a977e47250b8b44$var$isNestedFrozenRecursive(value, visited) {
    if (!Object.isFrozen(value)) return false;
    if (visited.has(value)) return true;
    visited.add(value);
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$3a977e47250b8b44$var$isNestedFrozenRecursive(nestedValue, visited)) return false;
    }
    return true;
}
function $3a977e47250b8b44$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
//#endregion
//#region src/getDefaultMiddleware.ts
function $3a977e47250b8b44$var$isBoolean(x) {
    return typeof x === "boolean";
}
const $3a977e47250b8b44$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk$1 = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options ?? {};
        let middlewareArray = new $3a977e47250b8b44$export$1908877435b1d5e9();
        if (thunk$1) {
            if ($3a977e47250b8b44$var$isBoolean(thunk$1)) middlewareArray.push((0, $6sXbR.thunk));
            else middlewareArray.push((0, $6sXbR.withExtraArgument)(thunk$1.extraArgument));
        }
        return middlewareArray;
    };
//#endregion
//#region src/autoBatchEnhancer.ts
const $3a977e47250b8b44$export$8fb31c0f05df007b = "RTK_autoBatch";
const $3a977e47250b8b44$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$3a977e47250b8b44$export$8fb31c0f05df007b]: true
            }
        });
const $3a977e47250b8b44$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
const $3a977e47250b8b44$var$createRafWithFallbackTimer = (raf, caf, timeout)=>{
    return (notify)=>{
        let called = false;
        let rafId;
        let timerId;
        const callback = ()=>{
            if (called) return;
            called = true;
            caf?.(rafId);
            clearTimeout(timerId);
            notify();
        };
        rafId = raf(callback);
        timerId = setTimeout(callback, timeout);
    };
};
const $3a977e47250b8b44$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? typeof window !== "undefined" && window.requestAnimationFrame ? $3a977e47250b8b44$var$createRafWithFallbackTimer(window.requestAnimationFrame, window.cancelAnimationFrame, 100) : $3a977e47250b8b44$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $3a977e47250b8b44$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                subscribe (listener) {
                    const wrappedListener = ()=>notifying && listener();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener);
                    };
                },
                dispatch (action) {
                    try {
                        notifying = !action?.meta?.[$3a977e47250b8b44$export$8fb31c0f05df007b];
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
//#endregion
//#region src/getDefaultEnhancers.ts
const $3a977e47250b8b44$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options ?? {};
        let enhancerArray = new $3a977e47250b8b44$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($3a977e47250b8b44$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
//#endregion
//#region src/configureStore.ts
function $3a977e47250b8b44$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $3a977e47250b8b44$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $dpYkU.isPlainObject)(reducer)) rootReducer = (0, $dpYkU.combineReducers)(reducer);
    else throw new Error($3a977e47250b8b44$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware1;
    let finalCompose = (0, $dpYkU.compose);
    if (devTools) finalCompose = $3a977e47250b8b44$var$composeWithDevTools({
        trace: false,
        ...typeof devTools === "object" && devTools
    });
    const middlewareEnhancer = (0, $dpYkU.applyMiddleware)(...finalMiddleware);
    const getDefaultEnhancers = $3a977e47250b8b44$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $dpYkU.createStore)(rootReducer, preloadedState, composedEnhancer);
}
//#endregion
//#region src/mapBuilders.ts
function $3a977e47250b8b44$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($3a977e47250b8b44$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($3a977e47250b8b44$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
//#endregion
//#region src/createReducer.ts
function $3a977e47250b8b44$var$isStateFunction(x) {
    return typeof x === "function";
}
function $3a977e47250b8b44$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $3a977e47250b8b44$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($3a977e47250b8b44$var$isStateFunction(initialState)) getInitialState = ()=>$3a977e47250b8b44$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $3a977e47250b8b44$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function applyCaseReducer(previousState, caseReducer, action) {
        if ((0, $3xSPq.isDraft)(previousState)) {
            const result = caseReducer(previousState, action);
            if (result === void 0) return previousState;
            return result;
        } else if (!(0, $3xSPq.isDraftable)(previousState)) {
            const result = caseReducer(previousState, action);
            if (result === void 0) {
                if (previousState === null) return previousState;
                throw new Error($3a977e47250b8b44$export$378fa86b259c0280(9));
            }
            return result;
        } else return (0, $3xSPq.produce)(previousState, (draft)=>{
            return caseReducer(draft, action);
        });
    }
    function reducer(state = getInitialState(), action) {
        const caseReducer = actionsMap[action.type];
        let matchedReducers;
        for (const { matcher: matcher, reducer: reducer } of finalActionMatchers)if (matcher(action) && reducer) (matchedReducers ??= []).push(reducer);
        if (!caseReducer && !matchedReducers) return finalDefaultCaseReducer ? applyCaseReducer(state, finalDefaultCaseReducer, action) : state;
        if (caseReducer) state = applyCaseReducer(state, caseReducer, action);
        if (matchedReducers) for (const matchedReducer of matchedReducers)state = applyCaseReducer(state, matchedReducer, action);
        return state;
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
//#endregion
//#region src/matchers.ts
const $3a977e47250b8b44$var$matches = (matcher, action)=>{
    if ($3a977e47250b8b44$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $3a977e47250b8b44$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$3a977e47250b8b44$var$matches(matcher, action));
    };
}
function $3a977e47250b8b44$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$3a977e47250b8b44$var$matches(matcher, action));
    };
}
function $3a977e47250b8b44$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $3a977e47250b8b44$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $3a977e47250b8b44$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$3a977e47250b8b44$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$3a977e47250b8b44$var$isAsyncThunkArray(asyncThunks)) return $3a977e47250b8b44$export$872dec21e9a69476()(asyncThunks[0]);
    return $3a977e47250b8b44$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $3a977e47250b8b44$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$3a977e47250b8b44$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$3a977e47250b8b44$var$isAsyncThunkArray(asyncThunks)) return $3a977e47250b8b44$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $3a977e47250b8b44$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $3a977e47250b8b44$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $3a977e47250b8b44$export$9dd1fb32974da385($3a977e47250b8b44$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$3a977e47250b8b44$var$isAsyncThunkArray(asyncThunks)) return $3a977e47250b8b44$export$fcc3388fb56de601()(asyncThunks[0]);
    return $3a977e47250b8b44$export$9dd1fb32974da385($3a977e47250b8b44$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $3a977e47250b8b44$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$3a977e47250b8b44$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$3a977e47250b8b44$var$isAsyncThunkArray(asyncThunks)) return $3a977e47250b8b44$export$1da80a6ef1307441()(asyncThunks[0]);
    return $3a977e47250b8b44$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $3a977e47250b8b44$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$3a977e47250b8b44$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$3a977e47250b8b44$var$isAsyncThunkArray(asyncThunks)) return $3a977e47250b8b44$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $3a977e47250b8b44$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
//#endregion
//#region src/nanoid.ts
let $3a977e47250b8b44$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
let $3a977e47250b8b44$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $3a977e47250b8b44$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
//#endregion
//#region src/createAsyncThunk.ts
const $3a977e47250b8b44$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $3a977e47250b8b44$var$RejectWithValue = class {
    payload;
    meta;
    _type;
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
};
var $3a977e47250b8b44$var$FulfillWithMeta = class {
    payload;
    meta;
    _type;
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
};
const $3a977e47250b8b44$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $3a977e47250b8b44$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
const $3a977e47250b8b44$var$externalAbortMessage = "External signal was aborted";
const $3a977e47250b8b44$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk(typePrefix, payloadCreator, options) {
        const fulfilled = $3a977e47250b8b44$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                }
            }));
        const pending = $3a977e47250b8b44$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                }
            }));
        const rejected = $3a977e47250b8b44$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $3a977e47250b8b44$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: payload !== void 0,
                    requestStatus: "rejected",
                    aborted: error?.name === "AbortError",
                    condition: error?.name === "ConditionError"
                }
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = options?.idGenerator ? options.idGenerator(arg) : $3a977e47250b8b44$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($3a977e47250b8b44$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($3a977e47250b8b44$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    let finalAction;
                    try {
                        let conditionResult = options?.condition?.(arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($3a977e47250b8b44$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        if (abortController.signal.aborted) throw {
                            name: "AbortError",
                            message: abortReason || "Aborted"
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, options?.getPendingMeta?.({
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $3a977e47250b8b44$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $3a977e47250b8b44$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $3a977e47250b8b44$var$RejectWithValue) throw result;
                                if (result instanceof $3a977e47250b8b44$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $3a977e47250b8b44$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    if (!(options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition)) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($3a977e47250b8b44$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $3a977e47250b8b44$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk.withTypes = ()=>createAsyncThunk;
    return createAsyncThunk;
})();
function $3a977e47250b8b44$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $3a977e47250b8b44$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
//#endregion
//#region src/createSlice.ts
const $3a977e47250b8b44$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
const $3a977e47250b8b44$export$343355ed40c51c46 = /* @__PURE__ */ (()=>({
        [$3a977e47250b8b44$var$asyncThunkSymbol]: $3a977e47250b8b44$export$6abd22dc03e5063f
    }))();
let $3a977e47250b8b44$export$23a094319a4b586 = /* @__PURE__ */ function(ReducerType) {
    ReducerType["reducer"] = "reducer";
    ReducerType["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType["asyncThunk"] = "asyncThunk";
    return ReducerType;
}({});
function $3a977e47250b8b44$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $3a977e47250b8b44$export$affdea4146de9cf5({ creators: creators } = {}) {
    const cAT = creators?.asyncThunk?.[$3a977e47250b8b44$var$asyncThunkSymbol];
    return function createSlice(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($3a977e47250b8b44$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($3a977e47250b8b44$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($3a977e47250b8b44$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($3a977e47250b8b44$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer;
                return contextMethods;
            },
            addMatcher (matcher, reducer) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer
                });
                return contextMethods;
            },
            exposeAction (name, actionCreator) {
                context.actionCreators[name] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name, reducer) {
                context.sliceCaseReducersByName[name] = reducer;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $3a977e47250b8b44$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($3a977e47250b8b44$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $3a977e47250b8b44$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $3a977e47250b8b44$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $3a977e47250b8b44$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = {
                ...extraReducers,
                ...context.sliceCaseReducersByType
            };
            return $3a977e47250b8b44$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $3a977e47250b8b44$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                return $3a977e47250b8b44$var$getOrInsertComputed($3a977e47250b8b44$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap()), selectState, ()=>{
                    const map = {};
                    for (const [name, selector] of Object.entries(options.selectors ?? {}))map[name] = $3a977e47250b8b44$var$wrapSelector(selector, selectState, ()=>$3a977e47250b8b44$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = {
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState,
            ...makeSelectorProps(reducerPath),
            injectInto (injectable, { reducerPath: pathOpt, ...config } = {}) {
                const newReducerPath = pathOpt ?? reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return {
                    ...slice,
                    ...makeSelectorProps(newReducerPath, true)
                };
            }
        };
        return slice;
    };
}
function $3a977e47250b8b44$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
const $3a977e47250b8b44$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $3a977e47250b8b44$export$affdea4146de9cf5();
function $3a977e47250b8b44$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return {
            _reducerDefinitionType: "asyncThunk",
            payloadCreator: payloadCreator,
            ...config
        };
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer"
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare",
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $3a977e47250b8b44$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$3a977e47250b8b44$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($3a977e47250b8b44$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $3a977e47250b8b44$export$309c7a02b0b0bc62(type, prepareCallback) : $3a977e47250b8b44$export$309c7a02b0b0bc62(type));
}
function $3a977e47250b8b44$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk";
}
function $3a977e47250b8b44$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare";
}
function $3a977e47250b8b44$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($3a977e47250b8b44$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $3a977e47250b8b44$var$noop$1,
        pending: pending || $3a977e47250b8b44$var$noop$1,
        rejected: rejected || $3a977e47250b8b44$var$noop$1,
        settled: settled || $3a977e47250b8b44$var$noop$1
    });
}
function $3a977e47250b8b44$var$noop$1() {}
//#endregion
//#region src/entities/entity_state.ts
function $3a977e47250b8b44$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $3a977e47250b8b44$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($3a977e47250b8b44$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
//#endregion
//#region src/entities/state_selectors.ts
function $3a977e47250b8b44$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector = $3a977e47250b8b44$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector(selectIds, (ids)=>ids.length);
        const selectIdsArg = (_, ids)=>ids;
        const selectByIds = (entities, ids)=>{
            const result = [];
            for (const id of ids){
                const entity = entities[id];
                if (entity !== void 0) result.push(entity);
            }
            return result;
        };
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector(selectEntities, selectId, selectById),
            selectByIds: createSelector(selectEntities, selectIdsArg, selectByIds)
        };
        const selectGlobalizedEntities = createSelector(selectState, selectEntities);
        return {
            selectIds: createSelector(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector(selectState, selectAll),
            selectTotal: createSelector(selectState, selectTotal),
            selectById: createSelector(selectGlobalizedEntities, selectId, selectById),
            selectByIds: createSelector(selectGlobalizedEntities, selectIdsArg, selectByIds)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
//#endregion
//#region src/entities/state_adapter.ts
const $3a977e47250b8b44$var$isDraftTyped = (0, $3xSPq.isDraft);
function $3a977e47250b8b44$var$createSingleArgumentStateOperator(mutator) {
    const operator = $3a977e47250b8b44$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $3a977e47250b8b44$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg) {
            return $3a977e47250b8b44$export$ebd532f9034651f3(arg);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($3a977e47250b8b44$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $3xSPq.produce)(state, runMutator);
    };
}
//#endregion
//#region src/entities/utils.ts
function $3a977e47250b8b44$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $3a977e47250b8b44$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $3a977e47250b8b44$var$isRemoveManyFilter(keysOrFilter) {
    return !Array.isArray(keysOrFilter);
}
function $3a977e47250b8b44$var$getCurrent(value) {
    return (0, $3xSPq.isDraft)(value) ? (0, $3xSPq.current)(value) : value;
}
function $3a977e47250b8b44$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $3a977e47250b8b44$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $3a977e47250b8b44$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $3a977e47250b8b44$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
//#endregion
//#region src/entities/unsorted_state_adapter.ts
function $3a977e47250b8b44$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $3a977e47250b8b44$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $3a977e47250b8b44$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $3a977e47250b8b44$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $3a977e47250b8b44$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $3a977e47250b8b44$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        setManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keysOrFilter, state) {
        const keys = $3a977e47250b8b44$var$isRemoveManyFilter(keysOrFilter) ? selectMatchingIds(keysOrFilter.where, state) : keysOrFilter;
        const removedIds = /* @__PURE__ */ new Set();
        for (const key of keys)if (key in state.entities) {
            delete state.entities[key];
            removedIds.add(String(key));
        }
        if (removedIds.size > 0) state.ids = $3a977e47250b8b44$var$getCurrent(state.ids).filter((id)=>!removedIds.has(String(id)));
    }
    function selectMatchingIds(where, state) {
        const ids = $3a977e47250b8b44$var$getCurrent(state.ids);
        const entities = $3a977e47250b8b44$var$getCurrent(state.entities);
        const whereKeys = Object.keys(where);
        if (whereKeys.length === 0) return [];
        return ids.filter((id)=>{
            const entity = entities[id];
            return whereKeys.every((key)=>entity[key] === where[key]);
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original = state.entities[update.id];
        if (original === void 0) return false;
        const updated = Object.assign({}, original, update.changes);
        const newKey = $3a977e47250b8b44$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: {
                    ...updatesPerEntity[update.id]?.changes,
                    ...update.changes
                }
            };
        });
        updates = Object.values(updatesPerEntity);
        if (updates.length > 0) {
            if (updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0) state.ids = Object.values(state.entities).map((e)=>$3a977e47250b8b44$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $3a977e47250b8b44$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $3a977e47250b8b44$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $3a977e47250b8b44$var$createStateOperator(addOneMutably),
        addMany: $3a977e47250b8b44$var$createStateOperator(addManyMutably),
        setOne: $3a977e47250b8b44$var$createStateOperator(setOneMutably),
        setMany: $3a977e47250b8b44$var$createStateOperator(setManyMutably),
        setAll: $3a977e47250b8b44$var$createStateOperator(setAllMutably),
        updateOne: $3a977e47250b8b44$var$createStateOperator(updateOneMutably),
        updateMany: $3a977e47250b8b44$var$createStateOperator(updateManyMutably),
        upsertOne: $3a977e47250b8b44$var$createStateOperator(upsertOneMutably),
        upsertMany: $3a977e47250b8b44$var$createStateOperator(upsertManyMutably),
        removeOne: $3a977e47250b8b44$var$createStateOperator(removeOneMutably),
        removeMany: $3a977e47250b8b44$var$createStateOperator(removeManyMutably)
    };
}
//#endregion
//#region src/entities/sorted_state_adapter.ts
function $3a977e47250b8b44$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        if (comparisonFunction(item, currentItem) >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $3a977e47250b8b44$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $3a977e47250b8b44$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $3a977e47250b8b44$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $3a977e47250b8b44$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $3a977e47250b8b44$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds ?? $3a977e47250b8b44$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $3a977e47250b8b44$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $3a977e47250b8b44$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $3a977e47250b8b44$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $3a977e47250b8b44$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        setManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        const updatesPerEntity = {};
        for (const update of updates)if (update.id in state.entities) updatesPerEntity[update.id] = {
            id: update.id,
            changes: {
                ...updatesPerEntity[update.id]?.changes,
                ...update.changes
            }
        };
        for (const update of Object.values(updatesPerEntity)){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $3a977e47250b8b44$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function mergeFunction(state, addedItems, appliedUpdates, replacedIds) {
        const currentEntities = $3a977e47250b8b44$var$getCurrent(state.entities);
        const currentIds = $3a977e47250b8b44$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $3a977e47250b8b44$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $3a977e47250b8b44$var$createStateOperator(addOneMutably),
        updateOne: $3a977e47250b8b44$var$createStateOperator(updateOneMutably),
        upsertOne: $3a977e47250b8b44$var$createStateOperator(upsertOneMutably),
        setOne: $3a977e47250b8b44$var$createStateOperator(setOneMutably),
        setMany: $3a977e47250b8b44$var$createStateOperator(setManyMutably),
        setAll: $3a977e47250b8b44$var$createStateOperator(setAllMutably),
        addMany: $3a977e47250b8b44$var$createStateOperator(addManyMutably),
        updateMany: $3a977e47250b8b44$var$createStateOperator(updateManyMutably),
        upsertMany: $3a977e47250b8b44$var$createStateOperator(upsertManyMutably)
    };
}
//#endregion
//#region src/entities/create_adapter.ts
function $3a977e47250b8b44$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = {
        sortComparer: false,
        selectId: (instance)=>instance.id,
        ...options
    };
    const stateAdapter = sortComparer ? $3a977e47250b8b44$var$createSortedStateAdapter(selectId, sortComparer) : $3a977e47250b8b44$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $3a977e47250b8b44$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $3a977e47250b8b44$var$createSelectorsFactory();
    return {
        selectId: selectId,
        sortComparer: sortComparer,
        ...stateFactory,
        ...selectorsFactory,
        ...stateAdapter
    };
}
//#endregion
//#region src/listenerMiddleware/exceptions.ts
const $3a977e47250b8b44$var$task = "task";
const $3a977e47250b8b44$var$listener = "listener";
const $3a977e47250b8b44$var$completed = "completed";
const $3a977e47250b8b44$var$cancelled = "cancelled";
const $3a977e47250b8b44$var$taskCancelled = `task-${$3a977e47250b8b44$var$cancelled}`;
const $3a977e47250b8b44$var$taskCompleted = `task-${$3a977e47250b8b44$var$completed}`;
const $3a977e47250b8b44$var$listenerCancelled = `${$3a977e47250b8b44$var$listener}-${$3a977e47250b8b44$var$cancelled}`;
const $3a977e47250b8b44$var$listenerCompleted = `${$3a977e47250b8b44$var$listener}-${$3a977e47250b8b44$var$completed}`;
var $3a977e47250b8b44$export$cb1bdac908fed7f = class {
    code;
    name = "TaskAbortError";
    message;
    constructor(code){
        this.code = code;
        this.message = `${$3a977e47250b8b44$var$task} ${$3a977e47250b8b44$var$cancelled} (reason: ${code})`;
    }
};
//#endregion
//#region src/listenerMiddleware/utils.ts
const $3a977e47250b8b44$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($3a977e47250b8b44$export$378fa86b259c0280(32));
};
const $3a977e47250b8b44$var$noop = ()=>{};
const $3a977e47250b8b44$var$catchRejection = (promise, onError = $3a977e47250b8b44$var$noop)=>{
    promise.catch(onError);
    return promise;
};
const $3a977e47250b8b44$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
//#endregion
//#region src/listenerMiddleware/task.ts
const $3a977e47250b8b44$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $3a977e47250b8b44$export$cb1bdac908fed7f(signal.reason);
};
function $3a977e47250b8b44$var$raceWithSignal(signal, promise) {
    let cleanup = $3a977e47250b8b44$var$noop;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $3a977e47250b8b44$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $3a977e47250b8b44$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $3a977e47250b8b44$var$noop;
    });
}
const $3a977e47250b8b44$var$runTask = async (task, cleanUp)=>{
    try {
        await Promise.resolve();
        return {
            status: "ok",
            value: await task()
        };
    } catch (error) {
        return {
            status: error instanceof $3a977e47250b8b44$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp?.();
    }
};
const $3a977e47250b8b44$var$createPause = (signal)=>{
    return (promise)=>{
        return $3a977e47250b8b44$var$catchRejection($3a977e47250b8b44$var$raceWithSignal(signal, promise).then((output)=>{
            $3a977e47250b8b44$var$validateActive(signal);
            return output;
        }));
    };
};
const $3a977e47250b8b44$var$createDelay = (signal)=>{
    const pause = $3a977e47250b8b44$var$createPause(signal);
    return (timeoutMs)=>{
        let timeoutId;
        return $3a977e47250b8b44$var$catchRejection(pause(new Promise((resolve)=>{
            timeoutId = setTimeout(resolve, timeoutMs);
        })).finally(()=>clearTimeout(timeoutId)));
    };
};
//#endregion
//#region src/listenerMiddleware/index.ts
const { assign: $3a977e47250b8b44$var$assign } = Object;
const $3a977e47250b8b44$var$INTERNAL_NIL_TOKEN = {};
const $3a977e47250b8b44$var$alm = "listenerMiddleware";
const $3a977e47250b8b44$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$3a977e47250b8b44$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $3a977e47250b8b44$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $3a977e47250b8b44$var$runTask(async ()=>{
            $3a977e47250b8b44$var$validateActive(parentAbortSignal);
            $3a977e47250b8b44$var$validateActive(childAbortController.signal);
            const result = await taskExecutor({
                pause: $3a977e47250b8b44$var$createPause(childAbortController.signal),
                delay: $3a977e47250b8b44$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $3a977e47250b8b44$var$validateActive(childAbortController.signal);
            return result;
        }, ()=>childAbortController.abort($3a977e47250b8b44$var$taskCompleted));
        if (opts?.autoJoin) parentBlockingPromises.push(result.catch($3a977e47250b8b44$var$noop));
        return {
            result: $3a977e47250b8b44$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($3a977e47250b8b44$var$taskCancelled);
            }
        };
    };
};
const $3a977e47250b8b44$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $3a977e47250b8b44$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const promises = [
            new Promise((resolve, reject)=>{
                let stopListening = startListening({
                    predicate: predicate,
                    effect: (action, listenerApi)=>{
                        listenerApi.unsubscribe();
                        resolve([
                            action,
                            listenerApi.getState(),
                            listenerApi.getOriginalState()
                        ]);
                    }
                });
                unsubscribe = ()=>{
                    stopListening();
                    reject();
                };
            })
        ];
        let timeoutId;
        if (timeout != null) promises.push(new Promise((resolve)=>{
            timeoutId = setTimeout(resolve, timeout, null);
        }));
        try {
            const output = await $3a977e47250b8b44$var$raceWithSignal(signal, Promise.race(promises));
            $3a977e47250b8b44$var$validateActive(signal);
            return output;
        } finally{
            clearTimeout(timeoutId);
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$3a977e47250b8b44$var$catchRejection(take(predicate, timeout));
};
const $3a977e47250b8b44$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $3a977e47250b8b44$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($3a977e47250b8b44$export$378fa86b259c0280(21));
    $3a977e47250b8b44$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
const $3a977e47250b8b44$var$createListenerEntry = /* @__PURE__ */ $3a977e47250b8b44$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $3a977e47250b8b44$var$getListenerEntryPropsFrom(options);
    return {
        id: $3a977e47250b8b44$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($3a977e47250b8b44$export$378fa86b259c0280(22));
        }
    };
}, {
    withTypes: ()=>$3a977e47250b8b44$var$createListenerEntry
});
const $3a977e47250b8b44$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $3a977e47250b8b44$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        return (typeof type === "string" ? entry.type === type : entry.predicate === predicate) && entry.effect === effect;
    });
};
const $3a977e47250b8b44$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($3a977e47250b8b44$var$listenerCancelled);
    });
};
const $3a977e47250b8b44$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener of executingListeners.keys())$3a977e47250b8b44$var$cancelActiveListeners(listener);
        listenerMap.clear();
    };
};
const $3a977e47250b8b44$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
const $3a977e47250b8b44$export$f03a6b845d3fb58b = /* @__PURE__ */ $3a977e47250b8b44$var$assign(/* @__PURE__ */ $3a977e47250b8b44$export$309c7a02b0b0bc62(`${$3a977e47250b8b44$var$alm}/add`), {
    withTypes: ()=>$3a977e47250b8b44$export$f03a6b845d3fb58b
});
const $3a977e47250b8b44$export$b1b8022855fb2b71 = /* @__PURE__ */ $3a977e47250b8b44$export$309c7a02b0b0bc62(`${$3a977e47250b8b44$var$alm}/removeAll`);
const $3a977e47250b8b44$export$b03e9483f936dccb = /* @__PURE__ */ $3a977e47250b8b44$var$assign(/* @__PURE__ */ $3a977e47250b8b44$export$309c7a02b0b0bc62(`${$3a977e47250b8b44$var$alm}/remove`), {
    withTypes: ()=>$3a977e47250b8b44$export$b03e9483f936dccb
});
const $3a977e47250b8b44$var$defaultErrorHandler = (...args)=>{
    console.error(`${$3a977e47250b8b44$var$alm}/error`, ...args);
};
const $3a977e47250b8b44$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        const count = executingListeners.get(entry) ?? 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        const count = executingListeners.get(entry) ?? 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $3a977e47250b8b44$var$defaultErrorHandler } = middlewareOptions;
    $3a977e47250b8b44$var$assertFunction(onError, "onError");
    let snapshot;
    const getSnapshot = ()=>{
        if (!snapshot) {
            const entries = Array.from(listenerMap.values());
            const types = /* @__PURE__ */ new Set();
            let anyType = false;
            for (const entry of entries)if (typeof entry.type === "string") types.add(entry.type);
            else anyType = true;
            snapshot = {
                entries: entries,
                types: types,
                anyType: anyType
            };
        }
        return snapshot;
    };
    const addToListenerMap = (entry)=>{
        if (!listenerMap.has(entry.id)) {
            listenerMap.set(entry.id, entry);
            snapshot = void 0;
        }
    };
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>{
            if (listenerMap.delete(entry.id)) snapshot = void 0;
        };
        addToListenerMap(entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions?.cancelActive) $3a977e47250b8b44$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        const entry = $3a977e47250b8b44$var$findListenerEntry(listenerMap, options) ?? $3a977e47250b8b44$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $3a977e47250b8b44$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $3a977e47250b8b44$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $3a977e47250b8b44$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $3a977e47250b8b44$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $3a977e47250b8b44$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, $3a977e47250b8b44$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $3a977e47250b8b44$var$createDelay(internalTaskController.signal),
                pause: $3a977e47250b8b44$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $3a977e47250b8b44$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    addToListenerMap(entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($3a977e47250b8b44$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($3a977e47250b8b44$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $3a977e47250b8b44$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $3a977e47250b8b44$export$cb1bdac908fed7f)) $3a977e47250b8b44$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($3a977e47250b8b44$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListeners = $3a977e47250b8b44$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const clearListenerMiddleware = ()=>{
        clearListeners();
        snapshot = void 0;
    };
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $dpYkU.isAction)(action)) return next(action);
                if ($3a977e47250b8b44$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($3a977e47250b8b44$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($3a977e47250b8b44$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $3a977e47250b8b44$var$INTERNAL_NIL_TOKEN) throw new Error($3a977e47250b8b44$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    const { entries: entries, types: types, anyType: anyType } = getSnapshot();
                    if (anyType || types.has(action.type)) {
                        const currentState = api.getState();
                        for (const entry of entries){
                            if (typeof entry.type === "string" && entry.type !== action.type) continue;
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $3a977e47250b8b44$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $3a977e47250b8b44$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
//#endregion
//#region src/dynamicMiddleware/index.ts
const $3a977e47250b8b44$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
const $3a977e47250b8b44$var$matchInstance = (instanceId)=>(action)=>action?.meta?.instanceId === instanceId;
const $3a977e47250b8b44$export$4bb1606a79445586 = ()=>{
    const instanceId = $3a977e47250b8b44$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    let middlewareVersion = 0;
    const withMiddleware = Object.assign($3a977e47250b8b44$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware(...middlewares) {
        const previousSize = middlewareMap.size;
        middlewares.forEach((middleware)=>{
            $3a977e47250b8b44$var$getOrInsertComputed(middlewareMap, middleware, $3a977e47250b8b44$var$createMiddlewareEntry);
        });
        if (middlewareMap.size !== previousSize) middlewareVersion++;
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$3a977e47250b8b44$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $dpYkU.compose)(...appliedMiddleware);
    };
    const isWithMiddleware = $3a977e47250b8b44$export$9dd1fb32974da385(withMiddleware, $3a977e47250b8b44$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>{
            let appliedVersion = -1;
            let dispatch = next;
            return (action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                if (appliedVersion !== middlewareVersion) {
                    dispatch = getFinalMiddleware(api)(next);
                    appliedVersion = middlewareVersion;
                }
                return dispatch(action);
            };
        };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
//#endregion
//#region src/combineSlices.ts
const $3a977e47250b8b44$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
const $3a977e47250b8b44$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$3a977e47250b8b44$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
const $3a977e47250b8b44$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
const $3a977e47250b8b44$var$isStateProxy = (value)=>!!value && !!value[$3a977e47250b8b44$var$ORIGINAL_STATE];
const $3a977e47250b8b44$var$createStateProxy = (stateProxyMap, state, reducerMap, initialStateCache)=>$3a977e47250b8b44$var$getOrInsertComputed(stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $3a977e47250b8b44$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $3a977e47250b8b44$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($3a977e47250b8b44$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
const $3a977e47250b8b44$var$original$1 = (state)=>{
    if (!$3a977e47250b8b44$var$isStateProxy(state)) throw new Error($3a977e47250b8b44$export$378fa86b259c0280(25));
    return state[$3a977e47250b8b44$var$ORIGINAL_STATE];
};
const $3a977e47250b8b44$var$emptyObject = {};
const $3a977e47250b8b44$var$noopReducer = (state = $3a977e47250b8b44$var$emptyObject)=>state;
function $3a977e47250b8b44$export$a3734c7614660b9(...slices) {
    const stateProxyMap = /* @__PURE__ */ new WeakMap();
    const reducerMap = Object.fromEntries($3a977e47250b8b44$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $dpYkU.combineReducers)(reducerMap) : $3a977e47250b8b44$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector(state, ...args) {
            return selectorFn($3a977e47250b8b44$var$createStateProxy(stateProxyMap, selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $3a977e47250b8b44$var$original$1
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
//#endregion
//#region src/formatProdErrorMessage.ts
function $3a977e47250b8b44$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

});
parcelRegister("3xSPq", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return $96da4e9402d59482$export$541ac630993a4c84; });
$parcel$export(module.exports, "isDraftable", function () { return $96da4e9402d59482$export$16e3aed3edb85946; });
$parcel$export(module.exports, "original", function () { return $96da4e9402d59482$export$22e8af3f75a010e3; });
$parcel$export(module.exports, "current", function () { return $96da4e9402d59482$export$97aac956da55dae9; });
$parcel$export(module.exports, "enablePatches", function () { return $96da4e9402d59482$export$d3a6659991a0696c; });
$parcel$export(module.exports, "produce", function () { return $96da4e9402d59482$export$b46cabe22e78bc00; });
$parcel$export(module.exports, "produceWithPatches", function () { return $96da4e9402d59482$export$4da66d41c9492c78; });
$parcel$export(module.exports, "applyPatches", function () { return $96da4e9402d59482$export$a8b8e03e6bbe5473; });
$parcel$export(module.exports, "castDraft", function () { return $96da4e9402d59482$export$c05b21e3257751e5; });
// src/utils/env.ts
var $96da4e9402d59482$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $96da4e9402d59482$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $96da4e9402d59482$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $96da4e9402d59482$var$errors = [];
function $96da4e9402d59482$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $96da4e9402d59482$var$O = Object;
var $96da4e9402d59482$var$getPrototypeOf = $96da4e9402d59482$var$O.getPrototypeOf;
var $96da4e9402d59482$var$CONSTRUCTOR = "constructor";
var $96da4e9402d59482$var$PROTOTYPE = "prototype";
var $96da4e9402d59482$var$CONFIGURABLE = "configurable";
var $96da4e9402d59482$var$ENUMERABLE = "enumerable";
var $96da4e9402d59482$var$WRITABLE = "writable";
var $96da4e9402d59482$var$VALUE = "value";
var $96da4e9402d59482$export$541ac630993a4c84 = (value)=>!!value && !!value[$96da4e9402d59482$var$DRAFT_STATE];
function $96da4e9402d59482$export$f9ded33a1a6c97c7(value) {
    if (!$96da4e9402d59482$export$541ac630993a4c84(value)) return false;
    return value[$96da4e9402d59482$var$DRAFT_STATE].modified_;
}
function $96da4e9402d59482$export$16e3aed3edb85946(value) {
    if (!value) return false;
    return $96da4e9402d59482$var$isPlainObject(value) || $96da4e9402d59482$var$isArray(value) || !!value[$96da4e9402d59482$export$6ee2082928bcb0ee] || !!value[$96da4e9402d59482$var$CONSTRUCTOR]?.[$96da4e9402d59482$export$6ee2082928bcb0ee] || $96da4e9402d59482$var$isMap(value) || $96da4e9402d59482$var$isSet(value);
}
var $96da4e9402d59482$var$objectCtorString = $96da4e9402d59482$var$O[$96da4e9402d59482$var$PROTOTYPE][$96da4e9402d59482$var$CONSTRUCTOR].toString();
var $96da4e9402d59482$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $96da4e9402d59482$var$isPlainObject(value) {
    if (!value || !$96da4e9402d59482$var$isObjectish(value)) return false;
    const proto = $96da4e9402d59482$var$getPrototypeOf(value);
    if (proto === null || proto === $96da4e9402d59482$var$O[$96da4e9402d59482$var$PROTOTYPE]) return true;
    const Ctor = $96da4e9402d59482$var$O.hasOwnProperty.call(proto, $96da4e9402d59482$var$CONSTRUCTOR) && proto[$96da4e9402d59482$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$96da4e9402d59482$var$isFunction(Ctor)) return false;
    let ctorString = $96da4e9402d59482$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $96da4e9402d59482$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $96da4e9402d59482$var$objectCtorString;
}
function $96da4e9402d59482$export$22e8af3f75a010e3(value) {
    if (!$96da4e9402d59482$export$541ac630993a4c84(value)) $96da4e9402d59482$var$die(15, value);
    return value[$96da4e9402d59482$var$DRAFT_STATE].base_;
}
function $96da4e9402d59482$var$each(obj, iter, strict = true) {
    if ($96da4e9402d59482$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $96da4e9402d59482$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $96da4e9402d59482$var$getArchtype(thing) {
    const state = thing[$96da4e9402d59482$var$DRAFT_STATE];
    return state ? state.type_ : $96da4e9402d59482$var$isArray(thing) ? 1 /* Array */  : $96da4e9402d59482$var$isMap(thing) ? 2 /* Map */  : $96da4e9402d59482$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $96da4e9402d59482$var$has = (thing, prop, type = $96da4e9402d59482$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $96da4e9402d59482$var$O[$96da4e9402d59482$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $96da4e9402d59482$var$get = (thing, prop, type = $96da4e9402d59482$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $96da4e9402d59482$var$set = (thing, propOrOldValue, value, type = $96da4e9402d59482$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $96da4e9402d59482$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $96da4e9402d59482$var$isArray = Array.isArray;
var $96da4e9402d59482$var$isMap = (target)=>target instanceof Map;
var $96da4e9402d59482$var$isSet = (target)=>target instanceof Set;
var $96da4e9402d59482$var$isObjectish = (target)=>typeof target === "object";
var $96da4e9402d59482$var$isFunction = (target)=>typeof target === "function";
var $96da4e9402d59482$var$isBoolean = (target)=>typeof target === "boolean";
function $96da4e9402d59482$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $96da4e9402d59482$var$getProxyDraft = (value)=>{
    if (!$96da4e9402d59482$var$isObjectish(value)) return null;
    return value?.[$96da4e9402d59482$var$DRAFT_STATE];
};
var $96da4e9402d59482$var$latest = (state)=>state.copy_ || state.base_;
var $96da4e9402d59482$var$getValue = (value)=>{
    const proxyDraft = $96da4e9402d59482$var$getProxyDraft(value);
    return proxyDraft ? $96da4e9402d59482$var$getFinalValue(proxyDraft) : value;
};
var $96da4e9402d59482$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $96da4e9402d59482$var$shallowCopy(base, strict) {
    if ($96da4e9402d59482$var$isMap(base)) return new Map(base);
    if ($96da4e9402d59482$var$isSet(base)) return new Set(base);
    if ($96da4e9402d59482$var$isArray(base)) return Array[$96da4e9402d59482$var$PROTOTYPE].slice.call(base);
    const isPlain = $96da4e9402d59482$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $96da4e9402d59482$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$96da4e9402d59482$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$96da4e9402d59482$var$WRITABLE] === false) {
                desc[$96da4e9402d59482$var$WRITABLE] = true;
                desc[$96da4e9402d59482$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$96da4e9402d59482$var$CONFIGURABLE]: true,
                [$96da4e9402d59482$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$96da4e9402d59482$var$ENUMERABLE]: desc[$96da4e9402d59482$var$ENUMERABLE],
                [$96da4e9402d59482$var$VALUE]: base[key]
            };
        }
        return $96da4e9402d59482$var$O.create($96da4e9402d59482$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $96da4e9402d59482$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return {
            ...base
        };
        const obj = $96da4e9402d59482$var$O.create(proto);
        return $96da4e9402d59482$var$O.assign(obj, base);
    }
}
function $96da4e9402d59482$export$792f3d81ea979f55(obj, deep = false) {
    if ($96da4e9402d59482$var$isFrozen(obj) || $96da4e9402d59482$export$541ac630993a4c84(obj) || !$96da4e9402d59482$export$16e3aed3edb85946(obj)) return obj;
    if ($96da4e9402d59482$var$getArchtype(obj) > 1) $96da4e9402d59482$var$O.defineProperties(obj, {
        set: $96da4e9402d59482$var$dontMutateMethodOverride,
        add: $96da4e9402d59482$var$dontMutateMethodOverride,
        clear: $96da4e9402d59482$var$dontMutateMethodOverride,
        delete: $96da4e9402d59482$var$dontMutateMethodOverride
    });
    $96da4e9402d59482$var$O.freeze(obj);
    if (deep) $96da4e9402d59482$var$each(obj, (_key, value)=>{
        $96da4e9402d59482$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $96da4e9402d59482$var$dontMutateFrozenCollections() {
    $96da4e9402d59482$var$die(2);
}
var $96da4e9402d59482$var$dontMutateMethodOverride = {
    [$96da4e9402d59482$var$VALUE]: $96da4e9402d59482$var$dontMutateFrozenCollections
};
function $96da4e9402d59482$var$isFrozen(obj) {
    if (obj === null || !$96da4e9402d59482$var$isObjectish(obj)) return true;
    return $96da4e9402d59482$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $96da4e9402d59482$var$PluginMapSet = "MapSet";
var $96da4e9402d59482$var$PluginPatches = "Patches";
var $96da4e9402d59482$var$PluginArrayMethods = "ArrayMethods";
var $96da4e9402d59482$var$plugins = {};
function $96da4e9402d59482$var$getPlugin(pluginKey) {
    const plugin = $96da4e9402d59482$var$plugins[pluginKey];
    if (!plugin) $96da4e9402d59482$var$die(0, pluginKey);
    return plugin;
}
var $96da4e9402d59482$var$isPluginLoaded = (pluginKey)=>!!$96da4e9402d59482$var$plugins[pluginKey];
function $96da4e9402d59482$var$loadPlugin(pluginKey, implementation) {
    if (!$96da4e9402d59482$var$plugins[pluginKey]) $96da4e9402d59482$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $96da4e9402d59482$var$currentScope;
var $96da4e9402d59482$var$getCurrentScope = ()=>$96da4e9402d59482$var$currentScope;
var $96da4e9402d59482$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $96da4e9402d59482$var$isPluginLoaded($96da4e9402d59482$var$PluginMapSet) ? $96da4e9402d59482$var$getPlugin($96da4e9402d59482$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $96da4e9402d59482$var$isPluginLoaded($96da4e9402d59482$var$PluginArrayMethods) ? $96da4e9402d59482$var$getPlugin($96da4e9402d59482$var$PluginArrayMethods) : void 0
    });
function $96da4e9402d59482$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $96da4e9402d59482$var$getPlugin($96da4e9402d59482$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $96da4e9402d59482$var$revokeScope(scope) {
    $96da4e9402d59482$var$leaveScope(scope);
    scope.drafts_.forEach($96da4e9402d59482$var$revokeDraft);
    scope.drafts_ = null;
}
function $96da4e9402d59482$var$leaveScope(scope) {
    if (scope === $96da4e9402d59482$var$currentScope) $96da4e9402d59482$var$currentScope = scope.parent_;
}
var $96da4e9402d59482$var$enterScope = (immer2)=>$96da4e9402d59482$var$currentScope = $96da4e9402d59482$var$createScope($96da4e9402d59482$var$currentScope, immer2);
function $96da4e9402d59482$var$revokeDraft(draft) {
    const state = draft[$96da4e9402d59482$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $96da4e9402d59482$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$96da4e9402d59482$var$DRAFT_STATE].modified_) {
            $96da4e9402d59482$var$revokeScope(scope);
            $96da4e9402d59482$var$die(4);
        }
        if ($96da4e9402d59482$export$16e3aed3edb85946(result)) result = $96da4e9402d59482$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$96da4e9402d59482$var$DRAFT_STATE].base_, result, scope);
    } else result = $96da4e9402d59482$var$finalize(scope, baseDraft);
    $96da4e9402d59482$var$maybeFreeze(scope, result, true);
    $96da4e9402d59482$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $96da4e9402d59482$export$45b790e32b2810ee ? result : void 0;
}
function $96da4e9402d59482$var$finalize(rootScope, value) {
    if ($96da4e9402d59482$var$isFrozen(value)) return value;
    const state = value[$96da4e9402d59482$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $96da4e9402d59482$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$96da4e9402d59482$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $96da4e9402d59482$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $96da4e9402d59482$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $96da4e9402d59482$export$792f3d81ea979f55(value, deep);
}
function $96da4e9402d59482$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $96da4e9402d59482$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $96da4e9402d59482$var$EMPTY_LOCATIONS_RESULT = [];
function $96da4e9402d59482$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    const parentCopy = $96da4e9402d59482$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $96da4e9402d59482$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $96da4e9402d59482$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $96da4e9402d59482$var$each(parentCopy, (key, value)=>{
            if ($96da4e9402d59482$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = parent.draftLocations_.get(draftValue) ?? $96da4e9402d59482$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$96da4e9402d59482$var$set(parentCopy, location, finalizedValue, parentType);
}
function $96da4e9402d59482$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        const state = child;
        if (!state || !$96da4e9402d59482$var$isSameScope(state, rootScope)) return;
        rootScope.mapSetPlugin_?.fixSetContents(state);
        const finalizedValue = $96da4e9402d59482$var$getFinalValue(state);
        $96da4e9402d59482$var$updateDraftInParent(parent, state.draft_ ?? state, finalizedValue, key);
        $96da4e9402d59482$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $96da4e9402d59482$var$generatePatchesAndFinalize(state, rootScope) {
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || (state.assigned_?.size ?? 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $96da4e9402d59482$var$markStateFinalized(state);
    }
}
function $96da4e9402d59482$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($96da4e9402d59482$export$541ac630993a4c84(value)) {
        const state = value[$96da4e9402d59482$var$DRAFT_STATE];
        if ($96da4e9402d59482$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $96da4e9402d59482$var$prepareCopy(target);
            const finalizedValue = $96da4e9402d59482$var$getFinalValue(state);
            $96da4e9402d59482$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($96da4e9402d59482$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        const targetCopy = $96da4e9402d59482$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $96da4e9402d59482$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($96da4e9402d59482$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && (target.assigned_.get(key) ?? false) === true && target.copy_) $96da4e9402d59482$var$handleValue($96da4e9402d59482$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $96da4e9402d59482$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($96da4e9402d59482$export$541ac630993a4c84(target) || handledSet.has(target) || !$96da4e9402d59482$export$16e3aed3edb85946(target) || $96da4e9402d59482$var$isFrozen(target)) return target;
    handledSet.add(target);
    $96da4e9402d59482$var$each(target, (key, value)=>{
        if ($96da4e9402d59482$export$541ac630993a4c84(value)) {
            const state = value[$96da4e9402d59482$var$DRAFT_STATE];
            if ($96da4e9402d59482$var$isSameScope(state, rootScope)) {
                const updatedValue = $96da4e9402d59482$var$getFinalValue(state);
                $96da4e9402d59482$var$set(target, key, updatedValue, target.type_);
                $96da4e9402d59482$var$markStateFinalized(state);
            }
        } else if ($96da4e9402d59482$export$16e3aed3edb85946(value)) $96da4e9402d59482$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $96da4e9402d59482$var$createProxyProxy(base, parent) {
    const baseIsArray = $96da4e9402d59482$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $96da4e9402d59482$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $96da4e9402d59482$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $96da4e9402d59482$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $96da4e9402d59482$var$objectTraps = {
    get (state, prop) {
        if (prop === $96da4e9402d59482$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin?.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $96da4e9402d59482$var$latest(state);
        if (!$96da4e9402d59482$var$has(source, prop, state.type_)) return $96da4e9402d59482$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$96da4e9402d59482$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && arrayPlugin?.isMutatingArrayMethod(state.operationMethod) && $96da4e9402d59482$var$isArrayIndex(prop)) return value;
        if (value === $96da4e9402d59482$var$peek(state.base_, prop) || $96da4e9402d59482$var$isRelocatedBaseRef(state, prop, value)) {
            $96da4e9402d59482$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $96da4e9402d59482$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $96da4e9402d59482$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($96da4e9402d59482$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $96da4e9402d59482$var$getDescriptorFromProto($96da4e9402d59482$var$latest(state), prop);
        if (desc?.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $96da4e9402d59482$var$peek($96da4e9402d59482$var$latest(state), prop);
            const currentState = current2?.[$96da4e9402d59482$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.delete(prop);
                return true;
            }
            if ($96da4e9402d59482$var$is(value, current2) && (value !== void 0 || $96da4e9402d59482$var$has(state.base_, prop, state.type_))) return true;
            $96da4e9402d59482$var$prepareCopy(state);
            $96da4e9402d59482$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || $96da4e9402d59482$var$has(state.copy_, prop, state.type_)) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $96da4e9402d59482$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $96da4e9402d59482$var$prepareCopy(state);
        if ($96da4e9402d59482$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $96da4e9402d59482$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $96da4e9402d59482$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$96da4e9402d59482$var$WRITABLE]: true,
            [$96da4e9402d59482$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$96da4e9402d59482$var$ENUMERABLE]: desc[$96da4e9402d59482$var$ENUMERABLE],
            [$96da4e9402d59482$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $96da4e9402d59482$var$die(11);
    },
    getPrototypeOf (state) {
        return $96da4e9402d59482$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $96da4e9402d59482$var$die(12);
    }
};
var $96da4e9402d59482$var$arrayTraps = {};
for(let key in $96da4e9402d59482$var$objectTraps){
    let fn = $96da4e9402d59482$var$objectTraps[key];
    $96da4e9402d59482$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$96da4e9402d59482$var$arrayTraps.deleteProperty = function(state, prop) {
    return $96da4e9402d59482$var$arrayTraps.set.call(this, state, prop, void 0);
};
$96da4e9402d59482$var$arrayTraps.set = function(state, prop, value) {
    return $96da4e9402d59482$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $96da4e9402d59482$var$peek(draft, prop) {
    const state = draft[$96da4e9402d59482$var$DRAFT_STATE];
    const source = state ? $96da4e9402d59482$var$latest(state) : draft;
    return source[prop];
}
function $96da4e9402d59482$var$isRelocatedBaseRef(state, prop, value) {
    if (state.type_ !== 1 /* Array */  || !state.allIndicesReassigned_ || !$96da4e9402d59482$export$16e3aed3edb85946(value) || value[$96da4e9402d59482$var$DRAFT_STATE]) return false;
    return state.baseRefs_.has(value);
}
function $96da4e9402d59482$var$readPropFromProto(state, source, prop) {
    const desc = $96da4e9402d59482$var$getDescriptorFromProto(source, prop);
    return desc ? $96da4e9402d59482$var$VALUE in desc ? desc[$96da4e9402d59482$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_) : void 0;
}
function $96da4e9402d59482$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $96da4e9402d59482$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $96da4e9402d59482$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $96da4e9402d59482$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $96da4e9402d59482$var$markChanged(state.parent_);
    }
}
function $96da4e9402d59482$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $96da4e9402d59482$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $96da4e9402d59482$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($96da4e9402d59482$var$isFunction(base) && !$96da4e9402d59482$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$96da4e9402d59482$var$isFunction(recipe)) $96da4e9402d59482$var$die(6);
            if (patchListener !== void 0 && !$96da4e9402d59482$var$isFunction(patchListener)) $96da4e9402d59482$var$die(7);
            let result;
            if ($96da4e9402d59482$export$16e3aed3edb85946(base)) {
                const scope = $96da4e9402d59482$var$enterScope(this);
                const proxy = $96da4e9402d59482$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $96da4e9402d59482$var$revokeScope(scope);
                    else $96da4e9402d59482$var$leaveScope(scope);
                }
                $96da4e9402d59482$var$usePatchesInScope(scope, patchListener);
                return $96da4e9402d59482$var$processResult(result, scope);
            } else if (!base || !$96da4e9402d59482$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $96da4e9402d59482$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $96da4e9402d59482$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $96da4e9402d59482$var$getPlugin($96da4e9402d59482$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $96da4e9402d59482$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($96da4e9402d59482$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($96da4e9402d59482$var$isBoolean(config?.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($96da4e9402d59482$var$isBoolean(config?.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($96da4e9402d59482$var$isBoolean(config?.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$96da4e9402d59482$export$16e3aed3edb85946(base)) $96da4e9402d59482$var$die(8);
        if ($96da4e9402d59482$export$541ac630993a4c84(base)) base = $96da4e9402d59482$export$97aac956da55dae9(base);
        const scope = $96da4e9402d59482$var$enterScope(this);
        const proxy = $96da4e9402d59482$var$createProxy(scope, base, void 0);
        proxy[$96da4e9402d59482$var$DRAFT_STATE].isManual_ = true;
        $96da4e9402d59482$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$96da4e9402d59482$var$DRAFT_STATE];
        if (!state || !state.isManual_) $96da4e9402d59482$var$die(9);
        const { scope_: scope } = state;
        $96da4e9402d59482$var$usePatchesInScope(scope, patchListener);
        return $96da4e9402d59482$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $96da4e9402d59482$var$getPlugin($96da4e9402d59482$var$PluginPatches).applyPatches_;
        if ($96da4e9402d59482$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $96da4e9402d59482$var$createProxy(rootScope, value, parent, key) {
    const [draft, state] = $96da4e9402d59482$var$isMap(value) ? $96da4e9402d59482$var$getPlugin($96da4e9402d59482$var$PluginMapSet).proxyMap_(value, parent) : $96da4e9402d59482$var$isSet(value) ? $96da4e9402d59482$var$getPlugin($96da4e9402d59482$var$PluginMapSet).proxySet_(value, parent) : $96da4e9402d59482$var$createProxyProxy(value, parent);
    const scope = parent?.scope_ ?? $96da4e9402d59482$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = parent?.callbacks_ ?? [];
    state.key_ = key;
    if (parent && key !== void 0) $96da4e9402d59482$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        rootScope2.mapSetPlugin_?.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $96da4e9402d59482$export$97aac956da55dae9(value) {
    if (!$96da4e9402d59482$export$541ac630993a4c84(value)) $96da4e9402d59482$var$die(10, value);
    return $96da4e9402d59482$var$currentImpl(value);
}
function $96da4e9402d59482$var$currentImpl(value) {
    if (!$96da4e9402d59482$export$16e3aed3edb85946(value) || $96da4e9402d59482$var$isFrozen(value)) return value;
    const state = value[$96da4e9402d59482$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $96da4e9402d59482$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $96da4e9402d59482$var$shallowCopy(value, true);
    const source = copy;
    if ($96da4e9402d59482$var$isSet(copy)) copy = /* @__PURE__ */ new Set();
    $96da4e9402d59482$var$each(source, (key, childValue)=>{
        $96da4e9402d59482$var$set(copy, key, $96da4e9402d59482$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $96da4e9402d59482$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        if (state.key_ !== void 0) {
            const parentCopy = state.parent_.copy_ ?? state.parent_.base_;
            const proxyDraft = $96da4e9402d59482$var$getProxyDraft($96da4e9402d59482$var$get(parentCopy, state.key_));
            const valueAtKey = $96da4e9402d59482$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $96da4e9402d59482$var$has(parentCopy, key))) return null;
            if (state.parent_.type_ === 1 /* Array */  && state.parent_.allIndicesReassigned_) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $96da4e9402d59482$var$get(current2, key);
            if (!$96da4e9402d59482$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || assigned_?.get(i.toString());
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem?.[$96da4e9402d59482$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $96da4e9402d59482$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $96da4e9402d59482$var$get(base_, key, type_);
            const value = $96da4e9402d59482$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $96da4e9402d59482$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $96da4e9402d59482$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $96da4e9402d59482$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $96da4e9402d59482$var$CONSTRUCTOR)) $96da4e9402d59482$var$die(errorOffset + 3);
                if ($96da4e9402d59482$var$isFunction(base) && p === $96da4e9402d59482$var$PROTOTYPE) $96da4e9402d59482$var$die(errorOffset + 3);
                base = $96da4e9402d59482$var$get(base, p);
                if (base === null || !$96da4e9402d59482$var$isObjectish(base)) $96da4e9402d59482$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $96da4e9402d59482$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $96da4e9402d59482$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $96da4e9402d59482$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$96da4e9402d59482$export$16e3aed3edb85946(obj)) return obj;
        if ($96da4e9402d59482$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($96da4e9402d59482$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($96da4e9402d59482$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($96da4e9402d59482$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($96da4e9402d59482$var$has(obj, $96da4e9402d59482$export$6ee2082928bcb0ee)) cloned[$96da4e9402d59482$export$6ee2082928bcb0ee] = obj[$96da4e9402d59482$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($96da4e9402d59482$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $96da4e9402d59482$var$loadPlugin($96da4e9402d59482$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
var $96da4e9402d59482$var$_globalIterator = globalThis.Iterator;
var $96da4e9402d59482$var$hasIteratorFrom = typeof $96da4e9402d59482$var$_globalIterator?.from === "function";
function $96da4e9402d59482$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$96da4e9402d59482$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $96da4e9402d59482$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            const state = this[$96da4e9402d59482$var$DRAFT_STATE];
            assertUnrevoked(state);
            return $96da4e9402d59482$var$latest(state).size;
        }
        has(key) {
            const state = this[$96da4e9402d59482$var$DRAFT_STATE];
            assertUnrevoked(state);
            return $96da4e9402d59482$var$latest(state).has(key);
        }
        set(key, value) {
            const state = this[$96da4e9402d59482$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$96da4e9402d59482$var$latest(state).has(key) || $96da4e9402d59482$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $96da4e9402d59482$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $96da4e9402d59482$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$96da4e9402d59482$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $96da4e9402d59482$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$96da4e9402d59482$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($96da4e9402d59482$var$latest(state).size) {
                prepareMapCopy(state);
                $96da4e9402d59482$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $96da4e9402d59482$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$96da4e9402d59482$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $96da4e9402d59482$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$96da4e9402d59482$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $96da4e9402d59482$var$latest(state).get(key);
            if (state.finalized_ || !$96da4e9402d59482$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $96da4e9402d59482$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            const state = this[$96da4e9402d59482$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            return $96da4e9402d59482$var$latest(state).keys();
        }
        values() {
            const iterator = this.keys();
            return iteratorFrom({
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            });
        }
        entries() {
            const iterator = this.keys();
            return iteratorFrom({
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            });
        }
        [($96da4e9402d59482$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function iteratorFrom(iterable) {
        if ($96da4e9402d59482$var$hasIteratorFrom) return $96da4e9402d59482$var$_globalIterator.from(iterable);
        const iterator = {
            ...iterable,
            [Symbol.iterator]: ()=>iterator
        };
        return iterator;
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$96da4e9402d59482$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$96da4e9402d59482$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $96da4e9402d59482$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            const state = this[$96da4e9402d59482$var$DRAFT_STATE];
            assertUnrevoked(state);
            return $96da4e9402d59482$var$latest(state).size;
        }
        has(value) {
            const state = this[$96da4e9402d59482$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$96da4e9402d59482$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $96da4e9402d59482$var$markChanged(state);
                state.copy_.add(value);
                $96da4e9402d59482$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$96da4e9402d59482$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $96da4e9402d59482$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$96da4e9402d59482$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($96da4e9402d59482$var$latest(state).size) {
                prepareSetCopy(state);
                $96da4e9402d59482$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$96da4e9402d59482$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$96da4e9402d59482$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($96da4e9402d59482$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$96da4e9402d59482$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($96da4e9402d59482$export$16e3aed3edb85946(value)) {
                    const draft = $96da4e9402d59482$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $96da4e9402d59482$var$die(3, JSON.stringify($96da4e9402d59482$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($96da4e9402d59482$var$getValue(value));
            });
        }
    }
    $96da4e9402d59482$var$loadPlugin($96da4e9402d59482$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $96da4e9402d59482$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $96da4e9402d59482$var$prepareCopy(state);
        const result = operation();
        markArrayChanged(state, markLength);
        return result;
    }
    function markArrayChanged(state, markLength = true) {
        $96da4e9402d59482$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
        state.baseRefs_ = new Set(state.base_);
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = "" + (startIndex + i);
            state.assigned_.set(index, true);
            $96da4e9402d59482$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        const isInsert = method === "push" || method === "unshift";
        if (isInsert ? args.length === 0 : $96da4e9402d59482$var$latest(state).length === 0) return isInsert ? $96da4e9402d59482$var$latest(state).length : void 0;
        $96da4e9402d59482$var$prepareCopy(state);
        const lengthBefore = state.copy_.length;
        const result = state.copy_[method](...args);
        markArrayChanged(state);
        if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
        if (method === "push") handleInsertedValues(state, lengthBefore, args);
        else if (method === "unshift") handleInsertedValues(state, 0, args);
        return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
    }
    function handleReorderingOperation(state, method, args) {
        if ($96da4e9402d59482$var$latest(state).length <= 1) return state.draft_;
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const insertCount = args.length > 2 ? args.length - 2 : 0;
                        if (insertCount === 0) {
                            const length = $96da4e9402d59482$var$latest(state).length;
                            if (args.length === 0 || normalizeSliceIndex(args[0] ?? 0, length) === length || args.length > 1 && !(args[1] >= 1)) return [];
                        }
                        $96da4e9402d59482$var$prepareCopy(state);
                        const lengthBefore = state.copy_.length;
                        const res = state.copy_.splice(...args);
                        if (res.length === 0 && insertCount === 0) return res;
                        markArrayChanged(state);
                        markAllIndicesReassigned(state);
                        if (insertCount > 0) {
                            const startIndex = normalizeSliceIndex(args[0] ?? 0, lengthBefore);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        const source = $96da4e9402d59482$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const thisArg = args[1];
            const result = [];
            const length = source.length;
            for(let i = 0; i < length; i++)if (predicate.call(thisArg, source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const thisArg = args[1];
            const length = source.length;
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : length - 1;
            for(let i = start; i >= 0 && i < length; i += step){
                if (predicate.call(thisArg, source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = args[0] ?? 0;
            const rawEnd = args[1] ?? source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $96da4e9402d59482$var$loadPlugin($96da4e9402d59482$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $96da4e9402d59482$var$immer = new $96da4e9402d59482$export$aaadc6ff0f822719();
var $96da4e9402d59482$export$b46cabe22e78bc00 = $96da4e9402d59482$var$immer.produce;
var $96da4e9402d59482$export$4da66d41c9492c78 = /* @__PURE__ */ $96da4e9402d59482$var$immer.produceWithPatches.bind($96da4e9402d59482$var$immer);
var $96da4e9402d59482$export$573f26f60825c493 = /* @__PURE__ */ $96da4e9402d59482$var$immer.setAutoFreeze.bind($96da4e9402d59482$var$immer);
var $96da4e9402d59482$export$333ce65961cbe047 = /* @__PURE__ */ $96da4e9402d59482$var$immer.setUseStrictShallowCopy.bind($96da4e9402d59482$var$immer);
var $96da4e9402d59482$export$1045b3be3904c489 = /* @__PURE__ */ $96da4e9402d59482$var$immer.setUseStrictIteration.bind($96da4e9402d59482$var$immer);
var $96da4e9402d59482$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $96da4e9402d59482$var$immer.applyPatches.bind($96da4e9402d59482$var$immer);
var $96da4e9402d59482$export$3c3214997190395f = /* @__PURE__ */ $96da4e9402d59482$var$immer.createDraft.bind($96da4e9402d59482$var$immer);
var $96da4e9402d59482$export$c60f5e69c521b528 = /* @__PURE__ */ $96da4e9402d59482$var$immer.finishDraft.bind($96da4e9402d59482$var$immer);
var $96da4e9402d59482$export$c05b21e3257751e5 = (value)=>value;
var $96da4e9402d59482$export$20f911b3f8cf0b74 = (value)=>value;

});

parcelRegister("6xl8b", function(module, exports) {

$parcel$export(module.exports, "weakMapMemoize", function () { return $3722dc03c208bae4$export$8402dc26d96f6902; });
$parcel$export(module.exports, "createSelectorCreator", function () { return $3722dc03c208bae4$export$5943f4447f6ef248; });
$parcel$export(module.exports, "createSelector", function () { return $3722dc03c208bae4$export$595d22ed68ca2841; });
// src/devModeChecks/cacheSizeCheck.ts
var $3722dc03c208bae4$var$CACHE_SIZE_CHECK_THRESHOLD = 1e3;
var $3722dc03c208bae4$var$runCacheSizeCheck = (cacheSize, funcName)=>{
    let stack = void 0;
    try {
        throw new Error();
    } catch (e) {
        ({ stack: stack } = e);
    }
    console.warn(`A function memoized with weakMapMemoize${funcName ? ` (\`${funcName}\`)` : ""} has seen over ${cacheSize} distinct values for the same primitive argument position.
Results keyed by primitive arguments are held strongly and are only released by \`clearCache()\`, so this cache will keep growing for as long as the function keeps seeing new values.
If it is called with ever-changing primitives (ids, offsets, timestamps), pass the \`maxSize\` option to bound the cache, switch to \`lruMemoize\`, or call \`.clearCache()\` at a suitable point.
See https://reselect.js.org/api/development-only-checks#cachesizecheck for details.`, {
        stack: stack
    });
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $3722dc03c208bae4$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once",
    cacheSizeCheck: "once"
};
var $3722dc03c208bae4$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($3722dc03c208bae4$var$globalDevModeChecks, devModeChecks);
};
// src/weakMapMemoize.ts
var $3722dc03c208bae4$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $3722dc03c208bae4$var$getWeakRef = ()=>typeof WeakRef === "undefined" ? $3722dc03c208bae4$var$StrongRef : WeakRef;
var $3722dc03c208bae4$var$Ref = /* @__PURE__ */ $3722dc03c208bae4$var$getWeakRef();
var $3722dc03c208bae4$var$UNTERMINATED = 0;
var $3722dc03c208bae4$var$TERMINATED = 1;
function $3722dc03c208bae4$var$createCacheNode() {
    return {
        s: $3722dc03c208bae4$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $3722dc03c208bae4$var$maybeDeref(r) {
    if (r instanceof $3722dc03c208bae4$var$Ref) return r.deref();
    return r;
}
function $3722dc03c208bae4$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $3722dc03c208bae4$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck, maxSize: maxSize } = options;
    const useGenerations = maxSize !== void 0;
    if (useGenerations && (!Number.isInteger(maxSize) || maxSize < 1)) throw new TypeError(`maxSize must be a positive integer, received: ${maxSize}`);
    let prevNode = null;
    let insertionCount = 0;
    let lastResult;
    let resultsCount = 0;
    let hasWarnedAboutCacheSize = false;
    function maybeFlipGenerations() {
        if (insertionCount >= maxSize) {
            prevNode = fnNode;
            fnNode = $3722dc03c208bae4$var$createCacheNode();
            insertionCount = 0;
        }
    }
    function memoized() {
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $3722dc03c208bae4$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $3722dc03c208bae4$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                    insertionCount++;
                } else cacheNode = primitiveNode;
            }
        }
        if (cacheNode.s === $3722dc03c208bae4$var$TERMINATED) return cacheNode.v;
        if (prevNode !== null) {
            let prevCacheNode = prevNode;
            for(let i = 0, l = length; i < l; i++){
                const arg = arguments[i];
                let next;
                if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                    const prevObjectCache = prevCacheNode.o;
                    next = prevObjectCache !== null ? prevObjectCache.get(arg) : void 0;
                } else {
                    const prevPrimitiveCache = prevCacheNode.p;
                    next = prevPrimitiveCache !== null ? prevPrimitiveCache.get(arg) : void 0;
                }
                if (next === void 0) {
                    prevCacheNode = null;
                    break;
                }
                prevCacheNode = next;
            }
            if (prevCacheNode !== null && prevCacheNode.s === $3722dc03c208bae4$var$TERMINATED) {
                const promotedNode = cacheNode;
                promotedNode.s = $3722dc03c208bae4$var$TERMINATED;
                promotedNode.v = prevCacheNode.v;
                maybeFlipGenerations();
                return prevCacheNode.v;
            }
        }
        const terminatedNode = cacheNode;
        let result = func.apply(null, arguments);
        resultsCount++;
        if (resultEqualityCheck) {
            const lastResultValue = $3722dc03c208bae4$var$maybeDeref(lastResult);
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? /* @__PURE__ */ new $3722dc03c208bae4$var$Ref(result) : result;
        }
        terminatedNode.s = $3722dc03c208bae4$var$TERMINATED;
        terminatedNode.v = result;
        if (useGenerations) maybeFlipGenerations();
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $3722dc03c208bae4$var$createCacheNode();
        prevNode = null;
        insertionCount = 0;
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/devModeChecks/identityFunctionCheck.ts
var $3722dc03c208bae4$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch  {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $3722dc03c208bae4$var$withoutResultEqualityCheck = (option)=>{
    if (option === null || typeof option !== "object" || !("resultEqualityCheck" in option)) return option;
    const optionCopy = {
        ...option
    };
    delete optionCopy.resultEqualityCheck;
    return optionCopy;
};
var $3722dc03c208bae4$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const probeMemoizeOptions = [];
    const { length: length } = memoizeOptions;
    for(let i = 0; i < length; i++)probeMemoizeOptions.push($3722dc03c208bae4$var$withoutResultEqualityCheck(memoizeOptions[i]));
    const createAnEmptyObject = memoize(()=>({}), ...probeMemoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/utils.ts
var $3722dc03c208bae4$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $3722dc03c208bae4$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $3722dc03c208bae4$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $3722dc03c208bae4$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $3722dc03c208bae4$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $3722dc03c208bae4$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $3722dc03c208bae4$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $3722dc03c208bae4$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
// src/createSelectorCreator.ts
function $3722dc03c208bae4$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $3722dc03c208bae4$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = {
            ...createSelectorCreatorOptions,
            ...directlyPassedOptions
        };
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $3722dc03c208bae4$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [] } = combinedOptions;
        const finalMemoizeOptions = $3722dc03c208bae4$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $3722dc03c208bae4$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $3722dc03c208bae4$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const { length: length } = dependencies;
            const inputSelectorResults = new Array(length);
            for(let i = 0; i < length; i++)inputSelectorResults[i] = dependencies[i].apply(null, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $3722dc03c208bae4$export$595d22ed68ca2841 = /* @__PURE__ */ $3722dc03c208bae4$export$5943f4447f6ef248($3722dc03c208bae4$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $3722dc03c208bae4$export$75979cfcd91bf38f = /* @__PURE__ */ Object.assign((inputSelectorsObject, selectorCreator = $3722dc03c208bae4$export$595d22ed68ca2841)=>{
    $3722dc03c208bae4$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$3722dc03c208bae4$export$75979cfcd91bf38f
});
// src/lruMemoize.ts
function $3722dc03c208bae4$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $3722dc03c208bae4$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        findMatchingEntry (value, resultEqualityCheck) {
            const current = entry;
            return current !== void 0 && resultEqualityCheck(current.value, value) ? current : void 0;
        },
        clear () {
            entry = void 0;
        }
    };
}
function $3722dc03c208bae4$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(entry.key, key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $3722dc03c208bae4$var$NOT_FOUND;
    }
    function put(key, value) {
        entries.unshift({
            key: key,
            value: value
        });
        if (entries.length > maxSize) entries.pop();
    }
    function findMatchingEntry(value, resultEqualityCheck) {
        const currentEntries = entries;
        const { length: length } = currentEntries;
        for(let i = 0; i < length; i++){
            const entry = currentEntries[i];
            if (resultEqualityCheck(entry.value, value)) return entry;
        }
        return void 0;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        findMatchingEntry: findMatchingEntry,
        clear: clear
    };
}
var $3722dc03c208bae4$export$3f025202a230c6dd = (a, b)=>a === b;
function $3722dc03c208bae4$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $3722dc03c208bae4$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $3722dc03c208bae4$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $3722dc03c208bae4$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $3722dc03c208bae4$var$createSingletonCache(comparator) : $3722dc03c208bae4$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $3722dc03c208bae4$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const matchingEntry = cache.findMatchingEntry(value, resultEqualityCheck);
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}

});

parcelRegister("6sXbR", function(module, exports) {

$parcel$export(module.exports, "thunk", function () { return $97366eee7a5b2478$export$dd164f5517779f15; });
$parcel$export(module.exports, "withExtraArgument", function () { return $97366eee7a5b2478$export$16d06542a1949d9e; });
// src/index.ts
function $97366eee7a5b2478$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $97366eee7a5b2478$export$dd164f5517779f15 = $97366eee7a5b2478$var$createThunkMiddleware();
var $97366eee7a5b2478$export$16d06542a1949d9e = $97366eee7a5b2478$var$createThunkMiddleware;

});


parcelRegister("6bOi6", function(module, exports) {

$parcel$export(module.exports, "SchemaError", function () { return $481ac7e387a25a46$export$44dde8d2b17fc96a; });
// src/getDotPath/getDotPath.ts
function $481ac7e387a25a46$export$31d66bebc5d58a1(issue) {
    if (issue.path?.length) {
        let dotPath = "";
        for (const item of issue.path){
            const key = typeof item === "object" ? item.key : item;
            if (typeof key === "string" || typeof key === "number") {
                if (dotPath) dotPath += `.${key}`;
                else dotPath += key;
            } else return null;
        }
        return dotPath;
    }
    return null;
}
// src/SchemaError/SchemaError.ts
var $481ac7e387a25a46$export$44dde8d2b17fc96a = class extends Error {
    /**
   * The schema issues.
   */ issues;
    /**
   * Creates a schema error with useful information.
   *
   * @param issues The schema issues.
   */ constructor(issues){
        super(issues[0].message);
        this.name = "SchemaError";
        this.issues = issues;
    }
};

});


parcelRegister("7nAvJ", function(module, exports) {

$parcel$export(module.exports, "shallowEqual", function () { return $966f27f056333206$export$d36bdfa510afb180; });
$parcel$export(module.exports, "ReactReduxContext", function () { return $966f27f056333206$export$cc80c08dc91f1c00; });
$parcel$export(module.exports, "Provider", function () { return $966f27f056333206$export$2881499e37b75b9a; });
$parcel$export(module.exports, "useStore", function () { return $966f27f056333206$export$6ccbb43953eebf8; });
$parcel$export(module.exports, "useDispatch", function () { return $966f27f056333206$export$8ad76b76a4c905f8; });
$parcel$export(module.exports, "useSelector", function () { return $966f27f056333206$export$2105062e25df4afe; });
$parcel$export(module.exports, "batch", function () { return $966f27f056333206$export$712ea50be43a7858; });

var $jHEir = parcelRequire("jHEir");

var $jClBK = parcelRequire("jClBK");
//#region src/utils/react-is.ts
const $966f27f056333206$var$IS_REACT_19 = /* @__PURE__ */ $jHEir.version.startsWith("19");
const $966f27f056333206$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($966f27f056333206$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
const $966f27f056333206$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
const $966f27f056333206$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
const $966f27f056333206$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
const $966f27f056333206$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
const $966f27f056333206$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
const $966f27f056333206$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
const $966f27f056333206$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
const $966f27f056333206$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
const $966f27f056333206$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
const $966f27f056333206$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
const $966f27f056333206$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
const $966f27f056333206$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
const $966f27f056333206$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
const $966f27f056333206$var$ForwardRef = $966f27f056333206$var$REACT_FORWARD_REF_TYPE;
const $966f27f056333206$var$Memo = $966f27f056333206$var$REACT_MEMO_TYPE;
function $966f27f056333206$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $966f27f056333206$var$REACT_FRAGMENT_TYPE || type === $966f27f056333206$var$REACT_PROFILER_TYPE || type === $966f27f056333206$var$REACT_STRICT_MODE_TYPE || type === $966f27f056333206$var$REACT_SUSPENSE_TYPE || type === $966f27f056333206$var$REACT_SUSPENSE_LIST_TYPE || type === $966f27f056333206$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $966f27f056333206$var$REACT_LAZY_TYPE || type.$$typeof === $966f27f056333206$var$REACT_MEMO_TYPE || type.$$typeof === $966f27f056333206$var$REACT_CONTEXT_TYPE || type.$$typeof === $966f27f056333206$var$REACT_CONSUMER_TYPE || type.$$typeof === $966f27f056333206$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $966f27f056333206$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? !0 : !1;
}
function $966f27f056333206$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $966f27f056333206$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $966f27f056333206$var$REACT_FRAGMENT_TYPE:
                    case $966f27f056333206$var$REACT_PROFILER_TYPE:
                    case $966f27f056333206$var$REACT_STRICT_MODE_TYPE:
                    case $966f27f056333206$var$REACT_SUSPENSE_TYPE:
                    case $966f27f056333206$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $966f27f056333206$var$REACT_CONTEXT_TYPE:
                            case $966f27f056333206$var$REACT_FORWARD_REF_TYPE:
                            case $966f27f056333206$var$REACT_LAZY_TYPE:
                            case $966f27f056333206$var$REACT_MEMO_TYPE:
                                return object;
                            case $966f27f056333206$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $966f27f056333206$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $966f27f056333206$var$isContextConsumer(object) {
    return $966f27f056333206$var$IS_REACT_19 ? $966f27f056333206$var$typeOf(object) === $966f27f056333206$var$REACT_CONSUMER_TYPE : $966f27f056333206$var$typeOf(object) === $966f27f056333206$var$REACT_CONTEXT_TYPE;
}
function $966f27f056333206$var$isMemo(object) {
    return $966f27f056333206$var$typeOf(object) === $966f27f056333206$var$REACT_MEMO_TYPE;
}
//#endregion
//#region src/utils/warning.ts
/**
* Prints a warning in the console if it exists.
*
* @param {String} message The warning message.
* @returns {void}
*/ function $966f27f056333206$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
//#endregion
//#region src/connect/verifySubselectors.ts
function $966f27f056333206$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $966f27f056333206$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $966f27f056333206$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $966f27f056333206$var$verify(mapStateToProps, "mapStateToProps");
    $966f27f056333206$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $966f27f056333206$var$verify(mergeProps, "mergeProps");
}
//#endregion
//#region src/connect/selectorFactory.ts
function $966f27f056333206$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $966f27f056333206$var$finalPropsSelectorFactory(dispatch, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps, ...options }) {
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $966f27f056333206$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
//#endregion
//#region src/utils/bindActionCreators.ts
function $966f27f056333206$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
//#endregion
//#region src/utils/isPlainObject.ts
/**
* @param {any} obj The object to inspect.
* @returns {boolean} True if the argument appears to be a plain object.
*/ function $966f27f056333206$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
//#endregion
//#region src/utils/verifyPlainObject.ts
function $966f27f056333206$var$verifyPlainObject(value, displayName, methodName) {
    if (!$966f27f056333206$var$isPlainObject(value)) $966f27f056333206$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
//#endregion
//#region src/connect/wrapMapToProps.ts
function $966f27f056333206$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $966f27f056333206$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps != null ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $966f27f056333206$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $966f27f056333206$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $966f27f056333206$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
//#endregion
//#region src/connect/invalidArgFactory.ts
function $966f27f056333206$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
//#endregion
//#region src/connect/mapDispatchToProps.ts
function $966f27f056333206$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $966f27f056333206$var$wrapMapToPropsConstant((dispatch)=>$966f27f056333206$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $966f27f056333206$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? $966f27f056333206$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $966f27f056333206$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
//#endregion
//#region src/connect/mapStateToProps.ts
function $966f27f056333206$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $966f27f056333206$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? $966f27f056333206$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $966f27f056333206$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
//#endregion
//#region src/connect/mergeProps.ts
function $966f27f056333206$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps
    };
}
function $966f27f056333206$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $966f27f056333206$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$966f27f056333206$var$defaultMergeProps : typeof mergeProps === "function" ? $966f27f056333206$var$wrapMergePropsFunc(mergeProps) : $966f27f056333206$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
//#endregion
//#region src/utils/batch.ts
function $966f27f056333206$var$defaultNoopBatch(callback) {
    callback();
}
//#endregion
//#region src/utils/Subscription.ts
function $966f27f056333206$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $966f27f056333206$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $966f27f056333206$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $966f27f056333206$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $966f27f056333206$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $966f27f056333206$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $966f27f056333206$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
//#endregion
//#region src/utils/useIsomorphicLayoutEffect.ts
const $966f27f056333206$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $966f27f056333206$var$isDOM = /* @__PURE__ */ $966f27f056333206$var$canUseDOM();
/**
* Checks if the code is running in a React Native environment.
*
* @returns Whether the code is running in a React Native environment.
*
* @see {@link https://github.com/facebook/react-native/issues/1331 Reference}
*/ const $966f27f056333206$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
const $966f27f056333206$var$isReactNative = /* @__PURE__ */ $966f27f056333206$var$isRunningInReactNative();
const $966f27f056333206$var$getUseIsomorphicLayoutEffect = ()=>$966f27f056333206$var$isDOM || $966f27f056333206$var$isReactNative ? $jHEir.useLayoutEffect : $jHEir.useEffect;
const $966f27f056333206$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $966f27f056333206$var$getUseIsomorphicLayoutEffect();
//#endregion
//#region src/utils/shallowEqual.ts
function $966f27f056333206$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $966f27f056333206$export$d36bdfa510afb180(objA, objB) {
    if ($966f27f056333206$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++)if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$966f27f056333206$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    return true;
}
//#endregion
//#region src/utils/hoistStatics.ts
const $966f27f056333206$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
const $966f27f056333206$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
const $966f27f056333206$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
const $966f27f056333206$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
const $966f27f056333206$var$TYPE_STATICS = {
    [$966f27f056333206$var$ForwardRef]: $966f27f056333206$var$FORWARD_REF_STATICS,
    [$966f27f056333206$var$Memo]: $966f27f056333206$var$MEMO_STATICS
};
function $966f27f056333206$var$getStatics(component) {
    if ($966f27f056333206$var$isMemo(component)) return $966f27f056333206$var$MEMO_STATICS;
    return $966f27f056333206$var$TYPE_STATICS[component["$$typeof"]] || $966f27f056333206$var$REACT_STATICS;
}
const $966f27f056333206$var$defineProperty = Object.defineProperty;
const $966f27f056333206$var$getOwnPropertyNames = Object.getOwnPropertyNames;
const $966f27f056333206$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
const $966f27f056333206$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
const $966f27f056333206$var$getPrototypeOf = Object.getPrototypeOf;
const $966f27f056333206$var$objectPrototype = Object.prototype;
function $966f27f056333206$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($966f27f056333206$var$objectPrototype) {
            const inheritedComponent = $966f27f056333206$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $966f27f056333206$var$objectPrototype) $966f27f056333206$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $966f27f056333206$var$getOwnPropertyNames(sourceComponent);
        if ($966f27f056333206$var$getOwnPropertySymbols) keys = keys.concat($966f27f056333206$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $966f27f056333206$var$getStatics(targetComponent);
        const sourceStatics = $966f27f056333206$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$966f27f056333206$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $966f27f056333206$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $966f27f056333206$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
//#endregion
//#region src/components/Context.ts
const $966f27f056333206$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
const $966f27f056333206$var$gT = typeof globalThis !== "undefined" ? globalThis : {};
function $966f27f056333206$var$getContext() {
    if (!$jHEir.createContext) return {};
    const contextMap = $966f27f056333206$var$gT[$966f27f056333206$var$ContextKey] ??= /* @__PURE__ */ new Map();
    let realContext = contextMap.get($jHEir.createContext);
    if (!realContext) {
        realContext = $jHEir.createContext(null);
        contextMap.set($jHEir.createContext, realContext);
    }
    return realContext;
}
const $966f27f056333206$export$cc80c08dc91f1c00 = /*#__PURE__*/ $966f27f056333206$var$getContext();
//#endregion
//#region src/components/connect.tsx
const $966f27f056333206$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
const $966f27f056333206$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $966f27f056333206$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $966f27f056333206$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $966f27f056333206$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $966f27f056333206$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener, displayName) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $966f27f056333206$var$strictEqual(a, b) {
    return a === b;
}
let $966f27f056333206$var$hasWarnedAboutDeprecatedPureOption = false;
/**
* @deprecated
*
* **We recommend using the `useSelector` and `useDispatch` hooks instead.**
* See https://react-redux.js.org/api/hooks
*
* If you need to use `connect` without this visual deprecation warning,
* import `legacy_connect` instead:
*
* `import { legacy_connect as connect } from 'react-redux'`
*
* Connects a React component to a Redux store.
*
* - Without arguments, just wraps the component, without changing the behavior / props
*
* - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
* is to override ownProps (as stated in the docs), so what remains is everything that's
* not a state or dispatch prop
*
* - When 3rd param is passed, we don't know if ownProps propagate and whether they
* should be valid component props, because it depends on mergeProps implementation.
* As such, it is the user's responsibility to extend ownProps interface from state or
* dispatch props or both when applicable
*
* @param mapStateToProps A function that extracts values from state
* @param mapDispatchToProps Setup for dispatching actions
* @param mergeProps Optional callback to merge state and dispatch props together
* @param options Options for configuring the connection
*
*/ function $966f27f056333206$var$_connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: pure, areStatesEqual: areStatesEqual = $966f27f056333206$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $966f27f056333206$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $966f27f056333206$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $966f27f056333206$export$d36bdfa510afb180, forwardRef: forwardRef = false, context: context = $966f27f056333206$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $966f27f056333206$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $966f27f056333206$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $966f27f056333206$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $jHEir.useMemo(()=>{
                const { reactReduxForwardedRef: reactReduxForwardedRef, ...wrapperProps } = props;
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $jHEir.useMemo(()=>{
                let ResultContext = Context;
                if (propsContext?.Consumer) ResultContext = propsContext;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $jHEir.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $jHEir.useMemo(()=>{
                return $966f27f056333206$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $jHEir.useMemo(()=>{
                if (!shouldHandleStateChanges) return $966f27f056333206$var$NO_SUBSCRIPTION_ARRAY;
                const subscription = $966f27f056333206$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                return [
                    subscription,
                    subscription.notifyNestedSubs.bind(subscription)
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $jHEir.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return {
                    ...contextValue,
                    subscription: subscription
                };
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $jHEir.useRef(void 0);
            const lastWrapperProps = $jHEir.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $jHEir.useRef(void 0);
            const renderIsScheduled = $jHEir.useRef(false);
            const isMounted = $jHEir.useRef(false);
            /**
			* @todo Change this to `React.useRef<Error>(undefined)` after upgrading to React 19.
			*/ const latestSubscriptionCallbackError = $jHEir.useRef(void 0);
            $966f27f056333206$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $jHEir.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $jHEir.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $966f27f056333206$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener, displayName);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $966f27f056333206$var$useIsomorphicLayoutEffectWithArgs($966f27f056333206$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $jHEir.useSyncExternalStore(subscribeForReact, actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            $966f27f056333206$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $jHEir.useMemo(()=>{
                const effectiveProps = {
                    ...actualChildProps
                };
                if (forwardRef) effectiveProps.ref = reactReduxForwardedRef;
                return /* @__PURE__ */ $jHEir.createElement(WrappedComponent, effectiveProps);
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            return $jHEir.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $jHEir.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
        }
        const Connect = $jHEir.memo(ConnectFunction);
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const forwarded = $jHEir.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $jHEir.createElement(Connect, {
                    ...props,
                    reactReduxForwardedRef: ref
                });
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /*#__PURE__*/ $966f27f056333206$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /*#__PURE__*/ $966f27f056333206$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
/**
*  * @deprecated
*
* **We recommend using the `useSelector` and `useDispatch` hooks instead.**
* See https://react-redux.js.org/api/hooks
*
* If you need to use `connect` without this visual deprecation warning,
* import `legacy_connect` instead:
*
* `import { legacy_connect as connect } from 'react-redux'`
*/ const $966f27f056333206$export$64605811ab45167f = $966f27f056333206$var$_connect;
/**
* Connects a React component to a Redux store. Same as `connect` but without
* the deprecation warning.
*
* **We recommend using the `useSelector` and `useDispatch` hooks instead.**
* See https://react-redux.js.org/api/hooks
*/ const $966f27f056333206$export$8807b5ba46f9d0b7 = $966f27f056333206$var$_connect;
//#endregion
//#region src/components/Provider.tsx
function $966f27f056333206$export$2881499e37b75b9a(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $jHEir.useMemo(()=>{
        const subscription = $966f27f056333206$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState != null ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $jHEir.useMemo(()=>store.getState(), [
        store
    ]);
    $966f27f056333206$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $966f27f056333206$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $jHEir.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
//#endregion
//#region src/hooks/useReduxContext.ts
/**
* Hook factory, which creates a `useReduxContext` hook bound to a given context. This is a low-level
* hook that you should usually not need to call directly.
*
* @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
* @returns {Function} A `useReduxContext` hook bound to the specified context.
*/ function $966f27f056333206$var$createReduxContextHook(context = $966f27f056333206$export$cc80c08dc91f1c00) {
    return function useReduxContext() {
        const contextValue = $jHEir.useContext(context);
        return contextValue;
    };
}
/**
* A hook to access the value of the `ReactReduxContext`. This is a low-level
* hook that you should usually not need to call directly.
*
* @returns {any} the value of the `ReactReduxContext`
*
* @example
*
* import React from 'react'
* import { useReduxContext } from 'react-redux'
*
* export const CounterComponent = () => {
*   const { store } = useReduxContext()
*   return <div>{store.getState()}</div>
* }
*/ const $966f27f056333206$var$useReduxContext = /*#__PURE__*/ $966f27f056333206$var$createReduxContextHook();
//#endregion
//#region src/hooks/useStore.ts
/**
* Hook factory, which creates a `useStore` hook bound to a given context.
*
* @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
* @returns {Function} A `useStore` hook bound to the specified context.
*/ function $966f27f056333206$export$671dba69185d0304(context = $966f27f056333206$export$cc80c08dc91f1c00) {
    const useReduxContext$2 = context === $966f27f056333206$export$cc80c08dc91f1c00 ? $966f27f056333206$var$useReduxContext : $966f27f056333206$var$createReduxContextHook(context);
    const useStore = ()=>{
        const { store: store } = useReduxContext$2();
        return store;
    };
    Object.assign(useStore, {
        withTypes: ()=>useStore
    });
    return useStore;
}
/**
* A hook to access the redux store.
*
* @returns {any} the redux store
*
* @example
*
* import React from 'react'
* import { useStore } from 'react-redux'
*
* export const ExampleComponent = () => {
*   const store = useStore()
*   return <div>{store.getState()}</div>
* }
*/ const $966f27f056333206$export$6ccbb43953eebf8 = /*#__PURE__*/ $966f27f056333206$export$671dba69185d0304();
//#endregion
//#region src/hooks/useDispatch.ts
/**
* Hook factory, which creates a `useDispatch` hook bound to a given context.
*
* @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
* @returns {Function} A `useDispatch` hook bound to the specified context.
*/ function $966f27f056333206$export$bc9b55530897c558(context = $966f27f056333206$export$cc80c08dc91f1c00) {
    const useStore$1 = context === $966f27f056333206$export$cc80c08dc91f1c00 ? $966f27f056333206$export$6ccbb43953eebf8 : $966f27f056333206$export$671dba69185d0304(context);
    const useDispatch = ()=>{
        return useStore$1().dispatch;
    };
    Object.assign(useDispatch, {
        withTypes: ()=>useDispatch
    });
    return useDispatch;
}
/**
* A hook to access the redux `dispatch` function.
*
* @returns {any|function} redux store's `dispatch` function
*
* @example
*
* import React, { useCallback } from 'react'
* import { useDispatch } from 'react-redux'
*
* export const CounterComponent = ({ value }) => {
*   const dispatch = useDispatch()
*   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
*   return (
*     <div>
*       <span>{value}</span>
*       <button onClick={increaseCounter}>Increase counter</button>
*     </div>
*   )
* }
*/ const $966f27f056333206$export$8ad76b76a4c905f8 = /*#__PURE__*/ $966f27f056333206$export$bc9b55530897c558();
//#endregion
//#region src/hooks/useSelector.ts
const $966f27f056333206$var$refEquality = (a, b)=>a === b;
/**
* Hook factory, which creates a `useSelector` hook bound to a given context.
*
* @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
* @returns {Function} A `useSelector` hook bound to the specified context.
*/ function $966f27f056333206$export$2b53f90d2bd1cbfb(context = $966f27f056333206$export$cc80c08dc91f1c00) {
    const useReduxContext$1 = context === $966f27f056333206$export$cc80c08dc91f1c00 ? $966f27f056333206$var$useReduxContext : $966f27f056333206$var$createReduxContextHook(context);
    const useSelector = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $966f27f056333206$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext$1();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $jHEir.useRef(true);
        const wrappedSelector = $jHEir.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $jClBK.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $jHEir.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector, {
        withTypes: ()=>useSelector
    });
    return useSelector;
}
/**
* A hook to access the redux store's state. This hook takes a selector function
* as an argument. The selector is called with the store state.
*
* This hook takes an optional equality comparison function as the second parameter
* that allows you to customize the way the selected state is compared to determine
* whether the component needs to be re-rendered.
*
* @param {Function} selector the selector function
* @param {Function=} equalityFn the function that will be used to determine equality
*
* @returns {any} the selected state
*
* @example
*
* import React from 'react'
* import { useSelector } from 'react-redux'
*
* export const CounterComponent = () => {
*   const counter = useSelector(state => state.counter)
*   return <div>{counter}</div>
* }
*/ const $966f27f056333206$export$2105062e25df4afe = /*#__PURE__*/ $966f27f056333206$export$2b53f90d2bd1cbfb();
//#endregion
//#region src/exports.ts
/**
* @deprecated As of React 18, batching is enabled by default for ReactDOM and React Native.
* This is now a no-op that immediately runs the callback.
*/ const $966f27f056333206$export$712ea50be43a7858 = $966f27f056333206$var$defaultNoopBatch;

});
parcelRegister("jClBK", function(module, exports) {
'use strict';

module.exports = (parcelRequire("c1dsE"));

});
parcelRegister("c1dsE", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $8c000521a8f9d90e$export$bf730a2d8bf68b42; }, function (v) { return $8c000521a8f9d90e$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8c000521a8f9d90e$export$bf730a2d8bf68b42;
"use strict";

var $jHEir = parcelRequire("jHEir");
function $8c000521a8f9d90e$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $8c000521a8f9d90e$var$objectIs = "function" === typeof Object.is ? Object.is : $8c000521a8f9d90e$var$is, $8c000521a8f9d90e$var$useSyncExternalStore = $jHEir.useSyncExternalStore, $8c000521a8f9d90e$var$useRef = $jHEir.useRef, $8c000521a8f9d90e$var$useEffect = $jHEir.useEffect, $8c000521a8f9d90e$var$useMemo = $jHEir.useMemo, $8c000521a8f9d90e$var$useDebugValue = $jHEir.useDebugValue;
$8c000521a8f9d90e$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $8c000521a8f9d90e$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $8c000521a8f9d90e$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($8c000521a8f9d90e$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $8c000521a8f9d90e$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $8c000521a8f9d90e$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $8c000521a8f9d90e$var$useDebugValue(value);
    return value;
};

});





parcelRegister("i3HgA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89061f977c0651ed$export$2e2bcd8739ae039; });

var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");
const $89061f977c0651ed$var$roleStyles = {
    admin: 'border-purple-500/20 bg-purple-500/10 text-purple-400',
    trader: 'border-emerald-500/20 bg-emerald-500/10 text-emerald-400',
    investor: 'border-cyan-500/20 bg-cyan-500/10 text-cyan-400',
    viewer: 'border-blue-500/20 bg-blue-500/10 text-blue-400'
};
const $89061f977c0651ed$var$roleLabels = {
    admin: 'Admin',
    trader: 'Trader',
    investor: 'Investor',
    viewer: 'Viewer'
};
const $89061f977c0651ed$var$UserTypeBadge = ({ role: role, className: className = '', compact: compact = false })=>{
    const key = role?.trim().toLowerCase() || '';
    const label = $89061f977c0651ed$var$roleLabels[key] || role?.trim() || 'Account';
    const sizeClasses = compact ? 'px-1.5 py-0.5 text-[8px]' : 'px-2.5 py-0.5 text-xs';
    return /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
        "aria-label": `User type: ${label}`,
        title: `User type: ${label}`,
        className: `inline-flex shrink-0 items-center rounded-full border font-semibold leading-none ${sizeClasses} ${$89061f977c0651ed$var$roleStyles[key] || 'border-white/10 bg-white/5 text-muted'} ${className}`,
        children: label
    });
};
var $89061f977c0651ed$export$2e2bcd8739ae039 = $89061f977c0651ed$var$UserTypeBadge;

});

parcelRegister("gQIZx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20f2000be62219f2$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $20f2000be62219f2$export$a2387ed3b5d536eb = {
    name: "activity",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
                key: "169zse"
            }
        ]
    ]
};
$20f2000be62219f2$export$a2387ed3b5d536eb.node;
const $20f2000be62219f2$export$2e2bcd8739ae039 = (0, $hHhnY.default)($20f2000be62219f2$export$a2387ed3b5d536eb);

});

parcelRegister("19CqD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13bb5b940db3a54a$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $13bb5b940db3a54a$export$a2387ed3b5d536eb = {
    name: "chart-column",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 3v16a2 2 0 0 0 2 2h16",
                key: "c24i48"
            }
        ],
        [
            "path",
            {
                d: "M18 17V9",
                key: "2bz60n"
            }
        ],
        [
            "path",
            {
                d: "M13 17V5",
                key: "1frdt8"
            }
        ],
        [
            "path",
            {
                d: "M8 17v-3",
                key: "17ska0"
            }
        ]
    ],
    aliases: [
        "bar-chart-3"
    ]
};
$13bb5b940db3a54a$export$a2387ed3b5d536eb.node;
const $13bb5b940db3a54a$export$2e2bcd8739ae039 = (0, $hHhnY.default)($13bb5b940db3a54a$export$a2387ed3b5d536eb);

});

parcelRegister("cSggV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67767fb406e85430$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $67767fb406e85430$export$a2387ed3b5d536eb = {
    name: "bell",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10.268 21a2 2 0 0 0 3.464 0",
                key: "vwvbt9"
            }
        ],
        [
            "path",
            {
                d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
                key: "11g9vi"
            }
        ]
    ]
};
$67767fb406e85430$export$a2387ed3b5d536eb.node;
const $67767fb406e85430$export$2e2bcd8739ae039 = (0, $hHhnY.default)($67767fb406e85430$export$a2387ed3b5d536eb);

});

parcelRegister("3KPv1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c42f51b7c337674$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $3c42f51b7c337674$export$a2387ed3b5d536eb = {
    name: "briefcase",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16",
                key: "jecpp"
            }
        ],
        [
            "rect",
            {
                width: "20",
                height: "14",
                x: "2",
                y: "6",
                rx: "2",
                key: "i6l2r4"
            }
        ]
    ]
};
$3c42f51b7c337674$export$a2387ed3b5d536eb.node;
const $3c42f51b7c337674$export$2e2bcd8739ae039 = (0, $hHhnY.default)($3c42f51b7c337674$export$a2387ed3b5d536eb);

});

parcelRegister("7b33p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $997fc8abd1889831$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $997fc8abd1889831$export$a2387ed3b5d536eb = {
    name: "calendar-days",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M8 2v3",
                key: "1ioesn"
            }
        ],
        [
            "path",
            {
                d: "M16 2v3",
                key: "otl347"
            }
        ],
        [
            "rect",
            {
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2",
                key: "h1oib"
            }
        ],
        [
            "path",
            {
                d: "M3 9h18",
                key: "1pudct"
            }
        ],
        [
            "path",
            {
                d: "M8 13h.01",
                key: "1sbv64"
            }
        ],
        [
            "path",
            {
                d: "M12 13h.01",
                key: "y0uutt"
            }
        ],
        [
            "path",
            {
                d: "M16 13h.01",
                key: "wip0gl"
            }
        ],
        [
            "path",
            {
                d: "M8 17h.01",
                key: "p3bg7i"
            }
        ],
        [
            "path",
            {
                d: "M12 17h.01",
                key: "p32p05"
            }
        ],
        [
            "path",
            {
                d: "M16 17h.01",
                key: "ql8jdd"
            }
        ]
    ]
};
$997fc8abd1889831$export$a2387ed3b5d536eb.node;
const $997fc8abd1889831$export$2e2bcd8739ae039 = (0, $hHhnY.default)($997fc8abd1889831$export$a2387ed3b5d536eb);

});

parcelRegister("94HEM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0093d6cc3007c698$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $0093d6cc3007c698$export$a2387ed3b5d536eb = {
    name: "database",
    size: 24,
    node: [
        [
            "ellipse",
            {
                cx: "12",
                cy: "5",
                rx: "9",
                ry: "3",
                key: "msslwz"
            }
        ],
        [
            "path",
            {
                d: "M3 5V19A9 3 0 0 0 21 19V5",
                key: "1wlel7"
            }
        ],
        [
            "path",
            {
                d: "M3 12A9 3 0 0 0 21 12",
                key: "mv7ke4"
            }
        ]
    ]
};
$0093d6cc3007c698$export$a2387ed3b5d536eb.node;
const $0093d6cc3007c698$export$2e2bcd8739ae039 = (0, $hHhnY.default)($0093d6cc3007c698$export$a2387ed3b5d536eb);

});

parcelRegister("f11WQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83ba44fa72bffc2a$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $83ba44fa72bffc2a$export$a2387ed3b5d536eb = {
    name: "file-text",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
                key: "1oefj6"
            }
        ],
        [
            "path",
            {
                d: "M14 2v5a1 1 0 0 0 1 1h5",
                key: "wfsgrz"
            }
        ],
        [
            "path",
            {
                d: "M10 9H8",
                key: "b1mrlr"
            }
        ],
        [
            "path",
            {
                d: "M16 13H8",
                key: "t4e002"
            }
        ],
        [
            "path",
            {
                d: "M16 17H8",
                key: "z1uh3a"
            }
        ]
    ]
};
$83ba44fa72bffc2a$export$a2387ed3b5d536eb.node;
const $83ba44fa72bffc2a$export$2e2bcd8739ae039 = (0, $hHhnY.default)($83ba44fa72bffc2a$export$a2387ed3b5d536eb);

});

parcelRegister("62xmE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96533230c587ccb9$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $96533230c587ccb9$export$a2387ed3b5d536eb = {
    name: "list",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 5h.01",
                key: "18ugdj"
            }
        ],
        [
            "path",
            {
                d: "M3 12h.01",
                key: "nlz23k"
            }
        ],
        [
            "path",
            {
                d: "M3 19h.01",
                key: "noohij"
            }
        ],
        [
            "path",
            {
                d: "M8 5h13",
                key: "1pao27"
            }
        ],
        [
            "path",
            {
                d: "M8 12h13",
                key: "1za7za"
            }
        ],
        [
            "path",
            {
                d: "M8 19h13",
                key: "m83p4d"
            }
        ]
    ]
};
$96533230c587ccb9$export$a2387ed3b5d536eb.node;
const $96533230c587ccb9$export$2e2bcd8739ae039 = (0, $hHhnY.default)($96533230c587ccb9$export$a2387ed3b5d536eb);

});

parcelRegister("6q9x0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51b5ff840c46ae1f$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $51b5ff840c46ae1f$export$a2387ed3b5d536eb = {
    name: "chart-pie",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z",
                key: "pzmjnu"
            }
        ],
        [
            "path",
            {
                d: "M21.21 15.89A10 10 0 1 1 8 2.83",
                key: "k2fpak"
            }
        ]
    ],
    aliases: [
        "pie-chart"
    ]
};
$51b5ff840c46ae1f$export$a2387ed3b5d536eb.node;
const $51b5ff840c46ae1f$export$2e2bcd8739ae039 = (0, $hHhnY.default)($51b5ff840c46ae1f$export$a2387ed3b5d536eb);

});

parcelRegister("ehZ63", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1154be80d7479d62$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $1154be80d7479d62$export$a2387ed3b5d536eb = {
    name: "shield",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
                key: "oel41y"
            }
        ]
    ]
};
$1154be80d7479d62$export$a2387ed3b5d536eb.node;
const $1154be80d7479d62$export$2e2bcd8739ae039 = (0, $hHhnY.default)($1154be80d7479d62$export$a2387ed3b5d536eb);

});

parcelRegister("8Rrv7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20985f9440d98bd3$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $20985f9440d98bd3$export$a2387ed3b5d536eb = {
    name: "sliders-horizontal",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10 5H3",
                key: "1qgfaw"
            }
        ],
        [
            "path",
            {
                d: "M12 19H3",
                key: "yhmn1j"
            }
        ],
        [
            "path",
            {
                d: "M14 3v4",
                key: "1sua03"
            }
        ],
        [
            "path",
            {
                d: "M16 17v4",
                key: "1q0r14"
            }
        ],
        [
            "path",
            {
                d: "M21 12h-9",
                key: "1o4lsq"
            }
        ],
        [
            "path",
            {
                d: "M21 19h-5",
                key: "1rlt1p"
            }
        ],
        [
            "path",
            {
                d: "M21 5h-7",
                key: "1oszz2"
            }
        ],
        [
            "path",
            {
                d: "M8 10v4",
                key: "tgpxqk"
            }
        ],
        [
            "path",
            {
                d: "M8 12H3",
                key: "a7s4jb"
            }
        ]
    ]
};
$20985f9440d98bd3$export$a2387ed3b5d536eb.node;
const $20985f9440d98bd3$export$2e2bcd8739ae039 = (0, $hHhnY.default)($20985f9440d98bd3$export$a2387ed3b5d536eb);

});

parcelRegister("4bqNy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9effe5e07d42d8d5$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $9effe5e07d42d8d5$export$a2387ed3b5d536eb = {
    name: "check",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M20 6 9 17l-5-5",
                key: "1gmf2c"
            }
        ]
    ]
};
$9effe5e07d42d8d5$export$a2387ed3b5d536eb.node;
const $9effe5e07d42d8d5$export$2e2bcd8739ae039 = (0, $hHhnY.default)($9effe5e07d42d8d5$export$a2387ed3b5d536eb);

});

parcelRegister("gNGY5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcb0af7e5bbff65b$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $dcb0af7e5bbff65b$export$a2387ed3b5d536eb = {
    name: "info",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "M12 16v-4",
                key: "1dtifu"
            }
        ],
        [
            "path",
            {
                d: "M12 8h.01",
                key: "e9boi3"
            }
        ]
    ]
};
$dcb0af7e5bbff65b$export$a2387ed3b5d536eb.node;
const $dcb0af7e5bbff65b$export$2e2bcd8739ae039 = (0, $hHhnY.default)($dcb0af7e5bbff65b$export$a2387ed3b5d536eb);

});

parcelRegister("8FKMh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $136635e7c7f6486f$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $136635e7c7f6486f$export$a2387ed3b5d536eb = {
    name: "trending-up",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 7h6v6",
                key: "box55l"
            }
        ],
        [
            "path",
            {
                d: "m22 7-8.5 8.5-5-5L2 17",
                key: "1t1m79"
            }
        ]
    ]
};
$136635e7c7f6486f$export$a2387ed3b5d536eb.node;
const $136635e7c7f6486f$export$2e2bcd8739ae039 = (0, $hHhnY.default)($136635e7c7f6486f$export$a2387ed3b5d536eb);

});

parcelRegister("lRLyZ", function(module, exports) {

$parcel$export(module.exports, "formatDateTimeET", function () { return $9b7034e9a555a9f0$export$da64fb0d6ddc83a; });
$parcel$export(module.exports, "formatTimeET", function () { return $9b7034e9a555a9f0$export$ff5577ee71c12d94; });
const $9b7034e9a555a9f0$export$da64fb0d6ddc83a = (value)=>{
    if (!value) return "\u2014";
    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
            const [y, m, d] = trimmed.split('-').map(Number);
            const date = new Date(y, m - 1, d, 12, 0, 0);
            return new Intl.DateTimeFormat('en-US', {
                timeZone: 'America/New_York',
                year: 'numeric',
                month: 'short',
                day: '2-digit'
            }).format(date);
        }
    }
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return "\u2014";
    return new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }).format(date) + ' ET';
};
const $9b7034e9a555a9f0$export$ff5577ee71c12d94 = (value)=>{
    if (!value) return "\u2014";
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return "\u2014";
    return new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }).format(date) + ' ET';
};

});

parcelRegister("5ogeV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c864ab6e9163432$export$2e2bcd8739ae039; });

var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");
const $0c864ab6e9163432$var$LoadingSpinner = ({ size: size = 'md', className: className = '' })=>{
    const sizeClasses = {
        sm: 'w-4 h-4',
        md: 'w-6 h-6',
        lg: 'w-8 h-8'
    };
    return /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
        className: `flex items-center justify-center ${className}`,
        children: /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
            className: `animate-spin rounded-full border-2 border-gray-300 border-t-primary-500 ${sizeClasses[size]}`,
            role: "status",
            "aria-label": "Loading",
            children: /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                className: "sr-only",
                children: "Loading..."
            })
        })
    });
};
var $0c864ab6e9163432$export$2e2bcd8739ae039 = $0c864ab6e9163432$var$LoadingSpinner;

});

parcelRegister("7i2bY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b009d3134badcf9e$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $b009d3134badcf9e$export$a2387ed3b5d536eb = {
    name: "circle-check",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "m16 9-5.5 5.5L8 12",
                key: "xofnsj"
            }
        ]
    ],
    aliases: [
        "check-circle-2"
    ]
};
$b009d3134badcf9e$export$a2387ed3b5d536eb.node;
const $b009d3134badcf9e$export$2e2bcd8739ae039 = (0, $hHhnY.default)($b009d3134badcf9e$export$a2387ed3b5d536eb);

});

parcelRegister("9sk6d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ef0e05f553a5ef3$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $6ef0e05f553a5ef3$export$a2387ed3b5d536eb = {
    name: "cloud",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z",
                key: "p7xjir"
            }
        ]
    ]
};
$6ef0e05f553a5ef3$export$a2387ed3b5d536eb.node;
const $6ef0e05f553a5ef3$export$2e2bcd8739ae039 = (0, $hHhnY.default)($6ef0e05f553a5ef3$export$a2387ed3b5d536eb);

});

parcelRegister("7QVYH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7223ae596b60916$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $c7223ae596b60916$export$a2387ed3b5d536eb = {
    name: "hard-drive",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10 16h.01",
                key: "1bzywj"
            }
        ],
        [
            "path",
            {
                d: "M2.212 11.577a2 2 0 0 0-.212.896V18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5.527a2 2 0 0 0-.212-.896L18.55 5.11A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
                key: "18tbho"
            }
        ],
        [
            "path",
            {
                d: "M21.946 12.013H2.054",
                key: "zqlbp7"
            }
        ],
        [
            "path",
            {
                d: "M6 16h.01",
                key: "1pmjb7"
            }
        ]
    ]
};
$c7223ae596b60916$export$a2387ed3b5d536eb.node;
const $c7223ae596b60916$export$2e2bcd8739ae039 = (0, $hHhnY.default)($c7223ae596b60916$export$a2387ed3b5d536eb);

});

parcelRegister("j0ppv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00beb94742b99fda$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $00beb94742b99fda$export$a2387ed3b5d536eb = {
    name: "circle-x",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "m15 9-6 6",
                key: "1uzhvr"
            }
        ],
        [
            "path",
            {
                d: "m9 9 6 6",
                key: "z0biqf"
            }
        ]
    ],
    aliases: [
        "x-circle"
    ]
};
$00beb94742b99fda$export$a2387ed3b5d536eb.node;
const $00beb94742b99fda$export$2e2bcd8739ae039 = (0, $hHhnY.default)($00beb94742b99fda$export$a2387ed3b5d536eb);

});

parcelRegister("Ec49u", function(module, exports) {

$parcel$export(module.exports, "formatDownloadTaskBarCount", function () { return $3b894a03465f009f$export$1866770e6904a6f1; });
const $3b894a03465f009f$export$1866770e6904a6f1 = (bars, fallback = '')=>typeof bars === 'number' && Number.isFinite(bars) ? bars.toLocaleString() : fallback;

});

parcelRegister("7Mvr3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eaa990055fa75a6e$export$2e2bcd8739ae039; });

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $jr1gO = parcelRequire("jr1gO");
var $5j4E8 = parcelRequire("5j4E8");
var $dL2Lt = parcelRequire("dL2Lt");
var $9Livr = parcelRequire("9Livr");
var $ehZ63 = parcelRequire("ehZ63");
var $k9hlW = parcelRequire("k9hlW");
var $bgvjD = parcelRequire("bgvjD");

var $zs3Np = parcelRequire("zs3Np");

var $67Thx = parcelRequire("67Thx");

var $g9vEp = parcelRequire("g9vEp");

var $e4aOX = parcelRequire("e4aOX");
const $eaa990055fa75a6e$var$GatewayConfigModal = ({ isOpen: isOpen, onClose: onClose, onSuccess: onSuccess, currentUsername: currentUsername, currentMode: currentMode, savedGateways: savedGateways })=>{
    const { user: user } = (0, $e4aOX.useAuth)();
    const isInvestor = user?.role === 'investor';
    const [username, setUsername] = (0, $jHEir.useState)(currentUsername || '');
    const [password, setPassword] = (0, $jHEir.useState)('');
    const [mode, setMode] = (0, $jHEir.useState)(isInvestor ? 'live' : currentMode || 'paper');
    // Default gatewayId to the mode name to ensure separation by default
    const [gatewayId, setGatewayId] = (0, $jHEir.useState)(isInvestor ? 'live' : currentMode || 'paper');
    const [configStatus, setConfigStatus] = (0, $jHEir.useState)(null);
    const [loading, setLoading] = (0, $jHEir.useState)(false);
    // Warning Modal State
    const [showWarning, setShowWarning] = (0, $jHEir.useState)(false);
    const [activating, setActivating] = (0, $jHEir.useState)(false);
    // Helper to find saved config for a mode
    const findSavedConfig = (targetMode)=>{
        if (!savedGateways) return null;
        // First try to find by ID matching mode (e.g. id="paper")
        let found = savedGateways.find((g)=>g.id === targetMode);
        // Fallback to finding by mode
        if (!found) found = savedGateways.find((g)=>g.mode === targetMode);
        return found;
    };
    const savedConfig = findSavedConfig(mode);
    const isActive = savedConfig?.is_active;
    // Reset state when modal opens
    (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useEffect(()=>{
        if (isOpen) {
            const initialMode = isInvestor ? 'live' : currentMode || 'paper';
            setMode(initialMode);
            setGatewayId(initialMode); // Default ID to mode name
            // Try to pre-fill from saved gateways first
            const saved = findSavedConfig(initialMode);
            if (saved && saved.username) {
                setUsername(saved.username);
                if (saved.id) setGatewayId(saved.id);
            } else setUsername(currentUsername || '');
            setPassword('');
            setConfigStatus(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen,
        isInvestor
    ]);
    if (!isOpen) return null;
    const handleModeSwitch = (newMode)=>{
        setMode(newMode);
        setConfigStatus(null);
        // Try to find saved config for the new mode
        const saved = findSavedConfig(newMode);
        if (saved && saved.username) {
            setUsername(saved.username);
            setGatewayId(saved.id);
        } else {
            // If switching back to initial mode, restore initial props
            if (newMode === currentMode) setUsername(currentUsername || '');
            else setUsername('');
            // Default ID to new mode name if no saved config found
            setGatewayId(newMode);
        }
        setPassword(''); // Always clear password for security
    };
    const handleSaveConfig = async (e)=>{
        e.preventDefault();
        if (!username || !password) {
            setConfigStatus({
                type: 'error',
                message: 'Username and password are required'
            });
            return;
        }
        setLoading(true);
        setConfigStatus({
            type: 'info',
            message: 'Saving configuration...'
        });
        try {
            const response = await (0, $zs3Np.tradingApi).configureIBGateway(username, password, mode, gatewayId || undefined, undefined, undefined // No renaming needed
            );
            if (response.success) {
                setConfigStatus({
                    type: 'success',
                    message: isInvestor ? 'Configuration saved. Preparing broker controls...' : 'Configuration saved. You can now activate this gateway.'
                });
                setPassword('');
                await Promise.resolve(onSuccess());
                if (isInvestor) setTimeout(onClose, 700);
            } else setConfigStatus({
                type: 'error',
                message: response.error || 'Failed to configure gateway'
            });
        } catch (err) {
            setConfigStatus({
                type: 'error',
                message: err.message || 'An error occurred'
            });
        } finally{
            setLoading(false);
        }
    };
    const handleActivateClick = ()=>{
        setShowWarning(true);
    };
    const handleConfirmSwitch = async ()=>{
        setActivating(true);
        try {
            // Use the gatewayId from state (which should match the saved one if we are in this state)
            // Or better, use the ID from the saved config we found
            const targetId = savedConfig?.id || gatewayId;
            const response = await (0, $zs3Np.tradingApi).activateIBGateway(targetId);
            if (response.success) {
                setConfigStatus({
                    type: 'success',
                    message: 'Gateway activated successfully!'
                });
                setTimeout(()=>{
                    onSuccess();
                    onClose();
                }, 1500);
            } else setConfigStatus({
                type: 'error',
                message: response.error || 'Failed to activate gateway'
            });
        } catch (err) {
            setConfigStatus({
                type: 'error',
                message: err.message || 'Failed to activate gateway'
            });
        } finally{
            setActivating(false);
            setShowWarning(false);
        }
    };
    const handleDeleteConfig = async ()=>{
        if (!savedConfig || !savedConfig.id) return;
        if (!window.confirm(`Are you sure you want to delete the configuration for ${savedConfig.mode} mode? This will stop the gateway if running.`)) return;
        setLoading(true);
        setConfigStatus({
            type: 'info',
            message: 'Deleting configuration...'
        });
        try {
            const response = await (0, $zs3Np.tradingApi).deleteIBGatewayConfig(savedConfig.id);
            if (response.success) {
                setConfigStatus({
                    type: 'success',
                    message: 'Configuration deleted.'
                });
                setUsername('');
                setPassword('');
                // If the deleted one was the current one, reset state to empty
                // Delay close/refresh
                setTimeout(()=>{
                    onSuccess();
                // Don't close immediately so user sees message
                }, 1000);
            } else setConfigStatus({
                type: 'error',
                message: response.error || 'Failed to delete configuration'
            });
        } catch (err) {
            setConfigStatus({
                type: 'error',
                message: err.message || 'An error occurred'
            });
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $eHRxX.jsx)((0, $g9vEp.default), {
        children: /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "fixed inset-0 z-1000 flex items-center justify-center bg-black/60 backdrop-blur-md p-4",
                    children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "bg-surface-3 border border-white/10 rounded-2xl w-full max-w-lg shadow-[0_0_50px_rgba(0,0,0,0.5)] overflow-hidden animate-in fade-in zoom-in duration-200",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "p-6 border-b border-white/10 flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: "p-2 rounded-lg bg-neon/10 text-neon",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $9Livr.default), {
                                                    className: "w-5 h-5"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                                        className: "text-lg font-bold text-white",
                                                        children: "Gateway Settings"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                        className: "text-xs text-muted",
                                                        children: username ? `Currently configured: ${username}` : 'Configure IB credentials'
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                        onClick: onClose,
                                        className: "text-muted hover:text-white transition",
                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                                            className: "w-5 h-5"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "p-6 space-y-6",
                                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("form", {
                                    onSubmit: handleSaveConfig,
                                    className: "space-y-6",
                                    autoComplete: "off",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("label", {
                                                    className: "block text-xs font-medium text-muted uppercase tracking-wider mb-2",
                                                    children: "Trading Mode"
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                    className: `grid ${isInvestor ? 'grid-cols-1' : 'grid-cols-2'} gap-4`,
                                                    children: [
                                                        !isInvestor && /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                            type: "button",
                                                            onClick: ()=>handleModeSwitch('paper'),
                                                            className: `p-3 rounded-xl border transition-all duration-200 flex items-center justify-center gap-2 text-sm font-medium ${mode === 'paper' ? 'bg-neon/10 border-neon text-neon shadow-[0_0_15px_rgba(34,197,94,0.1)]' : 'bg-black/20 border-white/5 text-muted hover:border-white/20 hover:bg-white/5'}`,
                                                            children: [
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $ehZ63.default), {
                                                                    className: "w-4 h-4"
                                                                }),
                                                                "Paper",
                                                                findSavedConfig('paper')?.is_active && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                    className: "ml-1 px-1.5 py-0.5 rounded-sm bg-emerald-500/20 text-emerald-400 text-[10px]",
                                                                    children: "ACTIVE"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                            type: "button",
                                                            onClick: ()=>handleModeSwitch('live'),
                                                            disabled: isInvestor,
                                                            className: `p-3 rounded-xl border transition-all duration-200 flex items-center justify-center gap-2 text-sm font-medium ${mode === 'live' ? 'bg-neon/10 border-neon text-neon shadow-[0_0_15px_rgba(34,197,94,0.1)]' : 'bg-black/20 border-white/5 text-muted hover:border-white/20 hover:bg-white/5'} ${isInvestor ? 'opacity-90 cursor-default' : ''}`,
                                                            children: [
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jr1gO.default), {
                                                                    className: "w-4 h-4"
                                                                }),
                                                                "Live Production",
                                                                findSavedConfig('live')?.is_active && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                    className: "ml-1 px-1.5 py-0.5 rounded-sm bg-emerald-500/20 text-emerald-400 text-[10px]",
                                                                    children: "ACTIVE"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("label", {
                                                    className: "block text-xs font-medium text-muted uppercase tracking-wider mb-2",
                                                    children: "TWS Username"
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                                    type: "text",
                                                    name: "tws-username",
                                                    id: "tws-username",
                                                    autoComplete: "off",
                                                    value: username,
                                                    onChange: (e)=>setUsername(e.target.value),
                                                    className: "w-full bg-black/40 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-white/20 focus:outline-hidden focus:border-neon focus:ring-1 focus:ring-neon/50 transition-all duration-200",
                                                    placeholder: "Enter IB username"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("label", {
                                                    className: "block text-xs font-medium text-muted uppercase tracking-wider mb-2",
                                                    children: "TWS Password"
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                                    type: "password",
                                                    name: "tws-password",
                                                    id: "tws-password",
                                                    autoComplete: "new-password",
                                                    value: password,
                                                    onChange: (e)=>setPassword(e.target.value),
                                                    className: "w-full bg-black/40 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-white/20 focus:outline-hidden focus:border-neon focus:ring-1 focus:ring-neon/50 transition-all duration-200",
                                                    placeholder: "Enter IB password"
                                                })
                                            ]
                                        }),
                                        configStatus && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                            className: `p-4 rounded-xl flex items-start gap-3 border ${configStatus.type === 'error' ? 'bg-red-500/5 border-red-500/20 text-red-400' : configStatus.type === 'success' ? 'bg-emerald-500/5 border-emerald-500/20 text-emerald-400' : 'bg-blue-500/5 border-blue-500/20 text-blue-400'}`,
                                            children: [
                                                configStatus.type === 'error' && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jr1gO.default), {
                                                    className: "w-5 h-5 shrink-0"
                                                }),
                                                configStatus.type === 'success' && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $5j4E8.default), {
                                                    className: "w-5 h-5 shrink-0"
                                                }),
                                                configStatus.type === 'info' && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                    className: "w-5 h-5 shrink-0 border-2 border-current border-t-transparent rounded-full animate-spin"
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                    className: "text-sm font-medium",
                                                    children: configStatus.message
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                            className: "pt-2 flex flex-col gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                                            type: "submit",
                                                            disabled: loading,
                                                            className: "flex-1 bg-blue-500/10 hover:bg-blue-500/20 text-blue-300 hover:text-blue-200 font-medium py-3.5 rounded-xl transition-all duration-200 border border-blue-500/20 hover:border-blue-500/40 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed",
                                                            children: loading ? 'Saving...' : /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $5j4E8.default), {
                                                                        className: "w-5 h-5"
                                                                    }),
                                                                    "Save"
                                                                ]
                                                            })
                                                        }),
                                                        savedConfig && !isActive && /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                            type: "button",
                                                            onClick: handleActivateClick,
                                                            disabled: loading,
                                                            className: "flex-1 bg-neon hover:bg-neon-hover text-black font-bold py-3.5 rounded-xl transition-all duration-200 shadow-lg shadow-neon/20 hover:shadow-neon/40 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transform hover:-translate-y-0.5 active:translate-y-0",
                                                            title: "Activate this gateway",
                                                            children: [
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $dL2Lt.default), {
                                                                    className: "w-5 h-5"
                                                                }),
                                                                "Activate"
                                                            ]
                                                        }),
                                                        savedConfig && /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                                            type: "button",
                                                            onClick: handleDeleteConfig,
                                                            disabled: loading,
                                                            title: "Delete configuration",
                                                            className: "w-14 bg-red-500/10 hover:bg-red-500/20 text-red-400 font-medium py-3.5 rounded-xl transition-all duration-200 border border-red-500/20 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed",
                                                            children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $k9hlW.default), {
                                                                className: "w-5 h-5"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                isActive && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                    className: "w-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 font-medium py-3.5 rounded-xl flex items-center justify-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $5j4E8.default), {
                                                            className: "w-5 h-5"
                                                        }),
                                                        "Currently Active"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $67Thx.default), {
                    isOpen: showWarning,
                    onClose: ()=>setShowWarning(false),
                    onConfirm: handleConfirmSwitch,
                    targetGatewayName: `${mode === 'live' ? 'Live' : 'Paper'} (${username})`,
                    isProcessing: activating
                })
            ]
        })
    });
};
var $eaa990055fa75a6e$export$2e2bcd8739ae039 = $eaa990055fa75a6e$var$GatewayConfigModal;

});
parcelRegister("jr1gO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d138de783c697906$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $d138de783c697906$export$a2387ed3b5d536eb = {
    name: "triangle-exclamation-point",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
                key: "wmoenq"
            }
        ],
        [
            "path",
            {
                d: "M12 9v4",
                key: "juzpu7"
            }
        ],
        [
            "path",
            {
                d: "M12 17h.01",
                key: "p32p05"
            }
        ]
    ],
    aliases: [
        "alert-triangle",
        "triangle-alert"
    ]
};
$d138de783c697906$export$a2387ed3b5d536eb.node;
const $d138de783c697906$export$2e2bcd8739ae039 = (0, $hHhnY.default)($d138de783c697906$export$a2387ed3b5d536eb);

});

parcelRegister("9Livr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a2057e568abf1e2$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $1a2057e568abf1e2$export$a2387ed3b5d536eb = {
    name: "server",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "20",
                height: "8",
                x: "2",
                y: "2",
                rx: "2",
                ry: "2",
                key: "ngkwjq"
            }
        ],
        [
            "rect",
            {
                width: "20",
                height: "8",
                x: "2",
                y: "14",
                rx: "2",
                ry: "2",
                key: "iecqi9"
            }
        ],
        [
            "line",
            {
                x1: "6",
                x2: "6.01",
                y1: "6",
                y2: "6",
                key: "16zg32"
            }
        ],
        [
            "line",
            {
                x1: "6",
                x2: "6.01",
                y1: "18",
                y2: "18",
                key: "nzw8ys"
            }
        ]
    ]
};
$1a2057e568abf1e2$export$a2387ed3b5d536eb.node;
const $1a2057e568abf1e2$export$2e2bcd8739ae039 = (0, $hHhnY.default)($1a2057e568abf1e2$export$a2387ed3b5d536eb);

});

parcelRegister("k9hlW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6758f95d078b7b1$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $a6758f95d078b7b1$export$a2387ed3b5d536eb = {
    name: "trash",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10 11v6",
                key: "nco0om"
            }
        ],
        [
            "path",
            {
                d: "M14 11v6",
                key: "outv1u"
            }
        ],
        [
            "path",
            {
                d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6",
                key: "miytrc"
            }
        ],
        [
            "path",
            {
                d: "M3 6h18",
                key: "d0wm0j"
            }
        ],
        [
            "path",
            {
                d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
                key: "e791ji"
            }
        ]
    ],
    aliases: [
        "trash-2"
    ]
};
$a6758f95d078b7b1$export$a2387ed3b5d536eb.node;
const $a6758f95d078b7b1$export$2e2bcd8739ae039 = (0, $hHhnY.default)($a6758f95d078b7b1$export$a2387ed3b5d536eb);

});

parcelRegister("67Thx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd0fc2622fec06b9$export$2e2bcd8739ae039; });

var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");

var $jr1gO = parcelRequire("jr1gO");
var $bgvjD = parcelRequire("bgvjD");

var $g9vEp = parcelRequire("g9vEp");
const $fd0fc2622fec06b9$var$GatewaySwitchWarningModal = ({ isOpen: isOpen, onClose: onClose, onConfirm: onConfirm, targetGatewayName: targetGatewayName, isProcessing: isProcessing })=>{
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $eHRxX.jsx)((0, $g9vEp.default), {
        children: /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
            className: "fixed inset-0 z-1100 flex items-center justify-center bg-black/60 backdrop-blur-xs p-4 animate-in fade-in duration-200",
            onClick: (e)=>{
                if (e.target === e.currentTarget && !isProcessing) onClose();
            },
            children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "bg-[#0e0e10] border border-red-500/30 rounded-2xl w-full max-w-md shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "p-6 border-b border-white/10 flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: "p-2 rounded-lg bg-red-500/10 text-red-500",
                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jr1gO.default), {
                                            className: "w-6 h-6"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                        className: "text-lg font-bold text-white",
                                        children: "Switch Account?"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                onClick: onClose,
                                disabled: isProcessing,
                                className: "text-muted hover:text-white transition disabled:opacity-50",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                                    className: "w-5 h-5"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "p-6 space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("p", {
                                className: "text-gray-300",
                                children: [
                                    "You are about to switch the active gateway to ",
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: "font-bold text-white",
                                        children: targetGatewayName
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "bg-red-500/10 border border-red-500/20 rounded-xl p-4",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                    className: "text-sm text-red-200 font-medium",
                                    children: "\u26A0\uFE0F Warning: This will deactivate and stop your current account's gateway. Any active trading sessions will be disconnected."
                                })
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                className: "text-sm text-muted",
                                children: "Are you sure you want to proceed?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "p-6 pt-2 flex gap-3",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                onClick: onClose,
                                disabled: isProcessing,
                                className: "flex-1 px-4 py-3 rounded-xl border border-white/10 text-white hover:bg-white/5 transition font-medium disabled:opacity-50",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                onClick: onConfirm,
                                disabled: isProcessing,
                                className: "flex-1 px-4 py-3 rounded-xl bg-red-500 hover:bg-red-600 text-white font-bold transition shadow-lg shadow-red-500/20 disabled:opacity-50 flex items-center justify-center gap-2",
                                children: isProcessing ? 'Switching...' : 'Yes, Switch Account'
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $fd0fc2622fec06b9$export$2e2bcd8739ae039 = $fd0fc2622fec06b9$var$GatewaySwitchWarningModal;

});
parcelRegister("g9vEp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e299af4799c0cc6$export$2e2bcd8739ae039; });
parcelRequire("jHEir");

var $faOpr = parcelRequire("faOpr");
const $9e299af4799c0cc6$export$abd440bc95a4ebb0 = 'modal-root';
/** Mount every application overlay outside local panel stacking/overflow contexts. */ const $9e299af4799c0cc6$var$ModalPortal = ({ children: children })=>{
    if (typeof document === 'undefined') return null;
    const target = document.getElementById($9e299af4799c0cc6$export$abd440bc95a4ebb0) || document.body;
    return /*#__PURE__*/ (0, $faOpr.createPortal)(children, target);
};
var $9e299af4799c0cc6$export$2e2bcd8739ae039 = $9e299af4799c0cc6$var$ModalPortal;

});



parcelRegister("m1iA2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b76bd93d4ad3c865$export$2e2bcd8739ae039; });

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $bgvjD = parcelRequire("bgvjD");

var $g9vEp = parcelRequire("g9vEp");
const $b76bd93d4ad3c865$var$Modal = ({ isOpen: isOpen, onClose: onClose, title: title, children: children, width: width = 'max-w-2xl', flush: flush = false })=>{
    const modalRef = (0, $jHEir.useRef)(null);
    (0, $jHEir.useEffect)(()=>{
        const handleEscape = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
            const previousOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            return ()=>{
                document.removeEventListener('keydown', handleEscape);
                document.body.style.overflow = previousOverflow;
            };
        }
        return ()=>{
            document.removeEventListener('keydown', handleEscape);
        };
    }, [
        isOpen,
        onClose
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $eHRxX.jsx)((0, $g9vEp.default), {
        children: /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
            className: "fixed inset-0 z-1000 flex items-center justify-center p-0 bg-black/60 backdrop-blur-xs sm:p-4",
            onClick: (event)=>{
                if (event.target === event.currentTarget) onClose();
            },
            children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                ref: modalRef,
                className: `max-h-dvh w-full ${width} bg-surface border-0 rounded-none shadow-2xl flex flex-col sm:h-auto sm:max-h-[90vh] sm:rounded-2xl sm:border sm:border-white/10`,
                onClick: (e)=>e.stopPropagation(),
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center justify-between border-b border-white/5 p-3 sm:p-4",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                className: "text-lg font-bold text-white",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                onClick: onClose,
                                className: "p-1 text-muted hover:text-white hover:bg-white/10 rounded-lg transition-colors",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                                    className: "w-5 h-5"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: `flex-1 overflow-y-auto scrollbar-thin ${flush ? 'p-0' : 'p-2 sm:p-4'}`,
                        children: children
                    })
                ]
            })
        })
    });
};
var $b76bd93d4ad3c865$export$2e2bcd8739ae039 = $b76bd93d4ad3c865$var$Modal;

});

parcelRegister("ctgHU", function(module, exports) {

$parcel$export(module.exports, "useGlobalError", function () { return $c0bd61f288c184dc$export$a2920187e96944a8; });
$parcel$export(module.exports, "GlobalErrorProvider", function () { return $c0bd61f288c184dc$export$42c73b50392fca82; });

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $jr1gO = parcelRequire("jr1gO");
var $bgvjD = parcelRequire("bgvjD");
const $c0bd61f288c184dc$var$GlobalErrorContext = /*#__PURE__*/ (0, $jHEir.createContext)(null);
const $c0bd61f288c184dc$export$a2920187e96944a8 = ()=>(0, $jHEir.useContext)($c0bd61f288c184dc$var$GlobalErrorContext);
const $c0bd61f288c184dc$var$GlobalErrorToast = ({ notice: notice, onDismiss: onDismiss })=>{
    if (!notice) return null;
    return /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
        className: "pointer-events-none fixed inset-x-3 top-20 z-1200 flex justify-center lg:inset-x-6 lg:top-24",
        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
            className: "pointer-events-auto flex w-full max-w-2xl items-start gap-3 border border-rose-400/35 bg-surface px-4 py-3 text-foreground shadow-2xl",
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-rose-500/15 text-rose-300",
                    children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jr1gO.default), {
                        className: "h-4 w-4"
                    })
                }),
                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "min-w-0 flex-1",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                            className: "text-xs font-bold uppercase tracking-[0.14em] text-rose-200",
                            children: notice.title
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                            className: "mt-1 wrap-break-word text-xs text-rose-100/80",
                            children: notice.error
                        }),
                        notice.onRetry && /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                            type: "button",
                            onClick: notice.onRetry,
                            className: "mt-2 inline-flex items-center rounded-lg border border-rose-300/40 bg-rose-500/10 px-3 py-1.5 text-[10px] font-bold uppercase tracking-wider text-rose-100 transition-colors hover:bg-rose-500/20",
                            children: "Try again"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                    type: "button",
                    onClick: onDismiss,
                    className: "shrink-0 rounded-lg p-1 text-rose-200/60 transition-colors hover:bg-rose-500/10 hover:text-rose-100",
                    "aria-label": "Dismiss error",
                    title: "Dismiss error",
                    children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                        className: "h-4 w-4"
                    })
                })
            ]
        })
    });
};
const $c0bd61f288c184dc$export$42c73b50392fca82 = ({ children: children })=>{
    const [notice, setNotice] = (0, $jHEir.useState)(null);
    (0, $jHEir.useEffect)(()=>{
        if (!notice) return;
        const timer = window.setTimeout(()=>{
            setNotice(null);
        }, 8000);
        return ()=>window.clearTimeout(timer);
    }, [
        notice
    ]);
    const publishError = (0, $jHEir.useCallback)((nextNotice)=>{
        setNotice((current)=>{
            if (current && current.id === nextNotice.id && current.title === nextNotice.title && current.error === nextNotice.error) return current;
            return nextNotice;
        });
    }, []);
    const clearError = (0, $jHEir.useCallback)((id)=>{
        setNotice((current)=>current?.id === id ? null : current);
    }, []);
    const value = (0, $jHEir.useMemo)(()=>({
            publishError: publishError,
            clearError: clearError
        }), [
        clearError,
        publishError
    ]);
    return /*#__PURE__*/ (0, $eHRxX.jsxs)($c0bd61f288c184dc$var$GlobalErrorContext.Provider, {
        value: value,
        children: [
            children,
            /*#__PURE__*/ (0, $eHRxX.jsx)($c0bd61f288c184dc$var$GlobalErrorToast, {
                notice: notice,
                onDismiss: ()=>setNotice(null)
            })
        ]
    });
};

});

parcelRegister("1BBEF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf71c7a44028f402$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $bf71c7a44028f402$export$a2387ed3b5d536eb = {
    name: "dollar-sign",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 3v18",
                key: "108xh3"
            }
        ],
        [
            "path",
            {
                d: "M17 5H9.5a1 1 0 000 7h5a1 1 0 010 7H6",
                key: "pwzcbw"
            }
        ]
    ]
};
$bf71c7a44028f402$export$a2387ed3b5d536eb.node;
const $bf71c7a44028f402$export$2e2bcd8739ae039 = (0, $hHhnY.default)($bf71c7a44028f402$export$a2387ed3b5d536eb);

});

parcelRegister("kdxJz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $750e5868ab308831$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $750e5868ab308831$export$a2387ed3b5d536eb = {
    name: "eye",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
                key: "1nclc0"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "3",
                key: "1v7zrd"
            }
        ]
    ]
};
$750e5868ab308831$export$a2387ed3b5d536eb.node;
const $750e5868ab308831$export$2e2bcd8739ae039 = (0, $hHhnY.default)($750e5868ab308831$export$a2387ed3b5d536eb);

});

parcelRegister("lY8C7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $904c6e0be7593ce1$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $904c6e0be7593ce1$export$a2387ed3b5d536eb = {
    name: "eye-off",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
                key: "ct8e1f"
            }
        ],
        [
            "path",
            {
                d: "M14.084 14.158a3 3 0 0 1-4.242-4.242",
                key: "151rxh"
            }
        ],
        [
            "path",
            {
                d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
                key: "13bj9a"
            }
        ],
        [
            "path",
            {
                d: "m2 2 20 20",
                key: "1ooewy"
            }
        ]
    ]
};
$904c6e0be7593ce1$export$a2387ed3b5d536eb.node;
const $904c6e0be7593ce1$export$2e2bcd8739ae039 = (0, $hHhnY.default)($904c6e0be7593ce1$export$a2387ed3b5d536eb);

});

parcelRegister("cKEgK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fe16b758305882b$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $3fe16b758305882b$export$a2387ed3b5d536eb = {
    name: "gauge",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m12 14 4-4",
                key: "9kzdfg"
            }
        ],
        [
            "path",
            {
                d: "M3.34 19a10 10 0 1 1 17.32 0",
                key: "19p75a"
            }
        ]
    ]
};
$3fe16b758305882b$export$a2387ed3b5d536eb.node;
const $3fe16b758305882b$export$2e2bcd8739ae039 = (0, $hHhnY.default)($3fe16b758305882b$export$a2387ed3b5d536eb);

});

parcelRegister("l8E6a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bd3c12ca432bdaf$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $2bd3c12ca432bdaf$export$a2387ed3b5d536eb = {
    name: "circle-question-mark",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
                key: "1u773s"
            }
        ],
        [
            "path",
            {
                d: "M12 17h.01",
                key: "p32p05"
            }
        ]
    ],
    aliases: [
        "help-circle",
        "circle-help"
    ]
};
$2bd3c12ca432bdaf$export$a2387ed3b5d536eb.node;
const $2bd3c12ca432bdaf$export$2e2bcd8739ae039 = (0, $hHhnY.default)($2bd3c12ca432bdaf$export$a2387ed3b5d536eb);

});

parcelRegister("2rkXu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e9b3fc899a19fcf$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $0e9b3fc899a19fcf$export$a2387ed3b5d536eb = {
    name: "trending-down",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 17h6v-6",
                key: "t6n2it"
            }
        ],
        [
            "path",
            {
                d: "m22 17-8.5-8.5-5 5L2 7",
                key: "x473p"
            }
        ]
    ]
};
$0e9b3fc899a19fcf$export$a2387ed3b5d536eb.node;
const $0e9b3fc899a19fcf$export$2e2bcd8739ae039 = (0, $hHhnY.default)($0e9b3fc899a19fcf$export$a2387ed3b5d536eb);

});

parcelRegister("dNdHx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e348369d6c30496$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $5e348369d6c30496$export$a2387ed3b5d536eb = {
    name: "wallet",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
                key: "18etb6"
            }
        ],
        [
            "path",
            {
                d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4",
                key: "xoc0q4"
            }
        ]
    ]
};
$5e348369d6c30496$export$a2387ed3b5d536eb.node;
const $5e348369d6c30496$export$2e2bcd8739ae039 = (0, $hHhnY.default)($5e348369d6c30496$export$a2387ed3b5d536eb);

});

parcelRegister("4cvdp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $828de33583874f72$export$2e2bcd8739ae039; });

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $ctgHU = parcelRequire("ctgHU");
const $828de33583874f72$var$ErrorDisplay = ({ error: error, onRetry: onRetry, message: message = 'Failed to load data' })=>{
    const globalError = (0, $ctgHU.useGlobalError)();
    const noticeId = (0, $jHEir.useId)();
    const retryRef = (0, $jHEir.useRef)(onRetry);
    retryRef.current = onRetry;
    (0, $jHEir.useEffect)(()=>{
        if (!globalError) return;
        if (!error) {
            globalError.clearError(noticeId);
            return ()=>globalError.clearError(noticeId);
        }
        // Suppress publishing error toast while document is hidden (user switched away on mobile)
        if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
        // Delay publishing error toast by 1500ms to allow foreground refetches to settle silently
        const publishTimer = window.setTimeout(()=>{
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            globalError.publishError({
                id: noticeId,
                title: message,
                error: error,
                onRetry: onRetry ? ()=>retryRef.current?.() : undefined
            });
        }, 1500);
        return ()=>{
            window.clearTimeout(publishTimer);
            globalError.clearError(noticeId);
        };
    }, [
        error,
        globalError,
        message,
        noticeId,
        onRetry
    ]);
    (0, $jHEir.useEffect)(()=>{
        // When returning to foreground with an active error, trigger retry automatically
        const handleVisible = ()=>{
            if (typeof document !== 'undefined' && document.visibilityState === 'visible' && error) retryRef.current?.();
        };
        document.addEventListener('visibilitychange', handleVisible);
        window.addEventListener('focus', handleVisible);
        return ()=>{
            document.removeEventListener('visibilitychange', handleVisible);
            window.removeEventListener('focus', handleVisible);
        };
    }, [
        error
    ]);
    if (!error) return null;
    if (globalError) return null;
    return /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
        className: "rounded-xl border border-rose-500/40 bg-rose-500/10 text-foreground px-3 py-2 sm:px-4 sm:py-3",
        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
            className: "flex items-start gap-3",
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "flex items-center justify-center h-7 w-7 rounded-full bg-rose-500/40 text-xs font-bold text-rose-50",
                    children: "!"
                }),
                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex-1 space-y-1",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                            className: "text-xs sm:text-sm font-semibold text-rose-100 uppercase tracking-[0.14em]",
                            children: message
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                            className: "text-[11px] sm:text-xs text-rose-100/80 wrap-break-word",
                            children: error
                        }),
                        onRetry && /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                            onClick: onRetry,
                            className: "mt-2 inline-flex items-center px-3 py-1.5 rounded-lg border border-rose-300/60 bg-rose-500/20 text-[11px] font-semibold uppercase tracking-[0.12em] text-rose-50 hover:bg-rose-500/30 disabled:opacity-50",
                            children: "Try Again"
                        })
                    ]
                })
            ]
        })
    });
};
var $828de33583874f72$export$2e2bcd8739ae039 = $828de33583874f72$var$ErrorDisplay;

});

parcelRegister("fvREG", function(module, exports) {

$parcel$export(module.exports, "DataTable", function () { return $469162e01158ce03$export$df30df7ec97b32b5; });

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $4VK7x = parcelRequire("4VK7x");
var $f65FB = parcelRequire("f65FB");
var $jpEa8 = parcelRequire("jpEa8");
var $l8E6a = parcelRequire("l8E6a");
parcelRequire("62Hcf");
var $5HFtN = parcelRequire("5HFtN");
function $469162e01158ce03$export$df30df7ec97b32b5({ data: data, columns: columns, className: className = '', loading: loading = false, emptyMessage: emptyMessage = 'No data available', onRowClick: onRowClick, rowClassName: rowClassName, initialSort: initialSort, compact: compact = false, getRowKey: getRowKey, expandedRowKey: expandedRowKey = null, renderExpandedRow: renderExpandedRow }) {
    const [sortConfig, setSortConfig] = (0, $jHEir.useState)(initialSort || null);
    const handleSort = (columnId)=>{
        setSortConfig((prev)=>{
            if (prev?.id === columnId) {
                if (prev.direction === 'asc') return {
                    id: columnId,
                    direction: 'desc'
                };
                return null; // Reset sort
            }
            return {
                id: columnId,
                direction: 'asc'
            };
        });
    };
    const sortedData = (0, $jHEir.useMemo)(()=>{
        const safeData = data || [];
        if (!sortConfig) return safeData;
        const column = columns.find((c)=>c.id === sortConfig.id);
        if (!column) return safeData;
        return [
            ...safeData
        ].sort((a, b)=>{
            const aValue = typeof column.accessor === 'function' ? column.accessor(a) : a[column.accessor];
            const bValue = typeof column.accessor === 'function' ? column.accessor(b) : b[column.accessor];
            if (aValue === bValue) return 0;
            if (aValue === null || aValue === undefined) return 1;
            if (bValue === null || bValue === undefined) return -1;
            const order = sortConfig.direction === 'asc' ? 1 : -1;
            if (typeof aValue === 'string' && typeof bValue === 'string') return aValue.localeCompare(bValue) * order;
            return (aValue < bValue ? -1 : 1) * order;
        });
    }, [
        data,
        sortConfig,
        columns
    ]);
    return /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
        className: `overflow-x-auto scrollbar-thin rounded-xl border border-white/10 bg-white/5 backdrop-blur-xl ${className}`,
        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("table", {
            className: `${(0, $5HFtN.themeTableClasses).table} divide-y divide-white/10 ${compact ? 'text-[11px]' : (0, $5HFtN.themeTableClasses).bodyText}`,
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsx)("thead", {
                    className: (0, $5HFtN.themeTableClasses).head,
                    children: /*#__PURE__*/ (0, $eHRxX.jsx)("tr", {
                        children: columns.map((column)=>/*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                scope: "col",
                                className: `${(0, $5HFtN.themeTableClasses).headerCell} ${compact ? 'px-2.5 py-2 text-[10px]' : ''} ${column.align === 'right' ? 'text-right' : column.align === 'center' ? 'text-center' : 'text-left'} ${column.headerClassName || ''} ${column.sortable ? 'cursor-pointer select-none hover:text-white hover:bg-white/5 transition-colors' : ''}`,
                                onClick: ()=>column.sortable && handleSort(column.id),
                                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                    className: `flex items-center gap-1.5 ${column.align === 'right' ? 'justify-end' : column.align === 'center' ? 'justify-center' : 'justify-start'}`,
                                    children: [
                                        column.header,
                                        column.headerInfo && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            className: "inline-flex shrink-0 text-white/35",
                                            title: column.headerInfo,
                                            "aria-label": `${column.header}: ${column.headerInfo}`,
                                            children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $l8E6a.default), {
                                                className: "h-3.5 w-3.5"
                                            })
                                        }),
                                        column.sortable && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                            className: "text-white/40 group-hover:text-white transition-colors",
                                            children: sortConfig?.id === column.id ? sortConfig.direction === 'asc' ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $f65FB.default), {
                                                className: "w-3.5 h-3.5 text-neon"
                                            }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4VK7x.default), {
                                                className: "w-3.5 h-3.5 text-neon"
                                            }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jpEa8.default), {
                                                className: "w-3.5 h-3.5 opacity-30"
                                            })
                                        })
                                    ]
                                })
                            }, column.id))
                    })
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)("tbody", {
                    className: `${(0, $5HFtN.themeTableClasses).body} bg-transparent`,
                    children: sortedData.length === 0 && !loading ? /*#__PURE__*/ (0, $eHRxX.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                            colSpan: columns.length,
                            className: `${(0, $5HFtN.themeTableClasses).cell} py-8 text-center text-muted`,
                            children: emptyMessage
                        })
                    }) : sortedData.length === 0 && loading ? /*#__PURE__*/ (0, $eHRxX.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                            colSpan: columns.length,
                            className: `${(0, $5HFtN.themeTableClasses).cell} py-12 text-center text-muted`,
                            children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex flex-col items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: "w-6 h-6 border-2 border-neon/30 border-t-neon rounded-full animate-spin"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        children: "Loading data..."
                                    })
                                ]
                            })
                        })
                    }) : sortedData.map((item, index)=>{
                        const customClassName = typeof rowClassName === 'function' ? rowClassName(item) : rowClassName;
                        const rowKey = getRowKey ? getRowKey(item, index) : index;
                        const isExpanded = expandedRowKey !== null && expandedRowKey !== undefined && getRowKey && rowKey === expandedRowKey;
                        return /*#__PURE__*/ (0, $eHRxX.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("tr", {
                                    onClick: ()=>onRowClick?.(item),
                                    className: `${(0, $5HFtN.themeTableClasses).row} ${onRowClick ? 'cursor-pointer' : ''} ${customClassName || ''}`,
                                    children: columns.map((column)=>/*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                            className: `${(0, $5HFtN.themeTableClasses).cell} ${compact ? 'px-2.5 py-2' : ''} whitespace-nowrap ${column.align === 'right' ? 'text-right' : column.align === 'center' ? 'text-center' : 'text-left'} ${column.className || ''}`,
                                            children: column.render ? column.render(item) : typeof column.accessor === 'function' ? column.accessor(item) : item[column.accessor]
                                        }, column.id))
                                }),
                                isExpanded && renderExpandedRow && /*#__PURE__*/ (0, $eHRxX.jsx)("tr", {
                                    className: "bg-black/20",
                                    children: /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                        colSpan: columns.length,
                                        className: "p-0",
                                        children: renderExpandedRow(item)
                                    })
                                })
                            ]
                        }, rowKey);
                    })
                })
            ]
        })
    });
}

});
parcelRegister("4VK7x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a6991056e1a89d9$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $7a6991056e1a89d9$export$a2387ed3b5d536eb = {
    name: "arrow-down",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 5v14",
                key: "s699le"
            }
        ],
        [
            "path",
            {
                d: "m19 12-7 7-7-7",
                key: "1idqje"
            }
        ]
    ]
};
$7a6991056e1a89d9$export$a2387ed3b5d536eb.node;
const $7a6991056e1a89d9$export$2e2bcd8739ae039 = (0, $hHhnY.default)($7a6991056e1a89d9$export$a2387ed3b5d536eb);

});

parcelRegister("f65FB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8904f476ccb66d22$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $8904f476ccb66d22$export$a2387ed3b5d536eb = {
    name: "arrow-up",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m5 12 7-7 7 7",
                key: "hav0vg"
            }
        ],
        [
            "path",
            {
                d: "M12 19V5",
                key: "x0mq9r"
            }
        ]
    ]
};
$8904f476ccb66d22$export$a2387ed3b5d536eb.node;
const $8904f476ccb66d22$export$2e2bcd8739ae039 = (0, $hHhnY.default)($8904f476ccb66d22$export$a2387ed3b5d536eb);

});

parcelRegister("jpEa8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d86902c240633749$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $d86902c240633749$export$a2387ed3b5d536eb = {
    name: "arrow-up-down",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m21 16-4 4-4-4",
                key: "f6ql7i"
            }
        ],
        [
            "path",
            {
                d: "M17 20V4",
                key: "1ejh1v"
            }
        ],
        [
            "path",
            {
                d: "m3 8 4-4 4 4",
                key: "11wl7u"
            }
        ],
        [
            "path",
            {
                d: "M7 4v16",
                key: "1glfcx"
            }
        ]
    ]
};
$d86902c240633749$export$a2387ed3b5d536eb.node;
const $d86902c240633749$export$2e2bcd8739ae039 = (0, $hHhnY.default)($d86902c240633749$export$a2387ed3b5d536eb);

});


parcelRegister("5xHjn", function(module, exports) {

$parcel$export(module.exports, "isValidHistoricalBar", function () { return $74f3c8883770b541$export$81b35256266466bf; });
const $74f3c8883770b541$export$81b35256266466bf = (bar)=>Number.isFinite(bar.time) && [
        bar.open,
        bar.high,
        bar.low,
        bar.close
    ].every((value)=>typeof value === 'number' && Number.isFinite(value));

});

parcelRegister("hQpqX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91ff906ae635b206$export$2e2bcd8739ae039; });

var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");

var $62Hcf = parcelRequire("62Hcf");
const $91ff906ae635b206$var$ChartToolbarButton = ({ label: label, icon: icon, children: children, onClick: onClick, selected: selected, disabled: disabled = false, size: size = 'default', segment: segment, iconOnly: iconOnly = false, title: title })=>/*#__PURE__*/ (0, $eHRxX.jsx)((0, $62Hcf.ThemeToggleButton), {
        label: label,
        icon: icon,
        iconOnly: iconOnly,
        selected: selected,
        size: size === 'compact' ? 'xs' : 'sm',
        segment: segment,
        onClick: onClick,
        disabled: disabled,
        title: title ?? label,
        children: children
    });
var $91ff906ae635b206$export$2e2bcd8739ae039 = $91ff906ae635b206$var$ChartToolbarButton;

});

parcelRegister("kv9Z9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a75aa72509a8fc4$export$2e2bcd8739ae039; });

var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");

var $gUah6 = parcelRequire("gUah6");
const $0a75aa72509a8fc4$var$ChartFrame = ({ toolbar: toolbar, children: children, className: className = '' })=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: `${(0, $gUah6.chartFrameClassName)} ${className}`,
        children: [
            toolbar,
            children
        ]
    });
var $0a75aa72509a8fc4$export$2e2bcd8739ae039 = $0a75aa72509a8fc4$var$ChartFrame;

});
parcelRegister("gUah6", function(module, exports) {

$parcel$export(module.exports, "chartToolbarClasses", function () { return $4d4584a16f7ef762$export$aa13135b8a287cbc; });
$parcel$export(module.exports, "chartFrameClassName", function () { return $4d4584a16f7ef762$export$670e23bc85f9492b; });
$parcel$export(module.exports, "chartToolbarSelectClasses", function () { return $4d4584a16f7ef762$export$c52a412185d085a1; });
$parcel$export(module.exports, "getChartStyleToggleSegments", function () { return $4d4584a16f7ef762$export$10db452810616201; });
$parcel$export(module.exports, "getChartToolbarSelectRootClassName", function () { return $4d4584a16f7ef762$export$b597d26eaa9b671c; });
const $4d4584a16f7ef762$export$aa13135b8a287cbc = {
    viewport: 'max-w-full overflow-x-auto border-b border-white/10 bg-black/10',
    row: 'flex w-full min-w-max items-center gap-2 px-3 py-1.5',
    leading: 'flex shrink-0 items-center gap-2 border-r border-white/10 pr-2',
    legend: 'flex shrink-0 items-center gap-2',
    controls: 'flex shrink-0 items-center gap-1',
    actions: 'ml-auto flex shrink-0 items-center gap-1',
    settings: 'ml-0.5 flex shrink-0 items-center gap-1.5 border-l border-white/10 pl-1.5',
    trailing: 'ml-0.5 flex shrink-0 items-center gap-1 border-l border-white/10 pl-1.5'
};
const $4d4584a16f7ef762$export$670e23bc85f9492b = 'flex min-h-0 min-w-0 flex-col overflow-hidden bg-[#0e0e12]';
const $4d4584a16f7ef762$export$c52a412185d085a1 = {
    button: 'w-full rounded-md text-[9px]',
    menu: 'rounded-xl border-t border-white/10'
};
function $4d4584a16f7ef762$export$10db452810616201(showLine) {
    return {
        candles: showLine ? 'first' : undefined,
        line: showLine ? 'last' : undefined
    };
}
function $4d4584a16f7ef762$export$b597d26eaa9b671c(widthClassName) {
    return `shrink-0 ${widthClassName}`;
}

});


parcelRegister("8YuD2", function(module, exports) {

$parcel$export(module.exports, "ChartToolbar", function () { return $bc6632561df04f88$export$fab13f9ae35bb0e2; });
$parcel$export(module.exports, "ChartStyleToggle", function () { return $bc6632561df04f88$export$35d7261eace0eb60; });
$parcel$export(module.exports, "ChartToolbarSelect", function () { return $bc6632561df04f88$export$6fc3c4894fe9e43f; });
$parcel$export(module.exports, "ChartToolbarValue", function () { return $bc6632561df04f88$export$2446f6397594252e; });

var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");

var $lvF9l = parcelRequire("lvF9l");
var $hBsCb = parcelRequire("hBsCb");
parcelRequire("2Mt3i");
var $4YGkM = parcelRequire("4YGkM");

var $62Hcf = parcelRequire("62Hcf");

var $hQpqX = parcelRequire("hQpqX");

var $gUah6 = parcelRequire("gUah6");
const $bc6632561df04f88$export$fab13f9ae35bb0e2 = ({ leading: leading, legend: legend, chartStyle: chartStyle, actions: actions, settings: settings, trailing: trailing, className: className = '' })=>/*#__PURE__*/ (0, $eHRxX.jsx)("div", {
        className: `${(0, $gUah6.chartToolbarClasses).viewport} ${className}`,
        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
            className: (0, $gUah6.chartToolbarClasses).row,
            children: [
                leading && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: (0, $gUah6.chartToolbarClasses).leading,
                    children: leading
                }),
                legend && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    "aria-label": "Chart legend",
                    role: "group",
                    className: (0, $gUah6.chartToolbarClasses).legend,
                    children: legend
                }),
                (chartStyle || settings || trailing) && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    role: "group",
                    "aria-label": "Chart selectors",
                    className: (0, $gUah6.chartToolbarClasses).controls,
                    children: [
                        chartStyle,
                        settings && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                            className: (0, $gUah6.chartToolbarClasses).settings,
                            children: settings
                        }),
                        trailing && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                            className: (0, $gUah6.chartToolbarClasses).trailing,
                            children: trailing
                        })
                    ]
                }),
                actions && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    role: "group",
                    "aria-label": "Chart actions",
                    className: (0, $gUah6.chartToolbarClasses).actions,
                    children: actions
                })
            ]
        })
    });
const $bc6632561df04f88$export$35d7261eace0eb60 = ({ value: value, onChange: onChange, showLine: showLine = true })=>{
    const segments = (0, $gUah6.getChartStyleToggleSegments)(showLine);
    return /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $62Hcf.ThemeToggleGroup), {
        "aria-label": "Chart style",
        className: "shrink-0 gap-px",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $hQpqX.default), {
                size: "compact",
                iconOnly: true,
                segment: segments.candles,
                label: "Candlestick chart",
                icon: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lvF9l.default), {
                    className: "h-3.5 w-3.5"
                }),
                selected: value === 'candles',
                onClick: ()=>onChange('candles')
            }),
            showLine && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $hQpqX.default), {
                size: "compact",
                iconOnly: true,
                segment: segments.line,
                label: "Line chart",
                icon: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $hBsCb.default), {
                    className: "h-3.5 w-3.5"
                }),
                selected: value === 'line',
                onClick: ()=>onChange('line')
            })
        ]
    });
};
const $bc6632561df04f88$export$6fc3c4894fe9e43f = ({ value: value, options: options, onChange: onChange, ariaLabel: ariaLabel, title: title, widthClassName: widthClassName })=>/*#__PURE__*/ (0, $eHRxX.jsx)((0, $4YGkM.CustomSelect), {
        value: value,
        options: options,
        onChange: onChange,
        ariaLabel: ariaLabel,
        triggerTitle: title,
        controlSize: "xs",
        className: (0, $gUah6.getChartToolbarSelectRootClassName)(widthClassName),
        buttonClassName: (0, $gUah6.chartToolbarSelectClasses).button,
        menuClassName: (0, $gUah6.chartToolbarSelectClasses).menu
    });
const $bc6632561df04f88$export$2446f6397594252e = ({ children: children })=>/*#__PURE__*/ (0, $eHRxX.jsx)("span", {
        className: "shrink-0 rounded-md border border-white/10 bg-white/5 px-1.5 py-1 text-[9px] font-black uppercase tracking-wider text-neon",
        children: children
    });

});
parcelRegister("lvF9l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c2915e13bf9477e$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $0c2915e13bf9477e$export$a2387ed3b5d536eb = {
    name: "chart-candlestick",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M9 5v4",
                key: "14uxtq"
            }
        ],
        [
            "rect",
            {
                width: "4",
                height: "6",
                x: "7",
                y: "9",
                rx: "1",
                key: "f4fvz0"
            }
        ],
        [
            "path",
            {
                d: "M9 15v2",
                key: "r5rk32"
            }
        ],
        [
            "path",
            {
                d: "M17 3v2",
                key: "1l2re6"
            }
        ],
        [
            "rect",
            {
                width: "4",
                height: "8",
                x: "15",
                y: "5",
                rx: "1",
                key: "z38je5"
            }
        ],
        [
            "path",
            {
                d: "M17 13v3",
                key: "5l0wba"
            }
        ],
        [
            "path",
            {
                d: "M3 3v16a2 2 0 0 0 2 2h16",
                key: "c24i48"
            }
        ]
    ],
    aliases: [
        "candlestick-chart"
    ]
};
$0c2915e13bf9477e$export$a2387ed3b5d536eb.node;
const $0c2915e13bf9477e$export$2e2bcd8739ae039 = (0, $hHhnY.default)($0c2915e13bf9477e$export$a2387ed3b5d536eb);

});

parcelRegister("hBsCb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b57cb28ef913da8$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $9b57cb28ef913da8$export$a2387ed3b5d536eb = {
    name: "chart-line",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 3v16a2 2 0 0 0 2 2h16",
                key: "c24i48"
            }
        ],
        [
            "path",
            {
                d: "m19 9-5 5-4-4-3 3",
                key: "2osh9i"
            }
        ]
    ],
    aliases: [
        "line-chart"
    ]
};
$9b57cb28ef913da8$export$a2387ed3b5d536eb.node;
const $9b57cb28ef913da8$export$2e2bcd8739ae039 = (0, $hHhnY.default)($9b57cb28ef913da8$export$a2387ed3b5d536eb);

});


parcelRegister("ltr73", function(module, exports) {

$parcel$export(module.exports, "LightweightChart", function () { return $30780d708e5363d5$export$58bd66238470b3e9; });

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $bzz2o = parcelRequire("bzz2o");

var $lvF9l = parcelRequire("lvF9l");
var $4z9p8 = parcelRequire("4z9p8");

var $hQpqX = parcelRequire("hQpqX");

var $dgdqP = parcelRequire("dgdqP");

var $fJI9q = parcelRequire("fJI9q");

var $fbk3Z = parcelRequire("fbk3Z");
const $30780d708e5363d5$var$chartRightGutterPx = 56;
const $30780d708e5363d5$var$EMPTY_CHART_ARRAY = [];
const $30780d708e5363d5$export$58bd66238470b3e9 = ({ data: data, trades: trades = $30780d708e5363d5$var$EMPTY_CHART_ARRAY, volumeData: volumeData = $30780d708e5363d5$var$EMPTY_CHART_ARRAY, lineOverlays: lineOverlays = $30780d708e5363d5$var$EMPTY_CHART_ARRAY, customMarkers: customMarkers = $30780d708e5363d5$var$EMPTY_CHART_ARRAY, lowerPaneData: lowerPaneData = $30780d708e5363d5$var$EMPTY_CHART_ARRAY, type: type, symbolStyle: symbolStyle = 'candles', timeVisible: timeVisible, initialVisibleBars: initialVisibleBars, latestVisibleBars: latestVisibleBars, showMa30: showMa30 = false, showMa200: showMa200 = false, showBuyMarkers: showBuyMarkers = true, showCloseMarkers: showCloseMarkers = true, equityVariant: equityVariant = 'area', height: height = 400, range: range, resetViewToken: resetViewToken = 0, resolution: resolution = 'native', onRangeChange: onRangeChange, hideControls: hideControls = false, showLatestControl: showLatestControl = false, oosStartDate: oosStartDate, lineColor: lineColor = (0, $dgdqP.themeColors).neon, topColor: topColor = (0, $dgdqP.themeColors).neonArea, bottomColor: bottomColor = (0, $dgdqP.themeColors).neonTransparent, candleUpColor: candleUpColor = (0, $dgdqP.themeColors).success, candleDownColor: candleDownColor = (0, $dgdqP.themeColors).danger, lowerPaneLabel: lowerPaneLabel = 'Lower', lowerPaneColor: lowerPaneColor = (0, $dgdqP.themeColors).dangerLight, lowerPaneValueSuffix: lowerPaneValueSuffix = '', lowerPaneValuePrefix: lowerPaneValuePrefix = '', visibleSeriesKeys: visibleSeriesKeys, displayMode: displayMode = 'dollar', showMainSeries: showMainSeries = true, compareGross: compareGross = false, showGrossSeries: showGrossSeries = true, lowerPaneType: lowerPaneType = 'line', showEquityCandles: showEquityCandles = false })=>{
    const chartContainerRef = (0, $jHEir.useRef)(null);
    const overlayRef = (0, $jHEir.useRef)(null);
    const chartRef = (0, $jHEir.useRef)(null);
    const seriesRef = (0, $jHEir.useRef)(null);
    const overlaySeriesRef = (0, $jHEir.useRef)([]);
    const processedDataRef = (0, $jHEir.useRef)(data);
    const resizeObserver = (0, $jHEir.useRef)(null);
    const visibleLogicalRangeRef = (0, $jHEir.useRef)(null);
    const appliedRangeRef = (0, $jHEir.useRef)(null);
    const appliedResetViewTokenRef = (0, $jHEir.useRef)(resetViewToken);
    const [internalRange, setInternalRange] = (0, $jHEir.useState)('ALL');
    const [hoverPoint, setHoverPoint] = (0, $jHEir.useState)(null);
    const [lowerHoverPoint, setLowerHoverPoint] = (0, $jHEir.useState)(null);
    const selectedRange = range || internalRange;
    // Stable strategy keys for consistent coloring
    const allStrategyKeys = (0, $jHEir.useMemo)(()=>{
        if (!data || data.length === 0) return [];
        const keys = new Set();
        data.forEach((d)=>{
            Object.keys(d).forEach((k)=>{
                if (k.startsWith('equity_') && k !== 'equity_curve') keys.add(k);
            });
        });
        return Array.from(keys).sort(); // Sort to ensure stable order
    }, [
        data
    ]);
    const handleRangeChange = (r)=>{
        if (onRangeChange) onRangeChange(r);
        else setInternalRange(r);
    };
    const processTime = (0, $jHEir.useCallback)((dateStr)=>{
        if (resolution === '1D') return (0, $fJI9q.toDayString)(dateStr);
        if (dateStr.includes(':')) {
            const match = dateStr.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/);
            if (match) {
                const [, year, month, day, hour, min, sec] = match;
                const fakeUtc = Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hour), parseInt(min), parseInt(sec));
                return fakeUtc / 1000;
            }
            const safeStr = dateStr.replace(' ', 'T');
            return new Date(safeStr).getTime() / 1000;
        }
        return dateStr;
    }, [
        resolution
    ]);
    const updateOosOverlay = (0, $jHEir.useCallback)(()=>{
        if (!overlayRef.current || !chartRef.current || !chartContainerRef.current || !oosStartDate) return;
        const overlay = overlayRef.current;
        const chart = chartRef.current;
        const timeScale = chart.timeScale();
        const width = chartContainerRef.current.clientWidth;
        const rightAxisInset = 64;
        const bottomAxisInset = 22;
        const minOverlayWidth = 36;
        const rangeData = processedDataRef.current || [];
        const toComparableMs = (dateStr)=>{
            if (resolution === '1D') return new Date(`${(0, $fJI9q.toDayString)(dateStr)}T12:00:00`).getTime();
            const safeStr = dateStr.includes('T') ? dateStr : dateStr.replace(' ', 'T');
            return new Date(safeStr).getTime();
        };
        const targetMs = toComparableMs(oosStartDate);
        const anchorPoint = rangeData.find((d)=>toComparableMs(String(d.date)) >= targetMs) || rangeData[rangeData.length - 1];
        const x = anchorPoint ? timeScale.timeToCoordinate(processTime(String(anchorPoint.date))) : null;
        if (x == null || Number.isNaN(x)) {
            overlay.style.display = 'none';
            return;
        }
        const left = Math.max(0, Math.min(width, x));
        const usableRightEdge = Math.max(0, width - rightAxisInset);
        const overlayLeft = Math.min(left, Math.max(0, usableRightEdge - minOverlayWidth));
        const overlayWidth = Math.max(minOverlayWidth, usableRightEdge - overlayLeft);
        overlay.style.display = 'block';
        overlay.style.left = `${overlayLeft}px`;
        overlay.style.width = `${Math.max(0, overlayWidth)}px`;
        overlay.style.bottom = `${bottomAxisInset}px`;
    }, [
        oosStartDate,
        processTime,
        resolution
    ]);
    // Helper to apply the visible range
    const applyRangeLogic = (0, $jHEir.useCallback)((showLatest = false)=>{
        const rangeData = processedDataRef.current;
        if (!chartRef.current || !seriesRef.current || rangeData.length === 0) return;
        const chart = chartRef.current;
        const timeScale = chart.timeScale();
        if (selectedRange === 'ALL') {
            const visibleBars = showLatest ? latestVisibleBars : initialVisibleBars;
            if (visibleBars && visibleBars > 0) timeScale.setVisibleLogicalRange({
                from: Math.max(0, rangeData.length - visibleBars),
                to: rangeData.length
            });
            else timeScale.fitContent();
            return;
        }
        const daysMap = {
            '1D': 1,
            '3D': 3,
            '1W': 7,
            '1M': 30,
            '3M': 90,
            '6M': 180,
            '1Y': 365,
            'YTD': 0,
            'ALL': 0
        };
        const lastItem = rangeData[rangeData.length - 1];
        const lastDate = new Date(lastItem.date.includes('T') ? lastItem.date : lastItem.date + 'T12:00:00');
        let targetStartDate;
        if (selectedRange === 'YTD') targetStartDate = new Date(new Date().getFullYear(), 0, 1);
        else {
            targetStartDate = new Date(lastDate);
            targetStartDate.setDate(targetStartDate.getDate() - (daysMap[selectedRange] || 0));
        }
        const startIndex = rangeData.findIndex((d)=>{
            const itemDate = new Date(d.date.includes('T') ? d.date : d.date + 'T12:00:00');
            return itemDate >= targetStartDate;
        });
        timeScale.setVisibleLogicalRange({
            from: startIndex === -1 ? 0 : startIndex,
            to: rangeData.length
        });
        window.requestAnimationFrame(()=>{
            if (chartRef.current !== chart) return;
            const barSpacing = timeScale.options().barSpacing || 6;
            timeScale.scrollToPosition($30780d708e5363d5$var$chartRightGutterPx / barSpacing, false);
        });
    }, [
        selectedRange,
        initialVisibleBars,
        latestVisibleBars
    ]);
    const formatHoverDate = (dateStr)=>{
        const safeStr = dateStr.includes('T') ? dateStr : dateStr.replace(' ', 'T');
        const dt = new Date(safeStr);
        if (Number.isNaN(dt.getTime())) return dateStr;
        if (resolution === '1D') return dt.toLocaleDateString();
        return dt.toLocaleString([], {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    };
    // Main Chart Creation and Series Update Effect
    (0, $jHEir.useEffect)(()=>{
        if (!chartContainerRef.current) return;
        const chart = (0, $bzz2o.createChart)(chartContainerRef.current, (0, $fbk3Z.buildThemedChartOptions)({
            width: chartContainerRef.current.clientWidth,
            height: chartContainerRef.current.clientHeight || height,
            timeVisible: timeVisible ?? resolution === 'native',
            rightOffsetPixels: $30780d708e5363d5$var$chartRightGutterPx,
            includePaneSeparators: true
        }));
        chartRef.current = chart;
        let series;
        const overlaySeries = [];
        const { data: processedData, lowerPaneData: processedLowerPaneData } = (0, $fJI9q.prepareChartData)({
            data: data,
            lowerPaneData: lowerPaneData,
            type: type,
            resolution: resolution,
            showEquityCandles: showEquityCandles,
            displayMode: displayMode
        });
        processedDataRef.current = processedData;
        if (type === 'equity') {
            if (equityVariant === 'line') series = chart.addSeries((0, $bzz2o.LineSeries), {
                color: lineColor,
                lineWidth: 2
            });
            else series = chart.addSeries((0, $bzz2o.AreaSeries), {
                lineColor: lineColor,
                topColor: topColor,
                bottomColor: bottomColor,
                lineWidth: 2
            });
            if (displayMode === 'percent') series.applyOptions({
                priceFormat: {
                    type: 'custom',
                    formatter: (price)=>`${price >= 0 ? '+' : ''}${price.toFixed(2)}%`
                }
            });
            if (showMainSeries) series.setData(processedData.map((d)=>{
                let val = d.equity;
                if (displayMode === 'gross') val = d.equity_gross ?? d.equity;
                return {
                    time: processTime(d.date),
                    value: Number(val || 0)
                };
            }));
            else series.setData([]);
            // Render individual strategy equity curves
            if (allStrategyKeys.length > 0) allStrategyKeys.forEach((key, idx)=>{
                if (visibleSeriesKeys && !visibleSeriesKeys.includes(key)) return;
                const stratSeries = chart.addSeries((0, $bzz2o.LineSeries), {
                    color: (0, $dgdqP.strategySeriesColors)[idx % (0, $dgdqP.strategySeriesColors).length],
                    lineWidth: 1,
                    priceLineVisible: false,
                    lastValueVisible: false
                });
                if (displayMode === 'percent') stratSeries.applyOptions({
                    priceFormat: {
                        type: 'custom',
                        formatter: (price)=>`${price >= 0 ? '+' : ''}${price.toFixed(2)}%`
                    }
                });
                stratSeries.setData(processedData.map((d)=>({
                        time: processTime(d.date),
                        value: d[key]
                    })));
                overlaySeries.push(stratSeries);
            });
            // Render Gross Comparison line if requested
            if (compareGross && showGrossSeries && processedData.some((d)=>d.equity_gross !== undefined)) {
                const grossSeries = chart.addSeries((0, $bzz2o.LineSeries), {
                    color: (0, $dgdqP.themeColors).warningBright,
                    lineWidth: 1,
                    lineStyle: 2,
                    priceLineVisible: false,
                    lastValueVisible: false
                });
                grossSeries.setData(processedData.map((d)=>{
                    const isGrossMode = displayMode === 'gross';
                    const targetVal = isGrossMode ? d.equity : d.equity_gross;
                    return {
                        time: processTime(d.date),
                        value: targetVal
                    };
                }));
                overlaySeries.push(grossSeries);
            }
        } else if (processedData.length > 0 && 'open' in processedData[0]) {
            if (symbolStyle === 'line') {
                series = chart.addSeries((0, $bzz2o.LineSeries), {
                    color: lineColor,
                    lineWidth: 2,
                    crosshairMarkerVisible: true,
                    priceLineVisible: true,
                    lastValueVisible: true
                });
                series.setData(processedData.map((d)=>({
                        time: processTime(d.date),
                        value: d.close
                    })));
            } else {
                series = chart.addSeries((0, $bzz2o.CandlestickSeries), {
                    upColor: candleUpColor,
                    downColor: candleDownColor,
                    borderVisible: false,
                    wickUpColor: candleUpColor,
                    wickDownColor: candleDownColor,
                    priceLineVisible: true,
                    lastValueVisible: true
                });
                series.setData(processedData.map((d)=>({
                        time: processTime(d.date),
                        open: d.open,
                        high: d.high,
                        low: d.low,
                        close: d.close
                    })));
            }
        } else {
            series = chart.addSeries((0, $bzz2o.LineSeries), {
                color: (0, $dgdqP.themeColors).infoDark,
                lineWidth: 2
            });
            series.setData(processedData.map((d)=>({
                    time: processTime(d.date),
                    value: d.price || d.equity
                })));
        }
        seriesRef.current = series;
        if (type === 'symbol') {
            if (showMa30 && processedData.some((d)=>d.ma30 != null)) {
                const ma30Series = chart.addSeries((0, $bzz2o.LineSeries), {
                    color: (0, $dgdqP.themeColors).info,
                    lineWidth: 1,
                    priceLineVisible: false,
                    lastValueVisible: false
                });
                ma30Series.setData(processedData.filter((d)=>d.ma30 != null).map((d)=>({
                        time: processTime(d.date),
                        value: d.ma30
                    })));
                overlaySeries.push(ma30Series);
            }
            if (showMa200 && processedData.some((d)=>d.ma200 != null)) {
                const ma200Series = chart.addSeries((0, $bzz2o.LineSeries), {
                    color: (0, $dgdqP.themeColors).warning,
                    lineWidth: 1,
                    priceLineVisible: false,
                    lastValueVisible: false
                });
                ma200Series.setData(processedData.filter((d)=>d.ma200 != null).map((d)=>({
                        time: processTime(d.date),
                        value: d.ma200
                    })));
                overlaySeries.push(ma200Series);
            }
        }
        lineOverlays.forEach((overlay)=>{
            if (overlay.data.length === 0) return;
            const overlaySeriesItem = chart.addSeries((0, $bzz2o.LineSeries), {
                color: overlay.color,
                lineWidth: overlay.lineWidth ?? 2,
                priceLineVisible: false,
                lastValueVisible: false,
                crosshairMarkerVisible: false,
                title: overlay.title ?? ''
            });
            overlaySeriesItem.setData(overlay.data.map((point)=>({
                    time: processTime(point.date),
                    value: point.value
                })));
            overlaySeries.push(overlaySeriesItem);
        });
        if (volumeData.length > 0) {
            const volumeSeries = chart.addSeries((0, $bzz2o.HistogramSeries), {
                priceFormat: {
                    type: 'volume'
                },
                priceScaleId: '',
                lastValueVisible: false,
                priceLineVisible: false
            });
            volumeSeries.priceScale().applyOptions({
                scaleMargins: {
                    top: 0.82,
                    bottom: 0
                }
            });
            volumeSeries.setData(volumeData.map((point)=>({
                    time: processTime(point.date),
                    value: point.value,
                    ...point.color ? {
                        color: point.color
                    } : {}
                })));
            overlaySeries.push(volumeSeries);
        }
        if (processedLowerPaneData.length > 0) {
            let lowerSeries;
            const lowerPanePriceFormat = lowerPaneValuePrefix || lowerPaneValueSuffix ? {
                type: 'custom',
                formatter: (price)=>`${lowerPaneValuePrefix}${lowerPaneValueSuffix === '%' && price > 0 ? '+' : ''}${price.toFixed(2)}${lowerPaneValueSuffix}`
            } : undefined;
            if (lowerPaneType === 'histogram') {
                lowerSeries = chart.addSeries((0, $bzz2o.HistogramSeries), {
                    color: lowerPaneColor,
                    priceLineVisible: false,
                    priceFormat: lowerPanePriceFormat
                }, 1);
                lowerSeries.setData(processedLowerPaneData.map((point)=>{
                    const val = point.equity;
                    return {
                        time: processTime(point.date),
                        value: val,
                        color: val >= 0 ? (0, $dgdqP.themeColors).success : (0, $dgdqP.themeColors).danger
                    };
                }));
            } else {
                lowerSeries = chart.addSeries((0, $bzz2o.LineSeries), {
                    color: lowerPaneColor,
                    lineWidth: 2,
                    priceLineVisible: false,
                    priceFormat: lowerPanePriceFormat
                }, 1);
                lowerSeries.setData(processedLowerPaneData.map((point)=>({
                        time: processTime(point.date),
                        value: point.equity
                    })));
            }
            overlaySeries.push(lowerSeries);
            const panes = chart.panes();
            if (panes[0]) panes[0].setStretchFactor(3);
            if (panes[1]) panes[1].setStretchFactor(1);
        }
        overlaySeriesRef.current = overlaySeries;
        // Add Markers
        const markers = [];
        if ((type === 'symbol' || type === 'equity') && Array.isArray(trades)) {
            const chartDataTimes = processedData.map((d)=>processTime(d.date));
            const snapToClosest = (targetTime)=>{
                if (chartDataTimes.length === 0) return null;
                if (resolution === '1D') {
                    const tStr = typeof targetTime === 'number' ? new Date(targetTime * 1000).toISOString().split('T')[0] : (0, $fJI9q.toDayString)(String(targetTime));
                    const exact = chartDataTimes.find((time)=>String(time) === tStr);
                    if (exact !== undefined) return exact;
                    return chartDataTimes.find((time)=>String(time) >= tStr) || chartDataTimes[chartDataTimes.length - 1];
                }
                const numericTarget = typeof targetTime === 'number' ? targetTime : Number(processTime(String(targetTime)));
                if (!Number.isFinite(numericTarget)) {
                    const exact = chartDataTimes.find((time)=>String(time) === String(targetTime));
                    return exact ?? null;
                }
                let closest = chartDataTimes[0];
                let minDiff = Math.abs(numericTarget - closest);
                for(let i = 1; i < chartDataTimes.length; i++){
                    const current = chartDataTimes[i];
                    const diff = Math.abs(numericTarget - current);
                    if (diff < minDiff) {
                        minDiff = diff;
                        closest = current;
                    }
                }
                return closest;
            };
            trades.forEach((t)=>{
                const entryTimeRaw = processTime(t.entry_date);
                const exitTimeRaw = t.status !== 'OPEN' && t.exit_date ? processTime(t.exit_date) : null;
                const entryTime = snapToClosest(entryTimeRaw);
                const exitTime = exitTimeRaw ? snapToClosest(exitTimeRaw) : null;
                if (entryTime && showBuyMarkers) {
                    const isLong = t.side === 'LONG';
                    markers.push({
                        time: entryTime,
                        position: isLong ? 'belowBar' : 'aboveBar',
                        color: isLong ? (0, $dgdqP.themeColors).successMarker : (0, $dgdqP.themeColors).dangerMarker,
                        shape: isLong ? 'arrowUp' : 'arrowDown',
                        text: isLong ? 'B' : 'S'
                    });
                }
                if (exitTime && showCloseMarkers) {
                    const isLong = t.side === 'LONG';
                    const exitColor = t.status === 'STOP_LOSS' ? (0, $dgdqP.themeColors).warningMarker : isLong ? (0, $dgdqP.themeColors).dangerMarker : (0, $dgdqP.themeColors).successMarker;
                    markers.push({
                        time: exitTime,
                        position: isLong ? 'aboveBar' : 'belowBar',
                        color: exitColor,
                        shape: isLong ? 'arrowDown' : 'arrowUp',
                        text: t.status === 'STOP_LOSS' ? 'SL' : 'C'
                    });
                }
            });
        }
        if (oosStartDate) markers.push({
            time: processTime(oosStartDate),
            position: 'aboveBar',
            color: (0, $dgdqP.themeColors).warning,
            shape: 'arrowDown',
            text: 'OOS',
            size: 2
        });
        customMarkers.forEach((marker)=>{
            markers.push({
                time: processTime(marker.date),
                position: marker.position,
                color: marker.color,
                shape: marker.shape,
                ...marker.text ? {
                    text: marker.text
                } : {},
                ...marker.size ? {
                    size: marker.size
                } : {}
            });
        });
        if (markers.length > 0) (0, $bzz2o.createSeriesMarkers)(series, markers.sort((a, b)=>String(a.time).localeCompare(String(b.time))));
        const savedVisibleRange = visibleLogicalRangeRef.current;
        if (savedVisibleRange) chart.timeScale().setVisibleLogicalRange(savedVisibleRange);
        else {
            applyRangeLogic();
            appliedRangeRef.current = selectedRange;
        }
        updateOosOverlay();
        const timeScale = chart.timeScale();
        const handleVisibleLogicalRangeChange = ()=>{
            visibleLogicalRangeRef.current = timeScale.getVisibleLogicalRange();
            updateOosOverlay();
        };
        const handleCrosshairMove = (param)=>{
            if (!param?.time || !processedDataRef.current.length) {
                setHoverPoint(null);
                setLowerHoverPoint(null);
                return;
            }
            const targetTime = String(param.time);
            const matchedPoint = processedDataRef.current.find((point)=>String(processTime(String(point.date))) === targetTime);
            const matchedLowerPoint = processedLowerPaneData.find((point)=>String(processTime(String(point.date))) === targetTime);
            setHoverPoint(matchedPoint || null);
            setLowerHoverPoint(matchedLowerPoint || null);
        };
        timeScale.subscribeVisibleTimeRangeChange(updateOosOverlay);
        timeScale.subscribeVisibleLogicalRangeChange(handleVisibleLogicalRangeChange);
        chart.subscribeCrosshairMove(handleCrosshairMove);
        resizeObserver.current = new ResizeObserver((entries)=>{
            const { width: width, height: h } = entries[0].contentRect;
            chart.applyOptions({
                width: width,
                height: h
            });
            updateOosOverlay();
        });
        resizeObserver.current.observe(chartContainerRef.current);
        return ()=>{
            visibleLogicalRangeRef.current = timeScale.getVisibleLogicalRange();
            timeScale.unsubscribeVisibleTimeRangeChange(updateOosOverlay);
            timeScale.unsubscribeVisibleLogicalRangeChange(handleVisibleLogicalRangeChange);
            chart.unsubscribeCrosshairMove(handleCrosshairMove);
            resizeObserver.current?.disconnect();
            chart.remove();
            chartRef.current = null;
            seriesRef.current = null;
            overlaySeriesRef.current = [];
            processedDataRef.current = [];
            setHoverPoint(null);
            setLowerHoverPoint(null);
        };
    // Range changes are applied below without rebuilding the chart instance.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data,
        trades,
        volumeData,
        lineOverlays,
        customMarkers,
        lowerPaneData,
        type,
        symbolStyle,
        showMa30,
        showMa200,
        showBuyMarkers,
        showCloseMarkers,
        equityVariant,
        height,
        resolution,
        timeVisible,
        oosStartDate,
        lineColor,
        topColor,
        bottomColor,
        candleUpColor,
        candleDownColor,
        lowerPaneColor,
        lowerPaneValuePrefix,
        lowerPaneValueSuffix,
        visibleSeriesKeys,
        displayMode,
        showMainSeries,
        compareGross,
        showGrossSeries,
        lowerPaneType,
        showEquityCandles,
        allStrategyKeys,
        processTime,
        updateOosOverlay
    ]);
    // Only toolbar range changes and explicit reset requests should move the
    // user's viewport. Data refreshes and crosshair hover rerenders preserve it.
    (0, $jHEir.useEffect)(()=>{
        if (!chartRef.current || !seriesRef.current || data.length === 0) return;
        const resetRequested = appliedResetViewTokenRef.current !== resetViewToken;
        const rangeChanged = appliedRangeRef.current !== selectedRange;
        if (!resetRequested && !rangeChanged) return;
        if (resetRequested) visibleLogicalRangeRef.current = null;
        appliedResetViewTokenRef.current = resetViewToken;
        appliedRangeRef.current = selectedRange;
        applyRangeLogic();
        updateOosOverlay();
    }, [
        selectedRange,
        resetViewToken,
        applyRangeLogic,
        updateOosOverlay
    ]);
    const rangeOptions = [
        '1D',
        '3D',
        '1W',
        '1M',
        '3M',
        '6M',
        'YTD',
        '1Y',
        'ALL'
    ];
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "relative w-full h-full",
        children: [
            (showLatestControl || !hideControls) && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "absolute bottom-9 right-20 z-20",
                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $hQpqX.default), {
                    size: "compact",
                    iconOnly: true,
                    label: "Scroll chart to latest",
                    title: "Scroll chart to latest",
                    icon: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4z9p8.default), {
                        className: "h-4 w-4"
                    }),
                    onClick: ()=>{
                        visibleLogicalRangeRef.current = null;
                        applyRangeLogic(true);
                        updateOosOverlay();
                    }
                })
            }),
            !hideControls && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "absolute top-2 right-2 z-10 flex flex-wrap justify-end gap-1",
                children: [
                    type === 'symbol' && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "mr-1 flex rounded-sm border border-line bg-surface-2 p-0.5",
                        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                            className: "flex h-7 items-center gap-1.5 rounded-sm px-2 text-[10px] font-bold uppercase tracking-wider text-neon",
                            title: "Candlestick chart",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lvF9l.default), {
                                    className: "h-3.5 w-3.5"
                                }),
                                "Candle"
                            ]
                        })
                    }),
                    rangeOptions.map((r)=>/*#__PURE__*/ (0, $eHRxX.jsx)((0, $hQpqX.default), {
                            size: "compact",
                            label: r,
                            selected: selectedRange === r,
                            onClick: ()=>handleRangeChange(r),
                            children: r
                        }, r))
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                ref: chartContainerRef,
                className: "w-full h-full bg-surface-3"
            }),
            hoverPoint && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "pointer-events-none absolute bottom-10 left-3 z-9 rounded-lg border border-line bg-surface/90 px-3 py-2 text-[11px] text-white shadow-lg backdrop-blur-xs",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "mb-1 font-mono text-white/80",
                        children: formatHoverDate(String(hoverPoint.date))
                    }),
                    type === 'symbol' ? /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "grid grid-cols-2 gap-x-3 gap-y-1 font-mono",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "text-white/60",
                                children: "O"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                children: Number(hoverPoint.open ?? 0).toFixed(2)
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "text-white/60",
                                children: "H"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                children: Number(hoverPoint.high ?? 0).toFixed(2)
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "text-white/60",
                                children: "L"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                children: Number(hoverPoint.low ?? 0).toFixed(2)
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "text-white/60",
                                children: "C"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                children: Number(hoverPoint.close ?? 0).toFixed(2)
                            }),
                            hoverPoint.ma30 != null && /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: "text-sky-300",
                                        children: "MA30"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        children: Number(hoverPoint.ma30).toFixed(2)
                                    })
                                ]
                            }),
                            hoverPoint.ma200 != null && /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: "text-warning-500",
                                        children: "MA200"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        children: Number(hoverPoint.ma200).toFixed(2)
                                    })
                                ]
                            }),
                            lowerHoverPoint && /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: lowerPaneLabel === 'Daily P/L' && Number(lowerHoverPoint.equity ?? 0) >= 0 ? 'text-success-500' : 'text-error-500',
                                        children: lowerPaneLabel
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                        className: lowerPaneLabel === 'Daily P/L' && Number(lowerHoverPoint.equity ?? 0) >= 0 ? 'text-success-500' : 'text-error-500',
                                        children: [
                                            lowerPaneValuePrefix,
                                            Number(lowerHoverPoint.equity ?? 0).toFixed(2),
                                            lowerPaneValueSuffix
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "grid grid-cols-2 gap-x-3 gap-y-1 font-mono",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "text-white/60",
                                children: displayMode === 'percent' ? 'Return' : 'Total Equity'
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                className: displayMode === 'percent' ? hoverPoint.equity >= 0 ? 'text-neon' : 'text-error-500' : 'text-white',
                                children: [
                                    displayMode === 'percent' ? hoverPoint.equity >= 0 ? '+' : '' : '$',
                                    Number(hoverPoint.equity ?? 0).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }),
                                    displayMode === 'percent' ? '%' : ''
                                ]
                            }),
                            compareGross && showGrossSeries && hoverPoint.equity_gross !== undefined && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $eHRxX.Fragment), {
                                children: (()=>{
                                    const isGrossMain = displayMode === 'gross';
                                    const compVal = isGrossMain ? hoverPoint.equity : hoverPoint.equity_gross;
                                    const startVal = data[0]?.equity || 1;
                                    return /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "text-warning-500/60",
                                                children: isGrossMain ? 'Net' : 'Gross'
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                className: "text-warning-500/80",
                                                children: [
                                                    displayMode === 'percent' ? compVal >= 0 ? '+' : '' : '$',
                                                    Number(displayMode === 'percent' ? (compVal / startVal - 1) * 100 : compVal).toLocaleString(undefined, {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }),
                                                    displayMode === 'percent' ? '%' : ''
                                                ]
                                            })
                                        ]
                                    });
                                })()
                            }),
                            allStrategyKeys.filter((k)=>hoverPoint[k] !== undefined).map((k)=>{
                                const idx = allStrategyKeys.indexOf(k);
                                const color = (0, $dgdqP.strategySeriesColors)[idx % (0, $dgdqP.strategySeriesColors).length];
                                return /*#__PURE__*/ (0, $eHRxX.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                            className: "flex items-center gap-1.5",
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                    className: "w-1.5 h-1.5 rounded-full",
                                                    style: {
                                                        backgroundColor: color
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                    className: "text-white/40",
                                                    children: k.replace('equity_', '').substring(0, 10)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                            className: displayMode === 'percent' ? hoverPoint[k] >= 0 ? 'text-neon/80' : 'text-error-500/80' : 'text-white/60',
                                            children: [
                                                displayMode === 'percent' ? hoverPoint[k] >= 0 ? '+' : '' : '$',
                                                Number(hoverPoint[k] ?? 0).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }),
                                                displayMode === 'percent' ? '%' : ''
                                            ]
                                        })
                                    ]
                                }, k);
                            }),
                            lowerHoverPoint && /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: lowerPaneLabel === 'Daily P/L' && Number(lowerHoverPoint.equity ?? 0) >= 0 ? 'text-success-500' : 'text-error-500',
                                        children: lowerPaneLabel
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                        className: lowerPaneLabel === 'Daily P/L' && Number(lowerHoverPoint.equity ?? 0) >= 0 ? 'text-success-500' : 'text-error-500',
                                        children: [
                                            lowerPaneValuePrefix,
                                            Number(lowerHoverPoint.equity ?? 0).toFixed(2),
                                            lowerPaneValueSuffix
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            oosStartDate && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                ref: overlayRef,
                className: "absolute top-0 bottom-0 z-5 pointer-events-none border-l border-slate-300/50 bg-slate-300/2.5",
                style: {
                    display: 'none'
                },
                children: /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "absolute top-2 right-2 rounded-sm bg-slate-200/70 px-1.5 py-0.5 text-[9px] font-bold tracking-widest text-slate-900",
                    children: "OOS"
                })
            })
        ]
    });
};

});
parcelRegister("bzz2o", function(module, exports) {

$parcel$export(module.exports, "ColorType", function () { return $8f74814242901c26$export$2cd82751acc0e609; });
$parcel$export(module.exports, "createChart", function () { return $8f74814242901c26$export$c870ec99876cb45c; });
$parcel$export(module.exports, "LineSeries", function () { return $8f74814242901c26$export$29b04ebffc4f4705; });
$parcel$export(module.exports, "AreaSeries", function () { return $8f74814242901c26$export$1d34d22a4e55a2c5; });
$parcel$export(module.exports, "CandlestickSeries", function () { return $8f74814242901c26$export$9bff15f5cdf5e23d; });
$parcel$export(module.exports, "HistogramSeries", function () { return $8f74814242901c26$export$9553650b5f8815ed; });
$parcel$export(module.exports, "createSeriesMarkers", function () { return $8f74814242901c26$export$b954512652d436b9; });
/*!
 * @license
 * TradingView Lightweight Charts™ v5.2.1
 * Copyright (c) 2026 TradingView, Inc.
 * Licensed under Apache License 2.0 https://www.apache.org/licenses/LICENSE-2.0
 */ parcelRequire("jAD69");
var $59mHk = parcelRequire("59mHk");
var $aFz8k = parcelRequire("aFz8k");
var $02Gl7 = parcelRequire("02Gl7");
const $8f74814242901c26$var$e = {
    title: "",
    visible: !0,
    hitTestTolerance: 3,
    lastValueVisible: !0,
    priceLineVisible: !0,
    priceLineSource: 0,
    priceLineWidth: 1,
    priceLineColor: "",
    priceLineStyle: 2,
    baseLineVisible: !0,
    baseLineWidth: 1,
    baseLineColor: "#B2B5BE",
    baseLineStyle: 0,
    priceFormat: {
        type: "price",
        precision: 2,
        minMove: .01
    }
};
var $8f74814242901c26$export$aa318e0578993894, $8f74814242901c26$export$5d24e00cfde59887;
function $8f74814242901c26$var$a(t, i) {
    const n = function(t, i) {
        switch(t){
            case 0:
            default:
                return [];
            case 1:
                return [
                    i,
                    i
                ];
            case 2:
                return [
                    2 * i,
                    2 * i
                ];
            case 3:
                return [
                    6 * i,
                    6 * i
                ];
            case 4:
                return [
                    i,
                    4 * i
                ];
        }
    }(i, t.lineWidth);
    return t.setLineDash(n), n;
}
function $8f74814242901c26$var$l(t, i, n, s) {
    t.beginPath();
    const e = t.lineWidth % 2 ? .5 : 0;
    t.moveTo(n, i + e), t.lineTo(s, i + e), t.stroke();
}
function $8f74814242901c26$var$o(t, i) {
    if (!t) throw new Error("Assertion failed" + (i ? ": " + i : ""));
}
function $8f74814242901c26$var$_(t) {
    if (void 0 === t) throw new Error("Value is undefined");
    return t;
}
function $8f74814242901c26$var$u(t) {
    if (null === t) throw new Error("Value is null");
    return t;
}
function $8f74814242901c26$var$c(t) {
    return $8f74814242901c26$var$u($8f74814242901c26$var$_(t));
}
!function(t) {
    t[t.Simple = 0] = "Simple", t[t.WithSteps = 1] = "WithSteps", t[t.Curved = 2] = "Curved";
}($8f74814242901c26$export$aa318e0578993894 || ($8f74814242901c26$export$aa318e0578993894 = {})), function(t) {
    t[t.Solid = 0] = "Solid", t[t.Dotted = 1] = "Dotted", t[t.Dashed = 2] = "Dashed", t[t.LargeDashed = 3] = "LargeDashed", t[t.SparseDotted = 4] = "SparseDotted";
}($8f74814242901c26$export$5d24e00cfde59887 || ($8f74814242901c26$export$5d24e00cfde59887 = {}));
class $8f74814242901c26$var$d {
    constructor(){
        this.t = [];
    }
    i(t, i, n) {
        const s = {
            h: t,
            l: i,
            o: !0 === n
        };
        this.t.push(s);
    }
    _(t) {
        const i = this.t.findIndex((i)=>t === i.h);
        i > -1 && this.t.splice(i, 1);
    }
    u(t) {
        this.t = this.t.filter((i)=>i.l !== t);
    }
    p(t, i, n) {
        const s = [
            ...this.t
        ];
        this.t = this.t.filter((t)=>!t.o), s.forEach((s)=>s.h(t, i, n));
    }
    v() {
        return this.t.length > 0;
    }
    m() {
        this.t = [];
    }
}
function $8f74814242901c26$var$f(t, ...i) {
    for (const n of i)for(const i in n)void 0 !== n[i] && Object.prototype.hasOwnProperty.call(n, i) && ![
        "__proto__",
        "constructor",
        "prototype"
    ].includes(i) && ("object" != typeof n[i] || void 0 === t[i] || Array.isArray(n[i]) ? t[i] = n[i] : $8f74814242901c26$var$f(t[i], n[i]));
    return t;
}
function $8f74814242901c26$var$p(t) {
    return "number" == typeof t && isFinite(t);
}
function $8f74814242901c26$var$v(t) {
    return "number" == typeof t && t % 1 == 0;
}
function $8f74814242901c26$var$m(t) {
    return "string" == typeof t;
}
function $8f74814242901c26$var$w(t) {
    return "boolean" == typeof t;
}
function $8f74814242901c26$var$M(t) {
    const i = t;
    if (!i || "object" != typeof i) return i;
    let n, s, e;
    for(s in n = Array.isArray(i) ? [] : {}, i)i.hasOwnProperty(s) && (e = i[s], n[s] = e && "object" == typeof e ? $8f74814242901c26$var$M(e) : e);
    return n;
}
function $8f74814242901c26$var$g(t) {
    return null !== t;
}
function $8f74814242901c26$var$b(t) {
    return null === t ? void 0 : t;
}
const $8f74814242901c26$var$S = "-apple-system, BlinkMacSystemFont, 'Trebuchet MS', Roboto, Ubuntu, sans-serif";
function $8f74814242901c26$var$x(t, i, n) {
    return void 0 === i && (i = $8f74814242901c26$var$S), `${n = void 0 !== n ? `${n} ` : ""}${t}px ${i}`;
}
class $8f74814242901c26$var$C {
    constructor(t){
        this.M = {
            S: 1,
            C: 5,
            P: NaN,
            k: "",
            T: "",
            R: "",
            D: "",
            I: 0,
            V: 0,
            B: 0,
            A: 0,
            L: 0
        }, this.O = t;
    }
    N() {
        const t = this.M, i = this.F(), n = this.W();
        return t.P === i && t.T === n || (t.P = i, t.T = n, t.k = $8f74814242901c26$var$x(i, n), t.A = 2.5 / 12 * i, t.I = t.A, t.V = i / 12 * t.C, t.B = i / 12 * t.C, t.L = 0), t.R = this.H(), t.D = this.U(), this.M;
    }
    H() {
        return this.O.N().layout.textColor;
    }
    U() {
        return this.O.$();
    }
    F() {
        return this.O.N().layout.fontSize;
    }
    W() {
        return this.O.N().layout.fontFamily;
    }
}
function $8f74814242901c26$var$y(t) {
    return t < 0 ? 0 : t > 255 ? 255 : Math.round(t) || 0;
}
function $8f74814242901c26$var$P(t) {
    return .199 * t[0] + .687 * t[1] + .114 * t[2];
}
class $8f74814242901c26$var$k {
    constructor(t, i){
        this.j = new Map, this.q = t, i && (this.j = i);
    }
    Y(t, i) {
        if ("transparent" === t) return t;
        const n = this.K(t), s = n[3];
        return `rgba(${n[0]}, ${n[1]}, ${n[2]}, ${i * s})`;
    }
    G(t) {
        const i = this.K(t);
        return {
            Z: `rgb(${i[0]}, ${i[1]}, ${i[2]})`,
            X: $8f74814242901c26$var$P(i) > 160 ? "black" : "white"
        };
    }
    J(t) {
        return $8f74814242901c26$var$P(this.K(t));
    }
    tt(t, i, n) {
        const [s, e, r, h] = this.K(t), [a, l, o, _] = this.K(i), u = [
            $8f74814242901c26$var$y(s + n * (a - s)),
            $8f74814242901c26$var$y(e + n * (l - e)),
            $8f74814242901c26$var$y(r + n * (o - r)),
            (c = h + n * (_ - h), c <= 0 || c > 1 ? Math.min(Math.max(c, 0), 1) : Math.round(1e4 * c) / 1e4)
        ];
        var c;
        return `rgba(${u[0]}, ${u[1]}, ${u[2]}, ${u[3]})`;
    }
    K(t) {
        const i = this.j.get(t);
        if (i) return i;
        const n = function(t) {
            const i = document.createElement("div");
            i.style.display = "none", document.body.appendChild(i), i.style.color = t;
            const n = window.getComputedStyle(i).color;
            return document.body.removeChild(i), n;
        }(t), s = n.match(/^rgba?\s*\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d*\.?\d+))?\)$/);
        if (!s) {
            if (this.q.length) for (const i of this.q){
                const n = i(t);
                if (n) return this.j.set(t, n), n;
            }
            throw new Error(`Failed to parse color: ${t}`);
        }
        const e = [
            parseInt(s[1], 10),
            parseInt(s[2], 10),
            parseInt(s[3], 10),
            s[4] ? parseFloat(s[4]) : 1
        ];
        return this.j.set(t, e), e;
    }
}
class $8f74814242901c26$var$T {
    constructor(){
        this.it = [];
    }
    nt(t) {
        this.it = t;
    }
    st(t, i, n) {
        this.it.forEach((s)=>{
            s.st(t, i, n);
        });
    }
}
class $8f74814242901c26$var$R {
    st(t, i, n) {
        t.useBitmapCoordinateSpace((t)=>this.et(t, i, n));
    }
}
class $8f74814242901c26$var$D extends $8f74814242901c26$var$R {
    constructor(){
        super(...arguments), this.rt = null;
    }
    ht(t) {
        this.rt = t;
    }
    et({ context: t, horizontalPixelRatio: i, verticalPixelRatio: n }) {
        if (null === this.rt || null === this.rt.lt) return;
        const s = this.rt.lt, e = this.rt, r = Math.max(1, Math.floor(i)) % 2 / 2, h = (h)=>{
            t.beginPath();
            for(let a = s.to - 1; a >= s.from; --a){
                const s = e.ot[a], l = Math.round(s._t * i) + r, o = s.ut * n, _ = h * n + r;
                t.moveTo(l, o), t.arc(l, o, _, 0, 2 * Math.PI);
            }
            t.fill();
        };
        e.ct > 0 && (t.fillStyle = e.dt, h(e.ft + e.ct)), t.fillStyle = e.vt, h(e.ft);
    }
}
function $8f74814242901c26$var$I() {
    return {
        ot: [
            {
                _t: 0,
                ut: 0,
                wt: 0,
                Mt: 0
            }
        ],
        vt: "",
        dt: "",
        ft: 0,
        ct: 0,
        lt: null
    };
}
const $8f74814242901c26$var$V = {
    from: 0,
    to: 1
};
class $8f74814242901c26$var$B {
    constructor(t, i, n){
        this.gt = new $8f74814242901c26$var$T, this.bt = [], this.St = [], this.xt = !0, this.O = t, this.Ct = i, this.yt = n, this.gt.nt(this.bt);
    }
    Pt(t) {
        this.kt(), this.xt = !0;
    }
    Tt() {
        return this.xt && (this.Rt(), this.xt = !1), this.gt;
    }
    kt() {
        const t = this.yt.Dt();
        t.length !== this.bt.length && (this.St = t.map($8f74814242901c26$var$I), this.bt = this.St.map((t)=>{
            const i = new $8f74814242901c26$var$D;
            return i.ht(t), i;
        }), this.gt.nt(this.bt));
    }
    Rt() {
        const t = 2 === this.Ct.N().mode || !this.Ct.It(), i = this.yt.Vt(), n = this.Ct.Bt(), s = this.O.Et();
        this.kt(), i.forEach((i, e)=>{
            const r = this.St[e], h = i.At(n), a = i.Lt();
            !t && null !== h && i.It() && null !== a ? (r.vt = h.zt, r.ft = h.ft, r.ct = h.Ot, r.ot[0].Mt = h.Mt, r.ot[0].ut = i.Ft().Nt(h.Mt, a.Wt), r.dt = h.Ht ?? this.O.Ut(r.ot[0].ut / i.Ft().$t()), r.ot[0].wt = n, r.ot[0]._t = s.jt(n), r.lt = $8f74814242901c26$var$V) : r.lt = null;
        });
    }
}
class $8f74814242901c26$var$E extends $8f74814242901c26$var$R {
    constructor(t){
        super(), this.qt = t;
    }
    et({ context: t, bitmapSize: i, horizontalPixelRatio: n, verticalPixelRatio: s }) {
        if (null === this.qt) return;
        const e = this.qt.Yt.It, r = this.qt.Kt.It;
        if (!e && !r) return;
        const h = Math.round(this.qt._t * n), o = Math.round(this.qt.ut * s);
        t.lineCap = "butt", e && h >= 0 && (t.lineWidth = Math.floor(this.qt.Yt.ct * n), t.strokeStyle = this.qt.Yt.R, t.fillStyle = this.qt.Yt.R, $8f74814242901c26$var$a(t, this.qt.Yt.Gt), function(t, i, n, s) {
            t.beginPath();
            const e = t.lineWidth % 2 ? .5 : 0;
            t.moveTo(i + e, n), t.lineTo(i + e, s), t.stroke();
        }(t, h, 0, i.height)), r && o >= 0 && (t.lineWidth = Math.floor(this.qt.Kt.ct * s), t.strokeStyle = this.qt.Kt.R, t.fillStyle = this.qt.Kt.R, $8f74814242901c26$var$a(t, this.qt.Kt.Gt), $8f74814242901c26$var$l(t, o, 0, i.width));
    }
}
class $8f74814242901c26$var$A {
    constructor(t, i){
        this.xt = !0, this.Zt = {
            Yt: {
                ct: 1,
                Gt: 0,
                R: "",
                It: !1
            },
            Kt: {
                ct: 1,
                Gt: 0,
                R: "",
                It: !1
            },
            _t: 0,
            ut: 0
        }, this.Xt = new $8f74814242901c26$var$E(this.Zt), this.Jt = t, this.yt = i;
    }
    Pt() {
        this.xt = !0;
    }
    Tt(t) {
        return this.xt && (this.Rt(), this.xt = !1), this.Xt;
    }
    Rt() {
        const t = this.Jt.It(), i = this.yt.Qt().N().crosshair, n = this.Zt;
        if (2 === i.mode) return n.Kt.It = !1, void (n.Yt.It = !1);
        n.Kt.It = t && this.Jt.ti(this.yt), n.Yt.It = t && this.Jt.ii(), n.Kt.ct = i.horzLine.width, n.Kt.Gt = i.horzLine.style, n.Kt.R = i.horzLine.color, n.Yt.ct = i.vertLine.width, n.Yt.Gt = i.vertLine.style, n.Yt.R = i.vertLine.color, n._t = this.Jt.ni(), n.ut = this.Jt.si();
    }
}
function $8f74814242901c26$var$L(t, i, n, s, e, r) {
    t.fillRect(i + r, n, s - 2 * r, r), t.fillRect(i + r, n + e - r, s - 2 * r, r), t.fillRect(i, n, r, e), t.fillRect(i + s - r, n, r, e);
}
function $8f74814242901c26$var$z(t, i, n, s, e, r) {
    t.save(), t.globalCompositeOperation = "copy", t.fillStyle = r, t.fillRect(i, n, s, e), t.restore();
}
function $8f74814242901c26$var$O(t, i, n, s, e, r) {
    t.beginPath(), t.roundRect ? t.roundRect(i, n, s, e, r) : (t.lineTo(i + s - r[1], n), 0 !== r[1] && t.arcTo(i + s, n, i + s, n + r[1], r[1]), t.lineTo(i + s, n + e - r[2]), 0 !== r[2] && t.arcTo(i + s, n + e, i + s - r[2], n + e, r[2]), t.lineTo(i + r[3], n + e), 0 !== r[3] && t.arcTo(i, n + e, i, n + e - r[3], r[3]), t.lineTo(i, n + r[0]), 0 !== r[0] && t.arcTo(i, n, i + r[0], n, r[0]));
}
function $8f74814242901c26$var$N(t, i, n, s, e, r, h = 0, a = [
    0,
    0,
    0,
    0
], l = "") {
    if (t.save(), !h || !l || l === r) return $8f74814242901c26$var$O(t, i, n, s, e, a), t.fillStyle = r, t.fill(), void t.restore();
    const o = h / 2;
    var _;
    $8f74814242901c26$var$O(t, i + o, n + o, s - h, e - h, (_ = -o, a.map((t)=>0 === t ? t : t + _))), "transparent" !== r && (t.fillStyle = r, t.fill()), "transparent" !== l && (t.lineWidth = h, t.strokeStyle = l, t.closePath(), t.stroke()), t.restore();
}
function $8f74814242901c26$var$F(t, i, n, s, e, r, h) {
    t.save(), t.globalCompositeOperation = "copy";
    const a = t.createLinearGradient(0, 0, 0, e);
    a.addColorStop(0, r), a.addColorStop(1, h), t.fillStyle = a, t.fillRect(i, n, s, e), t.restore();
}
class $8f74814242901c26$var$W {
    constructor(t, i){
        this.ht(t, i);
    }
    ht(t, i) {
        this.qt = t, this.ei = i;
    }
    $t(t, i) {
        return this.qt.It ? t.P + t.A + t.I : 0;
    }
    st(t, i, n, s) {
        if (!this.qt.It || 0 === this.qt.ri.length) return;
        const e = this.qt.R, r = this.ei.Z, h = t.useBitmapCoordinateSpace((t)=>{
            const h = t.context;
            h.font = i.k;
            const a = this.hi(t, i, n, s), l = a.ai;
            return a.li ? $8f74814242901c26$var$N(h, l.oi, l._i, l.ui, l.ci, r, l.di, [
                l.ft,
                0,
                0,
                l.ft
            ], r) : $8f74814242901c26$var$N(h, l.fi, l._i, l.ui, l.ci, r, l.di, [
                0,
                l.ft,
                l.ft,
                0
            ], r), this.qt.pi && (h.fillStyle = e, h.fillRect(l.fi, l.mi, l.wi - l.fi, l.Mi)), this.qt.gi && (h.fillStyle = i.D, h.fillRect(a.li ? l.bi - l.di : 0, l._i, l.di, l.Si - l._i)), a;
        });
        t.useMediaCoordinateSpace(({ context: t })=>{
            const n = h.xi;
            t.font = i.k, t.textAlign = h.li ? "right" : "left", t.textBaseline = "middle", t.fillStyle = e, t.fillText(this.qt.ri, n.Ci, (n._i + n.Si) / 2 + n.yi);
        });
    }
    hi(t, i, n, s) {
        const { context: e, bitmapSize: r, mediaSize: h, horizontalPixelRatio: a, verticalPixelRatio: l } = t, o = this.qt.pi || !this.qt.Pi ? i.C : 0, _ = this.qt.ki ? i.S : 0, u = i.A + this.ei.Ti, c = i.I + this.ei.Ri, d = i.V, f = i.B, p = this.qt.ri, v = i.P, m = n.Di(e, p), w = Math.ceil(n.Ii(e, p)), M = v + u + c, g = i.S + d + f + w + o, b = Math.max(1, Math.floor(l));
        let S = Math.round(M * l);
        S % 2 != b % 2 && (S += 1);
        const x = _ > 0 ? Math.max(1, Math.floor(_ * a)) : 0, C = Math.round(g * a), y = Math.round(o * a), P = this.ei.Vi ?? this.ei.Bi ?? this.ei.Ei, k = Math.round(P * l) - Math.floor(.5 * l), T = Math.floor(k + b / 2 - S / 2), R = T + S, D = "right" === s, I = D ? h.width - _ : _, V = D ? r.width - x : x;
        let B, E, A;
        return D ? (B = V - C, E = V - y, A = I - o - d - _) : (B = V + C, E = V + y, A = I + o + d), {
            li: D,
            ai: {
                _i: T,
                mi: k,
                Si: R,
                ui: C,
                ci: S,
                ft: 2 * a,
                di: x,
                oi: B,
                fi: V,
                wi: E,
                Mi: b,
                bi: r.width
            },
            xi: {
                _i: T / l,
                Si: R / l,
                Ci: A,
                yi: m
            }
        };
    }
}
class $8f74814242901c26$var$H {
    constructor(t){
        this.Ai = {
            Ei: 0,
            Z: "#000",
            Ri: 0,
            Ti: 0
        }, this.Li = {
            ri: "",
            It: !1,
            pi: !0,
            Pi: !1,
            Ht: "",
            R: "#FFF",
            gi: !1,
            ki: !1
        }, this.zi = {
            ri: "",
            It: !1,
            pi: !1,
            Pi: !0,
            Ht: "",
            R: "#FFF",
            gi: !0,
            ki: !0
        }, this.xt = !0, this.Oi = new (t || $8f74814242901c26$var$W)(this.Li, this.Ai), this.Ni = new (t || $8f74814242901c26$var$W)(this.zi, this.Ai);
    }
    ri() {
        return this.Fi(), this.Li.ri;
    }
    Ei() {
        return this.Fi(), this.Ai.Ei;
    }
    Pt() {
        this.xt = !0;
    }
    $t(t, i = !1) {
        return Math.max(this.Oi.$t(t, i), this.Ni.$t(t, i));
    }
    Wi() {
        return this.Ai.Vi ?? null;
    }
    Hi() {
        return this.Ai.Vi ?? this.Ai.Bi ?? this.Ei();
    }
    Ui(t) {
        this.Ai.Bi = t ?? void 0;
    }
    $i() {
        return this.Fi(), this.Li.It || this.zi.It;
    }
    ji() {
        return this.Fi(), this.Li.It;
    }
    Tt(t) {
        return this.Fi(), this.Li.pi = this.Li.pi && t.N().ticksVisible, this.zi.pi = this.zi.pi && t.N().ticksVisible, this.Oi.ht(this.Li, this.Ai), this.Ni.ht(this.zi, this.Ai), this.Oi;
    }
    qi() {
        return this.Fi(), this.Oi.ht(this.Li, this.Ai), this.Ni.ht(this.zi, this.Ai), this.Ni;
    }
    Fi() {
        this.xt && (this.Li.pi = !0, this.zi.pi = !1, this.Yi(this.Li, this.zi, this.Ai));
    }
}
class $8f74814242901c26$var$U extends $8f74814242901c26$var$H {
    constructor(t, i, n){
        super(), this.Jt = t, this.Ki = i, this.Gi = n;
    }
    Yi(t, i, n) {
        if (t.It = !1, 2 === this.Jt.N().mode) return;
        const s = this.Jt.N().horzLine;
        if (!s.labelVisible) return;
        const e = this.Ki.Lt();
        if (!this.Jt.It() || this.Ki.Zi() || null === e) return;
        const r = this.Ki.Xi().G(s.labelBackgroundColor);
        n.Z = r.Z, t.R = r.X;
        const h = 2 / 12 * this.Ki.P();
        n.Ti = h, n.Ri = h;
        const a = this.Gi(this.Ki);
        n.Ei = a.Ei, t.ri = this.Ki.Ji(a.Mt, e), t.It = !0;
    }
}
const $8f74814242901c26$var$$ = /[1-9]/g;
class $8f74814242901c26$var$j {
    constructor(){
        this.qt = null;
    }
    ht(t) {
        this.qt = t;
    }
    st(t, i) {
        if (null === this.qt || !1 === this.qt.It || 0 === this.qt.ri.length) return;
        const n = t.useMediaCoordinateSpace(({ context: t })=>(t.font = i.k, Math.round(i.Qi.Ii(t, $8f74814242901c26$var$u(this.qt).ri, $8f74814242901c26$var$$))));
        if (n <= 0) return;
        const s = i.tn, e = n + 2 * s, r = e / 2, h = this.qt.nn;
        let a = this.qt.Ei, l = Math.floor(a - r) + .5;
        l < 0 ? (a += Math.abs(0 - l), l = Math.floor(a - r) + .5) : l + e > h && (a -= Math.abs(h - (l + e)), l = Math.floor(a - r) + .5);
        const o = l + e, _ = Math.ceil(0 + i.S + i.C + i.A + i.P + i.I);
        t.useBitmapCoordinateSpace(({ context: t, horizontalPixelRatio: n, verticalPixelRatio: s })=>{
            const e = $8f74814242901c26$var$u(this.qt);
            t.fillStyle = e.Z;
            const r = Math.round(l * n), h = Math.round(0 * s), a = Math.round(o * n), c = Math.round(_ * s), d = Math.round(2 * n);
            if (t.beginPath(), t.moveTo(r, h), t.lineTo(r, c - d), t.arcTo(r, c, r + d, c, d), t.lineTo(a - d, c), t.arcTo(a, c, a, c - d, d), t.lineTo(a, h), t.fill(), e.pi) {
                const r = Math.round(e.Ei * n), a = h, l = Math.round((a + i.C) * s);
                t.fillStyle = e.R;
                const o = Math.max(1, Math.floor(n)), _ = Math.floor(.5 * n);
                t.fillRect(r - _, a, o, l - a);
            }
        }), t.useMediaCoordinateSpace(({ context: t })=>{
            const n = $8f74814242901c26$var$u(this.qt), e = 0 + i.S + i.C + i.A + i.P / 2;
            t.font = i.k, t.textAlign = "left", t.textBaseline = "middle", t.fillStyle = n.R;
            const r = i.Qi.Di(t, "Apr0");
            t.translate(l + s, e + r), t.fillText(n.ri, 0, 0);
        });
    }
}
class $8f74814242901c26$var$q {
    constructor(t, i, n){
        this.xt = !0, this.Xt = new $8f74814242901c26$var$j, this.Zt = {
            It: !1,
            Z: "#4c525e",
            R: "white",
            ri: "",
            nn: 0,
            Ei: NaN,
            pi: !0
        }, this.Ct = t, this.sn = i, this.Gi = n;
    }
    Pt() {
        this.xt = !0;
    }
    Tt() {
        return this.xt && (this.Rt(), this.xt = !1), this.Xt.ht(this.Zt), this.Xt;
    }
    Rt() {
        const t = this.Zt;
        if (t.It = !1, 2 === this.Ct.N().mode) return;
        const i = this.Ct.N().vertLine;
        if (!i.labelVisible) return;
        const n = this.sn.Et();
        if (n.Zi()) return;
        t.nn = n.nn();
        const s = this.Gi();
        if (null === s) return;
        t.Ei = s.Ei;
        const e = n.en(this.Ct.Bt());
        t.ri = n.rn($8f74814242901c26$var$u(e)), t.It = !0;
        const r = this.sn.Xi().G(i.labelBackgroundColor);
        t.Z = r.Z, t.R = r.X, t.pi = n.N().ticksVisible;
    }
}
class $8f74814242901c26$var$Y {
    constructor(){
        this.hn = null, this.an = 0;
    }
    ln() {
        return this.an;
    }
    _n(t) {
        this.an = t;
    }
    Ft() {
        return this.hn;
    }
    un(t) {
        this.hn = t;
    }
    cn(t) {
        return [];
    }
    dn() {
        return [];
    }
    It() {
        return !0;
    }
}
var $8f74814242901c26$export$67315bc29c7dd713;
!function(t) {
    t[t.Normal = 0] = "Normal", t[t.Magnet = 1] = "Magnet", t[t.Hidden = 2] = "Hidden", t[t.MagnetOHLC = 3] = "MagnetOHLC";
}($8f74814242901c26$export$67315bc29c7dd713 || ($8f74814242901c26$export$67315bc29c7dd713 = {}));
class $8f74814242901c26$var$G extends $8f74814242901c26$var$Y {
    constructor(t, i){
        super(), this.yt = null, this.fn = NaN, this.pn = 0, this.vn = !1, this.mn = new Map, this.wn = !1, this.Mn = new WeakMap, this.gn = new WeakMap, this.bn = NaN, this.Sn = NaN, this.xn = NaN, this.Cn = NaN, this.sn = t, this.yn = i;
        this.Pn = ((t, i)=>(n)=>{
                const s = i(), e = t();
                if (n === $8f74814242901c26$var$u(this.yt).kn()) return {
                    Mt: e,
                    Ei: s
                };
                {
                    const t = $8f74814242901c26$var$u(n.Lt());
                    return {
                        Mt: n.Tn(s, t),
                        Ei: s
                    };
                }
            })(()=>this.fn, ()=>this.Sn);
        const n = ((t, i)=>()=>{
                const n = this.sn.Et().Rn(t()), s = i();
                return n && Number.isFinite(s) ? {
                    wt: n,
                    Ei: s
                } : null;
            })(()=>this.pn, ()=>this.ni());
        this.Dn = new $8f74814242901c26$var$q(this, t, n);
    }
    N() {
        return this.yn;
    }
    In(t, i) {
        this.xn = t, this.Cn = i;
    }
    Vn() {
        this.xn = NaN, this.Cn = NaN;
    }
    Bn() {
        return this.xn;
    }
    En() {
        return this.Cn;
    }
    An(t, i, n) {
        this.wn || (this.wn = !0), this.vn = !0, this.Ln(t, i, n);
    }
    Bt() {
        return this.pn;
    }
    ni() {
        return this.bn;
    }
    si() {
        return this.Sn;
    }
    It() {
        return this.vn;
    }
    zn() {
        this.vn = !1, this.On(), this.fn = NaN, this.bn = NaN, this.Sn = NaN, this.yt = null, this.Vn(), this.Nn();
    }
    Fn(t) {
        if (!this.yn.doNotSnapToHiddenSeriesIndices) return t;
        const i = this.sn, n = i.Et();
        let s = null, e = null;
        for (const n of i.Wn()){
            const i = n.Un().Hn(t, -1);
            if (i) {
                if (i.$n === t) return t;
                (null === s || i.$n > s) && (s = i.$n);
            }
            const r = n.Un().Hn(t, 1);
            if (r) {
                if (r.$n === t) return t;
                (null === e || r.$n < e) && (e = r.$n);
            }
        }
        const r = [
            s,
            e
        ].filter($8f74814242901c26$var$g);
        if (0 === r.length) return t;
        const h = n.jt(t), a = r.map((t)=>Math.abs(h - n.jt(t)));
        return r[a.indexOf(Math.min(...a))];
    }
    jn(t) {
        let i = this.Mn.get(t);
        i || (i = new $8f74814242901c26$var$A(this, t), this.Mn.set(t, i));
        let n = this.gn.get(t);
        return n || (n = new $8f74814242901c26$var$B(this.sn, this, t), this.gn.set(t, n)), [
            i,
            n
        ];
    }
    ti(t) {
        return t === this.yt && this.yn.horzLine.visible;
    }
    ii() {
        return this.yn.vertLine.visible;
    }
    qn(t, i) {
        this.vn && this.yt === t || this.mn.clear();
        const n = [];
        return this.yt === t && n.push(this.Yn(this.mn, i, this.Pn)), n;
    }
    dn() {
        return this.vn ? [
            this.Dn
        ] : [];
    }
    Kn() {
        return this.yt;
    }
    Nn() {
        this.sn.Gn().forEach((t)=>{
            this.Mn.get(t)?.Pt(), this.gn.get(t)?.Pt();
        }), this.mn.forEach((t)=>t.Pt()), this.Dn.Pt();
    }
    Zn(t) {
        return t && !t.kn().Zi() ? t.kn() : null;
    }
    Ln(t, i, n) {
        this.Xn(t, i, n) && this.Nn();
    }
    Xn(t, i, n) {
        const s = this.bn, e = this.Sn, r = this.fn, h = this.pn, a = this.yt, l = this.Zn(n);
        this.pn = t, this.bn = isNaN(t) ? NaN : this.sn.Et().jt(t), this.yt = n;
        const o = null !== l ? l.Lt() : null;
        return null !== l && null !== o ? (this.fn = i, this.Sn = l.Nt(i, o)) : (this.fn = NaN, this.Sn = NaN), s !== this.bn || e !== this.Sn || h !== this.pn || r !== this.fn || a !== this.yt;
    }
    On() {
        const t = this.sn.Jn().map((t)=>t.Un().Qn()).filter($8f74814242901c26$var$g), i = 0 === t.length ? null : Math.max(...t);
        this.pn = null !== i ? i : NaN;
    }
    Yn(t, i, n) {
        let s = t.get(i);
        return void 0 === s && (s = new $8f74814242901c26$var$U(this, i, n), t.set(i, s)), s;
    }
}
function $8f74814242901c26$var$Z(t) {
    return "left" === t || "right" === t;
}
class $8f74814242901c26$var$X {
    constructor(t){
        this.ts = new Map, this.ns = [], this.ss = t;
    }
    es(t, i) {
        const n = function(t, i) {
            return void 0 === t ? i : {
                rs: Math.max(t.rs, i.rs),
                hs: t.hs || i.hs
            };
        }(this.ts.get(t), i);
        this.ts.set(t, n);
    }
    ls() {
        return this.ss;
    }
    _s(t) {
        const i = this.ts.get(t);
        return void 0 === i ? {
            rs: this.ss
        } : {
            rs: Math.max(this.ss, i.rs),
            hs: i.hs
        };
    }
    us() {
        this.cs(), this.ns = [
            {
                ds: 0
            }
        ];
    }
    fs(t) {
        this.cs(), this.ns = [
            {
                ds: 1,
                Wt: t
            }
        ];
    }
    ps(t) {
        this.vs(), this.ns.push({
            ds: 5,
            Wt: t
        });
    }
    cs() {
        this.vs(), this.ns.push({
            ds: 6
        });
    }
    ws() {
        this.cs(), this.ns = [
            {
                ds: 4
            }
        ];
    }
    Ms(t) {
        this.cs(), this.ns.push({
            ds: 2,
            Wt: t
        });
    }
    gs(t) {
        this.cs(), this.ns.push({
            ds: 3,
            Wt: t
        });
    }
    bs() {
        return this.ns;
    }
    Ss(t) {
        for (const i of t.ns)this.xs(i);
        this.ss = Math.max(this.ss, t.ss), t.ts.forEach((t, i)=>{
            this.es(i, t);
        });
    }
    static Cs() {
        return new $8f74814242901c26$var$X(2);
    }
    static ys() {
        return new $8f74814242901c26$var$X(3);
    }
    xs(t) {
        switch(t.ds){
            case 0:
                this.us();
                break;
            case 1:
                this.fs(t.Wt);
                break;
            case 2:
                this.Ms(t.Wt);
                break;
            case 3:
                this.gs(t.Wt);
                break;
            case 4:
                this.ws();
                break;
            case 5:
                this.ps(t.Wt);
                break;
            case 6:
                this.vs();
        }
    }
    vs() {
        const t = this.ns.findIndex((t)=>5 === t.ds);
        -1 !== t && this.ns.splice(t, 1);
    }
}
class $8f74814242901c26$var$J {
    formatTickmarks(t) {
        return t.map((t)=>this.format(t));
    }
}
const $8f74814242901c26$var$Q = ".";
function $8f74814242901c26$var$tt(t, i) {
    if (!$8f74814242901c26$var$p(t)) return "n/a";
    if (!$8f74814242901c26$var$v(i)) throw new TypeError("invalid length");
    if (i < 0 || i > 16) throw new TypeError("invalid length");
    if (0 === i) return t.toString();
    return ("0000000000000000" + t.toString()).slice(-i);
}
class $8f74814242901c26$var$it extends $8f74814242901c26$var$J {
    constructor(t, i){
        if (super(), i || (i = 1), $8f74814242901c26$var$p(t) && $8f74814242901c26$var$v(t) || (t = 100), t < 0) throw new TypeError("invalid base");
        this.Ki = t, this.Ps = i, this.ks();
    }
    format(t) {
        const i = t < 0 ? "\u2212" : "";
        return t = Math.abs(t), i + this.Ts(t);
    }
    ks() {
        if (this.Rs = 0, this.Ki > 0 && this.Ps > 0) {
            let t = this.Ki;
            for(; t > 1;)t /= 10, this.Rs++;
        }
    }
    Ts(t) {
        const i = this.Ki / this.Ps;
        let n = Math.floor(t), s = "";
        const e = void 0 !== this.Rs ? this.Rs : NaN;
        if (i > 1) {
            let r = +(Math.round(t * i) - n * i).toFixed(this.Rs);
            r >= i && (r -= i, n += 1), s = $8f74814242901c26$var$Q + $8f74814242901c26$var$tt(+r.toFixed(this.Rs) * this.Ps, e);
        } else n = Math.round(n * i) / i, e > 0 && (s = $8f74814242901c26$var$Q + $8f74814242901c26$var$tt(0, e));
        return n.toFixed(0) + s;
    }
}
class $8f74814242901c26$var$nt extends $8f74814242901c26$var$it {
    constructor(t = 100){
        super(t);
    }
    format(t) {
        return `${super.format(t)}%`;
    }
}
class $8f74814242901c26$var$st extends $8f74814242901c26$var$J {
    constructor(t){
        super(), this.Ds = t;
    }
    format(t) {
        let i = "";
        return t < 0 && (i = "-", t = -t), t < 995 ? i + this.Is(t) : t < 999995 ? i + this.Is(t / 1e3) + "K" : t < 999999995 ? (t = 1e3 * Math.round(t / 1e3), i + this.Is(t / 1e6) + "M") : (t = 1e6 * Math.round(t / 1e6), i + this.Is(t / 1e9) + "B");
    }
    Is(t) {
        let i;
        const n = Math.pow(10, this.Ds);
        return i = (t = Math.round(t * n) / n) >= 1e-15 && t < 1 ? t.toFixed(this.Ds).replace(/\.?0+$/, "") : String(t), i.replace(/(\.[1-9]*)0+$/, (t, i)=>i);
    }
}
const $8f74814242901c26$var$et = /[2-9]/g;
class $8f74814242901c26$var$rt {
    constructor(t = 50){
        this.Vs = 0, this.Bs = 1, this.Es = 1, this.As = {}, this.Ls = new Map, this.zs = t;
    }
    Os() {
        this.Vs = 0, this.Ls.clear(), this.Bs = 1, this.Es = 1, this.As = {};
    }
    Ii(t, i, n) {
        return this.Ns(t, i, n).width;
    }
    Di(t, i, n) {
        const s = this.Ns(t, i, n);
        return ((s.actualBoundingBoxAscent || 0) - (s.actualBoundingBoxDescent || 0)) / 2;
    }
    Ns(t, i, n) {
        const s = n || $8f74814242901c26$var$et, e = String(i).replace(s, "0");
        if (this.Ls.has(e)) return $8f74814242901c26$var$_(this.Ls.get(e)).Fs;
        if (this.Vs === this.zs) {
            const t = this.As[this.Es];
            delete this.As[this.Es], this.Ls.delete(t), this.Es++, this.Vs--;
        }
        t.save(), t.textBaseline = "middle";
        const r = t.measureText(e);
        return t.restore(), 0 === r.width && i.length || (this.Ls.set(e, {
            Fs: r,
            Ws: this.Bs
        }), this.As[this.Bs] = e, this.Vs++, this.Bs++), r;
    }
}
class $8f74814242901c26$var$ht {
    constructor(t){
        this.Hs = null, this.M = null, this.Us = "right", this.$s = t;
    }
    js(t, i, n) {
        this.Hs = t, this.M = i, this.Us = n;
    }
    st(t) {
        null !== this.M && null !== this.Hs && this.Hs.st(t, this.M, this.$s, this.Us);
    }
}
class $8f74814242901c26$var$at {
    constructor(t, i, n){
        this.qs = t, this.$s = new $8f74814242901c26$var$rt(50), this.Ys = i, this.O = n, this.F = -1, this.Xt = new $8f74814242901c26$var$ht(this.$s);
    }
    Tt() {
        const t = this.O.Ks(this.Ys);
        if (null === t) return null;
        const i = t.Gs(this.Ys) ? t.Zs() : this.Ys.Ft();
        if (null === i) return null;
        const n = t.Xs(i);
        if ("overlay" === n) return null;
        const s = this.O.Js();
        return s.P !== this.F && (this.F = s.P, this.$s.Os()), this.Xt.js(this.qs.qi(), s, n), this.Xt;
    }
}
class $8f74814242901c26$var$lt extends $8f74814242901c26$var$R {
    constructor(){
        super(...arguments), this.qt = null;
    }
    ht(t) {
        this.qt = t;
    }
    Qs(t, i) {
        if (!this.qt?.It) return null;
        const { ut: n, ct: s, te: e } = this.qt;
        return i >= n - s - 7 && i <= n + s + 7 ? {
            ie: this.qt,
            ne: Math.abs(i - n),
            se: 2,
            ee: "price-line",
            te: e
        } : null;
    }
    et({ context: t, bitmapSize: i, horizontalPixelRatio: n, verticalPixelRatio: s }) {
        if (null === this.qt) return;
        if (!1 === this.qt.It) return;
        const e = Math.round(this.qt.ut * s);
        e < 0 || e > i.height || (t.lineCap = "butt", t.strokeStyle = this.qt.R, t.lineWidth = Math.floor(this.qt.ct * n), $8f74814242901c26$var$a(t, this.qt.Gt), $8f74814242901c26$var$l(t, e, 0, i.width));
    }
}
class $8f74814242901c26$var$ot {
    constructor(t){
        this.re = {
            ut: 0,
            R: "rgba(0, 0, 0, 0)",
            ct: 1,
            Gt: 0,
            It: !1
        }, this.he = new $8f74814242901c26$var$lt, this.xt = !0, this.ae = t, this.le = t.Qt(), this.he.ht(this.re);
    }
    Pt() {
        this.xt = !0;
    }
    Tt() {
        return this.ae.It() ? (this.xt && (this.oe(), this.xt = !1), this.he) : null;
    }
}
class $8f74814242901c26$var$_t extends $8f74814242901c26$var$ot {
    constructor(t){
        super(t);
    }
    oe() {
        this.re.It = !1;
        const t = this.ae.Ft(), i = t._e()._e;
        if (2 !== i && 3 !== i) return;
        const n = this.ae.N();
        if (!n.baseLineVisible || !this.ae.It()) return;
        const s = this.ae.Lt();
        null !== s && (this.re.It = !0, this.re.ut = t.Nt(s.Wt, s.Wt), this.re.R = n.baseLineColor, this.re.ct = n.baseLineWidth, this.re.Gt = n.baseLineStyle);
    }
}
class $8f74814242901c26$var$ut extends $8f74814242901c26$var$R {
    constructor(){
        super(...arguments), this.qt = null;
    }
    ht(t) {
        this.qt = t;
    }
    ue() {
        return this.qt;
    }
    et({ context: t, horizontalPixelRatio: i, verticalPixelRatio: n }) {
        const s = this.qt;
        if (null === s) return;
        const e = Math.max(1, Math.floor(i)), r = e % 2 / 2, h = Math.round(s.ce.x * i) + r, a = s.ce.y * n;
        t.fillStyle = s.de, t.beginPath();
        const l = Math.max(2, 1.5 * s.fe) * i;
        t.arc(h, a, l, 0, 2 * Math.PI, !1), t.fill(), t.fillStyle = s.pe, t.beginPath(), t.arc(h, a, s.ft * i, 0, 2 * Math.PI, !1), t.fill(), t.lineWidth = e, t.strokeStyle = s.ve, t.beginPath(), t.arc(h, a, s.ft * i + e / 2, 0, 2 * Math.PI, !1), t.stroke();
    }
}
const $8f74814242901c26$var$ct = [
    {
        me: 0,
        we: .25,
        Me: 4,
        ge: 10,
        be: .25,
        Se: 0,
        xe: .4,
        Ce: .8
    },
    {
        me: .25,
        we: .525,
        Me: 10,
        ge: 14,
        be: 0,
        Se: 0,
        xe: .8,
        Ce: 0
    },
    {
        me: .525,
        we: 1,
        Me: 14,
        ge: 14,
        be: 0,
        Se: 0,
        xe: 0,
        Ce: 0
    }
];
class $8f74814242901c26$var$dt {
    constructor(t){
        this.Xt = new $8f74814242901c26$var$ut, this.xt = !0, this.ye = !0, this.Pe = performance.now(), this.ke = this.Pe - 1, this.Te = t;
    }
    Re() {
        this.ke = this.Pe - 1, this.Pt();
    }
    De() {
        if (this.Pt(), 2 === this.Te.N().lastPriceAnimation) {
            const t = performance.now(), i = this.ke - t;
            if (i > 0) return void (i < 650 && (this.ke += 2600));
            this.Pe = t, this.ke = t + 2600;
        }
    }
    Pt() {
        this.xt = !0;
    }
    Ie() {
        this.ye = !0;
    }
    It() {
        return 0 !== this.Te.N().lastPriceAnimation;
    }
    Ve() {
        switch(this.Te.N().lastPriceAnimation){
            case 0:
                return !1;
            case 1:
                return !0;
            case 2:
                return performance.now() <= this.ke;
        }
    }
    Tt() {
        return this.xt ? (this.Rt(), this.xt = !1, this.ye = !1) : this.ye && (this.Be(), this.ye = !1), this.Xt;
    }
    Rt() {
        this.Xt.ht(null);
        const t = this.Te.Qt().Et(), i = t.Ee(), n = this.Te.Lt();
        if (null === i || null === n) return;
        const s = this.Te.Ae(!0);
        if (s.Le || !i.ze(s.$n)) return;
        const e = {
            x: t.jt(s.$n),
            y: this.Te.Ft().Nt(s.Mt, n.Wt)
        }, r = s.R, h = this.Te.N().lineWidth, a = this.Oe(this.Ne(), r);
        this.Xt.ht({
            de: r,
            fe: h,
            pe: a.pe,
            ve: a.ve,
            ft: a.ft,
            ce: e
        });
    }
    Be() {
        const t = this.Xt.ue();
        if (null !== t) {
            const i = this.Oe(this.Ne(), t.de);
            t.pe = i.pe, t.ve = i.ve, t.ft = i.ft;
        }
    }
    Ne() {
        return this.Ve() ? performance.now() - this.Pe : 2599;
    }
    Fe(t, i, n, s) {
        const e = n + (s - n) * i;
        return this.Te.Qt().Xi().Y(t, e);
    }
    Oe(t, i) {
        const n = t % 2600 / 2600;
        let s;
        for (const t of $8f74814242901c26$var$ct)if (n >= t.me && n <= t.we) {
            s = t;
            break;
        }
        $8f74814242901c26$var$o(void 0 !== s, "Last price animation internal logic error");
        const e = (n - s.me) / (s.we - s.me);
        var r, h, a;
        return {
            pe: this.Fe(i, e, s.be, s.Se),
            ve: this.Fe(i, e, s.xe, s.Ce),
            ft: (r = e, h = s.Me, a = s.ge, h + (a - h) * r)
        };
    }
}
class $8f74814242901c26$var$ft extends $8f74814242901c26$var$ot {
    constructor(t){
        super(t);
    }
    oe() {
        const t = this.re;
        t.It = !1;
        const i = this.ae.N();
        if (!i.priceLineVisible || !this.ae.It()) return;
        const n = this.ae.Ae(0 === i.priceLineSource);
        n.Le || (t.It = !0, t.ut = n.Ei, t.R = this.ae.We(n.R), t.ct = i.priceLineWidth, t.Gt = i.priceLineStyle);
    }
}
class $8f74814242901c26$var$pt extends $8f74814242901c26$var$H {
    constructor(t){
        super(), this.Jt = t;
    }
    Yi(t, i, n) {
        t.It = !1, i.It = !1;
        const s = this.Jt;
        if (!s.It()) return;
        const e = s.N(), r = e.lastValueVisible, h = "" !== s.He(), a = 0 === e.seriesLastValueMode, l = s.Ae(!1);
        if (l.Le) return;
        r && (t.ri = this.Ue(l, r, a), t.It = 0 !== t.ri.length), (h || a) && (i.ri = this.$e(l, r, h, a), i.It = i.ri.length > 0);
        const o = s.We(l.R), _ = this.Jt.Qt().Xi().G(o);
        n.Z = _.Z, n.Ei = l.Ei, i.Ht = s.Qt().Ut(l.Ei / s.Ft().$t()), t.Ht = o, t.R = _.X, i.R = _.X;
    }
    $e(t, i, n, s) {
        let e = "";
        const r = this.Jt.He();
        return n && 0 !== r.length && (e += `${r} `), i && s && (e += this.Jt.Ft().je() ? t.qe : t.Ye), e.trim();
    }
    Ue(t, i, n) {
        return i ? n ? this.Jt.Ft().je() ? t.Ye : t.qe : t.ri : "";
    }
}
function $8f74814242901c26$var$vt(t, i, n, s) {
    const e = Number.isFinite(i), r = Number.isFinite(n);
    return e && r ? t(i, n) : e || r ? e ? i : n : s;
}
class $8f74814242901c26$var$mt {
    constructor(t, i){
        this.Ke = t, this.Ge = i;
    }
    Ze(t) {
        return null !== t && this.Ke === t.Ke && this.Ge === t.Ge;
    }
    Xe() {
        return new $8f74814242901c26$var$mt(this.Ke, this.Ge);
    }
    Je() {
        return this.Ke;
    }
    Qe() {
        return this.Ge;
    }
    tr() {
        return this.Ge - this.Ke;
    }
    Zi() {
        return this.Ge === this.Ke || Number.isNaN(this.Ge) || Number.isNaN(this.Ke);
    }
    Ss(t) {
        return null === t ? this : new $8f74814242901c26$var$mt($8f74814242901c26$var$vt(Math.min, this.Je(), t.Je(), -1 / 0), $8f74814242901c26$var$vt(Math.max, this.Qe(), t.Qe(), 1 / 0));
    }
    ir(t) {
        if (!$8f74814242901c26$var$p(t)) return;
        if (0 === this.Ge - this.Ke) return;
        const i = .5 * (this.Ge + this.Ke);
        let n = this.Ge - i, s = this.Ke - i;
        n *= t, s *= t, this.Ge = i + n, this.Ke = i + s;
    }
    nr(t) {
        $8f74814242901c26$var$p(t) && (this.Ge += t, this.Ke += t);
    }
    sr() {
        return {
            minValue: this.Ke,
            maxValue: this.Ge
        };
    }
    static er(t) {
        return null === t ? null : new $8f74814242901c26$var$mt(t.minValue, t.maxValue);
    }
}
class $8f74814242901c26$var$wt {
    constructor(t, i){
        this.rr = t, this.hr = i || null;
    }
    ar() {
        return this.rr;
    }
    lr() {
        return this.hr;
    }
    sr() {
        return {
            priceRange: null === this.rr ? null : this.rr.sr(),
            margins: this.hr || void 0
        };
    }
    static er(t) {
        return null === t ? null : new $8f74814242901c26$var$wt($8f74814242901c26$var$mt.er(t.priceRange), t.margins);
    }
}
const $8f74814242901c26$var$Mt = [
    2,
    4,
    8,
    16,
    32,
    64,
    128,
    256,
    512
], $8f74814242901c26$var$gt = "Custom series with conflation reducer must have a priceValueBuilder method";
class $8f74814242901c26$var$bt extends $8f74814242901c26$var$ot {
    constructor(t, i){
        super(t), this._r = i;
    }
    oe() {
        const t = this.re;
        t.It = !1;
        const i = this._r.N();
        if (!this.ae.It() || !i.lineVisible) return;
        const n = this._r.ur();
        null !== n && (t.It = !0, t.ut = n, t.R = i.color, t.ct = i.lineWidth, t.Gt = i.lineStyle, t.te = this._r.N().id);
    }
}
class $8f74814242901c26$var$St extends $8f74814242901c26$var$H {
    constructor(t, i){
        super(), this.Te = t, this._r = i;
    }
    Yi(t, i, n) {
        t.It = !1, i.It = !1;
        const s = this._r.N(), e = s.axisLabelVisible, r = "" !== s.title, h = this.Te;
        if (!e || !h.It()) return;
        const a = this._r.ur();
        if (null === a) return;
        r && (i.ri = s.title, i.It = !0), i.Ht = h.Qt().Ut(a / h.Ft().$t()), t.ri = this.cr(s.price), t.It = !0;
        const l = this.Te.Qt().Xi().G(s.axisLabelColor || s.color);
        n.Z = l.Z;
        const o = s.axisLabelTextColor || l.X;
        t.R = o, i.R = o, n.Ei = a;
    }
    cr(t) {
        const i = this.Te.Lt();
        return null === i ? "" : this.Te.Ft().Ji(t, i.Wt);
    }
}
class $8f74814242901c26$var$xt {
    constructor(t, i){
        this.Te = t, this.yn = i, this.dr = new $8f74814242901c26$var$bt(t, this), this.qs = new $8f74814242901c26$var$St(t, this), this.pr = new $8f74814242901c26$var$at(this.qs, t, t.Qt());
    }
    vr(t) {
        $8f74814242901c26$var$f(this.yn, t), this.Pt(), this.Te.Qt().mr();
    }
    N() {
        return this.yn;
    }
    wr() {
        return this.dr;
    }
    Mr() {
        return this.pr;
    }
    gr() {
        return this.qs;
    }
    Pt() {
        this.dr.Pt(), this.qs.Pt();
    }
    ur() {
        const t = this.Te, i = t.Ft();
        if (t.Qt().Et().Zi() || i.Zi()) return null;
        const n = t.Lt();
        return null === n ? null : i.Nt(this.yn.price, n.Wt);
    }
}
class $8f74814242901c26$var$Ct {
    constructor(){
        this.br = new WeakMap;
    }
    Sr(t, i, n) {
        const s = 1 / i * n;
        if (t >= s) return 1;
        const e = s / t, r = Math.pow(2, Math.floor(Math.log2(e)));
        return Math.min(r, 512);
    }
    Cr(t, i, n, s = !1, e) {
        if (0 === t.length || i <= 1) return t;
        const r = this.yr(i);
        if (r <= 1) return t;
        const h = this.Pr(t);
        let a = h.kr.get(r);
        return void 0 !== a || (a = this.Tr(t, r, n, s, e, h.kr), h.kr.set(r, a)), a;
    }
    Rr(t, i, n, s, e = !1, r) {
        if (n < 1 || 0 === t.length) return t;
        const h = this.Pr(t), a = h.kr.get(n);
        if (!a) return this.Cr(t, n, s, e, r);
        const l = this.Dr(t, i, n, a, e, s, r);
        return h.kr.set(n, l), l;
    }
    yr(t) {
        if (t <= 2) return 2;
        for (const i of $8f74814242901c26$var$Mt)if (t <= i) return i;
        return 512;
    }
    Ir(t) {
        if (0 === t.length) return 0;
        const i = t[0], n = t[t.length - 1];
        return 31 * t.length + 17 * i.$n + 13 * n.$n;
    }
    Tr(t, i, n, s = !1, e, r = new Map) {
        if (2 === i) return this.Vr(t, 2, n, s, e);
        const h = i / 2;
        let a = r.get(h);
        return a || (a = this.Tr(t, h, n, s, e, r), r.set(h, a)), this.Br(a, n, s, e);
    }
    Vr(t, i, n, s = !1, e) {
        const r = this.Er(t, i, n, s, e);
        return this.Ar(r, s);
    }
    Br(t, i, n = !1, s) {
        const e = this.Er(t, 2, i, n, s);
        return this.Ar(e, n);
    }
    Er(t, i, n, s = !1, e) {
        const r = [];
        for(let h = 0; h < t.length; h += i){
            if (t.length - h >= i) {
                const i = this.Lr(t[h], t[h + 1], n, s, e);
                i.zr = !1, r.push(i);
            } else if (0 === r.length) r.push(this.Or(t[h], !0));
            else {
                const i = r[r.length - 1];
                r[r.length - 1] = this.Nr(i, t[h], n, s, e);
            }
        }
        return r;
    }
    Fr(t, i) {
        return (t ?? 1) + (i ?? 1);
    }
    Lr(t, i, n, s = !1, e) {
        if (!s || !n || !e) {
            const n = t.Wt[1] > i.Wt[1] ? t.Wt[1] : i.Wt[1], s = t.Wt[2] < i.Wt[2] ? t.Wt[2] : i.Wt[2];
            return {
                Wr: t.$n,
                Hr: i.$n,
                Ur: t.wt,
                $r: i.wt,
                jr: t.Wt[0],
                qr: n,
                Yr: s,
                Kr: i.Wt[3],
                Gr: this.Fr(t.Gr, i.Gr),
                Zr: void 0,
                zr: !1
            };
        }
        const r = n(this.Xr(t, e), this.Xr(i, e)), h = e(r), a = h.length ? h[h.length - 1] : 0;
        return {
            Wr: t.$n,
            Hr: i.$n,
            Ur: t.wt,
            $r: i.wt,
            jr: t.Wt[0],
            qr: Math.max(t.Wt[1], a),
            Yr: Math.min(t.Wt[2], a),
            Kr: a,
            Gr: this.Fr(t.Gr, i.Gr),
            Zr: r,
            zr: !1
        };
    }
    Nr(t, i, n, s = !1, e) {
        if (!s || !n || !e) return {
            Wr: t.Wr,
            Hr: i.$n,
            Ur: t.Ur,
            $r: i.wt,
            jr: t.jr,
            qr: t.qr > i.Wt[1] ? t.qr : i.Wt[1],
            Yr: t.Yr < i.Wt[2] ? t.Yr : i.Wt[2],
            Kr: i.Wt[3],
            Gr: t.Gr + (i.Gr ?? 1),
            Zr: t.Zr,
            zr: !1
        };
        const r = t.Zr, h = this.Xr(i, e), a = r ? {
            data: r,
            index: t.Wr,
            originalTime: t.Ur,
            time: t.Ur,
            priceValues: e(r)
        } : null, l = a ? n(a, h) : h.data, o = a ? e(l) : h.priceValues, _ = o.length ? o[o.length - 1] : 0;
        return {
            Wr: t.Wr,
            Hr: i.$n,
            Ur: t.Ur,
            $r: i.wt,
            jr: t.jr,
            qr: Math.max(t.qr, _),
            Yr: Math.min(t.Yr, _),
            Kr: _,
            Gr: t.Gr + (i.Gr ?? 1),
            Zr: l,
            zr: !1
        };
    }
    Jr(t, i, n, s, e, r, h = !1, a) {
        const l = i === s ? e : t[i];
        if (n - i == 1) return this.Or(l, !0);
        const o = i + 1 === s ? e : t[i + 1];
        let _ = this.Lr(l, o, r, h, a);
        for(let l = i + 2; l < n; l++){
            const i = l === s ? e : t[l];
            _ = this.Nr(_, i, r, h, a);
        }
        return _;
    }
    Xr(t, i) {
        const n = t.ue ?? {};
        return {
            data: t.ue,
            index: t.$n,
            originalTime: t.Qr,
            time: t.wt,
            priceValues: i(n)
        };
    }
    th(t, i = !1) {
        const n = !0 === i, s = !!t.Zr;
        return {
            $n: t.Wr,
            wt: t.Ur,
            Qr: t.Ur,
            Wt: [
                n ? t.Kr : t.jr,
                t.qr,
                t.Yr,
                t.Kr
            ],
            Gr: t.Gr,
            ue: n ? s ? t.Zr : {
                wt: t.Ur
            } : void 0
        };
    }
    Ar(t, i = !1) {
        return t.map((t)=>this.th(t, i));
    }
    Dr(t, i, n, s, e = !1, r, h) {
        if (0 === s.length) return s;
        const a = t.length - 1, l = Math.floor(a / n) * n;
        if (Math.min(l + n, t.length) - l < n && t.length > n) {
            const s = t.slice();
            return s[s.length - 1] = i, this.Cr(s, n, r, e, h);
        }
        if (Math.floor((a - 1) / n) === Math.floor(a / n) || 1 === s.length) {
            const o = Math.min(l + n, t.length), _ = o - l;
            if (_ <= 0) return s;
            const u = 1 === _ ? this.Or(l === a ? i : t[l], !0) : this.Jr(t, l, o, a, i, r, e, h);
            return s[s.length - 1] = this.th(u, e), s;
        }
        {
            const s = t.slice();
            return s[s.length - 1] = i, this.Cr(s, n, r, e, h);
        }
    }
    Or(t, i = !1) {
        return {
            Wr: t.$n,
            Hr: t.$n,
            Ur: t.wt,
            $r: t.wt,
            jr: t.Wt[0],
            qr: t.Wt[1],
            Yr: t.Wt[2],
            Kr: t.Wt[3],
            Gr: t.Gr ?? 1,
            Zr: t.ue,
            zr: i
        };
    }
    Pr(t) {
        const i = this.ih(t), n = this.Ir(t);
        return i.nh !== n && (i.kr.clear(), i.nh = n), i;
    }
    ih(t) {
        let i = this.br.get(t);
        return void 0 === i && (i = {
            nh: this.Ir(t),
            kr: new Map
        }, this.br.set(t, i)), i;
    }
}
class $8f74814242901c26$var$yt extends $8f74814242901c26$var$Y {
    constructor(t){
        super(), this.sn = t;
    }
    Qt() {
        return this.sn;
    }
}
const $8f74814242901c26$var$Pt = {
    Bar: (t, i, n, s)=>{
        const e = i.upColor, r = i.downColor, h = $8f74814242901c26$var$u(t(n, s)), a = $8f74814242901c26$var$c(h.Wt[0]) <= $8f74814242901c26$var$c(h.Wt[3]);
        return {
            sh: h.R ?? (a ? e : r)
        };
    },
    Candlestick: (t, i, n, s)=>{
        const e = i.upColor, r = i.downColor, h = i.borderUpColor, a = i.borderDownColor, l = i.wickUpColor, o = i.wickDownColor, _ = $8f74814242901c26$var$u(t(n, s)), d = $8f74814242901c26$var$c(_.Wt[0]) <= $8f74814242901c26$var$c(_.Wt[3]);
        return {
            sh: _.R ?? (d ? e : r),
            eh: _.Ht ?? (d ? h : a),
            rh: _.hh ?? (d ? l : o)
        };
    },
    Custom: (t, i, n, s)=>({
            sh: $8f74814242901c26$var$u(t(n, s)).R ?? i.color
        }),
    Area: (t, i, n, s)=>{
        const e = $8f74814242901c26$var$u(t(n, s));
        return {
            sh: e.vt ?? i.lineColor,
            vt: e.vt ?? i.lineColor,
            ah: e.ah ?? i.topColor,
            oh: e.oh ?? i.bottomColor
        };
    },
    Baseline: (t, i, n, s)=>{
        const e = $8f74814242901c26$var$u(t(n, s));
        return {
            sh: e.Wt[3] >= i.baseValue.price ? i.topLineColor : i.bottomLineColor,
            _h: e._h ?? i.topLineColor,
            uh: e.uh ?? i.bottomLineColor,
            dh: e.dh ?? i.topFillColor1,
            fh: e.fh ?? i.topFillColor2,
            ph: e.ph ?? i.bottomFillColor1,
            mh: e.mh ?? i.bottomFillColor2
        };
    },
    Line: (t, i, n, s)=>{
        const e = $8f74814242901c26$var$u(t(n, s));
        return {
            sh: e.R ?? i.color,
            vt: e.R ?? i.color
        };
    },
    Histogram: (t, i, n, s)=>({
            sh: $8f74814242901c26$var$u(t(n, s)).R ?? i.color
        })
};
class $8f74814242901c26$var$kt {
    constructor(t){
        this.wh = (t, i)=>void 0 !== i ? i.Wt : this.Te.Un().Mh(t), this.Te = t, this.gh = $8f74814242901c26$var$Pt[t.bh()];
    }
    Sh(t, i) {
        return this.gh(this.wh, this.Te.N(), t, i);
    }
}
function $8f74814242901c26$var$Tt(t, i, n, s, e = 0, r = i.length) {
    let h = r - e;
    for(; 0 < h;){
        const r = h >> 1, a = e + r;
        s(i[a], n) === t ? (e = a + 1, h -= r + 1) : h = r;
    }
    return e;
}
const $8f74814242901c26$var$Rt = $8f74814242901c26$var$Tt.bind(null, !0), $8f74814242901c26$var$Dt = $8f74814242901c26$var$Tt.bind(null, !1);
var $8f74814242901c26$export$452387148ad6f8a7;
!function(t) {
    t[t.NearestLeft = -1] = "NearestLeft", t[t.None = 0] = "None", t[t.NearestRight = 1] = "NearestRight";
}($8f74814242901c26$export$452387148ad6f8a7 || ($8f74814242901c26$export$452387148ad6f8a7 = {}));
const $8f74814242901c26$var$Vt = 30;
class $8f74814242901c26$var$Bt {
    constructor(){
        this.xh = [], this.Ch = new Map, this.yh = new Map, this.Ph = [];
    }
    kh() {
        return this.Th() > 0 ? this.xh[this.xh.length - 1] : null;
    }
    Rh() {
        return this.Th() > 0 ? this.Dh(0) : null;
    }
    Qn() {
        return this.Th() > 0 ? this.Dh(this.xh.length - 1) : null;
    }
    Th() {
        return this.xh.length;
    }
    Zi() {
        return 0 === this.Th();
    }
    ze(t) {
        return null !== this.Ih(t, 0);
    }
    Mh(t) {
        return this.Hn(t);
    }
    Hn(t, i = 0) {
        const n = this.Ih(t, i);
        return null === n ? null : {
            ...this.Vh(n),
            $n: this.Dh(n)
        };
    }
    Bh() {
        return this.xh;
    }
    Eh(t, i, n) {
        if (this.Zi()) return null;
        let s = null;
        for (const e of n)s = $8f74814242901c26$var$Et(s, this.Ah(t, i, e));
        return s;
    }
    ht(t) {
        this.yh.clear(), this.Ch.clear(), this.xh = t, this.Ph = t.map((t)=>t.$n);
    }
    Lh() {
        return this.Ph;
    }
    Dh(t) {
        return this.xh[t].$n;
    }
    Vh(t) {
        return this.xh[t];
    }
    Ih(t, i) {
        const n = this.zh(t);
        if (null === n && 0 !== i) switch(i){
            case -1:
                return this.Oh(t);
            case 1:
                return this.Nh(t);
            default:
                throw new TypeError("Unknown search mode");
        }
        return n;
    }
    Oh(t) {
        let i = this.Fh(t);
        return i > 0 && (i -= 1), i !== this.xh.length && this.Dh(i) < t ? i : null;
    }
    Nh(t) {
        const i = this.Wh(t);
        return i !== this.xh.length && t < this.Dh(i) ? i : null;
    }
    zh(t) {
        const i = this.Fh(t);
        return i === this.xh.length || t < this.xh[i].$n ? null : i;
    }
    Fh(t) {
        return $8f74814242901c26$var$Rt(this.xh, t, (t, i)=>t.$n < i);
    }
    Wh(t) {
        return $8f74814242901c26$var$Dt(this.xh, t, (t, i)=>t.$n > i);
    }
    Hh(t, i, n) {
        let s = null;
        for(let e = t; e < i; e++){
            const t = this.xh[e].Wt[n];
            Number.isNaN(t) || (null === s ? s = {
                Uh: t,
                $h: t
            } : (t < s.Uh && (s.Uh = t), t > s.$h && (s.$h = t)));
        }
        return s;
    }
    Ah(t, i, n) {
        if (this.Zi()) return null;
        let s = null;
        const e = $8f74814242901c26$var$u(this.Rh()), r = $8f74814242901c26$var$u(this.Qn()), h = Math.max(t, e), a = Math.min(i, r), l = Math.ceil(h / $8f74814242901c26$var$Vt) * $8f74814242901c26$var$Vt, o = Math.max(l, Math.floor(a / $8f74814242901c26$var$Vt) * $8f74814242901c26$var$Vt);
        {
            const t = this.Fh(h), e = this.Wh(Math.min(a, l, i));
            s = $8f74814242901c26$var$Et(s, this.Hh(t, e, n));
        }
        let _ = this.Ch.get(n);
        void 0 === _ && (_ = new Map, this.Ch.set(n, _));
        for(let t = Math.max(l + 1, h); t < o; t += $8f74814242901c26$var$Vt){
            const i = Math.floor(t / $8f74814242901c26$var$Vt);
            let e = _.get(i);
            if (void 0 === e) {
                const t = this.Fh(i * $8f74814242901c26$var$Vt), s = this.Wh((i + 1) * $8f74814242901c26$var$Vt - 1);
                e = this.Hh(t, s, n), _.set(i, e);
            }
            s = $8f74814242901c26$var$Et(s, e);
        }
        {
            const t = this.Fh(o), i = this.Wh(a);
            s = $8f74814242901c26$var$Et(s, this.Hh(t, i, n));
        }
        return s;
    }
}
function $8f74814242901c26$var$Et(t, i) {
    if (null === t) return i;
    if (null === i) return t;
    return {
        Uh: Math.min(t.Uh, i.Uh),
        $h: Math.max(t.$h, i.$h)
    };
}
function $8f74814242901c26$var$At() {
    return new $8f74814242901c26$var$Bt;
}
const $8f74814242901c26$var$Lt = {
    setLineStyle: $8f74814242901c26$var$a
};
class $8f74814242901c26$var$zt {
    constructor(t){
        this.jh = t;
    }
    st(t, i, n) {
        this.jh.draw(t, $8f74814242901c26$var$Lt);
    }
    qh(t, i, n) {
        this.jh.drawBackground?.(t, $8f74814242901c26$var$Lt);
    }
}
class $8f74814242901c26$var$Ot {
    constructor(t){
        this.Ls = null, this.Yh = t;
    }
    Tt() {
        const t = this.Yh.renderer();
        if (null === t) return null;
        if (this.Ls?.Kh === t) return this.Ls.Gh;
        const i = new $8f74814242901c26$var$zt(t);
        return this.Ls = {
            Kh: t,
            Gh: i
        }, i;
    }
    Zh() {
        return this.Yh.zOrder?.() ?? "normal";
    }
}
class $8f74814242901c26$var$Nt {
    constructor(t){
        this.Xh = null, this.Jh = t;
    }
    Qh() {
        return this.Jh;
    }
    Nn() {
        this.Jh.updateAllViews?.();
    }
    jn() {
        const t = this.Jh.paneViews?.() ?? [];
        if (this.Xh?.Kh === t) return this.Xh.Gh;
        const i = t.map((t)=>new $8f74814242901c26$var$Ot(t));
        return this.Xh = {
            Kh: t,
            Gh: i
        }, i;
    }
    Qs(t, i) {
        return this.Jh.hitTest?.(t, i) ?? null;
    }
}
let $8f74814242901c26$var$Ft = class extends $8f74814242901c26$var$Nt {
    cn() {
        return [];
    }
};
class $8f74814242901c26$var$Wt {
    constructor(t){
        this.jh = t;
    }
    st(t, i, n) {
        this.jh.draw(t, $8f74814242901c26$var$Lt);
    }
    qh(t, i, n) {
        this.jh.drawBackground?.(t, $8f74814242901c26$var$Lt);
    }
}
class $8f74814242901c26$var$Ht {
    constructor(t){
        this.Ls = null, this.Yh = t;
    }
    Tt() {
        const t = this.Yh.renderer();
        if (null === t) return null;
        if (this.Ls?.Kh === t) return this.Ls.Gh;
        const i = new $8f74814242901c26$var$Wt(t);
        return this.Ls = {
            Kh: t,
            Gh: i
        }, i;
    }
    Zh() {
        return this.Yh.zOrder?.() ?? "normal";
    }
}
function $8f74814242901c26$var$Ut(t) {
    return {
        ri: t.text(),
        Ei: t.coordinate(),
        Vi: t.fixedCoordinate?.(),
        R: t.textColor(),
        Z: t.backColor(),
        It: t.visible?.() ?? !0,
        pi: t.tickVisible?.() ?? !0
    };
}
class $8f74814242901c26$var$$t {
    constructor(t, i){
        this.Xt = new $8f74814242901c26$var$j, this.ta = t, this.ia = i;
    }
    Tt() {
        return this.Xt.ht({
            nn: this.ia.nn(),
            ...$8f74814242901c26$var$Ut(this.ta)
        }), this.Xt;
    }
}
class $8f74814242901c26$var$jt extends $8f74814242901c26$var$H {
    constructor(t, i){
        super(), this.ta = t, this.Ki = i;
    }
    Yi(t, i, n) {
        const s = $8f74814242901c26$var$Ut(this.ta);
        n.Z = s.Z, t.R = s.R;
        const e = 2 / 12 * this.Ki.P();
        n.Ti = e, n.Ri = e, n.Ei = s.Ei, n.Vi = s.Vi, t.ri = s.ri, t.It = s.It, t.pi = s.pi;
    }
}
class $8f74814242901c26$var$qt extends $8f74814242901c26$var$Nt {
    constructor(t, i){
        super(t), this.na = null, this.sa = null, this.ea = null, this.ra = null, this.Te = i;
    }
    dn() {
        const t = this.Jh.timeAxisViews?.() ?? [];
        if (this.na?.Kh === t) return this.na.Gh;
        const i = this.Te.Qt().Et(), n = t.map((t)=>new $8f74814242901c26$var$$t(t, i));
        return this.na = {
            Kh: t,
            Gh: n
        }, n;
    }
    qn() {
        const t = this.Jh.priceAxisViews?.() ?? [];
        if (this.sa?.Kh === t) return this.sa.Gh;
        const i = this.Te.Ft(), n = t.map((t)=>new $8f74814242901c26$var$jt(t, i));
        return this.sa = {
            Kh: t,
            Gh: n
        }, n;
    }
    ha() {
        const t = this.Jh.priceAxisPaneViews?.() ?? [];
        if (this.ea?.Kh === t) return this.ea.Gh;
        const i = t.map((t)=>new $8f74814242901c26$var$Ht(t));
        return this.ea = {
            Kh: t,
            Gh: i
        }, i;
    }
    aa() {
        const t = this.Jh.timeAxisPaneViews?.() ?? [];
        if (this.ra?.Kh === t) return this.ra.Gh;
        const i = t.map((t)=>new $8f74814242901c26$var$Ht(t));
        return this.ra = {
            Kh: t,
            Gh: i
        }, i;
    }
    la(t, i) {
        return this.Jh.autoscaleInfo?.(t, i) ?? null;
    }
}
function $8f74814242901c26$var$Yt(t, i, n, s) {
    t.forEach((t)=>{
        i(t).forEach((t)=>{
            t.Zh() === n && s.push(t);
        });
    });
}
function $8f74814242901c26$var$Kt(t) {
    return t.jn();
}
function $8f74814242901c26$var$Gt(t) {
    return t.ha();
}
function $8f74814242901c26$var$Zt(t) {
    return t.aa();
}
const $8f74814242901c26$var$Xt = [
    "Area",
    "Line",
    "Baseline"
];
class $8f74814242901c26$var$Jt extends $8f74814242901c26$var$yt {
    constructor(t, i, n, s, e){
        super(t), this.qt = $8f74814242901c26$var$At(), this.dr = new $8f74814242901c26$var$ft(this), this.oa = [], this._a = new $8f74814242901c26$var$_t(this), this.ua = null, this.ca = null, this.da = null, this.fa = [], this.pa = new $8f74814242901c26$var$Ct, this.va = new Map, this.ma = null, this.yn = n, this.wa = i;
        const r = new $8f74814242901c26$var$pt(this);
        if (this.mn = [
            r
        ], this.pr = new $8f74814242901c26$var$at(r, this, t), $8f74814242901c26$var$Xt.includes(this.wa) && (this.ua = new $8f74814242901c26$var$dt(this)), this.Ma(), this.Yh = s(this, this.Qt(), e), "Custom" === this.wa) {
            const t = this.Yh;
            t.ga && this.ba(t.ga);
        }
    }
    m() {
        null !== this.da && clearTimeout(this.da);
    }
    We(t) {
        return this.yn.priceLineColor || t;
    }
    Ae(t) {
        const i = {
            Le: !0
        }, n = this.Ft();
        if (this.Qt().Et().Zi() || n.Zi() || this.qt.Zi()) return i;
        const s = this.Qt().Et().Ee(), e = this.Lt();
        if (null === s || null === e) return i;
        let r, h;
        if (t) {
            const t = this.qt.kh();
            if (null === t) return i;
            r = t, h = t.$n;
        } else {
            const t = this.qt.Hn(s.bi(), -1);
            if (null === t) return i;
            if (r = this.qt.Mh(t.$n), null === r) return i;
            h = t.$n;
        }
        const a = r.Wt[3], l = this.Sa().Sh(h, {
            Wt: r
        }), o = n.Nt(a, e.Wt);
        return {
            Le: !1,
            Mt: a,
            ri: n.Ji(a, e.Wt),
            qe: n.xa(a),
            Ye: n.Ca(a, e.Wt),
            R: l.sh,
            Ei: o,
            $n: h
        };
    }
    Sa() {
        return null !== this.ca || (this.ca = new $8f74814242901c26$var$kt(this)), this.ca;
    }
    N() {
        return this.yn;
    }
    vr(t) {
        const i = this.Qt(), { priceScaleId: n, visible: s, priceFormat: e } = t;
        void 0 !== n && n !== this.yn.priceScaleId && i.ya(this, n), void 0 !== s && s !== this.yn.visible && i.Pa();
        const r = void 0 !== t.conflationThresholdFactor;
        $8f74814242901c26$var$f(this.yn, t), Object.prototype.hasOwnProperty.call(t, "autoscaleInfoProvider") && void 0 === t.autoscaleInfoProvider && (this.yn.autoscaleInfoProvider = void 0), r && (this.va.clear(), this.Qt().mr()), void 0 !== e && (this.Ma(), i.ka()), i.Ta(this), i.Ra(), this.Yh.Pt("options");
    }
    ht(t, i) {
        this.qt.ht(t), this.va.clear();
        const n = this.Qt().Et().N();
        n.enableConflation && n.precomputeConflationOnInit && this.Da(n.precomputeConflationPriority), this.Ia(), null !== this.ua && (i && i.Va ? this.ua.De() : 0 === t.length && this.ua.Re());
        const s = this.Qt().Ks(this);
        this.Qt().Ba(s), this.Qt().Ta(this), this.Qt().Ra(), this.Qt().mr();
    }
    Ia() {
        this.Yh.Pt("data");
    }
    Ea(t) {
        const i = new $8f74814242901c26$var$xt(this, t);
        return this.oa.push(i), this.Qt().Ta(this), i;
    }
    Aa(t) {
        const i = this.oa.indexOf(t);
        -1 !== i && this.oa.splice(i, 1), this.Qt().Ta(this);
    }
    La() {
        return this.oa;
    }
    bh() {
        return this.wa;
    }
    Lt() {
        const t = this.za();
        return null === t ? null : {
            Wt: t.Wt[3],
            Oa: t.wt
        };
    }
    za() {
        const t = this.Qt().Et().Ee();
        if (null === t) return null;
        const i = t.Na();
        return this.qt.Hn(i, 1);
    }
    Un() {
        return this.qt;
    }
    ba(t) {
        this.ma = t, this.va.clear();
    }
    Fa() {
        return !!this.Qt().Et().N().enableConflation && this.Wa() > 1;
    }
    Rr(t) {
        if (!this.Fa()) return;
        const i = this.Wa();
        if (!this.va.has(i)) return;
        const n = "Custom" === this.wa, s = n && this.ma || void 0, e = n && this.Yh.Ha ? (t)=>{
            const i = t, n = this.Yh.Ha(i);
            return Array.isArray(n) ? n : [
                "number" == typeof n ? n : 0
            ];
        } : void 0, r = this.pa.Rr(this.qt.Bh(), t, i, s, n, e), h = $8f74814242901c26$var$At();
        h.ht(r), this.va.set(i, h);
    }
    Ua() {
        const t = this.Qt().Et().N().enableConflation;
        if ("Custom" === this.wa && null === this.ma) return this.qt;
        if (!t) return this.qt;
        const i = this.Wa(), n = this.va.get(i);
        if (n) return n;
        this.$a(i);
        return this.va.get(i) ?? this.qt;
    }
    ja(t) {
        const i = this.qt.Mh(t);
        return null === i ? null : "Bar" === this.wa || "Candlestick" === this.wa || "Custom" === this.wa ? {
            jr: i.Wt[0],
            qr: i.Wt[1],
            Yr: i.Wt[2],
            Kr: i.Wt[3]
        } : i.Wt[3];
    }
    qa(t) {
        const i = [];
        $8f74814242901c26$var$Yt(this.fa, $8f74814242901c26$var$Kt, "top", i);
        const n = this.ua;
        return null !== n && n.It() ? (null === this.da && n.Ve() && (this.da = setTimeout(()=>{
            this.da = null, this.Qt().Ya();
        }, 0)), n.Ie(), i.unshift(n), i) : i;
    }
    jn() {
        const t = [];
        this.Ka() || t.push(this._a), t.push(this.Yh, this.dr);
        const i = this.oa.map((t)=>t.wr());
        return t.push(...i), $8f74814242901c26$var$Yt(this.fa, $8f74814242901c26$var$Kt, "normal", t), t;
    }
    Ga() {
        const t = this.Yh.Ga?.() ?? null;
        if (null === t) return null;
        const i = [];
        this.Ka() || i.push(this._a), i.push(...t.Za), $8f74814242901c26$var$Yt(this.fa, $8f74814242901c26$var$Kt, "normal", i);
        const n = [];
        n.push(...t.qa, this.dr);
        const s = this.oa.map((t)=>t.wr());
        return n.push(...s), {
            Za: i,
            qa: n
        };
    }
    Xa() {
        return this.Ja($8f74814242901c26$var$Kt, "bottom");
    }
    Qa(t) {
        return this.Ja($8f74814242901c26$var$Gt, t);
    }
    tl(t) {
        return this.Ja($8f74814242901c26$var$Zt, t);
    }
    il(t, i) {
        return this.fa.map((n)=>n.Qs(t, i)).filter((t)=>null !== t);
    }
    cn() {
        return [
            this.pr,
            ...this.oa.map((t)=>t.Mr())
        ];
    }
    qn(t, i) {
        if (i !== this.hn && !this.Ka()) return [];
        const n = [
            ...this.mn
        ];
        for (const t of this.oa)n.push(t.gr());
        return this.fa.forEach((t)=>{
            n.push(...t.qn());
        }), n;
    }
    dn() {
        const t = [];
        return this.fa.forEach((i)=>{
            t.push(...i.dn());
        }), t;
    }
    la(t, i) {
        if (void 0 !== this.yn.autoscaleInfoProvider) {
            const n = this.yn.autoscaleInfoProvider(()=>{
                const n = this.nl(t, i);
                return null === n ? null : n.sr();
            });
            return $8f74814242901c26$var$wt.er(n);
        }
        return this.nl(t, i);
    }
    Kh() {
        const t = this.yn.priceFormat;
        return t.base ?? 1 / t.minMove;
    }
    sl() {
        return this.el;
    }
    Nn() {
        this.Yh.Pt();
        for (const t of this.mn)t.Pt();
        for (const t of this.oa)t.Pt();
        this.dr.Pt(), this._a.Pt(), this.ua?.Pt(), this.fa.forEach((t)=>t.Nn());
    }
    Ft() {
        return $8f74814242901c26$var$u(super.Ft());
    }
    At(t) {
        if (!(("Line" === this.wa || "Area" === this.wa || "Baseline" === this.wa) && this.yn.crosshairMarkerVisible)) return null;
        const i = this.qt.Mh(t);
        if (null === i) return null;
        return {
            Mt: i.Wt[3],
            ft: this.rl(),
            Ht: this.hl(),
            Ot: this.al(),
            zt: this.ll(t)
        };
    }
    He() {
        return this.yn.title;
    }
    It() {
        return this.yn.visible;
    }
    ol(t) {
        this.fa.push(new $8f74814242901c26$var$qt(t, this));
    }
    _l(t) {
        this.fa = this.fa.filter((i)=>i.Qh() !== t);
    }
    ul() {
        if ("Custom" === this.wa) return (t)=>this.Yh.Ha(t);
    }
    cl() {
        if ("Custom" === this.wa) return (t)=>this.Yh.dl(t);
    }
    fl() {
        return this.qt.Lh();
    }
    Ka() {
        return !$8f74814242901c26$var$Z(this.Ft().pl());
    }
    nl(t, i) {
        if (!$8f74814242901c26$var$v(t) || !$8f74814242901c26$var$v(i) || this.qt.Zi()) return null;
        const n = "Line" === this.wa || "Area" === this.wa || "Baseline" === this.wa || "Histogram" === this.wa ? [
            3
        ] : [
            2,
            1
        ], s = this.qt.Eh(t, i, n);
        let e = null !== s ? new $8f74814242901c26$var$mt(s.Uh, s.$h) : null, r = null;
        if ("Histogram" === this.bh()) {
            const t = this.yn.base, i = new $8f74814242901c26$var$mt(t, t);
            e = null !== e ? e.Ss(i) : i;
        }
        return this.fa.forEach((n)=>{
            const s = n.la(t, i);
            if (s?.priceRange) {
                const t = new $8f74814242901c26$var$mt(s.priceRange.minValue, s.priceRange.maxValue);
                e = null !== e ? e.Ss(t) : t;
            }
            s?.margins && (r = s.margins);
        }), new $8f74814242901c26$var$wt(e, r);
    }
    rl() {
        switch(this.wa){
            case "Line":
            case "Area":
            case "Baseline":
                return this.yn.crosshairMarkerRadius;
        }
        return 0;
    }
    hl() {
        switch(this.wa){
            case "Line":
            case "Area":
            case "Baseline":
                {
                    const t = this.yn.crosshairMarkerBorderColor;
                    if (0 !== t.length) return t;
                }
        }
        return null;
    }
    al() {
        switch(this.wa){
            case "Line":
            case "Area":
            case "Baseline":
                return this.yn.crosshairMarkerBorderWidth;
        }
        return 0;
    }
    ll(t) {
        switch(this.wa){
            case "Line":
            case "Area":
            case "Baseline":
                {
                    const t = this.yn.crosshairMarkerBackgroundColor;
                    if (0 !== t.length) return t;
                }
        }
        return this.Sa().Sh(t).sh;
    }
    Ma() {
        switch(this.yn.priceFormat.type){
            case "custom":
                {
                    const t = this.yn.priceFormat.formatter;
                    this.el = {
                        format: t,
                        formatTickmarks: this.yn.priceFormat.tickmarksFormatter ?? ((i)=>i.map(t))
                    };
                    break;
                }
            case "volume":
                this.el = new $8f74814242901c26$var$st(this.yn.priceFormat.precision);
                break;
            case "percent":
                this.el = new $8f74814242901c26$var$nt(this.yn.priceFormat.precision);
                break;
            default:
                {
                    const t = Math.pow(10, this.yn.priceFormat.precision);
                    this.el = new $8f74814242901c26$var$it(t, this.yn.priceFormat.minMove * t);
                }
        }
        null !== this.hn && this.hn.vl();
    }
    Ja(t, i) {
        const n = [];
        return $8f74814242901c26$var$Yt(this.fa, t, i, n), n;
    }
    Wa() {
        const { ml: t, wl: i, Ml: n } = this.gl();
        return this.pa.Sr(t, i, n);
    }
    gl() {
        const t = this.Qt().Et(), i = t.ml(), n = window.devicePixelRatio || 1, s = t.N().conflationThresholdFactor;
        return {
            ml: i,
            wl: n,
            Ml: this.yn.conflationThresholdFactor ?? s ?? 1
        };
    }
    bl(t) {
        const i = this.qt.Bh();
        let n;
        if ("Custom" === this.wa && null !== this.ma) {
            const s = this.ul();
            if (!s) throw new Error($8f74814242901c26$var$gt);
            n = this.pa.Cr(i, t, this.ma, !0, (t)=>s(t));
        } else n = this.pa.Cr(i, t);
        const s = $8f74814242901c26$var$At();
        return s.ht(n), s;
    }
    $a(t) {
        const i = this.bl(t);
        this.va.set(t, i);
    }
    Da(t) {
        if ("Custom" === this.wa && (null === this.ma || !this.ul())) return;
        this.va.clear();
        const i = this.Qt().Et().Sl();
        for (const n of i){
            const i = ()=>{
                this.xl(n);
            }, s = "object" == typeof window && window || "object" == typeof self && self;
            s?.yl?.Cl ? s.yl.Cl(()=>{
                i();
            }, {
                se: t
            }) : Promise.resolve().then(()=>i());
        }
    }
    xl(t) {
        if (this.va.has(t)) return;
        if (0 === this.qt.Bh().length) return;
        const i = this.bl(t);
        this.va.set(t, i);
    }
}
const $8f74814242901c26$var$Qt = [
    3
], $8f74814242901c26$var$ti = [
    0,
    1,
    2,
    3
];
class $8f74814242901c26$var$ii {
    constructor(t){
        this.yn = t;
    }
    Pl(t, i, n) {
        let s = t;
        if (0 === this.yn.mode) return s;
        const e = n.kn(), r = e.Lt();
        if (null === r) return s;
        const h = e.Nt(t, r), a = n.kl().filter((t)=>t instanceof $8f74814242901c26$var$Jt).reduce((t, s)=>{
            if (n.Gs(s) || !s.It()) return t;
            const e = s.Ft(), r = s.Un();
            if (e.Zi() || !r.ze(i)) return t;
            const h = r.Mh(i);
            if (null === h) return t;
            const a = $8f74814242901c26$var$c(s.Lt()), l = 3 === this.yn.mode ? $8f74814242901c26$var$ti : $8f74814242901c26$var$Qt;
            return t.concat(l.map((t)=>e.Nt(h.Wt[t], a.Wt)));
        }, []);
        if (0 === a.length) return s;
        a.sort((t, i)=>Math.abs(t - h) - Math.abs(i - h));
        const l = a[0];
        return s = e.Tn(l, r), s;
    }
}
function $8f74814242901c26$var$ni(t, i, n) {
    return Math.min(Math.max(t, i), n);
}
function $8f74814242901c26$var$si(t, i, n) {
    return i - t <= n;
}
function $8f74814242901c26$var$ei(t) {
    const i = Math.ceil(t);
    return i % 2 == 0 ? i - 1 : i;
}
class $8f74814242901c26$var$ri extends $8f74814242901c26$var$R {
    constructor(){
        super(...arguments), this.qt = null;
    }
    ht(t) {
        this.qt = t;
    }
    et({ context: t, bitmapSize: i, horizontalPixelRatio: n, verticalPixelRatio: s }) {
        if (null === this.qt) return;
        const e = Math.max(1, Math.floor(n));
        t.lineWidth = e, function(t, i) {
            t.save(), t.lineWidth % 2 && t.translate(.5, .5), i(), t.restore();
        }(t, ()=>{
            const r = $8f74814242901c26$var$u(this.qt);
            if (r.Tl) {
                t.strokeStyle = r.Rl, $8f74814242901c26$var$a(t, r.Dl), t.beginPath();
                for (const s of r.Il){
                    const r = Math.round(s.Vl * n);
                    t.moveTo(r, -e), t.lineTo(r, i.height + e);
                }
                t.stroke();
            }
            if (r.Bl) {
                t.strokeStyle = r.El, $8f74814242901c26$var$a(t, r.Al), t.beginPath();
                for (const n of r.Ll){
                    const r = Math.round(n.Vl * s);
                    t.moveTo(-e, r), t.lineTo(i.width + e, r);
                }
                t.stroke();
            }
        });
    }
}
class $8f74814242901c26$var$hi {
    constructor(t){
        this.Xt = new $8f74814242901c26$var$ri, this.xt = !0, this.yt = t;
    }
    Pt() {
        this.xt = !0;
    }
    Tt() {
        if (this.xt) {
            const t = this.yt.Qt().N().grid, i = {
                Bl: t.horzLines.visible,
                Tl: t.vertLines.visible,
                El: t.horzLines.color,
                Rl: t.vertLines.color,
                Al: t.horzLines.style,
                Dl: t.vertLines.style,
                Ll: this.yt.kn().zl(),
                Il: (this.yt.Qt().Et().zl() || []).map((t)=>({
                        Vl: t.coord
                    }))
            };
            this.Xt.ht(i), this.xt = !1;
        }
        return this.Xt;
    }
}
class $8f74814242901c26$var$ai {
    constructor(t){
        this.Yh = new $8f74814242901c26$var$hi(t);
    }
    wr() {
        return this.Yh;
    }
}
const $8f74814242901c26$var$li = {
    Ol: 4,
    Nl: 1e-4
};
function $8f74814242901c26$var$oi(t, i) {
    const n = 100 * (t - i) / i;
    return i < 0 ? -n : n;
}
function $8f74814242901c26$var$_i(t, i) {
    const n = $8f74814242901c26$var$oi(t.Je(), i), s = $8f74814242901c26$var$oi(t.Qe(), i);
    return new $8f74814242901c26$var$mt(n, s);
}
function $8f74814242901c26$var$ui(t, i) {
    const n = 100 * (t - i) / i + 100;
    return i < 0 ? -n : n;
}
function $8f74814242901c26$var$ci(t, i) {
    const n = $8f74814242901c26$var$ui(t.Je(), i), s = $8f74814242901c26$var$ui(t.Qe(), i);
    return new $8f74814242901c26$var$mt(n, s);
}
function $8f74814242901c26$var$di(t, i) {
    const n = Math.abs(t);
    if (n < 1e-15) return 0;
    const s = Math.log10(n + i.Nl) + i.Ol;
    return t < 0 ? -s : s;
}
function $8f74814242901c26$var$fi(t, i) {
    const n = Math.abs(t);
    if (n < 1e-15) return 0;
    const s = Math.pow(10, n - i.Ol) - i.Nl;
    return t < 0 ? -s : s;
}
function $8f74814242901c26$var$pi(t, i) {
    if (null === t) return null;
    const n = $8f74814242901c26$var$di(t.Je(), i), s = $8f74814242901c26$var$di(t.Qe(), i);
    return new $8f74814242901c26$var$mt(n, s);
}
function $8f74814242901c26$var$vi(t, i) {
    if (null === t) return null;
    const n = $8f74814242901c26$var$fi(t.Je(), i), s = $8f74814242901c26$var$fi(t.Qe(), i);
    return new $8f74814242901c26$var$mt(n, s);
}
function $8f74814242901c26$var$mi(t) {
    if (null === t) return $8f74814242901c26$var$li;
    const i = Math.abs(t.Qe() - t.Je());
    if (i >= 1 || i < 1e-15) return $8f74814242901c26$var$li;
    const n = Math.ceil(Math.abs(Math.log10(i))), s = $8f74814242901c26$var$li.Ol + n;
    return {
        Ol: s,
        Nl: 1 / Math.pow(10, s)
    };
}
class $8f74814242901c26$var$wi {
    constructor(t, i){
        if (this.Fl = t, this.Wl = i, function(t) {
            if (t < 0) return !1;
            if (t > 1e18) return !0;
            for(let i = t; i > 1; i /= 10)if (i % 10 != 0) return !1;
            return !0;
        }(this.Fl)) this.Hl = [
            2,
            2.5,
            2
        ];
        else {
            this.Hl = [];
            for(let t = this.Fl; 1 !== t;){
                if (t % 2 == 0) this.Hl.push(2), t /= 2;
                else {
                    if (t % 5 != 0) throw new Error("unexpected base");
                    this.Hl.push(2, 2.5), t /= 5;
                }
                if (this.Hl.length > 100) throw new Error("something wrong with base");
            }
        }
    }
    Ul(t, i, n) {
        const s = 0 === this.Fl ? 0 : 1 / this.Fl;
        let e = Math.pow(10, Math.max(0, Math.ceil(Math.log10(t - i)))), r = 0, h = this.Wl[0];
        for(;;){
            const t = $8f74814242901c26$var$si(e, s, 1e-14) && e > s + 1e-14, i = $8f74814242901c26$var$si(e, n * h, 1e-14), a = $8f74814242901c26$var$si(e, 1, 1e-14);
            if (!(t && i && a)) break;
            e /= h, h = this.Wl[++r % this.Wl.length];
        }
        if (e <= s + 1e-14 && (e = s), e = Math.max(1, e), this.Hl.length > 0 && (a = e, l = 1, o = 1e-14, Math.abs(a - l) < o)) for(r = 0, h = this.Hl[0]; $8f74814242901c26$var$si(e, n * h, 1e-14) && e > s + 1e-14;)e /= h, h = this.Hl[++r % this.Hl.length];
        var a, l, o;
        return e;
    }
}
class $8f74814242901c26$var$Mi {
    constructor(t, i, n, s){
        this.$l = [], this.Ki = t, this.Fl = i, this.jl = n, this.ql = s;
    }
    Ul(t, i) {
        if (t < i) throw new Error("high < low");
        const n = this.Ki.$t(), s = (t - i) * this.Yl() / n, e = new $8f74814242901c26$var$wi(this.Fl, [
            2,
            2.5,
            2
        ]), r = new $8f74814242901c26$var$wi(this.Fl, [
            2,
            2,
            2.5
        ]), h = new $8f74814242901c26$var$wi(this.Fl, [
            2.5,
            2,
            2
        ]), a = [];
        return a.push(e.Ul(t, i, s), r.Ul(t, i, s), h.Ul(t, i, s)), function(t) {
            if (t.length < 1) throw Error("array is empty");
            let i = t[0];
            for(let n = 1; n < t.length; ++n)t[n] < i && (i = t[n]);
            return i;
        }(a);
    }
    Kl() {
        const t = this.Ki, i = t.Lt();
        if (null === i) return void (this.$l = []);
        const n = t.$t(), s = this.jl(n - 1, i), e = this.jl(0, i), r = this.Ki.N().entireTextOnly ? this.Gl() / 2 : 0, h = r, a = n - 1 - r, l = Math.max(s, e), o = Math.min(s, e);
        if (l === o) return void (this.$l = []);
        const _ = this.Ul(l, o);
        if (this.Zl(i, _, l, o, h, a), t.Xl() && this.Jl(_, o, l)) {
            const t = this.Ki.Ql();
            this.io(i, _, h, a, t, 2 * t);
        }
        const u = this.$l.map((t)=>t.no), c = this.Ki.so(u);
        for(let t = 0; t < this.$l.length; t++)this.$l[t].eo = c[t];
    }
    zl() {
        return this.$l;
    }
    Gl() {
        return this.Ki.P();
    }
    Yl() {
        return Math.ceil(this.Gl() * this.Ki.N().tickMarkDensity);
    }
    Zl(t, i, n, s, e, r) {
        const h = this.$l, a = this.Ki;
        let l = n % i;
        l += l < 0 ? i : 0;
        const o = n >= s ? 1 : -1;
        let _ = null, u = 0;
        for(let c = n - l; c > s; c -= i){
            const n = this.ql(c, t, !0);
            null !== _ && Math.abs(n - _) < this.Yl() || n < e || n > r || (u < h.length ? (h[u].Vl = n, h[u].eo = a.ro(c), h[u].no = c) : h.push({
                Vl: n,
                eo: a.ro(c),
                no: c
            }), u++, _ = n, a.ho() && (i = this.Ul(c * o, s)));
        }
        h.length = u;
    }
    io(t, i, n, s, e, r) {
        const h = this.$l, a = this.ao(t, n, e, r), l = this.ao(t, s, -r, -e), o = this.ql(0, t, !0) - this.ql(i, t, !0);
        h.length > 0 && h[0].Vl - a.Vl < o / 2 && h.shift(), h.length > 0 && l.Vl - h[h.length - 1].Vl < o / 2 && h.pop(), h.unshift(a), h.push(l);
    }
    ao(t, i, n, s) {
        const e = (n + s) / 2, r = this.jl(i + n, t), h = this.jl(i + s, t), a = Math.min(r, h), l = Math.max(r, h), o = Math.max(.1, this.Ul(l, a)), _ = this.jl(i + e, t), u = _ - _ % o, c = this.ql(u, t, !0);
        return {
            eo: this.Ki.ro(u),
            Vl: c,
            no: u
        };
    }
    Jl(t, i, n) {
        let s = $8f74814242901c26$var$c(this.Ki.ar());
        return this.Ki.ho() && (s = $8f74814242901c26$var$vi(s, this.Ki.lo())), s.Je() - i < t && n - s.Qe() < t;
    }
}
function $8f74814242901c26$var$gi(t) {
    return t.slice().sort((t, i)=>$8f74814242901c26$var$u(t.ln()) - $8f74814242901c26$var$u(i.ln()));
}
var $8f74814242901c26$export$6b4fbb6217f8a7c2;
!function(t) {
    t[t.Normal = 0] = "Normal", t[t.Logarithmic = 1] = "Logarithmic", t[t.Percentage = 2] = "Percentage", t[t.IndexedTo100 = 3] = "IndexedTo100";
}($8f74814242901c26$export$6b4fbb6217f8a7c2 || ($8f74814242901c26$export$6b4fbb6217f8a7c2 = {}));
const $8f74814242901c26$var$Si = new $8f74814242901c26$var$nt, $8f74814242901c26$var$xi = new $8f74814242901c26$var$it(100, 1);
class $8f74814242901c26$var$Ci {
    constructor(t, i, n, s, e){
        this.oo = 0, this._o = null, this.rr = null, this.uo = null, this.co = {
            do: !1,
            fo: null
        }, this.po = !1, this.vo = 0, this.mo = 0, this.wo = new $8f74814242901c26$var$d, this.Mo = new $8f74814242901c26$var$d, this.bo = [], this.So = null, this.xo = null, this.Co = null, this.yo = null, this.Po = null, this.el = $8f74814242901c26$var$xi, this.ko = $8f74814242901c26$var$mi(null), this.To = t, this.yn = i, this.Ro = n, this.Do = s, this.Io = e, this.Vo = new $8f74814242901c26$var$Mi(this, 100, this.Bo.bind(this), this.Eo.bind(this));
    }
    pl() {
        return this.To;
    }
    N() {
        return this.yn;
    }
    vr(t) {
        if ($8f74814242901c26$var$f(this.yn, t), this.vl(), void 0 !== t.mode && this.Ao({
            _e: t.mode
        }), void 0 !== t.scaleMargins) {
            const i = $8f74814242901c26$var$_(t.scaleMargins.top), n = $8f74814242901c26$var$_(t.scaleMargins.bottom);
            if (i < 0 || i > 1) throw new Error(`Invalid top margin - expect value between 0 and 1, given=${i}`);
            if (n < 0 || n > 1) throw new Error(`Invalid bottom margin - expect value between 0 and 1, given=${n}`);
            if (i + n > 1) throw new Error(`Invalid margins - sum of margins must be less than 1, given=${i + n}`);
            this.Lo(), this.Co = null;
        }
    }
    zo() {
        return this.yn.autoScale;
    }
    Oo() {
        return this.po;
    }
    ho() {
        return 1 === this.yn.mode;
    }
    je() {
        return 2 === this.yn.mode;
    }
    No() {
        return 3 === this.yn.mode;
    }
    lo() {
        return this.ko;
    }
    _e() {
        return {
            hs: this.yn.autoScale,
            Fo: this.yn.invertScale,
            _e: this.yn.mode
        };
    }
    Ao(t) {
        const i = this._e();
        let n = null;
        void 0 !== t.hs && (this.yn.autoScale = t.hs), void 0 !== t._e && (this.yn.mode = t._e, 2 !== t._e && 3 !== t._e || (this.yn.autoScale = !0), this.co.do = !1), 1 === i._e && t._e !== i._e && (!function(t, i) {
            if (null === t) return !1;
            const n = $8f74814242901c26$var$fi(t.Je(), i), s = $8f74814242901c26$var$fi(t.Qe(), i);
            return isFinite(n) && isFinite(s);
        }(this.rr, this.ko) ? this.yn.autoScale = !0 : (n = $8f74814242901c26$var$vi(this.rr, this.ko), null !== n && this.Wo(n))), 1 === t._e && t._e !== i._e && (n = $8f74814242901c26$var$pi(this.rr, this.ko), null !== n && this.Wo(n));
        const s = i._e !== this.yn.mode;
        s && (2 === i._e || this.je()) && this.vl(), s && (3 === i._e || this.No()) && this.vl(), void 0 !== t.Fo && i.Fo !== t.Fo && (this.yn.invertScale = t.Fo, this.Ho()), this.Mo.p(i, this._e());
    }
    Uo() {
        return this.Mo;
    }
    P() {
        return this.Ro.fontSize;
    }
    $t() {
        return this.oo;
    }
    $o(t) {
        this.oo !== t && (this.oo = t, this.Lo(), this.Co = null);
    }
    jo() {
        if (this._o) return this._o;
        const t = this.$t() - this.qo() - this.Yo();
        return this._o = t, t;
    }
    ar() {
        return this.Ko(), this.rr;
    }
    Wo(t, i) {
        const n = this.rr;
        (i || null === n && null !== t || null !== n && !n.Ze(t)) && (this.Co = null, this.rr = t);
    }
    Go(t) {
        this.Wo(t), this.Zo(null !== t);
    }
    Zi() {
        return this.Ko(), 0 === this.oo || !this.rr || this.rr.Zi();
    }
    Xo(t) {
        return this.Fo() ? t : this.$t() - 1 - t;
    }
    Nt(t, i) {
        return this.je() ? t = $8f74814242901c26$var$oi(t, i) : this.No() && (t = $8f74814242901c26$var$ui(t, i)), this.Eo(t, i);
    }
    Jo(t, i, n) {
        this.Ko();
        const s = this.Yo(), e = $8f74814242901c26$var$u(this.ar()), r = e.Je(), h = e.Qe(), a = this.jo() - 1, l = this.Fo(), o = a / (h - r), _ = void 0 === n ? 0 : n.from, c = void 0 === n ? t.length : n.to, d = this.Qo();
        for(let n = _; n < c; n++){
            const e = t[n], h = e.Mt;
            if (isNaN(h)) continue;
            let a = h;
            null !== d && (a = d(e.Mt, i));
            const _ = s + o * (a - r), u = l ? _ : this.oo - 1 - _;
            e.ut = u;
        }
    }
    t_(t, i, n) {
        this.Ko();
        const s = this.Yo(), e = $8f74814242901c26$var$u(this.ar()), r = e.Je(), h = e.Qe(), a = this.jo() - 1, l = this.Fo(), o = a / (h - r), _ = void 0 === n ? 0 : n.from, c = void 0 === n ? t.length : n.to, d = this.Qo();
        for(let n = _; n < c; n++){
            const e = t[n];
            let h = e.jr, a = e.qr, _ = e.Yr, u = e.Kr;
            null !== d && (h = d(e.jr, i), a = d(e.qr, i), _ = d(e.Yr, i), u = d(e.Kr, i));
            let c = s + o * (h - r), f = l ? c : this.oo - 1 - c;
            e.i_ = f, c = s + o * (a - r), f = l ? c : this.oo - 1 - c, e.n_ = f, c = s + o * (_ - r), f = l ? c : this.oo - 1 - c, e.s_ = f, c = s + o * (u - r), f = l ? c : this.oo - 1 - c, e.e_ = f;
        }
    }
    Tn(t, i) {
        const n = this.Bo(t, i);
        return this.r_(n, i);
    }
    r_(t, i) {
        let n = t;
        return this.je() ? n = function(t, i) {
            return i < 0 && (t = -t), t / 100 * i + i;
        }(n, i) : this.No() && (n = function(t, i) {
            return t -= 100, i < 0 && (t = -t), t / 100 * i + i;
        }(n, i)), n;
    }
    kl() {
        return this.bo;
    }
    Dt() {
        return this.xo || (this.xo = $8f74814242901c26$var$gi(this.bo)), this.xo;
    }
    h_(t) {
        -1 === this.bo.indexOf(t) && (this.bo.push(t), this.vl(), this.a_());
    }
    l_(t) {
        const i = this.bo.indexOf(t);
        if (-1 === i) throw new Error("source is not attached to scale");
        this.bo.splice(i, 1), 0 === this.bo.length && (this.Ao({
            hs: !0
        }), this.Wo(null)), this.vl(), this.a_();
    }
    Lt() {
        let t = null;
        for (const i of this.bo){
            const n = i.Lt();
            null !== n && (null === t || n.Oa < t.Oa) && (t = n);
        }
        return null === t ? null : t.Wt;
    }
    Fo() {
        return this.yn.invertScale;
    }
    zl() {
        const t = null === this.Lt();
        if (null !== this.Co && (t || this.Co.o_ === t)) return this.Co.zl;
        this.Vo.Kl();
        const i = this.Vo.zl();
        return this.Co = {
            zl: i,
            o_: t
        }, this.wo.p(), i;
    }
    __() {
        return this.wo;
    }
    u_(t) {
        this.je() || this.No() || null === this.yo && null === this.uo && (this.Zi() || (this.yo = this.oo - t, this.uo = $8f74814242901c26$var$u(this.ar()).Xe()));
    }
    c_(t) {
        if (this.je() || this.No()) return;
        if (null === this.yo) return;
        this.Ao({
            hs: !1
        }), (t = this.oo - t) < 0 && (t = 0);
        let i = (this.yo + .2 * (this.oo - 1)) / (t + .2 * (this.oo - 1));
        const n = $8f74814242901c26$var$u(this.uo).Xe();
        i = Math.max(i, .1), n.ir(i), this.Wo(n);
    }
    d_() {
        this.je() || this.No() || (this.yo = null, this.uo = null);
    }
    f_(t) {
        this.zo() || null === this.Po && null === this.uo && (this.Zi() || (this.Po = t, this.uo = $8f74814242901c26$var$u(this.ar()).Xe()));
    }
    p_(t) {
        if (this.zo()) return;
        if (null === this.Po) return;
        const i = $8f74814242901c26$var$u(this.ar()).tr() / (this.jo() - 1);
        let n = t - this.Po;
        this.Fo() && (n *= -1);
        const s = n * i, e = $8f74814242901c26$var$u(this.uo).Xe();
        e.nr(s), this.Wo(e, !0), this.Co = null;
    }
    v_() {
        this.zo() || null !== this.Po && (this.Po = null, this.uo = null);
    }
    sl() {
        return this.el || this.vl(), this.el;
    }
    Ji(t, i) {
        switch(this.yn.mode){
            case 2:
                return this.m_($8f74814242901c26$var$oi(t, i));
            case 3:
                return this.sl().format($8f74814242901c26$var$ui(t, i));
            default:
                return this.cr(t);
        }
    }
    ro(t) {
        switch(this.yn.mode){
            case 2:
                return this.m_(t);
            case 3:
                return this.sl().format(t);
            default:
                return this.cr(t);
        }
    }
    so(t) {
        switch(this.yn.mode){
            case 2:
                return this.w_(t);
            case 3:
                return this.sl().formatTickmarks(t);
            default:
                return this.M_(t);
        }
    }
    xa(t) {
        return this.cr(t, $8f74814242901c26$var$u(this.So).sl());
    }
    Ca(t, i) {
        return t = $8f74814242901c26$var$oi(t, i), this.m_(t, $8f74814242901c26$var$Si);
    }
    g_() {
        return this.bo;
    }
    b_(t) {
        this.co = {
            fo: t,
            do: !1
        };
    }
    Nn() {
        this.bo.forEach((t)=>t.Nn());
    }
    Xl() {
        return this.yn.ensureEdgeTickMarksVisible && this.zo();
    }
    Ql() {
        return this.P() / 2;
    }
    vl() {
        this.Co = null;
        let t = 1 / 0;
        this.So = null;
        for (const i of this.bo)i.ln() < t && (t = i.ln(), this.So = i);
        let i = 100;
        null !== this.So && (i = Math.round(this.So.Kh())), this.el = $8f74814242901c26$var$xi, this.je() ? (this.el = $8f74814242901c26$var$Si, i = 100) : this.No() ? (this.el = new $8f74814242901c26$var$it(100, 1), i = 100) : null !== this.So && (this.el = this.So.sl()), this.Vo = new $8f74814242901c26$var$Mi(this, i, this.Bo.bind(this), this.Eo.bind(this)), this.Vo.Kl();
    }
    a_() {
        this.xo = null;
    }
    S_() {
        return null === this.So || this.je() || this.No() ? 1 : 1 / this.So.Kh();
    }
    Xi() {
        return this.Io;
    }
    Zo(t) {
        this.po = t;
    }
    qo() {
        return this.Fo() ? this.yn.scaleMargins.bottom * this.$t() + this.mo : this.yn.scaleMargins.top * this.$t() + this.vo;
    }
    Yo() {
        return this.Fo() ? this.yn.scaleMargins.top * this.$t() + this.vo : this.yn.scaleMargins.bottom * this.$t() + this.mo;
    }
    Ko() {
        this.co.do || (this.co.do = !0, this.x_());
    }
    Lo() {
        this._o = null;
    }
    Eo(t, i) {
        if (this.Ko(), this.Zi()) return 0;
        t = this.ho() && t ? $8f74814242901c26$var$di(t, this.ko) : t;
        const n = $8f74814242901c26$var$u(this.ar()), s = this.Yo() + (this.jo() - 1) * (t - n.Je()) / n.tr();
        return this.Xo(s);
    }
    Bo(t, i) {
        if (this.Ko(), this.Zi()) return 0;
        const n = this.Xo(t), s = $8f74814242901c26$var$u(this.ar()), e = s.Je() + s.tr() * ((n - this.Yo()) / (this.jo() - 1));
        return this.ho() ? $8f74814242901c26$var$fi(e, this.ko) : e;
    }
    Ho() {
        this.Co = null, this.Vo.Kl();
    }
    x_() {
        if (this.Oo() && !this.zo()) return;
        const t = this.co.fo;
        if (null === t) return;
        let i = null;
        const n = this.g_();
        let s = 0, e = 0;
        for (const r of n){
            if (!r.It()) continue;
            const n = r.Lt();
            if (null === n) continue;
            const h = r.la(t.Na(), t.bi());
            let a = h && h.ar();
            if (null !== a) {
                switch(this.yn.mode){
                    case 1:
                        a = $8f74814242901c26$var$pi(a, this.ko);
                        break;
                    case 2:
                        a = $8f74814242901c26$var$_i(a, n.Wt);
                        break;
                    case 3:
                        a = $8f74814242901c26$var$ci(a, n.Wt);
                }
                if (i = null === i ? a : i.Ss($8f74814242901c26$var$u(a)), null !== h) {
                    const t = h.lr();
                    null !== t && (s = Math.max(s, t.above), e = Math.max(e, t.below));
                }
            }
        }
        if (this.Xl() && (s = Math.max(s, this.Ql()), e = Math.max(e, this.Ql())), s === this.vo && e === this.mo || (this.vo = s, this.mo = e, this.Co = null, this.Lo()), null !== i) {
            if (i.Je() === i.Qe()) {
                const t = 5 * this.S_();
                this.ho() && (i = $8f74814242901c26$var$vi(i, this.ko)), i = new $8f74814242901c26$var$mt(i.Je() - t, i.Qe() + t), this.ho() && (i = $8f74814242901c26$var$pi(i, this.ko));
            }
            if (this.ho()) {
                const t = $8f74814242901c26$var$vi(i, this.ko), n = $8f74814242901c26$var$mi(t);
                if (r = n, h = this.ko, r.Ol !== h.Ol || r.Nl !== h.Nl) {
                    const s = null !== this.uo ? $8f74814242901c26$var$vi(this.uo, this.ko) : null;
                    this.ko = n, i = $8f74814242901c26$var$pi(t, n), null !== s && (this.uo = $8f74814242901c26$var$pi(s, n));
                }
            }
            this.Wo(i);
        } else null === this.rr && (this.Wo(new $8f74814242901c26$var$mt(-0.5, .5)), this.ko = $8f74814242901c26$var$mi(null));
        var r, h;
    }
    Qo() {
        return this.je() ? $8f74814242901c26$var$oi : this.No() ? $8f74814242901c26$var$ui : this.ho() ? (t)=>$8f74814242901c26$var$di(t, this.ko) : null;
    }
    C_(t, i, n) {
        return void 0 === i ? (void 0 === n && (n = this.sl()), n.format(t)) : i(t);
    }
    y_(t, i, n) {
        return void 0 === i ? (void 0 === n && (n = this.sl()), n.formatTickmarks(t)) : i(t);
    }
    cr(t, i) {
        return this.C_(t, this.Do.priceFormatter, i);
    }
    M_(t, i) {
        const n = this.Do.priceFormatter;
        return this.y_(t, this.Do.tickmarksPriceFormatter ?? (n ? (t)=>t.map(n) : void 0), i);
    }
    m_(t, i) {
        return this.C_(t, this.Do.percentageFormatter, i);
    }
    w_(t, i) {
        const n = this.Do.percentageFormatter;
        return this.y_(t, this.Do.tickmarksPercentageFormatter ?? (n ? (t)=>t.map(n) : void 0), i);
    }
}
function $8f74814242901c26$var$yi(t) {
    return t instanceof $8f74814242901c26$var$Jt;
}
class $8f74814242901c26$var$Pi {
    constructor(t, i){
        this.bo = [], this.P_ = new Map, this.oo = 0, this.k_ = 0, this.T_ = 1, this.xo = null, this.R_ = null, this.D_ = !1, this.I_ = new $8f74814242901c26$var$d, this.fa = [], this.ia = t, this.sn = i, this.V_ = new $8f74814242901c26$var$ai(this);
        const n = i.N();
        this.B_ = this.E_("left", n.leftPriceScale), this.A_ = this.E_("right", n.rightPriceScale), this.B_.Uo().i(this.L_.bind(this, this.B_), this), this.A_.Uo().i(this.L_.bind(this, this.A_), this), this.z_(n);
    }
    z_(t) {
        if (t.leftPriceScale && this.B_.vr(t.leftPriceScale), t.rightPriceScale && this.A_.vr(t.rightPriceScale), t.localization && (this.B_.vl(), this.A_.vl()), t.overlayPriceScales) {
            const i = Array.from(this.P_.values());
            for (const n of i){
                const i = $8f74814242901c26$var$u(n[0].Ft());
                i.vr(t.overlayPriceScales), t.localization && i.vl();
            }
        }
    }
    O_(t) {
        switch(t){
            case "left":
                return this.B_;
            case "right":
                return this.A_;
        }
        return this.P_.has(t) ? $8f74814242901c26$var$_(this.P_.get(t))[0].Ft() : null;
    }
    m() {
        this.Qt().N_().u(this), this.B_.Uo().u(this), this.A_.Uo().u(this), this.bo.forEach((t)=>{
            t.m && t.m();
        }), this.fa = this.fa.filter((t)=>{
            const i = t.Qh();
            return i.detached && i.detached(), !1;
        }), this.I_.p();
    }
    F_() {
        return this.T_;
    }
    W_(t) {
        this.T_ = t;
    }
    Qt() {
        return this.sn;
    }
    nn() {
        return this.k_;
    }
    $t() {
        return this.oo;
    }
    H_(t) {
        this.k_ = t, this.U_();
    }
    $o(t) {
        this.oo = t, this.B_.$o(t), this.A_.$o(t), this.bo.forEach((i)=>{
            if (this.Gs(i)) {
                const n = i.Ft();
                null !== n && n.$o(t);
            }
        }), this.U_();
    }
    j_(t) {
        this.D_ = t;
    }
    q_() {
        return this.D_;
    }
    Y_() {
        return this.bo.filter($8f74814242901c26$var$yi);
    }
    kl() {
        return this.bo;
    }
    Gs(t) {
        const i = t.Ft();
        return null === i || this.B_ !== i && this.A_ !== i;
    }
    h_(t, i, n) {
        this.K_(t, i, n ? t.ln() : this.bo.length);
    }
    l_(t, i) {
        const n = this.bo.indexOf(t);
        $8f74814242901c26$var$o(-1 !== n, "removeDataSource: invalid data source"), this.bo.splice(n, 1), i || this.bo.forEach((t, i)=>t._n(i));
        const s = $8f74814242901c26$var$u(t.Ft()).pl();
        if (this.P_.has(s)) {
            const i = $8f74814242901c26$var$_(this.P_.get(s)), n = i.indexOf(t);
            -1 !== n && (i.splice(n, 1), 0 === i.length && this.P_.delete(s));
        }
        const e = t.Ft();
        e && e.kl().indexOf(t) >= 0 && (e.l_(t), this.G_(e)), this.Z_();
    }
    Xs(t) {
        return t === this.B_ ? "left" : t === this.A_ ? "right" : "overlay";
    }
    X_() {
        return this.B_;
    }
    J_() {
        return this.A_;
    }
    Q_(t, i) {
        t.u_(i);
    }
    tu(t, i) {
        t.c_(i), this.U_();
    }
    iu(t) {
        t.d_();
    }
    nu(t, i) {
        t.f_(i);
    }
    su(t, i) {
        t.p_(i), this.U_();
    }
    eu(t) {
        t.v_();
    }
    U_() {
        this.bo.forEach((t)=>{
            t.Nn();
        });
    }
    kn() {
        const [t, i] = this.ru();
        let n = null;
        return t.N().visible && 0 !== t.kl().length ? n = t : i.N().visible && 0 !== i.kl().length ? n = i : 0 !== this.bo.length && (n = this.bo[0].Ft()), null === n && (n = this.Zs() ?? t), n;
    }
    Zs() {
        const [t, i] = this.ru();
        return t.N().visible ? t : i.N().visible ? i : null;
    }
    G_(t) {
        null !== t && t.zo() && this.hu(t);
    }
    au(t) {
        const i = this.ia.Ee();
        t.Ao({
            hs: !0
        }), null !== i && t.b_(i), this.U_();
    }
    lu() {
        this.hu(this.B_), this.hu(this.A_);
    }
    ou() {
        this.G_(this.B_), this.G_(this.A_), this.bo.forEach((t)=>{
            this.Gs(t) && this.G_(t.Ft());
        }), this.U_(), this.sn.mr();
    }
    Dt() {
        return null === this.xo && (this.xo = $8f74814242901c26$var$gi(this.bo)), this.xo;
    }
    _u() {
        const t = this.Dt(), i = this.sn.cu()?.uu, n = this.sn.N().hoveredSeriesOnTop, s = this.R_;
        if (null !== s && s.Kh === t && s.du === i && s.fu === n) return s.pu;
        const e = function(t, i, n) {
            if (!n) return t;
            const s = t.indexOf(i);
            if (-1 === s || s === t.length - 1) return t;
            const e = [];
            for(let i = 0; i < t.length; i++)i !== s && e.push(t[i]);
            return e.push(t[s]), e;
        }(t, i, n);
        return this.R_ = {
            Kh: t,
            du: i,
            fu: n,
            pu: e
        }, e;
    }
    vu(t, i) {
        i = $8f74814242901c26$var$ni(i, 0, this.bo.length - 1);
        const n = this.bo.indexOf(t);
        $8f74814242901c26$var$o(-1 !== n, "setSeriesOrder: invalid data source"), this.bo.splice(n, 1), this.bo.splice(i, 0, t), this.bo.forEach((t, i)=>t._n(i)), this.Z_();
        for (const t of [
            this.B_,
            this.A_
        ])t.a_(), t.vl();
        this.sn.mr();
    }
    Vt() {
        return this.Dt().filter($8f74814242901c26$var$yi);
    }
    mu() {
        return this.I_;
    }
    wu() {
        return this.V_;
    }
    ol(t) {
        this.fa.push(new $8f74814242901c26$var$Ft(t));
    }
    _l(t) {
        this.fa = this.fa.filter((i)=>i.Qh() !== t), t.detached && t.detached(), this.sn.mr();
    }
    Mu() {
        return this.fa;
    }
    il(t, i) {
        return this.fa.map((n)=>n.Qs(t, i)).filter((t)=>null !== t);
    }
    hu(t) {
        const i = t.g_();
        if (i && i.length > 0 && !this.ia.Zi()) {
            const i = this.ia.Ee();
            null !== i && t.b_(i);
        }
        t.Nn();
    }
    K_(t, i, n) {
        let s = this.O_(i);
        if (null === s && (s = this.E_(i, this.sn.N().overlayPriceScales)), this.bo.splice(n, 0, t), !$8f74814242901c26$var$Z(i)) {
            const n = this.P_.get(i) || [];
            n.push(t), this.P_.set(i, n);
        }
        t._n(n), s.h_(t), t.un(s), this.G_(s), this.Z_();
    }
    Z_() {
        this.xo = null, this.R_ = null;
    }
    ru() {
        return "left" === this.sn.N().defaultVisiblePriceScaleId ? [
            this.B_,
            this.A_
        ] : [
            this.A_,
            this.B_
        ];
    }
    L_(t, i, n) {
        i._e !== n._e && this.hu(t);
    }
    E_(t, i) {
        const n = {
            visible: !0,
            autoScale: !0,
            ...$8f74814242901c26$var$M(i)
        }, s = new $8f74814242901c26$var$Ci(t, n, this.sn.N().layout, this.sn.N().localization, this.sn.Xi());
        return s.$o(this.$t()), s;
    }
}
function $8f74814242901c26$var$ki(t, i) {
    return null === i || 2 === t.se && 2 !== i.se || (2 !== i.se || 2 === t.se) && t.ne !== i.ne && t.ne < i.ne;
}
function $8f74814242901c26$var$Ti(t) {
    return {
        te: t.te,
        ie: t.ie
    };
}
function $8f74814242901c26$var$Ri(t) {
    return {
        ne: t.distance ?? 0,
        se: t.hitTestPriority ?? ("marker" === t.itemType ? 2 : 0),
        ee: t.itemType ?? "primitive",
        gu: t.cursorStyle,
        te: t.externalId
    };
}
function $8f74814242901c26$var$Di(t) {
    return {
        uu: t.uu,
        bu: $8f74814242901c26$var$Ti(t.Su),
        gu: t.Su.gu,
        ee: t.Su.ee ?? "primitive"
    };
}
function $8f74814242901c26$var$Ii(t, i, n, s) {
    let e = null;
    for (const r of t){
        let t = r.Qs?.(i, n, s) ?? null;
        if (null === t) {
            const e = r.Tt(s);
            t = null !== e && e.Qs ? e.Qs(i, n) : null;
        }
        if (null !== t) {
            const i = {
                xu: r,
                Su: t
            };
            (null === e || $8f74814242901c26$var$ki(i.Su, e.Su)) && (e = i);
        }
    }
    return e;
}
function $8f74814242901c26$var$Vi(t) {
    return void 0 !== t.jn;
}
function $8f74814242901c26$var$Bi(t, i, n) {
    const s = [
        t,
        ...t.Dt()
    ].reverse(), e = function(t, i, n) {
        let s, e, r;
        for (const l of t){
            const t = l.il?.(i, n) ?? [];
            for (const i of t){
                const t = $8f74814242901c26$var$Ri(i);
                h = i.zOrder, a = s?.zOrder, (!a || "top" === h && "top" !== a || "normal" === h && "bottom" === a || i.zOrder === s?.zOrder && void 0 !== e && $8f74814242901c26$var$ki(t, e) || i.zOrder === s?.zOrder && void 0 === e) && (s = i, e = t, r = l);
            }
        }
        var h, a;
        return s && r && e ? {
            Su: e,
            Cu: s,
            uu: r
        } : null;
    }(s, i, n);
    if ("top" === e?.Cu.zOrder) return $8f74814242901c26$var$Di(e);
    let r = null, h = null;
    for (const a of s){
        if (e && e.uu === a && "bottom" !== e.Cu.zOrder && !e.Cu.isBackground) return r ?? $8f74814242901c26$var$Di(e);
        if ($8f74814242901c26$var$Vi(a)) {
            const s = $8f74814242901c26$var$Ii(a.jn(t), i, n, t);
            if (null !== s) {
                const t = {
                    uu: a,
                    xu: s.xu,
                    bu: $8f74814242901c26$var$Ti(s.Su),
                    gu: s.Su.gu,
                    ee: s.Su.ee ?? "primitive"
                };
                (null === r || $8f74814242901c26$var$ki(s.Su, h)) && (r = t, h = s.Su);
            }
        }
        if (e && e.uu === a && "bottom" !== e.Cu.zOrder && e.Cu.isBackground) return r ?? $8f74814242901c26$var$Di(e);
    }
    return null !== r ? r : e?.Cu ? $8f74814242901c26$var$Di(e) : null;
}
class $8f74814242901c26$var$Ei {
    constructor(t, i, n = 50){
        this.Vs = 0, this.Bs = 1, this.Es = 1, this.Ls = new Map, this.As = new Map, this.yu = t, this.Pu = i, this.zs = n;
    }
    ku(t) {
        const i = t.time, n = this.Pu.cacheKey(i), s = this.Ls.get(n);
        if (void 0 !== s) return s.Tu;
        if (this.Vs === this.zs) {
            const t = this.As.get(this.Es);
            this.As.delete(this.Es), this.Ls.delete($8f74814242901c26$var$_(t)), this.Es++, this.Vs--;
        }
        const e = this.yu(t);
        return this.Ls.set(n, {
            Tu: e,
            Ws: this.Bs
        }), this.As.set(this.Bs, n), this.Vs++, this.Bs++, e;
    }
}
class $8f74814242901c26$var$Ai {
    constructor(t, i){
        $8f74814242901c26$var$o(t <= i, "right should be >= left"), this.Ru = t, this.Du = i;
    }
    Na() {
        return this.Ru;
    }
    bi() {
        return this.Du;
    }
    Iu() {
        return this.Du - this.Ru + 1;
    }
    ze(t) {
        return this.Ru <= t && t <= this.Du;
    }
    Ze(t) {
        return this.Ru === t.Na() && this.Du === t.bi();
    }
}
function $8f74814242901c26$var$Li(t, i) {
    return null === t || null === i ? t === i : t.Ze(i);
}
class $8f74814242901c26$var$zi {
    constructor(){
        this.Vu = new Map, this.Ls = null, this.Bu = !1;
    }
    Eu(t) {
        this.Bu = t, this.Ls = null;
    }
    Au(t, i) {
        this.Lu(i), this.Ls = null;
        for(let n = i; n < t.length; ++n){
            const i = t[n];
            let s = this.Vu.get(i.timeWeight);
            void 0 === s && (s = [], this.Vu.set(i.timeWeight, s)), s.push({
                index: n,
                time: i.time,
                weight: i.timeWeight,
                originalTime: i.originalTime
            });
        }
    }
    zu(t, i, n, s, e) {
        const r = Math.ceil(i / t);
        return null !== this.Ls && this.Ls.Ou === r && e === this.Ls.Nu && n === this.Ls.Fu || (this.Ls = {
            Nu: e,
            Fu: n,
            zl: this.Wu(r, n, s),
            Ou: r
        }), this.Ls.zl;
    }
    Lu(t) {
        if (0 === t) return void this.Vu.clear();
        const i = [];
        this.Vu.forEach((n, s)=>{
            t <= n[0].index ? i.push(s) : n.splice($8f74814242901c26$var$Rt(n, t, (i)=>i.index < t), 1 / 0);
        });
        for (const t of i)this.Vu.delete(t);
    }
    Wu(t, i, n) {
        let s = [];
        const e = (t)=>!i || n.has(t.index);
        for (const i of Array.from(this.Vu.keys()).sort((t, i)=>i - t)){
            if (!this.Vu.get(i)) continue;
            const n = s;
            s = [];
            const r = n.length;
            let h = 0;
            const a = $8f74814242901c26$var$_(this.Vu.get(i)), l = a.length;
            let o = 1 / 0, u = -1 / 0;
            for(let i = 0; i < l; i++){
                const l = a[i], _ = l.index;
                for(; h < r;){
                    const t = n[h], i = t.index;
                    if (!(i < _ && e(t))) {
                        o = i;
                        break;
                    }
                    h++, s.push(t), u = i, o = 1 / 0;
                }
                if (o - _ >= t && _ - u >= t && e(l)) s.push(l), u = _;
                else if (this.Bu) return n;
            }
            for(; h < r; h++)e(n[h]) && s.push(n[h]);
        }
        return s;
    }
}
class $8f74814242901c26$var$Oi {
    constructor(t){
        this.Hu = t;
    }
    Uu() {
        return null === this.Hu ? null : new $8f74814242901c26$var$Ai(Math.floor(this.Hu.Na()), Math.ceil(this.Hu.bi()));
    }
    $u() {
        return this.Hu;
    }
    static ju() {
        return new $8f74814242901c26$var$Oi(null);
    }
}
function $8f74814242901c26$var$Ni(t, i) {
    return t.weight > i.weight ? t : i;
}
class $8f74814242901c26$var$Fi {
    constructor(t, i, n, s){
        this.k_ = 0, this.qu = null, this.Yu = [], this.Po = null, this.yo = null, this.Ku = new $8f74814242901c26$var$zi, this.Gu = new Map, this.Zu = $8f74814242901c26$var$Oi.ju(), this.Xu = !0, this.Ju = new $8f74814242901c26$var$d, this.Qu = new $8f74814242901c26$var$d, this.tc = new $8f74814242901c26$var$d, this.nc = null, this.sc = null, this.ec = new Map, this.rc = -1, this.hc = [], this.ac = 1, this.yn = i, this.Do = n, this.lc = i.rightOffset, this.oc = i.barSpacing, this.sn = t, this._c(i), this.Pu = s, this.uc(), this.Ku.Eu(i.uniformDistribution), this.cc(), this.dc();
    }
    N() {
        return this.yn;
    }
    fc(t) {
        $8f74814242901c26$var$f(this.Do, t), this.vc(), this.uc();
    }
    vr(t, i) {
        $8f74814242901c26$var$f(this.yn, t), this.yn.fixLeftEdge && this.mc(), this.yn.fixRightEdge && this.wc(), void 0 !== t.barSpacing && this.sn.Ms(t.barSpacing), void 0 !== t.rightOffset && this.sn.gs(t.rightOffset), this._c(t), void 0 === t.minBarSpacing && void 0 === t.maxBarSpacing || this.sn.Ms(t.barSpacing ?? this.oc), void 0 !== t.ignoreWhitespaceIndices && t.ignoreWhitespaceIndices !== this.yn.ignoreWhitespaceIndices && this.dc(), this.vc(), this.uc(), void 0 === t.enableConflation && void 0 === t.conflationThresholdFactor || this.cc(), this.tc.p();
    }
    Rn(t) {
        return this.Yu[t]?.time ?? null;
    }
    en(t) {
        return this.Yu[t] ?? null;
    }
    Mc(t, i) {
        if (this.Yu.length < 1) return null;
        if (this.Pu.key(t) > this.Pu.key(this.Yu[this.Yu.length - 1].time)) return i ? this.Yu.length - 1 : null;
        const n = $8f74814242901c26$var$Rt(this.Yu, this.Pu.key(t), (t, i)=>this.Pu.key(t.time) < i);
        return this.Pu.key(t) < this.Pu.key(this.Yu[n].time) ? i ? n : null : n;
    }
    Zi() {
        return 0 === this.k_ || 0 === this.Yu.length || null === this.qu;
    }
    gc() {
        return this.Yu.length > 0;
    }
    Ee() {
        return this.bc(), this.Zu.Uu();
    }
    Sc() {
        return this.bc(), this.Zu.$u();
    }
    xc() {
        const t = this.Ee();
        if (null === t) return null;
        const i = {
            from: t.Na(),
            to: t.bi()
        };
        return this.Cc(i);
    }
    Cc(t) {
        const i = Math.round(t.from), n = Math.round(t.to), s = $8f74814242901c26$var$u(this.yc()), e = $8f74814242901c26$var$u(this.Pc());
        return {
            from: $8f74814242901c26$var$u(this.en(Math.max(s, i))),
            to: $8f74814242901c26$var$u(this.en(Math.min(e, n)))
        };
    }
    kc(t) {
        return {
            from: $8f74814242901c26$var$u(this.Mc(t.from, !0)),
            to: $8f74814242901c26$var$u(this.Mc(t.to, !0))
        };
    }
    nn() {
        return this.k_;
    }
    H_(t) {
        if (!isFinite(t) || t <= 0) return;
        if (this.k_ === t) return;
        const i = this.Sc(), n = this.k_;
        if (this.k_ = t, this.Xu = !0, this.yn.lockVisibleTimeRangeOnResize && 0 !== n) {
            const i = this.oc * t / n;
            this.oc = i;
        }
        if (this.yn.fixLeftEdge && null !== i && i.Na() <= 0) {
            const i = n - t;
            this.lc -= Math.round(i / this.oc) + 1, this.Xu = !0;
        }
        this.Tc(), this.Rc();
    }
    jt(t) {
        if (this.Zi() || !$8f74814242901c26$var$v(t)) return 0;
        const i = this.Dc() + this.lc - t;
        return this.k_ - (i + .5) * this.oc - 1;
    }
    Ic(t, i) {
        const n = this.Dc(), s = void 0 === i ? 0 : i.from, e = void 0 === i ? t.length : i.to;
        for(let i = s; i < e; i++){
            const s = t[i].wt, e = n + this.lc - s, r = this.k_ - (e + .5) * this.oc - 1;
            t[i]._t = r;
        }
    }
    Vc(t, i) {
        const n = Math.ceil(this.Bc(t));
        return i && this.yn.ignoreWhitespaceIndices && !this.Ec(n) ? this.Ac(n) : n;
    }
    gs(t) {
        this.Xu = !0, this.lc = t, this.Rc(), this.sn.Lc(), this.sn.mr();
    }
    ml() {
        return this.oc;
    }
    Ms(t) {
        const i = this.oc;
        if (this.zc(t), void 0 !== this.yn.rightOffsetPixels && 0 !== i) {
            const t = this.lc * i / this.oc;
            this.lc = t;
        }
        this.Rc(), this.sn.Lc(), this.sn.mr();
    }
    Oc() {
        return this.lc;
    }
    zl() {
        if (this.Zi()) return null;
        if (null !== this.sc) return this.sc;
        const t = this.oc, i = 5 * (this.sn.N().layout.fontSize + 4) / 8 * (this.yn.tickMarkMaxCharacterLength || 8), n = Math.round(i / t), s = $8f74814242901c26$var$u(this.Ee()), e = Math.max(s.Na(), s.Na() - n), r = Math.max(s.bi(), s.bi() - n), h = this.Ku.zu(t, i, this.yn.ignoreWhitespaceIndices, this.ec, this.rc), a = this.yc() + n, l = this.Pc() - n, o = this.Nc(), _ = this.yn.fixLeftEdge || o, c = this.yn.fixRightEdge || o;
        let d = 0;
        for (const t of h){
            if (!(e <= t.index && t.index <= r)) continue;
            let n;
            d < this.hc.length ? (n = this.hc[d], n.coord = this.jt(t.index), n.label = this.Fc(t), n.weight = t.weight) : (n = {
                needAlignCoordinate: !1,
                coord: this.jt(t.index),
                label: this.Fc(t),
                weight: t.weight
            }, this.hc.push(n)), this.oc > i / 2 && !o ? n.needAlignCoordinate = !1 : n.needAlignCoordinate = _ && t.index <= a || c && t.index >= l, d++;
        }
        return this.hc.length = d, this.sc = this.hc, this.hc;
    }
    Wc() {
        let t;
        this.Xu = !0, this.Ms(this.yn.barSpacing), t = void 0 !== this.yn.rightOffsetPixels ? this.yn.rightOffsetPixels / this.ml() : this.yn.rightOffset, this.gs(t);
    }
    Hc(t) {
        this.Xu = !0, this.qu = t, this.Rc(), this.mc();
    }
    Uc(t, i) {
        const n = this.Bc(t), s = this.ml(), e = s + i * (s / 10);
        this.Ms(e), this.yn.rightBarStaysOnScroll || this.gs(this.Oc() + (n - this.Bc(t)));
    }
    u_(t) {
        this.Po && this.v_(), null === this.yo && null === this.nc && (this.Zi() || (this.yo = t, this.$c()));
    }
    c_(t) {
        if (null === this.nc) return;
        const i = $8f74814242901c26$var$ni(this.k_ - t, 0, this.k_), n = $8f74814242901c26$var$ni(this.k_ - $8f74814242901c26$var$u(this.yo), 0, this.k_);
        0 !== i && 0 !== n && this.Ms(this.nc.ml * i / n);
    }
    d_() {
        null !== this.yo && (this.yo = null, this.jc());
    }
    f_(t) {
        null === this.Po && null === this.nc && (this.Zi() || (this.Po = t, this.$c()));
    }
    p_(t) {
        if (null === this.Po) return;
        const i = (this.Po - t) / this.ml();
        this.lc = $8f74814242901c26$var$u(this.nc).Oc + i, this.Xu = !0, this.Rc();
    }
    v_() {
        null !== this.Po && (this.Po = null, this.jc());
    }
    qc() {
        this.Yc(this.yn.rightOffset);
    }
    Yc(t, i = 400) {
        if (!isFinite(t)) throw new RangeError("offset is required and must be finite number");
        if (!isFinite(i) || i <= 0) throw new RangeError("animationDuration (optional) must be finite positive number");
        const n = this.lc, s = performance.now();
        this.sn.ps({
            Kc: (t)=>(t - s) / i >= 1,
            Gc: (e)=>{
                const r = (e - s) / i;
                return r >= 1 ? t : n + (t - n) * r;
            }
        });
    }
    Pt(t, i) {
        this.Xu = !0, this.Yu = t, this.Ku.Au(t, i), this.Rc();
    }
    Zc() {
        return this.Ju;
    }
    Xc() {
        return this.Qu;
    }
    Jc() {
        return this.tc;
    }
    Dc() {
        return this.qu || 0;
    }
    Qc(t, i) {
        const n = t.Iu(), s = i && this.yn.rightOffsetPixels || 0;
        this.zc((this.k_ - s) / n), this.lc = t.bi() - this.Dc(), i && (this.lc = s ? s / this.ml() : this.yn.rightOffset), this.Rc(), this.Xu = !0, this.sn.Lc(), this.sn.mr();
    }
    td() {
        const t = this.yc(), i = this.Pc();
        if (null === t || null === i) return;
        const n = !this.yn.rightOffsetPixels && this.yn.rightOffset || 0;
        this.Qc(new $8f74814242901c26$var$Ai(t, i + n), !0);
    }
    nd(t) {
        const i = new $8f74814242901c26$var$Ai(t.from, t.to);
        this.Qc(i);
    }
    rn(t) {
        return void 0 !== this.Do.timeFormatter ? this.Do.timeFormatter(t.originalTime) : this.Pu.formatHorzItem(t.time);
    }
    dc() {
        if (!this.yn.ignoreWhitespaceIndices) return;
        this.ec.clear();
        const t = this.sn.Jn();
        for (const i of t)for (const t of i.fl())this.ec.set(t, !0);
        this.rc++;
    }
    sd() {
        return this.ac;
    }
    Sl() {
        const t = 1 / (window.devicePixelRatio || 1), i = this.yn.minBarSpacing;
        if (i >= t) return [
            1
        ];
        const n = [
            1
        ];
        let s = 2;
        for(; s <= 512;)i < t / s && n.push(s), s *= 2;
        return n;
    }
    Nc() {
        const t = this.sn.N().handleScroll, i = this.sn.N().handleScale;
        return !(t.horzTouchDrag || t.mouseWheel || t.pressedMouseMove || t.vertTouchDrag || i.axisDoubleClickReset.time || i.axisPressedMouseMove.time || i.mouseWheel || i.pinch);
    }
    yc() {
        return 0 === this.Yu.length ? null : 0;
    }
    Pc() {
        return 0 === this.Yu.length ? null : this.Yu.length - 1;
    }
    ed(t) {
        return (this.k_ - 1 - t) / this.oc;
    }
    Bc(t) {
        const i = this.ed(t), n = this.Dc() + this.lc - i;
        return Math.round(1e6 * n) / 1e6;
    }
    zc(t) {
        const i = this.oc;
        this.oc = t, this.Tc(), i !== this.oc && (this.Xu = !0, this.rd(), this.cc());
    }
    bc() {
        if (!this.Xu) return;
        if (this.Xu = !1, this.Zi()) return void this.hd($8f74814242901c26$var$Oi.ju());
        const t = this.Dc(), i = this.k_ / this.oc, n = this.lc + t, s = new $8f74814242901c26$var$Ai(n - i + 1, n);
        this.hd(new $8f74814242901c26$var$Oi(s));
    }
    Tc() {
        const t = $8f74814242901c26$var$ni(this.oc, this.ad(), this.ld());
        this.oc !== t && (this.oc = t, this.Xu = !0);
    }
    ld() {
        return this.yn.maxBarSpacing > 0 ? this.yn.maxBarSpacing : .5 * this.k_;
    }
    ad() {
        return this.yn.fixLeftEdge && this.yn.fixRightEdge && 0 !== this.Yu.length ? this.k_ / this.Yu.length : this.yn.minBarSpacing;
    }
    cc() {
        if (!this.yn.enableConflation) return void (this.ac = 1);
        const t = 1 / (window.devicePixelRatio || 1) * (this.yn.conflationThresholdFactor ?? 1);
        if (this.oc >= t) return void (this.ac = 1);
        const i = t / this.oc, n = Math.pow(2, Math.floor(Math.log2(i)));
        this.ac = Math.min(n, 512);
    }
    Rc() {
        const t = this.od();
        null !== t && this.lc < t && (this.lc = t, this.Xu = !0);
        const i = this._d();
        this.lc > i && (this.lc = i, this.Xu = !0);
    }
    od() {
        const t = this.yc(), i = this.qu;
        if (null === t || null === i) return null;
        return t - i - 1 + (this.yn.fixLeftEdge ? this.k_ / this.oc : Math.min(2, this.Yu.length));
    }
    _d() {
        return this.yn.fixRightEdge ? 0 : this.k_ / this.oc - Math.min(2, this.Yu.length);
    }
    $c() {
        this.nc = {
            ml: this.ml(),
            Oc: this.Oc()
        };
    }
    jc() {
        this.nc = null;
    }
    Fc(t) {
        let i = this.Gu.get(t.weight);
        return void 0 === i && (i = new $8f74814242901c26$var$Ei((t)=>this.ud(t), this.Pu), this.Gu.set(t.weight, i)), i.ku(t);
    }
    ud(t) {
        return this.Pu.formatTickmark(t, this.Do);
    }
    hd(t) {
        const i = this.Zu;
        this.Zu = t, $8f74814242901c26$var$Li(i.Uu(), this.Zu.Uu()) || this.Ju.p(), $8f74814242901c26$var$Li(i.$u(), this.Zu.$u()) || this.Qu.p(), this.rd();
    }
    rd() {
        this.sc = null;
    }
    vc() {
        this.rd(), this.Gu.clear();
    }
    uc() {
        this.Pu.updateFormatter(this.Do);
    }
    mc() {
        if (!this.yn.fixLeftEdge) return;
        const t = this.yc();
        if (null === t) return;
        const i = this.Ee();
        if (null === i) return;
        const n = i.Na() - t;
        if (n < 0) {
            const t = this.lc - n - 1;
            this.gs(t);
        }
        this.Tc();
    }
    wc() {
        this.Rc(), this.Tc();
    }
    Ec(t) {
        return !this.yn.ignoreWhitespaceIndices || this.ec.get(t) || !1;
    }
    Ac(t) {
        const i = function*(t) {
            const i = Math.round(t), n = i < t;
            let s = 1;
            for(;;)n ? (yield i + s, yield i - s) : (yield i - s, yield i + s), s++;
        }(t), n = this.Pc();
        for(; n;){
            const t = i.next().value;
            if (this.ec.get(t)) return t;
            if (t < 0 || t > n) break;
        }
        return t;
    }
    _c(t) {
        if (void 0 !== t.rightOffsetPixels) {
            const i = t.rightOffsetPixels / (t.barSpacing || this.oc);
            this.sn.gs(i);
        }
    }
}
var $8f74814242901c26$export$8515895ecde62c70, $8f74814242901c26$export$cac7f40581f5d090, $8f74814242901c26$export$10777445820939da, $8f74814242901c26$export$2cd82751acc0e609, $8f74814242901c26$export$2f85f4e66fc865ef;
!function(t) {
    t[t.OnTouchEnd = 0] = "OnTouchEnd", t[t.OnNextTap = 1] = "OnNextTap";
}($8f74814242901c26$export$8515895ecde62c70 || ($8f74814242901c26$export$8515895ecde62c70 = {}));
class $8f74814242901c26$var$qi {
    constructor(t, i, n){
        this.dd = [], this.fd = [], this.pd = null, this.k_ = 0, this.vd = null, this.md = new $8f74814242901c26$var$d, this.wd = new $8f74814242901c26$var$d, this.Md = null, this.gd = t, this.yn = i, this.Pu = n, this.Io = new $8f74814242901c26$var$k(this.yn.layout.colorParsers), this.bd = new $8f74814242901c26$var$C(this), this.ia = new $8f74814242901c26$var$Fi(this, i.timeScale, this.yn.localization, n), this.Ct = new $8f74814242901c26$var$G(this, i.crosshair), this.Sd = new $8f74814242901c26$var$ii(i.crosshair), i.addDefaultPane && (this.xd(0), this.dd[0].W_(2)), this.Cd = this.yd(0), this.Pd = this.yd(1);
    }
    ka() {
        this.kd($8f74814242901c26$var$X.ys());
    }
    mr() {
        this.kd($8f74814242901c26$var$X.Cs());
    }
    Ya() {
        this.kd(new $8f74814242901c26$var$X(1));
    }
    Ta(t) {
        const i = this.Td(t);
        this.kd(i);
    }
    cu() {
        return this.vd;
    }
    Rd(t) {
        if (this.vd?.uu === t?.uu && this.vd?.bu?.te === t?.bu?.te && this.vd?.bu?.ie === t?.bu?.ie && this.vd?.gu === t?.gu && this.vd?.ee === t?.ee) return;
        const i = this.vd;
        this.vd = t, null !== i && this.Ta(i.uu), null !== t && t.uu !== i?.uu && this.Ta(t.uu);
    }
    N() {
        return this.yn;
    }
    vr(t) {
        $8f74814242901c26$var$f(this.yn, t), this.dd.forEach((i)=>i.z_(t)), void 0 !== t.timeScale && this.ia.vr(t.timeScale), void 0 !== t.localization && this.ia.fc(t.localization), (t.leftPriceScale || t.rightPriceScale) && this.md.p(), this.Cd = this.yd(0), this.Pd = this.yd(1), this.ka();
    }
    Dd(t, i, n = 0) {
        const s = this.dd[n];
        if (void 0 === s) return;
        if ("left" === t) return $8f74814242901c26$var$f(this.yn, {
            leftPriceScale: i
        }), s.z_({
            leftPriceScale: i
        }), this.md.p(), void this.ka();
        if ("right" === t) return $8f74814242901c26$var$f(this.yn, {
            rightPriceScale: i
        }), s.z_({
            rightPriceScale: i
        }), this.md.p(), void this.ka();
        const e = this.Id(t, n);
        null !== e && (e.Ft.vr(i), this.md.p());
    }
    Id(t, i) {
        const n = this.dd[i];
        if (void 0 === n) return null;
        const s = n.O_(t);
        return null !== s ? {
            Kn: n,
            Ft: s
        } : null;
    }
    Et() {
        return this.ia;
    }
    Gn() {
        return this.dd;
    }
    Vd() {
        return this.Ct;
    }
    Bd() {
        return this.wd;
    }
    Ed(t, i) {
        t.$o(i), this.Lc();
    }
    H_(t) {
        this.k_ = t, this.ia.H_(this.k_), this.dd.forEach((i)=>i.H_(t)), this.Lc();
    }
    Ad(t) {
        1 !== this.dd.length && ($8f74814242901c26$var$o(t >= 0 && t < this.dd.length, "Invalid pane index"), this.dd.splice(t, 1), this.ka());
    }
    Ld(t, i) {
        if (this.dd.length < 2) return;
        $8f74814242901c26$var$o(t >= 0 && t < this.dd.length, "Invalid pane index");
        const n = this.dd[t], s = this.dd.reduce((t, i)=>t + i.F_(), 0), e = this.dd.reduce((t, i)=>t + i.$t(), 0), r = e - 30 * (this.dd.length - 1);
        i = Math.min(r, Math.max(30, i));
        const h = s / e, a = n.$t();
        n.W_(i * h);
        let l = i - a, _ = this.dd.length - 1;
        for (const t of this.dd)if (t !== n) {
            const i = Math.min(r, Math.max(30, t.$t() - l / _));
            l -= t.$t() - i, _ -= 1;
            const n = i * h;
            t.W_(n);
        }
        this.ka();
    }
    zd(t, i) {
        $8f74814242901c26$var$o(t >= 0 && t < this.dd.length && i >= 0 && i < this.dd.length, "Invalid pane index");
        const n = this.dd[t], s = this.dd[i];
        this.dd[t] = s, this.dd[i] = n, this.ka();
    }
    Od(t, i) {
        if ($8f74814242901c26$var$o(t >= 0 && t < this.dd.length && i >= 0 && i < this.dd.length, "Invalid pane index"), t === i) return;
        const [n] = this.dd.splice(t, 1);
        this.dd.splice(i, 0, n), this.ka();
    }
    Q_(t, i, n) {
        t.Q_(i, n);
    }
    tu(t, i, n) {
        t.tu(i, n), this.Ra(), this.kd(this.Nd(t, 2));
    }
    iu(t, i) {
        t.iu(i), this.kd(this.Nd(t, 2));
    }
    nu(t, i, n) {
        i.zo() || t.nu(i, n);
    }
    su(t, i, n) {
        i.zo() || (t.su(i, n), this.Ra(), this.kd(this.Nd(t, 2)));
    }
    eu(t, i) {
        i.zo() || (t.eu(i), this.kd(this.Nd(t, 2)));
    }
    au(t, i) {
        t.au(i), this.kd(this.Nd(t, 2));
    }
    Fd(t) {
        this.ia.u_(t);
    }
    Wd(t, i) {
        const n = this.Et();
        if (n.Zi() || 0 === i) return;
        const s = n.nn();
        t = Math.max(1, Math.min(t, s)), n.Uc(t, i), this.Lc();
    }
    Hd(t) {
        this.Ud(0), this.$d(t), this.jd();
    }
    qd(t) {
        this.ia.c_(t), this.Lc();
    }
    Yd() {
        this.ia.d_(), this.mr();
    }
    Ud(t) {
        this.ia.f_(t);
    }
    $d(t) {
        this.ia.p_(t), this.Lc();
    }
    jd() {
        this.ia.v_(), this.mr();
    }
    Jn() {
        return this.fd;
    }
    Wn() {
        return null === this.pd && (this.pd = this.fd.filter((t)=>t.It())), this.pd;
    }
    Pa() {
        this.pd = null;
    }
    Kd(t, i, n, s, e) {
        this.Ct.In(t, i);
        let r = NaN, h = this.ia.Vc(t, !0);
        const a = this.ia.Ee();
        null !== a && (h = Math.min(Math.max(a.Na(), h), a.bi())), h = this.Ct.Fn(h);
        const l = s.kn(), o = l.Lt();
        if (null !== o && (r = l.Tn(i, o)), r = this.Sd.Pl(r, h, s), this.Ct.An(h, r, s), this.Ya(), !e) {
            const e = $8f74814242901c26$var$Bi(s, t, i);
            this.Rd(e && {
                uu: e.uu,
                bu: e.bu,
                gu: e.gu || null,
                ee: e.ee
            }), this.wd.p(this.Ct.Bt(), {
                x: t,
                y: i
            }, n);
        }
    }
    Gd(t, i, n) {
        const s = n.kn(), e = s.Lt(), r = s.Nt(t, $8f74814242901c26$var$u(e)), h = this.ia.Mc(i, !0), a = this.ia.jt($8f74814242901c26$var$u(h));
        this.Kd(a, r, null, n, !0);
    }
    Zd(t) {
        this.Vd().zn(), this.Ya(), t || this.wd.p(null, null, null);
    }
    Ra() {
        const t = this.Ct.Kn();
        if (null !== t) {
            const i = this.Ct.Bn(), n = this.Ct.En();
            this.Kd(i, n, null, t);
        }
        this.Ct.Nn();
    }
    Xd(t, i, n) {
        const s = this.ia.Rn(0);
        void 0 !== i && void 0 !== n && this.ia.Pt(i, n);
        const e = this.ia.Rn(0), r = this.ia.Dc(), h = this.ia.Ee();
        if (null !== h && null !== s && null !== e) {
            const i = h.ze(r), a = this.Pu.key(s) > this.Pu.key(e), l = null !== t && t > r && !a, o = this.ia.N().allowShiftVisibleRangeOnWhitespaceReplacement, _ = i && (!(void 0 === n) || o) && this.ia.N().shiftVisibleRangeOnNewBar;
            if (l && !_) {
                const i = t - r;
                this.ia.gs(this.ia.Oc() - i);
            }
        }
        this.ia.Hc(t);
    }
    Ba(t) {
        null !== t && t.ou();
    }
    Ks(t) {
        if (function(t) {
            return t instanceof $8f74814242901c26$var$Pi;
        }(t)) return t;
        const i = this.dd.find((i)=>i.Dt().includes(t));
        return void 0 === i ? null : i;
    }
    Lc() {
        this.dd.forEach((t)=>t.ou()), this.Ra();
    }
    m() {
        this.dd.forEach((t)=>t.m()), this.dd.length = 0, this.yn.localization.priceFormatter = void 0, this.yn.localization.percentageFormatter = void 0, this.yn.localization.timeFormatter = void 0;
    }
    Jd() {
        return this.bd;
    }
    Js() {
        return this.bd.N();
    }
    N_() {
        return this.md;
    }
    Qd(t, i) {
        const n = this.xd(i);
        this.tf(t, n), this.fd.push(t), this.Pa(), 1 === this.fd.length ? this.ka() : this.mr();
    }
    if(t) {
        const i = this.Ks(t), n = this.fd.indexOf(t);
        $8f74814242901c26$var$o(-1 !== n, "Series not found");
        const s = $8f74814242901c26$var$u(i);
        this.fd.splice(n, 1), s.l_(t), t.m && t.m(), this.Pa(), this.ia.dc(), this.nf(s);
    }
    ya(t, i) {
        const n = $8f74814242901c26$var$u(this.Ks(t));
        n.l_(t, !0), n.h_(t, i, !0);
    }
    td() {
        const t = $8f74814242901c26$var$X.Cs();
        t.us(), this.kd(t);
    }
    sf(t) {
        const i = $8f74814242901c26$var$X.Cs();
        i.fs(t), this.kd(i);
    }
    ws() {
        const t = $8f74814242901c26$var$X.Cs();
        t.ws(), this.kd(t);
    }
    Ms(t) {
        const i = $8f74814242901c26$var$X.Cs();
        i.Ms(t), this.kd(i);
    }
    gs(t) {
        const i = $8f74814242901c26$var$X.Cs();
        i.gs(t), this.kd(i);
    }
    ps(t) {
        const i = $8f74814242901c26$var$X.Cs();
        i.ps(t), this.kd(i);
    }
    cs() {
        const t = $8f74814242901c26$var$X.Cs();
        t.cs(), this.kd(t);
    }
    ef() {
        const t = this.yn.defaultVisiblePriceScaleId, i = this.yn.leftPriceScale.visible;
        return i !== this.yn.rightPriceScale.visible ? i ? "left" : "right" : t;
    }
    rf(t, i) {
        $8f74814242901c26$var$o(i >= 0, "Index should be greater or equal to 0");
        if (i === this.hf(t)) return;
        const n = $8f74814242901c26$var$u(this.Ks(t));
        n.l_(t);
        const s = this.xd(i);
        this.tf(t, s);
        let e = !1;
        0 === n.kl().length && (e = this.nf(n)), e || this.ka();
    }
    af() {
        return this.Pd;
    }
    $() {
        return this.Cd;
    }
    Ut(t) {
        const i = this.Pd, n = this.Cd;
        if (i === n) return i;
        if (t = Math.max(0, Math.min(100, Math.round(100 * t))), null === this.Md || this.Md.ah !== n || this.Md.oh !== i) this.Md = {
            ah: n,
            oh: i,
            lf: new Map
        };
        else {
            const i = this.Md.lf.get(t);
            if (void 0 !== i) return i;
        }
        const s = this.Io.tt(n, i, t / 100);
        return this.Md.lf.set(t, s), s;
    }
    _f(t) {
        return this.dd.indexOf(t);
    }
    Xi() {
        return this.Io;
    }
    uf() {
        return this.cf();
    }
    cf(t) {
        const i = new $8f74814242901c26$var$Pi(this.ia, this);
        this.dd.push(i);
        const n = t ?? this.dd.length - 1, s = $8f74814242901c26$var$X.ys();
        return s.es(n, {
            rs: 0,
            hs: !0
        }), this.kd(s), i;
    }
    xd(t) {
        return $8f74814242901c26$var$o(t >= 0, "Index should be greater or equal to 0"), (t = Math.min(this.dd.length, t)) < this.dd.length ? this.dd[t] : this.cf(t);
    }
    hf(t) {
        return this.dd.findIndex((i)=>i.Y_().includes(t));
    }
    Nd(t, i) {
        const n = new $8f74814242901c26$var$X(i);
        if (null !== t) {
            const s = this.dd.indexOf(t);
            n.es(s, {
                rs: i
            });
        }
        return n;
    }
    Td(t, i) {
        return void 0 === i && (i = 2), this.Nd(this.Ks(t), i);
    }
    kd(t) {
        this.gd && this.gd(t), this.dd.forEach((t)=>t.wu().wr().Pt());
    }
    tf(t, i) {
        const n = t.N().priceScaleId, s = void 0 !== n ? n : this.ef();
        i.h_(t, s), $8f74814242901c26$var$Z(s) || t.vr(t.N());
    }
    yd(t) {
        const i = this.yn.layout;
        return "gradient" === i.background.type ? 0 === t ? i.background.topColor : i.background.bottomColor : i.background.color;
    }
    nf(t) {
        return !t.q_() && 0 === t.kl().length && this.dd.length > 1 && (this.dd.splice(this._f(t), 1), this.ka(), !0);
    }
}
function $8f74814242901c26$var$Yi(t) {
    if (t >= 1) return 0;
    let i = 0;
    for(; i < 8; i++){
        const n = Math.round(t);
        if (Math.abs(n - t) < 1e-8) return i;
        t *= 10;
    }
    return i;
}
function $8f74814242901c26$export$45e4facdeecbf8d7(t) {
    return !$8f74814242901c26$var$p(t) && !$8f74814242901c26$var$m(t);
}
function $8f74814242901c26$export$d45648b9f1f4eae6(t) {
    return $8f74814242901c26$var$p(t);
}
!function(t) {
    t[t.Disabled = 0] = "Disabled", t[t.Continuous = 1] = "Continuous", t[t.OnDataUpdate = 2] = "OnDataUpdate";
}($8f74814242901c26$export$cac7f40581f5d090 || ($8f74814242901c26$export$cac7f40581f5d090 = {})), function(t) {
    t[t.LastBar = 0] = "LastBar", t[t.LastVisible = 1] = "LastVisible";
}($8f74814242901c26$export$10777445820939da || ($8f74814242901c26$export$10777445820939da = {})), function(t) {
    t.Solid = "solid", t.VerticalGradient = "gradient";
}($8f74814242901c26$export$2cd82751acc0e609 || ($8f74814242901c26$export$2cd82751acc0e609 = {})), function(t) {
    t[t.Year = 0] = "Year", t[t.Month = 1] = "Month", t[t.DayOfMonth = 2] = "DayOfMonth", t[t.Time = 3] = "Time", t[t.TimeWithSeconds = 4] = "TimeWithSeconds";
}($8f74814242901c26$export$2f85f4e66fc865ef || ($8f74814242901c26$export$2f85f4e66fc865ef = {}));
const $8f74814242901c26$var$Zi = (t)=>t.getUTCFullYear();
function $8f74814242901c26$var$Xi(t, i, n) {
    return i.replace(/yyyy/g, ((t)=>$8f74814242901c26$var$tt($8f74814242901c26$var$Zi(t), 4))(t)).replace(/yy/g, ((t)=>$8f74814242901c26$var$tt($8f74814242901c26$var$Zi(t) % 100, 2))(t)).replace(/MMMM/g, ((t, i)=>new Date(t.getUTCFullYear(), t.getUTCMonth(), 1).toLocaleString(i, {
            month: "long"
        }))(t, n)).replace(/MMM/g, ((t, i)=>new Date(t.getUTCFullYear(), t.getUTCMonth(), 1).toLocaleString(i, {
            month: "short"
        }))(t, n)).replace(/MM/g, ((t)=>$8f74814242901c26$var$tt(((t)=>t.getUTCMonth() + 1)(t), 2))(t)).replace(/dd/g, ((t)=>$8f74814242901c26$var$tt(((t)=>t.getUTCDate())(t), 2))(t));
}
class $8f74814242901c26$var$Ji {
    constructor(t = "yyyy-MM-dd", i = "default"){
        this.df = t, this.ff = i;
    }
    ku(t) {
        return $8f74814242901c26$var$Xi(t, this.df, this.ff);
    }
}
class $8f74814242901c26$var$Qi {
    constructor(t){
        this.pf = t || "%h:%m:%s";
    }
    ku(t) {
        return this.pf.replace("%h", $8f74814242901c26$var$tt(t.getUTCHours(), 2)).replace("%m", $8f74814242901c26$var$tt(t.getUTCMinutes(), 2)).replace("%s", $8f74814242901c26$var$tt(t.getUTCSeconds(), 2));
    }
}
const $8f74814242901c26$var$tn = {
    vf: "yyyy-MM-dd",
    mf: "%h:%m:%s",
    wf: " ",
    Mf: "default"
};
class $8f74814242901c26$var$nn {
    constructor(t = {}){
        const i = {
            ...$8f74814242901c26$var$tn,
            ...t
        };
        this.gf = new $8f74814242901c26$var$Ji(i.vf, i.Mf), this.bf = new $8f74814242901c26$var$Qi(i.mf), this.Sf = i.wf;
    }
    ku(t) {
        return `${this.gf.ku(t)}${this.Sf}${this.bf.ku(t)}`;
    }
}
function $8f74814242901c26$var$sn(t) {
    return 60 * t * 60000;
}
function $8f74814242901c26$var$en(t) {
    return 60 * t * 1e3;
}
const $8f74814242901c26$var$rn = [
    {
        xf: ($8f74814242901c26$var$hn = 1, 1e3 * $8f74814242901c26$var$hn),
        Cf: 10
    },
    {
        xf: $8f74814242901c26$var$en(1),
        Cf: 20
    },
    {
        xf: $8f74814242901c26$var$en(5),
        Cf: 21
    },
    {
        xf: $8f74814242901c26$var$en(30),
        Cf: 22
    },
    {
        xf: $8f74814242901c26$var$sn(1),
        Cf: 30
    },
    {
        xf: $8f74814242901c26$var$sn(3),
        Cf: 31
    },
    {
        xf: $8f74814242901c26$var$sn(6),
        Cf: 32
    },
    {
        xf: $8f74814242901c26$var$sn(12),
        Cf: 33
    }
];
var $8f74814242901c26$var$hn;
function $8f74814242901c26$var$an(t, i) {
    if (t.getUTCFullYear() !== i.getUTCFullYear()) return 70;
    if (t.getUTCMonth() !== i.getUTCMonth()) return 60;
    if (t.getUTCDate() !== i.getUTCDate()) return 50;
    for(let n = $8f74814242901c26$var$rn.length - 1; n >= 0; --n)if (Math.floor(i.getTime() / $8f74814242901c26$var$rn[n].xf) !== Math.floor(t.getTime() / $8f74814242901c26$var$rn[n].xf)) return $8f74814242901c26$var$rn[n].Cf;
    return 0;
}
function $8f74814242901c26$var$ln(t) {
    let i = t;
    if ($8f74814242901c26$var$m(t) && (i = $8f74814242901c26$var$_n(t)), !$8f74814242901c26$export$45e4facdeecbf8d7(i)) throw new Error("time must be of type BusinessDay");
    const n = new Date(Date.UTC(i.year, i.month - 1, i.day, 0, 0, 0, 0));
    return {
        yf: Math.round(n.getTime() / 1e3),
        Pf: i
    };
}
function $8f74814242901c26$var$on(t) {
    if (!$8f74814242901c26$export$d45648b9f1f4eae6(t)) throw new Error("time must be of type isUTCTimestamp");
    return {
        yf: t
    };
}
function $8f74814242901c26$var$_n(t) {
    const i = new Date(t);
    if (isNaN(i.getTime())) throw new Error(`Invalid date string=${t}, expected format=yyyy-mm-dd`);
    return {
        day: i.getUTCDate(),
        month: i.getUTCMonth() + 1,
        year: i.getUTCFullYear()
    };
}
function $8f74814242901c26$var$un(t) {
    $8f74814242901c26$var$m(t.time) && (t.time = $8f74814242901c26$var$_n(t.time));
}
class $8f74814242901c26$var$cn {
    options() {
        return this.yn;
    }
    setOptions(t) {
        this.yn = t, this.updateFormatter(t.localization);
    }
    preprocessData(t) {
        Array.isArray(t) ? function(t) {
            t.forEach($8f74814242901c26$var$un);
        }(t) : $8f74814242901c26$var$un(t);
    }
    createConverterToInternalObj(t) {
        return $8f74814242901c26$var$u(function(t) {
            return 0 === t.length ? null : $8f74814242901c26$export$45e4facdeecbf8d7(t[0].time) || $8f74814242901c26$var$m(t[0].time) ? $8f74814242901c26$var$ln : $8f74814242901c26$var$on;
        }(t));
    }
    key(t) {
        return "object" == typeof t && "yf" in t ? t.yf : this.key(this.convertHorzItemToInternal(t));
    }
    cacheKey(t) {
        const i = t;
        return void 0 === i.Pf ? new Date(1e3 * i.yf).getTime() : new Date(Date.UTC(i.Pf.year, i.Pf.month - 1, i.Pf.day)).getTime();
    }
    convertHorzItemToInternal(t) {
        var i;
        return $8f74814242901c26$export$d45648b9f1f4eae6(i = t) ? $8f74814242901c26$var$on(i) : $8f74814242901c26$export$45e4facdeecbf8d7(i) ? $8f74814242901c26$var$ln(i) : $8f74814242901c26$var$ln($8f74814242901c26$var$_n(i));
    }
    updateFormatter(t) {
        if (!this.yn) return;
        const i = t.dateFormat;
        this.yn.timeScale.timeVisible ? this.kf = new $8f74814242901c26$var$nn({
            vf: i,
            mf: this.yn.timeScale.secondsVisible ? "%h:%m:%s" : "%h:%m",
            wf: "   ",
            Mf: t.locale
        }) : this.kf = new $8f74814242901c26$var$Ji(i, t.locale);
    }
    formatHorzItem(t) {
        const i = t;
        return this.kf.ku(new Date(1e3 * i.yf));
    }
    formatTickmark(t, i) {
        const n = function(t, i, n) {
            switch(t){
                case 0:
                case 10:
                    return i ? n ? 4 : 3 : 2;
                case 20:
                case 21:
                case 22:
                case 30:
                case 31:
                case 32:
                case 33:
                    return i ? 3 : 2;
                case 50:
                    return 2;
                case 60:
                    return 1;
                case 70:
                    return 0;
            }
        }(t.weight, this.yn.timeScale.timeVisible, this.yn.timeScale.secondsVisible), s = this.yn.timeScale;
        if (void 0 !== s.tickMarkFormatter) {
            const e = s.tickMarkFormatter(t.originalTime, n, i.locale);
            if (null !== e) return e;
        }
        return function(t, i, n) {
            const s = {};
            switch(i){
                case 0:
                    s.year = "numeric";
                    break;
                case 1:
                    s.month = "short";
                    break;
                case 2:
                    s.day = "numeric";
                    break;
                case 3:
                    s.hour12 = !1, s.hour = "2-digit", s.minute = "2-digit";
                    break;
                case 4:
                    s.hour12 = !1, s.hour = "2-digit", s.minute = "2-digit", s.second = "2-digit";
            }
            const e = void 0 === t.Pf ? new Date(1e3 * t.yf) : new Date(Date.UTC(t.Pf.year, t.Pf.month - 1, t.Pf.day));
            return new Date(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate(), e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds()).toLocaleString(n, s);
        }(t.time, n, i.locale);
    }
    maxTickMarkWeight(t) {
        let i = t.reduce($8f74814242901c26$var$Ni, t[0]).weight;
        return i > 30 && i < 50 && (i = 30), i;
    }
    fillWeightsForPoints(t, i) {
        !function(t, i = 0) {
            if (0 === t.length) return;
            let n = 0 === i ? null : t[i - 1].time.yf, s = null !== n ? new Date(1e3 * n) : null, e = 0;
            for(let r = i; r < t.length; ++r){
                const i = t[r], h = new Date(1e3 * i.time.yf);
                null !== s && (i.timeWeight = $8f74814242901c26$var$an(h, s)), e += i.time.yf - (n || i.time.yf), n = i.time.yf, s = h;
            }
            if (0 === i && t.length > 1) {
                const i = Math.ceil(e / (t.length - 1)), n = new Date(1e3 * (t[0].time.yf - i));
                t[0].timeWeight = $8f74814242901c26$var$an(new Date(1e3 * t[0].time.yf), n);
            }
        }(t, i);
    }
    static Tf(t) {
        return $8f74814242901c26$var$f({
            localization: {
                dateFormat: "dd MMM 'yy"
            }
        }, t ?? {});
    }
}
const $8f74814242901c26$var$dn = "undefined" != typeof window;
function $8f74814242901c26$var$fn() {
    return !!$8f74814242901c26$var$dn && window.navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
}
function $8f74814242901c26$var$pn() {
    return !!$8f74814242901c26$var$dn && /iPhone|iPad|iPod/.test(window.navigator.platform);
}
function $8f74814242901c26$var$vn(t, i) {
    switch(t){
        case "custom":
            return void 0 !== i ? "custom-object" : "series";
        case "price-line":
            return "custom-price-line";
        case "marker":
            return "series-marker";
        case "primitive":
            return "primitive";
        default:
            return "series";
    }
}
function $8f74814242901c26$var$mn(t) {
    return t + t % 2;
}
function $8f74814242901c26$var$wn(t) {
    $8f74814242901c26$var$dn && void 0 !== window.chrome && t.addEventListener("mousedown", (t)=>{
        if (1 === t.button) return t.preventDefault(), !1;
    });
}
class $8f74814242901c26$var$Mn {
    constructor(t, i, n){
        this.Rf = 0, this.Df = null, this.If = {
            _t: Number.NEGATIVE_INFINITY,
            ut: Number.POSITIVE_INFINITY
        }, this.Vf = 0, this.Bf = null, this.Ef = {
            _t: Number.NEGATIVE_INFINITY,
            ut: Number.POSITIVE_INFINITY
        }, this.Af = null, this.Lf = !1, this.zf = null, this.Of = null, this.Nf = !1, this.Ff = !1, this.Wf = !1, this.Hf = null, this.Uf = null, this.$f = null, this.jf = null, this.qf = null, this.Yf = null, this.Kf = null, this.Gf = 0, this.Zf = !1, this.Xf = !1, this.Jf = !1, this.Qf = 0, this.tp = null, this.ip = !$8f74814242901c26$var$pn(), this.np = (t)=>{
            this.sp(t);
        }, this.ep = (t)=>{
            if (this.rp(t)) {
                const i = this.hp(t);
                if (++this.Vf, this.Bf && this.Vf > 1) {
                    const { ap: n } = this.lp($8f74814242901c26$var$Sn(t), this.Ef);
                    n < 30 && !this.Wf && this.op(i, this.up._p), this.cp();
                }
            } else {
                const i = this.hp(t);
                if (++this.Rf, this.Df && this.Rf > 1) {
                    const { ap: n } = this.lp($8f74814242901c26$var$Sn(t), this.If);
                    n < 5 && !this.Ff && this.dp(i, this.up.fp), this.pp();
                }
            }
        }, this.vp = t, this.up = i, this.yn = n, this.mp();
    }
    m() {
        null !== this.Hf && (this.Hf(), this.Hf = null), null !== this.Uf && (this.Uf(), this.Uf = null), null !== this.jf && (this.jf(), this.jf = null), null !== this.qf && (this.qf(), this.qf = null), null !== this.Yf && (this.Yf(), this.Yf = null), null !== this.$f && (this.$f(), this.$f = null), this.wp(), this.pp();
    }
    Mp(t) {
        this.jf && this.jf();
        const i = this.gp.bind(this);
        if (this.jf = ()=>{
            this.vp.removeEventListener("mousemove", i);
        }, this.vp.addEventListener("mousemove", i), this.rp(t)) return;
        const n = this.hp(t);
        this.dp(n, this.up.bp), this.ip = !0;
    }
    pp() {
        null !== this.Df && clearTimeout(this.Df), this.Rf = 0, this.Df = null, this.If = {
            _t: Number.NEGATIVE_INFINITY,
            ut: Number.POSITIVE_INFINITY
        };
    }
    cp() {
        null !== this.Bf && clearTimeout(this.Bf), this.Vf = 0, this.Bf = null, this.Ef = {
            _t: Number.NEGATIVE_INFINITY,
            ut: Number.POSITIVE_INFINITY
        };
    }
    gp(t) {
        if (this.Jf || null !== this.Of) return;
        if (this.rp(t)) return;
        const i = this.hp(t);
        this.dp(i, this.up.Sp), this.ip = !0;
    }
    xp(t) {
        const i = $8f74814242901c26$var$Cn(t.changedTouches, $8f74814242901c26$var$u(this.tp));
        if (null === i) return;
        if (this.Qf = $8f74814242901c26$var$xn(t), null !== this.Kf) return;
        if (this.Xf) return;
        this.Zf = !0;
        const n = this.lp($8f74814242901c26$var$Sn(i), $8f74814242901c26$var$u(this.Of)), { Cp: s, yp: e, ap: r } = n;
        if (this.Nf || !(r < 5)) {
            if (!this.Nf) {
                const t = .5 * s, i = e >= t && !this.yn.Pp(), n = t > e && !this.yn.kp();
                i || n || (this.Xf = !0), this.Nf = !0, this.Wf = !0, this.wp(), this.cp();
            }
            if (!this.Xf) {
                const n = this.hp(t, i);
                this.op(n, this.up.Tp), $8f74814242901c26$var$bn(t);
            }
        }
    }
    Rp(t) {
        if (0 !== t.button) return;
        const i = this.lp($8f74814242901c26$var$Sn(t), $8f74814242901c26$var$u(this.zf)), { ap: n } = i;
        if (n >= 5 && (this.Ff = !0, this.pp()), this.Ff) {
            const i = this.hp(t);
            this.dp(i, this.up.Dp);
        }
    }
    lp(t, i) {
        const n = Math.abs(i._t - t._t), s = Math.abs(i.ut - t.ut);
        return {
            Cp: n,
            yp: s,
            ap: n + s
        };
    }
    Ip(t) {
        let i = $8f74814242901c26$var$Cn(t.changedTouches, $8f74814242901c26$var$u(this.tp));
        if (null === i && 0 === t.touches.length && (i = t.changedTouches[0]), null === i) return;
        this.tp = null, this.Qf = $8f74814242901c26$var$xn(t), this.wp(), this.Of = null, this.Yf && (this.Yf(), this.Yf = null);
        const n = this.hp(t, i);
        if (this.op(n, this.up.Vp), ++this.Vf, this.Bf && this.Vf > 1) {
            const { ap: t } = this.lp($8f74814242901c26$var$Sn(i), this.Ef);
            t < 30 && !this.Wf && this.op(n, this.up._p), this.cp();
        } else this.Wf || (this.op(n, this.up.Bp), this.up.Bp && $8f74814242901c26$var$bn(t));
        0 === this.Vf && $8f74814242901c26$var$bn(t), 0 === t.touches.length && this.Lf && (this.Lf = !1, $8f74814242901c26$var$bn(t));
    }
    sp(t) {
        if (0 !== t.button) return;
        const i = this.hp(t);
        if (this.zf = null, this.Jf = !1, this.qf && (this.qf(), this.qf = null), $8f74814242901c26$var$fn()) this.vp.ownerDocument.documentElement.removeEventListener("mouseleave", this.np);
        if (!this.rp(t)) {
            if (this.dp(i, this.up.Ep), ++this.Rf, this.Df && this.Rf > 1) {
                const { ap: n } = this.lp($8f74814242901c26$var$Sn(t), this.If);
                n < 5 && !this.Ff && this.dp(i, this.up.fp), this.pp();
            } else this.Ff || this.dp(i, this.up.Ap);
        }
    }
    wp() {
        null !== this.Af && (clearTimeout(this.Af), this.Af = null);
    }
    Lp(t) {
        if (null !== this.tp) return;
        const i = t.changedTouches[0];
        this.tp = i.identifier, this.Qf = $8f74814242901c26$var$xn(t);
        const n = this.vp.ownerDocument.documentElement;
        this.Wf = !1, this.Nf = !1, this.Xf = !1, this.Of = $8f74814242901c26$var$Sn(i), this.Yf && (this.Yf(), this.Yf = null);
        {
            const i = this.xp.bind(this), s = this.Ip.bind(this);
            this.Yf = ()=>{
                n.removeEventListener("touchmove", i), n.removeEventListener("touchend", s);
            }, n.addEventListener("touchmove", i, {
                passive: !1
            }), n.addEventListener("touchend", s, {
                passive: !1
            }), this.wp(), this.Af = setTimeout(this.zp.bind(this, t), 240);
        }
        const s = this.hp(t, i);
        this.op(s, this.up.Op), this.Bf || (this.Vf = 0, this.Bf = setTimeout(this.cp.bind(this), 500), this.Ef = $8f74814242901c26$var$Sn(i));
    }
    Np(t) {
        if (0 !== t.button) return;
        const i = this.vp.ownerDocument.documentElement;
        $8f74814242901c26$var$fn() && i.addEventListener("mouseleave", this.np), this.Ff = !1, this.zf = $8f74814242901c26$var$Sn(t), this.qf && (this.qf(), this.qf = null);
        {
            const t = this.Rp.bind(this), n = this.sp.bind(this);
            this.qf = ()=>{
                i.removeEventListener("mousemove", t), i.removeEventListener("mouseup", n);
            }, i.addEventListener("mousemove", t), i.addEventListener("mouseup", n);
        }
        if (this.Jf = !0, this.rp(t)) return;
        const n = this.hp(t);
        this.dp(n, this.up.Fp), this.Df || (this.Rf = 0, this.Df = setTimeout(this.pp.bind(this), 500), this.If = $8f74814242901c26$var$Sn(t));
    }
    mp() {
        this.vp.addEventListener("mouseenter", this.Mp.bind(this)), this.vp.addEventListener("touchcancel", this.wp.bind(this));
        {
            const t = this.vp.ownerDocument, i = (t)=>{
                this.up.Wp && (t.composed && this.vp.contains(t.composedPath()[0]) || t.target && this.vp.contains(t.target) || this.up.Wp());
            };
            this.Uf = ()=>{
                t.removeEventListener("touchstart", i);
            }, this.Hf = ()=>{
                t.removeEventListener("mousedown", i);
            }, t.addEventListener("mousedown", i), t.addEventListener("touchstart", i, {
                passive: !0
            });
        }
        $8f74814242901c26$var$pn() && (this.$f = ()=>{
            this.vp.removeEventListener("dblclick", this.ep);
        }, this.vp.addEventListener("dblclick", this.ep)), this.vp.addEventListener("mouseleave", this.Hp.bind(this)), this.vp.addEventListener("touchstart", this.Lp.bind(this), {
            passive: !0
        }), $8f74814242901c26$var$wn(this.vp), this.vp.addEventListener("mousedown", this.Np.bind(this)), this.Up(), this.vp.addEventListener("touchmove", ()=>{}, {
            passive: !1
        });
    }
    Up() {
        void 0 === this.up.$p && void 0 === this.up.jp && void 0 === this.up.qp || (this.vp.addEventListener("touchstart", (t)=>this.Yp(t.touches), {
            passive: !0
        }), this.vp.addEventListener("touchmove", (t)=>{
            if (2 === t.touches.length && null !== this.Kf && void 0 !== this.up.jp) {
                const i = $8f74814242901c26$var$gn(t.touches[0], t.touches[1]) / this.Gf;
                this.up.jp(this.Kf, i), $8f74814242901c26$var$bn(t);
            }
        }, {
            passive: !1
        }), this.vp.addEventListener("touchend", (t)=>{
            this.Yp(t.touches);
        }));
    }
    Yp(t) {
        1 === t.length && (this.Zf = !1), 2 !== t.length || this.Zf || this.Lf ? this.Kp() : this.Gp(t);
    }
    Gp(t) {
        const i = this.vp.getBoundingClientRect() || {
            left: 0,
            top: 0
        };
        this.Kf = {
            _t: (t[0].clientX - i.left + (t[1].clientX - i.left)) / 2,
            ut: (t[0].clientY - i.top + (t[1].clientY - i.top)) / 2
        }, this.Gf = $8f74814242901c26$var$gn(t[0], t[1]), void 0 !== this.up.$p && this.up.$p(), this.wp();
    }
    Kp() {
        null !== this.Kf && (this.Kf = null, void 0 !== this.up.qp && this.up.qp());
    }
    Hp(t) {
        if (this.jf && this.jf(), this.rp(t)) return;
        if (!this.ip) return;
        const i = this.hp(t);
        this.dp(i, this.up.Zp), this.ip = !$8f74814242901c26$var$pn();
    }
    zp(t) {
        const i = $8f74814242901c26$var$Cn(t.touches, $8f74814242901c26$var$u(this.tp));
        if (null === i) return;
        const n = this.hp(t, i);
        this.op(n, this.up.Xp), this.Wf = !0, this.Lf = !0;
    }
    rp(t) {
        return t.sourceCapabilities && void 0 !== t.sourceCapabilities.firesTouchEvents ? t.sourceCapabilities.firesTouchEvents : $8f74814242901c26$var$xn(t) < this.Qf + 500;
    }
    op(t, i) {
        i && i.call(this.up, t);
    }
    dp(t, i) {
        i && i.call(this.up, t);
    }
    hp(t, i) {
        const n = i || t, s = this.vp.getBoundingClientRect() || {
            left: 0,
            top: 0
        };
        return {
            clientX: n.clientX,
            clientY: n.clientY,
            pageX: n.pageX,
            pageY: n.pageY,
            screenX: n.screenX,
            screenY: n.screenY,
            localX: n.clientX - s.left,
            localY: n.clientY - s.top,
            ctrlKey: t.ctrlKey,
            altKey: t.altKey,
            shiftKey: t.shiftKey,
            metaKey: t.metaKey,
            Jp: !t.type.startsWith("mouse") && "contextmenu" !== t.type && "click" !== t.type,
            Qp: t.type,
            tv: n.target,
            xu: t.view,
            iv: ()=>{
                "touchstart" !== t.type && $8f74814242901c26$var$bn(t);
            }
        };
    }
}
function $8f74814242901c26$var$gn(t, i) {
    const n = t.clientX - i.clientX, s = t.clientY - i.clientY;
    return Math.sqrt(n * n + s * s);
}
function $8f74814242901c26$var$bn(t) {
    t.cancelable && t.preventDefault();
}
function $8f74814242901c26$var$Sn(t) {
    return {
        _t: t.pageX,
        ut: t.pageY
    };
}
function $8f74814242901c26$var$xn(t) {
    return t.timeStamp || performance.now();
}
function $8f74814242901c26$var$Cn(t, i) {
    for(let n = 0; n < t.length; ++n)if (t[n].identifier === i) return t[n];
    return null;
}
class $8f74814242901c26$var$yn {
    constructor(t, i, n){
        this.nv = null, this.sv = null, this.ev = !0, this.rv = null, this.hv = t, this.av = t.lv()[i], this.ov = t.lv()[n], this._v = document.createElement("tr"), this._v.style.height = "1px", this.uv = document.createElement("td"), this.uv.style.position = "relative", this.uv.style.padding = "0", this.uv.style.margin = "0", this.uv.setAttribute("colspan", "3"), this.cv(), this._v.appendChild(this.uv), this.ev = this.hv.N().layout.panes.enableResize, this.ev ? this.dv() : (this.nv = null, this.sv = null);
    }
    m() {
        null !== this.sv && this.sv.m();
    }
    fv() {
        return this._v;
    }
    pv() {
        return (0, $aFz8k.size)({
            width: this.av.pv().width,
            height: 1
        });
    }
    vv() {
        return (0, $aFz8k.size)({
            width: this.av.vv().width,
            height: 1 * window.devicePixelRatio
        });
    }
    mv(t, i, n) {
        const s = this.vv();
        t.fillStyle = this.hv.N().layout.panes.separatorColor, t.fillRect(i, n, s.width, s.height);
    }
    Pt() {
        this.cv(), this.hv.N().layout.panes.enableResize !== this.ev && (this.ev = this.hv.N().layout.panes.enableResize, this.ev ? this.dv() : (null !== this.nv && (this.uv.removeChild(this.nv.wv), this.uv.removeChild(this.nv.Mv), this.nv = null), null !== this.sv && (this.sv.m(), this.sv = null)));
    }
    dv() {
        const t = document.createElement("div"), i = t.style;
        i.position = "fixed", i.display = "none", i.zIndex = "49", i.top = "0", i.left = "0", i.width = "100%", i.height = "100%", i.cursor = "row-resize", this.uv.appendChild(t);
        const n = document.createElement("div"), s = n.style;
        s.position = "absolute", s.zIndex = "50", s.top = "-4px", s.height = "9px", s.width = "100%", s.backgroundColor = "", s.cursor = "row-resize", this.uv.appendChild(n);
        const e = {
            bp: this.gv.bind(this),
            Zp: this.bv.bind(this),
            Fp: this.Sv.bind(this),
            Op: this.Sv.bind(this),
            Dp: this.xv.bind(this),
            Tp: this.xv.bind(this),
            Ep: this.Cv.bind(this),
            Vp: this.Cv.bind(this)
        };
        this.sv = new $8f74814242901c26$var$Mn(n, e, {
            Pp: ()=>!1,
            kp: ()=>!0
        }), this.nv = {
            Mv: n,
            wv: t
        };
    }
    cv() {
        this.uv.style.background = this.hv.N().layout.panes.separatorColor;
    }
    gv(t) {
        null !== this.nv && (this.nv.Mv.style.backgroundColor = this.hv.N().layout.panes.separatorHoverColor);
    }
    bv(t) {
        null !== this.nv && null === this.rv && (this.nv.Mv.style.backgroundColor = "");
    }
    Sv(t) {
        if (null === this.nv) return;
        const i = this.av.yv().F_() + this.ov.yv().F_(), n = i / (this.av.pv().height + this.ov.pv().height), s = 30 * n;
        i <= 2 * s || (this.rv = {
            Pv: t.pageY,
            kv: this.av.yv().F_(),
            Tv: i - s,
            Rv: i,
            Dv: n,
            Iv: s
        }, this.nv.wv.style.display = "block");
    }
    xv(t) {
        const i = this.rv;
        if (null === i) return;
        const n = (t.pageY - i.Pv) * i.Dv, s = $8f74814242901c26$var$ni(i.kv + n, i.Iv, i.Tv);
        this.av.yv().W_(s), this.ov.yv().W_(i.Rv - s), this.hv.Qt().ka();
    }
    Cv(t) {
        null !== this.rv && null !== this.nv && (this.rv = null, this.nv.wv.style.display = "none");
    }
}
function $8f74814242901c26$var$Pn(t, i) {
    return t.Vv - i.Vv;
}
function $8f74814242901c26$var$kn(t, i, n) {
    const s = (t.Vv - i.Vv) / (t.wt - i.wt);
    return Math.sign(s) * Math.min(Math.abs(s), n);
}
class $8f74814242901c26$var$Tn {
    constructor(t, i, n, s){
        this.Bv = null, this.Ev = null, this.Av = null, this.Lv = null, this.zv = null, this.Ov = 0, this.Nv = 0, this.Fv = t, this.Wv = i, this.Hv = n, this.Ps = s;
    }
    Uv(t, i) {
        if (null !== this.Bv) {
            if (this.Bv.wt === i) return void (this.Bv.Vv = t);
            if (Math.abs(this.Bv.Vv - t) < this.Ps) return;
        }
        this.Lv = this.Av, this.Av = this.Ev, this.Ev = this.Bv, this.Bv = {
            wt: i,
            Vv: t
        };
    }
    me(t, i) {
        if (null === this.Bv || null === this.Ev) return;
        if (i - this.Bv.wt > 50) return;
        let n = 0;
        const s = $8f74814242901c26$var$kn(this.Bv, this.Ev, this.Wv), e = $8f74814242901c26$var$Pn(this.Bv, this.Ev), r = [
            s
        ], h = [
            e
        ];
        if (n += e, null !== this.Av) {
            const t = $8f74814242901c26$var$kn(this.Ev, this.Av, this.Wv);
            if (Math.sign(t) === Math.sign(s)) {
                const i = $8f74814242901c26$var$Pn(this.Ev, this.Av);
                if (r.push(t), h.push(i), n += i, null !== this.Lv) {
                    const t = $8f74814242901c26$var$kn(this.Av, this.Lv, this.Wv);
                    if (Math.sign(t) === Math.sign(s)) {
                        const i = $8f74814242901c26$var$Pn(this.Av, this.Lv);
                        r.push(t), h.push(i), n += i;
                    }
                }
            }
        }
        let a = 0;
        for(let t = 0; t < r.length; ++t)a += h[t] / n * r[t];
        Math.abs(a) < this.Fv || (this.zv = {
            Vv: t,
            wt: i
        }, this.Nv = a, this.Ov = function(t, i) {
            const n = Math.log(i);
            return Math.log(1 * n / -t) / n;
        }(Math.abs(a), this.Hv));
    }
    Gc(t) {
        const i = $8f74814242901c26$var$u(this.zv), n = t - i.wt;
        return i.Vv + this.Nv * (Math.pow(this.Hv, n) - 1) / Math.log(this.Hv);
    }
    Kc(t) {
        return null === this.zv || this.$v(t) === this.Ov;
    }
    $v(t) {
        const i = t - $8f74814242901c26$var$u(this.zv).wt;
        return Math.min(i, this.Ov);
    }
}
class $8f74814242901c26$var$Rn {
    constructor(t, i){
        this.jv = void 0, this.qv = void 0, this.Yv = void 0, this.vn = !1, this.Kv = t, this.Gv = i, this.Zv();
    }
    Pt() {
        this.Zv();
    }
    Xv() {
        this.jv && this.Kv.removeChild(this.jv), this.qv && this.Kv.removeChild(this.qv), this.jv = void 0, this.qv = void 0;
    }
    Jv() {
        return this.vn !== this.Qv() || this.Yv !== this.tm();
    }
    tm() {
        return this.Gv.Qt().Xi().J(this.Gv.N().layout.textColor) > 160 ? "dark" : "light";
    }
    Qv() {
        return this.Gv.N().layout.attributionLogo;
    }
    im() {
        const t = new URL(location.href);
        return t.hostname ? "&utm_source=" + t.hostname + t.pathname : "";
    }
    Zv() {
        this.Jv() && (this.Xv(), this.vn = this.Qv(), this.vn && (this.Yv = this.tm(), this.qv = document.createElement("style"), this.qv.innerText = "a#tv-attr-logo{--fill:#131722;--stroke:#fff;position:absolute;left:10px;bottom:10px;height:19px;width:35px;margin:0;padding:0;border:0;z-index:3;}a#tv-attr-logo[data-dark]{--fill:#D1D4DC;--stroke:#131722;}", this.jv = document.createElement("a"), this.jv.href = `https://www.tradingview.com/?utm_medium=lwc-link&utm_campaign=lwc-chart${this.im()}`, this.jv.title = "Charting by TradingView", this.jv.id = "tv-attr-logo", this.jv.target = "_blank", this.jv.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="19" fill="none"><g fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path fill="var(--stroke)" d="M2 0H0v10h6v9h21.4l.5-1.3 6-15 1-2.7H23.7l-.5 1.3-.2.6a5 5 0 0 0-7-.9V0H2Zm20 17h4l5.2-13 .8-2h-7l-1 2.5-.2.5-1.5 3.8-.3.7V17Zm-.8-10a3 3 0 0 0 .7-2.7A3 3 0 1 0 16.8 7h4.4ZM14 7V2H2v6h6v9h4V7h2Z"/><path fill="var(--fill)" d="M14 2H2v6h6v9h6V2Zm12 15h-7l6-15h7l-6 15Zm-7-9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/></g><defs><clipPath id="a"><path fill="var(--stroke)" d="M0 0h35v19H0z"/></clipPath></defs></svg>', this.jv.toggleAttribute("data-dark", "dark" === this.Yv), this.Kv.appendChild(this.qv), this.Kv.appendChild(this.jv)));
    }
}
function $8f74814242901c26$var$Dn(t, n) {
    const s = $8f74814242901c26$var$u(t.ownerDocument).createElement("canvas");
    t.appendChild(s);
    const e = (0, $59mHk.bindTo)(s, {
        type: "device-pixel-content-box",
        options: {
            allowResizeObserver: !0
        },
        transform: (t, i)=>({
                width: Math.max(t.width, i.width),
                height: Math.max(t.height, i.height)
            })
    });
    return e.resizeCanvasElement(n), e;
}
function $8f74814242901c26$var$In(t) {
    t.width = 1, t.height = 1, t.getContext("2d")?.clearRect(0, 0, 1, 1);
}
function $8f74814242901c26$var$Vn(t, i, n, s) {
    t.qh && t.qh(i, n, s);
}
function $8f74814242901c26$var$Bn(t, i, n, s) {
    t.st(i, n, s);
}
function $8f74814242901c26$var$En(t, i, n, s) {
    $8f74814242901c26$var$An(t(n, s), i, s);
}
function $8f74814242901c26$var$An(t, i, n) {
    for (const s of t){
        const t = s.Tt(n);
        null !== t && i(t);
    }
}
function $8f74814242901c26$var$Ln(t, i) {
    return (n)=>{
        if (!function(t) {
            return void 0 !== t.Ft;
        }(n)) return [];
        return (n.Ft()?.pl() ?? "") !== i ? [] : n.Qa?.(t) ?? [];
    };
}
function $8f74814242901c26$var$zn(t, i, n, s) {
    if (!t.length) return;
    let e = 0;
    const r = t[0].$t(s, !0);
    let h = 1 === i ? n / 2 - (t[0].Hi() - r / 2) : t[0].Hi() - r / 2 - n / 2;
    h = Math.max(0, h);
    for(let r = 1; r < t.length; r++){
        const a = t[r], l = t[r - 1], o = l.$t(s, !1), _ = a.Hi(), u = l.Hi();
        if (1 === i ? _ > u - o : _ < u + o) {
            const s = u - o * i;
            a.Ui(s);
            const r = s - i * o / 2;
            if ((1 === i ? r < 0 : r > n) && h > 0) {
                const s = 1 === i ? -1 - r : r - n, a = Math.min(s, h);
                for(let n = e; n < t.length; n++)t[n].Ui(t[n].Hi() + i * a);
                h -= a;
            }
        } else e = r, h = 1 === i ? u - o - _ : _ - (u + o);
    }
}
class $8f74814242901c26$var$On {
    constructor(i, n, s, e){
        this.Ki = null, this.nm = null, this.sm = !1, this.rm = new $8f74814242901c26$var$rt(200), this.hm = null, this.am = 0, this.lm = !1, this.om = ()=>{
            this.lm || this.yt._m().Qt().mr();
        }, this.um = ()=>{
            this.lm || this.yt._m().Qt().mr();
        }, this.yt = i, this.yn = n, this.Ro = n.layout, this.bd = s, this.dm = "left" === e, this.fm = $8f74814242901c26$var$Ln("normal", e), this.pm = $8f74814242901c26$var$Ln("top", e), this.vm = $8f74814242901c26$var$Ln("bottom", e), this.uv = document.createElement("div"), this.uv.style.height = "100%", this.uv.style.overflow = "hidden", this.uv.style.width = "25px", this.uv.style.left = "0", this.uv.style.position = "relative", this.wm = $8f74814242901c26$var$Dn(this.uv, (0, $aFz8k.size)({
            width: 16,
            height: 16
        })), this.wm.subscribeSuggestedBitmapSizeChanged(this.om);
        const r = this.wm.canvasElement;
        r.style.position = "absolute", r.style.zIndex = "1", r.style.left = "0", r.style.top = "0", this.Mm = $8f74814242901c26$var$Dn(this.uv, (0, $aFz8k.size)({
            width: 16,
            height: 16
        })), this.Mm.subscribeSuggestedBitmapSizeChanged(this.um);
        const h = this.Mm.canvasElement;
        h.style.position = "absolute", h.style.zIndex = "2", h.style.left = "0", h.style.top = "0";
        const a = {
            Fp: this.Sv.bind(this),
            Op: this.Sv.bind(this),
            Dp: this.xv.bind(this),
            Tp: this.xv.bind(this),
            Wp: this.gm.bind(this),
            Ep: this.Cv.bind(this),
            Vp: this.Cv.bind(this),
            fp: this.bm.bind(this),
            _p: this.bm.bind(this),
            bp: this.Sm.bind(this),
            Zp: this.bv.bind(this)
        };
        this.sv = new $8f74814242901c26$var$Mn(this.Mm.canvasElement, a, {
            Pp: ()=>!this.yn.handleScroll.vertTouchDrag,
            kp: ()=>!0
        });
    }
    m() {
        this.sv.m(), this.Mm.unsubscribeSuggestedBitmapSizeChanged(this.um), $8f74814242901c26$var$In(this.Mm.canvasElement), this.Mm.dispose(), this.wm.unsubscribeSuggestedBitmapSizeChanged(this.om), $8f74814242901c26$var$In(this.wm.canvasElement), this.wm.dispose(), null !== this.Ki && this.Ki.__().u(this), this.Ki = null;
    }
    fv() {
        return this.uv;
    }
    P() {
        return this.Ro.fontSize;
    }
    xm() {
        const t = this.bd.N();
        return this.hm !== t.k && (this.rm.Os(), this.hm = t.k), t;
    }
    Cm() {
        if (null === this.Ki) return 0;
        let t = 0;
        const i = this.xm(), n = $8f74814242901c26$var$u(this.wm.canvasElement.getContext("2d", {
            colorSpace: this.yt._m().N().layout.colorSpace
        }));
        n.save();
        const s = this.Ki.zl();
        n.font = this.ym(), s.length > 0 && (t = Math.max(this.rm.Ii(n, s[0].eo), this.rm.Ii(n, s[s.length - 1].eo)));
        const e = this.Pm();
        for(let i = e.length; i--;){
            const s = this.rm.Ii(n, e[i].ri());
            s > t && (t = s);
        }
        const r = this.Ki.Lt();
        if (null !== r && null !== this.nm && 2 !== (h = this.yn.crosshair).mode && h.horzLine.visible && h.horzLine.labelVisible) {
            const i = this.Ki.Tn(1, r), s = this.Ki.Tn(this.nm.height - 2, r);
            t = Math.max(t, this.rm.Ii(n, this.Ki.Ji(Math.floor(Math.min(i, s)) + .11111111111111, r)), this.rm.Ii(n, this.Ki.Ji(Math.ceil(Math.max(i, s)) - .11111111111111, r)));
        }
        var h;
        n.restore();
        const a = t || 34;
        return $8f74814242901c26$var$mn(Math.ceil(i.S + i.C + i.V + i.B + 5 + a));
    }
    km(t) {
        null !== this.nm && (0, $aFz8k.equalSizes)(this.nm, t) || (this.nm = t, this.lm = !0, this.wm.resizeCanvasElement(t), this.Mm.resizeCanvasElement(t), this.lm = !1, this.uv.style.width = `${t.width}px`, this.uv.style.height = `${t.height}px`);
    }
    Tm() {
        return $8f74814242901c26$var$u(this.nm).width;
    }
    un(t) {
        this.Ki !== t && (null !== this.Ki && this.Ki.__().u(this), this.Ki = t, t.__().i(this.wo.bind(this), this));
    }
    Ft() {
        return this.Ki;
    }
    Os() {
        const t = this.yt.yv();
        this.yt._m().Qt().au(t, $8f74814242901c26$var$u(this.Ft()));
    }
    Rm(t) {
        if (null === this.nm) return;
        const i = {
            colorSpace: this.yt._m().N().layout.colorSpace
        };
        if (1 !== t) {
            this.Dm(), this.wm.applySuggestedBitmapSize();
            const t = (0, $02Gl7.tryCreateCanvasRenderingTarget2D)(this.wm, i);
            null !== t && (t.useBitmapCoordinateSpace((t)=>{
                this.Im(t), this.Vm(t);
            }), this.yt.Bm(t, this.vm), this.Em(t), this.yt.Bm(t, this.fm), this.Am(t));
        }
        this.Mm.applySuggestedBitmapSize();
        const n = (0, $02Gl7.tryCreateCanvasRenderingTarget2D)(this.Mm, i);
        null !== n && (n.useBitmapCoordinateSpace(({ context: t, bitmapSize: i })=>{
            t.clearRect(0, 0, i.width, i.height);
        }), this.Lm(n), this.yt.Bm(n, this.pm));
    }
    vv() {
        return this.wm.bitmapSize;
    }
    mv(t, i, n, s) {
        const e = this.vv();
        if (e.width > 0 && e.height > 0 && (t.drawImage(this.wm.canvasElement, i, n), s)) {
            const s = this.Mm.canvasElement;
            t.drawImage(s, i, n);
        }
    }
    Pt() {
        this.Ki?.zl();
    }
    Sv(t) {
        if (null === this.Ki || this.Ki.Zi() || !this.yn.handleScale.axisPressedMouseMove.price) return;
        const i = this.yt._m().Qt(), n = this.yt.yv();
        this.sm = !0, i.Q_(n, this.Ki, t.localY);
    }
    xv(t) {
        if (null === this.Ki || !this.yn.handleScale.axisPressedMouseMove.price) return;
        const i = this.yt._m().Qt(), n = this.yt.yv(), s = this.Ki;
        i.tu(n, s, t.localY);
    }
    gm() {
        if (null === this.Ki || !this.yn.handleScale.axisPressedMouseMove.price) return;
        const t = this.yt._m().Qt(), i = this.yt.yv(), n = this.Ki;
        this.sm && (this.sm = !1, t.iu(i, n));
    }
    Cv(t) {
        if (null === this.Ki || !this.yn.handleScale.axisPressedMouseMove.price) return;
        const i = this.yt._m().Qt(), n = this.yt.yv();
        this.sm = !1, i.iu(n, this.Ki);
    }
    bm(t) {
        this.yn.handleScale.axisDoubleClickReset.price && this.Os();
    }
    Sm(t) {
        if (null === this.Ki) return;
        !this.yt._m().Qt().N().handleScale.axisPressedMouseMove.price || this.Ki.je() || this.Ki.No() || this.zm(1);
    }
    bv(t) {
        this.zm(0);
    }
    Pm() {
        const t = [], i = null === this.Ki ? void 0 : this.Ki;
        return ((n)=>{
            for(let s = 0; s < n.length; ++s){
                const e = n[s].qn(this.yt.yv(), i);
                for(let i = 0; i < e.length; i++)t.push(e[i]);
            }
        })(this.yt.yv().Dt()), t;
    }
    Im({ context: t, bitmapSize: i }) {
        const { width: n, height: s } = i, e = this.yt.yv().Qt(), r = e.$(), h = e.af();
        r === h ? $8f74814242901c26$var$z(t, 0, 0, n, s, r) : $8f74814242901c26$var$F(t, 0, 0, n, s, r, h);
    }
    Vm({ context: t, bitmapSize: i, horizontalPixelRatio: n }) {
        if (null === this.nm || null === this.Ki || !this.Ki.N().borderVisible) return;
        t.fillStyle = this.Ki.N().borderColor;
        const s = Math.max(1, Math.floor(this.xm().S * n));
        let e;
        e = this.dm ? i.width - s : 0, t.fillRect(e, 0, s, i.height);
    }
    Em(t) {
        if (null === this.nm || null === this.Ki) return;
        const i = this.Ki.zl(), n = this.Ki.N(), s = this.xm(), e = this.dm ? this.nm.width - s.C : 0;
        n.borderVisible && n.ticksVisible && t.useBitmapCoordinateSpace(({ context: t, horizontalPixelRatio: r, verticalPixelRatio: h })=>{
            t.fillStyle = n.borderColor;
            const a = Math.max(1, Math.floor(h)), l = Math.floor(.5 * h), o = Math.round(s.C * r);
            t.beginPath();
            for (const n of i)t.rect(Math.floor(e * r), Math.round(n.Vl * h) - l, o, a);
            t.fill();
        }), t.useMediaCoordinateSpace(({ context: t })=>{
            t.font = this.ym(), t.fillStyle = n.textColor ?? this.Ro.textColor, t.textAlign = this.dm ? "right" : "left", t.textBaseline = "middle";
            const r = this.dm ? Math.round(e - s.V) : Math.round(e + s.C + s.V), h = i.map((i)=>this.rm.Di(t, i.eo));
            for(let n = i.length; n--;){
                const s = i[n];
                t.fillText(s.eo, r, s.Vl + h[n]);
            }
        });
    }
    Dm() {
        if (null === this.nm || null === this.Ki) return;
        let t = this.nm.height / 2;
        const i = [], n = this.Ki.Dt().slice(), s = this.yt.yv(), e = this.xm();
        this.Ki === s.Zs() && this.yt.yv().Dt().forEach((t)=>{
            s.Gs(t) && n.push(t);
        });
        const r = this.Ki.kl()[0], h = this.Ki;
        n.forEach((n)=>{
            const e = n.qn(s, h);
            e.forEach((t)=>{
                t.$i() && null === t.Wi() && (t.Ui(null), i.push(t));
            }), r === n && e.length > 0 && (t = e[0].Ei());
        });
        this.Ki.N().alignLabels && this.Om(i, e, t);
    }
    Om(t, i, n) {
        if (null === this.nm) return;
        const s = t.filter((t)=>t.Ei() <= n), e = t.filter((t)=>t.Ei() > n);
        s.sort((t, i)=>i.Ei() - t.Ei()), s.length && e.length && e.push(s[0]), e.sort((t, i)=>t.Ei() - i.Ei());
        for (const n of t){
            const t = Math.floor(n.$t(i) / 2), s = n.Ei();
            s > -t && s < t && n.Ui(t), s > this.nm.height - t && s < this.nm.height + t && n.Ui(this.nm.height - t);
        }
        $8f74814242901c26$var$zn(s, 1, this.nm.height, i), $8f74814242901c26$var$zn(e, -1, this.nm.height, i);
    }
    Am(t) {
        if (null === this.nm) return;
        const i = this.Pm(), n = this.xm(), s = this.dm ? "right" : "left";
        i.forEach((i)=>{
            if (i.ji()) i.Tt($8f74814242901c26$var$u(this.Ki)).st(t, n, this.rm, s);
        });
    }
    Lm(t) {
        if (null === this.nm || null === this.Ki) return;
        const i = this.yt._m().Qt(), n = [], s = this.yt.yv(), e = i.Vd().qn(s, this.Ki);
        e.length && n.push(e);
        const r = this.xm(), h = this.dm ? "right" : "left";
        n.forEach((i)=>{
            i.forEach((i)=>{
                i.Tt($8f74814242901c26$var$u(this.Ki)).st(t, r, this.rm, h);
            });
        });
    }
    zm(t) {
        this.uv.style.cursor = 1 === t ? "ns-resize" : "default";
    }
    wo() {
        const t = this.Cm();
        this.am < t && this.yt._m().Qt().ka(), this.am = t;
    }
    ym() {
        return $8f74814242901c26$var$x(this.Ro.fontSize, this.Ro.fontFamily);
    }
}
function $8f74814242901c26$var$Nn(t, i) {
    return t.Xa?.(i) ?? [];
}
function $8f74814242901c26$var$Fn(t, i) {
    return t.jn?.(i) ?? [];
}
function $8f74814242901c26$var$Wn(t, i) {
    return t.cn?.(i) ?? [];
}
function $8f74814242901c26$var$Hn(t, i) {
    return t.qa?.(i) ?? [];
}
class $8f74814242901c26$var$Un {
    constructor(i, n){
        this.nm = (0, $aFz8k.size)({
            width: 0,
            height: 0
        }), this.Nm = null, this.Fm = null, this.Wm = null, this.Hm = null, this.Um = !1, this.$m = new $8f74814242901c26$var$d, this.jm = new $8f74814242901c26$var$d, this.qm = 0, this.Ym = !1, this.Km = null, this.Gm = !1, this.Zm = null, this.Xm = null, this.lm = !1, this.om = ()=>{
            this.lm || null === this.Jm || this.sn().mr();
        }, this.um = ()=>{
            this.lm || null === this.Jm || this.sn().mr();
        }, this.Gv = i, this.Jm = n, this.Jm.mu().i(this.Qm.bind(this), this, !0), this.tw = document.createElement("td"), this.tw.style.padding = "0", this.tw.style.position = "relative";
        const s = document.createElement("div");
        s.style.width = "100%", s.style.height = "100%", s.style.position = "relative", s.style.overflow = "hidden", this.iw = document.createElement("td"), this.iw.style.padding = "0", this.nw = document.createElement("td"), this.nw.style.padding = "0", this.tw.appendChild(s), this.wm = $8f74814242901c26$var$Dn(s, (0, $aFz8k.size)({
            width: 16,
            height: 16
        })), this.wm.subscribeSuggestedBitmapSizeChanged(this.om);
        const e = this.wm.canvasElement;
        e.style.position = "absolute", e.style.zIndex = "1", e.style.left = "0", e.style.top = "0", this.Mm = $8f74814242901c26$var$Dn(s, (0, $aFz8k.size)({
            width: 16,
            height: 16
        })), this.Mm.subscribeSuggestedBitmapSizeChanged(this.um);
        const r = this.Mm.canvasElement;
        r.style.position = "absolute", r.style.zIndex = "2", r.style.left = "0", r.style.top = "0", this._v = document.createElement("tr"), this._v.appendChild(this.iw), this._v.appendChild(this.tw), this._v.appendChild(this.nw), this.sw(), this.sv = new $8f74814242901c26$var$Mn(this.Mm.canvasElement, this, {
            Pp: ()=>null === this.Km && !this.Gv.N().handleScroll.vertTouchDrag,
            kp: ()=>null === this.Km && !this.Gv.N().handleScroll.horzTouchDrag
        });
    }
    m() {
        null !== this.Nm && this.Nm.m(), null !== this.Fm && this.Fm.m(), this.Wm = null, this.Mm.unsubscribeSuggestedBitmapSizeChanged(this.um), $8f74814242901c26$var$In(this.Mm.canvasElement), this.Mm.dispose(), this.wm.unsubscribeSuggestedBitmapSizeChanged(this.om), $8f74814242901c26$var$In(this.wm.canvasElement), this.wm.dispose(), null !== this.Jm && (this.Jm.mu().u(this), this.Jm.m()), this.sv.m();
    }
    yv() {
        return $8f74814242901c26$var$u(this.Jm);
    }
    ew(t) {
        null !== this.Jm && this.Jm.mu().u(this), this.Jm = t, null !== this.Jm && this.Jm.mu().i($8f74814242901c26$var$Un.prototype.Qm.bind(this), this, !0), this.sw(), this.Gv.lv().indexOf(this) === this.Gv.lv().length - 1 ? (this.Wm = this.Wm ?? new $8f74814242901c26$var$Rn(this.tw, this.Gv), this.Wm.Pt()) : (this.Wm?.Xv(), this.Wm = null);
    }
    _m() {
        return this.Gv;
    }
    fv() {
        return this._v;
    }
    sw() {
        if (null !== this.Jm && (this.rw(), 0 !== this.sn().Jn().length)) {
            if (null !== this.Nm) {
                const t = this.Jm.X_();
                this.Nm.un($8f74814242901c26$var$u(t));
            }
            if (null !== this.Fm) {
                const t = this.Jm.J_();
                this.Fm.un($8f74814242901c26$var$u(t));
            }
        }
    }
    hw() {
        null !== this.Nm && this.Nm.Pt(), null !== this.Fm && this.Fm.Pt();
    }
    F_() {
        return null !== this.Jm ? this.Jm.F_() : 0;
    }
    W_(t) {
        this.Jm && this.Jm.W_(t);
    }
    bp(t) {
        if (!this.Jm) return;
        this.aw();
        const i = t.localX, n = t.localY;
        this.lw(i, n, t);
    }
    Fp(t) {
        this.aw(), this.ow(), this.lw(t.localX, t.localY, t);
    }
    Sp(t) {
        if (!this.Jm) return;
        this.aw();
        const i = t.localX, n = t.localY;
        this.lw(i, n, t);
    }
    Ap(t) {
        null !== this.Jm && (this.aw(), this.lw(t.localX, t.localY, t), this._w(t));
    }
    fp(t) {
        null !== this.Jm && this.uw(this.jm, t);
    }
    _p(t) {
        this.fp(t);
    }
    Dp(t) {
        this.aw(), this.cw(t), this.lw(t.localX, t.localY, t);
    }
    Ep(t) {
        null !== this.Jm && (this.aw(), this.Ym = !1, this.dw(t));
    }
    Bp(t) {
        null !== this.Jm && this._w(t);
    }
    Xp(t) {
        if (this.Ym = !0, null === this.Km) {
            const i = {
                x: t.localX,
                y: t.localY
            };
            this.fw(i, i, t);
        }
    }
    Zp(t) {
        null !== this.Jm && (this.aw(), this.Jm.Qt().Rd(null), this.pw());
    }
    mw() {
        return this.$m;
    }
    ww() {
        return this.jm;
    }
    $p() {
        this.qm = 1, this.sn().cs();
    }
    jp(t, i) {
        if (!this.Gv.N().handleScale.pinch) return;
        const n = 5 * (i - this.qm);
        this.qm = i, this.sn().Wd(t._t, n);
    }
    Op(t) {
        this.Ym = !1, this.Gm = null !== this.Km, this.ow();
        const i = this.sn().Vd();
        null !== this.Km && i.It() && (this.Zm = {
            x: i.ni(),
            y: i.si()
        }, this.Km = {
            x: t.localX,
            y: t.localY
        });
    }
    Tp(t) {
        if (null === this.Jm) return;
        const i = t.localX, n = t.localY;
        if (null === this.Km) this.cw(t);
        else {
            this.Gm = !1;
            const s = $8f74814242901c26$var$u(this.Zm), e = s.x + (i - this.Km.x), r = s.y + (n - this.Km.y);
            this.lw(e, r, t);
        }
    }
    Vp(t) {
        0 === this._m().N().trackingMode.exitMode && (this.Gm = !0), this.Mw(), this.dw(t);
    }
    Qs(t, i) {
        const n = this.Jm;
        return null === n ? null : $8f74814242901c26$var$Bi(n, t, i);
    }
    gw(i, n) {
        $8f74814242901c26$var$u("left" === n ? this.Nm : this.Fm).km((0, $aFz8k.size)({
            width: i,
            height: this.nm.height
        }));
    }
    pv() {
        return this.nm;
    }
    km(t) {
        (0, $aFz8k.equalSizes)(this.nm, t) || (this.nm = t, this.lm = !0, this.wm.resizeCanvasElement(t), this.Mm.resizeCanvasElement(t), this.lm = !1, this.tw.style.width = t.width + "px", this.tw.style.height = t.height + "px");
    }
    bw() {
        const t = $8f74814242901c26$var$u(this.Jm);
        t.G_(t.X_()), t.G_(t.J_());
        for (const i of t.kl())if (t.Gs(i)) {
            const n = i.Ft();
            null !== n && t.G_(n), i.Nn();
        }
        for (const i of t.Mu())i.Nn();
    }
    vv() {
        return this.wm.bitmapSize;
    }
    mv(t, i, n, s) {
        const e = this.vv();
        if (e.width > 0 && e.height > 0 && (t.drawImage(this.wm.canvasElement, i, n), s)) {
            const s = this.Mm.canvasElement;
            null !== t && t.drawImage(s, i, n);
        }
    }
    Rm(t) {
        if (0 === t) return;
        if (null === this.Jm) return;
        t > 1 && this.bw(), null !== this.Nm && this.Nm.Rm(t), null !== this.Fm && this.Fm.Rm(t);
        const i = {
            colorSpace: this.Gv.N().layout.colorSpace
        };
        if (1 !== t) {
            this.wm.applySuggestedBitmapSize();
            const t = (0, $02Gl7.tryCreateCanvasRenderingTarget2D)(this.wm, i);
            null !== t && (t.useBitmapCoordinateSpace((t)=>{
                this.Im(t);
            }), this.Jm && (this.Sw(t, $8f74814242901c26$var$Nn), this.xw(t), this.Sw(t, $8f74814242901c26$var$Fn), this.Sw(t, $8f74814242901c26$var$Wn)));
        }
        this.Mm.applySuggestedBitmapSize();
        const n = (0, $02Gl7.tryCreateCanvasRenderingTarget2D)(this.Mm, i);
        null !== n && (n.useBitmapCoordinateSpace(({ context: t, bitmapSize: i })=>{
            t.clearRect(0, 0, i.width, i.height);
        }), this.Cw(n), this.Sw(n, $8f74814242901c26$var$Hn), this.Sw(n, $8f74814242901c26$var$Wn));
    }
    yw() {
        return this.Nm;
    }
    Pw() {
        return this.Fm;
    }
    Bm(t, i) {
        this.Sw(t, i);
    }
    Qm() {
        null !== this.Jm && this.Jm.mu().u(this), this.Jm = null;
    }
    _w(t) {
        this.uw(this.$m, t);
    }
    uw(t, i) {
        const n = i.localX, s = i.localY;
        t.v() && t.p(this.sn().Et().Vc(n), {
            x: n,
            y: s
        }, i);
    }
    Im({ context: t, bitmapSize: i }) {
        const { width: n, height: s } = i, e = this.sn(), r = e.$(), h = e.af();
        r === h ? $8f74814242901c26$var$z(t, 0, 0, n, s, h) : $8f74814242901c26$var$F(t, 0, 0, n, s, r, h);
    }
    xw(t) {
        const i = $8f74814242901c26$var$u(this.Jm), n = i.wu().wr().Tt(i);
        null !== n && n.st(t, !1);
    }
    Cw(t) {
        this.kw(t, $8f74814242901c26$var$Fn, $8f74814242901c26$var$Bn, this.sn().Vd());
    }
    Sw(t, i) {
        const n = $8f74814242901c26$var$u(this.Jm), s = i === $8f74814242901c26$var$Fn ? this.Tw() : null, e = null === s ? null : this.Rw(s, n), r = n.Mu();
        if (null === e || null === s) {
            const s = n._u();
            return this.Dw(t, i, $8f74814242901c26$var$Vn, r, s), void this.Dw(t, i, $8f74814242901c26$var$Bn, r, s);
        }
        const h = n.Dt(), a = (t)=>t === s ? e.Za : void 0;
        this.Dw(t, i, $8f74814242901c26$var$Vn, r, h, a), this.Dw(t, i, $8f74814242901c26$var$Bn, r, h, a), this.kw(t, i, $8f74814242901c26$var$Vn, s, e.qa), this.kw(t, i, $8f74814242901c26$var$Bn, s, e.qa);
    }
    Dw(t, i, n, s, e, r) {
        for (const e of s)this.kw(t, i, n, e);
        if (void 0 !== r) for (const s of e)this.kw(t, i, n, s, r(s));
        else for (const s of e)this.kw(t, i, n, s);
    }
    Tw() {
        const t = $8f74814242901c26$var$u(this.Jm), i = t.Qt().cu()?.uu;
        if (!t.Qt().N().hoveredSeriesOnTop || void 0 === i) return null;
        for (const n of t.Dt())if (n === i) return n;
        return null;
    }
    Rw(t, i) {
        const n = t.Ga?.(i) ?? null;
        return null === n || 0 === n.qa.length ? null : n;
    }
    kw(t, i, n, s, e) {
        const r = $8f74814242901c26$var$u(this.Jm), h = r.Qt().cu(), a = null !== h && h.uu === s, l = null !== h && a && void 0 !== h.bu ? h.bu.ie : void 0, o = (i)=>n(i, t, a, l);
        void 0 === e ? $8f74814242901c26$var$En(i, o, s, r) : $8f74814242901c26$var$An(e, o, r);
    }
    rw() {
        if (null === this.Jm) return;
        const t = this.Gv, i = this.Jm.X_().N().visible, n = this.Jm.J_().N().visible;
        i || null === this.Nm || (this.iw.removeChild(this.Nm.fv()), this.Nm.m(), this.Nm = null), n || null === this.Fm || (this.nw.removeChild(this.Fm.fv()), this.Fm.m(), this.Fm = null);
        const s = t.Qt().Jd();
        i && null === this.Nm && (this.Nm = new $8f74814242901c26$var$On(this, t.N(), s, "left"), this.iw.appendChild(this.Nm.fv())), n && null === this.Fm && (this.Fm = new $8f74814242901c26$var$On(this, t.N(), s, "right"), this.nw.appendChild(this.Fm.fv()));
    }
    Iw(t) {
        return t.Jp && this.Ym || null !== this.Km;
    }
    lw(t, i, n) {
        t = Math.max(0, Math.min(t, this.nm.width - 1)), i = Math.max(0, Math.min(i, this.nm.height - 1)), this.sn().Kd(t, i, n, $8f74814242901c26$var$u(this.Jm));
    }
    pw() {
        this.sn().Zd();
    }
    Mw() {
        this.Gm && (this.Km = null, this.pw());
    }
    fw(t, i, n) {
        this.Km = t, this.Gm = !1, this.lw(i.x, i.y, n);
        const s = this.sn().Vd();
        this.Zm = {
            x: s.ni(),
            y: s.si()
        };
    }
    sn() {
        return this.Gv.Qt();
    }
    dw(t) {
        if (!this.Um) return;
        const i = this.sn(), n = this.yv();
        if (i.eu(n, n.kn()), this.Hm = null, this.Um = !1, i.jd(), null !== this.Xm) {
            const t = performance.now(), n = i.Et();
            this.Xm.me(n.Oc(), t), this.Xm.Kc(t) || i.ps(this.Xm);
        }
    }
    aw() {
        this.Km = null;
    }
    ow() {
        if (!this.Jm) return;
        if (this.sn().cs(), document.activeElement !== document.body && document.activeElement !== document.documentElement) $8f74814242901c26$var$u(document.activeElement).blur();
        else {
            const t = document.getSelection();
            null !== t && t.removeAllRanges();
        }
        !this.Jm.kn().Zi() && this.sn().Et().Zi();
    }
    cw(t) {
        if (null === this.Jm) return;
        const i = this.sn(), n = i.Et();
        if (n.Zi()) return;
        const s = this.Gv.N(), e = s.handleScroll, r = s.kineticScroll;
        if ((!e.pressedMouseMove || t.Jp) && (!e.horzTouchDrag && !e.vertTouchDrag || !t.Jp)) return;
        const h = this.Jm.kn(), a = performance.now();
        if (null !== this.Hm || this.Iw(t) || (this.Hm = {
            x: t.clientX,
            y: t.clientY,
            yf: a,
            Vw: t.localX,
            Bw: t.localY
        }), null !== this.Hm && !this.Um && (this.Hm.x !== t.clientX || this.Hm.y !== t.clientY)) {
            if (t.Jp && r.touch || !t.Jp && r.mouse) {
                const t = n.ml();
                this.Xm = new $8f74814242901c26$var$Tn(.2 / t, 7 / t, .997, 15 / t), this.Xm.Uv(n.Oc(), this.Hm.yf);
            } else this.Xm = null;
            h.Zi() || i.nu(this.Jm, h, t.localY), i.Ud(t.localX), this.Um = !0;
        }
        this.Um && (h.Zi() || i.su(this.Jm, h, t.localY), i.$d(t.localX), null !== this.Xm && this.Xm.Uv(n.Oc(), a));
    }
}
class $8f74814242901c26$var$$n {
    constructor(i, n, s, e, r){
        this.xt = !0, this.nm = (0, $aFz8k.size)({
            width: 0,
            height: 0
        }), this.om = ()=>this.Rm(3), this.dm = "left" === i, this.bd = s.Jd, this.yn = n, this.Ew = e, this.Aw = r, this.uv = document.createElement("div"), this.uv.style.width = "25px", this.uv.style.height = "100%", this.uv.style.overflow = "hidden", this.wm = $8f74814242901c26$var$Dn(this.uv, (0, $aFz8k.size)({
            width: 16,
            height: 16
        })), this.wm.subscribeSuggestedBitmapSizeChanged(this.om);
    }
    m() {
        this.wm.unsubscribeSuggestedBitmapSizeChanged(this.om), $8f74814242901c26$var$In(this.wm.canvasElement), this.wm.dispose();
    }
    fv() {
        return this.uv;
    }
    pv() {
        return this.nm;
    }
    km(t) {
        (0, $aFz8k.equalSizes)(this.nm, t) || (this.nm = t, this.wm.resizeCanvasElement(t), this.uv.style.width = `${t.width}px`, this.uv.style.height = `${t.height}px`, this.xt = !0);
    }
    Rm(t) {
        if (t < 3 && !this.xt) return;
        if (0 === this.nm.width || 0 === this.nm.height) return;
        this.xt = !1, this.wm.applySuggestedBitmapSize();
        const i = (0, $02Gl7.tryCreateCanvasRenderingTarget2D)(this.wm, {
            colorSpace: this.yn.layout.colorSpace
        });
        null !== i && i.useBitmapCoordinateSpace((t)=>{
            this.Im(t), this.Vm(t);
        });
    }
    vv() {
        return this.wm.bitmapSize;
    }
    mv(t, i, n) {
        const s = this.vv();
        s.width > 0 && s.height > 0 && t.drawImage(this.wm.canvasElement, i, n);
    }
    Vm({ context: t, bitmapSize: i, horizontalPixelRatio: n, verticalPixelRatio: s }) {
        if (!this.Ew()) return;
        t.fillStyle = this.yn.timeScale.borderColor;
        const e = Math.floor(this.bd.N().S * n), r = Math.floor(this.bd.N().S * s), h = this.dm ? i.width - e : 0;
        t.fillRect(h, 0, e, r);
    }
    Im({ context: t, bitmapSize: i }) {
        $8f74814242901c26$var$z(t, 0, 0, i.width, i.height, this.Aw());
    }
}
function $8f74814242901c26$var$jn(t) {
    return (i)=>i.tl?.(t) ?? [];
}
const $8f74814242901c26$var$qn = $8f74814242901c26$var$jn("normal"), $8f74814242901c26$var$Yn = $8f74814242901c26$var$jn("top"), $8f74814242901c26$var$Kn = $8f74814242901c26$var$jn("bottom");
class $8f74814242901c26$var$Gn {
    constructor(i, n){
        this.Lw = null, this.zw = null, this.M = null, this.Ow = !1, this.nm = (0, $aFz8k.size)({
            width: 0,
            height: 0
        }), this.Nw = new $8f74814242901c26$var$d, this.rm = new $8f74814242901c26$var$rt(5), this.lm = !1, this.om = ()=>{
            this.lm || this.Gv.Qt().mr();
        }, this.um = ()=>{
            this.lm || this.Gv.Qt().mr();
        }, this.Gv = i, this.Pu = n, this.yn = i.N().layout, this.jv = document.createElement("tr"), this.Fw = document.createElement("td"), this.Fw.style.padding = "0", this.Ww = document.createElement("td"), this.Ww.style.padding = "0", this.uv = document.createElement("td"), this.uv.style.height = "25px", this.uv.style.padding = "0", this.Hw = document.createElement("div"), this.Hw.style.width = "100%", this.Hw.style.height = "100%", this.Hw.style.position = "relative", this.Hw.style.overflow = "hidden", this.uv.appendChild(this.Hw), this.wm = $8f74814242901c26$var$Dn(this.Hw, (0, $aFz8k.size)({
            width: 16,
            height: 16
        })), this.wm.subscribeSuggestedBitmapSizeChanged(this.om);
        const s = this.wm.canvasElement;
        s.style.position = "absolute", s.style.zIndex = "1", s.style.left = "0", s.style.top = "0", this.Mm = $8f74814242901c26$var$Dn(this.Hw, (0, $aFz8k.size)({
            width: 16,
            height: 16
        })), this.Mm.subscribeSuggestedBitmapSizeChanged(this.um);
        const e = this.Mm.canvasElement;
        e.style.position = "absolute", e.style.zIndex = "2", e.style.left = "0", e.style.top = "0", this.jv.appendChild(this.Fw), this.jv.appendChild(this.uv), this.jv.appendChild(this.Ww), this.Uw(), this.Gv.Qt().N_().i(this.Uw.bind(this), this), this.sv = new $8f74814242901c26$var$Mn(this.Mm.canvasElement, this, {
            Pp: ()=>!0,
            kp: ()=>!this.Gv.N().handleScroll.horzTouchDrag
        });
    }
    m() {
        this.sv.m(), null !== this.Lw && this.Lw.m(), null !== this.zw && this.zw.m(), this.Mm.unsubscribeSuggestedBitmapSizeChanged(this.um), $8f74814242901c26$var$In(this.Mm.canvasElement), this.Mm.dispose(), this.wm.unsubscribeSuggestedBitmapSizeChanged(this.om), $8f74814242901c26$var$In(this.wm.canvasElement), this.wm.dispose();
    }
    fv() {
        return this.jv;
    }
    $w() {
        return this.Lw;
    }
    jw() {
        return this.zw;
    }
    Fp(t) {
        if (this.Ow) return;
        this.Ow = !0;
        const i = this.Gv.Qt();
        !i.Et().Zi() && this.Gv.N().handleScale.axisPressedMouseMove.time && i.Fd(t.localX);
    }
    Op(t) {
        this.Fp(t);
    }
    Wp() {
        const t = this.Gv.Qt();
        !t.Et().Zi() && this.Ow && (this.Ow = !1, this.Gv.N().handleScale.axisPressedMouseMove.time && t.Yd());
    }
    Dp(t) {
        const i = this.Gv.Qt();
        !i.Et().Zi() && this.Gv.N().handleScale.axisPressedMouseMove.time && i.qd(t.localX);
    }
    Tp(t) {
        this.Dp(t);
    }
    Ep() {
        this.Ow = !1;
        const t = this.Gv.Qt();
        t.Et().Zi() && !this.Gv.N().handleScale.axisPressedMouseMove.time || t.Yd();
    }
    Vp() {
        this.Ep();
    }
    fp() {
        this.Gv.N().handleScale.axisDoubleClickReset.time && this.Gv.Qt().ws();
    }
    _p() {
        this.fp();
    }
    bp() {
        this.Gv.Qt().N().handleScale.axisPressedMouseMove.time && this.zm(1);
    }
    Zp() {
        this.zm(0);
    }
    pv() {
        return this.nm;
    }
    qw() {
        return this.Nw;
    }
    Yw(i, s, e) {
        (0, $aFz8k.equalSizes)(this.nm, i) || (this.nm = i, this.lm = !0, this.wm.resizeCanvasElement(i), this.Mm.resizeCanvasElement(i), this.lm = !1, this.uv.style.width = `${i.width}px`, this.uv.style.height = `${i.height}px`, this.Nw.p(i)), null !== this.Lw && this.Lw.km((0, $aFz8k.size)({
            width: s,
            height: i.height
        })), null !== this.zw && this.zw.km((0, $aFz8k.size)({
            width: e,
            height: i.height
        }));
    }
    Kw() {
        const t = this.Gw();
        return Math.ceil(t.S + t.C + t.P + t.A + t.I + t.Zw);
    }
    Pt() {
        this.Gv.Qt().Et().zl();
    }
    vv() {
        return this.wm.bitmapSize;
    }
    mv(t, i, n, s) {
        const e = this.vv();
        if (e.width > 0 && e.height > 0 && (t.drawImage(this.wm.canvasElement, i, n), s)) {
            const s = this.Mm.canvasElement;
            t.drawImage(s, i, n);
        }
    }
    Rm(t) {
        if (0 === t) return;
        const i = {
            colorSpace: this.yn.colorSpace
        };
        if (1 !== t) {
            this.wm.applySuggestedBitmapSize();
            const n = (0, $02Gl7.tryCreateCanvasRenderingTarget2D)(this.wm, i);
            null !== n && (n.useBitmapCoordinateSpace((t)=>{
                this.Im(t), this.Vm(t), this.Xw(n, $8f74814242901c26$var$Kn);
            }), this.Em(n), this.Xw(n, $8f74814242901c26$var$qn)), null !== this.Lw && this.Lw.Rm(t), null !== this.zw && this.zw.Rm(t);
        }
        this.Mm.applySuggestedBitmapSize();
        const n = (0, $02Gl7.tryCreateCanvasRenderingTarget2D)(this.Mm, i);
        null !== n && (n.useBitmapCoordinateSpace(({ context: t, bitmapSize: i })=>{
            t.clearRect(0, 0, i.width, i.height);
        }), this.Jw([
            ...this.Gv.Qt().Jn(),
            this.Gv.Qt().Vd()
        ], n), this.Xw(n, $8f74814242901c26$var$Yn));
    }
    Xw(t, i) {
        const n = this.Gv.Qt().Jn();
        for (const s of n)$8f74814242901c26$var$En(i, (i)=>$8f74814242901c26$var$Vn(i, t, !1, void 0), s, void 0);
        for (const s of n)$8f74814242901c26$var$En(i, (i)=>$8f74814242901c26$var$Bn(i, t, !1, void 0), s, void 0);
    }
    Im({ context: t, bitmapSize: i }) {
        $8f74814242901c26$var$z(t, 0, 0, i.width, i.height, this.Gv.Qt().af());
    }
    Vm({ context: t, bitmapSize: i, verticalPixelRatio: n }) {
        if (this.Gv.N().timeScale.borderVisible) {
            t.fillStyle = this.Qw();
            const s = Math.max(1, Math.floor(this.Gw().S * n));
            t.fillRect(0, 0, i.width, s);
        }
    }
    Em(t) {
        const i = this.Gv.Qt().Et(), n = i.zl();
        if (!n || 0 === n.length) return;
        const s = this.Pu.maxTickMarkWeight(n), e = this.Gw(), r = i.N();
        r.borderVisible && r.ticksVisible && t.useBitmapCoordinateSpace(({ context: t, horizontalPixelRatio: i, verticalPixelRatio: s })=>{
            t.strokeStyle = this.Qw(), t.fillStyle = this.Qw();
            const r = Math.max(1, Math.floor(i)), h = Math.floor(.5 * i);
            t.beginPath();
            const a = Math.round(e.C * s);
            for(let s = n.length; s--;){
                const e = Math.round(n[s].coord * i);
                t.rect(e - h, 0, r, a);
            }
            t.fill();
        }), t.useMediaCoordinateSpace(({ context: t })=>{
            const i = e.S + e.C + e.A + e.P / 2;
            t.textAlign = "center", t.textBaseline = "middle", t.fillStyle = this.H(), t.font = this.ym();
            for (const e of n)if (e.weight < s) {
                const n = e.needAlignCoordinate ? this.tM(t, e.coord, e.label) : e.coord;
                t.fillText(e.label, n, i);
            }
            this.Gv.N().timeScale.allowBoldLabels && (t.font = this.iM());
            for (const e of n)if (e.weight >= s) {
                const n = e.needAlignCoordinate ? this.tM(t, e.coord, e.label) : e.coord;
                t.fillText(e.label, n, i);
            }
        });
    }
    tM(t, i, n) {
        const s = this.rm.Ii(t, n), e = s / 2, r = Math.floor(i - e) + .5;
        return r < 0 ? i += Math.abs(0 - r) : r + s > this.nm.width && (i -= Math.abs(this.nm.width - (r + s))), i;
    }
    Jw(t, i) {
        const n = this.Gw();
        for (const s of t)for (const t of s.dn())t.Tt().st(i, n);
    }
    Qw() {
        return this.Gv.N().timeScale.borderColor;
    }
    H() {
        return this.yn.textColor;
    }
    F() {
        return this.yn.fontSize;
    }
    ym() {
        return $8f74814242901c26$var$x(this.F(), this.yn.fontFamily);
    }
    iM() {
        return $8f74814242901c26$var$x(this.F(), this.yn.fontFamily, "bold");
    }
    Gw() {
        null === this.M && (this.M = {
            S: 1,
            L: NaN,
            A: NaN,
            I: NaN,
            tn: NaN,
            C: 5,
            P: NaN,
            k: "",
            Qi: new $8f74814242901c26$var$rt,
            Zw: 0
        });
        const t = this.M, i = this.ym();
        if (t.k !== i) {
            const n = this.F();
            t.P = n, t.k = i, t.A = 3 * n / 12, t.I = 3 * n / 12, t.tn = 9 * n / 12, t.L = 0, t.Zw = 4 * n / 12, t.Qi.Os();
        }
        return this.M;
    }
    zm(t) {
        this.uv.style.cursor = 1 === t ? "ew-resize" : "default";
    }
    Uw() {
        const t = this.Gv.Qt(), i = t.N();
        i.leftPriceScale.visible || null === this.Lw || (this.Fw.removeChild(this.Lw.fv()), this.Lw.m(), this.Lw = null), i.rightPriceScale.visible || null === this.zw || (this.Ww.removeChild(this.zw.fv()), this.zw.m(), this.zw = null);
        const n = {
            Jd: this.Gv.Qt().Jd()
        }, s = ()=>i.leftPriceScale.borderVisible && t.Et().N().borderVisible, e = ()=>t.af();
        i.leftPriceScale.visible && null === this.Lw && (this.Lw = new $8f74814242901c26$var$$n("left", i, n, s, e), this.Fw.appendChild(this.Lw.fv())), i.rightPriceScale.visible && null === this.zw && (this.zw = new $8f74814242901c26$var$$n("right", i, n, s, e), this.Ww.appendChild(this.zw.fv()));
    }
}
const $8f74814242901c26$var$Zn = !!$8f74814242901c26$var$dn && !!navigator.userAgentData && navigator.userAgentData.brands.some((t)=>t.brand.includes("Chromium")) && !!$8f74814242901c26$var$dn && (navigator?.userAgentData?.platform ? "Windows" === navigator.userAgentData.platform : navigator.userAgent.toLowerCase().indexOf("win") >= 0);
class $8f74814242901c26$var$Xn {
    constructor(t, i, n){
        var s;
        this.nM = [], this.sM = [], this.eM = 0, this.oo = 0, this.k_ = 0, this.rM = 0, this.hM = 0, this.aM = null, this.lM = !1, this.$m = new $8f74814242901c26$var$d, this.jm = new $8f74814242901c26$var$d, this.wd = new $8f74814242901c26$var$d, this.oM = null, this._M = null, this.Kv = t, this.yn = i, this.Pu = n, this.jv = document.createElement("div"), this.jv.classList.add("tv-lightweight-charts"), this.jv.style.overflow = "hidden", this.jv.style.direction = "ltr", this.jv.style.width = "100%", this.jv.style.height = "100%", (s = this.jv).style.userSelect = "none", s.style.webkitUserSelect = "none", s.style.msUserSelect = "none", s.style.MozUserSelect = "none", s.style.webkitTapHighlightColor = "transparent", this.uM = document.createElement("table"), this.uM.setAttribute("cellspacing", "0"), this.jv.appendChild(this.uM), this.cM = this.dM.bind(this), $8f74814242901c26$var$Jn(this.yn) && this.fM(!0), this.sn = new $8f74814242901c26$var$qi(this.gd.bind(this), this.yn, n), this.Qt().Bd().i(this.pM.bind(this), this), this.vM = new $8f74814242901c26$var$Gn(this, this.Pu), this.uM.appendChild(this.vM.fv());
        const e = i.autoSize && this.mM();
        let r = this.yn.width, h = this.yn.height;
        if (e || 0 === r || 0 === h) {
            const i = t.getBoundingClientRect();
            r = r || i.width, h = h || i.height;
        }
        this.wM(r, h), this.MM(), t.appendChild(this.jv), this.gM(), this.sn.Et().Jc().i(this.sn.ka.bind(this.sn), this), this.sn.N_().i(this.sn.ka.bind(this.sn), this);
    }
    Qt() {
        return this.sn;
    }
    N() {
        return this.yn;
    }
    lv() {
        return this.nM;
    }
    bM() {
        return this.vM;
    }
    m() {
        this.fM(!1), 0 !== this.eM && window.cancelAnimationFrame(this.eM), this.sn.Bd().u(this), this.sn.Et().Jc().u(this), this.sn.N_().u(this), this.sn.m();
        for (const t of this.nM)this.uM.removeChild(t.fv()), t.mw().u(this), t.ww().u(this), t.m();
        this.nM = [];
        for (const t of this.sM)this.SM(t);
        this.sM = [], $8f74814242901c26$var$u(this.vM).m(), null !== this.jv.parentElement && this.jv.parentElement.removeChild(this.jv), this.wd.m(), this.$m.m(), this.jm.m(), this.xM();
    }
    wM(i, n, s = !1) {
        if (this.oo === n && this.k_ === i) return;
        const e = function(i) {
            const n = Math.floor(i.width), s = Math.floor(i.height);
            return (0, $aFz8k.size)({
                width: n - n % 2,
                height: s - s % 2
            });
        }((0, $aFz8k.size)({
            width: i,
            height: n
        }));
        this.oo = e.height, this.k_ = e.width;
        const r = this.oo + "px", h = this.k_ + "px";
        if (this.CM() || ($8f74814242901c26$var$u(this.jv).style.height = r, $8f74814242901c26$var$u(this.jv).style.width = h), this.uM.style.height = r, this.uM.style.width = h, s) {
            0 !== this.eM && (window.cancelAnimationFrame(this.eM), this.eM = 0), this.lM = !1;
            const t = $8f74814242901c26$var$X.ys();
            null !== this.aM && (t.Ss(this.aM), this.aM = null), this.yM(t, performance.now());
        } else this.sn.ka();
    }
    Rm(t) {
        void 0 === t && (t = $8f74814242901c26$var$X.ys());
        for(let i = 0; i < this.nM.length; i++)this.nM[i].Rm(t._s(i).rs);
        this.yn.timeScale.visible && this.vM.Rm(t.ls());
    }
    vr(t) {
        const i = $8f74814242901c26$var$Jn(this.yn);
        this.sn.vr(t);
        const n = $8f74814242901c26$var$Jn(this.yn);
        n !== i && this.fM(n), t.layout?.panes && this.PM(), this.gM(), this.kM(t);
    }
    mw() {
        return this.$m;
    }
    ww() {
        return this.jm;
    }
    Bd() {
        return this.wd;
    }
    TM(t = !1) {
        null !== this.aM && (this.yM(this.aM, performance.now()), this.aM = null);
        const i = this.RM(null), n = document.createElement("canvas");
        n.width = i.width, n.height = i.height;
        const s = $8f74814242901c26$var$u(n.getContext("2d"));
        return this.RM(s, t), n;
    }
    DM(t) {
        if ("left" === t && !this.IM()) return 0;
        if ("right" === t && !this.VM()) return 0;
        if (0 === this.nM.length) return 0;
        return $8f74814242901c26$var$u("left" === t ? this.nM[0].yw() : this.nM[0].Pw()).Tm();
    }
    CM() {
        return this.yn.autoSize && null !== this.oM;
    }
    Mv() {
        return this.jv;
    }
    BM(t) {
        this._M = t, this._M ? this.Mv().style.setProperty("cursor", t) : this.Mv().style.removeProperty("cursor");
    }
    EM() {
        return this._M;
    }
    AM(t) {
        return $8f74814242901c26$var$_(this.nM[t]).pv();
    }
    PM() {
        this.sM.forEach((t)=>{
            t.Pt();
        });
    }
    kM(t) {
        (void 0 !== t.autoSize || !this.oM || void 0 === t.width && void 0 === t.height) && (t.autoSize && !this.oM && this.mM(), !1 === t.autoSize && null !== this.oM && this.xM(), t.autoSize || void 0 === t.width && void 0 === t.height || this.wM(t.width || this.k_, t.height || this.oo));
    }
    RM(i, n) {
        let s = 0, e = 0;
        const r = this.nM[0], h = (t, s)=>{
            let e = 0;
            for(let r = 0; r < this.nM.length; r++){
                const h = this.nM[r], a = $8f74814242901c26$var$u("left" === t ? h.yw() : h.Pw()), l = a.vv();
                if (null !== i && a.mv(i, s, e, n), e += l.height, r < this.nM.length - 1) {
                    const t = this.sM[r], n = t.vv();
                    null !== i && t.mv(i, s, e), e += n.height;
                }
            }
        };
        if (this.IM()) {
            h("left", 0);
            s += $8f74814242901c26$var$u(r.yw()).vv().width;
        }
        for(let t = 0; t < this.nM.length; t++){
            const r = this.nM[t], h = r.vv();
            if (null !== i && r.mv(i, s, e, n), e += h.height, t < this.nM.length - 1) {
                const n = this.sM[t], r = n.vv();
                null !== i && n.mv(i, s, e), e += r.height;
            }
        }
        if (s += r.vv().width, this.VM()) {
            h("right", s);
            s += $8f74814242901c26$var$u(r.Pw()).vv().width;
        }
        const a = (t, n, s)=>{
            $8f74814242901c26$var$u("left" === t ? this.vM.$w() : this.vM.jw()).mv($8f74814242901c26$var$u(i), n, s);
        };
        if (this.yn.timeScale.visible) {
            const t = this.vM.vv();
            if (null !== i) {
                let s = 0;
                this.IM() && (a("left", s, e), s = $8f74814242901c26$var$u(r.yw()).vv().width), this.vM.mv(i, s, e, n), s += t.width, this.VM() && a("right", s, e);
            }
            e += t.height;
        }
        return (0, $aFz8k.size)({
            width: s,
            height: e
        });
    }
    LM() {
        let i = 0, n = 0, s = 0;
        for (const t of this.nM)this.IM() && (n = Math.max(n, $8f74814242901c26$var$u(t.yw()).Cm(), this.yn.leftPriceScale.minimumWidth)), this.VM() && (s = Math.max(s, $8f74814242901c26$var$u(t.Pw()).Cm(), this.yn.rightPriceScale.minimumWidth)), i += t.F_();
        n = $8f74814242901c26$var$mn(n), s = $8f74814242901c26$var$mn(s);
        const e = this.k_, r = this.oo, h = Math.max(e - n - s, 0), a = 1 * this.sM.length, l = this.yn.timeScale.visible;
        let o = l ? Math.max(this.vM.Kw(), this.yn.timeScale.minimumHeight) : 0;
        var _;
        o = (_ = o) + _ % 2;
        const c = a + o, d = r < c ? 0 : r - c, f = d / i;
        let p = 0;
        const v = window.devicePixelRatio || 1;
        for(let i = 0; i < this.nM.length; ++i){
            const e = this.nM[i];
            e.ew(this.sn.Gn()[i]);
            let r = 0, a = 0;
            a = i === this.nM.length - 1 ? Math.ceil((d - p) * v) / v : Math.round(e.F_() * f * v) / v, r = Math.max(a, 2), p += r, e.km((0, $aFz8k.size)({
                width: h,
                height: r
            })), this.IM() && e.gw(n, "left"), this.VM() && e.gw(s, "right"), e.yv() && this.sn.Ed(e.yv(), r);
        }
        this.vM.Yw((0, $aFz8k.size)({
            width: l ? h : 0,
            height: o
        }), l ? n : 0, l ? s : 0), this.sn.H_(h), this.rM !== n && (this.rM = n), this.hM !== s && (this.hM = s);
    }
    fM(t) {
        t ? this.jv.addEventListener("wheel", this.cM, {
            passive: !1
        }) : this.jv.removeEventListener("wheel", this.cM);
    }
    zM(t) {
        switch(t.deltaMode){
            case t.DOM_DELTA_PAGE:
                return 120;
            case t.DOM_DELTA_LINE:
                return 32;
        }
        return $8f74814242901c26$var$Zn ? 1 / window.devicePixelRatio : 1;
    }
    dM(t) {
        if (!(0 !== t.deltaX && this.yn.handleScroll.mouseWheel || 0 !== t.deltaY && this.yn.handleScale.mouseWheel)) return;
        const i = this.zM(t), n = i * t.deltaX / 100, s = -i * t.deltaY / 100;
        if (t.cancelable && t.preventDefault(), 0 !== s && this.yn.handleScale.mouseWheel) {
            const i = Math.sign(s) * Math.min(1, Math.abs(s)), n = t.clientX - this.jv.getBoundingClientRect().left;
            this.Qt().Wd(n, i);
        }
        0 !== n && this.yn.handleScroll.mouseWheel && this.Qt().Hd(-80 * n);
    }
    yM(t, i) {
        const n = t.ls();
        3 === n && this.OM(), 3 !== n && 2 !== n || (this.NM(t), this.FM(t, i), this.vM.Pt(), this.nM.forEach((t)=>{
            t.hw();
        }), 3 === this.aM?.ls() && (this.aM.Ss(t), this.OM(), this.NM(this.aM), this.FM(this.aM, i), t = this.aM, this.aM = null)), this.Rm(t);
    }
    FM(t, i) {
        for (const n of t.bs())this.xs(n, i);
    }
    NM(t) {
        const i = this.sn.Gn();
        for(let n = 0; n < i.length; n++)t._s(n).hs && i[n].lu();
    }
    xs(t, i) {
        const n = this.sn.Et();
        switch(t.ds){
            case 0:
                n.td();
                break;
            case 1:
                n.nd(t.Wt);
                break;
            case 2:
                n.Ms(t.Wt);
                break;
            case 3:
                n.gs(t.Wt);
                break;
            case 4:
                n.Wc();
                break;
            case 5:
                t.Wt.Kc(i) || n.gs(t.Wt.Gc(i));
        }
    }
    gd(t) {
        null !== this.aM ? this.aM.Ss(t) : this.aM = t, this.lM || (this.lM = !0, this.eM = window.requestAnimationFrame((t)=>{
            if (this.lM = !1, this.eM = 0, null !== this.aM) {
                const i = this.aM;
                this.aM = null, this.yM(i, t);
                for (const n of i.bs())if (5 === n.ds && !n.Wt.Kc(t)) {
                    this.Qt().ps(n.Wt);
                    break;
                }
            }
        }));
    }
    OM() {
        this.MM();
    }
    SM(t) {
        this.uM.removeChild(t.fv()), t.m();
    }
    MM() {
        const t = this.sn.Gn(), i = t.length, n = this.nM.length;
        for(let t = i; t < n; t++){
            const t = $8f74814242901c26$var$_(this.nM.pop());
            this.uM.removeChild(t.fv()), t.mw().u(this), t.ww().u(this), t.m();
            const i = this.sM.pop();
            void 0 !== i && this.SM(i);
        }
        for(let s = n; s < i; s++){
            const i = new $8f74814242901c26$var$Un(this, t[s]);
            if (i.mw().i(this.WM.bind(this, i), this), i.ww().i(this.HM.bind(this, i), this), this.nM.push(i), s > 0) {
                const t = new $8f74814242901c26$var$yn(this, s - 1, s);
                this.sM.push(t), this.uM.insertBefore(t.fv(), this.vM.fv());
            }
            this.uM.insertBefore(i.fv(), this.vM.fv());
        }
        for(let n = 0; n < i; n++){
            const i = t[n], s = this.nM[n];
            s.yv() !== i ? s.ew(i) : s.sw();
        }
        this.gM(), this.LM();
    }
    UM(t, i, n, s) {
        const e = new Map;
        if (null !== t) this.sn.Jn().forEach((i)=>{
            const n = i.Un().Hn(t);
            null !== n && e.set(i, n);
        });
        let r;
        if (null !== t) {
            const i = this.sn.Et().en(t)?.originalTime;
            void 0 !== i && (r = i);
        }
        const h = this.Qt().cu(), a = this.$M(s), l = function(t, i) {
            const n = null !== t && t.uu instanceof $8f74814242901c26$var$Jt ? t.uu : void 0, s = t?.bu?.te, e = void 0 !== i && -1 !== i ? i : void 0;
            var r, h;
            return null === t || void 0 === t.ee ? {
                jM: n,
                qM: s
            } : {
                jM: n,
                qM: s,
                YM: {
                    ds: t.ee,
                    KM: (r = t.uu, h = t.ee, r instanceof $8f74814242901c26$var$Pi ? "pane-primitive" : "marker" === h || "primitive" === h ? "series-primitive" : "series"),
                    GM: $8f74814242901c26$var$vn(t.ee, s),
                    Y_: n,
                    ZM: s,
                    XM: e
                }
            };
        }(h, a);
        return {
            Qr: r,
            $n: t ?? void 0,
            JM: i ?? void 0,
            XM: -1 !== a ? a : void 0,
            jM: l.jM,
            QM: e,
            qM: l.qM,
            YM: l.YM,
            tg: n ?? void 0
        };
    }
    $M(t) {
        let i = -1;
        if (t) i = this.nM.indexOf(t);
        else {
            const t = this.Qt().Vd().Kn();
            null !== t && (i = this.Qt().Gn().indexOf(t));
        }
        return i;
    }
    WM(t, i, n, s) {
        this.$m.p(()=>this.UM(i, n, s, t));
    }
    HM(t, i, n, s) {
        this.jm.p(()=>this.UM(i, n, s, t));
    }
    pM(t, i, n) {
        this.BM(this.Qt().cu()?.gu ?? null), this.wd.p(()=>this.UM(t, i, n));
    }
    gM() {
        const t = this.yn.timeScale.visible ? "" : "none";
        this.vM.fv().style.display = t;
    }
    IM() {
        return this.nM[0].yv().X_().N().visible;
    }
    VM() {
        return this.nM[0].yv().J_().N().visible;
    }
    mM() {
        return "ResizeObserver" in window && (this.oM = new ResizeObserver((t)=>{
            const i = t[t.length - 1];
            if (!i) return;
            const n = i.contentRect.width, s = i.contentRect.height;
            this.wM(n, s, !0);
        }), this.oM.observe(this.Kv, {
            box: "border-box"
        }), !0);
    }
    xM() {
        null !== this.oM && this.oM.disconnect(), this.oM = null;
    }
}
function $8f74814242901c26$var$Jn(t) {
    return Boolean(t.handleScroll.mouseWheel || t.handleScale.mouseWheel);
}
function $8f74814242901c26$var$Qn(t) {
    return void 0 === t.open && void 0 === t.value;
}
function $8f74814242901c26$var$ts(t) {
    return function(t) {
        return void 0 !== t.open;
    }(t) || function(t) {
        return void 0 !== t.value;
    }(t);
}
function $8f74814242901c26$var$is(t, i, n, s) {
    const e = n.value, r = {
        $n: i,
        wt: t,
        Wt: [
            e,
            e,
            e,
            e
        ],
        Qr: s
    };
    return void 0 !== n.color && (r.R = n.color), r;
}
function $8f74814242901c26$var$ns(t, i, n, s) {
    const e = n.value, r = {
        $n: i,
        wt: t,
        Wt: [
            e,
            e,
            e,
            e
        ],
        Qr: s
    };
    return void 0 !== n.lineColor && (r.vt = n.lineColor), void 0 !== n.topColor && (r.ah = n.topColor), void 0 !== n.bottomColor && (r.oh = n.bottomColor), r;
}
function $8f74814242901c26$var$ss(t, i, n, s) {
    const e = n.value, r = {
        $n: i,
        wt: t,
        Wt: [
            e,
            e,
            e,
            e
        ],
        Qr: s
    };
    return void 0 !== n.topLineColor && (r._h = n.topLineColor), void 0 !== n.bottomLineColor && (r.uh = n.bottomLineColor), void 0 !== n.topFillColor1 && (r.dh = n.topFillColor1), void 0 !== n.topFillColor2 && (r.fh = n.topFillColor2), void 0 !== n.bottomFillColor1 && (r.ph = n.bottomFillColor1), void 0 !== n.bottomFillColor2 && (r.mh = n.bottomFillColor2), r;
}
function $8f74814242901c26$var$es(t, i, n, s) {
    const e = {
        $n: i,
        wt: t,
        Wt: [
            n.open,
            n.high,
            n.low,
            n.close
        ],
        Qr: s
    };
    return void 0 !== n.color && (e.R = n.color), e;
}
function $8f74814242901c26$var$rs(t, i, n, s) {
    const e = {
        $n: i,
        wt: t,
        Wt: [
            n.open,
            n.high,
            n.low,
            n.close
        ],
        Qr: s
    };
    return void 0 !== n.color && (e.R = n.color), void 0 !== n.borderColor && (e.Ht = n.borderColor), void 0 !== n.wickColor && (e.hh = n.wickColor), e;
}
function $8f74814242901c26$var$hs(t, i, n, s, e) {
    const r = $8f74814242901c26$var$_(e)(n), h = Math.max(...r), a = Math.min(...r), l = r[r.length - 1], o = [
        l,
        h,
        a,
        l
    ], { time: u, color: c, ...d } = n;
    return {
        $n: i,
        wt: t,
        Wt: o,
        Qr: s,
        ue: d,
        R: c
    };
}
function $8f74814242901c26$var$as(t) {
    return void 0 !== t.Wt;
}
function $8f74814242901c26$var$ls(t, i) {
    return void 0 !== i.customValues && (t.ig = i.customValues), t;
}
function $8f74814242901c26$var$os(t) {
    return (i, n, s, e, r, h)=>(function(t, i) {
            return i ? i(t) : $8f74814242901c26$var$Qn(t);
        })(s, h) ? $8f74814242901c26$var$ls({
            wt: i,
            $n: n,
            Qr: e
        }, s) : $8f74814242901c26$var$ls(t(i, n, s, e, r), s);
}
function $8f74814242901c26$var$_s(t) {
    return ({
        Candlestick: $8f74814242901c26$var$os($8f74814242901c26$var$rs),
        Bar: $8f74814242901c26$var$os($8f74814242901c26$var$es),
        Area: $8f74814242901c26$var$os($8f74814242901c26$var$ns),
        Baseline: $8f74814242901c26$var$os($8f74814242901c26$var$ss),
        Histogram: $8f74814242901c26$var$os($8f74814242901c26$var$is),
        Line: $8f74814242901c26$var$os($8f74814242901c26$var$is),
        Custom: $8f74814242901c26$var$os($8f74814242901c26$var$hs)
    })[t];
}
function $8f74814242901c26$var$us(t) {
    return {
        $n: 0,
        ng: new Map,
        Oa: t
    };
}
function $8f74814242901c26$var$cs(t, i) {
    if (void 0 !== t && 0 !== t.length) return {
        sg: i.key(t[0].wt),
        eg: i.key(t[t.length - 1].wt)
    };
}
function $8f74814242901c26$var$ds(t) {
    let i;
    return t.forEach((t)=>{
        void 0 === i && (i = t.Qr);
    }), $8f74814242901c26$var$_(i);
}
class $8f74814242901c26$var$fs {
    constructor(t){
        this.rg = new Map, this.hg = new Map, this.ag = new Map, this.lg = [], this.Pu = t;
    }
    m() {
        this.rg.clear(), this.hg.clear(), this.ag.clear(), this.lg = [];
    }
    og(t, i) {
        let n = 0 !== this.rg.size, s = !1;
        const e = this.hg.get(t);
        if (void 0 !== e) {
            if (1 === this.hg.size) n = !1, s = !0, this.rg.clear();
            else for (const i of this.lg)i.pointData.ng.delete(t) && (s = !0);
        }
        let r = [];
        if (0 !== i.length) {
            const n = i.map((t)=>t.time), e = this.Pu.createConverterToInternalObj(i), h = $8f74814242901c26$var$_s(t.bh()), a = t.ul(), l = t.cl();
            r = i.map((i, r)=>{
                const o = e(i.time), _ = this.Pu.key(o);
                let u = this.rg.get(_);
                void 0 === u && (u = $8f74814242901c26$var$us(o), this.rg.set(_, u), s = !0);
                const c = h(o, u.$n, i, n[r], a, l);
                return u.ng.set(t, c), c;
            });
        }
        n && this._g(), this.ug(t, r);
        let h = -1;
        if (s) {
            const t = [];
            this.rg.forEach((i)=>{
                t.push({
                    timeWeight: 0,
                    time: i.Oa,
                    pointData: i,
                    originalTime: $8f74814242901c26$var$ds(i.ng)
                });
            }), t.sort((t, i)=>this.Pu.key(t.time) - this.Pu.key(i.time)), h = this.cg(t);
        }
        return this.dg(t, h, function(t, i, n) {
            const s = $8f74814242901c26$var$cs(t, n), e = $8f74814242901c26$var$cs(i, n);
            if (void 0 !== s && void 0 !== e) return {
                fg: !1,
                Va: s.eg >= e.eg && s.sg >= e.sg
            };
        }(this.hg.get(t), e, this.Pu));
    }
    if(t) {
        return this.og(t, []);
    }
    pg(t, i, n) {
        if (n && t.Fa()) throw new Error("Historical updates are not supported when conflation is enabled. Conflation requires data to be processed in order.");
        const s = i;
        !function(t) {
            void 0 === t.Qr && (t.Qr = t.time);
        }(s), this.Pu.preprocessData(i);
        const e = this.Pu.createConverterToInternalObj([
            i
        ])(i.time), r = this.ag.get(t);
        if (!n && void 0 !== r && this.Pu.key(e) < this.Pu.key(r)) throw new Error(`Cannot update oldest data, last time=${r}, new time=${e}`);
        let h = this.rg.get(this.Pu.key(e));
        if (n && void 0 === h) throw new Error("Cannot update non-existing data point when historicalUpdate is true");
        const a = void 0 === h;
        void 0 === h && (h = $8f74814242901c26$var$us(e), this.rg.set(this.Pu.key(e), h));
        const l = $8f74814242901c26$var$_s(t.bh()), o = t.ul(), _ = t.cl(), u = l(e, h.$n, i, s.Qr, o, _), c = !n && !a && void 0 !== r && this.Pu.key(e) === this.Pu.key(r);
        h.ng.set(t, u), n ? this.vg(t, u, h.$n) : c && t.Fa() && $8f74814242901c26$var$as(u) ? (t.Rr(u), this.mg(t, u)) : this.mg(t, u);
        const d = {
            Va: $8f74814242901c26$var$as(u),
            fg: n
        };
        if (!a) return this.dg(t, -1, d);
        const f = {
            timeWeight: 0,
            time: h.Oa,
            pointData: h,
            originalTime: $8f74814242901c26$var$ds(h.ng)
        }, p = $8f74814242901c26$var$Rt(this.lg, this.Pu.key(f.time), (t, i)=>this.Pu.key(t.time) < i);
        this.lg.splice(p, 0, f);
        for(let t = p; t < this.lg.length; ++t)$8f74814242901c26$var$ps(this.lg[t].pointData, t);
        return this.Pu.fillWeightsForPoints(this.lg, p), this.dg(t, p, d);
    }
    wg(t, i) {
        const n = this.hg.get(t);
        if (void 0 === n || i <= 0) return [
            [],
            this.Mg()
        ];
        i = Math.min(i, n.length);
        const s = n.splice(-i).reverse();
        0 === n.length ? this.ag.delete(t) : this.ag.set(t, n[n.length - 1].wt);
        for (const i of s){
            const n = this.rg.get(this.Pu.key(i.wt));
            if (n && (n.ng.delete(t), 0 === n.ng.size)) {
                this.rg.delete(this.Pu.key(n.Oa)), this.lg.splice(n.$n, 1);
                for(let t = n.$n; t < this.lg.length; ++t)$8f74814242901c26$var$ps(this.lg[t].pointData, t);
            }
        }
        return [
            s,
            this.dg(t, this.lg.length - 1, {
                fg: !1,
                Va: !1
            })
        ];
    }
    mg(t, i) {
        let n = this.hg.get(t);
        void 0 === n && (n = [], this.hg.set(t, n));
        const s = 0 !== n.length ? n[n.length - 1] : null;
        null === s || this.Pu.key(i.wt) > this.Pu.key(s.wt) ? $8f74814242901c26$var$as(i) && n.push(i) : $8f74814242901c26$var$as(i) ? n[n.length - 1] = i : n.splice(-1, 1), this.ag.set(t, i.wt);
    }
    vg(t, i, n) {
        const s = this.hg.get(t);
        if (void 0 === s) return;
        const e = $8f74814242901c26$var$Rt(s, n, (t, i)=>t.$n < i);
        $8f74814242901c26$var$as(i) ? s[e] = i : s.splice(e, 1);
    }
    ug(t, i) {
        0 !== i.length ? (this.hg.set(t, i.filter($8f74814242901c26$var$as)), this.ag.set(t, i[i.length - 1].wt)) : (this.hg.delete(t), this.ag.delete(t));
    }
    _g() {
        for (const t of this.lg)0 === t.pointData.ng.size && this.rg.delete(this.Pu.key(t.time));
    }
    cg(t) {
        let i = -1;
        for(let n = 0; n < this.lg.length && n < t.length; ++n){
            const s = this.lg[n], e = t[n];
            if (this.Pu.key(s.time) !== this.Pu.key(e.time)) {
                i = n;
                break;
            }
            e.timeWeight = s.timeWeight, $8f74814242901c26$var$ps(e.pointData, n);
        }
        if (-1 === i && this.lg.length !== t.length && (i = Math.min(this.lg.length, t.length)), -1 === i) return -1;
        for(let n = i; n < t.length; ++n)$8f74814242901c26$var$ps(t[n].pointData, n);
        return this.Pu.fillWeightsForPoints(t, i), this.lg = t, i;
    }
    gg() {
        if (0 === this.hg.size) return null;
        let t = 0;
        return this.hg.forEach((i)=>{
            0 !== i.length && (t = Math.max(t, i[i.length - 1].$n));
        }), t;
    }
    dg(t, i, n) {
        const s = this.Mg();
        if (-1 !== i) this.hg.forEach((i, e)=>{
            s.Y_.set(e, {
                ue: i,
                bg: e === t ? n : void 0
            });
        }), this.hg.has(t) || s.Y_.set(t, {
            ue: [],
            bg: n
        }), s.Et.Sg = this.lg, s.Et.xg = i;
        else {
            const i = this.hg.get(t);
            s.Y_.set(t, {
                ue: i || [],
                bg: n
            });
        }
        return s;
    }
    Mg() {
        return {
            Y_: new Map,
            Et: {
                Dc: this.gg()
            }
        };
    }
}
function $8f74814242901c26$var$ps(t, i) {
    t.$n = i, t.ng.forEach((t)=>{
        t.$n = i;
    });
}
function $8f74814242901c26$var$vs(t, i) {
    return t._t < i;
}
function $8f74814242901c26$var$ms(t, i) {
    return i < t._t;
}
function $8f74814242901c26$var$ws(t, i, n, s) {
    return $8f74814242901c26$var$Rt(t, i, $8f74814242901c26$var$vs, n, s);
}
function $8f74814242901c26$var$Ms(t, i, n, s) {
    return $8f74814242901c26$var$Dt(t, i, $8f74814242901c26$var$ms, n, s);
}
function $8f74814242901c26$var$gs(t, i, n) {
    return {
        ne: t,
        se: i,
        ee: n
    };
}
function $8f74814242901c26$var$bs(t, i, n, s) {
    return t >= i - s && t <= n + s;
}
function $8f74814242901c26$var$Ss(t, i, n, s, e, r) {
    const h = e - n, a = r - s;
    if (0 === h && 0 === a) return Math.hypot(t - n, i - s);
    const l = ((t - n) * h + (i - s) * a) / (h * h + a * a), o = Math.max(0, Math.min(1, l)), _ = n + h * o, u = s + a * o;
    return Math.hypot(t - _, i - u);
}
const $8f74814242901c26$var$xs = [
    0,
    0
];
function $8f74814242901c26$var$Cs(t, i, n) {
    return void 0 === i || i.wt !== t.wt - 1 ? t._t - n / 2 : (i._t + t._t) / 2;
}
function $8f74814242901c26$var$ys(t, i, n) {
    return void 0 === i || i.wt !== t.wt + 1 ? t._t + n / 2 : (t._t + i._t) / 2;
}
function $8f74814242901c26$var$Ps(t, i, n, s, e, r, h) {
    if (null === i || i.from >= i.to || 0 === t.length) return null;
    const a = e / 2 + r, l = $8f74814242901c26$var$ws(t, n - a, i.from, i.to), o = $8f74814242901c26$var$Ms(t, n + a, l, i.to);
    if (l >= o) return null;
    let _ = Number.POSITIVE_INFINITY;
    for(let a = l; a < o; a++){
        const l = t[a], o = a > i.from ? t[a - 1] : void 0, u = a < i.to - 1 ? t[a + 1] : void 0, c = $8f74814242901c26$var$Cs(l, o, e) - r, d = $8f74814242901c26$var$ys(l, u, e) + r;
        if (n < c || n > d) continue;
        h(l, $8f74814242901c26$var$xs);
        const f = $8f74814242901c26$var$xs[0], p = $8f74814242901c26$var$xs[1], v = Math.min(f, p), m = Math.max(f, p), w = v - r, M = m + r;
        if (s >= v && s <= m) _ = Math.min(_, 0);
        else if (s >= w && s <= M) {
            const t = Math.min(Math.abs(s - v), Math.abs(m - s));
            _ = Math.min(_, t);
        }
    }
    return Number.isFinite(_) ? $8f74814242901c26$var$gs(_, 0, "series-range") : null;
}
function $8f74814242901c26$var$ks(t, i) {
    return t.wt < i;
}
function $8f74814242901c26$var$Ts(t, i) {
    return i < t.wt;
}
function $8f74814242901c26$var$Rs(t, i, n) {
    const s = i.Na(), e = i.bi(), r = $8f74814242901c26$var$Rt(t, s, $8f74814242901c26$var$ks), h = $8f74814242901c26$var$Dt(t, e, $8f74814242901c26$var$Ts);
    if (!n) return {
        from: r,
        to: h
    };
    let a = r, l = h;
    return r > 0 && r < t.length && t[r].wt >= s && (a = r - 1), h > 0 && h < t.length && t[h - 1].wt <= e && (l = h + 1), {
        from: a,
        to: l
    };
}
class $8f74814242901c26$var$Ds {
    constructor(t, i, n){
        this.Cg = !0, this.yg = !0, this.Pg = !0, this.kg = [], this.Tg = null, this.Rg = -1, this.ae = t, this.le = i, this.Dg = n;
    }
    Pt(t) {
        this.Cg = !0, "data" === t && (this.yg = !0), "options" === t && (this.Pg = !0);
    }
    Tt() {
        return this.ae.It() ? (this.Ig(), null === this.Tg ? null : this.Vg) : null;
    }
    Qs(t, i) {
        return this.ae.It() ? (this.Ig(), null === this.Tg ? null : this.Bg(t, i)) : null;
    }
    Bg(t, i) {
        return null;
    }
    Eg() {
        this.kg = this.kg.map((t)=>({
                ...t,
                ...this.ae.Sa().Sh(t.wt)
            }));
    }
    Ag() {
        this.Tg = null;
    }
    Ig() {
        const t = this.le.Et(), i = t.N().enableConflation ? t.sd() : 0;
        i !== this.Rg && (this.yg = !0, this.Rg = i), this.yg && (this.Lg(), this.yg = !1), this.Pg && (this.Eg(), this.Pg = !1), this.Cg && (this.zg(), this.Cg = !1);
    }
    zg() {
        const t = this.ae.Ft(), i = this.le.Et();
        if (this.Ag(), i.Zi() || t.Zi()) return;
        const n = i.Ee();
        if (null === n) return;
        if (0 === this.ae.Un().Th()) return;
        const s = this.ae.Lt();
        null !== s && (this.Tg = $8f74814242901c26$var$Rs(this.kg, n, this.Dg), this.Og(t, i, s.Wt), this.Ng());
    }
}
class $8f74814242901c26$var$Is {
    constructor(t, i){
        this.Fg = t, this.Ki = i;
    }
    st(t, i, n) {
        this.Fg.draw(t, this.Ki, i, n);
    }
}
function $8f74814242901c26$var$Vs(t) {
    switch(t){
        case "point":
            return 2;
        case "range":
            return 0;
        default:
            return 1;
    }
}
class $8f74814242901c26$var$Bs extends $8f74814242901c26$var$Ds {
    constructor(t, i, n){
        super(t, i, !1), this.Yh = n, this.Fg = this.Yh.renderer(), this.Vg = new $8f74814242901c26$var$Is(this.Fg, (t)=>this.Wg(t));
    }
    get ga() {
        return this.Yh.conflationReducer;
    }
    Ha(t) {
        return this.Yh.priceValueBuilder(t);
    }
    dl(t) {
        return this.Yh.isWhitespace(t);
    }
    Bg(t, i) {
        const n = this.Fg.hitTest?.(t, i, (t)=>this.Wg(t));
        if (null != n) return {
            ne: (s = n).distance,
            se: $8f74814242901c26$var$Vs(s.type),
            ee: "custom",
            gu: s.cursorStyle,
            te: s.objectId,
            ie: s.hitTestData
        };
        var s;
        const e = $8f74814242901c26$var$Ps(this.kg, this.Tg, t, i, this.le.Et().ml(), this.ae.N().hitTestTolerance, (t, i)=>{
            const n = t.Hg;
            let s = NaN, e = NaN;
            if (void 0 !== n && !this.Yh.isWhitespace(n)) for (const t of this.Yh.priceValueBuilder(n)){
                const i = this.Wg(t);
                null !== i && (s = Number.isNaN(s) ? i : Math.min(s, i), e = Number.isNaN(e) ? i : Math.max(e, i));
            }
            i[0] = s, i[1] = e;
        });
        return null === e ? null : {
            ...e,
            ee: "custom"
        };
    }
    Lg() {
        const t = this.ae.Sa();
        this.kg = this.ae.Ua().Bh().map((i)=>({
                wt: i.$n,
                _t: NaN,
                ...t.Sh(i.$n),
                Hg: i.ue
            }));
    }
    Og(t, i) {
        i.Ic(this.kg, $8f74814242901c26$var$b(this.Tg));
    }
    Ng() {
        this.Yh.update({
            bars: this.kg.map($8f74814242901c26$var$Es),
            barSpacing: this.le.Et().ml(),
            visibleRange: this.Tg,
            conflationFactor: this.le.Et().sd()
        }, this.ae.N());
    }
    Wg(t) {
        const i = this.ae.Lt();
        return null === i ? null : this.ae.Ft().Nt(t, i.Wt);
    }
}
function $8f74814242901c26$var$Es(t) {
    return {
        x: t._t,
        time: t.wt,
        originalData: t.Hg,
        barColor: t.sh
    };
}
const $8f74814242901c26$var$As = {
    color: "#2196f3"
}, $8f74814242901c26$var$Ls = (t, i, n)=>{
    const s = $8f74814242901c26$var$c(n);
    return new $8f74814242901c26$var$Bs(t, i, s);
};
function $8f74814242901c26$var$zs(t) {
    const i = {
        value: t.Wt[3],
        time: t.Qr
    };
    return void 0 !== t.ig && (i.customValues = t.ig), i;
}
function $8f74814242901c26$var$Os(t) {
    const i = $8f74814242901c26$var$zs(t);
    return void 0 !== t.R && (i.color = t.R), i;
}
function $8f74814242901c26$var$Ns(t) {
    const i = $8f74814242901c26$var$zs(t);
    return void 0 !== t.vt && (i.lineColor = t.vt), void 0 !== t.ah && (i.topColor = t.ah), void 0 !== t.oh && (i.bottomColor = t.oh), i;
}
function $8f74814242901c26$var$Fs(t) {
    const i = $8f74814242901c26$var$zs(t);
    return void 0 !== t._h && (i.topLineColor = t._h), void 0 !== t.uh && (i.bottomLineColor = t.uh), void 0 !== t.dh && (i.topFillColor1 = t.dh), void 0 !== t.fh && (i.topFillColor2 = t.fh), void 0 !== t.ph && (i.bottomFillColor1 = t.ph), void 0 !== t.mh && (i.bottomFillColor2 = t.mh), i;
}
function $8f74814242901c26$var$Ws(t) {
    const i = {
        open: t.Wt[0],
        high: t.Wt[1],
        low: t.Wt[2],
        close: t.Wt[3],
        time: t.Qr
    };
    return void 0 !== t.ig && (i.customValues = t.ig), i;
}
function $8f74814242901c26$var$Hs(t) {
    const i = $8f74814242901c26$var$Ws(t);
    return void 0 !== t.R && (i.color = t.R), i;
}
function $8f74814242901c26$var$Us(t) {
    const i = $8f74814242901c26$var$Ws(t), { R: n, Ht: s, hh: e } = t;
    return void 0 !== n && (i.color = n), void 0 !== s && (i.borderColor = s), void 0 !== e && (i.wickColor = e), i;
}
function $8f74814242901c26$var$$s(t) {
    return ({
        Area: $8f74814242901c26$var$Ns,
        Line: $8f74814242901c26$var$Os,
        Baseline: $8f74814242901c26$var$Fs,
        Histogram: $8f74814242901c26$var$Os,
        Bar: $8f74814242901c26$var$Hs,
        Candlestick: $8f74814242901c26$var$Us,
        Custom: $8f74814242901c26$var$js
    })[t];
}
function $8f74814242901c26$var$js(t) {
    const i = t.Qr;
    return {
        ...t.ue,
        time: i
    };
}
const $8f74814242901c26$var$qs = {
    vertLine: {
        color: "#9598A1",
        width: 1,
        style: 3,
        visible: !0,
        labelVisible: !0,
        labelBackgroundColor: "#131722"
    },
    horzLine: {
        color: "#9598A1",
        width: 1,
        style: 3,
        visible: !0,
        labelVisible: !0,
        labelBackgroundColor: "#131722"
    },
    mode: 1,
    doNotSnapToHiddenSeriesIndices: !1
}, $8f74814242901c26$var$Ys = {
    vertLines: {
        color: "#D6DCDE",
        style: 0,
        visible: !0
    },
    horzLines: {
        color: "#D6DCDE",
        style: 0,
        visible: !0
    }
}, $8f74814242901c26$var$Ks = {
    background: {
        type: "solid",
        color: "#FFFFFF"
    },
    textColor: "#191919",
    fontSize: 12,
    fontFamily: $8f74814242901c26$var$S,
    panes: {
        enableResize: !0,
        separatorColor: "#E0E3EB",
        separatorHoverColor: "rgba(178, 181, 189, 0.2)"
    },
    attributionLogo: !0,
    colorSpace: "srgb",
    colorParsers: []
}, $8f74814242901c26$var$Gs = {
    autoScale: !0,
    mode: 0,
    invertScale: !1,
    alignLabels: !0,
    borderVisible: !0,
    borderColor: "#2B2B43",
    entireTextOnly: !1,
    visible: !1,
    ticksVisible: !1,
    scaleMargins: {
        bottom: .1,
        top: .2
    },
    minimumWidth: 0,
    ensureEdgeTickMarksVisible: !1,
    tickMarkDensity: 2.5
}, $8f74814242901c26$var$Zs = {
    rightOffset: 0,
    barSpacing: 6,
    minBarSpacing: .5,
    maxBarSpacing: 0,
    fixLeftEdge: !1,
    fixRightEdge: !1,
    lockVisibleTimeRangeOnResize: !1,
    rightBarStaysOnScroll: !1,
    borderVisible: !0,
    borderColor: "#2B2B43",
    visible: !0,
    timeVisible: !1,
    secondsVisible: !0,
    shiftVisibleRangeOnNewBar: !0,
    allowShiftVisibleRangeOnWhitespaceReplacement: !1,
    ticksVisible: !1,
    uniformDistribution: !1,
    minimumHeight: 0,
    allowBoldLabels: !0,
    ignoreWhitespaceIndices: !1,
    enableConflation: !1,
    conflationThresholdFactor: 1,
    precomputeConflationOnInit: !1,
    precomputeConflationPriority: "background"
};
function $8f74814242901c26$var$Xs() {
    return {
        addDefaultPane: !0,
        hoveredSeriesOnTop: !0,
        width: 0,
        height: 0,
        autoSize: !1,
        layout: $8f74814242901c26$var$Ks,
        crosshair: $8f74814242901c26$var$qs,
        grid: $8f74814242901c26$var$Ys,
        overlayPriceScales: {
            ...$8f74814242901c26$var$Gs
        },
        leftPriceScale: {
            ...$8f74814242901c26$var$Gs,
            visible: !1
        },
        rightPriceScale: {
            ...$8f74814242901c26$var$Gs,
            visible: !0
        },
        defaultVisiblePriceScaleId: "right",
        timeScale: $8f74814242901c26$var$Zs,
        localization: {
            locale: $8f74814242901c26$var$dn ? navigator.language : "",
            dateFormat: "dd MMM 'yy"
        },
        handleScroll: {
            mouseWheel: !0,
            pressedMouseMove: !0,
            horzTouchDrag: !0,
            vertTouchDrag: !0
        },
        handleScale: {
            axisPressedMouseMove: {
                time: !0,
                price: !0
            },
            axisDoubleClickReset: {
                time: !0,
                price: !0
            },
            mouseWheel: !0,
            pinch: !0
        },
        kineticScroll: {
            mouse: !1,
            touch: !0
        },
        trackingMode: {
            exitMode: 1
        }
    };
}
class $8f74814242901c26$var$Js {
    constructor(t, i, n){
        this.hv = t, this.Ug = i, this.$g = n ?? 0;
    }
    applyOptions(t) {
        this.hv.Qt().Dd(this.Ug, t, this.$g);
    }
    options() {
        return this.Ki().N();
    }
    width() {
        return $8f74814242901c26$var$Z(this.Ug) ? this.hv.DM(this.Ug) : 0;
    }
    setVisibleRange(t) {
        this.setAutoScale(!1), this.Ki().Go(new $8f74814242901c26$var$mt(t.from, t.to));
    }
    getVisibleRange() {
        let t, i, n = this.Ki().ar();
        if (null === n) return null;
        if (this.Ki().ho()) {
            const s = this.Ki().S_(), e = $8f74814242901c26$var$Yi(s);
            n = $8f74814242901c26$var$vi(n, this.Ki().lo()), t = Number((Math.round(n.Je() / s) * s).toFixed(e)), i = Number((Math.round(n.Qe() / s) * s).toFixed(e));
        } else t = n.Je(), i = n.Qe();
        return {
            from: t,
            to: i
        };
    }
    setAutoScale(t) {
        this.applyOptions({
            autoScale: t
        });
    }
    Ki() {
        return $8f74814242901c26$var$u(this.hv.Qt().Id(this.Ug, this.$g)).Ft;
    }
}
class $8f74814242901c26$var$Qs {
    constructor(t, i, n, s){
        this.hv = t, this.yt = n, this.jg = i, this.qg = s;
    }
    getHeight() {
        return this.yt.$t();
    }
    setHeight(t) {
        const i = this.hv.Qt(), n = i._f(this.yt);
        i.Ld(n, t);
    }
    getStretchFactor() {
        return this.yt.F_();
    }
    setStretchFactor(t) {
        this.yt.W_(t), this.hv.Qt().ka();
    }
    paneIndex() {
        return this.hv.Qt()._f(this.yt);
    }
    moveTo(t) {
        const i = this.paneIndex();
        i !== t && ($8f74814242901c26$var$o(t >= 0 && t < this.hv.lv().length, "Invalid pane index"), this.hv.Qt().Od(i, t));
    }
    getSeries() {
        return this.yt.Y_().map((t)=>this.jg(t)) ?? [];
    }
    getHTMLElement() {
        const t = this.hv.lv();
        return t && 0 !== t.length && t[this.paneIndex()] ? t[this.paneIndex()].fv() : null;
    }
    attachPrimitive(t) {
        this.yt.ol(t), t.attached && t.attached({
            chart: this.qg,
            requestUpdate: ()=>this.yt.Qt().ka()
        });
    }
    detachPrimitive(t) {
        this.yt._l(t);
    }
    priceScale(t) {
        if (null === this.yt.O_(t)) throw new Error(`Cannot find price scale with id: ${t}`);
        return new $8f74814242901c26$var$Js(this.hv, t, this.paneIndex());
    }
    setPreserveEmptyPane(t) {
        this.yt.j_(t);
    }
    preserveEmptyPane() {
        return this.yt.q_();
    }
    addCustomSeries(t, i = {}, n = 0) {
        return this.qg.addCustomSeries(t, i, n);
    }
    addSeries(t, i = {}) {
        return this.qg.addSeries(t, i, this.paneIndex());
    }
}
const $8f74814242901c26$var$te = {
    color: "#FF0000",
    price: 0,
    lineStyle: 2,
    lineWidth: 1,
    lineVisible: !0,
    axisLabelVisible: !0,
    title: "",
    axisLabelColor: "",
    axisLabelTextColor: ""
};
class $8f74814242901c26$var$ie {
    constructor(t){
        this._r = t;
    }
    applyOptions(t) {
        this._r.vr(t);
    }
    options() {
        return this._r.N();
    }
    Yg() {
        return this._r;
    }
}
class $8f74814242901c26$var$ne {
    constructor(t, i, n, s, e, r){
        this.Kg = new $8f74814242901c26$var$d, this.ae = t, this.Gg = i, this.Zg = n, this.Pu = e, this.qg = s, this.Xg = r;
    }
    m() {
        this.Kg.m();
    }
    priceFormatter() {
        return this.ae.sl();
    }
    priceToCoordinate(t) {
        const i = this.ae.Lt();
        return null === i ? null : this.ae.Ft().Nt(t, i.Wt);
    }
    coordinateToPrice(t) {
        const i = this.ae.Lt();
        return null === i ? null : this.ae.Ft().Tn(t, i.Wt);
    }
    barsInLogicalRange(t) {
        if (null === t) return null;
        const i = new $8f74814242901c26$var$Oi(new $8f74814242901c26$var$Ai(t.from, t.to)).Uu(), n = this.ae.Un();
        if (n.Zi()) return null;
        const s = n.Hn(i.Na(), 1), e = n.Hn(i.bi(), -1), r = $8f74814242901c26$var$u(n.Rh()), h = $8f74814242901c26$var$u(n.Qn());
        if (null !== s && null !== e && s.$n > e.$n) return {
            barsBefore: t.from - r,
            barsAfter: h - t.to
        };
        const a = {
            barsBefore: null === s || s.$n === r ? t.from - r : s.$n - r,
            barsAfter: null === e || e.$n === h ? h - t.to : h - e.$n
        };
        return null !== s && null !== e && (a.from = s.Qr, a.to = e.Qr), a;
    }
    setData(t) {
        this.Pu, this.ae.bh(), this.Gg.Jg(this.ae, t), this.Qg("full");
    }
    update(t, i = !1) {
        this.ae.bh(), this.Gg.tb(this.ae, t, i), this.Qg("update");
    }
    pop(t = 1) {
        const i = this.Gg.ib(this.ae, t);
        0 !== i.length && this.Qg("update");
        const n = $8f74814242901c26$var$$s(this.seriesType());
        return i.map((t)=>n(t));
    }
    dataByIndex(t, i) {
        const n = this.ae.Un().Hn(t, i);
        if (null === n) return null;
        return $8f74814242901c26$var$$s(this.seriesType())(n);
    }
    data() {
        const t = $8f74814242901c26$var$$s(this.seriesType());
        return this.ae.Un().Bh().map((i)=>t(i));
    }
    subscribeDataChanged(t) {
        this.Kg.i(t);
    }
    unsubscribeDataChanged(t) {
        this.Kg._(t);
    }
    applyOptions(t) {
        this.ae.vr(t);
    }
    options() {
        return $8f74814242901c26$var$M(this.ae.N());
    }
    priceScale() {
        return this.Zg.priceScale(this.ae.Ft().pl(), this.getPane().paneIndex());
    }
    createPriceLine(t) {
        const i = $8f74814242901c26$var$f($8f74814242901c26$var$M($8f74814242901c26$var$te), t), n = this.ae.Ea(i);
        return new $8f74814242901c26$var$ie(n);
    }
    removePriceLine(t) {
        this.ae.Aa(t.Yg());
    }
    priceLines() {
        return this.ae.La().map((t)=>new $8f74814242901c26$var$ie(t));
    }
    seriesType() {
        return this.ae.bh();
    }
    lastValueData(t) {
        const i = this.ae.Ae(t);
        return i.Le ? {
            noData: !0
        } : {
            noData: !1,
            price: i.Mt,
            color: i.R
        };
    }
    attachPrimitive(t) {
        this.ae.ol(t), t.attached && t.attached({
            chart: this.qg,
            series: this,
            requestUpdate: ()=>this.ae.Qt().ka(),
            horzScaleBehavior: this.Pu
        });
    }
    detachPrimitive(t) {
        this.ae._l(t), t.detached && t.detached(), this.ae.Qt().ka();
    }
    getPane() {
        const t = this.ae, i = $8f74814242901c26$var$u(this.ae.Qt().Ks(t));
        return this.Xg(i);
    }
    moveToPane(t) {
        this.ae.Qt().rf(this.ae, t);
    }
    seriesOrder() {
        const t = this.ae.Qt().Ks(this.ae);
        return null === t ? -1 : t.Y_().indexOf(this.ae);
    }
    setSeriesOrder(t) {
        const i = this.ae.Qt().Ks(this.ae);
        null !== i && i.vu(this.ae, t);
    }
    Qg(t) {
        this.Kg.v() && this.Kg.p(t);
    }
}
class $8f74814242901c26$var$se {
    constructor(t, i, n){
        this.nb = new $8f74814242901c26$var$d, this.Qu = new $8f74814242901c26$var$d, this.Nw = new $8f74814242901c26$var$d, this.sn = t, this.ia = t.Et(), this.vM = i, this.ia.Zc().i(this.sb.bind(this)), this.ia.Xc().i(this.eb.bind(this)), this.vM.qw().i(this.rb.bind(this)), this.Pu = n;
    }
    m() {
        this.ia.Zc().u(this), this.ia.Xc().u(this), this.vM.qw().u(this), this.nb.m(), this.Qu.m(), this.Nw.m();
    }
    scrollPosition() {
        return this.ia.Oc();
    }
    scrollToPosition(t, i) {
        i ? this.ia.Yc(t, 1e3) : this.sn.gs(t);
    }
    scrollToRealTime() {
        this.ia.qc();
    }
    getVisibleRange() {
        const t = this.ia.xc();
        return null === t ? null : {
            from: t.from.originalTime,
            to: t.to.originalTime
        };
    }
    setVisibleRange(t) {
        const i = {
            from: this.Pu.convertHorzItemToInternal(t.from),
            to: this.Pu.convertHorzItemToInternal(t.to)
        }, n = this.ia.kc(i);
        this.sn.sf(n);
    }
    getVisibleLogicalRange() {
        const t = this.ia.Sc();
        return null === t ? null : {
            from: t.Na(),
            to: t.bi()
        };
    }
    setVisibleLogicalRange(t) {
        $8f74814242901c26$var$o(t.from <= t.to, "The from index cannot be after the to index."), this.sn.sf(t);
    }
    resetTimeScale() {
        this.sn.ws();
    }
    fitContent() {
        this.sn.td();
    }
    logicalToCoordinate(t) {
        const i = this.sn.Et();
        return i.Zi() ? null : i.jt(t);
    }
    coordinateToLogical(t) {
        return this.ia.Zi() ? null : this.ia.Vc(t);
    }
    timeToIndex(t, i) {
        const n = this.Pu.convertHorzItemToInternal(t);
        return this.ia.Mc(n, i);
    }
    timeToCoordinate(t) {
        const i = this.timeToIndex(t, !1);
        return null === i ? null : this.ia.jt(i);
    }
    coordinateToTime(t) {
        const i = this.sn.Et(), n = i.Vc(t), s = i.en(n);
        return null === s ? null : s.originalTime;
    }
    width() {
        return this.vM.pv().width;
    }
    height() {
        return this.vM.pv().height;
    }
    subscribeVisibleTimeRangeChange(t) {
        this.nb.i(t);
    }
    unsubscribeVisibleTimeRangeChange(t) {
        this.nb._(t);
    }
    subscribeVisibleLogicalRangeChange(t) {
        this.Qu.i(t);
    }
    unsubscribeVisibleLogicalRangeChange(t) {
        this.Qu._(t);
    }
    subscribeSizeChange(t) {
        this.Nw.i(t);
    }
    unsubscribeSizeChange(t) {
        this.Nw._(t);
    }
    applyOptions(t) {
        this.ia.vr(t);
    }
    options() {
        return {
            ...$8f74814242901c26$var$M(this.ia.N()),
            barSpacing: this.ia.ml()
        };
    }
    sb() {
        this.nb.v() && this.nb.p(this.getVisibleRange());
    }
    eb() {
        this.Qu.v() && this.Qu.p(this.getVisibleLogicalRange());
    }
    rb(t) {
        this.Nw.p(t.width, t.height);
    }
}
function $8f74814242901c26$var$ee(t) {
    return function(t) {
        if ($8f74814242901c26$var$w(t.handleScale)) {
            const i = t.handleScale;
            t.handleScale = {
                axisDoubleClickReset: {
                    time: i,
                    price: i
                },
                axisPressedMouseMove: {
                    time: i,
                    price: i
                },
                mouseWheel: i,
                pinch: i
            };
        } else if (void 0 !== t.handleScale) {
            const { axisPressedMouseMove: i, axisDoubleClickReset: n } = t.handleScale;
            $8f74814242901c26$var$w(i) && (t.handleScale.axisPressedMouseMove = {
                time: i,
                price: i
            }), $8f74814242901c26$var$w(n) && (t.handleScale.axisDoubleClickReset = {
                time: n,
                price: n
            });
        }
        const i = t.handleScroll;
        $8f74814242901c26$var$w(i) && (t.handleScroll = {
            horzTouchDrag: i,
            vertTouchDrag: i,
            mouseWheel: i,
            pressedMouseMove: i
        });
    }(t), t;
}
class $8f74814242901c26$var$re {
    constructor(t, i, n){
        this.hb = new Map, this.ab = new Map, this.lb = new $8f74814242901c26$var$d, this.ob = new $8f74814242901c26$var$d, this._b = new $8f74814242901c26$var$d, this.dd = new WeakMap, this.ub = new $8f74814242901c26$var$fs(i);
        const s = void 0 === n ? $8f74814242901c26$var$M($8f74814242901c26$var$Xs()) : $8f74814242901c26$var$f($8f74814242901c26$var$M($8f74814242901c26$var$Xs()), $8f74814242901c26$var$ee(n));
        this.cb = i, this.hv = new $8f74814242901c26$var$Xn(t, s, i), this.hv.mw().i((t)=>{
            this.lb.v() && this.lb.p(this.fb(t()));
        }, this), this.hv.ww().i((t)=>{
            this.ob.v() && this.ob.p(this.fb(t()));
        }, this), this.hv.Bd().i((t)=>{
            this._b.v() && this._b.p(this.fb(t()));
        }, this);
        const e = this.hv.Qt();
        this.pb = new $8f74814242901c26$var$se(e, this.hv.bM(), this.cb);
    }
    remove() {
        this.hv.mw().u(this), this.hv.ww().u(this), this.hv.Bd().u(this), this.pb.m(), this.hv.m(), this.hb.clear(), this.ab.clear(), this.lb.m(), this.ob.m(), this._b.m(), this.ub.m();
    }
    resize(t, i, n) {
        this.autoSizeActive() || this.hv.wM(t, i, n);
    }
    addCustomSeries(t, i = {}, n = 0) {
        const s = ((t)=>({
                type: "Custom",
                isBuiltIn: !1,
                defaultOptions: {
                    ...$8f74814242901c26$var$As,
                    ...t.defaultOptions()
                },
                mb: $8f74814242901c26$var$Ls,
                wb: t
            }))($8f74814242901c26$var$c(t));
        return this.Mb(s, i, n);
    }
    addSeries(t, i = {}, n = 0) {
        return this.Mb(t, i, n);
    }
    removeSeries(t) {
        const i = $8f74814242901c26$var$_(this.hb.get(t)), n = this.ub.if(i);
        this.hv.Qt().if(i), this.gb(n), this.hb.delete(t), this.ab.delete(i);
    }
    Jg(t, i) {
        this.gb(this.ub.og(t, i));
    }
    tb(t, i, n) {
        this.gb(this.ub.pg(t, i, n));
    }
    ib(t, i) {
        const [n, s] = this.ub.wg(t, i);
        return 0 !== n.length && this.gb(s), n;
    }
    subscribeClick(t) {
        this.lb.i(t);
    }
    unsubscribeClick(t) {
        this.lb._(t);
    }
    subscribeCrosshairMove(t) {
        this._b.i(t);
    }
    unsubscribeCrosshairMove(t) {
        this._b._(t);
    }
    subscribeDblClick(t) {
        this.ob.i(t);
    }
    unsubscribeDblClick(t) {
        this.ob._(t);
    }
    priceScale(t, i = 0) {
        return new $8f74814242901c26$var$Js(this.hv, t, i);
    }
    timeScale() {
        return this.pb;
    }
    applyOptions(t) {
        this.hv.vr($8f74814242901c26$var$ee(t));
    }
    options() {
        return this.hv.N();
    }
    takeScreenshot(t = !1, i = !1) {
        let n, s;
        try {
            i || (n = this.hv.Qt().N().crosshair.mode, this.hv.vr({
                crosshair: {
                    mode: 2
                }
            })), s = this.hv.TM(t);
        } finally{
            i || void 0 === n || this.hv.Qt().vr({
                crosshair: {
                    mode: n
                }
            });
        }
        return s;
    }
    addPane(t = !1) {
        const i = this.hv.Qt().uf();
        return i.j_(t), this.bb(i);
    }
    removePane(t) {
        this.hv.Qt().Ad(t);
    }
    swapPanes(t, i) {
        this.hv.Qt().zd(t, i);
    }
    autoSizeActive() {
        return this.hv.CM();
    }
    chartElement() {
        return this.hv.Mv();
    }
    panes() {
        return this.hv.Qt().Gn().map((t)=>this.bb(t));
    }
    paneSize(t = 0) {
        const i = this.hv.AM(t);
        return {
            height: i.height,
            width: i.width
        };
    }
    setCrosshairPosition(t, i, n) {
        const s = this.hb.get(n);
        if (void 0 === s) return;
        const e = this.hv.Qt().Ks(s);
        null !== e && this.hv.Qt().Gd(t, i, e);
    }
    clearCrosshairPosition() {
        this.hv.Qt().Zd(!0);
    }
    horzBehaviour() {
        return this.cb;
    }
    Mb(t, i = {}, n = 0) {
        $8f74814242901c26$var$o(void 0 !== t.mb), function(t) {
            if (void 0 === t || "custom" === t.type) return;
            const i = t;
            void 0 !== i.minMove && void 0 === i.precision && (i.precision = $8f74814242901c26$var$Yi(i.minMove));
        }(i.priceFormat), "Candlestick" === t.type && function(t) {
            void 0 !== t.borderColor && (t.borderUpColor = t.borderColor, t.borderDownColor = t.borderColor), void 0 !== t.wickColor && (t.wickUpColor = t.wickColor, t.wickDownColor = t.wickColor);
        }(i);
        const s = $8f74814242901c26$var$f($8f74814242901c26$var$M($8f74814242901c26$var$e), $8f74814242901c26$var$M(t.defaultOptions), i), r = t.mb, h = new $8f74814242901c26$var$Jt(this.hv.Qt(), t.type, s, r, t.wb);
        this.hv.Qt().Qd(h, n);
        const a = new $8f74814242901c26$var$ne(h, this, this, this, this.cb, (t)=>this.bb(t));
        return this.hb.set(a, h), this.ab.set(h, a), a;
    }
    gb(t) {
        const i = this.hv.Qt();
        for (const i of t.Y_.keys())i.Ia();
        i.Xd(t.Et.Dc, t.Et.Sg, t.Et.xg), t.Y_.forEach((t, i)=>i.ht(t.ue, t.bg)), i.Et().dc(), i.Lc();
    }
    Sb(t) {
        return $8f74814242901c26$var$_(this.ab.get(t));
    }
    xb(t) {
        return void 0 !== t && this.ab.has(t) ? this.Sb(t) : void 0;
    }
    fb(t) {
        const i = new Map;
        t.QM.forEach((t, n)=>{
            const s = n.bh(), e = $8f74814242901c26$var$$s(s)(t);
            if ("Custom" !== s) $8f74814242901c26$var$o($8f74814242901c26$var$ts(e));
            else {
                const t = n.cl();
                $8f74814242901c26$var$o(!t || !1 === t(e));
            }
            i.set(this.Sb(n), e);
        });
        const n = this.xb(t.jM), s = void 0 === t.YM ? void 0 : {
            type: t.YM.ds,
            sourceKind: t.YM.KM,
            objectKind: t.YM.GM,
            series: this.xb(t.YM.Y_),
            objectId: t.YM.ZM,
            paneIndex: t.YM.XM
        };
        return {
            time: t.Qr,
            logical: t.$n,
            point: t.JM,
            paneIndex: t.XM,
            hoveredInfo: s,
            hoveredSeries: n,
            hoveredObjectId: t.qM,
            seriesData: i,
            sourceEvent: t.tg
        };
    }
    bb(t) {
        let i = this.dd.get(t);
        return i || (i = new $8f74814242901c26$var$Qs(this.hv, (t)=>this.Sb(t), t, this), this.dd.set(t, i)), i;
    }
}
function $8f74814242901c26$var$he(t) {
    if ($8f74814242901c26$var$m(t)) {
        const i = document.getElementById(t);
        return $8f74814242901c26$var$o(null !== i, `Cannot find element in DOM with id=${t}`), i;
    }
    return t;
}
function $8f74814242901c26$export$8982e77ac5c107b4(t, i, n) {
    const s = $8f74814242901c26$var$he(t), e = new $8f74814242901c26$var$re(s, i, n);
    return i.setOptions(e.options()), e;
}
function $8f74814242901c26$export$c870ec99876cb45c(t, i) {
    return $8f74814242901c26$export$8982e77ac5c107b4(t, new $8f74814242901c26$var$cn, $8f74814242901c26$var$cn.Tf(i));
}
function $8f74814242901c26$export$cb3a039e5379c857() {
    return $8f74814242901c26$var$cn;
}
function $8f74814242901c26$var$_e(t, i, n, s) {
    return Math.hypot(n - t, s - i);
}
function $8f74814242901c26$var$ue(t, i, n, s, e, r, h, a = 0) {
    if (0 === i.length || s.from >= i.length || s.to <= 0) return;
    const { context: l, horizontalPixelRatio: o, verticalPixelRatio: _ } = t, u = i[s.from];
    let c = r(t, u), d = u;
    if (s.to - s.from < 2) {
        const i = e / 2;
        l.beginPath();
        const n = {
            _t: u._t - i,
            ut: u.ut
        }, s = {
            _t: u._t + i,
            ut: u.ut
        };
        l.moveTo(n._t * o, n.ut * _), l.lineTo(s._t * o, s.ut * _), h(t, c, n, s);
    } else {
        const e = a > 0;
        let f = 0;
        const p = (i, n)=>{
            if (h(t, c, d, n), l.beginPath(), c = i, d = n, e) {
                const t = f % a;
                l.lineDashOffset = t, f = t;
            }
        };
        let v = d;
        l.beginPath(), l.moveTo(u._t * o, u.ut * _);
        for(let h = s.from + 1; h < s.to; ++h){
            v = i[h];
            const s = v._t * o, a = v.ut * _, u = r(t, v);
            switch(n){
                case 0:
                    if (l.lineTo(s, a), e) {
                        const t = i[h - 1], n = t._t * o, e = t.ut * _;
                        f += $8f74814242901c26$var$_e(n, e, s, a);
                    }
                    break;
                case 1:
                    {
                        const t = i[h - 1], n = t.ut * _;
                        l.lineTo(s, n), e && (f += Math.abs(v._t - t._t) * o), u !== c && (p(u, v), l.lineTo(s, n)), l.lineTo(s, a), e && (f += Math.abs(v.ut - t.ut) * _);
                        break;
                    }
                case 2:
                    {
                        const [t, n] = $8f74814242901c26$var$pe(i, h - 1, h), r = t._t * o, u = t.ut * _, c = n._t * o, d = n.ut * _;
                        if (l.bezierCurveTo(r, u, c, d, s, a), e) {
                            const t = i[h - 1], n = t._t * o, e = t.ut * _, l = $8f74814242901c26$var$_e(n, e, s, a), p = $8f74814242901c26$var$_e(n, e, r, u) + $8f74814242901c26$var$_e(r, u, c, d) + $8f74814242901c26$var$_e(c, d, s, a);
                            f += (l + p) / 2;
                        }
                        break;
                    }
            }
            1 !== n && u !== c && (p(u, v), l.moveTo(s, a));
        }
        (d !== v || d === v && 1 === n) && h(t, c, d, v), e && (l.lineDashOffset = 0);
    }
}
const $8f74814242901c26$var$ce = 6;
function $8f74814242901c26$var$de(t, i) {
    return {
        _t: t._t - i._t,
        ut: t.ut - i.ut
    };
}
function $8f74814242901c26$var$fe(t, i) {
    return {
        _t: t._t / i,
        ut: t.ut / i
    };
}
function $8f74814242901c26$var$pe(t, i, n) {
    const s = Math.max(0, i - 1), e = Math.min(t.length - 1, n + 1);
    var r, h;
    return [
        (r = t[i], h = $8f74814242901c26$var$fe($8f74814242901c26$var$de(t[n], t[s]), $8f74814242901c26$var$ce), {
            _t: r._t + h._t,
            ut: r.ut + h.ut
        }),
        $8f74814242901c26$var$de(t[n], $8f74814242901c26$var$fe($8f74814242901c26$var$de(t[e], t[i]), $8f74814242901c26$var$ce))
    ];
}
function $8f74814242901c26$var$ve(t, i) {
    const n = t.context;
    n.strokeStyle = i, n.stroke();
}
class $8f74814242901c26$var$me extends $8f74814242901c26$var$R {
    constructor(){
        super(...arguments), this.rt = null;
    }
    ht(t) {
        this.rt = t;
    }
    et(t) {
        if (null === this.rt) return;
        const { ot: i, lt: n, Cb: s, yb: e, ct: r, Gt: h, Pb: l } = this.rt;
        if (null === n) return;
        const o = t.context;
        o.lineCap = "butt", o.lineWidth = r * t.verticalPixelRatio;
        const _ = $8f74814242901c26$var$a(o, h);
        o.lineJoin = "round";
        const u = this.kb.bind(this), c = function(t) {
            return t.reduce((t, i)=>t + i, 0);
        }(_);
        void 0 !== e && $8f74814242901c26$var$ue(t, i, e, n, s, u, $8f74814242901c26$var$ve, c), l && function(t, i, n, s, e) {
            if (s.to - s.from <= 0) return;
            const { horizontalPixelRatio: r, verticalPixelRatio: h, context: a } = t;
            let l = null;
            const o = Math.max(1, Math.floor(r)) % 2 / 2, _ = n * h + o;
            for(let n = s.to - 1; n >= s.from; --n){
                const s = i[n];
                if (s) {
                    const i = e(t, s);
                    i !== l && (null !== l && a.fill(), a.beginPath(), a.fillStyle = i, l = i);
                    const n = Math.round(s._t * r) + o, u = s.ut * h;
                    a.moveTo(n, u), a.arc(n, u, _, 0, 2 * Math.PI);
                }
            }
            a.fill();
        }(t, i, l, n, u);
    }
}
class $8f74814242901c26$var$we extends $8f74814242901c26$var$me {
    kb(t, i) {
        return i.vt;
    }
}
function $8f74814242901c26$var$Me(t, i, n, s, e) {
    const r = 1 - e;
    return r * r * r * t + 3 * r * r * e * i + 3 * r * e * e * n + e * e * e * s;
}
function $8f74814242901c26$var$ge(t, i, n, s, e) {
    if (2 === n) {
        const [n, r] = $8f74814242901c26$var$pe(s, e - 1, e);
        return [
            Math.min(t._t, i._t, n._t, r._t),
            Math.max(t._t, i._t, n._t, r._t)
        ];
    }
    return [
        Math.min(t._t, i._t),
        Math.max(t._t, i._t)
    ];
}
function $8f74814242901c26$var$be(t, i, n, s, e, r, h, a) {
    switch(e){
        case 1:
            {
                const e = $8f74814242901c26$var$Ss(t, i, n._t, n.ut, s._t, n.ut), r = $8f74814242901c26$var$Ss(t, i, s._t, n.ut, s._t, s.ut), h = Math.min(e, r);
                return h <= a ? h : null;
            }
        case 2:
            {
                const [e, l] = $8f74814242901c26$var$pe(r, h - 1, h), o = function(t, i, n) {
                    let s = Number.POSITIVE_INFINITY, e = n[0];
                    for(let r = 1; r <= 12; r++){
                        const h = r / 12, a = {
                            _t: $8f74814242901c26$var$Me(n[0]._t, n[1]._t, n[2]._t, n[3]._t, h),
                            ut: $8f74814242901c26$var$Me(n[0].ut, n[1].ut, n[2].ut, n[3].ut, h)
                        };
                        s = Math.min(s, $8f74814242901c26$var$Ss(t, i, e._t, e.ut, a._t, a.ut)), e = a;
                    }
                    return s;
                }(t, i, [
                    n,
                    e,
                    l,
                    s
                ]);
                return o <= a ? o : null;
            }
        default:
            {
                const e = $8f74814242901c26$var$Ss(t, i, n._t, n.ut, s._t, s.ut);
                return e <= a ? e : null;
            }
    }
}
class $8f74814242901c26$var$Se extends $8f74814242901c26$var$Ds {
    constructor(t, i){
        super(t, i, !0);
    }
    Og(t, i, n) {
        i.Ic(this.kg, $8f74814242901c26$var$b(this.Tg)), t.Jo(this.kg, n, $8f74814242901c26$var$b(this.Tg));
    }
    Tb(t, i) {
        return {
            wt: t,
            Mt: i,
            _t: NaN,
            ut: NaN
        };
    }
    Lg() {
        const t = this.ae.Sa();
        this.kg = this.ae.Ua().Bh().map((i)=>{
            let n;
            if ((i.Gr ?? 1) > 1) {
                const t = i.Wt[1], s = i.Wt[2], e = i.Wt[3];
                n = Math.abs(t - e) > Math.abs(s - e) ? t : s;
            } else n = i.Wt[3];
            return this.Rb(i.$n, n, t);
        });
    }
}
class $8f74814242901c26$var$xe extends $8f74814242901c26$var$Se {
    Bg(t, i) {
        const n = this.ae.N();
        return function(t, i, n, s, e, r, h, a = 0, l = 0) {
            if (null === i || i.from >= i.to || 0 === t.length) return null;
            const o = Math.max(r / 2, h ?? 0) + l;
            let _ = Number.POSITIVE_INFINITY;
            if (void 0 !== h) {
                const e = h + l, r = $8f74814242901c26$var$ws(t, n - e, i.from, i.to), a = $8f74814242901c26$var$Ms(t, n + e, r, i.to);
                for(let i = r; i < a; i++){
                    const e = t[i];
                    if (!$8f74814242901c26$var$bs(n, e._t, e._t, h + l)) continue;
                    const r = Math.hypot(n - e._t, s - e.ut);
                    r <= h + l && (_ = Math.min(_, r));
                }
            }
            if (i.to - i.from < 2) {
                const e = t[i.from], r = Math.max(a / 2, o), h = $8f74814242901c26$var$Ss(n, s, e._t - r, e.ut, e._t + r, e.ut);
                return h <= o && (_ = Math.min(_, h)), Number.isFinite(_) ? $8f74814242901c26$var$gs(_, 2, "series-point") : null;
            }
            let u = Number.POSITIVE_INFINITY;
            const c = $8f74814242901c26$var$ws(t, n - o, i.from, i.to), d = $8f74814242901c26$var$Ms(t, n + o, c, i.to), f = Math.max(i.from + 1, c), p = Math.min(i.to, d + 1);
            for(let i = f; i < p; i++){
                const r = t[i - 1], h = t[i], [a, l] = $8f74814242901c26$var$ge(r, h, e, t, i);
                if (!$8f74814242901c26$var$bs(n, a, l, o)) continue;
                const _ = $8f74814242901c26$var$be(n, s, r, h, e, t, i, o);
                null !== _ && (u = Math.min(u, _));
            }
            return Number.isFinite(_) ? $8f74814242901c26$var$gs(_, 2, "series-point") : Number.isFinite(u) ? $8f74814242901c26$var$gs(u, 1, "series-line") : null;
        }(this.kg, this.Tg, t, i, n.lineType, n.lineVisible ? n.lineWidth : 1, n.pointMarkersVisible ? n.pointMarkersRadius || n.lineWidth / 2 + 2 : void 0, this.le.Et().ml(), n.hitTestTolerance);
    }
}
class $8f74814242901c26$var$Ce extends $8f74814242901c26$var$xe {
    constructor(){
        super(...arguments), this.Vg = new $8f74814242901c26$var$we;
    }
    Rb(t, i, n) {
        return {
            ...this.Tb(t, i),
            ...n.Sh(t)
        };
    }
    Ng() {
        const t = this.ae.N(), i = {
            ot: this.kg,
            Gt: t.lineStyle,
            yb: t.lineVisible ? t.lineType : void 0,
            ct: t.lineWidth,
            Pb: t.pointMarkersVisible ? t.pointMarkersRadius || t.lineWidth / 2 + 2 : void 0,
            lt: this.Tg,
            Cb: this.le.Et().ml()
        };
        this.Vg.ht(i);
    }
}
const $8f74814242901c26$export$29b04ebffc4f4705 = {
    type: "Line",
    isBuiltIn: !0,
    defaultOptions: {
        color: "#2196f3",
        lineStyle: 0,
        lineWidth: 3,
        lineType: 0,
        lineVisible: !0,
        crosshairMarkerVisible: !0,
        crosshairMarkerRadius: 4,
        crosshairMarkerBorderColor: "",
        crosshairMarkerBorderWidth: 2,
        crosshairMarkerBackgroundColor: "",
        lastPriceAnimation: 0,
        pointMarkersVisible: !1
    },
    mb: (t, i)=>new $8f74814242901c26$var$Ce(t, i)
};
function $8f74814242901c26$var$Pe(t, i) {
    return t.weight > i.weight ? t : i;
}
class $8f74814242901c26$var$ke {
    constructor(){
        this.Db = new $8f74814242901c26$var$d, this.Ib = function(t) {
            let i = !1;
            return function(...n) {
                i || (i = !0, queueMicrotask(()=>{
                    t(...n), i = !1;
                }));
            };
        }(()=>this.Db.p(this.Vb)), this.Vb = 0;
    }
    Bb() {
        return this.Db;
    }
    m() {
        this.Db.m();
    }
    options() {
        return this.yn;
    }
    setOptions(t) {
        this.yn = t;
    }
    preprocessData(t) {}
    updateFormatter(t) {
        this.yn && (this.yn.localization = t);
    }
    createConverterToInternalObj(t) {
        return this.Ib(), (t)=>(t > this.Vb && (this.Vb = t), t);
    }
    key(t) {
        return t;
    }
    cacheKey(t) {
        return t;
    }
    convertHorzItemToInternal(t) {
        return t;
    }
    formatHorzItem(t) {
        return this.Eb(t);
    }
    formatTickmark(t) {
        return this.Eb(t.time);
    }
    maxTickMarkWeight(t) {
        return t.reduce($8f74814242901c26$var$Pe, t[0]).weight;
    }
    fillWeightsForPoints(t, i) {
        for(let s = i; s < t.length; ++s)t[s].timeWeight = (n = t[s].time) % 120 == 0 ? 10 : n % 60 == 0 ? 9 : n % 36 == 0 ? 8 : n % 12 == 0 ? 7 : n % 6 == 0 ? 6 : n % 3 == 0 ? 5 : n % 1 == 0 ? 4 : 0;
        var n;
        this.Vb = t[t.length - 1].time, this.Ib();
    }
    Eb(t) {
        if (this.yn.localization?.timeFormatter) return this.yn.localization.timeFormatter(t);
        if (t < 12) return `${t}M`;
        const i = Math.floor(t / 12), n = t % 12;
        return 0 === n ? `${i}Y` : `${i}Y${n}M`;
    }
}
const $8f74814242901c26$var$Te = {
    yieldCurve: {
        baseResolution: 1,
        minimumTimeRange: 120,
        startTimeRange: 0
    },
    timeScale: {
        ignoreWhitespaceIndices: !0
    },
    leftPriceScale: {
        visible: !0
    },
    rightPriceScale: {
        visible: !1
    },
    localization: {
        priceFormatter: (t)=>t.toFixed(3) + "%"
    }
}, $8f74814242901c26$var$Re = {
    lastValueVisible: !1,
    priceLineVisible: !1
};
class $8f74814242901c26$var$De extends $8f74814242901c26$var$re {
    constructor(t, i){
        const n = $8f74814242901c26$var$f($8f74814242901c26$var$Te, i || {}), s = new $8f74814242901c26$var$ke;
        super(t, s, n), s.setOptions(this.options()), this._initWhitespaceSeries();
    }
    addSeries(t, i = {}, n = 0) {
        if (t.isBuiltIn && !1 === [
            "Area",
            "Line"
        ].includes(t.type)) throw new Error("Yield curve only support Area and Line series");
        const s = {
            ...$8f74814242901c26$var$Re,
            ...i
        };
        return super.addSeries(t, s, n);
    }
    _initWhitespaceSeries() {
        const t = this.horzBehaviour(), i = this.addSeries($8f74814242901c26$export$29b04ebffc4f4705);
        let n;
        function s(s) {
            const e = function(t, i) {
                return {
                    me: Math.max(0, t.startTimeRange),
                    we: Math.max(0, t.minimumTimeRange, i || 0),
                    Ab: Math.max(1, t.baseResolution)
                };
            }(t.options().yieldCurve, s), r = (({ me: t, we: i, Ab: n })=>`${t}~${i}~${n}`)(e);
            r !== n && (n = r, i.setData(function({ me: t, we: i, Ab: n }) {
                return Array.from({
                    length: Math.floor((i - t) / n) + 1
                }, (i, s)=>({
                        time: t + s * n
                    }));
            }(e)));
        }
        s(0), t.Bb().i(s);
    }
}
function $8f74814242901c26$export$2ac108d26dcfda4e(t, i) {
    const n = $8f74814242901c26$var$he(t);
    return new $8f74814242901c26$var$De(n, i);
}
function $8f74814242901c26$var$Ve(t, i) {
    return t.weight > i.weight ? t : i;
}
class $8f74814242901c26$var$Be {
    options() {
        return this.yn;
    }
    setOptions(t) {
        this.yn = t;
    }
    preprocessData(t) {}
    updateFormatter(t) {
        this.yn && (this.yn.localization = t);
    }
    createConverterToInternalObj(t) {
        return (t)=>t;
    }
    key(t) {
        return t;
    }
    cacheKey(t) {
        return t;
    }
    convertHorzItemToInternal(t) {
        return t;
    }
    formatHorzItem(t) {
        return t.toFixed(this.Ds());
    }
    formatTickmark(t, i) {
        return t.time.toFixed(this.Ds());
    }
    maxTickMarkWeight(t) {
        return t.reduce($8f74814242901c26$var$Ve, t[0]).weight;
    }
    fillWeightsForPoints(t, i) {
        for(let s = i; s < t.length; ++s)t[s].timeWeight = (n = t[s].time) === 100 * Math.ceil(n / 100) ? 8 : n === 50 * Math.ceil(n / 50) ? 7 : n === 25 * Math.ceil(n / 25) ? 6 : n === 10 * Math.ceil(n / 10) ? 5 : n === 5 * Math.ceil(n / 5) ? 4 : n === Math.ceil(n) ? 3 : 2 * n === Math.ceil(2 * n) ? 1 : 0;
        var n;
    }
    Ds() {
        return this.yn.localization.precision;
    }
}
function $8f74814242901c26$export$e0948170eca90879(t, i) {
    return $8f74814242901c26$export$8982e77ac5c107b4(t, new $8f74814242901c26$var$Be, i);
}
function $8f74814242901c26$var$Ae(t, i, n, s, e) {
    const { context: r, horizontalPixelRatio: h, verticalPixelRatio: a } = i;
    r.lineTo(e._t * h, t * a), r.lineTo(s._t * h, t * a), r.closePath(), r.fillStyle = n, r.fill();
}
class $8f74814242901c26$var$Le extends $8f74814242901c26$var$R {
    constructor(){
        super(...arguments), this.rt = null;
    }
    ht(t) {
        this.rt = t;
    }
    et(t) {
        if (null === this.rt) return;
        const { ot: i, lt: n, Cb: s, ct: e, Gt: r, yb: h } = this.rt, l = this.rt.Lb ?? (this.rt.zb ? 0 : t.mediaSize.height);
        if (null === n) return;
        const o = t.context;
        o.lineCap = "butt", o.lineJoin = "round", o.lineWidth = e, $8f74814242901c26$var$a(o, r), o.lineWidth = 1, $8f74814242901c26$var$ue(t, i, h, n, s, this.Ob.bind(this), $8f74814242901c26$var$Ae.bind(null, l));
    }
}
class $8f74814242901c26$var$ze {
    Nb(t, i) {
        const n = this.Fb, { Wb: s, Hb: e, Ub: r, $b: h, Lb: a, jb: l, qb: o } = i;
        if (void 0 === this.Yb || void 0 === n || n.Wb !== s || n.Hb !== e || n.Ub !== r || n.$b !== h || n.Lb !== a || n.jb !== l || n.qb !== o) {
            const { verticalPixelRatio: n } = t, _ = a || l > 0 ? n : 1, u = l * _, c = o === t.bitmapSize.height ? o : o * _, d = (a ?? 0) * _, f = t.context.createLinearGradient(0, u, 0, c);
            if (f.addColorStop(0, s), null != a) {
                const t = $8f74814242901c26$var$ni((d - u) / (c - u), 0, 1);
                f.addColorStop(t, e), f.addColorStop(t, r);
            }
            f.addColorStop(1, h), this.Yb = f, this.Fb = i;
        }
        return this.Yb;
    }
}
class $8f74814242901c26$var$Oe extends $8f74814242901c26$var$Le {
    constructor(){
        super(...arguments), this.Kb = new $8f74814242901c26$var$ze;
    }
    Ob(t, i) {
        const n = this.rt;
        return this.Kb.Nb(t, {
            Wb: i.dh,
            Hb: i.fh,
            Ub: i.ph,
            $b: i.mh,
            Lb: n.Lb,
            jb: n.jb ?? 0,
            qb: n.qb ?? t.bitmapSize.height
        });
    }
}
class $8f74814242901c26$var$Ne extends $8f74814242901c26$var$me {
    constructor(){
        super(...arguments), this.Gb = new $8f74814242901c26$var$ze;
    }
    kb(t, i) {
        const n = this.rt;
        return this.Gb.Nb(t, {
            Wb: i._h,
            Hb: i._h,
            Ub: i.uh,
            $b: i.uh,
            Lb: n.Lb,
            jb: n.jb ?? 0,
            qb: n.qb ?? t.bitmapSize.height
        });
    }
}
class $8f74814242901c26$var$Fe {
    constructor(t, i, n, s){
        this.Zb = t, this.Xb = i, this.Jb = n, this.Qb = s;
    }
    st(t, i, n) {
        this.Zb.st(t, i, n), !this.Jb() || i && this.Qb() || this.Xb.st(t, i, n);
    }
}
class $8f74814242901c26$var$We {
    constructor(t, i){
        this.Xb = t, this.tS = i;
    }
    Tt() {
        return this.tS() ? this.Xb : null;
    }
}
class $8f74814242901c26$var$He extends $8f74814242901c26$var$xe {
    constructor(t, i){
        super(t, i), this.iS = new $8f74814242901c26$var$Oe, this.nS = new $8f74814242901c26$var$Ne, this.sS = new $8f74814242901c26$var$We(this.nS, ()=>this.Jb()), this.eS = [
            this
        ], this.rS = [
            this.sS
        ], this.hS = {
            Za: this.eS,
            qa: this.rS
        }, this.Vg = new $8f74814242901c26$var$Fe(this.iS, this.nS, ()=>this.Jb(), ()=>this.le.N().hoveredSeriesOnTop);
    }
    Ga() {
        return this.hS;
    }
    Rb(t, i, n) {
        return {
            ...this.Tb(t, i),
            ...n.Sh(t)
        };
    }
    Ng() {
        const t = this.ae.Lt();
        if (null === t) return;
        const i = this.ae.N(), n = this.ae.Ft().Nt(i.baseValue.price, t.Wt), s = this.le.Et().ml();
        if (null === this.Tg || 0 === this.kg.length) return;
        let e, r;
        if (i.relativeGradient) {
            e = this.kg[this.Tg.from].ut, r = this.kg[this.Tg.from].ut;
            for(let t = this.Tg.from; t < this.Tg.to; t++){
                const i = this.kg[t];
                i.ut < e && (e = i.ut), i.ut > r && (r = i.ut);
            }
        }
        this.iS.ht({
            ot: this.kg,
            ct: i.lineWidth,
            Gt: i.lineStyle,
            yb: i.lineType,
            Lb: n,
            jb: e,
            qb: r,
            zb: !1,
            lt: this.Tg,
            Cb: s
        }), this.nS.ht({
            ot: this.kg,
            ct: i.lineWidth,
            Gt: i.lineStyle,
            yb: i.lineVisible ? i.lineType : void 0,
            Pb: i.pointMarkersVisible ? i.pointMarkersRadius || i.lineWidth / 2 + 2 : void 0,
            Lb: n,
            jb: e,
            qb: r,
            lt: this.Tg,
            Cb: s
        });
    }
    Jb() {
        return this.ae.It() && null !== this.Tg && this.aS();
    }
    aS() {
        const t = this.ae.N();
        return t.lineVisible || t.pointMarkersVisible;
    }
}
const $8f74814242901c26$export$7280a543172f8f3a = {
    type: "Baseline",
    isBuiltIn: !0,
    defaultOptions: {
        baseValue: {
            type: "price",
            price: 0
        },
        relativeGradient: !1,
        topFillColor1: "rgba(38, 166, 154, 0.28)",
        topFillColor2: "rgba(38, 166, 154, 0.05)",
        topLineColor: "rgba(38, 166, 154, 1)",
        bottomFillColor1: "rgba(239, 83, 80, 0.05)",
        bottomFillColor2: "rgba(239, 83, 80, 0.28)",
        bottomLineColor: "rgba(239, 83, 80, 1)",
        lineWidth: 3,
        lineStyle: 0,
        lineType: 0,
        lineVisible: !0,
        crosshairMarkerVisible: !0,
        crosshairMarkerRadius: 4,
        crosshairMarkerBorderColor: "",
        crosshairMarkerBorderWidth: 2,
        crosshairMarkerBackgroundColor: "",
        lastPriceAnimation: 0,
        pointMarkersVisible: !1
    },
    mb: (t, i)=>new $8f74814242901c26$var$He(t, i)
};
class $8f74814242901c26$var$$e extends $8f74814242901c26$var$Le {
    constructor(){
        super(...arguments), this.Kb = new $8f74814242901c26$var$ze;
    }
    Ob(t, i) {
        return this.Kb.Nb(t, {
            Wb: i.ah,
            Hb: "",
            Ub: "",
            $b: i.oh,
            jb: this.rt?.jb ?? 0,
            qb: t.bitmapSize.height
        });
    }
}
class $8f74814242901c26$var$je extends $8f74814242901c26$var$xe {
    constructor(t, i){
        super(t, i), this.lS = new $8f74814242901c26$var$$e, this.Xb = new $8f74814242901c26$var$we, this.sS = new $8f74814242901c26$var$We(this.Xb, ()=>this.Jb()), this.eS = [
            this
        ], this.rS = [
            this.sS
        ], this.hS = {
            Za: this.eS,
            qa: this.rS
        }, this.Vg = new $8f74814242901c26$var$Fe(this.lS, this.Xb, ()=>this.Jb(), ()=>this.le.N().hoveredSeriesOnTop);
    }
    Ga() {
        return this.hS;
    }
    Rb(t, i, n) {
        return {
            ...this.Tb(t, i),
            ...n.Sh(t)
        };
    }
    Ng() {
        const t = this.ae.N();
        if (null === this.Tg || 0 === this.kg.length) return;
        let i;
        if (t.relativeGradient) {
            i = this.kg[this.Tg.from].ut;
            for(let t = this.Tg.from; t < this.Tg.to; t++){
                const n = this.kg[t];
                n.ut < i && (i = n.ut);
            }
        }
        this.lS.ht({
            yb: t.lineType,
            ot: this.kg,
            Gt: t.lineStyle,
            ct: t.lineWidth,
            Lb: null,
            jb: i,
            zb: t.invertFilledArea,
            lt: this.Tg,
            Cb: this.le.Et().ml()
        }), this.Xb.ht({
            yb: t.lineVisible ? t.lineType : void 0,
            ot: this.kg,
            Gt: t.lineStyle,
            ct: t.lineWidth,
            lt: this.Tg,
            Cb: this.le.Et().ml(),
            Pb: t.pointMarkersVisible ? t.pointMarkersRadius || t.lineWidth / 2 + 2 : void 0
        });
    }
    Jb() {
        return this.ae.It() && null !== this.Tg && this.aS();
    }
    aS() {
        const t = this.ae.N();
        return t.lineVisible || t.pointMarkersVisible;
    }
}
const $8f74814242901c26$export$1d34d22a4e55a2c5 = {
    type: "Area",
    isBuiltIn: !0,
    defaultOptions: {
        topColor: "rgba( 46, 220, 135, 0.4)",
        bottomColor: "rgba( 40, 221, 100, 0)",
        invertFilledArea: !1,
        relativeGradient: !1,
        lineColor: "#33D778",
        lineStyle: 0,
        lineWidth: 3,
        lineType: 0,
        lineVisible: !0,
        crosshairMarkerVisible: !0,
        crosshairMarkerRadius: 4,
        crosshairMarkerBorderColor: "",
        crosshairMarkerBorderWidth: 2,
        crosshairMarkerBackgroundColor: "",
        lastPriceAnimation: 0,
        pointMarkersVisible: !1
    },
    mb: (t, i)=>new $8f74814242901c26$var$je(t, i)
};
class $8f74814242901c26$var$Ye extends $8f74814242901c26$var$R {
    constructor(){
        super(...arguments), this.qt = null, this.oS = 0, this._S = 0;
    }
    ht(t) {
        this.qt = t;
    }
    et({ context: t, horizontalPixelRatio: i, verticalPixelRatio: n }) {
        if (null === this.qt || 0 === this.qt.Un.length || null === this.qt.lt) return;
        if (this.oS = this.uS(i), this.oS >= 2) Math.max(1, Math.floor(i)) % 2 != this.oS % 2 && this.oS--;
        this._S = this.qt.cS ? Math.min(this.oS, Math.floor(i)) : this.oS;
        let s = null;
        const e = this._S <= this.oS && this.qt.ml >= Math.floor(1.5 * i);
        for(let r = this.qt.lt.from; r < this.qt.lt.to; ++r){
            const h = this.qt.Un[r];
            s !== h.sh && (t.fillStyle = h.sh, s = h.sh);
            const a = Math.floor(.5 * this._S), l = Math.round(h._t * i), o = l - a, _ = this._S, u = o + _ - 1, c = Math.min(h.n_, h.s_), d = Math.max(h.n_, h.s_), f = Math.round(c * n) - a, p = Math.round(d * n) + a, v = Math.max(p - f, this._S);
            t.fillRect(o, f, _, v);
            const m = Math.ceil(1.5 * this.oS);
            if (e) {
                if (this.qt.dS) {
                    const i = l - m;
                    let s = Math.max(f, Math.round(h.i_ * n) - a), e = s + _ - 1;
                    e > f + v - 1 && (e = f + v - 1, s = e - _ + 1), t.fillRect(i, s, o - i, e - s + 1);
                }
                const i = l + m;
                let s = Math.max(f, Math.round(h.e_ * n) - a), e = s + _ - 1;
                e > f + v - 1 && (e = f + v - 1, s = e - _ + 1), t.fillRect(u + 1, s, i - u, e - s + 1);
            }
        }
    }
    uS(t) {
        const i = Math.floor(t);
        return Math.max(i, Math.floor(function(t, i) {
            return Math.floor(.3 * t * i);
        }($8f74814242901c26$var$u(this.qt).ml, t)));
    }
}
class $8f74814242901c26$var$Ke extends $8f74814242901c26$var$Ds {
    constructor(t, i){
        super(t, i, !1);
    }
    Bg(t, i) {
        return $8f74814242901c26$var$Ps(this.kg, this.Tg, t, i, this.le.Et().ml(), this.ae.N().hitTestTolerance, (t, i)=>{
            i[0] = t.n_, i[1] = t.s_;
        });
    }
    Og(t, i, n) {
        i.Ic(this.kg, $8f74814242901c26$var$b(this.Tg)), t.t_(this.kg, n, $8f74814242901c26$var$b(this.Tg));
    }
    fS(t, i, n) {
        return {
            wt: t,
            jr: i.Wt[0],
            qr: i.Wt[1],
            Yr: i.Wt[2],
            Kr: i.Wt[3],
            _t: NaN,
            i_: NaN,
            n_: NaN,
            s_: NaN,
            e_: NaN
        };
    }
    Lg() {
        const t = this.ae.Sa();
        this.kg = this.ae.Ua().Bh().map((i)=>this.Rb(i.$n, i, t));
    }
}
class $8f74814242901c26$var$Ge extends $8f74814242901c26$var$Ke {
    constructor(){
        super(...arguments), this.Vg = new $8f74814242901c26$var$Ye;
    }
    Rb(t, i, n) {
        return {
            ...this.fS(t, i, n),
            ...n.Sh(t)
        };
    }
    Ng() {
        const t = this.ae.N();
        this.Vg.ht({
            Un: this.kg,
            ml: this.le.Et().ml(),
            dS: t.openVisible,
            cS: t.thinBars,
            lt: this.Tg
        });
    }
}
const $8f74814242901c26$export$2db55af16212ab81 = {
    type: "Bar",
    isBuiltIn: !0,
    defaultOptions: {
        upColor: "#26a69a",
        downColor: "#ef5350",
        openVisible: !0,
        thinBars: !0
    },
    mb: (t, i)=>new $8f74814242901c26$var$Ge(t, i)
};
class $8f74814242901c26$var$Xe extends $8f74814242901c26$var$R {
    constructor(){
        super(...arguments), this.qt = null, this.oS = 0;
    }
    ht(t) {
        this.qt = t;
    }
    et(t) {
        if (null === this.qt || 0 === this.qt.Un.length || null === this.qt.lt) return;
        const { horizontalPixelRatio: i } = t;
        if (this.oS = function(t, i) {
            if (t >= 2.5 && t <= 4) return Math.floor(3 * i);
            const n = 1 - .2 * Math.atan(Math.max(4, t) - 4) / (.5 * Math.PI), s = Math.floor(t * n * i), e = Math.floor(t * i), r = Math.min(s, e);
            return Math.max(Math.floor(i), r);
        }(this.qt.ml, i), this.oS >= 2) Math.floor(i) % 2 != this.oS % 2 && this.oS--;
        const n = this.qt.Un;
        this.qt.pS && this.vS(t, n, this.qt.lt), this.qt.gi && this.Vm(t, n, this.qt.lt);
        const s = this.mS(i);
        (!this.qt.gi || this.oS > 2 * s) && this.wS(t, n, this.qt.lt);
    }
    vS(t, i, n) {
        if (null === this.qt) return;
        const { context: s, horizontalPixelRatio: e, verticalPixelRatio: r } = t;
        let h = "", a = Math.min(Math.floor(e), Math.floor(this.qt.ml * e));
        a = Math.max(Math.floor(e), Math.min(a, this.oS));
        const l = Math.floor(.5 * a);
        let o = null;
        for(let t = n.from; t < n.to; t++){
            const n = i[t];
            n.rh !== h && (s.fillStyle = n.rh, h = n.rh);
            const _ = Math.round(Math.min(n.i_, n.e_) * r), u = Math.round(Math.max(n.i_, n.e_) * r), c = Math.round(n.n_ * r), d = Math.round(n.s_ * r);
            let f = Math.round(e * n._t) - l;
            const p = f + a - 1;
            null !== o && (f = Math.max(o + 1, f), f = Math.min(f, p));
            const v = p - f + 1;
            s.fillRect(f, c, v, _ - c), s.fillRect(f, u + 1, v, d - u), o = p;
        }
    }
    mS(t) {
        let i = Math.floor(1 * t);
        this.oS <= 2 * i && (i = Math.floor(.5 * (this.oS - 1)));
        const n = Math.max(Math.floor(t), i);
        return this.oS <= 2 * n ? Math.max(Math.floor(t), Math.floor(1 * t)) : n;
    }
    Vm(t, i, n) {
        if (null === this.qt) return;
        const { context: s, horizontalPixelRatio: e, verticalPixelRatio: r } = t;
        let h = "";
        const a = this.mS(e);
        let l = null;
        for(let t = n.from; t < n.to; t++){
            const n = i[t];
            n.eh !== h && (s.fillStyle = n.eh, h = n.eh);
            let o = Math.round(n._t * e) - Math.floor(.5 * this.oS);
            const _ = o + this.oS - 1, u = Math.round(Math.min(n.i_, n.e_) * r), c = Math.round(Math.max(n.i_, n.e_) * r);
            if (null !== l && (o = Math.max(l + 1, o), o = Math.min(o, _)), this.qt.ml * e > 2 * a) $8f74814242901c26$var$L(s, o, u, _ - o + 1, c - u + 1, a);
            else {
                const t = _ - o + 1;
                s.fillRect(o, u, t, c - u + 1);
            }
            l = _;
        }
    }
    wS(t, i, n) {
        if (null === this.qt) return;
        const { context: s, horizontalPixelRatio: e, verticalPixelRatio: r } = t;
        let h = "";
        const a = this.mS(e);
        for(let t = n.from; t < n.to; t++){
            const n = i[t];
            let l = Math.round(Math.min(n.i_, n.e_) * r), o = Math.round(Math.max(n.i_, n.e_) * r), _ = Math.round(n._t * e) - Math.floor(.5 * this.oS), u = _ + this.oS - 1;
            if (n.sh !== h) {
                const t = n.sh;
                s.fillStyle = t, h = t;
            }
            this.qt.gi && (_ += a, l += a, u -= a, o -= a), l > o || s.fillRect(_, l, u - _ + 1, o - l + 1);
        }
    }
}
class $8f74814242901c26$var$Je extends $8f74814242901c26$var$Ke {
    constructor(){
        super(...arguments), this.Vg = new $8f74814242901c26$var$Xe;
    }
    Rb(t, i, n) {
        return {
            ...this.fS(t, i, n),
            ...n.Sh(t)
        };
    }
    Ng() {
        const t = this.ae.N();
        this.Vg.ht({
            Un: this.kg,
            ml: this.le.Et().ml(),
            pS: t.wickVisible,
            gi: t.borderVisible,
            lt: this.Tg
        });
    }
}
const $8f74814242901c26$export$9bff15f5cdf5e23d = {
    type: "Candlestick",
    isBuiltIn: !0,
    defaultOptions: {
        upColor: "#26a69a",
        downColor: "#ef5350",
        wickVisible: !0,
        borderVisible: !0,
        borderColor: "#378658",
        borderUpColor: "#26a69a",
        borderDownColor: "#ef5350",
        wickColor: "#737375",
        wickUpColor: "#26a69a",
        wickDownColor: "#ef5350"
    },
    mb: (t, i)=>new $8f74814242901c26$var$Je(t, i)
};
class $8f74814242901c26$var$tr extends $8f74814242901c26$var$R {
    constructor(){
        super(...arguments), this.qt = null, this.MS = [];
    }
    ht(t) {
        this.qt = t, this.MS = [];
    }
    et({ context: t, horizontalPixelRatio: i, verticalPixelRatio: n }) {
        if (null === this.qt || 0 === this.qt.ot.length || null === this.qt.lt) return;
        this.MS.length || this.gS(i);
        const s = Math.max(1, Math.floor(n)), e = Math.round(this.qt.bS * n) - Math.floor(s / 2), r = e + s;
        for(let i = this.qt.lt.from; i < this.qt.lt.to; i++){
            const h = this.qt.ot[i], a = this.MS[i - this.qt.lt.from], l = Math.round(h.ut * n);
            let o, _;
            t.fillStyle = h.sh, l <= e ? (o = l, _ = r) : (o = e, _ = l - Math.floor(s / 2) + s), t.fillRect(a.Na, o, a.bi - a.Na + 1, _ - o);
        }
    }
    gS(t) {
        if (null === this.qt || 0 === this.qt.ot.length || null === this.qt.lt) return void (this.MS = []);
        const i = Math.ceil(this.qt.ml * t) <= 1 ? 0 : Math.max(1, Math.floor(t)), n = Math.round(this.qt.ml * t) - i;
        this.MS = new Array(this.qt.lt.to - this.qt.lt.from);
        for(let i = this.qt.lt.from; i < this.qt.lt.to; i++){
            const s = this.qt.ot[i], e = Math.round(s._t * t);
            let r, h;
            if (n % 2) {
                const t = (n - 1) / 2;
                r = e - t, h = e + t;
            } else {
                const t = n / 2;
                r = e - t, h = e + t - 1;
            }
            this.MS[i - this.qt.lt.from] = {
                Na: r,
                bi: h,
                SS: e,
                ce: s._t * t,
                wt: s.wt
            };
        }
        for(let t = this.qt.lt.from + 1; t < this.qt.lt.to; t++){
            const n = this.MS[t - this.qt.lt.from], s = this.MS[t - this.qt.lt.from - 1];
            n.wt === s.wt + 1 && n.Na - s.bi !== i + 1 && (s.SS > s.ce ? s.bi = n.Na - i - 1 : n.Na = s.bi + i + 1);
        }
        let s = Math.ceil(this.qt.ml * t);
        for(let t = this.qt.lt.from; t < this.qt.lt.to; t++){
            const i = this.MS[t - this.qt.lt.from];
            i.bi < i.Na && (i.bi = i.Na);
            const n = i.bi - i.Na + 1;
            s = Math.min(n, s);
        }
        if (i > 0 && s < 4) for(let t = this.qt.lt.from; t < this.qt.lt.to; t++){
            const i = this.MS[t - this.qt.lt.from];
            i.bi - i.Na + 1 > s && (i.SS > i.ce ? i.bi -= 1 : i.Na += 1);
        }
    }
}
class $8f74814242901c26$var$ir extends $8f74814242901c26$var$Se {
    constructor(){
        super(...arguments), this.Vg = new $8f74814242901c26$var$tr;
    }
    Bg(t, i) {
        const n = this.ae.Ft().Nt(this.ae.N().base, $8f74814242901c26$var$u(this.ae.Lt()).Wt);
        return null === n ? null : $8f74814242901c26$var$Ps(this.kg, this.Tg, t, i, this.le.Et().ml(), this.ae.N().hitTestTolerance, (t, i)=>{
            i[0] = t.ut, i[1] = n;
        });
    }
    Rb(t, i, n) {
        return {
            ...this.Tb(t, i),
            ...n.Sh(t)
        };
    }
    Ng() {
        const t = {
            ot: this.kg,
            ml: this.le.Et().ml(),
            lt: this.Tg,
            bS: this.ae.Ft().Nt(this.ae.N().base, $8f74814242901c26$var$u(this.ae.Lt()).Wt)
        };
        this.Vg.ht(t);
    }
}
const $8f74814242901c26$export$9553650b5f8815ed = {
    type: "Histogram",
    isBuiltIn: !0,
    defaultOptions: {
        color: "#26a69a",
        base: 0
    },
    mb: (t, i)=>new $8f74814242901c26$var$ir(t, i)
};
class $8f74814242901c26$var$sr {
    constructor(t, i){
        this.yt = t, this.xS = i, this.CS();
    }
    detach() {
        this.yt.detachPrimitive(this.xS);
    }
    getPane() {
        return this.yt;
    }
    applyOptions(t) {
        this.xS.vr?.(t);
    }
    CS() {
        this.yt.attachPrimitive(this.xS);
    }
}
const $8f74814242901c26$var$er = {
    visible: !0,
    horzAlign: "center",
    vertAlign: "center",
    lines: []
}, $8f74814242901c26$var$rr = {
    color: "rgba(0, 0, 0, 0.5)",
    fontSize: 48,
    fontFamily: $8f74814242901c26$var$S,
    fontStyle: "",
    text: ""
};
class $8f74814242901c26$var$hr {
    constructor(t){
        this.yS = new Map, this.qt = t;
    }
    draw(t) {
        t.useMediaCoordinateSpace((t)=>{
            if (!this.qt.visible) return;
            const { context: i, mediaSize: n } = t;
            let s = 0;
            for (const t of this.qt.lines){
                if (0 === t.text.length) continue;
                i.font = t.k;
                const e = this.PS(i, t.text);
                e > n.width ? t.Uc = n.width / e : t.Uc = 1, s += t.lineHeight * t.Uc;
            }
            let e = 0;
            switch(this.qt.vertAlign){
                case "top":
                    e = 0;
                    break;
                case "center":
                    e = Math.max((n.height - s) / 2, 0);
                    break;
                case "bottom":
                    e = Math.max(n.height - s, 0);
            }
            for (const t of this.qt.lines){
                i.save(), i.fillStyle = t.color;
                let s = 0;
                switch(this.qt.horzAlign){
                    case "left":
                        i.textAlign = "left", s = t.lineHeight / 2;
                        break;
                    case "center":
                        i.textAlign = "center", s = n.width / 2;
                        break;
                    case "right":
                        i.textAlign = "right", s = n.width - 1 - t.lineHeight / 2;
                }
                i.translate(s, e), i.textBaseline = "top", i.font = t.k, i.scale(t.Uc, t.Uc), i.fillText(t.text, 0, t.kS), i.restore(), e += t.lineHeight * t.Uc;
            }
        });
    }
    PS(t, i) {
        const n = this.TS(t.font);
        let s = n.get(i);
        return void 0 === s && (s = t.measureText(i).width, n.set(i, s)), s;
    }
    TS(t) {
        let i = this.yS.get(t);
        return void 0 === i && (i = new Map, this.yS.set(t, i)), i;
    }
}
class $8f74814242901c26$var$ar {
    constructor(t){
        this.yn = $8f74814242901c26$var$or(t);
    }
    Pt(t) {
        this.yn = $8f74814242901c26$var$or(t);
    }
    renderer() {
        return new $8f74814242901c26$var$hr(this.yn);
    }
}
function $8f74814242901c26$var$lr(t) {
    return {
        ...t,
        k: $8f74814242901c26$var$x(t.fontSize, t.fontFamily, t.fontStyle),
        lineHeight: t.lineHeight || 1.2 * t.fontSize,
        kS: 0,
        Uc: 0
    };
}
function $8f74814242901c26$var$or(t) {
    return {
        ...t,
        lines: t.lines.map($8f74814242901c26$var$lr)
    };
}
function $8f74814242901c26$var$_r(t) {
    return {
        ...$8f74814242901c26$var$rr,
        ...t
    };
}
function $8f74814242901c26$var$ur(t) {
    return {
        ...$8f74814242901c26$var$er,
        ...t,
        lines: t.lines?.map($8f74814242901c26$var$_r) ?? []
    };
}
class $8f74814242901c26$var$cr {
    constructor(t){
        this.yn = $8f74814242901c26$var$ur(t), this.RS = [
            new $8f74814242901c26$var$ar(this.yn)
        ];
    }
    updateAllViews() {
        this.RS.forEach((t)=>t.Pt(this.yn));
    }
    paneViews() {
        return this.RS;
    }
    attached({ requestUpdate: t }) {
        this.DS = t;
    }
    detached() {
        this.DS = void 0;
    }
    vr(t) {
        this.yn = $8f74814242901c26$var$ur({
            ...this.yn,
            ...t
        }), this.DS && this.DS();
    }
}
function $8f74814242901c26$export$50cefd0ddd654f76(t, i) {
    return new $8f74814242901c26$var$sr(t, new $8f74814242901c26$var$cr(i));
}
const $8f74814242901c26$var$fr = {
    alpha: 1,
    padding: 0
};
class $8f74814242901c26$var$pr {
    constructor(t){
        this.qt = t;
    }
    draw(t) {
        t.useMediaCoordinateSpace((t)=>{
            const i = t.context, n = this.IS(this.qt, t.mediaSize);
            n && this.qt.VS && (i.globalAlpha = this.qt.alpha ?? 1, i.drawImage(this.qt.VS, n._t, n.ut, n.nn, n.$t));
        });
    }
    IS(t, i) {
        const { maxHeight: n, maxWidth: s, BS: e, ES: r, padding: h } = t, a = Math.round(i.width / 2), l = Math.round(i.height / 2), o = h ?? 0;
        let _ = i.width - 2 * o, u = i.height - 2 * o;
        n && (u = Math.min(u, n)), s && (_ = Math.min(_, s));
        const c = _ / r, d = u / e, f = Math.min(c, d), p = r * f, v = e * f;
        return {
            _t: a - .5 * p,
            ut: l - .5 * v,
            $t: v,
            nn: p
        };
    }
}
class $8f74814242901c26$var$vr {
    constructor(t){
        this.AS = null, this.LS = 0, this.zS = 0, this.yn = t, this.M = $8f74814242901c26$var$mr(this.yn, this.AS, this.LS, this.zS);
    }
    OS(t) {
        void 0 !== t.NS && (this.LS = t.NS), void 0 !== t.FS && (this.zS = t.FS), void 0 !== t.WS && (this.AS = t.WS), this.Pt();
    }
    HS(t) {
        this.yn = t, this.Pt();
    }
    zOrder() {
        return "bottom";
    }
    Pt() {
        this.M = $8f74814242901c26$var$mr(this.yn, this.AS, this.LS, this.zS);
    }
    renderer() {
        return new $8f74814242901c26$var$pr(this.M);
    }
}
function $8f74814242901c26$var$mr(t, i, n, s) {
    return {
        ...t,
        VS: i,
        ES: n,
        BS: s
    };
}
function $8f74814242901c26$var$wr(t) {
    return {
        ...$8f74814242901c26$var$fr,
        ...t
    };
}
class $8f74814242901c26$var$Mr {
    constructor(t, i){
        this.US = null, this.$S = t, this.yn = $8f74814242901c26$var$wr(i), this.RS = [
            new $8f74814242901c26$var$vr(this.yn)
        ];
    }
    updateAllViews() {
        this.RS.forEach((t)=>t.Pt());
    }
    paneViews() {
        return this.RS;
    }
    attached(t) {
        const { requestUpdate: i } = t;
        this.jS = i, this.US = new Image, this.US.onload = ()=>{
            const t = this.US?.naturalHeight ?? 1, i = this.US?.naturalWidth ?? 1;
            this.RS.forEach((n)=>n.OS({
                    FS: t,
                    NS: i,
                    WS: this.US
                })), this.jS && this.jS();
        }, this.US.src = this.$S;
    }
    detached() {
        this.jS = void 0, this.US = null;
    }
    vr(t) {
        this.yn = $8f74814242901c26$var$wr({
            ...this.yn,
            ...t
        }), this.qS(), this.DS && this.DS();
    }
    DS() {
        this.jS && this.jS();
    }
    qS() {
        this.RS.forEach((t)=>t.HS(this.yn));
    }
}
function $8f74814242901c26$export$58be2ae7527a8029(t, i, n) {
    return new $8f74814242901c26$var$sr(t, new $8f74814242901c26$var$Mr(i, n));
}
class $8f74814242901c26$var$br {
    constructor(t, i){
        this.ae = t, this.Jh = i, this.CS();
    }
    detach() {
        this.ae.detachPrimitive(this.Jh);
    }
    getSeries() {
        return this.ae;
    }
    applyOptions(t) {
        this.Jh && this.Jh.vr && this.Jh.vr(t);
    }
    CS() {
        this.ae.attachPrimitive(this.Jh);
    }
}
const $8f74814242901c26$var$Sr = {
    autoScale: !0,
    zOrder: "normal"
};
function $8f74814242901c26$var$xr(t, i) {
    return $8f74814242901c26$var$ei(Math.min(Math.max(t, 12), 30) * i);
}
function $8f74814242901c26$var$Cr(t, i) {
    const n = "circle" === t ? .8 : "square" === t ? .7 : 1;
    return $8f74814242901c26$var$ei(Math.max(i, 12) * n);
}
function $8f74814242901c26$var$yr(t) {
    return function(t) {
        const i = Math.ceil(t);
        return i % 2 != 0 ? i - 1 : i;
    }($8f74814242901c26$var$xr(t, 1));
}
function $8f74814242901c26$var$Pr(t) {
    return Math.max($8f74814242901c26$var$xr(t, .1), 3);
}
function $8f74814242901c26$var$kr(t, i, n) {
    return i ? t : n ? Math.ceil(t / 2) : 0;
}
function $8f74814242901c26$var$Tr(t, i, n, s) {
    const e = ($8f74814242901c26$var$Cr("arrowUp", s) - 1) / 2 * n.YS, r = ($8f74814242901c26$var$ei(s / 2) - 1) / 2 * n.YS;
    i.beginPath(), t ? (i.moveTo(n._t - e, n.ut), i.lineTo(n._t, n.ut - e), i.lineTo(n._t + e, n.ut), i.lineTo(n._t + r, n.ut), i.lineTo(n._t + r, n.ut + e), i.lineTo(n._t - r, n.ut + e), i.lineTo(n._t - r, n.ut)) : (i.moveTo(n._t - e, n.ut), i.lineTo(n._t, n.ut + e), i.lineTo(n._t + e, n.ut), i.lineTo(n._t + r, n.ut), i.lineTo(n._t + r, n.ut - e), i.lineTo(n._t - r, n.ut - e), i.lineTo(n._t - r, n.ut)), i.fill();
}
function $8f74814242901c26$var$Rr(t, i, n, s, e, r) {
    const h = ($8f74814242901c26$var$Cr("arrowUp", s) - 1) / 2, a = ($8f74814242901c26$var$ei(s / 2) - 1) / 2;
    if (e >= i - a - 2 && e <= i + a + 2 && r >= (t ? n : n - h) - 2 && r <= (t ? n + h : n) + 2) return !0;
    return (()=>{
        if (e < i - h - 3 || e > i + h + 3 || r < (t ? n - h - 3 : n) || r > (t ? n : n + h + 3)) return !1;
        const s = Math.abs(e - i);
        return Math.abs(r - n) + 3 >= s / 2;
    })();
}
class $8f74814242901c26$var$Dr {
    constructor(){
        this.qt = null, this.$s = new $8f74814242901c26$var$rt, this.F = -1, this.W = "", this.hm = "", this.KS = "normal";
    }
    ht(t) {
        this.qt = t;
    }
    js(t, i, n) {
        this.F === t && this.W === i || (this.F = t, this.W = i, this.hm = $8f74814242901c26$var$x(t, i), this.$s.Os()), this.KS = n;
    }
    Qs(t, i) {
        if (null === this.qt || null === this.qt.lt) return null;
        for(let n = this.qt.lt.from; n < this.qt.lt.to; n++){
            const s = this.qt.ot[n];
            if (s && $8f74814242901c26$var$Vr(s, t, i)) return {
                zOrder: "normal",
                externalId: s.te ?? "",
                itemType: "marker"
            };
        }
        return null;
    }
    draw(t) {
        "aboveSeries" !== this.KS && t.useBitmapCoordinateSpace((t)=>{
            this.et(t);
        });
    }
    drawBackground(t) {
        "aboveSeries" === this.KS && t.useBitmapCoordinateSpace((t)=>{
            this.et(t);
        });
    }
    et({ context: t, horizontalPixelRatio: i, verticalPixelRatio: n }) {
        if (null !== this.qt && null !== this.qt.lt) {
            t.textBaseline = "middle", t.font = this.hm;
            for(let s = this.qt.lt.from; s < this.qt.lt.to; s++){
                const e = this.qt.ot[s];
                void 0 !== e.ri && (e.ri.nn = this.$s.Ii(t, e.ri.GS), e.ri.$t = this.F, e.ri._t = e._t - e.ri.nn / 2), $8f74814242901c26$var$Ir(e, t, i, n);
            }
        }
    }
}
function $8f74814242901c26$var$Ir(t, i, n, s) {
    i.fillStyle = t.R, void 0 !== t.ri && function(t, i, n, s, e, r) {
        t.save(), t.scale(e, r), t.fillText(i, n, s), t.restore();
    }(i, t.ri.GS, t.ri._t, t.ri.ut, n, s), function(t, i, n) {
        if (0 === t.Th) return;
        switch(t.ZS){
            case "arrowDown":
                return void $8f74814242901c26$var$Tr(!1, i, n, t.Th);
            case "arrowUp":
                return void $8f74814242901c26$var$Tr(!0, i, n, t.Th);
            case "circle":
                return void function(t, i, n) {
                    const s = ($8f74814242901c26$var$Cr("circle", n) - 1) / 2;
                    t.beginPath(), t.arc(i._t, i.ut, s * i.YS, 0, 2 * Math.PI, !1), t.fill();
                }(i, n, t.Th);
            case "square":
                return void function(t, i, n) {
                    const s = $8f74814242901c26$var$Cr("square", n), e = (s - 1) * i.YS / 2, r = i._t - e, h = i.ut - e;
                    t.fillRect(r, h, s * i.YS, s * i.YS);
                }(i, n, t.Th);
        }
        t.ZS;
    }(t, i, function(t, i, n) {
        const s = Math.max(1, Math.floor(i)) % 2 / 2;
        return {
            _t: Math.round(t._t * i) + s,
            ut: t.ut * n,
            YS: i
        };
    }(t, n, s));
}
function $8f74814242901c26$var$Vr(t, i, n) {
    return !(void 0 === t.ri || !function(t, i, n, s, e, r) {
        const h = s / 2;
        return e >= t && e <= t + n && r >= i - h && r <= i + h;
    }(t.ri._t, t.ri.ut, t.ri.nn, t.ri.$t, i, n)) || function(t, i, n) {
        if (0 === t.Th) return !1;
        switch(t.ZS){
            case "arrowDown":
                return $8f74814242901c26$var$Rr(!0, t._t, t.ut, t.Th, i, n);
            case "arrowUp":
                return $8f74814242901c26$var$Rr(!1, t._t, t.ut, t.Th, i, n);
            case "circle":
                return function(t, i, n, s, e) {
                    const r = 2 + $8f74814242901c26$var$Cr("circle", n) / 2, h = t - s, a = i - e;
                    return Math.sqrt(h * h + a * a) <= r;
                }(t._t, t.ut, t.Th, i, n);
            case "square":
                return function(t, i, n, s, e) {
                    const r = $8f74814242901c26$var$Cr("square", n), h = (r - 1) / 2, a = t - h, l = i - h;
                    return s >= a && s <= a + r && e >= l && e <= l + r;
                }(t._t, t.ut, t.Th, i, n);
        }
    }(t, i, n);
}
function $8f74814242901c26$var$Br(t) {
    return "atPriceTop" === t || "atPriceBottom" === t || "atPriceMiddle" === t;
}
function $8f74814242901c26$var$Er(t, i, n, s, e, r, h, a) {
    const l = function(t, i, n) {
        if ($8f74814242901c26$var$Br(i.position) && void 0 !== i.price) return i.price;
        if ("value" in (s = t) && "number" == typeof s.value) return t.value;
        var s;
        if (function(t) {
            return "open" in t && "high" in t && "low" in t && "close" in t;
        }(t)) {
            if ("inBar" === i.position) return t.close;
            if ("aboveBar" === i.position) return n ? t.low : t.high;
            if ("belowBar" === i.position) return n ? t.high : t.low;
        }
    }(n, i, h.priceScale().options().invertScale);
    if (void 0 === l) return;
    const o = $8f74814242901c26$var$Br(i.position), _ = a.timeScale(), c = $8f74814242901c26$var$p(i.size) ? Math.max(i.size, 0) : 1, d = $8f74814242901c26$var$yr(_.options().barSpacing) * c, f = d / 2;
    t.Th = d;
    switch(i.position){
        case "inBar":
        case "atPriceMiddle":
            return t.ut = $8f74814242901c26$var$u(h.priceToCoordinate(l)), void (void 0 !== t.ri && (t.ri.ut = t.ut + f + r + .6 * e));
        case "aboveBar":
        case "atPriceTop":
            {
                const i = o ? 0 : s.XS;
                return t.ut = $8f74814242901c26$var$u(h.priceToCoordinate(l)) - f - i, void 0 !== t.ri && (t.ri.ut = t.ut - f - .6 * e, s.XS += 1.2 * e), void (o || (s.XS += d + r));
            }
        case "belowBar":
        case "atPriceBottom":
            {
                const i = o ? 0 : s.JS;
                return t.ut = $8f74814242901c26$var$u(h.priceToCoordinate(l)) + f + i, void 0 !== t.ri && (t.ri.ut = t.ut + f + r + .6 * e, s.JS += 1.2 * e), void (o || (s.JS += d + r));
            }
    }
}
class $8f74814242901c26$var$Ar {
    constructor(t, i, n){
        this.QS = [], this.xt = !0, this.tx = !0, this.Xt = new $8f74814242901c26$var$Dr, this.Te = t, this.Gv = i, this.qt = {
            ot: [],
            lt: null
        }, this.yn = n;
    }
    renderer() {
        if (!this.Te.options().visible) return null;
        this.xt && this.Ig();
        const t = this.Gv.options().layout;
        return this.Xt.js(t.fontSize, t.fontFamily, this.yn.zOrder), this.Xt.ht(this.qt), this.Xt;
    }
    ix(t) {
        this.QS = t, this.Pt("data");
    }
    Pt(t) {
        this.xt = !0, "data" === t && (this.tx = !0);
    }
    nx(t) {
        this.xt = !0, this.yn = t;
    }
    zOrder() {
        return "aboveSeries" === this.yn.zOrder ? "top" : this.yn.zOrder;
    }
    Ig() {
        const t = this.Gv.timeScale(), i = this.QS;
        this.tx && (this.qt.ot = i.map((t)=>({
                wt: t.time,
                _t: 0,
                ut: 0,
                Th: 0,
                ZS: t.shape,
                R: t.color,
                te: t.id,
                sx: t.sx,
                ri: void 0
            })), this.tx = !1);
        const n = this.Gv.options().layout;
        this.qt.lt = null;
        const s = t.getVisibleLogicalRange();
        if (null === s) return;
        const e = new $8f74814242901c26$var$Ai(Math.floor(s.from), Math.ceil(s.to));
        if (null === this.Te.dataByIndex(0, 1)) return;
        if (0 === this.qt.ot.length) return;
        let r = NaN;
        const h = $8f74814242901c26$var$Pr(t.options().barSpacing), a = {
            XS: h,
            JS: h
        };
        this.qt.lt = $8f74814242901c26$var$Rs(this.qt.ot, e, !0);
        for(let s = this.qt.lt.from; s < this.qt.lt.to; s++){
            const e = i[s];
            e.time !== r && (a.XS = h, a.JS = h, r = e.time);
            const l = this.qt.ot[s];
            l._t = $8f74814242901c26$var$u(t.logicalToCoordinate(e.time)), void 0 !== e.text && e.text.length > 0 && (l.ri = {
                GS: e.text,
                _t: 0,
                ut: 0,
                nn: 0,
                $t: 0
            });
            const o = this.Te.dataByIndex(e.time, 0);
            null !== o && $8f74814242901c26$var$Er(l, e, o, a, n.fontSize, h, this.Te, this.Gv);
        }
        this.xt = !1;
    }
}
function $8f74814242901c26$var$Lr(t) {
    return {
        ...$8f74814242901c26$var$Sr,
        ...t
    };
}
class $8f74814242901c26$var$zr {
    constructor(t){
        this.Yh = null, this.QS = [], this.hx = [], this.lx = null, this.Te = null, this.Gv = null, this.ox = !0, this._x = null, this.ux = null, this.vx = null, this.mx = !0, this.yn = $8f74814242901c26$var$Lr(t);
    }
    attached(t) {
        this.wx(), this.Gv = t.chart, this.Te = t.series, this.Yh = new $8f74814242901c26$var$Ar(this.Te, $8f74814242901c26$var$u(this.Gv), this.yn), this.jS = t.requestUpdate, this.Te.subscribeDataChanged((t)=>this.Qg(t)), this.mx = !0, this.DS();
    }
    DS() {
        this.jS && this.jS();
    }
    detached() {
        this.Te && this.lx && this.Te.unsubscribeDataChanged(this.lx), this.Gv = null, this.Te = null, this.Yh = null, this.lx = null;
    }
    ix(t) {
        this.mx = !0, this.QS = t, this.wx(), this.ox = !0, this.ux = null, this.DS();
    }
    Mx() {
        return this.QS;
    }
    paneViews() {
        return this.Yh ? [
            this.Yh
        ] : [];
    }
    updateAllViews() {
        this.gx();
    }
    hitTest(t, i) {
        return this.Yh ? this.Yh.renderer()?.Qs(t, i) ?? null : null;
    }
    autoscaleInfo(t, i) {
        if (this.yn.autoScale && this.Yh) {
            const t = this.bx();
            if (t) return {
                priceRange: null,
                margins: t
            };
        }
        return null;
    }
    vr(t) {
        this.yn = $8f74814242901c26$var$Lr({
            ...this.yn,
            ...t
        }), this.DS && this.DS();
    }
    bx() {
        const t = $8f74814242901c26$var$u(this.Gv).timeScale().options().barSpacing;
        if (this.ox || t !== this.vx) {
            if (this.vx = t, this.QS.length > 0) {
                const i = $8f74814242901c26$var$Pr(t), n = 1.5 * $8f74814242901c26$var$yr(t) + 2 * i, s = this.Sx();
                this._x = {
                    above: $8f74814242901c26$var$kr(n, s.aboveBar, s.inBar),
                    below: $8f74814242901c26$var$kr(n, s.belowBar, s.inBar)
                };
            } else this._x = null;
            this.ox = !1;
        }
        return this._x;
    }
    Sx() {
        return null === this.ux && (this.ux = this.QS.reduce((t, i)=>(t[i.position] || (t[i.position] = !0), t), {
            inBar: !1,
            aboveBar: !1,
            belowBar: !1,
            atPriceTop: !1,
            atPriceBottom: !1,
            atPriceMiddle: !1
        })), this.ux;
    }
    wx() {
        if (!this.mx || !this.Gv || !this.Te) return;
        const t = this.Gv.timeScale(), i = this.Te?.data();
        if (null == t.getVisibleLogicalRange() || !this.Te || 0 === i.length) return void (this.hx = []);
        const n = t.timeToIndex($8f74814242901c26$var$u(i[0].time), !0);
        this.hx = this.QS.map((i, s)=>{
            const e = t.timeToIndex(i.time, !0), r = e < n ? 1 : -1, h = $8f74814242901c26$var$u(this.Te).dataByIndex(e, r), a = {
                time: t.timeToIndex($8f74814242901c26$var$u(h).time, !1),
                position: i.position,
                shape: i.shape,
                color: i.color,
                id: i.id,
                sx: s,
                text: i.text,
                size: i.size,
                price: i.price,
                Qr: i.time
            };
            if ("atPriceTop" === i.position || "atPriceBottom" === i.position || "atPriceMiddle" === i.position) {
                if (void 0 === i.price) throw new Error(`Price is required for position ${i.position}`);
                return {
                    ...a,
                    position: i.position,
                    price: i.price
                };
            }
            return {
                ...a,
                position: i.position,
                price: i.price
            };
        }), this.mx = !1;
    }
    gx(t) {
        this.Yh && (this.wx(), this.Yh.ix(this.hx), this.Yh.nx(this.yn), this.Yh.Pt(t));
    }
    Qg(t) {
        this.mx = !0, this.DS();
    }
}
class $8f74814242901c26$var$Or extends $8f74814242901c26$var$br {
    constructor(t, i, n){
        super(t, i), n && this.setMarkers(n);
    }
    setMarkers(t) {
        this.Jh.ix(t);
    }
    markers() {
        return this.Jh.Mx();
    }
}
function $8f74814242901c26$export$b954512652d436b9(t, i, n) {
    const s = new $8f74814242901c26$var$Or(t, new $8f74814242901c26$var$zr(n ?? {}));
    return i && s.setMarkers(i), s;
}
class $8f74814242901c26$var$Fr {
    constructor(t){
        this.QS = new Map, this.xx = t;
    }
    Cx(t, i, n) {
        if (this.yx(i), void 0 !== n) {
            const s = window.setTimeout(()=>{
                this.QS.delete(i), this.Px();
            }, n), e = {
                ...t,
                kx: s,
                Tx: Date.now() + n
            };
            this.QS.set(i, e);
        } else this.QS.set(i, {
            ...t,
            kx: void 0,
            Tx: void 0
        });
        this.Px();
    }
    yx(t) {
        const i = this.QS.get(t);
        i && void 0 !== i.kx && window.clearTimeout(i.kx), this.QS.delete(t), this.Px();
    }
    Rx() {
        for (const [t] of this.QS)this.yx(t);
    }
    Dx() {
        const t = Date.now(), i = [];
        for (const [n, s] of this.QS)!s.Tx || s.Tx > t ? i.push({
            time: s.time,
            sign: s.sign,
            value: s.value
        }) : this.yx(n);
        return i;
    }
    Ix(t) {
        this.xx = t;
    }
    Px() {
        this.xx && this.xx();
    }
}
const $8f74814242901c26$var$Wr = {
    positiveColor: "#22AB94",
    negativeColor: "#F7525F",
    updateVisibilityDuration: 5e3
};
class $8f74814242901c26$var$Hr {
    constructor(t, i, n, s){
        this.qt = t, this.Vx = i, this.Bx = n, this.Ex = s;
    }
    draw(t) {
        t.useBitmapCoordinateSpace((t)=>{
            const i = t.context, n = Math.max(1, Math.floor(t.horizontalPixelRatio)) % 2 / 2, s = 4 * t.verticalPixelRatio + n;
            this.qt.forEach((e)=>{
                const r = Math.round(e._t * t.horizontalPixelRatio) + n;
                i.beginPath();
                const h = this.Ax(e.Lx);
                i.fillStyle = h, i.arc(r, e.ut * t.verticalPixelRatio, s, 0, 2 * Math.PI, !1), i.fill(), e.Lx && (i.strokeStyle = h, i.lineWidth = Math.floor(2 * t.horizontalPixelRatio), i.beginPath(), i.moveTo((e._t - 4.7) * t.horizontalPixelRatio + n, (e.ut - 7 * e.Lx) * t.verticalPixelRatio), i.lineTo(e._t * t.horizontalPixelRatio + n, (e.ut - 7 * e.Lx - 7 * e.Lx * .5) * t.verticalPixelRatio), i.lineTo((e._t + 4.7) * t.horizontalPixelRatio + n, (e.ut - 7 * e.Lx) * t.verticalPixelRatio), i.stroke());
            });
        });
    }
    Ax(t) {
        return 0 === t ? this.Vx : t > 0 ? this.Ex : this.Bx;
    }
}
class $8f74814242901c26$var$Ur {
    constructor(t, i, n){
        this.qt = [], this.Te = t, this.ia = i, this.yn = n;
    }
    Pt(t) {
        this.qt = t.map((t)=>{
            const i = this.Te.priceToCoordinate(t.value);
            if (null === i) return null;
            return {
                _t: $8f74814242901c26$var$u(this.ia.timeToCoordinate(t.time)),
                ut: i,
                Lx: t.sign
            };
        }).filter($8f74814242901c26$var$g);
    }
    renderer() {
        const t = function(t, i) {
            return function(t, i) {
                return "Area" === i;
            }(0, i) ? t.lineColor : t.color;
        }(this.Te.options(), this.Te.seriesType());
        return new $8f74814242901c26$var$Hr(this.qt, t, this.yn.negativeColor, this.yn.positiveColor);
    }
}
function $8f74814242901c26$var$$r(t, i) {
    return "Line" === i || "Area" === i;
}
class $8f74814242901c26$var$jr {
    constructor(t){
        this.Gv = void 0, this.Te = void 0, this.RS = [], this.Pu = null, this.zx = new Map, this.Ox = new $8f74814242901c26$var$Fr(()=>this.DS()), this.yn = {
            ...$8f74814242901c26$var$Wr,
            ...t
        };
    }
    vr(t) {
        this.yn = {
            ...this.yn,
            ...t
        }, this.DS();
    }
    ix(t) {
        this.Ox.Rx();
        const i = this.Pu;
        i && t.forEach((t)=>{
            this.Ox.Cx(t, i.key(t.time));
        });
    }
    Mx() {
        return this.Ox.Dx();
    }
    DS() {
        this.jS?.();
    }
    attached(t) {
        const { chart: i, series: n, requestUpdate: s, horzScaleBehavior: e } = t;
        this.Gv = i, this.Te = n, this.Pu = e;
        const r = this.Te.seriesType();
        if ("Area" !== r && "Line" !== r) throw new Error("UpDownMarkersPrimitive is only supported for Area and Line series types");
        this.RS = [
            new $8f74814242901c26$var$Ur(this.Te, this.Gv.timeScale(), this.yn)
        ], this.jS = s, this.DS();
    }
    detached() {
        this.Gv = void 0, this.Te = void 0, this.jS = void 0;
    }
    _m() {
        return $8f74814242901c26$var$_(this.Gv);
    }
    Y_() {
        return $8f74814242901c26$var$_(this.Te);
    }
    updateAllViews() {
        this.RS.forEach((t)=>t.Pt(this.Mx()));
    }
    paneViews() {
        return this.RS;
    }
    ht(t) {
        if (!this.Te) throw new Error("Primitive not attached to series");
        const i = this.Te.seriesType();
        this.zx.clear();
        const n = this.Pu;
        n && t.forEach((t)=>{
            $8f74814242901c26$var$ts(t) && $8f74814242901c26$var$$r(0, i) && this.zx.set(n.key(t.time), t.value);
        }), $8f74814242901c26$var$_(this.Te).setData(t);
    }
    Pt(t, i) {
        if (!this.Te || !this.Pu) throw new Error("Primitive not attached to series");
        const n = this.Te.seriesType(), s = this.Pu.key(t.time);
        if ($8f74814242901c26$var$Qn(t) && this.zx.delete(s), $8f74814242901c26$var$ts(t) && $8f74814242901c26$var$$r(0, n)) {
            const i = this.zx.get(s);
            i && this.Ox.Cx({
                time: t.time,
                value: t.value,
                sign: $8f74814242901c26$var$qr(t.value, i)
            }, s, this.yn.updateVisibilityDuration);
        }
        $8f74814242901c26$var$_(this.Te).update(t, i);
    }
    Nx() {
        this.Ox.Rx();
    }
}
function $8f74814242901c26$var$qr(t, i) {
    return t === i ? 0 : t - i > 0 ? 1 : -1;
}
class $8f74814242901c26$var$Yr extends $8f74814242901c26$var$br {
    setData(t) {
        return this.Jh.ht(t);
    }
    update(t, i) {
        return this.Jh.Pt(t, i);
    }
    markers() {
        return this.Jh.Mx();
    }
    setMarkers(t) {
        return this.Jh.ix(t);
    }
    clearMarkers() {
        return this.Jh.Nx();
    }
}
function $8f74814242901c26$export$25a504258c8e63a9(t, i = {}) {
    return new $8f74814242901c26$var$Yr(t, new $8f74814242901c26$var$jr(i));
}
const $8f74814242901c26$export$fa49a2a1caf269cf = {
    ...$8f74814242901c26$var$e,
    color: "#2196f3"
};
function $8f74814242901c26$export$83d89fbfd8236492() {
    return "5.2.1";
}

});
parcelRegister("jAD69", function(module, exports) {

$parcel$export(module.exports, "size", function () { return (parcelRequire("aFz8k")).size; });
$parcel$export(module.exports, "equalSizes", function () { return (parcelRequire("aFz8k")).equalSizes; });
$parcel$export(module.exports, "bindCanvasElementBitmapSizeTo", function () { return (parcelRequire("59mHk")).bindTo; });
$parcel$export(module.exports, "tryCreateCanvasRenderingTarget2D", function () { return (parcelRequire("02Gl7")).tryCreateCanvasRenderingTarget2D; });

var $aFz8k = parcelRequire("aFz8k");

var $59mHk = parcelRequire("59mHk");

var $02Gl7 = parcelRequire("02Gl7");

});
parcelRegister("aFz8k", function(module, exports) {

$parcel$export(module.exports, "size", function () { return $61a3448b906e81eb$export$346677f925de839c; });
$parcel$export(module.exports, "equalSizes", function () { return $61a3448b906e81eb$export$dfcfeaf16c0e44ed; });
function $61a3448b906e81eb$export$346677f925de839c(_a) {
    var width = _a.width, height = _a.height;
    if (width < 0) throw new Error('Negative width is not allowed for Size');
    if (height < 0) throw new Error('Negative height is not allowed for Size');
    return {
        width: width,
        height: height
    };
}
function $61a3448b906e81eb$export$dfcfeaf16c0e44ed(first, second) {
    return first.width === second.width && first.height === second.height;
}

});

parcelRegister("59mHk", function(module, exports) {

$parcel$export(module.exports, "bindTo", function () { return $923e9adc7903f681$export$7c052ae73f8acff0; });

var $aFz8k = parcelRequire("aFz8k");

var $hCIjj = parcelRequire("hCIjj");
var $923e9adc7903f681$var$DevicePixelContentBoxBinding = /** @class */ function() {
    function DevicePixelContentBoxBinding(canvasElement, transformBitmapSize, options) {
        var _a;
        this._canvasElement = null;
        this._bitmapSizeChangedListeners = [];
        this._suggestedBitmapSize = null;
        this._suggestedBitmapSizeChangedListeners = [];
        // devicePixelRatio approach
        this._devicePixelRatioObservable = null;
        // ResizeObserver approach
        this._canvasElementResizeObserver = null;
        this._canvasElement = canvasElement;
        this._canvasElementClientSize = (0, $aFz8k.size)({
            width: this._canvasElement.clientWidth,
            height: this._canvasElement.clientHeight
        });
        this._transformBitmapSize = transformBitmapSize !== null && transformBitmapSize !== void 0 ? transformBitmapSize : function(size) {
            return size;
        };
        this._allowResizeObserver = (_a = options === null || options === void 0 ? void 0 : options.allowResizeObserver) !== null && _a !== void 0 ? _a : true;
        this._chooseAndInitObserver();
    // we MAY leave the constuctor without any bitmap size observation mechanics initialized
    }
    DevicePixelContentBoxBinding.prototype.dispose = function() {
        var _a, _b;
        if (this._canvasElement === null) throw new Error('Object is disposed');
        (_a = this._canvasElementResizeObserver) === null || _a === void 0 || _a.disconnect();
        this._canvasElementResizeObserver = null;
        (_b = this._devicePixelRatioObservable) === null || _b === void 0 || _b.dispose();
        this._devicePixelRatioObservable = null;
        this._suggestedBitmapSizeChangedListeners.length = 0;
        this._bitmapSizeChangedListeners.length = 0;
        this._canvasElement = null;
    };
    Object.defineProperty(DevicePixelContentBoxBinding.prototype, "canvasElement", {
        get: function() {
            if (this._canvasElement === null) throw new Error('Object is disposed');
            return this._canvasElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DevicePixelContentBoxBinding.prototype, "canvasElementClientSize", {
        get: function() {
            return this._canvasElementClientSize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DevicePixelContentBoxBinding.prototype, "bitmapSize", {
        get: function() {
            return (0, $aFz8k.size)({
                width: this.canvasElement.width,
                height: this.canvasElement.height
            });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Use this function to change canvas element client size until binding is disposed
     * @param clientSize New client size for bound HTMLCanvasElement
     */ DevicePixelContentBoxBinding.prototype.resizeCanvasElement = function(clientSize) {
        this._canvasElementClientSize = (0, $aFz8k.size)(clientSize);
        this.canvasElement.style.width = "".concat(this._canvasElementClientSize.width, "px");
        this.canvasElement.style.height = "".concat(this._canvasElementClientSize.height, "px");
        this._invalidateBitmapSize();
    };
    DevicePixelContentBoxBinding.prototype.subscribeBitmapSizeChanged = function(listener) {
        this._bitmapSizeChangedListeners.push(listener);
    };
    DevicePixelContentBoxBinding.prototype.unsubscribeBitmapSizeChanged = function(listener) {
        this._bitmapSizeChangedListeners = this._bitmapSizeChangedListeners.filter(function(l) {
            return l !== listener;
        });
    };
    Object.defineProperty(DevicePixelContentBoxBinding.prototype, "suggestedBitmapSize", {
        get: function() {
            return this._suggestedBitmapSize;
        },
        enumerable: false,
        configurable: true
    });
    DevicePixelContentBoxBinding.prototype.subscribeSuggestedBitmapSizeChanged = function(listener) {
        this._suggestedBitmapSizeChangedListeners.push(listener);
    };
    DevicePixelContentBoxBinding.prototype.unsubscribeSuggestedBitmapSizeChanged = function(listener) {
        this._suggestedBitmapSizeChangedListeners = this._suggestedBitmapSizeChangedListeners.filter(function(l) {
            return l !== listener;
        });
    };
    DevicePixelContentBoxBinding.prototype.applySuggestedBitmapSize = function() {
        if (this._suggestedBitmapSize === null) // nothing to apply
        return;
        var oldSuggestedSize = this._suggestedBitmapSize;
        this._suggestedBitmapSize = null;
        this._resizeBitmap(oldSuggestedSize);
        this._emitSuggestedBitmapSizeChanged(oldSuggestedSize, this._suggestedBitmapSize);
    };
    DevicePixelContentBoxBinding.prototype._resizeBitmap = function(newSize) {
        var oldSize = this.bitmapSize;
        if ((0, $aFz8k.equalSizes)(oldSize, newSize)) return;
        this.canvasElement.width = newSize.width;
        this.canvasElement.height = newSize.height;
        this._emitBitmapSizeChanged(oldSize, newSize);
    };
    DevicePixelContentBoxBinding.prototype._emitBitmapSizeChanged = function(oldSize, newSize) {
        var _this = this;
        this._bitmapSizeChangedListeners.forEach(function(listener) {
            return listener.call(_this, oldSize, newSize);
        });
    };
    DevicePixelContentBoxBinding.prototype._suggestNewBitmapSize = function(newSize) {
        var oldSuggestedSize = this._suggestedBitmapSize;
        var finalNewSize = (0, $aFz8k.size)(this._transformBitmapSize(newSize, this._canvasElementClientSize));
        var newSuggestedSize = (0, $aFz8k.equalSizes)(this.bitmapSize, finalNewSize) ? null : finalNewSize;
        if (oldSuggestedSize === null && newSuggestedSize === null) return;
        if (oldSuggestedSize !== null && newSuggestedSize !== null && (0, $aFz8k.equalSizes)(oldSuggestedSize, newSuggestedSize)) return;
        this._suggestedBitmapSize = newSuggestedSize;
        this._emitSuggestedBitmapSizeChanged(oldSuggestedSize, newSuggestedSize);
    };
    DevicePixelContentBoxBinding.prototype._emitSuggestedBitmapSizeChanged = function(oldSize, newSize) {
        var _this = this;
        this._suggestedBitmapSizeChangedListeners.forEach(function(listener) {
            return listener.call(_this, oldSize, newSize);
        });
    };
    DevicePixelContentBoxBinding.prototype._chooseAndInitObserver = function() {
        var _this = this;
        if (!this._allowResizeObserver) {
            this._initDevicePixelRatioObservable();
            return;
        }
        $923e9adc7903f681$var$isDevicePixelContentBoxSupported().then(function(isSupported) {
            return isSupported ? _this._initResizeObserver() : _this._initDevicePixelRatioObservable();
        });
    };
    // devicePixelRatio approach
    DevicePixelContentBoxBinding.prototype._initDevicePixelRatioObservable = function() {
        var _this = this;
        if (this._canvasElement === null) // it looks like we are already dead
        return;
        var win = $923e9adc7903f681$var$canvasElementWindow(this._canvasElement);
        if (win === null) throw new Error('No window is associated with the canvas');
        this._devicePixelRatioObservable = (0, $hCIjj.createObservable)(win);
        this._devicePixelRatioObservable.subscribe(function() {
            return _this._invalidateBitmapSize();
        });
        this._invalidateBitmapSize();
    };
    DevicePixelContentBoxBinding.prototype._invalidateBitmapSize = function() {
        var _a, _b;
        if (this._canvasElement === null) // it looks like we are already dead
        return;
        var win = $923e9adc7903f681$var$canvasElementWindow(this._canvasElement);
        if (win === null) return;
        var ratio = (_b = (_a = this._devicePixelRatioObservable) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : win.devicePixelRatio;
        var canvasRects = this._canvasElement.getClientRects();
        var newSize = // eslint-disable-next-line no-negated-condition
        canvasRects[0] !== undefined ? $923e9adc7903f681$var$predictedBitmapSize(canvasRects[0], ratio) : (0, $aFz8k.size)({
            width: this._canvasElementClientSize.width * ratio,
            height: this._canvasElementClientSize.height * ratio
        });
        this._suggestNewBitmapSize(newSize);
    };
    // ResizeObserver approach
    DevicePixelContentBoxBinding.prototype._initResizeObserver = function() {
        var _this = this;
        if (this._canvasElement === null) // it looks like we are already dead
        return;
        this._canvasElementResizeObserver = new ResizeObserver(function(entries) {
            var entry = entries.find(function(entry) {
                return entry.target === _this._canvasElement;
            });
            if (!entry || !entry.devicePixelContentBoxSize || !entry.devicePixelContentBoxSize[0]) return;
            var entrySize = entry.devicePixelContentBoxSize[0];
            var newSize = (0, $aFz8k.size)({
                width: entrySize.inlineSize,
                height: entrySize.blockSize
            });
            _this._suggestNewBitmapSize(newSize);
        });
        this._canvasElementResizeObserver.observe(this._canvasElement, {
            box: 'device-pixel-content-box'
        });
    };
    return DevicePixelContentBoxBinding;
}();
function $923e9adc7903f681$export$7c052ae73f8acff0(canvasElement, target) {
    if (target.type === 'device-pixel-content-box') return new $923e9adc7903f681$var$DevicePixelContentBoxBinding(canvasElement, target.transform, target.options);
    throw new Error('Unsupported binding target');
}
function $923e9adc7903f681$var$canvasElementWindow(canvasElement) {
    // According to DOM Level 2 Core specification, ownerDocument should never be null for HTMLCanvasElement
    // see https://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#node-ownerDoc
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return canvasElement.ownerDocument.defaultView;
}
function $923e9adc7903f681$var$isDevicePixelContentBoxSupported() {
    return new Promise(function(resolve) {
        var ro = new ResizeObserver(function(entries) {
            resolve(entries.every(function(entry) {
                return 'devicePixelContentBoxSize' in entry;
            }));
            ro.disconnect();
        });
        ro.observe(document.body, {
            box: 'device-pixel-content-box'
        });
    }).catch(function() {
        return false;
    });
}
function $923e9adc7903f681$var$predictedBitmapSize(canvasRect, ratio) {
    return (0, $aFz8k.size)({
        width: Math.round(canvasRect.left * ratio + canvasRect.width * ratio) - Math.round(canvasRect.left * ratio),
        height: Math.round(canvasRect.top * ratio + canvasRect.height * ratio) - Math.round(canvasRect.top * ratio)
    });
}

});
parcelRegister("hCIjj", function(module, exports) {

$parcel$export(module.exports, "createObservable", function () { return $5d8ba9cbdb995f2e$export$5e7f1682f65b2ce4; });
var $5d8ba9cbdb995f2e$var$Observable = /** @class */ function() {
    function Observable(win) {
        var _this = this;
        this._resolutionListener = function() {
            return _this._onResolutionChanged();
        };
        this._resolutionMediaQueryList = null;
        this._observers = [];
        this._window = win;
        this._installResolutionListener();
    }
    Observable.prototype.dispose = function() {
        this._uninstallResolutionListener();
        this._window = null;
    };
    Object.defineProperty(Observable.prototype, "value", {
        get: function() {
            return this._window.devicePixelRatio;
        },
        enumerable: false,
        configurable: true
    });
    Observable.prototype.subscribe = function(next) {
        var _this = this;
        var observer = {
            next: next
        };
        this._observers.push(observer);
        return {
            unsubscribe: function() {
                _this._observers = _this._observers.filter(function(o) {
                    return o !== observer;
                });
            }
        };
    };
    Observable.prototype._installResolutionListener = function() {
        if (this._resolutionMediaQueryList !== null) throw new Error('Resolution listener is already installed');
        var dppx = this._window.devicePixelRatio;
        this._resolutionMediaQueryList = this._window.matchMedia("all and (resolution: ".concat(dppx, "dppx)"));
        // IE and some versions of Edge do not support addEventListener/removeEventListener, and we are going to use the deprecated addListener/removeListener
        this._resolutionMediaQueryList.addListener(this._resolutionListener);
    };
    Observable.prototype._uninstallResolutionListener = function() {
        if (this._resolutionMediaQueryList !== null) {
            // IE and some versions of Edge do not support addEventListener/removeEventListener, and we are going to use the deprecated addListener/removeListener
            this._resolutionMediaQueryList.removeListener(this._resolutionListener);
            this._resolutionMediaQueryList = null;
        }
    };
    Observable.prototype._reinstallResolutionListener = function() {
        this._uninstallResolutionListener();
        this._installResolutionListener();
    };
    Observable.prototype._onResolutionChanged = function() {
        var _this = this;
        this._observers.forEach(function(observer) {
            return observer.next(_this._window.devicePixelRatio);
        });
        this._reinstallResolutionListener();
    };
    return Observable;
}();
function $5d8ba9cbdb995f2e$export$5e7f1682f65b2ce4(win) {
    return new $5d8ba9cbdb995f2e$var$Observable(win);
}

});


parcelRegister("02Gl7", function(module, exports) {

$parcel$export(module.exports, "tryCreateCanvasRenderingTarget2D", function () { return $eb48b24f0fffebe8$export$7130a2243f9306b6; });
/**
 * @experimental
 */ var $eb48b24f0fffebe8$export$d9009780fa8cf0a4 = /** @class */ function() {
    function CanvasRenderingTarget2D(context, mediaSize, bitmapSize) {
        if (mediaSize.width === 0 || mediaSize.height === 0) throw new TypeError('Rendering target could only be created on a media with positive width and height');
        this._mediaSize = mediaSize;
        // !Number.isInteger(bitmapSize.width) || !Number.isInteger(bitmapSize.height)
        if (bitmapSize.width === 0 || bitmapSize.height === 0) throw new TypeError('Rendering target could only be created using a bitmap with positive integer width and height');
        this._bitmapSize = bitmapSize;
        this._context = context;
    }
    CanvasRenderingTarget2D.prototype.useMediaCoordinateSpace = function(f) {
        try {
            this._context.save();
            // do not use resetTransform to support old versions of Edge
            this._context.setTransform(1, 0, 0, 1, 0, 0);
            this._context.scale(this._horizontalPixelRatio, this._verticalPixelRatio);
            return f({
                context: this._context,
                mediaSize: this._mediaSize
            });
        } finally{
            this._context.restore();
        }
    };
    CanvasRenderingTarget2D.prototype.useBitmapCoordinateSpace = function(f) {
        try {
            this._context.save();
            // do not use resetTransform to support old versions of Edge
            this._context.setTransform(1, 0, 0, 1, 0, 0);
            return f({
                context: this._context,
                mediaSize: this._mediaSize,
                bitmapSize: this._bitmapSize,
                horizontalPixelRatio: this._horizontalPixelRatio,
                verticalPixelRatio: this._verticalPixelRatio
            });
        } finally{
            this._context.restore();
        }
    };
    Object.defineProperty(CanvasRenderingTarget2D.prototype, "_horizontalPixelRatio", {
        get: function() {
            return this._bitmapSize.width / this._mediaSize.width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasRenderingTarget2D.prototype, "_verticalPixelRatio", {
        get: function() {
            return this._bitmapSize.height / this._mediaSize.height;
        },
        enumerable: false,
        configurable: true
    });
    return CanvasRenderingTarget2D;
}();
function $eb48b24f0fffebe8$export$279ad88fbb07063a(binding, contextOptions) {
    var mediaSize = binding.canvasElementClientSize;
    var bitmapSize = binding.bitmapSize;
    var context = binding.canvasElement.getContext('2d', contextOptions);
    if (context === null) throw new Error('Could not get 2d drawing context from bound canvas element. Has the canvas already been set to a different context mode?');
    return new $eb48b24f0fffebe8$export$d9009780fa8cf0a4(context, mediaSize, bitmapSize);
}
function $eb48b24f0fffebe8$export$7130a2243f9306b6(binding, contextOptions) {
    var mediaSize = binding.canvasElementClientSize;
    if (mediaSize.width === 0 || mediaSize.height === 0) return null;
    var bitmapSize = binding.bitmapSize;
    if (bitmapSize.width === 0 || bitmapSize.height === 0) return null;
    var context = binding.canvasElement.getContext('2d', contextOptions);
    if (context === null) return null;
    return new $eb48b24f0fffebe8$export$d9009780fa8cf0a4(context, mediaSize, bitmapSize);
}

});



parcelRegister("4z9p8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04ccdecfb50a943b$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $04ccdecfb50a943b$export$a2387ed3b5d536eb = {
    name: "chevrons-right",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m6 17 5-5-5-5",
                key: "xnjwq"
            }
        ],
        [
            "path",
            {
                d: "m13 17 5-5-5-5",
                key: "17xmmf"
            }
        ]
    ]
};
$04ccdecfb50a943b$export$a2387ed3b5d536eb.node;
const $04ccdecfb50a943b$export$2e2bcd8739ae039 = (0, $hHhnY.default)($04ccdecfb50a943b$export$a2387ed3b5d536eb);

});

parcelRegister("dgdqP", function(module, exports) {

$parcel$export(module.exports, "themeColors", function () { return $a6aed876de46b536$export$4aa0a1b480cdb1b6; });
$parcel$export(module.exports, "themeTokenDefinitions", function () { return $a6aed876de46b536$export$b92716a937ca4e2c; });
$parcel$export(module.exports, "strategySeriesColors", function () { return $a6aed876de46b536$export$c6b1cac1a36a183; });
const $a6aed876de46b536$export$4aa0a1b480cdb1b6 = {
    background: "#131321",
    surface: "#131321",
    surface2: "#191930",
    surface3: "#121222",
    surface4: "#0f0f27",
    surfaceHover: "#32384a",
    foreground: "#f4f4f5",
    textStrong: "#ffffff",
    muted: "#a1a1aa",
    mutedDark: "#6b7280",
    line: "#1a1f2b",
    lineSoft: "#151924",
    lineStrong: "#262c39",
    lineChartVert: "#202536",
    lineChartHorz: "#191d2a",
    linePane: "#1f2430",
    neon: "#6bdcc0",
    neonArea: "#6bdcc020",
    neonTransparent: "#6bdcc000",
    success: "#75cc97",
    successDark: "#059669",
    successMarker: "rgba(117,204,151,0.65)",
    danger: "#e98188",
    dangerDark: "#dc2626",
    dangerLight: "#e98188",
    dangerArea: "#e9818820",
    dangerTransparent: "#e9818800",
    dangerMarker: "rgba(233,129,136,0.65)",
    warning: "#e8bd58",
    warningBright: "#f0ce7e",
    warningMarker: "rgba(232,189,88,0.7)",
    info: "#7eaee6",
    infoDark: "#6297d3",
    transparent: "rgba(0,0,0,0)",
    gridSoft: "#ffffff05",
    gridStrong: "#ffffff10",
    gridScene: "#333333",
    hoverSurface: "#1a1a2e",
    hoverBorder: "#ffffff20"
};
const $a6aed876de46b536$export$b92716a937ca4e2c = [
    {
        name: "Canvas",
        value: $a6aed876de46b536$export$4aa0a1b480cdb1b6.background,
        variable: "--background",
        description: "The deep trading workspace background."
    },
    {
        name: "Surface",
        value: $a6aed876de46b536$export$4aa0a1b480cdb1b6.surface,
        variable: "--surface",
        description: "Opaque navigation, modal, and panel surfaces."
    },
    {
        name: "Foreground",
        value: $a6aed876de46b536$export$4aa0a1b480cdb1b6.foreground,
        variable: "--foreground",
        description: "Primary text and high-emphasis content."
    },
    {
        name: "Neon",
        value: $a6aed876de46b536$export$4aa0a1b480cdb1b6.neon,
        variable: "--neon",
        description: "Interactive focus, selected state, and brand accent."
    },
    {
        name: "Success",
        value: $a6aed876de46b536$export$4aa0a1b480cdb1b6.success,
        variable: "--success",
        description: "Connected, active, and profitable states."
    },
    {
        name: "Warning",
        value: $a6aed876de46b536$export$4aa0a1b480cdb1b6.warning,
        variable: "--warning",
        description: "Attention, acting-as, and degraded states."
    },
    {
        name: "Danger",
        value: $a6aed876de46b536$export$4aa0a1b480cdb1b6.danger,
        variable: "--danger",
        description: "Errors, losses, and destructive actions."
    },
    {
        name: "Info",
        value: $a6aed876de46b536$export$4aa0a1b480cdb1b6.info,
        variable: "--info",
        description: "Transport and informational status."
    }
];
const $a6aed876de46b536$export$c6b1cac1a36a183 = [
    "#f472b6",
    "#818cf8",
    "#34d399",
    "#fbbf24",
    "#a78bfa",
    "#60a5fa"
];

});

parcelRegister("fJI9q", function(module, exports) {

$parcel$export(module.exports, "isIntradayTimeframe", function () { return $0bc80823296f541a$export$4ae652e5f2b09e59; });
$parcel$export(module.exports, "shouldShowBacktestTradeMarkers", function () { return $0bc80823296f541a$export$8b7e037833eaa655; });
$parcel$export(module.exports, "toDayString", function () { return $0bc80823296f541a$export$ef778d3dcf2cb3db; });
$parcel$export(module.exports, "prepareChartData", function () { return $0bc80823296f541a$export$cf1a640e9db67d4b; });
const $0bc80823296f541a$export$4ae652e5f2b09e59 = (timeframe)=>{
    const normalized = String(timeframe ?? '').trim().toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
    if (normalized === 'minute' || normalized === 'hour') return true;
    return /^\d+\s*(?:m|min|mins|minute|minutes|h|hr|hrs|hour|hours)$/.test(normalized);
};
const $0bc80823296f541a$export$8b7e037833eaa655 = (resolution, timeframe)=>resolution === 'native' && $0bc80823296f541a$export$4ae652e5f2b09e59(timeframe);
const $0bc80823296f541a$export$ef778d3dcf2cb3db = (value)=>{
    if (!value) return '';
    if (value.includes('T')) return value.split('T')[0];
    if (value.includes(' ')) return value.split(' ')[0];
    return value;
};
const $0bc80823296f541a$export$cf1a640e9db67d4b = ({ data: data, lowerPaneData: lowerPaneData, type: type, resolution: resolution, showEquityCandles: showEquityCandles, displayMode: displayMode })=>{
    let processedData = [
        ...data
    ];
    let processedLowerPaneData = [
        ...lowerPaneData
    ];
    if (resolution === '1D') {
        const dailyMap = {};
        data.forEach((item)=>{
            const day = $0bc80823296f541a$export$ef778d3dcf2cb3db(item.date);
            if (!dailyMap[day]) {
                dailyMap[day] = {
                    ...item,
                    date: day
                };
                dailyMap[day].equity_open = item.equity;
                dailyMap[day].equity_high = item.equity;
                dailyMap[day].equity_low = item.equity;
                dailyMap[day].equity_close = item.equity;
                if (type === 'symbol') {
                    dailyMap[day].high = item.high;
                    dailyMap[day].low = item.low;
                    dailyMap[day].open = item.open;
                    dailyMap[day].close = item.close;
                    dailyMap[day].ma30 = item.ma30 ?? null;
                    dailyMap[day].ma200 = item.ma200 ?? null;
                }
            } else {
                const aggregate = dailyMap[day];
                aggregate.equity = item.equity;
                aggregate.equity_high = Math.max(aggregate.equity_high !== undefined ? aggregate.equity_high : aggregate.equity, item.equity);
                aggregate.equity_low = Math.min(aggregate.equity_low !== undefined ? aggregate.equity_low : aggregate.equity, item.equity);
                aggregate.equity_close = item.equity;
                if (type === 'equity') Object.keys(item).forEach((key)=>{
                    if (key.startsWith('equity_')) aggregate[key] = item[key];
                });
                else if (type === 'symbol') {
                    aggregate.high = Math.max(aggregate.high, item.high);
                    aggregate.low = Math.min(aggregate.low, item.low);
                    aggregate.close = item.close;
                    if (item.ma30 != null) aggregate.ma30 = item.ma30;
                    if (item.ma200 != null) aggregate.ma200 = item.ma200;
                }
            }
        });
        processedData = Object.values(dailyMap).sort((left, right)=>left.date.localeCompare(right.date));
        if (type === 'symbol') processedData = processedData.map((point, index, points)=>{
            const closes = points.slice(0, index + 1).map((item)=>Number(item.close)).filter(Number.isFinite);
            const average = (period)=>closes.length < period ? null : closes.slice(-period).reduce((sum, value)=>sum + value, 0) / period;
            return {
                ...point,
                ma30: average(30),
                ma200: average(200)
            };
        });
        if (lowerPaneData.length > 0) {
            const dailyLowerMap = {};
            lowerPaneData.forEach((item)=>{
                const day = $0bc80823296f541a$export$ef778d3dcf2cb3db(item.date);
                dailyLowerMap[day] = {
                    ...item,
                    date: day
                };
            });
            processedLowerPaneData = Object.values(dailyLowerMap).sort((left, right)=>left.date.localeCompare(right.date));
        }
    }
    if (showEquityCandles) processedData = processedData.map((point)=>({
            ...point,
            open: point.equity_open !== undefined ? point.equity_open : point.equity,
            high: point.equity_high !== undefined ? point.equity_high : point.equity,
            low: point.equity_low !== undefined ? point.equity_low : point.equity,
            close: point.equity_close !== undefined ? point.equity_close : point.equity
        }));
    if (type === 'equity' && displayMode === 'percent' && processedData.length > 0) {
        const startEquity = processedData[0].equity || 1;
        const strategyStarts = {};
        processedData.forEach((point)=>{
            Object.keys(point).forEach((key)=>{
                if (key.startsWith('equity_') && key !== 'equity_curve') {
                    if (!strategyStarts[key] && point[key] && point[key] !== 0) strategyStarts[key] = point[key];
                }
            });
        });
        processedData = processedData.map((point)=>{
            const normalized = {
                ...point
            };
            normalized.equity = (point.equity / startEquity - 1) * 100;
            Object.keys(point).forEach((key)=>{
                if (key.startsWith('equity_') && key !== 'equity_curve') {
                    const start = strategyStarts[key] || 1;
                    normalized[key] = (point[key] / start - 1) * 100;
                }
            });
            return normalized;
        });
    }
    return {
        data: processedData,
        lowerPaneData: processedLowerPaneData
    };
};

});

parcelRegister("fbk3Z", function(module, exports) {

$parcel$export(module.exports, "buildThemedChartOptions", function () { return $5ab737c06d24e44d$export$fc8bedd5586bdcbb; });

var $bzz2o = parcelRequire("bzz2o");

var $dgdqP = parcelRequire("dgdqP");
const $5ab737c06d24e44d$export$fc8bedd5586bdcbb = ({ width: width, height: height, timeVisible: timeVisible = true, rightOffset: rightOffset, rightOffsetPixels: rightOffsetPixels, shiftVisibleRangeOnNewBar: shiftVisibleRangeOnNewBar, includePaneSeparators: includePaneSeparators = false })=>({
        layout: {
            background: {
                type: (0, $bzz2o.ColorType).Solid,
                color: (0, $dgdqP.themeColors).surface3
            },
            textColor: (0, $dgdqP.themeColors).muted,
            ...includePaneSeparators ? {
                panes: {
                    separatorColor: (0, $dgdqP.themeColors).linePane,
                    separatorHoverColor: (0, $dgdqP.themeColors).surfaceHover
                }
            } : {}
        },
        grid: {
            vertLines: {
                color: (0, $dgdqP.themeColors).lineChartVert
            },
            horzLines: {
                color: (0, $dgdqP.themeColors).lineChartHorz
            }
        },
        width: width,
        height: height,
        rightPriceScale: {
            borderColor: (0, $dgdqP.themeColors).lineStrong
        },
        timeScale: {
            timeVisible: timeVisible,
            secondsVisible: false,
            borderColor: (0, $dgdqP.themeColors).lineStrong,
            ...rightOffset === undefined ? {} : {
                rightOffset: rightOffset
            },
            ...rightOffsetPixels === undefined ? {} : {
                rightOffsetPixels: rightOffsetPixels
            },
            ...shiftVisibleRangeOnNewBar === undefined ? {} : {
                shiftVisibleRangeOnNewBar: shiftVisibleRangeOnNewBar
            }
        },
        crosshair: {
            vertLine: {
                color: (0, $dgdqP.themeColors).mutedDark,
                width: 1,
                style: 3
            },
            horzLine: {
                color: (0, $dgdqP.themeColors).mutedDark,
                width: 1,
                style: 3
            }
        }
    });

});


parcelRegister("aNXfT", function(module, exports) {

$parcel$export(module.exports, "securityTypeOptions", function () { return $bad348e9ffb8e518$export$bcbfc4ede93d1d11; });
$parcel$export(module.exports, "getPositionDisplaySymbol", function () { return $bad348e9ffb8e518$export$622bfa79801e4cb8; });
$parcel$export(module.exports, "getPositionStrategies", function () { return $bad348e9ffb8e518$export$54a7d64bb352b58b; });
$parcel$export(module.exports, "getPositionDisplayStrategies", function () { return $bad348e9ffb8e518$export$cbd42a5f90889aa7; });
$parcel$export(module.exports, "getNQMMPortfolioPositions", function () { return $bad348e9ffb8e518$export$ce9c686c07132513; });
$parcel$export(module.exports, "getPositionMetadataKey", function () { return $bad348e9ffb8e518$export$b30029e0af7bcf4e; });
$parcel$export(module.exports, "getPositionRowKey", function () { return $bad348e9ffb8e518$export$9c28eaf9f60ab534; });
$parcel$export(module.exports, "getSecurityType", function () { return $bad348e9ffb8e518$export$8cbcd8185451f411; });
$parcel$export(module.exports, "formatPlainNumber", function () { return $bad348e9ffb8e518$export$446726de196e5af1; });
$parcel$export(module.exports, "getStrategyTagColor", function () { return $bad348e9ffb8e518$export$a7eb173f79c3c8a1; });
$parcel$export(module.exports, "getPositionQuoteIdentifiers", function () { return $bad348e9ffb8e518$export$800b9dc39dc23b9d; });
$parcel$export(module.exports, "addLiveQuoteToPosition", function () { return $bad348e9ffb8e518$export$8015fdbe4ffe9420; });
$parcel$export(module.exports, "getPositionStrategyOptions", function () { return $bad348e9ffb8e518$export$29debdfaf727af90; });
$parcel$export(module.exports, "getPositionStrategyNameOptions", function () { return $bad348e9ffb8e518$export$cb9132a73d9c734; });
$parcel$export(module.exports, "filterPositions", function () { return $bad348e9ffb8e518$export$8b7d5776eaeacaab; });

var $9YmcI = parcelRequire("9YmcI");
const $bad348e9ffb8e518$export$bcbfc4ede93d1d11 = [
    {
        value: 'ALL',
        label: 'All assets'
    },
    {
        value: 'STK',
        label: 'Stocks'
    },
    {
        value: 'CFD',
        label: 'CFDs'
    },
    {
        value: 'FUT',
        label: 'Futures'
    },
    {
        value: 'OPT',
        label: 'Options'
    }
];
const $bad348e9ffb8e518$export$622bfa79801e4cb8 = (position)=>{
    if (position.display_symbol) return position.display_symbol;
    if (position.local_symbol) return position.local_symbol;
    if (position.secType === 'FUT' && position.last_trade_date_or_contract_month) return `${position.symbol} ${position.last_trade_date_or_contract_month}`;
    return position.symbol;
};
const $bad348e9ffb8e518$export$54a7d64bb352b58b = (position)=>{
    if (position.strategies?.length) return position.strategies;
    if (position.strategy) return position.strategy.split(' + ').filter(Boolean);
    return [
        'UNASSIGNED'
    ];
};
const $bad348e9ffb8e518$export$cbd42a5f90889aa7 = (position)=>{
    const displayName = position.custom_strategy_name?.trim();
    return displayName ? [
        displayName
    ] : $bad348e9ffb8e518$export$54a7d64bb352b58b(position);
};
const $bad348e9ffb8e518$export$ce9c686c07132513 = (positions)=>{
    const result = {};
    for (const position of positions){
        const symbol = position.symbol?.trim().toUpperCase();
        const quantity = Number(position.quantity);
        if (!symbol || !Number.isFinite(quantity) || quantity === 0 || String(position.secType || 'STK').toUpperCase() !== 'STK' || !$bad348e9ffb8e518$export$cbd42a5f90889aa7(position).some((name)=>name.trim().toUpperCase() === 'NQMM')) continue;
        result[symbol] = (result[symbol] || 0) + quantity;
    }
    return result;
};
const $bad348e9ffb8e518$export$b30029e0af7bcf4e = (position)=>{
    if (position.position_key) return position.position_key;
    if (position.contract_key) return position.contract_key;
    if (Number(position.con_id) > 0) return `conid:${Number(position.con_id)}`;
    return `contract:${[
        position.secType,
        position.symbol,
        position.local_symbol,
        position.last_trade_date_or_contract_month,
        position.exchange,
        position.currency,
        position.trading_class,
        position.multiplier
    ].map((value)=>String(value || '').toUpperCase()).join('|')}`;
};
const $bad348e9ffb8e518$export$9c28eaf9f60ab534 = (position)=>$bad348e9ffb8e518$export$b30029e0af7bcf4e(position);
const $bad348e9ffb8e518$export$8cbcd8185451f411 = (item)=>String(item.secType || 'STK').toUpperCase();
const $bad348e9ffb8e518$export$446726de196e5af1 = (value)=>{
    if (value === undefined || value === null || !Number.isFinite(Number(value))) return '-';
    return Number(value).toLocaleString(undefined, {
        maximumFractionDigits: 2
    });
};
const $bad348e9ffb8e518$export$a7eb173f79c3c8a1 = (tag)=>tag.color && /^#[0-9A-F]{6}$/i.test(tag.color) ? tag.color : '#14B8A6';
const $bad348e9ffb8e518$export$800b9dc39dc23b9d = (positions)=>positions.map((position)=>(0, $9YmcI.quoteSubscriptionIdentifier)(position.symbol, {
            sec_type: position.secType,
            local_symbol: position.local_symbol
        }));
const $bad348e9ffb8e518$export$8015fdbe4ffe9420 = (position, quote, connectionStatus, positionsStale)=>{
    if (quote) {
        const presentation = (0, $9YmcI.getPricePresentation)({
            quote: quote,
            connectionStatus: connectionStatus,
            hasPrice: Number.isFinite(Number(quote.price)),
            streamed: true
        });
        return {
            ...position,
            current_price: quote.price,
            price_source: 'MARKET_DATA_HUB',
            quote_stale: presentation.stale,
            quote_status: presentation.status
        };
    }
    return positionsStale ? {
        ...position,
        quote_stale: true
    } : position;
};
const $bad348e9ffb8e518$export$29debdfaf727af90 = (positions)=>Array.from(new Set(positions.flatMap((position)=>$bad348e9ffb8e518$export$cbd42a5f90889aa7(position)))).sort();
const $bad348e9ffb8e518$export$cb9132a73d9c734 = (positions)=>Array.from(new Set([
        // Keep core strategy labels available for manual correction even when the
        // current open positions have not yet been attributed to that strategy.
        'ON',
        'ORB',
        'DT',
        'NQMM',
        'MORB',
        ...positions.flatMap((position)=>[
                ...$bad348e9ffb8e518$export$54a7d64bb352b58b(position),
                position.custom_strategy_name || ''
            ])
    ])).map((name)=>name.trim()).filter((name)=>name && name !== 'UNASSIGNED').sort((left, right)=>left.localeCompare(right));
const $bad348e9ffb8e518$export$8b7d5776eaeacaab = (positions, strategyFilter, securityTypeFilter)=>positions.filter((position)=>{
        const matchesStrategy = strategyFilter === 'ALL' || $bad348e9ffb8e518$export$cbd42a5f90889aa7(position).includes(strategyFilter);
        const matchesSecurityType = securityTypeFilter === 'ALL' || $bad348e9ffb8e518$export$8cbcd8185451f411(position) === securityTypeFilter;
        return matchesStrategy && matchesSecurityType;
    });

});
parcelRegister("9YmcI", function(module, exports) {

$parcel$export(module.exports, "quoteSubscriptionIdentifier", function () { return $a1a47f98cab0d925$export$58cfaa433673b2cf; });
$parcel$export(module.exports, "getPricePresentation", function () { return $a1a47f98cab0d925$export$4425ea2f78ae1f58; });
const $a1a47f98cab0d925$export$58cfaa433673b2cf = (symbol, quote)=>String(quote?.sec_type || '').toUpperCase() === 'FUT' ? quote?.local_symbol || symbol : symbol;
const $a1a47f98cab0d925$export$6a168eb6e934dc5c = (quote, now = Date.now(), defaultStaleAfterSeconds = 90)=>{
    if (!quote) return false;
    if (quote.stale) return true;
    const timestamp = quote.exchange_time || quote.received_at;
    const observedAt = timestamp ? Date.parse(timestamp) : Number.NaN;
    return !Number.isFinite(observedAt) || (now - observedAt) / 1000 > (quote.stale_after_seconds ?? defaultStaleAfterSeconds);
};
const $a1a47f98cab0d925$export$4425ea2f78ae1f58 = ({ quote: quote, connectionStatus: connectionStatus, hasPrice: hasPrice = quote?.price != null, streamed: streamed = false, now: now = Date.now(), defaultStaleAfterSeconds: defaultStaleAfterSeconds = 90 })=>{
    const disconnected = connectionStatus !== 'CONNECTED';
    const stale = hasPrice && (disconnected || $a1a47f98cab0d925$export$6a168eb6e934dc5c(quote, now, defaultStaleAfterSeconds));
    const normalizedStatus = String(quote?.data_status || '').toUpperCase();
    const frozen = Boolean(quote?.frozen) || normalizedStatus === 'FROZEN';
    const delayed = Boolean(quote?.delayed) || normalizedStatus === 'DELAYED';
    const status = stale ? 'STALE' : frozen ? 'FROZEN' : delayed ? 'DELAYED' : streamed ? 'LIVE' : 'MARK';
    const caution = status === 'STALE' || status === 'DELAYED' || status === 'FROZEN';
    return {
        status: status,
        stale: stale,
        // Frozen snapshots and stale values are reference-only; never use them to
        // populate an executable price or derive a trailing stop estimate.
        usableForPricing: hasPrice && status !== 'STALE' && status !== 'FROZEN',
        badgeClassName: caution ? 'border-amber-400/25 bg-amber-400/10 text-amber-300' : 'border-emerald-400/25 bg-emerald-400/10 text-emerald-300',
        priceClassName: caution ? 'text-amber-300' : 'text-emerald-400'
    };
};

});


parcelRegister("jxNNZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c63ece11e27cb3a5$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $c63ece11e27cb3a5$export$a2387ed3b5d536eb = {
    name: "chevron-down",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m6 9 6 6 6-6",
                key: "qrunsl"
            }
        ]
    ]
};
$c63ece11e27cb3a5$export$a2387ed3b5d536eb.node;
const $c63ece11e27cb3a5$export$2e2bcd8739ae039 = (0, $hHhnY.default)($c63ece11e27cb3a5$export$a2387ed3b5d536eb);

});

parcelRegister("e5esH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1aa4492cd2e5211$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $a1aa4492cd2e5211$export$a2387ed3b5d536eb = {
    name: "chevron-up",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m18 15-6-6-6 6",
                key: "153udz"
            }
        ]
    ]
};
$a1aa4492cd2e5211$export$a2387ed3b5d536eb.node;
const $a1aa4492cd2e5211$export$2e2bcd8739ae039 = (0, $hHhnY.default)($a1aa4492cd2e5211$export$a2387ed3b5d536eb);

});

parcelRegister("1RsxC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46ec7d91190a530a$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $46ec7d91190a530a$export$a2387ed3b5d536eb = {
    name: "rotate-ccw-clock",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
                key: "1357e3"
            }
        ],
        [
            "path",
            {
                d: "M3 3v5h5",
                key: "1xhq8a"
            }
        ],
        [
            "path",
            {
                d: "M12 7v5l4 2",
                key: "1fdv2h"
            }
        ]
    ],
    aliases: [
        "history"
    ]
};
$46ec7d91190a530a$export$a2387ed3b5d536eb.node;
const $46ec7d91190a530a$export$2e2bcd8739ae039 = (0, $hHhnY.default)($46ec7d91190a530a$export$a2387ed3b5d536eb);

});

parcelRegister("8F6u8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ceb030c91ba0ee8d$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $ceb030c91ba0ee8d$export$a2387ed3b5d536eb = {
    name: "rotate-ccw",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
                key: "1357e3"
            }
        ],
        [
            "path",
            {
                d: "M3 3v5h5",
                key: "1xhq8a"
            }
        ]
    ]
};
$ceb030c91ba0ee8d$export$a2387ed3b5d536eb.node;
const $ceb030c91ba0ee8d$export$2e2bcd8739ae039 = (0, $hHhnY.default)($ceb030c91ba0ee8d$export$a2387ed3b5d536eb);

});

parcelRegister("84yk3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2ef14d33a325c2b$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $e2ef14d33a325c2b$export$a2387ed3b5d536eb = {
    name: "save",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
                key: "1c8476"
            }
        ],
        [
            "path",
            {
                d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7",
                key: "1ydtos"
            }
        ],
        [
            "path",
            {
                d: "M7 3v4a1 1 0 0 0 1 1h7",
                key: "t51u73"
            }
        ]
    ]
};
$e2ef14d33a325c2b$export$a2387ed3b5d536eb.node;
const $e2ef14d33a325c2b$export$2e2bcd8739ae039 = (0, $hHhnY.default)($e2ef14d33a325c2b$export$a2387ed3b5d536eb);

});

parcelRegister("gECFA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b97ed9fd0578a8ff$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $b97ed9fd0578a8ff$export$a2387ed3b5d536eb = {
    name: "pause",
    size: 24,
    node: [
        [
            "rect",
            {
                x: "14",
                y: "3",
                width: "5",
                height: "18",
                rx: "1",
                key: "kaeet6"
            }
        ],
        [
            "rect",
            {
                x: "5",
                y: "3",
                width: "5",
                height: "18",
                rx: "1",
                key: "1wsw3u"
            }
        ]
    ]
};
$b97ed9fd0578a8ff$export$a2387ed3b5d536eb.node;
const $b97ed9fd0578a8ff$export$2e2bcd8739ae039 = (0, $hHhnY.default)($b97ed9fd0578a8ff$export$a2387ed3b5d536eb);

});

parcelRegister("c3l2j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8e3c6755bd597d3$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $d8e3c6755bd597d3$export$a2387ed3b5d536eb = {
    name: "shield-check",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
                key: "oel41y"
            }
        ],
        [
            "path",
            {
                d: "m9 12 2 2 4-4",
                key: "dzmm74"
            }
        ]
    ]
};
$d8e3c6755bd597d3$export$a2387ed3b5d536eb.node;
const $d8e3c6755bd597d3$export$2e2bcd8739ae039 = (0, $hHhnY.default)($d8e3c6755bd597d3$export$a2387ed3b5d536eb);

});

parcelRegister("4QgfA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47e2bc4ed1a99fc8$export$2e2bcd8739ae039; });

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $j8jJ4 = parcelRequire("j8jJ4");

var $e4aOX = parcelRequire("e4aOX");

var $dgdqP = parcelRequire("dgdqP");

var $etHUa = parcelRequire("etHUa");

var $zs3Np = parcelRequire("zs3Np");

var $5xHjn = parcelRequire("5xHjn");

var $dgqjv = parcelRequire("dgqjv");

var $3KrHx = parcelRequire("3KrHx");

var $kv9Z9 = parcelRequire("kv9Z9");

var $ltr73 = parcelRequire("ltr73");

var $fyvvE = parcelRequire("fyvvE");
const $47e2bc4ed1a99fc8$var$isoDateForTime = (time)=>new Date(time * 1000).toISOString();
const $47e2bc4ed1a99fc8$var$isoDateForChartTime = (time)=>{
    if (typeof time === 'number') return $47e2bc4ed1a99fc8$var$isoDateForTime(time);
    if (typeof time === 'string') return time;
    const month = String(time.month).padStart(2, '0');
    const day = String(time.day).padStart(2, '0');
    return `${time.year}-${month}-${day}`;
};
const $47e2bc4ed1a99fc8$var$createStrategyOverlays = (bars, timeframe, strategy, status)=>{
    const overlays = [];
    const addSegment = (from, to, value, color)=>{
        if (!Number.isFinite(value) || from >= to) return;
        overlays.push({
            color: color,
            lineWidth: 2,
            data: [
                {
                    date: $47e2bc4ed1a99fc8$var$isoDateForTime(from),
                    value: value
                },
                {
                    date: $47e2bc4ed1a99fc8$var$isoDateForTime(to),
                    value: value
                }
            ]
        });
    };
    const addLine = (data, color, lineWidth = 2)=>{
        if (!data.length) return;
        overlays.push({
            color: color,
            lineWidth: lineWidth,
            data: data.map((point)=>({
                    date: $47e2bc4ed1a99fc8$var$isoDateForChartTime(point.time),
                    value: point.value
                }))
        });
    };
    if (strategy === 'ORB') {
        (0, $fyvvE.groupByNyDay)(bars).forEach(({ bars: dayBars })=>{
            const sessionBars = (0, $fyvvE.regularSessionBars)(dayBars);
            if (sessionBars.length < 2) return;
            const openingBar = sessionBars[0];
            const { from: from, to: to } = (0, $fyvvE.sessionSegmentBounds)(sessionBars, timeframe);
            addSegment(from, to, openingBar.high, (0, $dgdqP.themeColors).success);
            addSegment(from, to, openingBar.low, (0, $dgdqP.themeColors).dangerLight);
        });
        const dayGroups = (0, $fyvvE.groupByNyDay)(bars);
        const latestDay = dayGroups[dayGroups.length - 1];
        const latestSessionBars = latestDay ? (0, $fyvvE.regularSessionBars)(latestDay.bars) : [];
        if (latestSessionBars.length > 1 && (0, $etHUa.hasFreshLevels)(status) && (0, $etHUa.isCurrentNySessionDate)(status) && (0, $etHUa.isValidPriceLevel)(status?.resistance) && (0, $etHUa.isValidPriceLevel)(status?.support)) {
            const { from: from, to: to } = (0, $fyvvE.sessionSegmentBounds)(latestSessionBars, timeframe);
            addSegment(from, to, Number(status.resistance), (0, $dgdqP.themeColors).neon);
            addSegment(from, to, Number(status.support), (0, $dgdqP.themeColors).warningBright);
        }
    }
    if (strategy === 'DT') {
        const dayGroups = (0, $fyvvE.groupByNyDay)(bars);
        const dailyTrueRanges = [];
        let previousClose = null;
        const thresholdFactor = Number(status?.threshold_factor || 0.5);
        dayGroups.forEach(({ bars: dayBars }, dayIndex)=>{
            const sessionBars = (0, $fyvvE.regularSessionBars)(dayBars);
            if (sessionBars.length < 2) return;
            const high = Math.max(...sessionBars.map((bar)=>bar.high));
            const low = Math.min(...sessionBars.map((bar)=>bar.low));
            const close = sessionBars[sessionBars.length - 1].close;
            const trueRange = previousClose == null ? high - low : Math.max(high - low, Math.abs(high - previousClose), Math.abs(low - previousClose));
            const historicalAtr = (0, $fyvvE.average)(dailyTrueRanges.slice(-14));
            dailyTrueRanges.push(trueRange);
            previousClose = close;
            const { from: from, to: to } = (0, $fyvvE.sessionSegmentBounds)(sessionBars, timeframe);
            const isLatestDay = dayIndex === dayGroups.length - 1;
            const hasFreshStatusLevels = isLatestDay && (0, $etHUa.hasFreshLevels)(status) && (0, $etHUa.isCurrentNySessionDate)(status);
            const dailyOpen = hasFreshStatusLevels && (0, $etHUa.isValidPriceLevel)(status?.daily_open) ? Number(status.daily_open) : sessionBars[0].open;
            const threshold = hasFreshStatusLevels && Number.isFinite(Number(status?.intraday_threshold)) && Number(status?.intraday_threshold) > 0 ? Number(status.intraday_threshold) : historicalAtr == null ? null : historicalAtr * thresholdFactor;
            addSegment(from, to, dailyOpen, (0, $dgdqP.themeColors).info);
            if (threshold != null && Number.isFinite(threshold)) {
                addSegment(from, to, dailyOpen + threshold, (0, $dgdqP.themeColors).success);
                addSegment(from, to, dailyOpen - threshold, (0, $dgdqP.themeColors).dangerLight);
            }
        });
    }
    if (strategy === 'ON') {
        addLine((0, $fyvvE.smaData)(bars, 30), (0, $dgdqP.themeColors).success, 1);
        addLine((0, $fyvvE.smaData)(bars, 200), (0, $dgdqP.themeColors).warningBright, 1);
    }
    if (strategy === 'MORB') {
        if (timeframe === '1d') {
            addLine((0, $fyvvE.smaData)(bars, Number(status?.entry_sma_period || 50), timeframe), (0, $dgdqP.themeColors).warning, 1);
            addLine((0, $fyvvE.smaData)(bars, Number(status?.sma_period || 10), timeframe), (0, $dgdqP.themeColors).warningBright, 1);
        } else {
            const entryMinutes = Number(status?.entry_minutes || 10);
            const atrMultiple = Number(status?.atr_multiple || 0.5);
            const direction = String(status?.direction || 'LONG').toUpperCase();
            const rangeBars = Math.max(1, Math.ceil(entryMinutes / Math.max(1, (0, $fyvvE.timeframeSeconds)(timeframe) / 60)));
            const dayGroups = (0, $fyvvE.groupByNyDay)(bars);
            let previousClose = null;
            const trueRanges = [];
            dayGroups.forEach(({ bars: dayBars }, dayIndex)=>{
                const sessionBars = (0, $fyvvE.regularSessionBars)(dayBars);
                if (sessionBars.length <= rangeBars) return;
                const openingBars = sessionBars.slice(0, rangeBars);
                const high = Math.max(...openingBars.map((bar)=>bar.high));
                const low = Math.min(...openingBars.map((bar)=>bar.low));
                const dayHigh = Math.max(...sessionBars.map((bar)=>bar.high));
                const dayLow = Math.min(...sessionBars.map((bar)=>bar.low));
                const dayClose = sessionBars[sessionBars.length - 1].close;
                const trueRange = previousClose == null ? dayHigh - dayLow : Math.max(dayHigh - dayLow, Math.abs(dayHigh - previousClose), Math.abs(dayLow - previousClose));
                const historicalAtr = (0, $fyvvE.average)(trueRanges.slice(-14));
                trueRanges.push(trueRange);
                previousClose = dayClose;
                const configuredAtr = Number(status?.atr);
                const atr = dayIndex === dayGroups.length - 1 && Number.isFinite(configuredAtr) && configuredAtr > 0 ? configuredAtr : historicalAtr ?? trueRange;
                const { from: from, to: to } = (0, $fyvvE.sessionSegmentBounds)(sessionBars, timeframe);
                addSegment(from, to, openingBars[0].open, (0, $dgdqP.themeColors).info);
                addSegment(from, to, high, (0, $dgdqP.themeColors).success);
                addSegment(from, to, low, (0, $dgdqP.themeColors).dangerLight);
                if (Number.isFinite(atr) && atr > 0) {
                    const trigger = direction === 'SHORT' ? low - atr * atrMultiple : high + atr * atrMultiple;
                    addSegment(from, to, trigger, (0, $dgdqP.themeColors).warningBright);
                }
            });
            const latestDay = dayGroups[dayGroups.length - 1];
            const latestSession = latestDay ? (0, $fyvvE.regularSessionBars)(latestDay.bars) : [];
            if (latestSession.length > 1) {
                const { from: from, to: to } = (0, $fyvvE.sessionSegmentBounds)(latestSession, timeframe);
                const addStatusLevel = (value, color)=>{
                    if ((0, $etHUa.isValidPriceLevel)(value)) addSegment(from, to, Number(value), color);
                };
                addStatusLevel(status?.daily_open, (0, $dgdqP.themeColors).info);
                addStatusLevel(status?.entry_level, (0, $dgdqP.themeColors).neon);
                addStatusLevel(status?.entry_sma, (0, $dgdqP.themeColors).warning);
                addStatusLevel(status?.ten_sma, (0, $dgdqP.themeColors).warningBright);
                (Array.isArray(status?.simulated_stop_levels) ? status.simulated_stop_levels : []).forEach((value)=>addStatusLevel(value, (0, $dgdqP.themeColors).danger));
            }
        }
    }
    return overlays;
};
const $47e2bc4ed1a99fc8$var$StrategySymbolChart = ({ symbol: symbol, timeframe: timeframe, onTimeframeChange: onTimeframeChange, label: label, strategy: strategy, status: status, historicalSignals: historicalSignals = [] })=>{
    const { token: token } = (0, $e4aOX.useAuth)();
    const [bars, setBars] = (0, $jHEir.useState)([]);
    const [chartStyle, setChartStyle] = (0, $jHEir.useState)('candles');
    const [showMarkers, setShowMarkers] = (0, $jHEir.useState)(false);
    const [showExtendedHours, setShowExtendedHours] = (0, $jHEir.useState)(false);
    const [loading, setLoading] = (0, $jHEir.useState)(true);
    const [error, setError] = (0, $jHEir.useState)(null);
    (0, $jHEir.useEffect)(()=>{
        if (timeframe === '1d' && chartStyle !== 'candles') setChartStyle('candles');
    }, [
        timeframe,
        chartStyle
    ]);
    (0, $jHEir.useEffect)(()=>{
        if (!token) return undefined;
        const controller = new AbortController();
        const fetchHistory = async ()=>{
            setBars([]);
            setLoading(true);
            setError(null);
            try {
                const result = await (0, $zs3Np.tradingApi).getHistoricalData(symbol, timeframe, (0, $fyvvE.durationForStrategy)(timeframe, strategy), 'auto', controller.signal);
                if (!result.success || !Array.isArray(result.data)) throw new Error(result.error || 'No chart data returned');
                const loadedBars = result.data.filter((0, $5xHjn.isValidHistoricalBar)).map((bar)=>({
                        time: bar.time,
                        open: bar.open,
                        high: bar.high,
                        low: bar.low,
                        close: bar.close,
                        volume: bar.volume ?? 0
                    })).sort((left, right)=>left.time - right.time);
                setBars(timeframe === '1d' ? (0, $fyvvE.consolidateDailyBars)(loadedBars) : loadedBars);
            } catch (err) {
                if (!controller.signal.aborted) {
                    setBars([]);
                    setError(err instanceof Error ? err.message : 'Failed to load chart');
                }
            } finally{
                if (!controller.signal.aborted) setLoading(false);
            }
        };
        fetchHistory();
        return ()=>controller.abort();
    }, [
        symbol,
        timeframe,
        token,
        strategy
    ]);
    const displayBars = (0, $jHEir.useMemo)(()=>timeframe === '1d' || showExtendedHours ? bars : (0, $fyvvE.regularSessionBars)(bars), [
        bars,
        timeframe,
        showExtendedHours
    ]);
    const chartData = (0, $jHEir.useMemo)(()=>displayBars.map((bar)=>({
                date: $47e2bc4ed1a99fc8$var$isoDateForTime(bar.time),
                open: bar.open,
                high: bar.high,
                low: bar.low,
                close: bar.close,
                volume: bar.volume
            })), [
        displayBars
    ]);
    const lineOverlays = (0, $jHEir.useMemo)(()=>$47e2bc4ed1a99fc8$var$createStrategyOverlays(displayBars, timeframe, strategy, status), [
        displayBars,
        timeframe,
        strategy,
        status
    ]);
    const volumeData = (0, $jHEir.useMemo)(()=>{
        const values = strategy === 'MORB' ? (0, $fyvvE.managedOrbVolumeData)(displayBars, status, (0, $dgdqP.themeColors)) : displayBars.map((bar)=>({
                time: (0, $fyvvE.chartTimeFor)(bar.time, timeframe),
                value: Number(bar.volume || 0),
                color: Number(bar.close) >= Number(bar.open) ? (0, $dgdqP.themeColors).success : (0, $dgdqP.themeColors).danger
            }));
        return timeframe === '1d' ? [] : values.map((point)=>({
                date: $47e2bc4ed1a99fc8$var$isoDateForChartTime(point.time),
                value: point.value,
                color: point.color
            }));
    }, [
        displayBars,
        timeframe,
        strategy,
        status
    ]);
    const customMarkers = (0, $jHEir.useMemo)(()=>{
        if (strategy !== 'MORB' || !showMarkers) return [];
        const markers = timeframe === '1d' ? (0, $fyvvE.dailyManagedOrbMarkers)(displayBars, status, (0, $dgdqP.themeColors), historicalSignals) : (0, $fyvvE.potentialManagedOrbMarkers)(displayBars, status, timeframe, (0, $dgdqP.themeColors));
        return markers.map((marker)=>({
                ...marker,
                date: $47e2bc4ed1a99fc8$var$isoDateForChartTime(marker.time)
            }));
    }, [
        displayBars,
        timeframe,
        strategy,
        status,
        historicalSignals,
        showMarkers
    ]);
    const legend = (0, $3KrHx.strategyChartLegend)(strategy, timeframe, status, (0, $dgdqP.themeColors));
    const latestBars = (0, $fyvvE.latestWindowBars)(timeframe);
    return /*#__PURE__*/ (0, $eHRxX.jsx)((0, $kv9Z9.default), {
        className: "w-full border-t border-white/10",
        toolbar: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $dgqjv.default), {
            symbol: symbol,
            label: label,
            strategy: strategy,
            timeframe: timeframe,
            onTimeframeChange: onTimeframeChange,
            chartStyle: chartStyle,
            showMarkers: showMarkers,
            showExtendedHours: showExtendedHours,
            legend: legend,
            onChartStyleChange: setChartStyle,
            onToggleMarkers: ()=>setShowMarkers((current)=>!current),
            onToggleExtendedHours: ()=>setShowExtendedHours((current)=>!current)
        }),
        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
            className: "relative h-[320px]",
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $ltr73.LightweightChart), {
                    data: chartData,
                    volumeData: volumeData,
                    lineOverlays: lineOverlays,
                    customMarkers: customMarkers,
                    type: "symbol",
                    symbolStyle: chartStyle,
                    lineColor: (0, $dgdqP.themeColors).neon,
                    resolution: timeframe === '1d' ? '1D' : 'native',
                    timeVisible: timeframe !== '1d',
                    initialVisibleBars: latestBars,
                    latestVisibleBars: latestBars,
                    showLatestControl: true,
                    hideControls: true
                }, `${symbol}:${timeframe}:${strategy}`),
                loading && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "absolute inset-0 flex items-center justify-center bg-[#0e0e12]/65",
                    children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                        className: "h-5 w-5 animate-spin text-neon"
                    })
                }),
                error && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "absolute inset-0 flex items-center justify-center bg-[#0e0e12]/90 px-4 text-center text-sm text-rose-300",
                    children: error
                })
            ]
        })
    });
};
var $47e2bc4ed1a99fc8$export$2e2bcd8739ae039 = $47e2bc4ed1a99fc8$var$StrategySymbolChart;

});
parcelRegister("etHUa", function(module, exports) {

$parcel$export(module.exports, "isValidPriceLevel", function () { return $24174eafe4e0d485$export$4263979d9f95518b; });
$parcel$export(module.exports, "isCurrentNySessionDate", function () { return $24174eafe4e0d485$export$6a3991af0461b924; });
$parcel$export(module.exports, "isEarlyRegularSession", function () { return $24174eafe4e0d485$export$e0ff425efbf512a5; });
$parcel$export(module.exports, "isRegularMarketOpen", function () { return $24174eafe4e0d485$export$22ca8658b33d8bb9; });
$parcel$export(module.exports, "getAdaptiveLevelTone", function () { return $24174eafe4e0d485$export$15d699cb2e4cb05b; });
$parcel$export(module.exports, "hasFreshLevels", function () { return $24174eafe4e0d485$export$53b972cfb77fd720; });
const $24174eafe4e0d485$var$nyDateFormatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
});
const $24174eafe4e0d485$export$4263979d9f95518b = (value)=>{
    const numberValue = Number(value);
    return Number.isFinite(numberValue) && numberValue > 0;
};
const $24174eafe4e0d485$export$fe8acb51cb0a1c4b = (value)=>{
    if (!value) return null;
    if (typeof value === "string") {
        const trimmed = value.trim();
        // Date-only ISO string (e.g. "2026-09-21") represents a specific session date.
        // Avoid parsing as UTC midnight which rolls back to previous day in New York timezone.
        if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed;
    }
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    return $24174eafe4e0d485$var$nyDateFormatter.format(date);
};
const $24174eafe4e0d485$var$nyTimeFormatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23"
});
const $24174eafe4e0d485$var$nySessionFormatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23"
});
const $24174eafe4e0d485$export$6a3991af0461b924 = (status, fallbackDate)=>{
    const sourceDate = status?.levels_date || status?.timestamp || fallbackDate;
    const levelDate = $24174eafe4e0d485$export$fe8acb51cb0a1c4b(sourceDate);
    return !!levelDate && levelDate === $24174eafe4e0d485$export$fe8acb51cb0a1c4b(new Date());
};
const $24174eafe4e0d485$export$e0ff425efbf512a5 = ()=>{
    const parts = $24174eafe4e0d485$var$nyTimeFormatter.formatToParts(new Date());
    const value = (type)=>Number(parts.find((part)=>part.type === type)?.value || 0);
    const minutes = value("hour") * 60 + value("minute");
    return minutes >= 570 && minutes < 600;
};
const $24174eafe4e0d485$export$22ca8658b33d8bb9 = (date = new Date())=>{
    const parts = $24174eafe4e0d485$var$nySessionFormatter.formatToParts(date);
    const value = (type)=>parts.find((part)=>part.type === type)?.value || "";
    const weekday = value("weekday");
    const minutes = Number(value("hour")) * 60 + Number(value("minute"));
    return weekday !== "Sat" && weekday !== "Sun" && minutes >= 570 && minutes < 960;
};
const $24174eafe4e0d485$var$clamp = (value, min, max)=>Math.min(Math.max(value, min), max);
const $24174eafe4e0d485$export$15d699cb2e4cb05b = ({ price: price, lowerLevel: lowerLevel, upperLevel: upperLevel, levelsReady: levelsReady, earlySession: earlySession = false, marketOpen: marketOpen = true })=>{
    if (!marketOpen) {
        const hasFixedLevels = levelsReady && Number.isFinite(lowerLevel) && Number.isFinite(upperLevel) && upperLevel > lowerLevel;
        return {
            label: hasFixedLevels ? "Market closed \xb7 levels fixed" : "Market closed \xb7 awaiting session",
            bias: hasFixedLevels ? "neutral" : "forming",
            rowStyle: {
                backgroundColor: hasFixedLevels ? "rgba(148, 163, 184, 0.035)" : "rgba(245, 158, 11, 0.035)"
            },
            priceClass: hasFixedLevels ? "text-white/70" : "text-amber-100/60",
            lowerClass: "text-rose-300/50",
            upperClass: "text-emerald-300/50"
        };
    }
    const neutral = {
        label: levelsReady ? "Inside levels" : "Levels forming",
        bias: levelsReady ? "neutral" : "forming",
        rowStyle: {
            backgroundColor: levelsReady ? "rgba(148, 163, 184, 0.025)" : "rgba(245, 158, 11, 0.045)"
        },
        priceClass: levelsReady ? "text-white/85" : "text-amber-100/70",
        lowerClass: "text-rose-300/65",
        upperClass: "text-emerald-300/65"
    };
    if (!levelsReady || !Number.isFinite(price) || !Number.isFinite(lowerLevel) || !Number.isFinite(upperLevel) || upperLevel <= lowerLevel) return neutral;
    const span = Math.max(upperLevel - lowerLevel, Math.abs(upperLevel) * 0.001, 0.01);
    const position = (price - lowerLevel) / span;
    const muted = earlySession ? 0.62 : 1;
    const edgeAlpha = (value)=>$24174eafe4e0d485$var$clamp(value * muted, 0.035, earlySession ? 0.18 : 0.3);
    if (position >= 1) {
        const alpha = edgeAlpha(0.12 + (position - 1) * 0.16);
        return {
            label: "Above long level",
            bias: "long",
            rowStyle: {
                backgroundColor: `rgba(16, 185, 129, ${alpha})`,
                boxShadow: `inset 3px 0 rgba(52, 211, 153, ${$24174eafe4e0d485$var$clamp(alpha + 0.14, 0.2, 0.48)})`
            },
            priceClass: "text-emerald-200",
            lowerClass: "text-rose-300/55",
            upperClass: "text-emerald-300 font-bold"
        };
    }
    if (position <= 0) {
        const alpha = edgeAlpha(0.12 + Math.abs(position) * 0.16);
        return {
            label: "Below short level",
            bias: "short",
            rowStyle: {
                backgroundColor: `rgba(244, 63, 94, ${alpha})`,
                boxShadow: `inset 3px 0 rgba(251, 113, 133, ${$24174eafe4e0d485$var$clamp(alpha + 0.14, 0.2, 0.48)})`
            },
            priceClass: "text-rose-200",
            lowerClass: "text-rose-300 font-bold",
            upperClass: "text-emerald-300/55"
        };
    }
    if (position >= 0.72) {
        const alpha = edgeAlpha(0.04 + (position - 0.72) / 0.28 * 0.07);
        return {
            label: "Near long level",
            bias: "long",
            rowStyle: {
                backgroundColor: `rgba(16, 185, 129, ${alpha})`
            },
            priceClass: "text-emerald-200/90",
            lowerClass: "text-rose-300/55",
            upperClass: "text-emerald-300 font-semibold"
        };
    }
    if (position <= 0.28) {
        const alpha = edgeAlpha(0.04 + (0.28 - position) / 0.28 * 0.07);
        return {
            label: "Near short level",
            bias: "short",
            rowStyle: {
                backgroundColor: `rgba(244, 63, 94, ${alpha})`
            },
            priceClass: "text-rose-200/90",
            lowerClass: "text-rose-300 font-semibold",
            upperClass: "text-emerald-300/55"
        };
    }
    return neutral;
};
const $24174eafe4e0d485$export$53b972cfb77fd720 = (status, fallbackDate)=>{
    const sourceDate = status?.levels_date || status?.timestamp || fallbackDate;
    const levelDate = $24174eafe4e0d485$export$fe8acb51cb0a1c4b(sourceDate);
    return !!levelDate;
};

});

parcelRegister("dgqjv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa0a7c78fbd7605d$export$2e2bcd8739ae039; });

var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");

var $aHzQb = parcelRequire("aHzQb");
var $pqTO6 = parcelRequire("pqTO6");

var $hQpqX = parcelRequire("hQpqX");

var $8YuD2 = parcelRequire("8YuD2");

var $62Hcf = parcelRequire("62Hcf");
const $fa0a7c78fbd7605d$var$StrategySymbolChartControls = ({ symbol: symbol, label: label, strategy: strategy, timeframe: timeframe, onTimeframeChange: onTimeframeChange, chartStyle: chartStyle, showMarkers: showMarkers, showExtendedHours: showExtendedHours, legend: legend, onChartStyleChange: onChartStyleChange, onToggleMarkers: onToggleMarkers, onToggleExtendedHours: onToggleExtendedHours })=>/*#__PURE__*/ (0, $eHRxX.jsx)((0, $8YuD2.ChartToolbar), {
        leading: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
            className: "flex shrink-0 items-baseline gap-1.5",
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                    className: "text-xs font-bold text-white",
                    children: symbol
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                    className: "text-[9px] uppercase tracking-wider text-muted",
                    children: label
                })
            ]
        }),
        legend: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $eHRxX.Fragment), {
            children: legend.map((item)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                    className: "inline-flex shrink-0 items-center gap-1 text-[9px] uppercase tracking-wide text-muted",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "w-4 h-0.5 rounded-full",
                            style: {
                                backgroundColor: item.color
                            }
                        }),
                        item.label
                    ]
                }, item.label))
        }),
        chartStyle: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8YuD2.ChartStyleToggle), {
            value: chartStyle,
            onChange: onChartStyleChange,
            showLine: timeframe !== '1d'
        }),
        actions: /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
            children: [
                strategy === 'MORB' && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $hQpqX.default), {
                    size: "compact",
                    iconOnly: true,
                    onClick: onToggleMarkers,
                    icon: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $pqTO6.default), {
                        className: "h-3.5 w-3.5"
                    }),
                    selected: showMarkers,
                    label: timeframe === '1d' ? showMarkers ? 'Hide buy/close signals' : 'Show buy/close signals' : showMarkers ? 'Hide potential signal markers' : 'Show potential signal markers',
                    title: timeframe === '1d' ? showMarkers ? 'Hide buy/close signals' : 'Show buy/close signals' : showMarkers ? 'Hide potential signal markers' : 'Show potential signal markers'
                }),
                timeframe !== '1d' && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $hQpqX.default), {
                    size: "compact",
                    onClick: onToggleExtendedHours,
                    selected: showExtendedHours,
                    label: showExtendedHours ? 'Show regular market hours only' : 'Show extended hours',
                    title: showExtendedHours ? 'Show regular market hours only' : 'Show extended hours',
                    icon: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $aHzQb.default), {
                        className: "h-3.5 w-3.5"
                    }),
                    children: showExtendedHours ? 'EXT' : 'RTH'
                })
            ]
        }),
        trailing: onTimeframeChange ? /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $62Hcf.ThemeToggleGroup), {
            "aria-label": "Chart timeframe",
            className: "shrink-0 gap-px",
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $hQpqX.default), {
                    size: "compact",
                    segment: "first",
                    label: "5 minute bars",
                    selected: timeframe === '5min',
                    onClick: ()=>onTimeframeChange('5min'),
                    children: "5m"
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $hQpqX.default), {
                    size: "compact",
                    segment: "last",
                    label: "Daily candles",
                    selected: timeframe === '1d',
                    onClick: ()=>onTimeframeChange('1d'),
                    children: "1D"
                })
            ]
        }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8YuD2.ChartToolbarValue), {
            children: timeframe
        })
    });
var $fa0a7c78fbd7605d$export$2e2bcd8739ae039 = $fa0a7c78fbd7605d$var$StrategySymbolChartControls;

});
parcelRegister("aHzQb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3234b3f1d60126b$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $b3234b3f1d60126b$export$a2387ed3b5d536eb = {
    name: "clock-3",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "M12 6v6h4",
                key: "135r8i"
            }
        ]
    ]
};
$b3234b3f1d60126b$export$a2387ed3b5d536eb.node;
const $b3234b3f1d60126b$export$2e2bcd8739ae039 = (0, $hHhnY.default)($b3234b3f1d60126b$export$a2387ed3b5d536eb);

});

parcelRegister("pqTO6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $750d80a970d9f3d0$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $750d80a970d9f3d0$export$a2387ed3b5d536eb = {
    name: "flag",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528",
                key: "1jaruq"
            }
        ]
    ]
};
$750d80a970d9f3d0$export$a2387ed3b5d536eb.node;
const $750d80a970d9f3d0$export$2e2bcd8739ae039 = (0, $hHhnY.default)($750d80a970d9f3d0$export$a2387ed3b5d536eb);

});


parcelRegister("3KrHx", function(module, exports) {

$parcel$export(module.exports, "strategyChartLegend", function () { return $1d4602b996ca5656$export$405d6434ed617e02; });
const $1d4602b996ca5656$export$405d6434ed617e02 = (strategy, timeframe, status, colors)=>{
    if (strategy === 'MORB' && timeframe === '1d') return [
        {
            label: `${status?.entry_sma_period || 50} SMA`,
            color: colors.warning
        },
        {
            label: `${status?.sma_period || 10} SMA`,
            color: colors.warningBright
        },
        {
            label: 'Buy / close signals',
            color: colors.neon
        }
    ];
    if (strategy === 'MORB') return [
        {
            label: 'Market open',
            color: colors.info
        },
        {
            label: 'ORB high / low',
            color: colors.success
        },
        {
            label: 'ATR entry trigger',
            color: colors.warningBright
        }
    ];
    if (strategy === 'ORB') return [
        {
            label: 'Open range',
            color: colors.success
        },
        {
            label: 'Live support/resistance',
            color: colors.neon
        }
    ];
    if (strategy === 'DT') return [
        {
            label: 'Daily open',
            color: colors.info
        },
        {
            label: 'ATR thresholds',
            color: colors.success
        }
    ];
    return [
        {
            label: 'SMA 30',
            color: colors.success
        },
        {
            label: 'SMA 200',
            color: colors.warningBright
        }
    ];
};

});

parcelRegister("fyvvE", function(module, exports) {

$parcel$export(module.exports, "durationForStrategy", function () { return $3e28fd1d89fcac0b$export$c5eec21590f59459; });
$parcel$export(module.exports, "chartTimeFor", function () { return $3e28fd1d89fcac0b$export$91c701c0111963f6; });
$parcel$export(module.exports, "regularSessionBars", function () { return $3e28fd1d89fcac0b$export$bddd759d272a4ed9; });
$parcel$export(module.exports, "timeframeSeconds", function () { return $3e28fd1d89fcac0b$export$7b93452404e28154; });
$parcel$export(module.exports, "sessionSegmentBounds", function () { return $3e28fd1d89fcac0b$export$5d0da53669563cd2; });
$parcel$export(module.exports, "groupByNyDay", function () { return $3e28fd1d89fcac0b$export$700871a7cae9b44; });
$parcel$export(module.exports, "consolidateDailyBars", function () { return $3e28fd1d89fcac0b$export$c36a2603d98abe74; });
$parcel$export(module.exports, "smaData", function () { return $3e28fd1d89fcac0b$export$b34148a8bb227faa; });
$parcel$export(module.exports, "average", function () { return $3e28fd1d89fcac0b$export$cc6710ee5f037d57; });
$parcel$export(module.exports, "latestWindowBars", function () { return $3e28fd1d89fcac0b$export$f231c38f5dd1ef1b; });
$parcel$export(module.exports, "potentialManagedOrbMarkers", function () { return $3e28fd1d89fcac0b$export$29e05362fa428c71; });
$parcel$export(module.exports, "managedOrbVolumeData", function () { return $3e28fd1d89fcac0b$export$e05b4e467f178bf2; });
$parcel$export(module.exports, "dailyManagedOrbMarkers", function () { return $3e28fd1d89fcac0b$export$7be82669d46b07a3; });
const $3e28fd1d89fcac0b$export$ad2adee0f25741f9 = (timeframe)=>{
    if (timeframe === '5min') return '2 D';
    if (timeframe === '30min') return '1 M';
    return '1 Y';
};
const $3e28fd1d89fcac0b$export$c5eec21590f59459 = (timeframe, strategy)=>strategy === 'MORB' && timeframe === '5min' ? '1 M' : $3e28fd1d89fcac0b$export$ad2adee0f25741f9(timeframe);
const $3e28fd1d89fcac0b$var$nyFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
});
const $3e28fd1d89fcac0b$var$getNyParts = (timestampSeconds)=>{
    const parts = $3e28fd1d89fcac0b$var$nyFormatter.formatToParts(new Date(timestampSeconds * 1000));
    const value = (type)=>parts.find((part)=>part.type === type)?.value || '00';
    const hour = Number(value('hour'));
    const minute = Number(value('minute'));
    return {
        key: `${value('year')}-${value('month')}-${value('day')}`,
        minutes: hour * 60 + minute
    };
};
const $3e28fd1d89fcac0b$var$getCalendarDay = (timestampSeconds)=>new Date(timestampSeconds * 1000).toISOString().slice(0, 10);
const $3e28fd1d89fcac0b$export$91c701c0111963f6 = (timestampSeconds, timeframe)=>{
    if (timeframe !== '1d') return timestampSeconds;
    const key = $3e28fd1d89fcac0b$var$getCalendarDay(timestampSeconds);
    const [year, month, day] = key.split('-').map(Number);
    return {
        year: year,
        month: month,
        day: day
    };
};
const $3e28fd1d89fcac0b$export$bddd759d272a4ed9 = (bars)=>bars.filter((bar)=>{
        const { minutes: minutes } = $3e28fd1d89fcac0b$var$getNyParts(bar.time);
        return minutes >= 570 && minutes <= 960;
    });
const $3e28fd1d89fcac0b$export$7b93452404e28154 = (timeframe)=>{
    if (timeframe === '5min') return 300;
    if (timeframe === '30min') return 1800;
    return 86400;
};
const $3e28fd1d89fcac0b$export$5d0da53669563cd2 = (sessionBars, timeframe)=>{
    const firstBar = sessionBars[0];
    const lastBar = sessionBars[sessionBars.length - 1];
    const interval = $3e28fd1d89fcac0b$export$7b93452404e28154(timeframe);
    const firstMinutes = $3e28fd1d89fcac0b$var$getNyParts(firstBar.time).minutes;
    const timestampsLookLikeBarClose = timeframe !== '1d' && firstMinutes > 570;
    return {
        from: timestampsLookLikeBarClose ? firstBar.time - interval : firstBar.time,
        to: timestampsLookLikeBarClose ? lastBar.time : lastBar.time + interval
    };
};
const $3e28fd1d89fcac0b$export$700871a7cae9b44 = (bars)=>{
    const groups = new Map();
    bars.forEach((bar)=>{
        const { key: key } = $3e28fd1d89fcac0b$var$getNyParts(bar.time);
        const dayBars = groups.get(key) || [];
        dayBars.push(bar);
        groups.set(key, dayBars);
    });
    return Array.from(groups.entries()).map(([key, dayBars])=>({
            key: key,
            bars: [
                ...dayBars
            ].sort((a, b)=>a.time - b.time)
        }));
};
const $3e28fd1d89fcac0b$var$groupByCalendarDay = (bars)=>{
    const groups = new Map();
    bars.forEach((bar)=>{
        const key = $3e28fd1d89fcac0b$var$getCalendarDay(bar.time);
        const dayBars = groups.get(key) || [];
        dayBars.push(bar);
        groups.set(key, dayBars);
    });
    return Array.from(groups.entries()).map(([key, dayBars])=>({
            key: key,
            bars: [
                ...dayBars
            ].sort((a, b)=>a.time - b.time)
        }));
};
const $3e28fd1d89fcac0b$export$c36a2603d98abe74 = (bars)=>$3e28fd1d89fcac0b$var$groupByCalendarDay(bars).map(({ bars: dayBars })=>{
        const sorted = [
            ...dayBars
        ].sort((a, b)=>a.time - b.time);
        return {
            time: sorted[0].time,
            open: sorted[0].open,
            high: Math.max(...sorted.map((bar)=>bar.high)),
            low: Math.min(...sorted.map((bar)=>bar.low)),
            close: sorted[sorted.length - 1].close,
            volume: sorted.reduce((sum, bar)=>sum + (Number.isFinite(bar.volume) ? bar.volume : 0), 0)
        };
    });
const $3e28fd1d89fcac0b$export$b34148a8bb227faa = (bars, period, timeframe = '5min')=>{
    const values = [];
    let sum = 0;
    bars.forEach((bar, index)=>{
        sum += bar.close;
        if (index >= period) sum -= bars[index - period].close;
        if (index >= period - 1) values.push({
            time: $3e28fd1d89fcac0b$export$91c701c0111963f6(bar.time, timeframe),
            value: sum / period
        });
    });
    return values;
};
const $3e28fd1d89fcac0b$export$cc6710ee5f037d57 = (values)=>values.length ? values.reduce((sum, value)=>sum + value, 0) / values.length : null;
const $3e28fd1d89fcac0b$export$f231c38f5dd1ef1b = (timeframe)=>{
    if (timeframe === '5min') return 78;
    if (timeframe === '30min') return 26;
    return 90;
};
const $3e28fd1d89fcac0b$export$29e05362fa428c71 = (bars, status, timeframe, colors)=>{
    const direction = String(status?.direction || 'LONG').toUpperCase();
    const entryMinutes = Number(status?.entry_minutes || 10);
    const atrMultiple = Number(status?.atr_multiple || 0.5);
    const volumeThreshold = Number(status?.relative_volume_threshold || 1.5);
    const rangeBars = Math.max(1, Math.ceil(entryMinutes / Math.max(1, $3e28fd1d89fcac0b$export$7b93452404e28154(timeframe) / 60)));
    const markers = [];
    let previousClose = null;
    const trueRanges = [];
    const openingVolumes = [];
    $3e28fd1d89fcac0b$export$700871a7cae9b44(bars).forEach(({ bars: dayBars }, dayIndex, dayGroups)=>{
        const sessionBars = $3e28fd1d89fcac0b$export$bddd759d272a4ed9(dayBars);
        if (sessionBars.length <= rangeBars) return;
        const openingBars = sessionBars.slice(0, rangeBars);
        const openingVolume = openingBars.reduce((sum, bar)=>sum + Math.max(0, Number(bar.volume) || 0), 0);
        const openingBaseline = $3e28fd1d89fcac0b$export$cc6710ee5f037d57(openingVolumes.slice(-20));
        const openingRvol = openingBaseline != null && openingBaseline > 0 ? openingVolume / openingBaseline : null;
        const high = Math.max(...openingBars.map((bar)=>bar.high));
        const low = Math.min(...openingBars.map((bar)=>bar.low));
        const dayHigh = Math.max(...sessionBars.map((bar)=>bar.high));
        const dayLow = Math.min(...sessionBars.map((bar)=>bar.low));
        const dayClose = sessionBars[sessionBars.length - 1].close;
        const trueRange = previousClose == null ? dayHigh - dayLow : Math.max(dayHigh - dayLow, Math.abs(dayHigh - previousClose), Math.abs(dayLow - previousClose));
        const historicalAtr = $3e28fd1d89fcac0b$export$cc6710ee5f037d57(trueRanges.slice(-14));
        trueRanges.push(trueRange);
        previousClose = dayClose;
        const configuredAtr = Number(status?.atr);
        const atr = dayIndex === dayGroups.length - 1 && Number.isFinite(configuredAtr) && configuredAtr > 0 ? configuredAtr : historicalAtr ?? trueRange;
        const trigger = direction === 'SHORT' ? low - atr * atrMultiple : high + atr * atrMultiple;
        const breakout = sessionBars.slice(rangeBars).find((bar)=>{
            const priceBreak = direction === 'SHORT' ? bar.low <= trigger : bar.high >= trigger;
            return priceBreak && openingRvol != null && openingRvol >= volumeThreshold;
        });
        openingVolumes.push(openingVolume);
        if (breakout) markers.push({
            time: breakout.time,
            position: direction === 'SHORT' ? 'aboveBar' : 'belowBar',
            color: status?.simulation_mode ? colors.warningBright : colors.neon,
            shape: direction === 'SHORT' ? 'arrowDown' : 'arrowUp',
            text: status?.simulation_mode ? 'SIM' : 'POT'
        });
    });
    return markers;
};
const $3e28fd1d89fcac0b$export$e05b4e467f178bf2 = (bars, status, colors)=>{
    const threshold = Number(status?.relative_volume_threshold || 1.5);
    const priorBuckets = new Map();
    return bars.map((bar)=>{
        const { minutes: minutes } = $3e28fd1d89fcac0b$var$getNyParts(bar.time);
        const regularSession = minutes >= 570 && minutes <= 960;
        const baseline = regularSession ? $3e28fd1d89fcac0b$export$cc6710ee5f037d57(priorBuckets.get(minutes) || []) : null;
        const highRvol = baseline != null && baseline > 0 && bar.volume >= baseline * threshold;
        const priceUp = Number(bar.close) > Number(bar.open);
        const priceDown = Number(bar.close) < Number(bar.open);
        const result = {
            time: bar.time,
            value: Number(bar.volume || 0),
            color: !regularSession ? colors.mutedDark : highRvol ? priceUp ? colors.success : priceDown ? colors.danger : colors.muted : colors.mutedDark
        };
        if (regularSession) {
            const values = priorBuckets.get(minutes) || [];
            values.push(Math.max(0, Number(bar.volume) || 0));
            priorBuckets.set(minutes, values);
        }
        return result;
    });
};
const $3e28fd1d89fcac0b$export$7be82669d46b07a3 = (bars, status, colors, historicalSignals = [])=>{
    const markers = [];
    const barsByDate = new Map();
    bars.forEach((bar)=>barsByDate.set($3e28fd1d89fcac0b$var$getCalendarDay(bar.time), bar));
    const addMarker = (date, position, color, shape, text)=>{
        const bar = date ? barsByDate.get(String(date).slice(0, 10)) : undefined;
        if (bar) markers.push({
            time: $3e28fd1d89fcac0b$export$91c701c0111963f6(bar.time, '1d'),
            position: position,
            color: color,
            shape: shape,
            text: text
        });
    };
    const trades = Array.isArray(status?.simulated_trades) ? status.simulated_trades : [];
    const seen = new Set();
    const addSignal = (signal)=>{
        const side = String(signal?.side || status?.direction || 'LONG').toUpperCase();
        const isShort = side.includes('SELL') || side === 'SHORT';
        const date = signal?.date || signal?.entry_date;
        const key = `${String(date || '').slice(0, 10)}:BUY`;
        if (date && !seen.has(key)) {
            addMarker(date, isShort ? 'aboveBar' : 'belowBar', colors.neon, isShort ? 'arrowDown' : 'arrowUp', isShort ? 'SELL' : 'BUY');
            seen.add(key);
        }
        if (signal?.exit_date || signal?.close_date) {
            const closeDate = signal.exit_date || signal.close_date;
            const closeKey = `${String(closeDate).slice(0, 10)}:CLOSE`;
            if (!seen.has(closeKey)) {
                addMarker(closeDate, isShort ? 'belowBar' : 'aboveBar', colors.danger, isShort ? 'arrowUp' : 'arrowDown', 'CLOSE');
                seen.add(closeKey);
            }
        }
    };
    historicalSignals.forEach(addSignal);
    trades.forEach((trade)=>addSignal(trade));
    if (!trades.length && status?.entry_date) {
        const isShort = String(status?.direction || 'LONG').toUpperCase() === 'SHORT';
        addMarker(status.entry_date, isShort ? 'aboveBar' : 'belowBar', colors.neon, isShort ? 'arrowDown' : 'arrowUp', isShort ? 'SELL' : 'BUY');
    }
    if (!trades.length && status?.simulated_exit?.date) addMarker(status.simulated_exit.date, 'aboveBar', colors.danger, 'arrowDown', 'CLOSE');
    return markers;
};

});


parcelRegister("3vzuD", function(module, exports) {

$parcel$export(module.exports, "getStrategyDescription", function () { return $1606c7916a8e326d$export$8363ce2bd0f62649; });
const $1606c7916a8e326d$export$8a8f68c015d6cc38 = {
    ON: {
        label: 'Overnight',
        description: 'Overnight trend and carry strategy using the configured ETF signals.',
        overview: 'Uses the overnight session windows and longer-term moving-average context to manage the configured ETF positions.'
    },
    ORB: {
        label: 'Opening Range Breakout',
        description: 'Intraday opening-range breakout strategy with ATR and momentum checks.',
        overview: 'Evaluates the opening range, ATR-based momentum, and configured exit rules before managing an intraday breakout position.'
    },
    DT: {
        label: 'ATR Day Trade',
        description: 'Multi-symbol intraday strategy driven by ATR thresholds and entry windows.',
        overview: 'Uses configured intraday ATR thresholds and entry windows across the selected symbols, with risk controls and end-of-day exits.'
    },
    NQMM: {
        label: 'Nasdaq-100 Monthly Momentum',
        description: 'Long-only monthly momentum sleeve for the current Nasdaq-100 universe.',
        overview: 'Ranks the current Nasdaq-100 universe, sizes the selected holdings using the configured method, and prepares monthly rebalance actions.'
    },
    MORB: {
        label: 'Managed ORB',
        description: 'Semi-automatic, user-selected opening-range breakout manager.',
        overview: 'Tracks selected stocks, checks volume and ATR quality gates, and manages entries, staged stops, and T+3 reductions.'
    },
    MANUAL: {
        label: 'Manual',
        description: 'Position placed manually outside an automated strategy.',
        overview: 'This position is not currently owned by an automated strategy.'
    },
    UNASSIGNED: {
        label: 'Unassigned',
        description: 'No strategy attribution is available for this position.',
        overview: 'No strategy description is available for this position.'
    }
};
const $1606c7916a8e326d$export$8363ce2bd0f62649 = (strategy)=>{
    const key = String(strategy || '').trim().toUpperCase();
    return $1606c7916a8e326d$export$8a8f68c015d6cc38[key] || {
        label: key || 'Unassigned',
        description: 'Strategy attribution is not documented.',
        overview: 'No strategy description is available for this strategy.'
    };
};

});

parcelRegister("f1cgi", function(module, exports) {
module.exports = import("9TBXL").then(()=>parcelRequire('4i6qQ'));

});

parcelRegister("lQ3uZ", function(module, exports) {
module.exports = import("7KzGQ").then(()=>parcelRequire('daaFs'));

});

parcelRegister("h9H29", function(module, exports) {
module.exports = Promise.all([
    import("011jM"),
    import("ibZGM"),
    import("fg5oY"),
    import("1SViu"),
    import("lmjQe")
]).then(()=>parcelRequire('I4kVf'));

});

parcelRegister("1hDAJ", function(module, exports) {
module.exports = Promise.all([
    import("1SViu"),
    import("5eTpz")
]).then(()=>parcelRequire('2SXE4'));

});

parcelRegister("h7lhJ", function(module, exports) {
module.exports = Promise.all([
    import("84Fwc"),
    import("011jM"),
    import("fg5oY"),
    import("dEH12")
]).then(()=>parcelRequire('1FnFy'));

});

parcelRegister("d8iKZ", function(module, exports) {
module.exports = Promise.all([
    import("84Fwc"),
    import("011jM"),
    import("fg5oY"),
    import("6u1XI")
]).then(()=>parcelRequire('j2Lpi'));

});

parcelRegister("cKbcz", function(module, exports) {
module.exports = import("j5Qze").then(()=>parcelRequire('fj90y'));

});

parcelRegister("gFC2Y", function(module, exports) {
module.exports = import("698BK").then(()=>parcelRequire('6XTAF'));

});

parcelRegister("dnqkk", function(module, exports) {
module.exports = import("9eFjZ").then(()=>parcelRequire('6MJzC'));

});

parcelRegister("7uRgN", function(module, exports) {
module.exports = Promise.all([
    import("011jM"),
    import("ibZGM"),
    import("8Dj0J")
]).then(()=>parcelRequire('cbMIG'));

});

parcelRegister("ir7Rs", function(module, exports) {
module.exports = import("k6jkk").then(()=>parcelRequire('3TT5v'));

});

parcelRegister("gRgfN", function(module, exports) {
module.exports = import("c9h1N").then(()=>parcelRequire('cy5kv'));

});

parcelRegister("c30hq", function(module, exports) {
module.exports = import("3nKwx").then(()=>parcelRequire('9qO5N'));

});

parcelRegister("7CvsC", function(module, exports) {
module.exports = import("cSND1").then(()=>parcelRequire('3HF3F'));

});

parcelRegister("fRdgn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5591aa177220e583$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $5591aa177220e583$export$a2387ed3b5d536eb = {
    name: "layers",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
                key: "zw3jo"
            }
        ],
        [
            "path",
            {
                d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
                key: "1wduqc"
            }
        ],
        [
            "path",
            {
                d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
                key: "kqbvx6"
            }
        ]
    ],
    aliases: [
        "layers-3"
    ]
};
$5591aa177220e583$export$a2387ed3b5d536eb.node;
const $5591aa177220e583$export$2e2bcd8739ae039 = (0, $hHhnY.default)($5591aa177220e583$export$a2387ed3b5d536eb);

});

parcelRegister("Yl6eb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40b3f679a8beef92$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $40b3f679a8beef92$export$a2387ed3b5d536eb = {
    name: "palette",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
                key: "e79jfc"
            }
        ],
        [
            "circle",
            {
                cx: "13.5",
                cy: "6.5",
                r: ".5",
                fill: "currentColor",
                key: "1okk4w"
            }
        ],
        [
            "circle",
            {
                cx: "17.5",
                cy: "10.5",
                r: ".5",
                fill: "currentColor",
                key: "f64h9f"
            }
        ],
        [
            "circle",
            {
                cx: "6.5",
                cy: "12.5",
                r: ".5",
                fill: "currentColor",
                key: "qy21gx"
            }
        ],
        [
            "circle",
            {
                cx: "8.5",
                cy: "7.5",
                r: ".5",
                fill: "currentColor",
                key: "fotxhn"
            }
        ]
    ]
};
$40b3f679a8beef92$export$a2387ed3b5d536eb.node;
const $40b3f679a8beef92$export$2e2bcd8739ae039 = (0, $hHhnY.default)($40b3f679a8beef92$export$a2387ed3b5d536eb);

});

parcelRegister("lSdiZ", function(module, exports) {
module.exports = import("eRihl").then(()=>parcelRequire('e49ek'));

});

parcelRegister("hW3AW", function(module, exports) {
module.exports = import("2jhGU").then(()=>parcelRequire('jf2ls'));

});

parcelRegister("jj9gA", function(module, exports) {
module.exports = import("aP9tu").then(()=>parcelRequire('lS1vI'));

});

parcelRegister("j8uwa", function(module, exports) {
module.exports = import.meta.resolve("kMspb");

});


var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");
var $68089ca9cef82829$exports = {};
'use strict';
function $68089ca9cef82829$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($68089ca9cef82829$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$68089ca9cef82829$var$checkDCE();

$68089ca9cef82829$exports = (parcelRequire("cc1lg"));



var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $cK6an = parcelRequire("cK6an");
var $lfSRY = parcelRequire("lfSRY");

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $e4aOX = parcelRequire("e4aOX");

var $zs3Np = parcelRequire("zs3Np");

var $12llf = parcelRequire("12llf");
const $3a6736e3e42b8acf$export$361f331cf51c8057 = ()=>{
    const { token: token } = (0, $e4aOX.useAuth)();
    const [marketStatus, setMarketStatus] = (0, $jHEir.useState)("");
    const [statusColor, setStatusColor] = (0, $jHEir.useState)("text-muted");
    const [tomorrowStatus, setTomorrowStatus] = (0, $jHEir.useState)("");
    const fetchMarketStatus = (0, $jHEir.useCallback)(async ()=>{
        if (!token) return;
        try {
            const result = await (0, $zs3Np.tradingApi).getMarketStatus();
            const liquidHours = result.data?.liquid_hours;
            if (result.success && liquidHours) {
                const now = new Date();
                const nyOptions = {
                    timeZone: "America/New_York",
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                };
                const formatter = new Intl.DateTimeFormat('en-US', nyOptions);
                // --- Tomorrow Logic ---
                const tomorrow = new Date(now);
                tomorrow.setDate(tomorrow.getDate() + 1);
                const tParts = formatter.formatToParts(tomorrow);
                const ty = tParts.find((p)=>p.type === 'year')?.value;
                const tm = tParts.find((p)=>p.type === 'month')?.value;
                const td = tParts.find((p)=>p.type === 'day')?.value;
                const tomorrowStr = `${ty}${tm}${td}`;
                const segments = liquidHours.split(';');
                const tomorrowSegment = segments.find((s)=>s.startsWith(tomorrowStr));
                if (tomorrowSegment) {
                    if (tomorrowSegment.includes("CLOSED")) setTomorrowStatus("Tomorrow: Closed");
                    else setTomorrowStatus("Tomorrow: Regular");
                } else {
                    const day = tomorrow.getDay();
                    if (day === 0 || day === 6) setTomorrowStatus("Tomorrow: Closed");
                    else setTomorrowStatus("Tomorrow: Regular");
                }
                // --- Today Logic ---
                const parts = formatter.formatToParts(now);
                const y = parts.find((p)=>p.type === 'year')?.value;
                const m = parts.find((p)=>p.type === 'month')?.value;
                const d = parts.find((p)=>p.type === 'day')?.value;
                const todayStr = `${y}${m}${d}`; // YYYYMMDD
                const todaySegment = segments.find((s)=>s.startsWith(todayStr));
                if (todaySegment) {
                    if (todaySegment.includes("CLOSED")) {
                        setMarketStatus("US Market: Closed (Holiday)");
                        setStatusColor("text-red-400");
                        return;
                    }
                    const [start, end] = todaySegment.split('-');
                    const [, startTime] = start.split(':');
                    const [, endTime] = end.split(':');
                    const getSeconds = (timeStr)=>{
                        const h = parseInt(timeStr.substring(0, 2));
                        const m = parseInt(timeStr.substring(2, 4));
                        return h * 3600 + m * 60;
                    };
                    const openSeconds = getSeconds(startTime);
                    const closeSeconds = getSeconds(endTime);
                    const nyTimeOptions = {
                        timeZone: "America/New_York",
                        hour12: false,
                        hour: 'numeric',
                        minute: 'numeric',
                        second: 'numeric'
                    };
                    const timeFormatter = new Intl.DateTimeFormat('en-US', nyTimeOptions);
                    const timeParts = timeFormatter.formatToParts(now);
                    const curH = parseInt(timeParts.find((p)=>p.type === 'hour')?.value || '0');
                    const curM = parseInt(timeParts.find((p)=>p.type === 'minute')?.value || '0');
                    const curS = parseInt(timeParts.find((p)=>p.type === 'second')?.value || '0');
                    const totalSeconds = curH * 3600 + curM * 60 + curS;
                    if (totalSeconds < openSeconds) {
                        const diff = openSeconds - totalSeconds;
                        const h = Math.floor(diff / 3600);
                        const m = Math.floor(diff % 3600 / 60);
                        const s = diff % 60;
                        setMarketStatus(`US Market: Opens in ${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`);
                        setStatusColor("text-yellow-400");
                    } else if (totalSeconds >= openSeconds && totalSeconds < closeSeconds) {
                        const diff = closeSeconds - totalSeconds;
                        const h = Math.floor(diff / 3600);
                        const m = Math.floor(diff % 3600 / 60);
                        const s = diff % 60;
                        setMarketStatus(`US Market: Open \u{2022} Closes in ${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`);
                        setStatusColor("text-neon");
                    } else {
                        setMarketStatus("US Market: Closed");
                        setStatusColor("text-red-400");
                    }
                    return;
                }
            }
        } catch (err) {
            console.warn("Failed to fetch market status", err);
        }
        updateMarketStatusLocal();
    }, [
        token
    ]);
    const updateMarketStatusLocal = ()=>{
        const now = new Date();
        const nyOptions = {
            timeZone: "America/New_York",
            hour12: false,
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            weekday: 'short'
        };
        const formatter = new Intl.DateTimeFormat('en-US', nyOptions);
        const parts = formatter.formatToParts(now);
        const getPart = (type)=>parts.find((p)=>p.type === type)?.value;
        const hour = parseInt(getPart('hour') || '0');
        const minute = parseInt(getPart('minute') || '0');
        const second = parseInt(getPart('second') || '0');
        const weekday = getPart('weekday');
        const dayIdx = now.getDay();
        if (dayIdx === 5 || dayIdx === 6) setTomorrowStatus("Tomorrow: Closed (Weekend)");
        else setTomorrowStatus("Tomorrow: Regular");
        const totalSeconds = hour * 3600 + minute * 60 + second;
        const openSeconds = 34200;
        const closeSeconds = 57600;
        const isWeekend = weekday === 'Sat' || weekday === 'Sun';
        if (isWeekend) {
            setMarketStatus("US Market: Closed (Weekend)");
            setStatusColor("text-red-400");
        } else if (totalSeconds < openSeconds) {
            const diff = openSeconds - totalSeconds;
            const h = Math.floor(diff / 3600);
            const m = Math.floor(diff % 3600 / 60);
            const s = diff % 60;
            setMarketStatus(`US Market: Opens in ${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`);
            setStatusColor("text-yellow-400");
        } else if (totalSeconds >= openSeconds && totalSeconds < closeSeconds) {
            const diff = closeSeconds - totalSeconds;
            const h = Math.floor(diff / 3600);
            const m = Math.floor(diff % 3600 / 60);
            const s = diff % 60;
            setMarketStatus(`US Market: Open \u{2022} Closes in ${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`);
            setStatusColor("text-neon");
        } else {
            setMarketStatus("US Market: Closed");
            setStatusColor("text-red-400");
        }
    };
    (0, $jHEir.useEffect)(()=>{
        fetchMarketStatus();
        // Market hours do not change every second. Avoid a global API/Intl parsing
        // loop while keeping the countdown responsive enough for the header.
        const statusInterval = setInterval(fetchMarketStatus, 5000);
        return ()=>{
            clearInterval(statusInterval);
        };
    }, [
        fetchMarketStatus
    ]);
    return /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
        className: "w-full overflow-hidden flex items-center justify-center",
        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $12llf.default), {
                    size: 14,
                    className: statusColor
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                    className: `text-xs font-bold uppercase tracking-wider ${statusColor} whitespace-nowrap`,
                    children: marketStatus
                }),
                tomorrowStatus && /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "text-white/20 mx-1",
                            children: "\u2022"
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "text-[10px] sm:text-xs font-medium text-muted uppercase tracking-wider whitespace-nowrap",
                            children: tomorrowStatus
                        })
                    ]
                })
            ]
        })
    });
};



var $hX4Sd = parcelRequire("hX4Sd");

var $2KORC = parcelRequire("2KORC");

var $eHRxX = parcelRequire("eHRxX");

var $62Hcf = parcelRequire("62Hcf");

var $jHEir = parcelRequire("jHEir");

var $gKbib = parcelRequire("gKbib");
var $5j4E8 = parcelRequire("5j4E8");/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $29b1874158a6f84e$export$a2387ed3b5d536eb = {
    name: "pencil",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
                key: "1a8usu"
            }
        ],
        [
            "path",
            {
                d: "m15 5 4 4",
                key: "1mk7zo"
            }
        ]
    ]
};
$29b1874158a6f84e$export$a2387ed3b5d536eb.node;
const $29b1874158a6f84e$export$2e2bcd8739ae039 = (0, $hHhnY.default)($29b1874158a6f84e$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $250845bdd95058d5$export$a2387ed3b5d536eb = {
    name: "send",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
                key: "1ffxy3"
            }
        ],
        [
            "path",
            {
                d: "m21.854 2.147-10.94 10.939",
                key: "12cjpa"
            }
        ]
    ]
};
$250845bdd95058d5$export$a2387ed3b5d536eb.node;
const $250845bdd95058d5$export$2e2bcd8739ae039 = (0, $hHhnY.default)($250845bdd95058d5$export$a2387ed3b5d536eb);


var $bgvjD = parcelRequire("bgvjD");/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $8d55bb18c538de43$export$a2387ed3b5d536eb = {
    name: "zap",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M15.914 4a1.5 1.5 0 00-2.474-1.561l-9 9A1.5 1.5 0 005.5 14h4.002a.5.5 0 01.471.666L8.086 20a1.5 1.5 0 002.475 1.56l9-9A1.5 1.5 0 0018.5 10h-3.997a.5.5 0 01-.472-.667z",
                key: "1v7up4"
            }
        ]
    ]
};
$8d55bb18c538de43$export$a2387ed3b5d536eb.node;
const $8d55bb18c538de43$export$2e2bcd8739ae039 = (0, $hHhnY.default)($8d55bb18c538de43$export$a2387ed3b5d536eb);



var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");

var $4nVaN = parcelRequire("4nVaN");
var $jQze5 = parcelRequire("jQze5");
parcelRequire("2Mt3i");
var $4YGkM = parcelRequire("4YGkM");
const $920abb5f1a8e551f$export$70d034a749d428df = (contract)=>Boolean(contract && (contract.sec_type === 'FUT' || contract.con_id || contract.last_trade_date_or_contract_month || contract.local_symbol));
const $920abb5f1a8e551f$export$4aaaaf2ad7363269 = (contract)=>String(contract?.sec_type || '').toUpperCase() === 'FUT';
const $920abb5f1a8e551f$export$2c5c4ae02dc830fb = (contract)=>{
    if (contract.display_symbol) return contract.display_symbol;
    if (contract.local_symbol) return contract.local_symbol;
    if (contract.sec_type === 'FUT' && contract.last_trade_date_or_contract_month) return `${contract.symbol} ${contract.last_trade_date_or_contract_month}`;
    return contract.symbol;
};
const $920abb5f1a8e551f$export$c9b619662d734331 = (positions, symbol, limit = 8)=>{
    const normalizedSymbol = symbol.toUpperCase();
    return positions.filter((item)=>{
        if (!normalizedSymbol) return true;
        return [
            item.symbol,
            item.local_symbol,
            item.trading_class
        ].filter(Boolean).some((value)=>String(value).toUpperCase().includes(normalizedSymbol));
    }).slice(0, limit);
};


const $0fc3db7cbc69ec2d$var$SEC_TYPE_OPTIONS = [
    'STK',
    'FUT',
    'OPT',
    'CFD',
    'CASH'
].map((value)=>({
        value: value,
        label: value
    }));
const $0fc3db7cbc69ec2d$var$ContractPicker = ({ symbol: symbol, secType: secType, isEditing: isEditing, positionSuggestions: positionSuggestions, lookupResults: lookupResults, lookupLoading: lookupLoading, showDropdown: showDropdown, selectedContract: selectedContract, marketPrice: marketPrice, fetchingPrice: fetchingPrice, pricePresentation: pricePresentation, onSymbolChange: onSymbolChange, onSymbolFocus: onSymbolFocus, onSymbolBlur: onSymbolBlur, onSecTypeChange: onSecTypeChange, onLookup: onLookup, onSelectContract: onSelectContract, onRefreshQuote: onRefreshQuote })=>{
    const suggestions = (0, $920abb5f1a8e551f$export$c9b619662d734331)(positionSuggestions, symbol);
    const hasDropdown = showDropdown && (suggestions.length > 0 || lookupResults.length > 0 || lookupLoading);
    const hasLatestPriceRow = marketPrice !== null || fetchingPrice;
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "flex gap-3",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex-2 relative",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("label", {
                        className: "block text-[10px] font-bold text-muted uppercase mb-1 tracking-wider opacity-70",
                        children: "Symbol"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                type: "text",
                                value: symbol,
                                onFocus: onSymbolFocus,
                                onChange: (event)=>onSymbolChange(event.target.value.toUpperCase()),
                                disabled: isEditing,
                                onKeyDown: (event)=>{
                                    if (event.key === 'Enter') {
                                        event.preventDefault();
                                        onLookup();
                                    }
                                },
                                onBlur: onSymbolBlur,
                                placeholder: positionSuggestions[0] ? (0, $920abb5f1a8e551f$export$2c5c4ae02dc830fb)(positionSuggestions[0]) : 'SPY',
                                className: `w-full bg-white/3 border border-white/10 px-3 pr-9 py-2 text-foreground placeholder-muted/30 focus:outline-hidden focus:border-neon/50 focus:bg-white/5 transition h-9 text-xs ${hasDropdown ? 'rounded-t-lg border-b-0' : 'rounded-lg'}`,
                                required: true
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                type: "button",
                                onMouseDown: (event)=>event.preventDefault(),
                                onClick: onLookup,
                                disabled: isEditing || lookupLoading || !symbol,
                                className: "absolute right-1.5 top-1/2 -translate-y-1/2 h-6 w-6 rounded-md text-muted hover:text-neon hover:bg-white/5 disabled:opacity-30 disabled:cursor-not-allowed transition flex items-center justify-center",
                                title: "Lookup qualified IB contracts",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jQze5.default), {
                                    className: `w-3.5 h-3.5 ${lookupLoading ? 'animate-pulse' : ''}`
                                })
                            })
                        ]
                    }),
                    hasLatestPriceRow && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "mt-1 flex h-5 items-center justify-between rounded-md border border-white/5 bg-white/2.5 px-2 text-[10px]",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "font-bold uppercase tracking-wider text-muted/60",
                                children: "Latest"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                type: "button",
                                onClick: onRefreshQuote,
                                disabled: fetchingPrice,
                                title: (0, $920abb5f1a8e551f$export$4aaaaf2ad7363269)(selectedContract) ? 'Refresh futures live snapshot' : 'Refresh latest price',
                                className: `flex items-center gap-1 font-mono font-bold transition hover:text-neon disabled:opacity-50 ${pricePresentation.priceClassName}`,
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4nVaN.default), {
                                        className: `h-2.5 w-2.5 ${fetchingPrice ? 'animate-spin' : ''}`
                                    }),
                                    marketPrice !== null ? `$${marketPrice.toFixed(2)}` : 'Loading',
                                    marketPrice !== null && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: `ml-1 rounded-sm border px-1 text-[8px] uppercase ${pricePresentation.badgeClassName}`,
                                        children: pricePresentation.status
                                    })
                                ]
                            })
                        ]
                    }),
                    hasDropdown && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: `absolute z-60 left-0 ${hasLatestPriceRow ? 'top-[calc(100%+1.25rem)]' : 'top-[calc(100%-1px)]'} min-w-full w-[min(32rem,calc(100vw-2rem))] bg-[#1a1a2e] border border-white/10 rounded-xl shadow-2xl overflow-hidden backdrop-blur-xl animate-in fade-in slide-in-from-top-1 duration-200`,
                        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "py-1 max-h-64 overflow-y-auto ux-scrollbar",
                            children: [
                                suggestions.length > 0 && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                    className: "px-3 py-1.5 text-[9px] font-bold uppercase tracking-wider text-muted/60",
                                    children: "Open positions"
                                }),
                                suggestions.map((item)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                        type: "button",
                                        onMouseDown: (event)=>event.preventDefault(),
                                        onClick: ()=>onSelectContract(item),
                                        className: "w-full px-4 py-2.5 text-left text-xs font-bold text-white/70 hover:text-neon hover:bg-white/5 transition-colors border-b border-white/3 last:border-0 flex items-center justify-between gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "truncate",
                                                children: (0, $920abb5f1a8e551f$export$2c5c4ae02dc830fb)(item)
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                className: "text-[10px] text-muted font-mono whitespace-nowrap",
                                                children: [
                                                    item.sec_type,
                                                    item.last_trade_date_or_contract_month ? ` ${item.last_trade_date_or_contract_month}` : ''
                                                ]
                                            })
                                        ]
                                    }, `position-${item.symbol}-${item.sec_type}-${item.con_id || item.local_symbol || ''}`)),
                                lookupLoading && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                    className: "px-4 py-2.5 text-xs text-muted flex items-center gap-2 border-t border-white/4",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4nVaN.default), {
                                            className: "w-3 h-3 animate-spin"
                                        }),
                                        "Looking up contracts..."
                                    ]
                                }),
                                lookupResults.length > 0 && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                    className: "px-3 py-1.5 text-[9px] font-bold uppercase tracking-wider text-muted/60 border-t border-white/4",
                                    children: "Lookup results"
                                }),
                                lookupResults.map((item)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                        type: "button",
                                        onMouseDown: (event)=>event.preventDefault(),
                                        onClick: ()=>onSelectContract(item),
                                        className: "w-full px-4 py-2.5 text-left text-xs text-white/75 hover:bg-white/5 hover:text-neon transition border-b border-white/4 last:border-0 flex items-center justify-between gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                className: "min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "block font-bold truncate",
                                                        children: item.local_symbol || item.symbol
                                                    }),
                                                    item.long_name && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "block text-[10px] text-muted truncate font-normal",
                                                        children: item.long_name
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                className: "text-[10px] text-muted font-mono whitespace-nowrap",
                                                children: [
                                                    item.sec_type,
                                                    " ",
                                                    item.last_trade_date_or_contract_month || '',
                                                    " ",
                                                    item.exchange || ''
                                                ]
                                            })
                                        ]
                                    }, `lookup-${item.con_id || item.local_symbol}-${item.exchange}`))
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex-1 relative",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("label", {
                        className: "block text-[10px] font-bold text-muted uppercase mb-1 tracking-wider opacity-70",
                        children: "Sec Type"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4YGkM.CustomSelect), {
                        value: secType,
                        onChange: onSecTypeChange,
                        options: $0fc3db7cbc69ec2d$var$SEC_TYPE_OPTIONS,
                        ariaLabel: "Security type",
                        disabled: isEditing
                    })
                ]
            })
        ]
    });
};
var $0fc3db7cbc69ec2d$export$2e2bcd8739ae039 = $0fc3db7cbc69ec2d$var$ContractPicker;



var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");
parcelRequire("2Mt3i");
var $4YGkM = parcelRequire("4YGkM");
const $b24d9bc3dbe97d48$var$TIME_IN_FORCE_OPTIONS = [
    {
        value: 'DAY',
        label: 'DAY'
    },
    {
        value: 'GTC',
        label: 'GTC'
    }
];
const $b24d9bc3dbe97d48$var$OrderExecutionOptionsFields = ({ timeInForce: timeInForce, outsideRegularHours: outsideRegularHours, orderType: orderType, onTimeInForceChange: onTimeInForceChange, onOutsideRegularHoursChange: onOutsideRegularHoursChange })=>{
    const outsideRegularHoursDisabled = orderType === 'MARKET' || orderType === 'MIDPRICE';
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "flex gap-3 items-end",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("label", {
                        className: "block text-[10px] font-bold text-muted uppercase mb-1 tracking-wider opacity-70",
                        children: "TIF"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4YGkM.CustomSelect), {
                        value: timeInForce,
                        onChange: (value)=>onTimeInForceChange(value),
                        options: $b24d9bc3dbe97d48$var$TIME_IN_FORCE_OPTIONS,
                        ariaLabel: "Time in force"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("label", {
                className: `flex flex-2 h-9 rounded-lg border px-3 items-center justify-between gap-3 transition ${outsideRegularHoursDisabled ? 'border-white/5 bg-white/2 opacity-40' : 'border-white/10 bg-white/3 hover:bg-white/5'}`,
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                        className: "text-[10px] font-bold text-muted uppercase tracking-wider leading-none",
                        children: "Outside RTH"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                        type: "checkbox",
                        checked: outsideRegularHours,
                        disabled: outsideRegularHoursDisabled,
                        onChange: (event)=>onOutsideRegularHoursChange(event.target.checked),
                        className: "h-4 w-4 shrink-0 accent-emerald-400"
                    })
                ]
            })
        ]
    });
};
var $b24d9bc3dbe97d48$export$2e2bcd8739ae039 = $b24d9bc3dbe97d48$var$OrderExecutionOptionsFields;



var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");

var $4nVaN = parcelRequire("4nVaN");
parcelRequire("2Mt3i");
var $4YGkM = parcelRequire("4YGkM");

var $iCbFX = parcelRequire("iCbFX");
const $4357098bced51348$var$ORDER_TYPE_OPTIONS = [
    {
        value: 'MARKET',
        label: 'MKT'
    },
    {
        value: 'LIMIT',
        label: 'LMT'
    },
    {
        value: 'MIDPRICE',
        label: 'MID'
    },
    {
        value: 'STOP',
        label: 'STP'
    },
    {
        value: 'TRAIL',
        label: 'TRAIL'
    }
];
const $4357098bced51348$var$OrderPricingFields = ({ orderType: orderType, price: price, trailingAmount: trailingAmount, trailType: trailType, action: action, marketPrice: marketPrice, fetchingPrice: fetchingPrice, pricePresentation: pricePresentation, currency: currency, onOrderTypeChange: onOrderTypeChange, onPriceChange: onPriceChange, onTrailingAmountChange: onTrailingAmountChange, onTrailTypeChange: onTrailTypeChange, onRefreshQuote: onRefreshQuote, onSnapToMarket: onSnapToMarket })=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "flex gap-3 items-end",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("label", {
                        className: "block text-[10px] font-bold text-muted uppercase mb-1 tracking-wider opacity-70",
                        children: "Type"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4YGkM.CustomSelect), {
                        value: orderType,
                        onChange: onOrderTypeChange,
                        options: $4357098bced51348$var$ORDER_TYPE_OPTIONS,
                        ariaLabel: "Order type"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex-[1.5]",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex justify-between items-end mb-1",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("label", {
                                className: `block text-[10px] font-bold uppercase tracking-wider ${orderType !== 'MARKET' ? 'text-neon opacity-90' : 'text-muted opacity-40'}`,
                                children: orderType === 'STOP' ? 'Stop' : orderType === 'TRAIL' ? 'Trailing Amt' : orderType === 'MIDPRICE' ? 'Midpoint Cap' : 'Price'
                            }),
                            marketPrice !== null ? /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-center gap-1.5 px-1.5 py-0.5 rounded-sm bg-white/3 border border-white/5",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                        type: "button",
                                        onClick: onRefreshQuote,
                                        disabled: fetchingPrice,
                                        className: `transition-all ${fetchingPrice ? 'animate-spin opacity-50' : 'hover:text-neon text-muted/60'}`,
                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4nVaN.default), {
                                            className: "w-2.5 h-2.5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: "text-[9px] font-bold text-muted/60 uppercase tracking-tighter",
                                        children: "Mkt"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: `text-[10px] font-mono font-bold ${fetchingPrice ? 'opacity-40' : pricePresentation.priceClassName}`,
                                        children: marketPrice.toFixed(2)
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: `rounded-sm border px-1 text-[8px] font-bold uppercase ${pricePresentation.badgeClassName}`,
                                        children: pricePresentation.status
                                    }),
                                    orderType !== 'MARKET' && /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                        type: "button",
                                        onClick: onSnapToMarket,
                                        disabled: !pricePresentation.usableForPricing,
                                        title: pricePresentation.usableForPricing ? 'Snap to Market' : 'Stale or frozen prices cannot populate an order',
                                        className: "ml-0.5 text-muted hover:text-neon transition-colors disabled:cursor-not-allowed disabled:opacity-25",
                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8d55bb18c538de43$export$2e2bcd8739ae039), {
                                            className: "w-2.5 h-2.5 fill-current"
                                        })
                                    })
                                ]
                            }) : fetchingPrice && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4nVaN.default), {
                                className: "w-2.5 h-2.5 text-muted animate-spin mb-0.5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "relative",
                        children: orderType === 'TRAIL' ? /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "flex gap-2 w-full",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                    type: "number",
                                    value: trailingAmount,
                                    onChange: (event)=>onTrailingAmountChange(event.target.value),
                                    onBlur: ()=>trailingAmount && onTrailingAmountChange(parseFloat(trailingAmount).toFixed(2)),
                                    placeholder: "0.00",
                                    step: "0.01",
                                    className: "flex-1 bg-white/3 border border-white/10 focus:border-neon/50 rounded-lg px-3 py-2 text-foreground transition h-9 text-xs focus:outline-hidden font-mono",
                                    required: true
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                    className: "flex-shrink-0 flex rounded-lg bg-white/5 p-0.5 border border-white/10 h-9",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>onTrailTypeChange('amount'),
                                            className: `px-2.5 rounded-md text-[10px] font-black transition-all ${trailType === 'amount' ? 'bg-neon text-black shadow-[0_0_10px_rgba(0,255,153,0.3)]' : 'text-white/50 hover:text-white'}`,
                                            children: "$"
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>onTrailTypeChange('percent'),
                                            className: `px-2.5 rounded-md text-[10px] font-black transition-all ${trailType === 'percent' ? 'bg-neon text-black shadow-[0_0_10px_rgba(0,255,153,0.3)]' : 'text-white/50 hover:text-white'}`,
                                            children: "%"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                    type: "number",
                                    value: price,
                                    onChange: (event)=>onPriceChange(event.target.value),
                                    onBlur: ()=>price && onPriceChange(parseFloat(price).toFixed(2)),
                                    placeholder: orderType !== 'MARKET' ? orderType === 'MIDPRICE' ? 'Max buy / min sell' : '0.00' : pricePresentation.usableForPricing && marketPrice ? marketPrice.toFixed(2) : 'Market',
                                    disabled: orderType === 'MARKET',
                                    step: "0.01",
                                    className: `w-full bg-white/3 border rounded-lg px-3 py-2 text-foreground transition h-9 text-xs focus:outline-hidden ${orderType !== 'MARKET' ? 'border-white/10 focus:border-neon/50' : 'border-transparent opacity-30 cursor-not-allowed placeholder-muted/50 font-bold'}`,
                                    required: orderType !== 'MARKET'
                                }),
                                orderType === 'MARKET' && marketPrice && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                    className: "absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-1 opacity-40",
                                    children: /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: `text-[10px] font-bold ${pricePresentation.priceClassName}`,
                                        children: pricePresentation.status
                                    })
                                })
                            ]
                        })
                    }),
                    orderType === 'TRAIL' && pricePresentation.usableForPricing && marketPrice && trailingAmount && !isNaN(parseFloat(trailingAmount)) && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "mt-1.5 text-[11px] font-bold text-white/50 flex justify-between items-center bg-white/2 border border-white/5 rounded-md px-2 py-1 select-none",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "uppercase tracking-wider text-[9px] text-muted",
                                children: "Est. Stop Price:"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "font-mono text-rose-400 font-black",
                                children: (0, $iCbFX.formatCurrency)(trailType === 'amount' ? action === 'BUY' ? marketPrice + parseFloat(trailingAmount) : marketPrice - parseFloat(trailingAmount) : action === 'BUY' ? marketPrice * (1 + parseFloat(trailingAmount) / 100) : marketPrice - parseFloat(trailingAmount) / 100, currency)
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $4357098bced51348$export$2e2bcd8739ae039 = $4357098bced51348$var$OrderPricingFields;



var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");

var $aunDS = parcelRequire("aunDS");
var $bTVJ1 = parcelRequire("bTVJ1");
const $6bcda43b84742562$var$OrderSideQuantityFields = ({ action: action, quantity: quantity, onActionChange: onActionChange, onQuantityChange: onQuantityChange })=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "flex gap-3",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("label", {
                        className: "block text-[10px] font-bold text-muted uppercase mb-1 tracking-wider opacity-70",
                        children: "Side"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex rounded-lg bg-white/3 p-1 border border-white/10 h-9 items-center",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                type: "button",
                                onClick: ()=>onActionChange('BUY'),
                                className: `flex-1 h-full text-[11px] font-bold rounded-md transition flex items-center justify-center ${action === 'BUY' ? 'bg-emerald-500/20 text-emerald-400 shadow-xs' : 'text-muted hover:text-foreground'}`,
                                children: "BUY"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                type: "button",
                                onClick: ()=>onActionChange('SELL'),
                                className: `flex-1 h-full text-[11px] font-bold rounded-md transition flex items-center justify-center ${action === 'SELL' ? 'bg-red-500/20 text-red-400 shadow-xs' : 'text-muted hover:text-foreground'}`,
                                children: "SELL"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("label", {
                        className: "block text-[10px] font-bold text-muted uppercase mb-1 tracking-wider opacity-70",
                        children: "Qty"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center h-9 bg-white/3 border border-white/10 rounded-lg overflow-hidden focus-within:border-neon/50 transition",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    const current = parseInt(quantity, 10) || 0;
                                    onQuantityChange(String(Math.max(1, current - 1)));
                                },
                                className: "px-2.5 h-full hover:bg-white/5 text-muted hover:text-neon transition-colors border-r border-white/5",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $aunDS.default), {
                                    className: "w-3 h-3"
                                })
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                type: "number",
                                value: quantity,
                                onChange: (event)=>onQuantityChange(event.target.value),
                                onBlur: ()=>{
                                    if (quantity === '' || parseInt(quantity, 10) <= 0) onQuantityChange('1');
                                },
                                min: "1",
                                className: "w-full bg-transparent px-2 text-center text-foreground focus:outline-hidden h-full text-xs [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
                                required: true
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    const current = parseInt(quantity, 10) || 0;
                                    onQuantityChange(String(current + 1));
                                },
                                className: "px-2.5 h-full hover:bg-white/5 text-muted hover:text-neon transition-colors border-l border-white/5",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bTVJ1.default), {
                                    className: "w-3 h-3"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $6bcda43b84742562$export$2e2bcd8739ae039 = $6bcda43b84742562$var$OrderSideQuantityFields;



const $9842c5c86de43524$var$ORDER_TYPE_ALIASES = {
    MKT: 'MARKET',
    MARKET: 'MARKET',
    LMT: 'LIMIT',
    LIMIT: 'LIMIT',
    MIDPRICE: 'MIDPRICE',
    STP: 'STOP',
    STOP: 'STOP',
    TRAIL: 'TRAIL'
};
const $9842c5c86de43524$export$50b86ba32e7259b5 = (order, isEditing)=>{
    const rootSymbol = order.rootSymbol || order.symbol || '';
    const normalizedSymbol = rootSymbol.toUpperCase();
    const rawOrderType = String(order.order_type || '').toUpperCase();
    const orderType = $9842c5c86de43524$var$ORDER_TYPE_ALIASES[rawOrderType] || 'MARKET';
    const unsupportedOrderType = orderType === 'MARKET' && ![
        'MKT',
        'MARKET'
    ].includes(rawOrderType) ? rawOrderType || 'UNKNOWN' : null;
    const isTrailingPercent = order.trailing_percent !== undefined && order.trailing_percent !== null;
    const secType = String(order.secType || 'STK').toUpperCase();
    return {
        symbol: normalizedSymbol,
        secType: secType,
        action: String(order.side || 'BUY').toUpperCase() === 'SELL' ? 'SELL' : 'BUY',
        strategyName: String(order.strategy || '').toUpperCase() === 'NQMM' ? 'NQMM' : 'MANUAL',
        orderType: orderType,
        unsupportedOrderType: isEditing ? unsupportedOrderType : null,
        tif: order.tif === 'GTC' ? 'GTC' : 'DAY',
        outsideRth: Boolean(order.outside_rth),
        quantity: String(order.quantity || 1),
        price: orderType === 'LIMIT' || orderType === 'MIDPRICE' ? String(order.limit_price ?? '') : orderType === 'STOP' ? String(order.stop_price ?? '') : '',
        trailType: isTrailingPercent ? 'percent' : 'amount',
        trailingAmount: orderType === 'TRAIL' ? String(isTrailingPercent ? order.trailing_percent ?? '' : order.trailing_amount ?? order.stop_price ?? '') : '',
        selectedContract: {
            symbol: normalizedSymbol,
            display_symbol: order.symbol ?? undefined,
            sec_type: secType,
            con_id: order.con_id,
            exchange: order.exchange,
            local_symbol: order.localSymbol,
            trading_class: order.tradingClass,
            last_trade_date_or_contract_month: order.lastTradeDateOrContractMonth,
            currency: order.currency ?? undefined,
            multiplier: order.multiplier
        },
        error: isEditing && unsupportedOrderType ? `IB order type ${unsupportedOrderType} cannot be edited safely from this form.` : null
    };
};



var $jHEir = parcelRequire("jHEir");

var $hpygi = parcelRequire("hpygi");
const $8048e7d747db5087$export$2138299cfd7e961a = (positions, responseStale = false, responseTimestamp)=>{
    const suggestions = positions.filter((position)=>position.symbol && Number(position.quantity || 0) !== 0).map((position)=>({
            symbol: String(position.symbol).toUpperCase(),
            display_symbol: position.display_symbol,
            sec_type: position.secType || 'STK',
            con_id: position.con_id,
            exchange: position.exchange,
            currency: position.currency,
            local_symbol: position.local_symbol,
            trading_class: position.trading_class,
            last_trade_date_or_contract_month: position.last_trade_date_or_contract_month,
            multiplier: position.multiplier,
            current_price: position.current_price,
            current_price_stale: Boolean(position.quote_stale || responseStale),
            current_price_delayed: position.quote_status === 'DELAYED',
            current_price_received_at: position.quote_received_at || responseTimestamp
        }));
    return Array.from(new Map(suggestions.map((suggestion)=>[
            `${suggestion.symbol}-${suggestion.sec_type}-${suggestion.con_id || suggestion.local_symbol || ''}`,
            suggestion
        ])).values());
};


const $a9f3210807455324$export$3d7e5f9788c3a86e = ()=>{
    const { data: positionsResponse, refetch: refetch } = (0, $hpygi.usePositionsQuery)();
    (0, $jHEir.useEffect)(()=>{
        const refreshPositions = ()=>{
            refetch();
        };
        window.addEventListener('trading-data-refresh', refreshPositions);
        return ()=>window.removeEventListener('trading-data-refresh', refreshPositions);
    }, [
        refetch
    ]);
    return (0, $jHEir.useMemo)(()=>(0, $8048e7d747db5087$export$2138299cfd7e961a)(positionsResponse?.data?.positions || [], Boolean(positionsResponse?.data?.stale), positionsResponse?.timestamp), [
        positionsResponse
    ]);
};



var $jHEir = parcelRequire("jHEir");
const $64e79129bad62c89$export$6d11c9454f4c762b = (detail)=>{
    const quantity = Math.floor(Number(detail?.quantity));
    if (!detail?.symbol || detail.action !== 'BUY' && detail.action !== 'SELL' || !Number.isFinite(quantity) || quantity <= 0) return null;
    const symbol = detail.symbol.toUpperCase();
    const secType = (detail.secType || 'STK').toUpperCase();
    const price = Number(detail.price);
    return {
        symbol: symbol,
        secType: secType,
        action: detail.action,
        quantity: String(quantity),
        orderType: detail.orderType || 'MIDPRICE',
        price: Number.isFinite(price) && price > 0 ? price.toFixed(2) : '',
        selectedContract: {
            symbol: symbol,
            sec_type: secType,
            display_symbol: symbol
        }
    };
};


const $79a8ce4ee2d1a60e$export$864d48651a61907e = ({ onCancelEditing: onCancelEditing, onPreparedOrder: onPreparedOrder })=>{
    (0, $jHEir.useEffect)(()=>{
        const handlePreparedNQMMOrder = (event)=>{
            const detail = event.detail;
            if (detail?.openInModal) return;
            const order = (0, $64e79129bad62c89$export$6d11c9454f4c762b)(detail);
            if (!order) return;
            onCancelEditing?.();
            onPreparedOrder(order);
            window.setTimeout(()=>{
                document.getElementById('manual-order-entry')?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }, 0);
        };
        window.addEventListener('nqmm-prepare-order', handlePreparedNQMMOrder);
        return ()=>window.removeEventListener('nqmm-prepare-order', handlePreparedNQMMOrder);
    }, [
        onCancelEditing,
        onPreparedOrder
    ]);
};



var $jHEir = parcelRequire("jHEir");
const $f1b3cd674aa7c25d$export$38f61b046952d08 = async (symbol, secType, lookup)=>{
    try {
        const response = await lookup({
            symbol: symbol.trim().toUpperCase(),
            sec_type: secType
        });
        const contracts = response?.data?.contracts || [];
        return {
            contracts: contracts,
            error: contracts.length === 0 ? `No ${secType} contracts found for ${symbol.toUpperCase()}.` : null
        };
    } catch (error) {
        const message = error && typeof error === 'object' && 'message' in error ? String(error.message || '') : '';
        return {
            contracts: [],
            error: message || 'Contract lookup failed.'
        };
    }
};



var $zs3Np = parcelRequire("zs3Np");
const $4afcdb9299e677ef$export$650e809fb8b3bf1e = ({ symbol: symbol, secType: secType, setError: setError, setShowDropdown: setShowDropdown })=>{
    const [lookupResults, setLookupResults] = (0, $jHEir.useState)([]);
    const [lookupLoading, setLookupLoading] = (0, $jHEir.useState)(false);
    const handleLookup = (0, $jHEir.useCallback)(async ()=>{
        if (!symbol.trim()) {
            setError('Enter a symbol before lookup.');
            return;
        }
        setLookupLoading(true);
        setError(null);
        setLookupResults([]);
        setShowDropdown(true);
        try {
            const result = await (0, $f1b3cd674aa7c25d$export$38f61b046952d08)(symbol, secType, (request)=>(0, $zs3Np.tradingApi).lookupOrderContracts(request));
            setLookupResults(result.contracts);
            if (result.error) setError(result.error);
        } finally{
            setLookupLoading(false);
        }
    }, [
        secType,
        setError,
        setShowDropdown,
        symbol
    ]);
    return {
        lookupResults: lookupResults,
        setLookupResults: setLookupResults,
        lookupLoading: lookupLoading,
        handleLookup: handleLookup
    };
};



var $jHEir = parcelRequire("jHEir");

var $zs3Np = parcelRequire("zs3Np");

var $jHEir = parcelRequire("jHEir");
const $965642ac39400a6c$var$normalize = (identifier)=>identifier.trim().toUpperCase();
class $965642ac39400a6c$var$QuoteStore {
    constructor(){
        this.socket = null;
        this.token = null;
        this.sessionKey = null;
        this.reconnectTimer = null;
        this.reconnectAttempts = 0;
        this.disposed = true;
        this.quotes = new Map();
        this.aliasToKey = new Map();
        this.listeners = new Map();
        this.references = new Map();
        this.statusListeners = new Set();
        this.status = 'DISCONNECTED';
        this.brokerConnected = false;
        this.version = 0;
        this.pendingListeners = new Set();
        this.notificationTimer = null;
        this.lastMessageAt = 0;
        this.getStatus = ()=>this.status;
        this.getVersion = ()=>this.version;
        if (typeof window !== 'undefined') {
            const handleWake = ()=>this.handleWakeup();
            document.addEventListener('visibilitychange', handleWake);
            window.addEventListener('focus', handleWake);
            window.addEventListener('online', handleWake);
        }
    }
    handleWakeup() {
        if (this.disposed || !this.token) return;
        if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
        const now = Date.now();
        // A socket claiming to be OPEN with no messages for > 15s is likely a dead zombie connection frozen by the mobile OS.
        const isZombie = this.socket?.readyState === WebSocket.OPEN && this.lastMessageAt > 0 && now - this.lastMessageAt > 15000;
        const isSocketDown = !this.socket || this.socket.readyState === WebSocket.CLOSING || this.socket.readyState === WebSocket.CLOSED || isZombie;
        if (isSocketDown) {
            if (this.reconnectTimer !== null) {
                window.clearTimeout(this.reconnectTimer);
                this.reconnectTimer = null;
            }
            this.reconnectAttempts = 0;
            if (this.socket) {
                try {
                    this.socket.onclose = null;
                    this.socket.onerror = null;
                    this.socket.onmessage = null;
                    this.socket.close();
                } catch  {
                // ignore
                }
                this.socket = null;
            }
            this.connect();
        } else if (this.socket?.readyState === WebSocket.OPEN) {
            if (this.references.size > 0) this.send('subscribe', [
                ...this.references.keys()
            ]);
            this.refreshStaleness();
        }
    }
    configure(token, sessionKey) {
        if (this.token === token && this.sessionKey === sessionKey) return;
        this.disconnect(true);
        this.token = token;
        this.sessionKey = sessionKey;
        if (token && sessionKey) {
            this.disposed = false;
            this.connect();
        }
    }
    subscribe(identifier, listener) {
        const alias = $965642ac39400a6c$var$normalize(identifier);
        if (!alias) return ()=>undefined;
        const listeners = this.listeners.get(alias) ?? new Set();
        listeners.add(listener);
        this.listeners.set(alias, listeners);
        const count = (this.references.get(alias) ?? 0) + 1;
        this.references.set(alias, count);
        if (count === 1 && this.socket?.readyState === WebSocket.OPEN) this.send('subscribe', [
            identifier
        ]);
        return ()=>{
            const current = this.listeners.get(alias);
            current?.delete(listener);
            if (current?.size === 0) this.listeners.delete(alias);
            const nextCount = Math.max(0, (this.references.get(alias) ?? 1) - 1);
            if (nextCount === 0) {
                this.references.delete(alias);
                if (this.socket?.readyState === WebSocket.OPEN) this.send('unsubscribe', [
                    identifier
                ]);
            } else this.references.set(alias, nextCount);
        };
    }
    getQuote(identifier) {
        const alias = $965642ac39400a6c$var$normalize(identifier);
        const key = this.aliasToKey.get(alias) ?? alias.toLowerCase();
        return this.quotes.get(key) ?? this.quotes.get(alias) ?? null;
    }
    subscribeStatus(listener) {
        this.statusListeners.add(listener);
        return ()=>this.statusListeners.delete(listener);
    }
    clear() {
        if (this.notificationTimer !== null) window.clearTimeout(this.notificationTimer);
        this.notificationTimer = null;
        this.pendingListeners.clear();
        this.quotes.clear();
        this.aliasToKey.clear();
        this.version += 1;
        this.emitAll();
    }
    connect() {
        if (this.disposed || !this.token) return;
        this.setStatus('CONNECTING');
        const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        this.socket = new WebSocket(`${protocol}//${window.location.host}/api/v1/market/ws`, [
            'access_token',
            this.token
        ]);
        this.socket.onopen = ()=>{
            this.reconnectAttempts = 0;
            this.lastMessageAt = Date.now();
            // The browser socket is only the transport. Wait for the server's broker
            // status before presenting retained quotes as live market data.
            this.brokerConnected = false;
            this.setStatus('CONNECTING');
            this.send('subscribe', [
                ...this.references.keys()
            ]);
        };
        this.socket.onmessage = (event)=>this.handleMessage(event.data);
        this.socket.onclose = (event)=>{
            this.socket = null;
            this.brokerConnected = false;
            this.setStatus('DISCONNECTED');
            this.refreshStaleness();
            if (this.disposed || event.code === 4401 || event.code === 4403) return;
            this.reconnectAttempts += 1;
            const isHidden = typeof document !== 'undefined' && document.visibilityState === 'hidden';
            const delay = isHidden ? 30000 : Math.min(15000, 500 * 2 ** Math.min(this.reconnectAttempts, 5));
            this.reconnectTimer = window.setTimeout(()=>this.connect(), delay);
        };
    }
    handleMessage(raw) {
        this.lastMessageAt = Date.now();
        let message;
        try {
            message = JSON.parse(raw);
        } catch  {
            return;
        }
        if (message.type === 'connection.status' || message.type === 'heartbeat') {
            const connected = message.status === 'CONNECTED';
            if (connected && !this.brokerConnected) this.send('subscribe', [
                ...this.references.keys()
            ]);
            this.brokerConnected = connected;
            this.setStatus(connected ? 'CONNECTED' : 'DISCONNECTED');
            this.refreshStaleness();
            return;
        }
        if (message.type !== 'quote.updated' || !message.quote?.contract_key) return;
        const incomingQuote = message.quote;
        const quote = this.brokerConnected ? incomingQuote : {
            ...incomingQuote,
            stale: true
        };
        const previous = this.quotes.get(quote.contract_key);
        if (previous && previous.sequence >= quote.sequence) return;
        this.quotes.set(quote.contract_key, quote);
        this.version += 1;
        const aliases = [
            quote.contract_key,
            quote.symbol,
            quote.local_symbol,
            quote.con_id ? `conid:${quote.con_id}` : null
        ].filter(Boolean).map((value)=>$965642ac39400a6c$var$normalize(String(value)));
        for (const alias of aliases)this.aliasToKey.set(alias, quote.contract_key);
        const notified = new Set();
        for (const alias of aliases)for (const listener of this.listeners.get(alias) ?? [])notified.add(listener);
        this.scheduleListeners(notified);
    }
    send(action, contracts) {
        if (contracts.length && this.socket?.readyState === WebSocket.OPEN) this.socket.send(JSON.stringify({
            action: action,
            contracts: contracts
        }));
    }
    refreshStaleness() {
        let changed = false;
        const now = Date.now();
        for (const [key, quote] of this.quotes){
            const timestamp = quote.exchange_time || quote.received_at;
            const observedAt = timestamp ? Date.parse(timestamp) : Number.NaN;
            const stale = !this.brokerConnected || quote.stale || !Number.isFinite(observedAt) || (now - observedAt) / 1000 > (quote.stale_after_seconds ?? 60);
            if (stale !== quote.stale) {
                this.quotes.set(key, {
                    ...quote,
                    stale: stale
                });
                changed = true;
            }
        }
        if (changed) {
            this.version += 1;
            this.emitAll();
        }
    }
    disconnect(clearQuotes) {
        this.disposed = true;
        if (this.reconnectTimer !== null) window.clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
        if (this.socket) {
            // Prevent a late close/message from an old tenant socket scheduling a
            // reconnect after a managed-user switch.
            this.socket.onclose = null;
            this.socket.onmessage = null;
            this.socket.close();
        }
        this.socket = null;
        this.brokerConnected = false;
        this.setStatus('DISCONNECTED');
        if (clearQuotes) this.clear();
    }
    setStatus(status) {
        if (this.status === status) return;
        this.status = status;
        for (const listener of this.statusListeners)listener();
    }
    emitAll() {
        const listeners = new Set([
            ...this.listeners.values()
        ].flatMap((set)=>[
                ...set
            ]));
        for (const listener of listeners)listener();
    }
    scheduleListeners(listeners) {
        for (const listener of listeners)this.pendingListeners.add(listener);
        if (this.notificationTimer !== null) return;
        const delay = document.visibilityState === 'hidden' ? 500 : 100;
        this.notificationTimer = window.setTimeout(()=>{
            this.notificationTimer = null;
            const pending = [
                ...this.pendingListeners
            ];
            this.pendingListeners.clear();
            for (const listener of pending)listener();
        }, delay);
    }
}
const $965642ac39400a6c$export$51b87650e98265a6 = new $965642ac39400a6c$var$QuoteStore();
const $965642ac39400a6c$export$79ae38ef14e32131 = (identifier)=>{
    const target = identifier ? $965642ac39400a6c$var$normalize(identifier) : '';
    const subscribe = (0, $jHEir.useCallback)((listener)=>target ? $965642ac39400a6c$export$51b87650e98265a6.subscribe(target, listener) : ()=>undefined, [
        target
    ]);
    const getSnapshot = (0, $jHEir.useCallback)(()=>target ? $965642ac39400a6c$export$51b87650e98265a6.getQuote(target) : null, [
        target
    ]);
    return (0, $jHEir.useSyncExternalStore)(subscribe, getSnapshot, ()=>null);
};
const $965642ac39400a6c$export$2341ff61511dbf4b = ()=>(0, $jHEir.useSyncExternalStore)((listener)=>$965642ac39400a6c$export$51b87650e98265a6.subscribeStatus(listener), $965642ac39400a6c$export$51b87650e98265a6.getStatus, ()=>'DISCONNECTED');
const $965642ac39400a6c$export$d969c99f03d34b97 = (identifiers)=>{
    const subscriptionKey = identifiers.filter(Boolean).map((value)=>$965642ac39400a6c$var$normalize(String(value))).sort().join('\u0000');
    const targets = (0, $jHEir.useMemo)(()=>subscriptionKey ? subscriptionKey.split('\u0000') : [], [
        subscriptionKey
    ]);
    const subscribe = (0, $jHEir.useCallback)((listener)=>{
        const unsubscribe = targets.map((target)=>$965642ac39400a6c$export$51b87650e98265a6.subscribe(target, listener));
        return ()=>unsubscribe.forEach((dispose)=>dispose());
    }, [
        targets
    ]);
    (0, $jHEir.useSyncExternalStore)(subscribe, $965642ac39400a6c$export$51b87650e98265a6.getVersion, ()=>0);
    return Object.fromEntries(targets.map((target)=>[
            target,
            $965642ac39400a6c$export$51b87650e98265a6.getQuote(target)
        ]));
};



var $9YmcI = parcelRequire("9YmcI");

const $4fae97be3bd1688e$export$bea0108ed1159fea = (input)=>{
    if (input.editingOrder && input.unsupportedOrderType) return `IB order type ${input.unsupportedOrderType} cannot be edited safely from this form.`;
    const quantity = parseInt(input.quantity);
    if (!input.symbol || isNaN(quantity) || quantity <= 0) return 'Valid quantity (minimum 1) is required';
    if ([
        'LIMIT',
        'MIDPRICE',
        'STOP'
    ].includes(input.orderType) && (!input.price || parseFloat(input.price) <= 0)) return input.orderType === 'MIDPRICE' ? 'A positive price cap is required for MIDPRICE orders' : `Valid price is required for ${input.orderType} orders`;
    if (input.orderType === 'MARKET' && input.tif === 'GTC') return 'GTC is only available for limit and stop orders.';
    if (input.orderType === 'MARKET' && input.outsideRth) return 'Outside RTH is only available for limit and stop orders.';
    if (input.orderType === 'TRAIL' && (!input.trailingAmount || parseFloat(input.trailingAmount) <= 0)) return 'A valid trailing amount or percent is required for TRAIL orders.';
    return null;
};
const $4fae97be3bd1688e$export$540f99b4ded10cc = (contract, inputSymbol)=>{
    if (!contract || !inputSymbol) return false;
    const normalizedInput = inputSymbol.toUpperCase();
    return [
        contract.symbol,
        contract.local_symbol,
        contract.display_symbol
    ].filter(Boolean).some((value)=>String(value).toUpperCase() === normalizedInput);
};
const $4fae97be3bd1688e$export$23c8c83a87ff6bb9 = (orderType, price, trailingAmount, trailType)=>({
        price: [
            'LIMIT',
            'MIDPRICE',
            'STOP'
        ].includes(orderType) ? parseFloat(parseFloat(price).toFixed(2)) : undefined,
        trailing_amount: orderType === 'TRAIL' && trailType === 'amount' ? parseFloat(parseFloat(trailingAmount).toFixed(2)) : undefined,
        trailing_percent: orderType === 'TRAIL' && trailType === 'percent' ? parseFloat(parseFloat(trailingAmount).toFixed(2)) : undefined
    });
const $4fae97be3bd1688e$export$6faa45e965c294d8 = (input, selectedContract)=>{
    const activeContract = $4fae97be3bd1688e$export$540f99b4ded10cc(selectedContract, input.symbol) ? selectedContract : null;
    const orderSymbol = activeContract?.symbol.toUpperCase() ?? input.symbol.toUpperCase();
    return {
        symbol: orderSymbol,
        action: input.action,
        quantity: input.quantity,
        order_type: input.orderType,
        ...input.priceFields,
        sec_type: input.secType,
        strategy_name: input.strategyName,
        tif: input.tif,
        outside_rth: input.outsideRth,
        ...activeContract ? {
            con_id: activeContract.con_id ?? undefined,
            exchange: activeContract.exchange ?? undefined,
            currency: activeContract.currency ?? undefined,
            last_trade_date_or_contract_month: activeContract.last_trade_date_or_contract_month ?? undefined,
            local_symbol: activeContract.local_symbol ?? undefined,
            trading_class: activeContract.trading_class ?? undefined,
            multiplier: activeContract.multiplier ?? undefined
        } : {}
    };
};


const $f39b8a1d460464c0$export$8907da9d2a74bdf7 = (quote)=>{
    if (!quote) return null;
    const value = quote.price ?? quote.last ?? quote.close;
    return value !== undefined && value !== null && !Number.isNaN(Number(value)) ? Number(value) : null;
};


const $5f2bef4e6a2b4b83$export$9b9361be1628b06 = ({ symbol: symbol, secType: secType, selectedContract: selectedContract })=>{
    const [marketPrice, setMarketPrice] = (0, $jHEir.useState)(null);
    const [marketPriceQuote, setMarketPriceQuote] = (0, $jHEir.useState)(null);
    const [fetchingPrice, setFetchingPrice] = (0, $jHEir.useState)(false);
    const liveQuoteIdentifier = selectedContract?.con_id ? `conid:${selectedContract.con_id}` : selectedContract?.symbol || symbol || null;
    const liveQuote = (0, $965642ac39400a6c$export$79ae38ef14e32131)(liveQuoteIdentifier);
    const quoteConnectionStatus = (0, $965642ac39400a6c$export$2341ff61511dbf4b)();
    const displayedMarketQuote = liveQuote || marketPriceQuote;
    const marketPricePresentation = (0, $9YmcI.getPricePresentation)({
        quote: displayedMarketQuote,
        connectionStatus: quoteConnectionStatus,
        hasPrice: marketPrice !== null,
        streamed: Boolean(liveQuote)
    });
    const clearQuote = (0, $jHEir.useCallback)(()=>{
        setMarketPrice(null);
        setMarketPriceQuote(null);
    }, []);
    const setQuoteSnapshot = (0, $jHEir.useCallback)((price, quote)=>{
        setMarketPrice(price);
        setMarketPriceQuote(quote);
    }, []);
    (0, $jHEir.useEffect)(()=>{
        if (!liveQuote || !Number.isFinite(Number(liveQuote.price))) return;
        setMarketPrice(Number(liveQuote.price));
        setMarketPriceQuote(liveQuote);
        setFetchingPrice(false);
    }, [
        liveQuote
    ]);
    const fetchQuote = (0, $jHEir.useCallback)(async (targetSymbols)=>{
        const symbols = (Array.isArray(targetSymbols) ? targetSymbols : [
            targetSymbols
        ]).map((value)=>String(value || '').trim().toUpperCase()).filter(Boolean);
        const uniqueSymbols = Array.from(new Set(symbols));
        if (uniqueSymbols.length === 0) {
            clearQuote();
            return;
        }
        setFetchingPrice(true);
        try {
            const response = await (0, $zs3Np.tradingApi).getQuotes(uniqueSymbols);
            const quotes = response.data;
            if (response.success && quotes) {
                const quote = uniqueSymbols.map((candidate)=>quotes[candidate]).find(Boolean);
                const quotePrice = (0, $f39b8a1d460464c0$export$8907da9d2a74bdf7)(quote);
                if (quotePrice !== null) setQuoteSnapshot(quotePrice, quote);
            }
        } catch (error) {
            console.warn('Failed to fetch quote:', error);
        } finally{
            setFetchingPrice(false);
        }
    }, [
        clearQuote,
        setQuoteSnapshot
    ]);
    const fetchContractQuote = (0, $jHEir.useCallback)(async (contract, preferLive = false)=>{
        if (!contract.symbol) return;
        setFetchingPrice(true);
        try {
            const response = await (0, $zs3Np.tradingApi).getContractQuote({
                symbol: contract.symbol.toUpperCase(),
                sec_type: contract.sec_type || secType,
                con_id: contract.con_id ?? undefined,
                exchange: contract.exchange ?? undefined,
                currency: contract.currency ?? undefined,
                last_trade_date_or_contract_month: contract.last_trade_date_or_contract_month ?? undefined,
                local_symbol: contract.local_symbol ?? undefined,
                trading_class: contract.trading_class ?? undefined,
                multiplier: contract.multiplier ?? undefined,
                prefer_live: preferLive
            });
            if (response.success && response.data) {
                const quotePrice = (0, $f39b8a1d460464c0$export$8907da9d2a74bdf7)(response.data);
                if (quotePrice !== null) setQuoteSnapshot(quotePrice, response.data);
            }
        } catch (error) {
            console.warn('Failed to fetch contract quote:', error);
        } finally{
            setFetchingPrice(false);
        }
    }, [
        secType,
        setQuoteSnapshot
    ]);
    (0, $jHEir.useEffect)(()=>{
        const timer = window.setTimeout(()=>{
            if (!symbol) return;
            const quoteSymbol = (0, $4fae97be3bd1688e$export$540f99b4ded10cc)(selectedContract, symbol) ? selectedContract : symbol;
            if (!quoteSymbol) return;
            if (typeof quoteSymbol === 'string') {
                if (secType === 'FUT') return;
                fetchQuote(quoteSymbol);
            } else if ((0, $920abb5f1a8e551f$export$70d034a749d428df)(quoteSymbol)) fetchContractQuote(quoteSymbol, (0, $920abb5f1a8e551f$export$4aaaaf2ad7363269)(quoteSymbol));
            else fetchQuote(quoteSymbol.symbol || '');
        }, 800);
        return ()=>window.clearTimeout(timer);
    }, [
        symbol,
        secType,
        selectedContract,
        fetchContractQuote,
        fetchQuote
    ]);
    const refreshSelectedQuote = (0, $jHEir.useCallback)(()=>{
        if ((0, $4fae97be3bd1688e$export$540f99b4ded10cc)(selectedContract, symbol) && selectedContract) {
            if ((0, $920abb5f1a8e551f$export$70d034a749d428df)(selectedContract)) {
                fetchContractQuote(selectedContract, (0, $920abb5f1a8e551f$export$4aaaaf2ad7363269)(selectedContract));
                return;
            }
        }
        if (secType === 'FUT') return;
        fetchQuote(symbol);
    }, [
        selectedContract,
        symbol,
        fetchContractQuote,
        secType,
        fetchQuote
    ]);
    return {
        marketPrice: marketPrice,
        setMarketPrice: setMarketPrice,
        fetchingPrice: fetchingPrice,
        marketPricePresentation: marketPricePresentation,
        clearQuote: clearQuote,
        setQuoteSnapshot: setQuoteSnapshot,
        fetchQuote: fetchQuote,
        fetchContractQuote: fetchContractQuote,
        refreshSelectedQuote: refreshSelectedQuote
    };
};



var $jHEir = parcelRequire("jHEir");

var $zs3Np = parcelRequire("zs3Np");

function $989e4c5fed015cb5$export$1b44b7b960ace4db({ editingOrder: editingOrder, unsupportedOrderType: unsupportedOrderType, symbol: symbol, action: action, quantity: quantity, orderType: orderType, price: price, trailingAmount: trailingAmount, trailType: trailType, tif: tif, outsideRth: outsideRth, secType: secType, strategyName: strategyName, selectedContract: selectedContract, setLoading: setLoading, setError: setError, setSuccess: setSuccess, resetForm: resetForm, onOrderModified: onOrderModified, onOrderSubmitted: onOrderSubmitted }) {
    return (0, $jHEir.useCallback)(async ()=>{
        const validationError = (0, $4fae97be3bd1688e$export$bea0108ed1159fea)({
            editingOrder: Boolean(editingOrder),
            unsupportedOrderType: unsupportedOrderType,
            symbol: symbol,
            quantity: quantity,
            orderType: orderType,
            price: price,
            tif: tif,
            outsideRth: outsideRth,
            trailingAmount: trailingAmount
        });
        if (validationError) {
            setError(validationError);
            return;
        }
        const qtyNum = parseInt(quantity);
        setLoading(true);
        setError(null);
        setSuccess(null);
        try {
            const priceFields = (0, $4fae97be3bd1688e$export$23c8c83a87ff6bb9)(orderType, price, trailingAmount, trailType);
            if (editingOrder) {
                const res = await (0, $zs3Np.tradingApi).modifyOrder(editingOrder.order_id, {
                    action: action,
                    quantity: qtyNum,
                    order_type: orderType,
                    ...priceFields,
                    tif: tif,
                    outside_rth: outsideRth
                });
                setSuccess(res.message || `Order ${editingOrder.order_id} modification submitted.`);
                window.dispatchEvent(new CustomEvent('trading-data-refresh'));
                resetForm();
                onOrderModified?.();
                return;
            }
            const orderPayload = (0, $4fae97be3bd1688e$export$6faa45e965c294d8)({
                symbol: symbol,
                action: action,
                quantity: qtyNum,
                orderType: orderType,
                priceFields: priceFields,
                secType: secType,
                strategyName: strategyName,
                tif: tif,
                outsideRth: outsideRth
            }, selectedContract);
            const res = await (0, $zs3Np.tradingApi).placeOrder(orderPayload);
            setSuccess(res.message || `${action} order for ${quantity} ${orderPayload.symbol} placed successfully.`);
            window.dispatchEvent(new CustomEvent('trading-data-refresh'));
            resetForm();
            onOrderSubmitted?.();
        } catch (err) {
            console.warn(err);
            setError(err.message || 'Failed to place order.');
        } finally{
            setLoading(false);
        }
    }, [
        action,
        editingOrder,
        onOrderModified,
        onOrderSubmitted,
        outsideRth,
        orderType,
        price,
        quantity,
        resetForm,
        secType,
        selectedContract,
        setError,
        setLoading,
        setSuccess,
        strategyName,
        tif,
        trailingAmount,
        trailType,
        symbol,
        unsupportedOrderType
    ]);
}


const $d9e214164e7fb7a2$var$ManualOrderEntry = ({ editingOrder: editingOrder = null, prefillOrder: prefillOrder = null, preparedNQMMOrder: preparedNQMMOrder = null, onCancelEditing: onCancelEditing, onCancel: onCancel, onOrderModified: onOrderModified, onOrderSubmitted: onOrderSubmitted, showCancelButton: showCancelButton = false, inModal: inModal = false })=>{
    const [symbol, setSymbol] = (0, $jHEir.useState)('');
    const [secType, setSecType] = (0, $jHEir.useState)('STK');
    const [strategyName, setStrategyName] = (0, $jHEir.useState)('MANUAL');
    const [action, setAction] = (0, $jHEir.useState)('BUY');
    const [orderType, setOrderType] = (0, $jHEir.useState)('MARKET');
    const [tif, setTif] = (0, $jHEir.useState)('DAY');
    const [outsideRth, setOutsideRth] = (0, $jHEir.useState)(false);
    const [price, setPrice] = (0, $jHEir.useState)('');
    const [trailingAmount, setTrailingAmount] = (0, $jHEir.useState)('');
    const [trailType, setTrailType] = (0, $jHEir.useState)('amount');
    const [quantity, setQuantity] = (0, $jHEir.useState)('1');
    const [loading, setLoading] = (0, $jHEir.useState)(false);
    const [error, setError] = (0, $jHEir.useState)(null);
    const [success, setSuccess] = (0, $jHEir.useState)(null);
    const [unsupportedOrderType, setUnsupportedOrderType] = (0, $jHEir.useState)(null);
    const [showDropdown, setShowDropdown] = (0, $jHEir.useState)(false);
    const [selectedContract, setSelectedContract] = (0, $jHEir.useState)(null);
    const initialOrderTypeEffect = (0, $jHEir.useRef)(true);
    const { lookupResults: lookupResults, setLookupResults: setLookupResults, lookupLoading: lookupLoading, handleLookup: handleLookup } = (0, $4afcdb9299e677ef$export$650e809fb8b3bf1e)({
        symbol: symbol,
        secType: secType,
        setError: setError,
        setShowDropdown: setShowDropdown
    });
    const { marketPrice: marketPrice, fetchingPrice: fetchingPrice, marketPricePresentation: marketPricePresentation, clearQuote: clearQuote, setQuoteSnapshot: setQuoteSnapshot, fetchQuote: fetchQuote, fetchContractQuote: fetchContractQuote, refreshSelectedQuote: refreshSelectedQuote } = (0, $5f2bef4e6a2b4b83$export$9b9361be1628b06)({
        symbol: symbol,
        secType: secType,
        selectedContract: selectedContract
    });
    const positionSuggestions = (0, $a9f3210807455324$export$3d7e5f9788c3a86e)();
    const resetForm = (0, $jHEir.useCallback)(()=>{
        setSymbol('');
        setSecType('STK');
        setStrategyName('MANUAL');
        setAction('BUY');
        setOrderType('MARKET');
        setTif('DAY');
        setOutsideRth(false);
        setQuantity('1');
        setPrice('');
        setTrailingAmount('');
        setTrailType('amount');
        setUnsupportedOrderType(null);
        clearQuote();
        setSelectedContract(null);
        setLookupResults([]);
        setShowDropdown(false);
    }, [
        clearQuote,
        setLookupResults
    ]);
    (0, $jHEir.useEffect)(()=>{
        const orderToPrefill = editingOrder || prefillOrder;
        if (!orderToPrefill) {
            setUnsupportedOrderType(null);
            return;
        }
        const prefillState = (0, $9842c5c86de43524$export$50b86ba32e7259b5)(orderToPrefill, Boolean(editingOrder));
        setSymbol(prefillState.symbol);
        setSecType(prefillState.secType);
        setAction(prefillState.action);
        setStrategyName(prefillState.strategyName);
        setOrderType(prefillState.orderType);
        setUnsupportedOrderType(prefillState.unsupportedOrderType);
        setTif(prefillState.tif);
        setOutsideRth(prefillState.outsideRth);
        setQuantity(prefillState.quantity);
        setPrice(prefillState.price);
        setTrailType(prefillState.trailType);
        setTrailingAmount(prefillState.trailingAmount);
        clearQuote();
        setSelectedContract(prefillState.selectedContract);
        setLookupResults([]);
        setShowDropdown(false);
        setError(prefillState.error);
        setSuccess(null);
    }, [
        editingOrder,
        prefillOrder,
        clearQuote,
        setLookupResults
    ]);
    const applyPreparedNQMMOrder = (0, $jHEir.useCallback)((prepared)=>{
        setSymbol(prepared.symbol);
        setSecType(prepared.secType);
        setStrategyName('NQMM');
        setAction(prepared.action);
        setOrderType(prepared.orderType);
        setTif('DAY');
        setOutsideRth(false);
        setQuantity(prepared.quantity);
        setPrice(prepared.price);
        setTrailingAmount('');
        setUnsupportedOrderType(null);
        setSelectedContract(prepared.selectedContract);
        setLookupResults([]);
        setShowDropdown(false);
        setError(null);
        setSuccess(null);
    }, [
        setLookupResults
    ]);
    (0, $jHEir.useEffect)(()=>{
        if (preparedNQMMOrder) applyPreparedNQMMOrder(preparedNQMMOrder);
    }, [
        applyPreparedNQMMOrder,
        preparedNQMMOrder
    ]);
    (0, $79a8ce4ee2d1a60e$export$864d48651a61907e)({
        onCancelEditing: onCancelEditing,
        onPreparedOrder: applyPreparedNQMMOrder
    });
    (0, $jHEir.useEffect)(()=>{
        if (initialOrderTypeEffect.current) {
            initialOrderTypeEffect.current = false;
            return;
        }
        if (orderType === 'MARKET') {
            setPrice('');
            setTrailingAmount('');
        } else if (orderType !== 'TRAIL') setTrailingAmount('');
        else setPrice('');
    }, [
        orderType
    ]);
    // Use the latest usable quote as a starting price for price-based orders.
    // The field remains editable, so this is only a convenience default.
    (0, $jHEir.useEffect)(()=>{
        if (![
            'LIMIT',
            'MIDPRICE',
            'STOP'
        ].includes(orderType)) return;
        if (price || marketPrice === null || !marketPricePresentation.usableForPricing) return;
        setPrice(marketPrice.toFixed(2));
    }, [
        marketPrice,
        marketPricePresentation.usableForPricing,
        orderType,
        price
    ]);
    // Auto-clear error messages after 8 seconds
    (0, $jHEir.useEffect)(()=>{
        if (error) {
            const timer = setTimeout(()=>setError(null), 8000);
            return ()=>clearTimeout(timer);
        }
    }, [
        error
    ]);
    // Auto-clear success messages after 5 seconds
    (0, $jHEir.useEffect)(()=>{
        if (success) {
            const timer = setTimeout(()=>setSuccess(null), 5000);
            return ()=>clearTimeout(timer);
        }
    }, [
        success
    ]);
    const applyContractSelection = (0, $jHEir.useCallback)((contract)=>{
        setSymbol((contract.local_symbol || contract.symbol || '').toUpperCase());
        if (contract.sec_type) setSecType(contract.sec_type.toUpperCase());
        setPrice('');
        setSelectedContract(contract);
        setLookupResults([]);
        setShowDropdown(false);
        clearQuote();
        if (contract.current_price !== undefined && contract.current_price !== null) setQuoteSnapshot(Number(contract.current_price), {
            price: Number(contract.current_price),
            stale: Boolean(contract.current_price_stale),
            delayed: Boolean(contract.current_price_delayed) || (0, $920abb5f1a8e551f$export$4aaaaf2ad7363269)(contract),
            received_at: contract.current_price_received_at
        });
        if ((0, $920abb5f1a8e551f$export$70d034a749d428df)(contract)) fetchContractQuote(contract, (0, $920abb5f1a8e551f$export$4aaaaf2ad7363269)(contract));
        else fetchQuote(contract.symbol || '');
    }, [
        clearQuote,
        fetchContractQuote,
        fetchQuote,
        setLookupResults,
        setQuoteSnapshot
    ]);
    const handleSnap = ()=>{
        if (marketPrice !== null && marketPricePresentation.usableForPricing) setPrice(marketPrice.toFixed(2));
    };
    const handleFormSubmit = (e)=>{
        e.preventDefault();
    };
    const handlePlaceOrderClick = (0, $989e4c5fed015cb5$export$1b44b7b960ace4db)({
        editingOrder: editingOrder,
        unsupportedOrderType: unsupportedOrderType,
        symbol: symbol,
        action: action,
        quantity: quantity,
        orderType: orderType,
        price: price,
        trailingAmount: trailingAmount,
        trailType: trailType,
        tif: tif,
        outsideRth: outsideRth,
        secType: secType,
        strategyName: strategyName,
        selectedContract: selectedContract,
        setLoading: setLoading,
        setError: setError,
        setSuccess: setSuccess,
        resetForm: resetForm,
        onOrderModified: onOrderModified,
        onOrderSubmitted: onOrderSubmitted
    });
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        id: inModal ? undefined : 'manual-order-entry',
        className: `panel w-full ${inModal ? 'modal-form-shell' : 'full-bleed-panel lg:h-full'}`,
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "px-6 py-5 border-b border-white/10",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: `p-2 rounded-lg ${editingOrder ? 'bg-warning-500/10 text-warning-500' : 'bg-neon/10 text-neon'}`,
                                children: editingOrder ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $29b1874158a6f84e$export$2e2bcd8739ae039), {
                                    className: "w-5 h-5"
                                }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8d55bb18c538de43$export$2e2bcd8739ae039), {
                                    className: "w-5 h-5 fill-current"
                                })
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "space-y-0.5",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                        className: "text-lg font-bold text-white tracking-tight",
                                        children: editingOrder ? 'Modify Order' : prefillOrder ? 'Close Position' : 'Manual Order'
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                        className: "text-xs text-muted",
                                        children: editingOrder ? `Editing open order #${editingOrder.order_id}` : prefillOrder ? 'Review the closing order before sending it to IB' : 'Discretionary trade execution via IB'
                                    })
                                ]
                            })
                        ]
                    }),
                    editingOrder && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "mt-4 rounded-lg border border-warning-500/25 bg-warning-500/10 px-3 py-2 text-[11px] text-warning-500",
                        children: "Update the current IB order, then submit the modification. The instrument stays locked to this order."
                    }),
                    unsupportedOrderType && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "mt-2 rounded-lg border border-error-500/25 bg-error-500/10 px-3 py-2 text-[11px] text-error-500",
                        children: [
                            "This order is ",
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "font-mono font-semibold",
                                children: unsupportedOrderType
                            }),
                            ", which this editor does not support. Cancel editing and use IBKR/TWS so the order type and protective price are preserved."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "p-4",
                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("form", {
                    onSubmit: handleFormSubmit,
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $0fc3db7cbc69ec2d$export$2e2bcd8739ae039), {
                            symbol: symbol,
                            secType: secType,
                            isEditing: Boolean(editingOrder),
                            positionSuggestions: positionSuggestions,
                            lookupResults: lookupResults,
                            lookupLoading: lookupLoading,
                            showDropdown: showDropdown,
                            selectedContract: selectedContract,
                            marketPrice: marketPrice,
                            fetchingPrice: fetchingPrice,
                            pricePresentation: marketPricePresentation,
                            onSymbolChange: (nextSymbol)=>{
                                setSymbol(nextSymbol);
                                setSelectedContract(null);
                                setLookupResults([]);
                                clearQuote();
                                setPrice('');
                                if (!showDropdown) setShowDropdown(true);
                            },
                            onSymbolFocus: ()=>{
                                setError(null);
                                setShowDropdown(true);
                            },
                            onSymbolBlur: ()=>{
                                // Delay to allow clicking dropdown items.
                                setTimeout(()=>setShowDropdown(false), 200);
                            },
                            onSecTypeChange: (value)=>{
                                setSecType(value);
                                setSelectedContract(null);
                                setLookupResults([]);
                                clearQuote();
                                setPrice('');
                            },
                            onLookup: handleLookup,
                            onSelectContract: applyContractSelection,
                            onRefreshQuote: refreshSelectedQuote
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $6bcda43b84742562$export$2e2bcd8739ae039), {
                            action: action,
                            quantity: quantity,
                            onActionChange: setAction,
                            onQuantityChange: setQuantity
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4357098bced51348$export$2e2bcd8739ae039), {
                            orderType: orderType,
                            price: price,
                            trailingAmount: trailingAmount,
                            trailType: trailType,
                            action: action,
                            marketPrice: marketPrice,
                            fetchingPrice: fetchingPrice,
                            pricePresentation: marketPricePresentation,
                            currency: selectedContract?.currency || 'USD',
                            onOrderTypeChange: (value)=>{
                                setOrderType(value);
                                if ([
                                    'LIMIT',
                                    'MIDPRICE',
                                    'STOP'
                                ].includes(value) && !price && marketPrice !== null && marketPricePresentation.usableForPricing) setPrice(marketPrice.toFixed(2));
                                if (value === 'MARKET' || value === 'MIDPRICE') {
                                    setTif('DAY');
                                    setOutsideRth(false);
                                }
                            },
                            onPriceChange: setPrice,
                            onTrailingAmountChange: setTrailingAmount,
                            onTrailTypeChange: setTrailType,
                            onRefreshQuote: refreshSelectedQuote,
                            onSnapToMarket: handleSnap
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $b24d9bc3dbe97d48$export$2e2bcd8739ae039), {
                            timeInForce: tif,
                            outsideRegularHours: outsideRth,
                            orderType: orderType,
                            onTimeInForceChange: setTif,
                            onOutsideRegularHoursChange: setOutsideRth
                        }),
                        error && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "flex items-center gap-2 text-xs text-error-500 bg-error-500/10 p-2 rounded-sm border border-error-500/20",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $gKbib.default), {
                                    className: "w-3 h-3 flex-shrink-0"
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                    children: error
                                })
                            ]
                        }),
                        success && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "flex items-center gap-2 text-xs text-success-500 bg-success-500/10 p-2 rounded-sm border border-success-500/20",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $5j4E8.default), {
                                    className: "w-3 h-3 flex-shrink-0"
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                    children: success
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "flex min-w-0 gap-2",
                            children: [
                                (editingOrder || showCancelButton) && /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $62Hcf.ThemeButton), {
                                    variant: "ghost",
                                    size: "xs",
                                    type: "button",
                                    onClick: ()=>{
                                        resetForm();
                                        (onCancel || onCancelEditing)?.();
                                    },
                                    disabled: loading,
                                    "aria-label": "Cancel editing",
                                    className: "min-w-0 flex-1 flex items-center justify-center gap-1.5 uppercase tracking-[0.12em] leading-none",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                                            className: "w-3.5 h-3.5 shrink-0"
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            className: "truncate",
                                            children: "CANCEL"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $62Hcf.ThemeButton), {
                                    variant: action === "BUY" ? "success" : "danger",
                                    size: "md",
                                    type: "button",
                                    onClick: handlePlaceOrderClick,
                                    disabled: loading || Boolean(unsupportedOrderType) || !symbol || !quantity || parseInt(quantity) <= 0,
                                    className: editingOrder || showCancelButton ? "min-w-0 flex-[1.2]" : "w-full",
                                    children: loading ? editingOrder ? 'Updating...' : 'Executing...' : /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                                        children: [
                                            editingOrder ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $29b1874158a6f84e$export$2e2bcd8739ae039), {
                                                className: "w-3.5 h-3.5 shrink-0"
                                            }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $250845bdd95058d5$export$2e2bcd8739ae039), {
                                                className: "w-3.5 h-3.5 shrink-0"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "truncate",
                                                children: editingOrder ? `MODIFY ${action}` : `PLACE ${action}`
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $d9e214164e7fb7a2$export$2e2bcd8739ae039 = $d9e214164e7fb7a2$var$ManualOrderEntry;




var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $zs3Np = parcelRequire("zs3Np");

var $e4aOX = parcelRequire("e4aOX");

var $i3HgA = parcelRequire("i3HgA");
const $62fd36d4e1e4997c$var$AccountSwitcher = ({ onContextChange: onContextChange, direction: direction = 'down', align: align = 'right', variant: variant = 'default', showIdentity: showIdentity = false, alwaysRender: alwaysRender = false })=>{
    const { login: login } = (0, $e4aOX.useAuth)();
    const [context, setContext] = (0, $jHEir.useState)(null);
    const [managedAccounts, setManagedAccounts] = (0, $jHEir.useState)([]);
    const [isOpen, setIsOpen] = (0, $jHEir.useState)(false);
    const [loading, setLoading] = (0, $jHEir.useState)(false);
    const dropdownRef = (0, $jHEir.useRef)(null);
    (0, $jHEir.useEffect)(()=>{
        fetchContext();
        fetchManagedAccounts();
    }, []);
    (0, $jHEir.useEffect)(()=>{
        const id = window.setInterval(fetchManagedAccounts, 10000);
        return ()=>window.clearInterval(id);
    }, []);
    // Close dropdown when clicking outside
    (0, $jHEir.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const fetchContext = async ()=>{
        try {
            const response = await (0, $zs3Np.tradingApi).getCurrentContext();
            if (response.success && response.data) setContext(response.data);
        } catch (err) {
            console.warn('Failed to fetch context:', err);
        }
    };
    const fetchManagedAccounts = async ()=>{
        try {
            const response = await (0, $zs3Np.tradingApi).getManagedAccounts();
            if (response.success && response.data?.managed_accounts) setManagedAccounts(response.data?.managed_accounts);
        } catch (err) {
            console.warn('Failed to fetch managed accounts:', err);
        }
    };
    const handleSwitch = async (accountId)=>{
        setLoading(true);
        try {
            const response = await (0, $zs3Np.tradingApi).switchToManagedAccount(accountId);
            if (response.access_token) {
                login(response.access_token);
                setIsOpen(false);
                await fetchContext();
                if (onContextChange) onContextChange();
                // Reload the page to refresh all data
                window.location.reload();
            }
        } catch (err) {
            console.warn('Failed to switch account:', err);
        } finally{
            setLoading(false);
        }
    };
    const handleSwitchBack = async ()=>{
        setLoading(true);
        try {
            const response = await (0, $zs3Np.tradingApi).switchBackToOwnAccount();
            if (response.access_token) {
                login(response.access_token);
                setIsOpen(false);
                await fetchContext();
                if (onContextChange) onContextChange();
                window.location.reload();
            }
        } catch (err) {
            console.warn('Failed to switch back:', err);
        } finally{
            setLoading(false);
        }
    };
    const canSwitchContext = managedAccounts.length > 0 || !!context?.is_acting_as;
    // Don't render if no managed accounts and not acting as someone
    if (!alwaysRender && !canSwitchContext) return null;
    const displayName = context?.first_name ? `${context.first_name}${context.last_name ? ' ' + context.last_name.charAt(0) + '.' : ''}` : context?.username || 'User';
    const isIdentityCompact = variant === 'compact' && showIdentity;
    const dropdownAlignment = isIdentityCompact ? 'left-0 max-w-[calc(100vw-7.25rem)]' : `max-w-[calc(100vw-2rem)] ${align === 'right' ? 'right-0' : 'left-0'}`;
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: `relative ${isIdentityCompact ? 'min-w-0 flex-1 max-w-[190px]' : ''}`,
        ref: dropdownRef,
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                onClick: ()=>{
                    if (canSwitchContext) setIsOpen(!isOpen);
                },
                className: `flex items-center gap-2 rounded-lg transition-colors min-w-0 ${variant === 'compact' ? context?.is_acting_as ? `${isIdentityCompact ? 'h-8 w-full px-2 justify-start' : 'w-7 h-7 justify-center flex-shrink-0'} bg-amber-900/30 border border-amber-600/50 text-amber-300 hover:bg-amber-900/50` : `${isIdentityCompact ? 'h-8 w-full px-2 justify-start' : 'w-7 h-7 justify-center flex-shrink-0'} bg-gray-800 border border-gray-600 text-gray-300 ${canSwitchContext ? 'hover:bg-gray-700' : ''}` : `px-3 py-1.5 border w-full text-left ${context?.is_acting_as ? 'bg-amber-900/30 border-amber-600/50 text-amber-300 hover:bg-amber-900/50' : 'bg-gray-800 border-gray-600 text-gray-300 hover:bg-gray-700'}`}`,
                disabled: loading,
                title: variant === 'compact' ? displayName : undefined,
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("svg", {
                        className: `flex-shrink-0 ${variant === 'compact' ? 'w-3.5 h-3.5' : 'w-4 h-4'} ${context?.is_acting_as ? 'text-amber-400 shadow-[0_0_8px_rgba(251,191,36,0.4)]' : 'text-neon shadow-[0_0_8px_rgba(var(--neon-rgb),0.3)]'}`,
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        children: /*#__PURE__*/ (0, $eHRxX.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        })
                    }),
                    isIdentityCompact && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "min-w-0 flex flex-col items-start justify-center leading-none",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "max-w-full truncate text-[11px] font-bold text-white",
                                children: displayName
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $i3HgA.default), {
                                role: context?.role,
                                compact: true,
                                className: "max-[360px]:hidden"
                            })
                        ]
                    }),
                    variant !== 'compact' && /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "text-sm font-medium truncate flex-1 min-w-0",
                                children: displayName
                            }),
                            context?.is_acting_as && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "text-[10px] px-1 py-0.5 bg-amber-600/30 rounded-sm text-amber-200 whitespace-nowrap flex-shrink-0",
                                children: "Acting As"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("svg", {
                                className: `w-4 h-4 transition-transform flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`,
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M19 9l-7 7-7-7"
                                })
                            })
                        ]
                    }),
                    isIdentityCompact && canSwitchContext && /*#__PURE__*/ (0, $eHRxX.jsx)("svg", {
                        className: `w-3 h-3 transition-transform flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`,
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        children: /*#__PURE__*/ (0, $eHRxX.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M19 9l-7 7-7-7"
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: `absolute w-64 ${dropdownAlignment} bg-gray-800 border border-gray-700 rounded-lg shadow-xl z-50 ${direction === 'up' ? 'bottom-full mb-2' : 'top-full mt-2'}`,
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "p-3 border-b border-gray-700",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                className: "text-xs text-gray-500 uppercase tracking-wider",
                                children: "Current Account"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "mt-1 flex items-center justify-between gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                        className: "min-w-0 truncate text-sm font-medium text-gray-200",
                                        title: context?.username,
                                        children: context?.username
                                    }),
                                    context && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $i3HgA.default), {
                                        role: context.role,
                                        compact: true
                                    })
                                ]
                            }),
                            context?.is_acting_as && context.original_user && /*#__PURE__*/ (0, $eHRxX.jsxs)("p", {
                                className: "text-xs text-amber-400 mt-1 truncate",
                                children: [
                                    "Managed by: ",
                                    context.original_user.username
                                ]
                            })
                        ]
                    }),
                    context?.is_acting_as && /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                        onClick: handleSwitchBack,
                        disabled: loading,
                        className: "w-full px-3 py-2 text-left text-sm text-blue-400 hover:bg-gray-700 transition-colors flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("svg", {
                                className: "w-4 h-4 flex-shrink-0",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"
                                })
                            }),
                            "Switch Back to My Account"
                        ]
                    }),
                    managedAccounts.length > 0 && /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "px-3 py-2 border-t border-gray-700",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                    className: "text-xs text-gray-500 uppercase tracking-wider",
                                    children: "Managed Accounts"
                                })
                            }),
                            managedAccounts.map((account)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                    onClick: ()=>handleSwitch(account.id),
                                    disabled: loading || context?.user_id === account.id,
                                    className: `w-full px-3 py-2 text-left text-sm transition-colors flex items-center gap-2 ${context?.user_id === account.id ? 'text-gray-500 cursor-not-allowed' : 'text-gray-300 hover:bg-gray-700'}`,
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("svg", {
                                            className: "w-4 h-4 flex-shrink-0",
                                            fill: "none",
                                            stroke: "currentColor",
                                            viewBox: "0 0 24 24",
                                            children: /*#__PURE__*/ (0, $eHRxX.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: 2,
                                                d: "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                            className: "min-w-0 flex-1 truncate",
                                            children: [
                                                account.first_name || account.username,
                                                account.last_name && ` ${account.last_name}`
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $i3HgA.default), {
                                            role: account.role,
                                            compact: true
                                        }),
                                        context?.user_id === account.id && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            className: "ml-auto text-xs text-gray-600 flex-shrink-0",
                                            children: "(current)"
                                        })
                                    ]
                                }, account.id))
                        ]
                    })
                ]
            })
        ]
    });
};
var $62fd36d4e1e4997c$export$2e2bcd8739ae039 = $62fd36d4e1e4997c$var$AccountSwitcher;



var $i3HgA = parcelRequire("i3HgA");

var $gQIZx = parcelRequire("gQIZx");
var $19CqD = parcelRequire("19CqD");
var $cSggV = parcelRequire("cSggV");
var $3KPv1 = parcelRequire("3KPv1");
var $7b33p = parcelRequire("7b33p");
var $h2RqY = parcelRequire("h2RqY");
var $ifMtg = parcelRequire("ifMtg");
var $94HEM = parcelRequire("94HEM");
var $f11WQ = parcelRequire("f11WQ");/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $7181117d24209aed$export$a2387ed3b5d536eb = {
    name: "house",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8",
                key: "5wwlr5"
            }
        ],
        [
            "path",
            {
                d: "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
                key: "r6nss1"
            }
        ]
    ],
    aliases: [
        "home"
    ]
};
$7181117d24209aed$export$a2387ed3b5d536eb.node;
const $7181117d24209aed$export$2e2bcd8739ae039 = (0, $hHhnY.default)($7181117d24209aed$export$a2387ed3b5d536eb);


var $62xmE = parcelRequire("62xmE");/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $b70a514b297db12d$export$a2387ed3b5d536eb = {
    name: "list-checks",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13 5h8",
                key: "a7qcls"
            }
        ],
        [
            "path",
            {
                d: "M13 12h8",
                key: "h98zly"
            }
        ],
        [
            "path",
            {
                d: "M13 19h8",
                key: "c3s6r1"
            }
        ],
        [
            "path",
            {
                d: "m3 17 2 2 4-4",
                key: "1jhpwq"
            }
        ],
        [
            "path",
            {
                d: "m3 7 2 2 4-4",
                key: "1obspn"
            }
        ]
    ]
};
$b70a514b297db12d$export$a2387ed3b5d536eb.node;
const $b70a514b297db12d$export$2e2bcd8739ae039 = (0, $hHhnY.default)($b70a514b297db12d$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $bb39fb9170dd8ee1$export$a2387ed3b5d536eb = {
    name: "log-out",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m16 17 5-5-5-5",
                key: "1bji2h"
            }
        ],
        [
            "path",
            {
                d: "M21 12H9",
                key: "dn1m92"
            }
        ],
        [
            "path",
            {
                d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
                key: "1uf3rs"
            }
        ]
    ]
};
$bb39fb9170dd8ee1$export$a2387ed3b5d536eb.node;
const $bb39fb9170dd8ee1$export$2e2bcd8739ae039 = (0, $hHhnY.default)($bb39fb9170dd8ee1$export$a2387ed3b5d536eb);


var $6q9x0 = parcelRequire("6q9x0");
var $bTVJ1 = parcelRequire("bTVJ1");
var $eC2xp = parcelRequire("eC2xp");
var $ehZ63 = parcelRequire("ehZ63");
var $8Rrv7 = parcelRequire("8Rrv7");/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $7e993a062fc3185b$export$a2387ed3b5d536eb = {
    name: "user",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
                key: "975kel"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "7",
                r: "4",
                key: "17ys0d"
            }
        ]
    ]
};
$7e993a062fc3185b$export$a2387ed3b5d536eb.node;
const $7e993a062fc3185b$export$2e2bcd8739ae039 = (0, $hHhnY.default)($7e993a062fc3185b$export$a2387ed3b5d536eb);


var $bgvjD = parcelRequire("bgvjD");

var $zs3Np = parcelRequire("zs3Np");

var $e4aOX = parcelRequire("e4aOX");

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $zs3Np = parcelRequire("zs3Np");

var $gKbib = parcelRequire("gKbib");
var $cSggV = parcelRequire("cSggV");
var $4bqNy = parcelRequire("4bqNy");
var $gNGY5 = parcelRequire("gNGY5");
var $eC2xp = parcelRequire("eC2xp");/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $e41a6c187c3a1be7$export$a2387ed3b5d536eb = {
    name: "shopping-bag",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 10a4 4 0 0 1-8 0",
                key: "1ltviw"
            }
        ],
        [
            "path",
            {
                d: "M3.103 6.034h17.794",
                key: "awc11p"
            }
        ],
        [
            "path",
            {
                d: "M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z",
                key: "o988cm"
            }
        ]
    ]
};
$e41a6c187c3a1be7$export$a2387ed3b5d536eb.node;
const $e41a6c187c3a1be7$export$2e2bcd8739ae039 = (0, $hHhnY.default)($e41a6c187c3a1be7$export$a2387ed3b5d536eb);


var $8FKMh = parcelRequire("8FKMh");
var $bgvjD = parcelRequire("bgvjD");

var $lRLyZ = parcelRequire("lRLyZ");

var $5ogeV = parcelRequire("5ogeV");
const $46b8a5c2cae5e5f7$var$NotificationFeed = ({ onClose: onClose, onUnreadCountChange: onUnreadCountChange })=>{
    const [notifications, setNotifications] = (0, $jHEir.useState)([]);
    const [unreadCount, setUnreadCount] = (0, $jHEir.useState)(0);
    const [loading, setLoading] = (0, $jHEir.useState)(true);
    const [showSettings, setShowSettings] = (0, $jHEir.useState)(false);
    const [preferences, setPreferences] = (0, $jHEir.useState)({
        notify_email_signal: false,
        notify_email_fill: true,
        notify_email_error: true,
        notify_email_warning: true,
        notify_email_system: false,
        notify_sound_enabled: true
    });
    const [savingPrefs, setSavingPrefs] = (0, $jHEir.useState)(false);
    const [activeFilter, setActiveFilter] = (0, $jHEir.useState)('ALL');
    const fetchData = (0, $jHEir.useCallback)(async ()=>{
        try {
            const [notifRes, countRes, contextRes] = await Promise.all([
                (0, $zs3Np.tradingApi).getNotifications(50),
                (0, $zs3Np.tradingApi).getUnreadCount(),
                (0, $zs3Np.tradingApi).getCurrentContext()
            ]);
            if (notifRes.success) setNotifications(notifRes.data);
            if (countRes.success) setUnreadCount(countRes.data.count);
            if (contextRes.success && contextRes.data) setPreferences(contextRes.data.preferences);
        } catch (err) {
            console.error('Failed to fetch notifications:', err);
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $jHEir.useEffect)(()=>{
        if (onUnreadCountChange) onUnreadCountChange(unreadCount);
    }, [
        unreadCount,
        onUnreadCountChange
    ]);
    (0, $jHEir.useEffect)(()=>{
        fetchData();
        const interval = setInterval(fetchData, 15000); // Poll every 15s
        return ()=>clearInterval(interval);
    }, [
        fetchData
    ]);
    const handleTogglePref = async (key)=>{
        setSavingPrefs(true);
        const newPrefs = {
            ...preferences,
            [key]: !preferences[key]
        };
        setPreferences(newPrefs); // Optimistic wrap
        try {
            await (0, $zs3Np.tradingApi).updateNotificationPreferences({
                [key]: newPrefs[key]
            });
        } catch  {
            // Revert on error
            setPreferences(preferences);
        } finally{
            setSavingPrefs(false);
        }
    };
    const handleMarkRead = async (id)=>{
        try {
            const res = await (0, $zs3Np.tradingApi).markNotificationRead(id);
            if (res.success) {
                setNotifications((prev)=>prev.map((n)=>n.id === id ? {
                            ...n,
                            is_read: true
                        } : n));
                setUnreadCount((prev)=>Math.max(0, prev - 1));
            }
        } catch (err) {
            console.error('Failed to mark notification as read:', err);
        }
    };
    const handleMarkAllRead = async ()=>{
        try {
            const res = await (0, $zs3Np.tradingApi).markAllRead();
            if (res.success) {
                setNotifications((prev)=>prev.map((n)=>({
                            ...n,
                            is_read: true
                        })));
                setUnreadCount(0);
            }
        } catch (err) {
            console.error('Failed to mark all as read:', err);
        }
    };
    const getIcon = (type)=>{
        switch(type){
            case 'SIGNAL':
                return /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8FKMh.default), {
                    className: "w-4 h-4 text-blue-400"
                });
            case 'FILL':
                return /*#__PURE__*/ (0, $eHRxX.jsx)((0, $e41a6c187c3a1be7$export$2e2bcd8739ae039), {
                    className: "w-4 h-4 text-emerald-400"
                });
            case 'ERROR':
                return /*#__PURE__*/ (0, $eHRxX.jsx)((0, $gKbib.default), {
                    className: "w-4 h-4 text-red-500"
                });
            case 'WARNING':
                return /*#__PURE__*/ (0, $eHRxX.jsx)((0, $gKbib.default), {
                    className: "w-4 h-4 text-yellow-500"
                });
            default:
                return /*#__PURE__*/ (0, $eHRxX.jsx)((0, $gNGY5.default), {
                    className: "w-4 h-4 text-muted"
                });
        }
    };
    const getPriorityClass = (priority)=>{
        switch(priority){
            case 'success':
                return 'border-emerald-500/30 bg-emerald-500/5';
            case 'error':
                return 'border-red-500/30 bg-red-500/5';
            case 'warning':
                return 'border-yellow-500/30 bg-yellow-500/5';
            default:
                return 'border-white/10 bg-white/5';
        }
    };
    const filteredNotifications = notifications.filter((n)=>activeFilter === 'ALL' || n.type === activeFilter);
    const getFilterButton = (filter, label)=>/*#__PURE__*/ (0, $eHRxX.jsx)("button", {
            onClick: ()=>setActiveFilter(filter),
            className: `px-3 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-widest transition-all duration-200 border ${activeFilter === filter ? 'bg-neon text-black border-neon shadow-[0_0_15px_rgba(92,246,205,0.4)]' : 'bg-white/5 text-muted border-white/10 hover:text-white hover:bg-white/10'}`,
            children: label
        });
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "flex flex-col h-full bg-surface/95 backdrop-blur-2xl border-l border-white/10 shadow-[-20px_0_40px_rgba(0,0,0,0.5)]",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex items-center justify-between p-6 border-b border-white/5 bg-white/5",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $cSggV.default), {
                                        className: "w-5 h-5 text-neon"
                                    }),
                                    unreadCount > 0 && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: "absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center animate-pulse",
                                        children: unreadCount > 9 ? '9+' : unreadCount
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("h2", {
                                className: "text-sm font-bold uppercase tracking-widest text-white",
                                children: "Activity"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-4",
                        children: [
                            unreadCount > 0 && /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                onClick: handleMarkAllRead,
                                className: "text-[10px] font-bold uppercase tracking-tighter text-neon hover:text-white transition-colors flex items-center gap-1 group",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4bqNy.default), {
                                        className: "w-3 h-3 group-hover:scale-110 transition-transform"
                                    }),
                                    "Clear"
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                onClick: ()=>setShowSettings(!showSettings),
                                className: `p-1.5 rounded-lg hover:bg-white/10 transition ${showSettings ? 'text-neon bg-white/5' : 'text-muted hover:text-white'}`,
                                title: "Email Preferences",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $eC2xp.default), {
                                    className: "w-5 h-5"
                                })
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                onClick: onClose,
                                className: "p-1.5 rounded-lg hover:bg-white/10 text-muted hover:text-white transition",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                                    className: "w-5 h-5"
                                })
                            })
                        ]
                    })
                ]
            }),
            !showSettings && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex items-center gap-2 p-4 border-b border-white/5 bg-black/10 overflow-x-auto no-scrollbar",
                children: [
                    getFilterButton('ALL', 'All'),
                    getFilterButton('SIGNAL', 'Signals'),
                    getFilterButton('FILL', 'Trades'),
                    getFilterButton('WARNING', 'Warnings'),
                    getFilterButton('ERROR', 'Errors')
                ]
            }),
            showSettings && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "p-5 border-b border-white/5 bg-black/20",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                        className: "text-[10px] font-bold text-white uppercase tracking-widest mb-4 opacity-50",
                        children: "Email Alert Preferences"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("label", {
                                className: "flex items-center justify-between cursor-pointer group",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: "text-xs font-semibold text-muted group-hover:text-white transition",
                                        children: "Trade Signals"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                                type: "checkbox",
                                                className: "sr-only",
                                                checked: preferences.notify_email_signal,
                                                onChange: ()=>handleTogglePref('notify_email_signal'),
                                                disabled: savingPrefs
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: `w-8 h-4 bg-white/10 rounded-full transition-colors ${preferences.notify_email_signal ? 'bg-neon' : ''}`
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: `dot absolute left-[3px] top-[3px] w-2.5 h-2.5 rounded-full transition-transform transform ${preferences.notify_email_signal ? 'translate-x-[16px] bg-black shadow-[0_0_8px_rgba(92,246,205,0.8)]' : 'bg-muted'}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("label", {
                                className: "flex items-center justify-between cursor-pointer group",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: "text-xs font-semibold text-muted group-hover:text-white transition",
                                        children: "Order Fills"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                                type: "checkbox",
                                                className: "sr-only",
                                                checked: preferences.notify_email_fill,
                                                onChange: ()=>handleTogglePref('notify_email_fill'),
                                                disabled: savingPrefs
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: `w-8 h-4 bg-white/10 rounded-full transition-colors ${preferences.notify_email_fill ? 'bg-neon' : ''}`
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: `dot absolute left-[3px] top-[3px] w-2.5 h-2.5 rounded-full transition-transform transform ${preferences.notify_email_fill ? 'translate-x-[16px] bg-black shadow-[0_0_8px_rgba(92,246,205,0.8)]' : 'bg-muted'}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("label", {
                                className: "flex items-center justify-between cursor-pointer group",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: "text-xs font-semibold text-muted group-hover:text-white transition",
                                        children: "Order Errors (Critical)"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                                type: "checkbox",
                                                className: "sr-only",
                                                checked: preferences.notify_email_error,
                                                onChange: ()=>handleTogglePref('notify_email_error'),
                                                disabled: savingPrefs
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: `w-8 h-4 bg-white/10 rounded-full transition-colors ${preferences.notify_email_error ? 'bg-neon' : ''}`
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: `dot absolute left-[3px] top-[3px] w-2.5 h-2.5 rounded-full transition-transform transform ${preferences.notify_email_error ? 'translate-x-[16px] bg-black shadow-[0_0_8px_rgba(92,246,205,0.8)]' : 'bg-muted'}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("label", {
                                className: "flex items-center justify-between cursor-pointer group",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: "text-xs font-semibold text-muted group-hover:text-white transition",
                                        children: "Data Quality Warnings"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                                type: "checkbox",
                                                className: "sr-only",
                                                checked: preferences.notify_email_warning,
                                                onChange: ()=>handleTogglePref('notify_email_warning'),
                                                disabled: savingPrefs
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: `w-8 h-4 bg-white/10 rounded-full transition-colors ${preferences.notify_email_warning ? 'bg-neon' : ''}`
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: `dot absolute left-[3px] top-[3px] w-2.5 h-2.5 rounded-full transition-transform transform ${preferences.notify_email_warning ? 'translate-x-[16px] bg-black shadow-[0_0_8px_rgba(92,246,205,0.8)]' : 'bg-muted'}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("label", {
                                className: "flex items-center justify-between cursor-pointer group",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: "text-xs font-semibold text-muted group-hover:text-white transition",
                                        children: "System Status"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                                type: "checkbox",
                                                className: "sr-only",
                                                checked: preferences.notify_email_system,
                                                onChange: ()=>handleTogglePref('notify_email_system'),
                                                disabled: savingPrefs
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: `w-8 h-4 bg-white/10 rounded-full transition-colors ${preferences.notify_email_system ? 'bg-neon' : ''}`
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: `dot absolute left-[3px] top-[3px] w-2.5 h-2.5 rounded-full transition-transform transform ${preferences.notify_email_system ? 'translate-x-[16px] bg-black shadow-[0_0_8px_rgba(92,246,205,0.8)]' : 'bg-muted'}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "h-px bg-white/10 my-1"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("label", {
                                className: "flex items-center justify-between cursor-pointer group",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: "text-xs font-semibold text-neon group-hover:text-white transition",
                                        children: "Sound Alerts"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                                type: "checkbox",
                                                className: "sr-only",
                                                checked: preferences.notify_sound_enabled,
                                                onChange: ()=>handleTogglePref('notify_sound_enabled'),
                                                disabled: savingPrefs
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: `w-8 h-4 bg-white/10 rounded-full transition-colors ${preferences.notify_sound_enabled ? 'bg-neon' : ''}`
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: `dot absolute left-[3px] top-[3px] w-2.5 h-2.5 rounded-full transition-transform transform ${preferences.notify_sound_enabled ? 'translate-x-[16px] bg-black shadow-[0_0_8px_rgba(92,246,205,0.8)]' : 'bg-black'}`
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "flex-1 overflow-y-auto scrollbar-thin p-4 space-y-3",
                children: loading && notifications.length === 0 ? /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "flex justify-center p-8",
                    children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $5ogeV.default), {
                        size: "md"
                    })
                }) : filteredNotifications.length === 0 ? /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "h-full flex flex-col items-center justify-center text-muted gap-4 opacity-30 pb-20",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $gNGY5.default), {
                            className: "w-12 h-12"
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "text-sm font-medium tracking-wide",
                            children: activeFilter === 'ALL' ? 'No recent events' : `No ${activeFilter.toLowerCase()} events`
                        })
                    ]
                }) : filteredNotifications.map((n)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        onClick: ()=>!n.is_read && handleMarkRead(n.id),
                        className: `relative group cursor-pointer p-4 rounded-xl border transition-all duration-200 hover:shadow-lg ${getPriorityClass(n.priority)} ${!n.is_read ? 'ring-1 ring-neon/20' : 'opacity-70 hover:opacity-100'}`,
                        children: [
                            !n.is_read && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "absolute top-4 right-4 w-2 h-2 bg-neon rounded-full shadow-[0_0_8px_rgba(var(--neon-rgb),0.5)]"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex flex-col gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                        className: "p-1.5 rounded-lg bg-surface/50 border border-white/5",
                                                        children: getIcon(n.type)
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "text-[10px] font-black text-muted uppercase tracking-widest",
                                                        children: n.type
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "text-[10px] font-mono text-muted/60",
                                                children: (0, $lRLyZ.formatTimeET)(n.timestamp)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "space-y-1.5",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                                className: `text-xs font-bold leading-tight ${n.is_read ? 'text-white/80' : 'text-white'}`,
                                                children: n.title
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                className: "text-[11px] leading-relaxed text-white/50 italic",
                                                children: n.message
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, n.id))
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "p-4 border-t border-white/5 text-center",
                children: /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                    className: "text-[10px] text-muted tracking-widest uppercase opacity-30",
                    children: "ALGO TRADER NOTIFICATION ENGINE"
                })
            })
        ]
    });
};
var $46b8a5c2cae5e5f7$export$2e2bcd8739ae039 = $46b8a5c2cae5e5f7$var$NotificationFeed;



var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $7i2bY = parcelRequire("7i2bY");
var $9sk6d = parcelRequire("9sk6d");
var $94HEM = parcelRequire("94HEM");
var $7QVYH = parcelRequire("7QVYH");
var $4nVaN = parcelRequire("4nVaN");
var $bgvjD = parcelRequire("bgvjD");
var $j0ppv = parcelRequire("j0ppv");

var $zs3Np = parcelRequire("zs3Np");

var $Ec49u = parcelRequire("Ec49u");
const $66706ed0d2e089b6$var$activeStatuses = [
    'queued',
    'running',
    'cancelling'
];
const $66706ed0d2e089b6$var$statusClass = (status)=>{
    if (status === 'completed') return 'text-emerald-400 bg-emerald-500/10 border-emerald-500/20';
    if (status === 'failed') return 'text-red-400 bg-red-500/10 border-red-500/20';
    if (status === 'cancelled') return 'text-muted bg-white/5 border-white/10';
    if (status === 'cancelling') return 'text-amber-300 bg-amber-500/10 border-amber-500/20';
    return 'text-neon bg-neon/10 border-neon/20';
};
const $66706ed0d2e089b6$var$storageClass = (status)=>{
    if (status === 'saved' || status === 'cached' || status === 'synced') return 'text-emerald-300 bg-emerald-500/10 border-emerald-500/20';
    if (status === 'failed') return 'text-amber-300 bg-amber-500/10 border-amber-500/20';
    if (status === 'skipped' || status === 'not_attempted') return 'text-muted bg-white/5 border-white/10';
    return 'text-neon bg-neon/10 border-neon/20';
};
const $66706ed0d2e089b6$var$StorageBadges = ({ task: task })=>{
    const local = task.storage?.local;
    const lake = task.storage?.research_lake;
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "flex flex-wrap gap-1.5",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                className: `inline-flex items-center gap-1 rounded-md border px-2 py-1 text-[9px] font-black uppercase tracking-widest ${$66706ed0d2e089b6$var$storageClass(local?.status)}`,
                title: local?.message || 'Trader DB storage status',
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7QVYH.default), {
                        className: "w-3 h-3"
                    }),
                    "DB ",
                    local?.status || 'pending'
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                className: `inline-flex items-center gap-1 rounded-md border px-2 py-1 text-[9px] font-black uppercase tracking-widest ${$66706ed0d2e089b6$var$storageClass(lake?.status)}`,
                title: lake?.message || 'Research Lake sync status',
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $9sk6d.default), {
                        className: "w-3 h-3"
                    }),
                    "Lake ",
                    lake?.status || 'pending'
                ]
            })
        ]
    });
};
const $66706ed0d2e089b6$var$formatDateTime = (value)=>{
    if (!value) return '-';
    return new Date(value).toLocaleString([], {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};
const $66706ed0d2e089b6$var$TaskDrawer = ({ onClose: onClose, onTaskCountChange: onTaskCountChange })=>{
    const [tasks, setTasks] = (0, $jHEir.useState)([]);
    const [loading, setLoading] = (0, $jHEir.useState)(true);
    const [error, setError] = (0, $jHEir.useState)('');
    const [activeFilter, setActiveFilter] = (0, $jHEir.useState)('ALL');
    const fetchTasks = (0, $jHEir.useCallback)(async ()=>{
        try {
            const nextTasks = await (0, $zs3Np.tradingApi).getDataDownloadTasks();
            setTasks(nextTasks);
            setError('');
            onTaskCountChange?.(nextTasks.filter((task)=>$66706ed0d2e089b6$var$activeStatuses.includes(task.status)).length);
        } catch (err) {
            setError(err.message || 'Failed to load tasks');
        } finally{
            setLoading(false);
        }
    }, [
        onTaskCountChange
    ]);
    (0, $jHEir.useEffect)(()=>{
        fetchTasks();
        const interval = window.setInterval(fetchTasks, 3000);
        return ()=>window.clearInterval(interval);
    }, [
        fetchTasks
    ]);
    const filteredTasks = (0, $jHEir.useMemo)(()=>{
        if (activeFilter === 'ACTIVE') return tasks.filter((task)=>$66706ed0d2e089b6$var$activeStatuses.includes(task.status));
        if (activeFilter === 'DONE') return tasks.filter((task)=>!$66706ed0d2e089b6$var$activeStatuses.includes(task.status));
        return tasks;
    }, [
        activeFilter,
        tasks
    ]);
    const cancelTask = async (taskId)=>{
        try {
            await (0, $zs3Np.tradingApi).cancelDataDownloadTask(taskId);
            await fetchTasks();
        } catch (err) {
            setError(err.message || 'Failed to cancel task');
        }
    };
    const getFilterButton = (filter, label)=>/*#__PURE__*/ (0, $eHRxX.jsx)("button", {
            onClick: ()=>setActiveFilter(filter),
            className: `px-3 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-widest transition-all duration-200 border ${activeFilter === filter ? 'bg-neon text-black border-neon shadow-[0_0_15px_rgba(92,246,205,0.4)]' : 'bg-white/5 text-muted border-white/10 hover:text-white hover:bg-white/10'}`,
            children: label
        });
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "flex flex-col h-full bg-surface/95 backdrop-blur-2xl border-l border-white/10 shadow-[-20px_0_40px_rgba(0,0,0,0.5)]",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex items-center justify-between p-6 border-b border-white/5 bg-white/5",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $b70a514b297db12d$export$2e2bcd8739ae039), {
                                        className: "w-5 h-5 text-neon"
                                    }),
                                    tasks.some((task)=>$66706ed0d2e089b6$var$activeStatuses.includes(task.status)) && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: "absolute -top-1 -right-1 w-2.5 h-2.5 bg-neon rounded-full animate-pulse"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("h2", {
                                className: "text-sm font-bold uppercase tracking-widest text-white",
                                children: "Tasks"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                onClick: fetchTasks,
                                className: "p-1.5 rounded-lg hover:bg-white/10 text-muted hover:text-white transition",
                                title: "Refresh tasks",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4nVaN.default), {
                                    className: "w-5 h-5"
                                })
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                onClick: onClose,
                                className: "p-1.5 rounded-lg hover:bg-white/10 text-muted hover:text-white transition",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                                    className: "w-5 h-5"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex items-center gap-2 p-4 border-b border-white/5 bg-black/10 overflow-x-auto no-scrollbar",
                children: [
                    getFilterButton('ALL', 'All'),
                    getFilterButton('ACTIVE', 'Running'),
                    getFilterButton('DONE', 'Done')
                ]
            }),
            error && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "mx-4 mt-4 border border-red-500/20 bg-red-500/10 text-red-300 px-3 py-2 rounded-xl text-xs",
                children: error
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "flex-1 overflow-y-auto scrollbar-thin p-4 space-y-3",
                children: loading && tasks.length === 0 ? /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "text-center text-muted text-sm py-10 animate-pulse",
                    children: "Loading tasks..."
                }) : filteredTasks.length === 0 ? /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "h-full flex flex-col items-center justify-center text-muted gap-4 opacity-30 pb-20",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7i2bY.default), {
                            className: "w-12 h-12"
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "text-sm font-medium tracking-wide",
                            children: activeFilter === 'ACTIVE' ? 'No running tasks' : 'No tasks found'
                        })
                    ]
                }) : filteredTasks.map((task)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "rounded-xl border border-white/10 bg-white/3 p-4 space-y-3",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-start justify-between gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "min-w-0 flex items-start gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: "mt-0.5 rounded-lg bg-surface/50 border border-white/5 p-1.5",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $94HEM.default), {
                                                    className: "w-4 h-4 text-neon"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("p", {
                                                        className: "text-xs font-black text-white truncate",
                                                        children: [
                                                            task.request.display_name || task.request.symbols?.join(', ') || task.request.symbol || '-',
                                                            " ",
                                                            task.request.sec_type || 'STK',
                                                            task.request.stk_type ? `/${task.request.stk_type}` : '',
                                                            " ",
                                                            task.request.timeframe
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("p", {
                                                        className: "text-[10px] text-muted font-mono",
                                                        children: [
                                                            task.request.data_source,
                                                            " ",
                                                            task.request.fetch_profile || 'balanced',
                                                            " #",
                                                            task.id
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: `px-2 py-1 rounded-lg border text-[9px] font-black uppercase tracking-widest ${$66706ed0d2e089b6$var$statusClass(task.status)}`,
                                        children: task.status
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "space-y-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: "h-1.5 bg-black/30 rounded-full overflow-hidden",
                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                            className: `h-full transition-all ${task.status === 'failed' ? 'bg-red-400' : task.status === 'completed' ? 'bg-emerald-400' : 'bg-neon'}`,
                                            style: {
                                                width: `${[
                                                    'completed',
                                                    'failed'
                                                ].includes(task.status) ? 100 : task.progress}%`
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center justify-between text-[10px] text-muted",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                children: [
                                                    task.progress,
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                children: $66706ed0d2e089b6$var$formatDateTime(task.updated_at)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-start justify-between gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "min-w-0",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)($66706ed0d2e089b6$var$StorageBadges, {
                                                task: task
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                className: "text-[11px] text-white/60 leading-relaxed",
                                                children: task.message
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("p", {
                                                className: "text-[10px] text-muted font-mono mt-1",
                                                children: [
                                                    task.request.start_date,
                                                    " to ",
                                                    task.request.end_date,
                                                    (0, $Ec49u.formatDownloadTaskBarCount)(task.bars) ? ` | ${(0, $Ec49u.formatDownloadTaskBarCount)(task.bars)} bars` : ''
                                                ]
                                            })
                                        ]
                                    }),
                                    task.can_cancel !== false && $66706ed0d2e089b6$var$activeStatuses.includes(task.status) && /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                        onClick: ()=>cancelTask(task.id),
                                        className: "p-1.5 text-red-400 hover:bg-red-500/10 rounded-lg shrink-0",
                                        title: "Cancel task",
                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j0ppv.default), {
                                            className: "w-4 h-4"
                                        })
                                    })
                                ]
                            })
                        ]
                    }, task.id))
            })
        ]
    });
};
var $66706ed0d2e089b6$export$2e2bcd8739ae039 = $66706ed0d2e089b6$var$TaskDrawer;



var $7Mvr3 = parcelRequire("7Mvr3");

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");
const $b1f93aec56d21e9d$var$MarketEvents = ({ compact: compact = false })=>{
    const [activeTab, setActiveTab] = (0, $jHEir.useState)('economic');
    const economicContainer = (0, $jHEir.useRef)(null);
    (0, $jHEir.useEffect)(()=>{
        // Economic Calendar Widget
        if (activeTab === 'economic' && economicContainer.current) {
            economicContainer.current.innerHTML = ''; // Clear previous
            const script = document.createElement('script');
            script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-events.js';
            script.async = true;
            script.innerHTML = JSON.stringify({
                "colorTheme": "dark",
                "isTransparent": true,
                "width": "100%",
                "height": "100%",
                "locale": "en",
                "importanceFilter": "0,1",
                "currencyFilter": "USD"
            });
            economicContainer.current.appendChild(script);
        }
    // Earnings Calendar Widget (placeholder/future implementation)
    }, [
        activeTab
    ]);
    const tabSwitcher = /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "flex items-center gap-1 bg-black/20 rounded-lg p-1",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                onClick: ()=>setActiveTab('economic'),
                className: `px-3 py-1.5 rounded-md text-xs font-medium transition-all ${activeTab === 'economic' ? 'bg-neon/10 text-neon shadow-xs' : 'text-muted hover:text-white hover:bg-white/5'}`,
                children: "Economic"
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                onClick: ()=>setActiveTab('earnings'),
                className: `px-3 py-1.5 rounded-md text-xs font-medium transition-all ${activeTab === 'earnings' ? 'bg-neon/10 text-neon shadow-xs' : 'text-muted hover:text-white hover:bg-white/5'}`,
                children: "Earnings"
            })
        ]
    });
    return /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
        className: `${compact ? 'h-[68vh]' : 'h-full p-6'} flex flex-col`,
        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
            className: `flex-1 flex flex-col relative ${compact ? 'min-h-[420px]' : 'panel min-h-[600px]'}`,
            children: [
                compact ? /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "flex items-center justify-end border-b border-white/10 px-3 py-3",
                    children: tabSwitcher
                }) : /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "px-4 py-4 flex items-center justify-between border-b border-white/10 bg-white/5",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "space-y-1",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("h2", {
                                    className: "font-semibold text-neon flex items-center gap-2",
                                    children: "Market Events"
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                    className: "text-xs text-muted",
                                    children: "Economic calendar and future releases"
                                })
                            ]
                        }),
                        tabSwitcher
                    ]
                }),
                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex-1 relative bg-surface/50",
                    children: [
                        activeTab === 'economic' && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "tradingview-widget-container absolute inset-0 w-full h-full",
                            ref: economicContainer,
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                    className: "tradingview-widget-container__widget h-full w-full"
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                    className: "tradingview-widget-copyright",
                                    children: /*#__PURE__*/ (0, $eHRxX.jsx)("a", {
                                        href: "https://www.tradingview.com/",
                                        rel: "noopener nofollow",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            className: "blue-text",
                                            children: "Track all markets on TradingView"
                                        })
                                    })
                                })
                            ]
                        }),
                        activeTab === 'earnings' && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                            className: "absolute inset-0 flex items-center justify-center text-muted flex-col gap-2",
                            children: /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                children: "Earnings calendar coming soon"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $b1f93aec56d21e9d$export$2e2bcd8739ae039 = $b1f93aec56d21e9d$var$MarketEvents;



var $m1iA2 = parcelRequire("m1iA2");

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $e4aOX = parcelRequire("e4aOX");

var $7nAvJ = parcelRequire("7nAvJ");
const $68cdc34a99fd8f75$export$f51d452c10d5b956 = (0, $7nAvJ.useDispatch).withTypes();
const $68cdc34a99fd8f75$export$a7347740d65f620b = (0, $7nAvJ.useSelector).withTypes();



var $37Zv1 = parcelRequire("37Zv1");

var $7dKe6 = parcelRequire("7dKe6");

var $hpygi = parcelRequire("hpygi");
const $82b8cc92710380d3$var$initialState = {
    userId: null,
    username: null
};
const $82b8cc92710380d3$var$sessionSlice = (0, $37Zv1.createSlice)({
    name: 'session',
    initialState: $82b8cc92710380d3$var$initialState,
    reducers: {
        sessionChanged: (_state, action)=>action.payload,
        sessionCleared: ()=>$82b8cc92710380d3$var$initialState
    }
});
const { sessionChanged: $82b8cc92710380d3$export$134f78b20a6d7058, sessionCleared: $82b8cc92710380d3$export$4f6ed4f612720419 } = $82b8cc92710380d3$var$sessionSlice.actions;
const $82b8cc92710380d3$export$6f57813fe9f31bf9 = (0, $37Zv1.configureStore)({
    reducer: {
        session: $82b8cc92710380d3$var$sessionSlice.reducer,
        [(0, $hpygi.tradingApiSlice).reducerPath]: (0, $hpygi.tradingApiSlice).reducer
    },
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat((0, $hpygi.tradingApiSlice).middleware)
});
(0, $7dKe6.setupListeners)($82b8cc92710380d3$export$6f57813fe9f31bf9.dispatch);



var $hpygi = parcelRequire("hpygi");

const $b745d524103da7cf$export$7c0d05a5f8d89647 = ({ children: children })=>{
    const { token: token, user: user } = (0, $e4aOX.useAuth)();
    const dispatch = (0, $68cdc34a99fd8f75$export$f51d452c10d5b956)();
    const userId = user?.id ?? null;
    const username = user?.username ?? null;
    const previousIdentity = (0, $jHEir.useRef)(null);
    (0, $jHEir.useEffect)(()=>{
        const nextIdentity = token && userId !== null ? `${userId}:${token}` : null;
        if (token && userId !== null) {
            dispatch((0, $82b8cc92710380d3$export$134f78b20a6d7058)({
                userId: userId,
                username: username
            }));
            (0, $965642ac39400a6c$export$51b87650e98265a6).configure(token, String(userId));
        } else {
            dispatch((0, $82b8cc92710380d3$export$4f6ed4f612720419)());
            (0, $965642ac39400a6c$export$51b87650e98265a6).configure(null, null);
        }
        // Do not reset on initial mount: account query subscriptions may already
        // be active, and deleting their first successful response can strand the
        // page in `isLoading` (especially under React StrictMode). Reset only when
        // an established identity genuinely changes or is cleared.
        if (previousIdentity.current !== null && previousIdentity.current !== nextIdentity) dispatch((0, $hpygi.tradingApiSlice).util.resetApiState());
        previousIdentity.current = nextIdentity;
    }, [
        dispatch,
        token,
        userId,
        username
    ]);
    return /*#__PURE__*/ (0, $eHRxX.jsx)((0, $eHRxX.Fragment), {
        children: children
    });
};



var $ctgHU = parcelRequire("ctgHU");

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $lIBUZ = parcelRequire("lIBUZ");
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $7ab85e16ca639a6c$export$a2387ed3b5d536eb = {
    name: "target",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "6",
                key: "1vlfrh"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "2",
                key: "1c9p78"
            }
        ]
    ]
};
$7ab85e16ca639a6c$export$a2387ed3b5d536eb.node;
const $7ab85e16ca639a6c$export$2e2bcd8739ae039 = (0, $hHhnY.default)($7ab85e16ca639a6c$export$a2387ed3b5d536eb);



var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $12llf = parcelRequire("12llf");
var $1BBEF = parcelRequire("1BBEF");
var $kdxJz = parcelRequire("kdxJz");
var $lY8C7 = parcelRequire("lY8C7");
var $cKEgK = parcelRequire("cKEgK");
var $l8E6a = parcelRequire("l8E6a");
var $2rkXu = parcelRequire("2rkXu");
var $8FKMh = parcelRequire("8FKMh");
var $dNdHx = parcelRequire("dNdHx");

var $5ogeV = parcelRequire("5ogeV");

var $4cvdp = parcelRequire("4cvdp");

var $lRLyZ = parcelRequire("lRLyZ");

var $iCbFX = parcelRequire("iCbFX");

var $hpygi = parcelRequire("hpygi");
const $4f787eedcb7e94da$var$AccountSummary = ({ refreshInterval: refreshInterval = 30000 })=>{
    const { data: portfolio = null, isLoading: loading, isFetching: refreshing, error: portfolioError, refetch: refetch } = (0, $hpygi.usePortfolioQuery)(undefined, {
        pollingInterval: refreshInterval,
        skipPollingIfUnfocused: true
    });
    const blockingError = portfolioError && !portfolio ? 'Failed to fetch account data' : null;
    const refreshError = portfolioError && portfolio ? 'Live refresh failed; keeping the last account values.' : null;
    const [hideValues, setHideValues] = (0, $jHEir.useState)(()=>{
        if (typeof window === 'undefined') return false;
        const saved = window.localStorage.getItem('accountSummaryHideValues');
        return saved === 'true';
    });
    (0, $jHEir.useEffect)(()=>{
        if (typeof window !== 'undefined') window.localStorage.setItem('accountSummaryHideValues', hideValues ? 'true' : 'false');
    }, [
        hideValues
    ]);
    const getCurrencyIcon = (size = 14)=>{
        const currency = portfolio?.data?.currency || 'USD';
        const symbol = (0, $iCbFX.getCurrencySymbol)(currency);
        if (symbol !== '$') return /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
            className: "font-bold text-[14px] text-muted",
            children: symbol
        });
        return /*#__PURE__*/ (0, $eHRxX.jsx)((0, $1BBEF.default), {
            size: size,
            className: "text-muted"
        });
    };
    const isStale = !!portfolio?.data?.stale;
    const hasSnapshot = portfolio?.data?.snapshot_available !== false;
    const isInitializing = portfolio?.data?.connection_status === 'initializing';
    const isUnavailable = portfolio?.data?.connection_status === 'unavailable';
    const availableMarginPct = portfolio?.data?.available_margin_pct;
    (0, $jHEir.useEffect)(()=>{
        if (!isInitializing) return;
        const retryId = window.setTimeout(()=>refetch(), 2000);
        return ()=>window.clearTimeout(retryId);
    }, [
        isInitializing,
        portfolio?.timestamp,
        refetch
    ]);
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: `panel full-bleed-panel lg:h-full transition-all duration-300 ${isStale ? 'border-warning-500/20 bg-warning-500/5' : ''}`,
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "px-6 py-5 flex items-center justify-between border-b border-white/10",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: `p-2 rounded-lg transition-colors ${isStale ? 'bg-warning-500/10 text-warning-500' : 'bg-neon/10 text-neon'}`,
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $dNdHx.default), {
                                    className: "w-5 h-5"
                                })
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "space-y-0.5",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("h2", {
                                                className: "text-lg font-bold text-white tracking-tight",
                                                children: "Account Summary"
                                            }),
                                            isStale && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "relative group cursor-help z-50",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "text-[9px] uppercase font-black tracking-wider px-2 py-0.5 rounded-sm bg-warning-500/20 text-warning-500 border border-warning-500/30 animate-pulse",
                                                        children: isInitializing ? 'Connecting' : hasSnapshot ? 'Stale Data' : 'Offline'
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                        className: "absolute left-0 top-full mt-2 hidden group-hover:block w-64 p-3 bg-surface border border-warning-500/30 rounded-xl shadow-xl text-xs font-normal text-warning-500 leading-normal normal-case pointer-events-none",
                                                        children: [
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                                className: "absolute bottom-full left-4 border-4 border-transparent border-b-surface"
                                                            }),
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                                className: "font-bold mb-1",
                                                                children: isInitializing ? 'Synchronizing Account' : isUnavailable ? 'Account Data Unavailable' : hasSnapshot ? 'Account Data Stale' : 'No Cached Account Data'
                                                            }),
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                                className: "opacity-80",
                                                                children: isInitializing ? 'IB is connected and account data is still synchronizing. This panel will refresh automatically.' : isUnavailable ? 'The IB socket is online, but account values did not arrive. The backend will keep retrying automatically.' : hasSnapshot ? 'Live streaming is currently unavailable. Displaying the last cached values recorded when connection was active.' : 'The gateway is offline and this account does not have a persisted summary yet.'
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                        className: "text-xs text-muted",
                                        children: isInitializing ? 'Connecting to IB and synchronizing account data' : isUnavailable ? "IB connected \u2014 account values currently unavailable" : isStale ? hasSnapshot ? 'Showing offline cached snapshot' : "Offline \u2014 no cached snapshot available" : 'Real-time portfolio and P&L oversight'
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                        onClick: ()=>setHideValues((prev)=>!prev),
                        className: "text-xs px-3 py-1.5 rounded-lg border border-white/10 bg-white/5 text-foreground hover:bg-white/10 transition flex items-center gap-2",
                        "aria-label": hideValues ? 'Show account values' : 'Hide account values',
                        children: hideValues ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lY8C7.default), {
                            size: 14
                        }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $kdxJz.default), {
                            size: 14
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "p-4 space-y-5",
                children: [
                    loading && !portfolio && !blockingError && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "flex justify-center py-8",
                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $5ogeV.default), {
                            size: "lg"
                        })
                    }),
                    blockingError && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4cvdp.default), {
                        error: blockingError,
                        onRetry: ()=>refetch(),
                        message: "Failed to load account data"
                    }),
                    refreshError && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "rounded-xl border border-warning-500/20 bg-warning-500/5 px-4 py-3 text-xs text-warning-300",
                        children: refreshError
                    }),
                    portfolio?.success && !blockingError && isStale && !hasSnapshot && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "rounded-xl border border-warning-500/20 bg-warning-500/5 px-4 py-8 text-center text-sm text-warning-300/80",
                        children: isInitializing ? "Connecting to IB and synchronizing this account\u2026" : isUnavailable ? 'IB is connected, but account values are unavailable. Synchronization will continue in the background.' : 'Connect this account once to create its first persisted account snapshot.'
                    }),
                    portfolio?.success && !blockingError && (!isStale || hasSnapshot) && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "space-y-4 text-sm text-foreground",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: `rounded-xl transition p-3 space-y-2 ${isStale ? 'bg-warning-500/5 border border-warning-500/20 hover:border-warning-500/35' : 'bg-white/6 border border-white/10 hover:border-neon/30'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                        className: "text-xs font-semibold text-muted",
                                                        children: "Net liquidation"
                                                    }),
                                                    getCurrencyIcon()
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                className: `mt-2 text-lg font-semibold text-foreground ${refreshing ? 'refreshing-text' : ''}`,
                                                children: (0, $iCbFX.formatCurrency)(portfolio.data?.net_liquidation, portfolio.data?.currency, hideValues)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: `rounded-xl transition p-3 space-y-2 ${isStale ? 'bg-warning-500/5 border border-warning-500/20 hover:border-warning-500/35' : 'bg-white/6 border border-white/10 hover:border-neon/30'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                        className: "text-xs font-semibold text-muted",
                                                        children: "Available funds"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $dNdHx.default), {
                                                        size: 14,
                                                        className: "text-muted"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                className: `mt-2 text-lg font-semibold text-foreground ${refreshing ? 'refreshing-text' : ''}`,
                                                children: (0, $iCbFX.formatCurrency)(portfolio.data?.available_funds, portfolio.data?.currency, hideValues)
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "space-y-0.5 text-[11px]",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                        className: "flex items-center justify-between gap-2 text-emerald-300",
                                                        children: [
                                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                                className: "inline-flex items-center gap-1",
                                                                title: "Percentage of net liquidation currently available for new positions.",
                                                                children: [
                                                                    "Available margin",
                                                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $l8E6a.default), {
                                                                        className: "h-3 w-3 text-emerald-300/70",
                                                                        "aria-label": "Available margin information"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                className: "font-semibold",
                                                                children: availableMarginPct !== undefined && availableMarginPct !== null ? `${availableMarginPct.toFixed(2)}%` : "\u2014"
                                                            })
                                                        ]
                                                    }),
                                                    portfolio.data?.init_margin_req !== undefined && portfolio.data?.init_margin_req !== null && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                        className: "flex items-center justify-between gap-2 text-muted",
                                                        children: [
                                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                                className: "inline-flex items-center gap-1",
                                                                title: "Initial margin currently reserved by open positions.",
                                                                children: [
                                                                    "Initial margin used",
                                                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $l8E6a.default), {
                                                                        className: "h-3 w-3 text-muted/70",
                                                                        "aria-label": "Initial margin information"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                children: (0, $iCbFX.formatCurrency)(portfolio.data.init_margin_req, portfolio.data.currency, hideValues)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: `rounded-xl transition p-3 space-y-2 ${isStale ? 'bg-warning-500/5 border border-warning-500/20 hover:border-warning-500/35' : 'bg-white/6 border border-white/10 hover:border-neon/30'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                        className: "text-xs font-semibold text-muted",
                                                        children: "Buying power"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $cKEgK.default), {
                                                        size: 14,
                                                        className: "text-muted"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                className: `mt-2 text-lg font-semibold text-foreground ${refreshing ? 'refreshing-text' : ''}`,
                                                children: (0, $iCbFX.formatCurrency)(portfolio.data?.buying_power, portfolio.data?.currency, hideValues)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: `rounded-xl transition p-3 space-y-2 ${isStale ? 'bg-warning-500/5 border border-warning-500/20 hover:border-warning-500/35' : 'bg-white/6 border border-white/10 hover:border-neon/30'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                        className: "text-xs font-semibold text-muted",
                                                        children: "Realized P&L (today)"
                                                    }),
                                                    portfolio.data?.realized_pnl_today !== undefined && portfolio.data?.realized_pnl_today !== null && portfolio.data?.realized_pnl_today < 0 ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $2rkXu.default), {
                                                        size: 14,
                                                        className: "text-red-400"
                                                    }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8FKMh.default), {
                                                        size: 14,
                                                        className: "text-emerald-400"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                className: `mt-2 text-lg font-semibold ${refreshing ? 'refreshing-text' : 'text-foreground'}`,
                                                children: (0, $iCbFX.formatCurrency)(portfolio.data?.realized_pnl_today, portfolio.data?.currency, hideValues)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: `rounded-xl transition p-3 space-y-2 ${isStale ? 'bg-warning-500/5 border border-warning-500/20 hover:border-warning-500/35' : 'bg-white/6 border border-white/10 hover:border-neon/30'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                        className: "text-xs font-semibold text-muted",
                                                        children: "Unrealized P&L (today)"
                                                    }),
                                                    portfolio.data?.unrealized_pnl_today !== undefined && portfolio.data?.unrealized_pnl_today !== null && portfolio.data?.unrealized_pnl_today < 0 ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $2rkXu.default), {
                                                        size: 14,
                                                        className: "text-red-400"
                                                    }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8FKMh.default), {
                                                        size: 14,
                                                        className: "text-emerald-400"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                className: `mt-2 text-lg font-semibold ${refreshing ? 'refreshing-text' : 'text-foreground'}`,
                                                children: (0, $iCbFX.formatCurrency)(portfolio.data?.unrealized_pnl_today, portfolio.data?.currency, hideValues)
                                            })
                                        ]
                                    }),
                                    portfolio.data?.pnl_timestamp && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: `rounded-xl transition p-3 space-y-2 ${isStale ? 'bg-warning-500/5 border border-warning-500/20' : 'bg-white/6 border border-white/10'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                        className: "text-xs font-semibold text-muted",
                                                        children: "P&L timestamp"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $12llf.default), {
                                                        size: 14,
                                                        className: "text-muted"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                className: "mt-2 text-xs font-semibold text-foreground",
                                                children: (0, $lRLyZ.formatDateTimeET)(portfolio.data?.pnl_timestamp)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $4f787eedcb7e94da$export$2e2bcd8739ae039 = $4f787eedcb7e94da$var$AccountSummary;



var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $12llf = parcelRequire("12llf");
var $1BBEF = parcelRequire("1BBEF");
var $kdxJz = parcelRequire("kdxJz");
var $lY8C7 = parcelRequire("lY8C7");
var $eC2xp = parcelRequire("eC2xp");
var $2rkXu = parcelRequire("2rkXu");
var $8FKMh = parcelRequire("8FKMh");

var $zs3Np = parcelRequire("zs3Np");

var $5ogeV = parcelRequire("5ogeV");

var $4cvdp = parcelRequire("4cvdp");

var $7Mvr3 = parcelRequire("7Mvr3");

var $2KORC = parcelRequire("2KORC");

var $lRLyZ = parcelRequire("lRLyZ");

var $iCbFX = parcelRequire("iCbFX");

var $e4aOX = parcelRequire("e4aOX");

var $hpygi = parcelRequire("hpygi");
const $41a83a4c68965c10$var$InvestorAccountSummary = ({ refreshInterval: refreshInterval = 30000, isConnected: isConnected = true })=>{
    const { user: user } = (0, $e4aOX.useAuth)();
    const isInvestor = user?.role === 'investor';
    const { data: portfolio = null, isLoading: loading, isFetching: refreshing, error: portfolioError, refetch: refetchPortfolio } = (0, $hpygi.usePortfolioQuery)(undefined, {
        pollingInterval: isConnected ? refreshInterval : 0
    });
    const blockingError = portfolioError && !portfolio ? 'Failed to fetch account data' : null;
    const refreshError = portfolioError && portfolio ? 'Live refresh failed; keeping the last account values.' : null;
    const [hideValues, setHideValues] = (0, $jHEir.useState)(()=>{
        if (typeof window === 'undefined') return false;
        const saved = window.localStorage.getItem('accountSummaryHideValues');
        return saved === 'true';
    });
    const [showConfigModal, setShowConfigModal] = (0, $jHEir.useState)(false);
    const [controlState, setControlState] = (0, $jHEir.useState)(null);
    const [configLoading, setConfigLoading] = (0, $jHEir.useState)(false);
    const [gatewayError, setGatewayError] = (0, $jHEir.useState)(null);
    // Auto-clear gateway error after 8 seconds
    (0, $jHEir.useEffect)(()=>{
        if (gatewayError) {
            const timer = setTimeout(()=>setGatewayError(null), 8000);
            return ()=>clearTimeout(timer);
        }
    }, [
        gatewayError
    ]);
    const fetchControlState = (0, $jHEir.useCallback)(async (silent = false)=>{
        if (!silent) setConfigLoading(true);
        try {
            const response = await (0, $zs3Np.tradingApi).getSystemControlState();
            if (response.success && response.data) {
                setControlState(response.data);
                if (!silent) setShowConfigModal(true);
            }
        } catch (err) {
            console.warn("Failed to fetch control state:", err);
            if (!silent) setShowConfigModal(true);
        } finally{
            if (!silent) setConfigLoading(false);
        }
    }, []);
    const hasAccountData = Boolean(portfolio?.data?.account_type && portfolio.data.account_type !== 'N/A' && portfolio.data.net_liquidation !== undefined && portfolio.data.net_liquidation !== null);
    const isEffectivelyConnected = portfolio?.data?.connection_status === 'connected' || isConnected && hasAccountData;
    const isInitializing = portfolio?.data?.connection_status === 'initializing';
    const isUnavailable = portfolio?.data?.connection_status === 'unavailable';
    const hasSnapshot = portfolio?.data?.snapshot_available !== false;
    (0, $jHEir.useEffect)(()=>{
        if (!isInitializing) return;
        const retryId = window.setTimeout(()=>refetchPortfolio(), 2000);
        return ()=>window.clearTimeout(retryId);
    }, [
        isInitializing,
        portfolio?.timestamp,
        refetchPortfolio
    ]);
    (0, $jHEir.useEffect)(()=>{
        // Always fetch control state silently to see if we have gateway controls available
        fetchControlState(true);
    }, [
        fetchControlState
    ]);
    // Polling for control state if modal is open OR if we are showing the start button (waiting for connect)
    (0, $jHEir.useEffect)(()=>{
        let intervalId;
        if (showConfigModal || !controlState?.ib_connected && controlState?.gateway_configured) intervalId = setInterval(()=>fetchControlState(true), 5000);
        return ()=>{
            if (intervalId) clearInterval(intervalId);
        };
    }, [
        showConfigModal,
        controlState?.ib_connected,
        controlState?.gateway_configured,
        fetchControlState
    ]);
    (0, $jHEir.useEffect)(()=>{
        if (typeof window !== 'undefined') window.localStorage.setItem('accountSummaryHideValues', hideValues ? 'true' : 'false');
    }, [
        hideValues
    ]);
    const isConfigured = controlState?.gateway_configured;
    const currency = portfolio?.data?.currency || 'USD';
    const isStale = !!portfolio?.data?.stale;
    // A persisted snapshot remains useful when IB is disconnected. Only hide
    // values when the backend confirms that no account snapshot exists.
    const canDisplayValues = hasSnapshot && hasAccountData;
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: `panel full-bleed-panel w-full lg:h-full relative transition-all duration-300 ${isStale ? 'border-warning-500/20 bg-warning-500/5' : ''}`,
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "px-6 py-5 flex flex-col sm:flex-row sm:items-center justify-between border-b border-white/10 relative z-10 gap-4",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "space-y-1",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h2", {
                                        className: "text-xl font-bold text-white",
                                        children: "Portfolio Overview"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: `text-xs px-2 py-0.5 rounded-full border ${isInitializing ? 'bg-warning-500/10 text-warning-400 border-warning-500/20' : isEffectivelyConnected ? isStale ? 'bg-warning-500/10 text-warning-400 border-warning-500/20' : 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' : 'bg-red-500/10 text-red-400 border-red-500/20'}`,
                                                children: isInitializing ? 'Connecting' : isUnavailable ? 'Account Unavailable' : isStale ? 'Stale Data' : isEffectivelyConnected ? 'Connected' : isConnected ? 'Not Configured' : 'Offline'
                                            }),
                                            isStale && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "relative group cursor-help z-50",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "text-[10px] uppercase font-black tracking-wider px-2 py-0.5 rounded-sm bg-warning-500/20 text-warning-500 border border-warning-500/30 animate-pulse",
                                                        children: "Stale"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                        className: "absolute right-0 top-full mt-2 hidden group-hover:block w-64 p-3 bg-surface border border-warning-500/30 rounded-xl shadow-xl text-xs font-normal text-warning-500 leading-normal normal-case pointer-events-none",
                                                        children: [
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                                className: "absolute bottom-full right-4 border-4 border-transparent border-b-surface"
                                                            }),
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                                className: "font-bold mb-1",
                                                                children: isInitializing ? 'Synchronizing Account' : isUnavailable ? 'Account Data Unavailable' : 'Portfolio Data Stale'
                                                            }),
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                                className: "opacity-80",
                                                                children: isInitializing ? 'IB is connected and account data is still synchronizing. This panel will refresh automatically.' : isUnavailable ? 'The IB socket is online, but account values did not arrive. The backend will keep retrying automatically.' : 'Live streaming is currently offline. Displaying last cached values recorded when connection was active.'
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                className: "text-sm text-muted",
                                children: isInitializing ? 'Connecting to IB and synchronizing account data' : isUnavailable ? "IB connected \u2014 account values currently unavailable" : isStale ? 'Showing offline cached snapshot' : 'Real-time account performance'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center justify-between sm:justify-end gap-3 w-full sm:w-auto",
                        children: [
                            !isInvestor && !isInitializing && (!isEffectivelyConnected || controlState && isConfigured) && /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                                children: [
                                    controlState && isConfigured ? /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $2KORC.default), {
                                                controlState: controlState,
                                                onRefresh: async ()=>{
                                                    await fetchControlState(true);
                                                },
                                                onConfigureNeeded: ()=>setShowConfigModal(true),
                                                onError: (msg)=>setGatewayError(msg),
                                                variant: "slim",
                                                className: "h-10 text-sm px-4 min-w-[120px]"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                                onClick: ()=>setShowConfigModal(true),
                                                className: "h-10 w-10 flex items-center justify-center rounded-xl bg-white/5 border border-white/10 text-muted hover:text-white hover:bg-white/10 transition",
                                                title: "Configure Connection",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $eC2xp.default), {
                                                    size: 18
                                                })
                                            })
                                        ]
                                    }) : !isEffectivelyConnected && /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                        onClick: ()=>fetchControlState(false),
                                        disabled: configLoading,
                                        className: "flex items-center gap-2 px-4 py-2 rounded-xl bg-emerald-600 hover:bg-emerald-500 text-white text-sm font-medium shadow-lg shadow-emerald-500/20 transition-all disabled:opacity-50 disabled:shadow-none",
                                        children: [
                                            configLoading ? /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: "w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"
                                            }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $eC2xp.default), {
                                                size: 16
                                            }),
                                            "Configure Connection"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: "h-8 w-px bg-white/10 mx-1"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                onClick: ()=>setHideValues((prev)=>!prev),
                                className: "p-2.5 rounded-xl border border-white/10 bg-white/5 text-muted hover:text-white hover:bg-white/10 transition flex items-center justify-center",
                                "aria-label": hideValues ? 'Show account values' : 'Hide account values',
                                title: hideValues ? 'Show values' : 'Hide values',
                                children: hideValues ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lY8C7.default), {
                                    size: 18
                                }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $kdxJz.default), {
                                    size: 18
                                })
                            })
                        ]
                    })
                ]
            }),
            gatewayError && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "bg-red-500/10 border-b border-red-500/20 px-6 py-2 flex items-center justify-between animate-in slide-in-from-top-2 duration-200",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-2 text-sm text-red-400",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse"
                            }),
                            gatewayError
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                        onClick: ()=>setGatewayError(null),
                        className: "text-xs text-red-400/70 hover:text-red-300",
                        children: "Dismiss"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "p-6",
                children: [
                    loading && !portfolio && !blockingError && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "flex justify-center py-8",
                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $5ogeV.default), {
                            size: "lg"
                        })
                    }),
                    blockingError && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4cvdp.default), {
                        error: blockingError,
                        onRetry: ()=>refetchPortfolio(),
                        message: "Failed to load account data"
                    }),
                    refreshError && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "mb-4 rounded-xl border border-warning-500/20 bg-warning-500/5 px-4 py-3 text-xs text-warning-300",
                        children: refreshError
                    }),
                    portfolio?.success && !blockingError && isStale && !hasSnapshot && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "rounded-xl border border-warning-500/20 bg-warning-500/5 px-4 py-8 text-center text-sm text-warning-300/80",
                        children: isInitializing ? "Connecting to IB and synchronizing this account\u2026" : isUnavailable ? 'IB is connected, but account values are unavailable. Synchronization will continue in the background.' : 'Connect this account once to create its first persisted account snapshot.'
                    }),
                    portfolio?.success && !blockingError && (!isStale || hasSnapshot) && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "space-y-6",
                        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "grid grid-cols-1 md:grid-cols-3 gap-6",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                    className: `rounded-xl transition duration-300 p-5 relative overflow-hidden group ${isStale ? 'bg-warning-500/5 border border-warning-500/20 hover:border-warning-500/35' : 'bg-white/10 border border-white/10 hover:border-neon/30'}`,
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                            className: "absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition",
                                            children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $1BBEF.default), {
                                                size: 48
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                            className: "text-sm font-medium text-gray-400 mb-1",
                                            children: "Net Liquidation Value"
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                            className: `text-3xl font-bold text-white tracking-tight ${refreshing ? 'animate-pulse' : ''}`,
                                            children: !canDisplayValues ? '---' : (0, $iCbFX.formatCurrency)(portfolio.data?.net_liquidation, currency, hideValues)
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                            className: "mt-4 flex items-center gap-2 text-xs text-muted",
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $12llf.default), {
                                                    size: 12
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                    children: [
                                                        "Updated: ",
                                                        (0, $lRLyZ.formatDateTimeET)(portfolio.data?.timestamp)
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                    className: `rounded-xl transition duration-300 p-5 ${isStale ? 'bg-warning-500/5 border border-warning-500/20 hover:border-warning-500/35' : 'bg-white/5 border border-white/10 hover:bg-white/10'}`,
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                            className: "flex items-center justify-between mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                    className: "text-sm font-medium text-gray-400",
                                                    children: "Realized P&L (Today)"
                                                }),
                                                portfolio.data?.realized_pnl_today !== undefined && portfolio.data?.realized_pnl_today < 0 ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $2rkXu.default), {
                                                    size: 16,
                                                    className: "text-red-400"
                                                }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8FKMh.default), {
                                                    size: 16,
                                                    className: "text-emerald-400"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                            className: `text-2xl font-bold tracking-tight ${(portfolio.data?.realized_pnl_today || 0) >= 0 ? 'text-emerald-400' : 'text-red-400'} ${refreshing ? 'animate-pulse' : ''}`,
                                            children: !canDisplayValues ? '---' : (0, $iCbFX.formatCurrency)(portfolio.data?.realized_pnl_today, currency, hideValues)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                    className: `rounded-xl transition duration-300 p-5 ${isStale ? 'bg-warning-500/5 border border-warning-500/20 hover:border-warning-500/35' : 'bg-white/5 border border-white/10 hover:bg-white/10'}`,
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                            className: "flex items-center justify-between mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                    className: "text-sm font-medium text-gray-400",
                                                    children: "Unrealized P&L (Today)"
                                                }),
                                                portfolio.data?.unrealized_pnl_today !== undefined && portfolio.data?.unrealized_pnl_today < 0 ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $2rkXu.default), {
                                                    size: 16,
                                                    className: "text-red-400"
                                                }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8FKMh.default), {
                                                    size: 16,
                                                    className: "text-emerald-400"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                            className: `text-2xl font-bold tracking-tight ${(portfolio.data?.unrealized_pnl_today || 0) >= 0 ? 'text-emerald-400' : 'text-red-400'} ${refreshing ? 'animate-pulse' : ''}`,
                                            children: !canDisplayValues ? '---' : (0, $iCbFX.formatCurrency)(portfolio.data?.unrealized_pnl_today, currency, hideValues)
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7Mvr3.default), {
                isOpen: showConfigModal,
                onClose: ()=>setShowConfigModal(false),
                onSuccess: ()=>{
                    setShowConfigModal(false);
                    refetchPortfolio(); // Refresh portfolio data after config
                },
                currentUsername: controlState?.ib_username,
                currentMode: controlState?.ib_mode,
                savedGateways: controlState?.saved_gateways
            })
        ]
    });
};
var $41a83a4c68965c10$export$2e2bcd8739ae039 = $41a83a4c68965c10$var$InvestorAccountSummary;



var $eHRxX = parcelRequire("eHRxX");

var $62Hcf = parcelRequire("62Hcf");

var $jHEir = parcelRequire("jHEir");

var $jr1gO = parcelRequire("jr1gO");
var $7i2bY = parcelRequire("7i2bY");/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $d21ded0a0bf0608c$export$a2387ed3b5d536eb = {
    name: "circle",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ]
    ]
};
$d21ded0a0bf0608c$export$a2387ed3b5d536eb.node;
const $d21ded0a0bf0608c$export$2e2bcd8739ae039 = (0, $hHhnY.default)($d21ded0a0bf0608c$export$a2387ed3b5d536eb);


var $9sk6d = parcelRequire("9sk6d");
var $j8jJ4 = parcelRequire("j8jJ4");
var $9WswS = parcelRequire("9WswS");
var $eC2xp = parcelRequire("eC2xp");
var $c5crE = parcelRequire("c5crE");

var $zs3Np = parcelRequire("zs3Np");

var $7Mvr3 = parcelRequire("7Mvr3");
const $99c01f15c39a6dcf$var$InvestorQuickStart = ()=>{
    const [showConfigModal, setShowConfigModal] = (0, $jHEir.useState)(false);
    const [controlState, setControlState] = (0, $jHEir.useState)(null);
    const [loading, setLoading] = (0, $jHEir.useState)(false);
    const [activeAction, setActiveAction] = (0, $jHEir.useState)(null);
    const [gatewayError, setGatewayError] = (0, $jHEir.useState)(null);
    const [setupRefreshing, setSetupRefreshing] = (0, $jHEir.useState)(false);
    const abortControllerRef = (0, $jHEir.useRef)(null);
    const fetchControlState = async ()=>{
        try {
            const response = await (0, $zs3Np.tradingApi).getSystemControlState();
            if (response.success && response.data) setControlState(response.data);
        } catch (err) {
            console.warn("Failed to fetch control state:", err);
        }
    };
    (0, $jHEir.useEffect)(()=>{
        fetchControlState();
        const id = setInterval(fetchControlState, 5000);
        return ()=>clearInterval(id);
    }, []);
    (0, $jHEir.useEffect)(()=>{
        if (!gatewayError) return;
        const timer = setTimeout(()=>setGatewayError(null), 10000);
        return ()=>clearTimeout(timer);
    }, [
        gatewayError
    ]);
    (0, $jHEir.useEffect)(()=>{
        return ()=>{
            if (abortControllerRef.current) abortControllerRef.current.abort();
        };
    }, []);
    const handleConfigureClick = async ()=>{
        setLoading(true);
        setGatewayError(null);
        try {
            const response = await (0, $zs3Np.tradingApi).getSystemControlState();
            if (response.success && response.data) {
                setControlState(response.data);
                setShowConfigModal(true);
            }
        } catch (err) {
            console.warn("Failed to open configuration:", err);
            setShowConfigModal(true);
        } finally{
            setLoading(false);
        }
    };
    const isGatewayActive = controlState?.gateway_running ?? controlState?.ib_connected ?? false;
    const isBrokerConnected = controlState?.ib_connected ?? false;
    const isConfigured = controlState?.gateway_configured ?? false;
    const showSetupPreparing = setupRefreshing && !isConfigured;
    const handleGatewayConfigSuccess = async ()=>{
        setSetupRefreshing(true);
        setGatewayError(null);
        await fetchControlState();
        setTimeout(()=>setSetupRefreshing(false), 2500);
    };
    const handleCancel = async ()=>{
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
            abortControllerRef.current = null;
        }
        setLoading(false);
        setActiveAction(null);
        try {
            // Explicitly stop the gateway to ensure cleanup
            await (0, $zs3Np.tradingApi).controlIBGateway("stop");
            await fetchControlState();
        } catch (err) {
            console.warn("Failed to stop gateway during cancellation:", err);
        }
    };
    const handleConnectClick = async ()=>{
        if (!controlState) return;
        if (!isConfigured && !isGatewayActive) {
            handleConfigureClick();
            return;
        }
        // If we are currently connecting, clicking again acts as a cancel action
        if (loading && activeAction === "start") {
            await handleCancel();
            return;
        }
        setLoading(true);
        setGatewayError(null);
        const action = isGatewayActive ? "stop" : "start";
        setActiveAction(action);
        // Cancel any existing controller and establish a new one
        if (abortControllerRef.current) abortControllerRef.current.abort();
        const controller = new AbortController();
        abortControllerRef.current = controller;
        try {
            const response = await (0, $zs3Np.tradingApi).controlIBGateway(action);
            if (response.success) {
                if (action === "start") {
                    // Poll for connection progress up to 30 seconds
                    let attempts = 0;
                    let maxAttempts = 30;
                    while(attempts < maxAttempts && abortControllerRef.current === controller){
                        await fetchControlState();
                        try {
                            const status = await (0, $zs3Np.tradingApi).getSystemControlState();
                            if (status.success && status.data) {
                                const statusData = status.data;
                                // Update hint/error states if any
                                if (statusData.gateway_hint) maxAttempts = Math.max(maxAttempts, 120); // extend window if user action is pending
                                if (statusData.connection_error) {
                                    const lower = statusData.connection_error.toLowerCase();
                                    const isFatal = lower.includes("invalid credential") || lower.includes("trading mode mismatch") || lower.includes("returned exit status") || lower.includes("failed to decrypt") || lower.includes("fatal");
                                    if (isFatal) {
                                        setGatewayError(statusData.connection_error);
                                        await (0, $zs3Np.tradingApi).controlIBGateway("stop");
                                        break;
                                    }
                                }
                                if (statusData.ib_connected) break;
                            }
                        } catch (e) {
                            console.warn("Failed to poll status:", e);
                        }
                        await new Promise((resolve)=>setTimeout(resolve, 1000));
                        attempts++;
                    }
                }
                await fetchControlState();
            } else setGatewayError(response.error || response.message || `Failed to ${action} gateway`);
        } catch (err) {
            if (err.name === 'AbortError') console.log('Broker connection connection cancelled');
            else setGatewayError(err.message || "Failed to control gateway");
        } finally{
            if (abortControllerRef.current === controller) {
                setLoading(false);
                setActiveAction(null);
                abortControllerRef.current = null;
            }
        }
    };
    const show2FABanner = controlState?.gateway_running && !controlState?.ib_connected;
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "flex flex-col gap-4 w-full",
        children: [
            gatewayError && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "rounded-xl bg-error-500/10 border border-error-500/20 px-4 py-3 flex items-start justify-between gap-4 animate-in slide-in-from-top-2 duration-200",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-start gap-2.5 text-sm text-error-500",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jr1gO.default), {
                                size: 16,
                                className: "text-error-500 mt-0.5 flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                children: gatewayError
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $62Hcf.ThemeButton), {
                        variant: "danger",
                        size: "sm",
                        type: "button",
                        onClick: ()=>setGatewayError(null),
                        children: "Dismiss"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-3 gap-4 items-stretch",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                        type: "button",
                        onClick: handleConfigureClick,
                        disabled: loading,
                        className: `w-full min-h-[112px] text-left rounded-xl bg-white/5 border p-4 flex items-center justify-between hover:bg-white/10 transition-colors duration-300 group cursor-pointer focus:outline-hidden focus:ring-1 focus:ring-neon/40 disabled:opacity-50 ${isConfigured ? 'border-success-500/30 shadow-[0_0_15px_rgba(16,185,129,0.05)]' : 'border-white/10'}`,
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: `h-10 w-10 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform flex-shrink-0 ${isConfigured ? 'bg-success-500/20 text-success-500' : 'bg-white/10 text-muted'}`,
                                        children: loading || showSetupPreparing ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                                            size: 20,
                                            className: "animate-spin"
                                        }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $eC2xp.default), {
                                            size: 20
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                                className: "text-sm font-semibold text-white",
                                                children: "1. Configure IB Connection"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                className: "text-xs text-muted",
                                                children: showSetupPreparing ? 'Saving setup and preparing broker controls...' : 'Set up your Interactive Brokers connection details.'
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "flex-shrink-0 ml-2",
                                children: isConfigured ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7i2bY.default), {
                                    className: "w-5 h-5 text-success-500 drop-shadow-[0_0_8px_rgba(16,185,129,0.5)] animate-in zoom-in-50 duration-300"
                                }) : showSetupPreparing ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                                    className: "w-5 h-5 text-info-500 animate-spin"
                                }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $d21ded0a0bf0608c$export$2e2bcd8739ae039), {
                                    className: "w-5 h-5 text-muted/40"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex flex-col gap-3 w-full h-full",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                type: "button",
                                onClick: handleConnectClick,
                                disabled: !controlState || showSetupPreparing || loading && activeAction === "stop",
                                className: `w-full flex-1 min-h-[112px] text-left rounded-xl bg-white/5 border p-4 flex items-center justify-between hover:bg-white/10 transition-colors duration-300 group cursor-pointer focus:outline-hidden focus:ring-1 focus:ring-neon/40 disabled:opacity-50 ${loading && activeAction === "start" ? 'border-warning-500/30 shadow-[0_0_15px_rgba(245,158,11,0.05)] bg-warning-500/5' : isGatewayActive ? 'border-success-500/30 shadow-[0_0_15px_rgba(16,185,129,0.05)]' : 'border-white/10'}`,
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: `h-10 w-10 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform flex-shrink-0 ${loading && activeAction === "start" ? 'bg-warning-500/20 text-warning-500' : isGatewayActive ? 'bg-error-500/20 text-error-500' : 'bg-info-500/20 text-info-500'}`,
                                                children: loading ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                                                    size: 20,
                                                    className: "animate-spin"
                                                }) : isGatewayActive ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $c5crE.default), {
                                                    size: 20
                                                }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $9WswS.default), {
                                                    size: 20
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                                        className: "text-sm font-semibold text-white flex items-center gap-2",
                                                        children: showSetupPreparing ? "2. Preparing Broker" : loading && activeAction === "start" ? /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                    children: "2. Connecting to Broker..."
                                                                }),
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                    className: "text-[10px] bg-error-500/20 text-error-500 border border-error-500/30 px-1.5 py-0.5 rounded-sm animate-pulse",
                                                                    children: "Click to Cancel"
                                                                })
                                                            ]
                                                        }) : isGatewayActive ? "2. Disconnect Broker" : "2. Connect to Broker"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                        className: "text-xs text-muted",
                                                        children: showSetupPreparing ? "Broker controls will be ready in a moment." : loading && activeAction === "start" ? "Establishing secure session. Click anywhere on this button to cancel connection." : isGatewayActive ? "Disconnect from Interactive Brokers." : "Launch the connection to begin the broker session."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: "flex-shrink-0 ml-2",
                                        children: loading && activeAction === "start" ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                                            className: "w-5 h-5 text-warning-500 animate-spin"
                                        }) : isGatewayActive ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7i2bY.default), {
                                            className: "w-5 h-5 text-success-500 drop-shadow-[0_0_8px_rgba(16,185,129,0.5)] animate-in zoom-in-50 duration-300"
                                        }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $d21ded0a0bf0608c$export$2e2bcd8739ae039), {
                                            className: "w-5 h-5 text-muted/40"
                                        })
                                    })
                                ]
                            }),
                            show2FABanner && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "w-full rounded-xl bg-warning-500/10 border border-warning-500/20 p-3.5 flex flex-col gap-2.5 shadow-[0_0_15px_rgba(245,158,11,0.05)] animate-pulse",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-start gap-2.5",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jr1gO.default), {
                                                size: 16,
                                                className: "text-warning-500 mt-0.5 flex-shrink-0"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h4", {
                                                        className: "text-xs font-semibold text-warning-500",
                                                        children: "Action Required: Complete 2FA"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                        className: "text-[10px] text-warning-500/80 leading-relaxed mt-1",
                                                        children: controlState?.gateway_hint || "Gateway connection is starting. Please check your mobile phone for an Interactive Brokers (IB Key) 2FA push notification to approve the secure session."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-1.5 text-[10px] text-warning-500 font-semibold bg-warning-500/20 px-2.5 py-1 rounded-sm border border-warning-500/30 w-max",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                                                size: 10,
                                                className: "animate-spin"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                children: "Awaiting 2FA Confirmation"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: `min-h-[112px] rounded-xl bg-white/5 border p-4 flex items-center justify-between hover:bg-white/10 transition-colors duration-300 group ${isBrokerConnected ? 'border-success-500/30 shadow-[0_0_15px_rgba(16,185,129,0.05)]' : 'border-white/10'}`,
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: `h-10 w-10 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform flex-shrink-0 mt-0.5 ${isBrokerConnected ? 'bg-success-500/20 text-success-500' : 'bg-white/10 text-muted'}`,
                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $9sk6d.default), {
                                            size: 20
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                                className: "text-sm font-semibold text-white",
                                                children: "3. Monitor Anytime"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                className: "text-xs text-muted",
                                                children: "You can close this window; trading runs 24/7 in the cloud."
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                className: "text-[10px] text-warning-500/85 mt-1",
                                                children: "Reconnects require mobile 2FA; auto-restart runs Sunday night."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "flex-shrink-0 ml-2",
                                children: isBrokerConnected ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7i2bY.default), {
                                    className: "w-5 h-5 text-success-500 drop-shadow-[0_0_8px_rgba(16,185,129,0.5)] animate-in zoom-in-50 duration-300"
                                }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $d21ded0a0bf0608c$export$2e2bcd8739ae039), {
                                    className: "w-5 h-5 text-muted/40"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7Mvr3.default), {
                        isOpen: showConfigModal,
                        onClose: ()=>setShowConfigModal(false),
                        onSuccess: handleGatewayConfigSuccess,
                        currentUsername: controlState?.ib_username,
                        currentMode: controlState?.ib_mode,
                        savedGateways: controlState?.saved_gateways
                    })
                ]
            })
        ]
    });
};
var $99c01f15c39a6dcf$export$2e2bcd8739ae039 = $99c01f15c39a6dcf$var$InvestorQuickStart;



var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $zs3Np = parcelRequire("zs3Np");

var $gQIZx = parcelRequire("gQIZx");/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $e1515c78957ff808$export$a2387ed3b5d536eb = {
    name: "moon",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401",
                key: "kfwtm"
            }
        ]
    ]
};
$e1515c78957ff808$export$a2387ed3b5d536eb.node;
const $e1515c78957ff808$export$2e2bcd8739ae039 = (0, $hHhnY.default)($e1515c78957ff808$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $c87066203dd10dc2$export$a2387ed3b5d536eb = {
    name: "sun",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "4",
                key: "4exip2"
            }
        ],
        [
            "path",
            {
                d: "M12 2v2",
                key: "tus03m"
            }
        ],
        [
            "path",
            {
                d: "M12 20v2",
                key: "1lh1kg"
            }
        ],
        [
            "path",
            {
                d: "m4.93 4.93 1.41 1.41",
                key: "149t6j"
            }
        ],
        [
            "path",
            {
                d: "m17.66 17.66 1.41 1.41",
                key: "ptbguv"
            }
        ],
        [
            "path",
            {
                d: "M2 12h2",
                key: "1t8f8n"
            }
        ],
        [
            "path",
            {
                d: "M20 12h2",
                key: "1q8mjw"
            }
        ],
        [
            "path",
            {
                d: "m6.34 17.66-1.41 1.41",
                key: "1m8zz5"
            }
        ],
        [
            "path",
            {
                d: "m19.07 4.93-1.41 1.41",
                key: "1shlcs"
            }
        ]
    ]
};
$c87066203dd10dc2$export$a2387ed3b5d536eb.node;
const $c87066203dd10dc2$export$2e2bcd8739ae039 = (0, $hHhnY.default)($c87066203dd10dc2$export$a2387ed3b5d536eb);


var $8FKMh = parcelRequire("8FKMh");

var $hpygi = parcelRequire("hpygi");

var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");

var $jr1gO = parcelRequire("jr1gO");
var $7i2bY = parcelRequire("7i2bY");
var $cKEgK = parcelRequire("cKEgK");

var $iCbFX = parcelRequire("iCbFX");
const $9e800d71ae82fe1f$var$StrategyMarginStatus = ({ status: status, compact: compact = false })=>{
    const required = status?.free_margin_required;
    const available = status?.free_margin_available;
    const sufficient = status?.free_margin_available_for_strategy;
    const currency = status?.free_margin_currency || 'USD';
    const badge = sufficient === true ? {
        label: 'Available',
        className: 'border-emerald-400/20 bg-emerald-400/10 text-emerald-300',
        icon: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7i2bY.default), {
            className: "h-3.5 w-3.5"
        })
    } : sufficient === false ? {
        label: 'Shortfall',
        className: 'border-rose-400/20 bg-rose-400/10 text-rose-300',
        icon: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jr1gO.default), {
            className: "h-3.5 w-3.5"
        })
    } : {
        label: 'Unavailable',
        className: 'border-white/10 bg-white/5 text-muted',
        icon: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $cKEgK.default), {
            className: "h-3.5 w-3.5"
        })
    };
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: `rounded-xl border border-white/10 bg-black/20 ${compact ? 'p-3' : 'p-4'}`,
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "text-[10px] font-black uppercase tracking-[0.16em] text-muted",
                                children: "Free margin"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "mt-1 text-xs text-white/60",
                                children: status?.free_margin_basis || 'Waiting for strategy sizing'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: `inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider ${badge.className}`,
                        children: [
                            badge.icon,
                            badge.label
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: `mt-3 grid gap-3 ${compact ? 'grid-cols-2' : 'grid-cols-1 sm:grid-cols-3'}`,
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "text-[10px] uppercase tracking-wider text-muted",
                                children: "Required"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "mt-1 font-mono text-sm font-semibold text-white",
                                children: (0, $iCbFX.formatCurrency)(required, currency)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "text-[10px] uppercase tracking-wider text-muted",
                                children: "Available"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "mt-1 font-mono text-sm font-semibold text-white",
                                children: (0, $iCbFX.formatCurrency)(available, currency)
                            })
                        ]
                    }),
                    !compact && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "text-[10px] uppercase tracking-wider text-muted",
                                children: "Shortfall"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: `mt-1 font-mono text-sm font-semibold ${status?.free_margin_shortfall ? 'text-rose-300' : 'text-emerald-300'}`,
                                children: (0, $iCbFX.formatCurrency)(status?.free_margin_shortfall, currency)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "mt-3 text-[10px] leading-relaxed text-white/40",
                children: "Estimated from current strategy sizing; IB available funds are the account availability check."
            })
        ]
    });
};
var $9e800d71ae82fe1f$export$2e2bcd8739ae039 = $9e800d71ae82fe1f$var$StrategyMarginStatus;


const $2a8d759113e28e7d$var$InvestorStrategyView = ()=>{
    const onStatus = (0, $hpygi.useStrategyStatusQuery)('ON', {
        pollingInterval: 30000
    }).data;
    const orbStatus = (0, $hpygi.useStrategyStatusQuery)('ORB', {
        pollingInterval: 30000
    }).data;
    const dtStatus = (0, $hpygi.useStrategyStatusQuery)('DT', {
        pollingInterval: 30000
    }).data;
    const nqmmStatus = (0, $hpygi.useStrategyStatusQuery)('NQMM', {
        pollingInterval: 30000
    }).data;
    const [configs, setConfigs] = (0, $jHEir.useState)({});
    (0, $jHEir.useEffect)(()=>{
        const fetchConfigs = async ()=>{
            try {
                const [onConfig, orbConfig, dtConfig, nqmmConfig] = await Promise.all([
                    (0, $zs3Np.tradingApi).getStrategyDbConfig('ON'),
                    (0, $zs3Np.tradingApi).getStrategyDbConfig('ORB'),
                    (0, $zs3Np.tradingApi).getStrategyDbConfig('DT'),
                    (0, $zs3Np.tradingApi).getStrategyDbConfig('NQMM')
                ]);
                setConfigs({
                    ON: onConfig,
                    ORB: orbConfig,
                    DT: dtConfig,
                    NQMM: nqmmConfig
                });
            } catch (error) {
                console.warn('Failed to fetch strategy configuration for investor view', error);
            }
        };
        fetchConfigs();
        const interval = setInterval(fetchConfigs, 30000);
        return ()=>clearInterval(interval);
    }, []);
    const strategies = (0, $jHEir.useMemo)(()=>{
        const getSymbols = (name, status)=>{
            const active = status?.data?.selected_symbols || status?.data?.active_symbols;
            if (name === 'NQMM' && Array.isArray(active) && active.length > 0) return active;
            const configured = configs[name]?.data?.config?.symbols;
            if (Array.isArray(configured) && configured.length > 0) return configured;
            return Array.isArray(active) ? active : [];
        };
        return {
            ON: {
                enabled: Boolean(onStatus?.data?.enabled),
                hydrated: Boolean(onStatus?.data?.hydrated),
                runtimeStale: Boolean(onStatus?.data?.runtime_stale),
                statusLoaded: Boolean(onStatus?.success && onStatus?.data),
                symbols: getSymbols('ON', onStatus)
            },
            ORB: {
                enabled: Boolean(orbStatus?.data?.enabled),
                hydrated: Boolean(orbStatus?.data?.hydrated),
                runtimeStale: Boolean(orbStatus?.data?.runtime_stale),
                statusLoaded: Boolean(orbStatus?.success && orbStatus?.data),
                symbols: getSymbols('ORB', orbStatus)
            },
            DT: {
                enabled: Boolean(dtStatus?.data?.enabled),
                hydrated: Boolean(dtStatus?.data?.hydrated),
                runtimeStale: Boolean(dtStatus?.data?.runtime_stale),
                statusLoaded: Boolean(dtStatus?.success && dtStatus?.data),
                symbols: getSymbols('DT', dtStatus)
            },
            NQMM: {
                enabled: Boolean(nqmmStatus?.data?.enabled),
                hydrated: Boolean(nqmmStatus?.data?.hydrated),
                runtimeStale: Boolean(nqmmStatus?.data?.runtime_stale),
                statusLoaded: Boolean(nqmmStatus?.success && nqmmStatus?.data),
                symbols: getSymbols('NQMM', nqmmStatus),
                sleeveAllocation: nqmmStatus?.data?.sleeve_allocation ?? nqmmStatus?.data?.position_size,
                universeSize: nqmmStatus?.data?.universe_size ?? configs.NQMM?.data?.config?.constituent_count
            }
        };
    }, [
        configs,
        dtStatus,
        nqmmStatus,
        onStatus,
        orbStatus
    ]);
    const StatusBadge = ({ strategy: strategy })=>{
        const label = !strategy.statusLoaded ? 'Unavailable' : !strategy.enabled ? 'Disabled' : strategy.runtimeStale ? 'Stale' : !strategy.hydrated ? 'Starting' : 'Enabled';
        const active = strategy.statusLoaded && strategy.enabled && !strategy.runtimeStale;
        const className = !strategy.statusLoaded ? 'bg-white/5 text-muted border-white/5' : !strategy.enabled ? 'bg-white/5 text-muted border-white/5' : strategy.runtimeStale ? 'bg-warning-500/10 text-warning-400 border-warning-500/20' : 'bg-success-500/10 text-success-500 border-success-500/20';
        return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
            className: `flex items-center gap-1.5 px-2 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider border ${className}`,
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                    className: `w-1.5 h-1.5 rounded-full ${active ? 'bg-success-500 animate-pulse' : 'bg-gray-500'}`
                }),
                label
            ]
        });
    };
    const SymbolTags = ({ symbols: symbols })=>/*#__PURE__*/ (0, $eHRxX.jsx)("div", {
            className: "flex flex-wrap gap-1.5 mt-3",
            children: symbols.map((sym)=>/*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                    className: "px-1.5 py-0.5 rounded-sm bg-white/5 border border-white/5 text-[10px] font-mono text-muted",
                    children: sym
                }, sym))
        });
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "panel full-bleed-panel",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "p-6 border-b border-white/10",
                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex items-center gap-3 mb-2",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                            className: "p-2 rounded-lg bg-neon/10 text-neon",
                            children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $gQIZx.default), {
                                className: "w-5 h-5"
                            })
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("h2", {
                                    className: "text-lg font-bold text-white",
                                    children: "Strategy Overview"
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                    className: "text-sm text-muted",
                                    children: "Configured automated systems and their current runtime status."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 divide-y lg:divide-y-0 lg:divide-x divide-white/10",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "p-6 space-y-4 hover:bg-white/2 transition duration-300",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-start justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: "p-2 rounded-lg bg-indigo-500/20 text-indigo-400",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8d55bb18c538de43$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                                        className: "font-bold text-white",
                                                        children: "Opening Range Breakout"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                        className: "text-xs font-mono text-muted mt-0.5",
                                                        children: "STRATEGY: ORB"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)(StatusBadge, {
                                        strategy: strategies.ORB
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                className: "text-sm text-gray-400 leading-relaxed",
                                children: "An intraday strategy that seeks to participate in strong moves after the market opens, with defined risk controls and no overnight exposure."
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)(SymbolTags, {
                                symbols: strategies.ORB.symbols
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $9e800d71ae82fe1f$export$2e2bcd8739ae039), {
                                status: orbStatus?.data,
                                compact: true
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "pt-2",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h4", {
                                        className: "text-xs font-semibold text-muted uppercase tracking-wider mb-2",
                                        children: "Key Features"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("ul", {
                                        className: "grid grid-cols-2 gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "text-xs text-indigo-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-indigo-400/50"
                                                    }),
                                                    "Morning Volatility"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "text-xs text-indigo-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-indigo-400/50"
                                                    }),
                                                    "Momentum Based"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "text-xs text-indigo-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-indigo-400/50"
                                                    }),
                                                    "Strict Stop Loss"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "text-xs text-indigo-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-indigo-400/50"
                                                    }),
                                                    "No Overnight Risk"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "p-6 space-y-4 hover:bg-white/2 transition duration-300",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-start justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: "p-2 rounded-lg bg-orange-500/20 text-orange-400",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $c87066203dd10dc2$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                                        className: "font-bold text-white",
                                                        children: "Intraday Trend"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                        className: "text-xs font-mono text-muted mt-0.5",
                                                        children: "STRATEGY: DT"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)(StatusBadge, {
                                        strategy: strategies.DT
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                className: "text-sm text-gray-400 leading-relaxed",
                                children: "An intraday trend-following strategy that responds to market movement during the session and closes positions before the day ends."
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)(SymbolTags, {
                                symbols: strategies.DT.symbols
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $9e800d71ae82fe1f$export$2e2bcd8739ae039), {
                                status: dtStatus?.data,
                                compact: true
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "pt-2",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h4", {
                                        className: "text-xs font-semibold text-muted uppercase tracking-wider mb-2",
                                        children: "Key Features"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("ul", {
                                        className: "grid grid-cols-2 gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "text-xs text-orange-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-orange-400/50"
                                                    }),
                                                    "Trend Following"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "text-xs text-orange-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-orange-400/50"
                                                    }),
                                                    "Volatility Adaptive"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "text-xs text-orange-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-orange-400/50"
                                                    }),
                                                    "Dynamic Risk Mgmt"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "text-xs text-orange-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-orange-400/50"
                                                    }),
                                                    "EOD Exit"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "p-6 space-y-4 hover:bg-white/2 transition duration-300",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-start justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: "p-2 rounded-lg bg-purple-500/20 text-purple-400",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $e1515c78957ff808$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                                        className: "font-bold text-white",
                                                        children: "Overnight Swing"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                        className: "text-xs font-mono text-muted mt-0.5",
                                                        children: "STRATEGY: ON"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)(StatusBadge, {
                                        strategy: strategies.ON
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                className: "text-sm text-gray-400 leading-relaxed",
                                children: "A long overnight strategy designed to capture moves between market sessions, with positions closed during the following trading session."
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)(SymbolTags, {
                                symbols: strategies.ON.symbols
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $9e800d71ae82fe1f$export$2e2bcd8739ae039), {
                                status: onStatus?.data,
                                compact: true
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "pt-2",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h4", {
                                        className: "text-xs font-semibold text-muted uppercase tracking-wider mb-2",
                                        children: "Key Features"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("ul", {
                                        className: "grid grid-cols-2 gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "text-xs text-purple-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-purple-400/50"
                                                    }),
                                                    "Overnight Edge"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "text-xs text-purple-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-purple-400/50"
                                                    }),
                                                    "Mean Reversion"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "text-xs text-purple-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-purple-400/50"
                                                    }),
                                                    "Diversified"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "text-xs text-purple-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-purple-400/50"
                                                    }),
                                                    "Gap Capture"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "p-6 space-y-4 hover:bg-white/2 transition duration-300",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-start justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: "p-2 rounded-lg bg-success-500/20 text-success-500",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8FKMh.default), {
                                                    className: "w-5 h-5"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                                        className: "font-bold text-white",
                                                        children: "Nasdaq-100 Momentum"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                        className: "text-xs font-mono text-muted mt-0.5",
                                                        children: "STRATEGY: NQMM"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)(StatusBadge, {
                                        strategy: strategies.NQMM
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                className: "text-sm text-gray-400 leading-relaxed",
                                children: "A long-only portfolio sleeve that ranks Nasdaq-100 stocks by relative momentum and periodically reallocates toward stronger names."
                            }),
                            strategies.NQMM.universeSize !== undefined && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "text-[10px] font-mono text-success-500/80",
                                children: [
                                    "Database QQQ universe: ",
                                    strategies.NQMM.universeSize,
                                    " constituents"
                                ]
                            }),
                            strategies.NQMM.symbols.length > 0 && /*#__PURE__*/ (0, $eHRxX.jsx)(SymbolTags, {
                                symbols: strategies.NQMM.symbols.slice(0, 12)
                            }),
                            strategies.NQMM.symbols.length > 12 && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "text-[10px] text-muted -mt-2",
                                children: [
                                    "+",
                                    strategies.NQMM.symbols.length - 12,
                                    " more active names"
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $9e800d71ae82fe1f$export$2e2bcd8739ae039), {
                                status: nqmmStatus?.data,
                                compact: true
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "pt-2",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h4", {
                                        className: "text-xs font-semibold text-muted uppercase tracking-wider mb-2",
                                        children: "Key Features"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("ul", {
                                        className: "grid grid-cols-2 gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "text-xs text-success-500/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-success-500/50"
                                                    }),
                                                    "Monthly Rebalance"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "text-xs text-success-500/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-success-500/50"
                                                    }),
                                                    "Cross-Sectional Rank"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "text-xs text-success-500/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-success-500/50"
                                                    }),
                                                    "Portfolio Sleeve"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "text-xs text-success-500/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-success-500/50"
                                                    }),
                                                    "Long Only"
                                                ]
                                            })
                                        ]
                                    }),
                                    strategies.NQMM.sleeveAllocation !== undefined && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "mt-3 text-[10px] font-mono text-success-500/80",
                                        children: [
                                            "Sleeve allocation: ",
                                            (strategies.NQMM.sleeveAllocation * 100).toFixed(1),
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $2a8d759113e28e7d$export$2e2bcd8739ae039 = $2a8d759113e28e7d$var$InvestorStrategyView;



var $eHRxX = parcelRequire("eHRxX");

var $62Hcf = parcelRequire("62Hcf");

var $5HFtN = parcelRequire("5HFtN");

var $jHEir = parcelRequire("jHEir");

var $zs3Np = parcelRequire("zs3Np");

var $f11WQ = parcelRequire("f11WQ");

var $5ogeV = parcelRequire("5ogeV");

var $4cvdp = parcelRequire("4cvdp");

var $lRLyZ = parcelRequire("lRLyZ");
const $676345489ed21047$var$DASHBOARD_LOG_FETCH_LIMIT = 2000;
const $676345489ed21047$var$DASHBOARD_LOG_DISPLAY_LIMIT = 1000;
const $676345489ed21047$var$LogViewer = ()=>{
    const [logs, setLogs] = (0, $jHEir.useState)([]);
    const [loading, setLoading] = (0, $jHEir.useState)(true);
    const [error, setError] = (0, $jHEir.useState)(null);
    const [levelFilter, setLevelFilter] = (0, $jHEir.useState)('ALL');
    const [componentFilter, setComponentFilter] = (0, $jHEir.useState)('ALL');
    const [autoScroll, setAutoScroll] = (0, $jHEir.useState)(true);
    const logsContainerRef = (0, $jHEir.useRef)(null);
    const logsFingerprintRef = (0, $jHEir.useRef)('');
    const requestInFlightRef = (0, $jHEir.useRef)(false);
    const fetchLogs = (0, $jHEir.useCallback)(async (isInitialLoad = false)=>{
        if (requestInFlightRef.current) return;
        requestInFlightRef.current = true;
        if (isInitialLoad) setLoading(true);
        setError(null);
        try {
            // Stagger initial API call for initial load
            if (isInitialLoad) await new Promise((resolve)=>setTimeout(resolve, 300));
            const response = await (0, $zs3Np.tradingApi).getRecentLogs($676345489ed21047$var$DASHBOARD_LOG_FETCH_LIMIT, levelFilter === 'ALL' ? undefined : levelFilter);
            if (response.success && response.data) {
                const nextLogs = response.data?.logs || [];
                const first = nextLogs[0];
                const last = nextLogs[nextLogs.length - 1];
                const fingerprint = [
                    nextLogs.length,
                    first?.timestamp,
                    first?.message,
                    last?.timestamp,
                    last?.message
                ].join('|');
                if (fingerprint !== logsFingerprintRef.current) {
                    logsFingerprintRef.current = fingerprint;
                    setLogs(nextLogs);
                }
            } else if (isInitialLoad) setLogs([]);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to fetch logs');
            if (isInitialLoad) setLogs([]);
        } finally{
            requestInFlightRef.current = false;
            setLoading(false);
        }
    }, [
        levelFilter
    ]);
    (0, $jHEir.useEffect)(()=>{
        fetchLogs(true);
    }, [
        fetchLogs
    ]);
    (0, $jHEir.useEffect)(()=>{
        const refreshWhenVisible = ()=>{
            if (document.visibilityState === 'visible') fetchLogs();
        };
        const intervalId = window.setInterval(refreshWhenVisible, 10000);
        document.addEventListener('visibilitychange', refreshWhenVisible);
        return ()=>{
            window.clearInterval(intervalId);
            document.removeEventListener('visibilitychange', refreshWhenVisible);
        };
    }, [
        fetchLogs
    ]);
    (0, $jHEir.useEffect)(()=>{
        // Auto-scroll to bottom when new logs arrive
        if (autoScroll && logsContainerRef.current) logsContainerRef.current.scrollTop = logsContainerRef.current.scrollHeight;
    }, [
        logs,
        autoScroll
    ]);
    const getLevelColor = (level)=>(0, $5HFtN.themeToneTextClasses)[(0, $5HFtN.getLogLevelTone)(level)];
    const getLevelBadge = (level)=>/*#__PURE__*/ (0, $eHRxX.jsx)((0, $62Hcf.ThemeBadge), {
            tone: (0, $5HFtN.getLogLevelTone)(level),
            children: level
        });
    const formatTimestamp = (timestamp)=>{
        return (0, $lRLyZ.formatTimeET)(timestamp);
    };
    const handleScroll = ()=>{
        if (logsContainerRef.current) {
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = logsContainerRef.current;
            const isNearBottom = scrollHeight - scrollTop - clientHeight < 50;
            setAutoScroll(isNearBottom);
        }
    };
    const levels = [
        'ALL',
        'INFO',
        'WARNING',
        'ERROR'
    ];
    const strategyComponents = [
        'ONStrategy',
        'ORBStrategy',
        'ATRDTStrategy'
    ];
    const visibleLogs = (0, $jHEir.useMemo)(()=>{
        const filtered = componentFilter === 'ALL' ? logs : logs.filter((log)=>log.component === componentFilter);
        // Keep the dashboard DOM bounded while retaining a longer recent window.
        return filtered.slice(-$676345489ed21047$var$DASHBOARD_LOG_DISPLAY_LIMIT);
    }, [
        componentFilter,
        logs
    ]);
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "panel full-bleed-panel w-full",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "px-6 py-5 border-b border-white/10",
                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex flex-col gap-3 md:flex-row md:items-center md:justify-between",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                    className: "p-2 rounded-lg bg-neon/10 text-neon",
                                    children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $f11WQ.default), {
                                        className: "w-5 h-5"
                                    })
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                    className: "space-y-0.5",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("h2", {
                                            className: "text-lg font-bold text-white tracking-tight",
                                            children: "System Logs"
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                            className: "text-xs text-muted font-medium",
                                            children: "Real-time telemetry, execution logs, and system alerts."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-3 md:justify-end",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                    className: "flex items-center gap-2 text-xs",
                                    children: levels.map((lvl)=>/*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                            onClick: ()=>setLevelFilter(lvl),
                                            className: `px-2.5 py-1 rounded-lg border text-[11px] font-semibold transition ${levelFilter === lvl ? 'border-neon text-neon bg-neon/10' : 'border-white/15 text-muted hover:text-foreground hover:border-neon/40'}`,
                                            children: lvl
                                        }, lvl))
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                    className: "flex items-center gap-2 text-[11px] text-muted",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            className: "uppercase tracking-[0.16em]",
                                            children: "Strategies"
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                            className: "flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                                    onClick: ()=>setComponentFilter('ALL'),
                                                    className: `px-2 py-1 rounded-lg transition ${componentFilter === 'ALL' ? 'bg-white/10 text-foreground' : 'text-muted hover:text-foreground hover:bg-white/5'}`,
                                                    children: "All"
                                                }),
                                                strategyComponents.map((name)=>/*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                                        onClick: ()=>setComponentFilter(name),
                                                        className: `px-2 py-1 rounded-lg transition ${componentFilter === name ? 'bg-neon/15 text-neon' : 'text-muted hover:text-foreground hover:bg-white/5'}`,
                                                        children: name.replace('Strategy', '')
                                                    }, name))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("label", {
                                    className: "flex items-center gap-2 text-xs text-muted",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                            type: "checkbox",
                                            id: "auto-scroll",
                                            checked: autoScroll,
                                            onChange: (e)=>setAutoScroll(e.target.checked),
                                            className: "h-3 w-3 text-neon focus:ring-neon border-line bg-dark-1"
                                        }),
                                        "Auto-scroll"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "p-5",
                children: [
                    error && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4cvdp.default), {
                        error: error,
                        onRetry: ()=>fetchLogs(),
                        message: "Failed to load logs"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "h-80 overflow-hidden",
                        children: /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                            ref: logsContainerRef,
                            onScroll: handleScroll,
                            className: "h-full overflow-y-auto scrollbar-thin p-4 font-mono text-xs text-foreground",
                            children: loading && logs.length === 0 ? /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "flex justify-center items-center h-full",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $5ogeV.default), {
                                    size: "lg"
                                })
                            }) : logs.length === 0 ? /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "flex justify-center items-center h-full text-muted",
                                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                    className: "text-center",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                            className: "text-4xl mb-4",
                                            children: "\uD83D\uDCCB"
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                            children: "No logs available"
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "space-y-0.5",
                                children: visibleLogs.map((log, index)=>/*#__PURE__*/ (0, $eHRxX.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex flex-col sm:hidden hover:bg-dark-4 p-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                        className: "flex items-center justify-between w-full mb-1 text-[10px] text-muted",
                                                        children: [
                                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                                className: "flex items-center space-x-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                        children: formatTimestamp(log.timestamp)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                        className: "truncate max-w-[120px]",
                                                                        children: log.logger
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                                children: getLevelBadge(log.level)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                        className: "flex-1 wrap-break-word text-sm",
                                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                            className: getLevelColor(log.level),
                                                            children: log.message
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "hidden sm:flex items-start space-x-3 hover:bg-dark-4 p-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                        className: "text-[11px] text-muted mt-0.5 min-w-[80px] flex-shrink-0",
                                                        children: formatTimestamp(log.timestamp)
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                        className: "min-w-[80px] flex-shrink-0 mt-0.5",
                                                        children: getLevelBadge(log.level)
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                        className: "text-[11px] text-muted min-w-[100px] flex-shrink-0 mt-0.5",
                                                        children: log.logger
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                        className: "flex-1 wrap-break-word",
                                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                            className: getLevelColor(log.level),
                                                            children: log.message
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, `${log.timestamp}-${index}`))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "mt-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-muted",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-center flex-wrap gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                        children: [
                                            logs.length,
                                            " entries"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                        children: [
                                            "Level: ",
                                            levelFilter
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                        children: [
                                            "Auto-scroll: ",
                                            autoScroll ? 'On' : 'Off'
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $62Hcf.ThemeButton), {
                                        variant: "ghost",
                                        size: "sm",
                                        onClick: ()=>setAutoScroll(true),
                                        disabled: autoScroll,
                                        children: "Go to Latest"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $62Hcf.ThemeButton), {
                                        variant: "secondary",
                                        size: "sm",
                                        onClick: ()=>fetchLogs(),
                                        children: "Refresh"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $676345489ed21047$export$2e2bcd8739ae039 = $676345489ed21047$var$LogViewer;




var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $zs3Np = parcelRequire("zs3Np");

var $3KPv1 = parcelRequire("3KPv1");/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $0ee46722e8758d35$export$a2387ed3b5d536eb = {
    name: "tag",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
                key: "vktsd0"
            }
        ],
        [
            "circle",
            {
                cx: "7.5",
                cy: "7.5",
                r: ".5",
                fill: "currentColor",
                key: "kqv944"
            }
        ]
    ]
};
$0ee46722e8758d35$export$a2387ed3b5d536eb.node;
const $0ee46722e8758d35$export$2e2bcd8739ae039 = (0, $hHhnY.default)($0ee46722e8758d35$export$a2387ed3b5d536eb);


var $bgvjD = parcelRequire("bgvjD");

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $zs3Np = parcelRequire("zs3Np");

var $4cvdp = parcelRequire("4cvdp");

var $lRLyZ = parcelRequire("lRLyZ");

var $iCbFX = parcelRequire("iCbFX");

var $fvREG = parcelRequire("fvREG");


var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $jQze5 = parcelRequire("jQze5");
var $bgvjD = parcelRequire("bgvjD");
const $fce324f2f44a438f$export$233c8e1804dc7af2 = (order, filter)=>{
    const target = filter.trim().toUpperCase();
    if (!target) return true;
    return [
        order.symbol,
        order.rootSymbol,
        order.localSymbol,
        order.lastTradeDateOrContractMonth
    ].some((value)=>String(value || '').toUpperCase().includes(target));
};
const $fce324f2f44a438f$var$OrderSymbolFilter = ({ orders: orders, value: value, onChange: onChange })=>{
    const symbols = (0, $jHEir.useMemo)(()=>Array.from(new Set(orders.map((order)=>String(order.symbol || order.rootSymbol || order.localSymbol || '').trim().toUpperCase()).filter(Boolean))).sort(), [
        orders
    ]);
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "flex flex-wrap items-center gap-2 rounded-xl border border-white/10 bg-white/2.5 px-3 py-2.5",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                className: "mr-1 text-[10px] font-black uppercase tracking-widest text-white/40",
                children: "Quick symbol"
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                type: "button",
                onClick: ()=>onChange(''),
                className: `rounded-lg border px-2.5 py-1.5 text-[10px] font-bold uppercase tracking-wider transition-colors ${!value ? 'border-neon/30 bg-neon/10 text-neon' : 'border-white/10 text-white/50 hover:border-white/20 hover:text-white'}`,
                children: "All"
            }),
            symbols.map((symbol)=>/*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                    type: "button",
                    onClick: ()=>onChange(symbol),
                    className: `rounded-lg border px-2.5 py-1.5 text-[10px] font-bold tracking-wider transition-colors ${value.toUpperCase() === symbol ? 'border-neon/30 bg-neon/10 text-neon' : 'border-white/10 text-white/50 hover:border-neon/25 hover:text-neon'}`,
                    children: symbol
                }, symbol)),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("label", {
                className: "relative ml-auto min-w-[180px] flex-1 sm:max-w-[240px]",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jQze5.default), {
                        className: "pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-white/35"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                        type: "search",
                        value: value,
                        onChange: (event)=>onChange(event.target.value),
                        placeholder: "Filter symbol\u2026",
                        "aria-label": "Filter orders by symbol",
                        className: "h-8 w-full rounded-lg border border-white/10 bg-black/20 pl-8 pr-8 text-xs text-white outline-hidden placeholder:text-white/30 focus:border-neon/40"
                    }),
                    value && /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                        type: "button",
                        onClick: ()=>onChange(''),
                        className: "absolute right-1.5 top-1/2 -translate-y-1/2 rounded-sm p-1 text-white/40 hover:bg-white/10 hover:text-white",
                        "aria-label": "Clear symbol filter",
                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                            className: "h-3.5 w-3.5"
                        })
                    })
                ]
            })
        ]
    });
};
var $fce324f2f44a438f$export$2e2bcd8739ae039 = $fce324f2f44a438f$var$OrderSymbolFilter;


const $6cb2621c04b4f142$var$OpenOrders = ({ refreshInterval: refreshInterval = 30000, onEditOrder: onEditOrder, securityTypeFilter: securityTypeFilter = 'ALL' })=>{
    const [orders, setOrders] = (0, $jHEir.useState)([]);
    const [page, setPage] = (0, $jHEir.useState)(1);
    const pageSize = 10; // Increased page size for better oversight
    const [loading, setLoading] = (0, $jHEir.useState)(true);
    const [refreshing, setRefreshing] = (0, $jHEir.useState)(false);
    const [error, setError] = (0, $jHEir.useState)(null);
    const [errorHeader, setErrorHeader] = (0, $jHEir.useState)("Failed to load data");
    const [lastUpdated, setLastUpdated] = (0, $jHEir.useState)(null);
    const [symbolFilter, setSymbolFilter] = (0, $jHEir.useState)('');
    const [cancellingId, setCancellingId] = (0, $jHEir.useState)(null);
    const [snapshotStatus, setSnapshotStatus] = (0, $jHEir.useState)({
        stale: false,
        available: true,
        connectionStatus: 'connected'
    });
    const hasFetchedOrdersRef = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useRef(false);
    const currentPageRef = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useRef(page);
    currentPageRef.current = page;
    const fetchOrders = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useCallback(async (isInitialLoad = false, pageOverride)=>{
        const hasData = hasFetchedOrdersRef.current;
        if (isInitialLoad || !hasData) setLoading(true);
        else setRefreshing(true);
        setError(null);
        try {
            if (isInitialLoad) await new Promise((resolve)=>setTimeout(resolve, 500));
            const response = await (0, $zs3Np.tradingApi).getOpenOrders(pageOverride ?? currentPageRef.current, pageSize, securityTypeFilter);
            if (response.success && response.data) {
                setOrders(response.data?.orders || []);
                setSnapshotStatus({
                    stale: !!response.data.stale,
                    available: response.data.snapshot_available !== false,
                    connectionStatus: response.data.connection_status || 'connected'
                });
            } else {
                setOrders([]);
                if (response.error) {
                    setError(response.error);
                    setErrorHeader("Failed to load open orders");
                }
            }
            const ts = response.timestamp || new Date().toISOString();
            setLastUpdated((0, $lRLyZ.formatTimeET)(ts));
            hasFetchedOrdersRef.current = true;
        } catch (err) {
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            setError(err instanceof Error ? err.message : 'Failed to fetch open orders');
            setErrorHeader("Failed to load open orders");
            setOrders([]);
        } finally{
            setLoading(false);
            setRefreshing(false);
        }
    }, [
        pageSize,
        securityTypeFilter
    ]);
    (0, $jHEir.useEffect)(()=>{
        const handleRefresh = ()=>fetchOrders(false, page);
        window.addEventListener('trading-data-refresh', handleRefresh);
        return ()=>window.removeEventListener('trading-data-refresh', handleRefresh);
    }, [
        fetchOrders,
        page
    ]);
    (0, $jHEir.useEffect)(()=>{
        fetchOrders(true, 1);
    }, [
        fetchOrders
    ]);
    (0, $jHEir.useEffect)(()=>{
        const refreshWhenVisible = ()=>{
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            fetchOrders(false, page);
        };
        const intervalId = setInterval(refreshWhenVisible, refreshInterval);
        document.addEventListener('visibilitychange', refreshWhenVisible);
        window.addEventListener('focus', refreshWhenVisible);
        return ()=>{
            clearInterval(intervalId);
            document.removeEventListener('visibilitychange', refreshWhenVisible);
            window.removeEventListener('focus', refreshWhenVisible);
        };
    }, [
        fetchOrders,
        page,
        refreshInterval
    ]);
    (0, $jHEir.useEffect)(()=>{
        if (snapshotStatus.connectionStatus !== 'initializing') return;
        const retryId = window.setTimeout(()=>fetchOrders(false, page), 2000);
        return ()=>window.clearTimeout(retryId);
    }, [
        fetchOrders,
        page,
        snapshotStatus.connectionStatus
    ]);
    const getSideBadge = (side)=>{
        const variants = {
            BUY: 'bg-emerald-500/20 text-emerald-300 border border-emerald-500/30',
            SELL: 'bg-rose-500/20 text-rose-300 border border-rose-500/30'
        };
        return /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
            className: `inline-flex items-center px-2.5 py-1 text-[11px] font-black tracking-widest uppercase rounded-sm ${variants[side] || 'bg-white/10 text-white/70 border border-white/20'}`,
            children: side
        });
    };
    const getStatusBadge = (status)=>{
        const variants = {
            Submitted: 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/30',
            PreSubmitted: 'bg-white/10 text-white/50 border border-white/10',
            Cancelled: 'bg-rose-500/20 text-rose-300 border border-rose-500/30',
            Filled: 'bg-emerald-500/30 text-emerald-50 border border-emerald-500/50'
        };
        return /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
            className: `inline-flex items-center px-3 py-1 text-[10px] font-black tracking-[0.15em] uppercase rounded-xs shadow-xs ${variants[status] || 'bg-white/5 text-white/40 border border-white/10'}`,
            children: status
        });
    };
    const getOrderTypeBadge = (orderType)=>{
        return /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
            className: "inline-flex items-center px-1.5 py-0.5 text-[10px] font-black bg-white/10 border border-white/20 text-white/90 uppercase tracking-tighter",
            children: orderType
        });
    };
    const getDisplayPrice = (order)=>{
        const type = (order.order_type || '').toUpperCase();
        const currency = order.currency || 'USD';
        if (type === 'MKT') return /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
            className: "text-white/30 font-black tracking-tighter uppercase italic text-[13px]",
            children: "Market"
        });
        if (type === 'MIDPRICE') return /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
            className: "text-cyan-300 font-black tracking-tighter uppercase italic text-[13px]",
            children: "Midpoint"
        });
        if (type === 'STP') return /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
            className: "text-rose-400 font-mono text-[14px] font-bold",
            children: (0, $iCbFX.formatCurrency)(order.stop_price, currency)
        });
        if (type === 'LMT') return /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
            className: "text-emerald-400 font-mono text-[14px] font-bold",
            children: (0, $iCbFX.formatCurrency)(order.limit_price, currency)
        });
        if (type === 'TRAIL') return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
            className: "flex flex-col leading-none font-mono",
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                    className: "text-rose-400 text-[14px] font-bold",
                    children: order.trailing_stop_price ? (0, $iCbFX.formatCurrency)(order.trailing_stop_price, currency) : 'Pending'
                }),
                /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                    className: "text-[10px] text-amber-400 font-black tracking-tighter italic",
                    children: [
                        "Trail: ",
                        order.trailing_percent ? `${order.trailing_percent}%` : (0, $iCbFX.formatCurrency)(order.stop_price, currency)
                    ]
                })
            ]
        });
        if (type === 'STPLMT') return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
            className: "flex flex-col leading-none font-mono",
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                    className: "text-emerald-400 text-[14px] font-bold",
                    children: (0, $iCbFX.formatCurrency)(order.limit_price, currency)
                }),
                /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                    className: "text-[10px] text-rose-400 font-black tracking-tighter italic",
                    children: [
                        "STP: ",
                        (0, $iCbFX.formatCurrency)(order.stop_price, currency)
                    ]
                })
            ]
        });
        return /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
            className: "font-mono text-[14px] font-bold text-white",
            children: (0, $iCbFX.formatCurrency)(order.limit_price || order.stop_price || 0, currency)
        });
    };
    const getDisplaySymbol = (order)=>{
        if ((order.secType || '').toUpperCase() === 'FUT') return order.localSymbol || (order.symbol && order.lastTradeDateOrContractMonth ? `${order.symbol} ${order.lastTradeDateOrContractMonth}` : order.symbol);
        return order.symbol;
    };
    const getOriginBadge = (origin)=>{
        const normalized = (origin || 'UNKNOWN').toUpperCase();
        const variants = {
            LOCAL: 'border border-neon text-neon bg-neon/10 shadow-[0_0_15px_rgba(0,255,153,0.2)]',
            RECOVERED: 'border border-rose-500 text-rose-300 bg-rose-500/20'
        };
        return /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
            className: `inline-flex items-center px-2 py-1 text-[10px] font-black uppercase rounded-xs ${variants[normalized] || 'border border-white/20 text-white/60 bg-white/10'}`,
            children: normalized === 'LOCAL' ? 'SYSTEM' : normalized
        });
    };
    const handleCancelOrder = async (orderId)=>{
        if (!orderId || cancellingId !== null) return;
        setCancellingId(orderId);
        setError(null);
        try {
            const response = await (0, $zs3Np.tradingApi).cancelOrder(orderId);
            if (!response.success) {
                setError(response.error || `Failed to cancel order ${orderId}`);
                setErrorHeader("Order Cancellation Failed");
            } else {
                setOrders((prev)=>prev.map((order)=>order.order_id === orderId ? {
                            ...order,
                            status: 'Cancelled',
                            remaining_quantity: 0
                        } : order));
                window.dispatchEvent(new CustomEvent('trading-data-refresh'));
            }
        } catch (err) {
            setError(err instanceof Error ? err.message : `Failed to cancel order ${orderId}`);
            setErrorHeader("Order Cancellation Failed");
        } finally{
            setCancellingId(null);
        }
    };
    const handleEditOrder = (order)=>{
        if ((order.status || '').toUpperCase() === 'CANCELLED') return;
        onEditOrder?.(order);
        window.setTimeout(()=>{
            document.getElementById('manual-order-entry')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }, 0);
    };
    const orderColumns = [
        {
            id: 'order_id',
            header: 'ID',
            accessor: 'order_id',
            sortable: true,
            render: (order)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        order.parent_id && order.parent_id !== 0 && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "text-neon/60 ml-1",
                            children: "\u2514\u2500\u2500"
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "font-mono text-white/40 text-[11px] font-bold tracking-tight",
                            children: order.order_id
                        })
                    ]
                })
        },
        {
            id: 'symbol',
            header: 'Symbol',
            accessor: (o)=>o.symbol || '',
            sortable: true,
            render: (order)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "font-semibold text-[12px] tracking-tight text-white",
                            children: getDisplaySymbol(order)
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "text-[10px] text-white/30 font-black uppercase tracking-widest",
                            children: order.secType || 'STK'
                        })
                    ]
                })
        },
        {
            id: 'origin',
            header: 'Origin',
            accessor: (o)=>`${o.origin || ''} ${o.strategy || ''}`,
            sortable: true,
            render: (order)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex flex-col gap-1.5",
                    children: [
                        getOriginBadge(order.origin),
                        order.strategy && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "text-[10px] font-black text-white/30 uppercase tracking-[0.2em]",
                            children: order.strategy
                        })
                    ]
                })
        },
        {
            id: 'side',
            header: 'Side',
            accessor: 'side',
            sortable: true,
            render: (order)=>getSideBadge(order.side)
        },
        {
            id: 'order_type',
            header: 'Type',
            accessor: 'order_type',
            sortable: true,
            render: (order)=>getOrderTypeBadge(order.order_type)
        },
        {
            id: 'quantity',
            header: 'Size',
            accessor: 'quantity',
            sortable: true,
            render: (order)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex flex-col font-mono leading-tight",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "font-black text-white text-[14px]",
                            children: order.quantity?.toLocaleString()
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "flex gap-2 text-[10px] font-bold mt-0.5",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                    className: "text-emerald-400",
                                    children: [
                                        "F: ",
                                        order.filled_quantity?.toLocaleString() ?? 0
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                    className: "text-white/20",
                                    children: [
                                        "R: ",
                                        order.remaining_quantity?.toLocaleString() ?? order.quantity?.toLocaleString()
                                    ]
                                })
                            ]
                        })
                    ]
                })
        },
        {
            id: 'price',
            header: 'Price',
            accessor: (o)=>o.limit_price || o.stop_price || 0,
            sortable: true,
            render: (order)=>/*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "font-mono font-black",
                    children: getDisplayPrice(order)
                })
        },
        {
            id: 'status',
            header: 'Status',
            accessor: 'status',
            sortable: true,
            render: (order)=>getStatusBadge(order.status || 'Unknown')
        },
        {
            id: 'timestamp',
            header: 'Time',
            accessor: 'timestamp',
            sortable: true,
            align: 'right',
            render: (order)=>/*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                    className: "text-white/60 font-mono font-bold text-[12px]",
                    children: (0, $lRLyZ.formatTimeET)(order.timestamp)
                })
        },
        {
            id: 'actions',
            header: 'Actions',
            accessor: 'order_id',
            align: 'right',
            render: (order)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex items-center justify-end gap-2",
                    children: [
                        onEditOrder && /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                            className: "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[10px] font-bold uppercase tracking-wider border border-neon/30 text-neon bg-neon/10 hover:bg-neon/20 active:scale-95 transition-all disabled:opacity-30",
                            disabled: refreshing || cancellingId !== null || (order.status || '').toUpperCase() === 'CANCELLED',
                            onClick: (e)=>{
                                e.stopPropagation();
                                handleEditOrder(order);
                            },
                            title: "Edit this order in Manual Order",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $29b1874158a6f84e$export$2e2bcd8739ae039), {
                                    className: "w-3 h-3"
                                }),
                                "Edit"
                            ]
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                            className: "px-3 py-1.5 rounded-lg text-[10px] font-bold uppercase tracking-wider border border-rose-500/30 text-rose-200 bg-rose-500/10 hover:bg-rose-500/20 active:scale-95 transition-all disabled:opacity-30",
                            disabled: refreshing || cancellingId === order.order_id || (order.status || '').toUpperCase() === 'CANCELLED',
                            onClick: (e)=>{
                                e.stopPropagation();
                                handleCancelOrder(order.order_id);
                            },
                            children: cancellingId === order.order_id ? 'Wait' : 'Cancel'
                        })
                    ]
                })
        }
    ];
    const displayOrders = (0, $jHEir.useMemo)(()=>{
        const filteredOrders = securityTypeFilter === 'ALL' ? orders : orders.filter((order)=>(order.secType || 'STK').toUpperCase() === securityTypeFilter);
        const symbolFilteredOrders = filteredOrders.filter((order)=>(0, $fce324f2f44a438f$export$233c8e1804dc7af2)(order, symbolFilter));
        const topLevel = symbolFilteredOrders.filter((o)=>!o.parent_id || o.parent_id === 0);
        const children = symbolFilteredOrders.filter((o)=>o.parent_id && o.parent_id !== 0);
        const result = [];
        topLevel.forEach((parent)=>{
            result.push(parent);
            const myChildren = children.filter((c)=>c.parent_id === parent.order_id);
            result.push(...myChildren);
        });
        const orphans = children.filter((c)=>!topLevel.find((p)=>p.order_id === c.parent_id));
        result.push(...orphans);
        return result;
    }, [
        orders,
        securityTypeFilter,
        symbolFilter
    ]);
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "flex items-center justify-between px-2",
                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "flex flex-col",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                    className: "text-sm font-bold text-neon tracking-tight uppercase mb-0.5",
                                    children: "Open Orders"
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                    className: "flex items-center gap-2 text-[10px] text-muted font-bold opacity-30 uppercase tracking-[0.2em]",
                                    children: [
                                        refreshing ? /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            className: "animate-pulse text-neon",
                                            children: "Refreshing..."
                                        }) : /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            children: snapshotStatus.connectionStatus === 'initializing' ? 'Synchronizing' : snapshotStatus.stale ? 'Offline Snapshot' : 'Live Data Feed'
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            children: "\u2022"
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            children: lastUpdated ?? "\u2014"
                                        })
                                    ]
                                })
                            ]
                        }),
                        onEditOrder && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "text-[10px] font-bold uppercase tracking-wider text-white/35",
                            children: "Click Edit or an order row to load it into Manual Order"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $fce324f2f44a438f$export$2e2bcd8739ae039), {
                        orders: orders,
                        value: symbolFilter,
                        onChange: setSymbolFilter
                    }),
                    snapshotStatus.stale && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "mb-4 rounded-xl border border-warning-500/25 bg-warning-500/10 px-4 py-3 text-xs text-warning-300",
                        children: snapshotStatus.connectionStatus === 'initializing' ? 'IB is connected and open orders are synchronizing. This panel will refresh automatically.' : snapshotStatus.available ? "Gateway offline \u2014 showing the last persisted open-order snapshot." : "Gateway offline \u2014 no persisted open-order snapshot is available yet."
                    }),
                    error && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "mb-4",
                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4cvdp.default), {
                            error: error,
                            onRetry: ()=>fetchOrders(),
                            message: errorHeader
                        })
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $fvREG.DataTable), {
                        data: displayOrders,
                        columns: orderColumns,
                        compact: true,
                        loading: loading,
                        onRowClick: handleEditOrder,
                        emptyMessage: snapshotStatus.stale && !snapshotStatus.available ? snapshotStatus.connectionStatus === 'initializing' ? "Synchronizing open orders\u2026" : "No persisted open-order snapshot available" : "No open orders in the queue.",
                        rowClassName: (order)=>order.parent_id && order.parent_id !== 0 ? 'bg-white/1.5' : ''
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex justify-end items-center gap-3 mt-6",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                className: "px-6 py-2 rounded-xl border border-white/5 bg-white/5 text-[10px] font-bold text-muted hover:text-foreground hover:bg-white/10 disabled:opacity-30 transition-all uppercase tracking-widest active:scale-95 shadow-lg",
                                disabled: page <= 1 || refreshing,
                                onClick: ()=>{
                                    const nextPage = Math.max(1, page - 1);
                                    setPage(nextPage);
                                    fetchOrders(false, nextPage);
                                },
                                children: "Previous"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "px-4 py-2 bg-black/40 rounded-xl border border-white/10 text-[10px] font-black text-neon shadow-[0_0_15px_rgba(0,255,153,0.1)]",
                                children: page.toString().padStart(2, '0')
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                className: "px-6 py-2 rounded-xl border border-white/5 bg-white/5 text-[10px] font-bold text-muted hover:text-foreground hover:bg-white/10 disabled:opacity-30 transition-all uppercase tracking-widest active:scale-95 shadow-lg",
                                disabled: orders.length < pageSize || refreshing,
                                onClick: ()=>{
                                    const nextPage = page + 1;
                                    setPage(nextPage);
                                    fetchOrders(false, nextPage);
                                },
                                children: "Next"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $6cb2621c04b4f142$export$2e2bcd8739ae039 = $6cb2621c04b4f142$var$OpenOrders;



var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $zs3Np = parcelRequire("zs3Np");

var $4cvdp = parcelRequire("4cvdp");

var $lRLyZ = parcelRequire("lRLyZ");

var $iCbFX = parcelRequire("iCbFX");

var $fvREG = parcelRequire("fvREG");

const $3f5d8c5cc66508fa$var$FilledOrders = ({ refreshInterval: refreshInterval = 30000, securityTypeFilter: securityTypeFilter = 'ALL' })=>{
    const [orders, setOrders] = (0, $jHEir.useState)([]);
    const [page, setPage] = (0, $jHEir.useState)(1);
    const pageSize = 10;
    const [loading, setLoading] = (0, $jHEir.useState)(true);
    const [refreshing, setRefreshing] = (0, $jHEir.useState)(false);
    const [error, setError] = (0, $jHEir.useState)(null);
    const [lastUpdated, setLastUpdated] = (0, $jHEir.useState)(null);
    const [symbolFilter, setSymbolFilter] = (0, $jHEir.useState)('');
    const [snapshotStatus, setSnapshotStatus] = (0, $jHEir.useState)({
        stale: false,
        available: true,
        connectionStatus: 'connected'
    });
    const hasFetchedOrdersRef = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useRef(false);
    const currentPageRef = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useRef(page);
    currentPageRef.current = page;
    const fetchOrders = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useCallback(async (isInitialLoad = false, pageOverride)=>{
        const hasData = hasFetchedOrdersRef.current;
        if (isInitialLoad || !hasData) setLoading(true);
        else setRefreshing(true);
        setError(null);
        try {
            if (isInitialLoad) await new Promise((resolve)=>setTimeout(resolve, 500));
            const response = await (0, $zs3Np.tradingApi).getFilledOrdersToday(pageOverride ?? currentPageRef.current, pageSize, securityTypeFilter);
            if (response.success && response.data) {
                setOrders(response.data?.orders || []);
                setSnapshotStatus({
                    stale: !!response.data.stale,
                    available: response.data.snapshot_available !== false,
                    connectionStatus: response.data.connection_status || 'connected'
                });
            } else setOrders([]);
            const ts = response.timestamp || new Date().toISOString();
            setLastUpdated((0, $lRLyZ.formatTimeET)(ts));
            hasFetchedOrdersRef.current = true;
        } catch (err) {
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            setError(err instanceof Error ? err.message : 'Failed to fetch filled orders');
            setOrders([]);
        } finally{
            setLoading(false);
            setRefreshing(false);
        }
    }, [
        pageSize,
        securityTypeFilter
    ]);
    (0, $jHEir.useEffect)(()=>{
        const handleRefresh = ()=>fetchOrders(false, page);
        window.addEventListener('trading-data-refresh', handleRefresh);
        return ()=>window.removeEventListener('trading-data-refresh', handleRefresh);
    }, [
        fetchOrders,
        page
    ]);
    (0, $jHEir.useEffect)(()=>{
        fetchOrders(true, 1);
    }, [
        fetchOrders
    ]);
    (0, $jHEir.useEffect)(()=>{
        const refreshWhenVisible = ()=>{
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            fetchOrders(false, page);
        };
        const intervalId = setInterval(refreshWhenVisible, refreshInterval);
        document.addEventListener('visibilitychange', refreshWhenVisible);
        window.addEventListener('focus', refreshWhenVisible);
        return ()=>{
            clearInterval(intervalId);
            document.removeEventListener('visibilitychange', refreshWhenVisible);
            window.removeEventListener('focus', refreshWhenVisible);
        };
    }, [
        fetchOrders,
        page,
        refreshInterval
    ]);
    (0, $jHEir.useEffect)(()=>{
        if (snapshotStatus.connectionStatus !== 'initializing') return;
        const retryId = window.setTimeout(()=>fetchOrders(false, page), 2000);
        return ()=>window.clearTimeout(retryId);
    }, [
        fetchOrders,
        page,
        snapshotStatus.connectionStatus
    ]);
    const getSideBadge = (side)=>{
        const variants = {
            BUY: 'bg-emerald-500/20 text-emerald-300 border border-emerald-500/30',
            SELL: 'bg-rose-500/20 text-rose-300 border border-rose-500/30'
        };
        return /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
            className: `inline-flex items-center px-2 py-1 text-[11px] font-black tracking-widest uppercase rounded-sm ${variants[side] || 'bg-white/10 text-white/70 border border-white/20'}`,
            children: side
        });
    };
    const getStatusBadge = (status)=>{
        const variants = {
            FILLED: 'bg-emerald-500/20 text-emerald-300 border border-emerald-500/30 shadow-[0_0_15px_rgba(16,185,129,0.2)]',
            PARTIALLYFILLED: 'bg-emerald-500/10 text-emerald-400 border border-emerald-500/20'
        };
        return /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
            className: `inline-flex items-center px-3 py-1 text-[10px] font-black tracking-widest uppercase rounded-xs shadow-xs ${variants[status.toUpperCase()] || 'bg-white/10 text-white/50 border border-white/10'}`,
            children: status
        });
    };
    const getDisplaySymbol = (order)=>{
        if ((order.secType || '').toUpperCase() === 'FUT') return order.localSymbol || (order.symbol && order.lastTradeDateOrContractMonth ? `${order.symbol} ${order.lastTradeDateOrContractMonth}` : order.symbol);
        return order.symbol;
    };
    const orderColumns = [
        {
            id: 'order_id',
            header: 'ID',
            accessor: 'order_id',
            sortable: true,
            render: (order)=>/*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                    className: "font-mono text-white/40 text-[11px] font-bold",
                    children: order.order_id
                })
        },
        {
            id: 'symbol',
            header: 'Symbol',
            accessor: 'symbol',
            sortable: true,
            render: (order)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "font-semibold text-[12px] tracking-tight text-white",
                            children: getDisplaySymbol(order)
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "text-[10px] text-white/30 font-black uppercase tracking-widest",
                            children: order.intent || order.secType || 'STK'
                        })
                    ]
                })
        },
        {
            id: 'side',
            header: 'Side',
            accessor: 'side',
            sortable: true,
            render: (order)=>getSideBadge(order.side)
        },
        {
            id: 'filled_quantity',
            header: 'Filled Size',
            accessor: 'filled_quantity',
            sortable: true,
            render: (order)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex items-center gap-2 font-mono",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "font-black text-white text-[14px]",
                            children: order.filled_quantity?.toLocaleString()
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "text-white/20",
                            children: "/"
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "text-white/50 text-[11px] font-bold",
                            children: order.quantity?.toLocaleString()
                        })
                    ]
                })
        },
        {
            id: 'fill_price',
            header: 'Fill Price',
            accessor: (o)=>o.fill_price || o.limit_price || 0,
            sortable: true,
            render: (order)=>/*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                    className: "font-mono font-black text-white text-[14px]",
                    children: (0, $iCbFX.formatCurrency)(order.fill_price ?? order.limit_price ?? 0, order.currency ?? undefined)
                })
        },
        {
            id: 'status',
            header: 'Status',
            accessor: 'status',
            sortable: true,
            render: (order)=>getStatusBadge(order.status || '')
        },
        {
            id: 'timestamp',
            header: 'Timestamp',
            accessor: 'timestamp',
            sortable: true,
            align: 'right',
            render: (order)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex flex-col items-end leading-none",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "text-white/80 font-mono font-black text-[12px]",
                            children: (0, $lRLyZ.formatTimeET)(order.timestamp)
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "text-[9px] text-white/30 font-bold uppercase mt-1 tracking-tighter",
                            children: (0, $lRLyZ.formatDateTimeET)(order.timestamp).split(' ')[0]
                        })
                    ]
                })
        }
    ];
    const displayOrders = (0, $jHEir.useMemo)(()=>{
        const securityFiltered = securityTypeFilter === 'ALL' ? orders : orders.filter((order)=>(order.secType || 'STK').toUpperCase() === securityTypeFilter);
        return securityFiltered.filter((order)=>(0, $fce324f2f44a438f$export$233c8e1804dc7af2)(order, symbolFilter));
    }, [
        orders,
        securityTypeFilter,
        symbolFilter
    ]);
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "flex items-center justify-between px-2",
                children: /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "flex items-center gap-4",
                    children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                className: "text-sm font-bold text-neon tracking-tight uppercase mb-0.5",
                                children: "Filled Orders Today"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-center gap-2 text-[10px] text-muted font-bold opacity-30 uppercase tracking-[0.2em]",
                                children: [
                                    refreshing ? /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: "animate-pulse text-neon",
                                        children: "Refreshing..."
                                    }) : /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        children: snapshotStatus.connectionStatus === 'initializing' ? 'Synchronizing' : snapshotStatus.stale ? 'Offline Snapshot' : 'Execution History'
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        children: "\u2022"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        children: lastUpdated ?? "\u2014"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $fce324f2f44a438f$export$2e2bcd8739ae039), {
                        orders: orders,
                        value: symbolFilter,
                        onChange: setSymbolFilter
                    }),
                    snapshotStatus.stale && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "mb-4 rounded-xl border border-warning-500/25 bg-warning-500/10 px-4 py-3 text-xs text-warning-300",
                        children: snapshotStatus.connectionStatus === 'initializing' ? 'IB is connected and executions are synchronizing. This panel will refresh automatically.' : snapshotStatus.available ? "Gateway offline \u2014 showing the last persisted filled-order snapshot." : "Gateway offline \u2014 no persisted filled-order snapshot is available yet."
                    }),
                    error && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "mb-4",
                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4cvdp.default), {
                            error: error,
                            onRetry: ()=>fetchOrders(),
                            message: "Failed to load filled orders"
                        })
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $fvREG.DataTable), {
                        data: displayOrders,
                        columns: orderColumns,
                        compact: true,
                        loading: loading,
                        emptyMessage: snapshotStatus.stale && !snapshotStatus.available ? snapshotStatus.connectionStatus === 'initializing' ? "Synchronizing executions\u2026" : "No persisted filled-order snapshot available" : "No executions recorded today."
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex justify-end items-center gap-3 mt-6",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                className: "px-6 py-2 rounded-xl border border-white/5 bg-white/5 text-[10px] font-bold text-muted hover:text-foreground hover:bg-white/10 disabled:opacity-30 transition-all uppercase tracking-widest active:scale-95 shadow-lg",
                                disabled: page <= 1 || refreshing,
                                onClick: ()=>{
                                    const nextPage = Math.max(1, page - 1);
                                    setPage(nextPage);
                                    fetchOrders(false, nextPage);
                                },
                                children: "Previous"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "px-4 py-2 bg-black/40 rounded-xl border border-white/10 text-[10px] font-black text-neon shadow-[0_0_15px_rgba(0,255,153,0.1)]",
                                children: page.toString().padStart(2, '0')
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                className: "px-6 py-2 rounded-xl border border-white/5 bg-white/5 text-[10px] font-bold text-muted hover:text-foreground hover:bg-white/10 disabled:opacity-30 transition-all uppercase tracking-widest active:scale-95 shadow-lg",
                                disabled: orders.length < pageSize || refreshing,
                                onClick: ()=>{
                                    const nextPage = page + 1;
                                    setPage(nextPage);
                                    fetchOrders(false, nextPage);
                                },
                                children: "Next"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $3f5d8c5cc66508fa$export$2e2bcd8739ae039 = $3f5d8c5cc66508fa$var$FilledOrders;



var $lRLyZ = parcelRequire("lRLyZ");

var $hpygi = parcelRequire("hpygi");


var $g9vEp = parcelRequire("g9vEp");

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $j8jJ4 = parcelRequire("j8jJ4");/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $60b0d80c1669ca38$export$a2387ed3b5d536eb = {
    name: "maximize-2",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M15 3h6v6",
                key: "1q9fwt"
            }
        ],
        [
            "path",
            {
                d: "m21 3-7 7",
                key: "1l2asr"
            }
        ],
        [
            "path",
            {
                d: "m3 21 7-7",
                key: "tjx5ai"
            }
        ],
        [
            "path",
            {
                d: "M9 21H3v-6",
                key: "wtvkvv"
            }
        ]
    ]
};
$60b0d80c1669ca38$export$a2387ed3b5d536eb.node;
const $60b0d80c1669ca38$export$2e2bcd8739ae039 = (0, $hHhnY.default)($60b0d80c1669ca38$export$a2387ed3b5d536eb);


var $jQze5 = parcelRequire("jQze5");
var $bgvjD = parcelRequire("bgvjD");

var $zs3Np = parcelRequire("zs3Np");

var $5xHjn = parcelRequire("5xHjn");

var $hQpqX = parcelRequire("hQpqX");

var $kv9Z9 = parcelRequire("kv9Z9");

var $8YuD2 = parcelRequire("8YuD2");

var $ltr73 = parcelRequire("ltr73");

var $g9vEp = parcelRequire("g9vEp");

var $dgdqP = parcelRequire("dgdqP");
const $55948ac21f10399f$var$timeframeOptions = [
    {
        value: '1min',
        label: '1 minute'
    },
    {
        value: '5min',
        label: '5 minutes'
    },
    {
        value: '15min',
        label: '15 minutes'
    },
    {
        value: '30min',
        label: '30 minutes'
    },
    {
        value: '1h',
        label: '1 hour'
    },
    {
        value: '1d',
        label: '1 day'
    }
];
const $55948ac21f10399f$var$durationOptions = [
    {
        value: '1 D',
        label: '1 day'
    },
    {
        value: '5 D',
        label: '5 days'
    },
    {
        value: '2 W',
        label: '2 weeks'
    },
    {
        value: '1 M',
        label: '1 month'
    },
    {
        value: '3 M',
        label: '3 months'
    },
    {
        value: '6 M',
        label: '6 months'
    },
    {
        value: '1 Y',
        label: '1 year'
    }
];
const $55948ac21f10399f$var$movingAverageOptions = [
    {
        value: 'off',
        label: 'Off'
    },
    {
        value: 'sma',
        label: 'SMA'
    },
    {
        value: 'ema',
        label: 'EMA'
    }
];
const $55948ac21f10399f$var$movingAverageColors = [
    (0, $dgdqP.themeColors).neon,
    (0, $dgdqP.themeColors).warningBright,
    (0, $dgdqP.themeColors).info
];
const $55948ac21f10399f$var$chartBars = (bars)=>bars.filter((0, $5xHjn.isValidHistoricalBar)).map((bar)=>({
            time: bar.time,
            open: bar.open,
            high: bar.high,
            low: bar.low,
            close: bar.close,
            volume: bar.volume ?? 0
        })).sort((a, b)=>a.time - b.time);
const $55948ac21f10399f$var$toIsoDate = (time)=>new Date(time * 1000).toISOString();
const $55948ac21f10399f$var$averageData = (bars, period, kind)=>{
    if (bars.length < period) return [];
    if (kind === 'sma') {
        const result = [];
        let sum = 0;
        bars.forEach((bar, index)=>{
            sum += bar.close;
            if (index >= period) sum -= bars[index - period].close;
            if (index >= period - 1) result.push({
                date: $55948ac21f10399f$var$toIsoDate(bar.time),
                value: sum / period
            });
        });
        return result;
    }
    const multiplier = 2 / (period + 1);
    const result = [];
    let previous = bars.slice(0, period).reduce((sum, bar)=>sum + bar.close, 0) / period;
    result.push({
        date: $55948ac21f10399f$var$toIsoDate(bars[period - 1].time),
        value: previous
    });
    bars.slice(period).forEach((bar)=>{
        previous = (bar.close - previous) * multiplier + previous;
        result.push({
            date: $55948ac21f10399f$var$toIsoDate(bar.time),
            value: previous
        });
    });
    return result;
};
const $55948ac21f10399f$var$defaultVisibleBars = (timeframe)=>{
    if (timeframe === '1d') return 180;
    if (timeframe === '1min') return 240;
    return 220;
};
const $55948ac21f10399f$var$displaySymbol = (position)=>position.display_symbol || position.local_symbol || position.symbol;
const $55948ac21f10399f$var$getHistorySymbol = (position)=>position.secType === 'FUT' ? position.local_symbol || position.display_symbol || position.symbol : position.symbol;
const $55948ac21f10399f$var$PositionChartModal = ({ position: position, onClose: onClose, inline: inline = false, onOpenModal: onOpenModal })=>{
    const [timeframe, setTimeframe] = (0, $jHEir.useState)('15min');
    const [duration, setDuration] = (0, $jHEir.useState)('1 M');
    const [chartStyle, setChartStyle] = (0, $jHEir.useState)('candles');
    const [ma20, setMa20] = (0, $jHEir.useState)('off');
    const [ma50, setMa50] = (0, $jHEir.useState)('off');
    const [ma200, setMa200] = (0, $jHEir.useState)('off');
    const [historySymbol, setHistorySymbol] = (0, $jHEir.useState)(()=>$55948ac21f10399f$var$getHistorySymbol(position));
    const [symbolInput, setSymbolInput] = (0, $jHEir.useState)(()=>$55948ac21f10399f$var$getHistorySymbol(position));
    const [bars, setBars] = (0, $jHEir.useState)([]);
    const [loading, setLoading] = (0, $jHEir.useState)(true);
    const [error, setError] = (0, $jHEir.useState)(null);
    const positionIdentity = position.position_key || position.contract_key || `${position.secType || 'STK'}:${position.symbol}:${position.local_symbol || ''}`;
    const nextHistorySymbol = $55948ac21f10399f$var$getHistorySymbol(position);
    (0, $jHEir.useEffect)(()=>{
        setHistorySymbol(nextHistorySymbol);
        setSymbolInput(nextHistorySymbol);
    }, [
        nextHistorySymbol,
        positionIdentity
    ]);
    (0, $jHEir.useEffect)(()=>{
        if (inline) return undefined;
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        const handleEscape = (event)=>{
            if (event.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleEscape);
        return ()=>{
            document.body.style.overflow = previousOverflow;
            document.removeEventListener('keydown', handleEscape);
        };
    }, [
        inline,
        onClose
    ]);
    (0, $jHEir.useEffect)(()=>{
        const controller = new AbortController();
        const loadHistory = async ()=>{
            setLoading(true);
            setError(null);
            try {
                const response = await (0, $zs3Np.tradingApi).getHistoricalData(historySymbol, timeframe, duration, 'ibkr', controller.signal);
                if (!response.success || !Array.isArray(response.data)) throw new Error(response.error || 'No historical data returned');
                if (!controller.signal.aborted) setBars($55948ac21f10399f$var$chartBars(response.data));
            } catch (err) {
                if (!controller.signal.aborted) {
                    setBars([]);
                    setError(err instanceof Error ? err.message : 'Failed to load chart');
                }
            } finally{
                if (!controller.signal.aborted) setLoading(false);
            }
        };
        loadHistory();
        return ()=>controller.abort();
    }, [
        historySymbol,
        timeframe,
        duration
    ]);
    const chartData = (0, $jHEir.useMemo)(()=>bars.map((bar)=>({
                date: $55948ac21f10399f$var$toIsoDate(bar.time),
                open: bar.open,
                high: bar.high,
                low: bar.low,
                close: bar.close,
                volume: bar.volume
            })), [
        bars
    ]);
    const lineOverlays = (0, $jHEir.useMemo)(()=>{
        const configs = [
            {
                period: 20,
                kind: ma20,
                color: $55948ac21f10399f$var$movingAverageColors[0]
            },
            {
                period: 50,
                kind: ma50,
                color: $55948ac21f10399f$var$movingAverageColors[1]
            },
            {
                period: 200,
                kind: ma200,
                color: $55948ac21f10399f$var$movingAverageColors[2]
            }
        ];
        return configs.flatMap((config)=>{
            if (config.kind === 'off') return [];
            const data = $55948ac21f10399f$var$averageData(bars, config.period, config.kind);
            return data.length ? [
                {
                    title: `${config.kind.toUpperCase()} ${config.period}`,
                    color: config.color,
                    lineWidth: 2,
                    data: data
                }
            ] : [];
        });
    }, [
        bars,
        ma20,
        ma50,
        ma200
    ]);
    const volumeData = (0, $jHEir.useMemo)(()=>bars.map((bar)=>({
                date: $55948ac21f10399f$var$toIsoDate(bar.time),
                value: bar.volume,
                color: bar.close >= bar.open ? (0, $dgdqP.themeColors).success : (0, $dgdqP.themeColors).danger
            })), [
        bars
    ]);
    const loadChartSymbol = ()=>{
        const nextSymbol = symbolInput.trim().toUpperCase();
        if (!nextSymbol || nextSymbol === historySymbol) return;
        setHistorySymbol(nextSymbol);
    };
    const handleSymbolInputKeyDown = (event)=>{
        if (event.key === 'Enter') {
            event.preventDefault();
            loadChartSymbol();
        }
    };
    const maSelect = (period, value, onChange)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
            className: "flex shrink-0 items-center gap-1",
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                    className: "text-[9px] font-bold uppercase tracking-wide text-muted",
                    children: [
                        "MA",
                        period
                    ]
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8YuD2.ChartToolbarSelect), {
                    value: value,
                    options: $55948ac21f10399f$var$movingAverageOptions,
                    onChange: onChange,
                    ariaLabel: `Moving average ${period}`,
                    title: `Moving average ${period}`,
                    widthClassName: "w-[58px]"
                })
            ]
        });
    const chartToolbar = /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8YuD2.ChartToolbar), {
        leading: /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex shrink-0 items-center gap-1.5",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("h2", {
                            className: "text-xs font-bold tracking-tight text-white",
                            children: $55948ac21f10399f$var$displaySymbol(position)
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "rounded-sm border border-neon/20 bg-neon/10 px-1 py-0.5 text-[8px] font-bold uppercase tracking-wider text-neon",
                            children: position.secType || 'STK'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex h-7 w-[128px] shrink-0 overflow-hidden rounded-md border border-white/10 bg-black/20 focus-within:border-neon/50",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                            value: symbolInput,
                            onChange: (event)=>setSymbolInput(event.target.value.toUpperCase()),
                            onKeyDown: handleSymbolInputKeyDown,
                            "aria-label": "Chart symbol",
                            className: "min-w-0 flex-1 bg-transparent px-2 text-[10px] font-bold text-white outline-hidden placeholder:text-white/25",
                            placeholder: "Underlying stock"
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                            className: "flex items-center border-l border-white/10",
                            children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $hQpqX.default), {
                                size: "compact",
                                iconOnly: true,
                                onClick: loadChartSymbol,
                                icon: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jQze5.default), {
                                    className: "h-3.5 w-3.5"
                                }),
                                label: "Load chart symbol"
                            })
                        })
                    ]
                })
            ]
        }),
        chartStyle: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8YuD2.ChartStyleToggle), {
            value: chartStyle,
            onChange: setChartStyle
        }),
        settings: /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8YuD2.ChartToolbarSelect), {
                    value: duration,
                    options: $55948ac21f10399f$var$durationOptions,
                    onChange: (value)=>setDuration(value),
                    ariaLabel: "Chart lookback",
                    title: "Lookback",
                    widthClassName: "w-[86px]"
                }),
                maSelect(20, ma20, (value)=>setMa20(value)),
                maSelect(50, ma50, (value)=>setMa50(value)),
                maSelect(200, ma200, (value)=>setMa200(value))
            ]
        }),
        trailing: /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8YuD2.ChartToolbarSelect), {
                    value: timeframe,
                    options: $55948ac21f10399f$var$timeframeOptions,
                    onChange: (value)=>setTimeframe(value),
                    ariaLabel: "Chart bar interval",
                    title: "Bar interval",
                    widthClassName: "w-[102px]"
                }),
                inline && onOpenModal && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $hQpqX.default), {
                    size: "compact",
                    iconOnly: true,
                    onClick: onOpenModal,
                    icon: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $60b0d80c1669ca38$export$2e2bcd8739ae039), {
                        className: "h-3.5 w-3.5"
                    }),
                    label: "Open position chart in modal",
                    title: "Open full chart"
                }),
                !inline && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $hQpqX.default), {
                    size: "compact",
                    iconOnly: true,
                    onClick: onClose,
                    icon: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                        className: "h-3.5 w-3.5"
                    }),
                    label: "Close position chart"
                })
            ]
        })
    });
    const chartPlot = /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: `relative min-h-0 flex-1 ${inline ? 'h-[320px] min-h-[280px]' : 'min-h-[320px]'} p-1`,
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $ltr73.LightweightChart), {
                data: chartData,
                volumeData: volumeData,
                lineOverlays: lineOverlays,
                type: "symbol",
                symbolStyle: chartStyle,
                lineColor: (0, $dgdqP.themeColors).neon,
                resolution: timeframe === '1d' ? '1D' : 'native',
                timeVisible: timeframe !== '1d',
                initialVisibleBars: $55948ac21f10399f$var$defaultVisibleBars(timeframe),
                latestVisibleBars: $55948ac21f10399f$var$defaultVisibleBars(timeframe),
                showLatestControl: true,
                hideControls: true
            }, `${positionIdentity}:${historySymbol}:${timeframe}:${duration}`),
            loading && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "absolute inset-0 flex items-center justify-center bg-[#0e0e12]/65",
                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex items-center gap-2 rounded-lg border border-white/10 bg-black/30 px-3 py-2 text-xs text-muted",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                            className: "h-4 w-4 animate-spin text-neon"
                        }),
                        " Loading history\u2026"
                    ]
                })
            }),
            !loading && error && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "absolute inset-0 flex items-center justify-center px-6 text-center text-sm text-rose-300",
                children: error
            }),
            !loading && !error && bars.length === 0 && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "absolute inset-0 flex items-center justify-center text-sm text-muted",
                children: [
                    "No historical bars available for ",
                    historySymbol,
                    "."
                ]
            })
        ]
    });
    if (inline) return /*#__PURE__*/ (0, $eHRxX.jsx)((0, $kv9Z9.default), {
        className: "w-full border-t border-white/10",
        toolbar: chartToolbar,
        children: chartPlot
    });
    return /*#__PURE__*/ (0, $eHRxX.jsx)((0, $g9vEp.default), {
        children: /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
            className: "fixed inset-0 z-1000 flex items-center justify-center bg-black/85 p-4 backdrop-blur-md",
            onClick: (event)=>{
                if (event.target === event.currentTarget) onClose();
            },
            children: /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "h-[min(94vh,900px)] w-full max-w-[1400px] overflow-hidden rounded-2xl border border-white/10 bg-[#0e0e12] shadow-[0_0_60px_rgba(0,0,0,0.55)]",
                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $kv9Z9.default), {
                    className: "h-full",
                    toolbar: chartToolbar,
                    children: chartPlot
                })
            })
        })
    });
};
var $55948ac21f10399f$export$2e2bcd8739ae039 = $55948ac21f10399f$var$PositionChartModal;



class $1483ce4a3bf3bb29$export$6339b3d8d8e13ec3 {
    constructor(api){
        this.api = api;
    }
    listTags() {
        return this.api.getStrategyDescriptionTags();
    }
    saveTag(form) {
        const name = form.name.trim();
        const description = form.description.trim();
        if (form.editingTagId !== null) return this.api.updateStrategyDescriptionTag(form.editingTagId, {
            name: name,
            description: description || null,
            color: form.color
        });
        return this.api.createStrategyDescriptionTag({
            name: name,
            description: description || undefined,
            color: form.color
        });
    }
    deleteTag(tagId) {
        return this.api.deleteStrategyDescriptionTag(tagId);
    }
    savePositionMetadata(positionKey, strategyName, tagIds) {
        return this.api.updatePositionMetadata(positionKey, strategyName.trim() || null, tagIds);
    }
}



var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");

var $bTVJ1 = parcelRequire("bTVJ1");
var $k9hlW = parcelRequire("k9hlW");
var $bgvjD = parcelRequire("bgvjD");

var $g9vEp = parcelRequire("g9vEp");

var $aNXfT = parcelRequire("aNXfT");
const $d81cfede2e2371fc$var$PositionStrategyTagModals = ({ state: state, strategyNameOptions: strategyNameOptions })=>{
    const { strategyTags: strategyTags, managerOpen: managerOpen, setManagerOpen: setManagerOpen, editorPosition: editorPosition, setEditorPosition: setEditorPosition, selectedTagIds: selectedTagIds, setSelectedTagIds: setSelectedTagIds, strategyLabelOverride: strategyLabelOverride, setStrategyLabelOverride: setStrategyLabelOverride, editingTagId: editingTagId, tagName: tagName, setTagName: setTagName, tagDescription: tagDescription, setTagDescription: setTagDescription, tagColor: tagColor, setTagColor: setTagColor, tagBusy: tagBusy, tagError: tagError, openManagerFromEditor: openManagerFromEditor, resetTagForm: resetTagForm, editTag: editTag, saveStrategyTag: saveStrategyTag, removeStrategyTag: removeStrategyTag, savePositionTags: savePositionTags } = state;
    const automaticStrategyLabels = editorPosition ? (0, $aNXfT.getPositionStrategies)(editorPosition).filter((strategy)=>strategy !== 'UNASSIGNED') : [];
    return /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
        children: [
            managerOpen && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $g9vEp.default), {
                children: /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "fixed inset-0 z-1000 flex items-center justify-center bg-black/80 p-4 backdrop-blur-md",
                    onClick: (event)=>{
                        if (event.target === event.currentTarget) setManagerOpen(false);
                    },
                    children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex max-h-[90vh] w-full max-w-xl flex-col overflow-hidden rounded-2xl border border-white/10 bg-[#0e0e12] shadow-[0_0_50px_rgba(0,0,0,0.5)]",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-start justify-between border-b border-white/10 px-6 py-5",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center gap-2 text-neon",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $0ee46722e8758d35$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                                        className: "text-lg font-bold text-white",
                                                        children: "Position labels"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                className: "mt-1 text-xs leading-relaxed text-muted",
                                                children: "Create reusable notes such as \u201Cearnings hedge\u201D or \u201Creview later\u201D."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setManagerOpen(false),
                                        className: "rounded-lg p-2 text-white/45 transition-colors hover:bg-white/5 hover:text-white",
                                        "aria-label": "Close label manager",
                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                                            className: "h-4 w-4"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "space-y-5 overflow-y-auto p-6",
                                children: [
                                    tagError && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: "rounded-lg border border-rose-500/25 bg-rose-500/10 px-3 py-2 text-xs text-rose-200",
                                        children: tagError
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("form", {
                                        onSubmit: saveStrategyTag,
                                        className: "space-y-3 rounded-xl border border-white/10 bg-white/3 p-4",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h4", {
                                                        className: "text-xs font-bold uppercase tracking-wider text-white/75",
                                                        children: editingTagId ? 'Edit label' : 'New label'
                                                    }),
                                                    editingTagId && /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                                        type: "button",
                                                        onClick: resetTagForm,
                                                        className: "text-[10px] font-bold uppercase tracking-wider text-white/45 hover:text-white",
                                                        children: "Cancel edit"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "grid gap-3 sm:grid-cols-[1fr_auto]",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("label", {
                                                        className: "space-y-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                className: "text-[10px] font-bold uppercase tracking-wider text-muted",
                                                                children: "Name"
                                                            }),
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                                                value: tagName,
                                                                onChange: (event)=>setTagName(event.target.value),
                                                                maxLength: 80,
                                                                placeholder: "e.g. Earnings hedge",
                                                                className: "w-full rounded-lg border border-white/10 bg-black/20 px-3 py-2 text-sm text-white outline-hidden transition-colors placeholder:text-white/25 focus:border-neon/50",
                                                                required: true
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("label", {
                                                        className: "space-y-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                className: "text-[10px] font-bold uppercase tracking-wider text-muted",
                                                                children: "Color"
                                                            }),
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                                                type: "color",
                                                                value: tagColor,
                                                                onChange: (event)=>setTagColor(event.target.value.toUpperCase()),
                                                                className: "block h-[38px] w-full cursor-pointer rounded-lg border border-white/10 bg-black/20 p-1",
                                                                "aria-label": "Label color"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("label", {
                                                className: "block space-y-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "text-[10px] font-bold uppercase tracking-wider text-muted",
                                                        children: "Description (optional)"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("textarea", {
                                                        value: tagDescription,
                                                        onChange: (event)=>setTagDescription(event.target.value),
                                                        maxLength: 500,
                                                        rows: 2,
                                                        placeholder: "Short explanation shown when hovering the tag",
                                                        className: "w-full resize-none rounded-lg border border-white/10 bg-black/20 px-3 py-2 text-sm text-white outline-hidden transition-colors placeholder:text-white/25 focus:border-neon/50"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                type: "submit",
                                                disabled: tagBusy || !tagName.trim(),
                                                className: "inline-flex items-center gap-1.5 rounded-lg border border-neon/30 bg-neon/10 px-3 py-2 text-[10px] font-bold uppercase tracking-wider text-neon transition-colors hover:bg-neon/20 disabled:cursor-not-allowed disabled:opacity-40",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bTVJ1.default), {
                                                        className: "h-3 w-3"
                                                    }),
                                                    editingTagId ? 'Save changes' : 'Add label'
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("h4", {
                                                className: "text-xs font-bold uppercase tracking-wider text-white/55",
                                                children: "Your labels"
                                            }),
                                            strategyTags.length === 0 ? /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                className: "rounded-xl border border-dashed border-white/10 px-4 py-5 text-center text-xs text-muted",
                                                children: "No position labels yet."
                                            }) : strategyTags.map((tag)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                    className: "flex items-center justify-between gap-3 rounded-xl border border-white/10 bg-white/3 px-3 py-2.5",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                            className: "min-w-0",
                                                            children: [
                                                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                                    className: "flex items-center gap-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                            className: "h-2.5 w-2.5 shrink-0 rounded-full",
                                                                            style: {
                                                                                backgroundColor: (0, $aNXfT.getStrategyTagColor)(tag)
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                            className: "truncate text-sm font-bold text-white",
                                                                            children: tag.name
                                                                        })
                                                                    ]
                                                                }),
                                                                tag.description && /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                                    className: "mt-1 truncate text-xs text-muted",
                                                                    children: tag.description
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                            className: "flex shrink-0 items-center gap-1",
                                                            children: [
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: ()=>editTag(tag),
                                                                    disabled: tagBusy,
                                                                    className: "rounded-lg p-2 text-white/45 transition-colors hover:bg-white/5 hover:text-neon disabled:opacity-40",
                                                                    "aria-label": `Edit ${tag.name}`,
                                                                    children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $29b1874158a6f84e$export$2e2bcd8739ae039), {
                                                                        className: "h-3.5 w-3.5"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: ()=>removeStrategyTag(tag),
                                                                    disabled: tagBusy,
                                                                    className: "rounded-lg p-2 text-white/45 transition-colors hover:bg-rose-500/10 hover:text-rose-300 disabled:opacity-40",
                                                                    "aria-label": `Delete ${tag.name}`,
                                                                    children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $k9hlW.default), {
                                                                        className: "h-3.5 w-3.5"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, tag.id))
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            editorPosition && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $g9vEp.default), {
                children: /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "fixed inset-0 z-1000 flex items-center justify-center bg-black/80 p-4 backdrop-blur-md",
                    onClick: (event)=>{
                        if (event.target === event.currentTarget) setEditorPosition(null);
                    },
                    children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "max-h-[90vh] w-full max-w-md overflow-y-auto rounded-2xl border border-white/10 bg-[#0e0e12] p-6 shadow-[0_0_50px_rgba(0,0,0,0.5)]",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "mb-5 flex items-start justify-between gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center gap-2 text-neon",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $0ee46722e8758d35$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                                        className: "text-lg font-bold text-white",
                                                        children: "Position labels"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                className: "mt-1 text-xs text-muted",
                                                children: (0, $aNXfT.getPositionDisplaySymbol)(editorPosition)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setEditorPosition(null),
                                        className: "rounded-lg p-2 text-white/45 transition-colors hover:bg-white/5 hover:text-white",
                                        "aria-label": "Close position labels",
                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                                            className: "h-4 w-4"
                                        })
                                    })
                                ]
                            }),
                            tagError && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "mb-4 rounded-lg border border-rose-500/25 bg-rose-500/10 px-3 py-2 text-xs text-rose-200",
                                children: tagError
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("section", {
                                className: "mb-5 rounded-xl border border-neon/20 bg-neon/4 p-4",
                                "aria-labelledby": "automatic-position-strategies",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex flex-wrap items-center justify-between gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("h4", {
                                                id: "automatic-position-strategies",
                                                className: "text-[10px] font-bold uppercase tracking-wider text-white/70",
                                                children: "Strategy label"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "rounded-sm border border-neon/20 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wider text-neon/70",
                                                children: "Automatic attribution"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: "mt-2 flex flex-wrap gap-1.5",
                                        children: automaticStrategyLabels.length > 0 ? automaticStrategyLabels.map((strategy)=>/*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "rounded-sm border border-neon/25 bg-neon/10 px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-neon",
                                                children: strategy
                                            }, strategy)) : /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            className: "rounded-sm border border-white/10 bg-white/3 px-2 py-1 text-[10px] font-semibold text-white/45",
                                            children: "No automatic strategy label"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                        className: "mt-2 text-[10px] leading-relaxed text-muted",
                                        children: "This attribution identifies which strategy opened the position. Set a display name below without changing order ownership or automatic closes."
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("label", {
                                        htmlFor: "custom-position-strategy",
                                        className: "mt-4 block text-[10px] font-bold uppercase tracking-wider text-white/70",
                                        children: "Display name"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                                id: "custom-position-strategy",
                                                type: "text",
                                                list: "position-strategy-name-options",
                                                value: strategyLabelOverride,
                                                onChange: (event)=>setStrategyLabelOverride(event.target.value),
                                                maxLength: 80,
                                                placeholder: automaticStrategyLabels.join(' + ') || 'Name this strategy label',
                                                className: "min-w-0 flex-1 rounded-lg border border-white/10 bg-black/30 px-3 py-2 text-sm text-white placeholder:text-white/25 outline-hidden transition-colors focus:border-neon/50"
                                            }),
                                            strategyLabelOverride.trim() && /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>setStrategyLabelOverride(''),
                                                className: "inline-flex shrink-0 items-center gap-1 rounded-lg border border-rose-400/20 px-2.5 py-2 text-[10px] font-bold uppercase tracking-wider text-rose-200/75 transition-colors hover:bg-rose-400/10 hover:text-rose-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                                                        className: "h-3 w-3"
                                                    }),
                                                    "Use automatic"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("datalist", {
                                        id: "position-strategy-name-options",
                                        children: strategyNameOptions.map((name)=>/*#__PURE__*/ (0, $eHRxX.jsx)("option", {
                                                value: name
                                            }, name))
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setStrategyLabelOverride('UNASSIGNED'),
                                        className: "mt-2 rounded-md border border-white/10 px-2 py-1 text-[10px] font-semibold text-white/60 hover:border-rose-400/30 hover:text-white",
                                        children: "Remove strategy name"
                                    }),
                                    strategyNameOptions.length > 0 && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "mt-2 flex flex-wrap items-center gap-1.5",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "mr-1 text-[10px] uppercase tracking-wider text-white/40",
                                                children: "Strategy names:"
                                            }),
                                            strategyNameOptions.map((name)=>/*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>setStrategyLabelOverride(name),
                                                    className: `rounded-md border px-2 py-1 text-[10px] font-semibold transition-colors ${strategyLabelOverride.trim() === name ? 'border-neon/40 bg-neon/10 text-neon' : 'border-white/10 text-white/55 hover:border-neon/30 hover:text-neon'}`,
                                                    children: name
                                                }, name))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                        className: "mt-2 text-[10px] leading-relaxed text-muted",
                                        children: "Leave blank to show the automatic name, or remove the name for this position. This changes the displayed label only."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("section", {
                                className: "space-y-2",
                                "aria-labelledby": "position-description-tags",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center justify-between gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h4", {
                                                        id: "position-description-tags",
                                                        className: "text-[10px] font-bold uppercase tracking-wider text-white/65",
                                                        children: "Descriptive labels"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                        className: "mt-0.5 text-[10px] text-muted",
                                                        children: "Notes and reminders attached to this position."
                                                    })
                                                ]
                                            }),
                                            selectedTagIds.length > 0 && /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setSelectedTagIds([]),
                                                className: "text-[10px] font-bold uppercase tracking-wider text-white/45 transition-colors hover:text-rose-300",
                                                children: "Remove all labels"
                                            })
                                        ]
                                    }),
                                    strategyTags.length === 0 ? /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: "rounded-xl border border-dashed border-white/10 px-4 py-5 text-center text-xs text-muted",
                                        children: "Create a position label first, then attach it here."
                                    }) : strategyTags.map((tag)=>{
                                        const checked = selectedTagIds.includes(tag.id);
                                        return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                            className: `flex items-center justify-between gap-3 rounded-xl border px-3 py-2.5 transition-colors ${checked ? 'border-neon/30 bg-neon/10' : 'border-white/10 bg-white/3'}`,
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                    className: "min-w-0",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                            className: "flex items-center gap-2 text-sm font-bold text-white",
                                                            children: [
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                    className: "h-2.5 w-2.5 shrink-0 rounded-full",
                                                                    style: {
                                                                        backgroundColor: (0, $aNXfT.getStrategyTagColor)(tag)
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                    className: "truncate",
                                                                    children: tag.name
                                                                }),
                                                                checked && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                    className: "shrink-0 text-[9px] font-bold uppercase tracking-wider text-neon",
                                                                    children: "Attached"
                                                                })
                                                            ]
                                                        }),
                                                        tag.description && /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                            className: "mt-0.5 truncate text-xs text-muted",
                                                            children: tag.description
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                    type: "button",
                                                    onClick: ()=>setSelectedTagIds((ids)=>checked ? ids.filter((id)=>id !== tag.id) : [
                                                                ...ids,
                                                                tag.id
                                                            ]),
                                                    className: `inline-flex shrink-0 items-center gap-1 rounded-lg border px-2.5 py-1.5 text-[10px] font-bold uppercase tracking-wider transition-colors ${checked ? 'border-rose-400/20 text-rose-200/75 hover:bg-rose-400/10 hover:text-rose-100' : 'border-neon/20 text-neon/80 hover:bg-neon/10 hover:text-neon'}`,
                                                    "aria-label": `${checked ? 'Remove' : 'Add'} ${tag.name} ${checked ? 'from' : 'to'} position`,
                                                    children: [
                                                        checked ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                                                            className: "h-3 w-3"
                                                        }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bTVJ1.default), {
                                                            className: "h-3 w-3"
                                                        }),
                                                        checked ? 'Remove' : 'Add'
                                                    ]
                                                })
                                            ]
                                        }, tag.id);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "mt-6 flex items-center justify-between gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                        type: "button",
                                        onClick: openManagerFromEditor,
                                        className: "inline-flex items-center gap-1.5 rounded-lg border border-white/10 px-3 py-2 text-[10px] font-bold uppercase tracking-wider text-white/60 transition-colors hover:border-neon/30 hover:text-neon",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bTVJ1.default), {
                                                className: "h-3 w-3"
                                            }),
                                            "Manage labels"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setEditorPosition(null),
                                                className: "rounded-lg border border-white/10 px-4 py-2 text-[10px] font-bold uppercase tracking-wider text-white/60 transition-colors hover:bg-white/5 hover:text-white",
                                                children: "Cancel"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                                type: "button",
                                                onClick: savePositionTags,
                                                disabled: tagBusy,
                                                className: "rounded-lg border border-neon/30 bg-neon/10 px-4 py-2 text-[10px] font-bold uppercase tracking-wider text-neon transition-colors hover:bg-neon/20 disabled:opacity-40",
                                                children: tagBusy ? "Saving\u2026" : 'Save labels'
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $d81cfede2e2371fc$export$2e2bcd8739ae039 = $d81cfede2e2371fc$var$PositionStrategyTagModals;



var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $gQIZx = parcelRequire("gQIZx");
var $12llf = parcelRequire("12llf");
var $8Rrv7 = parcelRequire("8Rrv7");
var $2rkXu = parcelRequire("2rkXu");
var $8FKMh = parcelRequire("8FKMh");
var $dNdHx = parcelRequire("dNdHx");

var $iCbFX = parcelRequire("iCbFX");

var $fvREG = parcelRequire("fvREG");

var $4cvdp = parcelRequire("4cvdp");


var $aNXfT = parcelRequire("aNXfT");
const $8ebd43a4f61e78b3$var$POSITION_COLUMN_STORAGE_KEY = 'dashboardPositionsHiddenColumns_v1';
const $8ebd43a4f61e78b3$var$DEFAULT_HIDDEN_POSITION_COLUMNS = [
    'margin_used'
];
const $8ebd43a4f61e78b3$var$POSITION_COLUMN_OPTIONS = [
    {
        id: 'secType',
        label: 'Type'
    },
    {
        id: 'strategy',
        label: 'Strategy'
    },
    {
        id: 'strategy_tags',
        label: 'Labels'
    },
    {
        id: 'quantity',
        label: 'Quantity'
    },
    {
        id: 'avg_cost',
        label: 'Entry Price'
    },
    {
        id: 'current_price',
        label: 'Market Price'
    },
    {
        id: 'market_value',
        label: 'Market Value'
    },
    {
        id: 'margin_used',
        label: 'Margin'
    },
    {
        id: 'daily_pnl',
        label: 'Daily P&L'
    },
    {
        id: 'daily_pnl_pct',
        label: 'Daily %'
    },
    {
        id: 'unrealized_pnl',
        label: 'Unrealized P&L'
    }
];
const $8ebd43a4f61e78b3$var$getInitialHiddenPositionColumns = ()=>{
    if (typeof window === 'undefined') return new Set($8ebd43a4f61e78b3$var$DEFAULT_HIDDEN_POSITION_COLUMNS);
    try {
        const stored = window.localStorage.getItem($8ebd43a4f61e78b3$var$POSITION_COLUMN_STORAGE_KEY);
        if (stored === null) return new Set($8ebd43a4f61e78b3$var$DEFAULT_HIDDEN_POSITION_COLUMNS);
        const parsed = JSON.parse(stored);
        if (!Array.isArray(parsed)) return new Set($8ebd43a4f61e78b3$var$DEFAULT_HIDDEN_POSITION_COLUMNS);
        return new Set(parsed.filter((id)=>typeof id === 'string' && $8ebd43a4f61e78b3$var$POSITION_COLUMN_OPTIONS.some(({ id: validId })=>validId === id)));
    } catch  {
        return new Set($8ebd43a4f61e78b3$var$DEFAULT_HIDDEN_POSITION_COLUMNS);
    }
};
const $8ebd43a4f61e78b3$var$getDailyAssetChangePercent = (position)=>{
    if (position.daily_pnl === undefined || position.daily_pnl === null) return null;
    const dailyPnl = Number(position.daily_pnl);
    if (!Number.isFinite(dailyPnl)) return null;
    const brokerMarketValue = position.market_value === undefined || position.market_value === null ? Number.NaN : Number(position.market_value);
    const parsedMultiplier = Number(position.multiplier);
    const multiplier = Number.isFinite(parsedMultiplier) && parsedMultiplier > 0 ? parsedMultiplier : 1;
    const currentMarketValue = Number.isFinite(brokerMarketValue) ? brokerMarketValue : Number(position.current_price) * Number(position.quantity) * multiplier;
    const previousMarketValue = currentMarketValue - dailyPnl;
    if (!Number.isFinite(previousMarketValue) || Math.abs(previousMarketValue) < 0.000001) return null;
    return dailyPnl / previousMarketValue * 100;
};
const $8ebd43a4f61e78b3$var$OpenPositionsTable = ({ positions: positions, hasAnyPositions: hasAnyPositions, positionsSucceeded: positionsSucceeded, loading: loading, refreshing: refreshing, error: error, lastUpdated: lastUpdated, accountCurrency: accountCurrency, stale: stale, snapshotAvailable: snapshotAvailable, initializing: initializing, connectionUnavailable: connectionUnavailable, onRetry: onRetry, onClosePosition: onClosePosition, onOpenPositionChart: onOpenPositionChart, onEditPositionTags: onEditPositionTags })=>{
    const [expandedChartPositionKey, setExpandedChartPositionKey] = (0, $jHEir.useState)(null);
    const [hiddenColumnIds, setHiddenColumnIds] = (0, $jHEir.useState)($8ebd43a4f61e78b3$var$getInitialHiddenPositionColumns);
    const [columnMenuOpen, setColumnMenuOpen] = (0, $jHEir.useState)(false);
    const columnMenuRef = (0, $jHEir.useRef)(null);
    (0, $jHEir.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        try {
            window.localStorage.setItem($8ebd43a4f61e78b3$var$POSITION_COLUMN_STORAGE_KEY, JSON.stringify([
                ...hiddenColumnIds
            ]));
        } catch  {
        // Keep column selection usable when browser storage is unavailable.
        }
    }, [
        hiddenColumnIds
    ]);
    (0, $jHEir.useEffect)(()=>{
        if (!columnMenuOpen) return undefined;
        const closeOnOutsideClick = (event)=>{
            if (!columnMenuRef.current?.contains(event.target)) setColumnMenuOpen(false);
        };
        const closeOnEscape = (event)=>{
            if (event.key === 'Escape') setColumnMenuOpen(false);
        };
        document.addEventListener('mousedown', closeOnOutsideClick);
        document.addEventListener('keydown', closeOnEscape);
        return ()=>{
            document.removeEventListener('mousedown', closeOnOutsideClick);
            document.removeEventListener('keydown', closeOnEscape);
        };
    }, [
        columnMenuOpen
    ]);
    const toggleColumn = (columnId)=>{
        setHiddenColumnIds((current)=>{
            const next = new Set(current);
            if (next.has(columnId)) next.delete(columnId);
            else next.add(columnId);
            return next;
        });
    };
    const columns = [
        {
            id: 'symbol',
            header: 'Symbol',
            accessor: 'symbol',
            sortable: true,
            className: 'w-[1%]',
            headerClassName: 'w-[1%]',
            render: (position)=>/*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "flex items-center",
                    children: /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                        className: "font-semibold text-[12px] tracking-tight text-white",
                        children: (0, $aNXfT.getPositionDisplaySymbol)(position)
                    })
                })
        },
        {
            id: 'secType',
            header: 'Type',
            accessor: (position)=>position.secType || 'STK',
            sortable: true,
            className: 'text-white/70 text-[12px]'
        },
        {
            id: 'strategy',
            header: 'Strategy',
            accessor: (position)=>(0, $aNXfT.getPositionDisplayStrategies)(position).join(', '),
            sortable: true,
            render: (position)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex items-center gap-1",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                            className: "flex flex-wrap gap-1",
                            children: (0, $aNXfT.getPositionDisplayStrategies)(position).map((strategy, index)=>/*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                    title: (position.strategy_order_lots || []).filter((lot)=>lot.strategy === ((0, $aNXfT.getPositionStrategies)(position)[index] || strategy)).map((lot)=>`${lot.strategy}: opened ${lot.opened_at || 'date unavailable'}${lot.opening_order_id ? ` by order #${lot.opening_order_id}` : ''}`).join('\n') || undefined,
                                    className: `rounded px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider ${strategy === 'UNASSIGNED' ? 'border border-white/10 bg-white/5 text-white/45' : 'border border-neon/20 bg-neon/10 text-neon'}`,
                                    children: strategy
                                }, strategy))
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                            type: "button",
                            onClick: (event)=>{
                                event.stopPropagation();
                                onEditPositionTags(position);
                            },
                            className: "inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-md border border-white/10 text-white/40 transition-colors hover:border-neon/30 hover:bg-neon/10 hover:text-neon",
                            title: "Edit position strategy label",
                            "aria-label": `Edit position strategy label for ${(0, $aNXfT.getPositionDisplaySymbol)(position)}`,
                            children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $29b1874158a6f84e$export$2e2bcd8739ae039), {
                                className: "h-3 w-3"
                            })
                        })
                    ]
                })
        },
        {
            id: 'strategy_tags',
            header: 'Labels',
            headerInfo: 'Descriptive labels attached to this position for notes and reminders.',
            accessor: (position)=>(position.strategy_tags || []).map((tag)=>tag.name).join(', '),
            sortable: true,
            className: 'w-[1%]',
            headerClassName: 'w-[1%]',
            render: (position)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex max-w-[200px] flex-wrap items-center gap-1",
                    children: [
                        (position.strategy_tags || []).map((tag)=>/*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                title: tag.description || tag.name,
                                className: "max-w-[76px] truncate rounded-sm border px-1 py-0.5 text-[9px] font-bold tracking-wide text-white/85",
                                style: {
                                    borderColor: `${(0, $aNXfT.getStrategyTagColor)(tag)}66`,
                                    backgroundColor: `${(0, $aNXfT.getStrategyTagColor)(tag)}1A`
                                },
                                children: tag.name
                            }, tag.id)),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                            type: "button",
                            onClick: (event)=>{
                                event.stopPropagation();
                                onEditPositionTags(position);
                            },
                            className: "inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-sm border border-dashed border-white/20 text-white/50 transition-colors hover:border-neon/40 hover:text-neon",
                            title: position.strategy_tags?.length ? 'Edit position labels' : 'Add position labels',
                            "aria-label": position.strategy_tags?.length ? 'Edit position labels' : 'Add position labels',
                            children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $0ee46722e8758d35$export$2e2bcd8739ae039), {
                                className: "h-3 w-3"
                            })
                        })
                    ]
                })
        },
        {
            id: 'quantity',
            header: 'Quantity',
            accessor: 'quantity',
            sortable: true,
            render: (position)=>/*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: `flex items-center gap-1.5 ${position.quantity && position.quantity < 0 ? 'text-rose-400' : 'text-white'}`,
                    children: /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                        className: "font-mono text-[14px] font-bold",
                        children: position.quantity
                    })
                })
        },
        {
            id: 'avg_cost',
            header: 'Entry Price',
            accessor: 'avg_cost',
            sortable: true,
            render: (position)=>/*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                    className: "text-white/90 font-mono text-[13px]",
                    children: position.avg_cost !== undefined && position.avg_cost !== null ? (0, $iCbFX.formatCurrency)(position.avg_cost, position.currency) : '-'
                })
        },
        {
            id: 'current_price',
            header: 'Mkt Price',
            accessor: 'current_price',
            sortable: true,
            render: (position)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                    className: `font-mono text-[13px] font-bold ${refreshing ? 'animate-pulse text-neon' : 'text-white/90'}`,
                    children: [
                        position.current_price !== undefined && position.current_price !== null ? (0, $iCbFX.formatCurrency)(position.current_price, position.currency) : '-',
                        position.quote_stale && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "ml-1 text-[9px] text-amber-300",
                            children: "Stale"
                        })
                    ]
                })
        },
        {
            id: 'market_value',
            header: 'Market Value',
            accessor: 'market_value',
            sortable: true,
            render: (position)=>/*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                    className: `font-mono text-[13px] font-bold ${refreshing ? 'animate-pulse text-neon' : 'text-white/80'}`,
                    children: (0, $iCbFX.formatCurrency)(position.market_value, position.currency)
                })
        },
        {
            id: 'margin_used',
            header: 'Margin',
            headerInfo: 'Estimated margin allocated to this position. The percentage is relative to total account value.',
            accessor: 'margin_used',
            sortable: true,
            render: (position)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "font-mono text-[13px] font-bold text-white/80 leading-tight",
                    children: [
                        position.margin_used_pct !== undefined && position.margin_used_pct !== null && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            children: [
                                position.margin_used_pct.toFixed(2),
                                "%"
                            ]
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                            className: "text-[11px] font-normal text-muted",
                            children: (0, $aNXfT.formatPlainNumber)(position.margin_used)
                        })
                    ]
                })
        },
        {
            id: 'daily_pnl',
            header: 'Daily P&L',
            accessor: 'daily_pnl',
            sortable: true,
            render: (position)=>/*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: `font-black font-mono text-[14px] ${(position.daily_pnl || 0) < 0 ? 'text-rose-400' : (position.daily_pnl || 0) > 0 ? 'text-emerald-400' : 'text-white/40'}`,
                    children: position.daily_pnl !== undefined && position.daily_pnl !== null ? (0, $iCbFX.formatCurrency)(position.daily_pnl, position.currency) : '-'
                })
        },
        {
            id: 'daily_pnl_pct',
            header: 'Daily %',
            headerInfo: 'Estimated underlying daily price change, calculated from daily P&L and the prior position value.',
            accessor: (position)=>$8ebd43a4f61e78b3$var$getDailyAssetChangePercent(position),
            sortable: true,
            render: (position)=>{
                const dailyPercent = $8ebd43a4f61e78b3$var$getDailyAssetChangePercent(position);
                return /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: `font-black font-mono text-[13px] ${dailyPercent === null ? 'text-white/40' : dailyPercent > 0 ? 'text-emerald-400' : dailyPercent < 0 ? 'text-rose-400' : 'text-white/80'}`,
                    children: dailyPercent === null ? "\u2014" : `${dailyPercent > 0 ? '+' : ''}${dailyPercent.toFixed(2)}%`
                });
            }
        },
        {
            id: 'unrealized_pnl',
            header: 'Unrealized P&L',
            accessor: 'unrealized_pnl',
            sortable: true,
            render: (position)=>/*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: `font-black font-mono text-[14px] ${(position.unrealized_pnl || 0) < 0 ? 'text-rose-400' : (position.unrealized_pnl || 0) > 0 ? 'text-emerald-400' : 'text-white/40'}`,
                    children: position.unrealized_pnl !== undefined && position.unrealized_pnl !== null ? (0, $iCbFX.formatCurrency)(position.unrealized_pnl, position.currency) : '-'
                })
        },
        {
            id: 'actions',
            header: 'Actions',
            accessor: 'id',
            align: 'right',
            render: (position)=>/*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                    className: "px-3 py-1.5 rounded-lg border border-rose-500/30 bg-rose-500/10 text-[10px] font-bold uppercase tracking-[0.12em] text-rose-200 hover:bg-rose-500/20 active:scale-95 transition-all disabled:opacity-50",
                    disabled: refreshing,
                    onClick: (event)=>{
                        event.stopPropagation();
                        onClosePosition(position);
                    },
                    children: "Close"
                })
        }
    ];
    const visibleColumns = columns.filter((column)=>column.id === 'symbol' || column.id === 'actions' || !hiddenColumnIds.has(column.id));
    const totalPositionValue = positions.reduce((sum, position)=>{
        const marketValue = position.market_value !== undefined && position.market_value !== null ? Number(position.market_value) : Number.NaN;
        if (Number.isFinite(marketValue)) return sum + Math.abs(marketValue);
        const price = Number(position.current_price);
        const quantity = Number(position.quantity);
        const parsedMultiplier = Number(position.multiplier);
        const multiplier = Number.isFinite(parsedMultiplier) && parsedMultiplier > 0 ? parsedMultiplier : 1;
        return Number.isFinite(price) && Number.isFinite(quantity) ? sum + Math.abs(price * quantity * multiplier) : sum;
    }, 0);
    const totalDailyPnl = positions.reduce((sum, position)=>sum + (position.daily_pnl || 0), 0);
    const isDailyPositive = totalDailyPnl >= 0;
    const totalUnrealized = positions.reduce((sum, position)=>sum + (position.unrealized_pnl || 0), 0);
    const isPositive = totalUnrealized >= 0;
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "flex min-h-0 flex-1 flex-col space-y-6",
        children: [
            stale && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "rounded-xl border border-warning-500/25 bg-warning-500/10 px-4 py-3 text-xs text-warning-300",
                children: initializing ? 'IB is connected and positions are synchronizing. This panel will refresh automatically.' : connectionUnavailable ? "IB is connected, but live positions are temporarily unavailable \u2014 showing the latest persisted snapshot." : !snapshotAvailable ? "Gateway offline \u2014 no persisted position snapshot is available yet." : "Gateway offline \u2014 showing the last persisted position snapshot."
            }),
            !error && positionsSucceeded && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex flex-wrap items-center gap-3 pb-2",
                children: [
                    hasAnyPositions && /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-[10px] font-bold uppercase tracking-wider text-emerald-400",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7ab85e16ca639a6c$export$2e2bcd8739ae039), {
                                        size: 12
                                    }),
                                    positions.length,
                                    " Active ",
                                    positions.length === 1 ? 'Position' : 'Positions'
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-[10px] font-bold uppercase tracking-wider text-white/80",
                                title: "Gross market value of the positions matching the current filters",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $dNdHx.default), {
                                        size: 12
                                    }),
                                    "Total value: ",
                                    (0, $iCbFX.formatCurrency)(totalPositionValue, accountCurrency)
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: `flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-[10px] font-bold uppercase tracking-wider ${isDailyPositive ? 'text-emerald-400' : 'text-rose-400'}`,
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $gQIZx.default), {
                                        size: 12
                                    }),
                                    "Daily P&L: ",
                                    (0, $iCbFX.formatCurrency)(totalDailyPnl, accountCurrency)
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: `flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-[10px] font-bold uppercase tracking-wider ${isPositive ? 'text-emerald-400' : 'text-rose-400'}`,
                                children: [
                                    isPositive ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8FKMh.default), {
                                        size: 12
                                    }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $2rkXu.default), {
                                        size: 12
                                    }),
                                    "Unrealized: ",
                                    (0, $iCbFX.formatCurrency)(totalUnrealized, accountCurrency)
                                ]
                            }),
                            lastUpdated && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-[10px] font-bold uppercase tracking-wider text-muted",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $12llf.default), {
                                        size: 12
                                    }),
                                    "Refreshed: ",
                                    lastUpdated
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "relative ml-auto",
                        ref: columnMenuRef,
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                type: "button",
                                onClick: ()=>setColumnMenuOpen((open)=>!open),
                                "aria-label": "Choose visible position fields",
                                "aria-expanded": columnMenuOpen,
                                className: "inline-flex items-center gap-2 rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-[10px] font-bold uppercase tracking-wider text-white/70 transition-colors hover:border-neon/30 hover:bg-neon/10 hover:text-neon",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8Rrv7.default), {
                                        className: "h-3.5 w-3.5"
                                    }),
                                    "Fields"
                                ]
                            }),
                            columnMenuOpen && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "absolute right-0 top-full z-30 mt-2 max-h-[70vh] w-56 overflow-y-auto rounded-xl border border-white/10 bg-slate-950 p-3 shadow-2xl",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: "mb-2 px-1 text-[9px] font-bold uppercase tracking-widest text-muted",
                                        children: "Shown fields"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: "space-y-1",
                                        children: $8ebd43a4f61e78b3$var$POSITION_COLUMN_OPTIONS.map(({ id: id, label: label })=>/*#__PURE__*/ (0, $eHRxX.jsxs)("label", {
                                                className: "flex cursor-pointer items-center gap-2 rounded-lg px-2 py-1.5 text-xs text-white/75 transition-colors hover:bg-white/5 hover:text-white",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: !hiddenColumnIds.has(id),
                                                        onChange: ()=>toggleColumn(id),
                                                        className: "h-3.5 w-3.5 accent-teal-400"
                                                    }),
                                                    label
                                                ]
                                            }, id))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4cvdp.default), {
                error: error,
                onRetry: onRetry,
                message: "Failed to load positions"
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $fvREG.DataTable), {
                data: positions,
                columns: visibleColumns,
                className: "min-h-0 flex-1",
                compact: true,
                loading: loading,
                onRowClick: (position)=>{
                    const rowKey = (0, $aNXfT.getPositionRowKey)(position);
                    setExpandedChartPositionKey((current)=>current === rowKey ? null : rowKey);
                },
                getRowKey: (0, $aNXfT.getPositionRowKey),
                expandedRowKey: expandedChartPositionKey,
                renderExpandedRow: (position)=>/*#__PURE__*/ (0, $eHRxX.jsx)((0, $55948ac21f10399f$export$2e2bcd8739ae039), {
                        position: position,
                        inline: true,
                        onClose: ()=>setExpandedChartPositionKey(null),
                        onOpenModal: ()=>onOpenPositionChart(position)
                    }),
                emptyMessage: stale && !snapshotAvailable ? initializing ? "Synchronizing positions\u2026" : 'No persisted position snapshot available' : 'No open positions found',
                initialSort: {
                    id: 'unrealized_pnl',
                    direction: 'desc'
                }
            })
        ]
    });
};
var $8ebd43a4f61e78b3$export$2e2bcd8739ae039 = $8ebd43a4f61e78b3$var$OpenPositionsTable;



var $jHEir = parcelRequire("jHEir");

var $aNXfT = parcelRequire("aNXfT");
function $2371e9ec4c36d648$export$6641edcb96c6f745({ service: service, refreshAfterDelete: refreshAfterDelete, refreshAfterSave: refreshAfterSave }) {
    const [strategyTags, setStrategyTags] = (0, $jHEir.useState)([]);
    const [managerOpen, setManagerOpen] = (0, $jHEir.useState)(false);
    const [editorPosition, setEditorPosition] = (0, $jHEir.useState)(null);
    const [selectedTagIds, setSelectedTagIds] = (0, $jHEir.useState)([]);
    const [strategyLabelOverride, setStrategyLabelOverride] = (0, $jHEir.useState)('');
    const [editingTagId, setEditingTagId] = (0, $jHEir.useState)(null);
    const [tagName, setTagName] = (0, $jHEir.useState)('');
    const [tagDescription, setTagDescription] = (0, $jHEir.useState)('');
    const [tagColor, setTagColor] = (0, $jHEir.useState)('#14B8A6');
    const [tagBusy, setTagBusy] = (0, $jHEir.useState)(false);
    const [tagError, setTagError] = (0, $jHEir.useState)(null);
    const loadStrategyTags = (0, $jHEir.useCallback)(async ()=>{
        try {
            const response = await service.listTags();
            if (response.success) {
                setStrategyTags(response.data?.tags || []);
                setTagError(null);
            } else if (managerOpen) setTagError(response.error || 'Failed to load position labels');
        } catch (err) {
            if (managerOpen) setTagError(err instanceof Error ? err.message : 'Failed to load position labels');
        }
    }, [
        managerOpen,
        service
    ]);
    (0, $jHEir.useEffect)(()=>{
        loadStrategyTags();
    }, [
        loadStrategyTags
    ]);
    const openManager = ()=>{
        setTagError(null);
        setManagerOpen(true);
    };
    const openPositionTagEditor = (position)=>{
        setTagError(null);
        setEditorPosition({
            ...position,
            position_key: (0, $aNXfT.getPositionMetadataKey)(position)
        });
        setSelectedTagIds((position.strategy_tags || []).map((tag)=>tag.id));
        setStrategyLabelOverride(position.custom_strategy_name || '');
    };
    const openManagerFromEditor = ()=>{
        setEditorPosition(null);
        openManager();
    };
    const resetTagForm = ()=>{
        setEditingTagId(null);
        setTagName('');
        setTagDescription('');
        setTagColor('#14B8A6');
    };
    const editTag = (tag)=>{
        setEditingTagId(tag.id);
        setTagName(tag.name);
        setTagDescription(tag.description || '');
        setTagColor(tag.color || '#14B8A6');
    };
    const saveStrategyTag = async (event)=>{
        event.preventDefault();
        if (!tagName.trim()) return;
        setTagBusy(true);
        setTagError(null);
        try {
            const response = await service.saveTag({
                editingTagId: editingTagId,
                name: tagName,
                description: tagDescription,
                color: tagColor
            });
            if (!response.success) {
                setTagError(response.error || 'Failed to save position label');
                return;
            }
            resetTagForm();
            await loadStrategyTags();
        } catch (err) {
            setTagError(err instanceof Error ? err.message : 'Failed to save position label');
        } finally{
            setTagBusy(false);
        }
    };
    const removeStrategyTag = async (tag)=>{
        if (!window.confirm(`Delete the \u{201C}${tag.name}\u{201D} label? Existing position links will be removed.`)) return;
        setTagBusy(true);
        setTagError(null);
        try {
            const response = await service.deleteTag(tag.id);
            if (!response.success) {
                setTagError(response.error || 'Failed to delete position label');
                return;
            }
            if (editingTagId === tag.id) resetTagForm();
            setSelectedTagIds((ids)=>ids.filter((id)=>id !== tag.id));
            await loadStrategyTags();
            await refreshAfterDelete();
        } catch (err) {
            setTagError(err instanceof Error ? err.message : 'Failed to delete position label');
        } finally{
            setTagBusy(false);
        }
    };
    const savePositionTags = async ()=>{
        if (!editorPosition) return;
        const positionKey = (0, $aNXfT.getPositionMetadataKey)(editorPosition);
        setTagBusy(true);
        setTagError(null);
        try {
            const response = await service.savePositionMetadata(positionKey, strategyLabelOverride, selectedTagIds);
            if (!response.success) {
                setTagError(response.error || 'Failed to update position labels');
                return;
            }
            setEditorPosition(null);
            await refreshAfterSave();
        } catch (err) {
            setTagError(err instanceof Error ? err.message : 'Failed to update position labels');
        } finally{
            setTagBusy(false);
        }
    };
    return {
        strategyTags: strategyTags,
        managerOpen: managerOpen,
        setManagerOpen: setManagerOpen,
        editorPosition: editorPosition,
        setEditorPosition: setEditorPosition,
        selectedTagIds: selectedTagIds,
        setSelectedTagIds: setSelectedTagIds,
        strategyLabelOverride: strategyLabelOverride,
        setStrategyLabelOverride: setStrategyLabelOverride,
        editingTagId: editingTagId,
        tagName: tagName,
        setTagName: setTagName,
        tagDescription: tagDescription,
        setTagDescription: setTagDescription,
        tagColor: tagColor,
        setTagColor: setTagColor,
        tagBusy: tagBusy,
        tagError: tagError,
        setTagError: setTagError,
        openManager: openManager,
        openPositionTagEditor: openPositionTagEditor,
        openManagerFromEditor: openManagerFromEditor,
        resetTagForm: resetTagForm,
        editTag: editTag,
        saveStrategyTag: saveStrategyTag,
        removeStrategyTag: removeStrategyTag,
        savePositionTags: savePositionTags
    };
}



var $aNXfT = parcelRequire("aNXfT");
const $5e09a53f0c6f1a36$var$PositionsOrdersPanel = ({ refreshInterval: refreshInterval = 30000, onEditOrder: onEditOrder, className: className = '' })=>{
    const positionTagService = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useMemo(()=>new (0, $1483ce4a3bf3bb29$export$6339b3d8d8e13ec3)((0, $zs3Np.tradingApi)), []);
    const { data: positions = null, isLoading: loading, isFetching: refreshing, error: positionsError, refetch: refetchPositions } = (0, $hpygi.usePositionsQuery)(undefined, {
        pollingInterval: refreshInterval,
        skipPollingIfUnfocused: true
    });
    const { data: ordersData, refetch: refetchOrders } = (0, $hpygi.useOpenOrdersQuery)({
        page: 1,
        pageSize: 100
    }, {
        pollingInterval: refreshInterval,
        skipPollingIfUnfocused: true
    });
    const [actionError, setActionError] = (0, $jHEir.useState)(null);
    const [activeTab, setActiveTab] = (0, $jHEir.useState)('positions');
    const [strategyFilter, setStrategyFilter] = (0, $jHEir.useState)('ALL');
    const [securityTypeFilter, setSecurityTypeFilter] = (0, $jHEir.useState)('ALL');
    const [pendingClose, setPendingClose] = (0, $jHEir.useState)(null);
    const [chartPosition, setChartPosition] = (0, $jHEir.useState)(null);
    const tagManagement = (0, $2371e9ec4c36d648$export$6641edcb96c6f745)({
        service: positionTagService,
        refreshAfterDelete: ()=>refetchPositions(),
        refreshAfterSave: ()=>refetchPositions().unwrap()
    });
    const { openManager: openStrategyTagManager, openPositionTagEditor: openPositionTagEditor } = tagManagement;
    const lastUpdated = positions?.timestamp ? (0, $lRLyZ.formatTimeET)(positions.timestamp) : null;
    const openOrdersCount = (ordersData?.data?.orders || []).filter((order)=>securityTypeFilter === 'ALL' || (0, $aNXfT.getSecurityType)(order) === securityTypeFilter).length;
    const error = actionError || (positionsError && !positions ? 'Failed to fetch positions' : null);
    const positionsStale = !!positions?.data?.stale;
    const positionsSnapshotAvailable = positions?.data?.snapshot_available !== false;
    const positionsInitializing = positions?.data?.connection_status === 'initializing';
    const ordersInitializing = ordersData?.data?.connection_status === 'initializing';
    const quoteIdentifiers = (0, $aNXfT.getPositionQuoteIdentifiers)(positions?.data?.positions || []);
    const liveQuotes = (0, $965642ac39400a6c$export$d969c99f03d34b97)(quoteIdentifiers);
    const quoteConnectionStatus = (0, $965642ac39400a6c$export$2341ff61511dbf4b)();
    const displayedPositions = (positions?.data?.positions || []).map((position, index)=>{
        const identifier = String(quoteIdentifiers[index] || '').toUpperCase();
        return (0, $aNXfT.addLiveQuoteToPosition)(position, liveQuotes[identifier], quoteConnectionStatus, positionsStale);
    });
    const strategyOptions = (0, $aNXfT.getPositionStrategyOptions)(displayedPositions);
    const strategyNameOptions = (0, $aNXfT.getPositionStrategyNameOptions)(displayedPositions);
    const filteredPositions = (0, $aNXfT.filterPositions)(displayedPositions, strategyFilter, securityTypeFilter);
    const fetchPositions = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useCallback(async ()=>{
        setActionError(null);
        try {
            await Promise.all([
                refetchPositions().unwrap(),
                refetchOrders().unwrap()
            ]);
        } catch (err) {
            setActionError(err instanceof Error ? err.message : 'Failed to fetch positions');
        }
    }, [
        refetchOrders,
        refetchPositions
    ]);
    (0, $jHEir.useEffect)(()=>{
        const handleRefresh = ()=>fetchPositions();
        window.addEventListener('trading-data-refresh', handleRefresh);
        return ()=>window.removeEventListener('trading-data-refresh', handleRefresh);
    }, [
        fetchPositions
    ]);
    (0, $jHEir.useEffect)(()=>{
        if (!positionsInitializing && !ordersInitializing) return;
        const retryId = window.setTimeout(()=>fetchPositions(), 2000);
        return ()=>window.clearTimeout(retryId);
    }, [
        fetchPositions,
        ordersInitializing,
        positions?.timestamp,
        positionsInitializing
    ]);
    const accountCurrency = positions?.data?.currency || 'USD';
    const handleCloseClick = (position)=>{
        if (!position.symbol || position.quantity === undefined) return;
        // Calculate the closing order details
        const qty = position.quantity;
        const side = qty < 0 ? 'BUY' : 'SELL';
        setPendingClose({
            symbol: position.symbol,
            displaySymbol: (0, $aNXfT.getPositionDisplaySymbol)(position),
            quantity: Math.abs(qty),
            side: side,
            secType: position.secType || 'STK',
            contract: {
                con_id: position.con_id,
                exchange: position.exchange,
                currency: position.currency,
                local_symbol: position.local_symbol,
                trading_class: position.trading_class,
                last_trade_date_or_contract_month: position.last_trade_date_or_contract_month,
                multiplier: position.multiplier
            }
        });
    };
    const handleCancelClose = ()=>{
        setPendingClose(null);
    };
    const pendingCloseDraft = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useMemo(()=>{
        if (!pendingClose) return null;
        return {
            symbol: pendingClose.symbol,
            rootSymbol: pendingClose.symbol,
            side: pendingClose.side,
            quantity: pendingClose.quantity,
            order_type: 'MARKET',
            secType: pendingClose.secType,
            strategy: 'MANUAL',
            tif: 'DAY',
            outside_rth: false,
            con_id: pendingClose.contract.con_id,
            exchange: pendingClose.contract.exchange,
            currency: pendingClose.contract.currency,
            localSymbol: pendingClose.contract.local_symbol,
            tradingClass: pendingClose.contract.trading_class,
            lastTradeDateOrContractMonth: pendingClose.contract.last_trade_date_or_contract_month,
            multiplier: pendingClose.contract.multiplier
        };
    }, [
        pendingClose
    ]);
    const handleCloseOrderSubmitted = ()=>{
        setPendingClose(null);
        setActionError(null);
        fetchPositions();
    };
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: `panel full-bleed-panel flex min-h-0 w-full flex-col ${className}`,
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex shrink-0 flex-col justify-between gap-4 border-b border-white/10 px-6 py-5 sm:flex-row sm:items-center",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "p-2 rounded-lg bg-neon/10 text-neon",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $3KPv1.default), {
                                    className: "w-5 h-5"
                                })
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h2", {
                                        className: "text-lg font-bold text-white tracking-tight",
                                        children: "Positions & Orders"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                        className: "text-sm text-muted",
                                        children: "Real-time portfolio oversight and execution logs."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center p-1 bg-white/5 border border-white/10 rounded-xl",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                onClick: ()=>setActiveTab('positions'),
                                className: `px-4 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider transition-all duration-300 flex items-center gap-2 ${activeTab === 'positions' ? 'bg-neon/10 text-neon shadow-[0_0_15px_rgba(45,212,191,0.1)]' : 'text-muted hover:text-white hover:bg-white/5'}`,
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        children: "Positions"
                                    }),
                                    filteredPositions.length > 0 && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: `flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[9px] font-black leading-none ${activeTab === 'positions' ? 'bg-neon text-black shadow-[0_0_10px_rgba(var(--neon-rgb),0.4)]' : 'bg-white/10 text-white/60 border border-white/10'}`,
                                        children: filteredPositions.length
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                onClick: ()=>setActiveTab('orders'),
                                className: `px-4 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider transition-all duration-300 flex items-center gap-2 ${activeTab === 'orders' ? 'bg-neon/10 text-neon shadow-[0_0_15px_rgba(45,212,191,0.1)]' : 'text-muted hover:text-white hover:bg-white/5'}`,
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        children: "Orders"
                                    }),
                                    openOrdersCount > 0 && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: `flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[9px] font-black leading-none ${activeTab === 'orders' ? 'bg-neon text-black shadow-[0_0_10px_rgba(var(--neon-rgb),0.4)]' : 'bg-white/10 text-white/60 border border-white/10'}`,
                                        children: openOrdersCount
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex min-h-0 flex-1 flex-col p-6",
                children: [
                    !actionError && (positions?.success || ordersData?.success) && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "mb-6 flex flex-wrap items-center gap-x-2 gap-y-2",
                        children: [
                            activeTab === 'positions' && /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                        type: "button",
                                        onClick: openStrategyTagManager,
                                        className: "mr-2 inline-flex items-center gap-1.5 rounded-full border border-neon/25 bg-neon/10 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-neon transition-colors hover:border-neon/50 hover:bg-neon/15",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $0ee46722e8758d35$export$2e2bcd8739ae039), {
                                                className: "h-3 w-3"
                                            }),
                                            "Manage tags"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: "mr-1 text-[10px] font-bold uppercase tracking-wider text-muted",
                                        children: "Strategy"
                                    }),
                                    [
                                        'ALL',
                                        ...strategyOptions
                                    ].map((strategy)=>/*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setStrategyFilter(strategy),
                                            className: `rounded-full border px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider transition-colors ${strategyFilter === strategy ? 'border-neon/40 bg-neon/15 text-neon' : 'border-white/10 bg-white/5 text-white/55 hover:border-white/20 hover:text-white'}`,
                                            children: strategy === 'ALL' ? 'All strategies' : strategy
                                        }, strategy)),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: "mx-1 hidden h-4 w-px bg-white/10 sm:block"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "mr-1 text-[10px] font-bold uppercase tracking-wider text-muted",
                                children: "Asset"
                            }),
                            (0, $aNXfT.securityTypeOptions).map((option)=>/*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setSecurityTypeFilter(option.value),
                                    className: `rounded-full border px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider transition-colors ${securityTypeFilter === option.value ? 'border-neon/40 bg-neon/15 text-neon' : 'border-white/10 bg-white/5 text-white/55 hover:border-white/20 hover:text-white'}`,
                                    children: option.label
                                }, option.value))
                        ]
                    }),
                    activeTab === 'positions' ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8ebd43a4f61e78b3$export$2e2bcd8739ae039), {
                        positions: filteredPositions,
                        hasAnyPositions: displayedPositions.length > 0,
                        positionsSucceeded: positions?.success === true,
                        loading: loading,
                        refreshing: refreshing,
                        error: error,
                        lastUpdated: lastUpdated,
                        accountCurrency: accountCurrency,
                        stale: positionsStale,
                        snapshotAvailable: positionsSnapshotAvailable,
                        initializing: positionsInitializing,
                        connectionUnavailable: positions?.data?.connection_status === 'unavailable',
                        onRetry: ()=>void fetchPositions(),
                        onClosePosition: handleCloseClick,
                        onOpenPositionChart: setChartPosition,
                        onEditPositionTags: openPositionTagEditor
                    }) : /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "animate-in fade-in slide-in-from-bottom-2 duration-300",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $6cb2621c04b4f142$export$2e2bcd8739ae039), {
                                refreshInterval: refreshInterval,
                                onEditOrder: onEditOrder,
                                securityTypeFilter: securityTypeFilter
                            }, `open-orders-${securityTypeFilter}`),
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $3f5d8c5cc66508fa$export$2e2bcd8739ae039), {
                                refreshInterval: refreshInterval,
                                securityTypeFilter: securityTypeFilter
                            }, `filled-orders-${securityTypeFilter}`)
                        ]
                    })
                ]
            }),
            chartPosition && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $55948ac21f10399f$export$2e2bcd8739ae039), {
                position: chartPosition,
                onClose: ()=>setChartPosition(null)
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $d81cfede2e2371fc$export$2e2bcd8739ae039), {
                state: tagManagement,
                strategyNameOptions: strategyNameOptions
            }),
            pendingCloseDraft && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $g9vEp.default), {
                children: /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "fixed inset-0 z-1000 flex items-center justify-center bg-black/55 p-0 backdrop-blur-xs animate-in fade-in duration-300 sm:p-4",
                    onClick: (event)=>{
                        if (event.target === event.currentTarget) handleCancelClose();
                    },
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-label": `Close ${pendingCloseDraft.symbol}`,
                    children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "relative max-h-dvh w-full max-w-2xl overflow-y-auto animate-in zoom-in duration-300 sm:max-h-[calc(100vh-2rem)]",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                type: "button",
                                onClick: handleCancelClose,
                                "aria-label": "Close order modal",
                                title: "Close",
                                className: "absolute right-3 top-3 z-10 rounded-lg p-2 text-white/50 transition-colors hover:bg-white/10 hover:text-white",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                                    className: "h-4 w-4"
                                })
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $d9e214164e7fb7a2$export$2e2bcd8739ae039), {
                                prefillOrder: pendingCloseDraft,
                                inModal: true,
                                showCancelButton: true,
                                onCancel: handleCancelClose,
                                onOrderSubmitted: handleCloseOrderSubmitted
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $5e09a53f0c6f1a36$export$2e2bcd8739ae039 = $5e09a53f0c6f1a36$var$PositionsOrdersPanel;



var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $zs3Np = parcelRequire("zs3Np");

var $gQIZx = parcelRequire("gQIZx");
var $7i2bY = parcelRequire("7i2bY");
var $jxNNZ = parcelRequire("jxNNZ");
var $e5esH = parcelRequire("e5esH");
var $gNGY5 = parcelRequire("gNGY5");
var $jQze5 = parcelRequire("jQze5");
parcelRequire("2Mt3i");
var $4YGkM = parcelRequire("4YGkM");

var $lRLyZ = parcelRequire("lRLyZ");
const $f5d1493564b0f8f7$var$SignalLogPanel = ({ fullBleed: fullBleed = false })=>{
    const [signals, setSignals] = (0, $jHEir.useState)([]);
    const [loading, setLoading] = (0, $jHEir.useState)(true);
    const [strategy, setStrategy] = (0, $jHEir.useState)('');
    const [symbol, setSymbol] = (0, $jHEir.useState)('');
    const [limit, setLimit] = (0, $jHEir.useState)(50);
    const [expandedId, setExpandedId] = (0, $jHEir.useState)(null);
    const fetchSignals = (0, $jHEir.useCallback)(async ()=>{
        setLoading(true);
        try {
            const response = await (0, $zs3Np.tradingApi).getStrategySignals({
                strategy: strategy || undefined,
                symbol: symbol || undefined,
                limit: limit
            });
            if (response && response.success) setSignals(response.data ?? []);
        } catch (err) {
            console.error('Failed to fetch signals:', err);
        } finally{
            setLoading(false);
        }
    }, [
        strategy,
        symbol,
        limit
    ]);
    (0, $jHEir.useEffect)(()=>{
        fetchSignals();
        // Poll every 30s if looking at recent signals
        const id = setInterval(fetchSignals, 30000);
        return ()=>clearInterval(id);
    }, [
        fetchSignals
    ]);
    const getSignalColor = (signal)=>{
        switch(signal){
            case 'BUY':
                return 'text-emerald-400 bg-emerald-500/10 border-emerald-500/20';
            case 'SELL':
                return 'text-red-400 bg-red-500/10 border-red-500/20';
            default:
                return 'text-gray-400 bg-white/5 border-white/10';
        }
    };
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: `panel flex flex-col h-[600px] ${fullBleed ? 'full-bleed-panel' : ''}`,
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "p-4 border-b border-white/10 bg-white/5 flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $gQIZx.default), {
                                className: "w-5 h-5 text-neon"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("h2", {
                                className: "text-md font-semibold text-white",
                                children: "Signal History"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "text-xs text-muted ml-2",
                                children: "Audit trail of strategy decisions"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4YGkM.CustomSelect), {
                                value: strategy,
                                onChange: setStrategy,
                                options: [
                                    {
                                        value: '',
                                        label: 'All Strategies'
                                    },
                                    {
                                        value: 'ON',
                                        label: 'Overnight (ON)'
                                    },
                                    {
                                        value: 'ORB',
                                        label: 'ORB'
                                    },
                                    {
                                        value: 'DT',
                                        label: 'Day Trade (DT)'
                                    },
                                    {
                                        value: 'NQMM',
                                        label: 'Nasdaq Momentum (NQMM)'
                                    }
                                ],
                                buttonClassName: "bg-surface border-white/10 rounded-lg px-3 py-1 text-xs text-foreground h-8",
                                className: "min-w-[150px]",
                                align: "right",
                                ariaLabel: "Strategy filter"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                type: "text",
                                placeholder: "Symbol...",
                                value: symbol,
                                onChange: (e)=>setSymbol(e.target.value.toUpperCase()),
                                className: "bg-surface border border-white/10 rounded-lg px-3 py-1 text-xs text-foreground w-24 outline-hidden focus:border-neon/50"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                onClick: fetchSignals,
                                className: "p-1.5 rounded-lg hover:bg-white/10 text-muted transition",
                                title: "Refresh",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jQze5.default), {
                                    className: "w-4 h-4"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "flex-1 overflow-y-auto scrollbar-thin",
                children: loading && signals.length === 0 ? /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "flex items-center justify-center p-12",
                    children: /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "animate-spin rounded-full h-8 w-8 border-b-2 border-neon"
                    })
                }) : signals.length === 0 ? /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex flex-col items-center justify-center p-12 text-muted",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $gNGY5.default), {
                            className: "w-8 h-8 mb-2 opacity-20"
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                            children: "No signals found matching filters."
                        })
                    ]
                }) : /*#__PURE__*/ (0, $eHRxX.jsxs)("table", {
                    className: "w-full text-left border-collapse",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("thead", {
                            className: "sticky top-0 bg-surface/90 backdrop-blur-md z-10",
                            children: /*#__PURE__*/ (0, $eHRxX.jsxs)("tr", {
                                className: "text-[10px] uppercase tracking-wider text-muted border-b border-white/5",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                        className: "px-4 py-3 font-semibold",
                                        children: "Time (NY)"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                        className: "px-4 py-3 font-semibold",
                                        children: "Strategy"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                        className: "px-4 py-3 font-semibold",
                                        children: "Symbol"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                        className: "px-4 py-3 font-semibold",
                                        children: "Signal"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                        className: "px-4 py-3 font-semibold",
                                        children: "Price"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                        className: "px-4 py-3 font-semibold",
                                        children: "Execution"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                        className: "px-4 py-3 font-semibold"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("tbody", {
                            className: "text-xs divide-y divide-white/5",
                            children: signals.map((sig)=>/*#__PURE__*/ (0, $eHRxX.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("tr", {
                                            className: `group hover:bg-white/5 transition-colors cursor-pointer ${expandedId === sig.id ? 'bg-white/5' : ''}`,
                                            onClick: ()=>setExpandedId(expandedId === sig.id ? null : sig.id),
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                    className: "px-4 py-3 text-muted whitespace-nowrap font-mono text-[11px]",
                                                    children: (0, $lRLyZ.formatDateTimeET)(sig.timestamp)
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                    className: "px-4 py-3 font-medium text-foreground",
                                                    children: sig.strategy
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                    className: "px-4 py-3",
                                                    children: /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "px-2 py-0.5 rounded-sm bg-white/5 font-mono text-white/80",
                                                        children: sig.symbol
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                    className: "px-4 py-3",
                                                    children: /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: `px-2 py-0.5 rounded-full border text-[10px] font-bold ${getSignalColor(sig.signal)}`,
                                                        children: sig.signal
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsxs)("td", {
                                                    className: "px-4 py-3 font-mono text-muted",
                                                    children: [
                                                        "$",
                                                        sig.price?.toFixed(2) || '---'
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                    className: "px-4 py-3",
                                                    children: sig.was_executed ? /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                        className: "flex items-center gap-1 text-emerald-400",
                                                        children: [
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7i2bY.default), {
                                                                className: "w-3.5 h-3.5"
                                                            }),
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                className: "text-[10px] font-semibold uppercase tracking-tighter",
                                                                children: "Filled"
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "text-muted text-[10px] uppercase tracking-tighter opacity-50",
                                                        children: "Log Only"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                    className: "px-4 py-3 text-right",
                                                    children: expandedId === sig.id ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $e5esH.default), {
                                                        className: "w-4 h-4 text-muted"
                                                    }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jxNNZ.default), {
                                                        className: "w-4 h-4 text-muted opacity-0 group-hover:opacity-100"
                                                    })
                                                })
                                            ]
                                        }),
                                        expandedId === sig.id && /*#__PURE__*/ (0, $eHRxX.jsx)("tr", {
                                            className: "bg-white/5 border-x-2 border-neon/20",
                                            children: /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                colSpan: 7,
                                                className: "px-8 py-4",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                    className: "space-y-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                            className: "flex items-start justify-between",
                                                            children: [
                                                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                                            className: "text-[10px] uppercase text-muted mb-1 font-bold tracking-widest",
                                                                            children: "Reason"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                                            className: "text-foreground text-sm leading-relaxed",
                                                                            children: sig.reason || 'N/A'
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                                    className: "text-right",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                                            className: "text-[10px] uppercase text-muted mb-1 font-bold tracking-widest",
                                                                            children: "Signal ID"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                                            className: "text-muted font-mono",
                                                                            children: sig.id
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        sig.metadata_json && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                                    className: "text-[10px] uppercase text-muted mb-2 font-bold tracking-widest",
                                                                    children: "Technical Metadata"
                                                                }),
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                                    className: "grid grid-cols-2 md:grid-cols-4 gap-4 p-3 rounded-xl bg-black/40 border border-white/5 border-dashed",
                                                                    children: Object.entries(sig.metadata_json).map(([k, v])=>typeof v !== 'object' ? /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                                                    className: "text-[9px] text-muted-foreground uppercase opacity-70 mb-0.5",
                                                                                    children: k.replace(/_/g, ' ')
                                                                                }),
                                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                                                    className: "font-mono text-white/90",
                                                                                    children: typeof v === 'number' ? v.toFixed(4) : String(v)
                                                                                })
                                                                            ]
                                                                        }, k) : null)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }, sig.id))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "p-3 border-t border-white/10 bg-surface/50 flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("p", {
                        className: "text-[10px] text-muted italic",
                        children: [
                            "Showing latest ",
                            signals.length,
                            " evaluations"
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "text-[10px] text-muted uppercase font-bold pr-1",
                                children: "Show"
                            }),
                            [
                                25,
                                50,
                                100
                            ].map((val)=>/*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                    onClick: ()=>setLimit(val),
                                    className: `w-7 h-7 rounded-sm flex items-center justify-center text-[10px] font-bold border transition ${limit === val ? 'bg-neon/20 border-neon/40 text-neon' : 'bg-white/5 border-white/10 text-muted hover:text-white'}`,
                                    children: val
                                }, val))
                        ]
                    })
                ]
            })
        ]
    });
};
var $f5d1493564b0f8f7$export$2e2bcd8739ae039 = $f5d1493564b0f8f7$var$SignalLogPanel;



var $eHRxX = parcelRequire("eHRxX");

var $62Hcf = parcelRequire("62Hcf");

var $jHEir = parcelRequire("jHEir");

var $jr1gO = parcelRequire("jr1gO");
var $4bqNy = parcelRequire("4bqNy");/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $91ab4dae2bd958d3$export$a2387ed3b5d536eb = {
    name: "code",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m16 18 6-6-6-6",
                key: "eg8j8"
            }
        ],
        [
            "path",
            {
                d: "m8 6-6 6 6 6",
                key: "ppft3o"
            }
        ]
    ]
};
$91ab4dae2bd958d3$export$a2387ed3b5d536eb.node;
const $91ab4dae2bd958d3$export$2e2bcd8739ae039 = (0, $hHhnY.default)($91ab4dae2bd958d3$export$a2387ed3b5d536eb);


var $kdxJz = parcelRequire("kdxJz");
var $1RsxC = parcelRequire("1RsxC");
var $4nVaN = parcelRequire("4nVaN");
var $8F6u8 = parcelRequire("8F6u8");
var $84yk3 = parcelRequire("84yk3");
var $eC2xp = parcelRequire("eC2xp");

var $zs3Np = parcelRequire("zs3Np");

var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");
const $3840d020e4b1745f$var$isConfigObject = (value)=>value !== null && typeof value === 'object' && !Array.isArray(value);
const $3840d020e4b1745f$var$StrategyConfigPreview = ({ config: config })=>{
    const symbols = Array.isArray(config.symbols) ? config.symbols : [];
    const hasSymbols = Boolean(config.symbols);
    const symbolConfig = $3840d020e4b1745f$var$isConfigObject(config.symbol_config) ? config.symbol_config : {};
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "ux-scrollbar h-full overflow-y-auto pr-3 space-y-5",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "p-5 rounded-2xl bg-white/5 border border-white/10",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-2 mb-4",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "w-1.5 h-1.5 rounded-full bg-blue-400"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("h4", {
                                className: "text-sm text-blue-400 uppercase font-black tracking-[0.2em]",
                                children: "Global Control Deck"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-3",
                        children: Object.entries(config).map(([key, value])=>{
                            if (key === 'symbol_config' || key === 'symbols' || typeof value === 'object') return null;
                            const isLeverage = key === 'leverage' || key === 'position_size';
                            return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex justify-between items-center py-2 border-b border-white/5 last:border-0 group overflow-hidden",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: `text-sm font-bold tracking-tight break-all mr-4 ${isLeverage ? 'text-blue-300' : 'text-white/40 group-hover:text-white/60 transition-colors'}`,
                                        children: key
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: "flex-shrink-0 flex items-center gap-2",
                                        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                            className: `text-sm font-mono font-bold ${isLeverage ? 'text-neon px-2 py-0.5 bg-neon/10 rounded-sm border border-neon/20' : 'text-white/80'}`,
                                            children: [
                                                typeof value === 'boolean' ? value ? 'ACTIVE' : 'INERT' : String(value),
                                                isLeverage ? 'x' : ''
                                            ]
                                        })
                                    })
                                ]
                            }, key);
                        })
                    })
                ]
            }),
            hasSymbols && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "p-5 rounded-2xl bg-white/5 border border-white/10",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-2 mb-4",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "w-1.5 h-1.5 rounded-full bg-neon shadow-[0_0_8px_var(--neon)]"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("h4", {
                                className: "text-sm text-neon uppercase font-black tracking-[0.2em]",
                                children: "Authorized Tickertape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "flex flex-wrap gap-2.5",
                        children: symbols.map((symbol, index)=>/*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "px-4 py-1.5 bg-neon/5 text-neon text-xs font-black rounded-lg border border-neon/20 tracking-tighter",
                                children: String(symbol)
                            }, `${String(symbol)}-${index}`))
                    })
                ]
            }),
            Object.keys(symbolConfig).length > 0 && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "p-5 rounded-2xl bg-white/5 border border-white/10",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-2 mb-5",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "w-1.5 h-1.5 rounded-full bg-amber-400"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("h4", {
                                className: "text-sm text-amber-400 uppercase font-black tracking-[0.2em]",
                                children: "Symbol Overrides"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "grid grid-cols-1 gap-4",
                        children: Object.entries(symbolConfig).map(([symbol, value])=>{
                            const overrides = $3840d020e4b1745f$var$isConfigObject(value) ? value : {};
                            return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "p-4 rounded-xl bg-black/30 border border-white/5 hover:border-white/10 transition-colors",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center space-x-3 mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "text-sm font-black text-white tracking-widest leading-none",
                                                children: symbol
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: "h-px grow bg-white/10"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: "grid grid-cols-2 gap-x-8 gap-y-1.5",
                                        children: Object.entries(overrides).map(([key, override])=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex justify-between items-center text-xs overflow-hidden",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "text-white/30 font-bold uppercase tracking-widest break-all mr-4",
                                                        children: key
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        className: "text-white/90 font-mono font-bold flex-shrink-0",
                                                        children: [
                                                            String(override),
                                                            key === 'leverage' ? 'x' : ''
                                                        ]
                                                    })
                                                ]
                                            }, key))
                                    })
                                ]
                            }, symbol);
                        })
                    })
                ]
            })
        ]
    });
};
var $3840d020e4b1745f$export$2e2bcd8739ae039 = $3840d020e4b1745f$var$StrategyConfigPreview;


const $7d5ccc9a550e2e99$var$isConfigObject = (value)=>value !== null && typeof value === 'object' && !Array.isArray(value);
const $7d5ccc9a550e2e99$var$normalizeBySchema = (current, schema)=>{
    if (Array.isArray(schema)) return Array.isArray(current) ? current : schema;
    if (!$7d5ccc9a550e2e99$var$isConfigObject(schema)) return current !== undefined ? current : schema;
    const result = {};
    Object.entries(schema).forEach(([key, schemaValue])=>{
        const currentValue = $7d5ccc9a550e2e99$var$isConfigObject(current) && Object.prototype.hasOwnProperty.call(current, key) ? current[key] : undefined;
        result[key] = $7d5ccc9a550e2e99$var$normalizeBySchema(currentValue, schemaValue);
    });
    return result;
};
const $7d5ccc9a550e2e99$var$normalizeSymbolConfig = (currentConfig, schemaConfig, symbols)=>{
    if (!$7d5ccc9a550e2e99$var$isConfigObject(schemaConfig)) return currentConfig || {};
    const schemaSymbols = Object.keys(schemaConfig);
    const template = schemaSymbols.length > 0 ? schemaConfig[schemaSymbols[0]] : {};
    const targetSymbols = symbols.length > 0 ? symbols.map(String) : schemaSymbols;
    const currentBySymbol = $7d5ccc9a550e2e99$var$isConfigObject(currentConfig) ? currentConfig : {};
    return targetSymbols.reduce((result, symbol)=>{
        const symbolSchema = schemaConfig[symbol] || template;
        result[symbol] = $7d5ccc9a550e2e99$var$normalizeBySchema(currentBySymbol[symbol], symbolSchema);
        return result;
    }, {});
};
const $7d5ccc9a550e2e99$var$normalizePositionSizes = (currentSizes, schemaSizes, symbols)=>{
    if (!$7d5ccc9a550e2e99$var$isConfigObject(schemaSizes)) return currentSizes || {};
    const targetSymbols = symbols.length > 0 ? symbols.map(String) : Object.keys(schemaSizes);
    const currentBySymbol = $7d5ccc9a550e2e99$var$isConfigObject(currentSizes) ? currentSizes : {};
    return targetSymbols.reduce((result, symbol)=>{
        if (Object.prototype.hasOwnProperty.call(currentBySymbol, symbol)) result[symbol] = currentBySymbol[symbol];
        else if (Object.prototype.hasOwnProperty.call(schemaSizes, symbol)) result[symbol] = schemaSizes[symbol];
        return result;
    }, {});
};
const $7d5ccc9a550e2e99$export$992e8ffd1033aa08 = (current, schema)=>{
    if (!$7d5ccc9a550e2e99$var$isConfigObject(schema)) return current;
    const normalized = $7d5ccc9a550e2e99$var$normalizeBySchema(current, schema);
    const symbols = Array.isArray(normalized.symbols) ? normalized.symbols : Array.isArray(schema.symbols) ? schema.symbols : [];
    const currentConfig = $7d5ccc9a550e2e99$var$isConfigObject(current) ? current : {};
    if (schema.symbol_config) normalized.symbol_config = $7d5ccc9a550e2e99$var$normalizeSymbolConfig(currentConfig.symbol_config, schema.symbol_config, symbols);
    if (schema.position_sizes) normalized.position_sizes = $7d5ccc9a550e2e99$var$normalizePositionSizes(currentConfig.position_sizes, schema.position_sizes, symbols);
    return normalized;
};


const $0fe4eaa15babde57$var$StrategyConfigPanel = ({ strategyName: strategyName, onConfigChange: onConfigChange, readOnly: readOnly = false, fullBleed: fullBleed = false })=>{
    const [configJson, setConfigJson] = (0, $jHEir.useState)('');
    const [isEnabled, setIsEnabled] = (0, $jHEir.useState)(false);
    const [loading, setLoading] = (0, $jHEir.useState)(true);
    const [saving, setSaving] = (0, $jHEir.useState)(false);
    const [error, setError] = (0, $jHEir.useState)(null);
    const [success, setSuccess] = (0, $jHEir.useState)(null);
    const [isPreview, setIsPreview] = (0, $jHEir.useState)(readOnly);
    const [showHistory, setShowHistory] = (0, $jHEir.useState)(false);
    const [jsonError, setJsonError] = (0, $jHEir.useState)(null);
    const [version, setVersion] = (0, $jHEir.useState)(null);
    const [updatedAt, setUpdatedAt] = (0, $jHEir.useState)(null);
    const [history, setHistory] = (0, $jHEir.useState)([]);
    const [historyLoading, setHistoryLoading] = (0, $jHEir.useState)(false);
    const [configSchema, setConfigSchema] = (0, $jHEir.useState)(null);
    const validateJson = (0, $jHEir.useCallback)((val)=>{
        try {
            JSON.parse(val);
            setJsonError(null);
            return true;
        } catch (validationError) {
            setJsonError(validationError instanceof Error ? validationError.message : 'Invalid JSON');
            return false;
        }
    }, []);
    const fetchHistory = (0, $jHEir.useCallback)(async ()=>{
        setHistoryLoading(true);
        try {
            const res = await (0, $zs3Np.tradingApi).getStrategyDbConfigHistory(strategyName);
            if (res.success) setHistory(res.data?.history || []);
        } catch (err) {
            console.error("Failed to fetch history:", err);
        } finally{
            setHistoryLoading(false);
        }
    }, [
        strategyName
    ]);
    const fetchConfig = (0, $jHEir.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $zs3Np.tradingApi).getStrategyDbConfig(strategyName);
            if (response.success && response.data) {
                const config = response.data.config;
                setIsEnabled(config.enabled);
                setVersion(config.version || 1);
                setUpdatedAt(config.updated_at);
                setConfigSchema(config.config_schema || config.config_json || {});
                const jsonStr = JSON.stringify(config.config_json || {}, null, 2);
                setConfigJson(jsonStr);
                validateJson(jsonStr);
            } else throw new Error(response.message || 'Failed to fetch config');
        } catch (err) {
            console.warn(err);
            setError('Failed to load configuration. Strategy might not be initialized yet.');
        } finally{
            setLoading(false);
        }
    }, [
        strategyName,
        validateJson
    ]);
    (0, $jHEir.useEffect)(()=>{
        fetchConfig();
    }, [
        fetchConfig
    ]);
    (0, $jHEir.useEffect)(()=>{
        if (readOnly) {
            setIsPreview(true);
            setShowHistory(false);
        }
    }, [
        readOnly
    ]);
    (0, $jHEir.useEffect)(()=>{
        if (showHistory) fetchHistory();
    }, [
        showHistory,
        fetchHistory
    ]);
    const handleTextChange = (val)=>{
        setConfigJson(val);
        validateJson(val);
    };
    const handleFormat = ()=>{
        try {
            const parsed = JSON.parse(configJson);
            const formatted = JSON.stringify((0, $7d5ccc9a550e2e99$export$992e8ffd1033aa08)(parsed, configSchema), null, 2);
            setConfigJson(formatted);
            setJsonError(null);
        } catch  {
            setError('Cannot format invalid JSON');
        }
    };
    const handleSave = async ()=>{
        setSaving(true);
        setError(null);
        setSuccess(null);
        try {
            // Validate JSON
            let parsedConfig;
            try {
                parsedConfig = JSON.parse(configJson);
            } catch  {
                throw new Error('Invalid JSON format');
            }
            const res = await (0, $zs3Np.tradingApi).updateStrategyDbConfig(strategyName, {
                is_enabled: isEnabled,
                config_json: parsedConfig
            });
            const message = res?.message || res?.data?.message || 'Configuration saved successfully.';
            setSuccess(message);
            // Refresh Strategy Oversight immediately after hot reload so the
            // displayed values and pending rebalance state match the save.
            window.dispatchEvent(new CustomEvent('trading-data-refresh'));
            if (onConfigChange) onConfigChange();
        } catch (err) {
            console.warn(err);
            setError(err.message || 'Failed to save configuration');
        } finally{
            setSaving(false);
        }
    };
    const handleReset = async ()=>{
        if (!window.confirm(`Are you sure you want to reset ${strategyName} configuration to defaults? This will erase all custom settings.`)) return;
        setSaving(true);
        setError(null);
        setSuccess(null);
        try {
            const res = await (0, $zs3Np.tradingApi).resetStrategyDbConfig(strategyName);
            if (res.success) {
                setSuccess(res.message || 'Configuration reset to defaults.');
                await fetchConfig();
                window.dispatchEvent(new CustomEvent('trading-data-refresh'));
                if (onConfigChange) onConfigChange();
            } else throw new Error(res.error || res.message || 'Reset failed');
        } catch (err) {
            console.warn(err);
            setError(err.message || 'Failed to reset configuration');
        } finally{
            setSaving(false);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "flex items-center justify-center p-12 bg-white/5 rounded-2xl border border-white/10",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4nVaN.default), {
                className: "w-6 h-6 text-neon animate-spin"
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                className: "ml-3 text-muted text-sm font-medium tracking-wide italic leading-none",
                children: "Retrieving telemetry..."
            })
        ]
    });
    const renderPreview = ()=>{
        try {
            const config = JSON.parse(configJson);
            return /*#__PURE__*/ (0, $eHRxX.jsx)((0, $3840d020e4b1745f$export$2e2bcd8739ae039), {
                config: config
            });
        } catch  {
            return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex flex-col items-center justify-center h-80 bg-error-500/5 rounded-xl border border-dashed border-error-500/20",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jr1gO.default), {
                        className: "w-8 h-8 text-error-500 mb-3 opacity-50"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                        className: "text-error-500 text-sm font-bold uppercase tracking-widest mb-2",
                        children: "Malformed JSON Buffer"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $62Hcf.ThemeButton), {
                        variant: "ghost",
                        size: "xs",
                        onClick: ()=>setIsPreview(false),
                        className: "uppercase",
                        children: "Return to Source Editor"
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: `panel fade-in ${fullBleed ? 'full-bleed-panel' : ''}`,
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "px-4 py-4 border-b border-white/10 flex items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-2.5 min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "p-1.5 rounded-lg bg-neon/10 text-neon shadow-[0_0_10px_rgba(92,246,205,0.1)] flex-shrink-0",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $eC2xp.default), {
                                    className: "w-4 h-4"
                                })
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("h2", {
                                        className: "text-sm font-bold text-white tracking-tight leading-tight truncate",
                                        children: [
                                            strategyName,
                                            " ",
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "text-muted font-normal text-xs",
                                                children: "Config"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                        className: "text-[9px] text-muted uppercase font-black tracking-[0.15em] mt-0.5 truncate",
                                        children: "Parameters & Overrides"
                                    })
                                ]
                            })
                        ]
                    }),
                    !readOnly && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex-shrink-0 flex items-center p-1 bg-white/5 border border-white/10 rounded-lg",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                onClick: ()=>setIsPreview(false),
                                title: "Edit JSON source",
                                className: `flex items-center justify-center w-7 h-7 rounded-md transition-all duration-200 ${!isPreview ? "bg-neon/10 text-neon shadow-[0_0_10px_rgba(45,212,191,0.1)]" : "text-muted hover:text-white hover:bg-white/5"}`,
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $91ab4dae2bd958d3$export$2e2bcd8739ae039), {
                                    className: "w-3.5 h-3.5"
                                })
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                onClick: ()=>{
                                    setIsPreview(false);
                                    setShowHistory(!showHistory);
                                },
                                title: "View history",
                                className: `flex items-center justify-center w-7 h-7 rounded-md transition-all duration-200 ${showHistory ? "bg-warning-500/10 text-warning-500 shadow-[0_0_10px_rgba(251,191,36,0.1)]" : "text-muted hover:text-white hover:bg-white/5"}`,
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $1RsxC.default), {
                                    className: "w-3.5 h-3.5"
                                })
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                onClick: ()=>{
                                    setShowHistory(false);
                                    setIsPreview(true);
                                },
                                title: "Preview config",
                                className: `flex items-center justify-center w-7 h-7 rounded-md transition-all duration-200 ${isPreview && !showHistory ? "bg-neon/10 text-neon shadow-[0_0_10px_rgba(45,212,191,0.1)]" : "text-muted hover:text-white hover:bg-white/5"}`,
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $kdxJz.default), {
                                    className: "w-3.5 h-3.5"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "px-6 py-2 bg-white/5 border-b border-white/5 flex items-center justify-between",
                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                            className: "text-[10px] font-black uppercase tracking-widest text-white/40",
                            children: [
                                "Version ",
                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                    className: "text-neon",
                                    children: version
                                })
                            ]
                        }),
                        updatedAt && /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                            className: "text-[10px] font-black uppercase tracking-widest text-white/40",
                            children: [
                                "Last Modified ",
                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                    className: "text-white/60",
                                    children: new Date(updatedAt).toLocaleString()
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "p-6",
                children: !isPreview && !showHistory ? /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "flex justify-between items-end mb-1",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                    className: "flex items-center space-x-2 px-1",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                            className: `w-1.5 h-1.5 rounded-full ${jsonError ? 'bg-error-500 animate-pulse' : 'bg-neon shadow-[0_0_5px_var(--neon)]'}`
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            className: `text-[10px] font-black uppercase tracking-widest ${jsonError ? 'text-error-500' : 'text-neon opacity-80'}`,
                                            children: jsonError ? 'Integrity Check Failed' : 'JSON Standard Compliant'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $62Hcf.ThemeButton), {
                                    variant: "secondary",
                                    size: "xs",
                                    onClick: handleFormat,
                                    className: "uppercase tracking-tighter",
                                    children: "Re-format Source"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "relative group",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("textarea", {
                                    value: configJson,
                                    onChange: (e)=>handleTextChange(e.target.value),
                                    className: `ux-scrollbar w-full h-80 bg-black/40 text-info-500/90 font-mono text-xs p-5 rounded-xl border transition-all duration-300 focus:outline-hidden ${jsonError ? 'border-error-500/30 focus:border-error-500/50' : 'border-white/5 focus:border-neon/30 focus:bg-black/60 shadow-inner'}`,
                                    spellCheck: false
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                    className: "absolute inset-0 rounded-xl pointer-events-none border border-white/5 group-hover:border-white/10 transition-colors"
                                })
                            ]
                        }),
                        jsonError && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "text-[10px] text-error-500/80 font-mono bg-error-500/5 p-3 rounded-lg border border-error-500/10 fade-in",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                    className: "text-error-500 font-bold",
                                    children: "ERROR:"
                                }),
                                " ",
                                jsonError
                            ]
                        })
                    ]
                }) : showHistory ? /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "fade-in h-80 overflow-y-auto ux-scrollbar bg-black/20 rounded-xl border border-white/5 p-4 space-y-3",
                    children: historyLoading && history.length === 0 ? /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex flex-col items-center justify-center h-full space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4nVaN.default), {
                                className: "w-5 h-5 text-neon animate-spin opacity-50"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "text-[10px] text-muted uppercase font-black tracking-widest",
                                children: "Retrieving Timeline..."
                            })
                        ]
                    }) : history.length === 0 ? /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex flex-col items-center justify-center h-full space-y-4 opacity-40",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $1RsxC.default), {
                                className: "w-8 h-8 text-muted"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "text-[10px] text-muted uppercase font-black tracking-widest",
                                children: "No previous iterations found"
                            })
                        ]
                    }) : history.map((entry, idx)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "p-4 rounded-xl bg-white/5 border border-white/5 hover:border-white/10 transition-all group",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                    className: "flex justify-between items-start mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                    className: "text-[10px] font-black text-warning-500 uppercase tracking-widest block mb-1",
                                                    children: [
                                                        "Iteration ",
                                                        entry.version
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                    className: "text-[9px] text-muted font-bold uppercase tracking-tighter italic",
                                                    children: entry.created_at ? new Date(entry.created_at).toLocaleString() : 'Timestamp unavailable'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $62Hcf.ThemeButton), {
                                            variant: "ghost",
                                            size: "xs",
                                            onClick: ()=>{
                                                setConfigJson(JSON.stringify(entry.config_json, null, 2));
                                                setShowHistory(false);
                                                setSuccess(`Version ${entry.version} restored to editor. Commit to apply.`);
                                            },
                                            className: "uppercase tracking-widest opacity-0 group-hover:opacity-100",
                                            children: "Restore"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                    className: "h-24 overflow-hidden relative rounded-lg border border-white/5 bg-black/20 p-2 cursor-pointer",
                                    onClick: ()=>{
                                        setConfigJson(JSON.stringify(entry.config_json, null, 2));
                                        setShowHistory(false);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("pre", {
                                            className: "text-[9px] font-mono text-white/30 truncate",
                                            children: JSON.stringify(entry.config_json, null, 2)
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                            className: "absolute inset-0 bg-linear-to-t from-black/60 to-transparent"
                                        })
                                    ]
                                })
                            ]
                        }, idx))
                }) : /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "fade-in h-80 overflow-hidden",
                    children: renderPreview()
                })
            }),
            (error || success) && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "px-6 pb-2",
                children: [
                    error && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "mb-4 text-error-500 text-xs font-bold bg-error-500/10 p-4 rounded-xl border border-error-500/20 flex items-center gap-3 fade-in",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jr1gO.default), {
                                className: "w-4 h-4"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                children: error
                            })
                        ]
                    }),
                    success && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "mb-4 text-neon text-xs font-bold bg-neon/5 p-4 rounded-xl border border-neon/20 flex items-center gap-3 fade-in",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4bqNy.default), {
                                className: "w-4 h-4"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                children: success
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "px-6 py-5 bg-white/2 border-t border-white/10 flex flex-wrap justify-between items-center gap-4",
                children: readOnly ? /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $62Hcf.ThemeButton), {
                    variant: "ghost",
                    size: "sm",
                    onClick: fetchConfig,
                    className: "flex items-center gap-2 uppercase tracking-widest",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4nVaN.default), {
                            className: `w-3.5 h-3.5 ${loading ? "animate-spin" : ""}`
                        }),
                        "Sync"
                    ]
                }) : /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $62Hcf.ThemeButton), {
                            variant: "danger",
                            size: "sm",
                            onClick: handleReset,
                            className: "flex items-center gap-2 uppercase tracking-widest",
                            disabled: saving,
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8F6u8.default), {
                                    className: "w-3.5 h-3.5"
                                }),
                                "Factory Reset"
                            ]
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $62Hcf.ThemeButton), {
                                    variant: "ghost",
                                    size: "sm",
                                    onClick: fetchConfig,
                                    className: "flex items-center gap-2 uppercase tracking-widest",
                                    disabled: saving,
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4nVaN.default), {
                                            className: `w-3.5 h-3.5 ${loading ? "animate-spin" : ""}`
                                        }),
                                        "Sync"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                    onClick: handleSave,
                                    disabled: saving || !!jsonError,
                                    className: `flex items-center gap-2 px-8 py-2.5 text-black text-xs font-black uppercase tracking-widest rounded-xl transition-all duration-500 shadow-[0_0_20px_rgba(92,246,205,0.1)] active:scale-95 ${saving || !!jsonError ? 'bg-white/10 text-white/30 cursor-not-allowed border border-white/10' : 'bg-neon hover:shadow-[0_0_30px_rgba(42,212,191,0.3)] hover:brightness-110'}`,
                                    children: [
                                        saving ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4nVaN.default), {
                                            className: "w-4 h-4 animate-spin text-black"
                                        }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $84yk3.default), {
                                            className: "w-4 h-4"
                                        }),
                                        saving ? 'Transmitting' : 'Commit Config'
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $0fe4eaa15babde57$export$2e2bcd8739ae039 = $0fe4eaa15babde57$var$StrategyConfigPanel;



var $eHRxX = parcelRequire("eHRxX");

var $62Hcf = parcelRequire("62Hcf");

var $jHEir = parcelRequire("jHEir");

var $j8jJ4 = parcelRequire("j8jJ4");

var $zs3Np = parcelRequire("zs3Np");

var $5ogeV = parcelRequire("5ogeV");

var $4cvdp = parcelRequire("4cvdp");

var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");
/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $5dd5a4ac1710f1a6$export$a2387ed3b5d536eb = {
    name: "calendar-x",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M8 2v3",
                key: "1ioesn"
            }
        ],
        [
            "path",
            {
                d: "M16 2v3",
                key: "otl347"
            }
        ],
        [
            "rect",
            {
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2",
                key: "h1oib"
            }
        ],
        [
            "path",
            {
                d: "M3 9h18",
                key: "1pudct"
            }
        ],
        [
            "path",
            {
                d: "m14 13-4 4",
                key: "1gib57"
            }
        ],
        [
            "path",
            {
                d: "m10 13 4 4",
                key: "153uiq"
            }
        ]
    ]
};
$5dd5a4ac1710f1a6$export$a2387ed3b5d536eb.node;
const $5dd5a4ac1710f1a6$export$2e2bcd8739ae039 = (0, $hHhnY.default)($5dd5a4ac1710f1a6$export$a2387ed3b5d536eb);


var $jxNNZ = parcelRequire("jxNNZ");
var $kdxJz = parcelRequire("kdxJz");
var $j8jJ4 = parcelRequire("j8jJ4");
var $gECFA = parcelRequire("gECFA");
var $9WswS = parcelRequire("9WswS");
var $c3l2j = parcelRequire("c3l2j");

var $lRLyZ = parcelRequire("lRLyZ");

var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");

var $4bqNy = parcelRequire("4bqNy");
var $bgvjD = parcelRequire("bgvjD");
const $50ac319971de4993$export$688c2074ab98e60 = (signal)=>{
    if (signal == null) return /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
        className: "inline-flex items-center px-2 py-0.5 rounded-sm text-[10px] font-bold bg-white/10 text-white/60 border border-white/10",
        children: "PENDING"
    });
    if (typeof signal === 'boolean') return signal ? /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
        className: "inline-flex items-center gap-1 px-2 py-0.5 rounded-sm text-[10px] font-bold bg-emerald-500/20 text-emerald-400 border border-emerald-500/30",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4bqNy.default), {
                size: 10,
                strokeWidth: 3
            }),
            " PASS"
        ]
    }) : /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
        className: "inline-flex items-center gap-1 px-2 py-0.5 rounded-sm text-[10px] font-bold bg-rose-500/20 text-rose-400 border border-rose-500/30",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                size: 10,
                strokeWidth: 3
            }),
            " FAIL"
        ]
    });
    const labels = {
        BUY: "BUY",
        SELL: "SELL",
        HOLD: "HOLD",
        SKIP: "SKIP",
        ERROR: "ERROR"
    };
    const variants = {
        BUY: "bg-emerald-500/50 text-emerald-100",
        SELL: "bg-rose-500/15 text-rose-100",
        HOLD: "bg-white/10 text-white/90",
        SKIP: "bg-white/10 text-white/90",
        ERROR: "bg-rose-500/20 text-rose-100"
    };
    const signalStr = String(signal).toUpperCase();
    const variantClass = variants[signalStr] || "bg-white/10 text-white/90";
    const label = labels[signalStr] || signalStr;
    return /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
        className: `px-2 py-0.5 rounded-sm text-[10px] font-bold uppercase tracking-wider ${variantClass}`,
        children: label
    });
};
const $50ac319971de4993$export$615c2a87f9eca3f3 = (signal)=>{
    const labels = {
        BUY: "BUY",
        SELL: "SELL",
        HOLD: "HOLD",
        BUY_PENDING: "BUY ",
        NO_POSITION: "NO POSITION"
    };
    const variants = {
        BUY: "bg-emerald-500/20 text-emerald-400 border border-emerald-500/30 ",
        SELL: "bg-rose-500/20 text-rose-400 border border-rose-500/30",
        HOLD: "bg-white/10 text-white/90",
        BUY_PENDING: "bg-emerald-500/20 text-emerald-400 border border-emerald-500/30",
        NO_POSITION: "bg-white/10 text-white/90"
    };
    const signalStr = signal || "N/A";
    const variantClass = variants[signalStr] || "bg-white/10 text-white/90";
    const label = labels[signalStr] || signalStr;
    return /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
        className: `inline-flex items-center gap-1 px-2 py-0.5 rounded-sm text-[10px] font-bold border border-emerald-500/30 ${variantClass}`,
        children: label
    });
};
const $50ac319971de4993$export$ea4a31c1561d9e94 = (side)=>{
    const labels = {
        BUY: 'BUY',
        SELL: 'SELL',
        LONG: 'LONG',
        SHORT: 'SHORT'
    };
    const variants = {
        BUY: 'bg-emerald-500/10 text-emerald-200 border border-emerald-400/30',
        SELL: 'bg-red-500/10 text-red-200 border border-red-400/30',
        LONG: 'bg-emerald-500/10 text-emerald-200 border border-emerald-400/30',
        SHORT: 'bg-red-500/10 text-red-200 border border-red-400/30'
    };
    const variantClass = variants[side?.toUpperCase()] || 'border border-line text-white/90 bg-surface';
    return /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
        className: `inline-flex items-center px-2.5 py-0.5 text-[10px] font-semibold tracking-wide uppercase ${variantClass}`,
        children: labels[side?.toUpperCase()] || side
    });
};



var $4QgfA = parcelRequire("4QgfA");

var $m1iA2 = parcelRequire("m1iA2");


var $etHUa = parcelRequire("etHUa");

var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");


var $9YmcI = parcelRequire("9YmcI");
const $3ba62f31f33453d8$var$money = (value)=>{
    const numeric = Number(value);
    return Number.isFinite(numeric) && numeric > 0 ? `$${numeric.toFixed(2)}` : "\u2014";
};
const $3ba62f31f33453d8$var$LiveStrategyPrice = ({ symbol: symbol, evaluatedPrice: evaluatedPrice, evaluatedQuote: evaluatedQuote, initialLiveQuote: initialLiveQuote, decisionPrice: decisionPrice, decisionSource: decisionSource, decisionLabel: decisionLabel, executionPrice: executionPrice, executionQuote: executionQuote, executionLabel: executionLabel, streamedQuoteOverride: streamedQuoteOverride, priceClassName: priceClassName = "text-white" })=>{
    const connectionStatus = (0, $965642ac39400a6c$export$2341ff61511dbf4b)();
    const streamedQuoteFromStore = (0, $965642ac39400a6c$export$79ae38ef14e32131)(streamedQuoteOverride === undefined ? (0, $9YmcI.quoteSubscriptionIdentifier)(symbol, evaluatedQuote) : null);
    const streamedQuote = streamedQuoteOverride === undefined ? streamedQuoteFromStore : streamedQuoteOverride;
    const separateExecutionContract = Boolean(executionPrice != null && executionQuote?.contract_key && executionQuote.contract_key !== evaluatedQuote?.contract_key);
    const streamedExecutionQuote = (0, $965642ac39400a6c$export$79ae38ef14e32131)(separateExecutionContract ? (0, $9YmcI.quoteSubscriptionIdentifier)(executionQuote?.symbol || symbol, executionQuote) : null);
    const liveQuote = streamedQuote || initialLiveQuote;
    const livePrice = liveQuote?.price ?? evaluatedPrice;
    const hasDisplayedPrice = Number.isFinite(Number(livePrice)) && Number(livePrice) > 0;
    const displayedQuote = liveQuote || evaluatedQuote;
    const presentation = (0, $9YmcI.getPricePresentation)({
        quote: displayedQuote,
        connectionStatus: connectionStatus,
        hasPrice: hasDisplayedPrice,
        streamed: Boolean(streamedQuote)
    });
    const executionPresentation = (0, $9YmcI.getPricePresentation)({
        quote: streamedExecutionQuote || executionQuote,
        connectionStatus: connectionStatus,
        hasPrice: executionPrice != null,
        streamed: Boolean(streamedExecutionQuote)
    });
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "flex flex-col items-end gap-0.5 leading-tight",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex items-center gap-1.5",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                        className: `font-semibold ${priceClassName}`,
                        children: $3ba62f31f33453d8$var$money(livePrice)
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                        className: `rounded-sm border px-1 py-0.5 text-[8px] font-bold uppercase tracking-wide ${presentation.badgeClassName}`,
                        children: presentation.status
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                className: "text-[9px] text-white/45",
                title: evaluatedQuote?.received_at || evaluatedQuote?.exchange_time || undefined,
                children: [
                    "Engine ",
                    $3ba62f31f33453d8$var$money(evaluatedPrice),
                    evaluatedQuote?.sequence != null ? ` \xb7 #${evaluatedQuote.sequence}` : ""
                ]
            }),
            decisionPrice != null && /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                className: "text-[9px] text-sky-300/70",
                title: decisionSource || undefined,
                children: [
                    decisionLabel || "Decision",
                    " ",
                    $3ba62f31f33453d8$var$money(decisionPrice)
                ]
            }),
            executionPrice != null && separateExecutionContract && /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                className: "text-[9px] text-neon/80",
                children: [
                    executionLabel || "Exec",
                    " ",
                    $3ba62f31f33453d8$var$money(streamedExecutionQuote?.price ?? executionPrice),
                    streamedExecutionQuote ? ` \xb7 ${executionPresentation.status.toLowerCase()}` : ""
                ]
            }),
            executionPrice != null && /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                className: "text-[9px] text-neon/70",
                title: executionQuote?.received_at || executionQuote?.exchange_time || undefined,
                children: [
                    separateExecutionContract ? "Sizing ref" : "Exec ref",
                    " ",
                    $3ba62f31f33453d8$var$money(executionPrice),
                    executionQuote?.sequence != null ? ` \xb7 #${executionQuote.sequence}` : ""
                ]
            })
        ]
    });
};
var $3ba62f31f33453d8$export$2e2bcd8739ae039 = $3ba62f31f33453d8$var$LiveStrategyPrice;


const $96b761dca47c06cb$var$ONStrategyContent = ({ onStatus: onStatus, handleStrategyToggle: handleStrategyToggle, strategyToggleLoading: strategyToggleLoading })=>{
    const [showRules, setShowRules] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(false);
    const [expandedSymbol, setExpandedSymbol] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(null);
    const [showConfigModal, setShowConfigModal] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(false);
    if (!onStatus) return null;
    const hasData = !!onStatus.data;
    const onData = onStatus.data;
    const latestOnTimestamp = onData && onData.timestamp ? (0, $lRLyZ.formatDateTimeET)(onData.timestamp) : null;
    const onEnabled = hasData ? onStatus.data?.enabled : false;
    const toggleState = strategyToggleLoading.ON;
    const onPositions = onData?.positions || {};
    const onPositionEntries = Object.entries(onPositions).filter(([, qty])=>typeof qty === "number" && qty !== 0);
    const onPositionMeta = onData?.position || {};
    const symbolStatus = onData?.symbol_status || {};
    return /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex items-center justify-between mb-2",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-2 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "text-muted",
                                children: "Strategy"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "font-semibold text-foreground",
                                children: "ON"
                            }),
                            onData?.version && /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                className: "px-1.5 py-0.5 rounded-md bg-white/5 border border-white/10 text-[10px] text-muted font-mono",
                                title: "Strategy Logic Version",
                                children: [
                                    "v",
                                    onData.version
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                        onClick: ()=>handleStrategyToggle("ON", onEnabled),
                        disabled: !!toggleState,
                        "aria-busy": !!toggleState,
                        className: `min-w-[104px] justify-center px-3 py-1.5 rounded-lg font-semibold uppercase flex text-sm items-center gap-1 transition disabled:cursor-wait disabled:opacity-80 ${toggleState ? "bg-amber-400/10 text-amber-300 border border-amber-400/20" : onEnabled ? "bg-neon-soft text-neon" : "text-muted hover:text-foreground hover:bg-white/10"}`,
                        children: [
                            toggleState ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                                size: 14,
                                className: "animate-spin"
                            }) : onEnabled ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $gECFA.default), {
                                size: 14
                            }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $9WswS.default), {
                                size: 14
                            }),
                            toggleState === "starting" ? "Starting" : toggleState === "pausing" ? "Pausing" : onEnabled ? "Pause" : "Start"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "text-foreground",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                        onClick: ()=>setShowRules(!showRules),
                        className: "flex items-center gap-2 mb-4 px-4 py-2 rounded-xl bg-white/5 border border-white/10 text-[11px] font-black uppercase tracking-[0.2em] text-muted hover:text-white hover:bg-white/10 transition-all shadow-inner group",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: `p-1 rounded-md transition-all ${showRules ? 'bg-neon/20 text-neon' : 'bg-white/10 text-white/40 group-hover:text-white'}`,
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $c3l2j.default), {
                                    size: 14,
                                    className: showRules ? 'animate-pulse' : ''
                                })
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                children: [
                                    showRules ? 'Hide' : 'Show',
                                    " Strategy Conditions & Rules"
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: `ml-auto transition-transform duration-300 ${showRules ? 'rotate-180 text-neon' : ''}`,
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)("svg", {
                                    width: "12",
                                    height: "12",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "3",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: /*#__PURE__*/ (0, $eHRxX.jsx)("path", {
                                        d: "m6 9 6 6 6-6"
                                    })
                                })
                            })
                        ]
                    }),
                    showRules && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2 mb-6 animate-in fade-in slide-in-from-top-2 duration-300",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "p-4 rounded-2xl bg-white/5 border border-white/10 space-y-3 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-1",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: "p-1.5 rounded-lg bg-neon/10 text-neon",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $c3l2j.default), {
                                                    size: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("h4", {
                                                className: "text-xs font-bold uppercase tracking-wider text-white/90",
                                                children: "Entry Conditions"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("ul", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-neon/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        children: [
                                                            "Price must be above ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "SMA30"
                                                            }),
                                                            " and ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "SMA200"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-neon/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        children: [
                                                            "Entry window: ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "15:55 - 16:00 ET"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "p-4 rounded-2xl bg-white/5 border border-white/10 space-y-3 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-1",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: "p-1.5 rounded-lg bg-amber-500/10 text-amber-400",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $5dd5a4ac1710f1a6$export$2e2bcd8739ae039), {
                                                    size: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("h4", {
                                                className: "text-xs font-bold uppercase tracking-wider text-white/90",
                                                children: "Market Closure Rules"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("ul", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-amber-400/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-amber-400/90",
                                                                children: "No Entry"
                                                            }),
                                                            " if tomorrow is a ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "Weekend"
                                                            }),
                                                            " or ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "Holiday"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-amber-400/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        children: [
                                                            "Positions are liquidated at ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "09:30 ET"
                                                            }),
                                                            " next trading day"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "mt-4 rounded-2xl bg-white/6 text-sm text-foreground",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex flex-col gap-3 mb-3 sm:flex-row sm:items-center sm:justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex flex-wrap items-center gap-3 min-w-0",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                                className: "text-sm font-semibold text-neon",
                                                children: "Signal Analysis"
                                            }),
                                            onData?.config_source && /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>setShowConfigModal(true),
                                                className: `inline-flex min-h-7 shrink-0 items-center gap-1.5 rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-wider transition-colors ${onData.config_source === 'USER' ? 'bg-neon/10 text-neon border border-neon/20' : 'bg-white/5 text-muted border border-white/10'} hover:bg-white/10 hover:text-white`,
                                                title: "View current ON strategy setup",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $kdxJz.default), {
                                                        className: "h-3.5 w-3.5"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "whitespace-nowrap",
                                                        children: onData.config_source === 'USER' ? 'User Config' : 'System Default'
                                                    }),
                                                    onData.config_version && /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        className: "whitespace-nowrap",
                                                        children: [
                                                            "v",
                                                            onData.config_version
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    latestOnTimestamp && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "px-3 py-1.5 rounded-xl bg-white/5 border border-white/10 flex flex-wrap items-center gap-2 self-start sm:self-auto",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "text-[10px] text-muted uppercase font-bold tracking-wider",
                                                children: "Latest Data"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "text-[11px] text-white font-semibold",
                                                children: latestOnTimestamp
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "overflow-x-auto scrollbar-thin rounded-xl border border-white/5 bg-surface",
                                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("table", {
                                    className: "min-w-full divide-y divide-white/10 text-[13px] text-foreground",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("thead", {
                                            className: "bg-black/60",
                                            children: /*#__PURE__*/ (0, $eHRxX.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Symbol"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Signal"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Technical"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Trading Day"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Price"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                        children: "SMAs (S/L)"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Size"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Lev"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Reason"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("tbody", {
                                            className: "divide-y divide-white/5",
                                            children: Object.keys(symbolStatus).length === 0 ? /*#__PURE__*/ (0, $eHRxX.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("td", {
                                                    colSpan: 9,
                                                    className: "px-3 py-4 text-center text-muted",
                                                    children: [
                                                        hasData ? "Market closed or no scan data available" : "Strategy offline",
                                                        onStatus.error && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                            className: "text-rose-400 mt-1",
                                                            children: onStatus.error
                                                        })
                                                    ]
                                                })
                                            }) : Object.keys(symbolStatus).map((symbol)=>{
                                                const data = symbolStatus[symbol];
                                                const isExpanded = expandedSymbol === symbol;
                                                const currentPrice = Number(data?.current_price);
                                                const smaShort = Number(data?.sma_short);
                                                const smaLong = Number(data?.sma_long);
                                                const isSignalLevel = (0, $etHUa.hasFreshLevels)(data, onData?.levels_date || onData?.timestamp) && (0, $etHUa.isValidPriceLevel)(currentPrice) && (0, $etHUa.isValidPriceLevel)(smaShort) && (0, $etHUa.isValidPriceLevel)(smaLong) && currentPrice > smaShort && currentPrice > smaLong;
                                                if (!data || Object.keys(data).length === 0) return /*#__PURE__*/ (0, $eHRxX.jsxs)("tr", {
                                                    className: "hover:bg-white/5 transition-colors",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                            className: "px-3 py-2 font-medium text-foreground",
                                                            children: symbol
                                                        }),
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                            colSpan: 8,
                                                            className: "px-3 py-2 text-muted italic",
                                                            children: "No data available"
                                                        })
                                                    ]
                                                }, symbol);
                                                return /*#__PURE__*/ (0, $eHRxX.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("tr", {
                                                            className: `transition-colors cursor-pointer ${isSignalLevel ? "bg-emerald-500/15 hover:bg-emerald-500/20 ring-1 ring-inset ring-emerald-400/20" : "hover:bg-white/5"}`,
                                                            onClick: ()=>setExpandedSymbol(isExpanded ? null : symbol),
                                                            children: [
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                                    className: "px-4 py-3 font-bold text-[14px] text-white",
                                                                    children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                                        className: "flex items-center gap-2",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jxNNZ.default), {
                                                                                className: `w-3.5 h-3.5 text-muted transition-transform ${isExpanded ? "rotate-180 text-neon" : ""}`
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                                                className: "flex flex-col",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                                        children: symbol
                                                                                    }),
                                                                                    data.execution_sec_type === 'FUT' && data.execution_display_symbol && /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                                                        className: "flex items-center gap-1 text-[10px] text-neon/80 font-mono font-bold uppercase tracking-wider",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                                                children: data.execution_display_symbol
                                                                                            }),
                                                                                            data.execution_price_delayed && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                                                className: "rounded-sm border border-amber-400/20 bg-amber-400/10 px-1 text-[9px] text-amber-300",
                                                                                                children: "Delayed"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                                    className: "px-3 py-2",
                                                                    children: (0, $50ac319971de4993$export$615c2a87f9eca3f3)(data.informative_signal)
                                                                }),
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                                    className: "px-3 py-2",
                                                                    children: (0, $50ac319971de4993$export$688c2074ab98e60)(data.technical_signal)
                                                                }),
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                                    className: "px-3 py-2",
                                                                    children: (0, $50ac319971de4993$export$688c2074ab98e60)(data.next_day_is_trading)
                                                                }),
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                                    className: "px-4 py-3 text-right font-mono",
                                                                    children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $3ba62f31f33453d8$export$2e2bcd8739ae039), {
                                                                        symbol: symbol,
                                                                        evaluatedPrice: data.current_price,
                                                                        evaluatedQuote: data.evaluated_quote,
                                                                        initialLiveQuote: data.live_quote,
                                                                        executionPrice: data.execution_price,
                                                                        executionQuote: data.execution_quote,
                                                                        executionLabel: data.execution_display_symbol
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                                    className: "px-4 py-3 text-right font-mono text-white/80",
                                                                    children: data.sma_short && data.sma_long ? /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                                                className: "text-emerald-400",
                                                                                children: [
                                                                                    "$",
                                                                                    Number(data.sma_short).toFixed(2)
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                                className: "mx-1",
                                                                                children: "/"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                                                className: "text-amber-400",
                                                                                children: [
                                                                                    "$",
                                                                                    Number(data.sma_long).toFixed(2)
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }) : "N/A"
                                                                }),
                                                                /*#__PURE__*/ (0, $eHRxX.jsxs)("td", {
                                                                    className: "px-4 py-3 text-right font-mono text-white/80",
                                                                    children: [
                                                                        data.calculated_size ?? "\u2014",
                                                                        data.execution_sec_type === 'FUT' && data.calculated_size !== undefined && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                            className: "ml-1 text-[10px] text-white/40",
                                                                            children: "ct"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                                    className: "px-4 py-3 text-right font-mono text-white/80",
                                                                    children: data.leverage ? `${(data.leverage * 100).toFixed(0)}%` : "\u2014"
                                                                }),
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                                    className: "px-4 py-3 text-white/70 max-w-[200px] truncate",
                                                                    title: data.reason,
                                                                    children: data.reason
                                                                })
                                                            ]
                                                        }),
                                                        isExpanded && /*#__PURE__*/ (0, $eHRxX.jsx)("tr", {
                                                            children: /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                                colSpan: 9,
                                                                className: "p-0 bg-black/20",
                                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4QgfA.default), {
                                                                    symbol: symbol,
                                                                    timeframe: "1d",
                                                                    label: "ON",
                                                                    strategy: "ON",
                                                                    status: {
                                                                        ...data,
                                                                        levels_date: data.levels_date || onData?.levels_date || onData?.timestamp
                                                                    }
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }, symbol);
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    onPositionEntries.length > 0 && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "mt-3 rounded-2xl bg-white/6 text-sm text-foreground",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-center justify-between mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                        className: "text-sm font-semibold text-neon",
                                        children: "Current Position"
                                    }),
                                    latestOnTimestamp && /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                        className: "text-[11px] text-muted",
                                        children: [
                                            "Latest Data: ",
                                            latestOnTimestamp
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "overflow-x-auto scrollbar-thin rounded-xl border border-white/5 bg-surface",
                                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("table", {
                                    className: "min-w-full divide-y divide-white/10 text-[13px] text-foreground",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("thead", {
                                            className: "bg-black/60",
                                            children: /*#__PURE__*/ (0, $eHRxX.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Symbol"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Quantity"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Entry Price"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Entry Time"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("tbody", {
                                            className: "divide-y divide-white/5",
                                            children: onPositionEntries.map(([sym, qty])=>/*#__PURE__*/ (0, $eHRxX.jsxs)("tr", {
                                                    className: "hover:bg-white/5 transition-colors",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                            className: "px-4 py-3 whitespace-nowrap font-bold text-[14px] text-white",
                                                            children: sym
                                                        }),
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                            className: "px-4 py-3 whitespace-nowrap font-medium",
                                                            children: qty
                                                        }),
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                            className: "px-4 py-3 whitespace-nowrap",
                                                            children: onPositionMeta?.entry_price ? `$${Number(onPositionMeta.entry_price).toFixed(2)}` : "N/A"
                                                        }),
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                            className: "px-4 py-3 whitespace-nowrap text-white/70",
                                                            children: onPositionMeta?.entry_time ? (0, $lRLyZ.formatDateTimeET)(onPositionMeta.entry_time) : "N/A"
                                                        })
                                                    ]
                                                }, sym))
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $m1iA2.default), {
                isOpen: showConfigModal,
                onClose: ()=>setShowConfigModal(false),
                title: "ON Strategy Setup",
                width: "max-w-4xl",
                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $0fe4eaa15babde57$export$2e2bcd8739ae039), {
                    strategyName: "ON",
                    readOnly: true
                })
            })
        ]
    });
};
var $96b761dca47c06cb$export$2e2bcd8739ae039 = $96b761dca47c06cb$var$ONStrategyContent;



var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $gKbib = parcelRequire("gKbib");
var $jxNNZ = parcelRequire("jxNNZ");
var $kdxJz = parcelRequire("kdxJz");
var $j8jJ4 = parcelRequire("j8jJ4");
var $gECFA = parcelRequire("gECFA");
var $9WswS = parcelRequire("9WswS");
var $c3l2j = parcelRequire("c3l2j");

var $lRLyZ = parcelRequire("lRLyZ");

var $4QgfA = parcelRequire("4QgfA");

var $m1iA2 = parcelRequire("m1iA2");


var $etHUa = parcelRequire("etHUa");


const $61d9e26d27b94e1d$var$ORBSymbolRow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).memo(({ symbol: symbol, status: status, levelsDateIso: levelsDateIso, marketOpen: marketOpen, expanded: expanded, onToggle: onToggle })=>{
    const quoteIdentifier = status?.evaluated_quote?.local_symbol || symbol;
    const streamedQuote = (0, $965642ac39400a6c$export$79ae38ef14e32131)(quoteIdentifier);
    const livePrice = Number(streamedQuote?.price ?? status?.live_quote?.price ?? status?.current_price);
    const decisionPrice = Number(status.decision_price);
    const signalPrice = Number.isFinite(decisionPrice) && decisionPrice > 0 ? decisionPrice : Number(status.current_price);
    const resistance = Number(status.resistance);
    const support = Number(status.support);
    const hasCurrentLevels = (0, $etHUa.hasFreshLevels)(status, levelsDateIso) && (0, $etHUa.isCurrentNySessionDate)(status, levelsDateIso) && (0, $etHUa.isValidPriceLevel)(resistance) && (0, $etHUa.isValidPriceLevel)(support);
    const levelTone = (0, $etHUa.getAdaptiveLevelTone)({
        price: (0, $etHUa.isValidPriceLevel)(livePrice) ? livePrice : signalPrice,
        lowerLevel: support,
        upperLevel: resistance,
        levelsReady: hasCurrentLevels,
        earlySession: (0, $etHUa.isEarlyRegularSession)(),
        marketOpen: marketOpen
    });
    return /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("tr", {
                className: "cursor-pointer transition-colors hover:bg-white/5",
                style: levelTone.rowStyle,
                title: levelTone.label,
                onClick: onToggle,
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: "px-4 py-3 font-bold text-[14px] text-white",
                        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jxNNZ.default), {
                                    className: `w-3.5 h-3.5 text-muted transition-transform ${expanded ? "rotate-180 text-neon" : ""}`
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            children: symbol
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            className: `block text-[10px] font-medium ${levelTone.priceClass}`,
                                            children: levelTone.label
                                        }),
                                        status.execution_sec_type === "FUT" && status.execution_display_symbol && /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                            className: "block text-[10px] font-mono font-normal text-amber-300/80",
                                            children: [
                                                "\u2192 ",
                                                status.execution_display_symbol
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: `px-4 py-3 text-right font-mono ${levelTone.priceClass}`,
                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $3ba62f31f33453d8$export$2e2bcd8739ae039), {
                            symbol: symbol,
                            evaluatedPrice: status.current_price,
                            evaluatedQuote: status.evaluated_quote,
                            initialLiveQuote: status.live_quote,
                            decisionPrice: status.decision_price,
                            decisionSource: status.decision_price_source,
                            decisionLabel: "5m decision",
                            streamedQuoteOverride: streamedQuote,
                            priceClassName: levelTone.priceClass
                        })
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: "px-4 py-3 text-right font-mono",
                        children: status.daily_open ? `$${Number(status.daily_open).toFixed(2)}` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: "px-4 py-3 text-right font-mono",
                        children: status.atr_value ? `$${Number(status.atr_value).toFixed(2)}` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: `px-4 py-3 text-right font-mono ${levelTone.lowerClass}`,
                        children: status.support ? `$${Number(status.support).toFixed(2)}` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: `px-4 py-3 text-right font-mono ${levelTone.upperClass}`,
                        children: status.resistance ? `$${Number(status.resistance).toFixed(2)}` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: "px-4 py-3 text-right font-mono",
                        children: status.current_vwap ? `$${Number(status.current_vwap).toFixed(2)}` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("td", {
                        className: "px-4 py-3 text-right font-mono text-white/80",
                        children: [
                            status.calculated_size ? status.calculated_size : "\u2014",
                            status.execution_sec_type === 'FUT' && status.calculated_size !== undefined && status.calculated_size !== null && status.calculated_size !== 0 && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "ml-1 text-[10px] text-white/40",
                                children: "ct"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: "px-4 py-3 text-right font-mono text-white/80",
                        children: status.current_leverage ? `${status.current_leverage}x` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: "px-4 py-3 text-right font-medium",
                        children: status.position ? typeof status.position === 'number' ? /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                            children: [
                                status.position,
                                status.execution_sec_type === 'FUT' && status.position !== 0 && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                    className: "ml-1 text-[10px] text-white/40",
                                    children: "ct"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                            children: [
                                status.position.shares || 0,
                                status.execution_sec_type === 'FUT' && (status.position.shares || 0) !== 0 && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                    className: "ml-1 text-[10px] text-white/40",
                                    children: "ct"
                                })
                            ]
                        }) : "\u2014"
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $eHRxX.jsx)("tr", {
                children: /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                    colSpan: 10,
                    className: "p-0 bg-black/20",
                    children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4QgfA.default), {
                        symbol: symbol,
                        timeframe: "5min",
                        label: "ORB",
                        strategy: "ORB",
                        status: {
                            ...status,
                            levels_date: status.levels_date || levelsDateIso
                        }
                    })
                })
            })
        ]
    });
});
const $61d9e26d27b94e1d$var$ORBStrategyContent = ({ orbStatusState: orbStatusState, handleStrategyToggle: handleStrategyToggle, strategyToggleLoading: strategyToggleLoading })=>{
    const [showRules, setShowRules] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(false);
    const [expandedSymbol, setExpandedSymbol] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(null);
    const [showConfigModal, setShowConfigModal] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(false);
    const [marketOpen, setMarketOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(()=>(0, $etHUa.isRegularMarketOpen)());
    (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useEffect(()=>{
        const updateMarketState = ()=>setMarketOpen((0, $etHUa.isRegularMarketOpen)());
        const interval = window.setInterval(updateMarketState, 30000);
        return ()=>window.clearInterval(interval);
    }, []);
    if (!orbStatusState) return null;
    const orbData = orbStatusState.data || {};
    const orbEnabled = orbData.enabled ?? false;
    const toggleState = strategyToggleLoading.ORB;
    const levelsDateIso = orbData?.levels_date;
    const levelsDate = levelsDateIso && !Number.isNaN(Date.parse(levelsDateIso)) ? (0, $lRLyZ.formatDateTimeET)(levelsDateIso) : undefined;
    return /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex items-center justify-between mb-2",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-2 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "text-muted",
                                children: "Strategy"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "font-semibold text-foreground",
                                children: "ORB"
                            }),
                            orbData?.version && /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                className: "px-1.5 py-0.5 rounded-md bg-white/5 border border-white/10 text-[10px] text-muted font-mono",
                                title: "Strategy Logic Version",
                                children: [
                                    "v",
                                    orbData.version
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                        onClick: ()=>handleStrategyToggle("ORB", orbEnabled),
                        disabled: !!toggleState,
                        "aria-busy": !!toggleState,
                        className: `min-w-[104px] justify-center px-3 py-1.5 rounded-lg font-semibold uppercase flex text-sm items-center gap-1 transition disabled:cursor-wait disabled:opacity-80 ${toggleState ? "bg-amber-400/10 text-amber-300 border border-amber-400/20" : orbEnabled ? "bg-neon-soft text-neon" : "text-muted hover:text-foreground hover:bg-white/10"}`,
                        children: [
                            toggleState ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                                size: 14,
                                className: "animate-spin"
                            }) : orbEnabled ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $gECFA.default), {
                                size: 14
                            }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $9WswS.default), {
                                size: 14
                            }),
                            toggleState === "starting" ? "Starting" : toggleState === "pausing" ? "Pausing" : orbEnabled ? "Pause" : "Start"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "text-foreground",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                        onClick: ()=>setShowRules(!showRules),
                        className: "flex items-center gap-2 mb-4 px-4 py-2 rounded-xl bg-white/5 border border-white/10 text-[11px] font-black uppercase tracking-[0.2em] text-muted hover:text-white hover:bg-white/10 transition-all shadow-inner group",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: `p-1 rounded-md transition-all ${showRules ? 'bg-neon/20 text-neon' : 'bg-white/10 text-white/40 group-hover:text-white'}`,
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $c3l2j.default), {
                                    size: 14,
                                    className: showRules ? 'animate-pulse' : ''
                                })
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                children: [
                                    showRules ? 'Hide' : 'Show',
                                    " Strategy Conditions & Rules"
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: `ml-auto transition-transform duration-300 ${showRules ? 'rotate-180 text-neon' : ''}`,
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)("svg", {
                                    width: "12",
                                    height: "12",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "3",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: /*#__PURE__*/ (0, $eHRxX.jsx)("path", {
                                        d: "m6 9 6 6 6-6"
                                    })
                                })
                            })
                        ]
                    }),
                    showRules && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2 mb-6 animate-in fade-in slide-in-from-top-2 duration-300",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "p-4 rounded-2xl bg-white/5 border border-white/10 space-y-3 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-1",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: "p-1.5 rounded-lg bg-neon/10 text-neon",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $c3l2j.default), {
                                                    size: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("h4", {
                                                className: "text-xs font-bold uppercase tracking-wider text-white/90",
                                                children: "Entry Conditions"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("ul", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-neon/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        children: [
                                                            "Price breakout of ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "Opening Range"
                                                            }),
                                                            " (Open \xb1 ATR factor)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-neon/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        children: [
                                                            "Entry window: ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "09:35 - 09:35:30 ET"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-neon/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        children: [
                                                            "Confirmed by ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "5-minute bar"
                                                            }),
                                                            " close"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "p-4 rounded-2xl bg-white/5 border border-white/10 space-y-3 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-1",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: "p-1.5 rounded-lg bg-amber-500/10 text-amber-400",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $gKbib.default), {
                                                    size: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("h4", {
                                                className: "text-xs font-bold uppercase tracking-wider text-white/90",
                                                children: "Strategy Rules"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("ul", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-amber-400/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        children: [
                                                            "Positions liquidated at ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "15:30 ET"
                                                            }),
                                                            " (EOD)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-amber-400/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        children: [
                                                            "ATR-based ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "Stop Loss"
                                                            }),
                                                            " set at entry"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-amber-400/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        children: [
                                                            "Optional ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "VWAP Exit"
                                                            }),
                                                            " if enabled"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "mt-2 grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-foreground",
                children: levelsDate && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "rounded-xl bg-white/6 border border-white/10 px-3 py-2 flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "text-muted mr-2",
                            children: "Latest Data"
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "text-foreground font-semibold",
                            children: levelsDate
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "mt-4 rounded-2xl bg-white/6 text-sm text-foreground",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center justify-between mb-3",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                className: "text-sm font-semibold text-neon",
                                children: "Symbol Status"
                            }),
                            orbData.config_source && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "flex items-center gap-2",
                                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>setShowConfigModal(true),
                                    className: `inline-flex min-h-7 shrink-0 items-center gap-1.5 rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-wider transition-colors ${orbData.config_source === 'USER' ? 'bg-neon/10 text-neon border border-neon/20' : 'bg-white/5 text-muted border border-white/10'} hover:bg-white/10 hover:text-white`,
                                    title: "View current ORB strategy setup",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $kdxJz.default), {
                                            className: "h-3.5 w-3.5"
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            className: "whitespace-nowrap",
                                            children: orbData.config_source === 'USER' ? 'User Config' : 'System Default'
                                        }),
                                        orbData.config_version && /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                            className: "whitespace-nowrap",
                                            children: [
                                                "v",
                                                orbData.config_version
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "overflow-x-auto scrollbar-thin rounded-xl border border-white/5 bg-surface",
                        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("table", {
                            className: "min-w-full divide-y divide-white/10 text-[13px] text-foreground",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("thead", {
                                    className: "bg-black/60",
                                    children: /*#__PURE__*/ (0, $eHRxX.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                children: "Symbol"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Price"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Open"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "ATR"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "ORB Low"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "ORB High"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "VWAP"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Size"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Lev"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Position"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsx)("tbody", {
                                    className: "divide-y divide-white/5",
                                    children: orbData.symbol_status && Object.keys(orbData.symbol_status).length > 0 ? Object.entries(orbData.symbol_status).map(([symbol, status])=>/*#__PURE__*/ (0, $eHRxX.jsx)($61d9e26d27b94e1d$var$ORBSymbolRow, {
                                            symbol: symbol,
                                            status: status,
                                            levelsDateIso: levelsDateIso,
                                            marketOpen: marketOpen,
                                            expanded: expandedSymbol === symbol,
                                            onToggle: ()=>setExpandedSymbol((current)=>current === symbol ? null : symbol)
                                        }, symbol)) : /*#__PURE__*/ (0, $eHRxX.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                            colSpan: 10,
                                            className: "px-3 py-4 text-center text-muted",
                                            children: orbEnabled ? "Waiting for market data..." : "Strategy offline"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $m1iA2.default), {
                isOpen: showConfigModal,
                onClose: ()=>setShowConfigModal(false),
                title: "ORB Strategy Setup",
                width: "max-w-4xl",
                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $0fe4eaa15babde57$export$2e2bcd8739ae039), {
                    strategyName: "ORB",
                    readOnly: true
                })
            })
        ]
    });
};
var $61d9e26d27b94e1d$export$2e2bcd8739ae039 = $61d9e26d27b94e1d$var$ORBStrategyContent;



var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $gKbib = parcelRequire("gKbib");
var $jxNNZ = parcelRequire("jxNNZ");
var $kdxJz = parcelRequire("kdxJz");
var $j8jJ4 = parcelRequire("j8jJ4");
var $gECFA = parcelRequire("gECFA");
var $9WswS = parcelRequire("9WswS");
var $c3l2j = parcelRequire("c3l2j");

var $lRLyZ = parcelRequire("lRLyZ");

var $4QgfA = parcelRequire("4QgfA");

var $m1iA2 = parcelRequire("m1iA2");


var $etHUa = parcelRequire("etHUa");


const $8d42580dd2e8c203$var$DTSymbolRow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).memo(({ symbol: symbol, status: status, levelsDateIso: levelsDateIso, expanded: expanded, onToggle: onToggle, chartWidth: chartWidth, marketOpen: marketOpen })=>{
    const quoteIdentifier = status?.evaluated_quote?.local_symbol || symbol;
    const streamedQuote = (0, $965642ac39400a6c$export$79ae38ef14e32131)(quoteIdentifier);
    const liveStatusPrice = Number(streamedQuote?.price ?? status.live_quote?.price ?? status.current_price);
    const dailyOpen = Number(status.daily_open);
    const threshold = Number(status.intraday_threshold);
    const hasCurrentLevels = (0, $etHUa.hasFreshLevels)(status, levelsDateIso) && (0, $etHUa.isCurrentNySessionDate)(status, levelsDateIso) && (0, $etHUa.isValidPriceLevel)(liveStatusPrice) && (0, $etHUa.isValidPriceLevel)(dailyOpen) && Number.isFinite(threshold) && threshold > 0;
    const levelTone = (0, $etHUa.getAdaptiveLevelTone)({
        price: liveStatusPrice,
        lowerLevel: dailyOpen - threshold,
        upperLevel: dailyOpen + threshold,
        levelsReady: hasCurrentLevels,
        earlySession: (0, $etHUa.isEarlyRegularSession)(),
        marketOpen: marketOpen
    });
    return /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("tr", {
                className: "cursor-pointer transition-colors hover:bg-white/5",
                style: levelTone.rowStyle,
                title: levelTone.label,
                onClick: onToggle,
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: "px-4 py-3 font-bold text-[14px] text-white",
                        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jxNNZ.default), {
                                    className: `w-3.5 h-3.5 text-muted transition-transform ${expanded ? "rotate-180 text-neon" : ""}`
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            children: symbol
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            className: `block text-[10px] font-medium ${levelTone.priceClass}`,
                                            children: levelTone.label
                                        }),
                                        status.execution_sec_type === "FUT" && status.execution_display_symbol && /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                            className: "block text-[10px] font-mono font-normal text-amber-300/80",
                                            children: [
                                                "\u2192 ",
                                                status.execution_display_symbol
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: `px-4 py-3 text-right font-mono ${levelTone.priceClass}`,
                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $3ba62f31f33453d8$export$2e2bcd8739ae039), {
                            symbol: symbol,
                            evaluatedPrice: status.current_price,
                            evaluatedQuote: status.evaluated_quote,
                            initialLiveQuote: status.live_quote,
                            decisionPrice: status.entry_type === "bar_close" ? status.decision_price : null,
                            decisionSource: status.decision_price_source,
                            decisionLabel: status.decision_label || (status.decision_price_source === "confirmed_5m_bar_close" ? "5m close" : "30m close"),
                            streamedQuoteOverride: streamedQuote,
                            priceClassName: levelTone.priceClass
                        })
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: "px-4 py-3 text-right font-mono",
                        children: status.daily_open ? `$${Number(status.daily_open).toFixed(2)}` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: "px-4 py-3 text-right font-mono",
                        children: status.atr_value ? `$${Number(status.atr_value).toFixed(2)}` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: `px-4 py-3 text-right font-mono ${levelTone.upperClass}`,
                        children: status.daily_open && status.intraday_threshold ? /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                    className: levelTone.upperClass,
                                    children: [
                                        "$",
                                        (Number(status.daily_open) + Number(status.intraday_threshold)).toFixed(2)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                    className: "mx-1 text-muted",
                                    children: "/"
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                    className: levelTone.lowerClass,
                                    children: [
                                        "$",
                                        (Number(status.daily_open) - Number(status.intraday_threshold)).toFixed(2)
                                    ]
                                })
                            ]
                        }) : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: "px-4 py-3 text-right font-mono",
                        children: status.current_vwap ? `$${Number(status.current_vwap).toFixed(2)}` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: "px-4 py-3 text-white/70",
                        children: status.threshold_window || "\u2014"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: "px-4 py-3 text-white/60 font-mono text-[12px]",
                        children: status.last_entry_time ? status.last_entry_time.slice(0, 5) : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: "px-4 py-3 text-white/70 text-xs uppercase",
                        children: status.execution_mode || "\u2014"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: "px-4 py-3 text-right font-mono text-white/80",
                        children: status.sl_atr_factor ? status.sl_atr_factor.toFixed(2) : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("td", {
                        className: "px-4 py-3 text-right font-mono text-white/80",
                        children: [
                            status.calculated_size === 0 && Number(status.leverage) > 0 ? /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                className: "inline-flex items-center gap-1 text-amber-400 font-semibold",
                                title: "Position size is 0 (Equity too low for 1 share with current leverage)",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $gKbib.default), {
                                        size: 12,
                                        className: "inline text-amber-400 shrink-0"
                                    }),
                                    "0"
                                ]
                            }) : status.calculated_size ?? "\u2014",
                            status.execution_sec_type === 'FUT' && status.calculated_size !== undefined && status.calculated_size !== null && status.calculated_size !== 0 && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "ml-1 text-[10px] text-white/40",
                                children: "ct"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: "px-4 py-3 text-right font-mono text-white/80",
                        children: status.leverage ? `${status.leverage}x` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: "px-4 py-3 text-right font-medium",
                        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                            className: (status.trades_today || 0) >= (status.max_trades || 1) ? "text-rose-400" : "text-muted",
                            children: [
                                status.trades_today || 0,
                                "/",
                                status.max_trades || 1
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                        className: "px-4 py-3 text-right font-medium",
                        children: status.position?.shares !== 0 ? /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                            children: [
                                status.position?.shares,
                                status.execution_sec_type === 'FUT' && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                    className: "ml-1 text-[10px] text-white/40",
                                    children: "ct"
                                })
                            ]
                        }) : "\u2014"
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $eHRxX.jsx)("tr", {
                children: /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                    colSpan: 14,
                    className: "p-0 bg-black/20",
                    children: /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "sticky left-0 box-border min-w-0 overflow-hidden",
                        style: chartWidth ? {
                            width: `${chartWidth}px`
                        } : undefined,
                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4QgfA.default), {
                            symbol: symbol,
                            timeframe: "30min",
                            label: "ATR-DT",
                            strategy: "DT",
                            status: {
                                ...status,
                                levels_date: status.levels_date || levelsDateIso
                            }
                        })
                    })
                })
            })
        ]
    });
});
const $8d42580dd2e8c203$var$DTStrategyContent = ({ dtStatus: dtStatus, handleStrategyToggle: handleStrategyToggle, strategyToggleLoading: strategyToggleLoading })=>{
    const [showRules, setShowRules] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(false);
    const [expandedSymbol, setExpandedSymbol] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(null);
    const [showConfigModal, setShowConfigModal] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(false);
    const [marketOpen, setMarketOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(()=>(0, $etHUa.isRegularMarketOpen)());
    const tableViewportRef = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useRef(null);
    const [chartWidth, setChartWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState();
    const dtData = dtStatus?.data || {};
    (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useEffect(()=>{
        const viewport = tableViewportRef.current;
        if (!viewport) return;
        const updateWidth = ()=>setChartWidth(Math.floor(viewport.clientWidth));
        updateWidth();
        const observer = new ResizeObserver(updateWidth);
        observer.observe(viewport);
        return ()=>observer.disconnect();
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useEffect(()=>{
        const updateMarketState = ()=>setMarketOpen((0, $etHUa.isRegularMarketOpen)());
        const interval = window.setInterval(updateMarketState, 30000);
        return ()=>window.clearInterval(interval);
    }, []);
    if (!dtStatus) return null;
    const hasData = !!dtStatus?.data;
    const levelsDateIso = dtData?.levels_date;
    const levelsDate = levelsDateIso && !Number.isNaN(Date.parse(levelsDateIso)) ? (0, $lRLyZ.formatDateTimeET)(levelsDateIso) : undefined;
    const dtEnabled = dtData?.enabled ?? false;
    const toggleState = strategyToggleLoading.DT;
    return /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex items-center justify-between mb-2",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-2 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "text-muted",
                                children: "Strategy"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "font-semibold text-foreground",
                                children: "ATR-DT"
                            }),
                            dtData?.version && /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                className: "px-1.5 py-0.5 rounded-md bg-white/5 border border-white/10 text-[10px] text-muted font-mono",
                                children: [
                                    "v",
                                    dtData.version
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                        onClick: ()=>handleStrategyToggle("DT", dtEnabled),
                        disabled: !!toggleState,
                        "aria-busy": !!toggleState,
                        className: `min-w-[104px] justify-center px-3 py-1.5 rounded-lg font-semibold uppercase flex text-sm items-center gap-1 transition disabled:cursor-wait disabled:opacity-80 ${toggleState ? "bg-amber-400/10 text-amber-300 border border-amber-400/20" : dtEnabled ? "bg-neon-soft text-neon" : "text-muted hover:text-foreground hover:bg-white/10"}`,
                        children: [
                            toggleState ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                                size: 14,
                                className: "animate-spin"
                            }) : dtEnabled ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $gECFA.default), {
                                size: 14
                            }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $9WswS.default), {
                                size: 14
                            }),
                            toggleState === "starting" ? "Starting" : toggleState === "pausing" ? "Pausing" : dtEnabled ? "Pause" : "Start"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "text-foreground",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                        onClick: ()=>setShowRules(!showRules),
                        className: "flex items-center gap-2 mb-4 px-4 py-2 rounded-xl bg-white/5 border border-white/10 text-[11px] font-black uppercase tracking-[0.2em] text-muted hover:text-white hover:bg-white/10 transition-all shadow-inner group",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: `p-1 rounded-md transition-all ${showRules ? 'bg-neon/20 text-neon' : 'bg-white/10 text-white/40 group-hover:text-white'}`,
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $c3l2j.default), {
                                    size: 14,
                                    className: showRules ? 'animate-pulse' : ''
                                })
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                children: [
                                    showRules ? 'Hide' : 'Show',
                                    " Strategy Conditions & Rules"
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: `ml-auto transition-transform duration-300 ${showRules ? 'rotate-180 text-neon' : ''}`,
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)("svg", {
                                    width: "12",
                                    height: "12",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "3",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: /*#__PURE__*/ (0, $eHRxX.jsx)("path", {
                                        d: "m6 9 6 6 6-6"
                                    })
                                })
                            })
                        ]
                    }),
                    showRules && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2 mb-6 animate-in fade-in slide-in-from-top-2 duration-300",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "p-4 rounded-2xl bg-white/5 border border-white/10 space-y-3 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-1",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: "p-1.5 rounded-lg bg-neon/10 text-neon",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $c3l2j.default), {
                                                    size: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("h4", {
                                                className: "text-xs font-bold uppercase tracking-wider text-white/90",
                                                children: "Entry Conditions"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("ul", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-neon/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        children: [
                                                            "Price deviation from ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "Daily Open"
                                                            }),
                                                            " exceeds ATR threshold"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-neon/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        children: [
                                                            "Variable thresholds for ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "First"
                                                            }),
                                                            " vs ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "Second Window"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-neon/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        children: [
                                                            "Entry via ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "Bar Close"
                                                            }),
                                                            " (H/HH) or ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "Traps"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "p-4 rounded-2xl bg-white/5 border border-white/10 space-y-3 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-1",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: "p-1.5 rounded-lg bg-amber-500/10 text-amber-400",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $gKbib.default), {
                                                    size: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("h4", {
                                                className: "text-xs font-bold uppercase tracking-wider text-white/90",
                                                children: "Strategy Rules"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("ul", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-amber-400/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        children: [
                                                            "Positions liquidated at ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "15:30 ET"
                                                            }),
                                                            " (EOD)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-amber-400/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        children: [
                                                            "Daily limit of ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "1 trade"
                                                            }),
                                                            " per symbol (default)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-amber-400/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        children: [
                                                            "No entries after ",
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "Last Entry Time"
                                                            }),
                                                            " cutoff"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "mt-2 grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-foreground",
                children: levelsDate && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "rounded-xl bg-white/6 border border-white/10 px-3 py-2 flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "text-muted mr-2",
                            children: "Latest Data"
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            className: "text-foreground font-semibold",
                            children: levelsDate
                        })
                    ]
                })
            }),
            hasData && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "mt-4 rounded-2xl bg-white/6 text-sm text-foreground",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center justify-between mb-3",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                className: "text-sm font-semibold text-neon",
                                children: "Symbol Status"
                            }),
                            dtStatus.data?.config_source && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "flex items-center gap-2",
                                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>setShowConfigModal(true),
                                    className: `inline-flex min-h-7 shrink-0 items-center gap-1.5 rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-wider transition-colors ${dtStatus.data.config_source === 'USER' ? 'bg-neon/10 text-neon border border-neon/20' : 'bg-white/5 text-muted border border-white/10'} hover:bg-white/10 hover:text-white`,
                                    title: "View current ATR-DT strategy setup",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $kdxJz.default), {
                                            className: "h-3.5 w-3.5"
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            className: "whitespace-nowrap",
                                            children: dtStatus.data.config_source === 'USER' ? 'User Config' : 'System Default'
                                        }),
                                        dtStatus.data.config_version && /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                            className: "whitespace-nowrap",
                                            children: [
                                                "v",
                                                dtStatus.data.config_version
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        ref: tableViewportRef,
                        className: "overflow-x-auto scrollbar-thin rounded-xl border border-white/5 bg-surface",
                        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("table", {
                            className: "min-w-full divide-y divide-white/10 text-[13px] text-foreground",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("thead", {
                                    className: "bg-black/60",
                                    children: /*#__PURE__*/ (0, $eHRxX.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                children: "Symbol"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Price"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Open"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "ATR"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Threshold"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "VWAP"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                children: "Window"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider text-[11px]",
                                                children: "Cutoff"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                children: "Mode"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "SL Factor"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Size"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Lev"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Trades"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Position"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsx)("tbody", {
                                    className: "divide-y divide-white/5",
                                    children: dtStatus.data?.symbol_status && Object.keys(dtStatus.data?.symbol_status || {}).length > 0 ? Object.entries(dtStatus.data?.symbol_status || {}).map(([symbol, status])=>/*#__PURE__*/ (0, $eHRxX.jsx)($8d42580dd2e8c203$var$DTSymbolRow, {
                                            symbol: symbol,
                                            status: status,
                                            levelsDateIso: levelsDateIso,
                                            expanded: expandedSymbol === symbol,
                                            onToggle: ()=>setExpandedSymbol((current)=>current === symbol ? null : symbol),
                                            chartWidth: chartWidth,
                                            marketOpen: marketOpen
                                        }, symbol)) : /*#__PURE__*/ (0, $eHRxX.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                            colSpan: 14,
                                            className: "px-3 py-4 text-center text-muted",
                                            children: dtEnabled ? "Waiting for market data..." : "Strategy offline"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $m1iA2.default), {
                isOpen: showConfigModal,
                onClose: ()=>setShowConfigModal(false),
                title: "ATR-DT Strategy Setup",
                width: "max-w-4xl",
                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $0fe4eaa15babde57$export$2e2bcd8739ae039), {
                    strategyName: "DT",
                    readOnly: true
                })
            })
        ]
    });
};
var $8d42580dd2e8c203$export$2e2bcd8739ae039 = $8d42580dd2e8c203$var$DTStrategyContent;



var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $jr1gO = parcelRequire("jr1gO");/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $b6e281429b4d3c69$export$a2387ed3b5d536eb = {
    name: "arrow-right-left",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m16 3 4 4-4 4",
                key: "1x1c3m"
            }
        ],
        [
            "path",
            {
                d: "M20 7H4",
                key: "zbl0bi"
            }
        ],
        [
            "path",
            {
                d: "m8 21-4-4 4-4",
                key: "h9nckh"
            }
        ],
        [
            "path",
            {
                d: "M4 17h16",
                key: "g4d7ey"
            }
        ]
    ]
};
$b6e281429b4d3c69$export$a2387ed3b5d536eb.node;
const $b6e281429b4d3c69$export$2e2bcd8739ae039 = (0, $hHhnY.default)($b6e281429b4d3c69$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $76df512e3da304ec$export$a2387ed3b5d536eb = {
    name: "calendar-clock",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 14v2.2l1.6 1",
                key: "fo4ql5"
            }
        ],
        [
            "path",
            {
                d: "M16 2v3",
                key: "otl347"
            }
        ],
        [
            "path",
            {
                d: "M21 7.338V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h2.338",
                key: "7hb8p4"
            }
        ],
        [
            "path",
            {
                d: "M3 9h5.859",
                key: "numkqi"
            }
        ],
        [
            "path",
            {
                d: "M8 2v3",
                key: "1ioesn"
            }
        ],
        [
            "circle",
            {
                cx: "16",
                cy: "16",
                r: "6",
                key: "qoo3c4"
            }
        ]
    ]
};
$76df512e3da304ec$export$a2387ed3b5d536eb.node;
const $76df512e3da304ec$export$2e2bcd8739ae039 = (0, $hHhnY.default)($76df512e3da304ec$export$a2387ed3b5d536eb);


var $jxNNZ = parcelRequire("jxNNZ");
var $e5esH = parcelRequire("e5esH");
var $kdxJz = parcelRequire("kdxJz");
var $j8jJ4 = parcelRequire("j8jJ4");
var $gECFA = parcelRequire("gECFA");
var $9WswS = parcelRequire("9WswS");
var $bTVJ1 = parcelRequire("bTVJ1");
var $4nVaN = parcelRequire("4nVaN");
var $8FKMh = parcelRequire("8FKMh");


var $m1iA2 = parcelRequire("m1iA2");

var $zs3Np = parcelRequire("zs3Np");

var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");

var $lRLyZ = parcelRequire("lRLyZ");
const $87e958fd0b043328$export$e7c2806c498ca04c = (value, _fraction = false)=>{
    if (value === undefined || value === null || !Number.isFinite(Number(value))) return "\u2014";
    return `${(Number(value) * 100).toFixed(1)}%`;
};
const $87e958fd0b043328$export$d68f5a36fb886d13 = (value)=>{
    if (!value) return "\u2014";
    try {
        return (0, $lRLyZ.formatDateTimeET)(value);
    } catch  {
        return value;
    }
};
const $87e958fd0b043328$export$859fa52db42cf485 = (value)=>{
    if (!value) return "\u2014";
    const match = String(value).slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return String(value);
    return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC'
    }).format(new Date(`${match[1]}-${match[2]}-${match[3]}T12:00:00Z`));
};
const $87e958fd0b043328$export$9e1dd5059e1fa82 = (value)=>value ? `${String(value).slice(0, 5)} ET` : "\u2014";
const $87e958fd0b043328$export$4505f314868b99ef = (value)=>value === undefined || value === null || !Number.isFinite(Number(value)) ? "\u2014" : `$${Number(value).toFixed(2)}`;
const $87e958fd0b043328$export$88014ce576d8bf84 = (value)=>{
    if (value === undefined || value === null || !Number.isFinite(Number(value))) return "\u2014";
    const quantity = Number(value);
    return quantity > 0 ? `+${quantity}` : `${quantity}`;
};
const $87e958fd0b043328$export$50ed74e268265b5c = (row, action, quantity)=>{
    const quote = row.price_quote;
    const bid = Number(quote?.bid);
    const ask = Number(quote?.ask);
    const currentPrice = Number(row.current_price);
    const midpoint = Number.isFinite(bid) && bid > 0 && Number.isFinite(ask) && ask >= bid ? (bid + ask) / 2 : currentPrice;
    return {
        symbol: row.symbol,
        action: action,
        quantity: quantity,
        openInModal: true,
        secType: 'STK',
        orderType: 'MIDPRICE',
        price: Number.isFinite(midpoint) && midpoint > 0 ? midpoint : undefined
    };
};
const $87e958fd0b043328$export$ba0a9709164c99ad = (symbolInput, quantityInput, priceInput)=>{
    const symbol = symbolInput.trim().toUpperCase();
    const quantity = Number.parseFloat(quantityInput);
    if (!symbol || Number.isNaN(quantity) || quantity === 0) return null;
    const parsedPrice = priceInput.trim() ? Number.parseFloat(priceInput) : undefined;
    return {
        symbol: symbol,
        quantity: quantity,
        current_price: parsedPrice && !Number.isNaN(parsedPrice) ? parsedPrice : undefined
    };
};


const $02413e6511e00f1f$var$NQMMCandidateTable = ({ title: title, icon: icon, candidates: candidates, rebalanceWindowOpen: rebalanceWindowOpen })=>{
    const prepareOrder = (row, action, quantity)=>{
        window.dispatchEvent(new CustomEvent('nqmm-prepare-order', {
            detail: (0, $87e958fd0b043328$export$50ed74e268265b5c)(row, action, quantity)
        }));
    };
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "rounded-2xl border border-white/10 bg-black/20 overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "px-4 py-3 border-b border-white/10 flex items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            icon,
                            /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                className: "text-xs font-bold uppercase tracking-wider text-white/90",
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-2 text-[10px] uppercase tracking-wider",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                className: "text-emerald-300",
                                children: [
                                    candidates.filter((candidate)=>(candidate.rebalance_quantity ?? 0) > 0).length,
                                    " buy"
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                className: "text-rose-300",
                                children: [
                                    candidates.filter((candidate)=>(candidate.rebalance_quantity ?? 0) < 0).length,
                                    " sell"
                                ]
                            })
                        ]
                    })
                ]
            }),
            candidates.length === 0 ? /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "px-4 py-6 text-center text-xs text-muted",
                children: rebalanceWindowOpen ? 'No buy or sell orders are needed for the scheduled target.' : 'Order suggestions appear during the scheduled rebalance window. Momentum rankings refresh daily.'
            }) : /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "max-h-80 overflow-x-auto overflow-y-auto ux-scrollbar",
                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("table", {
                    className: "w-full min-w-[620px] text-[11px]",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("thead", {
                            className: "sticky top-0 bg-[#111827] text-[9px] uppercase tracking-wider text-muted",
                            children: /*#__PURE__*/ (0, $eHRxX.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                        className: "px-3 py-2 text-left",
                                        children: "Symbol"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                        className: "px-3 py-2 text-right",
                                        children: "Price"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                        className: "px-3 py-2 text-right",
                                        children: "Target"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                        className: "px-3 py-2 text-right",
                                        children: "Current"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                        className: "px-3 py-2 text-right",
                                        children: "Change"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                        className: "px-3 py-2 text-right",
                                        children: "Action"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                        className: "px-3 py-2 text-right",
                                        children: "Momentum"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                        className: "sticky right-0 bg-[#111827] px-3 py-2 text-right",
                                        children: "Order"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("tbody", {
                            children: candidates.map((row)=>{
                                const currentQuantity = row.current_quantity ?? row.position?.shares ?? 0;
                                const targetQuantity = row.target_quantity ?? 0;
                                const quantityChange = row.rebalance_quantity ?? targetQuantity - currentQuantity;
                                const orderAction = quantityChange > 0 ? 'BUY' : 'SELL';
                                const orderQuantity = Math.abs(quantityChange);
                                const canPrepareOrder = quantityChange !== 0;
                                return /*#__PURE__*/ (0, $eHRxX.jsxs)("tr", {
                                    className: "border-t border-white/5 hover:bg-white/3",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("td", {
                                            className: "px-3 py-1.5",
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                    className: "font-semibold text-white",
                                                    children: row.symbol
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                    className: "text-[9px] text-muted",
                                                    children: [
                                                        "Rank ",
                                                        row.rank ?? "\u2014",
                                                        " \xb7 ",
                                                        row.candidate_reason || 'Momentum candidate'
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("td", {
                                            className: "px-3 py-1.5 text-right",
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                    className: "font-mono text-[10px] text-white",
                                                    children: (0, $87e958fd0b043328$export$4505f314868b99ef)(row.current_price)
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                    className: `text-[8px] uppercase tracking-wider ${row.price_status === 'LIVE' ? 'text-emerald-300' : row.price_status === 'UNAVAILABLE' ? 'text-rose-300' : 'text-amber-300'}`,
                                                    children: row.price_status || "\u2014"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                            className: "px-3 py-1.5 text-right font-mono text-white/70",
                                            children: targetQuantity
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                            className: "px-3 py-1.5 text-right font-mono text-white/70",
                                            children: currentQuantity
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                            className: `px-3 py-1.5 text-right font-mono font-semibold ${quantityChange > 0 ? 'text-emerald-300' : quantityChange < 0 ? 'text-rose-300' : 'text-white/50'}`,
                                            children: (0, $87e958fd0b043328$export$88014ce576d8bf84)(quantityChange)
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("td", {
                                            className: `px-3 py-1.5 text-right font-semibold uppercase tracking-wider ${orderAction === 'SELL' ? 'text-rose-300' : 'text-emerald-300'}`,
                                            children: [
                                                orderAction,
                                                " ",
                                                orderQuantity
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                            className: `px-3 py-1.5 text-right font-mono ${Number(row.momentum) >= 0 ? 'text-emerald-300' : 'text-rose-300'}`,
                                            children: (0, $87e958fd0b043328$export$e7c2806c498ca04c)(row.momentum)
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                            className: "sticky right-0 bg-[#111827] px-3 py-1.5 text-right",
                                            children: canPrepareOrder ? /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>prepareOrder(row, orderAction, orderQuantity),
                                                className: `rounded-md border px-2 py-1 text-[9px] font-bold uppercase tracking-wider transition ${orderAction === 'BUY' ? 'border-emerald-400/30 bg-emerald-400/10 text-emerald-300 hover:bg-emerald-400/20' : 'border-rose-400/30 bg-rose-400/10 text-rose-300 hover:bg-rose-400/20'}`,
                                                title: `Review an IBKR MIDPRICE ${orderAction} rebalance order in a modal`,
                                                children: [
                                                    orderAction,
                                                    " MID"
                                                ]
                                            }) : /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "text-[9px] uppercase tracking-wider text-white/30",
                                                children: "No order"
                                            })
                                        })
                                    ]
                                }, `rebalance-${row.symbol}`);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $02413e6511e00f1f$export$2e2bcd8739ae039 = $02413e6511e00f1f$var$NQMMCandidateTable;



var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $4bqNy = parcelRequire("4bqNy");
var $j8jJ4 = parcelRequire("j8jJ4");
var $bTVJ1 = parcelRequire("bTVJ1");
var $k9hlW = parcelRequire("k9hlW");
var $bgvjD = parcelRequire("bgvjD");

var $m1iA2 = parcelRequire("m1iA2");

const $eaca414f3f31d16b$var$NQMMHistoryCorrectionModal = ({ isOpen: isOpen, onClose: onClose, historyLoading: historyLoading, historyError: historyError, submittingSymbol: submittingSymbol, previousPositions: previousPositions, currentPositions: currentPositions, addPreviousPosition: addPreviousPosition, deletePreviousPosition: deletePreviousPosition })=>{
    const [manualSymbol, setManualSymbol] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState('');
    const [manualQuantity, setManualQuantity] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState('100');
    const [manualPrice, setManualPrice] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState('');
    if (!isOpen) return null;
    const stockPositions = currentPositions.filter((position)=>!position.secType || [
            'STK',
            'CFD'
        ].includes(position.secType));
    const handleManualSubmit = async (event)=>{
        event.preventDefault();
        const correction = (0, $87e958fd0b043328$export$ba0a9709164c99ad)(manualSymbol, manualQuantity, manualPrice);
        if (!correction) return;
        await addPreviousPosition(correction);
        setManualSymbol('');
    };
    return /*#__PURE__*/ (0, $eHRxX.jsx)((0, $m1iA2.default), {
        isOpen: isOpen,
        onClose: onClose,
        title: "Correct previous NQMM positions",
        width: "max-w-4xl",
        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex items-start justify-between gap-3 rounded-xl border border-white/10 bg-white/5 px-3 py-3 text-xs text-muted",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                            children: "Select a current stock position or manually enter a symbol and share count to update NQMM's 10-record position history."
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                            type: "button",
                            onClick: onClose,
                            className: "text-muted hover:text-white",
                            "aria-label": "Close",
                            children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                                size: 16
                            })
                        })
                    ]
                }),
                historyError && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                    className: "rounded-lg border border-rose-400/20 bg-rose-400/5 px-3 py-2 text-xs text-rose-300",
                    children: historyError
                }),
                historyLoading ? /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex items-center justify-center py-8 text-sm text-muted",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                            size: 16,
                            className: "mr-2 animate-spin text-neon"
                        }),
                        " Loading positions\u2026"
                    ]
                }) : /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsxs)("form", {
                            onSubmit: handleManualSubmit,
                            className: "rounded-xl border border-white/10 bg-white/5 p-3 space-y-3",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                    className: "text-[10px] font-bold uppercase tracking-wider text-neon",
                                    children: "Add custom position record"
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                    className: "grid grid-cols-1 sm:grid-cols-3 gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("label", {
                                                    className: "block text-[10px] text-muted mb-1 font-semibold uppercase",
                                                    children: "Symbol"
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                                    type: "text",
                                                    placeholder: "e.g. NVDA",
                                                    value: manualSymbol,
                                                    onChange: (event)=>setManualSymbol(event.target.value.toUpperCase()),
                                                    className: "w-full rounded-lg border border-white/10 bg-black/40 px-2.5 py-1.5 text-xs text-white uppercase placeholder:text-muted/50 focus:border-neon focus:outline-hidden",
                                                    required: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("label", {
                                                    className: "block text-[10px] text-muted mb-1 font-semibold uppercase",
                                                    children: "Shares / Quantity"
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                                    type: "number",
                                                    step: "any",
                                                    placeholder: "e.g. 100",
                                                    value: manualQuantity,
                                                    onChange: (event)=>setManualQuantity(event.target.value),
                                                    className: "w-full rounded-lg border border-white/10 bg-black/40 px-2.5 py-1.5 text-xs text-white placeholder:text-muted/50 focus:border-neon focus:outline-hidden",
                                                    required: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("label", {
                                                    className: "block text-[10px] text-muted mb-1 font-semibold uppercase",
                                                    children: "Price (Optional)"
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("input", {
                                                    type: "number",
                                                    step: "any",
                                                    placeholder: "e.g. 125.50",
                                                    value: manualPrice,
                                                    onChange: (event)=>setManualPrice(event.target.value),
                                                    className: "w-full rounded-lg border border-white/10 bg-black/40 px-2.5 py-1.5 text-xs text-white placeholder:text-muted/50 focus:border-neon focus:outline-hidden"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                    className: "flex justify-end",
                                    children: /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                        type: "submit",
                                        disabled: !manualSymbol.trim() || submittingSymbol !== null,
                                        className: "inline-flex items-center gap-1.5 rounded-lg border border-neon/30 bg-neon/10 px-3 py-1.5 text-xs font-bold text-neon hover:bg-neon/20 transition-all disabled:opacity-50",
                                        children: [
                                            submittingSymbol === manualSymbol.trim().toUpperCase() ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                                                size: 14,
                                                className: "animate-spin text-neon"
                                            }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bTVJ1.default), {
                                                size: 14
                                            }),
                                            "Save Record"
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                    className: "mb-2 text-[10px] font-bold uppercase tracking-wider text-muted",
                                    children: "Current broker stock positions"
                                }),
                                stockPositions.length === 0 ? /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                    className: "rounded-xl border border-white/10 bg-black/20 px-3 py-4 text-center text-xs text-muted",
                                    children: "No active stock positions in broker account. Use the form above to add a manual position."
                                }) : /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                    className: "overflow-hidden rounded-xl border border-white/10",
                                    children: stockPositions.map((position)=>{
                                        const existing = previousPositions.some((item)=>item.symbol === position.symbol);
                                        const isSubmitting = submittingSymbol === position.symbol;
                                        return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                            className: "flex items-center justify-between gap-3 border-b border-white/5 px-3 py-2 last:border-b-0",
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                    className: "min-w-0",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                            className: "font-semibold text-white",
                                                            children: position.symbol
                                                        }),
                                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                            className: "text-[10px] text-muted",
                                                            children: [
                                                                position.quantity,
                                                                " shares \xb7 ",
                                                                position.current_price ? (0, $87e958fd0b043328$export$4505f314868b99ef)(position.current_price) : 'price unavailable'
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                    type: "button",
                                                    disabled: isSubmitting,
                                                    onClick: ()=>addPreviousPosition(position),
                                                    className: "inline-flex shrink-0 items-center gap-1 rounded-lg border border-neon/30 bg-neon/10 px-2.5 py-1.5 text-[10px] font-bold uppercase tracking-wider text-neon hover:bg-neon/20 disabled:opacity-50",
                                                    children: [
                                                        isSubmitting ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                                                            size: 13,
                                                            className: "animate-spin text-neon"
                                                        }) : existing ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4bqNy.default), {
                                                            size: 13
                                                        }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bTVJ1.default), {
                                                            size: 13
                                                        }),
                                                        existing ? 'Correct' : 'Add'
                                                    ]
                                                })
                                            ]
                                        }, `${position.symbol}-${position.contract_key || 'stock'}`);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                    className: "mb-2 text-[10px] font-bold uppercase tracking-wider text-muted",
                                    children: "Recorded Previous 10 Positions"
                                }),
                                previousPositions.length === 0 ? /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                    className: "rounded-xl border border-white/10 bg-black/20 px-3 py-5 text-center text-xs text-muted",
                                    children: "No manual corrections recorded yet."
                                }) : /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                    className: "overflow-hidden rounded-xl border border-white/10",
                                    children: previousPositions.map((position)=>{
                                        const isDeleting = submittingSymbol === position.symbol;
                                        return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                            className: "flex items-center justify-between gap-3 border-b border-white/5 px-3 py-2 last:border-b-0",
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                            className: "font-semibold text-white",
                                                            children: position.symbol
                                                        }),
                                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                            className: "ml-2 text-xs text-muted",
                                                            children: [
                                                                position.quantity,
                                                                " shares"
                                                            ]
                                                        }),
                                                        position.current_price ? /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                            className: "ml-2 text-[10px] text-muted",
                                                            children: [
                                                                "(",
                                                                (0, $87e958fd0b043328$export$4505f314868b99ef)(position.current_price),
                                                                ")"
                                                            ]
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                    className: "flex items-center gap-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                            className: "text-[10px] text-muted",
                                                            children: position.recorded_at ? (0, $87e958fd0b043328$export$d68f5a36fb886d13)(position.recorded_at) : "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                                            type: "button",
                                                            disabled: isDeleting,
                                                            onClick: ()=>deletePreviousPosition(position.symbol),
                                                            className: "text-muted hover:text-rose-300 disabled:opacity-50",
                                                            "aria-label": `Remove ${position.symbol}`,
                                                            children: isDeleting ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                                                                size: 14,
                                                                className: "animate-spin text-rose-300"
                                                            }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $k9hlW.default), {
                                                                size: 14
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, position.id);
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $eaca414f3f31d16b$export$2e2bcd8739ae039 = $eaca414f3f31d16b$var$NQMMHistoryCorrectionModal;



var $hpygi = parcelRequire("hpygi");

var $aNXfT = parcelRequire("aNXfT");

const $6fdca57508802c24$var$NQMMStrategyContent = ({ nqmmStatus: nqmmStatus, handleStrategyToggle: handleStrategyToggle, strategyToggleLoading: strategyToggleLoading, refreshNQMMStatus: refreshNQMMStatus, rankingRefreshLoading: rankingRefreshLoading })=>{
    const [showConfigModal, setShowConfigModal] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(false);
    const [showHistoryModal, setShowHistoryModal] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(false);
    const [historyLoading, setHistoryLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(false);
    const [historyError, setHistoryError] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(null);
    const [previousPositions, setPreviousPositions] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState([]);
    const [currentPositions, setCurrentPositions] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState([]);
    const [showAllRankings, setShowAllRankings] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(true);
    const [semiAutomaticSetting, setSemiAutomaticSetting] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(true);
    const [semiAutomaticSaving, setSemiAutomaticSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(false);
    const [semiAutomaticError, setSemiAutomaticError] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(null);
    const data = nqmmStatus?.data;
    const { data: portfolioPositions } = (0, $hpygi.usePositionsQuery)(undefined, {
        pollingInterval: 10000,
        skipPollingIfUnfocused: true
    });
    const info = data?.strategy_info || {};
    const rankings = data?.rankings || [];
    const selectedSymbols = data?.selected_symbols || data?.active_symbols || [];
    const hasPortfolioSnapshot = portfolioPositions?.success === true && portfolioPositions.data?.snapshot_available !== false;
    const positions = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useMemo(()=>hasPortfolioSnapshot ? (0, $aNXfT.getNQMMPortfolioPositions)(portfolioPositions?.data?.positions || []) : data?.positions || {}, [
        hasPortfolioSnapshot,
        portfolioPositions?.data?.positions,
        data?.positions
    ]);
    const managedSymbols = new Set((data?.managed_symbols ?? Object.keys(data?.target_positions || {})).map((symbol)=>symbol.toUpperCase()));
    const manualUnmanagedSymbols = new Set((data?.manual_unmanaged_symbols || []).map((symbol)=>symbol.toUpperCase()));
    const previousPositionSymbols = new Set((data?.previous_positions || []).map((position)=>position.symbol.toUpperCase()));
    const toggleState = strategyToggleLoading.NQMM;
    const enabled = data?.enabled ?? false;
    const rebalanceStatus = data?.rebalance_status || info.rebalance_status || "NOT_RUN";
    const rankingStatus = data?.ranking_status || "NOT_RUN";
    const displayedRankings = rankings.length > 0 ? showAllRankings ? rankings : rankings.slice(0, 25) : [];
    const currentPositionRows = Object.entries(positions).map(([symbol, quantity])=>({
            symbol: symbol,
            quantity: Number(quantity)
        })).filter(({ symbol: symbol, quantity: quantity })=>Number.isFinite(quantity) && quantity !== 0 && (hasPortfolioSnapshot || !manualUnmanagedSymbols.has(symbol.toUpperCase()) && (managedSymbols.has(symbol.toUpperCase()) || previousPositionSymbols.has(symbol.toUpperCase())))).sort((left, right)=>left.symbol.localeCompare(right.symbol));
    const buyCandidates = data?.buy_candidates || [];
    const sellCandidates = data?.sell_candidates || [];
    const reportedRebalanceCandidates = data?.rebalance_candidates ?? [
        ...buyCandidates.filter((candidate)=>(candidate.rebalance_quantity ?? 0) > 0),
        ...sellCandidates.filter((candidate)=>(candidate.rebalance_quantity ?? 0) < 0)
    ];
    const rebalanceTime = data?.rebalance_time || info.rebalance_time;
    const sleeveAllocation = data?.sleeve_allocation ?? info.sleeve_allocation ?? data?.position_size;
    const cashBuffer = data?.cash_buffer ?? info.cash_buffer;
    const topN = data?.top_n ?? info.top_n;
    const maxPositionAllocation = data?.max_position_allocation ?? info.max_position_allocation;
    const lookbackMonths = data?.lookback_months ?? info.lookback_months;
    const skipRecentMonths = data?.skip_recent_months ?? info.skip_recent_months;
    const tradingDaysPerMonth = data?.trading_days_per_month ?? info.trading_days_per_month;
    const minMomentum = data?.min_momentum ?? info.min_momentum;
    const requirePositiveMomentum = data?.require_positive_momentum ?? info.require_positive_momentum;
    const maxConcurrentHistoryRequests = data?.max_concurrent_history_requests ?? info.max_concurrent_history_requests;
    const semiAutomatic = data?.semi_automatic ?? info.semi_automatic ?? true;
    const positionSizingMethod = data?.position_sizing_method || info.position_sizing_method || "inverse_volatility";
    const sizingLabel = positionSizingMethod === "equal_weight" ? "Equal weight" : "Inverse volatility";
    const qqqAbove200Sma = data?.qqq_above_200_sma ?? info.qqq_above_200_sma;
    const requireQqqAbove200Sma = data?.require_qqq_above_200_sma ?? info.require_qqq_above_200_sma;
    const qqqPrice = data?.qqq_price ?? info.qqq_price;
    const qqq200Sma = data?.qqq_200_sma ?? info.qqq_200_sma;
    const qqqDataAsOf = data?.qqq_data_as_of ?? info.qqq_data_as_of;
    const configChangePending = data?.config_change_pending ?? info.config_change_pending;
    const nextRebalanceAt = data?.next_rebalance_at ?? info.next_rebalance_at;
    const nextRebalanceLabel = `${(0, $87e958fd0b043328$export$859fa52db42cf485)(data?.next_rebalance_date || info.next_rebalance_date)} \xb7 ${(0, $87e958fd0b043328$export$9e1dd5059e1fa82)(rebalanceTime)}`;
    const qqqRegime = qqqAbove200Sma === true ? "Above 200 SMA" : qqqAbove200Sma === false ? "Below 200 SMA" : "Unavailable";
    const rebalanceTargetsReady = Boolean(data?.rebalance_targets_ready);
    const reportedPendingOrders = data?.pending_rebalance_orders ?? reportedRebalanceCandidates.filter((candidate)=>(candidate.rebalance_quantity ?? 0) !== 0).length;
    const rebalanceWindowOpen = Boolean(data?.rebalance_window_open || data?.rebalance_due || rebalanceStatus === "PENDING_SEMI_AUTOMATIC" && rebalanceTargetsReady && reportedPendingOrders > 0 || rebalanceStatus === "REBALANCE_DUE");
    const rebalanceCandidates = rebalanceWindowOpen && rebalanceTargetsReady ? reportedRebalanceCandidates : [];
    const pendingBuyOrders = rebalanceCandidates.filter((c)=>(c.rebalance_quantity ?? 0) > 0).length;
    const pendingSellOrders = rebalanceCandidates.filter((c)=>(c.rebalance_quantity ?? 0) < 0).length;
    const totalPendingOrders = rebalanceTargetsReady ? data?.pending_rebalance_orders ?? pendingBuyOrders + pendingSellOrders : 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useEffect(()=>{
        const configured = data?.semi_automatic ?? info.semi_automatic;
        if (typeof configured === "boolean") setSemiAutomaticSetting(configured);
    }, [
        data?.semi_automatic,
        info.semi_automatic
    ]);
    const handleSemiAutomaticToggle = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useCallback(async ()=>{
        if (semiAutomaticSaving) return;
        const nextValue = !semiAutomaticSetting;
        const previousValue = semiAutomaticSetting;
        setSemiAutomaticSetting(nextValue);
        setSemiAutomaticSaving(true);
        setSemiAutomaticError(null);
        try {
            const response = await (0, $zs3Np.tradingApi).updateStrategyDbConfig("NQMM", {
                config_json: {
                    semi_automatic: nextValue
                }
            });
            if (!response.success) throw new Error(response.message || "Failed to update NQMM execution mode");
            window.dispatchEvent(new CustomEvent("trading-data-refresh"));
        } catch (error) {
            setSemiAutomaticSetting(previousValue);
            setSemiAutomaticError(error instanceof Error ? error.message : "Failed to update NQMM execution mode");
        } finally{
            setSemiAutomaticSaving(false);
        }
    }, [
        semiAutomaticSaving,
        semiAutomaticSetting
    ]);
    const statusPositionFallback = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useMemo(()=>Object.entries(positions).map(([symbol, quantity])=>({
                symbol: symbol,
                quantity: Number(quantity),
                secType: "STK",
                timestamp: new Date().toISOString()
            })).filter((position)=>Number.isFinite(position.quantity) && position.quantity !== 0), [
        positions
    ]);
    const openHistoryModal = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useCallback(async ()=>{
        setShowHistoryModal(true);
        setHistoryLoading(true);
        setHistoryError(null);
        const [historyResult, positionsResult] = await Promise.allSettled([
            (0, $zs3Np.tradingApi).getNQMMPreviousPositions(),
            (0, $zs3Np.tradingApi).getPositions()
        ]);
        if (historyResult.status === "fulfilled") setPreviousPositions(historyResult.value.data?.previous_positions || []);
        else setHistoryError(historyResult.reason instanceof Error ? historyResult.reason.message : "Failed to load previous position corrections");
        if (positionsResult.status === "fulfilled") setCurrentPositions(positionsResult.value.data?.positions || []);
        else {
            // Pausing NQMM must not disable correction history.  If the account
            // endpoint is temporarily unavailable, use the position snapshot that
            // already backs the paused strategy status so existing stock holdings
            // can still be recorded without starting the strategy.
            setCurrentPositions(statusPositionFallback);
            if (statusPositionFallback.length === 0 && historyResult.status === "fulfilled") setHistoryError("Current positions are unavailable while disconnected from the account");
        }
        setHistoryLoading(false);
    }, [
        statusPositionFallback
    ]);
    const [submittingSymbol, setSubmittingSymbol] = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useState(null);
    const addPreviousPosition = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useCallback(async (position)=>{
        setSubmittingSymbol(position.symbol);
        setHistoryError(null);
        try {
            const response = await (0, $zs3Np.tradingApi).addNQMMPreviousPosition({
                symbol: position.symbol,
                quantity: position.quantity,
                avg_cost: position.avg_cost,
                current_price: position.current_price,
                market_value: position.market_value
            });
            if (response.success && response.data?.previous_positions) {
                setPreviousPositions(response.data.previous_positions);
                window.dispatchEvent(new CustomEvent("trading-data-refresh"));
            } else if (response.error || response.message) setHistoryError(response.error || response.message || "Failed to save position correction");
        } catch (error) {
            setHistoryError(error instanceof Error ? error.message : "Failed to save position correction");
        } finally{
            setSubmittingSymbol(null);
        }
    }, []);
    const deletePreviousPosition = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useCallback(async (symbol)=>{
        setSubmittingSymbol(symbol);
        setHistoryError(null);
        try {
            const response = await (0, $zs3Np.tradingApi).deleteNQMMPreviousPosition(symbol);
            if (response.success && response.data?.previous_positions) {
                setPreviousPositions(response.data.previous_positions);
                window.dispatchEvent(new CustomEvent("trading-data-refresh"));
            } else if (response.error || response.message) setHistoryError(response.error || response.message || "Failed to remove position correction");
        } catch (error) {
            setHistoryError(error instanceof Error ? error.message : "Failed to remove position correction");
        } finally{
            setSubmittingSymbol(null);
        }
    }, []);
    if (!data) return /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "rounded-2xl border border-amber-400/20 bg-amber-400/5 px-4 py-6 text-center",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "text-sm font-semibold text-amber-200",
                        children: "NQMM status unavailable"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                        className: "mt-1 text-xs text-muted",
                        children: "The trading session is offline or has not finished loading. Ranking data will appear when the engine reconnects."
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                        type: "button",
                        onClick: openHistoryModal,
                        className: "mt-4 inline-flex items-center gap-1.5 rounded-lg border border-neon/30 bg-neon/10 px-3 py-2 text-[10px] font-bold uppercase tracking-wider text-neon hover:bg-neon/20",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bTVJ1.default), {
                                size: 14
                            }),
                            " Correct previous 10"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $eaca414f3f31d16b$export$2e2bcd8739ae039), {
                isOpen: showHistoryModal,
                onClose: ()=>setShowHistoryModal(false),
                historyLoading: historyLoading,
                historyError: historyError,
                submittingSymbol: submittingSymbol,
                previousPositions: previousPositions,
                currentPositions: currentPositions,
                addPreviousPosition: addPreviousPosition,
                deletePreviousPosition: deletePreviousPosition
            })
        ]
    });
    return /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "mb-4 flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-2 text-sm min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "text-muted",
                                children: "Strategy"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "font-semibold text-foreground",
                                children: "NQMM"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "text-muted hidden sm:inline",
                                children: "Nasdaq-100 Monthly Momentum"
                            }),
                            data.config_version && /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                className: "px-1.5 py-0.5 rounded-md bg-white/5 border border-white/10 text-[10px] text-muted font-mono",
                                children: [
                                    "v",
                                    data.config_version
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                        onClick: ()=>handleStrategyToggle("NQMM", enabled),
                        disabled: !!toggleState,
                        "aria-busy": !!toggleState,
                        className: `inline-flex min-w-[76px] shrink-0 items-center justify-center gap-1 rounded-md px-2.5 py-1.5 text-[11px] font-semibold uppercase transition disabled:cursor-wait disabled:opacity-80 ${toggleState ? "bg-amber-400/10 text-amber-300 border border-amber-400/20" : enabled ? "bg-neon-soft text-neon" : "text-muted hover:text-foreground hover:bg-white/10"}`,
                        children: [
                            toggleState ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                                size: 14,
                                className: "animate-spin"
                            }) : enabled ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $gECFA.default), {
                                size: 14
                            }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $9WswS.default), {
                                size: 14
                            }),
                            toggleState === "starting" ? "Starting" : toggleState === "pausing" ? "Pausing" : enabled ? "Pause" : "Start"
                        ]
                    })
                ]
            }),
            rebalanceWindowOpen && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "mb-5 rounded-2xl border border-amber-400/30 bg-amber-500/10 p-4 text-amber-200 shadow-lg shadow-amber-500/5",
                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex items-start gap-3",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jr1gO.default), {
                            className: "h-5 w-5 text-amber-400 shrink-0 mt-0.5"
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "flex-1 min-w-0",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                    className: "flex items-center gap-2 font-bold text-amber-300 text-sm",
                                    children: "Rebalance Window Open \xb7 Action Required"
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                    className: "mt-1 text-xs text-amber-200/90 leading-relaxed",
                                    children: data?.rebalance_warning || `${data.effective_rebalance_frequency || info.effective_rebalance_frequency || data.rebalance_frequency || info.rebalance_frequency || "Monthly"} rebalance is scheduled for today (${(0, $87e958fd0b043328$export$859fa52db42cf485)(data?.next_rebalance_date || info.next_rebalance_date)} \xb7 ${(0, $87e958fd0b043328$export$9e1dd5059e1fa82)(rebalanceTime)}). ${totalPendingOrders > 0 ? `${totalPendingOrders} order(s) are pending execution to align portfolio with target allocations.` : "Portfolio targets are ready."}`
                                }),
                                totalPendingOrders > 0 && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                    className: "mt-2.5 flex flex-wrap items-center gap-2 text-xs font-semibold text-amber-300",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            className: "text-amber-200/80",
                                            children: "Pending orders:"
                                        }),
                                        pendingBuyOrders > 0 && /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                            className: "px-2 py-0.5 rounded-sm bg-emerald-500/20 text-emerald-300 border border-emerald-500/30 font-mono text-[11px]",
                                            children: [
                                                pendingBuyOrders,
                                                " BUY"
                                            ]
                                        }),
                                        pendingSellOrders > 0 && /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                            className: "px-2 py-0.5 rounded-sm bg-rose-500/20 text-rose-300 border border-rose-500/30 font-mono text-[11px]",
                                            children: [
                                                pendingSellOrders,
                                                " SELL"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                            className: "text-amber-200/70 text-[11px]",
                                            children: "(Use the order buttons in the rebalance table below to execute)"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "grid grid-cols-2 xl:grid-cols-5 gap-3 mb-5",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$Metric, {
                        label: "Portfolio sleeve",
                        value: (0, $87e958fd0b043328$export$e7c2806c498ca04c)(sleeveAllocation, true)
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$Metric, {
                        label: "Current allocation",
                        value: (0, $87e958fd0b043328$export$e7c2806c498ca04c)(data?.current_allocation, true)
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$Metric, {
                        label: "Selected stocks",
                        value: `${selectedSymbols.length}/${topN ?? "\u2014"}`
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$Metric, {
                        label: "Ranking universe",
                        value: `${data?.universe_size ?? info.universe_size ?? data?.universe?.length ?? "\u2014"}`
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$Metric, {
                        label: "Next rebalance",
                        value: `${nextRebalanceLabel}${rebalanceWindowOpen ? " (Window Open)" : ""}`,
                        valueClass: rebalanceWindowOpen ? "text-amber-300 font-bold" : "text-white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "mb-5 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-white/10 bg-black/20 px-4 py-3 text-[11px]",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "h-2 w-2 rounded-full bg-neon"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: "font-bold uppercase tracking-wider text-white/80",
                                children: "QQQ 200-day SMA regime"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: `rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${qqqAbove200Sma === true ? "border-emerald-400/30 bg-emerald-400/10 text-emerald-300" : qqqAbove200Sma === false ? "border-amber-400/30 bg-amber-400/10 text-amber-300" : "border-white/10 bg-white/5 text-muted"}`,
                                children: qqqRegime
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-x-4 gap-y-1 font-mono text-white/60",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                children: [
                                    "Close ",
                                    qqqPrice !== undefined && qqqPrice !== null ? `$${Number(qqqPrice).toFixed(2)}` : "\u2014"
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                children: [
                                    "200 SMA ",
                                    qqq200Sma !== undefined && qqq200Sma !== null ? `$${Number(qqq200Sma).toFixed(2)}` : "\u2014"
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                children: qqqDataAsOf ? `as of ${(0, $87e958fd0b043328$export$859fa52db42cf485)(qqqDataAsOf)}` : "data unavailable"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                className: requireQqqAbove200Sma ? "text-neon" : "text-white/40",
                                children: requireQqqAbove200Sma ? "Hold filter ON" : "Hold filter OFF"
                            })
                        ]
                    })
                ]
            }),
            configChangePending && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "mb-5 rounded-xl border border-amber-400/25 bg-amber-400/10 px-4 py-3 text-xs text-amber-200",
                children: [
                    "NQMM settings changed. Targets and orders will update at the next scheduled rebalance, using the prior trading session's close.",
                    nextRebalanceAt ? /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                        className: "ml-1 font-semibold text-amber-100",
                        children: [
                            "Next rebalance: ",
                            (0, $87e958fd0b043328$export$d68f5a36fb886d13)(nextRebalanceAt),
                            "."
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "mb-5 rounded-2xl border border-white/10 bg-black/20 overflow-hidden text-[11px]",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "px-4 py-3 border-b border-white/10 flex items-center justify-between gap-3",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8FKMh.default), {
                                        size: 16,
                                        className: "text-neon"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                        className: "text-xs font-bold uppercase tracking-wider text-white/90",
                                        children: "Current positions"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                className: "text-[10px] text-muted uppercase tracking-wider",
                                children: [
                                    currentPositionRows.length,
                                    " open",
                                    hasPortfolioSnapshot ? portfolioPositions?.data?.stale ? " \xb7 stale" : "" : " \xb7 strategy snapshot"
                                ]
                            })
                        ]
                    }),
                    currentPositionRows.length === 0 ? /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "px-4 py-4 text-xs text-muted",
                        children: "No current NQMM positions reported. Previous-position corrections remain observational and do not place orders."
                    }) : /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-1.5 p-2",
                        children: currentPositionRows.map(({ symbol: symbol, quantity: quantity })=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "rounded-lg border border-white/10 bg-white/5 px-2.5 py-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center justify-between gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "text-[11px] font-semibold tracking-tight text-white",
                                                children: symbol
                                            }),
                                            previousPositionSymbols.has(symbol.toUpperCase()) && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "rounded-sm bg-neon/10 px-1 py-0.5 text-[8px] font-bold uppercase tracking-wider text-neon",
                                                children: "History"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "mt-0.5 text-[10px] text-muted",
                                        children: [
                                            quantity,
                                            " shares"
                                        ]
                                    })
                                ]
                            }, symbol))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "grid grid-cols-1 xl:grid-cols-[1fr_1.5fr] gap-4 mb-5",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "min-w-0 p-4 rounded-2xl bg-white/5 border border-white/10 space-y-3",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex flex-col gap-3 border-b border-white/10 pb-3",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex min-w-0 items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: "p-1.5 rounded-lg bg-emerald-500/10 text-emerald-400",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8FKMh.default), {
                                                    size: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                                className: "truncate text-xs font-bold uppercase tracking-wider text-white/90",
                                                children: "Strategy information"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex w-full flex-wrap items-center gap-1.5",
                                        children: [
                                            data.config_source && /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>setShowConfigModal(true),
                                                title: data.config_source === "USER" ? "Open saved user configuration" : "Open system default configuration",
                                                className: "inline-flex min-w-0 flex-1 items-center justify-center gap-1 rounded-md border border-white/10 bg-white/5 px-2 py-1.5 text-[9px] font-bold uppercase tracking-wider text-muted hover:bg-white/10 hover:text-white sm:flex-none",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $kdxJz.default), {
                                                        className: "h-3.5 w-3.5 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        children: data.config_source === "USER" ? "User config" : "Defaults"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                type: "button",
                                                onClick: openHistoryModal,
                                                title: "Correct the previous ten NQMM position records",
                                                className: "inline-flex min-w-0 flex-1 items-center justify-center gap-1 rounded-md border border-white/10 bg-white/5 px-2 py-1.5 text-[9px] font-bold uppercase tracking-wider text-muted hover:bg-white/10 hover:text-white sm:flex-none",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bTVJ1.default), {
                                                        className: "h-3.5 w-3.5 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        children: "Correct 10"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                type: "button",
                                                role: "switch",
                                                "aria-checked": semiAutomaticSetting,
                                                "aria-busy": semiAutomaticSaving,
                                                onClick: handleSemiAutomaticToggle,
                                                disabled: semiAutomaticSaving,
                                                title: semiAutomaticSetting ? "Semi-automatic: review each NQMM order before submitting" : "Automatic: NQMM may submit rebalance orders on schedule",
                                                className: "inline-flex min-w-0 flex-1 items-center justify-center gap-1.5 rounded-md border border-white/10 bg-white/5 px-2 py-1.5 text-[9px] font-bold uppercase tracking-wider text-muted transition hover:bg-white/10 hover:text-white disabled:cursor-wait disabled:opacity-70 sm:flex-none",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: semiAutomaticSetting ? "text-neon" : "text-amber-300",
                                                        children: semiAutomaticSaving ? "Saving\u2026" : semiAutomaticSetting ? "Semi-auto" : "Automatic"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: `relative h-3.5 w-6 shrink-0 rounded-full transition ${semiAutomaticSetting ? "bg-neon/70" : "bg-white/20"}`,
                                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                            className: `absolute top-0.5 h-2.5 w-2.5 rounded-full bg-white transition ${semiAutomaticSetting ? "left-3" : "left-0.5"}`
                                                        })
                                                    }),
                                                    semiAutomaticSaving && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                                                        className: "h-3 w-3 shrink-0 animate-spin text-amber-300"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("p", {
                                className: "text-[11px] text-muted leading-relaxed",
                                children: [
                                    "Long-only cross-sectional momentum across the configured Nasdaq-100 universe. It uses a ",
                                    lookbackMonths ?? "\u2014",
                                    "-month lookback, skips ",
                                    skipRecentMonths ?? "\u2014",
                                    " recent months, and selects ",
                                    requirePositiveMomentum ? "positive-momentum " : "eligible ",
                                    "names using capped ",
                                    sizingLabel.toLowerCase(),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "grid grid-cols-1 gap-x-5 gap-y-2 text-[11px] sm:grid-cols-2",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Portfolio sleeve",
                                        value: (0, $87e958fd0b043328$export$e7c2806c498ca04c)(sleeveAllocation, true)
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Cash buffer",
                                        value: (0, $87e958fd0b043328$export$e7c2806c498ca04c)(cashBuffer, true)
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Selected stocks",
                                        value: `${selectedSymbols.length} / ${topN ?? "\u2014"}`
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Max per stock",
                                        value: (0, $87e958fd0b043328$export$e7c2806c498ca04c)(maxPositionAllocation, true)
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Lookback",
                                        value: `${lookbackMonths ?? "\u2014"} months`
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Skip recent",
                                        value: skipRecentMonths === 0 ? "None" : `${skipRecentMonths ?? "\u2014"} month${skipRecentMonths === 1 ? "" : "s"}`
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Trading days / month",
                                        value: `${tradingDaysPerMonth ?? "\u2014"}`
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Sizing",
                                        value: sizingLabel
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Vol window",
                                        value: `${data.volatility_lookback_months ?? info.volatility_lookback_months ?? "\u2014"} months`
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Min momentum",
                                        value: (0, $87e958fd0b043328$export$e7c2806c498ca04c)(minMomentum)
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Positive momentum",
                                        value: requirePositiveMomentum ? "Required" : "Allowed"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Schedule",
                                        value: `${data.effective_rebalance_frequency || info.effective_rebalance_frequency || data.rebalance_frequency || info.rebalance_frequency || "monthly"} \xb7 last working day \xb7 ${(0, $87e958fd0b043328$export$9e1dd5059e1fa82)(rebalanceTime)}${rebalanceTime?.startsWith("15:00") ? " \xb7 1h before close" : ""}`
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "QQQ regime",
                                        value: `${qqqRegime}${data.qqq_price && data.qqq_200_sma ? ` \xb7 $${Number(data.qqq_price).toFixed(2)} / $${Number(data.qqq_200_sma).toFixed(2)}` : ""}`,
                                        valueClass: qqqAbove200Sma === false ? "text-amber-300" : qqqAbove200Sma === true ? "text-emerald-300" : "text-muted"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "QQQ hold filter",
                                        value: requireQqqAbove200Sma ? "Only above 200 SMA" : "Off"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Rebalance cadence",
                                        value: "Month end only"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Execution",
                                        value: semiAutomatic ? "Semi-auto \xb7 order buttons" : "Automatic",
                                        valueClass: semiAutomatic ? "text-neon" : "text-amber-300"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Next action",
                                        value: nextRebalanceLabel,
                                        valueClass: configChangePending ? "text-amber-300" : "text-white/80"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "History requests",
                                        value: `${maxConcurrentHistoryRequests ?? "\u2014"} at a time`
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Last run",
                                        value: (0, $87e958fd0b043328$export$d68f5a36fb886d13)(data.last_rebalance_date || info.last_rebalance_date)
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Rebalance status",
                                        value: rebalanceStatus,
                                        valueClass: rebalanceStatus === "ERROR" ? "text-rose-300" : "text-emerald-300"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Momentum data",
                                        value: rankingStatus,
                                        valueClass: rankingStatus === "ERROR" ? "text-rose-300" : rankingStatus === "RUNNING" ? "text-amber-300" : "text-emerald-300"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Momentum close",
                                        value: data.ranking_data_as_of ? (0, $87e958fd0b043328$export$859fa52db42cf485)(data.ranking_data_as_of) : (0, $87e958fd0b043328$export$d68f5a36fb886d13)(data.last_ranking_at)
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)($6fdca57508802c24$var$InfoRow, {
                                        label: "Cash buffer",
                                        value: (0, $87e958fd0b043328$export$e7c2806c498ca04c)(data.cash_buffer, true)
                                    })
                                ]
                            }),
                            data.rebalance_error && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "rounded-lg border border-rose-400/20 bg-rose-400/5 px-3 py-2 text-[11px] text-rose-300",
                                children: data.rebalance_error
                            }),
                            semiAutomaticError && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "rounded-lg border border-rose-400/20 bg-rose-400/5 px-3 py-2 text-[11px] text-rose-300",
                                children: semiAutomaticError
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "rounded-2xl border border-white/10 bg-black/20 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "px-4 py-3 border-b border-white/10 flex items-center justify-between gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $76df512e3da304ec$export$2e2bcd8739ae039), {
                                                size: 16,
                                                className: "text-neon"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                                                className: "text-xs font-bold uppercase tracking-wider text-white/90",
                                                children: "Nasdaq momentum"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "text-[10px] text-muted uppercase tracking-wider",
                                                children: showAllRankings ? `${rankings.length} stocks` : `Top ${data.top_n ?? info.top_n ?? "\u2014"}`
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                type: "button",
                                                onClick: refreshNQMMStatus,
                                                disabled: rankingRefreshLoading,
                                                "aria-busy": rankingRefreshLoading,
                                                "aria-label": "Refresh Nasdaq momentum rankings",
                                                title: "Reload the latest Nasdaq momentum snapshot",
                                                className: "inline-flex items-center gap-1 rounded-md border border-white/10 bg-white/5 px-2 py-1 text-[10px] font-semibold uppercase tracking-wider text-muted hover:bg-white/10 hover:text-white disabled:cursor-wait disabled:opacity-60",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4nVaN.default), {
                                                        size: 13,
                                                        className: rankingRefreshLoading ? "animate-spin" : ""
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "hidden sm:inline",
                                                        children: rankingRefreshLoading ? "Refreshing" : "Refresh"
                                                    })
                                                ]
                                            }),
                                            rankings.length > 25 && /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>setShowAllRankings((current)=>!current),
                                                "aria-expanded": showAllRankings,
                                                className: "inline-flex items-center gap-1 rounded-md border border-white/10 bg-white/5 px-2 py-1 text-[10px] font-semibold uppercase tracking-wider text-muted hover:bg-white/10 hover:text-white",
                                                children: [
                                                    showAllRankings ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $e5esH.default), {
                                                        size: 13
                                                    }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $jxNNZ.default), {
                                                        size: 13
                                                    }),
                                                    showAllRankings ? "Collapse" : "Show all"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "max-h-[70vh] overflow-y-auto ux-scrollbar",
                                children: displayedRankings.length === 0 ? /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                    className: "px-4 py-10 text-center text-xs text-muted",
                                    children: rankingStatus === "RUNNING" ? "Refreshing completed daily momentum data\u2026" : data.ranking_error || (enabled ? "Waiting for the daily momentum snapshot." : "No ranking snapshot yet \u2014 the shared history backfill may still be running.")
                                }) : /*#__PURE__*/ (0, $eHRxX.jsxs)("table", {
                                    className: "w-full text-xs",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("thead", {
                                            className: "sticky top-0 bg-[#111827] text-[10px] uppercase tracking-wider text-muted",
                                            children: /*#__PURE__*/ (0, $eHRxX.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        className: "px-4 py-2 text-left",
                                                        children: "Rank"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        className: "px-4 py-2 text-left",
                                                        children: "Symbol"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        className: "px-4 py-2 text-right",
                                                        children: "Momentum"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        className: "px-4 py-2 text-right",
                                                        children: "Volatility"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        className: "px-4 py-2 text-right",
                                                        title: "Indicative targets based on the current ranking; actual trades use approved rebalance targets",
                                                        children: "Indicative %"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        className: "px-4 py-2 text-right",
                                                        children: "Indicative shares"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        className: "px-4 py-2 text-right",
                                                        children: "Position shares"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("th", {
                                                        className: "px-4 py-2 text-right",
                                                        children: "Indicative change"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)("tbody", {
                                            children: displayedRankings.map((row)=>{
                                                const quantity = hasPortfolioSnapshot ? positions[row.symbol.toUpperCase()] ?? 0 : row.position?.shares ?? (managedSymbols.has(row.symbol.toUpperCase()) ? positions[row.symbol] : 0) ?? 0;
                                                const targetQuantity = row.indicative_target_quantity ?? row.target_quantity ?? data.target_positions?.[row.symbol] ?? 0;
                                                const quantityChange = Number(targetQuantity) - Number(quantity);
                                                return /*#__PURE__*/ (0, $eHRxX.jsxs)("tr", {
                                                    className: `${row.selected ? "bg-emerald-400/10" : ""} border-t border-white/5`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                            className: "px-4 py-2 font-mono text-muted",
                                                            children: row.rank ?? "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                            className: "px-4 py-2 font-bold text-white",
                                                            children: row.symbol
                                                        }),
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                            className: `px-4 py-2 text-right font-mono ${Number(row.momentum) >= 0 ? "text-emerald-300" : "text-rose-300"}`,
                                                            children: row.ranking_status === "INSUFFICIENT_HISTORY" ? "No history" : (0, $87e958fd0b043328$export$e7c2806c498ca04c)(row.momentum)
                                                        }),
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                            className: "px-4 py-2 text-right font-mono text-white/70",
                                                            children: (0, $87e958fd0b043328$export$e7c2806c498ca04c)(row.realized_volatility)
                                                        }),
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                            className: "px-4 py-2 text-right font-mono text-white/70",
                                                            children: (0, $87e958fd0b043328$export$e7c2806c498ca04c)(row.indicative_target_allocation ?? row.target_allocation)
                                                        }),
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                            className: "px-4 py-2 text-right font-mono text-white/70",
                                                            children: targetQuantity
                                                        }),
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                            className: "px-4 py-2 text-right font-mono text-white/70",
                                                            children: quantity
                                                        }),
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("td", {
                                                            className: `px-4 py-2 text-right font-mono ${quantityChange > 0 ? "text-emerald-300" : quantityChange < 0 ? "text-rose-300" : "text-white/50"}`,
                                                            children: (0, $87e958fd0b043328$export$88014ce576d8bf84)(quantityChange)
                                                        })
                                                    ]
                                                }, row.symbol);
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "mb-5",
                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $02413e6511e00f1f$export$2e2bcd8739ae039), {
                    title: "Rebalance to target",
                    icon: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $b6e281429b4d3c69$export$2e2bcd8739ae039), {
                        size: 16,
                        className: "text-neon"
                    }),
                    candidates: rebalanceCandidates,
                    rebalanceWindowOpen: rebalanceWindowOpen && rebalanceTargetsReady
                })
            }),
            showConfigModal && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $m1iA2.default), {
                isOpen: showConfigModal,
                onClose: ()=>setShowConfigModal(false),
                title: "NQMM Strategy Setup",
                width: "max-w-5xl",
                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $0fe4eaa15babde57$export$2e2bcd8739ae039), {
                    strategyName: "NQMM",
                    readOnly: true
                })
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $eaca414f3f31d16b$export$2e2bcd8739ae039), {
                isOpen: showHistoryModal,
                onClose: ()=>setShowHistoryModal(false),
                historyLoading: historyLoading,
                historyError: historyError,
                submittingSymbol: submittingSymbol,
                previousPositions: previousPositions,
                currentPositions: currentPositions,
                addPreviousPosition: addPreviousPosition,
                deletePreviousPosition: deletePreviousPosition
            })
        ]
    });
};
const $6fdca57508802c24$var$Metric = ({ label: label, value: value, valueClass: valueClass = "text-white" })=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "p-3 rounded-xl bg-white/5 border border-white/10 min-w-0",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "text-[10px] uppercase tracking-wider font-bold text-muted mb-1",
                children: label
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: `text-sm font-semibold truncate ${valueClass}`,
                title: value,
                children: value
            })
        ]
    });
const $6fdca57508802c24$var$InfoRow = ({ label: label, value: value, valueClass: valueClass = "text-white/80" })=>/*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "flex min-w-0 items-center justify-between gap-2 border-b border-white/5 py-1.5",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                className: "min-w-0 truncate text-muted",
                children: label
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                className: `min-w-0 truncate font-mono text-right ${valueClass}`,
                title: value,
                children: value
            })
        ]
    });
var $6fdca57508802c24$export$2e2bcd8739ae039 = $6fdca57508802c24$var$NQMMStrategyContent;



var $eHRxX = parcelRequire("eHRxX");
parcelRequire("jHEir");

var $7i2bY = parcelRequire("7i2bY");
var $12llf = parcelRequire("12llf");
const $c718346cb0b6887b$var$HydrationStatus = ({ hydrated: hydrated, enabled: enabled, strategyName: strategyName })=>{
    if (!enabled) return null;
    return /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
        className: "flex items-center gap-2 px-2 py-1 rounded-full bg-white/5 border border-white/5 shadow-inner",
        children: hydrated ? /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7i2bY.default), {
                    size: 12,
                    className: "text-emerald-400"
                }),
                /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                    className: "text-[10px] font-bold text-emerald-400 uppercase tracking-tight",
                    children: [
                        strategyName,
                        " Hydrated"
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $12llf.default), {
                    size: 12,
                    className: "text-amber-400 animate-spin-slow"
                }),
                /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                    className: "text-[10px] font-bold text-amber-400 uppercase tracking-tight",
                    children: [
                        strategyName,
                        " Hydrating..."
                    ]
                })
            ]
        })
    });
};
var $c718346cb0b6887b$export$2e2bcd8739ae039 = $c718346cb0b6887b$var$HydrationStatus;




var $hpygi = parcelRequire("hpygi");

var $3vzuD = parcelRequire("3vzuD");
const $b66f05b375253f79$var$StrategyStatus = ({ className: className = '' })=>{
    const [activeTab, setActiveTab] = (0, $jHEir.useState)("ORB");
    const pollingOptions = (strategy)=>({
            pollingInterval: activeTab === strategy ? 10000 : 60000,
            skipPollingIfUnfocused: true
        });
    const onQuery = (0, $hpygi.useStrategyStatusQuery)('ON', pollingOptions('ON'));
    const orbQuery = (0, $hpygi.useStrategyStatusQuery)('ORB', pollingOptions('ORB'));
    const dtQuery = (0, $hpygi.useStrategyStatusQuery)('DT', pollingOptions('DT'));
    const nqmmQuery = (0, $hpygi.useStrategyStatusQuery)('NQMM', pollingOptions('NQMM'));
    const morbQuery = (0, $hpygi.useStrategyStatusQuery)('MORB', pollingOptions('MORB'));
    const [onStatus, setOnStatus] = (0, $jHEir.useState)(null);
    const [orbStatusState, setOrbStatusState] = (0, $jHEir.useState)(null);
    const [dtStatus, setDtStatus] = (0, $jHEir.useState)(null);
    const [nqmmStatus, setNqmmStatus] = (0, $jHEir.useState)(null);
    const [nqmmRefreshLoading, setNqmmRefreshLoading] = (0, $jHEir.useState)(false);
    const [morbStatus, setMorbStatus] = (0, $jHEir.useState)(null);
    const [error, setError] = (0, $jHEir.useState)(null);
    const [strategyToggleLoading, setStrategyToggleLoading] = (0, $jHEir.useState)({});
    const pendingStrategyTargets = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useRef({});
    const strategyToggleLoadingRef = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useRef({});
    const loading = onQuery.isLoading || orbQuery.isLoading || dtQuery.isLoading || nqmmQuery.isLoading || morbQuery.isLoading;
    const queryError = onQuery.error || orbQuery.error || dtQuery.error || nqmmQuery.error || morbQuery.error;
    const applyPendingTarget = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useCallback((strategyName, status)=>{
        const pendingEnabled = pendingStrategyTargets.current[strategyName];
        if (pendingEnabled === undefined) return status;
        return {
            ...status,
            data: {
                ...status.data,
                enabled: pendingEnabled
            }
        };
    }, []);
    const setToggleLoadingForStrategy = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useCallback((strategyName, action)=>{
        strategyToggleLoadingRef.current = {
            ...strategyToggleLoadingRef.current
        };
        if (action) strategyToggleLoadingRef.current[strategyName] = action;
        else delete strategyToggleLoadingRef.current[strategyName];
        setStrategyToggleLoading(strategyToggleLoadingRef.current);
    }, []);
    const fetchData = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useCallback(async ()=>{
        setError(null);
        try {
            const [onStatusData, orbStatusData, dtStatusData, nqmmStatusData, morbStatusData] = await Promise.all([
                onQuery.refetch().unwrap(),
                orbQuery.refetch().unwrap(),
                dtQuery.refetch().unwrap(),
                nqmmQuery.refetch().unwrap(),
                morbQuery.refetch().unwrap()
            ]);
            setOnStatus(applyPendingTarget("ON", onStatusData));
            setOrbStatusState(applyPendingTarget("ORB", orbStatusData));
            setDtStatus(applyPendingTarget("DT", dtStatusData));
            setNqmmStatus(applyPendingTarget("NQMM", nqmmStatusData));
            setMorbStatus(applyPendingTarget("MORB", morbStatusData));
        } catch (err) {
            setError(err instanceof Error ? err.message : "Failed to fetch strategy data");
        }
    }, [
        applyPendingTarget,
        dtQuery,
        morbQuery,
        nqmmQuery,
        onQuery,
        orbQuery
    ]);
    const refreshNQMMStatus = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useCallback(async ()=>{
        setNqmmRefreshLoading(true);
        setError(null);
        try {
            const status = await nqmmQuery.refetch().unwrap();
            setNqmmStatus(applyPendingTarget("NQMM", status));
        } catch (err) {
            setError(err instanceof Error ? err.message : "Failed to refresh Nasdaq momentum");
        } finally{
            setNqmmRefreshLoading(false);
        }
    }, [
        applyPendingTarget,
        nqmmQuery
    ]);
    const updateStrategyEnabled = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useCallback((strategyName, enabled)=>{
        const updater = (prev)=>prev ? {
                ...prev,
                data: {
                    ...prev.data,
                    enabled: Boolean(enabled)
                }
            } : prev;
        if (strategyName === "ORB") setOrbStatusState(updater);
        else if (strategyName === "DT") setDtStatus(updater);
        else if (strategyName === "NQMM") setNqmmStatus(updater);
        else if (strategyName === "MORB") setMorbStatus(updater);
        else setOnStatus(updater);
    }, []);
    const handleStrategyToggle = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useCallback(async (strategyName, currentlyEnabled)=>{
        if (strategyToggleLoadingRef.current[strategyName]) return;
        const newState = !currentlyEnabled;
        pendingStrategyTargets.current[strategyName] = newState;
        setToggleLoadingForStrategy(strategyName, newState ? "starting" : "pausing");
        updateStrategyEnabled(strategyName, newState);
        try {
            const response = await (0, $zs3Np.tradingApi).setStrategyEnabled(strategyName, newState);
            if (!response.success) throw new Error(response.message || `Failed to update ${strategyName} strategy state`);
            await fetchData();
            updateStrategyEnabled(strategyName, newState);
        } catch (err) {
            setError(err instanceof Error ? err.message : `Failed to update ${strategyName} strategy state`);
            delete pendingStrategyTargets.current[strategyName];
            updateStrategyEnabled(strategyName, currentlyEnabled);
        } finally{
            delete pendingStrategyTargets.current[strategyName];
            setToggleLoadingForStrategy(strategyName, null);
        }
    }, [
        fetchData,
        setToggleLoadingForStrategy,
        updateStrategyEnabled
    ]);
    const strategySummaries = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useMemo(()=>[
            {
                name: "ORB",
                enabled: orbStatusState?.data?.enabled
            },
            {
                name: "DT",
                enabled: dtStatus?.data?.enabled
            },
            {
                name: "ON",
                enabled: onStatus?.data?.enabled
            },
            {
                name: "NQMM",
                enabled: nqmmStatus?.data?.enabled
            },
            {
                name: "MORB",
                enabled: morbStatus?.data?.enabled
            }
        ], [
        dtStatus?.data?.enabled,
        morbStatus?.data?.enabled,
        nqmmStatus?.data?.enabled,
        onStatus?.data?.enabled,
        orbStatusState?.data?.enabled
    ]);
    const runningCount = strategySummaries.filter((strategy)=>strategy.enabled).length;
    const pausedCount = strategySummaries.length - runningCount;
    const activeStatus = activeTab === "ON" ? onStatus?.data : activeTab === "DT" ? dtStatus?.data : activeTab === "NQMM" ? nqmmStatus?.data : activeTab === "MORB" ? morbStatus?.data : orbStatusState?.data;
    (0, $jHEir.useEffect)(()=>{
        if (onQuery.data) setOnStatus(applyPendingTarget('ON', onQuery.data));
        if (orbQuery.data) setOrbStatusState(applyPendingTarget('ORB', orbQuery.data));
        if (dtQuery.data) setDtStatus(applyPendingTarget('DT', dtQuery.data));
        if (nqmmQuery.data) setNqmmStatus(applyPendingTarget('NQMM', nqmmQuery.data));
        if (morbQuery.data) setMorbStatus(applyPendingTarget('MORB', morbQuery.data));
    }, [
        applyPendingTarget,
        dtQuery.data,
        morbQuery.data,
        nqmmQuery.data,
        onQuery.data,
        orbQuery.data
    ]);
    (0, $jHEir.useEffect)(()=>{
        const handleRefresh = ()=>fetchData();
        window.addEventListener('trading-data-refresh', handleRefresh);
        return ()=>window.removeEventListener('trading-data-refresh', handleRefresh);
    }, [
        fetchData
    ]);
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: `panel full-bleed-panel flex min-h-0 w-full flex-col ${className}`,
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                className: "flex shrink-0 flex-col gap-4 border-b border-white/10 px-6 py-5 sm:flex-row sm:items-center sm:justify-between",
                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex items-center gap-3",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                            className: "p-2 rounded-lg bg-neon/10 text-neon",
                            children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7ab85e16ca639a6c$export$2e2bcd8739ae039), {
                                className: "w-5 h-5"
                            })
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "space-y-0.5",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("h2", {
                                    className: "text-lg font-bold text-white tracking-tight",
                                    children: "Strategy Oversight"
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                    className: "text-xs text-muted",
                                    children: "Real-time signal analysis and lifecycle control"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $62Hcf.ThemeTabBar), {
                "aria-label": "Strategy sections",
                children: [
                    "ORB",
                    "DT",
                    "ON",
                    "NQMM",
                    "MORB"
                ].map((tab)=>/*#__PURE__*/ (0, $eHRxX.jsx)((0, $62Hcf.ThemeButton), {
                        "aria-pressed": activeTab === tab,
                        variant: activeTab === tab ? 'secondary' : 'ghost',
                        size: "sm",
                        onClick: ()=>setActiveTab(tab),
                        children: tab
                    }, tab))
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "flex min-h-0 flex-1 flex-col p-5",
                children: [
                    loading && !(onStatus && onStatus.data) && !(orbStatusState && orbStatusState.data) && !(dtStatus && dtStatus.data) && !(nqmmStatus && nqmmStatus.data) && !(morbStatus && morbStatus.data) && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "flex justify-center py-8",
                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $5ogeV.default), {
                            size: "lg"
                        })
                    }),
                    (error || queryError && !(onStatus || orbStatusState || dtStatus || nqmmStatus || morbStatus)) && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4cvdp.default), {
                        error: error || 'Failed to fetch strategy data',
                        onRetry: ()=>fetchData(),
                        message: "Failed to load strategy data"
                    }),
                    onStatus || orbStatusState || dtStatus || nqmmStatus || morbStatus ? /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "space-y-4 text-foreground",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-4 mb-1",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex flex-wrap items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center gap-2 px-3 py-1.5 rounded-full bg-success-500/10 border border-success-500/20 text-success-400",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "text-[10px] uppercase font-black tracking-wider",
                                                        children: "Running"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "min-w-5 h-5 px-1 rounded-full bg-success-500/20 text-center text-xs font-black leading-5",
                                                        children: runningCount
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-white/60",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "text-[10px] uppercase font-black tracking-wider",
                                                        children: "Paused"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "min-w-5 h-5 px-1 rounded-full bg-white/10 text-center text-xs font-black leading-5",
                                                        children: pausedCount
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center gap-2 px-2 py-1 rounded-full bg-white/5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: `h-2 w-2 rounded-full ${strategyToggleLoading.ORB ? "bg-warning-500 animate-pulse" : orbStatusState?.data?.enabled ? "bg-success-500 animate-pulse" : "bg-white/30"}`
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "uppercase text-xs font-bold text-white/70",
                                                        children: "ORB"
                                                    }),
                                                    strategyToggleLoading.ORB && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                                                        className: "h-3 w-3 animate-spin text-warning-500"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center gap-2 px-2 py-1 rounded-full bg-white/5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: `h-2 w-2 rounded-full ${strategyToggleLoading.DT ? "bg-warning-500 animate-pulse" : dtStatus?.data?.enabled ? "bg-success-500 animate-pulse" : "bg-white/30"}`
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "uppercase text-xs font-bold text-white/70",
                                                        children: "DT"
                                                    }),
                                                    strategyToggleLoading.DT && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                                                        className: "h-3 w-3 animate-spin text-warning-500"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center gap-2 px-2 py-1 rounded-full bg-white/5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: `h-2 w-2 rounded-full ${strategyToggleLoading.ON ? "bg-warning-500 animate-pulse" : onStatus?.data?.enabled ? "bg-success-500 animate-pulse" : "bg-white/30"}`
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "uppercase text-xs font-bold text-white/70",
                                                        children: "ON"
                                                    }),
                                                    strategyToggleLoading.ON && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                                                        className: "h-3 w-3 animate-spin text-warning-500"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center gap-2 px-2 py-1 rounded-full bg-white/5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: `h-2 w-2 rounded-full ${strategyToggleLoading.NQMM ? "bg-warning-500 animate-pulse" : nqmmStatus?.data?.enabled ? "bg-success-500 animate-pulse" : "bg-white/30"}`
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "uppercase text-xs font-bold text-white/70",
                                                        children: "NQMM"
                                                    }),
                                                    strategyToggleLoading.NQMM && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                                                        className: "h-3 w-3 animate-spin text-warning-500"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center gap-2 px-2 py-1 rounded-full bg-white/5",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: `h-2 w-2 rounded-full ${strategyToggleLoading.MORB ? "bg-warning-500 animate-pulse" : morbStatus?.data?.enabled ? "bg-success-500 animate-pulse" : "bg-white/30"}`
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "uppercase text-xs font-bold text-white/70",
                                                        children: "MORB"
                                                    }),
                                                    strategyToggleLoading.MORB && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                                                        className: "h-3 w-3 animate-spin text-warning-500"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    activeStatus && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: `flex items-center gap-2 rounded-full border px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide ${activeStatus.runtime_stale ? "border-warning-500/25 bg-warning-500/10 text-warning-500" : "border-info-500/20 bg-info-500/10 text-info-500"}`,
                                        title: activeStatus.runtime_synced_at ? `Trading engine snapshot: ${activeStatus.runtime_synced_at}` : "Status is served by this trading engine process",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: `h-1.5 w-1.5 rounded-full ${activeStatus.runtime_stale ? "bg-warning-500" : "bg-info-500 animate-pulse"}`
                                            }),
                                            activeStatus.runtime_stale ? "Engine sync delayed" : "Engine synced"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-2 ml-auto",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $c718346cb0b6887b$export$2e2bcd8739ae039), {
                                                enabled: orbStatusState?.data?.enabled,
                                                hydrated: orbStatusState?.data?.hydrated,
                                                strategyName: "ORB"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $c718346cb0b6887b$export$2e2bcd8739ae039), {
                                                enabled: dtStatus?.data?.enabled,
                                                hydrated: dtStatus?.data?.hydrated,
                                                strategyName: "DT"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $c718346cb0b6887b$export$2e2bcd8739ae039), {
                                                enabled: onStatus?.data?.enabled,
                                                hydrated: onStatus?.data?.hydrated,
                                                strategyName: "ON"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $c718346cb0b6887b$export$2e2bcd8739ae039), {
                                                enabled: nqmmStatus?.data?.enabled,
                                                hydrated: nqmmStatus?.data?.hydrated,
                                                strategyName: "NQMM"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $c718346cb0b6887b$export$2e2bcd8739ae039), {
                                                enabled: morbStatus?.data?.enabled,
                                                hydrated: morbStatus?.data?.hydrated,
                                                strategyName: "MORB"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            activeStatus && /*#__PURE__*/ (0, $eHRxX.jsx)($b66f05b375253f79$var$StrategyOverview, {
                                strategy: activeTab,
                                status: activeStatus
                            }),
                            activeStatus && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $9e800d71ae82fe1f$export$2e2bcd8739ae039), {
                                status: activeStatus
                            }),
                            activeTab === "ORB" && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $61d9e26d27b94e1d$export$2e2bcd8739ae039), {
                                orbStatusState: orbStatusState,
                                handleStrategyToggle: handleStrategyToggle,
                                strategyToggleLoading: strategyToggleLoading
                            }),
                            activeTab === "DT" && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $8d42580dd2e8c203$export$2e2bcd8739ae039), {
                                dtStatus: dtStatus,
                                handleStrategyToggle: handleStrategyToggle,
                                strategyToggleLoading: strategyToggleLoading
                            }),
                            activeTab === "ON" && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $96b761dca47c06cb$export$2e2bcd8739ae039), {
                                onStatus: onStatus,
                                handleStrategyToggle: handleStrategyToggle,
                                strategyToggleLoading: strategyToggleLoading
                            }),
                            activeTab === "NQMM" && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $6fdca57508802c24$export$2e2bcd8739ae039), {
                                nqmmStatus: nqmmStatus,
                                handleStrategyToggle: handleStrategyToggle,
                                strategyToggleLoading: strategyToggleLoading,
                                refreshNQMMStatus: refreshNQMMStatus,
                                rankingRefreshLoading: nqmmRefreshLoading
                            }),
                            activeTab === "MORB" && /*#__PURE__*/ (0, $eHRxX.jsx)($b66f05b375253f79$var$ManagedORBOverview, {
                                status: morbStatus,
                                handleStrategyToggle: handleStrategyToggle,
                                strategyToggleLoading: strategyToggleLoading
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
const $b66f05b375253f79$var$StrategyOverview = ({ strategy: strategy, status: status })=>{
    const description = (0, $3vzuD.getStrategyDescription)(strategy);
    const symbols = status.active_symbols?.length ? status.active_symbols : status.managed_symbols || [];
    return /*#__PURE__*/ (0, $eHRxX.jsx)("section", {
        className: "rounded-2xl border border-neon/15 bg-neon/4 px-4 py-3.5 sm:px-5",
        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
            className: "flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between",
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                    className: "text-[10px] font-black uppercase tracking-[0.18em] text-neon",
                                    children: "Strategy overview"
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                    className: "rounded-full border border-white/10 bg-white/5 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white/60",
                                    children: description.label
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                            className: "mt-2 max-w-4xl text-sm leading-relaxed text-white/75",
                            children: description.overview
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "shrink-0 text-left text-[10px] text-white/45 sm:text-right",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                            className: "font-bold uppercase tracking-wider text-white/60",
                            children: "Tracked symbols"
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                            className: "mt-1 max-w-[260px] sm:max-w-[320px]",
                            children: symbols.length ? symbols.join(', ') : 'None currently reported'
                        })
                    ]
                })
            ]
        })
    });
};
const $b66f05b375253f79$var$ManagedORBOverview = ({ status: status, handleStrategyToggle: handleStrategyToggle, strategyToggleLoading: strategyToggleLoading })=>{
    const enabled = status?.data?.enabled;
    const toggleState = strategyToggleLoading.MORB;
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "flex flex-col gap-3 rounded-2xl border border-white/10 bg-white/2.5 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-5",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("h3", {
                        className: "text-sm font-bold text-white",
                        children: "Managed ORB control"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                        className: "mt-1 text-xs leading-relaxed text-muted",
                        children: "Configure selected symbols, entry quality gates, staged stops, and T+3 reductions from the Managed ORB page."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                type: "button",
                onClick: ()=>void handleStrategyToggle('MORB', enabled),
                disabled: Boolean(toggleState),
                className: `inline-flex h-9 shrink-0 items-center justify-center gap-2 rounded-xl border px-4 text-[10px] font-black uppercase tracking-widest transition disabled:cursor-not-allowed disabled:opacity-50 ${enabled ? 'border-warning-500/30 bg-warning-500/10 text-warning-500 hover:bg-warning-500/20' : 'border-neon/30 bg-neon/10 text-neon hover:bg-neon/20'}`,
                children: [
                    toggleState && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $j8jJ4.default), {
                        className: "h-3.5 w-3.5 animate-spin"
                    }),
                    toggleState ? toggleState === 'starting' ? "Starting\u2026" : "Pausing\u2026" : enabled ? 'Pause strategy' : 'Start strategy'
                ]
            })
        ]
    });
};
var $b66f05b375253f79$export$2e2bcd8739ae039 = $b66f05b375253f79$var$StrategyStatus;


const $8eed87fbca39fae3$export$987dd53eec1f61cf = (nodeEnvironment)=>nodeEnvironment !== "production";
const $8eed87fbca39fae3$export$b570d1d3dcedde62 = (hostname)=>hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
const $8eed87fbca39fae3$var$runtimeNodeEnvironment = typeof process === 'undefined' ? undefined : process.env?.NODE_ENV;
const $8eed87fbca39fae3$var$runtimeLocation = typeof window === 'undefined' ? undefined : window.location;
const $8eed87fbca39fae3$export$44b010f4f4d8063 = $8eed87fbca39fae3$var$runtimeNodeEnvironment ? $8eed87fbca39fae3$export$987dd53eec1f61cf($8eed87fbca39fae3$var$runtimeNodeEnvironment) : $8eed87fbca39fae3$export$b570d1d3dcedde62($8eed87fbca39fae3$var$runtimeLocation?.hostname ?? '');



const $873de16b0d9f3c5f$var$ControlPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).lazy(()=>(parcelRequire("f1cgi")));

const $873de16b0d9f3c5f$var$TradeLogPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).lazy(()=>(parcelRequire("lQ3uZ")));

const $873de16b0d9f3c5f$var$Backtester = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).lazy(()=>(parcelRequire("h9H29")));

const $873de16b0d9f3c5f$var$OptimizationResultsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).lazy(()=>(parcelRequire("1hDAJ")));

const $873de16b0d9f3c5f$var$BacktestDashboard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).lazy(()=>(parcelRequire("h7lhJ")));

const $873de16b0d9f3c5f$var$SharedBacktestsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).lazy(()=>(parcelRequire("d8iKZ")));

const $873de16b0d9f3c5f$var$DataPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).lazy(()=>(parcelRequire("cKbcz")));

const $873de16b0d9f3c5f$var$PositionsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).lazy(()=>(parcelRequire("gFC2Y")));

const $873de16b0d9f3c5f$var$ManagedORBPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).lazy(()=>(parcelRequire("dnqkk")));

const $873de16b0d9f3c5f$var$PortfolioPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).lazy(()=>(parcelRequire("7uRgN")));

const $873de16b0d9f3c5f$var$PortfolioHistoryPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).lazy(()=>(parcelRequire("ir7Rs")));

const $873de16b0d9f3c5f$var$AdminPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).lazy(()=>(parcelRequire("gRgfN")));

const $873de16b0d9f3c5f$var$AdminLogsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).lazy(()=>(parcelRequire("c30hq")));

const $873de16b0d9f3c5f$var$DevComponentsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).lazy(()=>(parcelRequire("7CvsC")));
const $873de16b0d9f3c5f$var$pageLoadingFallback = /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
    className: "flex min-h-[40vh] items-center justify-center",
    role: "status",
    children: /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
        className: "text-sm text-muted",
        children: "Loading page\u2026"
    })
});
const $873de16b0d9f3c5f$var$AppRoutes = ({ user: user, userContext: userContext, systemStatus: systemStatus, editingOrder: editingOrder, onEditingOrderChange: onEditingOrderChange })=>/*#__PURE__*/ (0, $eHRxX.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).Suspense, {
        fallback: $873de16b0d9f3c5f$var$pageLoadingFallback,
        children: /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $lIBUZ.Routes), {
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Route), {
                    path: "/",
                    element: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex min-h-[calc(100vh-5rem)] w-full flex-col gap-0 px-0 py-0",
                        children: [
                            user?.role === 'investor' && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $99c01f15c39a6dcf$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "grid grid-cols-1 gap-0 lg:grid-cols-3 lg:auto-rows-fr",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: `flex flex-col gap-0 lg:h-full ${user?.role === 'investor' ? 'lg:col-span-3' : 'lg:col-span-2'}`,
                                        children: user?.role === 'investor' ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $41a83a4c68965c10$export$2e2bcd8739ae039), {
                                            isConnected: !!systemStatus?.data?.ib_connected
                                        }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $4f787eedcb7e94da$export$2e2bcd8739ae039), {})
                                    }),
                                    user?.role !== 'investor' && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: "flex flex-col gap-0 lg:h-full lg:border-l lg:border-white/10",
                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $d9e214164e7fb7a2$export$2e2bcd8739ae039), {
                                            editingOrder: editingOrder,
                                            onCancelEditing: ()=>onEditingOrderChange(null),
                                            onOrderModified: ()=>onEditingOrderChange(null)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex min-h-0 flex-1 flex-col gap-0",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $5e09a53f0c6f1a36$export$2e2bcd8739ae039), {
                                        className: "min-h-[560px] flex-1",
                                        onEditOrder: onEditingOrderChange
                                    }),
                                    user?.role === 'investor' ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $2a8d759113e28e7d$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $b66f05b375253f79$export$2e2bcd8739ae039), {})
                                ]
                            }),
                            user?.role !== 'investor' && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $676345489ed21047$export$2e2bcd8739ae039), {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Route), {
                    path: "/control",
                    element: /*#__PURE__*/ (0, $eHRxX.jsx)($873de16b0d9f3c5f$var$ControlPage, {})
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Route), {
                    path: "/trades",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Navigate), {
                        to: "/"
                    }) : /*#__PURE__*/ (0, $eHRxX.jsx)($873de16b0d9f3c5f$var$TradeLogPage, {})
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Route), {
                    path: "/analysis",
                    element: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Navigate), {
                        to: "/",
                        replace: true
                    })
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Route), {
                    path: "/strategies",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Navigate), {
                        to: "/"
                    }) : /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex min-h-[calc(100vh-5rem)] w-full flex-col gap-0 px-0 py-0",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "panel full-bleed-panel page-heading",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("h1", {
                                        className: "flex items-center gap-2 text-2xl font-bold tracking-tight text-white",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7ab85e16ca639a6c$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-neon"
                                            }),
                                            "Strategies"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                        className: "text-sm text-muted",
                                        children: "Live status, monthly momentum rankings, and settings for ON, ORB, DT, and NQMM. Managed ORB has a dedicated workspace."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $b66f05b375253f79$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "panel full-bleed-panel",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: "page-heading",
                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)("h2", {
                                            className: "text-lg font-bold tracking-tight text-white",
                                            children: "Configuration"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "grid grid-cols-1 gap-0 lg:grid-cols-2",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $0fe4eaa15babde57$export$2e2bcd8739ae039), {
                                                strategyName: "DT",
                                                fullBleed: true
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $0fe4eaa15babde57$export$2e2bcd8739ae039), {
                                                strategyName: "ORB",
                                                fullBleed: true
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $0fe4eaa15babde57$export$2e2bcd8739ae039), {
                                                strategyName: "ON",
                                                fullBleed: true
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $0fe4eaa15babde57$export$2e2bcd8739ae039), {
                                                strategyName: "NQMM",
                                                fullBleed: true
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                className: "lg:col-span-1 border-t divider-line pt-0",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $f5d1493564b0f8f7$export$2e2bcd8739ae039), {
                                    fullBleed: true
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Route), {
                    path: "/backtest",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $eHRxX.jsx)($873de16b0d9f3c5f$var$SharedBacktestsPage, {}, user?.id) : /*#__PURE__*/ (0, $eHRxX.jsx)($873de16b0d9f3c5f$var$BacktestDashboard, {}, user?.id)
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Route), {
                    path: "/data",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Navigate), {
                        to: "/"
                    }) : /*#__PURE__*/ (0, $eHRxX.jsx)($873de16b0d9f3c5f$var$DataPage, {
                        canManageSharedMarketData: userContext?.role === 'admin' || userContext?.is_superuser === true
                    })
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Route), {
                    path: "/positions",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Navigate), {
                        to: "/"
                    }) : /*#__PURE__*/ (0, $eHRxX.jsx)($873de16b0d9f3c5f$var$PositionsPage, {})
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Route), {
                    path: "/managed-orb",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Navigate), {
                        to: "/"
                    }) : /*#__PURE__*/ (0, $eHRxX.jsx)($873de16b0d9f3c5f$var$ManagedORBPage, {})
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Route), {
                    path: "/backtest/:id",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $eHRxX.jsx)($873de16b0d9f3c5f$var$SharedBacktestsPage, {}, user?.id) : /*#__PURE__*/ (0, $eHRxX.jsx)($873de16b0d9f3c5f$var$Backtester, {}, user?.id)
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Route), {
                    path: "/backtest/strategy/:strategyId",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Navigate), {
                        to: "/"
                    }) : /*#__PURE__*/ (0, $eHRxX.jsx)($873de16b0d9f3c5f$var$Backtester, {}, user?.id)
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Route), {
                    path: "/portfolio",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Navigate), {
                        to: "/"
                    }) : /*#__PURE__*/ (0, $eHRxX.jsx)($873de16b0d9f3c5f$var$PortfolioPage, {})
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Route), {
                    path: "/portfolio/history",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Navigate), {
                        to: "/"
                    }) : /*#__PURE__*/ (0, $eHRxX.jsx)($873de16b0d9f3c5f$var$PortfolioHistoryPage, {})
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Route), {
                    path: "/optimization/:id",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Navigate), {
                        to: "/"
                    }) : /*#__PURE__*/ (0, $eHRxX.jsx)($873de16b0d9f3c5f$var$OptimizationResultsPage, {})
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Route), {
                    path: "/admin",
                    element: user?.role === 'admin' ? /*#__PURE__*/ (0, $eHRxX.jsx)($873de16b0d9f3c5f$var$AdminPage, {}) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Navigate), {
                        to: "/"
                    })
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Route), {
                    path: "/admin/logs",
                    element: user?.role === 'admin' ? /*#__PURE__*/ (0, $eHRxX.jsx)($873de16b0d9f3c5f$var$AdminLogsPage, {}) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Navigate), {
                        to: "/"
                    })
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Route), {
                    path: "/dev/components",
                    element: (0, $8eed87fbca39fae3$export$44b010f4f4d8063) ? /*#__PURE__*/ (0, $eHRxX.jsx)($873de16b0d9f3c5f$var$DevComponentsPage, {}) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Navigate), {
                        to: "/",
                        replace: true
                    })
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Route), {
                    path: "*",
                    element: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $lIBUZ.Navigate), {
                        to: "/",
                        replace: true
                    })
                })
            ]
        })
    });
var $873de16b0d9f3c5f$export$2e2bcd8739ae039 = $873de16b0d9f3c5f$var$AppRoutes;



var $eHRxX = parcelRequire("eHRxX");

var $jHEir = parcelRequire("jHEir");

var $ifMtg = parcelRequire("ifMtg");/**
 * @license lucide-react v1.69.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $hHhnY = parcelRequire("hHhnY");
const $674f974d5c2017fb$export$a2387ed3b5d536eb = {
    name: "code-xml",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m18 16 4-4-4-4",
                key: "1inbqp"
            }
        ],
        [
            "path",
            {
                d: "m6 8-4 4 4 4",
                key: "15zrgr"
            }
        ],
        [
            "path",
            {
                d: "m14.5 4-5 16",
                key: "e7oirm"
            }
        ]
    ],
    aliases: [
        "code-2"
    ]
};
$674f974d5c2017fb$export$a2387ed3b5d536eb.node;
const $674f974d5c2017fb$export$2e2bcd8739ae039 = (0, $hHhnY.default)($674f974d5c2017fb$export$a2387ed3b5d536eb);


var $fRdgn = parcelRequire("fRdgn");
var $Yl6eb = parcelRequire("Yl6eb");
var $bgvjD = parcelRequire("bgvjD");

var $lfSRY = parcelRequire("lfSRY");

const $b7110d78d1614e3b$var$gallerySections = [
    {
        id: 'theme',
        label: 'Theme & type'
    },
    {
        id: 'skeletons',
        label: 'Page skeletons'
    },
    {
        id: 'buttons',
        label: 'Buttons & variants'
    },
    {
        id: 'switches',
        label: 'Switches & toggles'
    },
    {
        id: 'tables',
        label: 'Tables'
    },
    {
        id: 'pagination',
        label: 'Pagination'
    },
    {
        id: 'sidebars',
        label: 'Sidebars'
    },
    {
        id: 'charts',
        label: 'Charts'
    },
    {
        id: 'overlays',
        label: 'Modals & popups'
    },
    {
        id: 'inventory',
        label: 'Component inventory'
    }
];
const $b7110d78d1614e3b$var$DevFloatingMenu = ()=>{
    const [isOpen, setIsOpen] = (0, $jHEir.useState)(false);
    const location = (0, $lfSRY.useLocation)();
    const navigate = (0, $lfSRY.useNavigate)();
    if (!(0, $8eed87fbca39fae3$export$44b010f4f4d8063)) return null;
    const openSection = (sectionId)=>{
        setIsOpen(false);
        if (location.pathname !== '/dev/components') {
            navigate(`/dev/components#${sectionId}`);
            return;
        }
        document.getElementById(sectionId)?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "fixed bottom-4 right-4 z-80 flex flex-col items-end gap-2",
        children: [
            isOpen && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "w-[min(20rem,calc(100vw-2rem))] overflow-hidden rounded-2xl border border-neon/25 bg-surface shadow-[0_24px_80px_rgba(0,0,0,0.65)]",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex items-center justify-between border-b border-white/10 bg-neon/6 px-4 py-3",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: "flex h-7 w-7 items-center justify-center rounded-lg border border-neon/20 bg-neon/10 text-neon",
                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $674f974d5c2017fb$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                className: "text-xs font-semibold text-white",
                                                children: "Developer tools"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                className: "text-[9px] uppercase tracking-[0.14em] text-muted",
                                                children: "Local development"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                type: "button",
                                onClick: ()=>setIsOpen(false),
                                className: "icon-action flex h-7 w-7 items-center justify-center",
                                "aria-label": "Close developer menu",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                                    className: "h-3.5 w-3.5"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                        type: "button",
                        onClick: ()=>openSection('theme'),
                        className: "flex w-full items-center justify-between border-b border-white/10 px-4 py-3 text-left transition hover:bg-neon/[0.07]",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                className: "flex items-center gap-2 text-xs font-semibold text-neon",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $Yl6eb.default), {
                                        className: "h-4 w-4"
                                    }),
                                    "Theme & component gallery"
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $ifMtg.default), {
                                className: "h-4 w-4 text-muted"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "max-h-[min(55vh,28rem)] overflow-y-auto p-2",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                className: "px-2 pb-1 pt-1 text-[9px] font-bold uppercase tracking-[0.16em] text-muted",
                                children: "Jump to section"
                            }),
                            $b7110d78d1614e3b$var$gallerySections.map((section)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>openSection(section.id),
                                    className: "group flex w-full items-center justify-between rounded-lg px-2.5 py-2 text-left text-[11px] text-white/70 transition hover:bg-white/5 hover:text-white",
                                    children: [
                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $fRdgn.default), {
                                                    className: "h-3.5 w-3.5 text-muted group-hover:text-neon"
                                                }),
                                                section.label
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eHRxX.jsx)((0, $ifMtg.default), {
                                            className: "h-3.5 w-3.5 text-muted/50 group-hover:text-neon"
                                        })
                                    ]
                                }, section.id))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                type: "button",
                onClick: ()=>setIsOpen((open)=>!open),
                "aria-expanded": isOpen,
                "aria-label": isOpen ? 'Close developer tools' : 'Open developer tools',
                title: "Developer tools",
                className: "flex h-12 items-center gap-2 rounded-full border border-neon/40 bg-surface px-4 text-neon shadow-[0_8px_32px_rgba(0,0,0,0.5)] transition hover:border-neon/70 hover:bg-surface-2 hover:shadow-[0_0_24px_rgba(92,246,205,0.18)]",
                children: [
                    isOpen ? /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                        className: "h-4 w-4"
                    }) : /*#__PURE__*/ (0, $eHRxX.jsx)((0, $674f974d5c2017fb$export$2e2bcd8739ae039), {
                        className: "h-4 w-4"
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                        className: "text-[10px] font-bold uppercase tracking-[0.16em]",
                        children: "Dev"
                    })
                ]
            })
        ]
    });
};
var $b7110d78d1614e3b$export$2e2bcd8739ae039 = $b7110d78d1614e3b$var$DevFloatingMenu;



const $a0aa99cfde5789b1$var$Login = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).lazy(()=>(parcelRequire("lSdiZ")));

const $a0aa99cfde5789b1$var$Register = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).lazy(()=>(parcelRequire("hW3AW")));

const $a0aa99cfde5789b1$var$SetupAccountPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).lazy(()=>(parcelRequire("jj9gA")));

const $a0aa99cfde5789b1$var$logo = new URL((parcelRequire("j8uwa"))).href;
var $2c5f7c2a8d628dee$exports = {};
$2c5f7c2a8d628dee$exports = import.meta.resolve("6xI1l");


const $a0aa99cfde5789b1$var$notificationSound = new URL($2c5f7c2a8d628dee$exports).href;
const $a0aa99cfde5789b1$var$pageLoadingFallback = /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
    className: "flex min-h-[40vh] items-center justify-center",
    role: "status",
    children: /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
        className: "text-sm text-muted",
        children: "Loading page\u2026"
    })
});
const $a0aa99cfde5789b1$var$LiveClock = ({ value: value })=>{
    const [time, setTime] = (0, $jHEir.useState)(()=>new Date().toLocaleTimeString());
    (0, $jHEir.useEffect)(()=>{
        if (value) return;
        const intervalId = window.setInterval(()=>setTime(new Date().toLocaleTimeString()), 1000);
        return ()=>window.clearInterval(intervalId);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $eHRxX.jsx)((0, $eHRxX.Fragment), {
        children: value || time
    });
};
const $a0aa99cfde5789b1$var$AppContent = ()=>{
    const { isAuthenticated: isAuthenticated, isUserLoading: isUserLoading, user: user, userProfileError: userProfileError, logout: logout, refreshUserProfile: refreshUserProfile } = (0, $e4aOX.useAuth)();
    const navigate = (0, $lfSRY.useNavigate)();
    const location = (0, $lfSRY.useLocation)();
    const [navOpen, setNavOpen] = (0, $jHEir.useState)(false);
    const [systemStatus, setSystemStatus] = (0, $jHEir.useState)(null);
    const [systemControlState, setSystemControlState] = (0, $jHEir.useState)(null);
    const [systemStatusTs, setSystemStatusTs] = (0, $jHEir.useState)('');
    const [isSidebarCollapsed, setIsSidebarCollapsed] = (0, $jHEir.useState)(true);
    const [isNotificationDrawerOpen, setIsNotificationDrawerOpen] = (0, $jHEir.useState)(false);
    const [isTaskDrawerOpen, setIsTaskDrawerOpen] = (0, $jHEir.useState)(false);
    const [unreadCount, setUnreadCount] = (0, $jHEir.useState)(0);
    const [activeTaskCount, setActiveTaskCount] = (0, $jHEir.useState)(0);
    const [userContext, setUserContext] = (0, $jHEir.useState)(null);
    const [isSettingsDropdownOpen, setIsSettingsDropdownOpen] = (0, $jHEir.useState)(false);
    const [isGatewayConfigModalOpen, setIsGatewayConfigModalOpen] = (0, $jHEir.useState)(false);
    const [isEventsModalOpen, setIsEventsModalOpen] = (0, $jHEir.useState)(false);
    const [isManualOrderModalOpen, setIsManualOrderModalOpen] = (0, $jHEir.useState)(false);
    const [preparedNQMMOrder, setPreparedNQMMOrder] = (0, $jHEir.useState)(null);
    const [editingOrder, setEditingOrder] = (0, $jHEir.useState)(null);
    // Ref for sound throttling and change detection
    const prevUnreadCount = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useRef(0);
    const lastSoundPlayedAt = (0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).useRef(0);
    const notificationAudio = (0, $jHEir.useMemo)(()=>new Audio($a0aa99cfde5789b1$var$notificationSound), []);
    (0, $jHEir.useEffect)(()=>{
        const handlePreparedNQMMOrder = (event)=>{
            const detail = event.detail;
            if (!detail?.openInModal) return;
            const order = (0, $64e79129bad62c89$export$6d11c9454f4c762b)(detail);
            if (!order) return;
            setPreparedNQMMOrder(order);
            setIsManualOrderModalOpen(true);
        };
        window.addEventListener('nqmm-prepare-order', handlePreparedNQMMOrder);
        return ()=>window.removeEventListener('nqmm-prepare-order', handlePreparedNQMMOrder);
    }, []);
    const openManualOrderModal = ()=>{
        setPreparedNQMMOrder(null);
        setIsManualOrderModalOpen(true);
    };
    const closeManualOrderModal = ()=>{
        setIsManualOrderModalOpen(false);
        setPreparedNQMMOrder(null);
    };
    // Redirect to login if not authenticated
    (0, $jHEir.useEffect)(()=>{
        if (!isAuthenticated && location.pathname !== '/login' && location.pathname !== '/register' && location.pathname !== '/setup-account') navigate('/login');
    }, [
        isAuthenticated,
        location.pathname,
        navigate
    ]);
    // Lightweight system status poller for header/sidebar badges
    const fetchSystemStatus = async ()=>{
        if (!isAuthenticated) return;
        try {
            const response = await (0, $zs3Np.tradingApi).getSystemControlState();
            if (response.success && response.data) {
                setSystemControlState(response.data);
                setSystemStatus({
                    success: true,
                    data: {
                        running: response.data.system_enabled,
                        ib_connected: response.data.ib_connected,
                        version: response.data.version,
                        timestamp: response.data.timestamp
                    },
                    timestamp: response.data.timestamp
                });
                setSystemStatusTs(new Date().toLocaleTimeString());
            }
        } catch  {
        // ignore header status errors
        }
    };
    const fetchUnreadCount = async ()=>{
        if (!isAuthenticated) return;
        try {
            const res = await (0, $zs3Np.tradingApi).getUnreadCount();
            if (res.success) setUnreadCount(res.data.count);
        } catch  {
        // ignore
        }
    };
    const fetchTaskCount = async ()=>{
        if (!isAuthenticated || user?.role === 'investor') return;
        try {
            const tasks = await (0, $zs3Np.tradingApi).getDataDownloadTasks();
            setActiveTaskCount(tasks.filter((task)=>[
                    'queued',
                    'running',
                    'cancelling'
                ].includes(task.status)).length);
        } catch  {
        // ignore
        }
    };
    const fetchUserContext = async ()=>{
        if (!isAuthenticated) return;
        try {
            const res = await (0, $zs3Np.tradingApi).getCurrentContext();
            if (res.success) setUserContext(res.data);
        } catch  {
        // ignore
        }
    };
    (0, $jHEir.useEffect)(()=>{
        if (isAuthenticated && !isUserLoading) {
            fetchSystemStatus();
            fetchUnreadCount();
            fetchTaskCount();
            fetchUserContext();
            const id = setInterval(()=>{
                fetchSystemStatus();
                fetchUnreadCount();
                fetchTaskCount();
                fetchUserContext();
            }, 10000); // Poll faster (10s) for responsive notifications
            return ()=>clearInterval(id);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAuthenticated,
        isUserLoading,
        user?.role
    ]);
    // Sound Effect Trigger
    (0, $jHEir.useEffect)(()=>{
        if (unreadCount > prevUnreadCount.current) {
            const soundEnabled = userContext?.preferences?.notify_sound_enabled ?? true;
            if (soundEnabled) {
                const now = Date.now();
                if (now - lastSoundPlayedAt.current > 500) {
                    notificationAudio.play().catch(()=>{
                    // Ignore audio play errors (e.g. browser interaction policy)
                    });
                    lastSoundPlayedAt.current = now;
                }
            }
        }
        prevUnreadCount.current = unreadCount;
    }, [
        unreadCount,
        userContext,
        notificationAudio
    ]);
    const navItems = (0, $jHEir.useMemo)(()=>{
        const items = [
            {
                label: 'Dashboard',
                path: '/',
                icon: (0, $7181117d24209aed$export$2e2bcd8739ae039)
            }
        ];
        if (user?.role === 'investor') items.push({
            label: 'Shared Backtests',
            path: '/backtest',
            icon: (0, $gQIZx.default)
        });
        // Investor backtests are read-only and show only accessible shared results.
        if (user?.role !== 'investor') items.push({
            label: 'Strategies',
            path: '/strategies',
            icon: (0, $19CqD.default)
        }, {
            label: 'Backtest',
            path: '/backtest',
            icon: (0, $gQIZx.default)
        }, {
            label: 'Data',
            path: '/data',
            icon: (0, $94HEM.default)
        }, {
            label: 'Positions',
            path: '/positions',
            icon: (0, $3KPv1.default)
        }, {
            label: 'Managed ORB',
            path: '/managed-orb',
            icon: (0, $8Rrv7.default)
        }, {
            label: 'Portfolio',
            path: '/portfolio',
            icon: (0, $6q9x0.default)
        }, {
            label: 'Trade Logs',
            path: '/trades',
            icon: (0, $62xmE.default)
        });
        return items;
    }, [
        user?.role
    ]);
    const handleNavigate = (path)=>{
        navigate(path);
        setNavOpen(false);
    };
    if (location.pathname === '/login') return /*#__PURE__*/ (0, $eHRxX.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).Suspense, {
        fallback: $a0aa99cfde5789b1$var$pageLoadingFallback,
        children: /*#__PURE__*/ (0, $eHRxX.jsx)($a0aa99cfde5789b1$var$Login, {})
    });
    if (location.pathname === '/register') return /*#__PURE__*/ (0, $eHRxX.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).Suspense, {
        fallback: $a0aa99cfde5789b1$var$pageLoadingFallback,
        children: /*#__PURE__*/ (0, $eHRxX.jsx)($a0aa99cfde5789b1$var$Register, {})
    });
    if (location.pathname.startsWith('/setup-account')) return /*#__PURE__*/ (0, $eHRxX.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).Suspense, {
        fallback: $a0aa99cfde5789b1$var$pageLoadingFallback,
        children: /*#__PURE__*/ (0, $eHRxX.jsx)($a0aa99cfde5789b1$var$SetupAccountPage, {})
    });
    if (!isAuthenticated) return null; // or loading spinner while redirecting
    if (isUserLoading) return /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
        className: "min-h-screen auth-shell flex items-center justify-center",
        children: /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
            className: "w-8 h-8 border-4 border-neon/30 border-t-neon rounded-full animate-spin"
        })
    });
    if (isAuthenticated && !user) return /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
        className: "min-h-screen auth-shell flex items-center justify-center p-4 text-foreground",
        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
            className: "auth-card max-w-md space-y-4 p-6 text-center",
            children: [
                /*#__PURE__*/ (0, $eHRxX.jsx)("h1", {
                    className: "text-lg font-bold",
                    children: "Account profile unavailable"
                }),
                /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                    className: "text-sm text-muted",
                    children: userProfileError || 'The server could not confirm this account.'
                }),
                /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                    className: "flex justify-center gap-3",
                    children: [
                        /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                            className: "rounded-lg border border-neon/40 px-4 py-2 text-sm text-neon",
                            onClick: refreshUserProfile,
                            children: "Try again"
                        }),
                        /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                            className: "rounded-lg border border-white/20 px-4 py-2 text-sm text-white/70",
                            onClick: logout,
                            children: "Sign out"
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
        className: "min-h-screen app-shell text-foreground relative overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $eHRxX.jsxs)("header", {
                className: `fixed top-0 right-0 z-30 topbar border-b transition-all duration-300 ease-in-out ${isSidebarCollapsed ? 'left-20' : 'left-60'} ${navOpen ? 'left-0' : ''} lg:block hidden`,
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "w-full px-4 lg:px-6 py-2 flex items-center justify-between gap-4",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-center gap-2 sm:gap-3 xl:gap-5 min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-2 xl:gap-4 text-[10px] font-bold tracking-tight uppercase shrink-0",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: `flex items-center gap-1.5 xl:gap-2 px-2 xl:px-2.5 py-1 rounded-lg border ${systemStatus?.data?.running ? systemStatus?.data?.ib_connected ? 'bg-success-50 border-success-500/20 text-success-500' : 'bg-warning-50 border-warning-500/20 text-warning-500' : 'bg-error-50 border-error-500/20 text-error-500'}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: `h-1.5 w-1.5 rounded-full shrink-0 ${systemStatus?.data?.running ? systemStatus?.data?.ib_connected ? 'bg-success-500 animate-pulse' : 'bg-warning-500 animate-pulse' : 'bg-error-500'}`
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "whitespace-nowrap",
                                                        children: systemStatus?.data?.running ? systemStatus?.data?.ib_connected ? /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                    className: "hidden xl:inline",
                                                                    children: "Trading "
                                                                }),
                                                                "Active"
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                    className: "hidden xl:inline",
                                                                    children: "Trading "
                                                                }),
                                                                "Stopped"
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                    className: "hidden xl:inline",
                                                                    children: "Trading "
                                                                }),
                                                                "Disabled"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center gap-1.5 xl:gap-2 px-2 xl:px-2.5 py-1 rounded-lg bg-info-50 border border-info-500/20",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: `h-1.5 w-1.5 rounded-full shrink-0 ${systemStatus?.data?.ib_connected ? 'bg-info-500 animate-pulse' : 'bg-error-500'}`
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                        className: `whitespace-nowrap ${systemStatus?.data?.ib_connected ? 'text-info-500' : 'text-error-500'}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                className: "hidden xl:inline",
                                                                children: "Connection "
                                                            }),
                                                            systemStatus?.data?.ib_connected ? 'Sync' : 'Lost'
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: "h-4 w-px divider shrink-0"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center gap-2 shrink-0",
                                        children: [
                                            user?.role !== 'investor' && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $hX4Sd.default), {
                                                controlState: systemControlState,
                                                onRefresh: fetchSystemStatus,
                                                onError: (err)=>console.error(err),
                                                variant: "slim",
                                                iconSize: 13,
                                                className: "h-7 text-[11px] px-2.5 gap-1.5 shrink-0"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $2KORC.default), {
                                                controlState: systemControlState,
                                                gatewayId: systemControlState?.saved_gateways?.find((g)=>g.is_active)?.id,
                                                onRefresh: fetchSystemStatus,
                                                onConfigureNeeded: ()=>setIsGatewayConfigModalOpen(true),
                                                onError: (err)=>console.error(err),
                                                variant: "slim",
                                                iconSize: 13,
                                                className: "h-7 text-[11px] px-2.5 gap-1.5 shrink-0"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "relative shrink-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                                        onClick: ()=>setIsSettingsDropdownOpen(!isSettingsDropdownOpen),
                                                        className: `h-8 w-8 flex items-center justify-center rounded-lg icon-action ${isSettingsDropdownOpen ? 'bg-neon text-black border-neon shadow-neon/20' : ''}`,
                                                        title: "System Settings",
                                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $eC2xp.default), {
                                                            className: "w-4 h-4"
                                                        })
                                                    }),
                                                    isSettingsDropdownOpen && /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                                className: "fixed inset-0 z-40",
                                                                onClick: ()=>setIsSettingsDropdownOpen(false)
                                                            }),
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                                className: "absolute top-full mt-2 right-0 w-56 panel-surface z-50 animate-in fade-in slide-in-from-top-2",
                                                                children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                                    className: "p-2 space-y-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                                            onClick: ()=>{
                                                                                navigate('/control');
                                                                                setIsSettingsDropdownOpen(false);
                                                                            },
                                                                            className: "menu-item",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $eC2xp.default), {
                                                                                    className: "w-4 h-4 text-neon"
                                                                                }),
                                                                                "Advanced Control"
                                                                            ]
                                                                        }),
                                                                        user?.role === 'admin' && /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                                            onClick: ()=>{
                                                                                navigate('/admin');
                                                                                setIsSettingsDropdownOpen(false);
                                                                            },
                                                                            className: "menu-item",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $ehZ63.default), {
                                                                                    className: "w-4 h-4 text-emerald-400"
                                                                                }),
                                                                                "Admin Dashboard"
                                                                            ]
                                                                        }),
                                                                        user?.role === 'admin' && /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                                            onClick: ()=>{
                                                                                navigate('/admin/logs');
                                                                                setIsSettingsDropdownOpen(false);
                                                                            },
                                                                            className: "menu-item",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $f11WQ.default), {
                                                                                    className: "w-4 h-4 text-neon"
                                                                                }),
                                                                                "Logs"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-center gap-1.5 xl:gap-2 shrink-0",
                                children: [
                                    user?.role !== 'investor' && /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                        onClick: openManualOrderModal,
                                        className: "relative h-8 w-8 flex items-center justify-center rounded-lg icon-action group shrink-0",
                                        title: "Place manual order",
                                        "aria-label": "Place manual order",
                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bTVJ1.default), {
                                            className: "w-4 h-4 group-hover:scale-110 transition-transform"
                                        })
                                    }),
                                    user?.role !== 'investor' && /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                        onClick: ()=>setIsTaskDrawerOpen(true),
                                        className: "relative h-8 w-8 flex items-center justify-center rounded-lg icon-action group shrink-0",
                                        title: "Background tasks",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $b70a514b297db12d$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4 group-hover:scale-110 transition-transform"
                                            }),
                                            activeTaskCount > 0 && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "absolute top-1.5 right-1.5 min-w-3.5 h-3.5 px-1 bg-neon text-black text-[9px] font-bold rounded-full flex items-center justify-center border border-surface shadow-[0_0_8px_rgba(var(--neon-rgb),0.5)]",
                                                children: activeTaskCount > 9 ? '9+' : activeTaskCount
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                        onClick: ()=>setIsNotificationDrawerOpen(true),
                                        className: "relative h-8 w-8 flex items-center justify-center rounded-lg icon-action group shrink-0",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $cSggV.default), {
                                                className: "w-4 h-4 group-hover:scale-110 transition-transform"
                                            }),
                                            unreadCount > 0 && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "absolute top-1.5 right-1.5 w-3.5 h-3.5 bg-error-500 text-white text-[9px] font-bold rounded-full flex items-center justify-center border border-surface shadow-[0_0_8px_rgba(var(--danger-rgb),0.5)]",
                                                children: unreadCount > 9 ? '9+' : unreadCount
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        className: "h-6 w-px divider mx-1 xl:mx-2 shrink-0"
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "h-8 flex items-center gap-1.5 xl:gap-2 pl-1.5 pr-1 rounded-lg panel-section border backdrop-blur-xs shrink-0",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: "flex items-center shrink-0",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $62fd36d4e1e4997c$export$2e2bcd8739ae039), {
                                                    variant: "compact"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                className: "h-4 w-px divider shrink-0"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex items-center gap-2 min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                        className: "flex flex-col items-end justify-center leading-none min-w-0 max-w-[80px] xl:max-w-[140px]",
                                                        children: [
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                                className: "text-[10px] font-black text-foreground leading-none tracking-tight truncate w-full text-right",
                                                                title: userContext?.is_acting_as ? `${userContext.original_user?.username} (${userContext.username})` : user?.username,
                                                                children: userContext?.is_acting_as ? `${userContext.original_user?.username} (${userContext.username})` : user?.username
                                                            }),
                                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                                className: "mt-0.5 flex items-center justify-end gap-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $i3HgA.default), {
                                                                        role: userContext?.role || user?.role,
                                                                        compact: true
                                                                    }),
                                                                    userContext?.is_acting_as && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                        className: "rounded-full border border-amber-500/25 bg-amber-500/10 px-1.5 py-0.5 text-[8px] font-black uppercase leading-none tracking-widest text-amber-400",
                                                                        children: "Manager"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                        className: `w-6 h-6 rounded-md flex items-center justify-center border transition-all shrink-0 ${userContext?.is_acting_as ? 'bg-amber-500/10 border-amber-500/25 shadow-[0_0_15px_rgba(var(--warning-rgb),0.1)]' : 'bg-neon/10 border-neon/20 shadow-[0_0_15px_rgba(var(--neon-rgb),0.1)]'}`,
                                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7e993a062fc3185b$export$2e2bcd8739ae039), {
                                                            className: `w-3 h-3 ${userContext?.is_acting_as ? 'text-amber-400' : 'text-neon'}`
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                                        onClick: logout,
                                                        className: "w-7 h-7 flex items-center justify-center rounded-md text-muted hover:text-error-500 hover:bg-error-50/10 transition group shrink-0",
                                                        title: "Sign Out",
                                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bb39fb9170dd8ee1$export$2e2bcd8739ae039), {
                                                            className: "w-3.5 h-3.5 group-hover:scale-110 transition-transform"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "w-full border-t border-white/5 bg-surface px-4 lg:px-6 py-1",
                        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "relative flex items-center justify-center",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)((0, $3a6736e3e42b8acf$export$361f331cf51c8057), {}),
                                user?.role !== 'investor' && /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                    onClick: ()=>setIsEventsModalOpen(true),
                                    className: "absolute right-0 top-1/2 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded-md border border-neon/25 bg-neon/10 text-neon transition-colors hover:border-neon/50 hover:bg-neon/20",
                                    title: "Market events",
                                    children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7b33p.default), {
                                        className: "w-3.5 h-3.5"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("header", {
                className: "sticky top-0 z-30 topbar border-b lg:hidden px-4 py-3",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "flex min-w-0 items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex shrink-0 items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                        className: "h-8 w-8 flex items-center justify-center rounded-md border border-white/10 bg-transparent text-muted shadow-none transition hover:border-neon/40 hover:bg-neon/5 hover:text-neon",
                                        onClick: ()=>setNavOpen(!navOpen),
                                        "aria-label": navOpen ? 'Close navigation' : 'Open navigation',
                                        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                            className: "space-y-1.5 w-5",
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                    className: `block h-0.5 w-full bg-current transition ${navOpen ? 'translate-y-2 rotate-45' : ''}`
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                    className: `block h-0.5 w-full bg-current transition ${navOpen ? 'opacity-0' : ''}`
                                                }),
                                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                    className: `block h-0.5 w-full bg-current transition ${navOpen ? '-translate-y-2 -rotate-45' : ''}`
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("img", {
                                        src: $a0aa99cfde5789b1$var$logo,
                                        alt: "Logo",
                                        className: "w-8 h-8 rounded-lg cursor-pointer hover:scale-105 transition-transform",
                                        onClick: ()=>handleNavigate('/'),
                                        title: "Go to Dashboard"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex min-w-0 flex-1 items-center justify-end gap-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $62fd36d4e1e4997c$export$2e2bcd8739ae039), {
                                        variant: "compact",
                                        showIdentity: true,
                                        alwaysRender: true
                                    }),
                                    user?.role !== 'investor' && /*#__PURE__*/ (0, $eHRxX.jsxs)((0, $eHRxX.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                                onClick: openManualOrderModal,
                                                className: "relative inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-neon/25 bg-neon/10 text-neon transition-colors hover:border-neon/50 hover:bg-neon/20",
                                                title: "Place manual order",
                                                "aria-label": "Place manual order",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bTVJ1.default), {
                                                    className: "h-4 w-4"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                                onClick: ()=>setIsEventsModalOpen(true),
                                                className: "relative inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-neon/25 bg-neon/10 text-neon transition-colors hover:border-neon/50 hover:bg-neon/20",
                                                title: "Market events",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7b33p.default), {
                                                    className: "h-4 w-4"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                onClick: ()=>setIsTaskDrawerOpen(true),
                                                className: "icon-action relative inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $b70a514b297db12d$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4"
                                                    }),
                                                    activeTaskCount > 0 && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "absolute -top-1 -right-1 min-w-4 h-4 px-1 bg-neon text-black text-[10px] font-bold rounded-full flex items-center justify-center border-2 border-surface",
                                                        children: activeTaskCount > 9 ? '9+' : activeTaskCount
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                        onClick: ()=>setIsNotificationDrawerOpen(true),
                                        className: "icon-action relative inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $cSggV.default), {
                                                className: "h-4 w-4"
                                            }),
                                            unreadCount > 0 && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "absolute -top-1 -right-1 w-4 h-4 bg-error-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center border-2 border-surface",
                                                children: unreadCount > 9 ? '9+' : unreadCount
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "mt-2 grid grid-cols-2 items-stretch gap-2 border-t border-white/10 pt-2",
                        children: [
                            user?.role !== 'investor' && /*#__PURE__*/ (0, $eHRxX.jsx)((0, $hX4Sd.default), {
                                controlState: systemControlState,
                                onRefresh: fetchSystemStatus,
                                onError: (err)=>console.error(err),
                                variant: "slim",
                                iconSize: 13,
                                className: "h-8 min-w-0 w-full rounded-md px-2 text-[10px] sm:text-[11px]"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $2KORC.default), {
                                controlState: systemControlState,
                                gatewayId: systemControlState?.saved_gateways?.find((g)=>g.is_active)?.id,
                                onRefresh: fetchSystemStatus,
                                onConfigureNeeded: ()=>setIsGatewayConfigModalOpen(true),
                                onError: (err)=>console.error(err),
                                variant: "slim",
                                iconSize: 13,
                                className: "h-8 min-w-0 w-full rounded-md px-2 text-[10px] sm:text-[11px]"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsxs)("aside", {
                className: `hidden lg:flex fixed top-0 left-0 h-full ${isSidebarCollapsed ? 'w-20' : 'w-60'} flex-col sidebar-shell z-40 transition-all duration-300 ease-in-out border-r`,
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: `p-4 flex items-center ${isSidebarCollapsed ? 'justify-center' : 'justify-between'} transition-all duration-300`,
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                onClick: ()=>handleNavigate('/'),
                                className: `flex items-center gap-3 cursor-pointer group ${isSidebarCollapsed ? 'justify-center w-full' : ''}`,
                                title: "Go to Dashboard",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("img", {
                                        src: $a0aa99cfde5789b1$var$logo,
                                        alt: "GetUndiluted Trader",
                                        className: "w-9 h-9 rounded-lg hover:scale-105 transition-transform"
                                    }),
                                    !isSidebarCollapsed && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                            className: "text-lg text-foreground font-bold tracking-tight group-hover:text-neon transition-colors",
                                            children: "GetUndiluted"
                                        })
                                    })
                                ]
                            }),
                            !isSidebarCollapsed && /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                onClick: ()=>setIsSidebarCollapsed(true),
                                className: "h-8 w-8 flex items-center justify-center rounded-md text-muted shadow-none hover:text-foreground hover:bg-neon/5 transition",
                                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $h2RqY.default), {
                                    className: "w-5 h-5"
                                })
                            })
                        ]
                    }),
                    isSidebarCollapsed && /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "w-full flex justify-center mb-4",
                        children: /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                            onClick: ()=>setIsSidebarCollapsed(false),
                            className: "h-8 w-8 flex items-center justify-center rounded-md text-muted shadow-none hover:text-foreground hover:bg-neon/5 transition",
                            "aria-label": "Expand navigation",
                            children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $ifMtg.default), {
                                className: "w-5 h-5"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "flex-1 -space-y-px overflow-y-auto scrollbar-thin px-2",
                        children: navItems.map((item)=>/*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                onClick: ()=>handleNavigate(item.path),
                                className: `group relative flex items-center transition-all duration-200 ${isSidebarCollapsed ? 'w-10 h-10 justify-center mx-auto rounded-md' : 'w-full min-h-9 justify-between rounded-none border-y border-x-0 border-white/10 px-2 py-1.5 text-xs'} ${location.pathname === item.path ? 'bg-neon/10 text-neon border-neon/20' : 'text-muted hover:text-foreground hover:bg-neon/10'}`,
                                title: isSidebarCollapsed ? item.label : '',
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                        className: `flex items-center gap-2 font-medium tracking-wide ${isSidebarCollapsed ? '' : 'mr-2 text-xs'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "inline-flex h-6 w-6 items-center justify-center rounded-none transition-colors",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)(item.icon, {
                                                    className: "h-4 w-4"
                                                })
                                            }),
                                            !isSidebarCollapsed && item.label
                                        ]
                                    }),
                                    !isSidebarCollapsed && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: `h-1.5 w-1.5 rounded-full ${location.pathname === item.path ? 'bg-neon' : 'bg-transparent'}`
                                    }),
                                    isSidebarCollapsed && location.pathname === item.path && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                        className: "absolute left-0 top-1/2 -translate-y-1/2 h-7 w-0.5 bg-neon"
                                    })
                                ]
                            }, item.path))
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: `mt-auto p-4 ${isSidebarCollapsed ? 'px-2' : 'px-6'} flex flex-col items-center gap-2`,
                        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                            className: "flex flex-col items-center gap-1 text-[9px] text-muted font-mono uppercase tracking-widest mb-2",
                            children: [
                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                    className: "opacity-70",
                                    children: systemStatus?.data?.version ? `v${systemStatus.data.version}` : 'Loading...'
                                }),
                                /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                    className: "opacity-50",
                                    children: /*#__PURE__*/ (0, $eHRxX.jsx)($a0aa99cfde5789b1$var$LiveClock, {
                                        value: systemStatusTs
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            navOpen && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "fixed inset-0 z-40 lg:hidden",
                role: "dialog",
                "aria-modal": "true",
                "aria-label": "Navigation",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "absolute inset-0 overlay-backdrop shadow-[inset_0_0_100px_rgba(var(--overlay-rgb),0.5)]",
                        onClick: ()=>setNavOpen(false)
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                        className: "absolute inset-0 flex h-dvh w-full flex-col sidebar-shell overflow-y-auto p-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] sm:p-4 sm:pb-4",
                        children: [
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "flex items-center justify-between gap-3 border-b border-white/10 pb-3",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        onClick: ()=>handleNavigate('/'),
                                        className: "flex min-w-0 items-center gap-3 cursor-pointer group",
                                        title: "Go to Dashboard",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("img", {
                                                src: $a0aa99cfde5789b1$var$logo,
                                                alt: "GetUndiluted Trader",
                                                className: "h-9 w-9 shrink-0 rounded-lg hover:scale-105 transition-transform"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                        className: "truncate text-sm font-semibold text-foreground group-hover:text-neon transition-colors",
                                                        children: "GetUndiluted Trader"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                        className: "text-[10px] uppercase tracking-[0.16em] text-muted",
                                                        children: "Navigation"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setNavOpen(false),
                                        className: "inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-white/10 text-muted transition hover:border-neon/40 hover:bg-neon/5 hover:text-neon",
                                        "aria-label": "Close navigation",
                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bgvjD.default), {
                                            className: "h-4 w-4"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                className: "mb-1 mt-4 px-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-muted",
                                children: "Navigate"
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "-space-y-px",
                                children: [
                                    user?.role !== 'investor' && /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                        onClick: ()=>{
                                            setNavOpen(false);
                                            setIsTaskDrawerOpen(true);
                                        },
                                        className: "w-full border-y border-x-0 border-white/10 px-2 py-1.5 text-left text-xs rounded-none transition text-muted hover:border-neon/20 hover:text-foreground hover:bg-neon/10",
                                        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                            className: "flex items-center justify-between text-xs font-semibold uppercase tracking-wider",
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                            className: "inline-flex h-6 w-6 items-center justify-center rounded-none",
                                                            children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $b70a514b297db12d$export$2e2bcd8739ae039), {
                                                                className: "h-4 w-4"
                                                            })
                                                        }),
                                                        "Tasks"
                                                    ]
                                                }),
                                                activeTaskCount > 0 && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                    className: "bg-neon text-black text-[10px] px-2 py-0.5 rounded-full",
                                                    children: activeTaskCount
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                        onClick: ()=>{
                                            setNavOpen(false);
                                            setIsNotificationDrawerOpen(true);
                                        },
                                        className: "w-full border-y border-x-0 border-white/10 px-2 py-1.5 text-left text-xs rounded-none transition text-muted hover:border-neon/20 hover:text-foreground hover:bg-neon/10",
                                        children: /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                            className: "flex items-center justify-between text-xs font-semibold uppercase tracking-wider",
                                            children: [
                                                /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                            className: "inline-flex h-6 w-6 items-center justify-center rounded-none",
                                                            children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $cSggV.default), {
                                                                className: "h-4 w-4"
                                                            })
                                                        }),
                                                        "Activity"
                                                    ]
                                                }),
                                                unreadCount > 0 && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                    className: "bg-error-500 text-white text-[10px] px-2 py-0.5 rounded-full",
                                                    children: unreadCount
                                                })
                                            ]
                                        })
                                    }),
                                    navItems.map((item)=>/*#__PURE__*/ (0, $eHRxX.jsx)("button", {
                                            onClick: ()=>handleNavigate(item.path),
                                            className: `w-full rounded-none border-y border-x-0 border-white/10 px-2 py-1.5 text-left text-xs transition ${location.pathname === item.path ? 'bg-neon/10 text-neon border-neon/20' : 'text-muted hover:text-foreground hover:bg-neon/10'}`,
                                            children: /*#__PURE__*/ (0, $eHRxX.jsxs)("span", {
                                                className: "flex items-center gap-2 text-xs font-semibold uppercase tracking-wider",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        className: "inline-flex h-6 w-6 items-center justify-center rounded-none",
                                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)(item.icon, {
                                                            className: "h-4 w-4"
                                                        })
                                                    }),
                                                    item.label
                                                ]
                                            })
                                        }, item.path))
                                ]
                            }),
                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                className: "mt-auto border-t border-white/10 pt-3",
                                children: [
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center justify-between gap-3 px-2 py-1",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                className: "flex min-w-0 items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                                                        className: "flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-success-500/20 bg-success-50 text-success-500",
                                                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7e993a062fc3185b$export$2e2bcd8739ae039), {
                                                            className: "h-3.5 w-3.5"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                        className: "min-w-0",
                                                        children: [
                                                            /*#__PURE__*/ (0, $eHRxX.jsx)("p", {
                                                                className: "truncate text-xs font-semibold text-foreground",
                                                                children: user?.username || 'User'
                                                            }),
                                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                                                className: "mt-1 flex items-center gap-1.5",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $i3HgA.default), {
                                                                        role: userContext?.role || user?.role,
                                                                        compact: true
                                                                    }),
                                                                    userContext?.is_acting_as && /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                                        className: "text-[8px] font-bold uppercase tracking-widest text-amber-400",
                                                                        children: "Manager"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>{
                                                    setNavOpen(false);
                                                    logout();
                                                },
                                                className: "inline-flex h-8 shrink-0 items-center gap-1.5 rounded-md border border-error-500/20 px-2.5 text-[10px] font-semibold uppercase tracking-[0.08em] text-error-500 transition hover:bg-error-50 hover:text-error-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)((0, $bb39fb9170dd8ee1$export$2e2bcd8739ae039), {
                                                        className: "h-3.5 w-3.5"
                                                    }),
                                                    /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                        children: "Logout"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                                        className: "flex items-center justify-between px-2 pt-2 text-[10px] text-muted",
                                        children: [
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                children: "Last update"
                                            }),
                                            /*#__PURE__*/ (0, $eHRxX.jsx)("span", {
                                                className: "font-semibold text-foreground",
                                                children: /*#__PURE__*/ (0, $eHRxX.jsx)($a0aa99cfde5789b1$var$LiveClock, {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)("main", {
                className: `relative z-10 min-h-screen w-full transition-all duration-300 ease-in-out ${isSidebarCollapsed ? 'lg:pl-20' : 'lg:pl-60'} pt-0 lg:pt-20`,
                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $873de16b0d9f3c5f$export$2e2bcd8739ae039), {
                    user: user,
                    userContext: userContext,
                    systemStatus: systemStatus,
                    editingOrder: editingOrder,
                    onEditingOrderChange: setEditingOrder
                })
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $b7110d78d1614e3b$export$2e2bcd8739ae039), {}),
            isNotificationDrawerOpen && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "fixed inset-0 z-100 transition-opacity duration-300",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "absolute inset-0 overlay-backdrop",
                        onClick: ()=>setIsNotificationDrawerOpen(false)
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("aside", {
                        className: `absolute top-0 right-0 h-full w-full sm:w-[400px] transform transition-transform duration-300 ease-out border-l divider-line shadow-2xl ${isNotificationDrawerOpen ? 'translate-x-0' : 'translate-x-full'}`,
                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $46b8a5c2cae5e5f7$export$2e2bcd8739ae039), {
                            onClose: ()=>setIsNotificationDrawerOpen(false),
                            onUnreadCountChange: setUnreadCount
                        })
                    })
                ]
            }),
            isTaskDrawerOpen && /*#__PURE__*/ (0, $eHRxX.jsxs)("div", {
                className: "fixed inset-0 z-100 transition-opacity duration-300",
                children: [
                    /*#__PURE__*/ (0, $eHRxX.jsx)("div", {
                        className: "absolute inset-0 overlay-backdrop",
                        onClick: ()=>setIsTaskDrawerOpen(false)
                    }),
                    /*#__PURE__*/ (0, $eHRxX.jsx)("aside", {
                        className: `absolute top-0 right-0 h-full w-full sm:w-[420px] transform transition-transform duration-300 ease-out border-l divider-line shadow-2xl ${isTaskDrawerOpen ? 'translate-x-0' : 'translate-x-full'}`,
                        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $66706ed0d2e089b6$export$2e2bcd8739ae039), {
                            onClose: ()=>setIsTaskDrawerOpen(false),
                            onTaskCountChange: setActiveTaskCount
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7Mvr3.default), {
                isOpen: isGatewayConfigModalOpen,
                onClose: ()=>setIsGatewayConfigModalOpen(false),
                onSuccess: ()=>{
                    setIsGatewayConfigModalOpen(false);
                    fetchSystemStatus();
                },
                currentUsername: systemControlState?.ib_username,
                currentMode: systemControlState?.ib_mode,
                savedGateways: systemControlState?.saved_gateways
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $m1iA2.default), {
                isOpen: isEventsModalOpen,
                onClose: ()=>setIsEventsModalOpen(false),
                title: "Market Events",
                width: "max-w-4xl",
                flush: true,
                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $b1f93aec56d21e9d$export$2e2bcd8739ae039), {
                    compact: true
                })
            }),
            /*#__PURE__*/ (0, $eHRxX.jsx)((0, $m1iA2.default), {
                isOpen: isManualOrderModalOpen,
                onClose: closeManualOrderModal,
                title: preparedNQMMOrder ? 'Review NQMM Rebalance Order' : 'Place Manual Order',
                width: "max-w-2xl",
                flush: true,
                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $d9e214164e7fb7a2$export$2e2bcd8739ae039), {
                    inModal: true,
                    showCancelButton: true,
                    preparedNQMMOrder: preparedNQMMOrder,
                    onCancel: closeManualOrderModal,
                    onOrderSubmitted: closeManualOrderModal
                })
            })
        ]
    });
};
const $a0aa99cfde5789b1$var$App = ()=>{
    return /*#__PURE__*/ (0, $eHRxX.jsx)((0, $cK6an.BrowserRouter), {
        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $e4aOX.AuthProvider), {
            children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $ctgHU.GlobalErrorProvider), {
                children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $b745d524103da7cf$export$7c0d05a5f8d89647), {
                    children: /*#__PURE__*/ (0, $eHRxX.jsx)($a0aa99cfde5789b1$var$AppContent, {})
                })
            })
        })
    });
};
var $a0aa99cfde5789b1$export$2e2bcd8739ae039 = $a0aa99cfde5789b1$var$App;




var $7nAvJ = parcelRequire("7nAvJ");

(0, (/*@__PURE__*/$parcel$interopDefault($68089ca9cef82829$exports))).createRoot(document.getElementById('root')).render(/*#__PURE__*/ (0, $eHRxX.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jHEir))).StrictMode, {
    children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $7nAvJ.Provider), {
        store: (0, $82b8cc92710380d3$export$6f57813fe9f31bf9),
        children: /*#__PURE__*/ (0, $eHRxX.jsx)((0, $a0aa99cfde5789b1$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=web_layer.264f49c1.js.map
